import { watch, effectScope, computed, reactive, openBlock, createElementBlock, shallowRef, Fragment, watchEffect, toRefs, capitalize as capitalize$1, isVNode as isVNode$1, Comment, unref, warn as warn$1, getCurrentInstance as getCurrentInstance$1, ref as ref$1, provide, inject, defineComponent as defineComponent$1, camelize, h as h$1, isRef, createVNode, toRef, onScopeDispose, toRaw, onBeforeUnmount, onMounted, onUpdated, mergeProps, Text, readonly, Transition, resolveDynamicComponent, nextTick as nextTick$2, withDirectives, toDisplayString as toDisplayString$1, createBlock, withCtx, createElementVNode, normalizeClass, renderList, vShow, TransitionGroup, Teleport, resolveDirective, onDeactivated, resolveComponent, onBeforeMount, onActivated, withModifiers, createTextVNode, createCommentVNode, renderSlot, createSlots, normalizeStyle, markRaw, cloneVNode, onUnmounted, onBeforeUpdate, vModelText, render, toHandlers, withKeys, normalizeProps, guardReactiveProps } from "vue";
import { createVuetify } from "vuetify";
const global$1 = globalThis || void 0 || self;
function getDevtoolsGlobalHook() {
  return getTarget$2().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function getTarget$2() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof global$1 < "u" ? global$1 : {};
}
const isProxyAvailable = typeof Proxy == "function", HOOK_SETUP = "devtools-plugin:setup", HOOK_PLUGIN_SETTINGS_SET = "plugin:settings:set";
let supported, perf;
function isPerformanceSupported() {
  var re;
  return supported !== void 0 || (typeof window < "u" && window.performance ? (supported = !0, perf = window.performance) : typeof global$1 < "u" && (!((re = global$1.perf_hooks) === null || re === void 0) && re.performance) ? (supported = !0, perf = global$1.perf_hooks.performance) : supported = !1), supported;
}
function now() {
  return isPerformanceSupported() ? perf.now() : Date.now();
}
class ApiProxy {
  constructor(ne, ae) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = ne, this.hook = ae;
    const ie = {};
    if (ne.settings)
      for (const ce in ne.settings) {
        const ue = ne.settings[ce];
        ie[ce] = ue.defaultValue;
      }
    const le = `__vue-devtools-plugin-settings__${ne.id}`;
    let se = Object.assign({}, ie);
    try {
      const ce = localStorage.getItem(le), ue = JSON.parse(ce);
      Object.assign(se, ue);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return se;
      },
      setSettings(ce) {
        try {
          localStorage.setItem(le, JSON.stringify(ce));
        } catch {
        }
        se = ce;
      },
      now() {
        return now();
      }
    }, ae && ae.on(HOOK_PLUGIN_SETTINGS_SET, (ce, ue) => {
      ce === this.plugin.id && this.fallbacks.setSettings(ue);
    }), this.proxiedOn = new Proxy({}, {
      get: (ce, ue) => this.target ? this.target.on[ue] : (...de) => {
        this.onQueue.push({
          method: ue,
          args: de
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (ce, ue) => this.target ? this.target[ue] : ue === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(ue) ? (...de) => (this.targetQueue.push({
        method: ue,
        args: de,
        resolve: () => {
        }
      }), this.fallbacks[ue](...de)) : (...de) => new Promise((me) => {
        this.targetQueue.push({
          method: ue,
          args: de,
          resolve: me
        });
      })
    });
  }
  async setRealTarget(ne) {
    this.target = ne;
    for (const ae of this.onQueue)
      this.target.on[ae.method](...ae.args);
    for (const ae of this.targetQueue)
      ae.resolve(await this.target[ae.method](...ae.args));
  }
}
function setupDevtoolsPlugin(re, ne) {
  const ae = re, ie = getTarget$2(), le = getDevtoolsGlobalHook(), se = isProxyAvailable && ae.enableEarlyProxy;
  if (le && (ie.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !se))
    le.emit(HOOK_SETUP, re, ne);
  else {
    const ce = se ? new ApiProxy(ae, le) : null;
    (ie.__VUE_DEVTOOLS_PLUGINS__ = ie.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: ae,
      setupFn: ne,
      proxy: ce
    }), ce && ne(ce.proxiedTarget);
  }
}
var define_process_env_default$2 = { npm_package_exports___require: "./dist/cs-design-system.umd.js", npm_package_devDependencies_vitest: "~2.1.4", npm_package_devDependencies_eslint_import_resolver_alias: "~1.1.2", npm_config_version_commit_hooks: "true", npm_config_user_agent: "yarn/1.22.19 npm/? node/v18.16.0 linux x64", NODE_VERSION: "18.16.0", npm_package_dependencies_vue: "~3.5.13", npm_config_bin_links: "true", npm_config_wrap_output: "", HOSTNAME: "14649218c17b", YARN_VERSION: "1.22.19", npm_node_execpath: "/usr/local/bin/node", npm_package_devDependencies_vite: "~5.4.9", npm_config_init_version: "1.0.0", npm_package_packageManager: "yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e", npm_package_files_0: "dist", HOME: "/root", npm_package_devDependencies_sass: "1.77.6", npm_package_dependencies_vuex: "4.1.0", npm_package_engines_node: ">=18.16.0", npm_config_init_license: "MIT", YARN_WRAP_OUTPUT: "false", npm_package_peerDependencies_vue: "~3.5.13", npm_package_dependencies__complispace_gainsight_px: "~2.1.0", npm_package_scripts_rebuild: "rm -rf dist && rm -rf node_modules && yarn install && yarn lint-staged && yarn build && yarn test:unit", npm_config_version_tag_prefix: "v", npm_config__complispace_registry: "https://registry.npmjs.org/", npm_package_keywords_0: "auth0", npm_package_devDependencies_husky: "~9.1.7", npm_package_keywords_1: "vue", npm_package_peerDependencies_vuex: "~4.1.0", npm_package_description: "Complispace SPA web application skeleton, including auth0 login process and UI components", npm_package_readmeFilename: "README.md", npm_package_lint_staged___vue_0: "eslint --fix", npm_package_keywords_2: "vuetify", npm_package_devDependencies_prettier: "~3.2.4", npm_package_devDependencies_mockdate: "~3.0.5", npm_package_lint_staged___js_0: "eslint --fix", npm_package_scripts_watch_rebuild: "rm -rf dist && rm -rf node_modules && yarn install && yarn lint-staged && yarn watch-build", npm_package_type: "module", npm_package_devDependencies_vite_plugin_node_polyfills: "~0.22.0", npm_package_module: "./dist/cs-design-system.es.js", npm_package_devDependencies__vitest_coverage_v8: "~2.1.4", npm_package_scripts_prepare: "husky", npm_package_scripts_lint: "eslint --ext .js,.vue src/", npm_config_registry: "https://registry.yarnpkg.com", npm_config_scope: "complispace", npm_package_devDependencies_happy_dom: "~15.11.2", npm_package_dependencies_vuetify: "~3.7.19", npm_package_devDependencies__vitejs_plugin_vue: "~5.1.4", npm_package_exports___import: "./dist/cs-design-system.es.js", npm_config_ignore_scripts: "", npm_config_version: "1.22.19", npm_package_dependencies_axios: "~1.7.7", PATH: "/tmp/yarn--1756864169391-0.6098667048828752:/var/lib/app/node_modules/.bin:/usr/local/share/.config/yarn/link/node_modules/.bin:/usr/local/libexec/lib/node_modules/npm/bin/node-gyp-bin:/usr/local/lib/node_modules/npm/bin/node-gyp-bin:/usr/local/bin/node_modules/npm/bin/node-gyp-bin:/tmp/yarn--1756864165216-0.09775249259687246:/var/lib/app/node_modules/.bin:/usr/local/share/.config/yarn/link/node_modules/.bin:/usr/local/libexec/lib/node_modules/npm/bin/node-gyp-bin:/usr/local/lib/node_modules/npm/bin/node-gyp-bin:/usr/local/bin/node_modules/npm/bin/node-gyp-bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin", NODE: "/usr/local/bin/node", npm_package_devDependencies__babel_eslint_parser: "~7.25.9", npm_package_dependencies_cross_env: "~7.0.3", npm_package_name: "@complispace/cs-design-system", npm_package_dependencies_jose: "~5.9.6", npm_package_devDependencies__vitest_ui: "~2.1.4", npm_package_scripts_build_scss_theme: "node --es-module-specifier-resolution=node ./src/theme/buildScss.mjs", npm_package_scripts_test_unit: "vitest run --dir src/tests/unit", npm_package_peerDependencies_vuetify: "~3.7.19", npm_package_devDependencies_eslint: "~8.57.1", npm_package_devDependencies__vue_test_utils: "~2.4.6", npm_lifecycle_script: "vite build", npm_package_browserslist_0: "> 1%", npm_package_exports___style_css: "./dist/style.css", npm_package_main: "./dist/cs-design-system.umd.js", npm_package_browserslist_1: "last 2 versions", npm_package_devDependencies__vue_eslint_config_prettier: "~9.0.0", npm_config_version_git_message: "v%s", npm_lifecycle_event: "build", npm_package_browserslist_2: "not dead", npm_package_version: "1.4.0", npm_config_argv: '{"remain":[],"cooked":["run","rebuild"],"original":["rebuild"]}', npm_package_engines_yarn: ">= 1.22.5", npm_package_devDependencies_lint_staged: "~15.2.0", npm_package_dependencies_vue_i18n: "9.9.0", npm_package_dependencies_buffer: "~6.0.3", npm_package_scripts_build: "vite build", npm_package_dependencies_lodash: "~4.17.21", npm_package_devDependencies_vite_plugin_vuetify: "~2.0.4", npm_package_devDependencies_sass_loader: "~10.2.0", npm_package_dependencies_vue_router: "4.2.5", npm_config_version_git_tag: "true", npm_config_version_git_sign: "", npm_package_license: "UNLICENSED", npm_config_strict_ssl: "true", npm_package_peerDependencies_vitest: "~2.1.4", npm_package_devDependencies_eslint_plugin_prettier: "~5.2.1", npm_config_complispace_registry: "https://registry.npmjs.org/", PWD: "/var/lib/app", npm_execpath: "/opt/yarn-v1.22.19/bin/yarn.js", npm_package_devDependencies_vue_eslint_parser: "~9.4.3", npm_package_peerDependencies_vue_i18n: "~9.9.0", npm_package_scripts_watch_build: "vite build --watch", npm_package_devDependencies_eslint_plugin_vue: "~9.31.0", npm_package_devDependencies__vue_eslint_config_standard: "~8.0.1", npm_package_dependencies__auth0_auth0_spa_js: "~2.1.3", npm_config_save_prefix: "^", npm_config_ignore_optional: "", npm_package_peerDependencies_vue_router: "~4.2.5", INIT_CWD: "/var/lib/app", npm_package_devDependencies_unplugin_vue_components: "~0.27.4", NODE_ENV: "production" }, storeKey = "store";
function forEachValue(re, ne) {
  Object.keys(re).forEach(function(ae) {
    return ne(re[ae], ae);
  });
}
function isObject$a(re) {
  return re !== null && typeof re == "object";
}
function isPromise$1(re) {
  return re && typeof re.then == "function";
}
function partial(re, ne) {
  return function() {
    return re(ne);
  };
}
function genericSubscribe(re, ne, ae) {
  return ne.indexOf(re) < 0 && (ae && ae.prepend ? ne.unshift(re) : ne.push(re)), function() {
    var ie = ne.indexOf(re);
    ie > -1 && ne.splice(ie, 1);
  };
}
function resetStore(re, ne) {
  re._actions = /* @__PURE__ */ Object.create(null), re._mutations = /* @__PURE__ */ Object.create(null), re._wrappedGetters = /* @__PURE__ */ Object.create(null), re._modulesNamespaceMap = /* @__PURE__ */ Object.create(null);
  var ae = re.state;
  installModule(re, ae, [], re._modules.root, !0), resetStoreState(re, ae, ne);
}
function resetStoreState(re, ne, ae) {
  var ie = re._state, le = re._scope;
  re.getters = {}, re._makeLocalGettersCache = /* @__PURE__ */ Object.create(null);
  var se = re._wrappedGetters, ce = {}, ue = {}, de = effectScope(!0);
  de.run(function() {
    forEachValue(se, function(me, fe) {
      ce[fe] = partial(me, re), ue[fe] = computed(function() {
        return ce[fe]();
      }), Object.defineProperty(re.getters, fe, {
        get: function() {
          return ue[fe].value;
        },
        enumerable: !0
        // for local getters
      });
    });
  }), re._state = reactive({
    data: ne
  }), re._scope = de, re.strict && enableStrictMode(re), ie && ae && re._withCommit(function() {
    ie.data = null;
  }), le && le.stop();
}
function installModule(re, ne, ae, ie, le) {
  var se = !ae.length, ce = re._modules.getNamespace(ae);
  if (ie.namespaced && (re._modulesNamespaceMap[ce] && define_process_env_default$2.NODE_ENV !== "production" && console.error("[vuex] duplicate namespace " + ce + " for the namespaced module " + ae.join("/")), re._modulesNamespaceMap[ce] = ie), !se && !le) {
    var ue = getNestedState(ne, ae.slice(0, -1)), de = ae[ae.length - 1];
    re._withCommit(function() {
      ue[de] = ie.state;
    });
  }
  var me = ie.context = makeLocalContext(re, ce, ae);
  ie.forEachMutation(function(fe, pe) {
    var ge = ce + pe;
    registerMutation(re, ge, fe, me);
  }), ie.forEachAction(function(fe, pe) {
    var ge = fe.root ? pe : ce + pe, be = fe.handler || fe;
    registerAction(re, ge, be, me);
  }), ie.forEachGetter(function(fe, pe) {
    var ge = ce + pe;
    registerGetter(re, ge, fe, me);
  }), ie.forEachChild(function(fe, pe) {
    installModule(re, ne, ae.concat(pe), fe, le);
  });
}
function makeLocalContext(re, ne, ae) {
  var ie = ne === "", le = {
    dispatch: ie ? re.dispatch : function(se, ce, ue) {
      var de = unifyObjectStyle(se, ce, ue), me = de.payload, fe = de.options, pe = de.type;
      return (!fe || !fe.root) && (pe = ne + pe), re.dispatch(pe, me);
    },
    commit: ie ? re.commit : function(se, ce, ue) {
      var de = unifyObjectStyle(se, ce, ue), me = de.payload, fe = de.options, pe = de.type;
      (!fe || !fe.root) && (pe = ne + pe), re.commit(pe, me, fe);
    }
  };
  return Object.defineProperties(le, {
    getters: {
      get: ie ? function() {
        return re.getters;
      } : function() {
        return makeLocalGetters(re, ne);
      }
    },
    state: {
      get: function() {
        return getNestedState(re.state, ae);
      }
    }
  }), le;
}
function makeLocalGetters(re, ne) {
  if (!re._makeLocalGettersCache[ne]) {
    var ae = {}, ie = ne.length;
    Object.keys(re.getters).forEach(function(le) {
      if (le.slice(0, ie) === ne) {
        var se = le.slice(ie);
        Object.defineProperty(ae, se, {
          get: function() {
            return re.getters[le];
          },
          enumerable: !0
        });
      }
    }), re._makeLocalGettersCache[ne] = ae;
  }
  return re._makeLocalGettersCache[ne];
}
function registerMutation(re, ne, ae, ie) {
  var le = re._mutations[ne] || (re._mutations[ne] = []);
  le.push(function(ce) {
    ae.call(re, ie.state, ce);
  });
}
function registerAction(re, ne, ae, ie) {
  var le = re._actions[ne] || (re._actions[ne] = []);
  le.push(function(ce) {
    var ue = ae.call(re, {
      dispatch: ie.dispatch,
      commit: ie.commit,
      getters: ie.getters,
      state: ie.state,
      rootGetters: re.getters,
      rootState: re.state
    }, ce);
    return isPromise$1(ue) || (ue = Promise.resolve(ue)), re._devtoolHook ? ue.catch(function(de) {
      throw re._devtoolHook.emit("vuex:error", de), de;
    }) : ue;
  });
}
function registerGetter(re, ne, ae, ie) {
  re._wrappedGetters[ne] || (re._wrappedGetters[ne] = function(se) {
    return ae(
      ie.state,
      // local state
      ie.getters,
      // local getters
      se.state,
      // root state
      se.getters
      // root getters
    );
  });
}
function enableStrictMode(re) {
  watch(function() {
    return re._state.data;
  }, function() {
  }, { deep: !0, flush: "sync" });
}
function getNestedState(re, ne) {
  return ne.reduce(function(ae, ie) {
    return ae[ie];
  }, re);
}
function unifyObjectStyle(re, ne, ae) {
  return isObject$a(re) && re.type && (ae = ne, ne = re, re = re.type), { type: re, payload: ne, options: ae };
}
var LABEL_VUEX_BINDINGS = "vuex bindings", MUTATIONS_LAYER_ID = "vuex:mutations", ACTIONS_LAYER_ID = "vuex:actions", INSPECTOR_ID = "vuex", actionId = 0;
function addDevtools(re, ne) {
  setupDevtoolsPlugin(
    {
      id: "org.vuejs.vuex",
      app: re,
      label: "Vuex",
      homepage: "https://next.vuex.vuejs.org/",
      logo: "https://vuejs.org/images/icons/favicon-96x96.png",
      packageName: "vuex",
      componentStateTypes: [LABEL_VUEX_BINDINGS]
    },
    function(ae) {
      ae.addTimelineLayer({
        id: MUTATIONS_LAYER_ID,
        label: "Vuex Mutations",
        color: COLOR_LIME_500
      }), ae.addTimelineLayer({
        id: ACTIONS_LAYER_ID,
        label: "Vuex Actions",
        color: COLOR_LIME_500
      }), ae.addInspector({
        id: INSPECTOR_ID,
        label: "Vuex",
        icon: "storage",
        treeFilterPlaceholder: "Filter stores..."
      }), ae.on.getInspectorTree(function(ie) {
        if (ie.app === re && ie.inspectorId === INSPECTOR_ID)
          if (ie.filter) {
            var le = [];
            flattenStoreForInspectorTree(le, ne._modules.root, ie.filter, ""), ie.rootNodes = le;
          } else
            ie.rootNodes = [
              formatStoreForInspectorTree(ne._modules.root, "")
            ];
      }), ae.on.getInspectorState(function(ie) {
        if (ie.app === re && ie.inspectorId === INSPECTOR_ID) {
          var le = ie.nodeId;
          makeLocalGetters(ne, le), ie.state = formatStoreForInspectorState(
            getStoreModule(ne._modules, le),
            le === "root" ? ne.getters : ne._makeLocalGettersCache,
            le
          );
        }
      }), ae.on.editInspectorState(function(ie) {
        if (ie.app === re && ie.inspectorId === INSPECTOR_ID) {
          var le = ie.nodeId, se = ie.path;
          le !== "root" && (se = le.split("/").filter(Boolean).concat(se)), ne._withCommit(function() {
            ie.set(ne._state.data, se, ie.state.value);
          });
        }
      }), ne.subscribe(function(ie, le) {
        var se = {};
        ie.payload && (se.payload = ie.payload), se.state = le, ae.notifyComponentUpdate(), ae.sendInspectorTree(INSPECTOR_ID), ae.sendInspectorState(INSPECTOR_ID), ae.addTimelineEvent({
          layerId: MUTATIONS_LAYER_ID,
          event: {
            time: Date.now(),
            title: ie.type,
            data: se
          }
        });
      }), ne.subscribeAction({
        before: function(ie, le) {
          var se = {};
          ie.payload && (se.payload = ie.payload), ie._id = actionId++, ie._time = Date.now(), se.state = le, ae.addTimelineEvent({
            layerId: ACTIONS_LAYER_ID,
            event: {
              time: ie._time,
              title: ie.type,
              groupId: ie._id,
              subtitle: "start",
              data: se
            }
          });
        },
        after: function(ie, le) {
          var se = {}, ce = Date.now() - ie._time;
          se.duration = {
            _custom: {
              type: "duration",
              display: ce + "ms",
              tooltip: "Action duration",
              value: ce
            }
          }, ie.payload && (se.payload = ie.payload), se.state = le, ae.addTimelineEvent({
            layerId: ACTIONS_LAYER_ID,
            event: {
              time: Date.now(),
              title: ie.type,
              groupId: ie._id,
              subtitle: "end",
              data: se
            }
          });
        }
      });
    }
  );
}
var COLOR_LIME_500 = 8702998, COLOR_DARK = 6710886, COLOR_WHITE = 16777215, TAG_NAMESPACED = {
  label: "namespaced",
  textColor: COLOR_WHITE,
  backgroundColor: COLOR_DARK
};
function extractNameFromPath(re) {
  return re && re !== "root" ? re.split("/").slice(-2, -1)[0] : "Root";
}
function formatStoreForInspectorTree(re, ne) {
  return {
    id: ne || "root",
    // all modules end with a `/`, we want the last segment only
    // cart/ -> cart
    // nested/cart/ -> cart
    label: extractNameFromPath(ne),
    tags: re.namespaced ? [TAG_NAMESPACED] : [],
    children: Object.keys(re._children).map(
      function(ae) {
        return formatStoreForInspectorTree(
          re._children[ae],
          ne + ae + "/"
        );
      }
    )
  };
}
function flattenStoreForInspectorTree(re, ne, ae, ie) {
  ie.includes(ae) && re.push({
    id: ie || "root",
    label: ie.endsWith("/") ? ie.slice(0, ie.length - 1) : ie || "Root",
    tags: ne.namespaced ? [TAG_NAMESPACED] : []
  }), Object.keys(ne._children).forEach(function(le) {
    flattenStoreForInspectorTree(re, ne._children[le], ae, ie + le + "/");
  });
}
function formatStoreForInspectorState(re, ne, ae) {
  ne = ae === "root" ? ne : ne[ae];
  var ie = Object.keys(ne), le = {
    state: Object.keys(re.state).map(function(ce) {
      return {
        key: ce,
        editable: !0,
        value: re.state[ce]
      };
    })
  };
  if (ie.length) {
    var se = transformPathsToObjectTree(ne);
    le.getters = Object.keys(se).map(function(ce) {
      return {
        key: ce.endsWith("/") ? extractNameFromPath(ce) : ce,
        editable: !1,
        value: canThrow(function() {
          return se[ce];
        })
      };
    });
  }
  return le;
}
function transformPathsToObjectTree(re) {
  var ne = {};
  return Object.keys(re).forEach(function(ae) {
    var ie = ae.split("/");
    if (ie.length > 1) {
      var le = ne, se = ie.pop();
      ie.forEach(function(ce) {
        le[ce] || (le[ce] = {
          _custom: {
            value: {},
            display: ce,
            tooltip: "Module",
            abstract: !0
          }
        }), le = le[ce]._custom.value;
      }), le[se] = canThrow(function() {
        return re[ae];
      });
    } else
      ne[ae] = canThrow(function() {
        return re[ae];
      });
  }), ne;
}
function getStoreModule(re, ne) {
  var ae = ne.split("/").filter(function(ie) {
    return ie;
  });
  return ae.reduce(
    function(ie, le, se) {
      var ce = ie[le];
      if (!ce)
        throw new Error('Missing module "' + le + '" for path "' + ne + '".');
      return se === ae.length - 1 ? ce : ce._children;
    },
    ne === "root" ? re : re.root._children
  );
}
function canThrow(re) {
  try {
    return re();
  } catch (ne) {
    return ne;
  }
}
var Module = function(ne, ae) {
  this.runtime = ae, this._children = /* @__PURE__ */ Object.create(null), this._rawModule = ne;
  var ie = ne.state;
  this.state = (typeof ie == "function" ? ie() : ie) || {};
}, prototypeAccessors$1 = { namespaced: { configurable: !0 } };
prototypeAccessors$1.namespaced.get = function() {
  return !!this._rawModule.namespaced;
};
Module.prototype.addChild = function(ne, ae) {
  this._children[ne] = ae;
};
Module.prototype.removeChild = function(ne) {
  delete this._children[ne];
};
Module.prototype.getChild = function(ne) {
  return this._children[ne];
};
Module.prototype.hasChild = function(ne) {
  return ne in this._children;
};
Module.prototype.update = function(ne) {
  this._rawModule.namespaced = ne.namespaced, ne.actions && (this._rawModule.actions = ne.actions), ne.mutations && (this._rawModule.mutations = ne.mutations), ne.getters && (this._rawModule.getters = ne.getters);
};
Module.prototype.forEachChild = function(ne) {
  forEachValue(this._children, ne);
};
Module.prototype.forEachGetter = function(ne) {
  this._rawModule.getters && forEachValue(this._rawModule.getters, ne);
};
Module.prototype.forEachAction = function(ne) {
  this._rawModule.actions && forEachValue(this._rawModule.actions, ne);
};
Module.prototype.forEachMutation = function(ne) {
  this._rawModule.mutations && forEachValue(this._rawModule.mutations, ne);
};
Object.defineProperties(Module.prototype, prototypeAccessors$1);
var ModuleCollection = function(ne) {
  this.register([], ne, !1);
};
ModuleCollection.prototype.get = function(ne) {
  return ne.reduce(function(ae, ie) {
    return ae.getChild(ie);
  }, this.root);
};
ModuleCollection.prototype.getNamespace = function(ne) {
  var ae = this.root;
  return ne.reduce(function(ie, le) {
    return ae = ae.getChild(le), ie + (ae.namespaced ? le + "/" : "");
  }, "");
};
ModuleCollection.prototype.update = function(ne) {
  update2([], this.root, ne);
};
ModuleCollection.prototype.register = function(ne, ae, ie) {
  var le = this;
  ie === void 0 && (ie = !0);
  var se = new Module(ae, ie);
  if (ne.length === 0)
    this.root = se;
  else {
    var ce = this.get(ne.slice(0, -1));
    ce.addChild(ne[ne.length - 1], se);
  }
  ae.modules && forEachValue(ae.modules, function(ue, de) {
    le.register(ne.concat(de), ue, ie);
  });
};
ModuleCollection.prototype.unregister = function(ne) {
  var ae = this.get(ne.slice(0, -1)), ie = ne[ne.length - 1], le = ae.getChild(ie);
  le && le.runtime && ae.removeChild(ie);
};
ModuleCollection.prototype.isRegistered = function(ne) {
  var ae = this.get(ne.slice(0, -1)), ie = ne[ne.length - 1];
  return ae ? ae.hasChild(ie) : !1;
};
function update2(re, ne, ae) {
  if (ne.update(ae), ae.modules)
    for (var ie in ae.modules) {
      if (!ne.getChild(ie))
        return;
      update2(
        re.concat(ie),
        ne.getChild(ie),
        ae.modules[ie]
      );
    }
}
var Store = function(ne) {
  var ae = this;
  ne === void 0 && (ne = {});
  var ie = ne.plugins;
  ie === void 0 && (ie = []);
  var le = ne.strict;
  le === void 0 && (le = !1);
  var se = ne.devtools;
  this._committing = !1, this._actions = /* @__PURE__ */ Object.create(null), this._actionSubscribers = [], this._mutations = /* @__PURE__ */ Object.create(null), this._wrappedGetters = /* @__PURE__ */ Object.create(null), this._modules = new ModuleCollection(ne), this._modulesNamespaceMap = /* @__PURE__ */ Object.create(null), this._subscribers = [], this._makeLocalGettersCache = /* @__PURE__ */ Object.create(null), this._scope = null, this._devtools = se;
  var ce = this, ue = this, de = ue.dispatch, me = ue.commit;
  this.dispatch = function(ge, be) {
    return de.call(ce, ge, be);
  }, this.commit = function(ge, be, Se) {
    return me.call(ce, ge, be, Se);
  }, this.strict = le;
  var fe = this._modules.root.state;
  installModule(this, fe, [], this._modules.root), resetStoreState(this, fe), ie.forEach(function(pe) {
    return pe(ae);
  });
}, prototypeAccessors = { state: { configurable: !0 } };
Store.prototype.install = function(ne, ae) {
  ne.provide(ae || storeKey, this), ne.config.globalProperties.$store = this;
  var ie = this._devtools !== void 0 ? this._devtools : !1;
  ie && addDevtools(ne, this);
};
prototypeAccessors.state.get = function() {
  return this._state.data;
};
prototypeAccessors.state.set = function(re) {
};
Store.prototype.commit = function(ne, ae, ie) {
  var le = this, se = unifyObjectStyle(ne, ae, ie), ce = se.type, ue = se.payload, de = { type: ce, payload: ue }, me = this._mutations[ce];
  me && (this._withCommit(function() {
    me.forEach(function(pe) {
      pe(ue);
    });
  }), this._subscribers.slice().forEach(function(fe) {
    return fe(de, le.state);
  }));
};
Store.prototype.dispatch = function(ne, ae) {
  var ie = this, le = unifyObjectStyle(ne, ae), se = le.type, ce = le.payload, ue = { type: se, payload: ce }, de = this._actions[se];
  if (de) {
    try {
      this._actionSubscribers.slice().filter(function(fe) {
        return fe.before;
      }).forEach(function(fe) {
        return fe.before(ue, ie.state);
      });
    } catch {
    }
    var me = de.length > 1 ? Promise.all(de.map(function(fe) {
      return fe(ce);
    })) : de[0](ce);
    return new Promise(function(fe, pe) {
      me.then(function(ge) {
        try {
          ie._actionSubscribers.filter(function(be) {
            return be.after;
          }).forEach(function(be) {
            return be.after(ue, ie.state);
          });
        } catch {
        }
        fe(ge);
      }, function(ge) {
        try {
          ie._actionSubscribers.filter(function(be) {
            return be.error;
          }).forEach(function(be) {
            return be.error(ue, ie.state, ge);
          });
        } catch {
        }
        pe(ge);
      });
    });
  }
};
Store.prototype.subscribe = function(ne, ae) {
  return genericSubscribe(ne, this._subscribers, ae);
};
Store.prototype.subscribeAction = function(ne, ae) {
  var ie = typeof ne == "function" ? { before: ne } : ne;
  return genericSubscribe(ie, this._actionSubscribers, ae);
};
Store.prototype.watch = function(ne, ae, ie) {
  var le = this;
  return watch(function() {
    return ne(le.state, le.getters);
  }, ae, Object.assign({}, ie));
};
Store.prototype.replaceState = function(ne) {
  var ae = this;
  this._withCommit(function() {
    ae._state.data = ne;
  });
};
Store.prototype.registerModule = function(ne, ae, ie) {
  ie === void 0 && (ie = {}), typeof ne == "string" && (ne = [ne]), this._modules.register(ne, ae), installModule(this, this.state, ne, this._modules.get(ne), ie.preserveState), resetStoreState(this, this.state);
};
Store.prototype.unregisterModule = function(ne) {
  var ae = this;
  typeof ne == "string" && (ne = [ne]), this._modules.unregister(ne), this._withCommit(function() {
    var ie = getNestedState(ae.state, ne.slice(0, -1));
    delete ie[ne[ne.length - 1]];
  }), resetStore(this);
};
Store.prototype.hasModule = function(ne) {
  return typeof ne == "string" && (ne = [ne]), this._modules.isRegistered(ne);
};
Store.prototype.hotUpdate = function(ne) {
  this._modules.update(ne), resetStore(this, !0);
};
Store.prototype._withCommit = function(ne) {
  var ae = this._committing;
  this._committing = !0, ne(), this._committing = ae;
};
Object.defineProperties(Store.prototype, prototypeAccessors);
var mapState = normalizeNamespace(function(re, ne) {
  var ae = {};
  return normalizeMap(ne).forEach(function(ie) {
    var le = ie.key, se = ie.val;
    ae[le] = function() {
      var ue = this.$store.state, de = this.$store.getters;
      if (re) {
        var me = getModuleByNamespace(this.$store, "mapState", re);
        if (!me)
          return;
        ue = me.context.state, de = me.context.getters;
      }
      return typeof se == "function" ? se.call(this, ue, de) : ue[se];
    }, ae[le].vuex = !0;
  }), ae;
}), mapGetters = normalizeNamespace(function(re, ne) {
  var ae = {};
  return normalizeMap(ne).forEach(function(ie) {
    var le = ie.key, se = ie.val;
    se = re + se, ae[le] = function() {
      if (!(re && !getModuleByNamespace(this.$store, "mapGetters", re)))
        return this.$store.getters[se];
    }, ae[le].vuex = !0;
  }), ae;
});
function normalizeMap(re) {
  return isValidMap(re) ? Array.isArray(re) ? re.map(function(ne) {
    return { key: ne, val: ne };
  }) : Object.keys(re).map(function(ne) {
    return { key: ne, val: re[ne] };
  }) : [];
}
function isValidMap(re) {
  return Array.isArray(re) || isObject$a(re);
}
function normalizeNamespace(re) {
  return function(ne, ae) {
    return typeof ne != "string" ? (ae = ne, ne = "") : ne.charAt(ne.length - 1) !== "/" && (ne += "/"), re(ne, ae);
  };
}
function getModuleByNamespace(re, ne, ae) {
  var ie = re._modulesNamespaceMap[ae];
  return ie;
}
class Auth0LoginError extends Error {
  constructor(ne) {
    super(ne), this.name = "Auth0LoginError";
  }
}
class Auth0RedirectCallbackError extends Error {
  constructor(ne) {
    super(ne), this.name = "Auth0RedirectCallbackError";
  }
}
class Auth0LogoutError extends Error {
  constructor(ne) {
    super(ne), this.name = "Auth0LogoutError";
  }
}
class Auth0ConfigError extends Error {
  constructor(ne) {
    super(ne), this.name = "Auth0ConfigError";
  }
}
class UnserialiseUserFailed extends Error {
  constructor(ne) {
    super(ne), this.name = "UnserialiseUser";
  }
}
class FindAuth0EnableListFailed extends Error {
  constructor(ne) {
    super(ne), this.name = "FindAuth0EnableListFailed";
  }
}
class GetRemoteClientAppConfigByHostnameFailed extends Error {
  constructor(ne) {
    super(ne), this.name = "GetRemoteClientAppConfigByHostnameFailed";
  }
}
class DeserializeGainsightFailed extends Error {
  constructor(ne) {
    super(ne), this.name = "DeserializeGainsight";
  }
}
const Assert = {
  isPresent: (re, ne) => {
    if (re == null)
      throw new Error(`required value ${ne} is not present.`);
    return re;
  }
}, User$1 = (re, ne, ae, ie, le, se, ce, ue) => (Assert.isPresent(re, "email"), Assert.isPresent(ne, "name"), Assert.isPresent(ae, "surname"), Assert.isPresent(ie, "groups"), Assert.isPresent(le, "siteCode"), Assert.isPresent(se, "isCompliSpaceStaff"), Assert.isPresent(ce, "isClientAdmin"), Assert.isPresent(ue, "picture"), {
  email: re,
  name: ne,
  surname: ae,
  groups: ie,
  siteCode: le,
  isCompliSpaceStaff: se,
  isClientAdmin: ce,
  picture: ue,
  getFullName: () => `${ne} ${ae}`,
  serialise: () => JSON.stringify({
    email: re,
    name: ne,
    surname: ae,
    groups: ie,
    siteCode: le,
    isCompliSpaceStaff: se,
    isClientAdmin: ce,
    picture: ue
  })
});
User$1.unserialise = (re) => {
  if (!re || Array.isArray(re))
    throw new UnserialiseUserFailed(`invalid input ${re}`);
  try {
    const ne = JSON.parse(re);
    return User$1(
      ne.email,
      ne.name,
      ne.surname,
      ne.groups,
      ne.siteCode,
      ne.isCompliSpaceStaff,
      ne.isClientAdmin,
      ne.picture
    );
  } catch (ne) {
    throw new UnserialiseUserFailed(`invalid input ${re} with ${ne.message}`);
  }
};
const parseGroup = (re, ne) => !re || !ne ? [] : re.filter((ae) => ne.includes(ae)), parseUser = (re, ne, ae) => {
  if (!re || re === "undefined")
    return null;
  const ie = ne.split(".")[0], le = parseGroup(re[`https://${ie}/groups`], ae), se = re[`https://${ie}/siteCode`] || "auth0", ce = !!re[`https://${ie}/isCompliSpaceStaff`], ue = !!re[`https://${ie}/isClientAdmin`];
  return User$1(
    re.email,
    re.given_name,
    re.family_name,
    le,
    se,
    ce,
    ue,
    re.picture
  );
}, RESET_SESSION = "resetSession", SET_USER = "setUser", SET_TOKEN = "setToken", SET_USER_GROUP_ALLOW_LIST = "setUserGroupAllowList", SET_SIDE_NAV = "setSideNav", TOGGLE_SIDE_NAV = "toggleSideNav", SET_ALERT = "setAlert", RESET_ALERT = "resetAlert", SET_DEFAULT_CURSOR = "setDefaultCursor", SET_PROGRESS_CURSOR = "setProgressCursor", SET_VIEW_TITLE = "setViewTitle", SET_DIALOG_IS_SHOWN = "setDialogIsShown", RESET_CS_APPEARANCE = "resetCsAppearance", SET_LOGIN_RESET_BTN_TIMEOUT = "loginResetBtnTimeout", SET_CS_SESSION_USER_GROUP_ALLOW_LIST = `cs-session/${SET_USER_GROUP_ALLOW_LIST}`, SET_AUTH0_CONFIG = "setAuth0Config", SET_CLIENT_APP_CONFIG = "setClientAppConfig", CS_APPEARANCE_SET_SIDE_NAV = `cs-appearance/${SET_SIDE_NAV}`, CS_APPEARANCE_SET_ALERT = `cs-appearance/${SET_ALERT}`, CS_APPEARANCE_RESET_ALERT = `cs-appearance/${RESET_ALERT}`, CS_APPEARANCE_SET_DEFAULT_CURSOR = `cs-appearance/${SET_DEFAULT_CURSOR}`, CS_APPEARANCE_SET_PROGRESS_CURSOR = `cs-appearance/${SET_PROGRESS_CURSOR}`, CS_APPEARANCE_SET_VIEW_TITLE = `cs-appearance/${SET_VIEW_TITLE}`, CS_APPEARANCE_SET_DIALOG_IS_SHOWN = `cs-appearance/${SET_DIALOG_IS_SHOWN}`, CS_APPEARANCE_SET_LOGIN_RESET_BTN_TIMEOUT = `cs-appearance/${SET_LOGIN_RESET_BTN_TIMEOUT}`, SET_GAINSIGHT_CONFIG = "setGainsightConfig", INIT_GAINSIGHT = "initGainsight", RESET_GAINSIGHT = "resetGainsight", GAINSIGHT_SET_GAINSIGHT_CONFIG = `gainsight/${SET_GAINSIGHT_CONFIG}`, Auth0State = reactive({
  loading: !1,
  auth0Client: null
});
function getDefaultExportFromCjs$1(re) {
  return re && re.__esModule && Object.prototype.hasOwnProperty.call(re, "default") ? re.default : re;
}
var browser$c = { exports: {} }, process = browser$c.exports = {}, cachedSetTimeout, cachedClearTimeout;
function defaultSetTimout() {
  throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? cachedSetTimeout = setTimeout : cachedSetTimeout = defaultSetTimout;
  } catch {
    cachedSetTimeout = defaultSetTimout;
  }
  try {
    typeof clearTimeout == "function" ? cachedClearTimeout = clearTimeout : cachedClearTimeout = defaultClearTimeout;
  } catch {
    cachedClearTimeout = defaultClearTimeout;
  }
})();
function runTimeout(re) {
  if (cachedSetTimeout === setTimeout)
    return setTimeout(re, 0);
  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout)
    return cachedSetTimeout = setTimeout, setTimeout(re, 0);
  try {
    return cachedSetTimeout(re, 0);
  } catch {
    try {
      return cachedSetTimeout.call(null, re, 0);
    } catch {
      return cachedSetTimeout.call(this, re, 0);
    }
  }
}
function runClearTimeout(re) {
  if (cachedClearTimeout === clearTimeout)
    return clearTimeout(re);
  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout)
    return cachedClearTimeout = clearTimeout, clearTimeout(re);
  try {
    return cachedClearTimeout(re);
  } catch {
    try {
      return cachedClearTimeout.call(null, re);
    } catch {
      return cachedClearTimeout.call(this, re);
    }
  }
}
var queue = [], draining = !1, currentQueue, queueIndex = -1;
function cleanUpNextTick() {
  !draining || !currentQueue || (draining = !1, currentQueue.length ? queue = currentQueue.concat(queue) : queueIndex = -1, queue.length && drainQueue());
}
function drainQueue() {
  if (!draining) {
    var re = runTimeout(cleanUpNextTick);
    draining = !0;
    for (var ne = queue.length; ne; ) {
      for (currentQueue = queue, queue = []; ++queueIndex < ne; )
        currentQueue && currentQueue[queueIndex].run();
      queueIndex = -1, ne = queue.length;
    }
    currentQueue = null, draining = !1, runClearTimeout(re);
  }
}
process.nextTick = function(re) {
  var ne = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var ae = 1; ae < arguments.length; ae++)
      ne[ae - 1] = arguments[ae];
  queue.push(new Item(re, ne)), queue.length === 1 && !draining && runTimeout(drainQueue);
};
function Item(re, ne) {
  this.fun = re, this.array = ne;
}
Item.prototype.run = function() {
  this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = !0;
process.env = {};
process.argv = [];
process.version = "";
process.versions = {};
function noop$4() {
}
process.on = noop$4;
process.addListener = noop$4;
process.once = noop$4;
process.off = noop$4;
process.removeListener = noop$4;
process.removeAllListeners = noop$4;
process.emit = noop$4;
process.prependListener = noop$4;
process.prependOnceListener = noop$4;
process.listeners = function(re) {
  return [];
};
process.binding = function(re) {
  throw new Error("process.binding is not supported");
};
process.cwd = function() {
  return "/";
};
process.chdir = function(re) {
  throw new Error("process.chdir is not supported");
};
process.umask = function() {
  return 0;
};
var browserExports$1 = browser$c.exports;
const process$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(browserExports$1);
function bind$5(re, ne) {
  return function() {
    return re.apply(ne, arguments);
  };
}
const { toString: toString$3 } = Object.prototype, { getPrototypeOf: getPrototypeOf$1 } = Object, kindOf = /* @__PURE__ */ ((re) => (ne) => {
  const ae = toString$3.call(ne);
  return re[ae] || (re[ae] = ae.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), kindOfTest = (re) => (re = re.toLowerCase(), (ne) => kindOf(ne) === re), typeOfTest = (re) => (ne) => typeof ne === re, { isArray: isArray$d } = Array, isUndefined$1 = typeOfTest("undefined");
function isBuffer$3(re) {
  return re !== null && !isUndefined$1(re) && re.constructor !== null && !isUndefined$1(re.constructor) && isFunction$5(re.constructor.isBuffer) && re.constructor.isBuffer(re);
}
const isArrayBuffer = kindOfTest("ArrayBuffer");
function isArrayBufferView(re) {
  let ne;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ne = ArrayBuffer.isView(re) : ne = re && re.buffer && isArrayBuffer(re.buffer), ne;
}
const isString$3 = typeOfTest("string"), isFunction$5 = typeOfTest("function"), isNumber$4 = typeOfTest("number"), isObject$9 = (re) => re !== null && typeof re == "object", isBoolean$2 = (re) => re === !0 || re === !1, isPlainObject$2 = (re) => {
  if (kindOf(re) !== "object")
    return !1;
  const ne = getPrototypeOf$1(re);
  return (ne === null || ne === Object.prototype || Object.getPrototypeOf(ne) === null) && !(Symbol.toStringTag in re) && !(Symbol.iterator in re);
}, isDate$2 = kindOfTest("Date"), isFile = kindOfTest("File"), isBlob = kindOfTest("Blob"), isFileList = kindOfTest("FileList"), isStream = (re) => isObject$9(re) && isFunction$5(re.pipe), isFormData = (re) => {
  let ne;
  return re && (typeof FormData == "function" && re instanceof FormData || isFunction$5(re.append) && ((ne = kindOf(re)) === "formdata" || // detect form-data instance
  ne === "object" && isFunction$5(re.toString) && re.toString() === "[object FormData]"));
}, isURLSearchParams = kindOfTest("URLSearchParams"), [isReadableStream, isRequest$2, isResponse, isHeaders] = ["ReadableStream", "Request", "Response", "Headers"].map(kindOfTest), trim = (re) => re.trim ? re.trim() : re.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function forEach$2(re, ne, { allOwnKeys: ae = !1 } = {}) {
  if (re === null || typeof re > "u")
    return;
  let ie, le;
  if (typeof re != "object" && (re = [re]), isArray$d(re))
    for (ie = 0, le = re.length; ie < le; ie++)
      ne.call(null, re[ie], ie, re);
  else {
    const se = ae ? Object.getOwnPropertyNames(re) : Object.keys(re), ce = se.length;
    let ue;
    for (ie = 0; ie < ce; ie++)
      ue = se[ie], ne.call(null, re[ue], ue, re);
  }
}
function findKey(re, ne) {
  ne = ne.toLowerCase();
  const ae = Object.keys(re);
  let ie = ae.length, le;
  for (; ie-- > 0; )
    if (le = ae[ie], ne === le.toLowerCase())
      return le;
  return null;
}
const _global = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global$1, isContextDefined = (re) => !isUndefined$1(re) && re !== _global;
function merge() {
  const { caseless: re } = isContextDefined(this) && this || {}, ne = {}, ae = (ie, le) => {
    const se = re && findKey(ne, le) || le;
    isPlainObject$2(ne[se]) && isPlainObject$2(ie) ? ne[se] = merge(ne[se], ie) : isPlainObject$2(ie) ? ne[se] = merge({}, ie) : isArray$d(ie) ? ne[se] = ie.slice() : ne[se] = ie;
  };
  for (let ie = 0, le = arguments.length; ie < le; ie++)
    arguments[ie] && forEach$2(arguments[ie], ae);
  return ne;
}
const extend = (re, ne, ae, { allOwnKeys: ie } = {}) => (forEach$2(ne, (le, se) => {
  ae && isFunction$5(le) ? re[se] = bind$5(le, ae) : re[se] = le;
}, { allOwnKeys: ie }), re), stripBOM = (re) => (re.charCodeAt(0) === 65279 && (re = re.slice(1)), re), inherits$s = (re, ne, ae, ie) => {
  re.prototype = Object.create(ne.prototype, ie), re.prototype.constructor = re, Object.defineProperty(re, "super", {
    value: ne.prototype
  }), ae && Object.assign(re.prototype, ae);
}, toFlatObject = (re, ne, ae, ie) => {
  let le, se, ce;
  const ue = {};
  if (ne = ne || {}, re == null) return ne;
  do {
    for (le = Object.getOwnPropertyNames(re), se = le.length; se-- > 0; )
      ce = le[se], (!ie || ie(ce, re, ne)) && !ue[ce] && (ne[ce] = re[ce], ue[ce] = !0);
    re = ae !== !1 && getPrototypeOf$1(re);
  } while (re && (!ae || ae(re, ne)) && re !== Object.prototype);
  return ne;
}, endsWith$1 = (re, ne, ae) => {
  re = String(re), (ae === void 0 || ae > re.length) && (ae = re.length), ae -= ne.length;
  const ie = re.indexOf(ne, ae);
  return ie !== -1 && ie === ae;
}, toArray$2 = (re) => {
  if (!re) return null;
  if (isArray$d(re)) return re;
  let ne = re.length;
  if (!isNumber$4(ne)) return null;
  const ae = new Array(ne);
  for (; ne-- > 0; )
    ae[ne] = re[ne];
  return ae;
}, isTypedArray$4 = /* @__PURE__ */ ((re) => (ne) => re && ne instanceof re)(typeof Uint8Array < "u" && getPrototypeOf$1(Uint8Array)), forEachEntry = (re, ne) => {
  const ie = (re && re[Symbol.iterator]).call(re);
  let le;
  for (; (le = ie.next()) && !le.done; ) {
    const se = le.value;
    ne.call(re, se[0], se[1]);
  }
}, matchAll = (re, ne) => {
  let ae;
  const ie = [];
  for (; (ae = re.exec(ne)) !== null; )
    ie.push(ae);
  return ie;
}, isHTMLForm = kindOfTest("HTMLFormElement"), toCamelCase = (re) => re.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(ae, ie, le) {
    return ie.toUpperCase() + le;
  }
), hasOwnProperty$b = (({ hasOwnProperty: re }) => (ne, ae) => re.call(ne, ae))(Object.prototype), isRegExp$2 = kindOfTest("RegExp"), reduceDescriptors = (re, ne) => {
  const ae = Object.getOwnPropertyDescriptors(re), ie = {};
  forEach$2(ae, (le, se) => {
    let ce;
    (ce = ne(le, se, re)) !== !1 && (ie[se] = ce || le);
  }), Object.defineProperties(re, ie);
}, freezeMethods = (re) => {
  reduceDescriptors(re, (ne, ae) => {
    if (isFunction$5(re) && ["arguments", "caller", "callee"].indexOf(ae) !== -1)
      return !1;
    const ie = re[ae];
    if (isFunction$5(ie)) {
      if (ne.enumerable = !1, "writable" in ne) {
        ne.writable = !1;
        return;
      }
      ne.set || (ne.set = () => {
        throw Error("Can not rewrite read-only method '" + ae + "'");
      });
    }
  });
}, toObjectSet = (re, ne) => {
  const ae = {}, ie = (le) => {
    le.forEach((se) => {
      ae[se] = !0;
    });
  };
  return isArray$d(re) ? ie(re) : ie(String(re).split(ne)), ae;
}, noop$3 = () => {
}, toFiniteNumber = (re, ne) => re != null && Number.isFinite(re = +re) ? re : ne, ALPHA = "abcdefghijklmnopqrstuvwxyz", DIGIT = "0123456789", ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}, generateString = (re = 16, ne = ALPHABET.ALPHA_DIGIT) => {
  let ae = "";
  const { length: ie } = ne;
  for (; re--; )
    ae += ne[Math.random() * ie | 0];
  return ae;
};
function isSpecCompliantForm(re) {
  return !!(re && isFunction$5(re.append) && re[Symbol.toStringTag] === "FormData" && re[Symbol.iterator]);
}
const toJSONObject = (re) => {
  const ne = new Array(10), ae = (ie, le) => {
    if (isObject$9(ie)) {
      if (ne.indexOf(ie) >= 0)
        return;
      if (!("toJSON" in ie)) {
        ne[le] = ie;
        const se = isArray$d(ie) ? [] : {};
        return forEach$2(ie, (ce, ue) => {
          const de = ae(ce, le + 1);
          !isUndefined$1(de) && (se[ue] = de);
        }), ne[le] = void 0, se;
      }
    }
    return ie;
  };
  return ae(re, 0);
}, isAsyncFn = kindOfTest("AsyncFunction"), isThenable = (re) => re && (isObject$9(re) || isFunction$5(re)) && isFunction$5(re.then) && isFunction$5(re.catch), _setImmediate = ((re, ne) => re ? setImmediate : ne ? ((ae, ie) => (_global.addEventListener("message", ({ source: le, data: se }) => {
  le === _global && se === ae && ie.length && ie.shift()();
}, !1), (le) => {
  ie.push(le), _global.postMessage(ae, "*");
}))(`axios@${Math.random()}`, []) : (ae) => setTimeout(ae))(
  typeof setImmediate == "function",
  isFunction$5(_global.postMessage)
), asap = typeof queueMicrotask < "u" ? queueMicrotask.bind(_global) : typeof process$1 < "u" && process$1.nextTick || _setImmediate, utils$p = {
  isArray: isArray$d,
  isArrayBuffer,
  isBuffer: isBuffer$3,
  isFormData,
  isArrayBufferView,
  isString: isString$3,
  isNumber: isNumber$4,
  isBoolean: isBoolean$2,
  isObject: isObject$9,
  isPlainObject: isPlainObject$2,
  isReadableStream,
  isRequest: isRequest$2,
  isResponse,
  isHeaders,
  isUndefined: isUndefined$1,
  isDate: isDate$2,
  isFile,
  isBlob,
  isRegExp: isRegExp$2,
  isFunction: isFunction$5,
  isStream,
  isURLSearchParams,
  isTypedArray: isTypedArray$4,
  isFileList,
  forEach: forEach$2,
  merge,
  extend,
  trim,
  stripBOM,
  inherits: inherits$s,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith: endsWith$1,
  toArray: toArray$2,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: hasOwnProperty$b,
  hasOwnProp: hasOwnProperty$b,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop: noop$3,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable,
  setImmediate: _setImmediate,
  asap
};
var buffer$1 = {}, base64Js = {};
base64Js.byteLength = byteLength;
base64Js.toByteArray = toByteArray;
base64Js.fromByteArray = fromByteArray;
var lookup = [], revLookup = [], Arr = typeof Uint8Array < "u" ? Uint8Array : Array, code$3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var i$1 = 0, len = code$3.length; i$1 < len; ++i$1)
  lookup[i$1] = code$3[i$1], revLookup[code$3.charCodeAt(i$1)] = i$1;
revLookup[45] = 62;
revLookup[95] = 63;
function getLens(re) {
  var ne = re.length;
  if (ne % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var ae = re.indexOf("=");
  ae === -1 && (ae = ne);
  var ie = ae === ne ? 0 : 4 - ae % 4;
  return [ae, ie];
}
function byteLength(re) {
  var ne = getLens(re), ae = ne[0], ie = ne[1];
  return (ae + ie) * 3 / 4 - ie;
}
function _byteLength(re, ne, ae) {
  return (ne + ae) * 3 / 4 - ae;
}
function toByteArray(re) {
  var ne, ae = getLens(re), ie = ae[0], le = ae[1], se = new Arr(_byteLength(re, ie, le)), ce = 0, ue = le > 0 ? ie - 4 : ie, de;
  for (de = 0; de < ue; de += 4)
    ne = revLookup[re.charCodeAt(de)] << 18 | revLookup[re.charCodeAt(de + 1)] << 12 | revLookup[re.charCodeAt(de + 2)] << 6 | revLookup[re.charCodeAt(de + 3)], se[ce++] = ne >> 16 & 255, se[ce++] = ne >> 8 & 255, se[ce++] = ne & 255;
  return le === 2 && (ne = revLookup[re.charCodeAt(de)] << 2 | revLookup[re.charCodeAt(de + 1)] >> 4, se[ce++] = ne & 255), le === 1 && (ne = revLookup[re.charCodeAt(de)] << 10 | revLookup[re.charCodeAt(de + 1)] << 4 | revLookup[re.charCodeAt(de + 2)] >> 2, se[ce++] = ne >> 8 & 255, se[ce++] = ne & 255), se;
}
function tripletToBase64(re) {
  return lookup[re >> 18 & 63] + lookup[re >> 12 & 63] + lookup[re >> 6 & 63] + lookup[re & 63];
}
function encodeChunk(re, ne, ae) {
  for (var ie, le = [], se = ne; se < ae; se += 3)
    ie = (re[se] << 16 & 16711680) + (re[se + 1] << 8 & 65280) + (re[se + 2] & 255), le.push(tripletToBase64(ie));
  return le.join("");
}
function fromByteArray(re) {
  for (var ne, ae = re.length, ie = ae % 3, le = [], se = 16383, ce = 0, ue = ae - ie; ce < ue; ce += se)
    le.push(encodeChunk(re, ce, ce + se > ue ? ue : ce + se));
  return ie === 1 ? (ne = re[ae - 1], le.push(
    lookup[ne >> 2] + lookup[ne << 4 & 63] + "=="
  )) : ie === 2 && (ne = (re[ae - 2] << 8) + re[ae - 1], le.push(
    lookup[ne >> 10] + lookup[ne >> 4 & 63] + lookup[ne << 2 & 63] + "="
  )), le.join("");
}
var ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
ieee754.read = function(re, ne, ae, ie, le) {
  var se, ce, ue = le * 8 - ie - 1, de = (1 << ue) - 1, me = de >> 1, fe = -7, pe = ae ? le - 1 : 0, ge = ae ? -1 : 1, be = re[ne + pe];
  for (pe += ge, se = be & (1 << -fe) - 1, be >>= -fe, fe += ue; fe > 0; se = se * 256 + re[ne + pe], pe += ge, fe -= 8)
    ;
  for (ce = se & (1 << -fe) - 1, se >>= -fe, fe += ie; fe > 0; ce = ce * 256 + re[ne + pe], pe += ge, fe -= 8)
    ;
  if (se === 0)
    se = 1 - me;
  else {
    if (se === de)
      return ce ? NaN : (be ? -1 : 1) * (1 / 0);
    ce = ce + Math.pow(2, ie), se = se - me;
  }
  return (be ? -1 : 1) * ce * Math.pow(2, se - ie);
};
ieee754.write = function(re, ne, ae, ie, le, se) {
  var ce, ue, de, me = se * 8 - le - 1, fe = (1 << me) - 1, pe = fe >> 1, ge = le === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, be = ie ? 0 : se - 1, Se = ie ? 1 : -1, Pe = ne < 0 || ne === 0 && 1 / ne < 0 ? 1 : 0;
  for (ne = Math.abs(ne), isNaN(ne) || ne === 1 / 0 ? (ue = isNaN(ne) ? 1 : 0, ce = fe) : (ce = Math.floor(Math.log(ne) / Math.LN2), ne * (de = Math.pow(2, -ce)) < 1 && (ce--, de *= 2), ce + pe >= 1 ? ne += ge / de : ne += ge * Math.pow(2, 1 - pe), ne * de >= 2 && (ce++, de /= 2), ce + pe >= fe ? (ue = 0, ce = fe) : ce + pe >= 1 ? (ue = (ne * de - 1) * Math.pow(2, le), ce = ce + pe) : (ue = ne * Math.pow(2, pe - 1) * Math.pow(2, le), ce = 0)); le >= 8; re[ae + be] = ue & 255, be += Se, ue /= 256, le -= 8)
    ;
  for (ce = ce << le | ue, me += le; me > 0; re[ae + be] = ce & 255, be += Se, ce /= 256, me -= 8)
    ;
  re[ae + be - Se] |= Pe * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(re) {
  const ne = base64Js, ae = ieee754, ie = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  re.Buffer = fe, re.SlowBuffer = He, re.INSPECT_MAX_BYTES = 50;
  const le = 2147483647;
  re.kMaxLength = le;
  const { Uint8Array: se, ArrayBuffer: ce, SharedArrayBuffer: ue } = globalThis;
  fe.TYPED_ARRAY_SUPPORT = de(), !fe.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function de() {
    try {
      const Je = new se(1), Me = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(Me, se.prototype), Object.setPrototypeOf(Je, Me), Je.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(fe.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (fe.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(fe.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (fe.isBuffer(this))
        return this.byteOffset;
    }
  });
  function me(Je) {
    if (Je > le)
      throw new RangeError('The value "' + Je + '" is invalid for option "size"');
    const Me = new se(Je);
    return Object.setPrototypeOf(Me, fe.prototype), Me;
  }
  function fe(Je, Me, Le) {
    if (typeof Je == "number") {
      if (typeof Me == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return Se(Je);
    }
    return pe(Je, Me, Le);
  }
  fe.poolSize = 8192;
  function pe(Je, Me, Le) {
    if (typeof Je == "string")
      return Pe(Je, Me);
    if (ce.isView(Je))
      return Ve(Je);
    if (Je == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Je
      );
    if (ut(Je, ce) || Je && ut(Je.buffer, ce) || typeof ue < "u" && (ut(Je, ue) || Je && ut(Je.buffer, ue)))
      return Ae(Je, Me, Le);
    if (typeof Je == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const Qe = Je.valueOf && Je.valueOf();
    if (Qe != null && Qe !== Je)
      return fe.from(Qe, Me, Le);
    const it = Oe(Je);
    if (it) return it;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof Je[Symbol.toPrimitive] == "function")
      return fe.from(Je[Symbol.toPrimitive]("string"), Me, Le);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Je
    );
  }
  fe.from = function(Je, Me, Le) {
    return pe(Je, Me, Le);
  }, Object.setPrototypeOf(fe.prototype, se.prototype), Object.setPrototypeOf(fe, se);
  function ge(Je) {
    if (typeof Je != "number")
      throw new TypeError('"size" argument must be of type number');
    if (Je < 0)
      throw new RangeError('The value "' + Je + '" is invalid for option "size"');
  }
  function be(Je, Me, Le) {
    return ge(Je), Je <= 0 ? me(Je) : Me !== void 0 ? typeof Le == "string" ? me(Je).fill(Me, Le) : me(Je).fill(Me) : me(Je);
  }
  fe.alloc = function(Je, Me, Le) {
    return be(Je, Me, Le);
  };
  function Se(Je) {
    return ge(Je), me(Je < 0 ? 0 : Ne(Je) | 0);
  }
  fe.allocUnsafe = function(Je) {
    return Se(Je);
  }, fe.allocUnsafeSlow = function(Je) {
    return Se(Je);
  };
  function Pe(Je, Me) {
    if ((typeof Me != "string" || Me === "") && (Me = "utf8"), !fe.isEncoding(Me))
      throw new TypeError("Unknown encoding: " + Me);
    const Le = Ue(Je, Me) | 0;
    let Qe = me(Le);
    const it = Qe.write(Je, Me);
    return it !== Le && (Qe = Qe.slice(0, it)), Qe;
  }
  function Ee(Je) {
    const Me = Je.length < 0 ? 0 : Ne(Je.length) | 0, Le = me(Me);
    for (let Qe = 0; Qe < Me; Qe += 1)
      Le[Qe] = Je[Qe] & 255;
    return Le;
  }
  function Ve(Je) {
    if (ut(Je, se)) {
      const Me = new se(Je);
      return Ae(Me.buffer, Me.byteOffset, Me.byteLength);
    }
    return Ee(Je);
  }
  function Ae(Je, Me, Le) {
    if (Me < 0 || Je.byteLength < Me)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (Je.byteLength < Me + (Le || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let Qe;
    return Me === void 0 && Le === void 0 ? Qe = new se(Je) : Le === void 0 ? Qe = new se(Je, Me) : Qe = new se(Je, Me, Le), Object.setPrototypeOf(Qe, fe.prototype), Qe;
  }
  function Oe(Je) {
    if (fe.isBuffer(Je)) {
      const Me = Ne(Je.length) | 0, Le = me(Me);
      return Le.length === 0 || Je.copy(Le, 0, 0, Me), Le;
    }
    if (Je.length !== void 0)
      return typeof Je.length != "number" || ht(Je.length) ? me(0) : Ee(Je);
    if (Je.type === "Buffer" && Array.isArray(Je.data))
      return Ee(Je.data);
  }
  function Ne(Je) {
    if (Je >= le)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + le.toString(16) + " bytes");
    return Je | 0;
  }
  function He(Je) {
    return +Je != Je && (Je = 0), fe.alloc(+Je);
  }
  fe.isBuffer = function(Me) {
    return Me != null && Me._isBuffer === !0 && Me !== fe.prototype;
  }, fe.compare = function(Me, Le) {
    if (ut(Me, se) && (Me = fe.from(Me, Me.offset, Me.byteLength)), ut(Le, se) && (Le = fe.from(Le, Le.offset, Le.byteLength)), !fe.isBuffer(Me) || !fe.isBuffer(Le))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (Me === Le) return 0;
    let Qe = Me.length, it = Le.length;
    for (let st = 0, ct = Math.min(Qe, it); st < ct; ++st)
      if (Me[st] !== Le[st]) {
        Qe = Me[st], it = Le[st];
        break;
      }
    return Qe < it ? -1 : it < Qe ? 1 : 0;
  }, fe.isEncoding = function(Me) {
    switch (String(Me).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, fe.concat = function(Me, Le) {
    if (!Array.isArray(Me))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (Me.length === 0)
      return fe.alloc(0);
    let Qe;
    if (Le === void 0)
      for (Le = 0, Qe = 0; Qe < Me.length; ++Qe)
        Le += Me[Qe].length;
    const it = fe.allocUnsafe(Le);
    let st = 0;
    for (Qe = 0; Qe < Me.length; ++Qe) {
      let ct = Me[Qe];
      if (ut(ct, se))
        st + ct.length > it.length ? (fe.isBuffer(ct) || (ct = fe.from(ct)), ct.copy(it, st)) : se.prototype.set.call(
          it,
          ct,
          st
        );
      else if (fe.isBuffer(ct))
        ct.copy(it, st);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      st += ct.length;
    }
    return it;
  };
  function Ue(Je, Me) {
    if (fe.isBuffer(Je))
      return Je.length;
    if (ce.isView(Je) || ut(Je, ce))
      return Je.byteLength;
    if (typeof Je != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof Je
      );
    const Le = Je.length, Qe = arguments.length > 2 && arguments[2] === !0;
    if (!Qe && Le === 0) return 0;
    let it = !1;
    for (; ; )
      switch (Me) {
        case "ascii":
        case "latin1":
        case "binary":
          return Le;
        case "utf8":
        case "utf-8":
          return gt(Je).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Le * 2;
        case "hex":
          return Le >>> 1;
        case "base64":
          return wt(Je).length;
        default:
          if (it)
            return Qe ? -1 : gt(Je).length;
          Me = ("" + Me).toLowerCase(), it = !0;
      }
  }
  fe.byteLength = Ue;
  function Ze(Je, Me, Le) {
    let Qe = !1;
    if ((Me === void 0 || Me < 0) && (Me = 0), Me > this.length || ((Le === void 0 || Le > this.length) && (Le = this.length), Le <= 0) || (Le >>>= 0, Me >>>= 0, Le <= Me))
      return "";
    for (Je || (Je = "utf8"); ; )
      switch (Je) {
        case "hex":
          return ye(this, Me, Le);
        case "utf8":
        case "utf-8":
          return $e(this, Me, Le);
        case "ascii":
          return we(this, Me, Le);
        case "latin1":
        case "binary":
          return ke(this, Me, Le);
        case "base64":
          return xe(this, Me, Le);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Be(this, Me, Le);
        default:
          if (Qe) throw new TypeError("Unknown encoding: " + Je);
          Je = (Je + "").toLowerCase(), Qe = !0;
      }
  }
  fe.prototype._isBuffer = !0;
  function Fe(Je, Me, Le) {
    const Qe = Je[Me];
    Je[Me] = Je[Le], Je[Le] = Qe;
  }
  fe.prototype.swap16 = function() {
    const Me = this.length;
    if (Me % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let Le = 0; Le < Me; Le += 2)
      Fe(this, Le, Le + 1);
    return this;
  }, fe.prototype.swap32 = function() {
    const Me = this.length;
    if (Me % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let Le = 0; Le < Me; Le += 4)
      Fe(this, Le, Le + 3), Fe(this, Le + 1, Le + 2);
    return this;
  }, fe.prototype.swap64 = function() {
    const Me = this.length;
    if (Me % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let Le = 0; Le < Me; Le += 8)
      Fe(this, Le, Le + 7), Fe(this, Le + 1, Le + 6), Fe(this, Le + 2, Le + 5), Fe(this, Le + 3, Le + 4);
    return this;
  }, fe.prototype.toString = function() {
    const Me = this.length;
    return Me === 0 ? "" : arguments.length === 0 ? $e(this, 0, Me) : Ze.apply(this, arguments);
  }, fe.prototype.toLocaleString = fe.prototype.toString, fe.prototype.equals = function(Me) {
    if (!fe.isBuffer(Me)) throw new TypeError("Argument must be a Buffer");
    return this === Me ? !0 : fe.compare(this, Me) === 0;
  }, fe.prototype.inspect = function() {
    let Me = "";
    const Le = re.INSPECT_MAX_BYTES;
    return Me = this.toString("hex", 0, Le).replace(/(.{2})/g, "$1 ").trim(), this.length > Le && (Me += " ... "), "<Buffer " + Me + ">";
  }, ie && (fe.prototype[ie] = fe.prototype.inspect), fe.prototype.compare = function(Me, Le, Qe, it, st) {
    if (ut(Me, se) && (Me = fe.from(Me, Me.offset, Me.byteLength)), !fe.isBuffer(Me))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof Me
      );
    if (Le === void 0 && (Le = 0), Qe === void 0 && (Qe = Me ? Me.length : 0), it === void 0 && (it = 0), st === void 0 && (st = this.length), Le < 0 || Qe > Me.length || it < 0 || st > this.length)
      throw new RangeError("out of range index");
    if (it >= st && Le >= Qe)
      return 0;
    if (it >= st)
      return -1;
    if (Le >= Qe)
      return 1;
    if (Le >>>= 0, Qe >>>= 0, it >>>= 0, st >>>= 0, this === Me) return 0;
    let ct = st - it, kt = Qe - Le;
    const St = Math.min(ct, kt), yt = this.slice(it, st), Nt = Me.slice(Le, Qe);
    for (let _t = 0; _t < St; ++_t)
      if (yt[_t] !== Nt[_t]) {
        ct = yt[_t], kt = Nt[_t];
        break;
      }
    return ct < kt ? -1 : kt < ct ? 1 : 0;
  };
  function Ke(Je, Me, Le, Qe, it) {
    if (Je.length === 0) return -1;
    if (typeof Le == "string" ? (Qe = Le, Le = 0) : Le > 2147483647 ? Le = 2147483647 : Le < -2147483648 && (Le = -2147483648), Le = +Le, ht(Le) && (Le = it ? 0 : Je.length - 1), Le < 0 && (Le = Je.length + Le), Le >= Je.length) {
      if (it) return -1;
      Le = Je.length - 1;
    } else if (Le < 0)
      if (it) Le = 0;
      else return -1;
    if (typeof Me == "string" && (Me = fe.from(Me, Qe)), fe.isBuffer(Me))
      return Me.length === 0 ? -1 : tt(Je, Me, Le, Qe, it);
    if (typeof Me == "number")
      return Me = Me & 255, typeof se.prototype.indexOf == "function" ? it ? se.prototype.indexOf.call(Je, Me, Le) : se.prototype.lastIndexOf.call(Je, Me, Le) : tt(Je, [Me], Le, Qe, it);
    throw new TypeError("val must be string, number or Buffer");
  }
  function tt(Je, Me, Le, Qe, it) {
    let st = 1, ct = Je.length, kt = Me.length;
    if (Qe !== void 0 && (Qe = String(Qe).toLowerCase(), Qe === "ucs2" || Qe === "ucs-2" || Qe === "utf16le" || Qe === "utf-16le")) {
      if (Je.length < 2 || Me.length < 2)
        return -1;
      st = 2, ct /= 2, kt /= 2, Le /= 2;
    }
    function St(Nt, _t) {
      return st === 1 ? Nt[_t] : Nt.readUInt16BE(_t * st);
    }
    let yt;
    if (it) {
      let Nt = -1;
      for (yt = Le; yt < ct; yt++)
        if (St(Je, yt) === St(Me, Nt === -1 ? 0 : yt - Nt)) {
          if (Nt === -1 && (Nt = yt), yt - Nt + 1 === kt) return Nt * st;
        } else
          Nt !== -1 && (yt -= yt - Nt), Nt = -1;
    } else
      for (Le + kt > ct && (Le = ct - kt), yt = Le; yt >= 0; yt--) {
        let Nt = !0;
        for (let _t = 0; _t < kt; _t++)
          if (St(Je, yt + _t) !== St(Me, _t)) {
            Nt = !1;
            break;
          }
        if (Nt) return yt;
      }
    return -1;
  }
  fe.prototype.includes = function(Me, Le, Qe) {
    return this.indexOf(Me, Le, Qe) !== -1;
  }, fe.prototype.indexOf = function(Me, Le, Qe) {
    return Ke(this, Me, Le, Qe, !0);
  }, fe.prototype.lastIndexOf = function(Me, Le, Qe) {
    return Ke(this, Me, Le, Qe, !1);
  };
  function Re(Je, Me, Le, Qe) {
    Le = Number(Le) || 0;
    const it = Je.length - Le;
    Qe ? (Qe = Number(Qe), Qe > it && (Qe = it)) : Qe = it;
    const st = Me.length;
    Qe > st / 2 && (Qe = st / 2);
    let ct;
    for (ct = 0; ct < Qe; ++ct) {
      const kt = parseInt(Me.substr(ct * 2, 2), 16);
      if (ht(kt)) return ct;
      Je[Le + ct] = kt;
    }
    return ct;
  }
  function Ce(Je, Me, Le, Qe) {
    return pt(gt(Me, Je.length - Le), Je, Le, Qe);
  }
  function _e(Je, Me, Le, Qe) {
    return pt(bt(Me), Je, Le, Qe);
  }
  function he(Je, Me, Le, Qe) {
    return pt(wt(Me), Je, Le, Qe);
  }
  function ve(Je, Me, Le, Qe) {
    return pt(At(Me, Je.length - Le), Je, Le, Qe);
  }
  fe.prototype.write = function(Me, Le, Qe, it) {
    if (Le === void 0)
      it = "utf8", Qe = this.length, Le = 0;
    else if (Qe === void 0 && typeof Le == "string")
      it = Le, Qe = this.length, Le = 0;
    else if (isFinite(Le))
      Le = Le >>> 0, isFinite(Qe) ? (Qe = Qe >>> 0, it === void 0 && (it = "utf8")) : (it = Qe, Qe = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const st = this.length - Le;
    if ((Qe === void 0 || Qe > st) && (Qe = st), Me.length > 0 && (Qe < 0 || Le < 0) || Le > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    it || (it = "utf8");
    let ct = !1;
    for (; ; )
      switch (it) {
        case "hex":
          return Re(this, Me, Le, Qe);
        case "utf8":
        case "utf-8":
          return Ce(this, Me, Le, Qe);
        case "ascii":
        case "latin1":
        case "binary":
          return _e(this, Me, Le, Qe);
        case "base64":
          return he(this, Me, Le, Qe);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return ve(this, Me, Le, Qe);
        default:
          if (ct) throw new TypeError("Unknown encoding: " + it);
          it = ("" + it).toLowerCase(), ct = !0;
      }
  }, fe.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function xe(Je, Me, Le) {
    return Me === 0 && Le === Je.length ? ne.fromByteArray(Je) : ne.fromByteArray(Je.slice(Me, Le));
  }
  function $e(Je, Me, Le) {
    Le = Math.min(Je.length, Le);
    const Qe = [];
    let it = Me;
    for (; it < Le; ) {
      const st = Je[it];
      let ct = null, kt = st > 239 ? 4 : st > 223 ? 3 : st > 191 ? 2 : 1;
      if (it + kt <= Le) {
        let St, yt, Nt, _t;
        switch (kt) {
          case 1:
            st < 128 && (ct = st);
            break;
          case 2:
            St = Je[it + 1], (St & 192) === 128 && (_t = (st & 31) << 6 | St & 63, _t > 127 && (ct = _t));
            break;
          case 3:
            St = Je[it + 1], yt = Je[it + 2], (St & 192) === 128 && (yt & 192) === 128 && (_t = (st & 15) << 12 | (St & 63) << 6 | yt & 63, _t > 2047 && (_t < 55296 || _t > 57343) && (ct = _t));
            break;
          case 4:
            St = Je[it + 1], yt = Je[it + 2], Nt = Je[it + 3], (St & 192) === 128 && (yt & 192) === 128 && (Nt & 192) === 128 && (_t = (st & 15) << 18 | (St & 63) << 12 | (yt & 63) << 6 | Nt & 63, _t > 65535 && _t < 1114112 && (ct = _t));
        }
      }
      ct === null ? (ct = 65533, kt = 1) : ct > 65535 && (ct -= 65536, Qe.push(ct >>> 10 & 1023 | 55296), ct = 56320 | ct & 1023), Qe.push(ct), it += kt;
    }
    return Ie(Qe);
  }
  const Te = 4096;
  function Ie(Je) {
    const Me = Je.length;
    if (Me <= Te)
      return String.fromCharCode.apply(String, Je);
    let Le = "", Qe = 0;
    for (; Qe < Me; )
      Le += String.fromCharCode.apply(
        String,
        Je.slice(Qe, Qe += Te)
      );
    return Le;
  }
  function we(Je, Me, Le) {
    let Qe = "";
    Le = Math.min(Je.length, Le);
    for (let it = Me; it < Le; ++it)
      Qe += String.fromCharCode(Je[it] & 127);
    return Qe;
  }
  function ke(Je, Me, Le) {
    let Qe = "";
    Le = Math.min(Je.length, Le);
    for (let it = Me; it < Le; ++it)
      Qe += String.fromCharCode(Je[it]);
    return Qe;
  }
  function ye(Je, Me, Le) {
    const Qe = Je.length;
    (!Me || Me < 0) && (Me = 0), (!Le || Le < 0 || Le > Qe) && (Le = Qe);
    let it = "";
    for (let st = Me; st < Le; ++st)
      it += vt[Je[st]];
    return it;
  }
  function Be(Je, Me, Le) {
    const Qe = Je.slice(Me, Le);
    let it = "";
    for (let st = 0; st < Qe.length - 1; st += 2)
      it += String.fromCharCode(Qe[st] + Qe[st + 1] * 256);
    return it;
  }
  fe.prototype.slice = function(Me, Le) {
    const Qe = this.length;
    Me = ~~Me, Le = Le === void 0 ? Qe : ~~Le, Me < 0 ? (Me += Qe, Me < 0 && (Me = 0)) : Me > Qe && (Me = Qe), Le < 0 ? (Le += Qe, Le < 0 && (Le = 0)) : Le > Qe && (Le = Qe), Le < Me && (Le = Me);
    const it = this.subarray(Me, Le);
    return Object.setPrototypeOf(it, fe.prototype), it;
  };
  function Xe(Je, Me, Le) {
    if (Je % 1 !== 0 || Je < 0) throw new RangeError("offset is not uint");
    if (Je + Me > Le) throw new RangeError("Trying to access beyond buffer length");
  }
  fe.prototype.readUintLE = fe.prototype.readUIntLE = function(Me, Le, Qe) {
    Me = Me >>> 0, Le = Le >>> 0, Qe || Xe(Me, Le, this.length);
    let it = this[Me], st = 1, ct = 0;
    for (; ++ct < Le && (st *= 256); )
      it += this[Me + ct] * st;
    return it;
  }, fe.prototype.readUintBE = fe.prototype.readUIntBE = function(Me, Le, Qe) {
    Me = Me >>> 0, Le = Le >>> 0, Qe || Xe(Me, Le, this.length);
    let it = this[Me + --Le], st = 1;
    for (; Le > 0 && (st *= 256); )
      it += this[Me + --Le] * st;
    return it;
  }, fe.prototype.readUint8 = fe.prototype.readUInt8 = function(Me, Le) {
    return Me = Me >>> 0, Le || Xe(Me, 1, this.length), this[Me];
  }, fe.prototype.readUint16LE = fe.prototype.readUInt16LE = function(Me, Le) {
    return Me = Me >>> 0, Le || Xe(Me, 2, this.length), this[Me] | this[Me + 1] << 8;
  }, fe.prototype.readUint16BE = fe.prototype.readUInt16BE = function(Me, Le) {
    return Me = Me >>> 0, Le || Xe(Me, 2, this.length), this[Me] << 8 | this[Me + 1];
  }, fe.prototype.readUint32LE = fe.prototype.readUInt32LE = function(Me, Le) {
    return Me = Me >>> 0, Le || Xe(Me, 4, this.length), (this[Me] | this[Me + 1] << 8 | this[Me + 2] << 16) + this[Me + 3] * 16777216;
  }, fe.prototype.readUint32BE = fe.prototype.readUInt32BE = function(Me, Le) {
    return Me = Me >>> 0, Le || Xe(Me, 4, this.length), this[Me] * 16777216 + (this[Me + 1] << 16 | this[Me + 2] << 8 | this[Me + 3]);
  }, fe.prototype.readBigUInt64LE = xt(function(Me) {
    Me = Me >>> 0, ot(Me, "offset");
    const Le = this[Me], Qe = this[Me + 7];
    (Le === void 0 || Qe === void 0) && lt(Me, this.length - 8);
    const it = Le + this[++Me] * 2 ** 8 + this[++Me] * 2 ** 16 + this[++Me] * 2 ** 24, st = this[++Me] + this[++Me] * 2 ** 8 + this[++Me] * 2 ** 16 + Qe * 2 ** 24;
    return BigInt(it) + (BigInt(st) << BigInt(32));
  }), fe.prototype.readBigUInt64BE = xt(function(Me) {
    Me = Me >>> 0, ot(Me, "offset");
    const Le = this[Me], Qe = this[Me + 7];
    (Le === void 0 || Qe === void 0) && lt(Me, this.length - 8);
    const it = Le * 2 ** 24 + this[++Me] * 2 ** 16 + this[++Me] * 2 ** 8 + this[++Me], st = this[++Me] * 2 ** 24 + this[++Me] * 2 ** 16 + this[++Me] * 2 ** 8 + Qe;
    return (BigInt(it) << BigInt(32)) + BigInt(st);
  }), fe.prototype.readIntLE = function(Me, Le, Qe) {
    Me = Me >>> 0, Le = Le >>> 0, Qe || Xe(Me, Le, this.length);
    let it = this[Me], st = 1, ct = 0;
    for (; ++ct < Le && (st *= 256); )
      it += this[Me + ct] * st;
    return st *= 128, it >= st && (it -= Math.pow(2, 8 * Le)), it;
  }, fe.prototype.readIntBE = function(Me, Le, Qe) {
    Me = Me >>> 0, Le = Le >>> 0, Qe || Xe(Me, Le, this.length);
    let it = Le, st = 1, ct = this[Me + --it];
    for (; it > 0 && (st *= 256); )
      ct += this[Me + --it] * st;
    return st *= 128, ct >= st && (ct -= Math.pow(2, 8 * Le)), ct;
  }, fe.prototype.readInt8 = function(Me, Le) {
    return Me = Me >>> 0, Le || Xe(Me, 1, this.length), this[Me] & 128 ? (255 - this[Me] + 1) * -1 : this[Me];
  }, fe.prototype.readInt16LE = function(Me, Le) {
    Me = Me >>> 0, Le || Xe(Me, 2, this.length);
    const Qe = this[Me] | this[Me + 1] << 8;
    return Qe & 32768 ? Qe | 4294901760 : Qe;
  }, fe.prototype.readInt16BE = function(Me, Le) {
    Me = Me >>> 0, Le || Xe(Me, 2, this.length);
    const Qe = this[Me + 1] | this[Me] << 8;
    return Qe & 32768 ? Qe | 4294901760 : Qe;
  }, fe.prototype.readInt32LE = function(Me, Le) {
    return Me = Me >>> 0, Le || Xe(Me, 4, this.length), this[Me] | this[Me + 1] << 8 | this[Me + 2] << 16 | this[Me + 3] << 24;
  }, fe.prototype.readInt32BE = function(Me, Le) {
    return Me = Me >>> 0, Le || Xe(Me, 4, this.length), this[Me] << 24 | this[Me + 1] << 16 | this[Me + 2] << 8 | this[Me + 3];
  }, fe.prototype.readBigInt64LE = xt(function(Me) {
    Me = Me >>> 0, ot(Me, "offset");
    const Le = this[Me], Qe = this[Me + 7];
    (Le === void 0 || Qe === void 0) && lt(Me, this.length - 8);
    const it = this[Me + 4] + this[Me + 5] * 2 ** 8 + this[Me + 6] * 2 ** 16 + (Qe << 24);
    return (BigInt(it) << BigInt(32)) + BigInt(Le + this[++Me] * 2 ** 8 + this[++Me] * 2 ** 16 + this[++Me] * 2 ** 24);
  }), fe.prototype.readBigInt64BE = xt(function(Me) {
    Me = Me >>> 0, ot(Me, "offset");
    const Le = this[Me], Qe = this[Me + 7];
    (Le === void 0 || Qe === void 0) && lt(Me, this.length - 8);
    const it = (Le << 24) + // Overflow
    this[++Me] * 2 ** 16 + this[++Me] * 2 ** 8 + this[++Me];
    return (BigInt(it) << BigInt(32)) + BigInt(this[++Me] * 2 ** 24 + this[++Me] * 2 ** 16 + this[++Me] * 2 ** 8 + Qe);
  }), fe.prototype.readFloatLE = function(Me, Le) {
    return Me = Me >>> 0, Le || Xe(Me, 4, this.length), ae.read(this, Me, !0, 23, 4);
  }, fe.prototype.readFloatBE = function(Me, Le) {
    return Me = Me >>> 0, Le || Xe(Me, 4, this.length), ae.read(this, Me, !1, 23, 4);
  }, fe.prototype.readDoubleLE = function(Me, Le) {
    return Me = Me >>> 0, Le || Xe(Me, 8, this.length), ae.read(this, Me, !0, 52, 8);
  }, fe.prototype.readDoubleBE = function(Me, Le) {
    return Me = Me >>> 0, Le || Xe(Me, 8, this.length), ae.read(this, Me, !1, 52, 8);
  };
  function et(Je, Me, Le, Qe, it, st) {
    if (!fe.isBuffer(Je)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (Me > it || Me < st) throw new RangeError('"value" argument is out of bounds');
    if (Le + Qe > Je.length) throw new RangeError("Index out of range");
  }
  fe.prototype.writeUintLE = fe.prototype.writeUIntLE = function(Me, Le, Qe, it) {
    if (Me = +Me, Le = Le >>> 0, Qe = Qe >>> 0, !it) {
      const kt = Math.pow(2, 8 * Qe) - 1;
      et(this, Me, Le, Qe, kt, 0);
    }
    let st = 1, ct = 0;
    for (this[Le] = Me & 255; ++ct < Qe && (st *= 256); )
      this[Le + ct] = Me / st & 255;
    return Le + Qe;
  }, fe.prototype.writeUintBE = fe.prototype.writeUIntBE = function(Me, Le, Qe, it) {
    if (Me = +Me, Le = Le >>> 0, Qe = Qe >>> 0, !it) {
      const kt = Math.pow(2, 8 * Qe) - 1;
      et(this, Me, Le, Qe, kt, 0);
    }
    let st = Qe - 1, ct = 1;
    for (this[Le + st] = Me & 255; --st >= 0 && (ct *= 256); )
      this[Le + st] = Me / ct & 255;
    return Le + Qe;
  }, fe.prototype.writeUint8 = fe.prototype.writeUInt8 = function(Me, Le, Qe) {
    return Me = +Me, Le = Le >>> 0, Qe || et(this, Me, Le, 1, 255, 0), this[Le] = Me & 255, Le + 1;
  }, fe.prototype.writeUint16LE = fe.prototype.writeUInt16LE = function(Me, Le, Qe) {
    return Me = +Me, Le = Le >>> 0, Qe || et(this, Me, Le, 2, 65535, 0), this[Le] = Me & 255, this[Le + 1] = Me >>> 8, Le + 2;
  }, fe.prototype.writeUint16BE = fe.prototype.writeUInt16BE = function(Me, Le, Qe) {
    return Me = +Me, Le = Le >>> 0, Qe || et(this, Me, Le, 2, 65535, 0), this[Le] = Me >>> 8, this[Le + 1] = Me & 255, Le + 2;
  }, fe.prototype.writeUint32LE = fe.prototype.writeUInt32LE = function(Me, Le, Qe) {
    return Me = +Me, Le = Le >>> 0, Qe || et(this, Me, Le, 4, 4294967295, 0), this[Le + 3] = Me >>> 24, this[Le + 2] = Me >>> 16, this[Le + 1] = Me >>> 8, this[Le] = Me & 255, Le + 4;
  }, fe.prototype.writeUint32BE = fe.prototype.writeUInt32BE = function(Me, Le, Qe) {
    return Me = +Me, Le = Le >>> 0, Qe || et(this, Me, Le, 4, 4294967295, 0), this[Le] = Me >>> 24, this[Le + 1] = Me >>> 16, this[Le + 2] = Me >>> 8, this[Le + 3] = Me & 255, Le + 4;
  };
  function Ye(Je, Me, Le, Qe, it) {
    nt(Me, Qe, it, Je, Le, 7);
    let st = Number(Me & BigInt(4294967295));
    Je[Le++] = st, st = st >> 8, Je[Le++] = st, st = st >> 8, Je[Le++] = st, st = st >> 8, Je[Le++] = st;
    let ct = Number(Me >> BigInt(32) & BigInt(4294967295));
    return Je[Le++] = ct, ct = ct >> 8, Je[Le++] = ct, ct = ct >> 8, Je[Le++] = ct, ct = ct >> 8, Je[Le++] = ct, Le;
  }
  function De(Je, Me, Le, Qe, it) {
    nt(Me, Qe, it, Je, Le, 7);
    let st = Number(Me & BigInt(4294967295));
    Je[Le + 7] = st, st = st >> 8, Je[Le + 6] = st, st = st >> 8, Je[Le + 5] = st, st = st >> 8, Je[Le + 4] = st;
    let ct = Number(Me >> BigInt(32) & BigInt(4294967295));
    return Je[Le + 3] = ct, ct = ct >> 8, Je[Le + 2] = ct, ct = ct >> 8, Je[Le + 1] = ct, ct = ct >> 8, Je[Le] = ct, Le + 8;
  }
  fe.prototype.writeBigUInt64LE = xt(function(Me, Le = 0) {
    return Ye(this, Me, Le, BigInt(0), BigInt("0xffffffffffffffff"));
  }), fe.prototype.writeBigUInt64BE = xt(function(Me, Le = 0) {
    return De(this, Me, Le, BigInt(0), BigInt("0xffffffffffffffff"));
  }), fe.prototype.writeIntLE = function(Me, Le, Qe, it) {
    if (Me = +Me, Le = Le >>> 0, !it) {
      const St = Math.pow(2, 8 * Qe - 1);
      et(this, Me, Le, Qe, St - 1, -St);
    }
    let st = 0, ct = 1, kt = 0;
    for (this[Le] = Me & 255; ++st < Qe && (ct *= 256); )
      Me < 0 && kt === 0 && this[Le + st - 1] !== 0 && (kt = 1), this[Le + st] = (Me / ct >> 0) - kt & 255;
    return Le + Qe;
  }, fe.prototype.writeIntBE = function(Me, Le, Qe, it) {
    if (Me = +Me, Le = Le >>> 0, !it) {
      const St = Math.pow(2, 8 * Qe - 1);
      et(this, Me, Le, Qe, St - 1, -St);
    }
    let st = Qe - 1, ct = 1, kt = 0;
    for (this[Le + st] = Me & 255; --st >= 0 && (ct *= 256); )
      Me < 0 && kt === 0 && this[Le + st + 1] !== 0 && (kt = 1), this[Le + st] = (Me / ct >> 0) - kt & 255;
    return Le + Qe;
  }, fe.prototype.writeInt8 = function(Me, Le, Qe) {
    return Me = +Me, Le = Le >>> 0, Qe || et(this, Me, Le, 1, 127, -128), Me < 0 && (Me = 255 + Me + 1), this[Le] = Me & 255, Le + 1;
  }, fe.prototype.writeInt16LE = function(Me, Le, Qe) {
    return Me = +Me, Le = Le >>> 0, Qe || et(this, Me, Le, 2, 32767, -32768), this[Le] = Me & 255, this[Le + 1] = Me >>> 8, Le + 2;
  }, fe.prototype.writeInt16BE = function(Me, Le, Qe) {
    return Me = +Me, Le = Le >>> 0, Qe || et(this, Me, Le, 2, 32767, -32768), this[Le] = Me >>> 8, this[Le + 1] = Me & 255, Le + 2;
  }, fe.prototype.writeInt32LE = function(Me, Le, Qe) {
    return Me = +Me, Le = Le >>> 0, Qe || et(this, Me, Le, 4, 2147483647, -2147483648), this[Le] = Me & 255, this[Le + 1] = Me >>> 8, this[Le + 2] = Me >>> 16, this[Le + 3] = Me >>> 24, Le + 4;
  }, fe.prototype.writeInt32BE = function(Me, Le, Qe) {
    return Me = +Me, Le = Le >>> 0, Qe || et(this, Me, Le, 4, 2147483647, -2147483648), Me < 0 && (Me = 4294967295 + Me + 1), this[Le] = Me >>> 24, this[Le + 1] = Me >>> 16, this[Le + 2] = Me >>> 8, this[Le + 3] = Me & 255, Le + 4;
  }, fe.prototype.writeBigInt64LE = xt(function(Me, Le = 0) {
    return Ye(this, Me, Le, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), fe.prototype.writeBigInt64BE = xt(function(Me, Le = 0) {
    return De(this, Me, Le, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function je(Je, Me, Le, Qe, it, st) {
    if (Le + Qe > Je.length) throw new RangeError("Index out of range");
    if (Le < 0) throw new RangeError("Index out of range");
  }
  function rt(Je, Me, Le, Qe, it) {
    return Me = +Me, Le = Le >>> 0, it || je(Je, Me, Le, 4), ae.write(Je, Me, Le, Qe, 23, 4), Le + 4;
  }
  fe.prototype.writeFloatLE = function(Me, Le, Qe) {
    return rt(this, Me, Le, !0, Qe);
  }, fe.prototype.writeFloatBE = function(Me, Le, Qe) {
    return rt(this, Me, Le, !1, Qe);
  };
  function at(Je, Me, Le, Qe, it) {
    return Me = +Me, Le = Le >>> 0, it || je(Je, Me, Le, 8), ae.write(Je, Me, Le, Qe, 52, 8), Le + 8;
  }
  fe.prototype.writeDoubleLE = function(Me, Le, Qe) {
    return at(this, Me, Le, !0, Qe);
  }, fe.prototype.writeDoubleBE = function(Me, Le, Qe) {
    return at(this, Me, Le, !1, Qe);
  }, fe.prototype.copy = function(Me, Le, Qe, it) {
    if (!fe.isBuffer(Me)) throw new TypeError("argument should be a Buffer");
    if (Qe || (Qe = 0), !it && it !== 0 && (it = this.length), Le >= Me.length && (Le = Me.length), Le || (Le = 0), it > 0 && it < Qe && (it = Qe), it === Qe || Me.length === 0 || this.length === 0) return 0;
    if (Le < 0)
      throw new RangeError("targetStart out of bounds");
    if (Qe < 0 || Qe >= this.length) throw new RangeError("Index out of range");
    if (it < 0) throw new RangeError("sourceEnd out of bounds");
    it > this.length && (it = this.length), Me.length - Le < it - Qe && (it = Me.length - Le + Qe);
    const st = it - Qe;
    return this === Me && typeof se.prototype.copyWithin == "function" ? this.copyWithin(Le, Qe, it) : se.prototype.set.call(
      Me,
      this.subarray(Qe, it),
      Le
    ), st;
  }, fe.prototype.fill = function(Me, Le, Qe, it) {
    if (typeof Me == "string") {
      if (typeof Le == "string" ? (it = Le, Le = 0, Qe = this.length) : typeof Qe == "string" && (it = Qe, Qe = this.length), it !== void 0 && typeof it != "string")
        throw new TypeError("encoding must be a string");
      if (typeof it == "string" && !fe.isEncoding(it))
        throw new TypeError("Unknown encoding: " + it);
      if (Me.length === 1) {
        const ct = Me.charCodeAt(0);
        (it === "utf8" && ct < 128 || it === "latin1") && (Me = ct);
      }
    } else typeof Me == "number" ? Me = Me & 255 : typeof Me == "boolean" && (Me = Number(Me));
    if (Le < 0 || this.length < Le || this.length < Qe)
      throw new RangeError("Out of range index");
    if (Qe <= Le)
      return this;
    Le = Le >>> 0, Qe = Qe === void 0 ? this.length : Qe >>> 0, Me || (Me = 0);
    let st;
    if (typeof Me == "number")
      for (st = Le; st < Qe; ++st)
        this[st] = Me;
    else {
      const ct = fe.isBuffer(Me) ? Me : fe.from(Me, it), kt = ct.length;
      if (kt === 0)
        throw new TypeError('The value "' + Me + '" is invalid for argument "value"');
      for (st = 0; st < Qe - Le; ++st)
        this[st + Le] = ct[st % kt];
    }
    return this;
  };
  const qe = {};
  function We(Je, Me, Le) {
    qe[Je] = class extends Le {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: Me.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${Je}]`, this.stack, delete this.name;
      }
      get code() {
        return Je;
      }
      set code(it) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: it,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${Je}]: ${this.message}`;
      }
    };
  }
  We(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(Je) {
      return Je ? `${Je} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), We(
    "ERR_INVALID_ARG_TYPE",
    function(Je, Me) {
      return `The "${Je}" argument must be of type number. Received type ${typeof Me}`;
    },
    TypeError
  ), We(
    "ERR_OUT_OF_RANGE",
    function(Je, Me, Le) {
      let Qe = `The value of "${Je}" is out of range.`, it = Le;
      return Number.isInteger(Le) && Math.abs(Le) > 2 ** 32 ? it = ze(String(Le)) : typeof Le == "bigint" && (it = String(Le), (Le > BigInt(2) ** BigInt(32) || Le < -(BigInt(2) ** BigInt(32))) && (it = ze(it)), it += "n"), Qe += ` It must be ${Me}. Received ${it}`, Qe;
    },
    RangeError
  );
  function ze(Je) {
    let Me = "", Le = Je.length;
    const Qe = Je[0] === "-" ? 1 : 0;
    for (; Le >= Qe + 4; Le -= 3)
      Me = `_${Je.slice(Le - 3, Le)}${Me}`;
    return `${Je.slice(0, Le)}${Me}`;
  }
  function Ge(Je, Me, Le) {
    ot(Me, "offset"), (Je[Me] === void 0 || Je[Me + Le] === void 0) && lt(Me, Je.length - (Le + 1));
  }
  function nt(Je, Me, Le, Qe, it, st) {
    if (Je > Le || Je < Me) {
      const ct = typeof Me == "bigint" ? "n" : "";
      let kt;
      throw Me === 0 || Me === BigInt(0) ? kt = `>= 0${ct} and < 2${ct} ** ${(st + 1) * 8}${ct}` : kt = `>= -(2${ct} ** ${(st + 1) * 8 - 1}${ct}) and < 2 ** ${(st + 1) * 8 - 1}${ct}`, new qe.ERR_OUT_OF_RANGE("value", kt, Je);
    }
    Ge(Qe, it, st);
  }
  function ot(Je, Me) {
    if (typeof Je != "number")
      throw new qe.ERR_INVALID_ARG_TYPE(Me, "number", Je);
  }
  function lt(Je, Me, Le) {
    throw Math.floor(Je) !== Je ? (ot(Je, Le), new qe.ERR_OUT_OF_RANGE("offset", "an integer", Je)) : Me < 0 ? new qe.ERR_BUFFER_OUT_OF_BOUNDS() : new qe.ERR_OUT_OF_RANGE(
      "offset",
      `>= 0 and <= ${Me}`,
      Je
    );
  }
  const mt = /[^+/0-9A-Za-z-_]/g;
  function dt(Je) {
    if (Je = Je.split("=")[0], Je = Je.trim().replace(mt, ""), Je.length < 2) return "";
    for (; Je.length % 4 !== 0; )
      Je = Je + "=";
    return Je;
  }
  function gt(Je, Me) {
    Me = Me || 1 / 0;
    let Le;
    const Qe = Je.length;
    let it = null;
    const st = [];
    for (let ct = 0; ct < Qe; ++ct) {
      if (Le = Je.charCodeAt(ct), Le > 55295 && Le < 57344) {
        if (!it) {
          if (Le > 56319) {
            (Me -= 3) > -1 && st.push(239, 191, 189);
            continue;
          } else if (ct + 1 === Qe) {
            (Me -= 3) > -1 && st.push(239, 191, 189);
            continue;
          }
          it = Le;
          continue;
        }
        if (Le < 56320) {
          (Me -= 3) > -1 && st.push(239, 191, 189), it = Le;
          continue;
        }
        Le = (it - 55296 << 10 | Le - 56320) + 65536;
      } else it && (Me -= 3) > -1 && st.push(239, 191, 189);
      if (it = null, Le < 128) {
        if ((Me -= 1) < 0) break;
        st.push(Le);
      } else if (Le < 2048) {
        if ((Me -= 2) < 0) break;
        st.push(
          Le >> 6 | 192,
          Le & 63 | 128
        );
      } else if (Le < 65536) {
        if ((Me -= 3) < 0) break;
        st.push(
          Le >> 12 | 224,
          Le >> 6 & 63 | 128,
          Le & 63 | 128
        );
      } else if (Le < 1114112) {
        if ((Me -= 4) < 0) break;
        st.push(
          Le >> 18 | 240,
          Le >> 12 & 63 | 128,
          Le >> 6 & 63 | 128,
          Le & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return st;
  }
  function bt(Je) {
    const Me = [];
    for (let Le = 0; Le < Je.length; ++Le)
      Me.push(Je.charCodeAt(Le) & 255);
    return Me;
  }
  function At(Je, Me) {
    let Le, Qe, it;
    const st = [];
    for (let ct = 0; ct < Je.length && !((Me -= 2) < 0); ++ct)
      Le = Je.charCodeAt(ct), Qe = Le >> 8, it = Le % 256, st.push(it), st.push(Qe);
    return st;
  }
  function wt(Je) {
    return ne.toByteArray(dt(Je));
  }
  function pt(Je, Me, Le, Qe) {
    let it;
    for (it = 0; it < Qe && !(it + Le >= Me.length || it >= Je.length); ++it)
      Me[it + Le] = Je[it];
    return it;
  }
  function ut(Je, Me) {
    return Je instanceof Me || Je != null && Je.constructor != null && Je.constructor.name != null && Je.constructor.name === Me.name;
  }
  function ht(Je) {
    return Je !== Je;
  }
  const vt = function() {
    const Je = "0123456789abcdef", Me = new Array(256);
    for (let Le = 0; Le < 16; ++Le) {
      const Qe = Le * 16;
      for (let it = 0; it < 16; ++it)
        Me[Qe + it] = Je[Le] + Je[it];
    }
    return Me;
  }();
  function xt(Je) {
    return typeof BigInt > "u" ? Bt : Je;
  }
  function Bt() {
    throw new Error("BigInt not supported");
  }
})(buffer$1);
const Buffer$D = buffer$1.Buffer, Blob$2 = buffer$1.Blob, BlobOptions = buffer$1.BlobOptions, Buffer$1$1 = buffer$1.Buffer, File = buffer$1.File, FileOptions = buffer$1.FileOptions, INSPECT_MAX_BYTES = buffer$1.INSPECT_MAX_BYTES, SlowBuffer = buffer$1.SlowBuffer, TranscodeEncoding = buffer$1.TranscodeEncoding, atob$1 = buffer$1.atob, btoa$1 = buffer$1.btoa, constants$1 = buffer$1.constants, isAscii = buffer$1.isAscii, isUtf8 = buffer$1.isUtf8, kMaxLength = buffer$1.kMaxLength, kStringMaxLength = buffer$1.kStringMaxLength, resolveObjectURL = buffer$1.resolveObjectURL, transcode = buffer$1.transcode, dist = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Blob: Blob$2,
  BlobOptions,
  Buffer: Buffer$1$1,
  File,
  FileOptions,
  INSPECT_MAX_BYTES,
  SlowBuffer,
  TranscodeEncoding,
  atob: atob$1,
  btoa: btoa$1,
  constants: constants$1,
  default: Buffer$D,
  isAscii,
  isUtf8,
  kMaxLength,
  kStringMaxLength,
  resolveObjectURL,
  transcode
}, Symbol.toStringTag, { value: "Module" }));
function AxiosError(re, ne, ae, ie, le) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = re, this.name = "AxiosError", ne && (this.code = ne), ae && (this.config = ae), ie && (this.request = ie), le && (this.response = le, this.status = le.status ? le.status : null);
}
utils$p.inherits(AxiosError, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$p.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const prototype$1 = AxiosError.prototype, descriptors = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((re) => {
  descriptors[re] = { value: re };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype$1, "isAxiosError", { value: !0 });
AxiosError.from = (re, ne, ae, ie, le, se) => {
  const ce = Object.create(prototype$1);
  return utils$p.toFlatObject(re, ce, function(de) {
    return de !== Error.prototype;
  }, (ue) => ue !== "isAxiosError"), AxiosError.call(ce, re.message, ne, ae, ie, le), ce.cause = re, ce.name = re.name, se && Object.assign(ce, se), ce;
};
const httpAdapter = null;
function isVisitable(re) {
  return utils$p.isPlainObject(re) || utils$p.isArray(re);
}
function removeBrackets(re) {
  return utils$p.endsWith(re, "[]") ? re.slice(0, -2) : re;
}
function renderKey(re, ne, ae) {
  return re ? re.concat(ne).map(function(le, se) {
    return le = removeBrackets(le), !ae && se ? "[" + le + "]" : le;
  }).join(ae ? "." : "") : ne;
}
function isFlatArray(re) {
  return utils$p.isArray(re) && !re.some(isVisitable);
}
const predicates = utils$p.toFlatObject(utils$p, {}, null, function(ne) {
  return /^is[A-Z]/.test(ne);
});
function toFormData(re, ne, ae) {
  if (!utils$p.isObject(re))
    throw new TypeError("target must be an object");
  ne = ne || new FormData(), ae = utils$p.toFlatObject(ae, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(Pe, Ee) {
    return !utils$p.isUndefined(Ee[Pe]);
  });
  const ie = ae.metaTokens, le = ae.visitor || fe, se = ae.dots, ce = ae.indexes, de = (ae.Blob || typeof Blob < "u" && Blob) && utils$p.isSpecCompliantForm(ne);
  if (!utils$p.isFunction(le))
    throw new TypeError("visitor must be a function");
  function me(Se) {
    if (Se === null) return "";
    if (utils$p.isDate(Se))
      return Se.toISOString();
    if (!de && utils$p.isBlob(Se))
      throw new AxiosError("Blob is not supported. Use a Buffer instead.");
    return utils$p.isArrayBuffer(Se) || utils$p.isTypedArray(Se) ? de && typeof Blob == "function" ? new Blob([Se]) : Buffer$D.from(Se) : Se;
  }
  function fe(Se, Pe, Ee) {
    let Ve = Se;
    if (Se && !Ee && typeof Se == "object") {
      if (utils$p.endsWith(Pe, "{}"))
        Pe = ie ? Pe : Pe.slice(0, -2), Se = JSON.stringify(Se);
      else if (utils$p.isArray(Se) && isFlatArray(Se) || (utils$p.isFileList(Se) || utils$p.endsWith(Pe, "[]")) && (Ve = utils$p.toArray(Se)))
        return Pe = removeBrackets(Pe), Ve.forEach(function(Oe, Ne) {
          !(utils$p.isUndefined(Oe) || Oe === null) && ne.append(
            // eslint-disable-next-line no-nested-ternary
            ce === !0 ? renderKey([Pe], Ne, se) : ce === null ? Pe : Pe + "[]",
            me(Oe)
          );
        }), !1;
    }
    return isVisitable(Se) ? !0 : (ne.append(renderKey(Ee, Pe, se), me(Se)), !1);
  }
  const pe = [], ge = Object.assign(predicates, {
    defaultVisitor: fe,
    convertValue: me,
    isVisitable
  });
  function be(Se, Pe) {
    if (!utils$p.isUndefined(Se)) {
      if (pe.indexOf(Se) !== -1)
        throw Error("Circular reference detected in " + Pe.join("."));
      pe.push(Se), utils$p.forEach(Se, function(Ve, Ae) {
        (!(utils$p.isUndefined(Ve) || Ve === null) && le.call(
          ne,
          Ve,
          utils$p.isString(Ae) ? Ae.trim() : Ae,
          Pe,
          ge
        )) === !0 && be(Ve, Pe ? Pe.concat(Ae) : [Ae]);
      }), pe.pop();
    }
  }
  if (!utils$p.isObject(re))
    throw new TypeError("data must be an object");
  return be(re), ne;
}
function encode$1(re) {
  const ne = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(re).replace(/[!'()~]|%20|%00/g, function(ie) {
    return ne[ie];
  });
}
function AxiosURLSearchParams(re, ne) {
  this._pairs = [], re && toFormData(re, this, ne);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function(ne, ae) {
  this._pairs.push([ne, ae]);
};
prototype.toString = function(ne) {
  const ae = ne ? function(ie) {
    return ne.call(this, ie, encode$1);
  } : encode$1;
  return this._pairs.map(function(le) {
    return ae(le[0]) + "=" + ae(le[1]);
  }, "").join("&");
};
function encode(re) {
  return encodeURIComponent(re).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL(re, ne, ae) {
  if (!ne)
    return re;
  const ie = ae && ae.encode || encode, le = ae && ae.serialize;
  let se;
  if (le ? se = le(ne, ae) : se = utils$p.isURLSearchParams(ne) ? ne.toString() : new AxiosURLSearchParams(ne, ae).toString(ie), se) {
    const ce = re.indexOf("#");
    ce !== -1 && (re = re.slice(0, ce)), re += (re.indexOf("?") === -1 ? "?" : "&") + se;
  }
  return re;
}
class InterceptorManager {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(ne, ae, ie) {
    return this.handlers.push({
      fulfilled: ne,
      rejected: ae,
      synchronous: ie ? ie.synchronous : !1,
      runWhen: ie ? ie.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(ne) {
    this.handlers[ne] && (this.handlers[ne] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(ne) {
    utils$p.forEach(this.handlers, function(ie) {
      ie !== null && ne(ie);
    });
  }
}
const transitionalDefaults = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, URLSearchParams$1 = typeof URLSearchParams < "u" ? URLSearchParams : AxiosURLSearchParams, FormData$1 = typeof FormData < "u" ? FormData : null, Blob$1 = typeof Blob < "u" ? Blob : null, platform$1 = {
  isBrowser: !0,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, hasBrowserEnv = typeof window < "u" && typeof document < "u", _navigator = typeof navigator == "object" && navigator || void 0, hasStandardBrowserEnv = hasBrowserEnv && (!_navigator || ["ReactNative", "NativeScript", "NS"].indexOf(_navigator.product) < 0), hasStandardBrowserWebWorkerEnv = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", origin = hasBrowserEnv && window.location.href || "http://localhost", utils$o = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv,
  hasStandardBrowserEnv,
  hasStandardBrowserWebWorkerEnv,
  navigator: _navigator,
  origin
}, Symbol.toStringTag, { value: "Module" })), platform = {
  ...utils$o,
  ...platform$1
};
function toURLEncodedForm(re, ne) {
  return toFormData(re, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(ae, ie, le, se) {
      return platform.isNode && utils$p.isBuffer(ae) ? (this.append(ie, ae.toString("base64")), !1) : se.defaultVisitor.apply(this, arguments);
    }
  }, ne));
}
function parsePropPath(re) {
  return utils$p.matchAll(/\w+|\[(\w*)]/g, re).map((ne) => ne[0] === "[]" ? "" : ne[1] || ne[0]);
}
function arrayToObject(re) {
  const ne = {}, ae = Object.keys(re);
  let ie;
  const le = ae.length;
  let se;
  for (ie = 0; ie < le; ie++)
    se = ae[ie], ne[se] = re[se];
  return ne;
}
function formDataToJSON(re) {
  function ne(ae, ie, le, se) {
    let ce = ae[se++];
    if (ce === "__proto__") return !0;
    const ue = Number.isFinite(+ce), de = se >= ae.length;
    return ce = !ce && utils$p.isArray(le) ? le.length : ce, de ? (utils$p.hasOwnProp(le, ce) ? le[ce] = [le[ce], ie] : le[ce] = ie, !ue) : ((!le[ce] || !utils$p.isObject(le[ce])) && (le[ce] = []), ne(ae, ie, le[ce], se) && utils$p.isArray(le[ce]) && (le[ce] = arrayToObject(le[ce])), !ue);
  }
  if (utils$p.isFormData(re) && utils$p.isFunction(re.entries)) {
    const ae = {};
    return utils$p.forEachEntry(re, (ie, le) => {
      ne(parsePropPath(ie), le, ae, 0);
    }), ae;
  }
  return null;
}
function stringifySafely(re, ne, ae) {
  if (utils$p.isString(re))
    try {
      return (ne || JSON.parse)(re), utils$p.trim(re);
    } catch (ie) {
      if (ie.name !== "SyntaxError")
        throw ie;
    }
  return (0, JSON.stringify)(re);
}
const defaults = {
  transitional: transitionalDefaults,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(ne, ae) {
    const ie = ae.getContentType() || "", le = ie.indexOf("application/json") > -1, se = utils$p.isObject(ne);
    if (se && utils$p.isHTMLForm(ne) && (ne = new FormData(ne)), utils$p.isFormData(ne))
      return le ? JSON.stringify(formDataToJSON(ne)) : ne;
    if (utils$p.isArrayBuffer(ne) || utils$p.isBuffer(ne) || utils$p.isStream(ne) || utils$p.isFile(ne) || utils$p.isBlob(ne) || utils$p.isReadableStream(ne))
      return ne;
    if (utils$p.isArrayBufferView(ne))
      return ne.buffer;
    if (utils$p.isURLSearchParams(ne))
      return ae.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), ne.toString();
    let ue;
    if (se) {
      if (ie.indexOf("application/x-www-form-urlencoded") > -1)
        return toURLEncodedForm(ne, this.formSerializer).toString();
      if ((ue = utils$p.isFileList(ne)) || ie.indexOf("multipart/form-data") > -1) {
        const de = this.env && this.env.FormData;
        return toFormData(
          ue ? { "files[]": ne } : ne,
          de && new de(),
          this.formSerializer
        );
      }
    }
    return se || le ? (ae.setContentType("application/json", !1), stringifySafely(ne)) : ne;
  }],
  transformResponse: [function(ne) {
    const ae = this.transitional || defaults.transitional, ie = ae && ae.forcedJSONParsing, le = this.responseType === "json";
    if (utils$p.isResponse(ne) || utils$p.isReadableStream(ne))
      return ne;
    if (ne && utils$p.isString(ne) && (ie && !this.responseType || le)) {
      const ce = !(ae && ae.silentJSONParsing) && le;
      try {
        return JSON.parse(ne);
      } catch (ue) {
        if (ce)
          throw ue.name === "SyntaxError" ? AxiosError.from(ue, AxiosError.ERR_BAD_RESPONSE, this, null, this.response) : ue;
      }
    }
    return ne;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },
  validateStatus: function(ne) {
    return ne >= 200 && ne < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
utils$p.forEach(["delete", "get", "head", "post", "put", "patch"], (re) => {
  defaults.headers[re] = {};
});
const ignoreDuplicateOf = utils$p.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), parseHeaders = (re) => {
  const ne = {};
  let ae, ie, le;
  return re && re.split(`
`).forEach(function(ce) {
    le = ce.indexOf(":"), ae = ce.substring(0, le).trim().toLowerCase(), ie = ce.substring(le + 1).trim(), !(!ae || ne[ae] && ignoreDuplicateOf[ae]) && (ae === "set-cookie" ? ne[ae] ? ne[ae].push(ie) : ne[ae] = [ie] : ne[ae] = ne[ae] ? ne[ae] + ", " + ie : ie);
  }), ne;
}, $internals = Symbol("internals");
function normalizeHeader(re) {
  return re && String(re).trim().toLowerCase();
}
function normalizeValue(re) {
  return re === !1 || re == null ? re : utils$p.isArray(re) ? re.map(normalizeValue) : String(re);
}
function parseTokens(re) {
  const ne = /* @__PURE__ */ Object.create(null), ae = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let ie;
  for (; ie = ae.exec(re); )
    ne[ie[1]] = ie[2];
  return ne;
}
const isValidHeaderName = (re) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(re.trim());
function matchHeaderValue(re, ne, ae, ie, le) {
  if (utils$p.isFunction(ie))
    return ie.call(this, ne, ae);
  if (le && (ne = ae), !!utils$p.isString(ne)) {
    if (utils$p.isString(ie))
      return ne.indexOf(ie) !== -1;
    if (utils$p.isRegExp(ie))
      return ie.test(ne);
  }
}
function formatHeader(re) {
  return re.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (ne, ae, ie) => ae.toUpperCase() + ie);
}
function buildAccessors(re, ne) {
  const ae = utils$p.toCamelCase(" " + ne);
  ["get", "set", "has"].forEach((ie) => {
    Object.defineProperty(re, ie + ae, {
      value: function(le, se, ce) {
        return this[ie].call(this, ne, le, se, ce);
      },
      configurable: !0
    });
  });
}
class AxiosHeaders {
  constructor(ne) {
    ne && this.set(ne);
  }
  set(ne, ae, ie) {
    const le = this;
    function se(ue, de, me) {
      const fe = normalizeHeader(de);
      if (!fe)
        throw new Error("header name must be a non-empty string");
      const pe = utils$p.findKey(le, fe);
      (!pe || le[pe] === void 0 || me === !0 || me === void 0 && le[pe] !== !1) && (le[pe || de] = normalizeValue(ue));
    }
    const ce = (ue, de) => utils$p.forEach(ue, (me, fe) => se(me, fe, de));
    if (utils$p.isPlainObject(ne) || ne instanceof this.constructor)
      ce(ne, ae);
    else if (utils$p.isString(ne) && (ne = ne.trim()) && !isValidHeaderName(ne))
      ce(parseHeaders(ne), ae);
    else if (utils$p.isHeaders(ne))
      for (const [ue, de] of ne.entries())
        se(de, ue, ie);
    else
      ne != null && se(ae, ne, ie);
    return this;
  }
  get(ne, ae) {
    if (ne = normalizeHeader(ne), ne) {
      const ie = utils$p.findKey(this, ne);
      if (ie) {
        const le = this[ie];
        if (!ae)
          return le;
        if (ae === !0)
          return parseTokens(le);
        if (utils$p.isFunction(ae))
          return ae.call(this, le, ie);
        if (utils$p.isRegExp(ae))
          return ae.exec(le);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(ne, ae) {
    if (ne = normalizeHeader(ne), ne) {
      const ie = utils$p.findKey(this, ne);
      return !!(ie && this[ie] !== void 0 && (!ae || matchHeaderValue(this, this[ie], ie, ae)));
    }
    return !1;
  }
  delete(ne, ae) {
    const ie = this;
    let le = !1;
    function se(ce) {
      if (ce = normalizeHeader(ce), ce) {
        const ue = utils$p.findKey(ie, ce);
        ue && (!ae || matchHeaderValue(ie, ie[ue], ue, ae)) && (delete ie[ue], le = !0);
      }
    }
    return utils$p.isArray(ne) ? ne.forEach(se) : se(ne), le;
  }
  clear(ne) {
    const ae = Object.keys(this);
    let ie = ae.length, le = !1;
    for (; ie--; ) {
      const se = ae[ie];
      (!ne || matchHeaderValue(this, this[se], se, ne, !0)) && (delete this[se], le = !0);
    }
    return le;
  }
  normalize(ne) {
    const ae = this, ie = {};
    return utils$p.forEach(this, (le, se) => {
      const ce = utils$p.findKey(ie, se);
      if (ce) {
        ae[ce] = normalizeValue(le), delete ae[se];
        return;
      }
      const ue = ne ? formatHeader(se) : String(se).trim();
      ue !== se && delete ae[se], ae[ue] = normalizeValue(le), ie[ue] = !0;
    }), this;
  }
  concat(...ne) {
    return this.constructor.concat(this, ...ne);
  }
  toJSON(ne) {
    const ae = /* @__PURE__ */ Object.create(null);
    return utils$p.forEach(this, (ie, le) => {
      ie != null && ie !== !1 && (ae[le] = ne && utils$p.isArray(ie) ? ie.join(", ") : ie);
    }), ae;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([ne, ae]) => ne + ": " + ae).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(ne) {
    return ne instanceof this ? ne : new this(ne);
  }
  static concat(ne, ...ae) {
    const ie = new this(ne);
    return ae.forEach((le) => ie.set(le)), ie;
  }
  static accessor(ne) {
    const ie = (this[$internals] = this[$internals] = {
      accessors: {}
    }).accessors, le = this.prototype;
    function se(ce) {
      const ue = normalizeHeader(ce);
      ie[ue] || (buildAccessors(le, ce), ie[ue] = !0);
    }
    return utils$p.isArray(ne) ? ne.forEach(se) : se(ne), this;
  }
}
AxiosHeaders.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
utils$p.reduceDescriptors(AxiosHeaders.prototype, ({ value: re }, ne) => {
  let ae = ne[0].toUpperCase() + ne.slice(1);
  return {
    get: () => re,
    set(ie) {
      this[ae] = ie;
    }
  };
});
utils$p.freezeMethods(AxiosHeaders);
function transformData(re, ne) {
  const ae = this || defaults, ie = ne || ae, le = AxiosHeaders.from(ie.headers);
  let se = ie.data;
  return utils$p.forEach(re, function(ue) {
    se = ue.call(ae, se, le.normalize(), ne ? ne.status : void 0);
  }), le.normalize(), se;
}
function isCancel(re) {
  return !!(re && re.__CANCEL__);
}
function CanceledError(re, ne, ae) {
  AxiosError.call(this, re ?? "canceled", AxiosError.ERR_CANCELED, ne, ae), this.name = "CanceledError";
}
utils$p.inherits(CanceledError, AxiosError, {
  __CANCEL__: !0
});
function settle(re, ne, ae) {
  const ie = ae.config.validateStatus;
  !ae.status || !ie || ie(ae.status) ? re(ae) : ne(new AxiosError(
    "Request failed with status code " + ae.status,
    [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(ae.status / 100) - 4],
    ae.config,
    ae.request,
    ae
  ));
}
function parseProtocol(re) {
  const ne = /^([-+\w]{1,25})(:?\/\/|:)/.exec(re);
  return ne && ne[1] || "";
}
function speedometer(re, ne) {
  re = re || 10;
  const ae = new Array(re), ie = new Array(re);
  let le = 0, se = 0, ce;
  return ne = ne !== void 0 ? ne : 1e3, function(de) {
    const me = Date.now(), fe = ie[se];
    ce || (ce = me), ae[le] = de, ie[le] = me;
    let pe = se, ge = 0;
    for (; pe !== le; )
      ge += ae[pe++], pe = pe % re;
    if (le = (le + 1) % re, le === se && (se = (se + 1) % re), me - ce < ne)
      return;
    const be = fe && me - fe;
    return be ? Math.round(ge * 1e3 / be) : void 0;
  };
}
function throttle(re, ne) {
  let ae = 0, ie = 1e3 / ne, le, se;
  const ce = (me, fe = Date.now()) => {
    ae = fe, le = null, se && (clearTimeout(se), se = null), re.apply(null, me);
  };
  return [(...me) => {
    const fe = Date.now(), pe = fe - ae;
    pe >= ie ? ce(me, fe) : (le = me, se || (se = setTimeout(() => {
      se = null, ce(le);
    }, ie - pe)));
  }, () => le && ce(le)];
}
const progressEventReducer = (re, ne, ae = 3) => {
  let ie = 0;
  const le = speedometer(50, 250);
  return throttle((se) => {
    const ce = se.loaded, ue = se.lengthComputable ? se.total : void 0, de = ce - ie, me = le(de), fe = ce <= ue;
    ie = ce;
    const pe = {
      loaded: ce,
      total: ue,
      progress: ue ? ce / ue : void 0,
      bytes: de,
      rate: me || void 0,
      estimated: me && ue && fe ? (ue - ce) / me : void 0,
      event: se,
      lengthComputable: ue != null,
      [ne ? "download" : "upload"]: !0
    };
    re(pe);
  }, ae);
}, progressEventDecorator = (re, ne) => {
  const ae = re != null;
  return [(ie) => ne[0]({
    lengthComputable: ae,
    total: re,
    loaded: ie
  }), ne[1]];
}, asyncDecorator = (re) => (...ne) => utils$p.asap(() => re(...ne)), isURLSameOrigin = platform.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const ne = platform.navigator && /(msie|trident)/i.test(platform.navigator.userAgent), ae = document.createElement("a");
    let ie;
    function le(se) {
      let ce = se;
      return ne && (ae.setAttribute("href", ce), ce = ae.href), ae.setAttribute("href", ce), {
        href: ae.href,
        protocol: ae.protocol ? ae.protocol.replace(/:$/, "") : "",
        host: ae.host,
        search: ae.search ? ae.search.replace(/^\?/, "") : "",
        hash: ae.hash ? ae.hash.replace(/^#/, "") : "",
        hostname: ae.hostname,
        port: ae.port,
        pathname: ae.pathname.charAt(0) === "/" ? ae.pathname : "/" + ae.pathname
      };
    }
    return ie = le(window.location.href), function(ce) {
      const ue = utils$p.isString(ce) ? le(ce) : ce;
      return ue.protocol === ie.protocol && ue.host === ie.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), cookies = platform.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(re, ne, ae, ie, le, se) {
      const ce = [re + "=" + encodeURIComponent(ne)];
      utils$p.isNumber(ae) && ce.push("expires=" + new Date(ae).toGMTString()), utils$p.isString(ie) && ce.push("path=" + ie), utils$p.isString(le) && ce.push("domain=" + le), se === !0 && ce.push("secure"), document.cookie = ce.join("; ");
    },
    read(re) {
      const ne = document.cookie.match(new RegExp("(^|;\\s*)(" + re + ")=([^;]*)"));
      return ne ? decodeURIComponent(ne[3]) : null;
    },
    remove(re) {
      this.write(re, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function isAbsoluteURL(re) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(re);
}
function combineURLs(re, ne) {
  return ne ? re.replace(/\/?\/$/, "") + "/" + ne.replace(/^\/+/, "") : re;
}
function buildFullPath(re, ne) {
  return re && !isAbsoluteURL(ne) ? combineURLs(re, ne) : ne;
}
const headersToObject = (re) => re instanceof AxiosHeaders ? { ...re } : re;
function mergeConfig(re, ne) {
  ne = ne || {};
  const ae = {};
  function ie(me, fe, pe) {
    return utils$p.isPlainObject(me) && utils$p.isPlainObject(fe) ? utils$p.merge.call({ caseless: pe }, me, fe) : utils$p.isPlainObject(fe) ? utils$p.merge({}, fe) : utils$p.isArray(fe) ? fe.slice() : fe;
  }
  function le(me, fe, pe) {
    if (utils$p.isUndefined(fe)) {
      if (!utils$p.isUndefined(me))
        return ie(void 0, me, pe);
    } else return ie(me, fe, pe);
  }
  function se(me, fe) {
    if (!utils$p.isUndefined(fe))
      return ie(void 0, fe);
  }
  function ce(me, fe) {
    if (utils$p.isUndefined(fe)) {
      if (!utils$p.isUndefined(me))
        return ie(void 0, me);
    } else return ie(void 0, fe);
  }
  function ue(me, fe, pe) {
    if (pe in ne)
      return ie(me, fe);
    if (pe in re)
      return ie(void 0, me);
  }
  const de = {
    url: se,
    method: se,
    data: se,
    baseURL: ce,
    transformRequest: ce,
    transformResponse: ce,
    paramsSerializer: ce,
    timeout: ce,
    timeoutMessage: ce,
    withCredentials: ce,
    withXSRFToken: ce,
    adapter: ce,
    responseType: ce,
    xsrfCookieName: ce,
    xsrfHeaderName: ce,
    onUploadProgress: ce,
    onDownloadProgress: ce,
    decompress: ce,
    maxContentLength: ce,
    maxBodyLength: ce,
    beforeRedirect: ce,
    transport: ce,
    httpAgent: ce,
    httpsAgent: ce,
    cancelToken: ce,
    socketPath: ce,
    responseEncoding: ce,
    validateStatus: ue,
    headers: (me, fe) => le(headersToObject(me), headersToObject(fe), !0)
  };
  return utils$p.forEach(Object.keys(Object.assign({}, re, ne)), function(fe) {
    const pe = de[fe] || le, ge = pe(re[fe], ne[fe], fe);
    utils$p.isUndefined(ge) && pe !== ue || (ae[fe] = ge);
  }), ae;
}
const resolveConfig = (re) => {
  const ne = mergeConfig({}, re);
  let { data: ae, withXSRFToken: ie, xsrfHeaderName: le, xsrfCookieName: se, headers: ce, auth: ue } = ne;
  ne.headers = ce = AxiosHeaders.from(ce), ne.url = buildURL(buildFullPath(ne.baseURL, ne.url), re.params, re.paramsSerializer), ue && ce.set(
    "Authorization",
    "Basic " + btoa((ue.username || "") + ":" + (ue.password ? unescape(encodeURIComponent(ue.password)) : ""))
  );
  let de;
  if (utils$p.isFormData(ae)) {
    if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv)
      ce.setContentType(void 0);
    else if ((de = ce.getContentType()) !== !1) {
      const [me, ...fe] = de ? de.split(";").map((pe) => pe.trim()).filter(Boolean) : [];
      ce.setContentType([me || "multipart/form-data", ...fe].join("; "));
    }
  }
  if (platform.hasStandardBrowserEnv && (ie && utils$p.isFunction(ie) && (ie = ie(ne)), ie || ie !== !1 && isURLSameOrigin(ne.url))) {
    const me = le && se && cookies.read(se);
    me && ce.set(le, me);
  }
  return ne;
}, isXHRAdapterSupported = typeof XMLHttpRequest < "u", xhrAdapter = isXHRAdapterSupported && function(re) {
  return new Promise(function(ae, ie) {
    const le = resolveConfig(re);
    let se = le.data;
    const ce = AxiosHeaders.from(le.headers).normalize();
    let { responseType: ue, onUploadProgress: de, onDownloadProgress: me } = le, fe, pe, ge, be, Se;
    function Pe() {
      be && be(), Se && Se(), le.cancelToken && le.cancelToken.unsubscribe(fe), le.signal && le.signal.removeEventListener("abort", fe);
    }
    let Ee = new XMLHttpRequest();
    Ee.open(le.method.toUpperCase(), le.url, !0), Ee.timeout = le.timeout;
    function Ve() {
      if (!Ee)
        return;
      const Oe = AxiosHeaders.from(
        "getAllResponseHeaders" in Ee && Ee.getAllResponseHeaders()
      ), He = {
        data: !ue || ue === "text" || ue === "json" ? Ee.responseText : Ee.response,
        status: Ee.status,
        statusText: Ee.statusText,
        headers: Oe,
        config: re,
        request: Ee
      };
      settle(function(Ze) {
        ae(Ze), Pe();
      }, function(Ze) {
        ie(Ze), Pe();
      }, He), Ee = null;
    }
    "onloadend" in Ee ? Ee.onloadend = Ve : Ee.onreadystatechange = function() {
      !Ee || Ee.readyState !== 4 || Ee.status === 0 && !(Ee.responseURL && Ee.responseURL.indexOf("file:") === 0) || setTimeout(Ve);
    }, Ee.onabort = function() {
      Ee && (ie(new AxiosError("Request aborted", AxiosError.ECONNABORTED, re, Ee)), Ee = null);
    }, Ee.onerror = function() {
      ie(new AxiosError("Network Error", AxiosError.ERR_NETWORK, re, Ee)), Ee = null;
    }, Ee.ontimeout = function() {
      let Ne = le.timeout ? "timeout of " + le.timeout + "ms exceeded" : "timeout exceeded";
      const He = le.transitional || transitionalDefaults;
      le.timeoutErrorMessage && (Ne = le.timeoutErrorMessage), ie(new AxiosError(
        Ne,
        He.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        re,
        Ee
      )), Ee = null;
    }, se === void 0 && ce.setContentType(null), "setRequestHeader" in Ee && utils$p.forEach(ce.toJSON(), function(Ne, He) {
      Ee.setRequestHeader(He, Ne);
    }), utils$p.isUndefined(le.withCredentials) || (Ee.withCredentials = !!le.withCredentials), ue && ue !== "json" && (Ee.responseType = le.responseType), me && ([ge, Se] = progressEventReducer(me, !0), Ee.addEventListener("progress", ge)), de && Ee.upload && ([pe, be] = progressEventReducer(de), Ee.upload.addEventListener("progress", pe), Ee.upload.addEventListener("loadend", be)), (le.cancelToken || le.signal) && (fe = (Oe) => {
      Ee && (ie(!Oe || Oe.type ? new CanceledError(null, re, Ee) : Oe), Ee.abort(), Ee = null);
    }, le.cancelToken && le.cancelToken.subscribe(fe), le.signal && (le.signal.aborted ? fe() : le.signal.addEventListener("abort", fe)));
    const Ae = parseProtocol(le.url);
    if (Ae && platform.protocols.indexOf(Ae) === -1) {
      ie(new AxiosError("Unsupported protocol " + Ae + ":", AxiosError.ERR_BAD_REQUEST, re));
      return;
    }
    Ee.send(se || null);
  });
}, composeSignals = (re, ne) => {
  const { length: ae } = re = re ? re.filter(Boolean) : [];
  if (ne || ae) {
    let ie = new AbortController(), le;
    const se = function(me) {
      if (!le) {
        le = !0, ue();
        const fe = me instanceof Error ? me : this.reason;
        ie.abort(fe instanceof AxiosError ? fe : new CanceledError(fe instanceof Error ? fe.message : fe));
      }
    };
    let ce = ne && setTimeout(() => {
      ce = null, se(new AxiosError(`timeout ${ne} of ms exceeded`, AxiosError.ETIMEDOUT));
    }, ne);
    const ue = () => {
      re && (ce && clearTimeout(ce), ce = null, re.forEach((me) => {
        me.unsubscribe ? me.unsubscribe(se) : me.removeEventListener("abort", se);
      }), re = null);
    };
    re.forEach((me) => me.addEventListener("abort", se));
    const { signal: de } = ie;
    return de.unsubscribe = () => utils$p.asap(ue), de;
  }
}, streamChunk = function* (re, ne) {
  let ae = re.byteLength;
  if (ae < ne) {
    yield re;
    return;
  }
  let ie = 0, le;
  for (; ie < ae; )
    le = ie + ne, yield re.slice(ie, le), ie = le;
}, readBytes = async function* (re, ne) {
  for await (const ae of readStream(re))
    yield* streamChunk(ae, ne);
}, readStream = async function* (re) {
  if (re[Symbol.asyncIterator]) {
    yield* re;
    return;
  }
  const ne = re.getReader();
  try {
    for (; ; ) {
      const { done: ae, value: ie } = await ne.read();
      if (ae)
        break;
      yield ie;
    }
  } finally {
    await ne.cancel();
  }
}, trackStream = (re, ne, ae, ie) => {
  const le = readBytes(re, ne);
  let se = 0, ce, ue = (de) => {
    ce || (ce = !0, ie && ie(de));
  };
  return new ReadableStream({
    async pull(de) {
      try {
        const { done: me, value: fe } = await le.next();
        if (me) {
          ue(), de.close();
          return;
        }
        let pe = fe.byteLength;
        if (ae) {
          let ge = se += pe;
          ae(ge);
        }
        de.enqueue(new Uint8Array(fe));
      } catch (me) {
        throw ue(me), me;
      }
    },
    cancel(de) {
      return ue(de), le.return();
    }
  }, {
    highWaterMark: 2
  });
}, isFetchSupported = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", isReadableStreamSupported = isFetchSupported && typeof ReadableStream == "function", encodeText = isFetchSupported && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((re) => (ne) => re.encode(ne))(new TextEncoder()) : async (re) => new Uint8Array(await new Response(re).arrayBuffer())), test$1 = (re, ...ne) => {
  try {
    return !!re(...ne);
  } catch {
    return !1;
  }
}, supportsRequestStream = isReadableStreamSupported && test$1(() => {
  let re = !1;
  const ne = new Request(platform.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return re = !0, "half";
    }
  }).headers.has("Content-Type");
  return re && !ne;
}), DEFAULT_CHUNK_SIZE = 64 * 1024, supportsResponseStream = isReadableStreamSupported && test$1(() => utils$p.isReadableStream(new Response("").body)), resolvers = {
  stream: supportsResponseStream && ((re) => re.body)
};
isFetchSupported && ((re) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((ne) => {
    !resolvers[ne] && (resolvers[ne] = utils$p.isFunction(re[ne]) ? (ae) => ae[ne]() : (ae, ie) => {
      throw new AxiosError(`Response type '${ne}' is not supported`, AxiosError.ERR_NOT_SUPPORT, ie);
    });
  });
})(new Response());
const getBodyLength = async (re) => {
  if (re == null)
    return 0;
  if (utils$p.isBlob(re))
    return re.size;
  if (utils$p.isSpecCompliantForm(re))
    return (await new Request(platform.origin, {
      method: "POST",
      body: re
    }).arrayBuffer()).byteLength;
  if (utils$p.isArrayBufferView(re) || utils$p.isArrayBuffer(re))
    return re.byteLength;
  if (utils$p.isURLSearchParams(re) && (re = re + ""), utils$p.isString(re))
    return (await encodeText(re)).byteLength;
}, resolveBodyLength = async (re, ne) => {
  const ae = utils$p.toFiniteNumber(re.getContentLength());
  return ae ?? getBodyLength(ne);
}, fetchAdapter = isFetchSupported && (async (re) => {
  let {
    url: ne,
    method: ae,
    data: ie,
    signal: le,
    cancelToken: se,
    timeout: ce,
    onDownloadProgress: ue,
    onUploadProgress: de,
    responseType: me,
    headers: fe,
    withCredentials: pe = "same-origin",
    fetchOptions: ge
  } = resolveConfig(re);
  me = me ? (me + "").toLowerCase() : "text";
  let be = composeSignals([le, se && se.toAbortSignal()], ce), Se;
  const Pe = be && be.unsubscribe && (() => {
    be.unsubscribe();
  });
  let Ee;
  try {
    if (de && supportsRequestStream && ae !== "get" && ae !== "head" && (Ee = await resolveBodyLength(fe, ie)) !== 0) {
      let He = new Request(ne, {
        method: "POST",
        body: ie,
        duplex: "half"
      }), Ue;
      if (utils$p.isFormData(ie) && (Ue = He.headers.get("content-type")) && fe.setContentType(Ue), He.body) {
        const [Ze, Fe] = progressEventDecorator(
          Ee,
          progressEventReducer(asyncDecorator(de))
        );
        ie = trackStream(He.body, DEFAULT_CHUNK_SIZE, Ze, Fe);
      }
    }
    utils$p.isString(pe) || (pe = pe ? "include" : "omit");
    const Ve = "credentials" in Request.prototype;
    Se = new Request(ne, {
      ...ge,
      signal: be,
      method: ae.toUpperCase(),
      headers: fe.normalize().toJSON(),
      body: ie,
      duplex: "half",
      credentials: Ve ? pe : void 0
    });
    let Ae = await fetch(Se);
    const Oe = supportsResponseStream && (me === "stream" || me === "response");
    if (supportsResponseStream && (ue || Oe && Pe)) {
      const He = {};
      ["status", "statusText", "headers"].forEach((Ke) => {
        He[Ke] = Ae[Ke];
      });
      const Ue = utils$p.toFiniteNumber(Ae.headers.get("content-length")), [Ze, Fe] = ue && progressEventDecorator(
        Ue,
        progressEventReducer(asyncDecorator(ue), !0)
      ) || [];
      Ae = new Response(
        trackStream(Ae.body, DEFAULT_CHUNK_SIZE, Ze, () => {
          Fe && Fe(), Pe && Pe();
        }),
        He
      );
    }
    me = me || "text";
    let Ne = await resolvers[utils$p.findKey(resolvers, me) || "text"](Ae, re);
    return !Oe && Pe && Pe(), await new Promise((He, Ue) => {
      settle(He, Ue, {
        data: Ne,
        headers: AxiosHeaders.from(Ae.headers),
        status: Ae.status,
        statusText: Ae.statusText,
        config: re,
        request: Se
      });
    });
  } catch (Ve) {
    throw Pe && Pe(), Ve && Ve.name === "TypeError" && /fetch/i.test(Ve.message) ? Object.assign(
      new AxiosError("Network Error", AxiosError.ERR_NETWORK, re, Se),
      {
        cause: Ve.cause || Ve
      }
    ) : AxiosError.from(Ve, Ve && Ve.code, re, Se);
  }
}), knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter,
  fetch: fetchAdapter
};
utils$p.forEach(knownAdapters, (re, ne) => {
  if (re) {
    try {
      Object.defineProperty(re, "name", { value: ne });
    } catch {
    }
    Object.defineProperty(re, "adapterName", { value: ne });
  }
});
const renderReason = (re) => `- ${re}`, isResolvedHandle = (re) => utils$p.isFunction(re) || re === null || re === !1, adapters = {
  getAdapter: (re) => {
    re = utils$p.isArray(re) ? re : [re];
    const { length: ne } = re;
    let ae, ie;
    const le = {};
    for (let se = 0; se < ne; se++) {
      ae = re[se];
      let ce;
      if (ie = ae, !isResolvedHandle(ae) && (ie = knownAdapters[(ce = String(ae)).toLowerCase()], ie === void 0))
        throw new AxiosError(`Unknown adapter '${ce}'`);
      if (ie)
        break;
      le[ce || "#" + se] = ie;
    }
    if (!ie) {
      const se = Object.entries(le).map(
        ([ue, de]) => `adapter ${ue} ` + (de === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let ce = ne ? se.length > 1 ? `since :
` + se.map(renderReason).join(`
`) : " " + renderReason(se[0]) : "as no adapter specified";
      throw new AxiosError(
        "There is no suitable adapter to dispatch the request " + ce,
        "ERR_NOT_SUPPORT"
      );
    }
    return ie;
  },
  adapters: knownAdapters
};
function throwIfCancellationRequested(re) {
  if (re.cancelToken && re.cancelToken.throwIfRequested(), re.signal && re.signal.aborted)
    throw new CanceledError(null, re);
}
function dispatchRequest(re) {
  return throwIfCancellationRequested(re), re.headers = AxiosHeaders.from(re.headers), re.data = transformData.call(
    re,
    re.transformRequest
  ), ["post", "put", "patch"].indexOf(re.method) !== -1 && re.headers.setContentType("application/x-www-form-urlencoded", !1), adapters.getAdapter(re.adapter || defaults.adapter)(re).then(function(ie) {
    return throwIfCancellationRequested(re), ie.data = transformData.call(
      re,
      re.transformResponse,
      ie
    ), ie.headers = AxiosHeaders.from(ie.headers), ie;
  }, function(ie) {
    return isCancel(ie) || (throwIfCancellationRequested(re), ie && ie.response && (ie.response.data = transformData.call(
      re,
      re.transformResponse,
      ie.response
    ), ie.response.headers = AxiosHeaders.from(ie.response.headers))), Promise.reject(ie);
  });
}
const VERSION$2 = "1.7.7", validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((re, ne) => {
  validators$1[re] = function(ie) {
    return typeof ie === re || "a" + (ne < 1 ? "n " : " ") + re;
  };
});
const deprecatedWarnings = {};
validators$1.transitional = function(ne, ae, ie) {
  function le(se, ce) {
    return "[Axios v" + VERSION$2 + "] Transitional option '" + se + "'" + ce + (ie ? ". " + ie : "");
  }
  return (se, ce, ue) => {
    if (ne === !1)
      throw new AxiosError(
        le(ce, " has been removed" + (ae ? " in " + ae : "")),
        AxiosError.ERR_DEPRECATED
      );
    return ae && !deprecatedWarnings[ce] && (deprecatedWarnings[ce] = !0, console.warn(
      le(
        ce,
        " has been deprecated since v" + ae + " and will be removed in the near future"
      )
    )), ne ? ne(se, ce, ue) : !0;
  };
};
function assertOptions(re, ne, ae) {
  if (typeof re != "object")
    throw new AxiosError("options must be an object", AxiosError.ERR_BAD_OPTION_VALUE);
  const ie = Object.keys(re);
  let le = ie.length;
  for (; le-- > 0; ) {
    const se = ie[le], ce = ne[se];
    if (ce) {
      const ue = re[se], de = ue === void 0 || ce(ue, se, re);
      if (de !== !0)
        throw new AxiosError("option " + se + " must be " + de, AxiosError.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (ae !== !0)
      throw new AxiosError("Unknown option " + se, AxiosError.ERR_BAD_OPTION);
  }
}
const validator = {
  assertOptions,
  validators: validators$1
}, validators = validator.validators;
class Axios {
  constructor(ne) {
    this.defaults = ne, this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(ne, ae) {
    try {
      return await this._request(ne, ae);
    } catch (ie) {
      if (ie instanceof Error) {
        let le;
        Error.captureStackTrace ? Error.captureStackTrace(le = {}) : le = new Error();
        const se = le.stack ? le.stack.replace(/^.+\n/, "") : "";
        try {
          ie.stack ? se && !String(ie.stack).endsWith(se.replace(/^.+\n.+\n/, "")) && (ie.stack += `
` + se) : ie.stack = se;
        } catch {
        }
      }
      throw ie;
    }
  }
  _request(ne, ae) {
    typeof ne == "string" ? (ae = ae || {}, ae.url = ne) : ae = ne || {}, ae = mergeConfig(this.defaults, ae);
    const { transitional: ie, paramsSerializer: le, headers: se } = ae;
    ie !== void 0 && validator.assertOptions(ie, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, !1), le != null && (utils$p.isFunction(le) ? ae.paramsSerializer = {
      serialize: le
    } : validator.assertOptions(le, {
      encode: validators.function,
      serialize: validators.function
    }, !0)), ae.method = (ae.method || this.defaults.method || "get").toLowerCase();
    let ce = se && utils$p.merge(
      se.common,
      se[ae.method]
    );
    se && utils$p.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (Se) => {
        delete se[Se];
      }
    ), ae.headers = AxiosHeaders.concat(ce, se);
    const ue = [];
    let de = !0;
    this.interceptors.request.forEach(function(Pe) {
      typeof Pe.runWhen == "function" && Pe.runWhen(ae) === !1 || (de = de && Pe.synchronous, ue.unshift(Pe.fulfilled, Pe.rejected));
    });
    const me = [];
    this.interceptors.response.forEach(function(Pe) {
      me.push(Pe.fulfilled, Pe.rejected);
    });
    let fe, pe = 0, ge;
    if (!de) {
      const Se = [dispatchRequest.bind(this), void 0];
      for (Se.unshift.apply(Se, ue), Se.push.apply(Se, me), ge = Se.length, fe = Promise.resolve(ae); pe < ge; )
        fe = fe.then(Se[pe++], Se[pe++]);
      return fe;
    }
    ge = ue.length;
    let be = ae;
    for (pe = 0; pe < ge; ) {
      const Se = ue[pe++], Pe = ue[pe++];
      try {
        be = Se(be);
      } catch (Ee) {
        Pe.call(this, Ee);
        break;
      }
    }
    try {
      fe = dispatchRequest.call(this, be);
    } catch (Se) {
      return Promise.reject(Se);
    }
    for (pe = 0, ge = me.length; pe < ge; )
      fe = fe.then(me[pe++], me[pe++]);
    return fe;
  }
  getUri(ne) {
    ne = mergeConfig(this.defaults, ne);
    const ae = buildFullPath(ne.baseURL, ne.url);
    return buildURL(ae, ne.params, ne.paramsSerializer);
  }
}
utils$p.forEach(["delete", "get", "head", "options"], function(ne) {
  Axios.prototype[ne] = function(ae, ie) {
    return this.request(mergeConfig(ie || {}, {
      method: ne,
      url: ae,
      data: (ie || {}).data
    }));
  };
});
utils$p.forEach(["post", "put", "patch"], function(ne) {
  function ae(ie) {
    return function(se, ce, ue) {
      return this.request(mergeConfig(ue || {}, {
        method: ne,
        headers: ie ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: se,
        data: ce
      }));
    };
  }
  Axios.prototype[ne] = ae(), Axios.prototype[ne + "Form"] = ae(!0);
});
class CancelToken {
  constructor(ne) {
    if (typeof ne != "function")
      throw new TypeError("executor must be a function.");
    let ae;
    this.promise = new Promise(function(se) {
      ae = se;
    });
    const ie = this;
    this.promise.then((le) => {
      if (!ie._listeners) return;
      let se = ie._listeners.length;
      for (; se-- > 0; )
        ie._listeners[se](le);
      ie._listeners = null;
    }), this.promise.then = (le) => {
      let se;
      const ce = new Promise((ue) => {
        ie.subscribe(ue), se = ue;
      }).then(le);
      return ce.cancel = function() {
        ie.unsubscribe(se);
      }, ce;
    }, ne(function(se, ce, ue) {
      ie.reason || (ie.reason = new CanceledError(se, ce, ue), ae(ie.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(ne) {
    if (this.reason) {
      ne(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(ne) : this._listeners = [ne];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(ne) {
    if (!this._listeners)
      return;
    const ae = this._listeners.indexOf(ne);
    ae !== -1 && this._listeners.splice(ae, 1);
  }
  toAbortSignal() {
    const ne = new AbortController(), ae = (ie) => {
      ne.abort(ie);
    };
    return this.subscribe(ae), ne.signal.unsubscribe = () => this.unsubscribe(ae), ne.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let ne;
    return {
      token: new CancelToken(function(le) {
        ne = le;
      }),
      cancel: ne
    };
  }
}
function spread(re) {
  return function(ae) {
    return re.apply(null, ae);
  };
}
function isAxiosError(re) {
  return utils$p.isObject(re) && re.isAxiosError === !0;
}
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(([re, ne]) => {
  HttpStatusCode[ne] = re;
});
function createInstance$1(re) {
  const ne = new Axios(re), ae = bind$5(Axios.prototype.request, ne);
  return utils$p.extend(ae, Axios.prototype, ne, { allOwnKeys: !0 }), utils$p.extend(ae, ne, null, { allOwnKeys: !0 }), ae.create = function(le) {
    return createInstance$1(mergeConfig(re, le));
  }, ae;
}
const axios = createInstance$1(defaults);
axios.Axios = Axios;
axios.CanceledError = CanceledError;
axios.CancelToken = CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION$2;
axios.toFormData = toFormData;
axios.AxiosError = AxiosError;
axios.Cancel = axios.CanceledError;
axios.all = function(ne) {
  return Promise.all(ne);
};
axios.spread = spread;
axios.isAxiosError = isAxiosError;
axios.mergeConfig = mergeConfig;
axios.AxiosHeaders = AxiosHeaders;
axios.formToJSON = (re) => formDataToJSON(utils$p.isHTMLForm(re) ? new FormData(re) : re);
axios.getAdapter = adapters.getAdapter;
axios.HttpStatusCode = HttpStatusCode;
axios.default = axios;
const getDirPathBy = (re) => (ne) => {
  let ae = re, ie = ne || "";
  return ae = ae.endsWith("/") ? ae : `${ae}/`, ie = ie.split("/").filter((se) => !!se).join("/"), ie ? `${ae}${ie}/` : ae;
}, getListBy = (re, ne) => async (ae) => {
  Assert.isPresent(ne, "axios");
  const ie = getDirPathBy(re)(ae);
  return (await ne.get(ie)).data || [];
}, getDirListBy = (re, ne) => async (ae) => {
  Assert.isPresent(ne, "axios");
  const ie = [], le = await getListBy(re, ne)(ae);
  return !le || le.length < 1 ? [] : (le.forEach((se) => {
    const ce = se.split("/");
    ce.length > 1 ? ce[0] && ce[1] && ie.push(ce[0]) : ce[0] && ce[0].indexOf(".") < 0 && ie.push(ce[0]);
  }), [...new Set(ie)]);
}, illustration$1 = (re, ne) => (Assert.isPresent(re, "rootDir"), Assert.isPresent(ne, "axios"), {
  getDirPathBy: getDirPathBy(re),
  getListBy: getListBy(re, ne),
  getDirListBy: getDirListBy(re, ne)
}), ClientAppConfig = (re, ne, ae, ie, le) => ({
  organization: re || null,
  promptOnLoginEnabled: ne || !1,
  sharedDeviceEnabled: ae || !1,
  connectionButtonsEnabled: ie || !1,
  connectionNames: le || []
}), getRemoteClientAppConfigByHostname = (re, ne) => async (ae) => {
  const ie = `${ne}/${ae}/auth0.json`, le = await re.get(ie);
  if (le.status >= 400)
    throw new GetRemoteClientAppConfigByHostnameFailed(
      `Failed to find organisation id by hostname ${ae} with http status: ${le.status}, message: ${le.statusText}`
    );
  const se = le.data.connectionButtonsEnabled && le.data.connectionNames && le.data.connectionNames.length > 1, ce = se ? le.data.connectionNames : [];
  return ClientAppConfig(
    le.data.organization,
    le.data.promptOnLoginEnabled,
    le.data.sharedDeviceEnabled,
    se,
    ce
  );
}, isAuth0EnabledWithHostname = (re, ne) => async (ae) => {
  const ie = `${ne}/list.json`, le = await re.get(ie);
  if (le.status >= 400)
    throw new FindAuth0EnableListFailed(
      `Failed to find auth0 enabled list with http status: ${le.status}, message: ${le.statusText}`
    );
  return le.data.some((ce) => ce === ae);
}, soulUrlByEnv = (re) => {
  if (!re) throw new Error("appEnv must not be empty.");
  const ne = "https://s3-ap-southeast-2.amazonaws.com";
  switch (re) {
    case "apex":
    case "development":
    case "develop":
    case "dev":
      return `${ne}/dev.soul.complispace.com.au`;
    case "staging":
      return `${ne}/staging.soul.complispace.com.au`;
    case "automation":
      return `${ne}/automation.soul.complispace.com.au`;
    case "demo":
      return `${ne}/demo.soul.complispace.com.au`;
    case "production":
      return `${ne}/production.soul.complispace.com.au`;
    default:
      throw new Error("appEnv is invalid.");
  }
}, soul$1 = (re) => (Assert.isPresent(re, "axios"), (ne) => {
  Assert.isPresent(ne, "appEnv");
  const ae = soulUrlByEnv(ne);
  return {
    getRemoteClientAppConfigByHostname: getRemoteClientAppConfigByHostname(re, ae),
    isAuth0EnabledWithHostname: isAuth0EnabledWithHostname(re, ae)
  };
});
function e(re, ne) {
  var ae = {};
  for (var ie in re) Object.prototype.hasOwnProperty.call(re, ie) && ne.indexOf(ie) < 0 && (ae[ie] = re[ie]);
  if (re != null && typeof Object.getOwnPropertySymbols == "function") {
    var le = 0;
    for (ie = Object.getOwnPropertySymbols(re); le < ie.length; le++) ne.indexOf(ie[le]) < 0 && Object.prototype.propertyIsEnumerable.call(re, ie[le]) && (ae[ie[le]] = re[ie[le]]);
  }
  return ae;
}
var t = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global$1 < "u" ? global$1 : typeof self < "u" ? self : {};
function i(re) {
  return re && re.__esModule && Object.prototype.hasOwnProperty.call(re, "default") ? re.default : re;
}
function o(re, ne) {
  return re(ne = { exports: {} }, ne.exports), ne.exports;
}
var n = o(function(re, ne) {
  Object.defineProperty(ne, "__esModule", { value: !0 });
  var ae = function() {
    function ie() {
      var le = this;
      this.locked = /* @__PURE__ */ new Map(), this.addToLocked = function(se, ce) {
        var ue = le.locked.get(se);
        ue === void 0 ? ce === void 0 ? le.locked.set(se, []) : le.locked.set(se, [ce]) : ce !== void 0 && (ue.unshift(ce), le.locked.set(se, ue));
      }, this.isLocked = function(se) {
        return le.locked.has(se);
      }, this.lock = function(se) {
        return new Promise(function(ce, ue) {
          le.isLocked(se) ? le.addToLocked(se, ce) : (le.addToLocked(se), ce());
        });
      }, this.unlock = function(se) {
        var ce = le.locked.get(se);
        if (ce !== void 0 && ce.length !== 0) {
          var ue = ce.pop();
          le.locked.set(se, ce), ue !== void 0 && setTimeout(ue, 0);
        } else le.locked.delete(se);
      };
    }
    return ie.getInstance = function() {
      return ie.instance === void 0 && (ie.instance = new ie()), ie.instance;
    }, ie;
  }();
  ne.default = function() {
    return ae.getInstance();
  };
});
i(n);
var a = i(o(function(re, ne) {
  var ae = t && t.__awaiter || function(fe, pe, ge, be) {
    return new (ge || (ge = Promise))(function(Se, Pe) {
      function Ee(Oe) {
        try {
          Ae(be.next(Oe));
        } catch (Ne) {
          Pe(Ne);
        }
      }
      function Ve(Oe) {
        try {
          Ae(be.throw(Oe));
        } catch (Ne) {
          Pe(Ne);
        }
      }
      function Ae(Oe) {
        Oe.done ? Se(Oe.value) : new ge(function(Ne) {
          Ne(Oe.value);
        }).then(Ee, Ve);
      }
      Ae((be = be.apply(fe, pe || [])).next());
    });
  }, ie = t && t.__generator || function(fe, pe) {
    var ge, be, Se, Pe, Ee = { label: 0, sent: function() {
      if (1 & Se[0]) throw Se[1];
      return Se[1];
    }, trys: [], ops: [] };
    return Pe = { next: Ve(0), throw: Ve(1), return: Ve(2) }, typeof Symbol == "function" && (Pe[Symbol.iterator] = function() {
      return this;
    }), Pe;
    function Ve(Ae) {
      return function(Oe) {
        return function(Ne) {
          if (ge) throw new TypeError("Generator is already executing.");
          for (; Ee; ) try {
            if (ge = 1, be && (Se = 2 & Ne[0] ? be.return : Ne[0] ? be.throw || ((Se = be.return) && Se.call(be), 0) : be.next) && !(Se = Se.call(be, Ne[1])).done) return Se;
            switch (be = 0, Se && (Ne = [2 & Ne[0], Se.value]), Ne[0]) {
              case 0:
              case 1:
                Se = Ne;
                break;
              case 4:
                return Ee.label++, { value: Ne[1], done: !1 };
              case 5:
                Ee.label++, be = Ne[1], Ne = [0];
                continue;
              case 7:
                Ne = Ee.ops.pop(), Ee.trys.pop();
                continue;
              default:
                if (Se = Ee.trys, !((Se = Se.length > 0 && Se[Se.length - 1]) || Ne[0] !== 6 && Ne[0] !== 2)) {
                  Ee = 0;
                  continue;
                }
                if (Ne[0] === 3 && (!Se || Ne[1] > Se[0] && Ne[1] < Se[3])) {
                  Ee.label = Ne[1];
                  break;
                }
                if (Ne[0] === 6 && Ee.label < Se[1]) {
                  Ee.label = Se[1], Se = Ne;
                  break;
                }
                if (Se && Ee.label < Se[2]) {
                  Ee.label = Se[2], Ee.ops.push(Ne);
                  break;
                }
                Se[2] && Ee.ops.pop(), Ee.trys.pop();
                continue;
            }
            Ne = pe.call(fe, Ee);
          } catch (He) {
            Ne = [6, He], be = 0;
          } finally {
            ge = Se = 0;
          }
          if (5 & Ne[0]) throw Ne[1];
          return { value: Ne[0] ? Ne[1] : void 0, done: !0 };
        }([Ae, Oe]);
      };
    }
  }, le = t;
  Object.defineProperty(ne, "__esModule", { value: !0 });
  var se = "browser-tabs-lock-key", ce = { key: function(fe) {
    return ae(le, void 0, void 0, function() {
      return ie(this, function(pe) {
        throw new Error("Unsupported");
      });
    });
  }, getItem: function(fe) {
    return ae(le, void 0, void 0, function() {
      return ie(this, function(pe) {
        throw new Error("Unsupported");
      });
    });
  }, clear: function() {
    return ae(le, void 0, void 0, function() {
      return ie(this, function(fe) {
        return [2, window.localStorage.clear()];
      });
    });
  }, removeItem: function(fe) {
    return ae(le, void 0, void 0, function() {
      return ie(this, function(pe) {
        throw new Error("Unsupported");
      });
    });
  }, setItem: function(fe, pe) {
    return ae(le, void 0, void 0, function() {
      return ie(this, function(ge) {
        throw new Error("Unsupported");
      });
    });
  }, keySync: function(fe) {
    return window.localStorage.key(fe);
  }, getItemSync: function(fe) {
    return window.localStorage.getItem(fe);
  }, clearSync: function() {
    return window.localStorage.clear();
  }, removeItemSync: function(fe) {
    return window.localStorage.removeItem(fe);
  }, setItemSync: function(fe, pe) {
    return window.localStorage.setItem(fe, pe);
  } };
  function ue(fe) {
    return new Promise(function(pe) {
      return setTimeout(pe, fe);
    });
  }
  function de(fe) {
    for (var pe = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", ge = "", be = 0; be < fe; be++)
      ge += pe[Math.floor(Math.random() * pe.length)];
    return ge;
  }
  var me = function() {
    function fe(pe) {
      this.acquiredIatSet = /* @__PURE__ */ new Set(), this.storageHandler = void 0, this.id = Date.now().toString() + de(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = pe, fe.waiters === void 0 && (fe.waiters = []);
    }
    return fe.prototype.acquireLock = function(pe, ge) {
      return ge === void 0 && (ge = 5e3), ae(this, void 0, void 0, function() {
        var be, Se, Pe, Ee, Ve, Ae, Oe;
        return ie(this, function(Ne) {
          switch (Ne.label) {
            case 0:
              be = Date.now() + de(4), Se = Date.now() + ge, Pe = se + "-" + pe, Ee = this.storageHandler === void 0 ? ce : this.storageHandler, Ne.label = 1;
            case 1:
              return Date.now() < Se ? [4, ue(30)] : [3, 8];
            case 2:
              return Ne.sent(), Ee.getItemSync(Pe) !== null ? [3, 5] : (Ve = this.id + "-" + pe + "-" + be, [4, ue(Math.floor(25 * Math.random()))]);
            case 3:
              return Ne.sent(), Ee.setItemSync(Pe, JSON.stringify({ id: this.id, iat: be, timeoutKey: Ve, timeAcquired: Date.now(), timeRefreshed: Date.now() })), [4, ue(30)];
            case 4:
              return Ne.sent(), (Ae = Ee.getItemSync(Pe)) !== null && (Oe = JSON.parse(Ae)).id === this.id && Oe.iat === be ? (this.acquiredIatSet.add(be), this.refreshLockWhileAcquired(Pe, be), [2, !0]) : [3, 7];
            case 5:
              return fe.lockCorrector(this.storageHandler === void 0 ? ce : this.storageHandler), [4, this.waitForSomethingToChange(Se)];
            case 6:
              Ne.sent(), Ne.label = 7;
            case 7:
              return be = Date.now() + de(4), [3, 1];
            case 8:
              return [2, !1];
          }
        });
      });
    }, fe.prototype.refreshLockWhileAcquired = function(pe, ge) {
      return ae(this, void 0, void 0, function() {
        var be = this;
        return ie(this, function(Se) {
          return setTimeout(function() {
            return ae(be, void 0, void 0, function() {
              var Pe, Ee, Ve;
              return ie(this, function(Ae) {
                switch (Ae.label) {
                  case 0:
                    return [4, n.default().lock(ge)];
                  case 1:
                    return Ae.sent(), this.acquiredIatSet.has(ge) ? (Pe = this.storageHandler === void 0 ? ce : this.storageHandler, (Ee = Pe.getItemSync(pe)) === null ? (n.default().unlock(ge), [2]) : ((Ve = JSON.parse(Ee)).timeRefreshed = Date.now(), Pe.setItemSync(pe, JSON.stringify(Ve)), n.default().unlock(ge), this.refreshLockWhileAcquired(pe, ge), [2])) : (n.default().unlock(ge), [2]);
                }
              });
            });
          }, 1e3), [2];
        });
      });
    }, fe.prototype.waitForSomethingToChange = function(pe) {
      return ae(this, void 0, void 0, function() {
        return ie(this, function(ge) {
          switch (ge.label) {
            case 0:
              return [4, new Promise(function(be) {
                var Se = !1, Pe = Date.now(), Ee = !1;
                function Ve() {
                  if (Ee || (window.removeEventListener("storage", Ve), fe.removeFromWaiting(Ve), clearTimeout(Ae), Ee = !0), !Se) {
                    Se = !0;
                    var Oe = 50 - (Date.now() - Pe);
                    Oe > 0 ? setTimeout(be, Oe) : be(null);
                  }
                }
                window.addEventListener("storage", Ve), fe.addToWaiting(Ve);
                var Ae = setTimeout(Ve, Math.max(0, pe - Date.now()));
              })];
            case 1:
              return ge.sent(), [2];
          }
        });
      });
    }, fe.addToWaiting = function(pe) {
      this.removeFromWaiting(pe), fe.waiters !== void 0 && fe.waiters.push(pe);
    }, fe.removeFromWaiting = function(pe) {
      fe.waiters !== void 0 && (fe.waiters = fe.waiters.filter(function(ge) {
        return ge !== pe;
      }));
    }, fe.notifyWaiters = function() {
      fe.waiters !== void 0 && fe.waiters.slice().forEach(function(pe) {
        return pe();
      });
    }, fe.prototype.releaseLock = function(pe) {
      return ae(this, void 0, void 0, function() {
        return ie(this, function(ge) {
          switch (ge.label) {
            case 0:
              return [4, this.releaseLock__private__(pe)];
            case 1:
              return [2, ge.sent()];
          }
        });
      });
    }, fe.prototype.releaseLock__private__ = function(pe) {
      return ae(this, void 0, void 0, function() {
        var ge, be, Se, Pe;
        return ie(this, function(Ee) {
          switch (Ee.label) {
            case 0:
              return ge = this.storageHandler === void 0 ? ce : this.storageHandler, be = se + "-" + pe, (Se = ge.getItemSync(be)) === null ? [2] : (Pe = JSON.parse(Se)).id !== this.id ? [3, 2] : [4, n.default().lock(Pe.iat)];
            case 1:
              Ee.sent(), this.acquiredIatSet.delete(Pe.iat), ge.removeItemSync(be), n.default().unlock(Pe.iat), fe.notifyWaiters(), Ee.label = 2;
            case 2:
              return [2];
          }
        });
      });
    }, fe.lockCorrector = function(pe) {
      for (var ge = Date.now() - 5e3, be = pe, Se = [], Pe = 0; ; ) {
        var Ee = be.keySync(Pe);
        if (Ee === null) break;
        Se.push(Ee), Pe++;
      }
      for (var Ve = !1, Ae = 0; Ae < Se.length; Ae++) {
        var Oe = Se[Ae];
        if (Oe.includes(se)) {
          var Ne = be.getItemSync(Oe);
          if (Ne !== null) {
            var He = JSON.parse(Ne);
            (He.timeRefreshed === void 0 && He.timeAcquired < ge || He.timeRefreshed !== void 0 && He.timeRefreshed < ge) && (be.removeItemSync(Oe), Ve = !0);
          }
        }
      }
      Ve && fe.notifyWaiters();
    }, fe.waiters = void 0, fe;
  }();
  ne.default = me;
}));
const r$1 = { timeoutInSeconds: 60 }, s$1 = { name: "auth0-spa-js", version: "2.1.3" }, c = () => Date.now();
class d extends Error {
  constructor(ne, ae) {
    super(ae), this.error = ne, this.error_description = ae, Object.setPrototypeOf(this, d.prototype);
  }
  static fromPayload({ error: ne, error_description: ae }) {
    return new d(ne, ae);
  }
}
class u extends d {
  constructor(ne, ae, ie, le = null) {
    super(ne, ae), this.state = ie, this.appState = le, Object.setPrototypeOf(this, u.prototype);
  }
}
class l extends d {
  constructor() {
    super("timeout", "Timeout"), Object.setPrototypeOf(this, l.prototype);
  }
}
class h extends l {
  constructor(ne) {
    super(), this.popup = ne, Object.setPrototypeOf(this, h.prototype);
  }
}
class p extends d {
  constructor(ne) {
    super("cancelled", "Popup closed"), this.popup = ne, Object.setPrototypeOf(this, p.prototype);
  }
}
class m extends d {
  constructor(ne, ae, ie) {
    super(ne, ae), this.mfa_token = ie, Object.setPrototypeOf(this, m.prototype);
  }
}
let f$1 = class br extends d {
  constructor(ne, ae) {
    super("missing_refresh_token", `Missing Refresh Token (audience: '${g$2(ne, ["default"])}', scope: '${g$2(ae)}')`), this.audience = ne, this.scope = ae, Object.setPrototypeOf(this, br.prototype);
  }
};
function g$2(re, ne = []) {
  return re && !ne.includes(re) ? re : "";
}
const w = () => window.crypto, y = () => {
  const re = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.";
  let ne = "";
  return Array.from(w().getRandomValues(new Uint8Array(43))).forEach((ae) => ne += re[ae % re.length]), ne;
}, k = (re) => btoa(re), v = (re) => {
  var { clientId: ne } = re, ae = e(re, ["clientId"]);
  return new URLSearchParams(((ie) => Object.keys(ie).filter((le) => ie[le] !== void 0).reduce((le, se) => Object.assign(Object.assign({}, le), { [se]: ie[se] }), {}))(Object.assign({ client_id: ne }, ae))).toString();
}, b = (re) => ((ne) => decodeURIComponent(atob(ne).split("").map((ae) => "%" + ("00" + ae.charCodeAt(0).toString(16)).slice(-2)).join("")))(re.replace(/_/g, "/").replace(/-/g, "+")), _ = async (re, ne) => {
  const ae = await fetch(re, ne);
  return { ok: ae.ok, json: await ae.json() };
}, I = async (re, ne, ae) => {
  const ie = new AbortController();
  let le;
  return ne.signal = ie.signal, Promise.race([_(re, ne), new Promise((se, ce) => {
    le = setTimeout(() => {
      ie.abort(), ce(new Error("Timeout when executing 'fetch'"));
    }, ae);
  })]).finally(() => {
    clearTimeout(le);
  });
}, S = async (re, ne, ae, ie, le, se, ce) => {
  return ue = { auth: { audience: ne, scope: ae }, timeout: le, fetchUrl: re, fetchOptions: ie, useFormData: ce }, de = se, new Promise(function(me, fe) {
    const pe = new MessageChannel();
    pe.port1.onmessage = function(ge) {
      ge.data.error ? fe(new Error(ge.data.error)) : me(ge.data), pe.port1.close();
    }, de.postMessage(ue, [pe.port2]);
  });
  var ue, de;
}, O = async (re, ne, ae, ie, le, se, ce = 1e4) => le ? S(re, ne, ae, ie, ce, le, se) : I(re, ie, ce);
async function T(re, ne) {
  var { baseUrl: ae, timeout: ie, audience: le, scope: se, auth0Client: ce, useFormData: ue } = re, de = e(re, ["baseUrl", "timeout", "audience", "scope", "auth0Client", "useFormData"]);
  const me = ue ? v(de) : JSON.stringify(de);
  return await async function(fe, pe, ge, be, Se, Pe, Ee) {
    let Ve, Ae = null;
    for (let Fe = 0; Fe < 3; Fe++) try {
      Ve = await O(fe, ge, be, Se, Pe, Ee, pe), Ae = null;
      break;
    } catch (Ke) {
      Ae = Ke;
    }
    if (Ae) throw Ae;
    const Oe = Ve.json, { error: Ne, error_description: He } = Oe, Ue = e(Oe, ["error", "error_description"]), { ok: Ze } = Ve;
    if (!Ze) {
      const Fe = He || `HTTP error. Unable to fetch ${fe}`;
      throw Ne === "mfa_required" ? new m(Ne, Fe, Ue.mfa_token) : Ne === "missing_refresh_token" ? new f$1(ge, be) : new d(Ne || "request_error", Fe);
    }
    return Ue;
  }(`${ae}/oauth/token`, ie, le || "default", se, { method: "POST", body: me, headers: { "Content-Type": ue ? "application/x-www-form-urlencoded" : "application/json", "Auth0-Client": btoa(JSON.stringify(ce || s$1)) } }, ne, ue);
}
const j = (...re) => {
  return (ne = re.filter(Boolean).join(" ").trim().split(/\s+/), Array.from(new Set(ne))).join(" ");
  var ne;
};
class C {
  constructor(ne, ae = "@@auth0spajs@@", ie) {
    this.prefix = ae, this.suffix = ie, this.clientId = ne.clientId, this.scope = ne.scope, this.audience = ne.audience;
  }
  toKey() {
    return [this.prefix, this.clientId, this.audience, this.scope, this.suffix].filter(Boolean).join("::");
  }
  static fromKey(ne) {
    const [ae, ie, le, se] = ne.split("::");
    return new C({ clientId: ie, scope: se, audience: le }, ae);
  }
  static fromCacheEntry(ne) {
    const { scope: ae, audience: ie, client_id: le } = ne;
    return new C({ scope: ae, audience: ie, clientId: le });
  }
}
class z {
  set(ne, ae) {
    localStorage.setItem(ne, JSON.stringify(ae));
  }
  get(ne) {
    const ae = window.localStorage.getItem(ne);
    if (ae) try {
      return JSON.parse(ae);
    } catch {
      return;
    }
  }
  remove(ne) {
    localStorage.removeItem(ne);
  }
  allKeys() {
    return Object.keys(window.localStorage).filter((ne) => ne.startsWith("@@auth0spajs@@"));
  }
}
class P {
  constructor() {
    this.enclosedCache = /* @__PURE__ */ function() {
      let ne = {};
      return { set(ae, ie) {
        ne[ae] = ie;
      }, get(ae) {
        const ie = ne[ae];
        if (ie) return ie;
      }, remove(ae) {
        delete ne[ae];
      }, allKeys: () => Object.keys(ne) };
    }();
  }
}
class x {
  constructor(ne, ae, ie) {
    this.cache = ne, this.keyManifest = ae, this.nowProvider = ie || c;
  }
  async setIdToken(ne, ae, ie) {
    var le;
    const se = this.getIdTokenCacheKey(ne);
    await this.cache.set(se, { id_token: ae, decodedToken: ie }), await ((le = this.keyManifest) === null || le === void 0 ? void 0 : le.add(se));
  }
  async getIdToken(ne) {
    const ae = await this.cache.get(this.getIdTokenCacheKey(ne.clientId));
    if (!ae && ne.scope && ne.audience) {
      const ie = await this.get(ne);
      return !ie || !ie.id_token || !ie.decodedToken ? void 0 : { id_token: ie.id_token, decodedToken: ie.decodedToken };
    }
    if (ae) return { id_token: ae.id_token, decodedToken: ae.decodedToken };
  }
  async get(ne, ae = 0) {
    var ie;
    let le = await this.cache.get(ne.toKey());
    if (!le) {
      const ue = await this.getCacheKeys();
      if (!ue) return;
      const de = this.matchExistingCacheKey(ne, ue);
      de && (le = await this.cache.get(de));
    }
    if (!le) return;
    const se = await this.nowProvider(), ce = Math.floor(se / 1e3);
    return le.expiresAt - ae < ce ? le.body.refresh_token ? (le.body = { refresh_token: le.body.refresh_token }, await this.cache.set(ne.toKey(), le), le.body) : (await this.cache.remove(ne.toKey()), void await ((ie = this.keyManifest) === null || ie === void 0 ? void 0 : ie.remove(ne.toKey()))) : le.body;
  }
  async set(ne) {
    var ae;
    const ie = new C({ clientId: ne.client_id, scope: ne.scope, audience: ne.audience }), le = await this.wrapCacheEntry(ne);
    await this.cache.set(ie.toKey(), le), await ((ae = this.keyManifest) === null || ae === void 0 ? void 0 : ae.add(ie.toKey()));
  }
  async clear(ne) {
    var ae;
    const ie = await this.getCacheKeys();
    ie && (await ie.filter((le) => !ne || le.includes(ne)).reduce(async (le, se) => {
      await le, await this.cache.remove(se);
    }, Promise.resolve()), await ((ae = this.keyManifest) === null || ae === void 0 ? void 0 : ae.clear()));
  }
  async wrapCacheEntry(ne) {
    const ae = await this.nowProvider();
    return { body: ne, expiresAt: Math.floor(ae / 1e3) + ne.expires_in };
  }
  async getCacheKeys() {
    var ne;
    return this.keyManifest ? (ne = await this.keyManifest.get()) === null || ne === void 0 ? void 0 : ne.keys : this.cache.allKeys ? this.cache.allKeys() : void 0;
  }
  getIdTokenCacheKey(ne) {
    return new C({ clientId: ne }, "@@auth0spajs@@", "@@user@@").toKey();
  }
  matchExistingCacheKey(ne, ae) {
    return ae.filter((ie) => {
      var le;
      const se = C.fromKey(ie), ce = new Set(se.scope && se.scope.split(" ")), ue = ((le = ne.scope) === null || le === void 0 ? void 0 : le.split(" ")) || [], de = se.scope && ue.reduce((me, fe) => me && ce.has(fe), !0);
      return se.prefix === "@@auth0spajs@@" && se.clientId === ne.clientId && se.audience === ne.audience && de;
    })[0];
  }
}
class Z {
  constructor(ne, ae, ie) {
    this.storage = ne, this.clientId = ae, this.cookieDomain = ie, this.storageKey = `a0.spajs.txs.${this.clientId}`;
  }
  create(ne) {
    this.storage.save(this.storageKey, ne, { daysUntilExpire: 1, cookieDomain: this.cookieDomain });
  }
  get() {
    return this.storage.get(this.storageKey);
  }
  remove() {
    this.storage.remove(this.storageKey, { cookieDomain: this.cookieDomain });
  }
}
const K$5 = (re) => typeof re == "number", W$6 = ["iss", "aud", "exp", "nbf", "iat", "jti", "azp", "nonce", "auth_time", "at_hash", "c_hash", "acr", "amr", "sub_jwk", "cnf", "sip_from_tag", "sip_date", "sip_callid", "sip_cseq_num", "sip_via_branch", "orig", "dest", "mky", "events", "toe", "txn", "rph", "sid", "vot", "vtm"], E = (re) => {
  if (!re.id_token) throw new Error("ID token is required but missing");
  const ne = ((se) => {
    const ce = se.split("."), [ue, de, me] = ce;
    if (ce.length !== 3 || !ue || !de || !me) throw new Error("ID token could not be decoded");
    const fe = JSON.parse(b(de)), pe = { __raw: se }, ge = {};
    return Object.keys(fe).forEach((be) => {
      pe[be] = fe[be], W$6.includes(be) || (ge[be] = fe[be]);
    }), { encoded: { header: ue, payload: de, signature: me }, header: JSON.parse(b(ue)), claims: pe, user: ge };
  })(re.id_token);
  if (!ne.claims.iss) throw new Error("Issuer (iss) claim must be a string present in the ID token");
  if (ne.claims.iss !== re.iss) throw new Error(`Issuer (iss) claim mismatch in the ID token; expected "${re.iss}", found "${ne.claims.iss}"`);
  if (!ne.user.sub) throw new Error("Subject (sub) claim must be a string present in the ID token");
  if (ne.header.alg !== "RS256") throw new Error(`Signature algorithm of "${ne.header.alg}" is not supported. Expected the ID token to be signed with "RS256".`);
  if (!ne.claims.aud || typeof ne.claims.aud != "string" && !Array.isArray(ne.claims.aud)) throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");
  if (Array.isArray(ne.claims.aud)) {
    if (!ne.claims.aud.includes(re.aud)) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${re.aud}" but was not one of "${ne.claims.aud.join(", ")}"`);
    if (ne.claims.aud.length > 1) {
      if (!ne.claims.azp) throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");
      if (ne.claims.azp !== re.aud) throw new Error(`Authorized Party (azp) claim mismatch in the ID token; expected "${re.aud}", found "${ne.claims.azp}"`);
    }
  } else if (ne.claims.aud !== re.aud) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${re.aud}" but found "${ne.claims.aud}"`);
  if (re.nonce) {
    if (!ne.claims.nonce) throw new Error("Nonce (nonce) claim must be a string present in the ID token");
    if (ne.claims.nonce !== re.nonce) throw new Error(`Nonce (nonce) claim mismatch in the ID token; expected "${re.nonce}", found "${ne.claims.nonce}"`);
  }
  if (re.max_age && !K$5(ne.claims.auth_time)) throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");
  if (ne.claims.exp == null || !K$5(ne.claims.exp)) throw new Error("Expiration Time (exp) claim must be a number present in the ID token");
  if (!K$5(ne.claims.iat)) throw new Error("Issued At (iat) claim must be a number present in the ID token");
  const ae = re.leeway || 60, ie = new Date(re.now || Date.now()), le = /* @__PURE__ */ new Date(0);
  if (le.setUTCSeconds(ne.claims.exp + ae), ie > le) throw new Error(`Expiration Time (exp) claim error in the ID token; current time (${ie}) is after expiration time (${le})`);
  if (ne.claims.nbf != null && K$5(ne.claims.nbf)) {
    const se = /* @__PURE__ */ new Date(0);
    if (se.setUTCSeconds(ne.claims.nbf - ae), ie < se) throw new Error(`Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Current time (${ie}) is before ${se}`);
  }
  if (ne.claims.auth_time != null && K$5(ne.claims.auth_time)) {
    const se = /* @__PURE__ */ new Date(0);
    if (se.setUTCSeconds(parseInt(ne.claims.auth_time) + re.max_age + ae), ie > se) throw new Error(`Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time (${ie}) is after last auth at ${se}`);
  }
  if (re.organization) {
    const se = re.organization.trim();
    if (se.startsWith("org_")) {
      const ce = se;
      if (!ne.claims.org_id) throw new Error("Organization ID (org_id) claim must be a string present in the ID token");
      if (ce !== ne.claims.org_id) throw new Error(`Organization ID (org_id) claim mismatch in the ID token; expected "${ce}", found "${ne.claims.org_id}"`);
    } else {
      const ce = se.toLowerCase();
      if (!ne.claims.org_name) throw new Error("Organization Name (org_name) claim must be a string present in the ID token");
      if (ce !== ne.claims.org_name) throw new Error(`Organization Name (org_name) claim mismatch in the ID token; expected "${ce}", found "${ne.claims.org_name}"`);
    }
  }
  return ne;
};
var R$1 = o(function(re, ne) {
  var ae = t && t.__assign || function() {
    return ae = Object.assign || function(de) {
      for (var me, fe = 1, pe = arguments.length; fe < pe; fe++) for (var ge in me = arguments[fe]) Object.prototype.hasOwnProperty.call(me, ge) && (de[ge] = me[ge]);
      return de;
    }, ae.apply(this, arguments);
  };
  function ie(de, me) {
    if (!me) return "";
    var fe = "; " + de;
    return me === !0 ? fe : fe + "=" + me;
  }
  function le(de, me, fe) {
    return encodeURIComponent(de).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(me).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + function(pe) {
      if (typeof pe.expires == "number") {
        var ge = /* @__PURE__ */ new Date();
        ge.setMilliseconds(ge.getMilliseconds() + 864e5 * pe.expires), pe.expires = ge;
      }
      return ie("Expires", pe.expires ? pe.expires.toUTCString() : "") + ie("Domain", pe.domain) + ie("Path", pe.path) + ie("Secure", pe.secure) + ie("SameSite", pe.sameSite);
    }(fe);
  }
  function se(de) {
    for (var me = {}, fe = de ? de.split("; ") : [], pe = /(%[\dA-F]{2})+/gi, ge = 0; ge < fe.length; ge++) {
      var be = fe[ge].split("="), Se = be.slice(1).join("=");
      Se.charAt(0) === '"' && (Se = Se.slice(1, -1));
      try {
        me[be[0].replace(pe, decodeURIComponent)] = Se.replace(pe, decodeURIComponent);
      } catch {
      }
    }
    return me;
  }
  function ce() {
    return se(document.cookie);
  }
  function ue(de, me, fe) {
    document.cookie = le(de, me, ae({ path: "/" }, fe));
  }
  ne.__esModule = !0, ne.encode = le, ne.parse = se, ne.getAll = ce, ne.get = function(de) {
    return ce()[de];
  }, ne.set = ue, ne.remove = function(de, me) {
    ue(de, "", ae(ae({}, me), { expires: -1 }));
  };
});
i(R$1), R$1.encode, R$1.parse, R$1.getAll;
var U = R$1.get, L = R$1.set, D = R$1.remove;
const X = { get(re) {
  const ne = U(re);
  if (ne !== void 0) return JSON.parse(ne);
}, save(re, ne, ae) {
  let ie = {};
  window.location.protocol === "https:" && (ie = { secure: !0, sameSite: "none" }), ae != null && ae.daysUntilExpire && (ie.expires = ae.daysUntilExpire), ae != null && ae.cookieDomain && (ie.domain = ae.cookieDomain), L(re, JSON.stringify(ne), ie);
}, remove(re, ne) {
  let ae = {};
  ne != null && ne.cookieDomain && (ae.domain = ne.cookieDomain), D(re, ae);
} }, N = { get(re) {
  return X.get(re) || X.get(`_legacy_${re}`);
}, save(re, ne, ae) {
  let ie = {};
  window.location.protocol === "https:" && (ie = { secure: !0 }), ae != null && ae.daysUntilExpire && (ie.expires = ae.daysUntilExpire), ae != null && ae.cookieDomain && (ie.domain = ae.cookieDomain), L(`_legacy_${re}`, JSON.stringify(ne), ie), X.save(re, ne, ae);
}, remove(re, ne) {
  let ae = {};
  ne != null && ne.cookieDomain && (ae.domain = ne.cookieDomain), D(re, ae), X.remove(re, ne), X.remove(`_legacy_${re}`, ne);
} }, J = { get(re) {
  if (typeof sessionStorage > "u") return;
  const ne = sessionStorage.getItem(re);
  return ne != null ? JSON.parse(ne) : void 0;
}, save(re, ne) {
  sessionStorage.setItem(re, JSON.stringify(ne));
}, remove(re) {
  sessionStorage.removeItem(re);
} };
function F(re, ne, ae) {
  var ie = ne === void 0 ? null : ne, le = function(de, me) {
    var fe = atob(de);
    if (me) {
      for (var pe = new Uint8Array(fe.length), ge = 0, be = fe.length; ge < be; ++ge) pe[ge] = fe.charCodeAt(ge);
      return String.fromCharCode.apply(null, new Uint16Array(pe.buffer));
    }
    return fe;
  }(re, ae !== void 0 && ae), se = le.indexOf(`
`, 10) + 1, ce = le.substring(se) + (ie ? "//# sourceMappingURL=" + ie : ""), ue = new Blob([ce], { type: "application/javascript" });
  return URL.createObjectURL(ue);
}
var H, Y, G$1, V, M = (H = "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", Y = null, G$1 = !1, function(re) {
  return V = V || F(H, Y, G$1), new Worker(V, re);
});
const A = {};
class B {
  constructor(ne, ae) {
    this.cache = ne, this.clientId = ae, this.manifestKey = this.createManifestKeyFrom(this.clientId);
  }
  async add(ne) {
    var ae;
    const ie = new Set(((ae = await this.cache.get(this.manifestKey)) === null || ae === void 0 ? void 0 : ae.keys) || []);
    ie.add(ne), await this.cache.set(this.manifestKey, { keys: [...ie] });
  }
  async remove(ne) {
    const ae = await this.cache.get(this.manifestKey);
    if (ae) {
      const ie = new Set(ae.keys);
      return ie.delete(ne), ie.size > 0 ? await this.cache.set(this.manifestKey, { keys: [...ie] }) : await this.cache.remove(this.manifestKey);
    }
  }
  get() {
    return this.cache.get(this.manifestKey);
  }
  clear() {
    return this.cache.remove(this.manifestKey);
  }
  createManifestKeyFrom(ne) {
    return `@@auth0spajs@@::${ne}`;
  }
}
const $ = { memory: () => new P().enclosedCache, localstorage: () => new z() }, q = (re) => $[re], Q = (re) => {
  const { openUrl: ne, onRedirect: ae } = re, ie = e(re, ["openUrl", "onRedirect"]);
  return Object.assign(Object.assign({}, ie), { openUrl: ne === !1 || ne ? ne : ae });
}, ee = new a();
class te {
  constructor(ne) {
    let ae, ie;
    if (this.userCache = new P().enclosedCache, this.defaultOptions = { authorizationParams: { scope: "openid profile email" }, useRefreshTokensFallback: !1, useFormData: !0 }, this._releaseLockOnPageHide = async () => {
      await ee.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
    }, this.options = Object.assign(Object.assign(Object.assign({}, this.defaultOptions), ne), { authorizationParams: Object.assign(Object.assign({}, this.defaultOptions.authorizationParams), ne.authorizationParams) }), typeof window < "u" && (() => {
      if (!w()) throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");
      if (w().subtle === void 0) throw new Error(`
      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/main/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.
    `);
    })(), ne.cache && ne.cacheLocation && console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."), ne.cache) ie = ne.cache;
    else {
      if (ae = ne.cacheLocation || "memory", !q(ae)) throw new Error(`Invalid cache location "${ae}"`);
      ie = q(ae)();
    }
    this.httpTimeoutMs = ne.httpTimeoutInSeconds ? 1e3 * ne.httpTimeoutInSeconds : 1e4, this.cookieStorage = ne.legacySameSiteCookie === !1 ? X : N, this.orgHintCookieName = `auth0.${this.options.clientId}.organization_hint`, this.isAuthenticatedCookieName = ((ce) => `auth0.${ce}.is.authenticated`)(this.options.clientId), this.sessionCheckExpiryDays = ne.sessionCheckExpiryDays || 1;
    const le = ne.useCookiesForTransactions ? this.cookieStorage : J;
    var se;
    this.scope = j("openid", this.options.authorizationParams.scope, this.options.useRefreshTokens ? "offline_access" : ""), this.transactionManager = new Z(le, this.options.clientId, this.options.cookieDomain), this.nowProvider = this.options.nowProvider || c, this.cacheManager = new x(ie, ie.allKeys ? void 0 : new B(ie, this.options.clientId), this.nowProvider), this.domainUrl = (se = this.options.domain, /^https?:\/\//.test(se) ? se : `https://${se}`), this.tokenIssuer = ((ce, ue) => ce ? ce.startsWith("https://") ? ce : `https://${ce}/` : `${ue}/`)(this.options.issuer, this.domainUrl), typeof window < "u" && window.Worker && this.options.useRefreshTokens && ae === "memory" && (this.options.workerUrl ? this.worker = new Worker(this.options.workerUrl) : this.worker = new M());
  }
  _url(ne) {
    const ae = encodeURIComponent(btoa(JSON.stringify(this.options.auth0Client || s$1)));
    return `${this.domainUrl}${ne}&auth0Client=${ae}`;
  }
  _authorizeUrl(ne) {
    return this._url(`/authorize?${v(ne)}`);
  }
  async _verifyIdToken(ne, ae, ie) {
    const le = await this.nowProvider();
    return E({ iss: this.tokenIssuer, aud: this.options.clientId, id_token: ne, nonce: ae, organization: ie, leeway: this.options.leeway, max_age: (se = this.options.authorizationParams.max_age, typeof se != "string" ? se : parseInt(se, 10) || void 0), now: le });
    var se;
  }
  _processOrgHint(ne) {
    ne ? this.cookieStorage.save(this.orgHintCookieName, ne, { daysUntilExpire: this.sessionCheckExpiryDays, cookieDomain: this.options.cookieDomain }) : this.cookieStorage.remove(this.orgHintCookieName, { cookieDomain: this.options.cookieDomain });
  }
  async _prepareAuthorizeUrl(ne, ae, ie) {
    const le = k(y()), se = k(y()), ce = y(), ue = ((fe) => {
      const pe = new Uint8Array(fe);
      return ((ge) => {
        const be = { "+": "-", "/": "_", "=": "" };
        return ge.replace(/[+/=]/g, (Se) => be[Se]);
      })(window.btoa(String.fromCharCode(...Array.from(pe))));
    })(await (async (fe) => await w().subtle.digest({ name: "SHA-256" }, new TextEncoder().encode(fe)))(ce)), de = ((fe, pe, ge, be, Se, Pe, Ee, Ve) => Object.assign(Object.assign(Object.assign({ client_id: fe.clientId }, fe.authorizationParams), ge), { scope: j(pe, ge.scope), response_type: "code", response_mode: Ve || "query", state: be, nonce: Se, redirect_uri: Ee || fe.authorizationParams.redirect_uri, code_challenge: Pe, code_challenge_method: "S256" }))(this.options, this.scope, ne, le, se, ue, ne.redirect_uri || this.options.authorizationParams.redirect_uri || ie, ae == null ? void 0 : ae.response_mode), me = this._authorizeUrl(de);
    return { nonce: se, code_verifier: ce, scope: de.scope, audience: de.audience || "default", redirect_uri: de.redirect_uri, state: le, url: me };
  }
  async loginWithPopup(ne, ae) {
    var ie;
    if (ne = ne || {}, !(ae = ae || {}).popup && (ae.popup = ((ue) => {
      const de = window.screenX + (window.innerWidth - 400) / 2, me = window.screenY + (window.innerHeight - 600) / 2;
      return window.open(ue, "auth0:authorize:popup", `left=${de},top=${me},width=400,height=600,resizable,scrollbars=yes,status=1`);
    })(""), !ae.popup)) throw new Error("Unable to open a popup for loginWithPopup - window.open returned `null`");
    const le = await this._prepareAuthorizeUrl(ne.authorizationParams || {}, { response_mode: "web_message" }, window.location.origin);
    ae.popup.location.href = le.url;
    const se = await ((ue) => new Promise((de, me) => {
      let fe;
      const pe = setInterval(() => {
        ue.popup && ue.popup.closed && (clearInterval(pe), clearTimeout(ge), window.removeEventListener("message", fe, !1), me(new p(ue.popup)));
      }, 1e3), ge = setTimeout(() => {
        clearInterval(pe), me(new h(ue.popup)), window.removeEventListener("message", fe, !1);
      }, 1e3 * (ue.timeoutInSeconds || 60));
      fe = function(be) {
        if (be.data && be.data.type === "authorization_response") {
          if (clearTimeout(ge), clearInterval(pe), window.removeEventListener("message", fe, !1), ue.popup.close(), be.data.response.error) return me(d.fromPayload(be.data.response));
          de(be.data.response);
        }
      }, window.addEventListener("message", fe);
    }))(Object.assign(Object.assign({}, ae), { timeoutInSeconds: ae.timeoutInSeconds || this.options.authorizeTimeoutInSeconds || 60 }));
    if (le.state !== se.state) throw new d("state_mismatch", "Invalid state");
    const ce = ((ie = ne.authorizationParams) === null || ie === void 0 ? void 0 : ie.organization) || this.options.authorizationParams.organization;
    await this._requestToken({ audience: le.audience, scope: le.scope, code_verifier: le.code_verifier, grant_type: "authorization_code", code: se.code, redirect_uri: le.redirect_uri }, { nonceIn: le.nonce, organization: ce });
  }
  async getUser() {
    var ne;
    const ae = await this._getIdTokenFromCache();
    return (ne = ae == null ? void 0 : ae.decodedToken) === null || ne === void 0 ? void 0 : ne.user;
  }
  async getIdTokenClaims() {
    var ne;
    const ae = await this._getIdTokenFromCache();
    return (ne = ae == null ? void 0 : ae.decodedToken) === null || ne === void 0 ? void 0 : ne.claims;
  }
  async loginWithRedirect(ne = {}) {
    var ae;
    const ie = Q(ne), { openUrl: le, fragment: se, appState: ce } = ie, ue = e(ie, ["openUrl", "fragment", "appState"]), de = ((ae = ue.authorizationParams) === null || ae === void 0 ? void 0 : ae.organization) || this.options.authorizationParams.organization, me = await this._prepareAuthorizeUrl(ue.authorizationParams || {}), { url: fe } = me, pe = e(me, ["url"]);
    this.transactionManager.create(Object.assign(Object.assign(Object.assign({}, pe), { appState: ce }), de && { organization: de }));
    const ge = se ? `${fe}#${se}` : fe;
    le ? await le(ge) : window.location.assign(ge);
  }
  async handleRedirectCallback(ne = window.location.href) {
    const ae = ne.split("?").slice(1);
    if (ae.length === 0) throw new Error("There are no query params available for parsing.");
    const { state: ie, code: le, error: se, error_description: ce } = ((pe) => {
      pe.indexOf("#") > -1 && (pe = pe.substring(0, pe.indexOf("#")));
      const ge = new URLSearchParams(pe);
      return { state: ge.get("state"), code: ge.get("code") || void 0, error: ge.get("error") || void 0, error_description: ge.get("error_description") || void 0 };
    })(ae.join("")), ue = this.transactionManager.get();
    if (!ue) throw new d("missing_transaction", "Invalid state");
    if (this.transactionManager.remove(), se) throw new u(se, ce || se, ie, ue.appState);
    if (!ue.code_verifier || ue.state && ue.state !== ie) throw new d("state_mismatch", "Invalid state");
    const de = ue.organization, me = ue.nonce, fe = ue.redirect_uri;
    return await this._requestToken(Object.assign({ audience: ue.audience, scope: ue.scope, code_verifier: ue.code_verifier, grant_type: "authorization_code", code: le }, fe ? { redirect_uri: fe } : {}), { nonceIn: me, organization: de }), { appState: ue.appState };
  }
  async checkSession(ne) {
    if (!this.cookieStorage.get(this.isAuthenticatedCookieName)) {
      if (!this.cookieStorage.get("auth0.is.authenticated")) return;
      this.cookieStorage.save(this.isAuthenticatedCookieName, !0, { daysUntilExpire: this.sessionCheckExpiryDays, cookieDomain: this.options.cookieDomain }), this.cookieStorage.remove("auth0.is.authenticated");
    }
    try {
      await this.getTokenSilently(ne);
    } catch {
    }
  }
  async getTokenSilently(ne = {}) {
    var ae;
    const ie = Object.assign(Object.assign({ cacheMode: "on" }, ne), { authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), ne.authorizationParams), { scope: j(this.scope, (ae = ne.authorizationParams) === null || ae === void 0 ? void 0 : ae.scope) }) }), le = await ((se, ce) => {
      let ue = A[ce];
      return ue || (ue = se().finally(() => {
        delete A[ce], ue = null;
      }), A[ce] = ue), ue;
    })(() => this._getTokenSilently(ie), `${this.options.clientId}::${ie.authorizationParams.audience}::${ie.authorizationParams.scope}`);
    return ne.detailedResponse ? le : le == null ? void 0 : le.access_token;
  }
  async _getTokenSilently(ne) {
    const { cacheMode: ae } = ne, ie = e(ne, ["cacheMode"]);
    if (ae !== "off") {
      const le = await this._getEntryFromCache({ scope: ie.authorizationParams.scope, audience: ie.authorizationParams.audience || "default", clientId: this.options.clientId });
      if (le) return le;
    }
    if (ae !== "cache-only") {
      if (!await (async (le, se = 3) => {
        for (let ce = 0; ce < se; ce++) if (await le()) return !0;
        return !1;
      })(() => ee.acquireLock("auth0.lock.getTokenSilently", 5e3), 10)) throw new l();
      try {
        if (window.addEventListener("pagehide", this._releaseLockOnPageHide), ae !== "off") {
          const me = await this._getEntryFromCache({ scope: ie.authorizationParams.scope, audience: ie.authorizationParams.audience || "default", clientId: this.options.clientId });
          if (me) return me;
        }
        const le = this.options.useRefreshTokens ? await this._getTokenUsingRefreshToken(ie) : await this._getTokenFromIFrame(ie), { id_token: se, access_token: ce, oauthTokenScope: ue, expires_in: de } = le;
        return Object.assign(Object.assign({ id_token: se, access_token: ce }, ue ? { scope: ue } : null), { expires_in: de });
      } finally {
        await ee.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
      }
    }
  }
  async getTokenWithPopup(ne = {}, ae = {}) {
    var ie;
    const le = Object.assign(Object.assign({}, ne), { authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), ne.authorizationParams), { scope: j(this.scope, (ie = ne.authorizationParams) === null || ie === void 0 ? void 0 : ie.scope) }) });
    return ae = Object.assign(Object.assign({}, r$1), ae), await this.loginWithPopup(le, ae), (await this.cacheManager.get(new C({ scope: le.authorizationParams.scope, audience: le.authorizationParams.audience || "default", clientId: this.options.clientId }))).access_token;
  }
  async isAuthenticated() {
    return !!await this.getUser();
  }
  _buildLogoutUrl(ne) {
    ne.clientId !== null ? ne.clientId = ne.clientId || this.options.clientId : delete ne.clientId;
    const ae = ne.logoutParams || {}, { federated: ie } = ae, le = e(ae, ["federated"]), se = ie ? "&federated" : "";
    return this._url(`/v2/logout?${v(Object.assign({ clientId: ne.clientId }, le))}`) + se;
  }
  async logout(ne = {}) {
    const ae = Q(ne), { openUrl: ie } = ae, le = e(ae, ["openUrl"]);
    ne.clientId === null ? await this.cacheManager.clear() : await this.cacheManager.clear(ne.clientId || this.options.clientId), this.cookieStorage.remove(this.orgHintCookieName, { cookieDomain: this.options.cookieDomain }), this.cookieStorage.remove(this.isAuthenticatedCookieName, { cookieDomain: this.options.cookieDomain }), this.userCache.remove("@@user@@");
    const se = this._buildLogoutUrl(le);
    ie ? await ie(se) : ie !== !1 && window.location.assign(se);
  }
  async _getTokenFromIFrame(ne) {
    const ae = Object.assign(Object.assign({}, ne.authorizationParams), { prompt: "none" }), ie = this.cookieStorage.get(this.orgHintCookieName);
    ie && !ae.organization && (ae.organization = ie);
    const { url: le, state: se, nonce: ce, code_verifier: ue, redirect_uri: de, scope: me, audience: fe } = await this._prepareAuthorizeUrl(ae, { response_mode: "web_message" }, window.location.origin);
    try {
      if (window.crossOriginIsolated) throw new d("login_required", "The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");
      const pe = ne.timeoutInSeconds || this.options.authorizeTimeoutInSeconds, ge = await ((Se, Pe, Ee = 60) => new Promise((Ve, Ae) => {
        const Oe = window.document.createElement("iframe");
        Oe.setAttribute("width", "0"), Oe.setAttribute("height", "0"), Oe.style.display = "none";
        const Ne = () => {
          window.document.body.contains(Oe) && (window.document.body.removeChild(Oe), window.removeEventListener("message", He, !1));
        };
        let He;
        const Ue = setTimeout(() => {
          Ae(new l()), Ne();
        }, 1e3 * Ee);
        He = function(Ze) {
          if (Ze.origin != Pe || !Ze.data || Ze.data.type !== "authorization_response") return;
          const Fe = Ze.source;
          Fe && Fe.close(), Ze.data.response.error ? Ae(d.fromPayload(Ze.data.response)) : Ve(Ze.data.response), clearTimeout(Ue), window.removeEventListener("message", He, !1), setTimeout(Ne, 2e3);
        }, window.addEventListener("message", He, !1), window.document.body.appendChild(Oe), Oe.setAttribute("src", Se);
      }))(le, this.domainUrl, pe);
      if (se !== ge.state) throw new d("state_mismatch", "Invalid state");
      const be = await this._requestToken(Object.assign(Object.assign({}, ne.authorizationParams), { code_verifier: ue, code: ge.code, grant_type: "authorization_code", redirect_uri: de, timeout: ne.authorizationParams.timeout || this.httpTimeoutMs }), { nonceIn: ce, organization: ae.organization });
      return Object.assign(Object.assign({}, be), { scope: me, oauthTokenScope: be.scope, audience: fe });
    } catch (pe) {
      throw pe.error === "login_required" && this.logout({ openUrl: !1 }), pe;
    }
  }
  async _getTokenUsingRefreshToken(ne) {
    const ae = await this.cacheManager.get(new C({ scope: ne.authorizationParams.scope, audience: ne.authorizationParams.audience || "default", clientId: this.options.clientId }));
    if (!(ae && ae.refresh_token || this.worker)) {
      if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(ne);
      throw new f$1(ne.authorizationParams.audience || "default", ne.authorizationParams.scope);
    }
    const ie = ne.authorizationParams.redirect_uri || this.options.authorizationParams.redirect_uri || window.location.origin, le = typeof ne.timeoutInSeconds == "number" ? 1e3 * ne.timeoutInSeconds : null;
    try {
      const se = await this._requestToken(Object.assign(Object.assign(Object.assign({}, ne.authorizationParams), { grant_type: "refresh_token", refresh_token: ae && ae.refresh_token, redirect_uri: ie }), le && { timeout: le }));
      return Object.assign(Object.assign({}, se), { scope: ne.authorizationParams.scope, oauthTokenScope: se.scope, audience: ne.authorizationParams.audience || "default" });
    } catch (se) {
      if ((se.message.indexOf("Missing Refresh Token") > -1 || se.message && se.message.indexOf("invalid refresh token") > -1) && this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(ne);
      throw se;
    }
  }
  async _saveEntryInCache(ne) {
    const { id_token: ae, decodedToken: ie } = ne, le = e(ne, ["id_token", "decodedToken"]);
    this.userCache.set("@@user@@", { id_token: ae, decodedToken: ie }), await this.cacheManager.setIdToken(this.options.clientId, ne.id_token, ne.decodedToken), await this.cacheManager.set(le);
  }
  async _getIdTokenFromCache() {
    const ne = this.options.authorizationParams.audience || "default", ae = await this.cacheManager.getIdToken(new C({ clientId: this.options.clientId, audience: ne, scope: this.scope })), ie = this.userCache.get("@@user@@");
    return ae && ae.id_token === (ie == null ? void 0 : ie.id_token) ? ie : (this.userCache.set("@@user@@", ae), ae);
  }
  async _getEntryFromCache({ scope: ne, audience: ae, clientId: ie }) {
    const le = await this.cacheManager.get(new C({ scope: ne, audience: ae, clientId: ie }), 60);
    if (le && le.access_token) {
      const { access_token: se, oauthTokenScope: ce, expires_in: ue } = le, de = await this._getIdTokenFromCache();
      return de && Object.assign(Object.assign({ id_token: de.id_token, access_token: se }, ce ? { scope: ce } : null), { expires_in: ue });
    }
  }
  async _requestToken(ne, ae) {
    const { nonceIn: ie, organization: le } = ae || {}, se = await T(Object.assign({ baseUrl: this.domainUrl, client_id: this.options.clientId, auth0Client: this.options.auth0Client, useFormData: this.options.useFormData, timeout: this.httpTimeoutMs }, ne), this.worker), ce = await this._verifyIdToken(se.id_token, ie, le);
    return await this._saveEntryInCache(Object.assign(Object.assign(Object.assign(Object.assign({}, se), { decodedToken: ce, scope: ne.scope, audience: ne.audience || "default" }), se.scope ? { oauthTokenScope: se.scope } : null), { client_id: this.options.clientId })), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, { daysUntilExpire: this.sessionCheckExpiryDays, cookieDomain: this.options.cookieDomain }), this._processOrgHint(le || ce.claims.org_id), Object.assign(Object.assign({}, se), { decodedToken: ce });
  }
}
async function oe(re) {
  const ne = new te(re);
  return await ne.checkSession(), ne;
}
const createAuth0 = () => async (re, ne, ae) => {
  const { appUrl: ie, domain: le, clientId: se, audience: ce, appState: ue } = re, de = {
    domain: le,
    clientId: se,
    appState: ue,
    authorizationParams: {
      audience: ce,
      organization: ne,
      connection: ae,
      redirect_uri: `${ie}/login/callback`
    },
    scope: "profile email",
    useRefreshTokens: !0,
    useRefreshTokensFallback: !0
  };
  return await oe(de);
}, auth0$1 = () => ({
  createAuth0: createAuth0()
}), dirPrefix = "/illustrations/", s3Axios = axios.create({
  headers: {
    timeout: 5e3,
    accept: "application/json"
  },
  data: {}
}), illustration = illustration$1(dirPrefix, s3Axios), soul = soul$1(s3Axios), auth0 = auth0$1();
class Auth0Client {
  constructor(ne) {
    this.client = ne;
  }
  async handleRedirectCallback() {
    if (window.location.search.includes("code=") && window.location.search.includes("state="))
      try {
        await this.client.handleRedirectCallback();
      } catch (ne) {
        throw new Error(`failed to handleRedirectCallback ${ne.message} ${ne.stack}`);
      }
  }
  loginWithRedirect(ne) {
    return this.client.loginWithRedirect(ne);
  }
  isAuthenticated(ne) {
    return this.client.isAuthenticated(ne);
  }
  checkSession(ne) {
    return this.client.checkSession(ne);
  }
  getIdTokenClaims() {
    return this.client.getIdTokenClaims();
  }
  getTokenSilently(ne) {
    return this.client.getTokenSilently(ne);
  }
  getTokenWithPopup(ne) {
    return this.client.getTokenWithPopup(ne);
  }
  getUser() {
    return this.client.getUser();
  }
  logout(ne) {
    return this.client.logout(ne);
  }
}
const CLIENT_APP_CONFIG = "clientAppConfig", SOUL_ERROR_MESSAGE = "soulErrorMessage", actions$2 = {
  init({ commit: re }, ne) {
    re(SET_AUTH0_CONFIG, ne);
  },
  async buildClient({ state: re, getters: ne }, ae) {
    const { organization: ie } = ne.clientAppConfig || {};
    if (!ie)
      throw new Auth0ConfigError("Invalid auth0 config. Missing organization!");
    if (Auth0State.auth0Client && !ae)
      return Auth0State.auth0Client;
    if (Auth0State.loading)
      return new Promise((se) => {
        const ce = watch(
          () => Auth0State.loading,
          (ue) => {
            ue || (ce(), se(Auth0State.auth0Client));
          }
        );
      });
    Auth0State.loading = !0;
    const le = await auth0.createAuth0(
      re.config,
      ie,
      ae && ae.connection || void 0
    );
    return Auth0State.auth0Client = new Auth0Client(le), Auth0State.loading = !1, Auth0State.auth0Client;
  },
  async getRemoteClientAppConfig({ state: re, commit: ne, getters: ae }, ie) {
    const le = re.config && re.config.appHost, se = re.config && re.config.appEnv, ce = ie && ie.refresh;
    try {
      const ue = ae.clientAppConfig;
      if (ue && !ce)
        return ue;
      const de = soul(se);
      if (await de.isAuth0EnabledWithHostname(le)) {
        const fe = await de.getRemoteClientAppConfigByHostname(le);
        return ne(SET_CLIENT_APP_CONFIG, fe), localStorage.setItem(CLIENT_APP_CONFIG, JSON.stringify(fe)), fe;
      }
    } catch (ue) {
      localStorage.setItem(SOUL_ERROR_MESSAGE, ue.message), console.error(ue.message);
    }
    return null;
  }
}, USER = "user", DEVICE_OPTIONS = "deviceOptions", ERROR_ALERT_MESSAGE = "errorAlertMessage", ERROR_MESSAGE$4 = "errorMessage", resetSessionImpl = async ({ commit: re }) => {
  re(RESET_SESSION), localStorage.removeItem(USER), localStorage.removeItem(SOUL_ERROR_MESSAGE);
}, logoutImpl = async (re, { commit: ne, rootGetters: ae }, ie, le) => {
  const { appUrl: se } = ae["auth0/config"], ce = ae["auth0/enabled"];
  ne(RESET_SESSION), localStorage.removeItem(USER), localStorage.removeItem(SOUL_ERROR_MESSAGE), localStorage.removeItem(DEVICE_OPTIONS), ce ? ie ? await re.logout({
    logoutParams: {
      returnTo: `${se}/login`,
      federated: !!ie
    }
  }) : window.location.href = `${se}/login` : le && await le("session/logout");
}, actions$1 = {
  async login({ commit: re }, ne) {
    try {
      const ae = await this.dispatch("auth0/buildClient", ne);
      re(RESET_SESSION), await ae.loginWithRedirect();
    } catch (ae) {
      throw new Auth0LoginError(`Fail to complete login: ${ae.message}`);
    }
  },
  async handleRedirectCallback({ state: re, commit: ne, rootGetters: ae }) {
    try {
      const ie = await this.dispatch("auth0/buildClient");
      if (await ie.handleRedirectCallback(), await ie.isAuthenticated()) {
        const se = await ie.getUser(), { domain: ce } = ae["auth0/config"], ue = parseUser(se, ce, re.userGroupAllowList);
        localStorage.setItem(USER, ue.serialise()), ne(SET_USER, ue);
        const de = await ie.getTokenSilently();
        ne(SET_TOKEN, de), this._actions["session/auth0LoginCallback"] && await this.dispatch("session/auth0LoginCallback"), localStorage.removeItem(ERROR_ALERT_MESSAGE);
      } else
        localStorage.setItem(
          ERROR_ALERT_MESSAGE,
          "failed to get auth0 token because it is not authenticated"
        );
    } catch (ie) {
      throw new Auth0RedirectCallbackError(`Fail to handleRedirectCallback: ${ie.message}`);
    }
  },
  async isLoggedIn({ getters: re, rootGetters: ne }, ae) {
    if (!ne["auth0/clientAppConfig"])
      return !1;
    try {
      const se = await (await this.dispatch("auth0/buildClient")).isAuthenticated();
      return (ae && ae.auth0Only || re.isLoggedIn) && se;
    } catch (le) {
      throw new Auth0LoginError(`Fail to check isLoggedIn: ${le.message}`);
    }
  },
  async getUser({ rootGetters: re }) {
    try {
      const ne = await this.dispatch("auth0/buildClient");
      return re["auth0/enabled"] ? await ne.getUser() : re["session/getToken"];
    } catch (ne) {
      throw new Auth0LoginError(`Fail to getUser: ${ne.message}`);
    }
  },
  async getToken({ state: re, commit: ne, getters: ae, rootGetters: ie }) {
    if (!ie["auth0/enabled"])
      return ie["session/getToken"];
    if (!ae.isLoggedIn)
      return null;
    const se = /* @__PURE__ */ new Date();
    if (!ae.isTokenExpiredByDate(se))
      return re.token;
    let ce;
    try {
      ce = await this.dispatch("auth0/buildClient");
      const ue = await ce.getTokenSilently();
      if (ue)
        return ne(SET_TOKEN, ue), localStorage.removeItem(ERROR_MESSAGE$4), ue;
    } catch (ue) {
      localStorage.setItem(ERROR_MESSAGE$4, `failed to get auth0 token because ${ue.message}`);
      const de = this._actions["session/logout"] ? this.dispatch : null;
      ce && await logoutImpl(ce, { commit: ne, rootGetters: ie }, !1, de);
    }
    return null;
  },
  async resetSession({ commit: re }) {
    resetSessionImpl({ commit: re });
  },
  async logout({ commit: re, rootGetters: ne }, ae) {
    const ie = ne["auth0/enabled"], le = ne["auth0/clientAppConfig"], se = le && le.promptOnLoginEnabled || !1;
    let ce = ae && ae.federated;
    ie && !ce && (se ? ce = localStorage.getItem(DEVICE_OPTIONS) === "shared-device" : ce = (await this.dispatch("auth0/getRemoteClientAppConfig", {
      refresh: !0
    })).sharedDeviceEnabled);
    try {
      const ue = await this.dispatch("auth0/buildClient"), de = this._actions["session/logout"] ? this.dispatch : null;
      await logoutImpl(ue, { commit: re, rootGetters: ne }, ce, de);
    } catch (ue) {
      throw new Auth0LogoutError(`Fail to complete logout: ${ue.message}`);
    }
  }
}, _export_sfc = (re, ne) => {
  const ae = re.__vccOpts || re;
  for (const [ie, le] of ne)
    ae[ie] = le;
  return ae;
}, _sfc_main$_ = {
  name: "CSBase",
  data() {
    return {
      loading: !1
    };
  },
  methods: {
    setDialogIsShown(re) {
      this.$store.commit(CS_APPEARANCE_SET_DIALOG_IS_SHOWN, re);
    },
    showSuccessAlert(re, ne, ae) {
      this.showAlert("success", re, ne, ae);
    },
    showInfoAlert(re, ne, ae) {
      this.showAlert("info", re, ne, ae);
    },
    showWarningAlert(re, ne, ae) {
      this.showAlert("warning", re, ne, ae);
    },
    showErrorAlert(re, ne, ae) {
      this.showAlert("error", re, ne, ae);
    },
    showAlert(re, ne, ae, ie) {
      this.$store.commit(CS_APPEARANCE_SET_ALERT, {
        type: re,
        message: ne,
        onDialogOnly: !!ae,
        href: ie == null ? void 0 : ie.href,
        func: ie == null ? void 0 : ie.func
      });
    },
    clearAlert() {
      this.$store.commit(CS_APPEARANCE_RESET_ALERT);
    },
    showErrorResponseAlert(re, ne) {
      let ae = re.message;
      const ie = JSON.parse(JSON.stringify(re));
      ie.response && ie.response.data && (ie.response.data.message ? ae = `Error: ${ie.response.data.message}` : ie.response.data.error && (ae = `Error: ${ie.response.data.error}`)), this.showErrorAlert(ae, ne);
    },
    setLoading(re) {
      this.loading = re, re ? this.$store.commit(CS_APPEARANCE_SET_PROGRESS_CURSOR) : this.$store.commit(CS_APPEARANCE_SET_DEFAULT_CURSOR);
    },
    isLoading() {
      return this.loading;
    },
    clearLoading() {
      this.setLoading(!1);
    },
    setViewTitle(re) {
      this.$store.commit(CS_APPEARANCE_SET_VIEW_TITLE, re);
    },
    setShowSideNav(re) {
      this.$store.commit(CS_APPEARANCE_SET_SIDE_NAV, !!re);
    }
  }
};
function _sfc_render$_(re, ne, ae, ie, le, se) {
  return openBlock(), createElementBlock("div");
}
const CSBase = /* @__PURE__ */ _export_sfc(_sfc_main$_, [["render", _sfc_render$_]]), IN_BROWSER = typeof window < "u", SUPPORTS_INTERSECTION = IN_BROWSER && "IntersectionObserver" in window, SUPPORTS_EYE_DROPPER = IN_BROWSER && "EyeDropper" in window;
function _classPrivateFieldInitSpec(re, ne, ae) {
  _checkPrivateRedeclaration(re, ne), ne.set(re, ae);
}
function _checkPrivateRedeclaration(re, ne) {
  if (ne.has(re)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function _classPrivateFieldSet(re, ne, ae) {
  return re.set(_assertClassBrand(re, ne), ae), ae;
}
function _classPrivateFieldGet(re, ne) {
  return re.get(_assertClassBrand(re, ne));
}
function _assertClassBrand(re, ne, ae) {
  if (typeof re == "function" ? re === ne : re.has(ne)) return arguments.length < 3 ? ne : ae;
  throw new TypeError("Private element is not present on this object");
}
function getNestedValue(re, ne, ae) {
  const ie = ne.length - 1;
  if (ie < 0) return re === void 0 ? ae : re;
  for (let le = 0; le < ie; le++) {
    if (re == null)
      return ae;
    re = re[ne[le]];
  }
  return re == null || re[ne[ie]] === void 0 ? ae : re[ne[ie]];
}
function deepEqual(re, ne) {
  if (re === ne) return !0;
  if (re instanceof Date && ne instanceof Date && re.getTime() !== ne.getTime() || re !== Object(re) || ne !== Object(ne))
    return !1;
  const ae = Object.keys(re);
  return ae.length !== Object.keys(ne).length ? !1 : ae.every((ie) => deepEqual(re[ie], ne[ie]));
}
function getObjectValueByPath(re, ne, ae) {
  return re == null || !ne || typeof ne != "string" ? ae : re[ne] !== void 0 ? re[ne] : (ne = ne.replace(/\[(\w+)\]/g, ".$1"), ne = ne.replace(/^\./, ""), getNestedValue(re, ne.split("."), ae));
}
function getPropertyFromItem(re, ne, ae) {
  if (ne === !0) return re === void 0 ? ae : re;
  if (ne == null || typeof ne == "boolean") return ae;
  if (re !== Object(re)) {
    if (typeof ne != "function") return ae;
    const le = ne(re, ae);
    return typeof le > "u" ? ae : le;
  }
  if (typeof ne == "string") return getObjectValueByPath(re, ne, ae);
  if (Array.isArray(ne)) return getNestedValue(re, ne, ae);
  if (typeof ne != "function") return ae;
  const ie = ne(re, ae);
  return typeof ie > "u" ? ae : ie;
}
function createRange(re) {
  let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return Array.from({
    length: re
  }, (ae, ie) => ne + ie);
}
function convertToUnit(re) {
  let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "px";
  if (re == null || re === "")
    return;
  const ae = Number(re);
  return isNaN(ae) ? String(re) : isFinite(ae) ? `${ae}${ne}` : void 0;
}
function isObject$8(re) {
  return re !== null && typeof re == "object" && !Array.isArray(re);
}
function isPlainObject$1(re) {
  let ne;
  return re !== null && typeof re == "object" && ((ne = Object.getPrototypeOf(re)) === Object.prototype || ne === null);
}
function refElement(re) {
  if (re && "$el" in re) {
    const ne = re.$el;
    return (ne == null ? void 0 : ne.nodeType) === Node.TEXT_NODE ? ne.nextElementSibling : ne;
  }
  return re;
}
const keyCodes = Object.freeze({
  enter: 13,
  tab: 9,
  delete: 46,
  esc: 27,
  space: 32,
  up: 38,
  down: 40,
  left: 37,
  right: 39,
  end: 35,
  home: 36,
  del: 46,
  backspace: 8,
  insert: 45,
  pageup: 33,
  pagedown: 34,
  shift: 16
}), keyValues = Object.freeze({
  enter: "Enter",
  tab: "Tab",
  delete: "Delete",
  esc: "Escape",
  space: "Space",
  up: "ArrowUp",
  down: "ArrowDown",
  left: "ArrowLeft",
  right: "ArrowRight",
  end: "End",
  home: "Home",
  del: "Delete",
  backspace: "Backspace",
  insert: "Insert",
  pageup: "PageUp",
  pagedown: "PageDown",
  shift: "Shift"
});
function keys$4(re) {
  return Object.keys(re);
}
function has(re, ne) {
  return ne.every((ae) => re.hasOwnProperty(ae));
}
function pick(re, ne) {
  const ae = {};
  for (const ie of ne)
    Object.prototype.hasOwnProperty.call(re, ie) && (ae[ie] = re[ie]);
  return ae;
}
function pickWithRest(re, ne, ae) {
  const ie = /* @__PURE__ */ Object.create(null), le = /* @__PURE__ */ Object.create(null);
  for (const se in re)
    ne.some((ce) => ce instanceof RegExp ? ce.test(se) : ce === se) && !(ae != null && ae.some((ce) => ce === se)) ? ie[se] = re[se] : le[se] = re[se];
  return [ie, le];
}
function omit(re, ne) {
  const ae = {
    ...re
  };
  return ne.forEach((ie) => delete ae[ie]), ae;
}
const onRE = /^on[^a-z]/, isOn = (re) => onRE.test(re), bubblingEvents = ["onAfterscriptexecute", "onAnimationcancel", "onAnimationend", "onAnimationiteration", "onAnimationstart", "onAuxclick", "onBeforeinput", "onBeforescriptexecute", "onChange", "onClick", "onCompositionend", "onCompositionstart", "onCompositionupdate", "onContextmenu", "onCopy", "onCut", "onDblclick", "onFocusin", "onFocusout", "onFullscreenchange", "onFullscreenerror", "onGesturechange", "onGestureend", "onGesturestart", "onGotpointercapture", "onInput", "onKeydown", "onKeypress", "onKeyup", "onLostpointercapture", "onMousedown", "onMousemove", "onMouseout", "onMouseover", "onMouseup", "onMousewheel", "onPaste", "onPointercancel", "onPointerdown", "onPointerenter", "onPointerleave", "onPointermove", "onPointerout", "onPointerover", "onPointerup", "onReset", "onSelect", "onSubmit", "onTouchcancel", "onTouchend", "onTouchmove", "onTouchstart", "onTransitioncancel", "onTransitionend", "onTransitionrun", "onTransitionstart", "onWheel"], compositionIgnoreKeys = ["ArrowUp", "ArrowDown", "ArrowRight", "ArrowLeft", "Enter", "Escape", "Tab", " "];
function isComposingIgnoreKey(re) {
  return re.isComposing && compositionIgnoreKeys.includes(re.key);
}
function filterInputAttrs(re) {
  const [ne, ae] = pickWithRest(re, [onRE]), ie = omit(ne, bubblingEvents), [le, se] = pickWithRest(ae, ["class", "style", "id", /^data-/]);
  return Object.assign(le, ne), Object.assign(se, ie), [le, se];
}
function wrapInArray(re) {
  return re == null ? [] : Array.isArray(re) ? re : [re];
}
function debounce(re, ne) {
  let ae = 0;
  const ie = function() {
    for (var le = arguments.length, se = new Array(le), ce = 0; ce < le; ce++)
      se[ce] = arguments[ce];
    clearTimeout(ae), ae = setTimeout(() => re(...se), unref(ne));
  };
  return ie.clear = () => {
    clearTimeout(ae);
  }, ie.immediate = re, ie;
}
function clamp(re) {
  let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, ae = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  return Math.max(ne, Math.min(ae, re));
}
function getDecimals(re) {
  const ne = re.toString().trim();
  return ne.includes(".") ? ne.length - ne.indexOf(".") - 1 : 0;
}
function padEnd(re, ne) {
  let ae = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0";
  return re + ae.repeat(Math.max(0, ne - re.length));
}
function chunk(re) {
  let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  const ae = [];
  let ie = 0;
  for (; ie < re.length; )
    ae.push(re.substr(ie, ne)), ie += ne;
  return ae;
}
function humanReadableFileSize(re) {
  let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e3;
  if (re < ne)
    return `${re} B`;
  const ae = ne === 1024 ? ["Ki", "Mi", "Gi"] : ["k", "M", "G"];
  let ie = -1;
  for (; Math.abs(re) >= ne && ie < ae.length - 1; )
    re /= ne, ++ie;
  return `${re.toFixed(1)} ${ae[ie]}B`;
}
function mergeDeep() {
  let re = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, ae = arguments.length > 2 ? arguments[2] : void 0;
  const ie = {};
  for (const le in re)
    ie[le] = re[le];
  for (const le in ne) {
    const se = re[le], ce = ne[le];
    if (isPlainObject$1(se) && isPlainObject$1(ce)) {
      ie[le] = mergeDeep(se, ce, ae);
      continue;
    }
    if (ae && Array.isArray(se) && Array.isArray(ce)) {
      ie[le] = ae(se, ce);
      continue;
    }
    ie[le] = ce;
  }
  return ie;
}
function flattenFragments(re) {
  return re.map((ne) => ne.type === Fragment ? flattenFragments(ne.children) : ne).flat();
}
function toKebabCase() {
  let re = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  if (toKebabCase.cache.has(re)) return toKebabCase.cache.get(re);
  const ne = re.replace(/[^a-z]/gi, "-").replace(/\B([A-Z])/g, "-$1").toLowerCase();
  return toKebabCase.cache.set(re, ne), ne;
}
toKebabCase.cache = /* @__PURE__ */ new Map();
function findChildrenWithProvide(re, ne) {
  if (!ne || typeof ne != "object") return [];
  if (Array.isArray(ne))
    return ne.map((ae) => findChildrenWithProvide(re, ae)).flat(1);
  if (ne.suspense)
    return findChildrenWithProvide(re, ne.ssContent);
  if (Array.isArray(ne.children))
    return ne.children.map((ae) => findChildrenWithProvide(re, ae)).flat(1);
  if (ne.component) {
    if (Object.getOwnPropertySymbols(ne.component.provides).includes(re))
      return [ne.component];
    if (ne.component.subTree)
      return findChildrenWithProvide(re, ne.component.subTree).flat(1);
  }
  return [];
}
var _arr = /* @__PURE__ */ new WeakMap(), _pointer = /* @__PURE__ */ new WeakMap();
class CircularBuffer {
  constructor(ne) {
    _classPrivateFieldInitSpec(this, _arr, []), _classPrivateFieldInitSpec(this, _pointer, 0), this.size = ne;
  }
  push(ne) {
    _classPrivateFieldGet(_arr, this)[_classPrivateFieldGet(_pointer, this)] = ne, _classPrivateFieldSet(_pointer, this, (_classPrivateFieldGet(_pointer, this) + 1) % this.size);
  }
  values() {
    return _classPrivateFieldGet(_arr, this).slice(_classPrivateFieldGet(_pointer, this)).concat(_classPrivateFieldGet(_arr, this).slice(0, _classPrivateFieldGet(_pointer, this)));
  }
}
function getEventCoordinates(re) {
  return "touches" in re ? {
    clientX: re.touches[0].clientX,
    clientY: re.touches[0].clientY
  } : {
    clientX: re.clientX,
    clientY: re.clientY
  };
}
function destructComputed(re) {
  const ne = reactive({}), ae = computed(re);
  return watchEffect(() => {
    for (const ie in ae.value)
      ne[ie] = ae.value[ie];
  }, {
    flush: "sync"
  }), toRefs(ne);
}
function includes$1(re, ne) {
  return re.includes(ne);
}
function eventName(re) {
  return re[2].toLowerCase() + re.slice(3);
}
const EventProp = () => [Function, Array];
function hasEvent(re, ne) {
  return ne = "on" + capitalize$1(ne), !!(re[ne] || re[`${ne}Once`] || re[`${ne}Capture`] || re[`${ne}OnceCapture`] || re[`${ne}CaptureOnce`]);
}
function callEvent(re) {
  for (var ne = arguments.length, ae = new Array(ne > 1 ? ne - 1 : 0), ie = 1; ie < ne; ie++)
    ae[ie - 1] = arguments[ie];
  if (Array.isArray(re))
    for (const le of re)
      le(...ae);
  else typeof re == "function" && re(...ae);
}
function focusableChildren(re) {
  let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  const ae = ["button", "[href]", 'input:not([type="hidden"])', "select", "textarea", "[tabindex]"].map((ie) => `${ie}${ne ? ':not([tabindex="-1"])' : ""}:not([disabled])`).join(", ");
  return [...re.querySelectorAll(ae)];
}
function getNextElement(re, ne, ae) {
  let ie, le = re.indexOf(document.activeElement);
  const se = ne === "next" ? 1 : -1;
  do
    le += se, ie = re[le];
  while ((!ie || ie.offsetParent == null || !((ae == null ? void 0 : ae(ie)) ?? !0)) && le < re.length && le >= 0);
  return ie;
}
function focusChild(re, ne) {
  var ie, le, se, ce;
  const ae = focusableChildren(re);
  if (!ne)
    (re === document.activeElement || !re.contains(document.activeElement)) && ((ie = ae[0]) == null || ie.focus());
  else if (ne === "first")
    (le = ae[0]) == null || le.focus();
  else if (ne === "last")
    (se = ae.at(-1)) == null || se.focus();
  else if (typeof ne == "number")
    (ce = ae[ne]) == null || ce.focus();
  else {
    const ue = getNextElement(ae, ne);
    ue ? ue.focus() : focusChild(re, ne === "next" ? "first" : "last");
  }
}
function isEmpty(re) {
  return re == null || typeof re == "string" && re.trim() === "";
}
function noop$2() {
}
function matchesSelector(re, ne) {
  if (!(IN_BROWSER && typeof CSS < "u" && typeof CSS.supports < "u" && CSS.supports(`selector(${ne})`))) return null;
  try {
    return !!re && re.matches(ne);
  } catch {
    return null;
  }
}
function ensureValidVNode(re) {
  return re.some((ne) => isVNode$1(ne) ? ne.type === Comment ? !1 : ne.type !== Fragment || ensureValidVNode(ne.children) : !0) ? re : null;
}
function defer(re, ne) {
  if (!IN_BROWSER || re === 0)
    return ne(), () => {
    };
  const ae = window.setTimeout(ne, re);
  return () => window.clearTimeout(ae);
}
function isClickInsideElement(re, ne) {
  const ae = re.clientX, ie = re.clientY, le = ne.getBoundingClientRect(), se = le.left, ce = le.top, ue = le.right, de = le.bottom;
  return ae >= se && ae <= ue && ie >= ce && ie <= de;
}
function templateRef() {
  const re = shallowRef(), ne = (ae) => {
    re.value = ae;
  };
  return Object.defineProperty(ne, "value", {
    enumerable: !0,
    get: () => re.value,
    set: (ae) => re.value = ae
  }), Object.defineProperty(ne, "el", {
    enumerable: !0,
    get: () => refElement(re.value)
  }), ne;
}
function checkPrintable(re) {
  const ne = re.key.length === 1, ae = !re.ctrlKey && !re.metaKey && !re.altKey;
  return ne && ae;
}
function isPrimitive$1(re) {
  return typeof re == "string" || typeof re == "number" || typeof re == "boolean" || typeof re == "bigint";
}
const block = ["top", "bottom"], inline = ["start", "end", "left", "right"];
function parseAnchor(re, ne) {
  let [ae, ie] = re.split(" ");
  return ie || (ie = includes$1(block, ae) ? "start" : includes$1(inline, ae) ? "top" : "center"), {
    side: toPhysical(ae, ne),
    align: toPhysical(ie, ne)
  };
}
function toPhysical(re, ne) {
  return re === "start" ? ne ? "right" : "left" : re === "end" ? ne ? "left" : "right" : re;
}
function flipSide(re) {
  return {
    side: {
      center: "center",
      top: "bottom",
      bottom: "top",
      left: "right",
      right: "left"
    }[re.side],
    align: re.align
  };
}
function flipAlign(re) {
  return {
    side: re.side,
    align: {
      center: "center",
      top: "bottom",
      bottom: "top",
      left: "right",
      right: "left"
    }[re.align]
  };
}
function flipCorner(re) {
  return {
    side: re.align,
    align: re.side
  };
}
function getAxis(re) {
  return includes$1(block, re.side) ? "y" : "x";
}
class Box {
  constructor(ne) {
    let {
      x: ae,
      y: ie,
      width: le,
      height: se
    } = ne;
    this.x = ae, this.y = ie, this.width = le, this.height = se;
  }
  get top() {
    return this.y;
  }
  get bottom() {
    return this.y + this.height;
  }
  get left() {
    return this.x;
  }
  get right() {
    return this.x + this.width;
  }
}
function getOverflow(re, ne) {
  return {
    x: {
      before: Math.max(0, ne.left - re.left),
      after: Math.max(0, re.right - ne.right)
    },
    y: {
      before: Math.max(0, ne.top - re.top),
      after: Math.max(0, re.bottom - ne.bottom)
    }
  };
}
function getTargetBox(re) {
  return Array.isArray(re) ? new Box({
    x: re[0],
    y: re[1],
    width: 0,
    height: 0
  }) : re.getBoundingClientRect();
}
function nullifyTransforms(re) {
  const ne = re.getBoundingClientRect(), ae = getComputedStyle(re), ie = ae.transform;
  if (ie) {
    let le, se, ce, ue, de;
    if (ie.startsWith("matrix3d("))
      le = ie.slice(9, -1).split(/, /), se = Number(le[0]), ce = Number(le[5]), ue = Number(le[12]), de = Number(le[13]);
    else if (ie.startsWith("matrix("))
      le = ie.slice(7, -1).split(/, /), se = Number(le[0]), ce = Number(le[3]), ue = Number(le[4]), de = Number(le[5]);
    else
      return new Box(ne);
    const me = ae.transformOrigin, fe = ne.x - ue - (1 - se) * parseFloat(me), pe = ne.y - de - (1 - ce) * parseFloat(me.slice(me.indexOf(" ") + 1)), ge = se ? ne.width / se : re.offsetWidth + 1, be = ce ? ne.height / ce : re.offsetHeight + 1;
    return new Box({
      x: fe,
      y: pe,
      width: ge,
      height: be
    });
  } else
    return new Box(ne);
}
function animate(re, ne, ae) {
  if (typeof re.animate > "u") return {
    finished: Promise.resolve()
  };
  let ie;
  try {
    ie = re.animate(ne, ae);
  } catch {
    return {
      finished: Promise.resolve()
    };
  }
  return typeof ie.finished > "u" && (ie.finished = new Promise((le) => {
    ie.onfinish = () => {
      le(ie);
    };
  })), ie;
}
const handlers = /* @__PURE__ */ new WeakMap();
function bindProps(re, ne) {
  Object.keys(ne).forEach((ae) => {
    if (isOn(ae)) {
      const ie = eventName(ae), le = handlers.get(re);
      if (ne[ae] == null)
        le == null || le.forEach((se) => {
          const [ce, ue] = se;
          ce === ie && (re.removeEventListener(ie, ue), le.delete(se));
        });
      else if (!le || ![...le].some((se) => se[0] === ie && se[1] === ne[ae])) {
        re.addEventListener(ie, ne[ae]);
        const se = le || /* @__PURE__ */ new Set();
        se.add([ie, ne[ae]]), handlers.has(re) || handlers.set(re, se);
      }
    } else
      ne[ae] == null ? re.removeAttribute(ae) : re.setAttribute(ae, ne[ae]);
  });
}
function unbindProps(re, ne) {
  Object.keys(ne).forEach((ae) => {
    if (isOn(ae)) {
      const ie = eventName(ae), le = handlers.get(re);
      le == null || le.forEach((se) => {
        const [ce, ue] = se;
        ce === ie && (re.removeEventListener(ie, ue), le.delete(se));
      });
    } else
      re.removeAttribute(ae);
  });
}
const mainTRC = 2.4, Rco = 0.2126729, Gco = 0.7151522, Bco = 0.072175, normBG = 0.55, normTXT = 0.58, revTXT = 0.57, revBG = 0.62, blkThrs = 0.03, blkClmp = 1.45, deltaYmin = 5e-4, scaleBoW = 1.25, scaleWoB = 1.25, loConThresh = 0.078, loConFactor = 12.82051282051282, loConOffset = 0.06, loClip = 1e-3;
function APCAcontrast(re, ne) {
  const ae = (re.r / 255) ** mainTRC, ie = (re.g / 255) ** mainTRC, le = (re.b / 255) ** mainTRC, se = (ne.r / 255) ** mainTRC, ce = (ne.g / 255) ** mainTRC, ue = (ne.b / 255) ** mainTRC;
  let de = ae * Rco + ie * Gco + le * Bco, me = se * Rco + ce * Gco + ue * Bco;
  if (de <= blkThrs && (de += (blkThrs - de) ** blkClmp), me <= blkThrs && (me += (blkThrs - me) ** blkClmp), Math.abs(me - de) < deltaYmin) return 0;
  let fe;
  if (me > de) {
    const pe = (me ** normBG - de ** normTXT) * scaleBoW;
    fe = pe < loClip ? 0 : pe < loConThresh ? pe - pe * loConFactor * loConOffset : pe - loConOffset;
  } else {
    const pe = (me ** revBG - de ** revTXT) * scaleWoB;
    fe = pe > -loClip ? 0 : pe > -loConThresh ? pe - pe * loConFactor * loConOffset : pe + loConOffset;
  }
  return fe * 100;
}
function consoleWarn(re) {
  warn$1(`Vuetify: ${re}`);
}
function consoleError(re) {
  warn$1(`Vuetify error: ${re}`);
}
function deprecate$1(re, ne) {
  ne = Array.isArray(ne) ? ne.slice(0, -1).map((ae) => `'${ae}'`).join(", ") + ` or '${ne.at(-1)}'` : `'${ne}'`, warn$1(`[Vuetify UPGRADE] '${re}' is deprecated, use ${ne} instead.`);
}
const srgbReverseMatrix = [[0.4124, 0.3576, 0.1805], [0.2126, 0.7152, 0.0722], [0.0193, 0.1192, 0.9505]], srgbReverseTransform = (re) => re <= 0.04045 ? re / 12.92 : ((re + 0.055) / 1.055) ** 2.4;
function toXYZ(re) {
  let {
    r: ne,
    g: ae,
    b: ie
  } = re;
  const le = [0, 0, 0], se = srgbReverseTransform, ce = srgbReverseMatrix;
  ne = se(ne / 255), ae = se(ae / 255), ie = se(ie / 255);
  for (let ue = 0; ue < 3; ++ue)
    le[ue] = ce[ue][0] * ne + ce[ue][1] * ae + ce[ue][2] * ie;
  return le;
}
function isCssColor(re) {
  return !!re && /^(#|var\(--|(rgb|hsl)a?\()/.test(re);
}
function isParsableColor(re) {
  return isCssColor(re) && !/^((rgb|hsl)a?\()?var\(--/.test(re);
}
const cssColorRe = /^(?<fn>(?:rgb|hsl)a?)\((?<values>.+)\)/, mappers = {
  rgb: (re, ne, ae, ie) => ({
    r: re,
    g: ne,
    b: ae,
    a: ie
  }),
  rgba: (re, ne, ae, ie) => ({
    r: re,
    g: ne,
    b: ae,
    a: ie
  }),
  hsl: (re, ne, ae, ie) => HSLtoRGB({
    h: re,
    s: ne,
    l: ae,
    a: ie
  }),
  hsla: (re, ne, ae, ie) => HSLtoRGB({
    h: re,
    s: ne,
    l: ae,
    a: ie
  }),
  hsv: (re, ne, ae, ie) => HSVtoRGB({
    h: re,
    s: ne,
    v: ae,
    a: ie
  }),
  hsva: (re, ne, ae, ie) => HSVtoRGB({
    h: re,
    s: ne,
    v: ae,
    a: ie
  })
};
function parseColor(re) {
  if (typeof re == "number")
    return (isNaN(re) || re < 0 || re > 16777215) && consoleWarn(`'${re}' is not a valid hex color`), {
      r: (re & 16711680) >> 16,
      g: (re & 65280) >> 8,
      b: re & 255
    };
  if (typeof re == "string" && cssColorRe.test(re)) {
    const {
      groups: ne
    } = re.match(cssColorRe), {
      fn: ae,
      values: ie
    } = ne, le = ie.split(/,\s*/).map((se) => se.endsWith("%") && ["hsl", "hsla", "hsv", "hsva"].includes(ae) ? parseFloat(se) / 100 : parseFloat(se));
    return mappers[ae](...le);
  } else if (typeof re == "string") {
    let ne = re.startsWith("#") ? re.slice(1) : re;
    [3, 4].includes(ne.length) ? ne = ne.split("").map((ie) => ie + ie).join("") : [6, 8].includes(ne.length) || consoleWarn(`'${re}' is not a valid hex(a) color`);
    const ae = parseInt(ne, 16);
    return (isNaN(ae) || ae < 0 || ae > 4294967295) && consoleWarn(`'${re}' is not a valid hex(a) color`), HexToRGB(ne);
  } else if (typeof re == "object") {
    if (has(re, ["r", "g", "b"]))
      return re;
    if (has(re, ["h", "s", "l"]))
      return HSVtoRGB(HSLtoHSV(re));
    if (has(re, ["h", "s", "v"]))
      return HSVtoRGB(re);
  }
  throw new TypeError(`Invalid color: ${re == null ? re : String(re) || re.constructor.name}
Expected #hex, #hexa, rgb(), rgba(), hsl(), hsla(), object or number`);
}
function HSVtoRGB(re) {
  const {
    h: ne,
    s: ae,
    v: ie,
    a: le
  } = re, se = (ue) => {
    const de = (ue + ne / 60) % 6;
    return ie - ie * ae * Math.max(Math.min(de, 4 - de, 1), 0);
  }, ce = [se(5), se(3), se(1)].map((ue) => Math.round(ue * 255));
  return {
    r: ce[0],
    g: ce[1],
    b: ce[2],
    a: le
  };
}
function HSLtoRGB(re) {
  return HSVtoRGB(HSLtoHSV(re));
}
function RGBtoHSV(re) {
  if (!re) return {
    h: 0,
    s: 1,
    v: 1,
    a: 1
  };
  const ne = re.r / 255, ae = re.g / 255, ie = re.b / 255, le = Math.max(ne, ae, ie), se = Math.min(ne, ae, ie);
  let ce = 0;
  le !== se && (le === ne ? ce = 60 * (0 + (ae - ie) / (le - se)) : le === ae ? ce = 60 * (2 + (ie - ne) / (le - se)) : le === ie && (ce = 60 * (4 + (ne - ae) / (le - se)))), ce < 0 && (ce = ce + 360);
  const ue = le === 0 ? 0 : (le - se) / le, de = [ce, ue, le];
  return {
    h: de[0],
    s: de[1],
    v: de[2],
    a: re.a
  };
}
function HSVtoHSL(re) {
  const {
    h: ne,
    s: ae,
    v: ie,
    a: le
  } = re, se = ie - ie * ae / 2, ce = se === 1 || se === 0 ? 0 : (ie - se) / Math.min(se, 1 - se);
  return {
    h: ne,
    s: ce,
    l: se,
    a: le
  };
}
function HSLtoHSV(re) {
  const {
    h: ne,
    s: ae,
    l: ie,
    a: le
  } = re, se = ie + ae * Math.min(ie, 1 - ie), ce = se === 0 ? 0 : 2 - 2 * ie / se;
  return {
    h: ne,
    s: ce,
    v: se,
    a: le
  };
}
function RGBtoCSS(re) {
  let {
    r: ne,
    g: ae,
    b: ie,
    a: le
  } = re;
  return le === void 0 ? `rgb(${ne}, ${ae}, ${ie})` : `rgba(${ne}, ${ae}, ${ie}, ${le})`;
}
function HSVtoCSS(re) {
  return RGBtoCSS(HSVtoRGB(re));
}
function toHex$1(re) {
  const ne = Math.round(re).toString(16);
  return ("00".substr(0, 2 - ne.length) + ne).toUpperCase();
}
function RGBtoHex(re) {
  let {
    r: ne,
    g: ae,
    b: ie,
    a: le
  } = re;
  return `#${[toHex$1(ne), toHex$1(ae), toHex$1(ie), le !== void 0 ? toHex$1(Math.round(le * 255)) : ""].join("")}`;
}
function HexToRGB(re) {
  re = parseHex(re);
  let [ne, ae, ie, le] = chunk(re, 2).map((se) => parseInt(se, 16));
  return le = le === void 0 ? le : le / 255, {
    r: ne,
    g: ae,
    b: ie,
    a: le
  };
}
function HexToHSV(re) {
  const ne = HexToRGB(re);
  return RGBtoHSV(ne);
}
function HSVtoHex(re) {
  return RGBtoHex(HSVtoRGB(re));
}
function parseHex(re) {
  return re.startsWith("#") && (re = re.slice(1)), re = re.replace(/([^0-9a-f])/gi, "F"), (re.length === 3 || re.length === 4) && (re = re.split("").map((ne) => ne + ne).join("")), re.length !== 6 && (re = padEnd(padEnd(re, 6), 8, "F")), re;
}
function getLuma(re) {
  const ne = parseColor(re);
  return toXYZ(ne)[1];
}
function getContrast(re, ne) {
  const ae = getLuma(re), ie = getLuma(ne), le = Math.max(ae, ie), se = Math.min(ae, ie);
  return (le + 0.05) / (se + 0.05);
}
function getForeground(re) {
  const ne = Math.abs(APCAcontrast(parseColor(0), parseColor(re)));
  return Math.abs(APCAcontrast(parseColor(16777215), parseColor(re))) > Math.min(ne, 50) ? "#fff" : "#000";
}
function propsFactory(re, ne) {
  return (ae) => Object.keys(re).reduce((ie, le) => {
    const ce = typeof re[le] == "object" && re[le] != null && !Array.isArray(re[le]) ? re[le] : {
      type: re[le]
    };
    return ae && le in ae ? ie[le] = {
      ...ce,
      default: ae[le]
    } : ie[le] = ce, ne && !ie[le].source && (ie[le].source = ne), ie;
  }, {});
}
const makeComponentProps = propsFactory({
  class: [String, Array, Object],
  style: {
    type: [String, Array, Object],
    default: null
  }
}, "component");
function getCurrentInstance(re, ne) {
  const ae = getCurrentInstance$1();
  if (!ae)
    throw new Error(`[Vuetify] ${re} must be called from inside a setup function`);
  return ae;
}
function getCurrentInstanceName() {
  let re = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "composables";
  const ne = getCurrentInstance(re).type;
  return toKebabCase((ne == null ? void 0 : ne.aliasName) || (ne == null ? void 0 : ne.name));
}
let _uid = 0, _map = /* @__PURE__ */ new WeakMap();
function getUid() {
  const re = getCurrentInstance("getUid");
  if (_map.has(re)) return _map.get(re);
  {
    const ne = _uid++;
    return _map.set(re, ne), ne;
  }
}
getUid.reset = () => {
  _uid = 0, _map = /* @__PURE__ */ new WeakMap();
};
function injectSelf(re) {
  let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getCurrentInstance("injectSelf");
  const {
    provides: ae
  } = ne;
  if (ae && re in ae)
    return ae[re];
}
const DefaultsSymbol = Symbol.for("vuetify:defaults");
function injectDefaults() {
  const re = inject(DefaultsSymbol);
  if (!re) throw new Error("[Vuetify] Could not find defaults instance");
  return re;
}
function provideDefaults(re, ne) {
  const ae = injectDefaults(), ie = ref$1(re), le = computed(() => {
    if (unref(ne == null ? void 0 : ne.disabled)) return ae.value;
    const ce = unref(ne == null ? void 0 : ne.scoped), ue = unref(ne == null ? void 0 : ne.reset), de = unref(ne == null ? void 0 : ne.root);
    if (ie.value == null && !(ce || ue || de)) return ae.value;
    let me = mergeDeep(ie.value, {
      prev: ae.value
    });
    if (ce) return me;
    if (ue || de) {
      const fe = Number(ue || 1 / 0);
      for (let pe = 0; pe <= fe && !(!me || !("prev" in me)); pe++)
        me = me.prev;
      return me && typeof de == "string" && de in me && (me = mergeDeep(mergeDeep(me, {
        prev: me
      }), me[de])), me;
    }
    return me.prev ? mergeDeep(me.prev, me) : me;
  });
  return provide(DefaultsSymbol, le), le;
}
function propIsDefined(re, ne) {
  var ae, ie;
  return typeof ((ae = re.props) == null ? void 0 : ae[ne]) < "u" || typeof ((ie = re.props) == null ? void 0 : ie[toKebabCase(ne)]) < "u";
}
function internalUseDefaults() {
  let re = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ne = arguments.length > 1 ? arguments[1] : void 0, ae = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : injectDefaults();
  const ie = getCurrentInstance("useDefaults");
  if (ne = ne ?? ie.type.name ?? ie.type.__name, !ne)
    throw new Error("[Vuetify] Could not determine component name");
  const le = computed(() => {
    var de;
    return (de = ae.value) == null ? void 0 : de[re._as ?? ne];
  }), se = new Proxy(re, {
    get(de, me) {
      var pe, ge, be, Se, Pe, Ee, Ve;
      const fe = Reflect.get(de, me);
      return me === "class" || me === "style" ? [(pe = le.value) == null ? void 0 : pe[me], fe].filter((Ae) => Ae != null) : typeof me == "string" && !propIsDefined(ie.vnode, me) ? ((ge = le.value) == null ? void 0 : ge[me]) !== void 0 ? (be = le.value) == null ? void 0 : be[me] : ((Pe = (Se = ae.value) == null ? void 0 : Se.global) == null ? void 0 : Pe[me]) !== void 0 ? (Ve = (Ee = ae.value) == null ? void 0 : Ee.global) == null ? void 0 : Ve[me] : fe : fe;
    }
  }), ce = shallowRef();
  watchEffect(() => {
    if (le.value) {
      const de = Object.entries(le.value).filter((me) => {
        let [fe] = me;
        return fe.startsWith(fe[0].toUpperCase());
      });
      ce.value = de.length ? Object.fromEntries(de) : void 0;
    } else
      ce.value = void 0;
  });
  function ue() {
    const de = injectSelf(DefaultsSymbol, ie);
    provide(DefaultsSymbol, computed(() => ce.value ? mergeDeep((de == null ? void 0 : de.value) ?? {}, ce.value) : de == null ? void 0 : de.value));
  }
  return {
    props: se,
    provideSubDefaults: ue
  };
}
function defineComponent(re) {
  if (re._setup = re._setup ?? re.setup, !re.name)
    return consoleWarn("The component is missing an explicit name, unable to generate default prop value"), re;
  if (re._setup) {
    re.props = propsFactory(re.props ?? {}, re.name)();
    const ne = Object.keys(re.props).filter((ae) => ae !== "class" && ae !== "style");
    re.filterProps = function(ie) {
      return pick(ie, ne);
    }, re.props._as = String, re.setup = function(ie, le) {
      const se = injectDefaults();
      if (!se.value) return re._setup(ie, le);
      const {
        props: ce,
        provideSubDefaults: ue
      } = internalUseDefaults(ie, ie._as ?? re.name, se), de = re._setup(ce, le);
      return ue(), de;
    };
  }
  return re;
}
function genericComponent() {
  let re = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
  return (ne) => (re ? defineComponent : defineComponent$1)(ne);
}
function defineFunctionalComponent(re, ne) {
  return ne.props = re, ne;
}
function createSimpleFunctional(re) {
  let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "div", ae = arguments.length > 2 ? arguments[2] : void 0;
  return genericComponent()({
    name: ae ?? capitalize$1(camelize(re.replace(/__/g, "-"))),
    props: {
      tag: {
        type: String,
        default: ne
      },
      ...makeComponentProps()
    },
    setup(ie, le) {
      let {
        slots: se
      } = le;
      return () => {
        var ce;
        return h$1(ie.tag, {
          class: [re, ie.class],
          style: ie.style
        }, (ce = se.default) == null ? void 0 : ce.call(se));
      };
    }
  });
}
function attachedRoot(re) {
  if (typeof re.getRootNode != "function") {
    for (; re.parentNode; ) re = re.parentNode;
    return re !== document ? null : document;
  }
  const ne = re.getRootNode();
  return ne !== document && ne.getRootNode({
    composed: !0
  }) !== document ? null : ne;
}
const standardEasing = "cubic-bezier(0.4, 0, 0.2, 1)", deceleratedEasing = "cubic-bezier(0.0, 0, 0.2, 1)", acceleratedEasing = "cubic-bezier(0.4, 0, 1, 1)";
function getPrefixedEventHandlers(re, ne, ae) {
  return Object.keys(re).filter((ie) => isOn(ie) && ie.endsWith(ne)).reduce((ie, le) => (ie[le.slice(0, -ne.length)] = (se) => re[le](se, ae(se)), ie), {});
}
function getScrollParent(re) {
  let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  for (; re; ) {
    if (ne ? isPotentiallyScrollable(re) : hasScrollbar(re)) return re;
    re = re.parentElement;
  }
  return document.scrollingElement;
}
function getScrollParents(re, ne) {
  const ae = [];
  if (ne && re && !ne.contains(re)) return ae;
  for (; re && (hasScrollbar(re) && ae.push(re), re !== ne); )
    re = re.parentElement;
  return ae;
}
function hasScrollbar(re) {
  if (!re || re.nodeType !== Node.ELEMENT_NODE) return !1;
  const ne = window.getComputedStyle(re);
  return ne.overflowY === "scroll" || ne.overflowY === "auto" && re.scrollHeight > re.clientHeight;
}
function isPotentiallyScrollable(re) {
  if (!re || re.nodeType !== Node.ELEMENT_NODE) return !1;
  const ne = window.getComputedStyle(re);
  return ["scroll", "auto"].includes(ne.overflowY);
}
function isFixedPosition(re) {
  for (; re; ) {
    if (window.getComputedStyle(re).position === "fixed")
      return !0;
    re = re.offsetParent;
  }
  return !1;
}
function useRender(re) {
  const ne = getCurrentInstance("useRender");
  ne.render = re;
}
const makeBorderProps = propsFactory({
  border: [Boolean, Number, String]
}, "border");
function useBorder(re) {
  let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getCurrentInstanceName();
  return {
    borderClasses: computed(() => {
      const ie = isRef(re) ? re.value : re.border, le = [];
      if (ie === !0 || ie === "")
        le.push(`${ne}--border`);
      else if (typeof ie == "string" || ie === 0)
        for (const se of String(ie).split(" "))
          le.push(`border-${se}`);
      return le;
    })
  };
}
const allowedDensities$1 = [null, "default", "comfortable", "compact"], makeDensityProps = propsFactory({
  density: {
    type: String,
    default: "default",
    validator: (re) => allowedDensities$1.includes(re)
  }
}, "density");
function useDensity(re) {
  let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getCurrentInstanceName();
  return {
    densityClasses: computed(() => `${ne}--density-${re.density}`)
  };
}
const makeElevationProps = propsFactory({
  elevation: {
    type: [Number, String],
    validator(re) {
      const ne = parseInt(re);
      return !isNaN(ne) && ne >= 0 && // Material Design has a maximum elevation of 24
      // https://material.io/design/environment/elevation.html#default-elevations
      ne <= 24;
    }
  }
}, "elevation");
function useElevation(re) {
  return {
    elevationClasses: computed(() => {
      const ae = isRef(re) ? re.value : re.elevation, ie = [];
      return ae == null || ie.push(`elevation-${ae}`), ie;
    })
  };
}
const makeRoundedProps = propsFactory({
  rounded: {
    type: [Boolean, Number, String],
    default: void 0
  },
  tile: Boolean
}, "rounded");
function useRounded(re) {
  let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getCurrentInstanceName();
  return {
    roundedClasses: computed(() => {
      const ie = isRef(re) ? re.value : re.rounded, le = isRef(re) ? re.value : re.tile, se = [];
      if (ie === !0 || ie === "")
        se.push(`${ne}--rounded`);
      else if (typeof ie == "string" || ie === 0)
        for (const ce of String(ie).split(" "))
          se.push(`rounded-${ce}`);
      else (le || ie === !1) && se.push("rounded-0");
      return se;
    })
  };
}
const makeTagProps = propsFactory({
  tag: {
    type: String,
    default: "div"
  }
}, "tag"), ThemeSymbol = Symbol.for("vuetify:theme"), makeThemeProps = propsFactory({
  theme: String
}, "theme");
function provideTheme(re) {
  getCurrentInstance("provideTheme");
  const ne = inject(ThemeSymbol, null);
  if (!ne) throw new Error("Could not find Vuetify theme injection");
  const ae = computed(() => re.theme ?? ne.name.value), ie = computed(() => ne.themes.value[ae.value]), le = computed(() => ne.isDisabled ? void 0 : `v-theme--${ae.value}`), se = {
    ...ne,
    name: ae,
    current: ie,
    themeClasses: le
  };
  return provide(ThemeSymbol, se), se;
}
function useTheme() {
  getCurrentInstance("useTheme");
  const re = inject(ThemeSymbol, null);
  if (!re) throw new Error("Could not find Vuetify theme injection");
  return re;
}
function useColor(re) {
  return destructComputed(() => {
    const ne = [], ae = {};
    if (re.value.background)
      if (isCssColor(re.value.background)) {
        if (ae.backgroundColor = re.value.background, !re.value.text && isParsableColor(re.value.background)) {
          const ie = parseColor(re.value.background);
          if (ie.a == null || ie.a === 1) {
            const le = getForeground(ie);
            ae.color = le, ae.caretColor = le;
          }
        }
      } else
        ne.push(`bg-${re.value.background}`);
    return re.value.text && (isCssColor(re.value.text) ? (ae.color = re.value.text, ae.caretColor = re.value.text) : ne.push(`text-${re.value.text}`)), {
      colorClasses: ne,
      colorStyles: ae
    };
  });
}
function useTextColor(re, ne) {
  const ae = computed(() => ({
    text: isRef(re) ? re.value : ne ? re[ne] : null
  })), {
    colorClasses: ie,
    colorStyles: le
  } = useColor(ae);
  return {
    textColorClasses: ie,
    textColorStyles: le
  };
}
function useBackgroundColor(re, ne) {
  const ae = computed(() => ({
    background: isRef(re) ? re.value : ne ? re[ne] : null
  })), {
    colorClasses: ie,
    colorStyles: le
  } = useColor(ae);
  return {
    backgroundColorClasses: ie,
    backgroundColorStyles: le
  };
}
const allowedVariants$2 = ["elevated", "flat", "tonal", "outlined", "text", "plain"];
function genOverlays(re, ne) {
  return createVNode(Fragment, null, [re && createVNode("span", {
    key: "overlay",
    class: `${ne}__overlay`
  }, null), createVNode("span", {
    key: "underlay",
    class: `${ne}__underlay`
  }, null)]);
}
const makeVariantProps = propsFactory({
  color: String,
  variant: {
    type: String,
    default: "elevated",
    validator: (re) => allowedVariants$2.includes(re)
  }
}, "variant");
function useVariant(re) {
  let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getCurrentInstanceName();
  const ae = computed(() => {
    const {
      variant: se
    } = unref(re);
    return `${ne}--variant-${se}`;
  }), {
    colorClasses: ie,
    colorStyles: le
  } = useColor(computed(() => {
    const {
      variant: se,
      color: ce
    } = unref(re);
    return {
      [["elevated", "flat"].includes(se) ? "background" : "text"]: ce
    };
  }));
  return {
    colorClasses: ie,
    colorStyles: le,
    variantClasses: ae
  };
}
const makeVBtnGroupProps = propsFactory({
  baseColor: String,
  divided: Boolean,
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeElevationProps(),
  ...makeRoundedProps(),
  ...makeTagProps(),
  ...makeThemeProps(),
  ...makeVariantProps()
}, "VBtnGroup"), VBtnGroup = genericComponent()({
  name: "VBtnGroup",
  props: makeVBtnGroupProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      themeClasses: ie
    } = provideTheme(re), {
      densityClasses: le
    } = useDensity(re), {
      borderClasses: se
    } = useBorder(re), {
      elevationClasses: ce
    } = useElevation(re), {
      roundedClasses: ue
    } = useRounded(re);
    provideDefaults({
      VBtn: {
        height: "auto",
        baseColor: toRef(re, "baseColor"),
        color: toRef(re, "color"),
        density: toRef(re, "density"),
        flat: !0,
        variant: toRef(re, "variant")
      }
    }), useRender(() => createVNode(re.tag, {
      class: ["v-btn-group", {
        "v-btn-group--divided": re.divided
      }, ie.value, se.value, le.value, ce.value, ue.value, re.class],
      style: re.style
    }, ae));
  }
});
function useToggleScope(re, ne) {
  let ae;
  function ie() {
    ae = effectScope(), ae.run(() => ne.length ? ne(() => {
      ae == null || ae.stop(), ie();
    }) : ne());
  }
  watch(re, (le) => {
    le && !ae ? ie() : le || (ae == null || ae.stop(), ae = void 0);
  }, {
    immediate: !0
  }), onScopeDispose(() => {
    ae == null || ae.stop();
  });
}
function useProxiedModel(re, ne, ae) {
  let ie = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : (pe) => pe, le = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : (pe) => pe;
  const se = getCurrentInstance("useProxiedModel"), ce = ref$1(re[ne] !== void 0 ? re[ne] : ae), ue = toKebabCase(ne), me = ue !== ne ? computed(() => {
    var pe, ge, be, Se;
    return re[ne], !!(((pe = se.vnode.props) != null && pe.hasOwnProperty(ne) || (ge = se.vnode.props) != null && ge.hasOwnProperty(ue)) && ((be = se.vnode.props) != null && be.hasOwnProperty(`onUpdate:${ne}`) || (Se = se.vnode.props) != null && Se.hasOwnProperty(`onUpdate:${ue}`)));
  }) : computed(() => {
    var pe, ge;
    return re[ne], !!((pe = se.vnode.props) != null && pe.hasOwnProperty(ne) && ((ge = se.vnode.props) != null && ge.hasOwnProperty(`onUpdate:${ne}`)));
  });
  useToggleScope(() => !me.value, () => {
    watch(() => re[ne], (pe) => {
      ce.value = pe;
    });
  });
  const fe = computed({
    get() {
      const pe = re[ne];
      return ie(me.value ? pe : ce.value);
    },
    set(pe) {
      const ge = le(pe), be = toRaw(me.value ? re[ne] : ce.value);
      be === ge || ie(be) === pe || (ce.value = ge, se == null || se.emit(`update:${ne}`, ge));
    }
  });
  return Object.defineProperty(fe, "externalValue", {
    get: () => me.value ? re[ne] : ce.value
  }), fe;
}
const makeGroupProps = propsFactory({
  modelValue: {
    type: null,
    default: void 0
  },
  multiple: Boolean,
  mandatory: [Boolean, String],
  max: Number,
  selectedClass: String,
  disabled: Boolean
}, "group"), makeGroupItemProps = propsFactory({
  value: null,
  disabled: Boolean,
  selectedClass: String
}, "group-item");
function useGroupItem(re, ne) {
  let ae = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  const ie = getCurrentInstance("useGroupItem");
  if (!ie)
    throw new Error("[Vuetify] useGroupItem composable must be used inside a component setup function");
  const le = getUid();
  provide(Symbol.for(`${ne.description}:id`), le);
  const se = inject(ne, null);
  if (!se) {
    if (!ae) return se;
    throw new Error(`[Vuetify] Could not find useGroup injection with symbol ${ne.description}`);
  }
  const ce = toRef(re, "value"), ue = computed(() => !!(se.disabled.value || re.disabled));
  se.register({
    id: le,
    value: ce,
    disabled: ue
  }, ie), onBeforeUnmount(() => {
    se.unregister(le);
  });
  const de = computed(() => se.isSelected(le)), me = computed(() => se.items.value[0].id === le), fe = computed(() => se.items.value[se.items.value.length - 1].id === le), pe = computed(() => de.value && [se.selectedClass.value, re.selectedClass]);
  return watch(de, (ge) => {
    ie.emit("group:selected", {
      value: ge
    });
  }, {
    flush: "sync"
  }), {
    id: le,
    isSelected: de,
    isFirst: me,
    isLast: fe,
    toggle: () => se.select(le, !de.value),
    select: (ge) => se.select(le, ge),
    selectedClass: pe,
    value: ce,
    disabled: ue,
    group: se
  };
}
function useGroup(re, ne) {
  let ae = !1;
  const ie = reactive([]), le = useProxiedModel(re, "modelValue", [], (ge) => ge == null ? [] : getIds(ie, wrapInArray(ge)), (ge) => {
    const be = getValues(ie, ge);
    return re.multiple ? be : be[0];
  }), se = getCurrentInstance("useGroup");
  function ce(ge, be) {
    const Se = ge, Pe = Symbol.for(`${ne.description}:id`), Ve = findChildrenWithProvide(Pe, se == null ? void 0 : se.vnode).indexOf(be);
    unref(Se.value) == null && (Se.value = Ve, Se.useIndexAsValue = !0), Ve > -1 ? ie.splice(Ve, 0, Se) : ie.push(Se);
  }
  function ue(ge) {
    if (ae) return;
    de();
    const be = ie.findIndex((Se) => Se.id === ge);
    ie.splice(be, 1);
  }
  function de() {
    const ge = ie.find((be) => !be.disabled);
    ge && re.mandatory === "force" && !le.value.length && (le.value = [ge.id]);
  }
  onMounted(() => {
    de();
  }), onBeforeUnmount(() => {
    ae = !0;
  }), onUpdated(() => {
    for (let ge = 0; ge < ie.length; ge++)
      ie[ge].useIndexAsValue && (ie[ge].value = ge);
  });
  function me(ge, be) {
    const Se = ie.find((Pe) => Pe.id === ge);
    if (!(be && (Se != null && Se.disabled)))
      if (re.multiple) {
        const Pe = le.value.slice(), Ee = Pe.findIndex((Ae) => Ae === ge), Ve = ~Ee;
        if (be = be ?? !Ve, Ve && re.mandatory && Pe.length <= 1 || !Ve && re.max != null && Pe.length + 1 > re.max) return;
        Ee < 0 && be ? Pe.push(ge) : Ee >= 0 && !be && Pe.splice(Ee, 1), le.value = Pe;
      } else {
        const Pe = le.value.includes(ge);
        if (re.mandatory && Pe) return;
        le.value = be ?? !Pe ? [ge] : [];
      }
  }
  function fe(ge) {
    if (re.multiple && consoleWarn('This method is not supported when using "multiple" prop'), le.value.length) {
      const be = le.value[0], Se = ie.findIndex((Ve) => Ve.id === be);
      let Pe = (Se + ge) % ie.length, Ee = ie[Pe];
      for (; Ee.disabled && Pe !== Se; )
        Pe = (Pe + ge) % ie.length, Ee = ie[Pe];
      if (Ee.disabled) return;
      le.value = [ie[Pe].id];
    } else {
      const be = ie.find((Se) => !Se.disabled);
      be && (le.value = [be.id]);
    }
  }
  const pe = {
    register: ce,
    unregister: ue,
    selected: le,
    select: me,
    disabled: toRef(re, "disabled"),
    prev: () => fe(ie.length - 1),
    next: () => fe(1),
    isSelected: (ge) => le.value.includes(ge),
    selectedClass: computed(() => re.selectedClass),
    items: computed(() => ie),
    getItemIndex: (ge) => getItemIndex(ie, ge)
  };
  return provide(ne, pe), pe;
}
function getItemIndex(re, ne) {
  const ae = getIds(re, [ne]);
  return ae.length ? re.findIndex((ie) => ie.id === ae[0]) : -1;
}
function getIds(re, ne) {
  const ae = [];
  return ne.forEach((ie) => {
    const le = re.find((ce) => deepEqual(ie, ce.value)), se = re[ie];
    (le == null ? void 0 : le.value) != null ? ae.push(le.id) : se != null && ae.push(se.id);
  }), ae;
}
function getValues(re, ne) {
  const ae = [];
  return ne.forEach((ie) => {
    const le = re.findIndex((se) => se.id === ie);
    if (~le) {
      const se = re[le];
      ae.push(se.value != null ? se.value : le);
    }
  }), ae;
}
const VBtnToggleSymbol = Symbol.for("vuetify:v-btn-toggle"), makeVBtnToggleProps = propsFactory({
  ...makeVBtnGroupProps(),
  ...makeGroupProps()
}, "VBtnToggle"), VBtnToggle = genericComponent()({
  name: "VBtnToggle",
  props: makeVBtnToggleProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      isSelected: ie,
      next: le,
      prev: se,
      select: ce,
      selected: ue
    } = useGroup(re, VBtnToggleSymbol);
    return useRender(() => {
      const de = VBtnGroup.filterProps(re);
      return createVNode(VBtnGroup, mergeProps({
        class: ["v-btn-toggle", re.class]
      }, de, {
        style: re.style
      }), {
        default: () => {
          var me;
          return [(me = ae.default) == null ? void 0 : me.call(ae, {
            isSelected: ie,
            next: le,
            prev: se,
            select: ce,
            selected: ue
          })];
        }
      });
    }), {
      next: le,
      prev: se,
      select: ce
    };
  }
}), makeVDefaultsProviderProps = propsFactory({
  defaults: Object,
  disabled: Boolean,
  reset: [Number, String],
  root: [Boolean, String],
  scoped: Boolean
}, "VDefaultsProvider"), VDefaultsProvider = genericComponent(!1)({
  name: "VDefaultsProvider",
  props: makeVDefaultsProviderProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      defaults: ie,
      disabled: le,
      reset: se,
      root: ce,
      scoped: ue
    } = toRefs(re);
    return provideDefaults(ie, {
      reset: se,
      root: ce,
      scoped: ue,
      disabled: le
    }), () => {
      var de;
      return (de = ae.default) == null ? void 0 : de.call(ae);
    };
  }
}), aliases = {
  collapse: "mdi-chevron-up",
  complete: "mdi-check",
  cancel: "mdi-close-circle",
  close: "mdi-close",
  delete: "mdi-close-circle",
  // delete (e.g. v-chip close)
  clear: "mdi-close-circle",
  success: "mdi-check-circle",
  info: "mdi-information",
  warning: "mdi-alert-circle",
  error: "mdi-close-circle",
  prev: "mdi-chevron-left",
  next: "mdi-chevron-right",
  checkboxOn: "mdi-checkbox-marked",
  checkboxOff: "mdi-checkbox-blank-outline",
  checkboxIndeterminate: "mdi-minus-box",
  delimiter: "mdi-circle",
  // for carousel
  sortAsc: "mdi-arrow-up",
  sortDesc: "mdi-arrow-down",
  expand: "mdi-chevron-down",
  menu: "mdi-menu",
  subgroup: "mdi-menu-down",
  dropdown: "mdi-menu-down",
  radioOn: "mdi-radiobox-marked",
  radioOff: "mdi-radiobox-blank",
  edit: "mdi-pencil",
  ratingEmpty: "mdi-star-outline",
  ratingFull: "mdi-star",
  ratingHalf: "mdi-star-half-full",
  loading: "mdi-cached",
  first: "mdi-page-first",
  last: "mdi-page-last",
  unfold: "mdi-unfold-more-horizontal",
  file: "mdi-paperclip",
  plus: "mdi-plus",
  minus: "mdi-minus",
  calendar: "mdi-calendar",
  treeviewCollapse: "mdi-menu-down",
  treeviewExpand: "mdi-menu-right",
  eyeDropper: "mdi-eyedropper",
  upload: "mdi-cloud-upload"
}, mdi = {
  // Not using mergeProps here, functional components merge props by default (?)
  component: (re) => h$1(VClassIcon, {
    ...re,
    class: "mdi"
  })
}, IconValue = [String, Function, Object, Array], IconSymbol = Symbol.for("vuetify:icons"), makeIconProps = propsFactory({
  icon: {
    type: IconValue
  },
  // Could not remove this and use makeTagProps, types complained because it is not required
  tag: {
    type: String,
    required: !0
  }
}, "icon"), VComponentIcon = genericComponent()({
  name: "VComponentIcon",
  props: makeIconProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    return () => {
      const ie = re.icon;
      return createVNode(re.tag, null, {
        default: () => {
          var le;
          return [re.icon ? createVNode(ie, null, null) : (le = ae.default) == null ? void 0 : le.call(ae)];
        }
      });
    };
  }
}), VSvgIcon = defineComponent({
  name: "VSvgIcon",
  inheritAttrs: !1,
  props: makeIconProps(),
  setup(re, ne) {
    let {
      attrs: ae
    } = ne;
    return () => createVNode(re.tag, mergeProps(ae, {
      style: null
    }), {
      default: () => [createVNode("svg", {
        class: "v-icon__svg",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        role: "img",
        "aria-hidden": "true"
      }, [Array.isArray(re.icon) ? re.icon.map((ie) => Array.isArray(ie) ? createVNode("path", {
        d: ie[0],
        "fill-opacity": ie[1]
      }, null) : createVNode("path", {
        d: ie
      }, null)) : createVNode("path", {
        d: re.icon
      }, null)])]
    });
  }
}), VLigatureIcon = defineComponent({
  name: "VLigatureIcon",
  props: makeIconProps(),
  setup(re) {
    return () => createVNode(re.tag, null, {
      default: () => [re.icon]
    });
  }
}), VClassIcon = defineComponent({
  name: "VClassIcon",
  props: makeIconProps(),
  setup(re) {
    return () => createVNode(re.tag, {
      class: re.icon
    }, null);
  }
}), useIcon = (re) => {
  const ne = inject(IconSymbol);
  if (!ne) throw new Error("Missing Vuetify Icons provide!");
  return {
    iconData: computed(() => {
      var de;
      const ie = unref(re);
      if (!ie) return {
        component: VComponentIcon
      };
      let le = ie;
      if (typeof le == "string" && (le = le.trim(), le.startsWith("$") && (le = (de = ne.aliases) == null ? void 0 : de[le.slice(1)])), le || consoleWarn(`Could not find aliased icon "${ie}"`), Array.isArray(le))
        return {
          component: VSvgIcon,
          icon: le
        };
      if (typeof le != "string")
        return {
          component: VComponentIcon,
          icon: le
        };
      const se = Object.keys(ne.sets).find((me) => typeof le == "string" && le.startsWith(`${me}:`)), ce = se ? le.slice(se.length + 1) : le;
      return {
        component: ne.sets[se ?? ne.defaultSet].component,
        icon: ce
      };
    })
  };
}, predefinedSizes = ["x-small", "small", "default", "large", "x-large"], makeSizeProps = propsFactory({
  size: {
    type: [String, Number],
    default: "default"
  }
}, "size");
function useSize(re) {
  let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getCurrentInstanceName();
  return destructComputed(() => {
    let ae, ie;
    return includes$1(predefinedSizes, re.size) ? ae = `${ne}--size-${re.size}` : re.size && (ie = {
      width: convertToUnit(re.size),
      height: convertToUnit(re.size)
    }), {
      sizeClasses: ae,
      sizeStyles: ie
    };
  });
}
const makeVIconProps = propsFactory({
  color: String,
  disabled: Boolean,
  start: Boolean,
  end: Boolean,
  icon: IconValue,
  ...makeComponentProps(),
  ...makeSizeProps(),
  ...makeTagProps({
    tag: "i"
  }),
  ...makeThemeProps()
}, "VIcon"), VIcon = genericComponent()({
  name: "VIcon",
  props: makeVIconProps(),
  setup(re, ne) {
    let {
      attrs: ae,
      slots: ie
    } = ne;
    const le = ref$1(), {
      themeClasses: se
    } = useTheme(), {
      iconData: ce
    } = useIcon(computed(() => le.value || re.icon)), {
      sizeClasses: ue
    } = useSize(re), {
      textColorClasses: de,
      textColorStyles: me
    } = useTextColor(toRef(re, "color"));
    return useRender(() => {
      var ge, be;
      const fe = (ge = ie.default) == null ? void 0 : ge.call(ie);
      fe && (le.value = (be = flattenFragments(fe).filter((Se) => Se.type === Text && Se.children && typeof Se.children == "string")[0]) == null ? void 0 : be.children);
      const pe = !!(ae.onClick || ae.onClickOnce);
      return createVNode(ce.value.component, {
        tag: re.tag,
        icon: ce.value.icon,
        class: ["v-icon", "notranslate", se.value, ue.value, de.value, {
          "v-icon--clickable": pe,
          "v-icon--disabled": re.disabled,
          "v-icon--start": re.start,
          "v-icon--end": re.end
        }, re.class],
        style: [ue.value ? void 0 : {
          fontSize: convertToUnit(re.size),
          height: convertToUnit(re.size),
          width: convertToUnit(re.size)
        }, me.value, re.style],
        role: pe ? "button" : void 0,
        "aria-hidden": !pe,
        tabindex: pe ? re.disabled ? -1 : 0 : void 0
      }, {
        default: () => [fe]
      });
    }), {};
  }
});
function useIntersectionObserver(re, ne) {
  const ae = ref$1(), ie = shallowRef(!1);
  if (SUPPORTS_INTERSECTION) {
    const le = new IntersectionObserver((se) => {
      ie.value = !!se.find((ce) => ce.isIntersecting);
    }, ne);
    onBeforeUnmount(() => {
      le.disconnect();
    }), watch(ae, (se, ce) => {
      ce && (le.unobserve(ce), ie.value = !1), se && le.observe(se);
    }, {
      flush: "post"
    });
  }
  return {
    intersectionRef: ae,
    isIntersecting: ie
  };
}
function useResizeObserver(re) {
  let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "content";
  const ae = templateRef(), ie = ref$1();
  if (IN_BROWSER) {
    const le = new ResizeObserver((se) => {
      re == null || re(se, le), se.length && (ne === "content" ? ie.value = se[0].contentRect : ie.value = se[0].target.getBoundingClientRect());
    });
    onBeforeUnmount(() => {
      le.disconnect();
    }), watch(() => ae.el, (se, ce) => {
      ce && (le.unobserve(ce), ie.value = void 0), se && le.observe(se);
    }, {
      flush: "post"
    });
  }
  return {
    resizeRef: ae,
    contentRect: readonly(ie)
  };
}
const makeVProgressCircularProps = propsFactory({
  bgColor: String,
  color: String,
  indeterminate: [Boolean, String],
  modelValue: {
    type: [Number, String],
    default: 0
  },
  rotate: {
    type: [Number, String],
    default: 0
  },
  width: {
    type: [Number, String],
    default: 4
  },
  ...makeComponentProps(),
  ...makeSizeProps(),
  ...makeTagProps({
    tag: "div"
  }),
  ...makeThemeProps()
}, "VProgressCircular"), VProgressCircular = genericComponent()({
  name: "VProgressCircular",
  props: makeVProgressCircularProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = 20, le = 2 * Math.PI * ie, se = ref$1(), {
      themeClasses: ce
    } = provideTheme(re), {
      sizeClasses: ue,
      sizeStyles: de
    } = useSize(re), {
      textColorClasses: me,
      textColorStyles: fe
    } = useTextColor(toRef(re, "color")), {
      textColorClasses: pe,
      textColorStyles: ge
    } = useTextColor(toRef(re, "bgColor")), {
      intersectionRef: be,
      isIntersecting: Se
    } = useIntersectionObserver(), {
      resizeRef: Pe,
      contentRect: Ee
    } = useResizeObserver(), Ve = computed(() => Math.max(0, Math.min(100, parseFloat(re.modelValue)))), Ae = computed(() => Number(re.width)), Oe = computed(() => de.value ? Number(re.size) : Ee.value ? Ee.value.width : Math.max(Ae.value, 32)), Ne = computed(() => ie / (1 - Ae.value / Oe.value) * 2), He = computed(() => Ae.value / Oe.value * Ne.value), Ue = computed(() => convertToUnit((100 - Ve.value) / 100 * le));
    return watchEffect(() => {
      be.value = se.value, Pe.value = se.value;
    }), useRender(() => createVNode(re.tag, {
      ref: se,
      class: ["v-progress-circular", {
        "v-progress-circular--indeterminate": !!re.indeterminate,
        "v-progress-circular--visible": Se.value,
        "v-progress-circular--disable-shrink": re.indeterminate === "disable-shrink"
      }, ce.value, ue.value, me.value, re.class],
      style: [de.value, fe.value, re.style],
      role: "progressbar",
      "aria-valuemin": "0",
      "aria-valuemax": "100",
      "aria-valuenow": re.indeterminate ? void 0 : Ve.value
    }, {
      default: () => [createVNode("svg", {
        style: {
          transform: `rotate(calc(-90deg + ${Number(re.rotate)}deg))`
        },
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: `0 0 ${Ne.value} ${Ne.value}`
      }, [createVNode("circle", {
        class: ["v-progress-circular__underlay", pe.value],
        style: ge.value,
        fill: "transparent",
        cx: "50%",
        cy: "50%",
        r: ie,
        "stroke-width": He.value,
        "stroke-dasharray": le,
        "stroke-dashoffset": 0
      }, null), createVNode("circle", {
        class: "v-progress-circular__overlay",
        fill: "transparent",
        cx: "50%",
        cy: "50%",
        r: ie,
        "stroke-width": He.value,
        "stroke-dasharray": le,
        "stroke-dashoffset": Ue.value
      }, null)]), ae.default && createVNode("div", {
        class: "v-progress-circular__content"
      }, [ae.default({
        value: Ve.value
      })])]
    })), {};
  }
}), makeDimensionProps = propsFactory({
  height: [Number, String],
  maxHeight: [Number, String],
  maxWidth: [Number, String],
  minHeight: [Number, String],
  minWidth: [Number, String],
  width: [Number, String]
}, "dimension");
function useDimension(re) {
  return {
    dimensionStyles: computed(() => {
      const ae = {}, ie = convertToUnit(re.height), le = convertToUnit(re.maxHeight), se = convertToUnit(re.maxWidth), ce = convertToUnit(re.minHeight), ue = convertToUnit(re.minWidth), de = convertToUnit(re.width);
      return ie != null && (ae.height = ie), le != null && (ae.maxHeight = le), se != null && (ae.maxWidth = se), ce != null && (ae.minHeight = ce), ue != null && (ae.minWidth = ue), de != null && (ae.width = de), ae;
    })
  };
}
const LocaleSymbol = Symbol.for("vuetify:locale");
function useLocale() {
  const re = inject(LocaleSymbol);
  if (!re) throw new Error("[Vuetify] Could not find injected locale instance");
  return re;
}
function provideLocale(re) {
  const ne = inject(LocaleSymbol);
  if (!ne) throw new Error("[Vuetify] Could not find injected locale instance");
  const ae = ne.provide(re), ie = provideRtl(ae, ne.rtl, re), le = {
    ...ae,
    ...ie
  };
  return provide(LocaleSymbol, le), le;
}
function provideRtl(re, ne, ae) {
  const ie = computed(() => ae.rtl ?? ne.value[re.current.value] ?? !1);
  return {
    isRtl: ie,
    rtl: ne,
    rtlClasses: computed(() => `v-locale--is-${ie.value ? "rtl" : "ltr"}`)
  };
}
function useRtl() {
  const re = inject(LocaleSymbol);
  if (!re) throw new Error("[Vuetify] Could not find injected rtl instance");
  return {
    isRtl: re.isRtl,
    rtlClasses: re.rtlClasses
  };
}
const oppositeMap = {
  center: "center",
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, makeLocationProps = propsFactory({
  location: String
}, "location");
function useLocation(re) {
  let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, ae = arguments.length > 2 ? arguments[2] : void 0;
  const {
    isRtl: ie
  } = useRtl();
  return {
    locationStyles: computed(() => {
      if (!re.location) return {};
      const {
        side: se,
        align: ce
      } = parseAnchor(re.location.split(" ").length > 1 ? re.location : `${re.location} center`, ie.value);
      function ue(me) {
        return ae ? ae(me) : 0;
      }
      const de = {};
      return se !== "center" && (ne ? de[oppositeMap[se]] = `calc(100% - ${ue(se)}px)` : de[se] = 0), ce !== "center" ? ne ? de[oppositeMap[ce]] = `calc(100% - ${ue(ce)}px)` : de[ce] = 0 : (se === "center" ? de.top = de.left = "50%" : de[{
        top: "left",
        bottom: "left",
        left: "top",
        right: "top"
      }[se]] = "50%", de.transform = {
        top: "translateX(-50%)",
        bottom: "translateX(-50%)",
        left: "translateY(-50%)",
        right: "translateY(-50%)",
        center: "translate(-50%, -50%)"
      }[se]), de;
    })
  };
}
const makeVProgressLinearProps = propsFactory({
  absolute: Boolean,
  active: {
    type: Boolean,
    default: !0
  },
  bgColor: String,
  bgOpacity: [Number, String],
  bufferValue: {
    type: [Number, String],
    default: 0
  },
  bufferColor: String,
  bufferOpacity: [Number, String],
  clickable: Boolean,
  color: String,
  height: {
    type: [Number, String],
    default: 4
  },
  indeterminate: Boolean,
  max: {
    type: [Number, String],
    default: 100
  },
  modelValue: {
    type: [Number, String],
    default: 0
  },
  opacity: [Number, String],
  reverse: Boolean,
  stream: Boolean,
  striped: Boolean,
  roundedBar: Boolean,
  ...makeComponentProps(),
  ...makeLocationProps({
    location: "top"
  }),
  ...makeRoundedProps(),
  ...makeTagProps(),
  ...makeThemeProps()
}, "VProgressLinear"), VProgressLinear = genericComponent()({
  name: "VProgressLinear",
  props: makeVProgressLinearProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    var Re;
    let {
      slots: ae
    } = ne;
    const ie = useProxiedModel(re, "modelValue"), {
      isRtl: le,
      rtlClasses: se
    } = useRtl(), {
      themeClasses: ce
    } = provideTheme(re), {
      locationStyles: ue
    } = useLocation(re), {
      textColorClasses: de,
      textColorStyles: me
    } = useTextColor(re, "color"), {
      backgroundColorClasses: fe,
      backgroundColorStyles: pe
    } = useBackgroundColor(computed(() => re.bgColor || re.color)), {
      backgroundColorClasses: ge,
      backgroundColorStyles: be
    } = useBackgroundColor(computed(() => re.bufferColor || re.bgColor || re.color)), {
      backgroundColorClasses: Se,
      backgroundColorStyles: Pe
    } = useBackgroundColor(re, "color"), {
      roundedClasses: Ee
    } = useRounded(re), {
      intersectionRef: Ve,
      isIntersecting: Ae
    } = useIntersectionObserver(), Oe = computed(() => parseFloat(re.max)), Ne = computed(() => parseFloat(re.height)), He = computed(() => clamp(parseFloat(re.bufferValue) / Oe.value * 100, 0, 100)), Ue = computed(() => clamp(parseFloat(ie.value) / Oe.value * 100, 0, 100)), Ze = computed(() => le.value !== re.reverse), Fe = computed(() => re.indeterminate ? "fade-transition" : "slide-x-transition"), Ke = IN_BROWSER && ((Re = window.matchMedia) == null ? void 0 : Re.call(window, "(forced-colors: active)").matches);
    function tt(Ce) {
      if (!Ve.value) return;
      const {
        left: _e,
        right: he,
        width: ve
      } = Ve.value.getBoundingClientRect(), xe = Ze.value ? ve - Ce.clientX + (he - ve) : Ce.clientX - _e;
      ie.value = Math.round(xe / ve * Oe.value);
    }
    return useRender(() => createVNode(re.tag, {
      ref: Ve,
      class: ["v-progress-linear", {
        "v-progress-linear--absolute": re.absolute,
        "v-progress-linear--active": re.active && Ae.value,
        "v-progress-linear--reverse": Ze.value,
        "v-progress-linear--rounded": re.rounded,
        "v-progress-linear--rounded-bar": re.roundedBar,
        "v-progress-linear--striped": re.striped
      }, Ee.value, ce.value, se.value, re.class],
      style: [{
        bottom: re.location === "bottom" ? 0 : void 0,
        top: re.location === "top" ? 0 : void 0,
        height: re.active ? convertToUnit(Ne.value) : 0,
        "--v-progress-linear-height": convertToUnit(Ne.value),
        ...re.absolute ? ue.value : {}
      }, re.style],
      role: "progressbar",
      "aria-hidden": re.active ? "false" : "true",
      "aria-valuemin": "0",
      "aria-valuemax": re.max,
      "aria-valuenow": re.indeterminate ? void 0 : Math.min(parseFloat(ie.value), Oe.value),
      onClick: re.clickable && tt
    }, {
      default: () => [re.stream && createVNode("div", {
        key: "stream",
        class: ["v-progress-linear__stream", de.value],
        style: {
          ...me.value,
          [Ze.value ? "left" : "right"]: convertToUnit(-Ne.value),
          borderTop: `${convertToUnit(Ne.value / 2)} dotted`,
          opacity: parseFloat(re.bufferOpacity),
          top: `calc(50% - ${convertToUnit(Ne.value / 4)})`,
          width: convertToUnit(100 - He.value, "%"),
          "--v-progress-linear-stream-to": convertToUnit(Ne.value * (Ze.value ? 1 : -1))
        }
      }, null), createVNode("div", {
        class: ["v-progress-linear__background", Ke ? void 0 : fe.value],
        style: [pe.value, {
          opacity: parseFloat(re.bgOpacity),
          width: re.stream ? 0 : void 0
        }]
      }, null), createVNode("div", {
        class: ["v-progress-linear__buffer", Ke ? void 0 : ge.value],
        style: [be.value, {
          opacity: parseFloat(re.bufferOpacity),
          width: convertToUnit(He.value, "%")
        }]
      }, null), createVNode(Transition, {
        name: Fe.value
      }, {
        default: () => [re.indeterminate ? createVNode("div", {
          class: "v-progress-linear__indeterminate"
        }, [["long", "short"].map((Ce) => createVNode("div", {
          key: Ce,
          class: ["v-progress-linear__indeterminate", Ce, Ke ? void 0 : Se.value],
          style: Pe.value
        }, null))]) : createVNode("div", {
          class: ["v-progress-linear__determinate", Ke ? void 0 : Se.value],
          style: [Pe.value, {
            width: convertToUnit(Ue.value, "%")
          }]
        }, null)]
      }), ae.default && createVNode("div", {
        class: "v-progress-linear__content"
      }, [ae.default({
        value: Ue.value,
        buffer: He.value
      })])]
    })), {};
  }
}), makeLoaderProps = propsFactory({
  loading: [Boolean, String]
}, "loader");
function useLoader(re) {
  let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getCurrentInstanceName();
  return {
    loaderClasses: computed(() => ({
      [`${ne}--loading`]: re.loading
    }))
  };
}
function LoaderSlot(re, ne) {
  var ie;
  let {
    slots: ae
  } = ne;
  return createVNode("div", {
    class: `${re.name}__loader`
  }, [((ie = ae.default) == null ? void 0 : ie.call(ae, {
    color: re.color,
    isActive: re.active
  })) || createVNode(VProgressLinear, {
    absolute: re.absolute,
    active: re.active,
    color: re.color,
    height: "2",
    indeterminate: !0
  }, null)]);
}
const positionValues = ["static", "relative", "fixed", "absolute", "sticky"], makePositionProps = propsFactory({
  position: {
    type: String,
    validator: (
      /* istanbul ignore next */
      (re) => positionValues.includes(re)
    )
  }
}, "position");
function usePosition(re) {
  let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getCurrentInstanceName();
  return {
    positionClasses: computed(() => re.position ? `${ne}--${re.position}` : void 0)
  };
}
function useRoute() {
  const re = getCurrentInstance("useRoute");
  return computed(() => {
    var ne;
    return (ne = re == null ? void 0 : re.proxy) == null ? void 0 : ne.$route;
  });
}
function useRouter() {
  var re, ne;
  return (ne = (re = getCurrentInstance("useRouter")) == null ? void 0 : re.proxy) == null ? void 0 : ne.$router;
}
function useLink(re, ne) {
  var pe, ge;
  const ae = resolveDynamicComponent("RouterLink"), ie = computed(() => !!(re.href || re.to)), le = computed(() => (ie == null ? void 0 : ie.value) || hasEvent(ne, "click") || hasEvent(re, "click"));
  if (typeof ae == "string" || !("useLink" in ae)) {
    const be = toRef(re, "href");
    return {
      isLink: ie,
      isClickable: le,
      href: be,
      linkProps: reactive({
        href: be
      })
    };
  }
  const se = computed(() => ({
    ...re,
    to: toRef(() => re.to || "")
  })), ce = ae.useLink(se.value), ue = computed(() => re.to ? ce : void 0), de = useRoute(), me = computed(() => {
    var be, Se, Pe;
    return ue.value ? re.exact ? de.value ? ((Pe = ue.value.isExactActive) == null ? void 0 : Pe.value) && deepEqual(ue.value.route.value.query, de.value.query) : ((Se = ue.value.isExactActive) == null ? void 0 : Se.value) ?? !1 : ((be = ue.value.isActive) == null ? void 0 : be.value) ?? !1 : !1;
  }), fe = computed(() => {
    var be;
    return re.to ? (be = ue.value) == null ? void 0 : be.route.value.href : re.href;
  });
  return {
    isLink: ie,
    isClickable: le,
    isActive: me,
    route: (pe = ue.value) == null ? void 0 : pe.route,
    navigate: (ge = ue.value) == null ? void 0 : ge.navigate,
    href: fe,
    linkProps: reactive({
      href: fe,
      "aria-current": computed(() => me.value ? "page" : void 0)
    })
  };
}
const makeRouterProps = propsFactory({
  href: String,
  replace: Boolean,
  to: [String, Object],
  exact: Boolean
}, "router");
let inTransition = !1;
function useBackButton(re, ne) {
  let ae = !1, ie, le;
  IN_BROWSER && (re != null && re.beforeEach) && (nextTick$2(() => {
    window.addEventListener("popstate", se), ie = re.beforeEach((ce, ue, de) => {
      inTransition ? ae ? ne(de) : de() : setTimeout(() => ae ? ne(de) : de()), inTransition = !0;
    }), le = re == null ? void 0 : re.afterEach(() => {
      inTransition = !1;
    });
  }), onScopeDispose(() => {
    window.removeEventListener("popstate", se), ie == null || ie(), le == null || le();
  }));
  function se(ce) {
    var ue;
    (ue = ce.state) != null && ue.replaced || (ae = !0, setTimeout(() => ae = !1));
  }
}
function useSelectLink(re, ne) {
  watch(() => {
    var ae;
    return (ae = re.isActive) == null ? void 0 : ae.value;
  }, (ae) => {
    re.isLink.value && ae && ne && nextTick$2(() => {
      ne(!0);
    });
  }, {
    immediate: !0
  });
}
const stopSymbol = Symbol("rippleStop"), DELAY_RIPPLE = 80;
function transform$1(re, ne) {
  re.style.transform = ne, re.style.webkitTransform = ne;
}
function isTouchEvent(re) {
  return re.constructor.name === "TouchEvent";
}
function isKeyboardEvent(re) {
  return re.constructor.name === "KeyboardEvent";
}
const calculate = function(re, ne) {
  var pe;
  let ae = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, ie = 0, le = 0;
  if (!isKeyboardEvent(re)) {
    const ge = ne.getBoundingClientRect(), be = isTouchEvent(re) ? re.touches[re.touches.length - 1] : re;
    ie = be.clientX - ge.left, le = be.clientY - ge.top;
  }
  let se = 0, ce = 0.3;
  (pe = ne._ripple) != null && pe.circle ? (ce = 0.15, se = ne.clientWidth / 2, se = ae.center ? se : se + Math.sqrt((ie - se) ** 2 + (le - se) ** 2) / 4) : se = Math.sqrt(ne.clientWidth ** 2 + ne.clientHeight ** 2) / 2;
  const ue = `${(ne.clientWidth - se * 2) / 2}px`, de = `${(ne.clientHeight - se * 2) / 2}px`, me = ae.center ? ue : `${ie - se}px`, fe = ae.center ? de : `${le - se}px`;
  return {
    radius: se,
    scale: ce,
    x: me,
    y: fe,
    centerX: ue,
    centerY: de
  };
}, ripples = {
  /* eslint-disable max-statements */
  show(re, ne) {
    var be;
    let ae = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!((be = ne == null ? void 0 : ne._ripple) != null && be.enabled))
      return;
    const ie = document.createElement("span"), le = document.createElement("span");
    ie.appendChild(le), ie.className = "v-ripple__container", ae.class && (ie.className += ` ${ae.class}`);
    const {
      radius: se,
      scale: ce,
      x: ue,
      y: de,
      centerX: me,
      centerY: fe
    } = calculate(re, ne, ae), pe = `${se * 2}px`;
    le.className = "v-ripple__animation", le.style.width = pe, le.style.height = pe, ne.appendChild(ie);
    const ge = window.getComputedStyle(ne);
    ge && ge.position === "static" && (ne.style.position = "relative", ne.dataset.previousPosition = "static"), le.classList.add("v-ripple__animation--enter"), le.classList.add("v-ripple__animation--visible"), transform$1(le, `translate(${ue}, ${de}) scale3d(${ce},${ce},${ce})`), le.dataset.activated = String(performance.now()), requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        le.classList.remove("v-ripple__animation--enter"), le.classList.add("v-ripple__animation--in"), transform$1(le, `translate(${me}, ${fe}) scale3d(1,1,1)`);
      });
    });
  },
  hide(re) {
    var se;
    if (!((se = re == null ? void 0 : re._ripple) != null && se.enabled)) return;
    const ne = re.getElementsByClassName("v-ripple__animation");
    if (ne.length === 0) return;
    const ae = ne[ne.length - 1];
    if (ae.dataset.isHiding) return;
    ae.dataset.isHiding = "true";
    const ie = performance.now() - Number(ae.dataset.activated), le = Math.max(250 - ie, 0);
    setTimeout(() => {
      ae.classList.remove("v-ripple__animation--in"), ae.classList.add("v-ripple__animation--out"), setTimeout(() => {
        var ue;
        re.getElementsByClassName("v-ripple__animation").length === 1 && re.dataset.previousPosition && (re.style.position = re.dataset.previousPosition, delete re.dataset.previousPosition), ((ue = ae.parentNode) == null ? void 0 : ue.parentNode) === re && re.removeChild(ae.parentNode);
      }, 300);
    }, le);
  }
};
function isRippleEnabled(re) {
  return typeof re > "u" || !!re;
}
function rippleShow(re) {
  const ne = {}, ae = re.currentTarget;
  if (!(!(ae != null && ae._ripple) || ae._ripple.touched || re[stopSymbol])) {
    if (re[stopSymbol] = !0, isTouchEvent(re))
      ae._ripple.touched = !0, ae._ripple.isTouch = !0;
    else if (ae._ripple.isTouch) return;
    if (ne.center = ae._ripple.centered || isKeyboardEvent(re), ae._ripple.class && (ne.class = ae._ripple.class), isTouchEvent(re)) {
      if (ae._ripple.showTimerCommit) return;
      ae._ripple.showTimerCommit = () => {
        ripples.show(re, ae, ne);
      }, ae._ripple.showTimer = window.setTimeout(() => {
        var ie;
        (ie = ae == null ? void 0 : ae._ripple) != null && ie.showTimerCommit && (ae._ripple.showTimerCommit(), ae._ripple.showTimerCommit = null);
      }, DELAY_RIPPLE);
    } else
      ripples.show(re, ae, ne);
  }
}
function rippleStop(re) {
  re[stopSymbol] = !0;
}
function rippleHide(re) {
  const ne = re.currentTarget;
  if (ne != null && ne._ripple) {
    if (window.clearTimeout(ne._ripple.showTimer), re.type === "touchend" && ne._ripple.showTimerCommit) {
      ne._ripple.showTimerCommit(), ne._ripple.showTimerCommit = null, ne._ripple.showTimer = window.setTimeout(() => {
        rippleHide(re);
      });
      return;
    }
    window.setTimeout(() => {
      ne._ripple && (ne._ripple.touched = !1);
    }), ripples.hide(ne);
  }
}
function rippleCancelShow(re) {
  const ne = re.currentTarget;
  ne != null && ne._ripple && (ne._ripple.showTimerCommit && (ne._ripple.showTimerCommit = null), window.clearTimeout(ne._ripple.showTimer));
}
let keyboardRipple = !1;
function keyboardRippleShow(re) {
  !keyboardRipple && (re.keyCode === keyCodes.enter || re.keyCode === keyCodes.space) && (keyboardRipple = !0, rippleShow(re));
}
function keyboardRippleHide(re) {
  keyboardRipple = !1, rippleHide(re);
}
function focusRippleHide(re) {
  keyboardRipple && (keyboardRipple = !1, rippleHide(re));
}
function updateRipple(re, ne, ae) {
  const {
    value: ie,
    modifiers: le
  } = ne, se = isRippleEnabled(ie);
  if (se || ripples.hide(re), re._ripple = re._ripple ?? {}, re._ripple.enabled = se, re._ripple.centered = le.center, re._ripple.circle = le.circle, isObject$8(ie) && ie.class && (re._ripple.class = ie.class), se && !ae) {
    if (le.stop) {
      re.addEventListener("touchstart", rippleStop, {
        passive: !0
      }), re.addEventListener("mousedown", rippleStop);
      return;
    }
    re.addEventListener("touchstart", rippleShow, {
      passive: !0
    }), re.addEventListener("touchend", rippleHide, {
      passive: !0
    }), re.addEventListener("touchmove", rippleCancelShow, {
      passive: !0
    }), re.addEventListener("touchcancel", rippleHide), re.addEventListener("mousedown", rippleShow), re.addEventListener("mouseup", rippleHide), re.addEventListener("mouseleave", rippleHide), re.addEventListener("keydown", keyboardRippleShow), re.addEventListener("keyup", keyboardRippleHide), re.addEventListener("blur", focusRippleHide), re.addEventListener("dragstart", rippleHide, {
      passive: !0
    });
  } else !se && ae && removeListeners(re);
}
function removeListeners(re) {
  re.removeEventListener("mousedown", rippleShow), re.removeEventListener("touchstart", rippleShow), re.removeEventListener("touchend", rippleHide), re.removeEventListener("touchmove", rippleCancelShow), re.removeEventListener("touchcancel", rippleHide), re.removeEventListener("mouseup", rippleHide), re.removeEventListener("mouseleave", rippleHide), re.removeEventListener("keydown", keyboardRippleShow), re.removeEventListener("keyup", keyboardRippleHide), re.removeEventListener("dragstart", rippleHide), re.removeEventListener("blur", focusRippleHide);
}
function mounted$5(re, ne) {
  updateRipple(re, ne, !1);
}
function unmounted$5(re) {
  delete re._ripple, removeListeners(re);
}
function updated$1(re, ne) {
  if (ne.value === ne.oldValue)
    return;
  const ae = isRippleEnabled(ne.oldValue);
  updateRipple(re, ne, ae);
}
const Ripple = {
  mounted: mounted$5,
  unmounted: unmounted$5,
  updated: updated$1
}, makeVBtnProps = propsFactory({
  active: {
    type: Boolean,
    default: void 0
  },
  activeColor: String,
  baseColor: String,
  symbol: {
    type: null,
    default: VBtnToggleSymbol
  },
  flat: Boolean,
  icon: [Boolean, String, Function, Object],
  prependIcon: IconValue,
  appendIcon: IconValue,
  block: Boolean,
  readonly: Boolean,
  slim: Boolean,
  stacked: Boolean,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  text: {
    type: [String, Number, Boolean],
    default: void 0
  },
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeDimensionProps(),
  ...makeElevationProps(),
  ...makeGroupItemProps(),
  ...makeLoaderProps(),
  ...makeLocationProps(),
  ...makePositionProps(),
  ...makeRoundedProps(),
  ...makeRouterProps(),
  ...makeSizeProps(),
  ...makeTagProps({
    tag: "button"
  }),
  ...makeThemeProps(),
  ...makeVariantProps({
    variant: "elevated"
  })
}, "VBtn"), VBtn = genericComponent()({
  name: "VBtn",
  props: makeVBtnProps(),
  emits: {
    "group:selected": (re) => !0
  },
  setup(re, ne) {
    let {
      attrs: ae,
      slots: ie
    } = ne;
    const {
      themeClasses: le
    } = provideTheme(re), {
      borderClasses: se
    } = useBorder(re), {
      densityClasses: ce
    } = useDensity(re), {
      dimensionStyles: ue
    } = useDimension(re), {
      elevationClasses: de
    } = useElevation(re), {
      loaderClasses: me
    } = useLoader(re), {
      locationStyles: fe
    } = useLocation(re), {
      positionClasses: pe
    } = usePosition(re), {
      roundedClasses: ge
    } = useRounded(re), {
      sizeClasses: be,
      sizeStyles: Se
    } = useSize(re), Pe = useGroupItem(re, re.symbol, !1), Ee = useLink(re, ae), Ve = computed(() => {
      var Re;
      return re.active !== void 0 ? re.active : Ee.isLink.value ? (Re = Ee.isActive) == null ? void 0 : Re.value : Pe == null ? void 0 : Pe.isSelected.value;
    }), Ae = computed(() => Ve.value ? re.activeColor ?? re.color : re.color), Oe = computed(() => {
      var Ce, _e;
      return {
        color: (Pe == null ? void 0 : Pe.isSelected.value) && (!Ee.isLink.value || ((Ce = Ee.isActive) == null ? void 0 : Ce.value)) || !Pe || ((_e = Ee.isActive) == null ? void 0 : _e.value) ? Ae.value ?? re.baseColor : re.baseColor,
        variant: re.variant
      };
    }), {
      colorClasses: Ne,
      colorStyles: He,
      variantClasses: Ue
    } = useVariant(Oe), Ze = computed(() => (Pe == null ? void 0 : Pe.disabled.value) || re.disabled), Fe = computed(() => re.variant === "elevated" && !(re.disabled || re.flat || re.border)), Ke = computed(() => {
      if (!(re.value === void 0 || typeof re.value == "symbol"))
        return Object(re.value) === re.value ? JSON.stringify(re.value, null, 0) : re.value;
    });
    function tt(Re) {
      var Ce;
      Ze.value || Ee.isLink.value && (Re.metaKey || Re.ctrlKey || Re.shiftKey || Re.button !== 0 || ae.target === "_blank") || ((Ce = Ee.navigate) == null || Ce.call(Ee, Re), Pe == null || Pe.toggle());
    }
    return useSelectLink(Ee, Pe == null ? void 0 : Pe.select), useRender(() => {
      const Re = Ee.isLink.value ? "a" : re.tag, Ce = !!(re.prependIcon || ie.prepend), _e = !!(re.appendIcon || ie.append), he = !!(re.icon && re.icon !== !0);
      return withDirectives(createVNode(Re, mergeProps({
        type: Re === "a" ? void 0 : "button",
        class: ["v-btn", Pe == null ? void 0 : Pe.selectedClass.value, {
          "v-btn--active": Ve.value,
          "v-btn--block": re.block,
          "v-btn--disabled": Ze.value,
          "v-btn--elevated": Fe.value,
          "v-btn--flat": re.flat,
          "v-btn--icon": !!re.icon,
          "v-btn--loading": re.loading,
          "v-btn--readonly": re.readonly,
          "v-btn--slim": re.slim,
          "v-btn--stacked": re.stacked
        }, le.value, se.value, Ne.value, ce.value, de.value, me.value, pe.value, ge.value, be.value, Ue.value, re.class],
        style: [He.value, ue.value, fe.value, Se.value, re.style],
        "aria-busy": re.loading ? !0 : void 0,
        disabled: Ze.value || void 0,
        tabindex: re.loading || re.readonly ? -1 : void 0,
        onClick: tt,
        value: Ke.value
      }, Ee.linkProps), {
        default: () => {
          var ve;
          return [genOverlays(!0, "v-btn"), !re.icon && Ce && createVNode("span", {
            key: "prepend",
            class: "v-btn__prepend"
          }, [ie.prepend ? createVNode(VDefaultsProvider, {
            key: "prepend-defaults",
            disabled: !re.prependIcon,
            defaults: {
              VIcon: {
                icon: re.prependIcon
              }
            }
          }, ie.prepend) : createVNode(VIcon, {
            key: "prepend-icon",
            icon: re.prependIcon
          }, null)]), createVNode("span", {
            class: "v-btn__content",
            "data-no-activator": ""
          }, [!ie.default && he ? createVNode(VIcon, {
            key: "content-icon",
            icon: re.icon
          }, null) : createVNode(VDefaultsProvider, {
            key: "content-defaults",
            disabled: !he,
            defaults: {
              VIcon: {
                icon: re.icon
              }
            }
          }, {
            default: () => {
              var xe;
              return [((xe = ie.default) == null ? void 0 : xe.call(ie)) ?? toDisplayString$1(re.text)];
            }
          })]), !re.icon && _e && createVNode("span", {
            key: "append",
            class: "v-btn__append"
          }, [ie.append ? createVNode(VDefaultsProvider, {
            key: "append-defaults",
            disabled: !re.appendIcon,
            defaults: {
              VIcon: {
                icon: re.appendIcon
              }
            }
          }, ie.append) : createVNode(VIcon, {
            key: "append-icon",
            icon: re.appendIcon
          }, null)]), !!re.loading && createVNode("span", {
            key: "loader",
            class: "v-btn__loader"
          }, [((ve = ie.loader) == null ? void 0 : ve.call(ie)) ?? createVNode(VProgressCircular, {
            color: typeof re.loading == "boolean" ? void 0 : re.loading,
            indeterminate: !0,
            width: "2"
          }, null)])];
        }
      }), [[Ripple, !Ze.value && re.ripple, "", {
        center: !!re.icon
      }]]);
    }), {
      group: Pe
    };
  }
}), _sfc_main$Z = {
  name: "CSAlert",
  extends: CSBase,
  props: {
    dialog: { type: Boolean, required: !1 }
  },
  emits: ["close"],
  data() {
    return {
      showSuccess: !1,
      showInfo: !1,
      showWarning: !1,
      showError: !1
    };
  },
  computed: {
    ...mapState({
      alert: (re) => re["cs-appearance"].alert
    }),
    ...mapGetters({
      isAlertClickable: "cs-appearance/isAlertClickable"
    }),
    iconName() {
      return this.showSuccess ? "mdi-check-circle-outline" : this.showInfo ? "mdi-information-outline" : this.showWarning ? "mdi-alert-outline" : this.showError ? "mdi-alert-circle-outline" : "";
    },
    show() {
      return !!(this.showSuccess || this.showInfo || this.showWarning || this.showError);
    },
    classType() {
      var ne;
      const re = (ne = this.alert) == null ? void 0 : ne.type;
      return !this.dialog && this.alert.onDialogOnly ? "" : re ? `cs-alert-${re}` : "";
    },
    clickableAlertMessage() {
      try {
        const { message: re, href: ne, func: ae } = this.alert, ie = this.parseAlertMessage(re, ne, ae);
        return this.validateParsedMessageWithHrefAndFunc(ie, ne, ae), ie;
      } catch (re) {
        return console.error(re), this.showErrorAlert(
          "Please contact Ideagen Complispace Dev Team for the issue",
          this.alert.onDialogOnly
        ), null;
      }
    }
  },
  watch: {
    alert(re) {
      re != null && re.type ? this.showWhich(re.type) : this.hideAll();
    }
  },
  methods: {
    hideAll() {
      this.showSuccess = !1, this.showInfo = !1, this.showWarning = !1, this.showError = !1;
    },
    showWhich(re) {
      !this.dialog && this.alert.onDialogOnly || (this.showSuccess = re === "success", this.showInfo = re === "info", this.showWarning = re === "warning", this.showError = re === "error");
    },
    onCloseErrorAlert() {
      localStorage.removeItem(ERROR_ALERT_MESSAGE);
    },
    onClose() {
      this.showError && this.onCloseErrorAlert(), this.hideAll(), this.$emit("close");
    },
    parseAlertMessage(re, ne, ae) {
      this.validateAmountOfHrefAndFuncTag(re, ne, ae);
      const ie = /(?:<href>(?<isInHref>.+)<\/href>)|(?:<func>(?<isInFunc>.+)<\/func>)|(?<notInHrefOrFunc>(?:(?!<\/?func>|<\/?href>).)+)/g;
      return [...re.matchAll(ie)].map((ce) => {
        const { isInHref: ue, isInFunc: de, notInHrefOrFunc: me } = ce.groups;
        return {
          text: ue || de || me,
          isInHref: !!ue,
          isInFunc: !!de
        };
      });
    },
    validateAmountOfHrefAndFuncTag(re, ne, ae) {
      Assert.isPresent(re, "alert.message");
      const ie = re.split("<href>").length - 1, le = re.split("</href>").length - 1, se = re.split("<func>").length - 1, ce = re.split("</func>").length - 1;
      if (ne && (ie !== le || ie !== 1))
        throw new Error("Invalid amount of <href></href> tags in message");
      if (!ne && (ie !== le || ie > 0))
        throw new Error("alert.href is required when <href></href> tags in message");
      if (ae && (se !== ce || se !== 1))
        throw new Error("Invalid amount of <func></func> tags in message");
      if (!ae && (se !== ce || se > 0))
        throw new Error("alert.func is required when <func></func> tags in message");
    },
    validateParsedMessageWithHrefAndFunc(re, ne, ae) {
      var ue, de;
      const ie = re.filter((me) => me.isInHref === !0), le = re.filter((me) => me.isInFunc === !0), se = (ue = ie == null ? void 0 : ie[0]) == null ? void 0 : ue.text, ce = (de = le == null ? void 0 : le[0]) == null ? void 0 : de.text;
      if (/^\s*$/.test(se) || /^\s*$/.test(ce))
        throw new Error("Messages wrapped in <href> or <func> cannot be whitespaces only");
      if (ne && typeof ne != "string")
        throw new Error("alert.href has to be a string");
      if (ne && !se)
        throw new Error("Missing message wrapped in <href> tags");
      if (ae && typeof ae != "function")
        throw new Error("alert.func has to be a function");
      if (ae && !ce)
        throw new Error("Missing message wrapped in <func> tags");
    }
  }
}, _hoisted_1$K = { class: "cs-alert" }, _hoisted_2$p = {
  key: 0,
  class: "cs-alert-text"
}, _hoisted_3$g = ["href"], _hoisted_4$a = { key: 2 }, _hoisted_5$6 = {
  key: 1,
  class: "cs-alert-text"
}, _hoisted_6$5 = { class: "cs-alert-close" };
function _sfc_render$Z(re, ne, ae, ie, le, se) {
  return openBlock(), createBlock(Transition, { name: "fade" }, {
    default: withCtx(() => [
      withDirectives(createElementVNode("div", _hoisted_1$K, [
        createElementVNode("div", {
          class: normalizeClass(["cs-alert-content", se.classType])
        }, [
          createElementVNode("div", null, [
            createVNode(VIcon, {
              class: "cs-icon cs-alert-sign",
              size: "20px",
              icon: se.iconName
            }, null, 8, ["icon"])
          ]),
          re.isAlertClickable ? (openBlock(), createElementBlock("div", _hoisted_2$p, [
            (openBlock(!0), createElementBlock(Fragment, null, renderList(se.clickableAlertMessage, (ce, ue) => (openBlock(), createElementBlock("div", { key: ue }, [
              ce.isInFunc ? (openBlock(), createElementBlock("a", {
                key: 0,
                id: "func-clickable",
                href: "#",
                onClick: ne[0] || (ne[0] = (...de) => re.alert.func && re.alert.func(...de))
              }, toDisplayString$1(ce.text), 1)) : ce.isInHref ? (openBlock(), createElementBlock("a", {
                key: 1,
                id: "href-clickable",
                href: re.alert.href
              }, toDisplayString$1(ce.text), 9, _hoisted_3$g)) : (openBlock(), createElementBlock("span", _hoisted_4$a, toDisplayString$1(ce.text), 1))
            ]))), 128))
          ])) : (openBlock(), createElementBlock("div", _hoisted_5$6, [
            createElementVNode("span", null, toDisplayString$1(re.alert.message), 1)
          ])),
          createElementVNode("div", null, [
            createElementVNode("div", _hoisted_6$5, [
              createVNode(VBtn, {
                icon: "",
                variant: "plain",
                height: "24px",
                width: "24px",
                onClick: se.onClose
              }, {
                default: withCtx(() => [
                  createVNode(VIcon, {
                    class: "cs-icon",
                    size: "24px",
                    icon: "mdi-close"
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ], 2)
      ], 512), [
        [vShow, se.show]
      ])
    ]),
    _: 1
  });
}
const CSAlert = /* @__PURE__ */ _export_sfc(_sfc_main$Z, [["render", _sfc_render$Z]]), _sfc_main$Y = {
  name: "CSLoader",
  data() {
    return {
      loading: !1
    };
  },
  computed: {
    ...mapState({
      cursor: (re) => re["cs-appearance"].cursor
    })
  },
  watch: {
    cursor(re) {
      switch (re) {
        case "progress":
          this.loading = !0;
          break;
        default:
          this.loading = !1;
          break;
      }
    }
  }
}, _hoisted_1$J = { class: "cs-loader" }, _hoisted_2$o = { key: 0 }, _hoisted_3$f = {
  key: 1,
  class: "cs-loader-bar"
};
function _sfc_render$Y(re, ne, ae, ie, le, se) {
  return openBlock(), createElementBlock("div", _hoisted_1$J, [
    le.loading ? (openBlock(), createElementBlock("div", _hoisted_2$o, [
      createVNode(VProgressLinear, {
        color: "primary",
        indeterminate: ""
      })
    ])) : (openBlock(), createElementBlock("div", _hoisted_3$f))
  ]);
}
const CSLoader = /* @__PURE__ */ _export_sfc(_sfc_main$Y, [["render", _sfc_render$Y], ["__scopeId", "data-v-0140aea7"]]);
class User {
  constructor(ne, ae, ie, le) {
    ne !== void 0 && (this.givenName = ne), ae !== void 0 && (this.surname = ae), ie !== void 0 && (this.email = ie), le !== void 0 && (this.fullName = le), User.validateHeaderProfileUser(this);
  }
  static validateHeaderProfileUser(ne) {
    return ne ? typeof ne != "object" ? (console.warn("user must be an instance of User!"), !1) : "givenName" in ne && typeof ne.givenName != "string" ? (console.warn("givenName must be a string"), !1) : "surname" in ne && typeof ne.surname != "string" ? (console.warn("surname must be a string"), !1) : "email" in ne && typeof ne.email != "string" ? (console.warn("email must be a string"), !1) : "fullName" in ne && typeof ne.fullName != "string" ? (console.warn("fullName must be a string"), !1) : !!["givenName", "surname", "email", "fullName"].some((ie) => ie in ne) : !1;
  }
}
class HeaderProfileActions {
  constructor(ne) {
    ne !== void 0 && (this.logout = ne), HeaderProfileActions.validateHeaderProfileActions(this);
  }
  static validateHeaderProfileActions(ne) {
    return ne ? typeof ne != "object" ? (console.warn("actions must be an object!"), !1) : "logout" in ne && typeof ne.logout.action != "function" ? (console.warn("logout action must be a function!"), !1) : Object.keys(ne).length > 0 && !("logout" in ne) ? (console.warn("actions must contains logout!"), !1) : !0 : !1;
  }
}
class CSHeaderProfileProps {
  constructor(ne, ae) {
    this.setUser(ne), this.setActions(ae);
  }
  setUser(ne) {
    if (ne) {
      if (ne instanceof User) {
        this.user = ne;
        return;
      }
      if (User.validateHeaderProfileUser(ne)) {
        this.user = new User(ne.givenName, ne.surname, ne.email);
        return;
      }
      console.error("user must be an instance of User!");
    }
  }
  setActions(ne) {
    if (ne) {
      if (ne instanceof HeaderProfileActions) {
        this.actions = ne;
        return;
      }
      if (HeaderProfileActions.validateHeaderProfileActions(ne)) {
        this.actions = new HeaderProfileActions(ne.logout);
        return;
      }
      console.error("action must be an instance of HeaderProfileActions!");
    }
  }
  static validateHeaderProfileType(ne) {
    return ne ? typeof ne != "object" ? (console.warn("headerProfile must be an instance of HeaderProfile!"), !1) : "user" in ne && !User.validateHeaderProfileUser(ne.user) || "actions" in ne && !HeaderProfileActions.validateHeaderProfileActions(ne.actions) ? !1 : !!["user", "actions"].some((ie) => ie in ne) : !1;
  }
}
class CSHeaderButtonProps {
  constructor(ne, ae, ie, le) {
    le !== void 0 && (this.action = le), ie !== void 0 && (this.href = ie), ne !== void 0 && (this.id = ne), ae !== void 0 && (this.toolTip = ae), CSHeaderButtonProps.validateHeaderButtonProps(this) || console.warn(
      "value must be provided with correct data type for action, href, id and toolTip!"
    );
  }
  static validateHeaderButtonProps(ne) {
    return ne ? typeof ne != "object" ? (console.warn("value must be an object!"), !1) : "action" in ne && typeof ne.action != "function" ? (console.warn("action must be a function!"), !1) : "href" in ne && typeof ne.href != "string" ? (console.warn("href must be a string!"), !1) : "id" in ne && typeof ne.id != "string" ? (console.warn("id must be a string!"), !1) : "toolTip" in ne && typeof ne.toolTip != "string" ? (console.warn("toolTip must be a string!"), !1) : !!["action", "href", "id", "toolTip"].some((ie) => ie in ne) : !1;
  }
}
class CSHeaderActiveButtonProps extends CSHeaderButtonProps {
  constructor(ne, ae, ie, le, se) {
    super(ne, ae, ie, le), se !== void 0 && (this.active = se), CSHeaderActiveButtonProps.validateActiveHeaderButtonProps(this) || console.warn(
      "value must be provided with correct data type for active, action, href, id and toolTip!"
    );
  }
  static validateActiveHeaderButtonProps(ne) {
    return ne ? typeof ne != "object" ? (console.warn("value must be an object!"), !1) : "active" in ne && typeof ne.active != "boolean" ? (console.warn("active must be a boolean!"), !1) : !!(CSHeaderButtonProps.validateHeaderButtonProps(ne) || "active" in ne) : !1;
  }
}
function errorHandler(re, ne, ae) {
  const ie = ne instanceof Error;
  let le = ne == null ? void 0 : ne.message;
  const se = (ne == null ? void 0 : ne.name) || "", ce = "Please contact Ideagen Complispace Dev Team for the issue.";
  if (ie) {
    switch (console.error(`${se}: ${le}`), ne instanceof Error && ne.stack && console.error(ne.stack), se) {
      case "Auth0LoginError": {
        le = `Fail to login. ${ce}`;
        break;
      }
      case "Auth0LogoutError": {
        le = `The logout process cannot be completed. ${ce}`;
        break;
      }
      case "Auth0RedirectCallbackError": {
        le = `The login process cannot be completed. ${ce}`;
        break;
      }
    }
    re && re.showErrorAlert && le && re.showErrorAlert(le);
  }
}
const makeTransitionProps$1 = propsFactory({
  disabled: Boolean,
  group: Boolean,
  hideOnLeave: Boolean,
  leaveAbsolute: Boolean,
  mode: String,
  origin: String
}, "transition");
function createCssTransition(re, ne, ae) {
  return genericComponent()({
    name: re,
    props: makeTransitionProps$1({
      mode: ae,
      origin: ne
    }),
    setup(ie, le) {
      let {
        slots: se
      } = le;
      const ce = {
        onBeforeEnter(ue) {
          ie.origin && (ue.style.transformOrigin = ie.origin);
        },
        onLeave(ue) {
          if (ie.leaveAbsolute) {
            const {
              offsetTop: de,
              offsetLeft: me,
              offsetWidth: fe,
              offsetHeight: pe
            } = ue;
            ue._transitionInitialStyles = {
              position: ue.style.position,
              top: ue.style.top,
              left: ue.style.left,
              width: ue.style.width,
              height: ue.style.height
            }, ue.style.position = "absolute", ue.style.top = `${de}px`, ue.style.left = `${me}px`, ue.style.width = `${fe}px`, ue.style.height = `${pe}px`;
          }
          ie.hideOnLeave && ue.style.setProperty("display", "none", "important");
        },
        onAfterLeave(ue) {
          if (ie.leaveAbsolute && (ue != null && ue._transitionInitialStyles)) {
            const {
              position: de,
              top: me,
              left: fe,
              width: pe,
              height: ge
            } = ue._transitionInitialStyles;
            delete ue._transitionInitialStyles, ue.style.position = de || "", ue.style.top = me || "", ue.style.left = fe || "", ue.style.width = pe || "", ue.style.height = ge || "";
          }
        }
      };
      return () => {
        const ue = ie.group ? TransitionGroup : Transition;
        return h$1(ue, {
          name: ie.disabled ? "" : re,
          css: !ie.disabled,
          ...ie.group ? void 0 : {
            mode: ie.mode
          },
          ...ie.disabled ? {} : ce
        }, se.default);
      };
    }
  });
}
function createJavascriptTransition(re, ne) {
  let ae = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "in-out";
  return genericComponent()({
    name: re,
    props: {
      mode: {
        type: String,
        default: ae
      },
      disabled: Boolean,
      group: Boolean
    },
    setup(ie, le) {
      let {
        slots: se
      } = le;
      const ce = ie.group ? TransitionGroup : Transition;
      return () => h$1(ce, {
        name: ie.disabled ? "" : re,
        css: !ie.disabled,
        // mode: props.mode, // TODO: vuejs/vue-next#3104
        ...ie.disabled ? {} : ne
      }, se.default);
    }
  });
}
function ExpandTransitionGenerator() {
  let re = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  const ae = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1) ? "width" : "height", ie = camelize(`offset-${ae}`);
  return {
    onBeforeEnter(ce) {
      ce._parent = ce.parentNode, ce._initialStyle = {
        transition: ce.style.transition,
        overflow: ce.style.overflow,
        [ae]: ce.style[ae]
      };
    },
    onEnter(ce) {
      const ue = ce._initialStyle;
      if (!ue) return;
      ce.style.setProperty("transition", "none", "important"), ce.style.overflow = "hidden";
      const de = `${ce[ie]}px`;
      ce.style[ae] = "0", ce.offsetHeight, ce.style.transition = ue.transition, re && ce._parent && ce._parent.classList.add(re), requestAnimationFrame(() => {
        ce.style[ae] = de;
      });
    },
    onAfterEnter: se,
    onEnterCancelled: se,
    onLeave(ce) {
      ce._initialStyle = {
        transition: "",
        overflow: ce.style.overflow,
        [ae]: ce.style[ae]
      }, ce.style.overflow = "hidden", ce.style[ae] = `${ce[ie]}px`, ce.offsetHeight, requestAnimationFrame(() => ce.style[ae] = "0");
    },
    onAfterLeave: le,
    onLeaveCancelled: le
  };
  function le(ce) {
    re && ce._parent && ce._parent.classList.remove(re), se(ce);
  }
  function se(ce) {
    if (!ce._initialStyle) return;
    const ue = ce._initialStyle[ae];
    ce.style.overflow = ce._initialStyle.overflow, ue != null && (ce.style[ae] = ue), delete ce._initialStyle;
  }
}
const makeVDialogTransitionProps = propsFactory({
  target: [Object, Array]
}, "v-dialog-transition"), VDialogTransition = genericComponent()({
  name: "VDialogTransition",
  props: makeVDialogTransitionProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = {
      onBeforeEnter(le) {
        le.style.pointerEvents = "none", le.style.visibility = "hidden";
      },
      async onEnter(le, se) {
        var ge;
        await new Promise((be) => requestAnimationFrame(be)), await new Promise((be) => requestAnimationFrame(be)), le.style.visibility = "";
        const {
          x: ce,
          y: ue,
          sx: de,
          sy: me,
          speed: fe
        } = getDimensions(re.target, le), pe = animate(le, [{
          transform: `translate(${ce}px, ${ue}px) scale(${de}, ${me})`,
          opacity: 0
        }, {}], {
          duration: 225 * fe,
          easing: deceleratedEasing
        });
        (ge = getChildren(le)) == null || ge.forEach((be) => {
          animate(be, [{
            opacity: 0
          }, {
            opacity: 0,
            offset: 0.33
          }, {}], {
            duration: 225 * 2 * fe,
            easing: standardEasing
          });
        }), pe.finished.then(() => se());
      },
      onAfterEnter(le) {
        le.style.removeProperty("pointer-events");
      },
      onBeforeLeave(le) {
        le.style.pointerEvents = "none";
      },
      async onLeave(le, se) {
        var ge;
        await new Promise((be) => requestAnimationFrame(be));
        const {
          x: ce,
          y: ue,
          sx: de,
          sy: me,
          speed: fe
        } = getDimensions(re.target, le);
        animate(le, [{}, {
          transform: `translate(${ce}px, ${ue}px) scale(${de}, ${me})`,
          opacity: 0
        }], {
          duration: 125 * fe,
          easing: acceleratedEasing
        }).finished.then(() => se()), (ge = getChildren(le)) == null || ge.forEach((be) => {
          animate(be, [{}, {
            opacity: 0,
            offset: 0.2
          }, {
            opacity: 0
          }], {
            duration: 125 * 2 * fe,
            easing: standardEasing
          });
        });
      },
      onAfterLeave(le) {
        le.style.removeProperty("pointer-events");
      }
    };
    return () => re.target ? createVNode(Transition, mergeProps({
      name: "dialog-transition"
    }, ie, {
      css: !1
    }), ae) : createVNode(Transition, {
      name: "dialog-transition"
    }, ae);
  }
});
function getChildren(re) {
  var ae;
  const ne = (ae = re.querySelector(":scope > .v-card, :scope > .v-sheet, :scope > .v-list")) == null ? void 0 : ae.children;
  return ne && [...ne];
}
function getDimensions(re, ne) {
  const ae = getTargetBox(re), ie = nullifyTransforms(ne), [le, se] = getComputedStyle(ne).transformOrigin.split(" ").map((Ve) => parseFloat(Ve)), [ce, ue] = getComputedStyle(ne).getPropertyValue("--v-overlay-anchor-origin").split(" ");
  let de = ae.left + ae.width / 2;
  ce === "left" || ue === "left" ? de -= ae.width / 2 : (ce === "right" || ue === "right") && (de += ae.width / 2);
  let me = ae.top + ae.height / 2;
  ce === "top" || ue === "top" ? me -= ae.height / 2 : (ce === "bottom" || ue === "bottom") && (me += ae.height / 2);
  const fe = ae.width / ie.width, pe = ae.height / ie.height, ge = Math.max(1, fe, pe), be = fe / ge || 0, Se = pe / ge || 0, Pe = ie.width * ie.height / (window.innerWidth * window.innerHeight), Ee = Pe > 0.12 ? Math.min(1.5, (Pe - 0.12) * 10 + 1) : 1;
  return {
    x: de - (le + ie.left),
    y: me - (se + ie.top),
    sx: be,
    sy: Se,
    speed: Ee
  };
}
const VFabTransition = createCssTransition("fab-transition", "center center", "out-in"), VDialogBottomTransition = createCssTransition("dialog-bottom-transition"), VDialogTopTransition = createCssTransition("dialog-top-transition"), VFadeTransition = createCssTransition("fade-transition"), VScaleTransition = createCssTransition("scale-transition"), VScrollXTransition = createCssTransition("scroll-x-transition"), VScrollXReverseTransition = createCssTransition("scroll-x-reverse-transition"), VScrollYTransition = createCssTransition("scroll-y-transition"), VScrollYReverseTransition = createCssTransition("scroll-y-reverse-transition"), VSlideXTransition = createCssTransition("slide-x-transition"), VSlideXReverseTransition = createCssTransition("slide-x-reverse-transition"), VSlideYTransition = createCssTransition("slide-y-transition"), VSlideYReverseTransition = createCssTransition("slide-y-reverse-transition"), VExpandTransition = createJavascriptTransition("expand-transition", ExpandTransitionGenerator()), VExpandXTransition = createJavascriptTransition("expand-x-transition", ExpandTransitionGenerator("", !0));
function elementToViewport(re, ne) {
  return {
    x: re.x + ne.x,
    y: re.y + ne.y
  };
}
function getOffset$2(re, ne) {
  return {
    x: re.x - ne.x,
    y: re.y - ne.y
  };
}
function anchorToPoint(re, ne) {
  if (re.side === "top" || re.side === "bottom") {
    const {
      side: ae,
      align: ie
    } = re, le = ie === "left" ? 0 : ie === "center" ? ne.width / 2 : ie === "right" ? ne.width : ie, se = ae === "top" ? 0 : ae === "bottom" ? ne.height : ae;
    return elementToViewport({
      x: le,
      y: se
    }, ne);
  } else if (re.side === "left" || re.side === "right") {
    const {
      side: ae,
      align: ie
    } = re, le = ae === "left" ? 0 : ae === "right" ? ne.width : ae, se = ie === "top" ? 0 : ie === "center" ? ne.height / 2 : ie === "bottom" ? ne.height : ie;
    return elementToViewport({
      x: le,
      y: se
    }, ne);
  }
  return elementToViewport({
    x: ne.width / 2,
    y: ne.height / 2
  }, ne);
}
const locationStrategies = {
  static: staticLocationStrategy,
  // specific viewport position, usually centered
  connected: connectedLocationStrategy
  // connected to a certain element
}, makeLocationStrategyProps = propsFactory({
  locationStrategy: {
    type: [String, Function],
    default: "static",
    validator: (re) => typeof re == "function" || re in locationStrategies
  },
  location: {
    type: String,
    default: "bottom"
  },
  origin: {
    type: String,
    default: "auto"
  },
  offset: [Number, String, Array]
}, "VOverlay-location-strategies");
function useLocationStrategies(re, ne) {
  const ae = ref$1({}), ie = ref$1();
  IN_BROWSER && useToggleScope(() => !!(ne.isActive.value && re.locationStrategy), (se) => {
    var ce, ue;
    watch(() => re.locationStrategy, se), onScopeDispose(() => {
      window.removeEventListener("resize", le), ie.value = void 0;
    }), window.addEventListener("resize", le, {
      passive: !0
    }), typeof re.locationStrategy == "function" ? ie.value = (ce = re.locationStrategy(ne, re, ae)) == null ? void 0 : ce.updateLocation : ie.value = (ue = locationStrategies[re.locationStrategy](ne, re, ae)) == null ? void 0 : ue.updateLocation;
  });
  function le(se) {
    var ce;
    (ce = ie.value) == null || ce.call(ie, se);
  }
  return {
    contentStyles: ae,
    updateLocation: ie
  };
}
function staticLocationStrategy() {
}
function getIntrinsicSize(re, ne) {
  const ae = nullifyTransforms(re);
  return ne ? ae.x += parseFloat(re.style.right || 0) : ae.x -= parseFloat(re.style.left || 0), ae.y -= parseFloat(re.style.top || 0), ae;
}
function connectedLocationStrategy(re, ne, ae) {
  (Array.isArray(re.target.value) || isFixedPosition(re.target.value)) && Object.assign(ae.value, {
    position: "fixed",
    top: 0,
    [re.isRtl.value ? "right" : "left"]: 0
  });
  const {
    preferredAnchor: le,
    preferredOrigin: se
  } = destructComputed(() => {
    const Se = parseAnchor(ne.location, re.isRtl.value), Pe = ne.origin === "overlap" ? Se : ne.origin === "auto" ? flipSide(Se) : parseAnchor(ne.origin, re.isRtl.value);
    return Se.side === Pe.side && Se.align === flipAlign(Pe).align ? {
      preferredAnchor: flipCorner(Se),
      preferredOrigin: flipCorner(Pe)
    } : {
      preferredAnchor: Se,
      preferredOrigin: Pe
    };
  }), [ce, ue, de, me] = ["minWidth", "minHeight", "maxWidth", "maxHeight"].map((Se) => computed(() => {
    const Pe = parseFloat(ne[Se]);
    return isNaN(Pe) ? 1 / 0 : Pe;
  })), fe = computed(() => {
    if (Array.isArray(ne.offset))
      return ne.offset;
    if (typeof ne.offset == "string") {
      const Se = ne.offset.split(" ").map(parseFloat);
      return Se.length < 2 && Se.push(0), Se;
    }
    return typeof ne.offset == "number" ? [ne.offset, 0] : [0, 0];
  });
  let pe = !1;
  const ge = new ResizeObserver(() => {
    pe && be();
  });
  watch([re.target, re.contentEl], (Se, Pe) => {
    let [Ee, Ve] = Se, [Ae, Oe] = Pe;
    Ae && !Array.isArray(Ae) && ge.unobserve(Ae), Ee && !Array.isArray(Ee) && ge.observe(Ee), Oe && ge.unobserve(Oe), Ve && ge.observe(Ve);
  }, {
    immediate: !0
  }), onScopeDispose(() => {
    ge.disconnect();
  });
  function be() {
    if (pe = !1, requestAnimationFrame(() => pe = !0), !re.target.value || !re.contentEl.value) return;
    const Se = getTargetBox(re.target.value), Pe = getIntrinsicSize(re.contentEl.value, re.isRtl.value), Ee = getScrollParents(re.contentEl.value), Ve = 12;
    Ee.length || (Ee.push(document.documentElement), re.contentEl.value.style.top && re.contentEl.value.style.left || (Pe.x -= parseFloat(document.documentElement.style.getPropertyValue("--v-body-scroll-x") || 0), Pe.y -= parseFloat(document.documentElement.style.getPropertyValue("--v-body-scroll-y") || 0)));
    const Ae = Ee.reduce((Re, Ce) => {
      const _e = Ce.getBoundingClientRect(), he = new Box({
        x: Ce === document.documentElement ? 0 : _e.x,
        y: Ce === document.documentElement ? 0 : _e.y,
        width: Ce.clientWidth,
        height: Ce.clientHeight
      });
      return Re ? new Box({
        x: Math.max(Re.left, he.left),
        y: Math.max(Re.top, he.top),
        width: Math.min(Re.right, he.right) - Math.max(Re.left, he.left),
        height: Math.min(Re.bottom, he.bottom) - Math.max(Re.top, he.top)
      }) : he;
    }, void 0);
    Ae.x += Ve, Ae.y += Ve, Ae.width -= Ve * 2, Ae.height -= Ve * 2;
    let Oe = {
      anchor: le.value,
      origin: se.value
    };
    function Ne(Re) {
      const Ce = new Box(Pe), _e = anchorToPoint(Re.anchor, Se), he = anchorToPoint(Re.origin, Ce);
      let {
        x: ve,
        y: xe
      } = getOffset$2(_e, he);
      switch (Re.anchor.side) {
        case "top":
          xe -= fe.value[0];
          break;
        case "bottom":
          xe += fe.value[0];
          break;
        case "left":
          ve -= fe.value[0];
          break;
        case "right":
          ve += fe.value[0];
          break;
      }
      switch (Re.anchor.align) {
        case "top":
          xe -= fe.value[1];
          break;
        case "bottom":
          xe += fe.value[1];
          break;
        case "left":
          ve -= fe.value[1];
          break;
        case "right":
          ve += fe.value[1];
          break;
      }
      return Ce.x += ve, Ce.y += xe, Ce.width = Math.min(Ce.width, de.value), Ce.height = Math.min(Ce.height, me.value), {
        overflows: getOverflow(Ce, Ae),
        x: ve,
        y: xe
      };
    }
    let He = 0, Ue = 0;
    const Ze = {
      x: 0,
      y: 0
    }, Fe = {
      x: !1,
      y: !1
    };
    let Ke = -1;
    for (; ; ) {
      if (Ke++ > 10) {
        consoleError("Infinite loop detected in connectedLocationStrategy");
        break;
      }
      const {
        x: Re,
        y: Ce,
        overflows: _e
      } = Ne(Oe);
      He += Re, Ue += Ce, Pe.x += Re, Pe.y += Ce;
      {
        const he = getAxis(Oe.anchor), ve = _e.x.before || _e.x.after, xe = _e.y.before || _e.y.after;
        let $e = !1;
        if (["x", "y"].forEach((Te) => {
          if (Te === "x" && ve && !Fe.x || Te === "y" && xe && !Fe.y) {
            const Ie = {
              anchor: {
                ...Oe.anchor
              },
              origin: {
                ...Oe.origin
              }
            }, we = Te === "x" ? he === "y" ? flipAlign : flipSide : he === "y" ? flipSide : flipAlign;
            Ie.anchor = we(Ie.anchor), Ie.origin = we(Ie.origin);
            const {
              overflows: ke
            } = Ne(Ie);
            (ke[Te].before <= _e[Te].before && ke[Te].after <= _e[Te].after || ke[Te].before + ke[Te].after < (_e[Te].before + _e[Te].after) / 2) && (Oe = Ie, $e = Fe[Te] = !0);
          }
        }), $e) continue;
      }
      _e.x.before && (He += _e.x.before, Pe.x += _e.x.before), _e.x.after && (He -= _e.x.after, Pe.x -= _e.x.after), _e.y.before && (Ue += _e.y.before, Pe.y += _e.y.before), _e.y.after && (Ue -= _e.y.after, Pe.y -= _e.y.after);
      {
        const he = getOverflow(Pe, Ae);
        Ze.x = Ae.width - he.x.before - he.x.after, Ze.y = Ae.height - he.y.before - he.y.after, He += he.x.before, Pe.x += he.x.before, Ue += he.y.before, Pe.y += he.y.before;
      }
      break;
    }
    const tt = getAxis(Oe.anchor);
    return Object.assign(ae.value, {
      "--v-overlay-anchor-origin": `${Oe.anchor.side} ${Oe.anchor.align}`,
      transformOrigin: `${Oe.origin.side} ${Oe.origin.align}`,
      // transform: `translate(${pixelRound(x)}px, ${pixelRound(y)}px)`,
      top: convertToUnit(pixelRound(Ue)),
      left: re.isRtl.value ? void 0 : convertToUnit(pixelRound(He)),
      right: re.isRtl.value ? convertToUnit(pixelRound(-He)) : void 0,
      minWidth: convertToUnit(tt === "y" ? Math.min(ce.value, Se.width) : ce.value),
      maxWidth: convertToUnit(pixelCeil(clamp(Ze.x, ce.value === 1 / 0 ? 0 : ce.value, de.value))),
      maxHeight: convertToUnit(pixelCeil(clamp(Ze.y, ue.value === 1 / 0 ? 0 : ue.value, me.value)))
    }), {
      available: Ze,
      contentBox: Pe
    };
  }
  return watch(() => [le.value, se.value, ne.offset, ne.minWidth, ne.minHeight, ne.maxWidth, ne.maxHeight], () => be()), nextTick$2(() => {
    const Se = be();
    if (!Se) return;
    const {
      available: Pe,
      contentBox: Ee
    } = Se;
    Ee.height > Pe.y && requestAnimationFrame(() => {
      be(), requestAnimationFrame(() => {
        be();
      });
    });
  }), {
    updateLocation: be
  };
}
function pixelRound(re) {
  return Math.round(re * devicePixelRatio) / devicePixelRatio;
}
function pixelCeil(re) {
  return Math.ceil(re * devicePixelRatio) / devicePixelRatio;
}
let clean = !0;
const frames = [];
function requestNewFrame(re) {
  !clean || frames.length ? (frames.push(re), run()) : (clean = !1, re(), run());
}
let raf = -1;
function run() {
  cancelAnimationFrame(raf), raf = requestAnimationFrame(() => {
    const re = frames.shift();
    re && re(), frames.length ? run() : clean = !0;
  });
}
const scrollStrategies = {
  none: null,
  close: closeScrollStrategy,
  block: blockScrollStrategy,
  reposition: repositionScrollStrategy
}, makeScrollStrategyProps = propsFactory({
  scrollStrategy: {
    type: [String, Function],
    default: "block",
    validator: (re) => typeof re == "function" || re in scrollStrategies
  }
}, "VOverlay-scroll-strategies");
function useScrollStrategies(re, ne) {
  if (!IN_BROWSER) return;
  let ae;
  watchEffect(async () => {
    ae == null || ae.stop(), ne.isActive.value && re.scrollStrategy && (ae = effectScope(), await new Promise((ie) => setTimeout(ie)), ae.active && ae.run(() => {
      var ie;
      typeof re.scrollStrategy == "function" ? re.scrollStrategy(ne, re, ae) : (ie = scrollStrategies[re.scrollStrategy]) == null || ie.call(scrollStrategies, ne, re, ae);
    }));
  }), onScopeDispose(() => {
    ae == null || ae.stop();
  });
}
function closeScrollStrategy(re) {
  function ne(ae) {
    re.isActive.value = !1;
  }
  bindScroll(re.targetEl.value ?? re.contentEl.value, ne);
}
function blockScrollStrategy(re, ne) {
  var ce;
  const ae = (ce = re.root.value) == null ? void 0 : ce.offsetParent, ie = [.../* @__PURE__ */ new Set([...getScrollParents(re.targetEl.value, ne.contained ? ae : void 0), ...getScrollParents(re.contentEl.value, ne.contained ? ae : void 0)])].filter((ue) => !ue.classList.contains("v-overlay-scroll-blocked")), le = window.innerWidth - document.documentElement.offsetWidth, se = ((ue) => hasScrollbar(ue) && ue)(ae || document.documentElement);
  se && re.root.value.classList.add("v-overlay--scroll-blocked"), ie.forEach((ue, de) => {
    ue.style.setProperty("--v-body-scroll-x", convertToUnit(-ue.scrollLeft)), ue.style.setProperty("--v-body-scroll-y", convertToUnit(-ue.scrollTop)), ue !== document.documentElement && ue.style.setProperty("--v-scrollbar-offset", convertToUnit(le)), ue.classList.add("v-overlay-scroll-blocked");
  }), onScopeDispose(() => {
    ie.forEach((ue, de) => {
      const me = parseFloat(ue.style.getPropertyValue("--v-body-scroll-x")), fe = parseFloat(ue.style.getPropertyValue("--v-body-scroll-y")), pe = ue.style.scrollBehavior;
      ue.style.scrollBehavior = "auto", ue.style.removeProperty("--v-body-scroll-x"), ue.style.removeProperty("--v-body-scroll-y"), ue.style.removeProperty("--v-scrollbar-offset"), ue.classList.remove("v-overlay-scroll-blocked"), ue.scrollLeft = -me, ue.scrollTop = -fe, ue.style.scrollBehavior = pe;
    }), se && re.root.value.classList.remove("v-overlay--scroll-blocked");
  });
}
function repositionScrollStrategy(re, ne, ae) {
  let ie = !1, le = -1, se = -1;
  function ce(ue) {
    requestNewFrame(() => {
      var fe, pe;
      const de = performance.now();
      (pe = (fe = re.updateLocation).value) == null || pe.call(fe, ue), ie = (performance.now() - de) / (1e3 / 60) > 2;
    });
  }
  se = (typeof requestIdleCallback > "u" ? (ue) => ue() : requestIdleCallback)(() => {
    ae.run(() => {
      bindScroll(re.targetEl.value ?? re.contentEl.value, (ue) => {
        ie ? (cancelAnimationFrame(le), le = requestAnimationFrame(() => {
          le = requestAnimationFrame(() => {
            ce(ue);
          });
        })) : ce(ue);
      });
    });
  }), onScopeDispose(() => {
    typeof cancelIdleCallback < "u" && cancelIdleCallback(se), cancelAnimationFrame(le);
  });
}
function bindScroll(re, ne) {
  const ae = [document, ...getScrollParents(re)];
  ae.forEach((ie) => {
    ie.addEventListener("scroll", ne, {
      passive: !0
    });
  }), onScopeDispose(() => {
    ae.forEach((ie) => {
      ie.removeEventListener("scroll", ne);
    });
  });
}
const VMenuSymbol = Symbol.for("vuetify:v-menu"), makeDelayProps = propsFactory({
  closeDelay: [Number, String],
  openDelay: [Number, String]
}, "delay");
function useDelay(re, ne) {
  let ae = () => {
  };
  function ie(ce) {
    ae == null || ae();
    const ue = Number(ce ? re.openDelay : re.closeDelay);
    return new Promise((de) => {
      ae = defer(ue, () => {
        ne == null || ne(ce), de(ce);
      });
    });
  }
  function le() {
    return ie(!0);
  }
  function se() {
    return ie(!1);
  }
  return {
    clearDelay: ae,
    runOpenDelay: le,
    runCloseDelay: se
  };
}
const makeActivatorProps = propsFactory({
  target: [String, Object],
  activator: [String, Object],
  activatorProps: {
    type: Object,
    default: () => ({})
  },
  openOnClick: {
    type: Boolean,
    default: void 0
  },
  openOnHover: Boolean,
  openOnFocus: {
    type: Boolean,
    default: void 0
  },
  closeOnContentClick: Boolean,
  ...makeDelayProps()
}, "VOverlay-activator");
function useActivator(re, ne) {
  let {
    isActive: ae,
    isTop: ie,
    contentEl: le
  } = ne;
  const se = getCurrentInstance("useActivator"), ce = ref$1();
  let ue = !1, de = !1, me = !0;
  const fe = computed(() => re.openOnFocus || re.openOnFocus == null && re.openOnHover), pe = computed(() => re.openOnClick || re.openOnClick == null && !re.openOnHover && !fe.value), {
    runOpenDelay: ge,
    runCloseDelay: be
  } = useDelay(re, (Fe) => {
    Fe === (re.openOnHover && ue || fe.value && de) && !(re.openOnHover && ae.value && !ie.value) && (ae.value !== Fe && (me = !0), ae.value = Fe);
  }), Se = ref$1(), Pe = {
    onClick: (Fe) => {
      Fe.stopPropagation(), ce.value = Fe.currentTarget || Fe.target, ae.value || (Se.value = [Fe.clientX, Fe.clientY]), ae.value = !ae.value;
    },
    onMouseenter: (Fe) => {
      var Ke;
      (Ke = Fe.sourceCapabilities) != null && Ke.firesTouchEvents || (ue = !0, ce.value = Fe.currentTarget || Fe.target, ge());
    },
    onMouseleave: (Fe) => {
      ue = !1, be();
    },
    onFocus: (Fe) => {
      matchesSelector(Fe.target, ":focus-visible") !== !1 && (de = !0, Fe.stopPropagation(), ce.value = Fe.currentTarget || Fe.target, ge());
    },
    onBlur: (Fe) => {
      de = !1, Fe.stopPropagation(), be();
    }
  }, Ee = computed(() => {
    const Fe = {};
    return pe.value && (Fe.onClick = Pe.onClick), re.openOnHover && (Fe.onMouseenter = Pe.onMouseenter, Fe.onMouseleave = Pe.onMouseleave), fe.value && (Fe.onFocus = Pe.onFocus, Fe.onBlur = Pe.onBlur), Fe;
  }), Ve = computed(() => {
    const Fe = {};
    if (re.openOnHover && (Fe.onMouseenter = () => {
      ue = !0, ge();
    }, Fe.onMouseleave = () => {
      ue = !1, be();
    }), fe.value && (Fe.onFocusin = () => {
      de = !0, ge();
    }, Fe.onFocusout = () => {
      de = !1, be();
    }), re.closeOnContentClick) {
      const Ke = inject(VMenuSymbol, null);
      Fe.onClick = () => {
        ae.value = !1, Ke == null || Ke.closeParents();
      };
    }
    return Fe;
  }), Ae = computed(() => {
    const Fe = {};
    return re.openOnHover && (Fe.onMouseenter = () => {
      me && (ue = !0, me = !1, ge());
    }, Fe.onMouseleave = () => {
      ue = !1, be();
    }), Fe;
  });
  watch(ie, (Fe) => {
    var Ke;
    Fe && (re.openOnHover && !ue && (!fe.value || !de) || fe.value && !de && (!re.openOnHover || !ue)) && !((Ke = le.value) != null && Ke.contains(document.activeElement)) && (ae.value = !1);
  }), watch(ae, (Fe) => {
    Fe || setTimeout(() => {
      Se.value = void 0;
    });
  }, {
    flush: "post"
  });
  const Oe = templateRef();
  watchEffect(() => {
    Oe.value && nextTick$2(() => {
      ce.value = Oe.el;
    });
  });
  const Ne = templateRef(), He = computed(() => re.target === "cursor" && Se.value ? Se.value : Ne.value ? Ne.el : getTarget$1(re.target, se) || ce.value), Ue = computed(() => Array.isArray(He.value) ? void 0 : He.value);
  let Ze;
  return watch(() => !!re.activator, (Fe) => {
    Fe && IN_BROWSER ? (Ze = effectScope(), Ze.run(() => {
      _useActivator(re, se, {
        activatorEl: ce,
        activatorEvents: Ee
      });
    })) : Ze && Ze.stop();
  }, {
    flush: "post",
    immediate: !0
  }), onScopeDispose(() => {
    Ze == null || Ze.stop();
  }), {
    activatorEl: ce,
    activatorRef: Oe,
    target: He,
    targetEl: Ue,
    targetRef: Ne,
    activatorEvents: Ee,
    contentEvents: Ve,
    scrimEvents: Ae
  };
}
function _useActivator(re, ne, ae) {
  let {
    activatorEl: ie,
    activatorEvents: le
  } = ae;
  watch(() => re.activator, (de, me) => {
    if (me && de !== me) {
      const fe = ue(me);
      fe && ce(fe);
    }
    de && nextTick$2(() => se());
  }, {
    immediate: !0
  }), watch(() => re.activatorProps, () => {
    se();
  }), onScopeDispose(() => {
    ce();
  });
  function se() {
    let de = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ue(), me = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : re.activatorProps;
    de && bindProps(de, mergeProps(le.value, me));
  }
  function ce() {
    let de = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ue(), me = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : re.activatorProps;
    de && unbindProps(de, mergeProps(le.value, me));
  }
  function ue() {
    let de = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : re.activator;
    const me = getTarget$1(de, ne);
    return ie.value = (me == null ? void 0 : me.nodeType) === Node.ELEMENT_NODE ? me : void 0, ie.value;
  }
}
function getTarget$1(re, ne) {
  var ie, le;
  if (!re) return;
  let ae;
  if (re === "parent") {
    let se = (le = (ie = ne == null ? void 0 : ne.proxy) == null ? void 0 : ie.$el) == null ? void 0 : le.parentNode;
    for (; se != null && se.hasAttribute("data-no-activator"); )
      se = se.parentNode;
    ae = se;
  } else typeof re == "string" ? ae = document.querySelector(re) : "$el" in re ? ae = re.$el : ae = re;
  return ae;
}
const breakpoints = ["sm", "md", "lg", "xl", "xxl"], DisplaySymbol = Symbol.for("vuetify:display"), makeDisplayProps = propsFactory({
  mobile: {
    type: Boolean,
    default: !1
  },
  mobileBreakpoint: [Number, String]
}, "display");
function useDisplay() {
  let re = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
    mobile: null
  }, ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getCurrentInstanceName();
  const ae = inject(DisplaySymbol);
  if (!ae) throw new Error("Could not find Vuetify display injection");
  const ie = computed(() => re.mobile ? !0 : typeof re.mobileBreakpoint == "number" ? ae.width.value < re.mobileBreakpoint : re.mobileBreakpoint ? ae.width.value < ae.thresholds.value[re.mobileBreakpoint] : re.mobile === null ? ae.mobile.value : !1), le = computed(() => ne ? {
    [`${ne}--mobile`]: ie.value
  } : {});
  return {
    ...ae,
    displayClasses: le,
    mobile: ie
  };
}
function useHydration() {
  if (!IN_BROWSER) return shallowRef(!1);
  const {
    ssr: re
  } = useDisplay();
  if (re) {
    const ne = shallowRef(!1);
    return onMounted(() => {
      ne.value = !0;
    }), ne;
  } else
    return shallowRef(!0);
}
const makeLazyProps = propsFactory({
  eager: Boolean
}, "lazy");
function useLazy(re, ne) {
  const ae = shallowRef(!1), ie = computed(() => ae.value || re.eager || ne.value);
  watch(ne, () => ae.value = !0);
  function le() {
    re.eager || (ae.value = !1);
  }
  return {
    isBooted: ae,
    hasContent: ie,
    onAfterLeave: le
  };
}
function useScopeId() {
  const ne = getCurrentInstance("useScopeId").vnode.scopeId;
  return {
    scopeId: ne ? {
      [ne]: ""
    } : void 0
  };
}
const StackSymbol = Symbol.for("vuetify:stack"), globalStack = reactive([]);
function useStack(re, ne, ae) {
  const ie = getCurrentInstance("useStack"), le = !ae, se = inject(StackSymbol, void 0), ce = reactive({
    activeChildren: /* @__PURE__ */ new Set()
  });
  provide(StackSymbol, ce);
  const ue = shallowRef(Number(ne.value));
  useToggleScope(re, () => {
    var pe;
    const fe = (pe = globalStack.at(-1)) == null ? void 0 : pe[1];
    ue.value = fe ? fe + 10 : Number(ne.value), le && globalStack.push([ie.uid, ue.value]), se == null || se.activeChildren.add(ie.uid), onScopeDispose(() => {
      if (le) {
        const ge = toRaw(globalStack).findIndex((be) => be[0] === ie.uid);
        globalStack.splice(ge, 1);
      }
      se == null || se.activeChildren.delete(ie.uid);
    });
  });
  const de = shallowRef(!0);
  le && watchEffect(() => {
    var pe;
    const fe = ((pe = globalStack.at(-1)) == null ? void 0 : pe[0]) === ie.uid;
    setTimeout(() => de.value = fe);
  });
  const me = computed(() => !ce.activeChildren.size);
  return {
    globalTop: readonly(de),
    localTop: me,
    stackStyles: computed(() => ({
      zIndex: ue.value
    }))
  };
}
function useTeleport(re) {
  return {
    teleportTarget: computed(() => {
      const ae = re();
      if (ae === !0 || !IN_BROWSER) return;
      const ie = ae === !1 ? document.body : typeof ae == "string" ? document.querySelector(ae) : ae;
      if (ie == null) {
        warn$1(`Unable to locate target ${ae}`);
        return;
      }
      let le = [...ie.children].find((se) => se.matches(".v-overlay-container"));
      return le || (le = document.createElement("div"), le.className = "v-overlay-container", ie.appendChild(le)), le;
    })
  };
}
const makeTransitionProps = propsFactory({
  transition: {
    type: [Boolean, String, Object],
    default: "fade-transition",
    validator: (re) => re !== !0
  }
}, "transition"), MaybeTransition = (re, ne) => {
  let {
    slots: ae
  } = ne;
  const {
    transition: ie,
    disabled: le,
    group: se,
    ...ce
  } = re, {
    component: ue = se ? TransitionGroup : Transition,
    ...de
  } = typeof ie == "object" ? ie : {};
  return h$1(ue, mergeProps(typeof ie == "string" ? {
    name: le ? "" : ie
  } : de, typeof ie == "string" ? {} : Object.fromEntries(Object.entries({
    disabled: le,
    group: se
  }).filter((me) => {
    let [fe, pe] = me;
    return pe !== void 0;
  })), ce), ae);
};
function defaultConditional() {
  return !0;
}
function checkEvent(re, ne, ae) {
  if (!re || checkIsActive(re, ae) === !1) return !1;
  const ie = attachedRoot(ne);
  if (typeof ShadowRoot < "u" && ie instanceof ShadowRoot && ie.host === re.target) return !1;
  const le = (typeof ae.value == "object" && ae.value.include || (() => []))();
  return le.push(ne), !le.some((se) => se == null ? void 0 : se.contains(re.target));
}
function checkIsActive(re, ne) {
  return (typeof ne.value == "object" && ne.value.closeConditional || defaultConditional)(re);
}
function directive(re, ne, ae) {
  const ie = typeof ae.value == "function" ? ae.value : ae.value.handler;
  re.shadowTarget = re.target, ne._clickOutside.lastMousedownWasOutside && checkEvent(re, ne, ae) && setTimeout(() => {
    checkIsActive(re, ae) && ie && ie(re);
  }, 0);
}
function handleShadow(re, ne) {
  const ae = attachedRoot(re);
  ne(document), typeof ShadowRoot < "u" && ae instanceof ShadowRoot && ne(ae);
}
const ClickOutside = {
  // [data-app] may not be found
  // if using bind, inserted makes
  // sure that the root element is
  // available, iOS does not support
  // clicks on body
  mounted(re, ne) {
    const ae = (le) => directive(le, re, ne), ie = (le) => {
      re._clickOutside.lastMousedownWasOutside = checkEvent(le, re, ne);
    };
    handleShadow(re, (le) => {
      le.addEventListener("click", ae, !0), le.addEventListener("mousedown", ie, !0);
    }), re._clickOutside || (re._clickOutside = {
      lastMousedownWasOutside: !1
    }), re._clickOutside[ne.instance.$.uid] = {
      onClick: ae,
      onMousedown: ie
    };
  },
  beforeUnmount(re, ne) {
    re._clickOutside && (handleShadow(re, (ae) => {
      var se;
      if (!ae || !((se = re._clickOutside) != null && se[ne.instance.$.uid])) return;
      const {
        onClick: ie,
        onMousedown: le
      } = re._clickOutside[ne.instance.$.uid];
      ae.removeEventListener("click", ie, !0), ae.removeEventListener("mousedown", le, !0);
    }), delete re._clickOutside[ne.instance.$.uid]);
  }
};
function Scrim(re) {
  const {
    modelValue: ne,
    color: ae,
    ...ie
  } = re;
  return createVNode(Transition, {
    name: "fade-transition",
    appear: !0
  }, {
    default: () => [re.modelValue && createVNode("div", mergeProps({
      class: ["v-overlay__scrim", re.color.backgroundColorClasses.value],
      style: re.color.backgroundColorStyles.value
    }, ie), null)]
  });
}
const makeVOverlayProps = propsFactory({
  absolute: Boolean,
  attach: [Boolean, String, Object],
  closeOnBack: {
    type: Boolean,
    default: !0
  },
  contained: Boolean,
  contentClass: null,
  contentProps: null,
  disabled: Boolean,
  opacity: [Number, String],
  noClickAnimation: Boolean,
  modelValue: Boolean,
  persistent: Boolean,
  scrim: {
    type: [Boolean, String],
    default: !0
  },
  zIndex: {
    type: [Number, String],
    default: 2e3
  },
  ...makeActivatorProps(),
  ...makeComponentProps(),
  ...makeDimensionProps(),
  ...makeLazyProps(),
  ...makeLocationStrategyProps(),
  ...makeScrollStrategyProps(),
  ...makeThemeProps(),
  ...makeTransitionProps()
}, "VOverlay"), VOverlay = genericComponent()({
  name: "VOverlay",
  directives: {
    ClickOutside
  },
  inheritAttrs: !1,
  props: {
    _disableGlobalStack: Boolean,
    ...makeVOverlayProps()
  },
  emits: {
    "click:outside": (re) => !0,
    "update:modelValue": (re) => !0,
    keydown: (re) => !0,
    afterEnter: () => !0,
    afterLeave: () => !0
  },
  setup(re, ne) {
    let {
      slots: ae,
      attrs: ie,
      emit: le
    } = ne;
    const se = getCurrentInstance("VOverlay"), ce = ref$1(), ue = ref$1(), de = ref$1(), me = useProxiedModel(re, "modelValue"), fe = computed({
      get: () => me.value,
      set: (De) => {
        De && re.disabled || (me.value = De);
      }
    }), {
      themeClasses: pe
    } = provideTheme(re), {
      rtlClasses: ge,
      isRtl: be
    } = useRtl(), {
      hasContent: Se,
      onAfterLeave: Pe
    } = useLazy(re, fe), Ee = useBackgroundColor(computed(() => typeof re.scrim == "string" ? re.scrim : null)), {
      globalTop: Ve,
      localTop: Ae,
      stackStyles: Oe
    } = useStack(fe, toRef(re, "zIndex"), re._disableGlobalStack), {
      activatorEl: Ne,
      activatorRef: He,
      target: Ue,
      targetEl: Ze,
      targetRef: Fe,
      activatorEvents: Ke,
      contentEvents: tt,
      scrimEvents: Re
    } = useActivator(re, {
      isActive: fe,
      isTop: Ae,
      contentEl: de
    }), {
      teleportTarget: Ce
    } = useTeleport(() => {
      var rt, at, qe;
      const De = re.attach || re.contained;
      if (De) return De;
      const je = ((rt = Ne == null ? void 0 : Ne.value) == null ? void 0 : rt.getRootNode()) || ((qe = (at = se.proxy) == null ? void 0 : at.$el) == null ? void 0 : qe.getRootNode());
      return je instanceof ShadowRoot ? je : !1;
    }), {
      dimensionStyles: _e
    } = useDimension(re), he = useHydration(), {
      scopeId: ve
    } = useScopeId();
    watch(() => re.disabled, (De) => {
      De && (fe.value = !1);
    });
    const {
      contentStyles: xe,
      updateLocation: $e
    } = useLocationStrategies(re, {
      isRtl: be,
      contentEl: de,
      target: Ue,
      isActive: fe
    });
    useScrollStrategies(re, {
      root: ce,
      contentEl: de,
      targetEl: Ze,
      isActive: fe,
      updateLocation: $e
    });
    function Te(De) {
      le("click:outside", De), re.persistent ? Xe() : fe.value = !1;
    }
    function Ie(De) {
      return fe.value && Ve.value && // If using scrim, only close if clicking on it rather than anything opened on top
      (!re.scrim || De.target === ue.value || De instanceof MouseEvent && De.shadowTarget === ue.value);
    }
    IN_BROWSER && watch(fe, (De) => {
      De ? window.addEventListener("keydown", we) : window.removeEventListener("keydown", we);
    }, {
      immediate: !0
    }), onBeforeUnmount(() => {
      IN_BROWSER && window.removeEventListener("keydown", we);
    });
    function we(De) {
      var je, rt, at;
      De.key === "Escape" && Ve.value && ((je = de.value) != null && je.contains(document.activeElement) || le("keydown", De), re.persistent ? Xe() : (fe.value = !1, (rt = de.value) != null && rt.contains(document.activeElement) && ((at = Ne.value) == null || at.focus())));
    }
    function ke(De) {
      De.key === "Escape" && !Ve.value || le("keydown", De);
    }
    const ye = useRouter();
    useToggleScope(() => re.closeOnBack, () => {
      useBackButton(ye, (De) => {
        Ve.value && fe.value ? (De(!1), re.persistent ? Xe() : fe.value = !1) : De();
      });
    });
    const Be = ref$1();
    watch(() => fe.value && (re.absolute || re.contained) && Ce.value == null, (De) => {
      if (De) {
        const je = getScrollParent(ce.value);
        je && je !== document.scrollingElement && (Be.value = je.scrollTop);
      }
    });
    function Xe() {
      re.noClickAnimation || de.value && animate(de.value, [{
        transformOrigin: "center"
      }, {
        transform: "scale(1.03)"
      }, {
        transformOrigin: "center"
      }], {
        duration: 150,
        easing: standardEasing
      });
    }
    function et() {
      le("afterEnter");
    }
    function Ye() {
      Pe(), le("afterLeave");
    }
    return useRender(() => {
      var De;
      return createVNode(Fragment, null, [(De = ae.activator) == null ? void 0 : De.call(ae, {
        isActive: fe.value,
        targetRef: Fe,
        props: mergeProps({
          ref: He
        }, Ke.value, re.activatorProps)
      }), he.value && Se.value && createVNode(Teleport, {
        disabled: !Ce.value,
        to: Ce.value
      }, {
        default: () => [createVNode("div", mergeProps({
          class: ["v-overlay", {
            "v-overlay--absolute": re.absolute || re.contained,
            "v-overlay--active": fe.value,
            "v-overlay--contained": re.contained
          }, pe.value, ge.value, re.class],
          style: [Oe.value, {
            "--v-overlay-opacity": re.opacity,
            top: convertToUnit(Be.value)
          }, re.style],
          ref: ce,
          onKeydown: ke
        }, ve, ie), [createVNode(Scrim, mergeProps({
          color: Ee,
          modelValue: fe.value && !!re.scrim,
          ref: ue
        }, Re.value), null), createVNode(MaybeTransition, {
          appear: !0,
          persisted: !0,
          transition: re.transition,
          target: Ue.value,
          onAfterEnter: et,
          onAfterLeave: Ye
        }, {
          default: () => {
            var je;
            return [withDirectives(createVNode("div", mergeProps({
              ref: de,
              class: ["v-overlay__content", re.contentClass],
              style: [_e.value, xe.value]
            }, tt.value, re.contentProps), [(je = ae.default) == null ? void 0 : je.call(ae, {
              isActive: fe
            })]), [[vShow, fe.value], [resolveDirective("click-outside"), {
              handler: Te,
              closeConditional: Ie,
              include: () => [Ne.value]
            }]])];
          }
        })])]
      })]);
    }), {
      activatorEl: Ne,
      scrimEl: ue,
      target: Ue,
      animateClick: Xe,
      contentEl: de,
      globalTop: Ve,
      localTop: Ae,
      updateLocation: $e
    };
  }
}), Refs = Symbol("Forwarded refs");
function getDescriptor(re, ne) {
  let ae = re;
  for (; ae; ) {
    const ie = Reflect.getOwnPropertyDescriptor(ae, ne);
    if (ie) return ie;
    ae = Object.getPrototypeOf(ae);
  }
}
function forwardRefs(re) {
  for (var ne = arguments.length, ae = new Array(ne > 1 ? ne - 1 : 0), ie = 1; ie < ne; ie++)
    ae[ie - 1] = arguments[ie];
  return re[Refs] = ae, new Proxy(re, {
    get(le, se) {
      if (Reflect.has(le, se))
        return Reflect.get(le, se);
      if (!(typeof se == "symbol" || se.startsWith("$") || se.startsWith("__"))) {
        for (const ce of ae)
          if (ce.value && Reflect.has(ce.value, se)) {
            const ue = Reflect.get(ce.value, se);
            return typeof ue == "function" ? ue.bind(ce.value) : ue;
          }
      }
    },
    has(le, se) {
      if (Reflect.has(le, se))
        return !0;
      if (typeof se == "symbol" || se.startsWith("$") || se.startsWith("__")) return !1;
      for (const ce of ae)
        if (ce.value && Reflect.has(ce.value, se))
          return !0;
      return !1;
    },
    set(le, se, ce) {
      if (Reflect.has(le, se))
        return Reflect.set(le, se, ce);
      if (typeof se == "symbol" || se.startsWith("$") || se.startsWith("__")) return !1;
      for (const ue of ae)
        if (ue.value && Reflect.has(ue.value, se))
          return Reflect.set(ue.value, se, ce);
      return !1;
    },
    getOwnPropertyDescriptor(le, se) {
      var ue;
      const ce = Reflect.getOwnPropertyDescriptor(le, se);
      if (ce) return ce;
      if (!(typeof se == "symbol" || se.startsWith("$") || se.startsWith("__"))) {
        for (const de of ae) {
          if (!de.value) continue;
          const me = getDescriptor(de.value, se) ?? ("_" in de.value ? getDescriptor((ue = de.value._) == null ? void 0 : ue.setupState, se) : void 0);
          if (me) return me;
        }
        for (const de of ae) {
          const me = de.value && de.value[Refs];
          if (!me) continue;
          const fe = me.slice();
          for (; fe.length; ) {
            const pe = fe.shift(), ge = getDescriptor(pe.value, se);
            if (ge) return ge;
            const be = pe.value && pe.value[Refs];
            be && fe.push(...be);
          }
        }
      }
    }
  });
}
const makeVMenuProps = propsFactory({
  // TODO
  // disableKeys: Boolean,
  id: String,
  submenu: Boolean,
  ...omit(makeVOverlayProps({
    closeDelay: 250,
    closeOnContentClick: !0,
    locationStrategy: "connected",
    location: void 0,
    openDelay: 300,
    scrim: !1,
    scrollStrategy: "reposition",
    transition: {
      component: VDialogTransition
    }
  }), ["absolute"])
}, "VMenu"), VMenu = genericComponent()({
  name: "VMenu",
  props: makeVMenuProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = useProxiedModel(re, "modelValue"), {
      scopeId: le
    } = useScopeId(), {
      isRtl: se
    } = useRtl(), ce = getUid(), ue = computed(() => re.id || `v-menu-${ce}`), de = ref$1(), me = inject(VMenuSymbol, null), fe = shallowRef(/* @__PURE__ */ new Set());
    provide(VMenuSymbol, {
      register() {
        fe.value.add(ce);
      },
      unregister() {
        fe.value.delete(ce);
      },
      closeParents(Ee) {
        setTimeout(() => {
          var Ve;
          !fe.value.size && !re.persistent && (Ee == null || (Ve = de.value) != null && Ve.contentEl && !isClickInsideElement(Ee, de.value.contentEl)) && (ie.value = !1, me == null || me.closeParents());
        }, 40);
      }
    }), onBeforeUnmount(() => {
      me == null || me.unregister(), document.removeEventListener("focusin", pe);
    }), onDeactivated(() => ie.value = !1);
    async function pe(Ee) {
      var Oe, Ne, He;
      const Ve = Ee.relatedTarget, Ae = Ee.target;
      await nextTick$2(), ie.value && Ve !== Ae && ((Oe = de.value) != null && Oe.contentEl) && // We're the topmost menu
      ((Ne = de.value) != null && Ne.globalTop) && // It isn't the document or the menu body
      ![document, de.value.contentEl].includes(Ae) && // It isn't inside the menu body
      !de.value.contentEl.contains(Ae) && ((He = focusableChildren(de.value.contentEl)[0]) == null || He.focus());
    }
    watch(ie, (Ee) => {
      Ee ? (me == null || me.register(), IN_BROWSER && document.addEventListener("focusin", pe, {
        once: !0
      })) : (me == null || me.unregister(), IN_BROWSER && document.removeEventListener("focusin", pe));
    }, {
      immediate: !0
    });
    function ge(Ee) {
      me == null || me.closeParents(Ee);
    }
    function be(Ee) {
      var Ve, Ae, Oe, Ne, He;
      if (!re.disabled)
        if (Ee.key === "Tab" || Ee.key === "Enter" && !re.closeOnContentClick) {
          if (Ee.key === "Enter" && (Ee.target instanceof HTMLTextAreaElement || Ee.target instanceof HTMLInputElement && Ee.target.closest("form"))) return;
          Ee.key === "Enter" && Ee.preventDefault(), getNextElement(focusableChildren((Ve = de.value) == null ? void 0 : Ve.contentEl, !1), Ee.shiftKey ? "prev" : "next", (Ze) => Ze.tabIndex >= 0) || (ie.value = !1, (Oe = (Ae = de.value) == null ? void 0 : Ae.activatorEl) == null || Oe.focus());
        } else re.submenu && Ee.key === (se.value ? "ArrowRight" : "ArrowLeft") && (ie.value = !1, (He = (Ne = de.value) == null ? void 0 : Ne.activatorEl) == null || He.focus());
    }
    function Se(Ee) {
      var Ae;
      if (re.disabled) return;
      const Ve = (Ae = de.value) == null ? void 0 : Ae.contentEl;
      Ve && ie.value ? Ee.key === "ArrowDown" ? (Ee.preventDefault(), Ee.stopImmediatePropagation(), focusChild(Ve, "next")) : Ee.key === "ArrowUp" ? (Ee.preventDefault(), Ee.stopImmediatePropagation(), focusChild(Ve, "prev")) : re.submenu && (Ee.key === (se.value ? "ArrowRight" : "ArrowLeft") ? ie.value = !1 : Ee.key === (se.value ? "ArrowLeft" : "ArrowRight") && (Ee.preventDefault(), focusChild(Ve, "first"))) : (re.submenu ? Ee.key === (se.value ? "ArrowLeft" : "ArrowRight") : ["ArrowDown", "ArrowUp"].includes(Ee.key)) && (ie.value = !0, Ee.preventDefault(), setTimeout(() => setTimeout(() => Se(Ee))));
    }
    const Pe = computed(() => mergeProps({
      "aria-haspopup": "menu",
      "aria-expanded": String(ie.value),
      "aria-controls": ue.value,
      onKeydown: Se
    }, re.activatorProps));
    return useRender(() => {
      const Ee = VOverlay.filterProps(re);
      return createVNode(VOverlay, mergeProps({
        ref: de,
        id: ue.value,
        class: ["v-menu", re.class],
        style: re.style
      }, Ee, {
        modelValue: ie.value,
        "onUpdate:modelValue": (Ve) => ie.value = Ve,
        absolute: !0,
        activatorProps: Pe.value,
        location: re.location ?? (re.submenu ? "end" : "bottom"),
        "onClick:outside": ge,
        onKeydown: be
      }, le), {
        activator: ae.activator,
        default: function() {
          for (var Ve = arguments.length, Ae = new Array(Ve), Oe = 0; Oe < Ve; Oe++)
            Ae[Oe] = arguments[Oe];
          return createVNode(VDefaultsProvider, {
            root: "VMenu"
          }, {
            default: () => {
              var Ne;
              return [(Ne = ae.default) == null ? void 0 : Ne.call(ae, ...Ae)];
            }
          });
        }
      });
    }), forwardRefs({
      id: ue,
      ΨopenChildren: fe
    }, de);
  }
}), makeVSheetProps = propsFactory({
  color: String,
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDimensionProps(),
  ...makeElevationProps(),
  ...makeLocationProps(),
  ...makePositionProps(),
  ...makeRoundedProps(),
  ...makeTagProps(),
  ...makeThemeProps()
}, "VSheet"), VSheet = genericComponent()({
  name: "VSheet",
  props: makeVSheetProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      themeClasses: ie
    } = provideTheme(re), {
      backgroundColorClasses: le,
      backgroundColorStyles: se
    } = useBackgroundColor(toRef(re, "color")), {
      borderClasses: ce
    } = useBorder(re), {
      dimensionStyles: ue
    } = useDimension(re), {
      elevationClasses: de
    } = useElevation(re), {
      locationStyles: me
    } = useLocation(re), {
      positionClasses: fe
    } = usePosition(re), {
      roundedClasses: pe
    } = useRounded(re);
    return useRender(() => createVNode(re.tag, {
      class: ["v-sheet", ie.value, le.value, ce.value, de.value, fe.value, pe.value, re.class],
      style: [se.value, ue.value, me.value, re.style]
    }, ae)), {};
  }
}), _sfc_main$X = {
  name: "CSHeaderProfile",
  extends: CSBase,
  props: {
    headerProfile: {
      type: CSHeaderProfileProps,
      required: !1,
      default: void 0
    },
    versionInUserProfile: {
      type: String,
      required: !1,
      default: void 0
    }
  },
  computed: {
    ...mapGetters({
      user: "cs-session/user"
    }),
    userInitials() {
      const re = this.headerProfile ? this.headerProfile.user : this.user, ne = (re == null ? void 0 : re.givenName) || (re == null ? void 0 : re.name) || "", ae = (re == null ? void 0 : re.surname) || "";
      return `${ne.substring(0, 1)}${ae.substring(0, 1)}`.toUpperCase();
    },
    userProfile() {
      if (this.headerProfile && this.headerProfile.user) {
        const { user: re } = this.headerProfile, ne = `${re.givenName} ${re.surname}`;
        return new User(void 0, void 0, re.email, ne);
      }
      return new User(void 0, void 0, this.user.email, this.user.getFullName());
    }
  },
  methods: {
    async logout() {
      this.setLoading(!0);
      try {
        this.headerProfile ? await this.headerProfile.actions.logout.action() : await this.$store.dispatch("cs-session/logout");
      } catch (re) {
        errorHandler(this, re);
      }
      this.clearLoading();
    }
  }
};
function _sfc_render$X(re, ne, ae, ie, le, se) {
  const ce = resolveComponent("cs-avatar"), ue = resolveComponent("cs-button"), de = resolveComponent("cs-user-profile");
  return openBlock(), createBlock(VMenu, {
    class: "cs-header-profile",
    eager: "",
    location: "bottom",
    transition: "slide-y-reverse-transition",
    "close-on-content-click": !1
  }, {
    activator: withCtx(({ props: me }) => [
      createVNode(ce, mergeProps(me, {
        initials: se.userInitials,
        picture: re.user && re.user.picture || ""
      }), null, 16, ["initials", "picture"])
    ]),
    default: withCtx(() => [
      createVNode(VSheet, null, {
        default: withCtx(() => [
          createVNode(de, {
            user: se.userProfile,
            "version-in-user-profile": ae.versionInUserProfile,
            class: "pa-1"
          }, {
            avatar: withCtx(() => [
              createVNode(ce, {
                initials: se.userInitials,
                picture: re.user && re.user.picture || ""
              }, null, 8, ["initials", "picture"])
            ]),
            action: withCtx(() => [
              createVNode(ue, {
                id: "logout-btn",
                label: re.$t("cs.header.logoutButtonText"),
                color: "primary",
                loading: re.loading,
                onClick: se.logout
              }, null, 8, ["label", "loading", "onClick"])
            ]),
            _: 1
          }, 8, ["user", "version-in-user-profile"])
        ]),
        _: 1
      })
    ]),
    _: 1
  });
}
const CSHeaderProfile = /* @__PURE__ */ _export_sfc(_sfc_main$X, [["render", _sfc_render$X], ["__scopeId", "data-v-933054da"]]), makeVToolbarTitleProps = propsFactory({
  text: String,
  ...makeComponentProps(),
  ...makeTagProps()
}, "VToolbarTitle"), VToolbarTitle = genericComponent()({
  name: "VToolbarTitle",
  props: makeVToolbarTitleProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    return useRender(() => {
      const ie = !!(ae.default || ae.text || re.text);
      return createVNode(re.tag, {
        class: ["v-toolbar-title", re.class],
        style: re.style
      }, {
        default: () => {
          var le;
          return [ie && createVNode("div", {
            class: "v-toolbar-title__placeholder"
          }, [ae.text ? ae.text() : re.text, (le = ae.default) == null ? void 0 : le.call(ae)])];
        }
      });
    }), {};
  }
});
function useAspectStyles(re) {
  return {
    aspectStyles: computed(() => {
      const ne = Number(re.aspectRatio);
      return ne ? {
        paddingBottom: String(1 / ne * 100) + "%"
      } : void 0;
    })
  };
}
const makeVResponsiveProps = propsFactory({
  aspectRatio: [String, Number],
  contentClass: null,
  inline: Boolean,
  ...makeComponentProps(),
  ...makeDimensionProps()
}, "VResponsive"), VResponsive = genericComponent()({
  name: "VResponsive",
  props: makeVResponsiveProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      aspectStyles: ie
    } = useAspectStyles(re), {
      dimensionStyles: le
    } = useDimension(re);
    return useRender(() => {
      var se;
      return createVNode("div", {
        class: ["v-responsive", {
          "v-responsive--inline": re.inline
        }, re.class],
        style: [le.value, re.style]
      }, [createVNode("div", {
        class: "v-responsive__sizer",
        style: ie.value
      }, null), (se = ae.additional) == null ? void 0 : se.call(ae), ae.default && createVNode("div", {
        class: ["v-responsive__content", re.contentClass]
      }, [ae.default()])]);
    }), {};
  }
});
function mounted$4(re, ne) {
  if (!SUPPORTS_INTERSECTION) return;
  const ae = ne.modifiers || {}, ie = ne.value, {
    handler: le,
    options: se
  } = typeof ie == "object" ? ie : {
    handler: ie,
    options: {}
  }, ce = new IntersectionObserver(function() {
    var pe;
    let ue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], de = arguments.length > 1 ? arguments[1] : void 0;
    const me = (pe = re._observe) == null ? void 0 : pe[ne.instance.$.uid];
    if (!me) return;
    const fe = ue.some((ge) => ge.isIntersecting);
    le && (!ae.quiet || me.init) && (!ae.once || fe || me.init) && le(fe, ue, de), fe && ae.once ? unmounted$4(re, ne) : me.init = !0;
  }, se);
  re._observe = Object(re._observe), re._observe[ne.instance.$.uid] = {
    init: !1,
    observer: ce
  }, ce.observe(re);
}
function unmounted$4(re, ne) {
  var ie;
  const ae = (ie = re._observe) == null ? void 0 : ie[ne.instance.$.uid];
  ae && (ae.observer.unobserve(re), delete re._observe[ne.instance.$.uid]);
}
const Intersect = {
  mounted: mounted$4,
  unmounted: unmounted$4
}, makeVImgProps = propsFactory({
  absolute: Boolean,
  alt: String,
  cover: Boolean,
  color: String,
  draggable: {
    type: [Boolean, String],
    default: void 0
  },
  eager: Boolean,
  gradient: String,
  lazySrc: String,
  options: {
    type: Object,
    // For more information on types, navigate to:
    // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
    default: () => ({
      root: void 0,
      rootMargin: void 0,
      threshold: void 0
    })
  },
  sizes: String,
  src: {
    type: [String, Object],
    default: ""
  },
  crossorigin: String,
  referrerpolicy: String,
  srcset: String,
  position: String,
  ...makeVResponsiveProps(),
  ...makeComponentProps(),
  ...makeRoundedProps(),
  ...makeTransitionProps()
}, "VImg"), VImg = genericComponent()({
  name: "VImg",
  directives: {
    intersect: Intersect
  },
  props: makeVImgProps(),
  emits: {
    loadstart: (re) => !0,
    load: (re) => !0,
    error: (re) => !0
  },
  setup(re, ne) {
    let {
      emit: ae,
      slots: ie
    } = ne;
    const {
      backgroundColorClasses: le,
      backgroundColorStyles: se
    } = useBackgroundColor(toRef(re, "color")), {
      roundedClasses: ce
    } = useRounded(re), ue = getCurrentInstance("VImg"), de = shallowRef(""), me = ref$1(), fe = shallowRef(re.eager ? "loading" : "idle"), pe = shallowRef(), ge = shallowRef(), be = computed(() => re.src && typeof re.src == "object" ? {
      src: re.src.src,
      srcset: re.srcset || re.src.srcset,
      lazySrc: re.lazySrc || re.src.lazySrc,
      aspect: Number(re.aspectRatio || re.src.aspect || 0)
    } : {
      src: re.src,
      srcset: re.srcset,
      lazySrc: re.lazySrc,
      aspect: Number(re.aspectRatio || 0)
    }), Se = computed(() => be.value.aspect || pe.value / ge.value || 0);
    watch(() => re.src, () => {
      Pe(fe.value !== "idle");
    }), watch(Se, (Ce, _e) => {
      !Ce && _e && me.value && Ne(me.value);
    }), onBeforeMount(() => Pe());
    function Pe(Ce) {
      if (!(re.eager && Ce) && !(SUPPORTS_INTERSECTION && !Ce && !re.eager)) {
        if (fe.value = "loading", be.value.lazySrc) {
          const _e = new Image();
          _e.src = be.value.lazySrc, Ne(_e, null);
        }
        be.value.src && nextTick$2(() => {
          var _e;
          ae("loadstart", ((_e = me.value) == null ? void 0 : _e.currentSrc) || be.value.src), setTimeout(() => {
            var he;
            if (!ue.isUnmounted)
              if ((he = me.value) != null && he.complete) {
                if (me.value.naturalWidth || Ve(), fe.value === "error") return;
                Se.value || Ne(me.value, null), fe.value === "loading" && Ee();
              } else
                Se.value || Ne(me.value), Ae();
          });
        });
      }
    }
    function Ee() {
      var Ce;
      ue.isUnmounted || (Ae(), Ne(me.value), fe.value = "loaded", ae("load", ((Ce = me.value) == null ? void 0 : Ce.currentSrc) || be.value.src));
    }
    function Ve() {
      var Ce;
      ue.isUnmounted || (fe.value = "error", ae("error", ((Ce = me.value) == null ? void 0 : Ce.currentSrc) || be.value.src));
    }
    function Ae() {
      const Ce = me.value;
      Ce && (de.value = Ce.currentSrc || Ce.src);
    }
    let Oe = -1;
    onBeforeUnmount(() => {
      clearTimeout(Oe);
    });
    function Ne(Ce) {
      let _e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
      const he = () => {
        if (clearTimeout(Oe), ue.isUnmounted) return;
        const {
          naturalHeight: ve,
          naturalWidth: xe
        } = Ce;
        ve || xe ? (pe.value = xe, ge.value = ve) : !Ce.complete && fe.value === "loading" && _e != null ? Oe = window.setTimeout(he, _e) : (Ce.currentSrc.endsWith(".svg") || Ce.currentSrc.startsWith("data:image/svg+xml")) && (pe.value = 1, ge.value = 1);
      };
      he();
    }
    const He = computed(() => ({
      "v-img__img--cover": re.cover,
      "v-img__img--contain": !re.cover
    })), Ue = () => {
      var he;
      if (!be.value.src || fe.value === "idle") return null;
      const Ce = createVNode("img", {
        class: ["v-img__img", He.value],
        style: {
          objectPosition: re.position
        },
        crossorigin: re.crossorigin,
        src: be.value.src,
        srcset: be.value.srcset,
        alt: re.alt,
        referrerpolicy: re.referrerpolicy,
        draggable: re.draggable,
        sizes: re.sizes,
        ref: me,
        onLoad: Ee,
        onError: Ve
      }, null), _e = (he = ie.sources) == null ? void 0 : he.call(ie);
      return createVNode(MaybeTransition, {
        transition: re.transition,
        appear: !0
      }, {
        default: () => [withDirectives(_e ? createVNode("picture", {
          class: "v-img__picture"
        }, [_e, Ce]) : Ce, [[vShow, fe.value === "loaded"]])]
      });
    }, Ze = () => createVNode(MaybeTransition, {
      transition: re.transition
    }, {
      default: () => [be.value.lazySrc && fe.value !== "loaded" && createVNode("img", {
        class: ["v-img__img", "v-img__img--preload", He.value],
        style: {
          objectPosition: re.position
        },
        crossorigin: re.crossorigin,
        src: be.value.lazySrc,
        alt: re.alt,
        referrerpolicy: re.referrerpolicy,
        draggable: re.draggable
      }, null)]
    }), Fe = () => ie.placeholder ? createVNode(MaybeTransition, {
      transition: re.transition,
      appear: !0
    }, {
      default: () => [(fe.value === "loading" || fe.value === "error" && !ie.error) && createVNode("div", {
        class: "v-img__placeholder"
      }, [ie.placeholder()])]
    }) : null, Ke = () => ie.error ? createVNode(MaybeTransition, {
      transition: re.transition,
      appear: !0
    }, {
      default: () => [fe.value === "error" && createVNode("div", {
        class: "v-img__error"
      }, [ie.error()])]
    }) : null, tt = () => re.gradient ? createVNode("div", {
      class: "v-img__gradient",
      style: {
        backgroundImage: `linear-gradient(${re.gradient})`
      }
    }, null) : null, Re = shallowRef(!1);
    {
      const Ce = watch(Se, (_e) => {
        _e && (requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            Re.value = !0;
          });
        }), Ce());
      });
    }
    return useRender(() => {
      const Ce = VResponsive.filterProps(re);
      return withDirectives(createVNode(VResponsive, mergeProps({
        class: ["v-img", {
          "v-img--absolute": re.absolute,
          "v-img--booting": !Re.value
        }, le.value, ce.value, re.class],
        style: [{
          width: convertToUnit(re.width === "auto" ? pe.value : re.width)
        }, se.value, re.style]
      }, Ce, {
        aspectRatio: Se.value,
        "aria-label": re.alt,
        role: re.alt ? "img" : void 0
      }), {
        additional: () => createVNode(Fragment, null, [createVNode(Ue, null, null), createVNode(Ze, null, null), createVNode(tt, null, null), createVNode(Fe, null, null), createVNode(Ke, null, null)]),
        default: ie.default
      }), [[resolveDirective("intersect"), {
        handler: Pe,
        options: re.options
      }, null, {
        once: !0
      }]]);
    }), {
      currentSrc: de,
      image: me,
      state: fe,
      naturalWidth: pe,
      naturalHeight: ge
    };
  }
}), allowedDensities = [null, "prominent", "default", "comfortable", "compact"], makeVToolbarProps = propsFactory({
  absolute: Boolean,
  collapse: Boolean,
  color: String,
  density: {
    type: String,
    default: "default",
    validator: (re) => allowedDensities.includes(re)
  },
  extended: Boolean,
  extensionHeight: {
    type: [Number, String],
    default: 48
  },
  flat: Boolean,
  floating: Boolean,
  height: {
    type: [Number, String],
    default: 64
  },
  image: String,
  title: String,
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeElevationProps(),
  ...makeRoundedProps(),
  ...makeTagProps({
    tag: "header"
  }),
  ...makeThemeProps()
}, "VToolbar"), VToolbar = genericComponent()({
  name: "VToolbar",
  props: makeVToolbarProps(),
  setup(re, ne) {
    var be;
    let {
      slots: ae
    } = ne;
    const {
      backgroundColorClasses: ie,
      backgroundColorStyles: le
    } = useBackgroundColor(toRef(re, "color")), {
      borderClasses: se
    } = useBorder(re), {
      elevationClasses: ce
    } = useElevation(re), {
      roundedClasses: ue
    } = useRounded(re), {
      themeClasses: de
    } = provideTheme(re), {
      rtlClasses: me
    } = useRtl(), fe = shallowRef(!!(re.extended || (be = ae.extension) != null && be.call(ae))), pe = computed(() => parseInt(Number(re.height) + (re.density === "prominent" ? Number(re.height) : 0) - (re.density === "comfortable" ? 8 : 0) - (re.density === "compact" ? 16 : 0), 10)), ge = computed(() => fe.value ? parseInt(Number(re.extensionHeight) + (re.density === "prominent" ? Number(re.extensionHeight) : 0) - (re.density === "comfortable" ? 4 : 0) - (re.density === "compact" ? 8 : 0), 10) : 0);
    return provideDefaults({
      VBtn: {
        variant: "text"
      }
    }), useRender(() => {
      var Ve;
      const Se = !!(re.title || ae.title), Pe = !!(ae.image || re.image), Ee = (Ve = ae.extension) == null ? void 0 : Ve.call(ae);
      return fe.value = !!(re.extended || Ee), createVNode(re.tag, {
        class: ["v-toolbar", {
          "v-toolbar--absolute": re.absolute,
          "v-toolbar--collapse": re.collapse,
          "v-toolbar--flat": re.flat,
          "v-toolbar--floating": re.floating,
          [`v-toolbar--density-${re.density}`]: !0
        }, ie.value, se.value, ce.value, ue.value, de.value, me.value, re.class],
        style: [le.value, re.style]
      }, {
        default: () => [Pe && createVNode("div", {
          key: "image",
          class: "v-toolbar__image"
        }, [ae.image ? createVNode(VDefaultsProvider, {
          key: "image-defaults",
          disabled: !re.image,
          defaults: {
            VImg: {
              cover: !0,
              src: re.image
            }
          }
        }, ae.image) : createVNode(VImg, {
          key: "image-img",
          cover: !0,
          src: re.image
        }, null)]), createVNode(VDefaultsProvider, {
          defaults: {
            VTabs: {
              height: convertToUnit(pe.value)
            }
          }
        }, {
          default: () => {
            var Ae, Oe, Ne;
            return [createVNode("div", {
              class: "v-toolbar__content",
              style: {
                height: convertToUnit(pe.value)
              }
            }, [ae.prepend && createVNode("div", {
              class: "v-toolbar__prepend"
            }, [(Ae = ae.prepend) == null ? void 0 : Ae.call(ae)]), Se && createVNode(VToolbarTitle, {
              key: "title",
              text: re.title
            }, {
              text: ae.title
            }), (Oe = ae.default) == null ? void 0 : Oe.call(ae), ae.append && createVNode("div", {
              class: "v-toolbar__append"
            }, [(Ne = ae.append) == null ? void 0 : Ne.call(ae)])])];
          }
        }), createVNode(VDefaultsProvider, {
          defaults: {
            VTabs: {
              height: convertToUnit(ge.value)
            }
          }
        }, {
          default: () => [createVNode(VExpandTransition, null, {
            default: () => [fe.value && createVNode("div", {
              class: "v-toolbar__extension",
              style: {
                height: convertToUnit(ge.value)
              }
            }, [Ee])]
          })]
        })]
      });
    }), {
      contentHeight: pe,
      extensionHeight: ge
    };
  }
}), VuetifyLayoutKey = Symbol.for("vuetify:layout"), VuetifyLayoutItemKey = Symbol.for("vuetify:layout-item"), ROOT_ZINDEX = 1e3, makeLayoutProps = propsFactory({
  overlaps: {
    type: Array,
    default: () => []
  },
  fullHeight: Boolean
}, "layout"), makeLayoutItemProps = propsFactory({
  name: {
    type: String
  },
  order: {
    type: [Number, String],
    default: 0
  },
  absolute: Boolean
}, "layout-item");
function useLayout() {
  const re = inject(VuetifyLayoutKey);
  if (!re) throw new Error("[Vuetify] Could not find injected layout");
  return {
    getLayoutItem: re.getLayoutItem,
    mainRect: re.mainRect,
    mainStyles: re.mainStyles
  };
}
function useLayoutItem(re) {
  const ne = inject(VuetifyLayoutKey);
  if (!ne) throw new Error("[Vuetify] Could not find injected layout");
  const ae = re.id ?? `layout-item-${getUid()}`, ie = getCurrentInstance("useLayoutItem");
  provide(VuetifyLayoutItemKey, {
    id: ae
  });
  const le = shallowRef(!1);
  onDeactivated(() => le.value = !0), onActivated(() => le.value = !1);
  const {
    layoutItemStyles: se,
    layoutItemScrimStyles: ce
  } = ne.register(ie, {
    ...re,
    active: computed(() => le.value ? !1 : re.active.value),
    id: ae
  });
  return onBeforeUnmount(() => ne.unregister(ae)), {
    layoutItemStyles: se,
    layoutRect: ne.layoutRect,
    layoutItemScrimStyles: ce
  };
}
const generateLayers = (re, ne, ae, ie) => {
  let le = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  };
  const se = [{
    id: "",
    layer: {
      ...le
    }
  }];
  for (const ce of re) {
    const ue = ne.get(ce), de = ae.get(ce), me = ie.get(ce);
    if (!ue || !de || !me) continue;
    const fe = {
      ...le,
      [ue.value]: parseInt(le[ue.value], 10) + (me.value ? parseInt(de.value, 10) : 0)
    };
    se.push({
      id: ce,
      layer: fe
    }), le = fe;
  }
  return se;
};
function createLayout(re) {
  const ne = inject(VuetifyLayoutKey, null), ae = computed(() => ne ? ne.rootZIndex.value - 100 : ROOT_ZINDEX), ie = ref$1([]), le = reactive(/* @__PURE__ */ new Map()), se = reactive(/* @__PURE__ */ new Map()), ce = reactive(/* @__PURE__ */ new Map()), ue = reactive(/* @__PURE__ */ new Map()), de = reactive(/* @__PURE__ */ new Map()), {
    resizeRef: me,
    contentRect: fe
  } = useResizeObserver(), pe = computed(() => {
    const Ue = /* @__PURE__ */ new Map(), Ze = re.overlaps ?? [];
    for (const Fe of Ze.filter((Ke) => Ke.includes(":"))) {
      const [Ke, tt] = Fe.split(":");
      if (!ie.value.includes(Ke) || !ie.value.includes(tt)) continue;
      const Re = le.get(Ke), Ce = le.get(tt), _e = se.get(Ke), he = se.get(tt);
      !Re || !Ce || !_e || !he || (Ue.set(tt, {
        position: Re.value,
        amount: parseInt(_e.value, 10)
      }), Ue.set(Ke, {
        position: Ce.value,
        amount: -parseInt(he.value, 10)
      }));
    }
    return Ue;
  }), ge = computed(() => {
    const Ue = [...new Set([...ce.values()].map((Fe) => Fe.value))].sort((Fe, Ke) => Fe - Ke), Ze = [];
    for (const Fe of Ue) {
      const Ke = ie.value.filter((tt) => {
        var Re;
        return ((Re = ce.get(tt)) == null ? void 0 : Re.value) === Fe;
      });
      Ze.push(...Ke);
    }
    return generateLayers(Ze, le, se, ue);
  }), be = computed(() => !Array.from(de.values()).some((Ue) => Ue.value)), Se = computed(() => ge.value[ge.value.length - 1].layer), Pe = computed(() => ({
    "--v-layout-left": convertToUnit(Se.value.left),
    "--v-layout-right": convertToUnit(Se.value.right),
    "--v-layout-top": convertToUnit(Se.value.top),
    "--v-layout-bottom": convertToUnit(Se.value.bottom),
    ...be.value ? void 0 : {
      transition: "none"
    }
  })), Ee = computed(() => ge.value.slice(1).map((Ue, Ze) => {
    let {
      id: Fe
    } = Ue;
    const {
      layer: Ke
    } = ge.value[Ze], tt = se.get(Fe), Re = le.get(Fe);
    return {
      id: Fe,
      ...Ke,
      size: Number(tt.value),
      position: Re.value
    };
  })), Ve = (Ue) => Ee.value.find((Ze) => Ze.id === Ue), Ae = getCurrentInstance("createLayout"), Oe = shallowRef(!1);
  onMounted(() => {
    Oe.value = !0;
  }), provide(VuetifyLayoutKey, {
    register: (Ue, Ze) => {
      let {
        id: Fe,
        order: Ke,
        position: tt,
        layoutSize: Re,
        elementSize: Ce,
        active: _e,
        disableTransitions: he,
        absolute: ve
      } = Ze;
      ce.set(Fe, Ke), le.set(Fe, tt), se.set(Fe, Re), ue.set(Fe, _e), he && de.set(Fe, he);
      const $e = findChildrenWithProvide(VuetifyLayoutItemKey, Ae == null ? void 0 : Ae.vnode).indexOf(Ue);
      $e > -1 ? ie.value.splice($e, 0, Fe) : ie.value.push(Fe);
      const Te = computed(() => Ee.value.findIndex((ye) => ye.id === Fe)), Ie = computed(() => ae.value + ge.value.length * 2 - Te.value * 2), we = computed(() => {
        const ye = tt.value === "left" || tt.value === "right", Be = tt.value === "right", Xe = tt.value === "bottom", et = Ce.value ?? Re.value, Ye = et === 0 ? "%" : "px", De = {
          [tt.value]: 0,
          zIndex: Ie.value,
          transform: `translate${ye ? "X" : "Y"}(${(_e.value ? 0 : -(et === 0 ? 100 : et)) * (Be || Xe ? -1 : 1)}${Ye})`,
          position: ve.value || ae.value !== ROOT_ZINDEX ? "absolute" : "fixed",
          ...be.value ? void 0 : {
            transition: "none"
          }
        };
        if (!Oe.value) return De;
        const je = Ee.value[Te.value];
        if (!je) throw new Error(`[Vuetify] Could not find layout item "${Fe}"`);
        const rt = pe.value.get(Fe);
        return rt && (je[rt.position] += rt.amount), {
          ...De,
          height: ye ? `calc(100% - ${je.top}px - ${je.bottom}px)` : Ce.value ? `${Ce.value}px` : void 0,
          left: Be ? void 0 : `${je.left}px`,
          right: Be ? `${je.right}px` : void 0,
          top: tt.value !== "bottom" ? `${je.top}px` : void 0,
          bottom: tt.value !== "top" ? `${je.bottom}px` : void 0,
          width: ye ? Ce.value ? `${Ce.value}px` : void 0 : `calc(100% - ${je.left}px - ${je.right}px)`
        };
      }), ke = computed(() => ({
        zIndex: Ie.value - 1
      }));
      return {
        layoutItemStyles: we,
        layoutItemScrimStyles: ke,
        zIndex: Ie
      };
    },
    unregister: (Ue) => {
      ce.delete(Ue), le.delete(Ue), se.delete(Ue), ue.delete(Ue), de.delete(Ue), ie.value = ie.value.filter((Ze) => Ze !== Ue);
    },
    mainRect: Se,
    mainStyles: Pe,
    getLayoutItem: Ve,
    items: Ee,
    layoutRect: fe,
    rootZIndex: ae
  });
  const Ne = computed(() => ["v-layout", {
    "v-layout--full-height": re.fullHeight
  }]), He = computed(() => ({
    zIndex: ne ? ae.value : void 0,
    position: ne ? "relative" : void 0,
    overflow: ne ? "hidden" : void 0
  }));
  return {
    layoutClasses: Ne,
    layoutStyles: He,
    getLayoutItem: Ve,
    items: Ee,
    layoutRect: fe,
    layoutRef: me
  };
}
const makeScrollProps = propsFactory({
  scrollTarget: {
    type: String
  },
  scrollThreshold: {
    type: [String, Number],
    default: 300
  }
}, "scroll");
function useScroll(re) {
  let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    canScroll: ae
  } = ne;
  let ie = 0, le = 0;
  const se = ref$1(null), ce = shallowRef(0), ue = shallowRef(0), de = shallowRef(0), me = shallowRef(!1), fe = shallowRef(!1), pe = computed(() => Number(re.scrollThreshold)), ge = computed(() => clamp((pe.value - ce.value) / pe.value || 0)), be = () => {
    const Se = se.value;
    if (!Se || ae && !ae.value) return;
    ie = ce.value, ce.value = "window" in Se ? Se.pageYOffset : Se.scrollTop;
    const Pe = Se instanceof Window ? document.documentElement.scrollHeight : Se.scrollHeight;
    if (le !== Pe) {
      le = Pe;
      return;
    }
    fe.value = ce.value < ie, de.value = Math.abs(ce.value - pe.value);
  };
  return watch(fe, () => {
    ue.value = ue.value || ce.value;
  }), watch(me, () => {
    ue.value = 0;
  }), onMounted(() => {
    watch(() => re.scrollTarget, (Se) => {
      var Ee;
      const Pe = Se ? document.querySelector(Se) : window;
      if (!Pe) {
        consoleWarn(`Unable to locate element with identifier ${Se}`);
        return;
      }
      Pe !== se.value && ((Ee = se.value) == null || Ee.removeEventListener("scroll", be), se.value = Pe, se.value.addEventListener("scroll", be, {
        passive: !0
      }));
    }, {
      immediate: !0
    });
  }), onBeforeUnmount(() => {
    var Se;
    (Se = se.value) == null || Se.removeEventListener("scroll", be);
  }), ae && watch(ae, be, {
    immediate: !0
  }), {
    scrollThreshold: pe,
    currentScroll: ce,
    currentThreshold: de,
    isScrollActive: me,
    scrollRatio: ge,
    // required only for testing
    // probably can be removed
    // later (2 chars chlng)
    isScrollingUp: fe,
    savedScroll: ue
  };
}
function useSsrBoot() {
  const re = shallowRef(!1);
  return onMounted(() => {
    window.requestAnimationFrame(() => {
      re.value = !0;
    });
  }), {
    ssrBootStyles: computed(() => re.value ? void 0 : {
      transition: "none !important"
    }),
    isBooted: readonly(re)
  };
}
const makeVAppBarProps = propsFactory({
  scrollBehavior: String,
  modelValue: {
    type: Boolean,
    default: !0
  },
  location: {
    type: String,
    default: "top",
    validator: (re) => ["top", "bottom"].includes(re)
  },
  ...makeVToolbarProps(),
  ...makeLayoutItemProps(),
  ...makeScrollProps(),
  height: {
    type: [Number, String],
    default: 64
  }
}, "VAppBar"), VAppBar = genericComponent()({
  name: "VAppBar",
  props: makeVAppBarProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = ref$1(), le = useProxiedModel(re, "modelValue"), se = computed(() => {
      var Oe;
      const Ae = new Set(((Oe = re.scrollBehavior) == null ? void 0 : Oe.split(" ")) ?? []);
      return {
        hide: Ae.has("hide"),
        fullyHide: Ae.has("fully-hide"),
        inverted: Ae.has("inverted"),
        collapse: Ae.has("collapse"),
        elevate: Ae.has("elevate"),
        fadeImage: Ae.has("fade-image")
        // shrink: behavior.has('shrink'),
      };
    }), ce = computed(() => {
      const Ae = se.value;
      return Ae.hide || Ae.fullyHide || Ae.inverted || Ae.collapse || Ae.elevate || Ae.fadeImage || // behavior.shrink ||
      !le.value;
    }), {
      currentScroll: ue,
      scrollThreshold: de,
      isScrollingUp: me,
      scrollRatio: fe
    } = useScroll(re, {
      canScroll: ce
    }), pe = computed(() => se.value.hide || se.value.fullyHide), ge = computed(() => re.collapse || se.value.collapse && (se.value.inverted ? fe.value > 0 : fe.value === 0)), be = computed(() => re.flat || se.value.fullyHide && !le.value || se.value.elevate && (se.value.inverted ? ue.value > 0 : ue.value === 0)), Se = computed(() => se.value.fadeImage ? se.value.inverted ? 1 - fe.value : fe.value : void 0), Pe = computed(() => {
      var Ne, He;
      if (se.value.hide && se.value.inverted) return 0;
      const Ae = ((Ne = ie.value) == null ? void 0 : Ne.contentHeight) ?? 0, Oe = ((He = ie.value) == null ? void 0 : He.extensionHeight) ?? 0;
      return pe.value ? ue.value < de.value || se.value.fullyHide ? Ae + Oe : Ae : Ae + Oe;
    });
    useToggleScope(computed(() => !!re.scrollBehavior), () => {
      watchEffect(() => {
        pe.value ? se.value.inverted ? le.value = ue.value > de.value : le.value = me.value || ue.value < de.value : le.value = !0;
      });
    });
    const {
      ssrBootStyles: Ee
    } = useSsrBoot(), {
      layoutItemStyles: Ve
    } = useLayoutItem({
      id: re.name,
      order: computed(() => parseInt(re.order, 10)),
      position: toRef(re, "location"),
      layoutSize: Pe,
      elementSize: shallowRef(void 0),
      active: le,
      absolute: toRef(re, "absolute")
    });
    return useRender(() => {
      const Ae = VToolbar.filterProps(re);
      return createVNode(VToolbar, mergeProps({
        ref: ie,
        class: ["v-app-bar", {
          "v-app-bar--bottom": re.location === "bottom"
        }, re.class],
        style: [{
          ...Ve.value,
          "--v-toolbar-image-opacity": Se.value,
          height: void 0,
          ...Ee.value
        }, re.style]
      }, Ae, {
        collapse: ge.value,
        flat: be.value
      }), ae);
    }), {};
  }
}), makeVAppBarNavIconProps = propsFactory({
  ...makeVBtnProps({
    icon: "$menu",
    variant: "text"
  })
}, "VAppBarNavIcon"), VAppBarNavIcon = genericComponent()({
  name: "VAppBarNavIcon",
  props: makeVAppBarNavIconProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    return useRender(() => createVNode(VBtn, mergeProps(re, {
      class: ["v-app-bar-nav-icon"]
    }), ae)), {};
  }
}), VAppBarTitle = genericComponent()({
  name: "VAppBarTitle",
  props: makeVToolbarTitleProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    return useRender(() => createVNode(VToolbarTitle, mergeProps(re, {
      class: "v-app-bar-title"
    }), ae)), {};
  }
}), makeVContainerProps = propsFactory({
  fluid: {
    type: Boolean,
    default: !1
  },
  ...makeComponentProps(),
  ...makeDimensionProps(),
  ...makeTagProps()
}, "VContainer"), VContainer = genericComponent()({
  name: "VContainer",
  props: makeVContainerProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      rtlClasses: ie
    } = useRtl(), {
      dimensionStyles: le
    } = useDimension(re);
    return useRender(() => createVNode(re.tag, {
      class: ["v-container", {
        "v-container--fluid": re.fluid
      }, ie.value, re.class],
      style: [le.value, re.style]
    }, ae)), {};
  }
}), breakpointProps = breakpoints.reduce((re, ne) => (re[ne] = {
  type: [Boolean, String, Number],
  default: !1
}, re), {}), offsetProps = breakpoints.reduce((re, ne) => {
  const ae = "offset" + capitalize$1(ne);
  return re[ae] = {
    type: [String, Number],
    default: null
  }, re;
}, {}), orderProps = breakpoints.reduce((re, ne) => {
  const ae = "order" + capitalize$1(ne);
  return re[ae] = {
    type: [String, Number],
    default: null
  }, re;
}, {}), propMap$1 = {
  col: Object.keys(breakpointProps),
  offset: Object.keys(offsetProps),
  order: Object.keys(orderProps)
};
function breakpointClass$1(re, ne, ae) {
  let ie = re;
  if (!(ae == null || ae === !1)) {
    if (ne) {
      const le = ne.replace(re, "");
      ie += `-${le}`;
    }
    return re === "col" && (ie = "v-" + ie), re === "col" && (ae === "" || ae === !0) || (ie += `-${ae}`), ie.toLowerCase();
  }
}
const ALIGN_SELF_VALUES = ["auto", "start", "end", "center", "baseline", "stretch"], makeVColProps = propsFactory({
  cols: {
    type: [Boolean, String, Number],
    default: !1
  },
  ...breakpointProps,
  offset: {
    type: [String, Number],
    default: null
  },
  ...offsetProps,
  order: {
    type: [String, Number],
    default: null
  },
  ...orderProps,
  alignSelf: {
    type: String,
    default: null,
    validator: (re) => ALIGN_SELF_VALUES.includes(re)
  },
  ...makeComponentProps(),
  ...makeTagProps()
}, "VCol"), VCol = genericComponent()({
  name: "VCol",
  props: makeVColProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = computed(() => {
      const le = [];
      let se;
      for (se in propMap$1)
        propMap$1[se].forEach((ue) => {
          const de = re[ue], me = breakpointClass$1(se, ue, de);
          me && le.push(me);
        });
      const ce = le.some((ue) => ue.startsWith("v-col-"));
      return le.push({
        // Default to .v-col if no other col-{bp}-* classes generated nor `cols` specified.
        "v-col": !ce || !re.cols,
        [`v-col-${re.cols}`]: re.cols,
        [`offset-${re.offset}`]: re.offset,
        [`order-${re.order}`]: re.order,
        [`align-self-${re.alignSelf}`]: re.alignSelf
      }), le;
    });
    return () => {
      var le;
      return h$1(re.tag, {
        class: [ie.value, re.class],
        style: re.style
      }, (le = ae.default) == null ? void 0 : le.call(ae));
    };
  }
}), ALIGNMENT = ["start", "end", "center"], SPACE = ["space-between", "space-around", "space-evenly"];
function makeRowProps(re, ne) {
  return breakpoints.reduce((ae, ie) => {
    const le = re + capitalize$1(ie);
    return ae[le] = ne(), ae;
  }, {});
}
const ALIGN_VALUES = [...ALIGNMENT, "baseline", "stretch"], alignValidator = (re) => ALIGN_VALUES.includes(re), alignProps = makeRowProps("align", () => ({
  type: String,
  default: null,
  validator: alignValidator
})), JUSTIFY_VALUES = [...ALIGNMENT, ...SPACE], justifyValidator = (re) => JUSTIFY_VALUES.includes(re), justifyProps = makeRowProps("justify", () => ({
  type: String,
  default: null,
  validator: justifyValidator
})), ALIGN_CONTENT_VALUES = [...ALIGNMENT, ...SPACE, "stretch"], alignContentValidator = (re) => ALIGN_CONTENT_VALUES.includes(re), alignContentProps = makeRowProps("alignContent", () => ({
  type: String,
  default: null,
  validator: alignContentValidator
})), propMap = {
  align: Object.keys(alignProps),
  justify: Object.keys(justifyProps),
  alignContent: Object.keys(alignContentProps)
}, classMap = {
  align: "align",
  justify: "justify",
  alignContent: "align-content"
};
function breakpointClass(re, ne, ae) {
  let ie = classMap[re];
  if (ae != null) {
    if (ne) {
      const le = ne.replace(re, "");
      ie += `-${le}`;
    }
    return ie += `-${ae}`, ie.toLowerCase();
  }
}
const makeVRowProps = propsFactory({
  dense: Boolean,
  noGutters: Boolean,
  align: {
    type: String,
    default: null,
    validator: alignValidator
  },
  ...alignProps,
  justify: {
    type: String,
    default: null,
    validator: justifyValidator
  },
  ...justifyProps,
  alignContent: {
    type: String,
    default: null,
    validator: alignContentValidator
  },
  ...alignContentProps,
  ...makeComponentProps(),
  ...makeTagProps()
}, "VRow"), VRow = genericComponent()({
  name: "VRow",
  props: makeVRowProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = computed(() => {
      const le = [];
      let se;
      for (se in propMap)
        propMap[se].forEach((ce) => {
          const ue = re[ce], de = breakpointClass(se, ce, ue);
          de && le.push(de);
        });
      return le.push({
        "v-row--no-gutters": re.noGutters,
        "v-row--dense": re.dense,
        [`align-${re.align}`]: re.align,
        [`justify-${re.justify}`]: re.justify,
        [`align-content-${re.alignContent}`]: re.alignContent
      }), le;
    });
    return () => {
      var le;
      return h$1(re.tag, {
        class: ["v-row", ie.value, re.class],
        style: re.style
      }, (le = ae.default) == null ? void 0 : le.call(ae));
    };
  }
}), VSpacer = createSimpleFunctional("v-spacer", "div", "VSpacer"), _sfc_main$W = {
  name: "CSHeader",
  components: { "cs-header-profile": CSHeaderProfile },
  extends: CSBase,
  props: {
    appLogoUri: { type: String, required: !1, default: "" },
    homeRoute: { type: String, required: !1, default: "" },
    publicView: { type: Boolean, required: !1 },
    headerProfile: {
      type: CSHeaderProfileProps,
      required: !1,
      default: void 0
    },
    feedbackBtn: {
      type: CSHeaderButtonProps,
      required: !1,
      default: void 0
    },
    helpBtn: {
      type: CSHeaderButtonProps,
      required: !1,
      default: void 0
    },
    searchBtn: {
      type: CSHeaderActiveButtonProps,
      required: !1,
      default: void 0
    },
    updateBtn: {
      type: CSHeaderButtonProps,
      required: !1,
      default: void 0
    },
    viewBtn: {
      type: CSHeaderActiveButtonProps,
      required: !1,
      default: void 0
    },
    settingsBtn: {
      type: CSHeaderButtonProps,
      required: !1,
      default: void 0
    },
    versionInUserProfile: {
      type: String,
      required: !1,
      default: void 0
    }
  },
  emits: [
    "feedback-btn-click",
    "search-btn-click",
    "help-btn-click",
    "update-btn-click",
    "view-btn-click",
    "settings-btn-click"
  ],
  computed: {
    ...mapGetters({
      isLoggedIn: "cs-session/isLoggedIn"
    }),
    appLogo() {
      return this.appLogoUri || "data:image/png;base64,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";
    }
  },
  methods: {
    goToHome() {
      const re = this.homeRoute || "/";
      this.$route.path === re ? this.$router.go() : this.$router.push(re);
    },
    goToLogin() {
      this.$route.path === "/login" ? this.$router.go() : this.$router.push("/login");
    },
    goTo() {
      this.publicView && !this.isLoggedIn ? this.goToLogin() : this.goToHome();
    },
    async onFeedbackBtn() {
      this.$emit("feedback-btn-click");
    },
    async onHelpBtn() {
      this.$emit("help-btn-click");
    },
    async onSearchBtn() {
      this.$emit("search-btn-click");
    },
    async onUpdateBtn() {
      this.$emit("update-btn-click");
    },
    async onViewBtn() {
      this.$emit("view-btn-click");
    },
    async onSettingsBtn() {
      this.$emit("settings-btn-click");
    }
  }
}, _hoisted_1$I = { class: "cs-header" }, _hoisted_2$n = { class: "cs-header-app-bar-container" }, _hoisted_3$e = { class: "cs-header-app-bar-content" }, _hoisted_4$9 = ["src"], _hoisted_5$5 = { class: "ml-2" }, _hoisted_6$4 = { class: "ml-2 header-menu" }, _hoisted_7$3 = { class: "ml-2 header-left" }, _hoisted_8$2 = { class: "ml-2 header-right-2" }, _hoisted_9$1 = { class: "ml-2 header-right" }, _hoisted_10$1 = { class: "cs-header-icons" }, _hoisted_11 = { class: "pl-3" };
function _sfc_render$W(re, ne, ae, ie, le, se) {
  const ce = resolveComponent("cs-header-icon-btn"), ue = resolveComponent("cs-header-profile"), de = resolveComponent("cs-loader");
  return openBlock(), createElementBlock("div", _hoisted_1$I, [
    createVNode(VAppBar, {
      id: "cs-header-app-bar",
      class: "cs-header-app-bar elevation-0",
      height: "80"
    }, {
      default: withCtx(() => [
        createElementVNode("div", _hoisted_2$n, [
          createElementVNode("div", _hoisted_3$e, [
            createElementVNode("div", {
              id: "cs-header--logo-btn",
              class: "app-logo pt-2",
              onClick: ne[0] || (ne[0] = withModifiers((...me) => se.goTo && se.goTo(...me), ["prevent", "stop"]))
            }, [
              createElementVNode("img", {
                src: se.appLogo,
                alt: "app logo",
                class: "app-logo-img"
              }, null, 8, _hoisted_4$9)
            ]),
            createElementVNode("div", _hoisted_5$5, [
              ae.publicView && !re.isLoggedIn ? (openBlock(), createBlock(VBtn, {
                key: 0,
                id: "cs-header--login-btn",
                variant: "text",
                class: "text-capitalize top-home-btn",
                onClick: se.goToLogin
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString$1(re.$t("cs.header.loginButtonText")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])) : createCommentVNode("", !0)
            ]),
            createElementVNode("div", _hoisted_6$4, [
              renderSlot(re.$slots, "header-menu", {}, void 0, !0)
            ]),
            createElementVNode("div", _hoisted_7$3, [
              renderSlot(re.$slots, "header-left", {}, void 0, !0)
            ]),
            createVNode(VSpacer),
            createElementVNode("div", _hoisted_8$2, [
              renderSlot(re.$slots, "header-right-2", {}, void 0, !0)
            ]),
            createElementVNode("div", _hoisted_9$1, [
              renderSlot(re.$slots, "header-right", {}, void 0, !0)
            ]),
            createElementVNode("div", _hoisted_10$1, [
              ae.feedbackBtn || re.$slots["header-feedback-menu"] ? (openBlock(), createBlock(ce, {
                key: 0,
                id: ae.feedbackBtn && ae.feedbackBtn.id || "feedback",
                "tool-tip": ae.feedbackBtn && ae.feedbackBtn.toolTip || "Feedback",
                action: ae.feedbackBtn && ae.feedbackBtn.action,
                href: ae.feedbackBtn && ae.feedbackBtn.href,
                onClick: se.onFeedbackBtn
              }, createSlots({
                "header-btn-icon": withCtx(() => [
                  createVNode(VIcon, {
                    size: "20",
                    icon: "fa:fas fa-bullhorn"
                  })
                ]),
                _: 2
              }, [
                re.$slots["header-feedback-menu"] ? {
                  name: "header-btn-menu",
                  fn: withCtx(() => [
                    renderSlot(re.$slots, "header-feedback-menu", {}, void 0, !0)
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["id", "tool-tip", "action", "href", "onClick"])) : createCommentVNode("", !0),
              ae.helpBtn || re.$slots["header-help-menu"] ? (openBlock(), createBlock(ce, {
                key: 1,
                id: ae.helpBtn && ae.helpBtn.id || "help",
                "tool-tip": ae.helpBtn && ae.helpBtn.toolTip || "Help",
                action: ae.helpBtn && ae.helpBtn.action,
                href: ae.helpBtn && ae.helpBtn.href,
                onClick: se.onHelpBtn
              }, createSlots({
                "header-btn-icon": withCtx(() => [
                  createVNode(VIcon, { icon: "mdi-help-circle" })
                ]),
                _: 2
              }, [
                re.$slots["header-help-menu"] ? {
                  name: "header-btn-menu",
                  fn: withCtx(() => [
                    renderSlot(re.$slots, "header-help-menu", {}, void 0, !0)
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["id", "tool-tip", "action", "href", "onClick"])) : createCommentVNode("", !0),
              ae.searchBtn || re.$slots["header-search-menu"] ? (openBlock(), createBlock(ce, {
                key: 2,
                id: ae.searchBtn && ae.searchBtn.id || "search",
                "tool-tip": ae.searchBtn && ae.searchBtn.toolTip || "Search",
                action: ae.searchBtn && ae.searchBtn.action,
                href: ae.searchBtn && ae.searchBtn.href,
                active: ae.searchBtn && ae.searchBtn.active,
                onClick: se.onSearchBtn
              }, createSlots({
                "header-btn-icon": withCtx(() => [
                  createVNode(VIcon, { icon: "mdi-magnify" })
                ]),
                _: 2
              }, [
                re.$slots["header-search-menu"] ? {
                  name: "header-btn-menu",
                  fn: withCtx(() => [
                    renderSlot(re.$slots, "header-search-menu", {}, void 0, !0)
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["id", "tool-tip", "action", "href", "active", "onClick"])) : createCommentVNode("", !0),
              ae.updateBtn || re.$slots["header-update-menu"] ? (openBlock(), createBlock(ce, {
                key: 3,
                id: ae.updateBtn && ae.updateBtn.id || "update",
                "tool-tip": ae.updateBtn && ae.updateBtn.toolTip || "Updates",
                action: ae.updateBtn && ae.updateBtn.action,
                href: ae.updateBtn && ae.updateBtn.href,
                onClick: se.onUpdateBtn
              }, createSlots({
                "header-btn-icon": withCtx(() => [
                  createVNode(VIcon, { icon: "mdi-update" })
                ]),
                _: 2
              }, [
                re.$slots["header-update-menu"] ? {
                  name: "header-btn-menu",
                  fn: withCtx(() => [
                    renderSlot(re.$slots, "header-update-menu", {}, void 0, !0)
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["id", "tool-tip", "action", "href", "onClick"])) : createCommentVNode("", !0),
              ae.viewBtn || re.$slots["header-view-menu"] ? (openBlock(), createBlock(ce, {
                key: 4,
                id: ae.viewBtn && ae.viewBtn.id || "view",
                "tool-tip": ae.viewBtn && ae.viewBtn.toolTip || "View",
                action: ae.viewBtn && ae.viewBtn.action,
                href: ae.viewBtn && ae.viewBtn.href,
                active: ae.viewBtn && ae.viewBtn.active,
                onClick: se.onViewBtn
              }, createSlots({
                "header-btn-icon": withCtx(() => [
                  createVNode(VIcon, { icon: "mdi-eye" })
                ]),
                _: 2
              }, [
                re.$slots["header-view-menu"] ? {
                  name: "header-btn-menu",
                  fn: withCtx(() => [
                    renderSlot(re.$slots, "header-view-menu", {}, void 0, !0)
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["id", "tool-tip", "action", "href", "active", "onClick"])) : createCommentVNode("", !0),
              ae.settingsBtn || re.$slots["header-settings-menu"] ? (openBlock(), createBlock(ce, {
                key: 5,
                id: ae.settingsBtn && ae.settingsBtn.id || "settings",
                "tool-tip": ae.settingsBtn && ae.settingsBtn.toolTip || "Settings",
                action: ae.settingsBtn && ae.settingsBtn.action,
                href: ae.settingsBtn && ae.settingsBtn.href,
                onClick: se.onSettingsBtn
              }, createSlots({
                "header-btn-icon": withCtx(() => [
                  createVNode(VIcon, { icon: "mdi-cog" })
                ]),
                _: 2
              }, [
                re.$slots["header-settings-menu"] ? {
                  name: "header-btn-menu",
                  fn: withCtx(() => [
                    renderSlot(re.$slots, "header-settings-menu", {}, void 0, !0)
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["id", "tool-tip", "action", "href", "onClick"])) : createCommentVNode("", !0)
            ]),
            createElementVNode("div", _hoisted_11, [
              !ae.publicView || re.isLoggedIn ? (openBlock(), createBlock(ue, {
                key: 0,
                color: "white",
                "header-profile": ae.headerProfile,
                "version-in-user-profile": ae.versionInUserProfile
              }, null, 8, ["header-profile", "version-in-user-profile"])) : createCommentVNode("", !0)
            ])
          ]),
          createVNode(de)
        ])
      ]),
      _: 3
    })
  ]);
}
const CSHeader = /* @__PURE__ */ _export_sfc(_sfc_main$W, [["render", _sfc_render$W], ["__scopeId", "data-v-ddbad22c"]]), _sfc_main$V = {
  name: "CSView",
  extends: CSBase,
  props: {
    singleView: { type: Boolean, required: !1, default: !1 },
    wideNav: { type: Boolean, required: !1, default: !1 },
    center: { type: Boolean, required: !1, default: !1 }
  },
  data() {
    return {
      container: `cs-view h-100 align-center pt-0 pb-0 ${this.center ? "text-center" : "text-left"}`
    };
  },
  unmounted() {
    this.clearAlert();
  }
};
function _sfc_render$V(re, ne, ae, ie, le, se) {
  return openBlock(), createBlock(VContainer, {
    class: normalizeClass(le.container),
    fluid: "fluid"
  }, {
    default: withCtx(() => [
      createVNode(VRow, { class: "fill-height" }, {
        default: withCtx(() => [
          !ae.singleView && !ae.wideNav ? (openBlock(), createBlock(VCol, {
            key: 0,
            cols: "2"
          }, {
            default: withCtx(() => [
              renderSlot(re.$slots, "left-content")
            ]),
            _: 3
          })) : createCommentVNode("", !0),
          !ae.singleView && !ae.wideNav ? (openBlock(), createBlock(VCol, {
            key: 1,
            cols: "10",
            class: "pl-0"
          }, {
            default: withCtx(() => [
              renderSlot(re.$slots, "right-content")
            ]),
            _: 3
          })) : createCommentVNode("", !0),
          !ae.singleView && ae.wideNav ? (openBlock(), createBlock(VCol, {
            key: 2,
            cols: "3"
          }, {
            default: withCtx(() => [
              renderSlot(re.$slots, "left-content")
            ]),
            _: 3
          })) : createCommentVNode("", !0),
          !ae.singleView && ae.wideNav ? (openBlock(), createBlock(VCol, {
            key: 3,
            cols: "9",
            class: "pl-0"
          }, {
            default: withCtx(() => [
              renderSlot(re.$slots, "right-content")
            ]),
            _: 3
          })) : createCommentVNode("", !0),
          ae.singleView ? (openBlock(), createBlock(VCol, {
            key: 4,
            cols: "12"
          }, {
            default: withCtx(() => [
              renderSlot(re.$slots, "content")
            ]),
            _: 3
          })) : createCommentVNode("", !0)
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["class"]);
}
const CSView = /* @__PURE__ */ _export_sfc(_sfc_main$V, [["render", _sfc_render$V]]);
function useSticky(re) {
  let {
    rootEl: ne,
    isSticky: ae,
    layoutItemStyles: ie
  } = re;
  const le = shallowRef(!1), se = shallowRef(0), ce = computed(() => {
    const me = typeof le.value == "boolean" ? "top" : le.value;
    return [ae.value ? {
      top: "auto",
      bottom: "auto",
      height: void 0
    } : void 0, le.value ? {
      [me]: convertToUnit(se.value)
    } : {
      top: ie.value.top
    }];
  });
  onMounted(() => {
    watch(ae, (me) => {
      me ? window.addEventListener("scroll", de, {
        passive: !0
      }) : window.removeEventListener("scroll", de);
    }, {
      immediate: !0
    });
  }), onBeforeUnmount(() => {
    window.removeEventListener("scroll", de);
  });
  let ue = 0;
  function de() {
    const me = ue > window.scrollY ? "up" : "down", fe = ne.value.getBoundingClientRect(), pe = parseFloat(ie.value.top ?? 0), ge = window.scrollY - Math.max(0, se.value - pe), be = fe.height + Math.max(se.value, pe) - window.scrollY - window.innerHeight, Se = parseFloat(getComputedStyle(ne.value).getPropertyValue("--v-body-scroll-y")) || 0;
    fe.height < window.innerHeight - pe ? (le.value = "top", se.value = pe) : me === "up" && le.value === "bottom" || me === "down" && le.value === "top" ? (se.value = window.scrollY + fe.top - Se, le.value = !0) : me === "down" && be <= 0 ? (se.value = 0, le.value = "bottom") : me === "up" && ge <= 0 && (Se ? le.value !== "top" && (se.value = -ge + Se + pe, le.value = "top") : (se.value = fe.top + ge, le.value = "top")), ue = window.scrollY;
  }
  return {
    isStuck: le,
    stickyStyles: ce
  };
}
const HORIZON = 100, HISTORY = 20;
function kineticEnergyToVelocity(re) {
  return (re < 0 ? -1 : 1) * Math.sqrt(Math.abs(re)) * 1.41421356237;
}
function calculateImpulseVelocity(re) {
  if (re.length < 2)
    return 0;
  if (re.length === 2)
    return re[1].t === re[0].t ? 0 : (re[1].d - re[0].d) / (re[1].t - re[0].t);
  let ne = 0;
  for (let ae = re.length - 1; ae > 0; ae--) {
    if (re[ae].t === re[ae - 1].t)
      continue;
    const ie = kineticEnergyToVelocity(ne), le = (re[ae].d - re[ae - 1].d) / (re[ae].t - re[ae - 1].t);
    ne += (le - ie) * Math.abs(le), ae === re.length - 1 && (ne *= 0.5);
  }
  return kineticEnergyToVelocity(ne) * 1e3;
}
function useVelocity() {
  const re = {};
  function ne(le) {
    Array.from(le.changedTouches).forEach((se) => {
      (re[se.identifier] ?? (re[se.identifier] = new CircularBuffer(HISTORY))).push([le.timeStamp, se]);
    });
  }
  function ae(le) {
    Array.from(le.changedTouches).forEach((se) => {
      delete re[se.identifier];
    });
  }
  function ie(le) {
    var me;
    const se = (me = re[le]) == null ? void 0 : me.values().reverse();
    if (!se)
      throw new Error(`No samples for touch id ${le}`);
    const ce = se[0], ue = [], de = [];
    for (const fe of se) {
      if (ce[0] - fe[0] > HORIZON) break;
      ue.push({
        t: fe[0],
        d: fe[1].clientX
      }), de.push({
        t: fe[0],
        d: fe[1].clientY
      });
    }
    return {
      x: calculateImpulseVelocity(ue),
      y: calculateImpulseVelocity(de),
      get direction() {
        const {
          x: fe,
          y: pe
        } = this, [ge, be] = [Math.abs(fe), Math.abs(pe)];
        return ge > be && fe >= 0 ? "right" : ge > be && fe <= 0 ? "left" : be > ge && pe >= 0 ? "down" : be > ge && pe <= 0 ? "up" : oops$1();
      }
    };
  }
  return {
    addMovement: ne,
    endTouch: ae,
    getVelocity: ie
  };
}
function oops$1() {
  throw new Error();
}
function useTouch(re) {
  let {
    el: ne,
    isActive: ae,
    isTemporary: ie,
    width: le,
    touchless: se,
    position: ce
  } = re;
  onMounted(() => {
    window.addEventListener("touchstart", Ae, {
      passive: !0
    }), window.addEventListener("touchmove", Oe, {
      passive: !1
    }), window.addEventListener("touchend", Ne, {
      passive: !0
    });
  }), onBeforeUnmount(() => {
    window.removeEventListener("touchstart", Ae), window.removeEventListener("touchmove", Oe), window.removeEventListener("touchend", Ne);
  });
  const ue = computed(() => ["left", "right"].includes(ce.value)), {
    addMovement: de,
    endTouch: me,
    getVelocity: fe
  } = useVelocity();
  let pe = !1;
  const ge = shallowRef(!1), be = shallowRef(0), Se = shallowRef(0);
  let Pe;
  function Ee(Ue, Ze) {
    return (ce.value === "left" ? Ue : ce.value === "right" ? document.documentElement.clientWidth - Ue : ce.value === "top" ? Ue : ce.value === "bottom" ? document.documentElement.clientHeight - Ue : oops()) - (Ze ? le.value : 0);
  }
  function Ve(Ue) {
    let Ze = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    const Fe = ce.value === "left" ? (Ue - Se.value) / le.value : ce.value === "right" ? (document.documentElement.clientWidth - Ue - Se.value) / le.value : ce.value === "top" ? (Ue - Se.value) / le.value : ce.value === "bottom" ? (document.documentElement.clientHeight - Ue - Se.value) / le.value : oops();
    return Ze ? Math.max(0, Math.min(1, Fe)) : Fe;
  }
  function Ae(Ue) {
    if (se.value) return;
    const Ze = Ue.changedTouches[0].clientX, Fe = Ue.changedTouches[0].clientY, Ke = 25, tt = ce.value === "left" ? Ze < Ke : ce.value === "right" ? Ze > document.documentElement.clientWidth - Ke : ce.value === "top" ? Fe < Ke : ce.value === "bottom" ? Fe > document.documentElement.clientHeight - Ke : oops(), Re = ae.value && (ce.value === "left" ? Ze < le.value : ce.value === "right" ? Ze > document.documentElement.clientWidth - le.value : ce.value === "top" ? Fe < le.value : ce.value === "bottom" ? Fe > document.documentElement.clientHeight - le.value : oops());
    (tt || Re || ae.value && ie.value) && (Pe = [Ze, Fe], Se.value = Ee(ue.value ? Ze : Fe, ae.value), be.value = Ve(ue.value ? Ze : Fe), pe = Se.value > -20 && Se.value < 80, me(Ue), de(Ue));
  }
  function Oe(Ue) {
    const Ze = Ue.changedTouches[0].clientX, Fe = Ue.changedTouches[0].clientY;
    if (pe) {
      if (!Ue.cancelable) {
        pe = !1;
        return;
      }
      const tt = Math.abs(Ze - Pe[0]), Re = Math.abs(Fe - Pe[1]);
      (ue.value ? tt > Re && tt > 3 : Re > tt && Re > 3) ? (ge.value = !0, pe = !1) : (ue.value ? Re : tt) > 3 && (pe = !1);
    }
    if (!ge.value) return;
    Ue.preventDefault(), de(Ue);
    const Ke = Ve(ue.value ? Ze : Fe, !1);
    be.value = Math.max(0, Math.min(1, Ke)), Ke > 1 ? Se.value = Ee(ue.value ? Ze : Fe, !0) : Ke < 0 && (Se.value = Ee(ue.value ? Ze : Fe, !1));
  }
  function Ne(Ue) {
    if (pe = !1, !ge.value) return;
    de(Ue), ge.value = !1;
    const Ze = fe(Ue.changedTouches[0].identifier), Fe = Math.abs(Ze.x), Ke = Math.abs(Ze.y);
    (ue.value ? Fe > Ke && Fe > 400 : Ke > Fe && Ke > 3) ? ae.value = Ze.direction === ({
      left: "right",
      right: "left",
      top: "down",
      bottom: "up"
    }[ce.value] || oops()) : ae.value = be.value > 0.5;
  }
  const He = computed(() => ge.value ? {
    transform: ce.value === "left" ? `translateX(calc(-100% + ${be.value * le.value}px))` : ce.value === "right" ? `translateX(calc(100% - ${be.value * le.value}px))` : ce.value === "top" ? `translateY(calc(-100% + ${be.value * le.value}px))` : ce.value === "bottom" ? `translateY(calc(100% - ${be.value * le.value}px))` : oops(),
    transition: "none"
  } : void 0);
  return useToggleScope(ge, () => {
    var Fe, Ke;
    const Ue = ((Fe = ne.value) == null ? void 0 : Fe.style.transform) ?? null, Ze = ((Ke = ne.value) == null ? void 0 : Ke.style.transition) ?? null;
    watchEffect(() => {
      var tt, Re, Ce, _e;
      (Re = ne.value) == null || Re.style.setProperty("transform", ((tt = He.value) == null ? void 0 : tt.transform) || "none"), (_e = ne.value) == null || _e.style.setProperty("transition", ((Ce = He.value) == null ? void 0 : Ce.transition) || null);
    }), onScopeDispose(() => {
      var tt, Re;
      (tt = ne.value) == null || tt.style.setProperty("transform", Ue), (Re = ne.value) == null || Re.style.setProperty("transition", Ze);
    });
  }), {
    isDragging: ge,
    dragProgress: be,
    dragStyles: He
  };
}
function oops() {
  throw new Error();
}
const DateOptionsSymbol = Symbol.for("vuetify:date-options");
function createInstance(re, ne) {
  const ae = reactive(typeof re.adapter == "function" ? new re.adapter({
    locale: re.locale[ne.current.value] ?? ne.current.value,
    formats: re.formats
  }) : re.adapter);
  return watch(ne.current, (ie) => {
    ae.locale = re.locale[ie] ?? ie ?? ae.locale;
  }), ae;
}
function useDate() {
  const re = inject(DateOptionsSymbol);
  if (!re) throw new Error("[Vuetify] Could not find injected date options");
  const ne = useLocale();
  return createInstance(re, ne);
}
function getWeek(re, ne) {
  const ae = re.toJsDate(ne);
  let ie = ae.getFullYear(), le = new Date(ie, 0, 1);
  if (ae < le)
    ie = ie - 1, le = new Date(ie, 0, 1);
  else {
    const ue = new Date(ie + 1, 0, 1);
    ae >= ue && (ie = ie + 1, le = ue);
  }
  const se = Math.abs(ae.getTime() - le.getTime()), ce = Math.ceil(se / (1e3 * 60 * 60 * 24));
  return Math.floor(ce / 7) + 1;
}
const GoToSymbol = Symbol.for("vuetify:goto");
function genDefaults() {
  return {
    container: void 0,
    duration: 300,
    layout: !1,
    offset: 0,
    easing: "easeInOutCubic",
    patterns: {
      linear: (re) => re,
      easeInQuad: (re) => re ** 2,
      easeOutQuad: (re) => re * (2 - re),
      easeInOutQuad: (re) => re < 0.5 ? 2 * re ** 2 : -1 + (4 - 2 * re) * re,
      easeInCubic: (re) => re ** 3,
      easeOutCubic: (re) => --re ** 3 + 1,
      easeInOutCubic: (re) => re < 0.5 ? 4 * re ** 3 : (re - 1) * (2 * re - 2) * (2 * re - 2) + 1,
      easeInQuart: (re) => re ** 4,
      easeOutQuart: (re) => 1 - --re ** 4,
      easeInOutQuart: (re) => re < 0.5 ? 8 * re ** 4 : 1 - 8 * --re ** 4,
      easeInQuint: (re) => re ** 5,
      easeOutQuint: (re) => 1 + --re ** 5,
      easeInOutQuint: (re) => re < 0.5 ? 16 * re ** 5 : 1 + 16 * --re ** 5
    }
  };
}
function getContainer(re) {
  return getTarget(re) ?? (document.scrollingElement || document.body);
}
function getTarget(re) {
  return typeof re == "string" ? document.querySelector(re) : refElement(re);
}
function getOffset$1(re, ne, ae) {
  if (typeof re == "number") return ne && ae ? -re : re;
  let ie = getTarget(re), le = 0;
  for (; ie; )
    le += ne ? ie.offsetLeft : ie.offsetTop, ie = ie.offsetParent;
  return le;
}
async function scrollTo(re, ne, ae, ie) {
  const le = ae ? "scrollLeft" : "scrollTop", se = mergeDeep((ie == null ? void 0 : ie.options) ?? genDefaults(), ne), ce = ie == null ? void 0 : ie.rtl.value, ue = (typeof re == "number" ? re : getTarget(re)) ?? 0, de = se.container === "parent" && ue instanceof HTMLElement ? ue.parentElement : getContainer(se.container), me = typeof se.easing == "function" ? se.easing : se.patterns[se.easing];
  if (!me) throw new TypeError(`Easing function "${se.easing}" not found.`);
  let fe;
  if (typeof ue == "number")
    fe = getOffset$1(ue, ae, ce);
  else if (fe = getOffset$1(ue, ae, ce) - getOffset$1(de, ae, ce), se.layout) {
    const Se = window.getComputedStyle(ue).getPropertyValue("--v-layout-top");
    Se && (fe -= parseInt(Se, 10));
  }
  fe += se.offset, fe = clampTarget(de, fe, !!ce, !!ae);
  const pe = de[le] ?? 0;
  if (fe === pe) return Promise.resolve(fe);
  const ge = performance.now();
  return new Promise((be) => requestAnimationFrame(function Se(Pe) {
    const Ve = (Pe - ge) / se.duration, Ae = Math.floor(pe + (fe - pe) * me(clamp(Ve, 0, 1)));
    if (de[le] = Ae, Ve >= 1 && Math.abs(Ae - de[le]) < 10)
      return be(fe);
    if (Ve > 2)
      return consoleWarn("Scroll target is not reachable"), be(de[le]);
    requestAnimationFrame(Se);
  }));
}
function useGoTo() {
  let re = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const ne = inject(GoToSymbol), {
    isRtl: ae
  } = useRtl();
  if (!ne) throw new Error("[Vuetify] Could not find injected goto instance");
  const ie = {
    ...ne,
    // can be set via VLocaleProvider
    rtl: computed(() => ne.rtl.value || ae.value)
  };
  async function le(se, ce) {
    return scrollTo(se, mergeDeep(re, ce), !1, ie);
  }
  return le.horizontal = async (se, ce) => scrollTo(se, mergeDeep(re, ce), !0, ie), le;
}
function clampTarget(re, ne, ae, ie) {
  const {
    scrollWidth: le,
    scrollHeight: se
  } = re, [ce, ue] = re === document.scrollingElement ? [window.innerWidth, window.innerHeight] : [re.offsetWidth, re.offsetHeight];
  let de, me;
  return ie ? ae ? (de = -(le - ce), me = 0) : (de = 0, me = le - ce) : (de = 0, me = se + -ue), Math.max(Math.min(ne, me), de);
}
const locations = ["start", "end", "left", "right", "top", "bottom"], makeVNavigationDrawerProps = propsFactory({
  color: String,
  disableResizeWatcher: Boolean,
  disableRouteWatcher: Boolean,
  expandOnHover: Boolean,
  floating: Boolean,
  modelValue: {
    type: Boolean,
    default: null
  },
  permanent: Boolean,
  rail: {
    type: Boolean,
    default: null
  },
  railWidth: {
    type: [Number, String],
    default: 56
  },
  scrim: {
    type: [Boolean, String],
    default: !0
  },
  image: String,
  temporary: Boolean,
  persistent: Boolean,
  touchless: Boolean,
  width: {
    type: [Number, String],
    default: 256
  },
  location: {
    type: String,
    default: "start",
    validator: (re) => locations.includes(re)
  },
  sticky: Boolean,
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDelayProps(),
  ...makeDisplayProps({
    mobile: null
  }),
  ...makeElevationProps(),
  ...makeLayoutItemProps(),
  ...makeRoundedProps(),
  ...makeTagProps({
    tag: "nav"
  }),
  ...makeThemeProps()
}, "VNavigationDrawer"), VNavigationDrawer = genericComponent()({
  name: "VNavigationDrawer",
  props: makeVNavigationDrawerProps(),
  emits: {
    "update:modelValue": (re) => !0,
    "update:rail": (re) => !0
  },
  setup(re, ne) {
    let {
      attrs: ae,
      emit: ie,
      slots: le
    } = ne;
    const {
      isRtl: se
    } = useRtl(), {
      themeClasses: ce
    } = provideTheme(re), {
      borderClasses: ue
    } = useBorder(re), {
      backgroundColorClasses: de,
      backgroundColorStyles: me
    } = useBackgroundColor(toRef(re, "color")), {
      elevationClasses: fe
    } = useElevation(re), {
      displayClasses: pe,
      mobile: ge
    } = useDisplay(re), {
      roundedClasses: be
    } = useRounded(re), Se = useRouter(), Pe = useProxiedModel(re, "modelValue", null, (we) => !!we), {
      ssrBootStyles: Ee
    } = useSsrBoot(), {
      scopeId: Ve
    } = useScopeId(), Ae = ref$1(), Oe = shallowRef(!1), {
      runOpenDelay: Ne,
      runCloseDelay: He
    } = useDelay(re, (we) => {
      Oe.value = we;
    }), Ue = computed(() => re.rail && re.expandOnHover && Oe.value ? Number(re.width) : Number(re.rail ? re.railWidth : re.width)), Ze = computed(() => toPhysical(re.location, se.value)), Fe = computed(() => re.persistent), Ke = computed(() => !re.permanent && (ge.value || re.temporary)), tt = computed(() => re.sticky && !Ke.value && Ze.value !== "bottom");
    useToggleScope(() => re.expandOnHover && re.rail != null, () => {
      watch(Oe, (we) => ie("update:rail", !we));
    }), useToggleScope(() => !re.disableResizeWatcher, () => {
      watch(Ke, (we) => !re.permanent && nextTick$2(() => Pe.value = !we));
    }), useToggleScope(() => !re.disableRouteWatcher && !!Se, () => {
      watch(Se.currentRoute, () => Ke.value && (Pe.value = !1));
    }), watch(() => re.permanent, (we) => {
      we && (Pe.value = !0);
    }), re.modelValue == null && !Ke.value && (Pe.value = re.permanent || !ge.value);
    const {
      isDragging: Re,
      dragProgress: Ce
    } = useTouch({
      el: Ae,
      isActive: Pe,
      isTemporary: Ke,
      width: Ue,
      touchless: toRef(re, "touchless"),
      position: Ze
    }), _e = computed(() => {
      const we = Ke.value ? 0 : re.rail && re.expandOnHover ? Number(re.railWidth) : Ue.value;
      return Re.value ? we * Ce.value : we;
    }), {
      layoutItemStyles: he,
      layoutItemScrimStyles: ve
    } = useLayoutItem({
      id: re.name,
      order: computed(() => parseInt(re.order, 10)),
      position: Ze,
      layoutSize: _e,
      elementSize: Ue,
      active: computed(() => Pe.value || Re.value),
      disableTransitions: computed(() => Re.value),
      absolute: computed(() => (
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        re.absolute || tt.value && typeof xe.value != "string"
      ))
    }), {
      isStuck: xe,
      stickyStyles: $e
    } = useSticky({
      rootEl: Ae,
      isSticky: tt,
      layoutItemStyles: he
    }), Te = useBackgroundColor(computed(() => typeof re.scrim == "string" ? re.scrim : null)), Ie = computed(() => ({
      ...Re.value ? {
        opacity: Ce.value * 0.2,
        transition: "none"
      } : void 0,
      ...ve.value
    }));
    return provideDefaults({
      VList: {
        bgColor: "transparent"
      }
    }), useRender(() => {
      const we = le.image || re.image;
      return createVNode(Fragment, null, [createVNode(re.tag, mergeProps({
        ref: Ae,
        onMouseenter: Ne,
        onMouseleave: He,
        class: ["v-navigation-drawer", `v-navigation-drawer--${Ze.value}`, {
          "v-navigation-drawer--expand-on-hover": re.expandOnHover,
          "v-navigation-drawer--floating": re.floating,
          "v-navigation-drawer--is-hovering": Oe.value,
          "v-navigation-drawer--rail": re.rail,
          "v-navigation-drawer--temporary": Ke.value,
          "v-navigation-drawer--persistent": Fe.value,
          "v-navigation-drawer--active": Pe.value,
          "v-navigation-drawer--sticky": tt.value
        }, ce.value, de.value, ue.value, pe.value, fe.value, be.value, re.class],
        style: [me.value, he.value, Ee.value, $e.value, re.style]
      }, Ve, ae), {
        default: () => {
          var ke, ye, Be;
          return [we && createVNode("div", {
            key: "image",
            class: "v-navigation-drawer__img"
          }, [le.image ? createVNode(VDefaultsProvider, {
            key: "image-defaults",
            disabled: !re.image,
            defaults: {
              VImg: {
                alt: "",
                cover: !0,
                height: "inherit",
                src: re.image
              }
            }
          }, le.image) : createVNode(VImg, {
            key: "image-img",
            alt: "",
            cover: !0,
            height: "inherit",
            src: re.image
          }, null)]), le.prepend && createVNode("div", {
            class: "v-navigation-drawer__prepend"
          }, [(ke = le.prepend) == null ? void 0 : ke.call(le)]), createVNode("div", {
            class: "v-navigation-drawer__content"
          }, [(ye = le.default) == null ? void 0 : ye.call(le)]), le.append && createVNode("div", {
            class: "v-navigation-drawer__append"
          }, [(Be = le.append) == null ? void 0 : Be.call(le)])];
        }
      }), createVNode(Transition, {
        name: "fade-transition"
      }, {
        default: () => [Ke.value && (Re.value || Pe.value) && !!re.scrim && createVNode("div", mergeProps({
          class: ["v-navigation-drawer__scrim", Te.backgroundColorClasses.value],
          style: [Ie.value, Te.backgroundColorStyles.value],
          onClick: () => {
            Fe.value || (Pe.value = !1);
          }
        }, Ve), null)]
      })]);
    }), {
      isStuck: xe
    };
  }
}), _sfc_main$U = {
  name: "CSSideNav",
  extends: CSBase,
  props: {
    modelValue: { type: Boolean, required: !0 },
    width: { type: Number, required: !0 },
    customerLogoUri: { type: String, required: !1, default: "" },
    customerLogoWidth: { type: Number, required: !1, default: 125 },
    customerName: { type: String, required: !1, default: "" },
    version: { type: String, required: !1, default: "" }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      showSideNav: this.modelValue
    };
  },
  watch: {
    modelValue(re) {
      this.showSideNav = this.modelValue, this.setShowSideNav(re);
    },
    showSideNav(re) {
      this.setShowSideNav(re);
    }
  }
}, _hoisted_1$H = {
  key: 0,
  class: "text-center side-nav-customer"
}, _hoisted_2$m = { class: "mt-3 mb-3" }, _hoisted_3$d = { class: "side-nav-client-logo-container" }, _hoisted_4$8 = { class: "side-nav-client-logo" }, _hoisted_5$4 = ["src", "width"], _hoisted_6$3 = { class: "display-name" }, _hoisted_7$2 = { class: "side-nav" }, _hoisted_8$1 = {
  key: 1,
  class: "text-left ml-2 mt-2"
}, _hoisted_9 = { class: "text-sm-body-2 text-center mb-2" }, _hoisted_10 = { class: "text-sm-body-2 font-weight-bold text-center" };
function _sfc_render$U(re, ne, ae, ie, le, se) {
  return openBlock(), createBlock(VNavigationDrawer, {
    id: "cs-side-nav",
    modelValue: le.showSideNav,
    "onUpdate:modelValue": ne[0] || (ne[0] = (ce) => le.showSideNav = ce),
    width: ae.width
  }, {
    default: withCtx(() => [
      ae.customerLogoUri ? (openBlock(), createElementBlock("div", _hoisted_1$H, [
        createElementVNode("div", _hoisted_2$m, [
          createElementVNode("div", _hoisted_3$d, [
            createElementVNode("div", _hoisted_4$8, [
              createElementVNode("img", {
                class: "side-nav-logo",
                src: ae.customerLogoUri,
                alt: "Logo",
                width: ae.customerLogoWidth
              }, null, 8, _hoisted_5$4)
            ])
          ])
        ]),
        createElementVNode("p", _hoisted_6$3, toDisplayString$1(ae.customerName), 1)
      ])) : createCommentVNode("", !0),
      createElementVNode("div", _hoisted_7$2, [
        renderSlot(re.$slots, "side-nav", {}, void 0, !0)
      ]),
      createVNode(VSpacer),
      ae.version ? (openBlock(), createElementBlock("div", _hoisted_8$1, [
        createElementVNode("p", _hoisted_9, " ©" + toDisplayString$1(re.$te("custom.copyRightText") ? re.$t("custom.copyRightText") : re.$t("cs.copyRightText")), 1),
        createElementVNode("p", _hoisted_10, "v" + toDisplayString$1(ae.version), 1)
      ])) : createCommentVNode("", !0)
    ]),
    _: 3
  }, 8, ["modelValue", "width"]);
}
const CSSideNav = /* @__PURE__ */ _export_sfc(_sfc_main$U, [["render", _sfc_render$U], ["__scopeId", "data-v-2074e9fa"]]), getSiteInfo = async (re, ne) => {
  const ae = `/${window.location.host}/site.json`, le = await re({
    method: "GET",
    baseURL: ne,
    url: ae
  });
  if (!le || !le.data || typeof le.data != "object")
    throw new Error("Invalid response from gainsight gateway");
  return {
    safeId: le.data.safeId,
    subscriptionId: le.data.subscriptionId,
    clientName: le.data.clientName
  };
}, gainsightPx = (re, ne) => `
    (function(n,t,a,e,co){var i="aptrinsic";n[i]=n[i]||function(){
      (n[i].q=n[i].q||[]).push(arguments)},n[i].p=e;n[i].c=co;
      var r=t.createElement("script");r.async=!0,r.src=a+"?a="+e;
      var c=t.getElementsByTagName("script")[0];c.parentNode.insertBefore(r,c)
    })(window,document,"${re}","${ne}");
  `, injectTrackingCodeScript = (re) => {
  const ne = "gainsightPxScript", ae = document.createElement("script"), ie = gainsightPx(re.gainsightUrl, re.gainsightProductTag);
  ae.id = ne, ae.text = ie;
  const le = document.getElementById(ne);
  le ? le.parentNode.replaceChild(ae, le) : document.head.appendChild(ae);
}, gainsightConfig = (re, ne, ae, ie) => {
  const le = re || "part1|part2|part3";
  return {
    applicationId: le,
    customerId: le.split("|")[0],
    subscriptionName: le.split("|")[1],
    productSku: le.split("|")[2],
    accountName: ne,
    productTag: ae,
    appName: ie
  };
};
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(re) {
  return re && re.__esModule && Object.prototype.hasOwnProperty.call(re, "default") ? re.default : re;
}
function getAugmentedNamespace(re) {
  if (re.__esModule) return re;
  var ne = re.default;
  if (typeof ne == "function") {
    var ae = function ie() {
      return this instanceof ie ? Reflect.construct(ne, arguments, this.constructor) : ne.apply(this, arguments);
    };
    ae.prototype = ne.prototype;
  } else ae = {};
  return Object.defineProperty(ae, "__esModule", { value: !0 }), Object.keys(re).forEach(function(ie) {
    var le = Object.getOwnPropertyDescriptor(re, ie);
    Object.defineProperty(ae, ie, le.get ? le : {
      enumerable: !0,
      get: function() {
        return re[ie];
      }
    });
  }), ae;
}
var cryptoBrowserify = {}, browser$b = { exports: {} }, safeBuffer$2 = { exports: {} };
const require$$1$2 = /* @__PURE__ */ getAugmentedNamespace(dist);
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
(function(re, ne) {
  var ae = require$$1$2, ie = ae.Buffer;
  function le(ce, ue) {
    for (var de in ce)
      ue[de] = ce[de];
  }
  ie.from && ie.alloc && ie.allocUnsafe && ie.allocUnsafeSlow ? re.exports = ae : (le(ae, ne), ne.Buffer = se);
  function se(ce, ue, de) {
    return ie(ce, ue, de);
  }
  se.prototype = Object.create(ie.prototype), le(ie, se), se.from = function(ce, ue, de) {
    if (typeof ce == "number")
      throw new TypeError("Argument must not be a number");
    return ie(ce, ue, de);
  }, se.alloc = function(ce, ue, de) {
    if (typeof ce != "number")
      throw new TypeError("Argument must be a number");
    var me = ie(ce);
    return ue !== void 0 ? typeof de == "string" ? me.fill(ue, de) : me.fill(ue) : me.fill(0), me;
  }, se.allocUnsafe = function(ce) {
    if (typeof ce != "number")
      throw new TypeError("Argument must be a number");
    return ie(ce);
  }, se.allocUnsafeSlow = function(ce) {
    if (typeof ce != "number")
      throw new TypeError("Argument must be a number");
    return ae.SlowBuffer(ce);
  };
})(safeBuffer$2, safeBuffer$2.exports);
var safeBufferExports$1 = safeBuffer$2.exports, MAX_BYTES = 65536, MAX_UINT32 = 4294967295;
function oldBrowser$1() {
  throw new Error(`Secure random number generation is not supported by this browser.
Use Chrome, Firefox or Internet Explorer 11`);
}
var Buffer$C = safeBufferExports$1.Buffer, crypto$2 = commonjsGlobal.crypto || commonjsGlobal.msCrypto;
crypto$2 && crypto$2.getRandomValues ? browser$b.exports = randomBytes$2 : browser$b.exports = oldBrowser$1;
function randomBytes$2(re, ne) {
  if (re > MAX_UINT32) throw new RangeError("requested too many random bytes");
  var ae = Buffer$C.allocUnsafe(re);
  if (re > 0)
    if (re > MAX_BYTES)
      for (var ie = 0; ie < re; ie += MAX_BYTES)
        crypto$2.getRandomValues(ae.slice(ie, ie + MAX_BYTES));
    else
      crypto$2.getRandomValues(ae);
  return typeof ne == "function" ? process$1.nextTick(function() {
    ne(null, ae);
  }) : ae;
}
var browserExports = browser$b.exports, inherits_browser = { exports: {} };
typeof Object.create == "function" ? inherits_browser.exports = function(ne, ae) {
  ae && (ne.super_ = ae, ne.prototype = Object.create(ae.prototype, {
    constructor: {
      value: ne,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : inherits_browser.exports = function(ne, ae) {
  if (ae) {
    ne.super_ = ae;
    var ie = function() {
    };
    ie.prototype = ae.prototype, ne.prototype = new ie(), ne.prototype.constructor = ne;
  }
};
var inherits_browserExports = inherits_browser.exports, readableBrowser$1 = { exports: {} }, events = { exports: {} }, R = typeof Reflect == "object" ? Reflect : null, ReflectApply = R && typeof R.apply == "function" ? R.apply : function(ne, ae, ie) {
  return Function.prototype.apply.call(ne, ae, ie);
}, ReflectOwnKeys;
R && typeof R.ownKeys == "function" ? ReflectOwnKeys = R.ownKeys : Object.getOwnPropertySymbols ? ReflectOwnKeys = function(ne) {
  return Object.getOwnPropertyNames(ne).concat(Object.getOwnPropertySymbols(ne));
} : ReflectOwnKeys = function(ne) {
  return Object.getOwnPropertyNames(ne);
};
function ProcessEmitWarning(re) {
  console && console.warn && console.warn(re);
}
var NumberIsNaN = Number.isNaN || function(ne) {
  return ne !== ne;
};
function EventEmitter() {
  EventEmitter.init.call(this);
}
events.exports = EventEmitter;
events.exports.once = once$2;
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = void 0;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = void 0;
var defaultMaxListeners = 10;
function checkListener(re) {
  if (typeof re != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof re);
}
Object.defineProperty(EventEmitter, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(re) {
    if (typeof re != "number" || re < 0 || NumberIsNaN(re))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + re + ".");
    defaultMaxListeners = re;
  }
});
EventEmitter.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
EventEmitter.prototype.setMaxListeners = function(ne) {
  if (typeof ne != "number" || ne < 0 || NumberIsNaN(ne))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + ne + ".");
  return this._maxListeners = ne, this;
};
function _getMaxListeners(re) {
  return re._maxListeners === void 0 ? EventEmitter.defaultMaxListeners : re._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function() {
  return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function(ne) {
  for (var ae = [], ie = 1; ie < arguments.length; ie++) ae.push(arguments[ie]);
  var le = ne === "error", se = this._events;
  if (se !== void 0)
    le = le && se.error === void 0;
  else if (!le)
    return !1;
  if (le) {
    var ce;
    if (ae.length > 0 && (ce = ae[0]), ce instanceof Error)
      throw ce;
    var ue = new Error("Unhandled error." + (ce ? " (" + ce.message + ")" : ""));
    throw ue.context = ce, ue;
  }
  var de = se[ne];
  if (de === void 0)
    return !1;
  if (typeof de == "function")
    ReflectApply(de, this, ae);
  else
    for (var me = de.length, fe = arrayClone(de, me), ie = 0; ie < me; ++ie)
      ReflectApply(fe[ie], this, ae);
  return !0;
};
function _addListener(re, ne, ae, ie) {
  var le, se, ce;
  if (checkListener(ae), se = re._events, se === void 0 ? (se = re._events = /* @__PURE__ */ Object.create(null), re._eventsCount = 0) : (se.newListener !== void 0 && (re.emit(
    "newListener",
    ne,
    ae.listener ? ae.listener : ae
  ), se = re._events), ce = se[ne]), ce === void 0)
    ce = se[ne] = ae, ++re._eventsCount;
  else if (typeof ce == "function" ? ce = se[ne] = ie ? [ae, ce] : [ce, ae] : ie ? ce.unshift(ae) : ce.push(ae), le = _getMaxListeners(re), le > 0 && ce.length > le && !ce.warned) {
    ce.warned = !0;
    var ue = new Error("Possible EventEmitter memory leak detected. " + ce.length + " " + String(ne) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    ue.name = "MaxListenersExceededWarning", ue.emitter = re, ue.type = ne, ue.count = ce.length, ProcessEmitWarning(ue);
  }
  return re;
}
EventEmitter.prototype.addListener = function(ne, ae) {
  return _addListener(this, ne, ae, !1);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function(ne, ae) {
  return _addListener(this, ne, ae, !0);
};
function onceWrapper() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function _onceWrap(re, ne, ae) {
  var ie = { fired: !1, wrapFn: void 0, target: re, type: ne, listener: ae }, le = onceWrapper.bind(ie);
  return le.listener = ae, ie.wrapFn = le, le;
}
EventEmitter.prototype.once = function(ne, ae) {
  return checkListener(ae), this.on(ne, _onceWrap(this, ne, ae)), this;
};
EventEmitter.prototype.prependOnceListener = function(ne, ae) {
  return checkListener(ae), this.prependListener(ne, _onceWrap(this, ne, ae)), this;
};
EventEmitter.prototype.removeListener = function(ne, ae) {
  var ie, le, se, ce, ue;
  if (checkListener(ae), le = this._events, le === void 0)
    return this;
  if (ie = le[ne], ie === void 0)
    return this;
  if (ie === ae || ie.listener === ae)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete le[ne], le.removeListener && this.emit("removeListener", ne, ie.listener || ae));
  else if (typeof ie != "function") {
    for (se = -1, ce = ie.length - 1; ce >= 0; ce--)
      if (ie[ce] === ae || ie[ce].listener === ae) {
        ue = ie[ce].listener, se = ce;
        break;
      }
    if (se < 0)
      return this;
    se === 0 ? ie.shift() : spliceOne(ie, se), ie.length === 1 && (le[ne] = ie[0]), le.removeListener !== void 0 && this.emit("removeListener", ne, ue || ae);
  }
  return this;
};
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners = function(ne) {
  var ae, ie, le;
  if (ie = this._events, ie === void 0)
    return this;
  if (ie.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : ie[ne] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete ie[ne]), this;
  if (arguments.length === 0) {
    var se = Object.keys(ie), ce;
    for (le = 0; le < se.length; ++le)
      ce = se[le], ce !== "removeListener" && this.removeAllListeners(ce);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (ae = ie[ne], typeof ae == "function")
    this.removeListener(ne, ae);
  else if (ae !== void 0)
    for (le = ae.length - 1; le >= 0; le--)
      this.removeListener(ne, ae[le]);
  return this;
};
function _listeners(re, ne, ae) {
  var ie = re._events;
  if (ie === void 0)
    return [];
  var le = ie[ne];
  return le === void 0 ? [] : typeof le == "function" ? ae ? [le.listener || le] : [le] : ae ? unwrapListeners(le) : arrayClone(le, le.length);
}
EventEmitter.prototype.listeners = function(ne) {
  return _listeners(this, ne, !0);
};
EventEmitter.prototype.rawListeners = function(ne) {
  return _listeners(this, ne, !1);
};
EventEmitter.listenerCount = function(re, ne) {
  return typeof re.listenerCount == "function" ? re.listenerCount(ne) : listenerCount.call(re, ne);
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(re) {
  var ne = this._events;
  if (ne !== void 0) {
    var ae = ne[re];
    if (typeof ae == "function")
      return 1;
    if (ae !== void 0)
      return ae.length;
  }
  return 0;
}
EventEmitter.prototype.eventNames = function() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(re, ne) {
  for (var ae = new Array(ne), ie = 0; ie < ne; ++ie)
    ae[ie] = re[ie];
  return ae;
}
function spliceOne(re, ne) {
  for (; ne + 1 < re.length; ne++)
    re[ne] = re[ne + 1];
  re.pop();
}
function unwrapListeners(re) {
  for (var ne = new Array(re.length), ae = 0; ae < ne.length; ++ae)
    ne[ae] = re[ae].listener || re[ae];
  return ne;
}
function once$2(re, ne) {
  return new Promise(function(ae, ie) {
    function le(ce) {
      re.removeListener(ne, se), ie(ce);
    }
    function se() {
      typeof re.removeListener == "function" && re.removeListener("error", le), ae([].slice.call(arguments));
    }
    eventTargetAgnosticAddListener(re, ne, se, { once: !0 }), ne !== "error" && addErrorHandlerIfEventEmitter(re, le, { once: !0 });
  });
}
function addErrorHandlerIfEventEmitter(re, ne, ae) {
  typeof re.on == "function" && eventTargetAgnosticAddListener(re, "error", ne, ae);
}
function eventTargetAgnosticAddListener(re, ne, ae, ie) {
  if (typeof re.on == "function")
    ie.once ? re.once(ne, ae) : re.on(ne, ae);
  else if (typeof re.addEventListener == "function")
    re.addEventListener(ne, function le(se) {
      ie.once && re.removeEventListener(ne, le), ae(se);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof re);
}
var eventsExports = events.exports, streamBrowser$1 = eventsExports.EventEmitter, util$3 = {}, types = {}, shams$4 = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var ne = {}, ae = Symbol("test"), ie = Object(ae);
  if (typeof ae == "string" || Object.prototype.toString.call(ae) !== "[object Symbol]" || Object.prototype.toString.call(ie) !== "[object Symbol]")
    return !1;
  var le = 42;
  ne[ae] = le;
  for (ae in ne)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(ne).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(ne).length !== 0)
    return !1;
  var se = Object.getOwnPropertySymbols(ne);
  if (se.length !== 1 || se[0] !== ae || !Object.prototype.propertyIsEnumerable.call(ne, ae))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var ce = Object.getOwnPropertyDescriptor(ne, ae);
    if (ce.value !== le || ce.enumerable !== !0)
      return !1;
  }
  return !0;
}, hasSymbols$5 = shams$4, shams$3 = function() {
  return hasSymbols$5() && !!Symbol.toStringTag;
}, shams$2 = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var ne = {}, ae = Symbol("test"), ie = Object(ae);
  if (typeof ae == "string" || Object.prototype.toString.call(ae) !== "[object Symbol]" || Object.prototype.toString.call(ie) !== "[object Symbol]")
    return !1;
  var le = 42;
  ne[ae] = le;
  for (ae in ne)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(ne).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(ne).length !== 0)
    return !1;
  var se = Object.getOwnPropertySymbols(ne);
  if (se.length !== 1 || se[0] !== ae || !Object.prototype.propertyIsEnumerable.call(ne, ae))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var ce = Object.getOwnPropertyDescriptor(ne, ae);
    if (ce.value !== le || ce.enumerable !== !0)
      return !1;
  }
  return !0;
}, origSymbol$1 = typeof Symbol < "u" && Symbol, hasSymbolSham$1 = shams$2, hasSymbols$4 = function() {
  return typeof origSymbol$1 != "function" || typeof Symbol != "function" || typeof origSymbol$1("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : hasSymbolSham$1();
}, ERROR_MESSAGE$3 = "Function.prototype.bind called on incompatible ", slice$2 = Array.prototype.slice, toStr$6 = Object.prototype.toString, funcType$3 = "[object Function]", implementation$7 = function(ne) {
  var ae = this;
  if (typeof ae != "function" || toStr$6.call(ae) !== funcType$3)
    throw new TypeError(ERROR_MESSAGE$3 + ae);
  for (var ie = slice$2.call(arguments, 1), le, se = function() {
    if (this instanceof le) {
      var fe = ae.apply(
        this,
        ie.concat(slice$2.call(arguments))
      );
      return Object(fe) === fe ? fe : this;
    } else
      return ae.apply(
        ne,
        ie.concat(slice$2.call(arguments))
      );
  }, ce = Math.max(0, ae.length - ie.length), ue = [], de = 0; de < ce; de++)
    ue.push("$" + de);
  if (le = Function("binder", "return function (" + ue.join(",") + "){ return binder.apply(this,arguments); }")(se), ae.prototype) {
    var me = function() {
    };
    me.prototype = ae.prototype, le.prototype = new me(), me.prototype = null;
  }
  return le;
}, implementation$6 = implementation$7, functionBind$3 = Function.prototype.bind || implementation$6, ERROR_MESSAGE$2 = "Function.prototype.bind called on incompatible ", slice$1 = Array.prototype.slice, toStr$5 = Object.prototype.toString, funcType$2 = "[object Function]", implementation$5 = function(ne) {
  var ae = this;
  if (typeof ae != "function" || toStr$5.call(ae) !== funcType$2)
    throw new TypeError(ERROR_MESSAGE$2 + ae);
  for (var ie = slice$1.call(arguments, 1), le, se = function() {
    if (this instanceof le) {
      var fe = ae.apply(
        this,
        ie.concat(slice$1.call(arguments))
      );
      return Object(fe) === fe ? fe : this;
    } else
      return ae.apply(
        ne,
        ie.concat(slice$1.call(arguments))
      );
  }, ce = Math.max(0, ae.length - ie.length), ue = [], de = 0; de < ce; de++)
    ue.push("$" + de);
  if (le = Function("binder", "return function (" + ue.join(",") + "){ return binder.apply(this,arguments); }")(se), ae.prototype) {
    var me = function() {
    };
    me.prototype = ae.prototype, le.prototype = new me(), me.prototype = null;
  }
  return le;
}, implementation$4 = implementation$5, functionBind$2 = Function.prototype.bind || implementation$4, bind$4 = functionBind$2, src = bind$4.call(Function.call, Object.prototype.hasOwnProperty), undefined$3, $SyntaxError$3 = SyntaxError, $Function$2 = Function, $TypeError$4 = TypeError, getEvalledConstructor$2 = function(re) {
  try {
    return $Function$2('"use strict"; return (' + re + ").constructor;")();
  } catch {
  }
}, $gOPD$3 = Object.getOwnPropertyDescriptor;
if ($gOPD$3)
  try {
    $gOPD$3({}, "");
  } catch {
    $gOPD$3 = null;
  }
var throwTypeError$2 = function() {
  throw new $TypeError$4();
}, ThrowTypeError$2 = $gOPD$3 ? function() {
  try {
    return arguments.callee, throwTypeError$2;
  } catch {
    try {
      return $gOPD$3(arguments, "callee").get;
    } catch {
      return throwTypeError$2;
    }
  }
}() : throwTypeError$2, hasSymbols$3 = hasSymbols$4(), getProto$3 = Object.getPrototypeOf || function(re) {
  return re.__proto__;
}, needsEval$2 = {}, TypedArray$2 = typeof Uint8Array > "u" ? undefined$3 : getProto$3(Uint8Array), INTRINSICS$2 = {
  "%AggregateError%": typeof AggregateError > "u" ? undefined$3 : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? undefined$3 : ArrayBuffer,
  "%ArrayIteratorPrototype%": hasSymbols$3 ? getProto$3([][Symbol.iterator]()) : undefined$3,
  "%AsyncFromSyncIteratorPrototype%": undefined$3,
  "%AsyncFunction%": needsEval$2,
  "%AsyncGenerator%": needsEval$2,
  "%AsyncGeneratorFunction%": needsEval$2,
  "%AsyncIteratorPrototype%": needsEval$2,
  "%Atomics%": typeof Atomics > "u" ? undefined$3 : Atomics,
  "%BigInt%": typeof BigInt > "u" ? undefined$3 : BigInt,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? undefined$3 : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? undefined$3 : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? undefined$3 : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? undefined$3 : FinalizationRegistry,
  "%Function%": $Function$2,
  "%GeneratorFunction%": needsEval$2,
  "%Int8Array%": typeof Int8Array > "u" ? undefined$3 : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? undefined$3 : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? undefined$3 : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": hasSymbols$3 ? getProto$3(getProto$3([][Symbol.iterator]())) : undefined$3,
  "%JSON%": typeof JSON == "object" ? JSON : undefined$3,
  "%Map%": typeof Map > "u" ? undefined$3 : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !hasSymbols$3 ? undefined$3 : getProto$3((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? undefined$3 : Promise,
  "%Proxy%": typeof Proxy > "u" ? undefined$3 : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? undefined$3 : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? undefined$3 : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !hasSymbols$3 ? undefined$3 : getProto$3((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? undefined$3 : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": hasSymbols$3 ? getProto$3(""[Symbol.iterator]()) : undefined$3,
  "%Symbol%": hasSymbols$3 ? Symbol : undefined$3,
  "%SyntaxError%": $SyntaxError$3,
  "%ThrowTypeError%": ThrowTypeError$2,
  "%TypedArray%": TypedArray$2,
  "%TypeError%": $TypeError$4,
  "%Uint8Array%": typeof Uint8Array > "u" ? undefined$3 : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? undefined$3 : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? undefined$3 : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? undefined$3 : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap > "u" ? undefined$3 : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? undefined$3 : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? undefined$3 : WeakSet
}, doEval$2 = function re(ne) {
  var ae;
  if (ne === "%AsyncFunction%")
    ae = getEvalledConstructor$2("async function () {}");
  else if (ne === "%GeneratorFunction%")
    ae = getEvalledConstructor$2("function* () {}");
  else if (ne === "%AsyncGeneratorFunction%")
    ae = getEvalledConstructor$2("async function* () {}");
  else if (ne === "%AsyncGenerator%") {
    var ie = re("%AsyncGeneratorFunction%");
    ie && (ae = ie.prototype);
  } else if (ne === "%AsyncIteratorPrototype%") {
    var le = re("%AsyncGenerator%");
    le && (ae = getProto$3(le.prototype));
  }
  return INTRINSICS$2[ne] = ae, ae;
}, LEGACY_ALIASES$2 = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, bind$3 = functionBind$3, hasOwn$3 = src, $concat$2 = bind$3.call(Function.call, Array.prototype.concat), $spliceApply$2 = bind$3.call(Function.apply, Array.prototype.splice), $replace$2 = bind$3.call(Function.call, String.prototype.replace), $strSlice$2 = bind$3.call(Function.call, String.prototype.slice), rePropName$3 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, reEscapeChar$3 = /\\(\\)?/g, stringToPath$4 = function(ne) {
  var ae = $strSlice$2(ne, 0, 1), ie = $strSlice$2(ne, -1);
  if (ae === "%" && ie !== "%")
    throw new $SyntaxError$3("invalid intrinsic syntax, expected closing `%`");
  if (ie === "%" && ae !== "%")
    throw new $SyntaxError$3("invalid intrinsic syntax, expected opening `%`");
  var le = [];
  return $replace$2(ne, rePropName$3, function(se, ce, ue, de) {
    le[le.length] = ue ? $replace$2(de, reEscapeChar$3, "$1") : ce || se;
  }), le;
}, getBaseIntrinsic$2 = function(ne, ae) {
  var ie = ne, le;
  if (hasOwn$3(LEGACY_ALIASES$2, ie) && (le = LEGACY_ALIASES$2[ie], ie = "%" + le[0] + "%"), hasOwn$3(INTRINSICS$2, ie)) {
    var se = INTRINSICS$2[ie];
    if (se === needsEval$2 && (se = doEval$2(ie)), typeof se > "u" && !ae)
      throw new $TypeError$4("intrinsic " + ne + " exists, but is not available. Please file an issue!");
    return {
      alias: le,
      name: ie,
      value: se
    };
  }
  throw new $SyntaxError$3("intrinsic " + ne + " does not exist!");
}, getIntrinsic$2 = function(ne, ae) {
  if (typeof ne != "string" || ne.length === 0)
    throw new $TypeError$4("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof ae != "boolean")
    throw new $TypeError$4('"allowMissing" argument must be a boolean');
  var ie = stringToPath$4(ne), le = ie.length > 0 ? ie[0] : "", se = getBaseIntrinsic$2("%" + le + "%", ae), ce = se.name, ue = se.value, de = !1, me = se.alias;
  me && (le = me[0], $spliceApply$2(ie, $concat$2([0, 1], me)));
  for (var fe = 1, pe = !0; fe < ie.length; fe += 1) {
    var ge = ie[fe], be = $strSlice$2(ge, 0, 1), Se = $strSlice$2(ge, -1);
    if ((be === '"' || be === "'" || be === "`" || Se === '"' || Se === "'" || Se === "`") && be !== Se)
      throw new $SyntaxError$3("property names with quotes must have matching quotes");
    if ((ge === "constructor" || !pe) && (de = !0), le += "." + ge, ce = "%" + le + "%", hasOwn$3(INTRINSICS$2, ce))
      ue = INTRINSICS$2[ce];
    else if (ue != null) {
      if (!(ge in ue)) {
        if (!ae)
          throw new $TypeError$4("base intrinsic for " + ne + " exists, but the property is not available.");
        return;
      }
      if ($gOPD$3 && fe + 1 >= ie.length) {
        var Pe = $gOPD$3(ue, ge);
        pe = !!Pe, pe && "get" in Pe && !("originalValue" in Pe.get) ? ue = Pe.get : ue = ue[ge];
      } else
        pe = hasOwn$3(ue, ge), ue = ue[ge];
      pe && !de && (INTRINSICS$2[ce] = ue);
    }
  }
  return ue;
}, callBind$4 = { exports: {} };
(function(re) {
  var ne = functionBind$3, ae = getIntrinsic$2, ie = ae("%Function.prototype.apply%"), le = ae("%Function.prototype.call%"), se = ae("%Reflect.apply%", !0) || ne.call(le, ie), ce = ae("%Object.getOwnPropertyDescriptor%", !0), ue = ae("%Object.defineProperty%", !0), de = ae("%Math.max%");
  if (ue)
    try {
      ue({}, "a", { value: 1 });
    } catch {
      ue = null;
    }
  re.exports = function(pe) {
    var ge = se(ne, le, arguments);
    if (ce && ue) {
      var be = ce(ge, "length");
      be.configurable && ue(
        ge,
        "length",
        { value: 1 + de(0, pe.length - (arguments.length - 1)) }
      );
    }
    return ge;
  };
  var me = function() {
    return se(ne, ie, arguments);
  };
  ue ? ue(re.exports, "apply", { value: me }) : re.exports.apply = me;
})(callBind$4);
var callBindExports$1 = callBind$4.exports, GetIntrinsic$3 = getIntrinsic$2, callBind$3 = callBindExports$1, $indexOf$2 = callBind$3(GetIntrinsic$3("String.prototype.indexOf")), callBound$3 = function(ne, ae) {
  var ie = GetIntrinsic$3(ne, !!ae);
  return typeof ie == "function" && $indexOf$2(ne, ".prototype.") > -1 ? callBind$3(ie) : ie;
}, hasToStringTag$3 = shams$3(), callBound$2 = callBound$3, $toString$1 = callBound$2("Object.prototype.toString"), isStandardArguments = function(ne) {
  return hasToStringTag$3 && ne && typeof ne == "object" && Symbol.toStringTag in ne ? !1 : $toString$1(ne) === "[object Arguments]";
}, isLegacyArguments = function(ne) {
  return isStandardArguments(ne) ? !0 : ne !== null && typeof ne == "object" && typeof ne.length == "number" && ne.length >= 0 && $toString$1(ne) !== "[object Array]" && $toString$1(ne.callee) === "[object Function]";
}, supportsStandardArguments = function() {
  return isStandardArguments(arguments);
}();
isStandardArguments.isLegacyArguments = isLegacyArguments;
var isArguments$3 = supportsStandardArguments ? isStandardArguments : isLegacyArguments, toStr$4 = Object.prototype.toString, fnToStr$1 = Function.prototype.toString, isFnRegex = /^\s*(?:function)?\*/, hasToStringTag$2 = shams$3(), getProto$2 = Object.getPrototypeOf, getGeneratorFunc = function() {
  if (!hasToStringTag$2)
    return !1;
  try {
    return Function("return function*() {}")();
  } catch {
  }
}, GeneratorFunction, isGeneratorFunction = function(ne) {
  if (typeof ne != "function")
    return !1;
  if (isFnRegex.test(fnToStr$1.call(ne)))
    return !0;
  if (!hasToStringTag$2) {
    var ae = toStr$4.call(ne);
    return ae === "[object GeneratorFunction]";
  }
  if (!getProto$2)
    return !1;
  if (typeof GeneratorFunction > "u") {
    var ie = getGeneratorFunc();
    GeneratorFunction = ie ? getProto$2(ie) : !1;
  }
  return getProto$2(ne) === GeneratorFunction;
}, fnToStr = Function.prototype.toString, reflectApply = typeof Reflect == "object" && Reflect !== null && Reflect.apply, badArrayLike, isCallableMarker;
if (typeof reflectApply == "function" && typeof Object.defineProperty == "function")
  try {
    badArrayLike = Object.defineProperty({}, "length", {
      get: function() {
        throw isCallableMarker;
      }
    }), isCallableMarker = {}, reflectApply(function() {
      throw 42;
    }, null, badArrayLike);
  } catch (re) {
    re !== isCallableMarker && (reflectApply = null);
  }
else
  reflectApply = null;
var constructorRegex = /^\s*class\b/, isES6ClassFn = function(ne) {
  try {
    var ae = fnToStr.call(ne);
    return constructorRegex.test(ae);
  } catch {
    return !1;
  }
}, tryFunctionObject = function(ne) {
  try {
    return isES6ClassFn(ne) ? !1 : (fnToStr.call(ne), !0);
  } catch {
    return !1;
  }
}, toStr$3 = Object.prototype.toString, objectClass = "[object Object]", fnClass = "[object Function]", genClass = "[object GeneratorFunction]", ddaClass = "[object HTMLAllCollection]", ddaClass2 = "[object HTML document.all class]", ddaClass3 = "[object HTMLCollection]", hasToStringTag$1 = typeof Symbol == "function" && !!Symbol.toStringTag, isIE68 = !(0 in [,]), isDDA = function() {
  return !1;
};
if (typeof document == "object") {
  var all = document.all;
  toStr$3.call(all) === toStr$3.call(document.all) && (isDDA = function(ne) {
    if ((isIE68 || !ne) && (typeof ne > "u" || typeof ne == "object"))
      try {
        var ae = toStr$3.call(ne);
        return (ae === ddaClass || ae === ddaClass2 || ae === ddaClass3 || ae === objectClass) && ne("") == null;
      } catch {
      }
    return !1;
  });
}
var isCallable$1 = reflectApply ? function(ne) {
  if (isDDA(ne))
    return !0;
  if (!ne || typeof ne != "function" && typeof ne != "object")
    return !1;
  try {
    reflectApply(ne, null, badArrayLike);
  } catch (ae) {
    if (ae !== isCallableMarker)
      return !1;
  }
  return !isES6ClassFn(ne) && tryFunctionObject(ne);
} : function(ne) {
  if (isDDA(ne))
    return !0;
  if (!ne || typeof ne != "function" && typeof ne != "object")
    return !1;
  if (hasToStringTag$1)
    return tryFunctionObject(ne);
  if (isES6ClassFn(ne))
    return !1;
  var ae = toStr$3.call(ne);
  return ae !== fnClass && ae !== genClass && !/^\[object HTML/.test(ae) ? !1 : tryFunctionObject(ne);
}, isCallable = isCallable$1, toStr$2 = Object.prototype.toString, hasOwnProperty$a = Object.prototype.hasOwnProperty, forEachArray = function(ne, ae, ie) {
  for (var le = 0, se = ne.length; le < se; le++)
    hasOwnProperty$a.call(ne, le) && (ie == null ? ae(ne[le], le, ne) : ae.call(ie, ne[le], le, ne));
}, forEachString = function(ne, ae, ie) {
  for (var le = 0, se = ne.length; le < se; le++)
    ie == null ? ae(ne.charAt(le), le, ne) : ae.call(ie, ne.charAt(le), le, ne);
}, forEachObject = function(ne, ae, ie) {
  for (var le in ne)
    hasOwnProperty$a.call(ne, le) && (ie == null ? ae(ne[le], le, ne) : ae.call(ie, ne[le], le, ne));
}, forEach$1 = function(ne, ae, ie) {
  if (!isCallable(ae))
    throw new TypeError("iterator must be a function");
  var le;
  arguments.length >= 3 && (le = ie), toStr$2.call(ne) === "[object Array]" ? forEachArray(ne, ae, le) : typeof ne == "string" ? forEachString(ne, ae, le) : forEachObject(ne, ae, le);
}, forEach_1 = forEach$1, possibleTypedArrayNames = [
  "Float32Array",
  "Float64Array",
  "Int8Array",
  "Int16Array",
  "Int32Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "Uint16Array",
  "Uint32Array",
  "BigInt64Array",
  "BigUint64Array"
], possibleNames = possibleTypedArrayNames, g$1 = typeof globalThis > "u" ? commonjsGlobal : globalThis, availableTypedArrays$1 = function() {
  for (var ne = [], ae = 0; ae < possibleNames.length; ae++)
    typeof g$1[possibleNames[ae]] == "function" && (ne[ne.length] = possibleNames[ae]);
  return ne;
}, callBind$2 = { exports: {} }, ERROR_MESSAGE$1 = "Function.prototype.bind called on incompatible ", toStr$1 = Object.prototype.toString, max = Math.max, funcType$1 = "[object Function]", concatty = function(ne, ae) {
  for (var ie = [], le = 0; le < ne.length; le += 1)
    ie[le] = ne[le];
  for (var se = 0; se < ae.length; se += 1)
    ie[se + ne.length] = ae[se];
  return ie;
}, slicy = function(ne, ae) {
  for (var ie = [], le = ae, se = 0; le < ne.length; le += 1, se += 1)
    ie[se] = ne[le];
  return ie;
}, joiny = function(re, ne) {
  for (var ae = "", ie = 0; ie < re.length; ie += 1)
    ae += re[ie], ie + 1 < re.length && (ae += ne);
  return ae;
}, implementation$3 = function(ne) {
  var ae = this;
  if (typeof ae != "function" || toStr$1.apply(ae) !== funcType$1)
    throw new TypeError(ERROR_MESSAGE$1 + ae);
  for (var ie = slicy(arguments, 1), le, se = function() {
    if (this instanceof le) {
      var fe = ae.apply(
        this,
        concatty(ie, arguments)
      );
      return Object(fe) === fe ? fe : this;
    }
    return ae.apply(
      ne,
      concatty(ie, arguments)
    );
  }, ce = max(0, ae.length - ie.length), ue = [], de = 0; de < ce; de++)
    ue[de] = "$" + de;
  if (le = Function("binder", "return function (" + joiny(ue, ",") + "){ return binder.apply(this,arguments); }")(se), ae.prototype) {
    var me = function() {
    };
    me.prototype = ae.prototype, le.prototype = new me(), me.prototype = null;
  }
  return le;
}, implementation$2 = implementation$3, functionBind$1 = Function.prototype.bind || implementation$2, esErrors = Error, _eval = EvalError, range = RangeError, ref = ReferenceError, syntax = SyntaxError, type = TypeError, uri = URIError, shams$1, hasRequiredShams$1;
function requireShams$1() {
  return hasRequiredShams$1 || (hasRequiredShams$1 = 1, shams$1 = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var ne = {}, ae = Symbol("test"), ie = Object(ae);
    if (typeof ae == "string" || Object.prototype.toString.call(ae) !== "[object Symbol]" || Object.prototype.toString.call(ie) !== "[object Symbol]")
      return !1;
    var le = 42;
    ne[ae] = le;
    for (ae in ne)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(ne).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(ne).length !== 0)
      return !1;
    var se = Object.getOwnPropertySymbols(ne);
    if (se.length !== 1 || se[0] !== ae || !Object.prototype.propertyIsEnumerable.call(ne, ae))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var ce = Object.getOwnPropertyDescriptor(ne, ae);
      if (ce.value !== le || ce.enumerable !== !0)
        return !1;
    }
    return !0;
  }), shams$1;
}
var origSymbol = typeof Symbol < "u" && Symbol, hasSymbolSham = requireShams$1(), hasSymbols$2 = function() {
  return typeof origSymbol != "function" || typeof Symbol != "function" || typeof origSymbol("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : hasSymbolSham();
}, test = {
  foo: {}
}, $Object = Object, hasProto$1 = function() {
  return { __proto__: test }.foo === test.foo && !({ __proto__: null } instanceof $Object);
}, call$1 = Function.prototype.call, $hasOwn = Object.prototype.hasOwnProperty, bind$2 = functionBind$1, hasown = bind$2.call(call$1, $hasOwn), undefined$2, $Error = esErrors, $EvalError = _eval, $RangeError = range, $ReferenceError = ref, $SyntaxError$2 = syntax, $TypeError$3 = type, $URIError = uri, $Function$1 = Function, getEvalledConstructor$1 = function(re) {
  try {
    return $Function$1('"use strict"; return (' + re + ").constructor;")();
  } catch {
  }
}, $gOPD$2 = Object.getOwnPropertyDescriptor;
if ($gOPD$2)
  try {
    $gOPD$2({}, "");
  } catch {
    $gOPD$2 = null;
  }
var throwTypeError$1 = function() {
  throw new $TypeError$3();
}, ThrowTypeError$1 = $gOPD$2 ? function() {
  try {
    return arguments.callee, throwTypeError$1;
  } catch {
    try {
      return $gOPD$2(arguments, "callee").get;
    } catch {
      return throwTypeError$1;
    }
  }
}() : throwTypeError$1, hasSymbols$1 = hasSymbols$2(), hasProto = hasProto$1(), getProto$1 = Object.getPrototypeOf || (hasProto ? function(re) {
  return re.__proto__;
} : null), needsEval$1 = {}, TypedArray$1 = typeof Uint8Array > "u" || !getProto$1 ? undefined$2 : getProto$1(Uint8Array), INTRINSICS$1 = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError > "u" ? undefined$2 : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? undefined$2 : ArrayBuffer,
  "%ArrayIteratorPrototype%": hasSymbols$1 && getProto$1 ? getProto$1([][Symbol.iterator]()) : undefined$2,
  "%AsyncFromSyncIteratorPrototype%": undefined$2,
  "%AsyncFunction%": needsEval$1,
  "%AsyncGenerator%": needsEval$1,
  "%AsyncGeneratorFunction%": needsEval$1,
  "%AsyncIteratorPrototype%": needsEval$1,
  "%Atomics%": typeof Atomics > "u" ? undefined$2 : Atomics,
  "%BigInt%": typeof BigInt > "u" ? undefined$2 : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? undefined$2 : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? undefined$2 : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? undefined$2 : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": $Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": $EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? undefined$2 : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? undefined$2 : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? undefined$2 : FinalizationRegistry,
  "%Function%": $Function$1,
  "%GeneratorFunction%": needsEval$1,
  "%Int8Array%": typeof Int8Array > "u" ? undefined$2 : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? undefined$2 : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? undefined$2 : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": hasSymbols$1 && getProto$1 ? getProto$1(getProto$1([][Symbol.iterator]())) : undefined$2,
  "%JSON%": typeof JSON == "object" ? JSON : undefined$2,
  "%Map%": typeof Map > "u" ? undefined$2 : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !hasSymbols$1 || !getProto$1 ? undefined$2 : getProto$1((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? undefined$2 : Promise,
  "%Proxy%": typeof Proxy > "u" ? undefined$2 : Proxy,
  "%RangeError%": $RangeError,
  "%ReferenceError%": $ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? undefined$2 : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? undefined$2 : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !hasSymbols$1 || !getProto$1 ? undefined$2 : getProto$1((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? undefined$2 : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": hasSymbols$1 && getProto$1 ? getProto$1(""[Symbol.iterator]()) : undefined$2,
  "%Symbol%": hasSymbols$1 ? Symbol : undefined$2,
  "%SyntaxError%": $SyntaxError$2,
  "%ThrowTypeError%": ThrowTypeError$1,
  "%TypedArray%": TypedArray$1,
  "%TypeError%": $TypeError$3,
  "%Uint8Array%": typeof Uint8Array > "u" ? undefined$2 : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? undefined$2 : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? undefined$2 : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? undefined$2 : Uint32Array,
  "%URIError%": $URIError,
  "%WeakMap%": typeof WeakMap > "u" ? undefined$2 : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? undefined$2 : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? undefined$2 : WeakSet
};
if (getProto$1)
  try {
    null.error;
  } catch (re) {
    var errorProto$1 = getProto$1(getProto$1(re));
    INTRINSICS$1["%Error.prototype%"] = errorProto$1;
  }
var doEval$1 = function re(ne) {
  var ae;
  if (ne === "%AsyncFunction%")
    ae = getEvalledConstructor$1("async function () {}");
  else if (ne === "%GeneratorFunction%")
    ae = getEvalledConstructor$1("function* () {}");
  else if (ne === "%AsyncGeneratorFunction%")
    ae = getEvalledConstructor$1("async function* () {}");
  else if (ne === "%AsyncGenerator%") {
    var ie = re("%AsyncGeneratorFunction%");
    ie && (ae = ie.prototype);
  } else if (ne === "%AsyncIteratorPrototype%") {
    var le = re("%AsyncGenerator%");
    le && getProto$1 && (ae = getProto$1(le.prototype));
  }
  return INTRINSICS$1[ne] = ae, ae;
}, LEGACY_ALIASES$1 = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, bind$1 = functionBind$1, hasOwn$2 = hasown, $concat$1 = bind$1.call(Function.call, Array.prototype.concat), $spliceApply$1 = bind$1.call(Function.apply, Array.prototype.splice), $replace$1 = bind$1.call(Function.call, String.prototype.replace), $strSlice$1 = bind$1.call(Function.call, String.prototype.slice), $exec$1 = bind$1.call(Function.call, RegExp.prototype.exec), rePropName$2 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, reEscapeChar$2 = /\\(\\)?/g, stringToPath$3 = function(ne) {
  var ae = $strSlice$1(ne, 0, 1), ie = $strSlice$1(ne, -1);
  if (ae === "%" && ie !== "%")
    throw new $SyntaxError$2("invalid intrinsic syntax, expected closing `%`");
  if (ie === "%" && ae !== "%")
    throw new $SyntaxError$2("invalid intrinsic syntax, expected opening `%`");
  var le = [];
  return $replace$1(ne, rePropName$2, function(se, ce, ue, de) {
    le[le.length] = ue ? $replace$1(de, reEscapeChar$2, "$1") : ce || se;
  }), le;
}, getBaseIntrinsic$1 = function(ne, ae) {
  var ie = ne, le;
  if (hasOwn$2(LEGACY_ALIASES$1, ie) && (le = LEGACY_ALIASES$1[ie], ie = "%" + le[0] + "%"), hasOwn$2(INTRINSICS$1, ie)) {
    var se = INTRINSICS$1[ie];
    if (se === needsEval$1 && (se = doEval$1(ie)), typeof se > "u" && !ae)
      throw new $TypeError$3("intrinsic " + ne + " exists, but is not available. Please file an issue!");
    return {
      alias: le,
      name: ie,
      value: se
    };
  }
  throw new $SyntaxError$2("intrinsic " + ne + " does not exist!");
}, getIntrinsic$1 = function(ne, ae) {
  if (typeof ne != "string" || ne.length === 0)
    throw new $TypeError$3("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof ae != "boolean")
    throw new $TypeError$3('"allowMissing" argument must be a boolean');
  if ($exec$1(/^%?[^%]*%?$/, ne) === null)
    throw new $SyntaxError$2("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var ie = stringToPath$3(ne), le = ie.length > 0 ? ie[0] : "", se = getBaseIntrinsic$1("%" + le + "%", ae), ce = se.name, ue = se.value, de = !1, me = se.alias;
  me && (le = me[0], $spliceApply$1(ie, $concat$1([0, 1], me)));
  for (var fe = 1, pe = !0; fe < ie.length; fe += 1) {
    var ge = ie[fe], be = $strSlice$1(ge, 0, 1), Se = $strSlice$1(ge, -1);
    if ((be === '"' || be === "'" || be === "`" || Se === '"' || Se === "'" || Se === "`") && be !== Se)
      throw new $SyntaxError$2("property names with quotes must have matching quotes");
    if ((ge === "constructor" || !pe) && (de = !0), le += "." + ge, ce = "%" + le + "%", hasOwn$2(INTRINSICS$1, ce))
      ue = INTRINSICS$1[ce];
    else if (ue != null) {
      if (!(ge in ue)) {
        if (!ae)
          throw new $TypeError$3("base intrinsic for " + ne + " exists, but the property is not available.");
        return;
      }
      if ($gOPD$2 && fe + 1 >= ie.length) {
        var Pe = $gOPD$2(ue, ge);
        pe = !!Pe, pe && "get" in Pe && !("originalValue" in Pe.get) ? ue = Pe.get : ue = ue[ge];
      } else
        pe = hasOwn$2(ue, ge), ue = ue[ge];
      pe && !de && (INTRINSICS$1[ce] = ue);
    }
  }
  return ue;
}, esDefineProperty, hasRequiredEsDefineProperty;
function requireEsDefineProperty() {
  if (hasRequiredEsDefineProperty) return esDefineProperty;
  hasRequiredEsDefineProperty = 1;
  var re = getIntrinsic$1, ne = re("%Object.defineProperty%", !0) || !1;
  if (ne)
    try {
      ne({}, "a", { value: 1 });
    } catch {
      ne = !1;
    }
  return esDefineProperty = ne, esDefineProperty;
}
var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ", slice = Array.prototype.slice, toStr = Object.prototype.toString, funcType = "[object Function]", implementation$1 = function(ne) {
  var ae = this;
  if (typeof ae != "function" || toStr.call(ae) !== funcType)
    throw new TypeError(ERROR_MESSAGE + ae);
  for (var ie = slice.call(arguments, 1), le, se = function() {
    if (this instanceof le) {
      var fe = ae.apply(
        this,
        ie.concat(slice.call(arguments))
      );
      return Object(fe) === fe ? fe : this;
    } else
      return ae.apply(
        ne,
        ie.concat(slice.call(arguments))
      );
  }, ce = Math.max(0, ae.length - ie.length), ue = [], de = 0; de < ce; de++)
    ue.push("$" + de);
  if (le = Function("binder", "return function (" + ue.join(",") + "){ return binder.apply(this,arguments); }")(se), ae.prototype) {
    var me = function() {
    };
    me.prototype = ae.prototype, le.prototype = new me(), me.prototype = null;
  }
  return le;
}, implementation = implementation$1, functionBind = Function.prototype.bind || implementation, undefined$1, $SyntaxError$1 = SyntaxError, $Function = Function, $TypeError$2 = TypeError, getEvalledConstructor = function(re) {
  try {
    return $Function('"use strict"; return (' + re + ").constructor;")();
  } catch {
  }
}, $gOPD$1 = Object.getOwnPropertyDescriptor;
if ($gOPD$1)
  try {
    $gOPD$1({}, "");
  } catch {
    $gOPD$1 = null;
  }
var throwTypeError = function() {
  throw new $TypeError$2();
}, ThrowTypeError = $gOPD$1 ? function() {
  try {
    return arguments.callee, throwTypeError;
  } catch {
    try {
      return $gOPD$1(arguments, "callee").get;
    } catch {
      return throwTypeError;
    }
  }
}() : throwTypeError, hasSymbols = hasSymbols$2(), getProto = Object.getPrototypeOf || function(re) {
  return re.__proto__;
}, needsEval = {}, TypedArray = typeof Uint8Array > "u" ? undefined$1 : getProto(Uint8Array), INTRINSICS = {
  "%AggregateError%": typeof AggregateError > "u" ? undefined$1 : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? undefined$1 : ArrayBuffer,
  "%ArrayIteratorPrototype%": hasSymbols ? getProto([][Symbol.iterator]()) : undefined$1,
  "%AsyncFromSyncIteratorPrototype%": undefined$1,
  "%AsyncFunction%": needsEval,
  "%AsyncGenerator%": needsEval,
  "%AsyncGeneratorFunction%": needsEval,
  "%AsyncIteratorPrototype%": needsEval,
  "%Atomics%": typeof Atomics > "u" ? undefined$1 : Atomics,
  "%BigInt%": typeof BigInt > "u" ? undefined$1 : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? undefined$1 : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? undefined$1 : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? undefined$1 : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? undefined$1 : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? undefined$1 : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? undefined$1 : FinalizationRegistry,
  "%Function%": $Function,
  "%GeneratorFunction%": needsEval,
  "%Int8Array%": typeof Int8Array > "u" ? undefined$1 : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? undefined$1 : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? undefined$1 : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
  "%JSON%": typeof JSON == "object" ? JSON : undefined$1,
  "%Map%": typeof Map > "u" ? undefined$1 : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !hasSymbols ? undefined$1 : getProto((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? undefined$1 : Promise,
  "%Proxy%": typeof Proxy > "u" ? undefined$1 : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? undefined$1 : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? undefined$1 : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !hasSymbols ? undefined$1 : getProto((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? undefined$1 : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": hasSymbols ? getProto(""[Symbol.iterator]()) : undefined$1,
  "%Symbol%": hasSymbols ? Symbol : undefined$1,
  "%SyntaxError%": $SyntaxError$1,
  "%ThrowTypeError%": ThrowTypeError,
  "%TypedArray%": TypedArray,
  "%TypeError%": $TypeError$2,
  "%Uint8Array%": typeof Uint8Array > "u" ? undefined$1 : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? undefined$1 : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? undefined$1 : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? undefined$1 : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap > "u" ? undefined$1 : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? undefined$1 : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? undefined$1 : WeakSet
};
try {
  null.error;
} catch (re) {
  var errorProto = getProto(getProto(re));
  INTRINSICS["%Error.prototype%"] = errorProto;
}
var doEval = function re(ne) {
  var ae;
  if (ne === "%AsyncFunction%")
    ae = getEvalledConstructor("async function () {}");
  else if (ne === "%GeneratorFunction%")
    ae = getEvalledConstructor("function* () {}");
  else if (ne === "%AsyncGeneratorFunction%")
    ae = getEvalledConstructor("async function* () {}");
  else if (ne === "%AsyncGenerator%") {
    var ie = re("%AsyncGeneratorFunction%");
    ie && (ae = ie.prototype);
  } else if (ne === "%AsyncIteratorPrototype%") {
    var le = re("%AsyncGenerator%");
    le && (ae = getProto(le.prototype));
  }
  return INTRINSICS[ne] = ae, ae;
}, LEGACY_ALIASES = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, bind = functionBind, hasOwn$1 = src, $concat = bind.call(Function.call, Array.prototype.concat), $spliceApply = bind.call(Function.apply, Array.prototype.splice), $replace = bind.call(Function.call, String.prototype.replace), $strSlice = bind.call(Function.call, String.prototype.slice), $exec = bind.call(Function.call, RegExp.prototype.exec), rePropName$1 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, reEscapeChar$1 = /\\(\\)?/g, stringToPath$2 = function(ne) {
  var ae = $strSlice(ne, 0, 1), ie = $strSlice(ne, -1);
  if (ae === "%" && ie !== "%")
    throw new $SyntaxError$1("invalid intrinsic syntax, expected closing `%`");
  if (ie === "%" && ae !== "%")
    throw new $SyntaxError$1("invalid intrinsic syntax, expected opening `%`");
  var le = [];
  return $replace(ne, rePropName$1, function(se, ce, ue, de) {
    le[le.length] = ue ? $replace(de, reEscapeChar$1, "$1") : ce || se;
  }), le;
}, getBaseIntrinsic = function(ne, ae) {
  var ie = ne, le;
  if (hasOwn$1(LEGACY_ALIASES, ie) && (le = LEGACY_ALIASES[ie], ie = "%" + le[0] + "%"), hasOwn$1(INTRINSICS, ie)) {
    var se = INTRINSICS[ie];
    if (se === needsEval && (se = doEval(ie)), typeof se > "u" && !ae)
      throw new $TypeError$2("intrinsic " + ne + " exists, but is not available. Please file an issue!");
    return {
      alias: le,
      name: ie,
      value: se
    };
  }
  throw new $SyntaxError$1("intrinsic " + ne + " does not exist!");
}, getIntrinsic = function(ne, ae) {
  if (typeof ne != "string" || ne.length === 0)
    throw new $TypeError$2("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof ae != "boolean")
    throw new $TypeError$2('"allowMissing" argument must be a boolean');
  if ($exec(/^%?[^%]*%?$/, ne) === null)
    throw new $SyntaxError$1("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var ie = stringToPath$2(ne), le = ie.length > 0 ? ie[0] : "", se = getBaseIntrinsic("%" + le + "%", ae), ce = se.name, ue = se.value, de = !1, me = se.alias;
  me && (le = me[0], $spliceApply(ie, $concat([0, 1], me)));
  for (var fe = 1, pe = !0; fe < ie.length; fe += 1) {
    var ge = ie[fe], be = $strSlice(ge, 0, 1), Se = $strSlice(ge, -1);
    if ((be === '"' || be === "'" || be === "`" || Se === '"' || Se === "'" || Se === "`") && be !== Se)
      throw new $SyntaxError$1("property names with quotes must have matching quotes");
    if ((ge === "constructor" || !pe) && (de = !0), le += "." + ge, ce = "%" + le + "%", hasOwn$1(INTRINSICS, ce))
      ue = INTRINSICS[ce];
    else if (ue != null) {
      if (!(ge in ue)) {
        if (!ae)
          throw new $TypeError$2("base intrinsic for " + ne + " exists, but the property is not available.");
        return;
      }
      if ($gOPD$1 && fe + 1 >= ie.length) {
        var Pe = $gOPD$1(ue, ge);
        pe = !!Pe, pe && "get" in Pe && !("originalValue" in Pe.get) ? ue = Pe.get : ue = ue[ge];
      } else
        pe = hasOwn$1(ue, ge), ue = ue[ge];
      pe && !de && (INTRINSICS[ce] = ue);
    }
  }
  return ue;
}, GetIntrinsic$2 = getIntrinsic, $gOPD = GetIntrinsic$2("%Object.getOwnPropertyDescriptor%", !0);
if ($gOPD)
  try {
    $gOPD([], "length");
  } catch {
    $gOPD = null;
  }
var gopd$1 = $gOPD, $defineProperty$1 = requireEsDefineProperty(), $SyntaxError = syntax, $TypeError$1 = type, gopd = gopd$1, defineDataProperty = function(ne, ae, ie) {
  if (!ne || typeof ne != "object" && typeof ne != "function")
    throw new $TypeError$1("`obj` must be an object or a function`");
  if (typeof ae != "string" && typeof ae != "symbol")
    throw new $TypeError$1("`property` must be a string or a symbol`");
  if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
    throw new $TypeError$1("`nonEnumerable`, if provided, must be a boolean or null");
  if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
    throw new $TypeError$1("`nonWritable`, if provided, must be a boolean or null");
  if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
    throw new $TypeError$1("`nonConfigurable`, if provided, must be a boolean or null");
  if (arguments.length > 6 && typeof arguments[6] != "boolean")
    throw new $TypeError$1("`loose`, if provided, must be a boolean");
  var le = arguments.length > 3 ? arguments[3] : null, se = arguments.length > 4 ? arguments[4] : null, ce = arguments.length > 5 ? arguments[5] : null, ue = arguments.length > 6 ? arguments[6] : !1, de = !!gopd && gopd(ne, ae);
  if ($defineProperty$1)
    $defineProperty$1(ne, ae, {
      configurable: ce === null && de ? de.configurable : !ce,
      enumerable: le === null && de ? de.enumerable : !le,
      value: ie,
      writable: se === null && de ? de.writable : !se
    });
  else if (ue || !le && !se && !ce)
    ne[ae] = ie;
  else
    throw new $SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
}, $defineProperty = requireEsDefineProperty(), hasPropertyDescriptors = function() {
  return !!$defineProperty;
};
hasPropertyDescriptors.hasArrayLengthDefineBug = function() {
  if (!$defineProperty)
    return null;
  try {
    return $defineProperty([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var hasPropertyDescriptors_1 = hasPropertyDescriptors, GetIntrinsic$1 = getIntrinsic$1, define = defineDataProperty, hasDescriptors = hasPropertyDescriptors_1(), gOPD$1 = gopd$1, $TypeError = type, $floor = GetIntrinsic$1("%Math.floor%"), setFunctionLength = function(ne, ae) {
  if (typeof ne != "function")
    throw new $TypeError("`fn` is not a function");
  if (typeof ae != "number" || ae < 0 || ae > 4294967295 || $floor(ae) !== ae)
    throw new $TypeError("`length` must be a positive 32-bit integer");
  var ie = arguments.length > 2 && !!arguments[2], le = !0, se = !0;
  if ("length" in ne && gOPD$1) {
    var ce = gOPD$1(ne, "length");
    ce && !ce.configurable && (le = !1), ce && !ce.writable && (se = !1);
  }
  return (le || se || !ie) && (hasDescriptors ? define(
    /** @type {Parameters<define>[0]} */
    ne,
    "length",
    ae,
    !0,
    !0
  ) : define(
    /** @type {Parameters<define>[0]} */
    ne,
    "length",
    ae
  )), ne;
};
(function(re) {
  var ne = functionBind$1, ae = getIntrinsic$1, ie = setFunctionLength, le = type, se = ae("%Function.prototype.apply%"), ce = ae("%Function.prototype.call%"), ue = ae("%Reflect.apply%", !0) || ne.call(ce, se), de = requireEsDefineProperty(), me = ae("%Math.max%");
  re.exports = function(ge) {
    if (typeof ge != "function")
      throw new le("a function is required");
    var be = ue(ne, ce, arguments);
    return ie(
      be,
      1 + me(0, ge.length - (arguments.length - 1)),
      !0
    );
  };
  var fe = function() {
    return ue(ne, se, arguments);
  };
  de ? de(re.exports, "apply", { value: fe }) : re.exports.apply = fe;
})(callBind$2);
var callBindExports = callBind$2.exports, GetIntrinsic = getIntrinsic$1, callBind$1 = callBindExports, $indexOf$1 = callBind$1(GetIntrinsic("String.prototype.indexOf")), callBound$1 = function(ne, ae) {
  var ie = GetIntrinsic(ne, !!ae);
  return typeof ie == "function" && $indexOf$1(ne, ".prototype.") > -1 ? callBind$1(ie) : ie;
}, shams, hasRequiredShams;
function requireShams() {
  if (hasRequiredShams) return shams;
  hasRequiredShams = 1;
  var re = requireShams$1();
  return shams = function() {
    return re() && !!Symbol.toStringTag;
  }, shams;
}
var forEach = forEach_1, availableTypedArrays = availableTypedArrays$1, callBind = callBindExports, callBound = callBound$1, gOPD = gopd$1, $toString = callBound("Object.prototype.toString"), hasToStringTag = requireShams()(), g = typeof globalThis > "u" ? commonjsGlobal : globalThis, typedArrays = availableTypedArrays(), $slice = callBound("String.prototype.slice"), getPrototypeOf = Object.getPrototypeOf, $indexOf = callBound("Array.prototype.indexOf", !0) || function(ne, ae) {
  for (var ie = 0; ie < ne.length; ie += 1)
    if (ne[ie] === ae)
      return ie;
  return -1;
}, cache$1 = { __proto__: null };
hasToStringTag && gOPD && getPrototypeOf ? forEach(typedArrays, function(re) {
  var ne = new g[re]();
  if (Symbol.toStringTag in ne) {
    var ae = getPrototypeOf(ne), ie = gOPD(ae, Symbol.toStringTag);
    if (!ie) {
      var le = getPrototypeOf(ae);
      ie = gOPD(le, Symbol.toStringTag);
    }
    cache$1["$" + re] = callBind(ie.get);
  }
}) : forEach(typedArrays, function(re) {
  var ne = new g[re](), ae = ne.slice || ne.set;
  ae && (cache$1["$" + re] = callBind(ae));
});
var tryTypedArrays = function(ne) {
  var ae = !1;
  return forEach(
    // eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */
    /** @type {any} */
    cache$1,
    /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
    function(ie, le) {
      if (!ae)
        try {
          "$" + ie(ne) === le && (ae = $slice(le, 1));
        } catch {
        }
    }
  ), ae;
}, trySlices = function(ne) {
  var ae = !1;
  return forEach(
    // eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */
    /** @type {any} */
    cache$1,
    /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */
    function(ie, le) {
      if (!ae)
        try {
          ie(ne), ae = $slice(le, 1);
        } catch {
        }
    }
  ), ae;
}, whichTypedArray$1 = function(ne) {
  if (!ne || typeof ne != "object")
    return !1;
  if (!hasToStringTag) {
    var ae = $slice($toString(ne), 8, -1);
    return $indexOf(typedArrays, ae) > -1 ? ae : ae !== "Object" ? !1 : trySlices(ne);
  }
  return gOPD ? tryTypedArrays(ne) : null;
}, whichTypedArray = whichTypedArray$1, isTypedArray$3 = function(ne) {
  return !!whichTypedArray(ne);
};
(function(re) {
  var ne = isArguments$3, ae = isGeneratorFunction, ie = whichTypedArray$1, le = isTypedArray$3;
  function se(dt) {
    return dt.call.bind(dt);
  }
  var ce = typeof BigInt < "u", ue = typeof Symbol < "u", de = se(Object.prototype.toString), me = se(Number.prototype.valueOf), fe = se(String.prototype.valueOf), pe = se(Boolean.prototype.valueOf);
  if (ce)
    var ge = se(BigInt.prototype.valueOf);
  if (ue)
    var be = se(Symbol.prototype.valueOf);
  function Se(dt, gt) {
    if (typeof dt != "object")
      return !1;
    try {
      return gt(dt), !0;
    } catch {
      return !1;
    }
  }
  re.isArgumentsObject = ne, re.isGeneratorFunction = ae, re.isTypedArray = le;
  function Pe(dt) {
    return typeof Promise < "u" && dt instanceof Promise || dt !== null && typeof dt == "object" && typeof dt.then == "function" && typeof dt.catch == "function";
  }
  re.isPromise = Pe;
  function Ee(dt) {
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(dt) : le(dt) || Be(dt);
  }
  re.isArrayBufferView = Ee;
  function Ve(dt) {
    return ie(dt) === "Uint8Array";
  }
  re.isUint8Array = Ve;
  function Ae(dt) {
    return ie(dt) === "Uint8ClampedArray";
  }
  re.isUint8ClampedArray = Ae;
  function Oe(dt) {
    return ie(dt) === "Uint16Array";
  }
  re.isUint16Array = Oe;
  function Ne(dt) {
    return ie(dt) === "Uint32Array";
  }
  re.isUint32Array = Ne;
  function He(dt) {
    return ie(dt) === "Int8Array";
  }
  re.isInt8Array = He;
  function Ue(dt) {
    return ie(dt) === "Int16Array";
  }
  re.isInt16Array = Ue;
  function Ze(dt) {
    return ie(dt) === "Int32Array";
  }
  re.isInt32Array = Ze;
  function Fe(dt) {
    return ie(dt) === "Float32Array";
  }
  re.isFloat32Array = Fe;
  function Ke(dt) {
    return ie(dt) === "Float64Array";
  }
  re.isFloat64Array = Ke;
  function tt(dt) {
    return ie(dt) === "BigInt64Array";
  }
  re.isBigInt64Array = tt;
  function Re(dt) {
    return ie(dt) === "BigUint64Array";
  }
  re.isBigUint64Array = Re;
  function Ce(dt) {
    return de(dt) === "[object Map]";
  }
  Ce.working = typeof Map < "u" && Ce(/* @__PURE__ */ new Map());
  function _e(dt) {
    return typeof Map > "u" ? !1 : Ce.working ? Ce(dt) : dt instanceof Map;
  }
  re.isMap = _e;
  function he(dt) {
    return de(dt) === "[object Set]";
  }
  he.working = typeof Set < "u" && he(/* @__PURE__ */ new Set());
  function ve(dt) {
    return typeof Set > "u" ? !1 : he.working ? he(dt) : dt instanceof Set;
  }
  re.isSet = ve;
  function xe(dt) {
    return de(dt) === "[object WeakMap]";
  }
  xe.working = typeof WeakMap < "u" && xe(/* @__PURE__ */ new WeakMap());
  function $e(dt) {
    return typeof WeakMap > "u" ? !1 : xe.working ? xe(dt) : dt instanceof WeakMap;
  }
  re.isWeakMap = $e;
  function Te(dt) {
    return de(dt) === "[object WeakSet]";
  }
  Te.working = typeof WeakSet < "u" && Te(/* @__PURE__ */ new WeakSet());
  function Ie(dt) {
    return Te(dt);
  }
  re.isWeakSet = Ie;
  function we(dt) {
    return de(dt) === "[object ArrayBuffer]";
  }
  we.working = typeof ArrayBuffer < "u" && we(new ArrayBuffer());
  function ke(dt) {
    return typeof ArrayBuffer > "u" ? !1 : we.working ? we(dt) : dt instanceof ArrayBuffer;
  }
  re.isArrayBuffer = ke;
  function ye(dt) {
    return de(dt) === "[object DataView]";
  }
  ye.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && ye(new DataView(new ArrayBuffer(1), 0, 1));
  function Be(dt) {
    return typeof DataView > "u" ? !1 : ye.working ? ye(dt) : dt instanceof DataView;
  }
  re.isDataView = Be;
  var Xe = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
  function et(dt) {
    return de(dt) === "[object SharedArrayBuffer]";
  }
  function Ye(dt) {
    return typeof Xe > "u" ? !1 : (typeof et.working > "u" && (et.working = et(new Xe())), et.working ? et(dt) : dt instanceof Xe);
  }
  re.isSharedArrayBuffer = Ye;
  function De(dt) {
    return de(dt) === "[object AsyncFunction]";
  }
  re.isAsyncFunction = De;
  function je(dt) {
    return de(dt) === "[object Map Iterator]";
  }
  re.isMapIterator = je;
  function rt(dt) {
    return de(dt) === "[object Set Iterator]";
  }
  re.isSetIterator = rt;
  function at(dt) {
    return de(dt) === "[object Generator]";
  }
  re.isGeneratorObject = at;
  function qe(dt) {
    return de(dt) === "[object WebAssembly.Module]";
  }
  re.isWebAssemblyCompiledModule = qe;
  function We(dt) {
    return Se(dt, me);
  }
  re.isNumberObject = We;
  function ze(dt) {
    return Se(dt, fe);
  }
  re.isStringObject = ze;
  function Ge(dt) {
    return Se(dt, pe);
  }
  re.isBooleanObject = Ge;
  function nt(dt) {
    return ce && Se(dt, ge);
  }
  re.isBigIntObject = nt;
  function ot(dt) {
    return ue && Se(dt, be);
  }
  re.isSymbolObject = ot;
  function lt(dt) {
    return We(dt) || ze(dt) || Ge(dt) || nt(dt) || ot(dt);
  }
  re.isBoxedPrimitive = lt;
  function mt(dt) {
    return typeof Uint8Array < "u" && (ke(dt) || Ye(dt));
  }
  re.isAnyArrayBuffer = mt, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(dt) {
    Object.defineProperty(re, dt, {
      enumerable: !1,
      value: function() {
        throw new Error(dt + " is not supported in userland");
      }
    });
  });
})(types);
var isBufferBrowser = function(ne) {
  return ne && typeof ne == "object" && typeof ne.copy == "function" && typeof ne.fill == "function" && typeof ne.readUInt8 == "function";
};
(function(re) {
  var ne = { npm_package_exports___require: "./dist/cs-design-system.umd.js", npm_package_devDependencies_vitest: "~2.1.4", npm_package_devDependencies_eslint_import_resolver_alias: "~1.1.2", npm_config_version_commit_hooks: "true", npm_config_user_agent: "yarn/1.22.19 npm/? node/v18.16.0 linux x64", NODE_VERSION: "18.16.0", npm_package_dependencies_vue: "~3.5.13", npm_config_bin_links: "true", npm_config_wrap_output: "", HOSTNAME: "14649218c17b", YARN_VERSION: "1.22.19", npm_node_execpath: "/usr/local/bin/node", npm_package_devDependencies_vite: "~5.4.9", npm_config_init_version: "1.0.0", npm_package_packageManager: "yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e", npm_package_files_0: "dist", HOME: "/root", npm_package_devDependencies_sass: "1.77.6", npm_package_dependencies_vuex: "4.1.0", npm_package_engines_node: ">=18.16.0", npm_config_init_license: "MIT", YARN_WRAP_OUTPUT: "false", npm_package_peerDependencies_vue: "~3.5.13", npm_package_dependencies__complispace_gainsight_px: "~2.1.0", npm_package_scripts_rebuild: "rm -rf dist && rm -rf node_modules && yarn install && yarn lint-staged && yarn build && yarn test:unit", npm_config_version_tag_prefix: "v", npm_config__complispace_registry: "https://registry.npmjs.org/", npm_package_keywords_0: "auth0", npm_package_devDependencies_husky: "~9.1.7", npm_package_keywords_1: "vue", npm_package_peerDependencies_vuex: "~4.1.0", npm_package_description: "Complispace SPA web application skeleton, including auth0 login process and UI components", npm_package_readmeFilename: "README.md", npm_package_lint_staged___vue_0: "eslint --fix", npm_package_keywords_2: "vuetify", npm_package_devDependencies_prettier: "~3.2.4", npm_package_devDependencies_mockdate: "~3.0.5", npm_package_lint_staged___js_0: "eslint --fix", npm_package_scripts_watch_rebuild: "rm -rf dist && rm -rf node_modules && yarn install && yarn lint-staged && yarn watch-build", npm_package_type: "module", npm_package_devDependencies_vite_plugin_node_polyfills: "~0.22.0", npm_package_module: "./dist/cs-design-system.es.js", npm_package_devDependencies__vitest_coverage_v8: "~2.1.4", npm_package_scripts_prepare: "husky", npm_package_scripts_lint: "eslint --ext .js,.vue src/", npm_config_registry: "https://registry.yarnpkg.com", npm_config_scope: "complispace", npm_package_devDependencies_happy_dom: "~15.11.2", npm_package_dependencies_vuetify: "~3.7.19", npm_package_devDependencies__vitejs_plugin_vue: "~5.1.4", npm_package_exports___import: "./dist/cs-design-system.es.js", npm_config_ignore_scripts: "", npm_config_version: "1.22.19", npm_package_dependencies_axios: "~1.7.7", PATH: "/tmp/yarn--1756864169391-0.6098667048828752:/var/lib/app/node_modules/.bin:/usr/local/share/.config/yarn/link/node_modules/.bin:/usr/local/libexec/lib/node_modules/npm/bin/node-gyp-bin:/usr/local/lib/node_modules/npm/bin/node-gyp-bin:/usr/local/bin/node_modules/npm/bin/node-gyp-bin:/tmp/yarn--1756864165216-0.09775249259687246:/var/lib/app/node_modules/.bin:/usr/local/share/.config/yarn/link/node_modules/.bin:/usr/local/libexec/lib/node_modules/npm/bin/node-gyp-bin:/usr/local/lib/node_modules/npm/bin/node-gyp-bin:/usr/local/bin/node_modules/npm/bin/node-gyp-bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin", NODE: "/usr/local/bin/node", npm_package_devDependencies__babel_eslint_parser: "~7.25.9", npm_package_dependencies_cross_env: "~7.0.3", npm_package_name: "@complispace/cs-design-system", npm_package_dependencies_jose: "~5.9.6", npm_package_devDependencies__vitest_ui: "~2.1.4", npm_package_scripts_build_scss_theme: "node --es-module-specifier-resolution=node ./src/theme/buildScss.mjs", npm_package_scripts_test_unit: "vitest run --dir src/tests/unit", npm_package_peerDependencies_vuetify: "~3.7.19", npm_package_devDependencies_eslint: "~8.57.1", npm_package_devDependencies__vue_test_utils: "~2.4.6", npm_lifecycle_script: "vite build", npm_package_browserslist_0: "> 1%", npm_package_exports___style_css: "./dist/style.css", npm_package_main: "./dist/cs-design-system.umd.js", npm_package_browserslist_1: "last 2 versions", npm_package_devDependencies__vue_eslint_config_prettier: "~9.0.0", npm_config_version_git_message: "v%s", npm_lifecycle_event: "build", npm_package_browserslist_2: "not dead", npm_package_version: "1.4.0", npm_config_argv: '{"remain":[],"cooked":["run","rebuild"],"original":["rebuild"]}', npm_package_engines_yarn: ">= 1.22.5", npm_package_devDependencies_lint_staged: "~15.2.0", npm_package_dependencies_vue_i18n: "9.9.0", npm_package_dependencies_buffer: "~6.0.3", npm_package_scripts_build: "vite build", npm_package_dependencies_lodash: "~4.17.21", npm_package_devDependencies_vite_plugin_vuetify: "~2.0.4", npm_package_devDependencies_sass_loader: "~10.2.0", npm_package_dependencies_vue_router: "4.2.5", npm_config_version_git_tag: "true", npm_config_version_git_sign: "", npm_package_license: "UNLICENSED", npm_config_strict_ssl: "true", npm_package_peerDependencies_vitest: "~2.1.4", npm_package_devDependencies_eslint_plugin_prettier: "~5.2.1", npm_config_complispace_registry: "https://registry.npmjs.org/", PWD: "/var/lib/app", npm_execpath: "/opt/yarn-v1.22.19/bin/yarn.js", npm_package_devDependencies_vue_eslint_parser: "~9.4.3", npm_package_peerDependencies_vue_i18n: "~9.9.0", npm_package_scripts_watch_build: "vite build --watch", npm_package_devDependencies_eslint_plugin_vue: "~9.31.0", npm_package_devDependencies__vue_eslint_config_standard: "~8.0.1", npm_package_dependencies__auth0_auth0_spa_js: "~2.1.3", npm_config_save_prefix: "^", npm_config_ignore_optional: "", npm_package_peerDependencies_vue_router: "~4.2.5", INIT_CWD: "/var/lib/app", npm_package_devDependencies_unplugin_vue_components: "~0.27.4", NODE_ENV: "production" }, ae = Object.getOwnPropertyDescriptors || function(Xe) {
    for (var et = Object.keys(Xe), Ye = {}, De = 0; De < et.length; De++)
      Ye[et[De]] = Object.getOwnPropertyDescriptor(Xe, et[De]);
    return Ye;
  }, ie = /%[sdj%]/g;
  re.format = function(Be) {
    if (!Ue(Be)) {
      for (var Xe = [], et = 0; et < arguments.length; et++)
        Xe.push(ue(arguments[et]));
      return Xe.join(" ");
    }
    for (var et = 1, Ye = arguments, De = Ye.length, je = String(Be).replace(ie, function(at) {
      if (at === "%%") return "%";
      if (et >= De) return at;
      switch (at) {
        case "%s":
          return String(Ye[et++]);
        case "%d":
          return Number(Ye[et++]);
        case "%j":
          try {
            return JSON.stringify(Ye[et++]);
          } catch {
            return "[Circular]";
          }
        default:
          return at;
      }
    }), rt = Ye[et]; et < De; rt = Ye[++et])
      Oe(rt) || !tt(rt) ? je += " " + rt : je += " " + ue(rt);
    return je;
  }, re.deprecate = function(Be, Xe) {
    if (typeof process$1 < "u" && process$1.noDeprecation === !0)
      return Be;
    if (typeof process$1 > "u")
      return function() {
        return re.deprecate(Be, Xe).apply(this, arguments);
      };
    var et = !1;
    function Ye() {
      if (!et) {
        if (process$1.throwDeprecation)
          throw new Error(Xe);
        process$1.traceDeprecation ? console.trace(Xe) : console.error(Xe), et = !0;
      }
      return Be.apply(this, arguments);
    }
    return Ye;
  };
  var le = {}, se = /^$/;
  if (ne.NODE_DEBUG) {
    var ce = ne.NODE_DEBUG;
    ce = ce.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), se = new RegExp("^" + ce + "$", "i");
  }
  re.debuglog = function(Be) {
    if (Be = Be.toUpperCase(), !le[Be])
      if (se.test(Be)) {
        var Xe = process$1.pid;
        le[Be] = function() {
          var et = re.format.apply(re, arguments);
          console.error("%s %d: %s", Be, Xe, et);
        };
      } else
        le[Be] = function() {
        };
    return le[Be];
  };
  function ue(Be, Xe) {
    var et = {
      seen: [],
      stylize: me
    };
    return arguments.length >= 3 && (et.depth = arguments[2]), arguments.length >= 4 && (et.colors = arguments[3]), Ae(Xe) ? et.showHidden = Xe : Xe && re._extend(et, Xe), Fe(et.showHidden) && (et.showHidden = !1), Fe(et.depth) && (et.depth = 2), Fe(et.colors) && (et.colors = !1), Fe(et.customInspect) && (et.customInspect = !0), et.colors && (et.stylize = de), pe(et, Be, et.depth);
  }
  re.inspect = ue, ue.colors = {
    bold: [1, 22],
    italic: [3, 23],
    underline: [4, 24],
    inverse: [7, 27],
    white: [37, 39],
    grey: [90, 39],
    black: [30, 39],
    blue: [34, 39],
    cyan: [36, 39],
    green: [32, 39],
    magenta: [35, 39],
    red: [31, 39],
    yellow: [33, 39]
  }, ue.styles = {
    special: "cyan",
    number: "yellow",
    boolean: "yellow",
    undefined: "grey",
    null: "bold",
    string: "green",
    date: "magenta",
    // "name": intentionally not styling
    regexp: "red"
  };
  function de(Be, Xe) {
    var et = ue.styles[Xe];
    return et ? "\x1B[" + ue.colors[et][0] + "m" + Be + "\x1B[" + ue.colors[et][1] + "m" : Be;
  }
  function me(Be, Xe) {
    return Be;
  }
  function fe(Be) {
    var Xe = {};
    return Be.forEach(function(et, Ye) {
      Xe[et] = !0;
    }), Xe;
  }
  function pe(Be, Xe, et) {
    if (Be.customInspect && Xe && _e(Xe.inspect) && // Filter out the util module, it's inspect function is special
    Xe.inspect !== re.inspect && // Also filter out any prototype objects using the circular check.
    !(Xe.constructor && Xe.constructor.prototype === Xe)) {
      var Ye = Xe.inspect(et, Be);
      return Ue(Ye) || (Ye = pe(Be, Ye, et)), Ye;
    }
    var De = ge(Be, Xe);
    if (De)
      return De;
    var je = Object.keys(Xe), rt = fe(je);
    if (Be.showHidden && (je = Object.getOwnPropertyNames(Xe)), Ce(Xe) && (je.indexOf("message") >= 0 || je.indexOf("description") >= 0))
      return be(Xe);
    if (je.length === 0) {
      if (_e(Xe)) {
        var at = Xe.name ? ": " + Xe.name : "";
        return Be.stylize("[Function" + at + "]", "special");
      }
      if (Ke(Xe))
        return Be.stylize(RegExp.prototype.toString.call(Xe), "regexp");
      if (Re(Xe))
        return Be.stylize(Date.prototype.toString.call(Xe), "date");
      if (Ce(Xe))
        return be(Xe);
    }
    var qe = "", We = !1, ze = ["{", "}"];
    if (Ve(Xe) && (We = !0, ze = ["[", "]"]), _e(Xe)) {
      var Ge = Xe.name ? ": " + Xe.name : "";
      qe = " [Function" + Ge + "]";
    }
    if (Ke(Xe) && (qe = " " + RegExp.prototype.toString.call(Xe)), Re(Xe) && (qe = " " + Date.prototype.toUTCString.call(Xe)), Ce(Xe) && (qe = " " + be(Xe)), je.length === 0 && (!We || Xe.length == 0))
      return ze[0] + qe + ze[1];
    if (et < 0)
      return Ke(Xe) ? Be.stylize(RegExp.prototype.toString.call(Xe), "regexp") : Be.stylize("[Object]", "special");
    Be.seen.push(Xe);
    var nt;
    return We ? nt = Se(Be, Xe, et, rt, je) : nt = je.map(function(ot) {
      return Pe(Be, Xe, et, rt, ot, We);
    }), Be.seen.pop(), Ee(nt, qe, ze);
  }
  function ge(Be, Xe) {
    if (Fe(Xe))
      return Be.stylize("undefined", "undefined");
    if (Ue(Xe)) {
      var et = "'" + JSON.stringify(Xe).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
      return Be.stylize(et, "string");
    }
    if (He(Xe))
      return Be.stylize("" + Xe, "number");
    if (Ae(Xe))
      return Be.stylize("" + Xe, "boolean");
    if (Oe(Xe))
      return Be.stylize("null", "null");
  }
  function be(Be) {
    return "[" + Error.prototype.toString.call(Be) + "]";
  }
  function Se(Be, Xe, et, Ye, De) {
    for (var je = [], rt = 0, at = Xe.length; rt < at; ++rt)
      Ie(Xe, String(rt)) ? je.push(Pe(
        Be,
        Xe,
        et,
        Ye,
        String(rt),
        !0
      )) : je.push("");
    return De.forEach(function(qe) {
      qe.match(/^\d+$/) || je.push(Pe(
        Be,
        Xe,
        et,
        Ye,
        qe,
        !0
      ));
    }), je;
  }
  function Pe(Be, Xe, et, Ye, De, je) {
    var rt, at, qe;
    if (qe = Object.getOwnPropertyDescriptor(Xe, De) || { value: Xe[De] }, qe.get ? qe.set ? at = Be.stylize("[Getter/Setter]", "special") : at = Be.stylize("[Getter]", "special") : qe.set && (at = Be.stylize("[Setter]", "special")), Ie(Ye, De) || (rt = "[" + De + "]"), at || (Be.seen.indexOf(qe.value) < 0 ? (Oe(et) ? at = pe(Be, qe.value, null) : at = pe(Be, qe.value, et - 1), at.indexOf(`
`) > -1 && (je ? at = at.split(`
`).map(function(We) {
      return "  " + We;
    }).join(`
`).slice(2) : at = `
` + at.split(`
`).map(function(We) {
      return "   " + We;
    }).join(`
`))) : at = Be.stylize("[Circular]", "special")), Fe(rt)) {
      if (je && De.match(/^\d+$/))
        return at;
      rt = JSON.stringify("" + De), rt.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (rt = rt.slice(1, -1), rt = Be.stylize(rt, "name")) : (rt = rt.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), rt = Be.stylize(rt, "string"));
    }
    return rt + ": " + at;
  }
  function Ee(Be, Xe, et) {
    var Ye = Be.reduce(function(De, je) {
      return je.indexOf(`
`) >= 0, De + je.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    return Ye > 60 ? et[0] + (Xe === "" ? "" : Xe + `
 `) + " " + Be.join(`,
  `) + " " + et[1] : et[0] + Xe + " " + Be.join(", ") + " " + et[1];
  }
  re.types = types;
  function Ve(Be) {
    return Array.isArray(Be);
  }
  re.isArray = Ve;
  function Ae(Be) {
    return typeof Be == "boolean";
  }
  re.isBoolean = Ae;
  function Oe(Be) {
    return Be === null;
  }
  re.isNull = Oe;
  function Ne(Be) {
    return Be == null;
  }
  re.isNullOrUndefined = Ne;
  function He(Be) {
    return typeof Be == "number";
  }
  re.isNumber = He;
  function Ue(Be) {
    return typeof Be == "string";
  }
  re.isString = Ue;
  function Ze(Be) {
    return typeof Be == "symbol";
  }
  re.isSymbol = Ze;
  function Fe(Be) {
    return Be === void 0;
  }
  re.isUndefined = Fe;
  function Ke(Be) {
    return tt(Be) && ve(Be) === "[object RegExp]";
  }
  re.isRegExp = Ke, re.types.isRegExp = Ke;
  function tt(Be) {
    return typeof Be == "object" && Be !== null;
  }
  re.isObject = tt;
  function Re(Be) {
    return tt(Be) && ve(Be) === "[object Date]";
  }
  re.isDate = Re, re.types.isDate = Re;
  function Ce(Be) {
    return tt(Be) && (ve(Be) === "[object Error]" || Be instanceof Error);
  }
  re.isError = Ce, re.types.isNativeError = Ce;
  function _e(Be) {
    return typeof Be == "function";
  }
  re.isFunction = _e;
  function he(Be) {
    return Be === null || typeof Be == "boolean" || typeof Be == "number" || typeof Be == "string" || typeof Be == "symbol" || // ES6 symbol
    typeof Be > "u";
  }
  re.isPrimitive = he, re.isBuffer = isBufferBrowser;
  function ve(Be) {
    return Object.prototype.toString.call(Be);
  }
  function xe(Be) {
    return Be < 10 ? "0" + Be.toString(10) : Be.toString(10);
  }
  var $e = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  function Te() {
    var Be = /* @__PURE__ */ new Date(), Xe = [
      xe(Be.getHours()),
      xe(Be.getMinutes()),
      xe(Be.getSeconds())
    ].join(":");
    return [Be.getDate(), $e[Be.getMonth()], Xe].join(" ");
  }
  re.log = function() {
    console.log("%s - %s", Te(), re.format.apply(re, arguments));
  }, re.inherits = inherits_browserExports, re._extend = function(Be, Xe) {
    if (!Xe || !tt(Xe)) return Be;
    for (var et = Object.keys(Xe), Ye = et.length; Ye--; )
      Be[et[Ye]] = Xe[et[Ye]];
    return Be;
  };
  function Ie(Be, Xe) {
    return Object.prototype.hasOwnProperty.call(Be, Xe);
  }
  var we = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
  re.promisify = function(Xe) {
    if (typeof Xe != "function")
      throw new TypeError('The "original" argument must be of type Function');
    if (we && Xe[we]) {
      var et = Xe[we];
      if (typeof et != "function")
        throw new TypeError('The "util.promisify.custom" argument must be of type Function');
      return Object.defineProperty(et, we, {
        value: et,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), et;
    }
    function et() {
      for (var Ye, De, je = new Promise(function(qe, We) {
        Ye = qe, De = We;
      }), rt = [], at = 0; at < arguments.length; at++)
        rt.push(arguments[at]);
      rt.push(function(qe, We) {
        qe ? De(qe) : Ye(We);
      });
      try {
        Xe.apply(this, rt);
      } catch (qe) {
        De(qe);
      }
      return je;
    }
    return Object.setPrototypeOf(et, Object.getPrototypeOf(Xe)), we && Object.defineProperty(et, we, {
      value: et,
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), Object.defineProperties(
      et,
      ae(Xe)
    );
  }, re.promisify.custom = we;
  function ke(Be, Xe) {
    if (!Be) {
      var et = new Error("Promise was rejected with a falsy value");
      et.reason = Be, Be = et;
    }
    return Xe(Be);
  }
  function ye(Be) {
    if (typeof Be != "function")
      throw new TypeError('The "original" argument must be of type Function');
    function Xe() {
      for (var et = [], Ye = 0; Ye < arguments.length; Ye++)
        et.push(arguments[Ye]);
      var De = et.pop();
      if (typeof De != "function")
        throw new TypeError("The last argument must be of type Function");
      var je = this, rt = function() {
        return De.apply(je, arguments);
      };
      Be.apply(this, et).then(
        function(at) {
          process$1.nextTick(rt.bind(null, null, at));
        },
        function(at) {
          process$1.nextTick(ke.bind(null, at, rt));
        }
      );
    }
    return Object.setPrototypeOf(Xe, Object.getPrototypeOf(Be)), Object.defineProperties(
      Xe,
      ae(Be)
    ), Xe;
  }
  re.callbackify = ye;
})(util$3);
var buffer_list, hasRequiredBuffer_list;
function requireBuffer_list() {
  if (hasRequiredBuffer_list) return buffer_list;
  hasRequiredBuffer_list = 1;
  function re(Se, Pe) {
    var Ee = Object.keys(Se);
    if (Object.getOwnPropertySymbols) {
      var Ve = Object.getOwnPropertySymbols(Se);
      Pe && (Ve = Ve.filter(function(Ae) {
        return Object.getOwnPropertyDescriptor(Se, Ae).enumerable;
      })), Ee.push.apply(Ee, Ve);
    }
    return Ee;
  }
  function ne(Se) {
    for (var Pe = 1; Pe < arguments.length; Pe++) {
      var Ee = arguments[Pe] != null ? arguments[Pe] : {};
      Pe % 2 ? re(Object(Ee), !0).forEach(function(Ve) {
        ae(Se, Ve, Ee[Ve]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Se, Object.getOwnPropertyDescriptors(Ee)) : re(Object(Ee)).forEach(function(Ve) {
        Object.defineProperty(Se, Ve, Object.getOwnPropertyDescriptor(Ee, Ve));
      });
    }
    return Se;
  }
  function ae(Se, Pe, Ee) {
    return Pe = ce(Pe), Pe in Se ? Object.defineProperty(Se, Pe, { value: Ee, enumerable: !0, configurable: !0, writable: !0 }) : Se[Pe] = Ee, Se;
  }
  function ie(Se, Pe) {
    if (!(Se instanceof Pe))
      throw new TypeError("Cannot call a class as a function");
  }
  function le(Se, Pe) {
    for (var Ee = 0; Ee < Pe.length; Ee++) {
      var Ve = Pe[Ee];
      Ve.enumerable = Ve.enumerable || !1, Ve.configurable = !0, "value" in Ve && (Ve.writable = !0), Object.defineProperty(Se, ce(Ve.key), Ve);
    }
  }
  function se(Se, Pe, Ee) {
    return Pe && le(Se.prototype, Pe), Object.defineProperty(Se, "prototype", { writable: !1 }), Se;
  }
  function ce(Se) {
    var Pe = ue(Se, "string");
    return typeof Pe == "symbol" ? Pe : String(Pe);
  }
  function ue(Se, Pe) {
    if (typeof Se != "object" || Se === null) return Se;
    var Ee = Se[Symbol.toPrimitive];
    if (Ee !== void 0) {
      var Ve = Ee.call(Se, Pe || "default");
      if (typeof Ve != "object") return Ve;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (Pe === "string" ? String : Number)(Se);
  }
  var de = require$$1$2, me = de.Buffer, fe = util$3, pe = fe.inspect, ge = pe && pe.custom || "inspect";
  function be(Se, Pe, Ee) {
    me.prototype.copy.call(Se, Pe, Ee);
  }
  return buffer_list = /* @__PURE__ */ function() {
    function Se() {
      ie(this, Se), this.head = null, this.tail = null, this.length = 0;
    }
    return se(Se, [{
      key: "push",
      value: function(Ee) {
        var Ve = {
          data: Ee,
          next: null
        };
        this.length > 0 ? this.tail.next = Ve : this.head = Ve, this.tail = Ve, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(Ee) {
        var Ve = {
          data: Ee,
          next: this.head
        };
        this.length === 0 && (this.tail = Ve), this.head = Ve, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var Ee = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, Ee;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(Ee) {
        if (this.length === 0) return "";
        for (var Ve = this.head, Ae = "" + Ve.data; Ve = Ve.next; ) Ae += Ee + Ve.data;
        return Ae;
      }
    }, {
      key: "concat",
      value: function(Ee) {
        if (this.length === 0) return me.alloc(0);
        for (var Ve = me.allocUnsafe(Ee >>> 0), Ae = this.head, Oe = 0; Ae; )
          be(Ae.data, Ve, Oe), Oe += Ae.data.length, Ae = Ae.next;
        return Ve;
      }
      // Consumes a specified amount of bytes or characters from the buffered data.
    }, {
      key: "consume",
      value: function(Ee, Ve) {
        var Ae;
        return Ee < this.head.data.length ? (Ae = this.head.data.slice(0, Ee), this.head.data = this.head.data.slice(Ee)) : Ee === this.head.data.length ? Ae = this.shift() : Ae = Ve ? this._getString(Ee) : this._getBuffer(Ee), Ae;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
      // Consumes a specified amount of characters from the buffered data.
    }, {
      key: "_getString",
      value: function(Ee) {
        var Ve = this.head, Ae = 1, Oe = Ve.data;
        for (Ee -= Oe.length; Ve = Ve.next; ) {
          var Ne = Ve.data, He = Ee > Ne.length ? Ne.length : Ee;
          if (He === Ne.length ? Oe += Ne : Oe += Ne.slice(0, Ee), Ee -= He, Ee === 0) {
            He === Ne.length ? (++Ae, Ve.next ? this.head = Ve.next : this.head = this.tail = null) : (this.head = Ve, Ve.data = Ne.slice(He));
            break;
          }
          ++Ae;
        }
        return this.length -= Ae, Oe;
      }
      // Consumes a specified amount of bytes from the buffered data.
    }, {
      key: "_getBuffer",
      value: function(Ee) {
        var Ve = me.allocUnsafe(Ee), Ae = this.head, Oe = 1;
        for (Ae.data.copy(Ve), Ee -= Ae.data.length; Ae = Ae.next; ) {
          var Ne = Ae.data, He = Ee > Ne.length ? Ne.length : Ee;
          if (Ne.copy(Ve, Ve.length - Ee, 0, He), Ee -= He, Ee === 0) {
            He === Ne.length ? (++Oe, Ae.next ? this.head = Ae.next : this.head = this.tail = null) : (this.head = Ae, Ae.data = Ne.slice(He));
            break;
          }
          ++Oe;
        }
        return this.length -= Oe, Ve;
      }
      // Make sure the linked list only shows the minimal necessary information.
    }, {
      key: ge,
      value: function(Ee, Ve) {
        return pe(this, ne(ne({}, Ve), {}, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: !1
        }));
      }
    }]), Se;
  }(), buffer_list;
}
function destroy$1(re, ne) {
  var ae = this, ie = this._readableState && this._readableState.destroyed, le = this._writableState && this._writableState.destroyed;
  return ie || le ? (ne ? ne(re) : re && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, process$1.nextTick(emitErrorNT$1, this, re)) : process$1.nextTick(emitErrorNT$1, this, re)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(re || null, function(se) {
    !ne && se ? ae._writableState ? ae._writableState.errorEmitted ? process$1.nextTick(emitCloseNT, ae) : (ae._writableState.errorEmitted = !0, process$1.nextTick(emitErrorAndCloseNT, ae, se)) : process$1.nextTick(emitErrorAndCloseNT, ae, se) : ne ? (process$1.nextTick(emitCloseNT, ae), ne(se)) : process$1.nextTick(emitCloseNT, ae);
  }), this);
}
function emitErrorAndCloseNT(re, ne) {
  emitErrorNT$1(re, ne), emitCloseNT(re);
}
function emitCloseNT(re) {
  re._writableState && !re._writableState.emitClose || re._readableState && !re._readableState.emitClose || re.emit("close");
}
function undestroy$1() {
  this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
}
function emitErrorNT$1(re, ne) {
  re.emit("error", ne);
}
function errorOrDestroy(re, ne) {
  var ae = re._readableState, ie = re._writableState;
  ae && ae.autoDestroy || ie && ie.autoDestroy ? re.destroy(ne) : re.emit("error", ne);
}
var destroy_1$1 = {
  destroy: destroy$1,
  undestroy: undestroy$1,
  errorOrDestroy
}, errorsBrowser = {};
function _inheritsLoose(re, ne) {
  re.prototype = Object.create(ne.prototype), re.prototype.constructor = re, re.__proto__ = ne;
}
var codes = {};
function createErrorType(re, ne, ae) {
  ae || (ae = Error);
  function ie(se, ce, ue) {
    return typeof ne == "string" ? ne : ne(se, ce, ue);
  }
  var le = /* @__PURE__ */ function(se) {
    _inheritsLoose(ce, se);
    function ce(ue, de, me) {
      return se.call(this, ie(ue, de, me)) || this;
    }
    return ce;
  }(ae);
  le.prototype.name = ae.name, le.prototype.code = re, codes[re] = le;
}
function oneOf(re, ne) {
  if (Array.isArray(re)) {
    var ae = re.length;
    return re = re.map(function(ie) {
      return String(ie);
    }), ae > 2 ? "one of ".concat(ne, " ").concat(re.slice(0, ae - 1).join(", "), ", or ") + re[ae - 1] : ae === 2 ? "one of ".concat(ne, " ").concat(re[0], " or ").concat(re[1]) : "of ".concat(ne, " ").concat(re[0]);
  } else
    return "of ".concat(ne, " ").concat(String(re));
}
function startsWith(re, ne, ae) {
  return re.substr(0, ne.length) === ne;
}
function endsWith(re, ne, ae) {
  return (ae === void 0 || ae > re.length) && (ae = re.length), re.substring(ae - ne.length, ae) === ne;
}
function includes(re, ne, ae) {
  return typeof ae != "number" && (ae = 0), ae + ne.length > re.length ? !1 : re.indexOf(ne, ae) !== -1;
}
createErrorType("ERR_INVALID_OPT_VALUE", function(re, ne) {
  return 'The value "' + ne + '" is invalid for option "' + re + '"';
}, TypeError);
createErrorType("ERR_INVALID_ARG_TYPE", function(re, ne, ae) {
  var ie;
  typeof ne == "string" && startsWith(ne, "not ") ? (ie = "must not be", ne = ne.replace(/^not /, "")) : ie = "must be";
  var le;
  if (endsWith(re, " argument"))
    le = "The ".concat(re, " ").concat(ie, " ").concat(oneOf(ne, "type"));
  else {
    var se = includes(re, ".") ? "property" : "argument";
    le = 'The "'.concat(re, '" ').concat(se, " ").concat(ie, " ").concat(oneOf(ne, "type"));
  }
  return le += ". Received type ".concat(typeof ae), le;
}, TypeError);
createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(re) {
  return "The " + re + " method is not implemented";
});
createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
createErrorType("ERR_STREAM_DESTROYED", function(re) {
  return "Cannot call " + re + " after a stream was destroyed";
});
createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
createErrorType("ERR_UNKNOWN_ENCODING", function(re) {
  return "Unknown encoding: " + re;
}, TypeError);
createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
errorsBrowser.codes = codes;
var ERR_INVALID_OPT_VALUE = errorsBrowser.codes.ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(re, ne, ae) {
  return re.highWaterMark != null ? re.highWaterMark : ne ? re[ae] : null;
}
function getHighWaterMark(re, ne, ae, ie) {
  var le = highWaterMarkFrom(ne, ie, ae);
  if (le != null) {
    if (!(isFinite(le) && Math.floor(le) === le) || le < 0) {
      var se = ie ? ae : "highWaterMark";
      throw new ERR_INVALID_OPT_VALUE(se, le);
    }
    return Math.floor(le);
  }
  return re.objectMode ? 16 : 16 * 1024;
}
var state$4 = {
  getHighWaterMark
}, browser$a = deprecate;
function deprecate(re, ne) {
  if (config("noDeprecation"))
    return re;
  var ae = !1;
  function ie() {
    if (!ae) {
      if (config("throwDeprecation"))
        throw new Error(ne);
      config("traceDeprecation") ? console.trace(ne) : console.warn(ne), ae = !0;
    }
    return re.apply(this, arguments);
  }
  return ie;
}
function config(re) {
  try {
    if (!commonjsGlobal.localStorage) return !1;
  } catch {
    return !1;
  }
  var ne = commonjsGlobal.localStorage[re];
  return ne == null ? !1 : String(ne).toLowerCase() === "true";
}
var _stream_writable$1, hasRequired_stream_writable$1;
function require_stream_writable$1() {
  if (hasRequired_stream_writable$1) return _stream_writable$1;
  hasRequired_stream_writable$1 = 1, _stream_writable$1 = Fe;
  function re(Ye) {
    var De = this;
    this.next = null, this.entry = null, this.finish = function() {
      et(De, Ye);
    };
  }
  var ne;
  Fe.WritableState = Ue;
  var ae = {
    deprecate: browser$a
  }, ie = streamBrowser$1, le = require$$1$2.Buffer, se = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function ce(Ye) {
    return le.from(Ye);
  }
  function ue(Ye) {
    return le.isBuffer(Ye) || Ye instanceof se;
  }
  var de = destroy_1$1, me = state$4, fe = me.getHighWaterMark, pe = errorsBrowser.codes, ge = pe.ERR_INVALID_ARG_TYPE, be = pe.ERR_METHOD_NOT_IMPLEMENTED, Se = pe.ERR_MULTIPLE_CALLBACK, Pe = pe.ERR_STREAM_CANNOT_PIPE, Ee = pe.ERR_STREAM_DESTROYED, Ve = pe.ERR_STREAM_NULL_VALUES, Ae = pe.ERR_STREAM_WRITE_AFTER_END, Oe = pe.ERR_UNKNOWN_ENCODING, Ne = de.errorOrDestroy;
  inherits_browserExports(Fe, ie);
  function He() {
  }
  function Ue(Ye, De, je) {
    ne = ne || require_stream_duplex$1(), Ye = Ye || {}, typeof je != "boolean" && (je = De instanceof ne), this.objectMode = !!Ye.objectMode, je && (this.objectMode = this.objectMode || !!Ye.writableObjectMode), this.highWaterMark = fe(this, Ye, "writableHighWaterMark", je), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var rt = Ye.decodeStrings === !1;
    this.decodeStrings = !rt, this.defaultEncoding = Ye.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(at) {
      xe(De, at);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = Ye.emitClose !== !1, this.autoDestroy = !!Ye.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new re(this);
  }
  Ue.prototype.getBuffer = function() {
    for (var De = this.bufferedRequest, je = []; De; )
      je.push(De), De = De.next;
    return je;
  }, function() {
    try {
      Object.defineProperty(Ue.prototype, "buffer", {
        get: ae.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var Ze;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (Ze = Function.prototype[Symbol.hasInstance], Object.defineProperty(Fe, Symbol.hasInstance, {
    value: function(De) {
      return Ze.call(this, De) ? !0 : this !== Fe ? !1 : De && De._writableState instanceof Ue;
    }
  })) : Ze = function(De) {
    return De instanceof this;
  };
  function Fe(Ye) {
    ne = ne || require_stream_duplex$1();
    var De = this instanceof ne;
    if (!De && !Ze.call(Fe, this)) return new Fe(Ye);
    this._writableState = new Ue(Ye, this, De), this.writable = !0, Ye && (typeof Ye.write == "function" && (this._write = Ye.write), typeof Ye.writev == "function" && (this._writev = Ye.writev), typeof Ye.destroy == "function" && (this._destroy = Ye.destroy), typeof Ye.final == "function" && (this._final = Ye.final)), ie.call(this);
  }
  Fe.prototype.pipe = function() {
    Ne(this, new Pe());
  };
  function Ke(Ye, De) {
    var je = new Ae();
    Ne(Ye, je), process$1.nextTick(De, je);
  }
  function tt(Ye, De, je, rt) {
    var at;
    return je === null ? at = new Ve() : typeof je != "string" && !De.objectMode && (at = new ge("chunk", ["string", "Buffer"], je)), at ? (Ne(Ye, at), process$1.nextTick(rt, at), !1) : !0;
  }
  Fe.prototype.write = function(Ye, De, je) {
    var rt = this._writableState, at = !1, qe = !rt.objectMode && ue(Ye);
    return qe && !le.isBuffer(Ye) && (Ye = ce(Ye)), typeof De == "function" && (je = De, De = null), qe ? De = "buffer" : De || (De = rt.defaultEncoding), typeof je != "function" && (je = He), rt.ending ? Ke(this, je) : (qe || tt(this, rt, Ye, je)) && (rt.pendingcb++, at = Ce(this, rt, qe, Ye, De, je)), at;
  }, Fe.prototype.cork = function() {
    this._writableState.corked++;
  }, Fe.prototype.uncork = function() {
    var Ye = this._writableState;
    Ye.corked && (Ye.corked--, !Ye.writing && !Ye.corked && !Ye.bufferProcessing && Ye.bufferedRequest && Ie(this, Ye));
  }, Fe.prototype.setDefaultEncoding = function(De) {
    if (typeof De == "string" && (De = De.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((De + "").toLowerCase()) > -1)) throw new Oe(De);
    return this._writableState.defaultEncoding = De, this;
  }, Object.defineProperty(Fe.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function Re(Ye, De, je) {
    return !Ye.objectMode && Ye.decodeStrings !== !1 && typeof De == "string" && (De = le.from(De, je)), De;
  }
  Object.defineProperty(Fe.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function Ce(Ye, De, je, rt, at, qe) {
    if (!je) {
      var We = Re(De, rt, at);
      rt !== We && (je = !0, at = "buffer", rt = We);
    }
    var ze = De.objectMode ? 1 : rt.length;
    De.length += ze;
    var Ge = De.length < De.highWaterMark;
    if (Ge || (De.needDrain = !0), De.writing || De.corked) {
      var nt = De.lastBufferedRequest;
      De.lastBufferedRequest = {
        chunk: rt,
        encoding: at,
        isBuf: je,
        callback: qe,
        next: null
      }, nt ? nt.next = De.lastBufferedRequest : De.bufferedRequest = De.lastBufferedRequest, De.bufferedRequestCount += 1;
    } else
      _e(Ye, De, !1, ze, rt, at, qe);
    return Ge;
  }
  function _e(Ye, De, je, rt, at, qe, We) {
    De.writelen = rt, De.writecb = We, De.writing = !0, De.sync = !0, De.destroyed ? De.onwrite(new Ee("write")) : je ? Ye._writev(at, De.onwrite) : Ye._write(at, qe, De.onwrite), De.sync = !1;
  }
  function he(Ye, De, je, rt, at) {
    --De.pendingcb, je ? (process$1.nextTick(at, rt), process$1.nextTick(Be, Ye, De), Ye._writableState.errorEmitted = !0, Ne(Ye, rt)) : (at(rt), Ye._writableState.errorEmitted = !0, Ne(Ye, rt), Be(Ye, De));
  }
  function ve(Ye) {
    Ye.writing = !1, Ye.writecb = null, Ye.length -= Ye.writelen, Ye.writelen = 0;
  }
  function xe(Ye, De) {
    var je = Ye._writableState, rt = je.sync, at = je.writecb;
    if (typeof at != "function") throw new Se();
    if (ve(je), De) he(Ye, je, rt, De, at);
    else {
      var qe = we(je) || Ye.destroyed;
      !qe && !je.corked && !je.bufferProcessing && je.bufferedRequest && Ie(Ye, je), rt ? process$1.nextTick($e, Ye, je, qe, at) : $e(Ye, je, qe, at);
    }
  }
  function $e(Ye, De, je, rt) {
    je || Te(Ye, De), De.pendingcb--, rt(), Be(Ye, De);
  }
  function Te(Ye, De) {
    De.length === 0 && De.needDrain && (De.needDrain = !1, Ye.emit("drain"));
  }
  function Ie(Ye, De) {
    De.bufferProcessing = !0;
    var je = De.bufferedRequest;
    if (Ye._writev && je && je.next) {
      var rt = De.bufferedRequestCount, at = new Array(rt), qe = De.corkedRequestsFree;
      qe.entry = je;
      for (var We = 0, ze = !0; je; )
        at[We] = je, je.isBuf || (ze = !1), je = je.next, We += 1;
      at.allBuffers = ze, _e(Ye, De, !0, De.length, at, "", qe.finish), De.pendingcb++, De.lastBufferedRequest = null, qe.next ? (De.corkedRequestsFree = qe.next, qe.next = null) : De.corkedRequestsFree = new re(De), De.bufferedRequestCount = 0;
    } else {
      for (; je; ) {
        var Ge = je.chunk, nt = je.encoding, ot = je.callback, lt = De.objectMode ? 1 : Ge.length;
        if (_e(Ye, De, !1, lt, Ge, nt, ot), je = je.next, De.bufferedRequestCount--, De.writing)
          break;
      }
      je === null && (De.lastBufferedRequest = null);
    }
    De.bufferedRequest = je, De.bufferProcessing = !1;
  }
  Fe.prototype._write = function(Ye, De, je) {
    je(new be("_write()"));
  }, Fe.prototype._writev = null, Fe.prototype.end = function(Ye, De, je) {
    var rt = this._writableState;
    return typeof Ye == "function" ? (je = Ye, Ye = null, De = null) : typeof De == "function" && (je = De, De = null), Ye != null && this.write(Ye, De), rt.corked && (rt.corked = 1, this.uncork()), rt.ending || Xe(this, rt, je), this;
  }, Object.defineProperty(Fe.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function we(Ye) {
    return Ye.ending && Ye.length === 0 && Ye.bufferedRequest === null && !Ye.finished && !Ye.writing;
  }
  function ke(Ye, De) {
    Ye._final(function(je) {
      De.pendingcb--, je && Ne(Ye, je), De.prefinished = !0, Ye.emit("prefinish"), Be(Ye, De);
    });
  }
  function ye(Ye, De) {
    !De.prefinished && !De.finalCalled && (typeof Ye._final == "function" && !De.destroyed ? (De.pendingcb++, De.finalCalled = !0, process$1.nextTick(ke, Ye, De)) : (De.prefinished = !0, Ye.emit("prefinish")));
  }
  function Be(Ye, De) {
    var je = we(De);
    if (je && (ye(Ye, De), De.pendingcb === 0 && (De.finished = !0, Ye.emit("finish"), De.autoDestroy))) {
      var rt = Ye._readableState;
      (!rt || rt.autoDestroy && rt.endEmitted) && Ye.destroy();
    }
    return je;
  }
  function Xe(Ye, De, je) {
    De.ending = !0, Be(Ye, De), je && (De.finished ? process$1.nextTick(je) : Ye.once("finish", je)), De.ended = !0, Ye.writable = !1;
  }
  function et(Ye, De, je) {
    var rt = Ye.entry;
    for (Ye.entry = null; rt; ) {
      var at = rt.callback;
      De.pendingcb--, at(je), rt = rt.next;
    }
    De.corkedRequestsFree.next = Ye;
  }
  return Object.defineProperty(Fe.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(De) {
      this._writableState && (this._writableState.destroyed = De);
    }
  }), Fe.prototype.destroy = de.destroy, Fe.prototype._undestroy = de.undestroy, Fe.prototype._destroy = function(Ye, De) {
    De(Ye);
  }, _stream_writable$1;
}
var _stream_duplex$1, hasRequired_stream_duplex$1;
function require_stream_duplex$1() {
  if (hasRequired_stream_duplex$1) return _stream_duplex$1;
  hasRequired_stream_duplex$1 = 1;
  var re = Object.keys || function(me) {
    var fe = [];
    for (var pe in me) fe.push(pe);
    return fe;
  };
  _stream_duplex$1 = ce;
  var ne = require_stream_readable$1(), ae = require_stream_writable$1();
  inherits_browserExports(ce, ne);
  for (var ie = re(ae.prototype), le = 0; le < ie.length; le++) {
    var se = ie[le];
    ce.prototype[se] || (ce.prototype[se] = ae.prototype[se]);
  }
  function ce(me) {
    if (!(this instanceof ce)) return new ce(me);
    ne.call(this, me), ae.call(this, me), this.allowHalfOpen = !0, me && (me.readable === !1 && (this.readable = !1), me.writable === !1 && (this.writable = !1), me.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", ue)));
  }
  Object.defineProperty(ce.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(ce.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(ce.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function ue() {
    this._writableState.ended || process$1.nextTick(de, this);
  }
  function de(me) {
    me.end();
  }
  return Object.defineProperty(ce.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(fe) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = fe, this._writableState.destroyed = fe);
    }
  }), _stream_duplex$1;
}
var string_decoder = {}, Buffer$B = safeBufferExports$1.Buffer, isEncoding = Buffer$B.isEncoding || function(re) {
  switch (re = "" + re, re && re.toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
    case "raw":
      return !0;
    default:
      return !1;
  }
};
function _normalizeEncoding(re) {
  if (!re) return "utf8";
  for (var ne; ; )
    switch (re) {
      case "utf8":
      case "utf-8":
        return "utf8";
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return "utf16le";
      case "latin1":
      case "binary":
        return "latin1";
      case "base64":
      case "ascii":
      case "hex":
        return re;
      default:
        if (ne) return;
        re = ("" + re).toLowerCase(), ne = !0;
    }
}
function normalizeEncoding(re) {
  var ne = _normalizeEncoding(re);
  if (typeof ne != "string" && (Buffer$B.isEncoding === isEncoding || !isEncoding(re))) throw new Error("Unknown encoding: " + re);
  return ne || re;
}
string_decoder.StringDecoder = StringDecoder$1;
function StringDecoder$1(re) {
  this.encoding = normalizeEncoding(re);
  var ne;
  switch (this.encoding) {
    case "utf16le":
      this.text = utf16Text, this.end = utf16End, ne = 4;
      break;
    case "utf8":
      this.fillLast = utf8FillLast, ne = 4;
      break;
    case "base64":
      this.text = base64Text, this.end = base64End, ne = 3;
      break;
    default:
      this.write = simpleWrite, this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0, this.lastTotal = 0, this.lastChar = Buffer$B.allocUnsafe(ne);
}
StringDecoder$1.prototype.write = function(re) {
  if (re.length === 0) return "";
  var ne, ae;
  if (this.lastNeed) {
    if (ne = this.fillLast(re), ne === void 0) return "";
    ae = this.lastNeed, this.lastNeed = 0;
  } else
    ae = 0;
  return ae < re.length ? ne ? ne + this.text(re, ae) : this.text(re, ae) : ne || "";
};
StringDecoder$1.prototype.end = utf8End;
StringDecoder$1.prototype.text = utf8Text;
StringDecoder$1.prototype.fillLast = function(re) {
  if (this.lastNeed <= re.length)
    return re.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
  re.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, re.length), this.lastNeed -= re.length;
};
function utf8CheckByte(re) {
  return re <= 127 ? 0 : re >> 5 === 6 ? 2 : re >> 4 === 14 ? 3 : re >> 3 === 30 ? 4 : re >> 6 === 2 ? -1 : -2;
}
function utf8CheckIncomplete(re, ne, ae) {
  var ie = ne.length - 1;
  if (ie < ae) return 0;
  var le = utf8CheckByte(ne[ie]);
  return le >= 0 ? (le > 0 && (re.lastNeed = le - 1), le) : --ie < ae || le === -2 ? 0 : (le = utf8CheckByte(ne[ie]), le >= 0 ? (le > 0 && (re.lastNeed = le - 2), le) : --ie < ae || le === -2 ? 0 : (le = utf8CheckByte(ne[ie]), le >= 0 ? (le > 0 && (le === 2 ? le = 0 : re.lastNeed = le - 3), le) : 0));
}
function utf8CheckExtraBytes(re, ne, ae) {
  if ((ne[0] & 192) !== 128)
    return re.lastNeed = 0, "�";
  if (re.lastNeed > 1 && ne.length > 1) {
    if ((ne[1] & 192) !== 128)
      return re.lastNeed = 1, "�";
    if (re.lastNeed > 2 && ne.length > 2 && (ne[2] & 192) !== 128)
      return re.lastNeed = 2, "�";
  }
}
function utf8FillLast(re) {
  var ne = this.lastTotal - this.lastNeed, ae = utf8CheckExtraBytes(this, re);
  if (ae !== void 0) return ae;
  if (this.lastNeed <= re.length)
    return re.copy(this.lastChar, ne, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
  re.copy(this.lastChar, ne, 0, re.length), this.lastNeed -= re.length;
}
function utf8Text(re, ne) {
  var ae = utf8CheckIncomplete(this, re, ne);
  if (!this.lastNeed) return re.toString("utf8", ne);
  this.lastTotal = ae;
  var ie = re.length - (ae - this.lastNeed);
  return re.copy(this.lastChar, 0, ie), re.toString("utf8", ne, ie);
}
function utf8End(re) {
  var ne = re && re.length ? this.write(re) : "";
  return this.lastNeed ? ne + "�" : ne;
}
function utf16Text(re, ne) {
  if ((re.length - ne) % 2 === 0) {
    var ae = re.toString("utf16le", ne);
    if (ae) {
      var ie = ae.charCodeAt(ae.length - 1);
      if (ie >= 55296 && ie <= 56319)
        return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = re[re.length - 2], this.lastChar[1] = re[re.length - 1], ae.slice(0, -1);
    }
    return ae;
  }
  return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = re[re.length - 1], re.toString("utf16le", ne, re.length - 1);
}
function utf16End(re) {
  var ne = re && re.length ? this.write(re) : "";
  if (this.lastNeed) {
    var ae = this.lastTotal - this.lastNeed;
    return ne + this.lastChar.toString("utf16le", 0, ae);
  }
  return ne;
}
function base64Text(re, ne) {
  var ae = (re.length - ne) % 3;
  return ae === 0 ? re.toString("base64", ne) : (this.lastNeed = 3 - ae, this.lastTotal = 3, ae === 1 ? this.lastChar[0] = re[re.length - 1] : (this.lastChar[0] = re[re.length - 2], this.lastChar[1] = re[re.length - 1]), re.toString("base64", ne, re.length - ae));
}
function base64End(re) {
  var ne = re && re.length ? this.write(re) : "";
  return this.lastNeed ? ne + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : ne;
}
function simpleWrite(re) {
  return re.toString(this.encoding);
}
function simpleEnd(re) {
  return re && re.length ? this.write(re) : "";
}
var ERR_STREAM_PREMATURE_CLOSE = errorsBrowser.codes.ERR_STREAM_PREMATURE_CLOSE;
function once$1(re) {
  var ne = !1;
  return function() {
    if (!ne) {
      ne = !0;
      for (var ae = arguments.length, ie = new Array(ae), le = 0; le < ae; le++)
        ie[le] = arguments[le];
      re.apply(this, ie);
    }
  };
}
function noop$1() {
}
function isRequest$1(re) {
  return re.setHeader && typeof re.abort == "function";
}
function eos$1(re, ne, ae) {
  if (typeof ne == "function") return eos$1(re, null, ne);
  ne || (ne = {}), ae = once$1(ae || noop$1);
  var ie = ne.readable || ne.readable !== !1 && re.readable, le = ne.writable || ne.writable !== !1 && re.writable, se = function() {
    re.writable || ue();
  }, ce = re._writableState && re._writableState.finished, ue = function() {
    le = !1, ce = !0, ie || ae.call(re);
  }, de = re._readableState && re._readableState.endEmitted, me = function() {
    ie = !1, de = !0, le || ae.call(re);
  }, fe = function(Se) {
    ae.call(re, Se);
  }, pe = function() {
    var Se;
    if (ie && !de)
      return (!re._readableState || !re._readableState.ended) && (Se = new ERR_STREAM_PREMATURE_CLOSE()), ae.call(re, Se);
    if (le && !ce)
      return (!re._writableState || !re._writableState.ended) && (Se = new ERR_STREAM_PREMATURE_CLOSE()), ae.call(re, Se);
  }, ge = function() {
    re.req.on("finish", ue);
  };
  return isRequest$1(re) ? (re.on("complete", ue), re.on("abort", pe), re.req ? ge() : re.on("request", ge)) : le && !re._writableState && (re.on("end", se), re.on("close", se)), re.on("end", me), re.on("finish", ue), ne.error !== !1 && re.on("error", fe), re.on("close", pe), function() {
    re.removeListener("complete", ue), re.removeListener("abort", pe), re.removeListener("request", ge), re.req && re.req.removeListener("finish", ue), re.removeListener("end", se), re.removeListener("close", se), re.removeListener("finish", ue), re.removeListener("end", me), re.removeListener("error", fe), re.removeListener("close", pe);
  };
}
var endOfStream = eos$1, async_iterator, hasRequiredAsync_iterator;
function requireAsync_iterator() {
  if (hasRequiredAsync_iterator) return async_iterator;
  hasRequiredAsync_iterator = 1;
  var re;
  function ne(Oe, Ne, He) {
    return Ne = ae(Ne), Ne in Oe ? Object.defineProperty(Oe, Ne, { value: He, enumerable: !0, configurable: !0, writable: !0 }) : Oe[Ne] = He, Oe;
  }
  function ae(Oe) {
    var Ne = ie(Oe, "string");
    return typeof Ne == "symbol" ? Ne : String(Ne);
  }
  function ie(Oe, Ne) {
    if (typeof Oe != "object" || Oe === null) return Oe;
    var He = Oe[Symbol.toPrimitive];
    if (He !== void 0) {
      var Ue = He.call(Oe, Ne || "default");
      if (typeof Ue != "object") return Ue;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (Ne === "string" ? String : Number)(Oe);
  }
  var le = endOfStream, se = Symbol("lastResolve"), ce = Symbol("lastReject"), ue = Symbol("error"), de = Symbol("ended"), me = Symbol("lastPromise"), fe = Symbol("handlePromise"), pe = Symbol("stream");
  function ge(Oe, Ne) {
    return {
      value: Oe,
      done: Ne
    };
  }
  function be(Oe) {
    var Ne = Oe[se];
    if (Ne !== null) {
      var He = Oe[pe].read();
      He !== null && (Oe[me] = null, Oe[se] = null, Oe[ce] = null, Ne(ge(He, !1)));
    }
  }
  function Se(Oe) {
    process$1.nextTick(be, Oe);
  }
  function Pe(Oe, Ne) {
    return function(He, Ue) {
      Oe.then(function() {
        if (Ne[de]) {
          He(ge(void 0, !0));
          return;
        }
        Ne[fe](He, Ue);
      }, Ue);
    };
  }
  var Ee = Object.getPrototypeOf(function() {
  }), Ve = Object.setPrototypeOf((re = {
    get stream() {
      return this[pe];
    },
    next: function() {
      var Ne = this, He = this[ue];
      if (He !== null)
        return Promise.reject(He);
      if (this[de])
        return Promise.resolve(ge(void 0, !0));
      if (this[pe].destroyed)
        return new Promise(function(Ke, tt) {
          process$1.nextTick(function() {
            Ne[ue] ? tt(Ne[ue]) : Ke(ge(void 0, !0));
          });
        });
      var Ue = this[me], Ze;
      if (Ue)
        Ze = new Promise(Pe(Ue, this));
      else {
        var Fe = this[pe].read();
        if (Fe !== null)
          return Promise.resolve(ge(Fe, !1));
        Ze = new Promise(this[fe]);
      }
      return this[me] = Ze, Ze;
    }
  }, ne(re, Symbol.asyncIterator, function() {
    return this;
  }), ne(re, "return", function() {
    var Ne = this;
    return new Promise(function(He, Ue) {
      Ne[pe].destroy(null, function(Ze) {
        if (Ze) {
          Ue(Ze);
          return;
        }
        He(ge(void 0, !0));
      });
    });
  }), re), Ee), Ae = function(Ne) {
    var He, Ue = Object.create(Ve, (He = {}, ne(He, pe, {
      value: Ne,
      writable: !0
    }), ne(He, se, {
      value: null,
      writable: !0
    }), ne(He, ce, {
      value: null,
      writable: !0
    }), ne(He, ue, {
      value: null,
      writable: !0
    }), ne(He, de, {
      value: Ne._readableState.endEmitted,
      writable: !0
    }), ne(He, fe, {
      value: function(Fe, Ke) {
        var tt = Ue[pe].read();
        tt ? (Ue[me] = null, Ue[se] = null, Ue[ce] = null, Fe(ge(tt, !1))) : (Ue[se] = Fe, Ue[ce] = Ke);
      },
      writable: !0
    }), He));
    return Ue[me] = null, le(Ne, function(Ze) {
      if (Ze && Ze.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var Fe = Ue[ce];
        Fe !== null && (Ue[me] = null, Ue[se] = null, Ue[ce] = null, Fe(Ze)), Ue[ue] = Ze;
        return;
      }
      var Ke = Ue[se];
      Ke !== null && (Ue[me] = null, Ue[se] = null, Ue[ce] = null, Ke(ge(void 0, !0))), Ue[de] = !0;
    }), Ne.on("readable", Se.bind(null, Ue)), Ue;
  };
  return async_iterator = Ae, async_iterator;
}
var fromBrowser, hasRequiredFromBrowser;
function requireFromBrowser() {
  return hasRequiredFromBrowser || (hasRequiredFromBrowser = 1, fromBrowser = function() {
    throw new Error("Readable.from is not available in the browser");
  }), fromBrowser;
}
var _stream_readable$1, hasRequired_stream_readable$1;
function require_stream_readable$1() {
  if (hasRequired_stream_readable$1) return _stream_readable$1;
  hasRequired_stream_readable$1 = 1, _stream_readable$1 = Ke;
  var re;
  Ke.ReadableState = Fe, eventsExports.EventEmitter;
  var ne = function(We, ze) {
    return We.listeners(ze).length;
  }, ae = streamBrowser$1, ie = require$$1$2.Buffer, le = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function se(qe) {
    return ie.from(qe);
  }
  function ce(qe) {
    return ie.isBuffer(qe) || qe instanceof le;
  }
  var ue = util$3, de;
  ue && ue.debuglog ? de = ue.debuglog("stream") : de = function() {
  };
  var me = requireBuffer_list(), fe = destroy_1$1, pe = state$4, ge = pe.getHighWaterMark, be = errorsBrowser.codes, Se = be.ERR_INVALID_ARG_TYPE, Pe = be.ERR_STREAM_PUSH_AFTER_EOF, Ee = be.ERR_METHOD_NOT_IMPLEMENTED, Ve = be.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, Ae, Oe, Ne;
  inherits_browserExports(Ke, ae);
  var He = fe.errorOrDestroy, Ue = ["error", "close", "destroy", "pause", "resume"];
  function Ze(qe, We, ze) {
    if (typeof qe.prependListener == "function") return qe.prependListener(We, ze);
    !qe._events || !qe._events[We] ? qe.on(We, ze) : Array.isArray(qe._events[We]) ? qe._events[We].unshift(ze) : qe._events[We] = [ze, qe._events[We]];
  }
  function Fe(qe, We, ze) {
    re = re || require_stream_duplex$1(), qe = qe || {}, typeof ze != "boolean" && (ze = We instanceof re), this.objectMode = !!qe.objectMode, ze && (this.objectMode = this.objectMode || !!qe.readableObjectMode), this.highWaterMark = ge(this, qe, "readableHighWaterMark", ze), this.buffer = new me(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = qe.emitClose !== !1, this.autoDestroy = !!qe.autoDestroy, this.destroyed = !1, this.defaultEncoding = qe.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, qe.encoding && (Ae || (Ae = string_decoder.StringDecoder), this.decoder = new Ae(qe.encoding), this.encoding = qe.encoding);
  }
  function Ke(qe) {
    if (re = re || require_stream_duplex$1(), !(this instanceof Ke)) return new Ke(qe);
    var We = this instanceof re;
    this._readableState = new Fe(qe, this, We), this.readable = !0, qe && (typeof qe.read == "function" && (this._read = qe.read), typeof qe.destroy == "function" && (this._destroy = qe.destroy)), ae.call(this);
  }
  Object.defineProperty(Ke.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(We) {
      this._readableState && (this._readableState.destroyed = We);
    }
  }), Ke.prototype.destroy = fe.destroy, Ke.prototype._undestroy = fe.undestroy, Ke.prototype._destroy = function(qe, We) {
    We(qe);
  }, Ke.prototype.push = function(qe, We) {
    var ze = this._readableState, Ge;
    return ze.objectMode ? Ge = !0 : typeof qe == "string" && (We = We || ze.defaultEncoding, We !== ze.encoding && (qe = ie.from(qe, We), We = ""), Ge = !0), tt(this, qe, We, !1, Ge);
  }, Ke.prototype.unshift = function(qe) {
    return tt(this, qe, null, !0, !1);
  };
  function tt(qe, We, ze, Ge, nt) {
    de("readableAddChunk", We);
    var ot = qe._readableState;
    if (We === null)
      ot.reading = !1, xe(qe, ot);
    else {
      var lt;
      if (nt || (lt = Ce(ot, We)), lt)
        He(qe, lt);
      else if (ot.objectMode || We && We.length > 0)
        if (typeof We != "string" && !ot.objectMode && Object.getPrototypeOf(We) !== ie.prototype && (We = se(We)), Ge)
          ot.endEmitted ? He(qe, new Ve()) : Re(qe, ot, We, !0);
        else if (ot.ended)
          He(qe, new Pe());
        else {
          if (ot.destroyed)
            return !1;
          ot.reading = !1, ot.decoder && !ze ? (We = ot.decoder.write(We), ot.objectMode || We.length !== 0 ? Re(qe, ot, We, !1) : Ie(qe, ot)) : Re(qe, ot, We, !1);
        }
      else Ge || (ot.reading = !1, Ie(qe, ot));
    }
    return !ot.ended && (ot.length < ot.highWaterMark || ot.length === 0);
  }
  function Re(qe, We, ze, Ge) {
    We.flowing && We.length === 0 && !We.sync ? (We.awaitDrain = 0, qe.emit("data", ze)) : (We.length += We.objectMode ? 1 : ze.length, Ge ? We.buffer.unshift(ze) : We.buffer.push(ze), We.needReadable && $e(qe)), Ie(qe, We);
  }
  function Ce(qe, We) {
    var ze;
    return !ce(We) && typeof We != "string" && We !== void 0 && !qe.objectMode && (ze = new Se("chunk", ["string", "Buffer", "Uint8Array"], We)), ze;
  }
  Ke.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, Ke.prototype.setEncoding = function(qe) {
    Ae || (Ae = string_decoder.StringDecoder);
    var We = new Ae(qe);
    this._readableState.decoder = We, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var ze = this._readableState.buffer.head, Ge = ""; ze !== null; )
      Ge += We.write(ze.data), ze = ze.next;
    return this._readableState.buffer.clear(), Ge !== "" && this._readableState.buffer.push(Ge), this._readableState.length = Ge.length, this;
  };
  var _e = 1073741824;
  function he(qe) {
    return qe >= _e ? qe = _e : (qe--, qe |= qe >>> 1, qe |= qe >>> 2, qe |= qe >>> 4, qe |= qe >>> 8, qe |= qe >>> 16, qe++), qe;
  }
  function ve(qe, We) {
    return qe <= 0 || We.length === 0 && We.ended ? 0 : We.objectMode ? 1 : qe !== qe ? We.flowing && We.length ? We.buffer.head.data.length : We.length : (qe > We.highWaterMark && (We.highWaterMark = he(qe)), qe <= We.length ? qe : We.ended ? We.length : (We.needReadable = !0, 0));
  }
  Ke.prototype.read = function(qe) {
    de("read", qe), qe = parseInt(qe, 10);
    var We = this._readableState, ze = qe;
    if (qe !== 0 && (We.emittedReadable = !1), qe === 0 && We.needReadable && ((We.highWaterMark !== 0 ? We.length >= We.highWaterMark : We.length > 0) || We.ended))
      return de("read: emitReadable", We.length, We.ended), We.length === 0 && We.ended ? je(this) : $e(this), null;
    if (qe = ve(qe, We), qe === 0 && We.ended)
      return We.length === 0 && je(this), null;
    var Ge = We.needReadable;
    de("need readable", Ge), (We.length === 0 || We.length - qe < We.highWaterMark) && (Ge = !0, de("length less than watermark", Ge)), We.ended || We.reading ? (Ge = !1, de("reading or ended", Ge)) : Ge && (de("do read"), We.reading = !0, We.sync = !0, We.length === 0 && (We.needReadable = !0), this._read(We.highWaterMark), We.sync = !1, We.reading || (qe = ve(ze, We)));
    var nt;
    return qe > 0 ? nt = De(qe, We) : nt = null, nt === null ? (We.needReadable = We.length <= We.highWaterMark, qe = 0) : (We.length -= qe, We.awaitDrain = 0), We.length === 0 && (We.ended || (We.needReadable = !0), ze !== qe && We.ended && je(this)), nt !== null && this.emit("data", nt), nt;
  };
  function xe(qe, We) {
    if (de("onEofChunk"), !We.ended) {
      if (We.decoder) {
        var ze = We.decoder.end();
        ze && ze.length && (We.buffer.push(ze), We.length += We.objectMode ? 1 : ze.length);
      }
      We.ended = !0, We.sync ? $e(qe) : (We.needReadable = !1, We.emittedReadable || (We.emittedReadable = !0, Te(qe)));
    }
  }
  function $e(qe) {
    var We = qe._readableState;
    de("emitReadable", We.needReadable, We.emittedReadable), We.needReadable = !1, We.emittedReadable || (de("emitReadable", We.flowing), We.emittedReadable = !0, process$1.nextTick(Te, qe));
  }
  function Te(qe) {
    var We = qe._readableState;
    de("emitReadable_", We.destroyed, We.length, We.ended), !We.destroyed && (We.length || We.ended) && (qe.emit("readable"), We.emittedReadable = !1), We.needReadable = !We.flowing && !We.ended && We.length <= We.highWaterMark, Ye(qe);
  }
  function Ie(qe, We) {
    We.readingMore || (We.readingMore = !0, process$1.nextTick(we, qe, We));
  }
  function we(qe, We) {
    for (; !We.reading && !We.ended && (We.length < We.highWaterMark || We.flowing && We.length === 0); ) {
      var ze = We.length;
      if (de("maybeReadMore read 0"), qe.read(0), ze === We.length)
        break;
    }
    We.readingMore = !1;
  }
  Ke.prototype._read = function(qe) {
    He(this, new Ee("_read()"));
  }, Ke.prototype.pipe = function(qe, We) {
    var ze = this, Ge = this._readableState;
    switch (Ge.pipesCount) {
      case 0:
        Ge.pipes = qe;
        break;
      case 1:
        Ge.pipes = [Ge.pipes, qe];
        break;
      default:
        Ge.pipes.push(qe);
        break;
    }
    Ge.pipesCount += 1, de("pipe count=%d opts=%j", Ge.pipesCount, We);
    var nt = (!We || We.end !== !1) && qe !== process$1.stdout && qe !== process$1.stderr, ot = nt ? mt : ht;
    Ge.endEmitted ? process$1.nextTick(ot) : ze.once("end", ot), qe.on("unpipe", lt);
    function lt(vt, xt) {
      de("onunpipe"), vt === ze && xt && xt.hasUnpiped === !1 && (xt.hasUnpiped = !0, bt());
    }
    function mt() {
      de("onend"), qe.end();
    }
    var dt = ke(ze);
    qe.on("drain", dt);
    var gt = !1;
    function bt() {
      de("cleanup"), qe.removeListener("close", pt), qe.removeListener("finish", ut), qe.removeListener("drain", dt), qe.removeListener("error", wt), qe.removeListener("unpipe", lt), ze.removeListener("end", mt), ze.removeListener("end", ht), ze.removeListener("data", At), gt = !0, Ge.awaitDrain && (!qe._writableState || qe._writableState.needDrain) && dt();
    }
    ze.on("data", At);
    function At(vt) {
      de("ondata");
      var xt = qe.write(vt);
      de("dest.write", xt), xt === !1 && ((Ge.pipesCount === 1 && Ge.pipes === qe || Ge.pipesCount > 1 && at(Ge.pipes, qe) !== -1) && !gt && (de("false write response, pause", Ge.awaitDrain), Ge.awaitDrain++), ze.pause());
    }
    function wt(vt) {
      de("onerror", vt), ht(), qe.removeListener("error", wt), ne(qe, "error") === 0 && He(qe, vt);
    }
    Ze(qe, "error", wt);
    function pt() {
      qe.removeListener("finish", ut), ht();
    }
    qe.once("close", pt);
    function ut() {
      de("onfinish"), qe.removeListener("close", pt), ht();
    }
    qe.once("finish", ut);
    function ht() {
      de("unpipe"), ze.unpipe(qe);
    }
    return qe.emit("pipe", ze), Ge.flowing || (de("pipe resume"), ze.resume()), qe;
  };
  function ke(qe) {
    return function() {
      var ze = qe._readableState;
      de("pipeOnDrain", ze.awaitDrain), ze.awaitDrain && ze.awaitDrain--, ze.awaitDrain === 0 && ne(qe, "data") && (ze.flowing = !0, Ye(qe));
    };
  }
  Ke.prototype.unpipe = function(qe) {
    var We = this._readableState, ze = {
      hasUnpiped: !1
    };
    if (We.pipesCount === 0) return this;
    if (We.pipesCount === 1)
      return qe && qe !== We.pipes ? this : (qe || (qe = We.pipes), We.pipes = null, We.pipesCount = 0, We.flowing = !1, qe && qe.emit("unpipe", this, ze), this);
    if (!qe) {
      var Ge = We.pipes, nt = We.pipesCount;
      We.pipes = null, We.pipesCount = 0, We.flowing = !1;
      for (var ot = 0; ot < nt; ot++) Ge[ot].emit("unpipe", this, {
        hasUnpiped: !1
      });
      return this;
    }
    var lt = at(We.pipes, qe);
    return lt === -1 ? this : (We.pipes.splice(lt, 1), We.pipesCount -= 1, We.pipesCount === 1 && (We.pipes = We.pipes[0]), qe.emit("unpipe", this, ze), this);
  }, Ke.prototype.on = function(qe, We) {
    var ze = ae.prototype.on.call(this, qe, We), Ge = this._readableState;
    return qe === "data" ? (Ge.readableListening = this.listenerCount("readable") > 0, Ge.flowing !== !1 && this.resume()) : qe === "readable" && !Ge.endEmitted && !Ge.readableListening && (Ge.readableListening = Ge.needReadable = !0, Ge.flowing = !1, Ge.emittedReadable = !1, de("on readable", Ge.length, Ge.reading), Ge.length ? $e(this) : Ge.reading || process$1.nextTick(Be, this)), ze;
  }, Ke.prototype.addListener = Ke.prototype.on, Ke.prototype.removeListener = function(qe, We) {
    var ze = ae.prototype.removeListener.call(this, qe, We);
    return qe === "readable" && process$1.nextTick(ye, this), ze;
  }, Ke.prototype.removeAllListeners = function(qe) {
    var We = ae.prototype.removeAllListeners.apply(this, arguments);
    return (qe === "readable" || qe === void 0) && process$1.nextTick(ye, this), We;
  };
  function ye(qe) {
    var We = qe._readableState;
    We.readableListening = qe.listenerCount("readable") > 0, We.resumeScheduled && !We.paused ? We.flowing = !0 : qe.listenerCount("data") > 0 && qe.resume();
  }
  function Be(qe) {
    de("readable nexttick read 0"), qe.read(0);
  }
  Ke.prototype.resume = function() {
    var qe = this._readableState;
    return qe.flowing || (de("resume"), qe.flowing = !qe.readableListening, Xe(this, qe)), qe.paused = !1, this;
  };
  function Xe(qe, We) {
    We.resumeScheduled || (We.resumeScheduled = !0, process$1.nextTick(et, qe, We));
  }
  function et(qe, We) {
    de("resume", We.reading), We.reading || qe.read(0), We.resumeScheduled = !1, qe.emit("resume"), Ye(qe), We.flowing && !We.reading && qe.read(0);
  }
  Ke.prototype.pause = function() {
    return de("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (de("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function Ye(qe) {
    var We = qe._readableState;
    for (de("flow", We.flowing); We.flowing && qe.read() !== null; ) ;
  }
  Ke.prototype.wrap = function(qe) {
    var We = this, ze = this._readableState, Ge = !1;
    qe.on("end", function() {
      if (de("wrapped end"), ze.decoder && !ze.ended) {
        var lt = ze.decoder.end();
        lt && lt.length && We.push(lt);
      }
      We.push(null);
    }), qe.on("data", function(lt) {
      if (de("wrapped data"), ze.decoder && (lt = ze.decoder.write(lt)), !(ze.objectMode && lt == null) && !(!ze.objectMode && (!lt || !lt.length))) {
        var mt = We.push(lt);
        mt || (Ge = !0, qe.pause());
      }
    });
    for (var nt in qe)
      this[nt] === void 0 && typeof qe[nt] == "function" && (this[nt] = /* @__PURE__ */ function(mt) {
        return function() {
          return qe[mt].apply(qe, arguments);
        };
      }(nt));
    for (var ot = 0; ot < Ue.length; ot++)
      qe.on(Ue[ot], this.emit.bind(this, Ue[ot]));
    return this._read = function(lt) {
      de("wrapped _read", lt), Ge && (Ge = !1, qe.resume());
    }, this;
  }, typeof Symbol == "function" && (Ke.prototype[Symbol.asyncIterator] = function() {
    return Oe === void 0 && (Oe = requireAsync_iterator()), Oe(this);
  }), Object.defineProperty(Ke.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(Ke.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(Ke.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(We) {
      this._readableState && (this._readableState.flowing = We);
    }
  }), Ke._fromList = De, Object.defineProperty(Ke.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function De(qe, We) {
    if (We.length === 0) return null;
    var ze;
    return We.objectMode ? ze = We.buffer.shift() : !qe || qe >= We.length ? (We.decoder ? ze = We.buffer.join("") : We.buffer.length === 1 ? ze = We.buffer.first() : ze = We.buffer.concat(We.length), We.buffer.clear()) : ze = We.buffer.consume(qe, We.decoder), ze;
  }
  function je(qe) {
    var We = qe._readableState;
    de("endReadable", We.endEmitted), We.endEmitted || (We.ended = !0, process$1.nextTick(rt, We, qe));
  }
  function rt(qe, We) {
    if (de("endReadableNT", qe.endEmitted, qe.length), !qe.endEmitted && qe.length === 0 && (qe.endEmitted = !0, We.readable = !1, We.emit("end"), qe.autoDestroy)) {
      var ze = We._writableState;
      (!ze || ze.autoDestroy && ze.finished) && We.destroy();
    }
  }
  typeof Symbol == "function" && (Ke.from = function(qe, We) {
    return Ne === void 0 && (Ne = requireFromBrowser()), Ne(Ke, qe, We);
  });
  function at(qe, We) {
    for (var ze = 0, Ge = qe.length; ze < Ge; ze++)
      if (qe[ze] === We) return ze;
    return -1;
  }
  return _stream_readable$1;
}
var _stream_transform$1 = Transform$a, _require$codes$1 = errorsBrowser.codes, ERR_METHOD_NOT_IMPLEMENTED = _require$codes$1.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes$1.ERR_MULTIPLE_CALLBACK, ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes$1.ERR_TRANSFORM_ALREADY_TRANSFORMING, ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes$1.ERR_TRANSFORM_WITH_LENGTH_0, Duplex$1 = require_stream_duplex$1();
inherits_browserExports(Transform$a, Duplex$1);
function afterTransform$1(re, ne) {
  var ae = this._transformState;
  ae.transforming = !1;
  var ie = ae.writecb;
  if (ie === null)
    return this.emit("error", new ERR_MULTIPLE_CALLBACK());
  ae.writechunk = null, ae.writecb = null, ne != null && this.push(ne), ie(re);
  var le = this._readableState;
  le.reading = !1, (le.needReadable || le.length < le.highWaterMark) && this._read(le.highWaterMark);
}
function Transform$a(re) {
  if (!(this instanceof Transform$a)) return new Transform$a(re);
  Duplex$1.call(this, re), this._transformState = {
    afterTransform: afterTransform$1.bind(this),
    needTransform: !1,
    transforming: !1,
    writecb: null,
    writechunk: null,
    writeencoding: null
  }, this._readableState.needReadable = !0, this._readableState.sync = !1, re && (typeof re.transform == "function" && (this._transform = re.transform), typeof re.flush == "function" && (this._flush = re.flush)), this.on("prefinish", prefinish$1);
}
function prefinish$1() {
  var re = this;
  typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(ne, ae) {
    done$1(re, ne, ae);
  }) : done$1(this, null, null);
}
Transform$a.prototype.push = function(re, ne) {
  return this._transformState.needTransform = !1, Duplex$1.prototype.push.call(this, re, ne);
};
Transform$a.prototype._transform = function(re, ne, ae) {
  ae(new ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
Transform$a.prototype._write = function(re, ne, ae) {
  var ie = this._transformState;
  if (ie.writecb = ae, ie.writechunk = re, ie.writeencoding = ne, !ie.transforming) {
    var le = this._readableState;
    (ie.needTransform || le.needReadable || le.length < le.highWaterMark) && this._read(le.highWaterMark);
  }
};
Transform$a.prototype._read = function(re) {
  var ne = this._transformState;
  ne.writechunk !== null && !ne.transforming ? (ne.transforming = !0, this._transform(ne.writechunk, ne.writeencoding, ne.afterTransform)) : ne.needTransform = !0;
};
Transform$a.prototype._destroy = function(re, ne) {
  Duplex$1.prototype._destroy.call(this, re, function(ae) {
    ne(ae);
  });
};
function done$1(re, ne, ae) {
  if (ne) return re.emit("error", ne);
  if (ae != null && re.push(ae), re._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (re._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return re.push(null);
}
var _stream_passthrough$1 = PassThrough$1, Transform$9 = _stream_transform$1;
inherits_browserExports(PassThrough$1, Transform$9);
function PassThrough$1(re) {
  if (!(this instanceof PassThrough$1)) return new PassThrough$1(re);
  Transform$9.call(this, re);
}
PassThrough$1.prototype._transform = function(re, ne, ae) {
  ae(null, re);
};
var eos;
function once(re) {
  var ne = !1;
  return function() {
    ne || (ne = !0, re.apply(void 0, arguments));
  };
}
var _require$codes = errorsBrowser.codes, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(re) {
  if (re) throw re;
}
function isRequest(re) {
  return re.setHeader && typeof re.abort == "function";
}
function destroyer(re, ne, ae, ie) {
  ie = once(ie);
  var le = !1;
  re.on("close", function() {
    le = !0;
  }), eos === void 0 && (eos = endOfStream), eos(re, {
    readable: ne,
    writable: ae
  }, function(ce) {
    if (ce) return ie(ce);
    le = !0, ie();
  });
  var se = !1;
  return function(ce) {
    if (!le && !se) {
      if (se = !0, isRequest(re)) return re.abort();
      if (typeof re.destroy == "function") return re.destroy();
      ie(ce || new ERR_STREAM_DESTROYED("pipe"));
    }
  };
}
function call(re) {
  re();
}
function pipe(re, ne) {
  return re.pipe(ne);
}
function popCallback(re) {
  return !re.length || typeof re[re.length - 1] != "function" ? noop : re.pop();
}
function pipeline() {
  for (var re = arguments.length, ne = new Array(re), ae = 0; ae < re; ae++)
    ne[ae] = arguments[ae];
  var ie = popCallback(ne);
  if (Array.isArray(ne[0]) && (ne = ne[0]), ne.length < 2)
    throw new ERR_MISSING_ARGS("streams");
  var le, se = ne.map(function(ce, ue) {
    var de = ue < ne.length - 1, me = ue > 0;
    return destroyer(ce, de, me, function(fe) {
      le || (le = fe), fe && se.forEach(call), !de && (se.forEach(call), ie(le));
    });
  });
  return ne.reduce(pipe);
}
var pipeline_1 = pipeline;
(function(re, ne) {
  ne = re.exports = require_stream_readable$1(), ne.Stream = ne, ne.Readable = ne, ne.Writable = require_stream_writable$1(), ne.Duplex = require_stream_duplex$1(), ne.Transform = _stream_transform$1, ne.PassThrough = _stream_passthrough$1, ne.finished = endOfStream, ne.pipeline = pipeline_1;
})(readableBrowser$1, readableBrowser$1.exports);
var readableBrowserExports$1 = readableBrowser$1.exports, Buffer$A = safeBufferExports$1.Buffer, Transform$8 = readableBrowserExports$1.Transform, inherits$r = inherits_browserExports;
function throwIfNotStringOrBuffer$1(re, ne) {
  if (!Buffer$A.isBuffer(re) && typeof re != "string")
    throw new TypeError(ne + " must be a string or a buffer");
}
function HashBase$3(re) {
  Transform$8.call(this), this._block = Buffer$A.allocUnsafe(re), this._blockSize = re, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
}
inherits$r(HashBase$3, Transform$8);
HashBase$3.prototype._transform = function(re, ne, ae) {
  var ie = null;
  try {
    this.update(re, ne);
  } catch (le) {
    ie = le;
  }
  ae(ie);
};
HashBase$3.prototype._flush = function(re) {
  var ne = null;
  try {
    this.push(this.digest());
  } catch (ae) {
    ne = ae;
  }
  re(ne);
};
HashBase$3.prototype.update = function(re, ne) {
  if (throwIfNotStringOrBuffer$1(re, "Data"), this._finalized) throw new Error("Digest already called");
  Buffer$A.isBuffer(re) || (re = Buffer$A.from(re, ne));
  for (var ae = this._block, ie = 0; this._blockOffset + re.length - ie >= this._blockSize; ) {
    for (var le = this._blockOffset; le < this._blockSize; ) ae[le++] = re[ie++];
    this._update(), this._blockOffset = 0;
  }
  for (; ie < re.length; ) ae[this._blockOffset++] = re[ie++];
  for (var se = 0, ce = re.length * 8; ce > 0; ++se)
    this._length[se] += ce, ce = this._length[se] / 4294967296 | 0, ce > 0 && (this._length[se] -= 4294967296 * ce);
  return this;
};
HashBase$3.prototype._update = function() {
  throw new Error("_update is not implemented");
};
HashBase$3.prototype.digest = function(re) {
  if (this._finalized) throw new Error("Digest already called");
  this._finalized = !0;
  var ne = this._digest();
  re !== void 0 && (ne = ne.toString(re)), this._block.fill(0), this._blockOffset = 0;
  for (var ae = 0; ae < 4; ++ae) this._length[ae] = 0;
  return ne;
};
HashBase$3.prototype._digest = function() {
  throw new Error("_digest is not implemented");
};
var hashBase$1 = HashBase$3, inherits$q = inherits_browserExports, HashBase$2 = hashBase$1, Buffer$z = safeBufferExports$1.Buffer, ARRAY16$1 = new Array(16);
function MD5$3() {
  HashBase$2.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
}
inherits$q(MD5$3, HashBase$2);
MD5$3.prototype._update = function() {
  for (var re = ARRAY16$1, ne = 0; ne < 16; ++ne) re[ne] = this._block.readInt32LE(ne * 4);
  var ae = this._a, ie = this._b, le = this._c, se = this._d;
  ae = fnF(ae, ie, le, se, re[0], 3614090360, 7), se = fnF(se, ae, ie, le, re[1], 3905402710, 12), le = fnF(le, se, ae, ie, re[2], 606105819, 17), ie = fnF(ie, le, se, ae, re[3], 3250441966, 22), ae = fnF(ae, ie, le, se, re[4], 4118548399, 7), se = fnF(se, ae, ie, le, re[5], 1200080426, 12), le = fnF(le, se, ae, ie, re[6], 2821735955, 17), ie = fnF(ie, le, se, ae, re[7], 4249261313, 22), ae = fnF(ae, ie, le, se, re[8], 1770035416, 7), se = fnF(se, ae, ie, le, re[9], 2336552879, 12), le = fnF(le, se, ae, ie, re[10], 4294925233, 17), ie = fnF(ie, le, se, ae, re[11], 2304563134, 22), ae = fnF(ae, ie, le, se, re[12], 1804603682, 7), se = fnF(se, ae, ie, le, re[13], 4254626195, 12), le = fnF(le, se, ae, ie, re[14], 2792965006, 17), ie = fnF(ie, le, se, ae, re[15], 1236535329, 22), ae = fnG(ae, ie, le, se, re[1], 4129170786, 5), se = fnG(se, ae, ie, le, re[6], 3225465664, 9), le = fnG(le, se, ae, ie, re[11], 643717713, 14), ie = fnG(ie, le, se, ae, re[0], 3921069994, 20), ae = fnG(ae, ie, le, se, re[5], 3593408605, 5), se = fnG(se, ae, ie, le, re[10], 38016083, 9), le = fnG(le, se, ae, ie, re[15], 3634488961, 14), ie = fnG(ie, le, se, ae, re[4], 3889429448, 20), ae = fnG(ae, ie, le, se, re[9], 568446438, 5), se = fnG(se, ae, ie, le, re[14], 3275163606, 9), le = fnG(le, se, ae, ie, re[3], 4107603335, 14), ie = fnG(ie, le, se, ae, re[8], 1163531501, 20), ae = fnG(ae, ie, le, se, re[13], 2850285829, 5), se = fnG(se, ae, ie, le, re[2], 4243563512, 9), le = fnG(le, se, ae, ie, re[7], 1735328473, 14), ie = fnG(ie, le, se, ae, re[12], 2368359562, 20), ae = fnH(ae, ie, le, se, re[5], 4294588738, 4), se = fnH(se, ae, ie, le, re[8], 2272392833, 11), le = fnH(le, se, ae, ie, re[11], 1839030562, 16), ie = fnH(ie, le, se, ae, re[14], 4259657740, 23), ae = fnH(ae, ie, le, se, re[1], 2763975236, 4), se = fnH(se, ae, ie, le, re[4], 1272893353, 11), le = fnH(le, se, ae, ie, re[7], 4139469664, 16), ie = fnH(ie, le, se, ae, re[10], 3200236656, 23), ae = fnH(ae, ie, le, se, re[13], 681279174, 4), se = fnH(se, ae, ie, le, re[0], 3936430074, 11), le = fnH(le, se, ae, ie, re[3], 3572445317, 16), ie = fnH(ie, le, se, ae, re[6], 76029189, 23), ae = fnH(ae, ie, le, se, re[9], 3654602809, 4), se = fnH(se, ae, ie, le, re[12], 3873151461, 11), le = fnH(le, se, ae, ie, re[15], 530742520, 16), ie = fnH(ie, le, se, ae, re[2], 3299628645, 23), ae = fnI(ae, ie, le, se, re[0], 4096336452, 6), se = fnI(se, ae, ie, le, re[7], 1126891415, 10), le = fnI(le, se, ae, ie, re[14], 2878612391, 15), ie = fnI(ie, le, se, ae, re[5], 4237533241, 21), ae = fnI(ae, ie, le, se, re[12], 1700485571, 6), se = fnI(se, ae, ie, le, re[3], 2399980690, 10), le = fnI(le, se, ae, ie, re[10], 4293915773, 15), ie = fnI(ie, le, se, ae, re[1], 2240044497, 21), ae = fnI(ae, ie, le, se, re[8], 1873313359, 6), se = fnI(se, ae, ie, le, re[15], 4264355552, 10), le = fnI(le, se, ae, ie, re[6], 2734768916, 15), ie = fnI(ie, le, se, ae, re[13], 1309151649, 21), ae = fnI(ae, ie, le, se, re[4], 4149444226, 6), se = fnI(se, ae, ie, le, re[11], 3174756917, 10), le = fnI(le, se, ae, ie, re[2], 718787259, 15), ie = fnI(ie, le, se, ae, re[9], 3951481745, 21), this._a = this._a + ae | 0, this._b = this._b + ie | 0, this._c = this._c + le | 0, this._d = this._d + se | 0;
};
MD5$3.prototype._digest = function() {
  this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
  var re = Buffer$z.allocUnsafe(16);
  return re.writeInt32LE(this._a, 0), re.writeInt32LE(this._b, 4), re.writeInt32LE(this._c, 8), re.writeInt32LE(this._d, 12), re;
};
function rotl$1(re, ne) {
  return re << ne | re >>> 32 - ne;
}
function fnF(re, ne, ae, ie, le, se, ce) {
  return rotl$1(re + (ne & ae | ~ne & ie) + le + se | 0, ce) + ne | 0;
}
function fnG(re, ne, ae, ie, le, se, ce) {
  return rotl$1(re + (ne & ie | ae & ~ie) + le + se | 0, ce) + ne | 0;
}
function fnH(re, ne, ae, ie, le, se, ce) {
  return rotl$1(re + (ne ^ ae ^ ie) + le + se | 0, ce) + ne | 0;
}
function fnI(re, ne, ae, ie, le, se, ce) {
  return rotl$1(re + (ae ^ (ne | ~ie)) + le + se | 0, ce) + ne | 0;
}
var md5_js = MD5$3, Buffer$y = safeBufferExports$1.Buffer, Transform$7 = readableBrowserExports$1.Transform, inherits$p = inherits_browserExports;
function throwIfNotStringOrBuffer(re, ne) {
  if (!Buffer$y.isBuffer(re) && typeof re != "string")
    throw new TypeError(ne + " must be a string or a buffer");
}
function HashBase$1(re) {
  Transform$7.call(this), this._block = Buffer$y.allocUnsafe(re), this._blockSize = re, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
}
inherits$p(HashBase$1, Transform$7);
HashBase$1.prototype._transform = function(re, ne, ae) {
  var ie = null;
  try {
    this.update(re, ne);
  } catch (le) {
    ie = le;
  }
  ae(ie);
};
HashBase$1.prototype._flush = function(re) {
  var ne = null;
  try {
    this.push(this.digest());
  } catch (ae) {
    ne = ae;
  }
  re(ne);
};
HashBase$1.prototype.update = function(re, ne) {
  if (throwIfNotStringOrBuffer(re, "Data"), this._finalized) throw new Error("Digest already called");
  Buffer$y.isBuffer(re) || (re = Buffer$y.from(re, ne));
  for (var ae = this._block, ie = 0; this._blockOffset + re.length - ie >= this._blockSize; ) {
    for (var le = this._blockOffset; le < this._blockSize; ) ae[le++] = re[ie++];
    this._update(), this._blockOffset = 0;
  }
  for (; ie < re.length; ) ae[this._blockOffset++] = re[ie++];
  for (var se = 0, ce = re.length * 8; ce > 0; ++se)
    this._length[se] += ce, ce = this._length[se] / 4294967296 | 0, ce > 0 && (this._length[se] -= 4294967296 * ce);
  return this;
};
HashBase$1.prototype._update = function() {
  throw new Error("_update is not implemented");
};
HashBase$1.prototype.digest = function(re) {
  if (this._finalized) throw new Error("Digest already called");
  this._finalized = !0;
  var ne = this._digest();
  re !== void 0 && (ne = ne.toString(re)), this._block.fill(0), this._blockOffset = 0;
  for (var ae = 0; ae < 4; ++ae) this._length[ae] = 0;
  return ne;
};
HashBase$1.prototype._digest = function() {
  throw new Error("_digest is not implemented");
};
var hashBase = HashBase$1, Buffer$x = require$$1$2.Buffer, inherits$o = inherits_browserExports, HashBase = hashBase, ARRAY16 = new Array(16), zl = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  7,
  4,
  13,
  1,
  10,
  6,
  15,
  3,
  12,
  0,
  9,
  5,
  2,
  14,
  11,
  8,
  3,
  10,
  14,
  4,
  9,
  15,
  8,
  1,
  2,
  7,
  0,
  6,
  13,
  11,
  5,
  12,
  1,
  9,
  11,
  10,
  0,
  8,
  12,
  4,
  13,
  3,
  7,
  15,
  14,
  5,
  6,
  2,
  4,
  0,
  5,
  9,
  7,
  12,
  2,
  10,
  14,
  1,
  3,
  8,
  11,
  6,
  15,
  13
], zr = [
  5,
  14,
  7,
  0,
  9,
  2,
  11,
  4,
  13,
  6,
  15,
  8,
  1,
  10,
  3,
  12,
  6,
  11,
  3,
  7,
  0,
  13,
  5,
  10,
  14,
  15,
  8,
  12,
  4,
  9,
  1,
  2,
  15,
  5,
  1,
  3,
  7,
  14,
  6,
  9,
  11,
  8,
  12,
  2,
  10,
  0,
  4,
  13,
  8,
  6,
  4,
  1,
  3,
  11,
  15,
  0,
  5,
  12,
  2,
  13,
  9,
  7,
  10,
  14,
  12,
  15,
  10,
  4,
  1,
  5,
  8,
  7,
  6,
  2,
  13,
  14,
  0,
  3,
  9,
  11
], sl = [
  11,
  14,
  15,
  12,
  5,
  8,
  7,
  9,
  11,
  13,
  14,
  15,
  6,
  7,
  9,
  8,
  7,
  6,
  8,
  13,
  11,
  9,
  7,
  15,
  7,
  12,
  15,
  9,
  11,
  7,
  13,
  12,
  11,
  13,
  6,
  7,
  14,
  9,
  13,
  15,
  14,
  8,
  13,
  6,
  5,
  12,
  7,
  5,
  11,
  12,
  14,
  15,
  14,
  15,
  9,
  8,
  9,
  14,
  5,
  6,
  8,
  6,
  5,
  12,
  9,
  15,
  5,
  11,
  6,
  8,
  13,
  12,
  5,
  12,
  13,
  14,
  11,
  8,
  5,
  6
], sr = [
  8,
  9,
  9,
  11,
  13,
  15,
  15,
  5,
  7,
  7,
  8,
  11,
  14,
  14,
  12,
  6,
  9,
  13,
  15,
  7,
  12,
  8,
  9,
  11,
  7,
  7,
  12,
  7,
  6,
  15,
  13,
  11,
  9,
  7,
  15,
  11,
  8,
  6,
  6,
  14,
  12,
  13,
  5,
  14,
  13,
  13,
  7,
  5,
  15,
  5,
  8,
  11,
  14,
  14,
  6,
  14,
  6,
  9,
  12,
  9,
  12,
  5,
  15,
  8,
  8,
  5,
  12,
  9,
  12,
  5,
  14,
  6,
  8,
  13,
  6,
  5,
  15,
  13,
  11,
  11
], hl = [0, 1518500249, 1859775393, 2400959708, 2840853838], hr = [1352829926, 1548603684, 1836072691, 2053994217, 0];
function RIPEMD160$4() {
  HashBase.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
}
inherits$o(RIPEMD160$4, HashBase);
RIPEMD160$4.prototype._update = function() {
  for (var re = ARRAY16, ne = 0; ne < 16; ++ne) re[ne] = this._block.readInt32LE(ne * 4);
  for (var ae = this._a | 0, ie = this._b | 0, le = this._c | 0, se = this._d | 0, ce = this._e | 0, ue = this._a | 0, de = this._b | 0, me = this._c | 0, fe = this._d | 0, pe = this._e | 0, ge = 0; ge < 80; ge += 1) {
    var be, Se;
    ge < 16 ? (be = fn1(ae, ie, le, se, ce, re[zl[ge]], hl[0], sl[ge]), Se = fn5(ue, de, me, fe, pe, re[zr[ge]], hr[0], sr[ge])) : ge < 32 ? (be = fn2(ae, ie, le, se, ce, re[zl[ge]], hl[1], sl[ge]), Se = fn4(ue, de, me, fe, pe, re[zr[ge]], hr[1], sr[ge])) : ge < 48 ? (be = fn3(ae, ie, le, se, ce, re[zl[ge]], hl[2], sl[ge]), Se = fn3(ue, de, me, fe, pe, re[zr[ge]], hr[2], sr[ge])) : ge < 64 ? (be = fn4(ae, ie, le, se, ce, re[zl[ge]], hl[3], sl[ge]), Se = fn2(ue, de, me, fe, pe, re[zr[ge]], hr[3], sr[ge])) : (be = fn5(ae, ie, le, se, ce, re[zl[ge]], hl[4], sl[ge]), Se = fn1(ue, de, me, fe, pe, re[zr[ge]], hr[4], sr[ge])), ae = ce, ce = se, se = rotl(le, 10), le = ie, ie = be, ue = pe, pe = fe, fe = rotl(me, 10), me = de, de = Se;
  }
  var Pe = this._b + le + fe | 0;
  this._b = this._c + se + pe | 0, this._c = this._d + ce + ue | 0, this._d = this._e + ae + de | 0, this._e = this._a + ie + me | 0, this._a = Pe;
};
RIPEMD160$4.prototype._digest = function() {
  this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
  var re = Buffer$x.alloc ? Buffer$x.alloc(20) : new Buffer$x(20);
  return re.writeInt32LE(this._a, 0), re.writeInt32LE(this._b, 4), re.writeInt32LE(this._c, 8), re.writeInt32LE(this._d, 12), re.writeInt32LE(this._e, 16), re;
};
function rotl(re, ne) {
  return re << ne | re >>> 32 - ne;
}
function fn1(re, ne, ae, ie, le, se, ce, ue) {
  return rotl(re + (ne ^ ae ^ ie) + se + ce | 0, ue) + le | 0;
}
function fn2(re, ne, ae, ie, le, se, ce, ue) {
  return rotl(re + (ne & ae | ~ne & ie) + se + ce | 0, ue) + le | 0;
}
function fn3(re, ne, ae, ie, le, se, ce, ue) {
  return rotl(re + ((ne | ~ae) ^ ie) + se + ce | 0, ue) + le | 0;
}
function fn4(re, ne, ae, ie, le, se, ce, ue) {
  return rotl(re + (ne & ie | ae & ~ie) + se + ce | 0, ue) + le | 0;
}
function fn5(re, ne, ae, ie, le, se, ce, ue) {
  return rotl(re + (ne ^ (ae | ~ie)) + se + ce | 0, ue) + le | 0;
}
var ripemd160 = RIPEMD160$4, sha_js = { exports: {} }, Buffer$w = safeBufferExports$1.Buffer;
function Hash$9(re, ne) {
  this._block = Buffer$w.alloc(re), this._finalSize = ne, this._blockSize = re, this._len = 0;
}
Hash$9.prototype.update = function(re, ne) {
  typeof re == "string" && (ne = ne || "utf8", re = Buffer$w.from(re, ne));
  for (var ae = this._block, ie = this._blockSize, le = re.length, se = this._len, ce = 0; ce < le; ) {
    for (var ue = se % ie, de = Math.min(le - ce, ie - ue), me = 0; me < de; me++)
      ae[ue + me] = re[ce + me];
    se += de, ce += de, se % ie === 0 && this._update(ae);
  }
  return this._len += le, this;
};
Hash$9.prototype.digest = function(re) {
  var ne = this._len % this._blockSize;
  this._block[ne] = 128, this._block.fill(0, ne + 1), ne >= this._finalSize && (this._update(this._block), this._block.fill(0));
  var ae = this._len * 8;
  if (ae <= 4294967295)
    this._block.writeUInt32BE(ae, this._blockSize - 4);
  else {
    var ie = (ae & 4294967295) >>> 0, le = (ae - ie) / 4294967296;
    this._block.writeUInt32BE(le, this._blockSize - 8), this._block.writeUInt32BE(ie, this._blockSize - 4);
  }
  this._update(this._block);
  var se = this._hash();
  return re ? se.toString(re) : se;
};
Hash$9.prototype._update = function() {
  throw new Error("_update must be implemented by subclass");
};
var hash$3 = Hash$9, inherits$n = inherits_browserExports, Hash$8 = hash$3, Buffer$v = safeBufferExports$1.Buffer, K$4 = [
  1518500249,
  1859775393,
  -1894007588,
  -899497514
], W$5 = new Array(80);
function Sha() {
  this.init(), this._w = W$5, Hash$8.call(this, 64, 56);
}
inherits$n(Sha, Hash$8);
Sha.prototype.init = function() {
  return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
};
function rotl5$1(re) {
  return re << 5 | re >>> 27;
}
function rotl30$1(re) {
  return re << 30 | re >>> 2;
}
function ft$1(re, ne, ae, ie) {
  return re === 0 ? ne & ae | ~ne & ie : re === 2 ? ne & ae | ne & ie | ae & ie : ne ^ ae ^ ie;
}
Sha.prototype._update = function(re) {
  for (var ne = this._w, ae = this._a | 0, ie = this._b | 0, le = this._c | 0, se = this._d | 0, ce = this._e | 0, ue = 0; ue < 16; ++ue) ne[ue] = re.readInt32BE(ue * 4);
  for (; ue < 80; ++ue) ne[ue] = ne[ue - 3] ^ ne[ue - 8] ^ ne[ue - 14] ^ ne[ue - 16];
  for (var de = 0; de < 80; ++de) {
    var me = ~~(de / 20), fe = rotl5$1(ae) + ft$1(me, ie, le, se) + ce + ne[de] + K$4[me] | 0;
    ce = se, se = le, le = rotl30$1(ie), ie = ae, ae = fe;
  }
  this._a = ae + this._a | 0, this._b = ie + this._b | 0, this._c = le + this._c | 0, this._d = se + this._d | 0, this._e = ce + this._e | 0;
};
Sha.prototype._hash = function() {
  var re = Buffer$v.allocUnsafe(20);
  return re.writeInt32BE(this._a | 0, 0), re.writeInt32BE(this._b | 0, 4), re.writeInt32BE(this._c | 0, 8), re.writeInt32BE(this._d | 0, 12), re.writeInt32BE(this._e | 0, 16), re;
};
var sha$4 = Sha, inherits$m = inherits_browserExports, Hash$7 = hash$3, Buffer$u = safeBufferExports$1.Buffer, K$3 = [
  1518500249,
  1859775393,
  -1894007588,
  -899497514
], W$4 = new Array(80);
function Sha1() {
  this.init(), this._w = W$4, Hash$7.call(this, 64, 56);
}
inherits$m(Sha1, Hash$7);
Sha1.prototype.init = function() {
  return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
};
function rotl1(re) {
  return re << 1 | re >>> 31;
}
function rotl5(re) {
  return re << 5 | re >>> 27;
}
function rotl30(re) {
  return re << 30 | re >>> 2;
}
function ft(re, ne, ae, ie) {
  return re === 0 ? ne & ae | ~ne & ie : re === 2 ? ne & ae | ne & ie | ae & ie : ne ^ ae ^ ie;
}
Sha1.prototype._update = function(re) {
  for (var ne = this._w, ae = this._a | 0, ie = this._b | 0, le = this._c | 0, se = this._d | 0, ce = this._e | 0, ue = 0; ue < 16; ++ue) ne[ue] = re.readInt32BE(ue * 4);
  for (; ue < 80; ++ue) ne[ue] = rotl1(ne[ue - 3] ^ ne[ue - 8] ^ ne[ue - 14] ^ ne[ue - 16]);
  for (var de = 0; de < 80; ++de) {
    var me = ~~(de / 20), fe = rotl5(ae) + ft(me, ie, le, se) + ce + ne[de] + K$3[me] | 0;
    ce = se, se = le, le = rotl30(ie), ie = ae, ae = fe;
  }
  this._a = ae + this._a | 0, this._b = ie + this._b | 0, this._c = le + this._c | 0, this._d = se + this._d | 0, this._e = ce + this._e | 0;
};
Sha1.prototype._hash = function() {
  var re = Buffer$u.allocUnsafe(20);
  return re.writeInt32BE(this._a | 0, 0), re.writeInt32BE(this._b | 0, 4), re.writeInt32BE(this._c | 0, 8), re.writeInt32BE(this._d | 0, 12), re.writeInt32BE(this._e | 0, 16), re;
};
var sha1 = Sha1, inherits$l = inherits_browserExports, Hash$6 = hash$3, Buffer$t = safeBufferExports$1.Buffer, K$2 = [
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
], W$3 = new Array(64);
function Sha256$1() {
  this.init(), this._w = W$3, Hash$6.call(this, 64, 56);
}
inherits$l(Sha256$1, Hash$6);
Sha256$1.prototype.init = function() {
  return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
};
function ch(re, ne, ae) {
  return ae ^ re & (ne ^ ae);
}
function maj$1(re, ne, ae) {
  return re & ne | ae & (re | ne);
}
function sigma0$1(re) {
  return (re >>> 2 | re << 30) ^ (re >>> 13 | re << 19) ^ (re >>> 22 | re << 10);
}
function sigma1$1(re) {
  return (re >>> 6 | re << 26) ^ (re >>> 11 | re << 21) ^ (re >>> 25 | re << 7);
}
function gamma0(re) {
  return (re >>> 7 | re << 25) ^ (re >>> 18 | re << 14) ^ re >>> 3;
}
function gamma1(re) {
  return (re >>> 17 | re << 15) ^ (re >>> 19 | re << 13) ^ re >>> 10;
}
Sha256$1.prototype._update = function(re) {
  for (var ne = this._w, ae = this._a | 0, ie = this._b | 0, le = this._c | 0, se = this._d | 0, ce = this._e | 0, ue = this._f | 0, de = this._g | 0, me = this._h | 0, fe = 0; fe < 16; ++fe) ne[fe] = re.readInt32BE(fe * 4);
  for (; fe < 64; ++fe) ne[fe] = gamma1(ne[fe - 2]) + ne[fe - 7] + gamma0(ne[fe - 15]) + ne[fe - 16] | 0;
  for (var pe = 0; pe < 64; ++pe) {
    var ge = me + sigma1$1(ce) + ch(ce, ue, de) + K$2[pe] + ne[pe] | 0, be = sigma0$1(ae) + maj$1(ae, ie, le) | 0;
    me = de, de = ue, ue = ce, ce = se + ge | 0, se = le, le = ie, ie = ae, ae = ge + be | 0;
  }
  this._a = ae + this._a | 0, this._b = ie + this._b | 0, this._c = le + this._c | 0, this._d = se + this._d | 0, this._e = ce + this._e | 0, this._f = ue + this._f | 0, this._g = de + this._g | 0, this._h = me + this._h | 0;
};
Sha256$1.prototype._hash = function() {
  var re = Buffer$t.allocUnsafe(32);
  return re.writeInt32BE(this._a, 0), re.writeInt32BE(this._b, 4), re.writeInt32BE(this._c, 8), re.writeInt32BE(this._d, 12), re.writeInt32BE(this._e, 16), re.writeInt32BE(this._f, 20), re.writeInt32BE(this._g, 24), re.writeInt32BE(this._h, 28), re;
};
var sha256$1 = Sha256$1, inherits$k = inherits_browserExports, Sha256 = sha256$1, Hash$5 = hash$3, Buffer$s = safeBufferExports$1.Buffer, W$2 = new Array(64);
function Sha224() {
  this.init(), this._w = W$2, Hash$5.call(this, 64, 56);
}
inherits$k(Sha224, Sha256);
Sha224.prototype.init = function() {
  return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
};
Sha224.prototype._hash = function() {
  var re = Buffer$s.allocUnsafe(28);
  return re.writeInt32BE(this._a, 0), re.writeInt32BE(this._b, 4), re.writeInt32BE(this._c, 8), re.writeInt32BE(this._d, 12), re.writeInt32BE(this._e, 16), re.writeInt32BE(this._f, 20), re.writeInt32BE(this._g, 24), re;
};
var sha224$1 = Sha224, inherits$j = inherits_browserExports, Hash$4 = hash$3, Buffer$r = safeBufferExports$1.Buffer, K$1 = [
  1116352408,
  3609767458,
  1899447441,
  602891725,
  3049323471,
  3964484399,
  3921009573,
  2173295548,
  961987163,
  4081628472,
  1508970993,
  3053834265,
  2453635748,
  2937671579,
  2870763221,
  3664609560,
  3624381080,
  2734883394,
  310598401,
  1164996542,
  607225278,
  1323610764,
  1426881987,
  3590304994,
  1925078388,
  4068182383,
  2162078206,
  991336113,
  2614888103,
  633803317,
  3248222580,
  3479774868,
  3835390401,
  2666613458,
  4022224774,
  944711139,
  264347078,
  2341262773,
  604807628,
  2007800933,
  770255983,
  1495990901,
  1249150122,
  1856431235,
  1555081692,
  3175218132,
  1996064986,
  2198950837,
  2554220882,
  3999719339,
  2821834349,
  766784016,
  2952996808,
  2566594879,
  3210313671,
  3203337956,
  3336571891,
  1034457026,
  3584528711,
  2466948901,
  113926993,
  3758326383,
  338241895,
  168717936,
  666307205,
  1188179964,
  773529912,
  1546045734,
  1294757372,
  1522805485,
  1396182291,
  2643833823,
  1695183700,
  2343527390,
  1986661051,
  1014477480,
  2177026350,
  1206759142,
  2456956037,
  344077627,
  2730485921,
  1290863460,
  2820302411,
  3158454273,
  3259730800,
  3505952657,
  3345764771,
  106217008,
  3516065817,
  3606008344,
  3600352804,
  1432725776,
  4094571909,
  1467031594,
  275423344,
  851169720,
  430227734,
  3100823752,
  506948616,
  1363258195,
  659060556,
  3750685593,
  883997877,
  3785050280,
  958139571,
  3318307427,
  1322822218,
  3812723403,
  1537002063,
  2003034995,
  1747873779,
  3602036899,
  1955562222,
  1575990012,
  2024104815,
  1125592928,
  2227730452,
  2716904306,
  2361852424,
  442776044,
  2428436474,
  593698344,
  2756734187,
  3733110249,
  3204031479,
  2999351573,
  3329325298,
  3815920427,
  3391569614,
  3928383900,
  3515267271,
  566280711,
  3940187606,
  3454069534,
  4118630271,
  4000239992,
  116418474,
  1914138554,
  174292421,
  2731055270,
  289380356,
  3203993006,
  460393269,
  320620315,
  685471733,
  587496836,
  852142971,
  1086792851,
  1017036298,
  365543100,
  1126000580,
  2618297676,
  1288033470,
  3409855158,
  1501505948,
  4234509866,
  1607167915,
  987167468,
  1816402316,
  1246189591
], W$1 = new Array(160);
function Sha512() {
  this.init(), this._w = W$1, Hash$4.call(this, 128, 112);
}
inherits$j(Sha512, Hash$4);
Sha512.prototype.init = function() {
  return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
};
function Ch(re, ne, ae) {
  return ae ^ re & (ne ^ ae);
}
function maj(re, ne, ae) {
  return re & ne | ae & (re | ne);
}
function sigma0(re, ne) {
  return (re >>> 28 | ne << 4) ^ (ne >>> 2 | re << 30) ^ (ne >>> 7 | re << 25);
}
function sigma1(re, ne) {
  return (re >>> 14 | ne << 18) ^ (re >>> 18 | ne << 14) ^ (ne >>> 9 | re << 23);
}
function Gamma0(re, ne) {
  return (re >>> 1 | ne << 31) ^ (re >>> 8 | ne << 24) ^ re >>> 7;
}
function Gamma0l(re, ne) {
  return (re >>> 1 | ne << 31) ^ (re >>> 8 | ne << 24) ^ (re >>> 7 | ne << 25);
}
function Gamma1(re, ne) {
  return (re >>> 19 | ne << 13) ^ (ne >>> 29 | re << 3) ^ re >>> 6;
}
function Gamma1l(re, ne) {
  return (re >>> 19 | ne << 13) ^ (ne >>> 29 | re << 3) ^ (re >>> 6 | ne << 26);
}
function getCarry(re, ne) {
  return re >>> 0 < ne >>> 0 ? 1 : 0;
}
Sha512.prototype._update = function(re) {
  for (var ne = this._w, ae = this._ah | 0, ie = this._bh | 0, le = this._ch | 0, se = this._dh | 0, ce = this._eh | 0, ue = this._fh | 0, de = this._gh | 0, me = this._hh | 0, fe = this._al | 0, pe = this._bl | 0, ge = this._cl | 0, be = this._dl | 0, Se = this._el | 0, Pe = this._fl | 0, Ee = this._gl | 0, Ve = this._hl | 0, Ae = 0; Ae < 32; Ae += 2)
    ne[Ae] = re.readInt32BE(Ae * 4), ne[Ae + 1] = re.readInt32BE(Ae * 4 + 4);
  for (; Ae < 160; Ae += 2) {
    var Oe = ne[Ae - 30], Ne = ne[Ae - 15 * 2 + 1], He = Gamma0(Oe, Ne), Ue = Gamma0l(Ne, Oe);
    Oe = ne[Ae - 2 * 2], Ne = ne[Ae - 2 * 2 + 1];
    var Ze = Gamma1(Oe, Ne), Fe = Gamma1l(Ne, Oe), Ke = ne[Ae - 7 * 2], tt = ne[Ae - 7 * 2 + 1], Re = ne[Ae - 16 * 2], Ce = ne[Ae - 16 * 2 + 1], _e = Ue + tt | 0, he = He + Ke + getCarry(_e, Ue) | 0;
    _e = _e + Fe | 0, he = he + Ze + getCarry(_e, Fe) | 0, _e = _e + Ce | 0, he = he + Re + getCarry(_e, Ce) | 0, ne[Ae] = he, ne[Ae + 1] = _e;
  }
  for (var ve = 0; ve < 160; ve += 2) {
    he = ne[ve], _e = ne[ve + 1];
    var xe = maj(ae, ie, le), $e = maj(fe, pe, ge), Te = sigma0(ae, fe), Ie = sigma0(fe, ae), we = sigma1(ce, Se), ke = sigma1(Se, ce), ye = K$1[ve], Be = K$1[ve + 1], Xe = Ch(ce, ue, de), et = Ch(Se, Pe, Ee), Ye = Ve + ke | 0, De = me + we + getCarry(Ye, Ve) | 0;
    Ye = Ye + et | 0, De = De + Xe + getCarry(Ye, et) | 0, Ye = Ye + Be | 0, De = De + ye + getCarry(Ye, Be) | 0, Ye = Ye + _e | 0, De = De + he + getCarry(Ye, _e) | 0;
    var je = Ie + $e | 0, rt = Te + xe + getCarry(je, Ie) | 0;
    me = de, Ve = Ee, de = ue, Ee = Pe, ue = ce, Pe = Se, Se = be + Ye | 0, ce = se + De + getCarry(Se, be) | 0, se = le, be = ge, le = ie, ge = pe, ie = ae, pe = fe, fe = Ye + je | 0, ae = De + rt + getCarry(fe, Ye) | 0;
  }
  this._al = this._al + fe | 0, this._bl = this._bl + pe | 0, this._cl = this._cl + ge | 0, this._dl = this._dl + be | 0, this._el = this._el + Se | 0, this._fl = this._fl + Pe | 0, this._gl = this._gl + Ee | 0, this._hl = this._hl + Ve | 0, this._ah = this._ah + ae + getCarry(this._al, fe) | 0, this._bh = this._bh + ie + getCarry(this._bl, pe) | 0, this._ch = this._ch + le + getCarry(this._cl, ge) | 0, this._dh = this._dh + se + getCarry(this._dl, be) | 0, this._eh = this._eh + ce + getCarry(this._el, Se) | 0, this._fh = this._fh + ue + getCarry(this._fl, Pe) | 0, this._gh = this._gh + de + getCarry(this._gl, Ee) | 0, this._hh = this._hh + me + getCarry(this._hl, Ve) | 0;
};
Sha512.prototype._hash = function() {
  var re = Buffer$r.allocUnsafe(64);
  function ne(ae, ie, le) {
    re.writeInt32BE(ae, le), re.writeInt32BE(ie, le + 4);
  }
  return ne(this._ah, this._al, 0), ne(this._bh, this._bl, 8), ne(this._ch, this._cl, 16), ne(this._dh, this._dl, 24), ne(this._eh, this._el, 32), ne(this._fh, this._fl, 40), ne(this._gh, this._gl, 48), ne(this._hh, this._hl, 56), re;
};
var sha512$1 = Sha512, inherits$i = inherits_browserExports, SHA512$2 = sha512$1, Hash$3 = hash$3, Buffer$q = safeBufferExports$1.Buffer, W = new Array(160);
function Sha384() {
  this.init(), this._w = W, Hash$3.call(this, 128, 112);
}
inherits$i(Sha384, SHA512$2);
Sha384.prototype.init = function() {
  return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
};
Sha384.prototype._hash = function() {
  var re = Buffer$q.allocUnsafe(48);
  function ne(ae, ie, le) {
    re.writeInt32BE(ae, le), re.writeInt32BE(ie, le + 4);
  }
  return ne(this._ah, this._al, 0), ne(this._bh, this._bl, 8), ne(this._ch, this._cl, 16), ne(this._dh, this._dl, 24), ne(this._eh, this._el, 32), ne(this._fh, this._fl, 40), re;
};
var sha384$1 = Sha384, exports = sha_js.exports = function(ne) {
  ne = ne.toLowerCase();
  var ae = exports[ne];
  if (!ae) throw new Error(ne + " is not supported (we accept pull requests)");
  return new ae();
};
exports.sha = sha$4;
exports.sha1 = sha1;
exports.sha224 = sha224$1;
exports.sha256 = sha256$1;
exports.sha384 = sha384$1;
exports.sha512 = sha512$1;
var sha_jsExports = sha_js.exports, streamBrowserify = Stream, EE = eventsExports.EventEmitter, inherits$h = inherits_browserExports;
inherits$h(Stream, EE);
Stream.Readable = require_stream_readable$1();
Stream.Writable = require_stream_writable$1();
Stream.Duplex = require_stream_duplex$1();
Stream.Transform = _stream_transform$1;
Stream.PassThrough = _stream_passthrough$1;
Stream.finished = endOfStream;
Stream.pipeline = pipeline_1;
Stream.Stream = Stream;
function Stream() {
  EE.call(this);
}
Stream.prototype.pipe = function(re, ne) {
  var ae = this;
  function ie(fe) {
    re.writable && re.write(fe) === !1 && ae.pause && ae.pause();
  }
  ae.on("data", ie);
  function le() {
    ae.readable && ae.resume && ae.resume();
  }
  re.on("drain", le), !re._isStdio && (!ne || ne.end !== !1) && (ae.on("end", ce), ae.on("close", ue));
  var se = !1;
  function ce() {
    se || (se = !0, re.end());
  }
  function ue() {
    se || (se = !0, typeof re.destroy == "function" && re.destroy());
  }
  function de(fe) {
    if (me(), EE.listenerCount(this, "error") === 0)
      throw fe;
  }
  ae.on("error", de), re.on("error", de);
  function me() {
    ae.removeListener("data", ie), re.removeListener("drain", le), ae.removeListener("end", ce), ae.removeListener("close", ue), ae.removeListener("error", de), re.removeListener("error", de), ae.removeListener("end", me), ae.removeListener("close", me), re.removeListener("close", me);
  }
  return ae.on("end", me), ae.on("close", me), re.on("close", me), re.emit("pipe", ae), re;
};
var Buffer$p = safeBufferExports$1.Buffer, Transform$6 = streamBrowserify.Transform, StringDecoder = string_decoder.StringDecoder, inherits$g = inherits_browserExports;
function CipherBase$1(re) {
  Transform$6.call(this), this.hashMode = typeof re == "string", this.hashMode ? this[re] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
}
inherits$g(CipherBase$1, Transform$6);
CipherBase$1.prototype.update = function(re, ne, ae) {
  typeof re == "string" && (re = Buffer$p.from(re, ne));
  var ie = this._update(re);
  return this.hashMode ? this : (ae && (ie = this._toString(ie, ae)), ie);
};
CipherBase$1.prototype.setAutoPadding = function() {
};
CipherBase$1.prototype.getAuthTag = function() {
  throw new Error("trying to get auth tag in unsupported state");
};
CipherBase$1.prototype.setAuthTag = function() {
  throw new Error("trying to set auth tag in unsupported state");
};
CipherBase$1.prototype.setAAD = function() {
  throw new Error("trying to set aad in unsupported state");
};
CipherBase$1.prototype._transform = function(re, ne, ae) {
  var ie;
  try {
    this.hashMode ? this._update(re) : this.push(this._update(re));
  } catch (le) {
    ie = le;
  } finally {
    ae(ie);
  }
};
CipherBase$1.prototype._flush = function(re) {
  var ne;
  try {
    this.push(this.__final());
  } catch (ae) {
    ne = ae;
  }
  re(ne);
};
CipherBase$1.prototype._finalOrDigest = function(re) {
  var ne = this.__final() || Buffer$p.alloc(0);
  return re && (ne = this._toString(ne, re, !0)), ne;
};
CipherBase$1.prototype._toString = function(re, ne, ae) {
  if (this._decoder || (this._decoder = new StringDecoder(ne), this._encoding = ne), this._encoding !== ne) throw new Error("can't switch encodings");
  var ie = this._decoder.write(re);
  return ae && (ie += this._decoder.end()), ie;
};
var cipherBase = CipherBase$1, inherits$f = inherits_browserExports, MD5$2 = md5_js, RIPEMD160$3 = ripemd160, sha$3 = sha_jsExports, Base$5 = cipherBase;
function Hash$2(re) {
  Base$5.call(this, "digest"), this._hash = re;
}
inherits$f(Hash$2, Base$5);
Hash$2.prototype._update = function(re) {
  this._hash.update(re);
};
Hash$2.prototype._final = function() {
  return this._hash.digest();
};
var browser$9 = function(ne) {
  return ne = ne.toLowerCase(), ne === "md5" ? new MD5$2() : ne === "rmd160" || ne === "ripemd160" ? new RIPEMD160$3() : new Hash$2(sha$3(ne));
}, inherits$e = inherits_browserExports, Buffer$o = safeBufferExports$1.Buffer, Base$4 = cipherBase, ZEROS$2 = Buffer$o.alloc(128), blocksize = 64;
function Hmac$3(re, ne) {
  Base$4.call(this, "digest"), typeof ne == "string" && (ne = Buffer$o.from(ne)), this._alg = re, this._key = ne, ne.length > blocksize ? ne = re(ne) : ne.length < blocksize && (ne = Buffer$o.concat([ne, ZEROS$2], blocksize));
  for (var ae = this._ipad = Buffer$o.allocUnsafe(blocksize), ie = this._opad = Buffer$o.allocUnsafe(blocksize), le = 0; le < blocksize; le++)
    ae[le] = ne[le] ^ 54, ie[le] = ne[le] ^ 92;
  this._hash = [ae];
}
inherits$e(Hmac$3, Base$4);
Hmac$3.prototype._update = function(re) {
  this._hash.push(re);
};
Hmac$3.prototype._final = function() {
  var re = this._alg(Buffer$o.concat(this._hash));
  return this._alg(Buffer$o.concat([this._opad, re]));
};
var legacy = Hmac$3, MD5$1 = md5_js, md5$2 = function(re) {
  return new MD5$1().update(re).digest();
}, inherits$d = inherits_browserExports, Legacy = legacy, Base$3 = cipherBase, Buffer$n = safeBufferExports$1.Buffer, md5$1 = md5$2, RIPEMD160$2 = ripemd160, sha$2 = sha_jsExports, ZEROS$1 = Buffer$n.alloc(128);
function Hmac$2(re, ne) {
  Base$3.call(this, "digest"), typeof ne == "string" && (ne = Buffer$n.from(ne));
  var ae = re === "sha512" || re === "sha384" ? 128 : 64;
  if (this._alg = re, this._key = ne, ne.length > ae) {
    var ie = re === "rmd160" ? new RIPEMD160$2() : sha$2(re);
    ne = ie.update(ne).digest();
  } else ne.length < ae && (ne = Buffer$n.concat([ne, ZEROS$1], ae));
  for (var le = this._ipad = Buffer$n.allocUnsafe(ae), se = this._opad = Buffer$n.allocUnsafe(ae), ce = 0; ce < ae; ce++)
    le[ce] = ne[ce] ^ 54, se[ce] = ne[ce] ^ 92;
  this._hash = re === "rmd160" ? new RIPEMD160$2() : sha$2(re), this._hash.update(le);
}
inherits$d(Hmac$2, Base$3);
Hmac$2.prototype._update = function(re) {
  this._hash.update(re);
};
Hmac$2.prototype._final = function() {
  var re = this._hash.digest(), ne = this._alg === "rmd160" ? new RIPEMD160$2() : sha$2(this._alg);
  return ne.update(this._opad).update(re).digest();
};
var browser$8 = function(ne, ae) {
  return ne = ne.toLowerCase(), ne === "rmd160" || ne === "ripemd160" ? new Hmac$2("rmd160", ae) : ne === "md5" ? new Legacy(md5$1, ae) : new Hmac$2(ne, ae);
};
const sha224WithRSAEncryption = {
  sign: "rsa",
  hash: "sha224",
  id: "302d300d06096086480165030402040500041c"
}, sha256WithRSAEncryption = {
  sign: "rsa",
  hash: "sha256",
  id: "3031300d060960864801650304020105000420"
}, sha384WithRSAEncryption = {
  sign: "rsa",
  hash: "sha384",
  id: "3041300d060960864801650304020205000430"
}, sha512WithRSAEncryption = {
  sign: "rsa",
  hash: "sha512",
  id: "3051300d060960864801650304020305000440"
}, sha256 = {
  sign: "ecdsa",
  hash: "sha256",
  id: ""
}, sha224 = {
  sign: "ecdsa",
  hash: "sha224",
  id: ""
}, sha384 = {
  sign: "ecdsa",
  hash: "sha384",
  id: ""
}, sha512 = {
  sign: "ecdsa",
  hash: "sha512",
  id: ""
}, DSA = {
  sign: "dsa",
  hash: "sha1",
  id: ""
}, ripemd160WithRSA = {
  sign: "rsa",
  hash: "rmd160",
  id: "3021300906052b2403020105000414"
}, md5WithRSAEncryption = {
  sign: "rsa",
  hash: "md5",
  id: "3020300c06082a864886f70d020505000410"
}, require$$6 = {
  sha224WithRSAEncryption,
  "RSA-SHA224": {
    sign: "ecdsa/rsa",
    hash: "sha224",
    id: "302d300d06096086480165030402040500041c"
  },
  sha256WithRSAEncryption,
  "RSA-SHA256": {
    sign: "ecdsa/rsa",
    hash: "sha256",
    id: "3031300d060960864801650304020105000420"
  },
  sha384WithRSAEncryption,
  "RSA-SHA384": {
    sign: "ecdsa/rsa",
    hash: "sha384",
    id: "3041300d060960864801650304020205000430"
  },
  sha512WithRSAEncryption,
  "RSA-SHA512": {
    sign: "ecdsa/rsa",
    hash: "sha512",
    id: "3051300d060960864801650304020305000440"
  },
  "RSA-SHA1": {
    sign: "rsa",
    hash: "sha1",
    id: "3021300906052b0e03021a05000414"
  },
  "ecdsa-with-SHA1": {
    sign: "ecdsa",
    hash: "sha1",
    id: ""
  },
  sha256,
  sha224,
  sha384,
  sha512,
  "DSA-SHA": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  "DSA-SHA1": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  DSA,
  "DSA-WITH-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-WITH-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-WITH-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-WITH-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-RIPEMD160": {
    sign: "dsa",
    hash: "rmd160",
    id: ""
  },
  ripemd160WithRSA,
  "RSA-RIPEMD160": {
    sign: "rsa",
    hash: "rmd160",
    id: "3021300906052b2403020105000414"
  },
  md5WithRSAEncryption,
  "RSA-MD5": {
    sign: "rsa",
    hash: "md5",
    id: "3020300c06082a864886f70d020505000410"
  }
};
var algos = require$$6, browser$7 = {}, MAX_ALLOC = Math.pow(2, 30) - 1, precondition = function(re, ne) {
  if (typeof re != "number")
    throw new TypeError("Iterations not a number");
  if (re < 0)
    throw new TypeError("Bad iterations");
  if (typeof ne != "number")
    throw new TypeError("Key length not a number");
  if (ne < 0 || ne > MAX_ALLOC || ne !== ne)
    throw new TypeError("Bad key length");
}, defaultEncoding$2;
if (commonjsGlobal.process && commonjsGlobal.process.browser)
  defaultEncoding$2 = "utf-8";
else if (commonjsGlobal.process && commonjsGlobal.process.version) {
  var pVersionMajor = parseInt(process$1.version.split(".")[0].slice(1), 10);
  defaultEncoding$2 = pVersionMajor >= 6 ? "utf-8" : "binary";
} else
  defaultEncoding$2 = "utf-8";
var defaultEncoding_1 = defaultEncoding$2, Buffer$m = safeBufferExports$1.Buffer, toBuffer$2 = function(re, ne, ae) {
  if (Buffer$m.isBuffer(re))
    return re;
  if (typeof re == "string")
    return Buffer$m.from(re, ne);
  if (ArrayBuffer.isView(re))
    return Buffer$m.from(re.buffer);
  throw new TypeError(ae + " must be a string, a Buffer, a typed array or a DataView");
}, md5 = md5$2, RIPEMD160$1 = ripemd160, sha$1 = sha_jsExports, Buffer$l = safeBufferExports$1.Buffer, checkParameters$1 = precondition, defaultEncoding$1 = defaultEncoding_1, toBuffer$1 = toBuffer$2, ZEROS = Buffer$l.alloc(128), sizes = {
  md5: 16,
  sha1: 20,
  sha224: 28,
  sha256: 32,
  sha384: 48,
  sha512: 64,
  rmd160: 20,
  ripemd160: 20
};
function Hmac$1(re, ne, ae) {
  var ie = getDigest(re), le = re === "sha512" || re === "sha384" ? 128 : 64;
  ne.length > le ? ne = ie(ne) : ne.length < le && (ne = Buffer$l.concat([ne, ZEROS], le));
  for (var se = Buffer$l.allocUnsafe(le + sizes[re]), ce = Buffer$l.allocUnsafe(le + sizes[re]), ue = 0; ue < le; ue++)
    se[ue] = ne[ue] ^ 54, ce[ue] = ne[ue] ^ 92;
  var de = Buffer$l.allocUnsafe(le + ae + 4);
  se.copy(de, 0, 0, le), this.ipad1 = de, this.ipad2 = se, this.opad = ce, this.alg = re, this.blocksize = le, this.hash = ie, this.size = sizes[re];
}
Hmac$1.prototype.run = function(re, ne) {
  re.copy(ne, this.blocksize);
  var ae = this.hash(ne);
  return ae.copy(this.opad, this.blocksize), this.hash(this.opad);
};
function getDigest(re) {
  function ne(ie) {
    return sha$1(re).update(ie).digest();
  }
  function ae(ie) {
    return new RIPEMD160$1().update(ie).digest();
  }
  return re === "rmd160" || re === "ripemd160" ? ae : re === "md5" ? md5 : ne;
}
function pbkdf2(re, ne, ae, ie, le) {
  checkParameters$1(ae, ie), re = toBuffer$1(re, defaultEncoding$1, "Password"), ne = toBuffer$1(ne, defaultEncoding$1, "Salt"), le = le || "sha1";
  var se = new Hmac$1(le, re, ne.length), ce = Buffer$l.allocUnsafe(ie), ue = Buffer$l.allocUnsafe(ne.length + 4);
  ne.copy(ue, 0, 0, ne.length);
  for (var de = 0, me = sizes[le], fe = Math.ceil(ie / me), pe = 1; pe <= fe; pe++) {
    ue.writeUInt32BE(pe, ne.length);
    for (var ge = se.run(ue, se.ipad1), be = ge, Se = 1; Se < ae; Se++) {
      be = se.run(be, se.ipad2);
      for (var Pe = 0; Pe < me; Pe++) ge[Pe] ^= be[Pe];
    }
    ge.copy(ce, de), de += me;
  }
  return ce;
}
var syncBrowser = pbkdf2, Buffer$k = safeBufferExports$1.Buffer, checkParameters = precondition, defaultEncoding = defaultEncoding_1, sync = syncBrowser, toBuffer = toBuffer$2, ZERO_BUF, subtle = commonjsGlobal.crypto && commonjsGlobal.crypto.subtle, toBrowser = {
  sha: "SHA-1",
  "sha-1": "SHA-1",
  sha1: "SHA-1",
  sha256: "SHA-256",
  "sha-256": "SHA-256",
  sha384: "SHA-384",
  "sha-384": "SHA-384",
  "sha-512": "SHA-512",
  sha512: "SHA-512"
}, checks = [];
function checkNative(re) {
  if (commonjsGlobal.process && !commonjsGlobal.process.browser || !subtle || !subtle.importKey || !subtle.deriveBits)
    return Promise.resolve(!1);
  if (checks[re] !== void 0)
    return checks[re];
  ZERO_BUF = ZERO_BUF || Buffer$k.alloc(8);
  var ne = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, re).then(function() {
    return !0;
  }).catch(function() {
    return !1;
  });
  return checks[re] = ne, ne;
}
var nextTick$1;
function getNextTick() {
  return nextTick$1 || (commonjsGlobal.process && commonjsGlobal.process.nextTick ? nextTick$1 = commonjsGlobal.process.nextTick : commonjsGlobal.queueMicrotask ? nextTick$1 = commonjsGlobal.queueMicrotask : commonjsGlobal.setImmediate ? nextTick$1 = commonjsGlobal.setImmediate : nextTick$1 = commonjsGlobal.setTimeout, nextTick$1);
}
function browserPbkdf2(re, ne, ae, ie, le) {
  return subtle.importKey(
    "raw",
    re,
    { name: "PBKDF2" },
    !1,
    ["deriveBits"]
  ).then(function(se) {
    return subtle.deriveBits({
      name: "PBKDF2",
      salt: ne,
      iterations: ae,
      hash: {
        name: le
      }
    }, se, ie << 3);
  }).then(function(se) {
    return Buffer$k.from(se);
  });
}
function resolvePromise(re, ne) {
  re.then(function(ae) {
    getNextTick()(function() {
      ne(null, ae);
    });
  }, function(ae) {
    getNextTick()(function() {
      ne(ae);
    });
  });
}
var async = function(re, ne, ae, ie, le, se) {
  typeof le == "function" && (se = le, le = void 0), le = le || "sha1";
  var ce = toBrowser[le.toLowerCase()];
  if (!ce || typeof commonjsGlobal.Promise != "function") {
    getNextTick()(function() {
      var ue;
      try {
        ue = sync(re, ne, ae, ie, le);
      } catch (de) {
        return se(de);
      }
      se(null, ue);
    });
    return;
  }
  if (checkParameters(ae, ie), re = toBuffer(re, defaultEncoding, "Password"), ne = toBuffer(ne, defaultEncoding, "Salt"), typeof se != "function") throw new Error("No callback provided to pbkdf2");
  resolvePromise(checkNative(ce).then(function(ue) {
    return ue ? browserPbkdf2(re, ne, ae, ie, ce) : sync(re, ne, ae, ie, le);
  }), se);
};
browser$7.pbkdf2 = async;
browser$7.pbkdf2Sync = syncBrowser;
var browser$6 = {}, des$2 = {}, utils$n = {};
utils$n.readUInt32BE = function(ne, ae) {
  var ie = ne[0 + ae] << 24 | ne[1 + ae] << 16 | ne[2 + ae] << 8 | ne[3 + ae];
  return ie >>> 0;
};
utils$n.writeUInt32BE = function(ne, ae, ie) {
  ne[0 + ie] = ae >>> 24, ne[1 + ie] = ae >>> 16 & 255, ne[2 + ie] = ae >>> 8 & 255, ne[3 + ie] = ae & 255;
};
utils$n.ip = function(ne, ae, ie, le) {
  for (var se = 0, ce = 0, ue = 6; ue >= 0; ue -= 2) {
    for (var de = 0; de <= 24; de += 8)
      se <<= 1, se |= ae >>> de + ue & 1;
    for (var de = 0; de <= 24; de += 8)
      se <<= 1, se |= ne >>> de + ue & 1;
  }
  for (var ue = 6; ue >= 0; ue -= 2) {
    for (var de = 1; de <= 25; de += 8)
      ce <<= 1, ce |= ae >>> de + ue & 1;
    for (var de = 1; de <= 25; de += 8)
      ce <<= 1, ce |= ne >>> de + ue & 1;
  }
  ie[le + 0] = se >>> 0, ie[le + 1] = ce >>> 0;
};
utils$n.rip = function(ne, ae, ie, le) {
  for (var se = 0, ce = 0, ue = 0; ue < 4; ue++)
    for (var de = 24; de >= 0; de -= 8)
      se <<= 1, se |= ae >>> de + ue & 1, se <<= 1, se |= ne >>> de + ue & 1;
  for (var ue = 4; ue < 8; ue++)
    for (var de = 24; de >= 0; de -= 8)
      ce <<= 1, ce |= ae >>> de + ue & 1, ce <<= 1, ce |= ne >>> de + ue & 1;
  ie[le + 0] = se >>> 0, ie[le + 1] = ce >>> 0;
};
utils$n.pc1 = function(ne, ae, ie, le) {
  for (var se = 0, ce = 0, ue = 7; ue >= 5; ue--) {
    for (var de = 0; de <= 24; de += 8)
      se <<= 1, se |= ae >> de + ue & 1;
    for (var de = 0; de <= 24; de += 8)
      se <<= 1, se |= ne >> de + ue & 1;
  }
  for (var de = 0; de <= 24; de += 8)
    se <<= 1, se |= ae >> de + ue & 1;
  for (var ue = 1; ue <= 3; ue++) {
    for (var de = 0; de <= 24; de += 8)
      ce <<= 1, ce |= ae >> de + ue & 1;
    for (var de = 0; de <= 24; de += 8)
      ce <<= 1, ce |= ne >> de + ue & 1;
  }
  for (var de = 0; de <= 24; de += 8)
    ce <<= 1, ce |= ne >> de + ue & 1;
  ie[le + 0] = se >>> 0, ie[le + 1] = ce >>> 0;
};
utils$n.r28shl = function(ne, ae) {
  return ne << ae & 268435455 | ne >>> 28 - ae;
};
var pc2table = [
  // inL => outL
  14,
  11,
  17,
  4,
  27,
  23,
  25,
  0,
  13,
  22,
  7,
  18,
  5,
  9,
  16,
  24,
  2,
  20,
  12,
  21,
  1,
  8,
  15,
  26,
  // inR => outR
  15,
  4,
  25,
  19,
  9,
  1,
  26,
  16,
  5,
  11,
  23,
  8,
  12,
  7,
  17,
  0,
  22,
  3,
  10,
  14,
  6,
  20,
  27,
  24
];
utils$n.pc2 = function(ne, ae, ie, le) {
  for (var se = 0, ce = 0, ue = pc2table.length >>> 1, de = 0; de < ue; de++)
    se <<= 1, se |= ne >>> pc2table[de] & 1;
  for (var de = ue; de < pc2table.length; de++)
    ce <<= 1, ce |= ae >>> pc2table[de] & 1;
  ie[le + 0] = se >>> 0, ie[le + 1] = ce >>> 0;
};
utils$n.expand = function(ne, ae, ie) {
  var le = 0, se = 0;
  le = (ne & 1) << 5 | ne >>> 27;
  for (var ce = 23; ce >= 15; ce -= 4)
    le <<= 6, le |= ne >>> ce & 63;
  for (var ce = 11; ce >= 3; ce -= 4)
    se |= ne >>> ce & 63, se <<= 6;
  se |= (ne & 31) << 1 | ne >>> 31, ae[ie + 0] = le >>> 0, ae[ie + 1] = se >>> 0;
};
var sTable = [
  14,
  0,
  4,
  15,
  13,
  7,
  1,
  4,
  2,
  14,
  15,
  2,
  11,
  13,
  8,
  1,
  3,
  10,
  10,
  6,
  6,
  12,
  12,
  11,
  5,
  9,
  9,
  5,
  0,
  3,
  7,
  8,
  4,
  15,
  1,
  12,
  14,
  8,
  8,
  2,
  13,
  4,
  6,
  9,
  2,
  1,
  11,
  7,
  15,
  5,
  12,
  11,
  9,
  3,
  7,
  14,
  3,
  10,
  10,
  0,
  5,
  6,
  0,
  13,
  15,
  3,
  1,
  13,
  8,
  4,
  14,
  7,
  6,
  15,
  11,
  2,
  3,
  8,
  4,
  14,
  9,
  12,
  7,
  0,
  2,
  1,
  13,
  10,
  12,
  6,
  0,
  9,
  5,
  11,
  10,
  5,
  0,
  13,
  14,
  8,
  7,
  10,
  11,
  1,
  10,
  3,
  4,
  15,
  13,
  4,
  1,
  2,
  5,
  11,
  8,
  6,
  12,
  7,
  6,
  12,
  9,
  0,
  3,
  5,
  2,
  14,
  15,
  9,
  10,
  13,
  0,
  7,
  9,
  0,
  14,
  9,
  6,
  3,
  3,
  4,
  15,
  6,
  5,
  10,
  1,
  2,
  13,
  8,
  12,
  5,
  7,
  14,
  11,
  12,
  4,
  11,
  2,
  15,
  8,
  1,
  13,
  1,
  6,
  10,
  4,
  13,
  9,
  0,
  8,
  6,
  15,
  9,
  3,
  8,
  0,
  7,
  11,
  4,
  1,
  15,
  2,
  14,
  12,
  3,
  5,
  11,
  10,
  5,
  14,
  2,
  7,
  12,
  7,
  13,
  13,
  8,
  14,
  11,
  3,
  5,
  0,
  6,
  6,
  15,
  9,
  0,
  10,
  3,
  1,
  4,
  2,
  7,
  8,
  2,
  5,
  12,
  11,
  1,
  12,
  10,
  4,
  14,
  15,
  9,
  10,
  3,
  6,
  15,
  9,
  0,
  0,
  6,
  12,
  10,
  11,
  1,
  7,
  13,
  13,
  8,
  15,
  9,
  1,
  4,
  3,
  5,
  14,
  11,
  5,
  12,
  2,
  7,
  8,
  2,
  4,
  14,
  2,
  14,
  12,
  11,
  4,
  2,
  1,
  12,
  7,
  4,
  10,
  7,
  11,
  13,
  6,
  1,
  8,
  5,
  5,
  0,
  3,
  15,
  15,
  10,
  13,
  3,
  0,
  9,
  14,
  8,
  9,
  6,
  4,
  11,
  2,
  8,
  1,
  12,
  11,
  7,
  10,
  1,
  13,
  14,
  7,
  2,
  8,
  13,
  15,
  6,
  9,
  15,
  12,
  0,
  5,
  9,
  6,
  10,
  3,
  4,
  0,
  5,
  14,
  3,
  12,
  10,
  1,
  15,
  10,
  4,
  15,
  2,
  9,
  7,
  2,
  12,
  6,
  9,
  8,
  5,
  0,
  6,
  13,
  1,
  3,
  13,
  4,
  14,
  14,
  0,
  7,
  11,
  5,
  3,
  11,
  8,
  9,
  4,
  14,
  3,
  15,
  2,
  5,
  12,
  2,
  9,
  8,
  5,
  12,
  15,
  3,
  10,
  7,
  11,
  0,
  14,
  4,
  1,
  10,
  7,
  1,
  6,
  13,
  0,
  11,
  8,
  6,
  13,
  4,
  13,
  11,
  0,
  2,
  11,
  14,
  7,
  15,
  4,
  0,
  9,
  8,
  1,
  13,
  10,
  3,
  14,
  12,
  3,
  9,
  5,
  7,
  12,
  5,
  2,
  10,
  15,
  6,
  8,
  1,
  6,
  1,
  6,
  4,
  11,
  11,
  13,
  13,
  8,
  12,
  1,
  3,
  4,
  7,
  10,
  14,
  7,
  10,
  9,
  15,
  5,
  6,
  0,
  8,
  15,
  0,
  14,
  5,
  2,
  9,
  3,
  2,
  12,
  13,
  1,
  2,
  15,
  8,
  13,
  4,
  8,
  6,
  10,
  15,
  3,
  11,
  7,
  1,
  4,
  10,
  12,
  9,
  5,
  3,
  6,
  14,
  11,
  5,
  0,
  0,
  14,
  12,
  9,
  7,
  2,
  7,
  2,
  11,
  1,
  4,
  14,
  1,
  7,
  9,
  4,
  12,
  10,
  14,
  8,
  2,
  13,
  0,
  15,
  6,
  12,
  10,
  9,
  13,
  0,
  15,
  3,
  3,
  5,
  5,
  6,
  8,
  11
];
utils$n.substitute = function(ne, ae) {
  for (var ie = 0, le = 0; le < 4; le++) {
    var se = ne >>> 18 - le * 6 & 63, ce = sTable[le * 64 + se];
    ie <<= 4, ie |= ce;
  }
  for (var le = 0; le < 4; le++) {
    var se = ae >>> 18 - le * 6 & 63, ce = sTable[4 * 64 + le * 64 + se];
    ie <<= 4, ie |= ce;
  }
  return ie >>> 0;
};
var permuteTable = [
  16,
  25,
  12,
  11,
  3,
  20,
  4,
  15,
  31,
  17,
  9,
  6,
  27,
  14,
  1,
  22,
  30,
  24,
  8,
  18,
  0,
  5,
  29,
  23,
  13,
  19,
  2,
  26,
  10,
  21,
  28,
  7
];
utils$n.permute = function(ne) {
  for (var ae = 0, ie = 0; ie < permuteTable.length; ie++)
    ae <<= 1, ae |= ne >>> permuteTable[ie] & 1;
  return ae >>> 0;
};
utils$n.padSplit = function(ne, ae, ie) {
  for (var le = ne.toString(2); le.length < ae; )
    le = "0" + le;
  for (var se = [], ce = 0; ce < ae; ce += ie)
    se.push(le.slice(ce, ce + ie));
  return se.join(" ");
};
var minimalisticAssert = assert$i;
function assert$i(re, ne) {
  if (!re)
    throw new Error(ne || "Assertion failed");
}
assert$i.equal = function(ne, ae, ie) {
  if (ne != ae)
    throw new Error(ie || "Assertion failed: " + ne + " != " + ae);
};
var assert$h = minimalisticAssert;
function Cipher$3(re) {
  this.options = re, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0, this.padding = re.padding !== !1;
}
var cipher = Cipher$3;
Cipher$3.prototype._init = function() {
};
Cipher$3.prototype.update = function(ne) {
  return ne.length === 0 ? [] : this.type === "decrypt" ? this._updateDecrypt(ne) : this._updateEncrypt(ne);
};
Cipher$3.prototype._buffer = function(ne, ae) {
  for (var ie = Math.min(this.buffer.length - this.bufferOff, ne.length - ae), le = 0; le < ie; le++)
    this.buffer[this.bufferOff + le] = ne[ae + le];
  return this.bufferOff += ie, ie;
};
Cipher$3.prototype._flushBuffer = function(ne, ae) {
  return this._update(this.buffer, 0, ne, ae), this.bufferOff = 0, this.blockSize;
};
Cipher$3.prototype._updateEncrypt = function(ne) {
  var ae = 0, ie = 0, le = (this.bufferOff + ne.length) / this.blockSize | 0, se = new Array(le * this.blockSize);
  this.bufferOff !== 0 && (ae += this._buffer(ne, ae), this.bufferOff === this.buffer.length && (ie += this._flushBuffer(se, ie)));
  for (var ce = ne.length - (ne.length - ae) % this.blockSize; ae < ce; ae += this.blockSize)
    this._update(ne, ae, se, ie), ie += this.blockSize;
  for (; ae < ne.length; ae++, this.bufferOff++)
    this.buffer[this.bufferOff] = ne[ae];
  return se;
};
Cipher$3.prototype._updateDecrypt = function(ne) {
  for (var ae = 0, ie = 0, le = Math.ceil((this.bufferOff + ne.length) / this.blockSize) - 1, se = new Array(le * this.blockSize); le > 0; le--)
    ae += this._buffer(ne, ae), ie += this._flushBuffer(se, ie);
  return ae += this._buffer(ne, ae), se;
};
Cipher$3.prototype.final = function(ne) {
  var ae;
  ne && (ae = this.update(ne));
  var ie;
  return this.type === "encrypt" ? ie = this._finalEncrypt() : ie = this._finalDecrypt(), ae ? ae.concat(ie) : ie;
};
Cipher$3.prototype._pad = function(ne, ae) {
  if (ae === 0)
    return !1;
  for (; ae < ne.length; )
    ne[ae++] = 0;
  return !0;
};
Cipher$3.prototype._finalEncrypt = function() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];
  var ne = new Array(this.blockSize);
  return this._update(this.buffer, 0, ne, 0), ne;
};
Cipher$3.prototype._unpad = function(ne) {
  return ne;
};
Cipher$3.prototype._finalDecrypt = function() {
  assert$h.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
  var ne = new Array(this.blockSize);
  return this._flushBuffer(ne, 0), this._unpad(ne);
};
var assert$g = minimalisticAssert, inherits$c = inherits_browserExports, utils$m = utils$n, Cipher$2 = cipher;
function DESState() {
  this.tmp = new Array(2), this.keys = null;
}
function DES$3(re) {
  Cipher$2.call(this, re);
  var ne = new DESState();
  this._desState = ne, this.deriveKeys(ne, re.key);
}
inherits$c(DES$3, Cipher$2);
var des$1 = DES$3;
DES$3.create = function(ne) {
  return new DES$3(ne);
};
var shiftTable = [
  1,
  1,
  2,
  2,
  2,
  2,
  2,
  2,
  1,
  2,
  2,
  2,
  2,
  2,
  2,
  1
];
DES$3.prototype.deriveKeys = function(ne, ae) {
  ne.keys = new Array(16 * 2), assert$g.equal(ae.length, this.blockSize, "Invalid key length");
  var ie = utils$m.readUInt32BE(ae, 0), le = utils$m.readUInt32BE(ae, 4);
  utils$m.pc1(ie, le, ne.tmp, 0), ie = ne.tmp[0], le = ne.tmp[1];
  for (var se = 0; se < ne.keys.length; se += 2) {
    var ce = shiftTable[se >>> 1];
    ie = utils$m.r28shl(ie, ce), le = utils$m.r28shl(le, ce), utils$m.pc2(ie, le, ne.keys, se);
  }
};
DES$3.prototype._update = function(ne, ae, ie, le) {
  var se = this._desState, ce = utils$m.readUInt32BE(ne, ae), ue = utils$m.readUInt32BE(ne, ae + 4);
  utils$m.ip(ce, ue, se.tmp, 0), ce = se.tmp[0], ue = se.tmp[1], this.type === "encrypt" ? this._encrypt(se, ce, ue, se.tmp, 0) : this._decrypt(se, ce, ue, se.tmp, 0), ce = se.tmp[0], ue = se.tmp[1], utils$m.writeUInt32BE(ie, ce, le), utils$m.writeUInt32BE(ie, ue, le + 4);
};
DES$3.prototype._pad = function(ne, ae) {
  if (this.padding === !1)
    return !1;
  for (var ie = ne.length - ae, le = ae; le < ne.length; le++)
    ne[le] = ie;
  return !0;
};
DES$3.prototype._unpad = function(ne) {
  if (this.padding === !1)
    return ne;
  for (var ae = ne[ne.length - 1], ie = ne.length - ae; ie < ne.length; ie++)
    assert$g.equal(ne[ie], ae);
  return ne.slice(0, ne.length - ae);
};
DES$3.prototype._encrypt = function(ne, ae, ie, le, se) {
  for (var ce = ae, ue = ie, de = 0; de < ne.keys.length; de += 2) {
    var me = ne.keys[de], fe = ne.keys[de + 1];
    utils$m.expand(ue, ne.tmp, 0), me ^= ne.tmp[0], fe ^= ne.tmp[1];
    var pe = utils$m.substitute(me, fe), ge = utils$m.permute(pe), be = ue;
    ue = (ce ^ ge) >>> 0, ce = be;
  }
  utils$m.rip(ue, ce, le, se);
};
DES$3.prototype._decrypt = function(ne, ae, ie, le, se) {
  for (var ce = ie, ue = ae, de = ne.keys.length - 2; de >= 0; de -= 2) {
    var me = ne.keys[de], fe = ne.keys[de + 1];
    utils$m.expand(ce, ne.tmp, 0), me ^= ne.tmp[0], fe ^= ne.tmp[1];
    var pe = utils$m.substitute(me, fe), ge = utils$m.permute(pe), be = ce;
    ce = (ue ^ ge) >>> 0, ue = be;
  }
  utils$m.rip(ce, ue, le, se);
};
var cbc$1 = {}, assert$f = minimalisticAssert, inherits$b = inherits_browserExports, proto = {};
function CBCState(re) {
  assert$f.equal(re.length, 8, "Invalid IV length"), this.iv = new Array(8);
  for (var ne = 0; ne < this.iv.length; ne++)
    this.iv[ne] = re[ne];
}
function instantiate(re) {
  function ne(se) {
    re.call(this, se), this._cbcInit();
  }
  inherits$b(ne, re);
  for (var ae = Object.keys(proto), ie = 0; ie < ae.length; ie++) {
    var le = ae[ie];
    ne.prototype[le] = proto[le];
  }
  return ne.create = function(ce) {
    return new ne(ce);
  }, ne;
}
cbc$1.instantiate = instantiate;
proto._cbcInit = function() {
  var ne = new CBCState(this.options.iv);
  this._cbcState = ne;
};
proto._update = function(ne, ae, ie, le) {
  var se = this._cbcState, ce = this.constructor.super_.prototype, ue = se.iv;
  if (this.type === "encrypt") {
    for (var de = 0; de < this.blockSize; de++)
      ue[de] ^= ne[ae + de];
    ce._update.call(this, ue, 0, ie, le);
    for (var de = 0; de < this.blockSize; de++)
      ue[de] = ie[le + de];
  } else {
    ce._update.call(this, ne, ae, ie, le);
    for (var de = 0; de < this.blockSize; de++)
      ie[le + de] ^= ue[de];
    for (var de = 0; de < this.blockSize; de++)
      ue[de] = ne[ae + de];
  }
};
var assert$e = minimalisticAssert, inherits$a = inherits_browserExports, Cipher$1 = cipher, DES$2 = des$1;
function EDEState(re, ne) {
  assert$e.equal(ne.length, 24, "Invalid key length");
  var ae = ne.slice(0, 8), ie = ne.slice(8, 16), le = ne.slice(16, 24);
  re === "encrypt" ? this.ciphers = [
    DES$2.create({ type: "encrypt", key: ae }),
    DES$2.create({ type: "decrypt", key: ie }),
    DES$2.create({ type: "encrypt", key: le })
  ] : this.ciphers = [
    DES$2.create({ type: "decrypt", key: le }),
    DES$2.create({ type: "encrypt", key: ie }),
    DES$2.create({ type: "decrypt", key: ae })
  ];
}
function EDE(re) {
  Cipher$1.call(this, re);
  var ne = new EDEState(this.type, this.options.key);
  this._edeState = ne;
}
inherits$a(EDE, Cipher$1);
var ede = EDE;
EDE.create = function(ne) {
  return new EDE(ne);
};
EDE.prototype._update = function(ne, ae, ie, le) {
  var se = this._edeState;
  se.ciphers[0]._update(ne, ae, ie, le), se.ciphers[1]._update(ie, le, ie, le), se.ciphers[2]._update(ie, le, ie, le);
};
EDE.prototype._pad = DES$2.prototype._pad;
EDE.prototype._unpad = DES$2.prototype._unpad;
des$2.utils = utils$n;
des$2.Cipher = cipher;
des$2.DES = des$1;
des$2.CBC = cbc$1;
des$2.EDE = ede;
var CipherBase = cipherBase, des = des$2, inherits$9 = inherits_browserExports, Buffer$j = safeBufferExports$1.Buffer, modes$4 = {
  "des-ede3-cbc": des.CBC.instantiate(des.EDE),
  "des-ede3": des.EDE,
  "des-ede-cbc": des.CBC.instantiate(des.EDE),
  "des-ede": des.EDE,
  "des-cbc": des.CBC.instantiate(des.DES),
  "des-ecb": des.DES
};
modes$4.des = modes$4["des-cbc"];
modes$4.des3 = modes$4["des-ede3-cbc"];
var browserifyDes = DES$1;
inherits$9(DES$1, CipherBase);
function DES$1(re) {
  CipherBase.call(this);
  var ne = re.mode.toLowerCase(), ae = modes$4[ne], ie;
  re.decrypt ? ie = "decrypt" : ie = "encrypt";
  var le = re.key;
  Buffer$j.isBuffer(le) || (le = Buffer$j.from(le)), (ne === "des-ede" || ne === "des-ede-cbc") && (le = Buffer$j.concat([le, le.slice(0, 8)]));
  var se = re.iv;
  Buffer$j.isBuffer(se) || (se = Buffer$j.from(se)), this._des = ae.create({
    key: le,
    iv: se,
    type: ie
  });
}
DES$1.prototype._update = function(re) {
  return Buffer$j.from(this._des.update(re));
};
DES$1.prototype._final = function() {
  return Buffer$j.from(this._des.final());
};
var browser$5 = {}, encrypter = {}, ecb = {};
ecb.encrypt = function(re, ne) {
  return re._cipher.encryptBlock(ne);
};
ecb.decrypt = function(re, ne) {
  return re._cipher.decryptBlock(ne);
};
var cbc = {}, bufferXor = function(ne, ae) {
  for (var ie = Math.min(ne.length, ae.length), le = new Buffer$D(ie), se = 0; se < ie; ++se)
    le[se] = ne[se] ^ ae[se];
  return le;
}, xor$7 = bufferXor;
cbc.encrypt = function(re, ne) {
  var ae = xor$7(ne, re._prev);
  return re._prev = re._cipher.encryptBlock(ae), re._prev;
};
cbc.decrypt = function(re, ne) {
  var ae = re._prev;
  re._prev = ne;
  var ie = re._cipher.decryptBlock(ne);
  return xor$7(ie, ae);
};
var cfb = {}, Buffer$i = safeBufferExports$1.Buffer, xor$6 = bufferXor;
function encryptStart(re, ne, ae) {
  var ie = ne.length, le = xor$6(ne, re._cache);
  return re._cache = re._cache.slice(ie), re._prev = Buffer$i.concat([re._prev, ae ? ne : le]), le;
}
cfb.encrypt = function(re, ne, ae) {
  for (var ie = Buffer$i.allocUnsafe(0), le; ne.length; )
    if (re._cache.length === 0 && (re._cache = re._cipher.encryptBlock(re._prev), re._prev = Buffer$i.allocUnsafe(0)), re._cache.length <= ne.length)
      le = re._cache.length, ie = Buffer$i.concat([ie, encryptStart(re, ne.slice(0, le), ae)]), ne = ne.slice(le);
    else {
      ie = Buffer$i.concat([ie, encryptStart(re, ne, ae)]);
      break;
    }
  return ie;
};
var cfb8 = {}, Buffer$h = safeBufferExports$1.Buffer;
function encryptByte$1(re, ne, ae) {
  var ie = re._cipher.encryptBlock(re._prev), le = ie[0] ^ ne;
  return re._prev = Buffer$h.concat([
    re._prev.slice(1),
    Buffer$h.from([ae ? ne : le])
  ]), le;
}
cfb8.encrypt = function(re, ne, ae) {
  for (var ie = ne.length, le = Buffer$h.allocUnsafe(ie), se = -1; ++se < ie; )
    le[se] = encryptByte$1(re, ne[se], ae);
  return le;
};
var cfb1 = {}, Buffer$g = safeBufferExports$1.Buffer;
function encryptByte(re, ne, ae) {
  for (var ie, le = -1, se = 8, ce = 0, ue, de; ++le < se; )
    ie = re._cipher.encryptBlock(re._prev), ue = ne & 1 << 7 - le ? 128 : 0, de = ie[0] ^ ue, ce += (de & 128) >> le % 8, re._prev = shiftIn(re._prev, ae ? ue : de);
  return ce;
}
function shiftIn(re, ne) {
  var ae = re.length, ie = -1, le = Buffer$g.allocUnsafe(re.length);
  for (re = Buffer$g.concat([re, Buffer$g.from([ne])]); ++ie < ae; )
    le[ie] = re[ie] << 1 | re[ie + 1] >> 7;
  return le;
}
cfb1.encrypt = function(re, ne, ae) {
  for (var ie = ne.length, le = Buffer$g.allocUnsafe(ie), se = -1; ++se < ie; )
    le[se] = encryptByte(re, ne[se], ae);
  return le;
};
var ofb = {}, xor$5 = bufferXor;
function getBlock$1(re) {
  return re._prev = re._cipher.encryptBlock(re._prev), re._prev;
}
ofb.encrypt = function(re, ne) {
  for (; re._cache.length < ne.length; )
    re._cache = Buffer$D.concat([re._cache, getBlock$1(re)]);
  var ae = re._cache.slice(0, ne.length);
  return re._cache = re._cache.slice(ne.length), xor$5(ne, ae);
};
var ctr = {};
function incr32$2(re) {
  for (var ne = re.length, ae; ne--; )
    if (ae = re.readUInt8(ne), ae === 255)
      re.writeUInt8(0, ne);
    else {
      ae++, re.writeUInt8(ae, ne);
      break;
    }
}
var incr32_1 = incr32$2, xor$4 = bufferXor, Buffer$f = safeBufferExports$1.Buffer, incr32$1 = incr32_1;
function getBlock(re) {
  var ne = re._cipher.encryptBlockRaw(re._prev);
  return incr32$1(re._prev), ne;
}
var blockSize = 16;
ctr.encrypt = function(re, ne) {
  var ae = Math.ceil(ne.length / blockSize), ie = re._cache.length;
  re._cache = Buffer$f.concat([
    re._cache,
    Buffer$f.allocUnsafe(ae * blockSize)
  ]);
  for (var le = 0; le < ae; le++) {
    var se = getBlock(re), ce = ie + le * blockSize;
    re._cache.writeUInt32BE(se[0], ce + 0), re._cache.writeUInt32BE(se[1], ce + 4), re._cache.writeUInt32BE(se[2], ce + 8), re._cache.writeUInt32BE(se[3], ce + 12);
  }
  var ue = re._cache.slice(0, ne.length);
  return re._cache = re._cache.slice(ne.length), xor$4(ne, ue);
};
const aes128 = {
  cipher: "AES",
  key: 128,
  iv: 16,
  mode: "CBC",
  type: "block"
}, aes192 = {
  cipher: "AES",
  key: 192,
  iv: 16,
  mode: "CBC",
  type: "block"
}, aes256 = {
  cipher: "AES",
  key: 256,
  iv: 16,
  mode: "CBC",
  type: "block"
}, require$$2 = {
  "aes-128-ecb": {
    cipher: "AES",
    key: 128,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-192-ecb": {
    cipher: "AES",
    key: 192,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-256-ecb": {
    cipher: "AES",
    key: 256,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-128-cbc": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-192-cbc": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-256-cbc": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  aes128,
  aes192,
  aes256,
  "aes-128-cfb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-192-cfb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-256-cfb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-128-cfb8": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-192-cfb8": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-256-cfb8": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-128-cfb1": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-192-cfb1": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-256-cfb1": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-128-ofb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-192-ofb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-256-ofb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-128-ctr": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-192-ctr": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-256-ctr": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-128-gcm": {
    cipher: "AES",
    key: 128,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-192-gcm": {
    cipher: "AES",
    key: 192,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-256-gcm": {
    cipher: "AES",
    key: 256,
    iv: 12,
    mode: "GCM",
    type: "auth"
  }
};
var modeModules = {
  ECB: ecb,
  CBC: cbc,
  CFB: cfb,
  CFB8: cfb8,
  CFB1: cfb1,
  OFB: ofb,
  CTR: ctr,
  GCM: ctr
}, modes$3 = require$$2;
for (var key$2 in modes$3)
  modes$3[key$2].module = modeModules[modes$3[key$2].mode];
var modes_1 = modes$3, aes$5 = {}, Buffer$e = safeBufferExports$1.Buffer;
function asUInt32Array(re) {
  Buffer$e.isBuffer(re) || (re = Buffer$e.from(re));
  for (var ne = re.length / 4 | 0, ae = new Array(ne), ie = 0; ie < ne; ie++)
    ae[ie] = re.readUInt32BE(ie * 4);
  return ae;
}
function scrubVec(re) {
  for (var ne = 0; ne < re.length; re++)
    re[ne] = 0;
}
function cryptBlock(re, ne, ae, ie, le) {
  for (var se = ae[0], ce = ae[1], ue = ae[2], de = ae[3], me = re[0] ^ ne[0], fe = re[1] ^ ne[1], pe = re[2] ^ ne[2], ge = re[3] ^ ne[3], be, Se, Pe, Ee, Ve = 4, Ae = 1; Ae < le; Ae++)
    be = se[me >>> 24] ^ ce[fe >>> 16 & 255] ^ ue[pe >>> 8 & 255] ^ de[ge & 255] ^ ne[Ve++], Se = se[fe >>> 24] ^ ce[pe >>> 16 & 255] ^ ue[ge >>> 8 & 255] ^ de[me & 255] ^ ne[Ve++], Pe = se[pe >>> 24] ^ ce[ge >>> 16 & 255] ^ ue[me >>> 8 & 255] ^ de[fe & 255] ^ ne[Ve++], Ee = se[ge >>> 24] ^ ce[me >>> 16 & 255] ^ ue[fe >>> 8 & 255] ^ de[pe & 255] ^ ne[Ve++], me = be, fe = Se, pe = Pe, ge = Ee;
  return be = (ie[me >>> 24] << 24 | ie[fe >>> 16 & 255] << 16 | ie[pe >>> 8 & 255] << 8 | ie[ge & 255]) ^ ne[Ve++], Se = (ie[fe >>> 24] << 24 | ie[pe >>> 16 & 255] << 16 | ie[ge >>> 8 & 255] << 8 | ie[me & 255]) ^ ne[Ve++], Pe = (ie[pe >>> 24] << 24 | ie[ge >>> 16 & 255] << 16 | ie[me >>> 8 & 255] << 8 | ie[fe & 255]) ^ ne[Ve++], Ee = (ie[ge >>> 24] << 24 | ie[me >>> 16 & 255] << 16 | ie[fe >>> 8 & 255] << 8 | ie[pe & 255]) ^ ne[Ve++], be = be >>> 0, Se = Se >>> 0, Pe = Pe >>> 0, Ee = Ee >>> 0, [be, Se, Pe, Ee];
}
var RCON = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], G = function() {
  for (var re = new Array(256), ne = 0; ne < 256; ne++)
    ne < 128 ? re[ne] = ne << 1 : re[ne] = ne << 1 ^ 283;
  for (var ae = [], ie = [], le = [[], [], [], []], se = [[], [], [], []], ce = 0, ue = 0, de = 0; de < 256; ++de) {
    var me = ue ^ ue << 1 ^ ue << 2 ^ ue << 3 ^ ue << 4;
    me = me >>> 8 ^ me & 255 ^ 99, ae[ce] = me, ie[me] = ce;
    var fe = re[ce], pe = re[fe], ge = re[pe], be = re[me] * 257 ^ me * 16843008;
    le[0][ce] = be << 24 | be >>> 8, le[1][ce] = be << 16 | be >>> 16, le[2][ce] = be << 8 | be >>> 24, le[3][ce] = be, be = ge * 16843009 ^ pe * 65537 ^ fe * 257 ^ ce * 16843008, se[0][me] = be << 24 | be >>> 8, se[1][me] = be << 16 | be >>> 16, se[2][me] = be << 8 | be >>> 24, se[3][me] = be, ce === 0 ? ce = ue = 1 : (ce = fe ^ re[re[re[ge ^ fe]]], ue ^= re[re[ue]]);
  }
  return {
    SBOX: ae,
    INV_SBOX: ie,
    SUB_MIX: le,
    INV_SUB_MIX: se
  };
}();
function AES(re) {
  this._key = asUInt32Array(re), this._reset();
}
AES.blockSize = 4 * 4;
AES.keySize = 256 / 8;
AES.prototype.blockSize = AES.blockSize;
AES.prototype.keySize = AES.keySize;
AES.prototype._reset = function() {
  for (var re = this._key, ne = re.length, ae = ne + 6, ie = (ae + 1) * 4, le = [], se = 0; se < ne; se++)
    le[se] = re[se];
  for (se = ne; se < ie; se++) {
    var ce = le[se - 1];
    se % ne === 0 ? (ce = ce << 8 | ce >>> 24, ce = G.SBOX[ce >>> 24] << 24 | G.SBOX[ce >>> 16 & 255] << 16 | G.SBOX[ce >>> 8 & 255] << 8 | G.SBOX[ce & 255], ce ^= RCON[se / ne | 0] << 24) : ne > 6 && se % ne === 4 && (ce = G.SBOX[ce >>> 24] << 24 | G.SBOX[ce >>> 16 & 255] << 16 | G.SBOX[ce >>> 8 & 255] << 8 | G.SBOX[ce & 255]), le[se] = le[se - ne] ^ ce;
  }
  for (var ue = [], de = 0; de < ie; de++) {
    var me = ie - de, fe = le[me - (de % 4 ? 0 : 4)];
    de < 4 || me <= 4 ? ue[de] = fe : ue[de] = G.INV_SUB_MIX[0][G.SBOX[fe >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[fe >>> 16 & 255]] ^ G.INV_SUB_MIX[2][G.SBOX[fe >>> 8 & 255]] ^ G.INV_SUB_MIX[3][G.SBOX[fe & 255]];
  }
  this._nRounds = ae, this._keySchedule = le, this._invKeySchedule = ue;
};
AES.prototype.encryptBlockRaw = function(re) {
  return re = asUInt32Array(re), cryptBlock(re, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds);
};
AES.prototype.encryptBlock = function(re) {
  var ne = this.encryptBlockRaw(re), ae = Buffer$e.allocUnsafe(16);
  return ae.writeUInt32BE(ne[0], 0), ae.writeUInt32BE(ne[1], 4), ae.writeUInt32BE(ne[2], 8), ae.writeUInt32BE(ne[3], 12), ae;
};
AES.prototype.decryptBlock = function(re) {
  re = asUInt32Array(re);
  var ne = re[1];
  re[1] = re[3], re[3] = ne;
  var ae = cryptBlock(re, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds), ie = Buffer$e.allocUnsafe(16);
  return ie.writeUInt32BE(ae[0], 0), ie.writeUInt32BE(ae[3], 4), ie.writeUInt32BE(ae[2], 8), ie.writeUInt32BE(ae[1], 12), ie;
};
AES.prototype.scrub = function() {
  scrubVec(this._keySchedule), scrubVec(this._invKeySchedule), scrubVec(this._key);
};
aes$5.AES = AES;
var Buffer$d = safeBufferExports$1.Buffer, ZEROES = Buffer$d.alloc(16, 0);
function toArray$1(re) {
  return [
    re.readUInt32BE(0),
    re.readUInt32BE(4),
    re.readUInt32BE(8),
    re.readUInt32BE(12)
  ];
}
function fromArray(re) {
  var ne = Buffer$d.allocUnsafe(16);
  return ne.writeUInt32BE(re[0] >>> 0, 0), ne.writeUInt32BE(re[1] >>> 0, 4), ne.writeUInt32BE(re[2] >>> 0, 8), ne.writeUInt32BE(re[3] >>> 0, 12), ne;
}
function GHASH$1(re) {
  this.h = re, this.state = Buffer$d.alloc(16, 0), this.cache = Buffer$d.allocUnsafe(0);
}
GHASH$1.prototype.ghash = function(re) {
  for (var ne = -1; ++ne < re.length; )
    this.state[ne] ^= re[ne];
  this._multiply();
};
GHASH$1.prototype._multiply = function() {
  for (var re = toArray$1(this.h), ne = [0, 0, 0, 0], ae, ie, le, se = -1; ++se < 128; ) {
    for (ie = (this.state[~~(se / 8)] & 1 << 7 - se % 8) !== 0, ie && (ne[0] ^= re[0], ne[1] ^= re[1], ne[2] ^= re[2], ne[3] ^= re[3]), le = (re[3] & 1) !== 0, ae = 3; ae > 0; ae--)
      re[ae] = re[ae] >>> 1 | (re[ae - 1] & 1) << 31;
    re[0] = re[0] >>> 1, le && (re[0] = re[0] ^ 225 << 24);
  }
  this.state = fromArray(ne);
};
GHASH$1.prototype.update = function(re) {
  this.cache = Buffer$d.concat([this.cache, re]);
  for (var ne; this.cache.length >= 16; )
    ne = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(ne);
};
GHASH$1.prototype.final = function(re, ne) {
  return this.cache.length && this.ghash(Buffer$d.concat([this.cache, ZEROES], 16)), this.ghash(fromArray([0, re, 0, ne])), this.state;
};
var ghash = GHASH$1, aes$4 = aes$5, Buffer$c = safeBufferExports$1.Buffer, Transform$5 = cipherBase, inherits$8 = inherits_browserExports, GHASH = ghash, xor$3 = bufferXor, incr32 = incr32_1;
function xorTest(re, ne) {
  var ae = 0;
  re.length !== ne.length && ae++;
  for (var ie = Math.min(re.length, ne.length), le = 0; le < ie; ++le)
    ae += re[le] ^ ne[le];
  return ae;
}
function calcIv(re, ne, ae) {
  if (ne.length === 12)
    return re._finID = Buffer$c.concat([ne, Buffer$c.from([0, 0, 0, 1])]), Buffer$c.concat([ne, Buffer$c.from([0, 0, 0, 2])]);
  var ie = new GHASH(ae), le = ne.length, se = le % 16;
  ie.update(ne), se && (se = 16 - se, ie.update(Buffer$c.alloc(se, 0))), ie.update(Buffer$c.alloc(8, 0));
  var ce = le * 8, ue = Buffer$c.alloc(8);
  ue.writeUIntBE(ce, 0, 8), ie.update(ue), re._finID = ie.state;
  var de = Buffer$c.from(re._finID);
  return incr32(de), de;
}
function StreamCipher$3(re, ne, ae, ie) {
  Transform$5.call(this);
  var le = Buffer$c.alloc(4, 0);
  this._cipher = new aes$4.AES(ne);
  var se = this._cipher.encryptBlock(le);
  this._ghash = new GHASH(se), ae = calcIv(this, ae, se), this._prev = Buffer$c.from(ae), this._cache = Buffer$c.allocUnsafe(0), this._secCache = Buffer$c.allocUnsafe(0), this._decrypt = ie, this._alen = 0, this._len = 0, this._mode = re, this._authTag = null, this._called = !1;
}
inherits$8(StreamCipher$3, Transform$5);
StreamCipher$3.prototype._update = function(re) {
  if (!this._called && this._alen) {
    var ne = 16 - this._alen % 16;
    ne < 16 && (ne = Buffer$c.alloc(ne, 0), this._ghash.update(ne));
  }
  this._called = !0;
  var ae = this._mode.encrypt(this, re);
  return this._decrypt ? this._ghash.update(re) : this._ghash.update(ae), this._len += re.length, ae;
};
StreamCipher$3.prototype._final = function() {
  if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
  var re = xor$3(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
  if (this._decrypt && xorTest(re, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
  this._authTag = re, this._cipher.scrub();
};
StreamCipher$3.prototype.getAuthTag = function() {
  if (this._decrypt || !Buffer$c.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
  return this._authTag;
};
StreamCipher$3.prototype.setAuthTag = function(ne) {
  if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
  this._authTag = ne;
};
StreamCipher$3.prototype.setAAD = function(ne) {
  if (this._called) throw new Error("Attempting to set AAD in unsupported state");
  this._ghash.update(ne), this._alen += ne.length;
};
var authCipher = StreamCipher$3, aes$3 = aes$5, Buffer$b = safeBufferExports$1.Buffer, Transform$4 = cipherBase, inherits$7 = inherits_browserExports;
function StreamCipher$2(re, ne, ae, ie) {
  Transform$4.call(this), this._cipher = new aes$3.AES(ne), this._prev = Buffer$b.from(ae), this._cache = Buffer$b.allocUnsafe(0), this._secCache = Buffer$b.allocUnsafe(0), this._decrypt = ie, this._mode = re;
}
inherits$7(StreamCipher$2, Transform$4);
StreamCipher$2.prototype._update = function(re) {
  return this._mode.encrypt(this, re, this._decrypt);
};
StreamCipher$2.prototype._final = function() {
  this._cipher.scrub();
};
var streamCipher = StreamCipher$2, Buffer$a = safeBufferExports$1.Buffer, MD5 = md5_js;
function EVP_BytesToKey(re, ne, ae, ie) {
  if (Buffer$a.isBuffer(re) || (re = Buffer$a.from(re, "binary")), ne && (Buffer$a.isBuffer(ne) || (ne = Buffer$a.from(ne, "binary")), ne.length !== 8))
    throw new RangeError("salt should be Buffer with 8 byte length");
  for (var le = ae / 8, se = Buffer$a.alloc(le), ce = Buffer$a.alloc(ie || 0), ue = Buffer$a.alloc(0); le > 0 || ie > 0; ) {
    var de = new MD5();
    de.update(ue), de.update(re), ne && de.update(ne), ue = de.digest();
    var me = 0;
    if (le > 0) {
      var fe = se.length - le;
      me = Math.min(le, ue.length), ue.copy(se, fe, 0, me), le -= me;
    }
    if (me < ue.length && ie > 0) {
      var pe = ce.length - ie, ge = Math.min(ie, ue.length - me);
      ue.copy(ce, pe, me, me + ge), ie -= ge;
    }
  }
  return ue.fill(0), { key: se, iv: ce };
}
var evp_bytestokey = EVP_BytesToKey, MODES$1 = modes_1, AuthCipher$1 = authCipher, Buffer$9 = safeBufferExports$1.Buffer, StreamCipher$1 = streamCipher, Transform$3 = cipherBase, aes$2 = aes$5, ebtk$2 = evp_bytestokey, inherits$6 = inherits_browserExports;
function Cipher(re, ne, ae) {
  Transform$3.call(this), this._cache = new Splitter$1(), this._cipher = new aes$2.AES(ne), this._prev = Buffer$9.from(ae), this._mode = re, this._autopadding = !0;
}
inherits$6(Cipher, Transform$3);
Cipher.prototype._update = function(re) {
  this._cache.add(re);
  for (var ne, ae, ie = []; ne = this._cache.get(); )
    ae = this._mode.encrypt(this, ne), ie.push(ae);
  return Buffer$9.concat(ie);
};
var PADDING = Buffer$9.alloc(16, 16);
Cipher.prototype._final = function() {
  var re = this._cache.flush();
  if (this._autopadding)
    return re = this._mode.encrypt(this, re), this._cipher.scrub(), re;
  if (!re.equals(PADDING))
    throw this._cipher.scrub(), new Error("data not multiple of block length");
};
Cipher.prototype.setAutoPadding = function(re) {
  return this._autopadding = !!re, this;
};
function Splitter$1() {
  this.cache = Buffer$9.allocUnsafe(0);
}
Splitter$1.prototype.add = function(re) {
  this.cache = Buffer$9.concat([this.cache, re]);
};
Splitter$1.prototype.get = function() {
  if (this.cache.length > 15) {
    var re = this.cache.slice(0, 16);
    return this.cache = this.cache.slice(16), re;
  }
  return null;
};
Splitter$1.prototype.flush = function() {
  for (var re = 16 - this.cache.length, ne = Buffer$9.allocUnsafe(re), ae = -1; ++ae < re; )
    ne.writeUInt8(re, ae);
  return Buffer$9.concat([this.cache, ne]);
};
function createCipheriv$1(re, ne, ae) {
  var ie = MODES$1[re.toLowerCase()];
  if (!ie) throw new TypeError("invalid suite type");
  if (typeof ne == "string" && (ne = Buffer$9.from(ne)), ne.length !== ie.key / 8) throw new TypeError("invalid key length " + ne.length);
  if (typeof ae == "string" && (ae = Buffer$9.from(ae)), ie.mode !== "GCM" && ae.length !== ie.iv) throw new TypeError("invalid iv length " + ae.length);
  return ie.type === "stream" ? new StreamCipher$1(ie.module, ne, ae) : ie.type === "auth" ? new AuthCipher$1(ie.module, ne, ae) : new Cipher(ie.module, ne, ae);
}
function createCipher$1(re, ne) {
  var ae = MODES$1[re.toLowerCase()];
  if (!ae) throw new TypeError("invalid suite type");
  var ie = ebtk$2(ne, !1, ae.key, ae.iv);
  return createCipheriv$1(re, ie.key, ie.iv);
}
encrypter.createCipheriv = createCipheriv$1;
encrypter.createCipher = createCipher$1;
var decrypter = {}, AuthCipher = authCipher, Buffer$8 = safeBufferExports$1.Buffer, MODES = modes_1, StreamCipher = streamCipher, Transform$2 = cipherBase, aes$1 = aes$5, ebtk$1 = evp_bytestokey, inherits$5 = inherits_browserExports;
function Decipher(re, ne, ae) {
  Transform$2.call(this), this._cache = new Splitter(), this._last = void 0, this._cipher = new aes$1.AES(ne), this._prev = Buffer$8.from(ae), this._mode = re, this._autopadding = !0;
}
inherits$5(Decipher, Transform$2);
Decipher.prototype._update = function(re) {
  this._cache.add(re);
  for (var ne, ae, ie = []; ne = this._cache.get(this._autopadding); )
    ae = this._mode.decrypt(this, ne), ie.push(ae);
  return Buffer$8.concat(ie);
};
Decipher.prototype._final = function() {
  var re = this._cache.flush();
  if (this._autopadding)
    return unpad(this._mode.decrypt(this, re));
  if (re)
    throw new Error("data not multiple of block length");
};
Decipher.prototype.setAutoPadding = function(re) {
  return this._autopadding = !!re, this;
};
function Splitter() {
  this.cache = Buffer$8.allocUnsafe(0);
}
Splitter.prototype.add = function(re) {
  this.cache = Buffer$8.concat([this.cache, re]);
};
Splitter.prototype.get = function(re) {
  var ne;
  if (re) {
    if (this.cache.length > 16)
      return ne = this.cache.slice(0, 16), this.cache = this.cache.slice(16), ne;
  } else if (this.cache.length >= 16)
    return ne = this.cache.slice(0, 16), this.cache = this.cache.slice(16), ne;
  return null;
};
Splitter.prototype.flush = function() {
  if (this.cache.length) return this.cache;
};
function unpad(re) {
  var ne = re[15];
  if (ne < 1 || ne > 16)
    throw new Error("unable to decrypt data");
  for (var ae = -1; ++ae < ne; )
    if (re[ae + (16 - ne)] !== ne)
      throw new Error("unable to decrypt data");
  if (ne !== 16)
    return re.slice(0, 16 - ne);
}
function createDecipheriv$1(re, ne, ae) {
  var ie = MODES[re.toLowerCase()];
  if (!ie) throw new TypeError("invalid suite type");
  if (typeof ae == "string" && (ae = Buffer$8.from(ae)), ie.mode !== "GCM" && ae.length !== ie.iv) throw new TypeError("invalid iv length " + ae.length);
  if (typeof ne == "string" && (ne = Buffer$8.from(ne)), ne.length !== ie.key / 8) throw new TypeError("invalid key length " + ne.length);
  return ie.type === "stream" ? new StreamCipher(ie.module, ne, ae, !0) : ie.type === "auth" ? new AuthCipher(ie.module, ne, ae, !0) : new Decipher(ie.module, ne, ae);
}
function createDecipher$1(re, ne) {
  var ae = MODES[re.toLowerCase()];
  if (!ae) throw new TypeError("invalid suite type");
  var ie = ebtk$1(ne, !1, ae.key, ae.iv);
  return createDecipheriv$1(re, ie.key, ie.iv);
}
decrypter.createDecipher = createDecipher$1;
decrypter.createDecipheriv = createDecipheriv$1;
var ciphers$2 = encrypter, deciphers = decrypter, modes$2 = require$$2;
function getCiphers$1() {
  return Object.keys(modes$2);
}
browser$5.createCipher = browser$5.Cipher = ciphers$2.createCipher;
browser$5.createCipheriv = browser$5.Cipheriv = ciphers$2.createCipheriv;
browser$5.createDecipher = browser$5.Decipher = deciphers.createDecipher;
browser$5.createDecipheriv = browser$5.Decipheriv = deciphers.createDecipheriv;
browser$5.listCiphers = browser$5.getCiphers = getCiphers$1;
var modes$1 = {};
(function(re) {
  re["des-ecb"] = {
    key: 8,
    iv: 0
  }, re["des-cbc"] = re.des = {
    key: 8,
    iv: 8
  }, re["des-ede3-cbc"] = re.des3 = {
    key: 24,
    iv: 8
  }, re["des-ede3"] = {
    key: 24,
    iv: 0
  }, re["des-ede-cbc"] = {
    key: 16,
    iv: 8
  }, re["des-ede"] = {
    key: 16,
    iv: 0
  };
})(modes$1);
var DES = browserifyDes, aes = browser$5, aesModes = modes_1, desModes = modes$1, ebtk = evp_bytestokey;
function createCipher(re, ne) {
  re = re.toLowerCase();
  var ae, ie;
  if (aesModes[re])
    ae = aesModes[re].key, ie = aesModes[re].iv;
  else if (desModes[re])
    ae = desModes[re].key * 8, ie = desModes[re].iv;
  else
    throw new TypeError("invalid suite type");
  var le = ebtk(ne, !1, ae, ie);
  return createCipheriv(re, le.key, le.iv);
}
function createDecipher(re, ne) {
  re = re.toLowerCase();
  var ae, ie;
  if (aesModes[re])
    ae = aesModes[re].key, ie = aesModes[re].iv;
  else if (desModes[re])
    ae = desModes[re].key * 8, ie = desModes[re].iv;
  else
    throw new TypeError("invalid suite type");
  var le = ebtk(ne, !1, ae, ie);
  return createDecipheriv(re, le.key, le.iv);
}
function createCipheriv(re, ne, ae) {
  if (re = re.toLowerCase(), aesModes[re]) return aes.createCipheriv(re, ne, ae);
  if (desModes[re]) return new DES({ key: ne, iv: ae, mode: re });
  throw new TypeError("invalid suite type");
}
function createDecipheriv(re, ne, ae) {
  if (re = re.toLowerCase(), aesModes[re]) return aes.createDecipheriv(re, ne, ae);
  if (desModes[re]) return new DES({ key: ne, iv: ae, mode: re, decrypt: !0 });
  throw new TypeError("invalid suite type");
}
function getCiphers() {
  return Object.keys(desModes).concat(aes.getCiphers());
}
browser$6.createCipher = browser$6.Cipher = createCipher;
browser$6.createCipheriv = browser$6.Cipheriv = createCipheriv;
browser$6.createDecipher = browser$6.Decipher = createDecipher;
browser$6.createDecipheriv = browser$6.Decipheriv = createDecipheriv;
browser$6.listCiphers = browser$6.getCiphers = getCiphers;
var browser$4 = {}, bn$2 = { exports: {} };
bn$2.exports;
(function(re) {
  (function(ne, ae) {
    function ie(Re, Ce) {
      if (!Re) throw new Error(Ce || "Assertion failed");
    }
    function le(Re, Ce) {
      Re.super_ = Ce;
      var _e = function() {
      };
      _e.prototype = Ce.prototype, Re.prototype = new _e(), Re.prototype.constructor = Re;
    }
    function se(Re, Ce, _e) {
      if (se.isBN(Re))
        return Re;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, Re !== null && ((Ce === "le" || Ce === "be") && (_e = Ce, Ce = 10), this._init(Re || 0, Ce || 10, _e || "be"));
    }
    typeof ne == "object" ? ne.exports = se : ae.BN = se, se.BN = se, se.wordSize = 26;
    var ce;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? ce = window.Buffer : ce = require$$1$2.Buffer;
    } catch {
    }
    se.isBN = function(Ce) {
      return Ce instanceof se ? !0 : Ce !== null && typeof Ce == "object" && Ce.constructor.wordSize === se.wordSize && Array.isArray(Ce.words);
    }, se.max = function(Ce, _e) {
      return Ce.cmp(_e) > 0 ? Ce : _e;
    }, se.min = function(Ce, _e) {
      return Ce.cmp(_e) < 0 ? Ce : _e;
    }, se.prototype._init = function(Ce, _e, he) {
      if (typeof Ce == "number")
        return this._initNumber(Ce, _e, he);
      if (typeof Ce == "object")
        return this._initArray(Ce, _e, he);
      _e === "hex" && (_e = 16), ie(_e === (_e | 0) && _e >= 2 && _e <= 36), Ce = Ce.toString().replace(/\s+/g, "");
      var ve = 0;
      Ce[0] === "-" && (ve++, this.negative = 1), ve < Ce.length && (_e === 16 ? this._parseHex(Ce, ve, he) : (this._parseBase(Ce, _e, ve), he === "le" && this._initArray(this.toArray(), _e, he)));
    }, se.prototype._initNumber = function(Ce, _e, he) {
      Ce < 0 && (this.negative = 1, Ce = -Ce), Ce < 67108864 ? (this.words = [Ce & 67108863], this.length = 1) : Ce < 4503599627370496 ? (this.words = [
        Ce & 67108863,
        Ce / 67108864 & 67108863
      ], this.length = 2) : (ie(Ce < 9007199254740992), this.words = [
        Ce & 67108863,
        Ce / 67108864 & 67108863,
        1
      ], this.length = 3), he === "le" && this._initArray(this.toArray(), _e, he);
    }, se.prototype._initArray = function(Ce, _e, he) {
      if (ie(typeof Ce.length == "number"), Ce.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(Ce.length / 3), this.words = new Array(this.length);
      for (var ve = 0; ve < this.length; ve++)
        this.words[ve] = 0;
      var xe, $e, Te = 0;
      if (he === "be")
        for (ve = Ce.length - 1, xe = 0; ve >= 0; ve -= 3)
          $e = Ce[ve] | Ce[ve - 1] << 8 | Ce[ve - 2] << 16, this.words[xe] |= $e << Te & 67108863, this.words[xe + 1] = $e >>> 26 - Te & 67108863, Te += 24, Te >= 26 && (Te -= 26, xe++);
      else if (he === "le")
        for (ve = 0, xe = 0; ve < Ce.length; ve += 3)
          $e = Ce[ve] | Ce[ve + 1] << 8 | Ce[ve + 2] << 16, this.words[xe] |= $e << Te & 67108863, this.words[xe + 1] = $e >>> 26 - Te & 67108863, Te += 24, Te >= 26 && (Te -= 26, xe++);
      return this.strip();
    };
    function ue(Re, Ce) {
      var _e = Re.charCodeAt(Ce);
      return _e >= 65 && _e <= 70 ? _e - 55 : _e >= 97 && _e <= 102 ? _e - 87 : _e - 48 & 15;
    }
    function de(Re, Ce, _e) {
      var he = ue(Re, _e);
      return _e - 1 >= Ce && (he |= ue(Re, _e - 1) << 4), he;
    }
    se.prototype._parseHex = function(Ce, _e, he) {
      this.length = Math.ceil((Ce.length - _e) / 6), this.words = new Array(this.length);
      for (var ve = 0; ve < this.length; ve++)
        this.words[ve] = 0;
      var xe = 0, $e = 0, Te;
      if (he === "be")
        for (ve = Ce.length - 1; ve >= _e; ve -= 2)
          Te = de(Ce, _e, ve) << xe, this.words[$e] |= Te & 67108863, xe >= 18 ? (xe -= 18, $e += 1, this.words[$e] |= Te >>> 26) : xe += 8;
      else {
        var Ie = Ce.length - _e;
        for (ve = Ie % 2 === 0 ? _e + 1 : _e; ve < Ce.length; ve += 2)
          Te = de(Ce, _e, ve) << xe, this.words[$e] |= Te & 67108863, xe >= 18 ? (xe -= 18, $e += 1, this.words[$e] |= Te >>> 26) : xe += 8;
      }
      this.strip();
    };
    function me(Re, Ce, _e, he) {
      for (var ve = 0, xe = Math.min(Re.length, _e), $e = Ce; $e < xe; $e++) {
        var Te = Re.charCodeAt($e) - 48;
        ve *= he, Te >= 49 ? ve += Te - 49 + 10 : Te >= 17 ? ve += Te - 17 + 10 : ve += Te;
      }
      return ve;
    }
    se.prototype._parseBase = function(Ce, _e, he) {
      this.words = [0], this.length = 1;
      for (var ve = 0, xe = 1; xe <= 67108863; xe *= _e)
        ve++;
      ve--, xe = xe / _e | 0;
      for (var $e = Ce.length - he, Te = $e % ve, Ie = Math.min($e, $e - Te) + he, we = 0, ke = he; ke < Ie; ke += ve)
        we = me(Ce, ke, ke + ve, _e), this.imuln(xe), this.words[0] + we < 67108864 ? this.words[0] += we : this._iaddn(we);
      if (Te !== 0) {
        var ye = 1;
        for (we = me(Ce, ke, Ce.length, _e), ke = 0; ke < Te; ke++)
          ye *= _e;
        this.imuln(ye), this.words[0] + we < 67108864 ? this.words[0] += we : this._iaddn(we);
      }
      this.strip();
    }, se.prototype.copy = function(Ce) {
      Ce.words = new Array(this.length);
      for (var _e = 0; _e < this.length; _e++)
        Ce.words[_e] = this.words[_e];
      Ce.length = this.length, Ce.negative = this.negative, Ce.red = this.red;
    }, se.prototype.clone = function() {
      var Ce = new se(null);
      return this.copy(Ce), Ce;
    }, se.prototype._expand = function(Ce) {
      for (; this.length < Ce; )
        this.words[this.length++] = 0;
      return this;
    }, se.prototype.strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, se.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, se.prototype.inspect = function() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var fe = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], pe = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], ge = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    se.prototype.toString = function(Ce, _e) {
      Ce = Ce || 10, _e = _e | 0 || 1;
      var he;
      if (Ce === 16 || Ce === "hex") {
        he = "";
        for (var ve = 0, xe = 0, $e = 0; $e < this.length; $e++) {
          var Te = this.words[$e], Ie = ((Te << ve | xe) & 16777215).toString(16);
          xe = Te >>> 24 - ve & 16777215, xe !== 0 || $e !== this.length - 1 ? he = fe[6 - Ie.length] + Ie + he : he = Ie + he, ve += 2, ve >= 26 && (ve -= 26, $e--);
        }
        for (xe !== 0 && (he = xe.toString(16) + he); he.length % _e !== 0; )
          he = "0" + he;
        return this.negative !== 0 && (he = "-" + he), he;
      }
      if (Ce === (Ce | 0) && Ce >= 2 && Ce <= 36) {
        var we = pe[Ce], ke = ge[Ce];
        he = "";
        var ye = this.clone();
        for (ye.negative = 0; !ye.isZero(); ) {
          var Be = ye.modn(ke).toString(Ce);
          ye = ye.idivn(ke), ye.isZero() ? he = Be + he : he = fe[we - Be.length] + Be + he;
        }
        for (this.isZero() && (he = "0" + he); he.length % _e !== 0; )
          he = "0" + he;
        return this.negative !== 0 && (he = "-" + he), he;
      }
      ie(!1, "Base should be between 2 and 36");
    }, se.prototype.toNumber = function() {
      var Ce = this.words[0];
      return this.length === 2 ? Ce += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? Ce += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && ie(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -Ce : Ce;
    }, se.prototype.toJSON = function() {
      return this.toString(16);
    }, se.prototype.toBuffer = function(Ce, _e) {
      return ie(typeof ce < "u"), this.toArrayLike(ce, Ce, _e);
    }, se.prototype.toArray = function(Ce, _e) {
      return this.toArrayLike(Array, Ce, _e);
    }, se.prototype.toArrayLike = function(Ce, _e, he) {
      var ve = this.byteLength(), xe = he || Math.max(1, ve);
      ie(ve <= xe, "byte array longer than desired length"), ie(xe > 0, "Requested array length <= 0"), this.strip();
      var $e = _e === "le", Te = new Ce(xe), Ie, we, ke = this.clone();
      if ($e) {
        for (we = 0; !ke.isZero(); we++)
          Ie = ke.andln(255), ke.iushrn(8), Te[we] = Ie;
        for (; we < xe; we++)
          Te[we] = 0;
      } else {
        for (we = 0; we < xe - ve; we++)
          Te[we] = 0;
        for (we = 0; !ke.isZero(); we++)
          Ie = ke.andln(255), ke.iushrn(8), Te[xe - we - 1] = Ie;
      }
      return Te;
    }, Math.clz32 ? se.prototype._countBits = function(Ce) {
      return 32 - Math.clz32(Ce);
    } : se.prototype._countBits = function(Ce) {
      var _e = Ce, he = 0;
      return _e >= 4096 && (he += 13, _e >>>= 13), _e >= 64 && (he += 7, _e >>>= 7), _e >= 8 && (he += 4, _e >>>= 4), _e >= 2 && (he += 2, _e >>>= 2), he + _e;
    }, se.prototype._zeroBits = function(Ce) {
      if (Ce === 0) return 26;
      var _e = Ce, he = 0;
      return _e & 8191 || (he += 13, _e >>>= 13), _e & 127 || (he += 7, _e >>>= 7), _e & 15 || (he += 4, _e >>>= 4), _e & 3 || (he += 2, _e >>>= 2), _e & 1 || he++, he;
    }, se.prototype.bitLength = function() {
      var Ce = this.words[this.length - 1], _e = this._countBits(Ce);
      return (this.length - 1) * 26 + _e;
    };
    function be(Re) {
      for (var Ce = new Array(Re.bitLength()), _e = 0; _e < Ce.length; _e++) {
        var he = _e / 26 | 0, ve = _e % 26;
        Ce[_e] = (Re.words[he] & 1 << ve) >>> ve;
      }
      return Ce;
    }
    se.prototype.zeroBits = function() {
      if (this.isZero()) return 0;
      for (var Ce = 0, _e = 0; _e < this.length; _e++) {
        var he = this._zeroBits(this.words[_e]);
        if (Ce += he, he !== 26) break;
      }
      return Ce;
    }, se.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, se.prototype.toTwos = function(Ce) {
      return this.negative !== 0 ? this.abs().inotn(Ce).iaddn(1) : this.clone();
    }, se.prototype.fromTwos = function(Ce) {
      return this.testn(Ce - 1) ? this.notn(Ce).iaddn(1).ineg() : this.clone();
    }, se.prototype.isNeg = function() {
      return this.negative !== 0;
    }, se.prototype.neg = function() {
      return this.clone().ineg();
    }, se.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, se.prototype.iuor = function(Ce) {
      for (; this.length < Ce.length; )
        this.words[this.length++] = 0;
      for (var _e = 0; _e < Ce.length; _e++)
        this.words[_e] = this.words[_e] | Ce.words[_e];
      return this.strip();
    }, se.prototype.ior = function(Ce) {
      return ie((this.negative | Ce.negative) === 0), this.iuor(Ce);
    }, se.prototype.or = function(Ce) {
      return this.length > Ce.length ? this.clone().ior(Ce) : Ce.clone().ior(this);
    }, se.prototype.uor = function(Ce) {
      return this.length > Ce.length ? this.clone().iuor(Ce) : Ce.clone().iuor(this);
    }, se.prototype.iuand = function(Ce) {
      var _e;
      this.length > Ce.length ? _e = Ce : _e = this;
      for (var he = 0; he < _e.length; he++)
        this.words[he] = this.words[he] & Ce.words[he];
      return this.length = _e.length, this.strip();
    }, se.prototype.iand = function(Ce) {
      return ie((this.negative | Ce.negative) === 0), this.iuand(Ce);
    }, se.prototype.and = function(Ce) {
      return this.length > Ce.length ? this.clone().iand(Ce) : Ce.clone().iand(this);
    }, se.prototype.uand = function(Ce) {
      return this.length > Ce.length ? this.clone().iuand(Ce) : Ce.clone().iuand(this);
    }, se.prototype.iuxor = function(Ce) {
      var _e, he;
      this.length > Ce.length ? (_e = this, he = Ce) : (_e = Ce, he = this);
      for (var ve = 0; ve < he.length; ve++)
        this.words[ve] = _e.words[ve] ^ he.words[ve];
      if (this !== _e)
        for (; ve < _e.length; ve++)
          this.words[ve] = _e.words[ve];
      return this.length = _e.length, this.strip();
    }, se.prototype.ixor = function(Ce) {
      return ie((this.negative | Ce.negative) === 0), this.iuxor(Ce);
    }, se.prototype.xor = function(Ce) {
      return this.length > Ce.length ? this.clone().ixor(Ce) : Ce.clone().ixor(this);
    }, se.prototype.uxor = function(Ce) {
      return this.length > Ce.length ? this.clone().iuxor(Ce) : Ce.clone().iuxor(this);
    }, se.prototype.inotn = function(Ce) {
      ie(typeof Ce == "number" && Ce >= 0);
      var _e = Math.ceil(Ce / 26) | 0, he = Ce % 26;
      this._expand(_e), he > 0 && _e--;
      for (var ve = 0; ve < _e; ve++)
        this.words[ve] = ~this.words[ve] & 67108863;
      return he > 0 && (this.words[ve] = ~this.words[ve] & 67108863 >> 26 - he), this.strip();
    }, se.prototype.notn = function(Ce) {
      return this.clone().inotn(Ce);
    }, se.prototype.setn = function(Ce, _e) {
      ie(typeof Ce == "number" && Ce >= 0);
      var he = Ce / 26 | 0, ve = Ce % 26;
      return this._expand(he + 1), _e ? this.words[he] = this.words[he] | 1 << ve : this.words[he] = this.words[he] & ~(1 << ve), this.strip();
    }, se.prototype.iadd = function(Ce) {
      var _e;
      if (this.negative !== 0 && Ce.negative === 0)
        return this.negative = 0, _e = this.isub(Ce), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && Ce.negative !== 0)
        return Ce.negative = 0, _e = this.isub(Ce), Ce.negative = 1, _e._normSign();
      var he, ve;
      this.length > Ce.length ? (he = this, ve = Ce) : (he = Ce, ve = this);
      for (var xe = 0, $e = 0; $e < ve.length; $e++)
        _e = (he.words[$e] | 0) + (ve.words[$e] | 0) + xe, this.words[$e] = _e & 67108863, xe = _e >>> 26;
      for (; xe !== 0 && $e < he.length; $e++)
        _e = (he.words[$e] | 0) + xe, this.words[$e] = _e & 67108863, xe = _e >>> 26;
      if (this.length = he.length, xe !== 0)
        this.words[this.length] = xe, this.length++;
      else if (he !== this)
        for (; $e < he.length; $e++)
          this.words[$e] = he.words[$e];
      return this;
    }, se.prototype.add = function(Ce) {
      var _e;
      return Ce.negative !== 0 && this.negative === 0 ? (Ce.negative = 0, _e = this.sub(Ce), Ce.negative ^= 1, _e) : Ce.negative === 0 && this.negative !== 0 ? (this.negative = 0, _e = Ce.sub(this), this.negative = 1, _e) : this.length > Ce.length ? this.clone().iadd(Ce) : Ce.clone().iadd(this);
    }, se.prototype.isub = function(Ce) {
      if (Ce.negative !== 0) {
        Ce.negative = 0;
        var _e = this.iadd(Ce);
        return Ce.negative = 1, _e._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(Ce), this.negative = 1, this._normSign();
      var he = this.cmp(Ce);
      if (he === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var ve, xe;
      he > 0 ? (ve = this, xe = Ce) : (ve = Ce, xe = this);
      for (var $e = 0, Te = 0; Te < xe.length; Te++)
        _e = (ve.words[Te] | 0) - (xe.words[Te] | 0) + $e, $e = _e >> 26, this.words[Te] = _e & 67108863;
      for (; $e !== 0 && Te < ve.length; Te++)
        _e = (ve.words[Te] | 0) + $e, $e = _e >> 26, this.words[Te] = _e & 67108863;
      if ($e === 0 && Te < ve.length && ve !== this)
        for (; Te < ve.length; Te++)
          this.words[Te] = ve.words[Te];
      return this.length = Math.max(this.length, Te), ve !== this && (this.negative = 1), this.strip();
    }, se.prototype.sub = function(Ce) {
      return this.clone().isub(Ce);
    };
    function Se(Re, Ce, _e) {
      _e.negative = Ce.negative ^ Re.negative;
      var he = Re.length + Ce.length | 0;
      _e.length = he, he = he - 1 | 0;
      var ve = Re.words[0] | 0, xe = Ce.words[0] | 0, $e = ve * xe, Te = $e & 67108863, Ie = $e / 67108864 | 0;
      _e.words[0] = Te;
      for (var we = 1; we < he; we++) {
        for (var ke = Ie >>> 26, ye = Ie & 67108863, Be = Math.min(we, Ce.length - 1), Xe = Math.max(0, we - Re.length + 1); Xe <= Be; Xe++) {
          var et = we - Xe | 0;
          ve = Re.words[et] | 0, xe = Ce.words[Xe] | 0, $e = ve * xe + ye, ke += $e / 67108864 | 0, ye = $e & 67108863;
        }
        _e.words[we] = ye | 0, Ie = ke | 0;
      }
      return Ie !== 0 ? _e.words[we] = Ie | 0 : _e.length--, _e.strip();
    }
    var Pe = function(Ce, _e, he) {
      var ve = Ce.words, xe = _e.words, $e = he.words, Te = 0, Ie, we, ke, ye = ve[0] | 0, Be = ye & 8191, Xe = ye >>> 13, et = ve[1] | 0, Ye = et & 8191, De = et >>> 13, je = ve[2] | 0, rt = je & 8191, at = je >>> 13, qe = ve[3] | 0, We = qe & 8191, ze = qe >>> 13, Ge = ve[4] | 0, nt = Ge & 8191, ot = Ge >>> 13, lt = ve[5] | 0, mt = lt & 8191, dt = lt >>> 13, gt = ve[6] | 0, bt = gt & 8191, At = gt >>> 13, wt = ve[7] | 0, pt = wt & 8191, ut = wt >>> 13, ht = ve[8] | 0, vt = ht & 8191, xt = ht >>> 13, Bt = ve[9] | 0, Je = Bt & 8191, Me = Bt >>> 13, Le = xe[0] | 0, Qe = Le & 8191, it = Le >>> 13, st = xe[1] | 0, ct = st & 8191, kt = st >>> 13, St = xe[2] | 0, yt = St & 8191, Nt = St >>> 13, _t = xe[3] | 0, Ct = _t & 8191, Ut = _t >>> 13, Ot = xe[4] | 0, $t = Ot & 8191, zt = Ot >>> 13, Dt = xe[5] | 0, Et = Dt & 8191, qt = Dt >>> 13, Lt = xe[6] | 0, Pt = Lt & 8191, Gt = Lt >>> 13, Ft = xe[7] | 0, Vt = Ft & 8191, Wt = Ft >>> 13, Ht = xe[8] | 0, It = Ht & 8191, Kt = Ht >>> 13, jt = xe[9] | 0, Tt = jt & 8191, Yt = jt >>> 13;
      he.negative = Ce.negative ^ _e.negative, he.length = 19, Ie = Math.imul(Be, Qe), we = Math.imul(Be, it), we = we + Math.imul(Xe, Qe) | 0, ke = Math.imul(Xe, it);
      var Mt = (Te + Ie | 0) + ((we & 8191) << 13) | 0;
      Te = (ke + (we >>> 13) | 0) + (Mt >>> 26) | 0, Mt &= 67108863, Ie = Math.imul(Ye, Qe), we = Math.imul(Ye, it), we = we + Math.imul(De, Qe) | 0, ke = Math.imul(De, it), Ie = Ie + Math.imul(Be, ct) | 0, we = we + Math.imul(Be, kt) | 0, we = we + Math.imul(Xe, ct) | 0, ke = ke + Math.imul(Xe, kt) | 0;
      var Rt = (Te + Ie | 0) + ((we & 8191) << 13) | 0;
      Te = (ke + (we >>> 13) | 0) + (Rt >>> 26) | 0, Rt &= 67108863, Ie = Math.imul(rt, Qe), we = Math.imul(rt, it), we = we + Math.imul(at, Qe) | 0, ke = Math.imul(at, it), Ie = Ie + Math.imul(Ye, ct) | 0, we = we + Math.imul(Ye, kt) | 0, we = we + Math.imul(De, ct) | 0, ke = ke + Math.imul(De, kt) | 0, Ie = Ie + Math.imul(Be, yt) | 0, we = we + Math.imul(Be, Nt) | 0, we = we + Math.imul(Xe, yt) | 0, ke = ke + Math.imul(Xe, Nt) | 0;
      var Jt = (Te + Ie | 0) + ((we & 8191) << 13) | 0;
      Te = (ke + (we >>> 13) | 0) + (Jt >>> 26) | 0, Jt &= 67108863, Ie = Math.imul(We, Qe), we = Math.imul(We, it), we = we + Math.imul(ze, Qe) | 0, ke = Math.imul(ze, it), Ie = Ie + Math.imul(rt, ct) | 0, we = we + Math.imul(rt, kt) | 0, we = we + Math.imul(at, ct) | 0, ke = ke + Math.imul(at, kt) | 0, Ie = Ie + Math.imul(Ye, yt) | 0, we = we + Math.imul(Ye, Nt) | 0, we = we + Math.imul(De, yt) | 0, ke = ke + Math.imul(De, Nt) | 0, Ie = Ie + Math.imul(Be, Ct) | 0, we = we + Math.imul(Be, Ut) | 0, we = we + Math.imul(Xe, Ct) | 0, ke = ke + Math.imul(Xe, Ut) | 0;
      var Xt = (Te + Ie | 0) + ((we & 8191) << 13) | 0;
      Te = (ke + (we >>> 13) | 0) + (Xt >>> 26) | 0, Xt &= 67108863, Ie = Math.imul(nt, Qe), we = Math.imul(nt, it), we = we + Math.imul(ot, Qe) | 0, ke = Math.imul(ot, it), Ie = Ie + Math.imul(We, ct) | 0, we = we + Math.imul(We, kt) | 0, we = we + Math.imul(ze, ct) | 0, ke = ke + Math.imul(ze, kt) | 0, Ie = Ie + Math.imul(rt, yt) | 0, we = we + Math.imul(rt, Nt) | 0, we = we + Math.imul(at, yt) | 0, ke = ke + Math.imul(at, Nt) | 0, Ie = Ie + Math.imul(Ye, Ct) | 0, we = we + Math.imul(Ye, Ut) | 0, we = we + Math.imul(De, Ct) | 0, ke = ke + Math.imul(De, Ut) | 0, Ie = Ie + Math.imul(Be, $t) | 0, we = we + Math.imul(Be, zt) | 0, we = we + Math.imul(Xe, $t) | 0, ke = ke + Math.imul(Xe, zt) | 0;
      var Zt = (Te + Ie | 0) + ((we & 8191) << 13) | 0;
      Te = (ke + (we >>> 13) | 0) + (Zt >>> 26) | 0, Zt &= 67108863, Ie = Math.imul(mt, Qe), we = Math.imul(mt, it), we = we + Math.imul(dt, Qe) | 0, ke = Math.imul(dt, it), Ie = Ie + Math.imul(nt, ct) | 0, we = we + Math.imul(nt, kt) | 0, we = we + Math.imul(ot, ct) | 0, ke = ke + Math.imul(ot, kt) | 0, Ie = Ie + Math.imul(We, yt) | 0, we = we + Math.imul(We, Nt) | 0, we = we + Math.imul(ze, yt) | 0, ke = ke + Math.imul(ze, Nt) | 0, Ie = Ie + Math.imul(rt, Ct) | 0, we = we + Math.imul(rt, Ut) | 0, we = we + Math.imul(at, Ct) | 0, ke = ke + Math.imul(at, Ut) | 0, Ie = Ie + Math.imul(Ye, $t) | 0, we = we + Math.imul(Ye, zt) | 0, we = we + Math.imul(De, $t) | 0, ke = ke + Math.imul(De, zt) | 0, Ie = Ie + Math.imul(Be, Et) | 0, we = we + Math.imul(Be, qt) | 0, we = we + Math.imul(Xe, Et) | 0, ke = ke + Math.imul(Xe, qt) | 0;
      var Qt = (Te + Ie | 0) + ((we & 8191) << 13) | 0;
      Te = (ke + (we >>> 13) | 0) + (Qt >>> 26) | 0, Qt &= 67108863, Ie = Math.imul(bt, Qe), we = Math.imul(bt, it), we = we + Math.imul(At, Qe) | 0, ke = Math.imul(At, it), Ie = Ie + Math.imul(mt, ct) | 0, we = we + Math.imul(mt, kt) | 0, we = we + Math.imul(dt, ct) | 0, ke = ke + Math.imul(dt, kt) | 0, Ie = Ie + Math.imul(nt, yt) | 0, we = we + Math.imul(nt, Nt) | 0, we = we + Math.imul(ot, yt) | 0, ke = ke + Math.imul(ot, Nt) | 0, Ie = Ie + Math.imul(We, Ct) | 0, we = we + Math.imul(We, Ut) | 0, we = we + Math.imul(ze, Ct) | 0, ke = ke + Math.imul(ze, Ut) | 0, Ie = Ie + Math.imul(rt, $t) | 0, we = we + Math.imul(rt, zt) | 0, we = we + Math.imul(at, $t) | 0, ke = ke + Math.imul(at, zt) | 0, Ie = Ie + Math.imul(Ye, Et) | 0, we = we + Math.imul(Ye, qt) | 0, we = we + Math.imul(De, Et) | 0, ke = ke + Math.imul(De, qt) | 0, Ie = Ie + Math.imul(Be, Pt) | 0, we = we + Math.imul(Be, Gt) | 0, we = we + Math.imul(Xe, Pt) | 0, ke = ke + Math.imul(Xe, Gt) | 0;
      var er = (Te + Ie | 0) + ((we & 8191) << 13) | 0;
      Te = (ke + (we >>> 13) | 0) + (er >>> 26) | 0, er &= 67108863, Ie = Math.imul(pt, Qe), we = Math.imul(pt, it), we = we + Math.imul(ut, Qe) | 0, ke = Math.imul(ut, it), Ie = Ie + Math.imul(bt, ct) | 0, we = we + Math.imul(bt, kt) | 0, we = we + Math.imul(At, ct) | 0, ke = ke + Math.imul(At, kt) | 0, Ie = Ie + Math.imul(mt, yt) | 0, we = we + Math.imul(mt, Nt) | 0, we = we + Math.imul(dt, yt) | 0, ke = ke + Math.imul(dt, Nt) | 0, Ie = Ie + Math.imul(nt, Ct) | 0, we = we + Math.imul(nt, Ut) | 0, we = we + Math.imul(ot, Ct) | 0, ke = ke + Math.imul(ot, Ut) | 0, Ie = Ie + Math.imul(We, $t) | 0, we = we + Math.imul(We, zt) | 0, we = we + Math.imul(ze, $t) | 0, ke = ke + Math.imul(ze, zt) | 0, Ie = Ie + Math.imul(rt, Et) | 0, we = we + Math.imul(rt, qt) | 0, we = we + Math.imul(at, Et) | 0, ke = ke + Math.imul(at, qt) | 0, Ie = Ie + Math.imul(Ye, Pt) | 0, we = we + Math.imul(Ye, Gt) | 0, we = we + Math.imul(De, Pt) | 0, ke = ke + Math.imul(De, Gt) | 0, Ie = Ie + Math.imul(Be, Vt) | 0, we = we + Math.imul(Be, Wt) | 0, we = we + Math.imul(Xe, Vt) | 0, ke = ke + Math.imul(Xe, Wt) | 0;
      var tr = (Te + Ie | 0) + ((we & 8191) << 13) | 0;
      Te = (ke + (we >>> 13) | 0) + (tr >>> 26) | 0, tr &= 67108863, Ie = Math.imul(vt, Qe), we = Math.imul(vt, it), we = we + Math.imul(xt, Qe) | 0, ke = Math.imul(xt, it), Ie = Ie + Math.imul(pt, ct) | 0, we = we + Math.imul(pt, kt) | 0, we = we + Math.imul(ut, ct) | 0, ke = ke + Math.imul(ut, kt) | 0, Ie = Ie + Math.imul(bt, yt) | 0, we = we + Math.imul(bt, Nt) | 0, we = we + Math.imul(At, yt) | 0, ke = ke + Math.imul(At, Nt) | 0, Ie = Ie + Math.imul(mt, Ct) | 0, we = we + Math.imul(mt, Ut) | 0, we = we + Math.imul(dt, Ct) | 0, ke = ke + Math.imul(dt, Ut) | 0, Ie = Ie + Math.imul(nt, $t) | 0, we = we + Math.imul(nt, zt) | 0, we = we + Math.imul(ot, $t) | 0, ke = ke + Math.imul(ot, zt) | 0, Ie = Ie + Math.imul(We, Et) | 0, we = we + Math.imul(We, qt) | 0, we = we + Math.imul(ze, Et) | 0, ke = ke + Math.imul(ze, qt) | 0, Ie = Ie + Math.imul(rt, Pt) | 0, we = we + Math.imul(rt, Gt) | 0, we = we + Math.imul(at, Pt) | 0, ke = ke + Math.imul(at, Gt) | 0, Ie = Ie + Math.imul(Ye, Vt) | 0, we = we + Math.imul(Ye, Wt) | 0, we = we + Math.imul(De, Vt) | 0, ke = ke + Math.imul(De, Wt) | 0, Ie = Ie + Math.imul(Be, It) | 0, we = we + Math.imul(Be, Kt) | 0, we = we + Math.imul(Xe, It) | 0, ke = ke + Math.imul(Xe, Kt) | 0;
      var rr = (Te + Ie | 0) + ((we & 8191) << 13) | 0;
      Te = (ke + (we >>> 13) | 0) + (rr >>> 26) | 0, rr &= 67108863, Ie = Math.imul(Je, Qe), we = Math.imul(Je, it), we = we + Math.imul(Me, Qe) | 0, ke = Math.imul(Me, it), Ie = Ie + Math.imul(vt, ct) | 0, we = we + Math.imul(vt, kt) | 0, we = we + Math.imul(xt, ct) | 0, ke = ke + Math.imul(xt, kt) | 0, Ie = Ie + Math.imul(pt, yt) | 0, we = we + Math.imul(pt, Nt) | 0, we = we + Math.imul(ut, yt) | 0, ke = ke + Math.imul(ut, Nt) | 0, Ie = Ie + Math.imul(bt, Ct) | 0, we = we + Math.imul(bt, Ut) | 0, we = we + Math.imul(At, Ct) | 0, ke = ke + Math.imul(At, Ut) | 0, Ie = Ie + Math.imul(mt, $t) | 0, we = we + Math.imul(mt, zt) | 0, we = we + Math.imul(dt, $t) | 0, ke = ke + Math.imul(dt, zt) | 0, Ie = Ie + Math.imul(nt, Et) | 0, we = we + Math.imul(nt, qt) | 0, we = we + Math.imul(ot, Et) | 0, ke = ke + Math.imul(ot, qt) | 0, Ie = Ie + Math.imul(We, Pt) | 0, we = we + Math.imul(We, Gt) | 0, we = we + Math.imul(ze, Pt) | 0, ke = ke + Math.imul(ze, Gt) | 0, Ie = Ie + Math.imul(rt, Vt) | 0, we = we + Math.imul(rt, Wt) | 0, we = we + Math.imul(at, Vt) | 0, ke = ke + Math.imul(at, Wt) | 0, Ie = Ie + Math.imul(Ye, It) | 0, we = we + Math.imul(Ye, Kt) | 0, we = we + Math.imul(De, It) | 0, ke = ke + Math.imul(De, Kt) | 0, Ie = Ie + Math.imul(Be, Tt) | 0, we = we + Math.imul(Be, Yt) | 0, we = we + Math.imul(Xe, Tt) | 0, ke = ke + Math.imul(Xe, Yt) | 0;
      var nr = (Te + Ie | 0) + ((we & 8191) << 13) | 0;
      Te = (ke + (we >>> 13) | 0) + (nr >>> 26) | 0, nr &= 67108863, Ie = Math.imul(Je, ct), we = Math.imul(Je, kt), we = we + Math.imul(Me, ct) | 0, ke = Math.imul(Me, kt), Ie = Ie + Math.imul(vt, yt) | 0, we = we + Math.imul(vt, Nt) | 0, we = we + Math.imul(xt, yt) | 0, ke = ke + Math.imul(xt, Nt) | 0, Ie = Ie + Math.imul(pt, Ct) | 0, we = we + Math.imul(pt, Ut) | 0, we = we + Math.imul(ut, Ct) | 0, ke = ke + Math.imul(ut, Ut) | 0, Ie = Ie + Math.imul(bt, $t) | 0, we = we + Math.imul(bt, zt) | 0, we = we + Math.imul(At, $t) | 0, ke = ke + Math.imul(At, zt) | 0, Ie = Ie + Math.imul(mt, Et) | 0, we = we + Math.imul(mt, qt) | 0, we = we + Math.imul(dt, Et) | 0, ke = ke + Math.imul(dt, qt) | 0, Ie = Ie + Math.imul(nt, Pt) | 0, we = we + Math.imul(nt, Gt) | 0, we = we + Math.imul(ot, Pt) | 0, ke = ke + Math.imul(ot, Gt) | 0, Ie = Ie + Math.imul(We, Vt) | 0, we = we + Math.imul(We, Wt) | 0, we = we + Math.imul(ze, Vt) | 0, ke = ke + Math.imul(ze, Wt) | 0, Ie = Ie + Math.imul(rt, It) | 0, we = we + Math.imul(rt, Kt) | 0, we = we + Math.imul(at, It) | 0, ke = ke + Math.imul(at, Kt) | 0, Ie = Ie + Math.imul(Ye, Tt) | 0, we = we + Math.imul(Ye, Yt) | 0, we = we + Math.imul(De, Tt) | 0, ke = ke + Math.imul(De, Yt) | 0;
      var ar = (Te + Ie | 0) + ((we & 8191) << 13) | 0;
      Te = (ke + (we >>> 13) | 0) + (ar >>> 26) | 0, ar &= 67108863, Ie = Math.imul(Je, yt), we = Math.imul(Je, Nt), we = we + Math.imul(Me, yt) | 0, ke = Math.imul(Me, Nt), Ie = Ie + Math.imul(vt, Ct) | 0, we = we + Math.imul(vt, Ut) | 0, we = we + Math.imul(xt, Ct) | 0, ke = ke + Math.imul(xt, Ut) | 0, Ie = Ie + Math.imul(pt, $t) | 0, we = we + Math.imul(pt, zt) | 0, we = we + Math.imul(ut, $t) | 0, ke = ke + Math.imul(ut, zt) | 0, Ie = Ie + Math.imul(bt, Et) | 0, we = we + Math.imul(bt, qt) | 0, we = we + Math.imul(At, Et) | 0, ke = ke + Math.imul(At, qt) | 0, Ie = Ie + Math.imul(mt, Pt) | 0, we = we + Math.imul(mt, Gt) | 0, we = we + Math.imul(dt, Pt) | 0, ke = ke + Math.imul(dt, Gt) | 0, Ie = Ie + Math.imul(nt, Vt) | 0, we = we + Math.imul(nt, Wt) | 0, we = we + Math.imul(ot, Vt) | 0, ke = ke + Math.imul(ot, Wt) | 0, Ie = Ie + Math.imul(We, It) | 0, we = we + Math.imul(We, Kt) | 0, we = we + Math.imul(ze, It) | 0, ke = ke + Math.imul(ze, Kt) | 0, Ie = Ie + Math.imul(rt, Tt) | 0, we = we + Math.imul(rt, Yt) | 0, we = we + Math.imul(at, Tt) | 0, ke = ke + Math.imul(at, Yt) | 0;
      var ir = (Te + Ie | 0) + ((we & 8191) << 13) | 0;
      Te = (ke + (we >>> 13) | 0) + (ir >>> 26) | 0, ir &= 67108863, Ie = Math.imul(Je, Ct), we = Math.imul(Je, Ut), we = we + Math.imul(Me, Ct) | 0, ke = Math.imul(Me, Ut), Ie = Ie + Math.imul(vt, $t) | 0, we = we + Math.imul(vt, zt) | 0, we = we + Math.imul(xt, $t) | 0, ke = ke + Math.imul(xt, zt) | 0, Ie = Ie + Math.imul(pt, Et) | 0, we = we + Math.imul(pt, qt) | 0, we = we + Math.imul(ut, Et) | 0, ke = ke + Math.imul(ut, qt) | 0, Ie = Ie + Math.imul(bt, Pt) | 0, we = we + Math.imul(bt, Gt) | 0, we = we + Math.imul(At, Pt) | 0, ke = ke + Math.imul(At, Gt) | 0, Ie = Ie + Math.imul(mt, Vt) | 0, we = we + Math.imul(mt, Wt) | 0, we = we + Math.imul(dt, Vt) | 0, ke = ke + Math.imul(dt, Wt) | 0, Ie = Ie + Math.imul(nt, It) | 0, we = we + Math.imul(nt, Kt) | 0, we = we + Math.imul(ot, It) | 0, ke = ke + Math.imul(ot, Kt) | 0, Ie = Ie + Math.imul(We, Tt) | 0, we = we + Math.imul(We, Yt) | 0, we = we + Math.imul(ze, Tt) | 0, ke = ke + Math.imul(ze, Yt) | 0;
      var or = (Te + Ie | 0) + ((we & 8191) << 13) | 0;
      Te = (ke + (we >>> 13) | 0) + (or >>> 26) | 0, or &= 67108863, Ie = Math.imul(Je, $t), we = Math.imul(Je, zt), we = we + Math.imul(Me, $t) | 0, ke = Math.imul(Me, zt), Ie = Ie + Math.imul(vt, Et) | 0, we = we + Math.imul(vt, qt) | 0, we = we + Math.imul(xt, Et) | 0, ke = ke + Math.imul(xt, qt) | 0, Ie = Ie + Math.imul(pt, Pt) | 0, we = we + Math.imul(pt, Gt) | 0, we = we + Math.imul(ut, Pt) | 0, ke = ke + Math.imul(ut, Gt) | 0, Ie = Ie + Math.imul(bt, Vt) | 0, we = we + Math.imul(bt, Wt) | 0, we = we + Math.imul(At, Vt) | 0, ke = ke + Math.imul(At, Wt) | 0, Ie = Ie + Math.imul(mt, It) | 0, we = we + Math.imul(mt, Kt) | 0, we = we + Math.imul(dt, It) | 0, ke = ke + Math.imul(dt, Kt) | 0, Ie = Ie + Math.imul(nt, Tt) | 0, we = we + Math.imul(nt, Yt) | 0, we = we + Math.imul(ot, Tt) | 0, ke = ke + Math.imul(ot, Yt) | 0;
      var lr = (Te + Ie | 0) + ((we & 8191) << 13) | 0;
      Te = (ke + (we >>> 13) | 0) + (lr >>> 26) | 0, lr &= 67108863, Ie = Math.imul(Je, Et), we = Math.imul(Je, qt), we = we + Math.imul(Me, Et) | 0, ke = Math.imul(Me, qt), Ie = Ie + Math.imul(vt, Pt) | 0, we = we + Math.imul(vt, Gt) | 0, we = we + Math.imul(xt, Pt) | 0, ke = ke + Math.imul(xt, Gt) | 0, Ie = Ie + Math.imul(pt, Vt) | 0, we = we + Math.imul(pt, Wt) | 0, we = we + Math.imul(ut, Vt) | 0, ke = ke + Math.imul(ut, Wt) | 0, Ie = Ie + Math.imul(bt, It) | 0, we = we + Math.imul(bt, Kt) | 0, we = we + Math.imul(At, It) | 0, ke = ke + Math.imul(At, Kt) | 0, Ie = Ie + Math.imul(mt, Tt) | 0, we = we + Math.imul(mt, Yt) | 0, we = we + Math.imul(dt, Tt) | 0, ke = ke + Math.imul(dt, Yt) | 0;
      var cr = (Te + Ie | 0) + ((we & 8191) << 13) | 0;
      Te = (ke + (we >>> 13) | 0) + (cr >>> 26) | 0, cr &= 67108863, Ie = Math.imul(Je, Pt), we = Math.imul(Je, Gt), we = we + Math.imul(Me, Pt) | 0, ke = Math.imul(Me, Gt), Ie = Ie + Math.imul(vt, Vt) | 0, we = we + Math.imul(vt, Wt) | 0, we = we + Math.imul(xt, Vt) | 0, ke = ke + Math.imul(xt, Wt) | 0, Ie = Ie + Math.imul(pt, It) | 0, we = we + Math.imul(pt, Kt) | 0, we = we + Math.imul(ut, It) | 0, ke = ke + Math.imul(ut, Kt) | 0, Ie = Ie + Math.imul(bt, Tt) | 0, we = we + Math.imul(bt, Yt) | 0, we = we + Math.imul(At, Tt) | 0, ke = ke + Math.imul(At, Yt) | 0;
      var ur = (Te + Ie | 0) + ((we & 8191) << 13) | 0;
      Te = (ke + (we >>> 13) | 0) + (ur >>> 26) | 0, ur &= 67108863, Ie = Math.imul(Je, Vt), we = Math.imul(Je, Wt), we = we + Math.imul(Me, Vt) | 0, ke = Math.imul(Me, Wt), Ie = Ie + Math.imul(vt, It) | 0, we = we + Math.imul(vt, Kt) | 0, we = we + Math.imul(xt, It) | 0, ke = ke + Math.imul(xt, Kt) | 0, Ie = Ie + Math.imul(pt, Tt) | 0, we = we + Math.imul(pt, Yt) | 0, we = we + Math.imul(ut, Tt) | 0, ke = ke + Math.imul(ut, Yt) | 0;
      var dr = (Te + Ie | 0) + ((we & 8191) << 13) | 0;
      Te = (ke + (we >>> 13) | 0) + (dr >>> 26) | 0, dr &= 67108863, Ie = Math.imul(Je, It), we = Math.imul(Je, Kt), we = we + Math.imul(Me, It) | 0, ke = Math.imul(Me, Kt), Ie = Ie + Math.imul(vt, Tt) | 0, we = we + Math.imul(vt, Yt) | 0, we = we + Math.imul(xt, Tt) | 0, ke = ke + Math.imul(xt, Yt) | 0;
      var fr = (Te + Ie | 0) + ((we & 8191) << 13) | 0;
      Te = (ke + (we >>> 13) | 0) + (fr >>> 26) | 0, fr &= 67108863, Ie = Math.imul(Je, Tt), we = Math.imul(Je, Yt), we = we + Math.imul(Me, Tt) | 0, ke = Math.imul(Me, Yt);
      var pr = (Te + Ie | 0) + ((we & 8191) << 13) | 0;
      return Te = (ke + (we >>> 13) | 0) + (pr >>> 26) | 0, pr &= 67108863, $e[0] = Mt, $e[1] = Rt, $e[2] = Jt, $e[3] = Xt, $e[4] = Zt, $e[5] = Qt, $e[6] = er, $e[7] = tr, $e[8] = rr, $e[9] = nr, $e[10] = ar, $e[11] = ir, $e[12] = or, $e[13] = lr, $e[14] = cr, $e[15] = ur, $e[16] = dr, $e[17] = fr, $e[18] = pr, Te !== 0 && ($e[19] = Te, he.length++), he;
    };
    Math.imul || (Pe = Se);
    function Ee(Re, Ce, _e) {
      _e.negative = Ce.negative ^ Re.negative, _e.length = Re.length + Ce.length;
      for (var he = 0, ve = 0, xe = 0; xe < _e.length - 1; xe++) {
        var $e = ve;
        ve = 0;
        for (var Te = he & 67108863, Ie = Math.min(xe, Ce.length - 1), we = Math.max(0, xe - Re.length + 1); we <= Ie; we++) {
          var ke = xe - we, ye = Re.words[ke] | 0, Be = Ce.words[we] | 0, Xe = ye * Be, et = Xe & 67108863;
          $e = $e + (Xe / 67108864 | 0) | 0, et = et + Te | 0, Te = et & 67108863, $e = $e + (et >>> 26) | 0, ve += $e >>> 26, $e &= 67108863;
        }
        _e.words[xe] = Te, he = $e, $e = ve;
      }
      return he !== 0 ? _e.words[xe] = he : _e.length--, _e.strip();
    }
    function Ve(Re, Ce, _e) {
      var he = new Ae();
      return he.mulp(Re, Ce, _e);
    }
    se.prototype.mulTo = function(Ce, _e) {
      var he, ve = this.length + Ce.length;
      return this.length === 10 && Ce.length === 10 ? he = Pe(this, Ce, _e) : ve < 63 ? he = Se(this, Ce, _e) : ve < 1024 ? he = Ee(this, Ce, _e) : he = Ve(this, Ce, _e), he;
    };
    function Ae(Re, Ce) {
      this.x = Re, this.y = Ce;
    }
    Ae.prototype.makeRBT = function(Ce) {
      for (var _e = new Array(Ce), he = se.prototype._countBits(Ce) - 1, ve = 0; ve < Ce; ve++)
        _e[ve] = this.revBin(ve, he, Ce);
      return _e;
    }, Ae.prototype.revBin = function(Ce, _e, he) {
      if (Ce === 0 || Ce === he - 1) return Ce;
      for (var ve = 0, xe = 0; xe < _e; xe++)
        ve |= (Ce & 1) << _e - xe - 1, Ce >>= 1;
      return ve;
    }, Ae.prototype.permute = function(Ce, _e, he, ve, xe, $e) {
      for (var Te = 0; Te < $e; Te++)
        ve[Te] = _e[Ce[Te]], xe[Te] = he[Ce[Te]];
    }, Ae.prototype.transform = function(Ce, _e, he, ve, xe, $e) {
      this.permute($e, Ce, _e, he, ve, xe);
      for (var Te = 1; Te < xe; Te <<= 1)
        for (var Ie = Te << 1, we = Math.cos(2 * Math.PI / Ie), ke = Math.sin(2 * Math.PI / Ie), ye = 0; ye < xe; ye += Ie)
          for (var Be = we, Xe = ke, et = 0; et < Te; et++) {
            var Ye = he[ye + et], De = ve[ye + et], je = he[ye + et + Te], rt = ve[ye + et + Te], at = Be * je - Xe * rt;
            rt = Be * rt + Xe * je, je = at, he[ye + et] = Ye + je, ve[ye + et] = De + rt, he[ye + et + Te] = Ye - je, ve[ye + et + Te] = De - rt, et !== Ie && (at = we * Be - ke * Xe, Xe = we * Xe + ke * Be, Be = at);
          }
    }, Ae.prototype.guessLen13b = function(Ce, _e) {
      var he = Math.max(_e, Ce) | 1, ve = he & 1, xe = 0;
      for (he = he / 2 | 0; he; he = he >>> 1)
        xe++;
      return 1 << xe + 1 + ve;
    }, Ae.prototype.conjugate = function(Ce, _e, he) {
      if (!(he <= 1))
        for (var ve = 0; ve < he / 2; ve++) {
          var xe = Ce[ve];
          Ce[ve] = Ce[he - ve - 1], Ce[he - ve - 1] = xe, xe = _e[ve], _e[ve] = -_e[he - ve - 1], _e[he - ve - 1] = -xe;
        }
    }, Ae.prototype.normalize13b = function(Ce, _e) {
      for (var he = 0, ve = 0; ve < _e / 2; ve++) {
        var xe = Math.round(Ce[2 * ve + 1] / _e) * 8192 + Math.round(Ce[2 * ve] / _e) + he;
        Ce[ve] = xe & 67108863, xe < 67108864 ? he = 0 : he = xe / 67108864 | 0;
      }
      return Ce;
    }, Ae.prototype.convert13b = function(Ce, _e, he, ve) {
      for (var xe = 0, $e = 0; $e < _e; $e++)
        xe = xe + (Ce[$e] | 0), he[2 * $e] = xe & 8191, xe = xe >>> 13, he[2 * $e + 1] = xe & 8191, xe = xe >>> 13;
      for ($e = 2 * _e; $e < ve; ++$e)
        he[$e] = 0;
      ie(xe === 0), ie((xe & -8192) === 0);
    }, Ae.prototype.stub = function(Ce) {
      for (var _e = new Array(Ce), he = 0; he < Ce; he++)
        _e[he] = 0;
      return _e;
    }, Ae.prototype.mulp = function(Ce, _e, he) {
      var ve = 2 * this.guessLen13b(Ce.length, _e.length), xe = this.makeRBT(ve), $e = this.stub(ve), Te = new Array(ve), Ie = new Array(ve), we = new Array(ve), ke = new Array(ve), ye = new Array(ve), Be = new Array(ve), Xe = he.words;
      Xe.length = ve, this.convert13b(Ce.words, Ce.length, Te, ve), this.convert13b(_e.words, _e.length, ke, ve), this.transform(Te, $e, Ie, we, ve, xe), this.transform(ke, $e, ye, Be, ve, xe);
      for (var et = 0; et < ve; et++) {
        var Ye = Ie[et] * ye[et] - we[et] * Be[et];
        we[et] = Ie[et] * Be[et] + we[et] * ye[et], Ie[et] = Ye;
      }
      return this.conjugate(Ie, we, ve), this.transform(Ie, we, Xe, $e, ve, xe), this.conjugate(Xe, $e, ve), this.normalize13b(Xe, ve), he.negative = Ce.negative ^ _e.negative, he.length = Ce.length + _e.length, he.strip();
    }, se.prototype.mul = function(Ce) {
      var _e = new se(null);
      return _e.words = new Array(this.length + Ce.length), this.mulTo(Ce, _e);
    }, se.prototype.mulf = function(Ce) {
      var _e = new se(null);
      return _e.words = new Array(this.length + Ce.length), Ve(this, Ce, _e);
    }, se.prototype.imul = function(Ce) {
      return this.clone().mulTo(Ce, this);
    }, se.prototype.imuln = function(Ce) {
      ie(typeof Ce == "number"), ie(Ce < 67108864);
      for (var _e = 0, he = 0; he < this.length; he++) {
        var ve = (this.words[he] | 0) * Ce, xe = (ve & 67108863) + (_e & 67108863);
        _e >>= 26, _e += ve / 67108864 | 0, _e += xe >>> 26, this.words[he] = xe & 67108863;
      }
      return _e !== 0 && (this.words[he] = _e, this.length++), this;
    }, se.prototype.muln = function(Ce) {
      return this.clone().imuln(Ce);
    }, se.prototype.sqr = function() {
      return this.mul(this);
    }, se.prototype.isqr = function() {
      return this.imul(this.clone());
    }, se.prototype.pow = function(Ce) {
      var _e = be(Ce);
      if (_e.length === 0) return new se(1);
      for (var he = this, ve = 0; ve < _e.length && _e[ve] === 0; ve++, he = he.sqr())
        ;
      if (++ve < _e.length)
        for (var xe = he.sqr(); ve < _e.length; ve++, xe = xe.sqr())
          _e[ve] !== 0 && (he = he.mul(xe));
      return he;
    }, se.prototype.iushln = function(Ce) {
      ie(typeof Ce == "number" && Ce >= 0);
      var _e = Ce % 26, he = (Ce - _e) / 26, ve = 67108863 >>> 26 - _e << 26 - _e, xe;
      if (_e !== 0) {
        var $e = 0;
        for (xe = 0; xe < this.length; xe++) {
          var Te = this.words[xe] & ve, Ie = (this.words[xe] | 0) - Te << _e;
          this.words[xe] = Ie | $e, $e = Te >>> 26 - _e;
        }
        $e && (this.words[xe] = $e, this.length++);
      }
      if (he !== 0) {
        for (xe = this.length - 1; xe >= 0; xe--)
          this.words[xe + he] = this.words[xe];
        for (xe = 0; xe < he; xe++)
          this.words[xe] = 0;
        this.length += he;
      }
      return this.strip();
    }, se.prototype.ishln = function(Ce) {
      return ie(this.negative === 0), this.iushln(Ce);
    }, se.prototype.iushrn = function(Ce, _e, he) {
      ie(typeof Ce == "number" && Ce >= 0);
      var ve;
      _e ? ve = (_e - _e % 26) / 26 : ve = 0;
      var xe = Ce % 26, $e = Math.min((Ce - xe) / 26, this.length), Te = 67108863 ^ 67108863 >>> xe << xe, Ie = he;
      if (ve -= $e, ve = Math.max(0, ve), Ie) {
        for (var we = 0; we < $e; we++)
          Ie.words[we] = this.words[we];
        Ie.length = $e;
      }
      if ($e !== 0) if (this.length > $e)
        for (this.length -= $e, we = 0; we < this.length; we++)
          this.words[we] = this.words[we + $e];
      else
        this.words[0] = 0, this.length = 1;
      var ke = 0;
      for (we = this.length - 1; we >= 0 && (ke !== 0 || we >= ve); we--) {
        var ye = this.words[we] | 0;
        this.words[we] = ke << 26 - xe | ye >>> xe, ke = ye & Te;
      }
      return Ie && ke !== 0 && (Ie.words[Ie.length++] = ke), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
    }, se.prototype.ishrn = function(Ce, _e, he) {
      return ie(this.negative === 0), this.iushrn(Ce, _e, he);
    }, se.prototype.shln = function(Ce) {
      return this.clone().ishln(Ce);
    }, se.prototype.ushln = function(Ce) {
      return this.clone().iushln(Ce);
    }, se.prototype.shrn = function(Ce) {
      return this.clone().ishrn(Ce);
    }, se.prototype.ushrn = function(Ce) {
      return this.clone().iushrn(Ce);
    }, se.prototype.testn = function(Ce) {
      ie(typeof Ce == "number" && Ce >= 0);
      var _e = Ce % 26, he = (Ce - _e) / 26, ve = 1 << _e;
      if (this.length <= he) return !1;
      var xe = this.words[he];
      return !!(xe & ve);
    }, se.prototype.imaskn = function(Ce) {
      ie(typeof Ce == "number" && Ce >= 0);
      var _e = Ce % 26, he = (Ce - _e) / 26;
      if (ie(this.negative === 0, "imaskn works only with positive numbers"), this.length <= he)
        return this;
      if (_e !== 0 && he++, this.length = Math.min(he, this.length), _e !== 0) {
        var ve = 67108863 ^ 67108863 >>> _e << _e;
        this.words[this.length - 1] &= ve;
      }
      return this.strip();
    }, se.prototype.maskn = function(Ce) {
      return this.clone().imaskn(Ce);
    }, se.prototype.iaddn = function(Ce) {
      return ie(typeof Ce == "number"), ie(Ce < 67108864), Ce < 0 ? this.isubn(-Ce) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < Ce ? (this.words[0] = Ce - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(Ce), this.negative = 1, this) : this._iaddn(Ce);
    }, se.prototype._iaddn = function(Ce) {
      this.words[0] += Ce;
      for (var _e = 0; _e < this.length && this.words[_e] >= 67108864; _e++)
        this.words[_e] -= 67108864, _e === this.length - 1 ? this.words[_e + 1] = 1 : this.words[_e + 1]++;
      return this.length = Math.max(this.length, _e + 1), this;
    }, se.prototype.isubn = function(Ce) {
      if (ie(typeof Ce == "number"), ie(Ce < 67108864), Ce < 0) return this.iaddn(-Ce);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(Ce), this.negative = 1, this;
      if (this.words[0] -= Ce, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var _e = 0; _e < this.length && this.words[_e] < 0; _e++)
          this.words[_e] += 67108864, this.words[_e + 1] -= 1;
      return this.strip();
    }, se.prototype.addn = function(Ce) {
      return this.clone().iaddn(Ce);
    }, se.prototype.subn = function(Ce) {
      return this.clone().isubn(Ce);
    }, se.prototype.iabs = function() {
      return this.negative = 0, this;
    }, se.prototype.abs = function() {
      return this.clone().iabs();
    }, se.prototype._ishlnsubmul = function(Ce, _e, he) {
      var ve = Ce.length + he, xe;
      this._expand(ve);
      var $e, Te = 0;
      for (xe = 0; xe < Ce.length; xe++) {
        $e = (this.words[xe + he] | 0) + Te;
        var Ie = (Ce.words[xe] | 0) * _e;
        $e -= Ie & 67108863, Te = ($e >> 26) - (Ie / 67108864 | 0), this.words[xe + he] = $e & 67108863;
      }
      for (; xe < this.length - he; xe++)
        $e = (this.words[xe + he] | 0) + Te, Te = $e >> 26, this.words[xe + he] = $e & 67108863;
      if (Te === 0) return this.strip();
      for (ie(Te === -1), Te = 0, xe = 0; xe < this.length; xe++)
        $e = -(this.words[xe] | 0) + Te, Te = $e >> 26, this.words[xe] = $e & 67108863;
      return this.negative = 1, this.strip();
    }, se.prototype._wordDiv = function(Ce, _e) {
      var he = this.length - Ce.length, ve = this.clone(), xe = Ce, $e = xe.words[xe.length - 1] | 0, Te = this._countBits($e);
      he = 26 - Te, he !== 0 && (xe = xe.ushln(he), ve.iushln(he), $e = xe.words[xe.length - 1] | 0);
      var Ie = ve.length - xe.length, we;
      if (_e !== "mod") {
        we = new se(null), we.length = Ie + 1, we.words = new Array(we.length);
        for (var ke = 0; ke < we.length; ke++)
          we.words[ke] = 0;
      }
      var ye = ve.clone()._ishlnsubmul(xe, 1, Ie);
      ye.negative === 0 && (ve = ye, we && (we.words[Ie] = 1));
      for (var Be = Ie - 1; Be >= 0; Be--) {
        var Xe = (ve.words[xe.length + Be] | 0) * 67108864 + (ve.words[xe.length + Be - 1] | 0);
        for (Xe = Math.min(Xe / $e | 0, 67108863), ve._ishlnsubmul(xe, Xe, Be); ve.negative !== 0; )
          Xe--, ve.negative = 0, ve._ishlnsubmul(xe, 1, Be), ve.isZero() || (ve.negative ^= 1);
        we && (we.words[Be] = Xe);
      }
      return we && we.strip(), ve.strip(), _e !== "div" && he !== 0 && ve.iushrn(he), {
        div: we || null,
        mod: ve
      };
    }, se.prototype.divmod = function(Ce, _e, he) {
      if (ie(!Ce.isZero()), this.isZero())
        return {
          div: new se(0),
          mod: new se(0)
        };
      var ve, xe, $e;
      return this.negative !== 0 && Ce.negative === 0 ? ($e = this.neg().divmod(Ce, _e), _e !== "mod" && (ve = $e.div.neg()), _e !== "div" && (xe = $e.mod.neg(), he && xe.negative !== 0 && xe.iadd(Ce)), {
        div: ve,
        mod: xe
      }) : this.negative === 0 && Ce.negative !== 0 ? ($e = this.divmod(Ce.neg(), _e), _e !== "mod" && (ve = $e.div.neg()), {
        div: ve,
        mod: $e.mod
      }) : this.negative & Ce.negative ? ($e = this.neg().divmod(Ce.neg(), _e), _e !== "div" && (xe = $e.mod.neg(), he && xe.negative !== 0 && xe.isub(Ce)), {
        div: $e.div,
        mod: xe
      }) : Ce.length > this.length || this.cmp(Ce) < 0 ? {
        div: new se(0),
        mod: this
      } : Ce.length === 1 ? _e === "div" ? {
        div: this.divn(Ce.words[0]),
        mod: null
      } : _e === "mod" ? {
        div: null,
        mod: new se(this.modn(Ce.words[0]))
      } : {
        div: this.divn(Ce.words[0]),
        mod: new se(this.modn(Ce.words[0]))
      } : this._wordDiv(Ce, _e);
    }, se.prototype.div = function(Ce) {
      return this.divmod(Ce, "div", !1).div;
    }, se.prototype.mod = function(Ce) {
      return this.divmod(Ce, "mod", !1).mod;
    }, se.prototype.umod = function(Ce) {
      return this.divmod(Ce, "mod", !0).mod;
    }, se.prototype.divRound = function(Ce) {
      var _e = this.divmod(Ce);
      if (_e.mod.isZero()) return _e.div;
      var he = _e.div.negative !== 0 ? _e.mod.isub(Ce) : _e.mod, ve = Ce.ushrn(1), xe = Ce.andln(1), $e = he.cmp(ve);
      return $e < 0 || xe === 1 && $e === 0 ? _e.div : _e.div.negative !== 0 ? _e.div.isubn(1) : _e.div.iaddn(1);
    }, se.prototype.modn = function(Ce) {
      ie(Ce <= 67108863);
      for (var _e = (1 << 26) % Ce, he = 0, ve = this.length - 1; ve >= 0; ve--)
        he = (_e * he + (this.words[ve] | 0)) % Ce;
      return he;
    }, se.prototype.idivn = function(Ce) {
      ie(Ce <= 67108863);
      for (var _e = 0, he = this.length - 1; he >= 0; he--) {
        var ve = (this.words[he] | 0) + _e * 67108864;
        this.words[he] = ve / Ce | 0, _e = ve % Ce;
      }
      return this.strip();
    }, se.prototype.divn = function(Ce) {
      return this.clone().idivn(Ce);
    }, se.prototype.egcd = function(Ce) {
      ie(Ce.negative === 0), ie(!Ce.isZero());
      var _e = this, he = Ce.clone();
      _e.negative !== 0 ? _e = _e.umod(Ce) : _e = _e.clone();
      for (var ve = new se(1), xe = new se(0), $e = new se(0), Te = new se(1), Ie = 0; _e.isEven() && he.isEven(); )
        _e.iushrn(1), he.iushrn(1), ++Ie;
      for (var we = he.clone(), ke = _e.clone(); !_e.isZero(); ) {
        for (var ye = 0, Be = 1; !(_e.words[0] & Be) && ye < 26; ++ye, Be <<= 1) ;
        if (ye > 0)
          for (_e.iushrn(ye); ye-- > 0; )
            (ve.isOdd() || xe.isOdd()) && (ve.iadd(we), xe.isub(ke)), ve.iushrn(1), xe.iushrn(1);
        for (var Xe = 0, et = 1; !(he.words[0] & et) && Xe < 26; ++Xe, et <<= 1) ;
        if (Xe > 0)
          for (he.iushrn(Xe); Xe-- > 0; )
            ($e.isOdd() || Te.isOdd()) && ($e.iadd(we), Te.isub(ke)), $e.iushrn(1), Te.iushrn(1);
        _e.cmp(he) >= 0 ? (_e.isub(he), ve.isub($e), xe.isub(Te)) : (he.isub(_e), $e.isub(ve), Te.isub(xe));
      }
      return {
        a: $e,
        b: Te,
        gcd: he.iushln(Ie)
      };
    }, se.prototype._invmp = function(Ce) {
      ie(Ce.negative === 0), ie(!Ce.isZero());
      var _e = this, he = Ce.clone();
      _e.negative !== 0 ? _e = _e.umod(Ce) : _e = _e.clone();
      for (var ve = new se(1), xe = new se(0), $e = he.clone(); _e.cmpn(1) > 0 && he.cmpn(1) > 0; ) {
        for (var Te = 0, Ie = 1; !(_e.words[0] & Ie) && Te < 26; ++Te, Ie <<= 1) ;
        if (Te > 0)
          for (_e.iushrn(Te); Te-- > 0; )
            ve.isOdd() && ve.iadd($e), ve.iushrn(1);
        for (var we = 0, ke = 1; !(he.words[0] & ke) && we < 26; ++we, ke <<= 1) ;
        if (we > 0)
          for (he.iushrn(we); we-- > 0; )
            xe.isOdd() && xe.iadd($e), xe.iushrn(1);
        _e.cmp(he) >= 0 ? (_e.isub(he), ve.isub(xe)) : (he.isub(_e), xe.isub(ve));
      }
      var ye;
      return _e.cmpn(1) === 0 ? ye = ve : ye = xe, ye.cmpn(0) < 0 && ye.iadd(Ce), ye;
    }, se.prototype.gcd = function(Ce) {
      if (this.isZero()) return Ce.abs();
      if (Ce.isZero()) return this.abs();
      var _e = this.clone(), he = Ce.clone();
      _e.negative = 0, he.negative = 0;
      for (var ve = 0; _e.isEven() && he.isEven(); ve++)
        _e.iushrn(1), he.iushrn(1);
      do {
        for (; _e.isEven(); )
          _e.iushrn(1);
        for (; he.isEven(); )
          he.iushrn(1);
        var xe = _e.cmp(he);
        if (xe < 0) {
          var $e = _e;
          _e = he, he = $e;
        } else if (xe === 0 || he.cmpn(1) === 0)
          break;
        _e.isub(he);
      } while (!0);
      return he.iushln(ve);
    }, se.prototype.invm = function(Ce) {
      return this.egcd(Ce).a.umod(Ce);
    }, se.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, se.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, se.prototype.andln = function(Ce) {
      return this.words[0] & Ce;
    }, se.prototype.bincn = function(Ce) {
      ie(typeof Ce == "number");
      var _e = Ce % 26, he = (Ce - _e) / 26, ve = 1 << _e;
      if (this.length <= he)
        return this._expand(he + 1), this.words[he] |= ve, this;
      for (var xe = ve, $e = he; xe !== 0 && $e < this.length; $e++) {
        var Te = this.words[$e] | 0;
        Te += xe, xe = Te >>> 26, Te &= 67108863, this.words[$e] = Te;
      }
      return xe !== 0 && (this.words[$e] = xe, this.length++), this;
    }, se.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, se.prototype.cmpn = function(Ce) {
      var _e = Ce < 0;
      if (this.negative !== 0 && !_e) return -1;
      if (this.negative === 0 && _e) return 1;
      this.strip();
      var he;
      if (this.length > 1)
        he = 1;
      else {
        _e && (Ce = -Ce), ie(Ce <= 67108863, "Number is too big");
        var ve = this.words[0] | 0;
        he = ve === Ce ? 0 : ve < Ce ? -1 : 1;
      }
      return this.negative !== 0 ? -he | 0 : he;
    }, se.prototype.cmp = function(Ce) {
      if (this.negative !== 0 && Ce.negative === 0) return -1;
      if (this.negative === 0 && Ce.negative !== 0) return 1;
      var _e = this.ucmp(Ce);
      return this.negative !== 0 ? -_e | 0 : _e;
    }, se.prototype.ucmp = function(Ce) {
      if (this.length > Ce.length) return 1;
      if (this.length < Ce.length) return -1;
      for (var _e = 0, he = this.length - 1; he >= 0; he--) {
        var ve = this.words[he] | 0, xe = Ce.words[he] | 0;
        if (ve !== xe) {
          ve < xe ? _e = -1 : ve > xe && (_e = 1);
          break;
        }
      }
      return _e;
    }, se.prototype.gtn = function(Ce) {
      return this.cmpn(Ce) === 1;
    }, se.prototype.gt = function(Ce) {
      return this.cmp(Ce) === 1;
    }, se.prototype.gten = function(Ce) {
      return this.cmpn(Ce) >= 0;
    }, se.prototype.gte = function(Ce) {
      return this.cmp(Ce) >= 0;
    }, se.prototype.ltn = function(Ce) {
      return this.cmpn(Ce) === -1;
    }, se.prototype.lt = function(Ce) {
      return this.cmp(Ce) === -1;
    }, se.prototype.lten = function(Ce) {
      return this.cmpn(Ce) <= 0;
    }, se.prototype.lte = function(Ce) {
      return this.cmp(Ce) <= 0;
    }, se.prototype.eqn = function(Ce) {
      return this.cmpn(Ce) === 0;
    }, se.prototype.eq = function(Ce) {
      return this.cmp(Ce) === 0;
    }, se.red = function(Ce) {
      return new Ke(Ce);
    }, se.prototype.toRed = function(Ce) {
      return ie(!this.red, "Already a number in reduction context"), ie(this.negative === 0, "red works only with positives"), Ce.convertTo(this)._forceRed(Ce);
    }, se.prototype.fromRed = function() {
      return ie(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, se.prototype._forceRed = function(Ce) {
      return this.red = Ce, this;
    }, se.prototype.forceRed = function(Ce) {
      return ie(!this.red, "Already a number in reduction context"), this._forceRed(Ce);
    }, se.prototype.redAdd = function(Ce) {
      return ie(this.red, "redAdd works only with red numbers"), this.red.add(this, Ce);
    }, se.prototype.redIAdd = function(Ce) {
      return ie(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, Ce);
    }, se.prototype.redSub = function(Ce) {
      return ie(this.red, "redSub works only with red numbers"), this.red.sub(this, Ce);
    }, se.prototype.redISub = function(Ce) {
      return ie(this.red, "redISub works only with red numbers"), this.red.isub(this, Ce);
    }, se.prototype.redShl = function(Ce) {
      return ie(this.red, "redShl works only with red numbers"), this.red.shl(this, Ce);
    }, se.prototype.redMul = function(Ce) {
      return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ce), this.red.mul(this, Ce);
    }, se.prototype.redIMul = function(Ce) {
      return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, Ce), this.red.imul(this, Ce);
    }, se.prototype.redSqr = function() {
      return ie(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, se.prototype.redISqr = function() {
      return ie(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, se.prototype.redSqrt = function() {
      return ie(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, se.prototype.redInvm = function() {
      return ie(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, se.prototype.redNeg = function() {
      return ie(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, se.prototype.redPow = function(Ce) {
      return ie(this.red && !Ce.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, Ce);
    };
    var Oe = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function Ne(Re, Ce) {
      this.name = Re, this.p = new se(Ce, 16), this.n = this.p.bitLength(), this.k = new se(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    Ne.prototype._tmp = function() {
      var Ce = new se(null);
      return Ce.words = new Array(Math.ceil(this.n / 13)), Ce;
    }, Ne.prototype.ireduce = function(Ce) {
      var _e = Ce, he;
      do
        this.split(_e, this.tmp), _e = this.imulK(_e), _e = _e.iadd(this.tmp), he = _e.bitLength();
      while (he > this.n);
      var ve = he < this.n ? -1 : _e.ucmp(this.p);
      return ve === 0 ? (_e.words[0] = 0, _e.length = 1) : ve > 0 ? _e.isub(this.p) : _e.strip !== void 0 ? _e.strip() : _e._strip(), _e;
    }, Ne.prototype.split = function(Ce, _e) {
      Ce.iushrn(this.n, 0, _e);
    }, Ne.prototype.imulK = function(Ce) {
      return Ce.imul(this.k);
    };
    function He() {
      Ne.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    le(He, Ne), He.prototype.split = function(Ce, _e) {
      for (var he = 4194303, ve = Math.min(Ce.length, 9), xe = 0; xe < ve; xe++)
        _e.words[xe] = Ce.words[xe];
      if (_e.length = ve, Ce.length <= 9) {
        Ce.words[0] = 0, Ce.length = 1;
        return;
      }
      var $e = Ce.words[9];
      for (_e.words[_e.length++] = $e & he, xe = 10; xe < Ce.length; xe++) {
        var Te = Ce.words[xe] | 0;
        Ce.words[xe - 10] = (Te & he) << 4 | $e >>> 22, $e = Te;
      }
      $e >>>= 22, Ce.words[xe - 10] = $e, $e === 0 && Ce.length > 10 ? Ce.length -= 10 : Ce.length -= 9;
    }, He.prototype.imulK = function(Ce) {
      Ce.words[Ce.length] = 0, Ce.words[Ce.length + 1] = 0, Ce.length += 2;
      for (var _e = 0, he = 0; he < Ce.length; he++) {
        var ve = Ce.words[he] | 0;
        _e += ve * 977, Ce.words[he] = _e & 67108863, _e = ve * 64 + (_e / 67108864 | 0);
      }
      return Ce.words[Ce.length - 1] === 0 && (Ce.length--, Ce.words[Ce.length - 1] === 0 && Ce.length--), Ce;
    };
    function Ue() {
      Ne.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    le(Ue, Ne);
    function Ze() {
      Ne.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    le(Ze, Ne);
    function Fe() {
      Ne.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    le(Fe, Ne), Fe.prototype.imulK = function(Ce) {
      for (var _e = 0, he = 0; he < Ce.length; he++) {
        var ve = (Ce.words[he] | 0) * 19 + _e, xe = ve & 67108863;
        ve >>>= 26, Ce.words[he] = xe, _e = ve;
      }
      return _e !== 0 && (Ce.words[Ce.length++] = _e), Ce;
    }, se._prime = function(Ce) {
      if (Oe[Ce]) return Oe[Ce];
      var _e;
      if (Ce === "k256")
        _e = new He();
      else if (Ce === "p224")
        _e = new Ue();
      else if (Ce === "p192")
        _e = new Ze();
      else if (Ce === "p25519")
        _e = new Fe();
      else
        throw new Error("Unknown prime " + Ce);
      return Oe[Ce] = _e, _e;
    };
    function Ke(Re) {
      if (typeof Re == "string") {
        var Ce = se._prime(Re);
        this.m = Ce.p, this.prime = Ce;
      } else
        ie(Re.gtn(1), "modulus must be greater than 1"), this.m = Re, this.prime = null;
    }
    Ke.prototype._verify1 = function(Ce) {
      ie(Ce.negative === 0, "red works only with positives"), ie(Ce.red, "red works only with red numbers");
    }, Ke.prototype._verify2 = function(Ce, _e) {
      ie((Ce.negative | _e.negative) === 0, "red works only with positives"), ie(
        Ce.red && Ce.red === _e.red,
        "red works only with red numbers"
      );
    }, Ke.prototype.imod = function(Ce) {
      return this.prime ? this.prime.ireduce(Ce)._forceRed(this) : Ce.umod(this.m)._forceRed(this);
    }, Ke.prototype.neg = function(Ce) {
      return Ce.isZero() ? Ce.clone() : this.m.sub(Ce)._forceRed(this);
    }, Ke.prototype.add = function(Ce, _e) {
      this._verify2(Ce, _e);
      var he = Ce.add(_e);
      return he.cmp(this.m) >= 0 && he.isub(this.m), he._forceRed(this);
    }, Ke.prototype.iadd = function(Ce, _e) {
      this._verify2(Ce, _e);
      var he = Ce.iadd(_e);
      return he.cmp(this.m) >= 0 && he.isub(this.m), he;
    }, Ke.prototype.sub = function(Ce, _e) {
      this._verify2(Ce, _e);
      var he = Ce.sub(_e);
      return he.cmpn(0) < 0 && he.iadd(this.m), he._forceRed(this);
    }, Ke.prototype.isub = function(Ce, _e) {
      this._verify2(Ce, _e);
      var he = Ce.isub(_e);
      return he.cmpn(0) < 0 && he.iadd(this.m), he;
    }, Ke.prototype.shl = function(Ce, _e) {
      return this._verify1(Ce), this.imod(Ce.ushln(_e));
    }, Ke.prototype.imul = function(Ce, _e) {
      return this._verify2(Ce, _e), this.imod(Ce.imul(_e));
    }, Ke.prototype.mul = function(Ce, _e) {
      return this._verify2(Ce, _e), this.imod(Ce.mul(_e));
    }, Ke.prototype.isqr = function(Ce) {
      return this.imul(Ce, Ce.clone());
    }, Ke.prototype.sqr = function(Ce) {
      return this.mul(Ce, Ce);
    }, Ke.prototype.sqrt = function(Ce) {
      if (Ce.isZero()) return Ce.clone();
      var _e = this.m.andln(3);
      if (ie(_e % 2 === 1), _e === 3) {
        var he = this.m.add(new se(1)).iushrn(2);
        return this.pow(Ce, he);
      }
      for (var ve = this.m.subn(1), xe = 0; !ve.isZero() && ve.andln(1) === 0; )
        xe++, ve.iushrn(1);
      ie(!ve.isZero());
      var $e = new se(1).toRed(this), Te = $e.redNeg(), Ie = this.m.subn(1).iushrn(1), we = this.m.bitLength();
      for (we = new se(2 * we * we).toRed(this); this.pow(we, Ie).cmp(Te) !== 0; )
        we.redIAdd(Te);
      for (var ke = this.pow(we, ve), ye = this.pow(Ce, ve.addn(1).iushrn(1)), Be = this.pow(Ce, ve), Xe = xe; Be.cmp($e) !== 0; ) {
        for (var et = Be, Ye = 0; et.cmp($e) !== 0; Ye++)
          et = et.redSqr();
        ie(Ye < Xe);
        var De = this.pow(ke, new se(1).iushln(Xe - Ye - 1));
        ye = ye.redMul(De), ke = De.redSqr(), Be = Be.redMul(ke), Xe = Ye;
      }
      return ye;
    }, Ke.prototype.invm = function(Ce) {
      var _e = Ce._invmp(this.m);
      return _e.negative !== 0 ? (_e.negative = 0, this.imod(_e).redNeg()) : this.imod(_e);
    }, Ke.prototype.pow = function(Ce, _e) {
      if (_e.isZero()) return new se(1).toRed(this);
      if (_e.cmpn(1) === 0) return Ce.clone();
      var he = 4, ve = new Array(1 << he);
      ve[0] = new se(1).toRed(this), ve[1] = Ce;
      for (var xe = 2; xe < ve.length; xe++)
        ve[xe] = this.mul(ve[xe - 1], Ce);
      var $e = ve[0], Te = 0, Ie = 0, we = _e.bitLength() % 26;
      for (we === 0 && (we = 26), xe = _e.length - 1; xe >= 0; xe--) {
        for (var ke = _e.words[xe], ye = we - 1; ye >= 0; ye--) {
          var Be = ke >> ye & 1;
          if ($e !== ve[0] && ($e = this.sqr($e)), Be === 0 && Te === 0) {
            Ie = 0;
            continue;
          }
          Te <<= 1, Te |= Be, Ie++, !(Ie !== he && (xe !== 0 || ye !== 0)) && ($e = this.mul($e, ve[Te]), Ie = 0, Te = 0);
        }
        we = 26;
      }
      return $e;
    }, Ke.prototype.convertTo = function(Ce) {
      var _e = Ce.umod(this.m);
      return _e === Ce ? _e.clone() : _e;
    }, Ke.prototype.convertFrom = function(Ce) {
      var _e = Ce.clone();
      return _e.red = null, _e;
    }, se.mont = function(Ce) {
      return new tt(Ce);
    };
    function tt(Re) {
      Ke.call(this, Re), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new se(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    le(tt, Ke), tt.prototype.convertTo = function(Ce) {
      return this.imod(Ce.ushln(this.shift));
    }, tt.prototype.convertFrom = function(Ce) {
      var _e = this.imod(Ce.mul(this.rinv));
      return _e.red = null, _e;
    }, tt.prototype.imul = function(Ce, _e) {
      if (Ce.isZero() || _e.isZero())
        return Ce.words[0] = 0, Ce.length = 1, Ce;
      var he = Ce.imul(_e), ve = he.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), xe = he.isub(ve).iushrn(this.shift), $e = xe;
      return xe.cmp(this.m) >= 0 ? $e = xe.isub(this.m) : xe.cmpn(0) < 0 && ($e = xe.iadd(this.m)), $e._forceRed(this);
    }, tt.prototype.mul = function(Ce, _e) {
      if (Ce.isZero() || _e.isZero()) return new se(0)._forceRed(this);
      var he = Ce.mul(_e), ve = he.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), xe = he.isub(ve).iushrn(this.shift), $e = xe;
      return xe.cmp(this.m) >= 0 ? $e = xe.isub(this.m) : xe.cmpn(0) < 0 && ($e = xe.iadd(this.m)), $e._forceRed(this);
    }, tt.prototype.invm = function(Ce) {
      var _e = this.imod(Ce._invmp(this.m).mul(this.r2));
      return _e._forceRed(this);
    };
  })(re, commonjsGlobal);
})(bn$2);
var bnExports$2 = bn$2.exports, brorand = { exports: {} }, hasRequiredBrorand;
function requireBrorand() {
  if (hasRequiredBrorand) return brorand.exports;
  hasRequiredBrorand = 1;
  var re;
  brorand.exports = function(le) {
    return re || (re = new ne(null)), re.generate(le);
  };
  function ne(ie) {
    this.rand = ie;
  }
  if (brorand.exports.Rand = ne, ne.prototype.generate = function(le) {
    return this._rand(le);
  }, ne.prototype._rand = function(le) {
    if (this.rand.getBytes)
      return this.rand.getBytes(le);
    for (var se = new Uint8Array(le), ce = 0; ce < se.length; ce++)
      se[ce] = this.rand.getByte();
    return se;
  }, typeof self == "object")
    self.crypto && self.crypto.getRandomValues ? ne.prototype._rand = function(le) {
      var se = new Uint8Array(le);
      return self.crypto.getRandomValues(se), se;
    } : self.msCrypto && self.msCrypto.getRandomValues ? ne.prototype._rand = function(le) {
      var se = new Uint8Array(le);
      return self.msCrypto.getRandomValues(se), se;
    } : typeof window == "object" && (ne.prototype._rand = function() {
      throw new Error("Not implemented yet");
    });
  else
    try {
      var ae = requireCryptoBrowserify();
      if (typeof ae.randomBytes != "function")
        throw new Error("Not supported");
      ne.prototype._rand = function(le) {
        return ae.randomBytes(le);
      };
    } catch {
    }
  return brorand.exports;
}
var mr, hasRequiredMr;
function requireMr() {
  if (hasRequiredMr) return mr;
  hasRequiredMr = 1;
  var re = bnExports$2, ne = requireBrorand();
  function ae(ie) {
    this.rand = ie || new ne.Rand();
  }
  return mr = ae, ae.create = function(le) {
    return new ae(le);
  }, ae.prototype._randbelow = function(le) {
    var se = le.bitLength(), ce = Math.ceil(se / 8);
    do
      var ue = new re(this.rand.generate(ce));
    while (ue.cmp(le) >= 0);
    return ue;
  }, ae.prototype._randrange = function(le, se) {
    var ce = se.sub(le);
    return le.add(this._randbelow(ce));
  }, ae.prototype.test = function(le, se, ce) {
    var ue = le.bitLength(), de = re.mont(le), me = new re(1).toRed(de);
    se || (se = Math.max(1, ue / 48 | 0));
    for (var fe = le.subn(1), pe = 0; !fe.testn(pe); pe++)
      ;
    for (var ge = le.shrn(pe), be = fe.toRed(de), Se = !0; se > 0; se--) {
      var Pe = this._randrange(new re(2), fe);
      ce && ce(Pe);
      var Ee = Pe.toRed(de).redPow(ge);
      if (!(Ee.cmp(me) === 0 || Ee.cmp(be) === 0)) {
        for (var Ve = 1; Ve < pe; Ve++) {
          if (Ee = Ee.redSqr(), Ee.cmp(me) === 0)
            return !1;
          if (Ee.cmp(be) === 0)
            break;
        }
        if (Ve === pe)
          return !1;
      }
    }
    return Se;
  }, ae.prototype.getDivisor = function(le, se) {
    var ce = le.bitLength(), ue = re.mont(le), de = new re(1).toRed(ue);
    se || (se = Math.max(1, ce / 48 | 0));
    for (var me = le.subn(1), fe = 0; !me.testn(fe); fe++)
      ;
    for (var pe = le.shrn(fe), ge = me.toRed(ue); se > 0; se--) {
      var be = this._randrange(new re(2), me), Se = le.gcd(be);
      if (Se.cmpn(1) !== 0)
        return Se;
      var Pe = be.toRed(ue).redPow(pe);
      if (!(Pe.cmp(de) === 0 || Pe.cmp(ge) === 0)) {
        for (var Ee = 1; Ee < fe; Ee++) {
          if (Pe = Pe.redSqr(), Pe.cmp(de) === 0)
            return Pe.fromRed().subn(1).gcd(le);
          if (Pe.cmp(ge) === 0)
            break;
        }
        if (Ee === fe)
          return Pe = Pe.redSqr(), Pe.fromRed().subn(1).gcd(le);
      }
    }
    return !1;
  }, mr;
}
var generatePrime, hasRequiredGeneratePrime;
function requireGeneratePrime() {
  if (hasRequiredGeneratePrime) return generatePrime;
  hasRequiredGeneratePrime = 1;
  var re = browserExports;
  generatePrime = Ee, Ee.simpleSieve = Se, Ee.fermatTest = Pe;
  var ne = bnExports$2, ae = new ne(24), ie = requireMr(), le = new ie(), se = new ne(1), ce = new ne(2), ue = new ne(5);
  new ne(16), new ne(8);
  var de = new ne(10), me = new ne(3);
  new ne(7);
  var fe = new ne(11), pe = new ne(4);
  new ne(12);
  var ge = null;
  function be() {
    if (ge !== null)
      return ge;
    var Ve = 1048576, Ae = [];
    Ae[0] = 2;
    for (var Oe = 1, Ne = 3; Ne < Ve; Ne += 2) {
      for (var He = Math.ceil(Math.sqrt(Ne)), Ue = 0; Ue < Oe && Ae[Ue] <= He && Ne % Ae[Ue] !== 0; Ue++)
        ;
      Oe !== Ue && Ae[Ue] <= He || (Ae[Oe++] = Ne);
    }
    return ge = Ae, Ae;
  }
  function Se(Ve) {
    for (var Ae = be(), Oe = 0; Oe < Ae.length; Oe++)
      if (Ve.modn(Ae[Oe]) === 0)
        return Ve.cmpn(Ae[Oe]) === 0;
    return !0;
  }
  function Pe(Ve) {
    var Ae = ne.mont(Ve);
    return ce.toRed(Ae).redPow(Ve.subn(1)).fromRed().cmpn(1) === 0;
  }
  function Ee(Ve, Ae) {
    if (Ve < 16)
      return Ae === 2 || Ae === 5 ? new ne([140, 123]) : new ne([140, 39]);
    Ae = new ne(Ae);
    for (var Oe, Ne; ; ) {
      for (Oe = new ne(re(Math.ceil(Ve / 8))); Oe.bitLength() > Ve; )
        Oe.ishrn(1);
      if (Oe.isEven() && Oe.iadd(se), Oe.testn(1) || Oe.iadd(ce), Ae.cmp(ce)) {
        if (!Ae.cmp(ue))
          for (; Oe.mod(de).cmp(me); )
            Oe.iadd(pe);
      } else for (; Oe.mod(ae).cmp(fe); )
        Oe.iadd(pe);
      if (Ne = Oe.shrn(1), Se(Ne) && Se(Oe) && Pe(Ne) && Pe(Oe) && le.test(Ne) && le.test(Oe))
        return Oe;
    }
  }
  return generatePrime;
}
const modp1 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
}, modp2 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
}, modp5 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
}, modp14 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
}, modp15 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
}, modp16 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
}, modp17 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
}, modp18 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dbe115974a3926f12fee5e438777cb6a932df8cd8bec4d073b931ba3bc832b68d9dd300741fa7bf8afc47ed2576f6936ba424663aab639c5ae4f5683423b4742bf1c978238f16cbe39d652de3fdb8befc848ad922222e04a4037c0713eb57a81a23f0c73473fc646cea306b4bcbc8862f8385ddfa9d4b7fa2c087e879683303ed5bdd3a062b3cf5b3a278a66d2a13f83f44f82ddf310ee074ab6a364597e899a0255dc164f31cc50846851df9ab48195ded7ea1b1d510bd7ee74d73faf36bc31ecfa268359046f4eb879f924009438b481c6cd7889a002ed5ee382bc9190da6fc026e479558e4475677e9aa9e3050e2765694dfc81f56e880b96e7160c980dd98edd3dfffffffffffffffff"
}, require$$1$1 = {
  modp1,
  modp2,
  modp5,
  modp14,
  modp15,
  modp16,
  modp17,
  modp18
};
var dh, hasRequiredDh;
function requireDh() {
  if (hasRequiredDh) return dh;
  hasRequiredDh = 1;
  var re = bnExports$2, ne = requireMr(), ae = new ne(), ie = new re(24), le = new re(11), se = new re(10), ce = new re(3), ue = new re(7), de = requireGeneratePrime(), me = browserExports;
  dh = Se;
  function fe(Ee, Ve) {
    return Ve = Ve || "utf8", Buffer$D.isBuffer(Ee) || (Ee = new Buffer$D(Ee, Ve)), this._pub = new re(Ee), this;
  }
  function pe(Ee, Ve) {
    return Ve = Ve || "utf8", Buffer$D.isBuffer(Ee) || (Ee = new Buffer$D(Ee, Ve)), this._priv = new re(Ee), this;
  }
  var ge = {};
  function be(Ee, Ve) {
    var Ae = Ve.toString("hex"), Oe = [Ae, Ee.toString(16)].join("_");
    if (Oe in ge)
      return ge[Oe];
    var Ne = 0;
    if (Ee.isEven() || !de.simpleSieve || !de.fermatTest(Ee) || !ae.test(Ee))
      return Ne += 1, Ae === "02" || Ae === "05" ? Ne += 8 : Ne += 4, ge[Oe] = Ne, Ne;
    ae.test(Ee.shrn(1)) || (Ne += 2);
    var He;
    switch (Ae) {
      case "02":
        Ee.mod(ie).cmp(le) && (Ne += 8);
        break;
      case "05":
        He = Ee.mod(se), He.cmp(ce) && He.cmp(ue) && (Ne += 8);
        break;
      default:
        Ne += 4;
    }
    return ge[Oe] = Ne, Ne;
  }
  function Se(Ee, Ve, Ae) {
    this.setGenerator(Ve), this.__prime = new re(Ee), this._prime = re.mont(this.__prime), this._primeLen = Ee.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, Ae ? (this.setPublicKey = fe, this.setPrivateKey = pe) : this._primeCode = 8;
  }
  Object.defineProperty(Se.prototype, "verifyError", {
    enumerable: !0,
    get: function() {
      return typeof this._primeCode != "number" && (this._primeCode = be(this.__prime, this.__gen)), this._primeCode;
    }
  }), Se.prototype.generateKeys = function() {
    return this._priv || (this._priv = new re(me(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
  }, Se.prototype.computeSecret = function(Ee) {
    Ee = new re(Ee), Ee = Ee.toRed(this._prime);
    var Ve = Ee.redPow(this._priv).fromRed(), Ae = new Buffer$D(Ve.toArray()), Oe = this.getPrime();
    if (Ae.length < Oe.length) {
      var Ne = new Buffer$D(Oe.length - Ae.length);
      Ne.fill(0), Ae = Buffer$D.concat([Ne, Ae]);
    }
    return Ae;
  }, Se.prototype.getPublicKey = function(Ve) {
    return Pe(this._pub, Ve);
  }, Se.prototype.getPrivateKey = function(Ve) {
    return Pe(this._priv, Ve);
  }, Se.prototype.getPrime = function(Ee) {
    return Pe(this.__prime, Ee);
  }, Se.prototype.getGenerator = function(Ee) {
    return Pe(this._gen, Ee);
  }, Se.prototype.setGenerator = function(Ee, Ve) {
    return Ve = Ve || "utf8", Buffer$D.isBuffer(Ee) || (Ee = new Buffer$D(Ee, Ve)), this.__gen = Ee, this._gen = new re(Ee), this;
  };
  function Pe(Ee, Ve) {
    var Ae = new Buffer$D(Ee.toArray());
    return Ve ? Ae.toString(Ve) : Ae;
  }
  return dh;
}
var hasRequiredBrowser$2;
function requireBrowser$2() {
  if (hasRequiredBrowser$2) return browser$4;
  hasRequiredBrowser$2 = 1;
  var re = requireGeneratePrime(), ne = require$$1$1, ae = requireDh();
  function ie(ce) {
    var ue = new Buffer$D(ne[ce].prime, "hex"), de = new Buffer$D(ne[ce].gen, "hex");
    return new ae(ue, de);
  }
  var le = {
    binary: !0,
    hex: !0,
    base64: !0
  };
  function se(ce, ue, de, me) {
    return Buffer$D.isBuffer(ue) || le[ue] === void 0 ? se(ce, "binary", ue, de) : (ue = ue || "binary", me = me || "binary", de = de || new Buffer$D([2]), Buffer$D.isBuffer(de) || (de = new Buffer$D(de, me)), typeof ce == "number" ? new ae(re(ce, de), de, !0) : (Buffer$D.isBuffer(ce) || (ce = new Buffer$D(ce, ue)), new ae(ce, de, !0)));
  }
  return browser$4.DiffieHellmanGroup = browser$4.createDiffieHellmanGroup = browser$4.getDiffieHellman = ie, browser$4.createDiffieHellman = browser$4.DiffieHellman = se, browser$4;
}
var readableBrowser = { exports: {} }, processNextickArgs = { exports: {} };
typeof process$1 > "u" || !process$1.version || process$1.version.indexOf("v0.") === 0 || process$1.version.indexOf("v1.") === 0 && process$1.version.indexOf("v1.8.") !== 0 ? processNextickArgs.exports = { nextTick } : processNextickArgs.exports = process$1;
function nextTick(re, ne, ae, ie) {
  if (typeof re != "function")
    throw new TypeError('"callback" argument must be a function');
  var le = arguments.length, se, ce;
  switch (le) {
    case 0:
    case 1:
      return process$1.nextTick(re);
    case 2:
      return process$1.nextTick(function() {
        re.call(null, ne);
      });
    case 3:
      return process$1.nextTick(function() {
        re.call(null, ne, ae);
      });
    case 4:
      return process$1.nextTick(function() {
        re.call(null, ne, ae, ie);
      });
    default:
      for (se = new Array(le - 1), ce = 0; ce < se.length; )
        se[ce++] = arguments[ce];
      return process$1.nextTick(function() {
        re.apply(null, se);
      });
  }
}
var processNextickArgsExports = processNextickArgs.exports, toString$2 = {}.toString, isarray = Array.isArray || function(re) {
  return toString$2.call(re) == "[object Array]";
}, streamBrowser = eventsExports.EventEmitter, safeBuffer$1 = { exports: {} };
(function(re, ne) {
  var ae = require$$1$2, ie = ae.Buffer;
  function le(ce, ue) {
    for (var de in ce)
      ue[de] = ce[de];
  }
  ie.from && ie.alloc && ie.allocUnsafe && ie.allocUnsafeSlow ? re.exports = ae : (le(ae, ne), ne.Buffer = se);
  function se(ce, ue, de) {
    return ie(ce, ue, de);
  }
  le(ie, se), se.from = function(ce, ue, de) {
    if (typeof ce == "number")
      throw new TypeError("Argument must not be a number");
    return ie(ce, ue, de);
  }, se.alloc = function(ce, ue, de) {
    if (typeof ce != "number")
      throw new TypeError("Argument must be a number");
    var me = ie(ce);
    return ue !== void 0 ? typeof de == "string" ? me.fill(ue, de) : me.fill(ue) : me.fill(0), me;
  }, se.allocUnsafe = function(ce) {
    if (typeof ce != "number")
      throw new TypeError("Argument must be a number");
    return ie(ce);
  }, se.allocUnsafeSlow = function(ce) {
    if (typeof ce != "number")
      throw new TypeError("Argument must be a number");
    return ae.SlowBuffer(ce);
  };
})(safeBuffer$1, safeBuffer$1.exports);
var safeBufferExports = safeBuffer$1.exports, util$2 = {};
function isArray$c(re) {
  return Array.isArray ? Array.isArray(re) : objectToString$3(re) === "[object Array]";
}
util$2.isArray = isArray$c;
function isBoolean$1(re) {
  return typeof re == "boolean";
}
util$2.isBoolean = isBoolean$1;
function isNull(re) {
  return re === null;
}
util$2.isNull = isNull;
function isNullOrUndefined(re) {
  return re == null;
}
util$2.isNullOrUndefined = isNullOrUndefined;
function isNumber$3(re) {
  return typeof re == "number";
}
util$2.isNumber = isNumber$3;
function isString$2(re) {
  return typeof re == "string";
}
util$2.isString = isString$2;
function isSymbol$5(re) {
  return typeof re == "symbol";
}
util$2.isSymbol = isSymbol$5;
function isUndefined(re) {
  return re === void 0;
}
util$2.isUndefined = isUndefined;
function isRegExp$1(re) {
  return objectToString$3(re) === "[object RegExp]";
}
util$2.isRegExp = isRegExp$1;
function isObject$7(re) {
  return typeof re == "object" && re !== null;
}
util$2.isObject = isObject$7;
function isDate$1(re) {
  return objectToString$3(re) === "[object Date]";
}
util$2.isDate = isDate$1;
function isError(re) {
  return objectToString$3(re) === "[object Error]" || re instanceof Error;
}
util$2.isError = isError;
function isFunction$4(re) {
  return typeof re == "function";
}
util$2.isFunction = isFunction$4;
function isPrimitive(re) {
  return re === null || typeof re == "boolean" || typeof re == "number" || typeof re == "string" || typeof re == "symbol" || // ES6 symbol
  typeof re > "u";
}
util$2.isPrimitive = isPrimitive;
util$2.isBuffer = require$$1$2.Buffer.isBuffer;
function objectToString$3(re) {
  return Object.prototype.toString.call(re);
}
var BufferList = { exports: {} }, hasRequiredBufferList;
function requireBufferList() {
  return hasRequiredBufferList || (hasRequiredBufferList = 1, function(re) {
    function ne(se, ce) {
      if (!(se instanceof ce))
        throw new TypeError("Cannot call a class as a function");
    }
    var ae = safeBufferExports.Buffer, ie = util$3;
    function le(se, ce, ue) {
      se.copy(ce, ue);
    }
    re.exports = function() {
      function se() {
        ne(this, se), this.head = null, this.tail = null, this.length = 0;
      }
      return se.prototype.push = function(ue) {
        var de = { data: ue, next: null };
        this.length > 0 ? this.tail.next = de : this.head = de, this.tail = de, ++this.length;
      }, se.prototype.unshift = function(ue) {
        var de = { data: ue, next: this.head };
        this.length === 0 && (this.tail = de), this.head = de, ++this.length;
      }, se.prototype.shift = function() {
        if (this.length !== 0) {
          var ue = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, ue;
        }
      }, se.prototype.clear = function() {
        this.head = this.tail = null, this.length = 0;
      }, se.prototype.join = function(ue) {
        if (this.length === 0) return "";
        for (var de = this.head, me = "" + de.data; de = de.next; )
          me += ue + de.data;
        return me;
      }, se.prototype.concat = function(ue) {
        if (this.length === 0) return ae.alloc(0);
        for (var de = ae.allocUnsafe(ue >>> 0), me = this.head, fe = 0; me; )
          le(me.data, de, fe), fe += me.data.length, me = me.next;
        return de;
      }, se;
    }(), ie && ie.inspect && ie.inspect.custom && (re.exports.prototype[ie.inspect.custom] = function() {
      var se = ie.inspect({ length: this.length });
      return this.constructor.name + " " + se;
    });
  }(BufferList)), BufferList.exports;
}
var pna = processNextickArgsExports;
function destroy(re, ne) {
  var ae = this, ie = this._readableState && this._readableState.destroyed, le = this._writableState && this._writableState.destroyed;
  return ie || le ? (ne ? ne(re) : re && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, pna.nextTick(emitErrorNT, this, re)) : pna.nextTick(emitErrorNT, this, re)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(re || null, function(se) {
    !ne && se ? ae._writableState ? ae._writableState.errorEmitted || (ae._writableState.errorEmitted = !0, pna.nextTick(emitErrorNT, ae, se)) : pna.nextTick(emitErrorNT, ae, se) : ne && ne(se);
  }), this);
}
function undestroy() {
  this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
}
function emitErrorNT(re, ne) {
  re.emit("error", ne);
}
var destroy_1 = {
  destroy,
  undestroy
}, _stream_writable, hasRequired_stream_writable;
function require_stream_writable() {
  if (hasRequired_stream_writable) return _stream_writable;
  hasRequired_stream_writable = 1;
  var re = processNextickArgsExports;
  _stream_writable = Pe;
  function ne($e) {
    var Te = this;
    this.next = null, this.entry = null, this.finish = function() {
      xe(Te, $e);
    };
  }
  var ae = !process$1.browser && ["v0.10", "v0.9."].indexOf(process$1.version.slice(0, 5)) > -1 ? setImmediate : re.nextTick, ie;
  Pe.WritableState = be;
  var le = Object.create(util$2);
  le.inherits = inherits_browserExports;
  var se = {
    deprecate: browser$a
  }, ce = streamBrowser, ue = safeBufferExports.Buffer, de = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function me($e) {
    return ue.from($e);
  }
  function fe($e) {
    return ue.isBuffer($e) || $e instanceof de;
  }
  var pe = destroy_1;
  le.inherits(Pe, ce);
  function ge() {
  }
  function be($e, Te) {
    ie = ie || require_stream_duplex(), $e = $e || {};
    var Ie = Te instanceof ie;
    this.objectMode = !!$e.objectMode, Ie && (this.objectMode = this.objectMode || !!$e.writableObjectMode);
    var we = $e.highWaterMark, ke = $e.writableHighWaterMark, ye = this.objectMode ? 16 : 16 * 1024;
    we || we === 0 ? this.highWaterMark = we : Ie && (ke || ke === 0) ? this.highWaterMark = ke : this.highWaterMark = ye, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var Be = $e.decodeStrings === !1;
    this.decodeStrings = !Be, this.defaultEncoding = $e.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(Xe) {
      Ze(Te, Xe);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new ne(this);
  }
  be.prototype.getBuffer = function() {
    for (var Te = this.bufferedRequest, Ie = []; Te; )
      Ie.push(Te), Te = Te.next;
    return Ie;
  }, function() {
    try {
      Object.defineProperty(be.prototype, "buffer", {
        get: se.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var Se;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (Se = Function.prototype[Symbol.hasInstance], Object.defineProperty(Pe, Symbol.hasInstance, {
    value: function($e) {
      return Se.call(this, $e) ? !0 : this !== Pe ? !1 : $e && $e._writableState instanceof be;
    }
  })) : Se = function($e) {
    return $e instanceof this;
  };
  function Pe($e) {
    if (ie = ie || require_stream_duplex(), !Se.call(Pe, this) && !(this instanceof ie))
      return new Pe($e);
    this._writableState = new be($e, this), this.writable = !0, $e && (typeof $e.write == "function" && (this._write = $e.write), typeof $e.writev == "function" && (this._writev = $e.writev), typeof $e.destroy == "function" && (this._destroy = $e.destroy), typeof $e.final == "function" && (this._final = $e.final)), ce.call(this);
  }
  Pe.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
  };
  function Ee($e, Te) {
    var Ie = new Error("write after end");
    $e.emit("error", Ie), re.nextTick(Te, Ie);
  }
  function Ve($e, Te, Ie, we) {
    var ke = !0, ye = !1;
    return Ie === null ? ye = new TypeError("May not write null values to stream") : typeof Ie != "string" && Ie !== void 0 && !Te.objectMode && (ye = new TypeError("Invalid non-string/buffer chunk")), ye && ($e.emit("error", ye), re.nextTick(we, ye), ke = !1), ke;
  }
  Pe.prototype.write = function($e, Te, Ie) {
    var we = this._writableState, ke = !1, ye = !we.objectMode && fe($e);
    return ye && !ue.isBuffer($e) && ($e = me($e)), typeof Te == "function" && (Ie = Te, Te = null), ye ? Te = "buffer" : Te || (Te = we.defaultEncoding), typeof Ie != "function" && (Ie = ge), we.ended ? Ee(this, Ie) : (ye || Ve(this, we, $e, Ie)) && (we.pendingcb++, ke = Oe(this, we, ye, $e, Te, Ie)), ke;
  }, Pe.prototype.cork = function() {
    var $e = this._writableState;
    $e.corked++;
  }, Pe.prototype.uncork = function() {
    var $e = this._writableState;
    $e.corked && ($e.corked--, !$e.writing && !$e.corked && !$e.bufferProcessing && $e.bufferedRequest && tt(this, $e));
  }, Pe.prototype.setDefaultEncoding = function(Te) {
    if (typeof Te == "string" && (Te = Te.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((Te + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + Te);
    return this._writableState.defaultEncoding = Te, this;
  };
  function Ae($e, Te, Ie) {
    return !$e.objectMode && $e.decodeStrings !== !1 && typeof Te == "string" && (Te = ue.from(Te, Ie)), Te;
  }
  Object.defineProperty(Pe.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function Oe($e, Te, Ie, we, ke, ye) {
    if (!Ie) {
      var Be = Ae(Te, we, ke);
      we !== Be && (Ie = !0, ke = "buffer", we = Be);
    }
    var Xe = Te.objectMode ? 1 : we.length;
    Te.length += Xe;
    var et = Te.length < Te.highWaterMark;
    if (et || (Te.needDrain = !0), Te.writing || Te.corked) {
      var Ye = Te.lastBufferedRequest;
      Te.lastBufferedRequest = {
        chunk: we,
        encoding: ke,
        isBuf: Ie,
        callback: ye,
        next: null
      }, Ye ? Ye.next = Te.lastBufferedRequest : Te.bufferedRequest = Te.lastBufferedRequest, Te.bufferedRequestCount += 1;
    } else
      Ne($e, Te, !1, Xe, we, ke, ye);
    return et;
  }
  function Ne($e, Te, Ie, we, ke, ye, Be) {
    Te.writelen = we, Te.writecb = Be, Te.writing = !0, Te.sync = !0, Ie ? $e._writev(ke, Te.onwrite) : $e._write(ke, ye, Te.onwrite), Te.sync = !1;
  }
  function He($e, Te, Ie, we, ke) {
    --Te.pendingcb, Ie ? (re.nextTick(ke, we), re.nextTick(he, $e, Te), $e._writableState.errorEmitted = !0, $e.emit("error", we)) : (ke(we), $e._writableState.errorEmitted = !0, $e.emit("error", we), he($e, Te));
  }
  function Ue($e) {
    $e.writing = !1, $e.writecb = null, $e.length -= $e.writelen, $e.writelen = 0;
  }
  function Ze($e, Te) {
    var Ie = $e._writableState, we = Ie.sync, ke = Ie.writecb;
    if (Ue(Ie), Te) He($e, Ie, we, Te, ke);
    else {
      var ye = Re(Ie);
      !ye && !Ie.corked && !Ie.bufferProcessing && Ie.bufferedRequest && tt($e, Ie), we ? ae(Fe, $e, Ie, ye, ke) : Fe($e, Ie, ye, ke);
    }
  }
  function Fe($e, Te, Ie, we) {
    Ie || Ke($e, Te), Te.pendingcb--, we(), he($e, Te);
  }
  function Ke($e, Te) {
    Te.length === 0 && Te.needDrain && (Te.needDrain = !1, $e.emit("drain"));
  }
  function tt($e, Te) {
    Te.bufferProcessing = !0;
    var Ie = Te.bufferedRequest;
    if ($e._writev && Ie && Ie.next) {
      var we = Te.bufferedRequestCount, ke = new Array(we), ye = Te.corkedRequestsFree;
      ye.entry = Ie;
      for (var Be = 0, Xe = !0; Ie; )
        ke[Be] = Ie, Ie.isBuf || (Xe = !1), Ie = Ie.next, Be += 1;
      ke.allBuffers = Xe, Ne($e, Te, !0, Te.length, ke, "", ye.finish), Te.pendingcb++, Te.lastBufferedRequest = null, ye.next ? (Te.corkedRequestsFree = ye.next, ye.next = null) : Te.corkedRequestsFree = new ne(Te), Te.bufferedRequestCount = 0;
    } else {
      for (; Ie; ) {
        var et = Ie.chunk, Ye = Ie.encoding, De = Ie.callback, je = Te.objectMode ? 1 : et.length;
        if (Ne($e, Te, !1, je, et, Ye, De), Ie = Ie.next, Te.bufferedRequestCount--, Te.writing)
          break;
      }
      Ie === null && (Te.lastBufferedRequest = null);
    }
    Te.bufferedRequest = Ie, Te.bufferProcessing = !1;
  }
  Pe.prototype._write = function($e, Te, Ie) {
    Ie(new Error("_write() is not implemented"));
  }, Pe.prototype._writev = null, Pe.prototype.end = function($e, Te, Ie) {
    var we = this._writableState;
    typeof $e == "function" ? (Ie = $e, $e = null, Te = null) : typeof Te == "function" && (Ie = Te, Te = null), $e != null && this.write($e, Te), we.corked && (we.corked = 1, this.uncork()), we.ending || ve(this, we, Ie);
  };
  function Re($e) {
    return $e.ending && $e.length === 0 && $e.bufferedRequest === null && !$e.finished && !$e.writing;
  }
  function Ce($e, Te) {
    $e._final(function(Ie) {
      Te.pendingcb--, Ie && $e.emit("error", Ie), Te.prefinished = !0, $e.emit("prefinish"), he($e, Te);
    });
  }
  function _e($e, Te) {
    !Te.prefinished && !Te.finalCalled && (typeof $e._final == "function" ? (Te.pendingcb++, Te.finalCalled = !0, re.nextTick(Ce, $e, Te)) : (Te.prefinished = !0, $e.emit("prefinish")));
  }
  function he($e, Te) {
    var Ie = Re(Te);
    return Ie && (_e($e, Te), Te.pendingcb === 0 && (Te.finished = !0, $e.emit("finish"))), Ie;
  }
  function ve($e, Te, Ie) {
    Te.ending = !0, he($e, Te), Ie && (Te.finished ? re.nextTick(Ie) : $e.once("finish", Ie)), Te.ended = !0, $e.writable = !1;
  }
  function xe($e, Te, Ie) {
    var we = $e.entry;
    for ($e.entry = null; we; ) {
      var ke = we.callback;
      Te.pendingcb--, ke(Ie), we = we.next;
    }
    Te.corkedRequestsFree.next = $e;
  }
  return Object.defineProperty(Pe.prototype, "destroyed", {
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function($e) {
      this._writableState && (this._writableState.destroyed = $e);
    }
  }), Pe.prototype.destroy = pe.destroy, Pe.prototype._undestroy = pe.undestroy, Pe.prototype._destroy = function($e, Te) {
    this.end(), Te($e);
  }, _stream_writable;
}
var _stream_duplex, hasRequired_stream_duplex;
function require_stream_duplex() {
  if (hasRequired_stream_duplex) return _stream_duplex;
  hasRequired_stream_duplex = 1;
  var re = processNextickArgsExports, ne = Object.keys || function(pe) {
    var ge = [];
    for (var be in pe)
      ge.push(be);
    return ge;
  };
  _stream_duplex = de;
  var ae = Object.create(util$2);
  ae.inherits = inherits_browserExports;
  var ie = require_stream_readable(), le = require_stream_writable();
  ae.inherits(de, ie);
  for (var se = ne(le.prototype), ce = 0; ce < se.length; ce++) {
    var ue = se[ce];
    de.prototype[ue] || (de.prototype[ue] = le.prototype[ue]);
  }
  function de(pe) {
    if (!(this instanceof de)) return new de(pe);
    ie.call(this, pe), le.call(this, pe), pe && pe.readable === !1 && (this.readable = !1), pe && pe.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, pe && pe.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", me);
  }
  Object.defineProperty(de.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function me() {
    this.allowHalfOpen || this._writableState.ended || re.nextTick(fe, this);
  }
  function fe(pe) {
    pe.end();
  }
  return Object.defineProperty(de.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(pe) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = pe, this._writableState.destroyed = pe);
    }
  }), de.prototype._destroy = function(pe, ge) {
    this.push(null), this.end(), re.nextTick(ge, pe);
  }, _stream_duplex;
}
var _stream_readable, hasRequired_stream_readable;
function require_stream_readable() {
  if (hasRequired_stream_readable) return _stream_readable;
  hasRequired_stream_readable = 1;
  var re = processNextickArgsExports;
  _stream_readable = Ae;
  var ne = isarray, ae;
  Ae.ReadableState = Ve, eventsExports.EventEmitter;
  var ie = function(De, je) {
    return De.listeners(je).length;
  }, le = streamBrowser, se = safeBufferExports.Buffer, ce = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function ue(De) {
    return se.from(De);
  }
  function de(De) {
    return se.isBuffer(De) || De instanceof ce;
  }
  var me = Object.create(util$2);
  me.inherits = inherits_browserExports;
  var fe = util$3, pe = void 0;
  fe && fe.debuglog ? pe = fe.debuglog("stream") : pe = function() {
  };
  var ge = requireBufferList(), be = destroy_1, Se;
  me.inherits(Ae, le);
  var Pe = ["error", "close", "destroy", "pause", "resume"];
  function Ee(De, je, rt) {
    if (typeof De.prependListener == "function") return De.prependListener(je, rt);
    !De._events || !De._events[je] ? De.on(je, rt) : ne(De._events[je]) ? De._events[je].unshift(rt) : De._events[je] = [rt, De._events[je]];
  }
  function Ve(De, je) {
    ae = ae || require_stream_duplex(), De = De || {};
    var rt = je instanceof ae;
    this.objectMode = !!De.objectMode, rt && (this.objectMode = this.objectMode || !!De.readableObjectMode);
    var at = De.highWaterMark, qe = De.readableHighWaterMark, We = this.objectMode ? 16 : 16 * 1024;
    at || at === 0 ? this.highWaterMark = at : rt && (qe || qe === 0) ? this.highWaterMark = qe : this.highWaterMark = We, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new ge(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = De.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, De.encoding && (Se || (Se = string_decoder.StringDecoder), this.decoder = new Se(De.encoding), this.encoding = De.encoding);
  }
  function Ae(De) {
    if (ae = ae || require_stream_duplex(), !(this instanceof Ae)) return new Ae(De);
    this._readableState = new Ve(De, this), this.readable = !0, De && (typeof De.read == "function" && (this._read = De.read), typeof De.destroy == "function" && (this._destroy = De.destroy)), le.call(this);
  }
  Object.defineProperty(Ae.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(De) {
      this._readableState && (this._readableState.destroyed = De);
    }
  }), Ae.prototype.destroy = be.destroy, Ae.prototype._undestroy = be.undestroy, Ae.prototype._destroy = function(De, je) {
    this.push(null), je(De);
  }, Ae.prototype.push = function(De, je) {
    var rt = this._readableState, at;
    return rt.objectMode ? at = !0 : typeof De == "string" && (je = je || rt.defaultEncoding, je !== rt.encoding && (De = se.from(De, je), je = ""), at = !0), Oe(this, De, je, !1, at);
  }, Ae.prototype.unshift = function(De) {
    return Oe(this, De, null, !0, !1);
  };
  function Oe(De, je, rt, at, qe) {
    var We = De._readableState;
    if (je === null)
      We.reading = !1, tt(De, We);
    else {
      var ze;
      qe || (ze = He(We, je)), ze ? De.emit("error", ze) : We.objectMode || je && je.length > 0 ? (typeof je != "string" && !We.objectMode && Object.getPrototypeOf(je) !== se.prototype && (je = ue(je)), at ? We.endEmitted ? De.emit("error", new Error("stream.unshift() after end event")) : Ne(De, We, je, !0) : We.ended ? De.emit("error", new Error("stream.push() after EOF")) : (We.reading = !1, We.decoder && !rt ? (je = We.decoder.write(je), We.objectMode || je.length !== 0 ? Ne(De, We, je, !1) : _e(De, We)) : Ne(De, We, je, !1))) : at || (We.reading = !1);
    }
    return Ue(We);
  }
  function Ne(De, je, rt, at) {
    je.flowing && je.length === 0 && !je.sync ? (De.emit("data", rt), De.read(0)) : (je.length += je.objectMode ? 1 : rt.length, at ? je.buffer.unshift(rt) : je.buffer.push(rt), je.needReadable && Re(De)), _e(De, je);
  }
  function He(De, je) {
    var rt;
    return !de(je) && typeof je != "string" && je !== void 0 && !De.objectMode && (rt = new TypeError("Invalid non-string/buffer chunk")), rt;
  }
  function Ue(De) {
    return !De.ended && (De.needReadable || De.length < De.highWaterMark || De.length === 0);
  }
  Ae.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, Ae.prototype.setEncoding = function(De) {
    return Se || (Se = string_decoder.StringDecoder), this._readableState.decoder = new Se(De), this._readableState.encoding = De, this;
  };
  var Ze = 8388608;
  function Fe(De) {
    return De >= Ze ? De = Ze : (De--, De |= De >>> 1, De |= De >>> 2, De |= De >>> 4, De |= De >>> 8, De |= De >>> 16, De++), De;
  }
  function Ke(De, je) {
    return De <= 0 || je.length === 0 && je.ended ? 0 : je.objectMode ? 1 : De !== De ? je.flowing && je.length ? je.buffer.head.data.length : je.length : (De > je.highWaterMark && (je.highWaterMark = Fe(De)), De <= je.length ? De : je.ended ? je.length : (je.needReadable = !0, 0));
  }
  Ae.prototype.read = function(De) {
    pe("read", De), De = parseInt(De, 10);
    var je = this._readableState, rt = De;
    if (De !== 0 && (je.emittedReadable = !1), De === 0 && je.needReadable && (je.length >= je.highWaterMark || je.ended))
      return pe("read: emitReadable", je.length, je.ended), je.length === 0 && je.ended ? Xe(this) : Re(this), null;
    if (De = Ke(De, je), De === 0 && je.ended)
      return je.length === 0 && Xe(this), null;
    var at = je.needReadable;
    pe("need readable", at), (je.length === 0 || je.length - De < je.highWaterMark) && (at = !0, pe("length less than watermark", at)), je.ended || je.reading ? (at = !1, pe("reading or ended", at)) : at && (pe("do read"), je.reading = !0, je.sync = !0, je.length === 0 && (je.needReadable = !0), this._read(je.highWaterMark), je.sync = !1, je.reading || (De = Ke(rt, je)));
    var qe;
    return De > 0 ? qe = we(De, je) : qe = null, qe === null ? (je.needReadable = !0, De = 0) : je.length -= De, je.length === 0 && (je.ended || (je.needReadable = !0), rt !== De && je.ended && Xe(this)), qe !== null && this.emit("data", qe), qe;
  };
  function tt(De, je) {
    if (!je.ended) {
      if (je.decoder) {
        var rt = je.decoder.end();
        rt && rt.length && (je.buffer.push(rt), je.length += je.objectMode ? 1 : rt.length);
      }
      je.ended = !0, Re(De);
    }
  }
  function Re(De) {
    var je = De._readableState;
    je.needReadable = !1, je.emittedReadable || (pe("emitReadable", je.flowing), je.emittedReadable = !0, je.sync ? re.nextTick(Ce, De) : Ce(De));
  }
  function Ce(De) {
    pe("emit readable"), De.emit("readable"), Ie(De);
  }
  function _e(De, je) {
    je.readingMore || (je.readingMore = !0, re.nextTick(he, De, je));
  }
  function he(De, je) {
    for (var rt = je.length; !je.reading && !je.flowing && !je.ended && je.length < je.highWaterMark && (pe("maybeReadMore read 0"), De.read(0), rt !== je.length); )
      rt = je.length;
    je.readingMore = !1;
  }
  Ae.prototype._read = function(De) {
    this.emit("error", new Error("_read() is not implemented"));
  }, Ae.prototype.pipe = function(De, je) {
    var rt = this, at = this._readableState;
    switch (at.pipesCount) {
      case 0:
        at.pipes = De;
        break;
      case 1:
        at.pipes = [at.pipes, De];
        break;
      default:
        at.pipes.push(De);
        break;
    }
    at.pipesCount += 1, pe("pipe count=%d opts=%j", at.pipesCount, je);
    var qe = (!je || je.end !== !1) && De !== process$1.stdout && De !== process$1.stderr, We = qe ? Ge : wt;
    at.endEmitted ? re.nextTick(We) : rt.once("end", We), De.on("unpipe", ze);
    function ze(pt, ut) {
      pe("onunpipe"), pt === rt && ut && ut.hasUnpiped === !1 && (ut.hasUnpiped = !0, lt());
    }
    function Ge() {
      pe("onend"), De.end();
    }
    var nt = ve(rt);
    De.on("drain", nt);
    var ot = !1;
    function lt() {
      pe("cleanup"), De.removeListener("close", bt), De.removeListener("finish", At), De.removeListener("drain", nt), De.removeListener("error", gt), De.removeListener("unpipe", ze), rt.removeListener("end", Ge), rt.removeListener("end", wt), rt.removeListener("data", dt), ot = !0, at.awaitDrain && (!De._writableState || De._writableState.needDrain) && nt();
    }
    var mt = !1;
    rt.on("data", dt);
    function dt(pt) {
      pe("ondata"), mt = !1;
      var ut = De.write(pt);
      ut === !1 && !mt && ((at.pipesCount === 1 && at.pipes === De || at.pipesCount > 1 && Ye(at.pipes, De) !== -1) && !ot && (pe("false write response, pause", at.awaitDrain), at.awaitDrain++, mt = !0), rt.pause());
    }
    function gt(pt) {
      pe("onerror", pt), wt(), De.removeListener("error", gt), ie(De, "error") === 0 && De.emit("error", pt);
    }
    Ee(De, "error", gt);
    function bt() {
      De.removeListener("finish", At), wt();
    }
    De.once("close", bt);
    function At() {
      pe("onfinish"), De.removeListener("close", bt), wt();
    }
    De.once("finish", At);
    function wt() {
      pe("unpipe"), rt.unpipe(De);
    }
    return De.emit("pipe", rt), at.flowing || (pe("pipe resume"), rt.resume()), De;
  };
  function ve(De) {
    return function() {
      var je = De._readableState;
      pe("pipeOnDrain", je.awaitDrain), je.awaitDrain && je.awaitDrain--, je.awaitDrain === 0 && ie(De, "data") && (je.flowing = !0, Ie(De));
    };
  }
  Ae.prototype.unpipe = function(De) {
    var je = this._readableState, rt = { hasUnpiped: !1 };
    if (je.pipesCount === 0) return this;
    if (je.pipesCount === 1)
      return De && De !== je.pipes ? this : (De || (De = je.pipes), je.pipes = null, je.pipesCount = 0, je.flowing = !1, De && De.emit("unpipe", this, rt), this);
    if (!De) {
      var at = je.pipes, qe = je.pipesCount;
      je.pipes = null, je.pipesCount = 0, je.flowing = !1;
      for (var We = 0; We < qe; We++)
        at[We].emit("unpipe", this, { hasUnpiped: !1 });
      return this;
    }
    var ze = Ye(je.pipes, De);
    return ze === -1 ? this : (je.pipes.splice(ze, 1), je.pipesCount -= 1, je.pipesCount === 1 && (je.pipes = je.pipes[0]), De.emit("unpipe", this, rt), this);
  }, Ae.prototype.on = function(De, je) {
    var rt = le.prototype.on.call(this, De, je);
    if (De === "data")
      this._readableState.flowing !== !1 && this.resume();
    else if (De === "readable") {
      var at = this._readableState;
      !at.endEmitted && !at.readableListening && (at.readableListening = at.needReadable = !0, at.emittedReadable = !1, at.reading ? at.length && Re(this) : re.nextTick(xe, this));
    }
    return rt;
  }, Ae.prototype.addListener = Ae.prototype.on;
  function xe(De) {
    pe("readable nexttick read 0"), De.read(0);
  }
  Ae.prototype.resume = function() {
    var De = this._readableState;
    return De.flowing || (pe("resume"), De.flowing = !0, $e(this, De)), this;
  };
  function $e(De, je) {
    je.resumeScheduled || (je.resumeScheduled = !0, re.nextTick(Te, De, je));
  }
  function Te(De, je) {
    je.reading || (pe("resume read 0"), De.read(0)), je.resumeScheduled = !1, je.awaitDrain = 0, De.emit("resume"), Ie(De), je.flowing && !je.reading && De.read(0);
  }
  Ae.prototype.pause = function() {
    return pe("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (pe("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
  };
  function Ie(De) {
    var je = De._readableState;
    for (pe("flow", je.flowing); je.flowing && De.read() !== null; )
      ;
  }
  Ae.prototype.wrap = function(De) {
    var je = this, rt = this._readableState, at = !1;
    De.on("end", function() {
      if (pe("wrapped end"), rt.decoder && !rt.ended) {
        var ze = rt.decoder.end();
        ze && ze.length && je.push(ze);
      }
      je.push(null);
    }), De.on("data", function(ze) {
      if (pe("wrapped data"), rt.decoder && (ze = rt.decoder.write(ze)), !(rt.objectMode && ze == null) && !(!rt.objectMode && (!ze || !ze.length))) {
        var Ge = je.push(ze);
        Ge || (at = !0, De.pause());
      }
    });
    for (var qe in De)
      this[qe] === void 0 && typeof De[qe] == "function" && (this[qe] = /* @__PURE__ */ function(ze) {
        return function() {
          return De[ze].apply(De, arguments);
        };
      }(qe));
    for (var We = 0; We < Pe.length; We++)
      De.on(Pe[We], this.emit.bind(this, Pe[We]));
    return this._read = function(ze) {
      pe("wrapped _read", ze), at && (at = !1, De.resume());
    }, this;
  }, Object.defineProperty(Ae.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Ae._fromList = we;
  function we(De, je) {
    if (je.length === 0) return null;
    var rt;
    return je.objectMode ? rt = je.buffer.shift() : !De || De >= je.length ? (je.decoder ? rt = je.buffer.join("") : je.buffer.length === 1 ? rt = je.buffer.head.data : rt = je.buffer.concat(je.length), je.buffer.clear()) : rt = ke(De, je.buffer, je.decoder), rt;
  }
  function ke(De, je, rt) {
    var at;
    return De < je.head.data.length ? (at = je.head.data.slice(0, De), je.head.data = je.head.data.slice(De)) : De === je.head.data.length ? at = je.shift() : at = rt ? ye(De, je) : Be(De, je), at;
  }
  function ye(De, je) {
    var rt = je.head, at = 1, qe = rt.data;
    for (De -= qe.length; rt = rt.next; ) {
      var We = rt.data, ze = De > We.length ? We.length : De;
      if (ze === We.length ? qe += We : qe += We.slice(0, De), De -= ze, De === 0) {
        ze === We.length ? (++at, rt.next ? je.head = rt.next : je.head = je.tail = null) : (je.head = rt, rt.data = We.slice(ze));
        break;
      }
      ++at;
    }
    return je.length -= at, qe;
  }
  function Be(De, je) {
    var rt = se.allocUnsafe(De), at = je.head, qe = 1;
    for (at.data.copy(rt), De -= at.data.length; at = at.next; ) {
      var We = at.data, ze = De > We.length ? We.length : De;
      if (We.copy(rt, rt.length - De, 0, ze), De -= ze, De === 0) {
        ze === We.length ? (++qe, at.next ? je.head = at.next : je.head = je.tail = null) : (je.head = at, at.data = We.slice(ze));
        break;
      }
      ++qe;
    }
    return je.length -= qe, rt;
  }
  function Xe(De) {
    var je = De._readableState;
    if (je.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    je.endEmitted || (je.ended = !0, re.nextTick(et, je, De));
  }
  function et(De, je) {
    !De.endEmitted && De.length === 0 && (De.endEmitted = !0, je.readable = !1, je.emit("end"));
  }
  function Ye(De, je) {
    for (var rt = 0, at = De.length; rt < at; rt++)
      if (De[rt] === je) return rt;
    return -1;
  }
  return _stream_readable;
}
var _stream_transform = Transform$1, Duplex = require_stream_duplex(), util$1 = Object.create(util$2);
util$1.inherits = inherits_browserExports;
util$1.inherits(Transform$1, Duplex);
function afterTransform(re, ne) {
  var ae = this._transformState;
  ae.transforming = !1;
  var ie = ae.writecb;
  if (!ie)
    return this.emit("error", new Error("write callback called multiple times"));
  ae.writechunk = null, ae.writecb = null, ne != null && this.push(ne), ie(re);
  var le = this._readableState;
  le.reading = !1, (le.needReadable || le.length < le.highWaterMark) && this._read(le.highWaterMark);
}
function Transform$1(re) {
  if (!(this instanceof Transform$1)) return new Transform$1(re);
  Duplex.call(this, re), this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: !1,
    transforming: !1,
    writecb: null,
    writechunk: null,
    writeencoding: null
  }, this._readableState.needReadable = !0, this._readableState.sync = !1, re && (typeof re.transform == "function" && (this._transform = re.transform), typeof re.flush == "function" && (this._flush = re.flush)), this.on("prefinish", prefinish);
}
function prefinish() {
  var re = this;
  typeof this._flush == "function" ? this._flush(function(ne, ae) {
    done(re, ne, ae);
  }) : done(this, null, null);
}
Transform$1.prototype.push = function(re, ne) {
  return this._transformState.needTransform = !1, Duplex.prototype.push.call(this, re, ne);
};
Transform$1.prototype._transform = function(re, ne, ae) {
  throw new Error("_transform() is not implemented");
};
Transform$1.prototype._write = function(re, ne, ae) {
  var ie = this._transformState;
  if (ie.writecb = ae, ie.writechunk = re, ie.writeencoding = ne, !ie.transforming) {
    var le = this._readableState;
    (ie.needTransform || le.needReadable || le.length < le.highWaterMark) && this._read(le.highWaterMark);
  }
};
Transform$1.prototype._read = function(re) {
  var ne = this._transformState;
  ne.writechunk !== null && ne.writecb && !ne.transforming ? (ne.transforming = !0, this._transform(ne.writechunk, ne.writeencoding, ne.afterTransform)) : ne.needTransform = !0;
};
Transform$1.prototype._destroy = function(re, ne) {
  var ae = this;
  Duplex.prototype._destroy.call(this, re, function(ie) {
    ne(ie), ae.emit("close");
  });
};
function done(re, ne, ae) {
  if (ne) return re.emit("error", ne);
  if (ae != null && re.push(ae), re._writableState.length) throw new Error("Calling transform done when ws.length != 0");
  if (re._transformState.transforming) throw new Error("Calling transform done when still transforming");
  return re.push(null);
}
var _stream_passthrough = PassThrough, Transform = _stream_transform, util = Object.create(util$2);
util.inherits = inherits_browserExports;
util.inherits(PassThrough, Transform);
function PassThrough(re) {
  if (!(this instanceof PassThrough)) return new PassThrough(re);
  Transform.call(this, re);
}
PassThrough.prototype._transform = function(re, ne, ae) {
  ae(null, re);
};
(function(re, ne) {
  ne = re.exports = require_stream_readable(), ne.Stream = ne, ne.Readable = ne, ne.Writable = require_stream_writable(), ne.Duplex = require_stream_duplex(), ne.Transform = _stream_transform, ne.PassThrough = _stream_passthrough;
})(readableBrowser, readableBrowser.exports);
var readableBrowserExports = readableBrowser.exports, sign = { exports: {} }, bn$1 = { exports: {} };
bn$1.exports;
(function(re) {
  (function(ne, ae) {
    function ie(_e, he) {
      if (!_e) throw new Error(he || "Assertion failed");
    }
    function le(_e, he) {
      _e.super_ = he;
      var ve = function() {
      };
      ve.prototype = he.prototype, _e.prototype = new ve(), _e.prototype.constructor = _e;
    }
    function se(_e, he, ve) {
      if (se.isBN(_e))
        return _e;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, _e !== null && ((he === "le" || he === "be") && (ve = he, he = 10), this._init(_e || 0, he || 10, ve || "be"));
    }
    typeof ne == "object" ? ne.exports = se : ae.BN = se, se.BN = se, se.wordSize = 26;
    var ce;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? ce = window.Buffer : ce = require$$1$2.Buffer;
    } catch {
    }
    se.isBN = function(he) {
      return he instanceof se ? !0 : he !== null && typeof he == "object" && he.constructor.wordSize === se.wordSize && Array.isArray(he.words);
    }, se.max = function(he, ve) {
      return he.cmp(ve) > 0 ? he : ve;
    }, se.min = function(he, ve) {
      return he.cmp(ve) < 0 ? he : ve;
    }, se.prototype._init = function(he, ve, xe) {
      if (typeof he == "number")
        return this._initNumber(he, ve, xe);
      if (typeof he == "object")
        return this._initArray(he, ve, xe);
      ve === "hex" && (ve = 16), ie(ve === (ve | 0) && ve >= 2 && ve <= 36), he = he.toString().replace(/\s+/g, "");
      var $e = 0;
      he[0] === "-" && ($e++, this.negative = 1), $e < he.length && (ve === 16 ? this._parseHex(he, $e, xe) : (this._parseBase(he, ve, $e), xe === "le" && this._initArray(this.toArray(), ve, xe)));
    }, se.prototype._initNumber = function(he, ve, xe) {
      he < 0 && (this.negative = 1, he = -he), he < 67108864 ? (this.words = [he & 67108863], this.length = 1) : he < 4503599627370496 ? (this.words = [
        he & 67108863,
        he / 67108864 & 67108863
      ], this.length = 2) : (ie(he < 9007199254740992), this.words = [
        he & 67108863,
        he / 67108864 & 67108863,
        1
      ], this.length = 3), xe === "le" && this._initArray(this.toArray(), ve, xe);
    }, se.prototype._initArray = function(he, ve, xe) {
      if (ie(typeof he.length == "number"), he.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(he.length / 3), this.words = new Array(this.length);
      for (var $e = 0; $e < this.length; $e++)
        this.words[$e] = 0;
      var Te, Ie, we = 0;
      if (xe === "be")
        for ($e = he.length - 1, Te = 0; $e >= 0; $e -= 3)
          Ie = he[$e] | he[$e - 1] << 8 | he[$e - 2] << 16, this.words[Te] |= Ie << we & 67108863, this.words[Te + 1] = Ie >>> 26 - we & 67108863, we += 24, we >= 26 && (we -= 26, Te++);
      else if (xe === "le")
        for ($e = 0, Te = 0; $e < he.length; $e += 3)
          Ie = he[$e] | he[$e + 1] << 8 | he[$e + 2] << 16, this.words[Te] |= Ie << we & 67108863, this.words[Te + 1] = Ie >>> 26 - we & 67108863, we += 24, we >= 26 && (we -= 26, Te++);
      return this._strip();
    };
    function ue(_e, he) {
      var ve = _e.charCodeAt(he);
      if (ve >= 48 && ve <= 57)
        return ve - 48;
      if (ve >= 65 && ve <= 70)
        return ve - 55;
      if (ve >= 97 && ve <= 102)
        return ve - 87;
      ie(!1, "Invalid character in " + _e);
    }
    function de(_e, he, ve) {
      var xe = ue(_e, ve);
      return ve - 1 >= he && (xe |= ue(_e, ve - 1) << 4), xe;
    }
    se.prototype._parseHex = function(he, ve, xe) {
      this.length = Math.ceil((he.length - ve) / 6), this.words = new Array(this.length);
      for (var $e = 0; $e < this.length; $e++)
        this.words[$e] = 0;
      var Te = 0, Ie = 0, we;
      if (xe === "be")
        for ($e = he.length - 1; $e >= ve; $e -= 2)
          we = de(he, ve, $e) << Te, this.words[Ie] |= we & 67108863, Te >= 18 ? (Te -= 18, Ie += 1, this.words[Ie] |= we >>> 26) : Te += 8;
      else {
        var ke = he.length - ve;
        for ($e = ke % 2 === 0 ? ve + 1 : ve; $e < he.length; $e += 2)
          we = de(he, ve, $e) << Te, this.words[Ie] |= we & 67108863, Te >= 18 ? (Te -= 18, Ie += 1, this.words[Ie] |= we >>> 26) : Te += 8;
      }
      this._strip();
    };
    function me(_e, he, ve, xe) {
      for (var $e = 0, Te = 0, Ie = Math.min(_e.length, ve), we = he; we < Ie; we++) {
        var ke = _e.charCodeAt(we) - 48;
        $e *= xe, ke >= 49 ? Te = ke - 49 + 10 : ke >= 17 ? Te = ke - 17 + 10 : Te = ke, ie(ke >= 0 && Te < xe, "Invalid character"), $e += Te;
      }
      return $e;
    }
    se.prototype._parseBase = function(he, ve, xe) {
      this.words = [0], this.length = 1;
      for (var $e = 0, Te = 1; Te <= 67108863; Te *= ve)
        $e++;
      $e--, Te = Te / ve | 0;
      for (var Ie = he.length - xe, we = Ie % $e, ke = Math.min(Ie, Ie - we) + xe, ye = 0, Be = xe; Be < ke; Be += $e)
        ye = me(he, Be, Be + $e, ve), this.imuln(Te), this.words[0] + ye < 67108864 ? this.words[0] += ye : this._iaddn(ye);
      if (we !== 0) {
        var Xe = 1;
        for (ye = me(he, Be, he.length, ve), Be = 0; Be < we; Be++)
          Xe *= ve;
        this.imuln(Xe), this.words[0] + ye < 67108864 ? this.words[0] += ye : this._iaddn(ye);
      }
      this._strip();
    }, se.prototype.copy = function(he) {
      he.words = new Array(this.length);
      for (var ve = 0; ve < this.length; ve++)
        he.words[ve] = this.words[ve];
      he.length = this.length, he.negative = this.negative, he.red = this.red;
    };
    function fe(_e, he) {
      _e.words = he.words, _e.length = he.length, _e.negative = he.negative, _e.red = he.red;
    }
    if (se.prototype._move = function(he) {
      fe(he, this);
    }, se.prototype.clone = function() {
      var he = new se(null);
      return this.copy(he), he;
    }, se.prototype._expand = function(he) {
      for (; this.length < he; )
        this.words[this.length++] = 0;
      return this;
    }, se.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, se.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        se.prototype[Symbol.for("nodejs.util.inspect.custom")] = pe;
      } catch {
        se.prototype.inspect = pe;
      }
    else
      se.prototype.inspect = pe;
    function pe() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var ge = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], be = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], Se = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    se.prototype.toString = function(he, ve) {
      he = he || 10, ve = ve | 0 || 1;
      var xe;
      if (he === 16 || he === "hex") {
        xe = "";
        for (var $e = 0, Te = 0, Ie = 0; Ie < this.length; Ie++) {
          var we = this.words[Ie], ke = ((we << $e | Te) & 16777215).toString(16);
          Te = we >>> 24 - $e & 16777215, $e += 2, $e >= 26 && ($e -= 26, Ie--), Te !== 0 || Ie !== this.length - 1 ? xe = ge[6 - ke.length] + ke + xe : xe = ke + xe;
        }
        for (Te !== 0 && (xe = Te.toString(16) + xe); xe.length % ve !== 0; )
          xe = "0" + xe;
        return this.negative !== 0 && (xe = "-" + xe), xe;
      }
      if (he === (he | 0) && he >= 2 && he <= 36) {
        var ye = be[he], Be = Se[he];
        xe = "";
        var Xe = this.clone();
        for (Xe.negative = 0; !Xe.isZero(); ) {
          var et = Xe.modrn(Be).toString(he);
          Xe = Xe.idivn(Be), Xe.isZero() ? xe = et + xe : xe = ge[ye - et.length] + et + xe;
        }
        for (this.isZero() && (xe = "0" + xe); xe.length % ve !== 0; )
          xe = "0" + xe;
        return this.negative !== 0 && (xe = "-" + xe), xe;
      }
      ie(!1, "Base should be between 2 and 36");
    }, se.prototype.toNumber = function() {
      var he = this.words[0];
      return this.length === 2 ? he += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? he += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && ie(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -he : he;
    }, se.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, ce && (se.prototype.toBuffer = function(he, ve) {
      return this.toArrayLike(ce, he, ve);
    }), se.prototype.toArray = function(he, ve) {
      return this.toArrayLike(Array, he, ve);
    };
    var Pe = function(he, ve) {
      return he.allocUnsafe ? he.allocUnsafe(ve) : new he(ve);
    };
    se.prototype.toArrayLike = function(he, ve, xe) {
      this._strip();
      var $e = this.byteLength(), Te = xe || Math.max(1, $e);
      ie($e <= Te, "byte array longer than desired length"), ie(Te > 0, "Requested array length <= 0");
      var Ie = Pe(he, Te), we = ve === "le" ? "LE" : "BE";
      return this["_toArrayLike" + we](Ie, $e), Ie;
    }, se.prototype._toArrayLikeLE = function(he, ve) {
      for (var xe = 0, $e = 0, Te = 0, Ie = 0; Te < this.length; Te++) {
        var we = this.words[Te] << Ie | $e;
        he[xe++] = we & 255, xe < he.length && (he[xe++] = we >> 8 & 255), xe < he.length && (he[xe++] = we >> 16 & 255), Ie === 6 ? (xe < he.length && (he[xe++] = we >> 24 & 255), $e = 0, Ie = 0) : ($e = we >>> 24, Ie += 2);
      }
      if (xe < he.length)
        for (he[xe++] = $e; xe < he.length; )
          he[xe++] = 0;
    }, se.prototype._toArrayLikeBE = function(he, ve) {
      for (var xe = he.length - 1, $e = 0, Te = 0, Ie = 0; Te < this.length; Te++) {
        var we = this.words[Te] << Ie | $e;
        he[xe--] = we & 255, xe >= 0 && (he[xe--] = we >> 8 & 255), xe >= 0 && (he[xe--] = we >> 16 & 255), Ie === 6 ? (xe >= 0 && (he[xe--] = we >> 24 & 255), $e = 0, Ie = 0) : ($e = we >>> 24, Ie += 2);
      }
      if (xe >= 0)
        for (he[xe--] = $e; xe >= 0; )
          he[xe--] = 0;
    }, Math.clz32 ? se.prototype._countBits = function(he) {
      return 32 - Math.clz32(he);
    } : se.prototype._countBits = function(he) {
      var ve = he, xe = 0;
      return ve >= 4096 && (xe += 13, ve >>>= 13), ve >= 64 && (xe += 7, ve >>>= 7), ve >= 8 && (xe += 4, ve >>>= 4), ve >= 2 && (xe += 2, ve >>>= 2), xe + ve;
    }, se.prototype._zeroBits = function(he) {
      if (he === 0) return 26;
      var ve = he, xe = 0;
      return ve & 8191 || (xe += 13, ve >>>= 13), ve & 127 || (xe += 7, ve >>>= 7), ve & 15 || (xe += 4, ve >>>= 4), ve & 3 || (xe += 2, ve >>>= 2), ve & 1 || xe++, xe;
    }, se.prototype.bitLength = function() {
      var he = this.words[this.length - 1], ve = this._countBits(he);
      return (this.length - 1) * 26 + ve;
    };
    function Ee(_e) {
      for (var he = new Array(_e.bitLength()), ve = 0; ve < he.length; ve++) {
        var xe = ve / 26 | 0, $e = ve % 26;
        he[ve] = _e.words[xe] >>> $e & 1;
      }
      return he;
    }
    se.prototype.zeroBits = function() {
      if (this.isZero()) return 0;
      for (var he = 0, ve = 0; ve < this.length; ve++) {
        var xe = this._zeroBits(this.words[ve]);
        if (he += xe, xe !== 26) break;
      }
      return he;
    }, se.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, se.prototype.toTwos = function(he) {
      return this.negative !== 0 ? this.abs().inotn(he).iaddn(1) : this.clone();
    }, se.prototype.fromTwos = function(he) {
      return this.testn(he - 1) ? this.notn(he).iaddn(1).ineg() : this.clone();
    }, se.prototype.isNeg = function() {
      return this.negative !== 0;
    }, se.prototype.neg = function() {
      return this.clone().ineg();
    }, se.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, se.prototype.iuor = function(he) {
      for (; this.length < he.length; )
        this.words[this.length++] = 0;
      for (var ve = 0; ve < he.length; ve++)
        this.words[ve] = this.words[ve] | he.words[ve];
      return this._strip();
    }, se.prototype.ior = function(he) {
      return ie((this.negative | he.negative) === 0), this.iuor(he);
    }, se.prototype.or = function(he) {
      return this.length > he.length ? this.clone().ior(he) : he.clone().ior(this);
    }, se.prototype.uor = function(he) {
      return this.length > he.length ? this.clone().iuor(he) : he.clone().iuor(this);
    }, se.prototype.iuand = function(he) {
      var ve;
      this.length > he.length ? ve = he : ve = this;
      for (var xe = 0; xe < ve.length; xe++)
        this.words[xe] = this.words[xe] & he.words[xe];
      return this.length = ve.length, this._strip();
    }, se.prototype.iand = function(he) {
      return ie((this.negative | he.negative) === 0), this.iuand(he);
    }, se.prototype.and = function(he) {
      return this.length > he.length ? this.clone().iand(he) : he.clone().iand(this);
    }, se.prototype.uand = function(he) {
      return this.length > he.length ? this.clone().iuand(he) : he.clone().iuand(this);
    }, se.prototype.iuxor = function(he) {
      var ve, xe;
      this.length > he.length ? (ve = this, xe = he) : (ve = he, xe = this);
      for (var $e = 0; $e < xe.length; $e++)
        this.words[$e] = ve.words[$e] ^ xe.words[$e];
      if (this !== ve)
        for (; $e < ve.length; $e++)
          this.words[$e] = ve.words[$e];
      return this.length = ve.length, this._strip();
    }, se.prototype.ixor = function(he) {
      return ie((this.negative | he.negative) === 0), this.iuxor(he);
    }, se.prototype.xor = function(he) {
      return this.length > he.length ? this.clone().ixor(he) : he.clone().ixor(this);
    }, se.prototype.uxor = function(he) {
      return this.length > he.length ? this.clone().iuxor(he) : he.clone().iuxor(this);
    }, se.prototype.inotn = function(he) {
      ie(typeof he == "number" && he >= 0);
      var ve = Math.ceil(he / 26) | 0, xe = he % 26;
      this._expand(ve), xe > 0 && ve--;
      for (var $e = 0; $e < ve; $e++)
        this.words[$e] = ~this.words[$e] & 67108863;
      return xe > 0 && (this.words[$e] = ~this.words[$e] & 67108863 >> 26 - xe), this._strip();
    }, se.prototype.notn = function(he) {
      return this.clone().inotn(he);
    }, se.prototype.setn = function(he, ve) {
      ie(typeof he == "number" && he >= 0);
      var xe = he / 26 | 0, $e = he % 26;
      return this._expand(xe + 1), ve ? this.words[xe] = this.words[xe] | 1 << $e : this.words[xe] = this.words[xe] & ~(1 << $e), this._strip();
    }, se.prototype.iadd = function(he) {
      var ve;
      if (this.negative !== 0 && he.negative === 0)
        return this.negative = 0, ve = this.isub(he), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && he.negative !== 0)
        return he.negative = 0, ve = this.isub(he), he.negative = 1, ve._normSign();
      var xe, $e;
      this.length > he.length ? (xe = this, $e = he) : (xe = he, $e = this);
      for (var Te = 0, Ie = 0; Ie < $e.length; Ie++)
        ve = (xe.words[Ie] | 0) + ($e.words[Ie] | 0) + Te, this.words[Ie] = ve & 67108863, Te = ve >>> 26;
      for (; Te !== 0 && Ie < xe.length; Ie++)
        ve = (xe.words[Ie] | 0) + Te, this.words[Ie] = ve & 67108863, Te = ve >>> 26;
      if (this.length = xe.length, Te !== 0)
        this.words[this.length] = Te, this.length++;
      else if (xe !== this)
        for (; Ie < xe.length; Ie++)
          this.words[Ie] = xe.words[Ie];
      return this;
    }, se.prototype.add = function(he) {
      var ve;
      return he.negative !== 0 && this.negative === 0 ? (he.negative = 0, ve = this.sub(he), he.negative ^= 1, ve) : he.negative === 0 && this.negative !== 0 ? (this.negative = 0, ve = he.sub(this), this.negative = 1, ve) : this.length > he.length ? this.clone().iadd(he) : he.clone().iadd(this);
    }, se.prototype.isub = function(he) {
      if (he.negative !== 0) {
        he.negative = 0;
        var ve = this.iadd(he);
        return he.negative = 1, ve._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(he), this.negative = 1, this._normSign();
      var xe = this.cmp(he);
      if (xe === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var $e, Te;
      xe > 0 ? ($e = this, Te = he) : ($e = he, Te = this);
      for (var Ie = 0, we = 0; we < Te.length; we++)
        ve = ($e.words[we] | 0) - (Te.words[we] | 0) + Ie, Ie = ve >> 26, this.words[we] = ve & 67108863;
      for (; Ie !== 0 && we < $e.length; we++)
        ve = ($e.words[we] | 0) + Ie, Ie = ve >> 26, this.words[we] = ve & 67108863;
      if (Ie === 0 && we < $e.length && $e !== this)
        for (; we < $e.length; we++)
          this.words[we] = $e.words[we];
      return this.length = Math.max(this.length, we), $e !== this && (this.negative = 1), this._strip();
    }, se.prototype.sub = function(he) {
      return this.clone().isub(he);
    };
    function Ve(_e, he, ve) {
      ve.negative = he.negative ^ _e.negative;
      var xe = _e.length + he.length | 0;
      ve.length = xe, xe = xe - 1 | 0;
      var $e = _e.words[0] | 0, Te = he.words[0] | 0, Ie = $e * Te, we = Ie & 67108863, ke = Ie / 67108864 | 0;
      ve.words[0] = we;
      for (var ye = 1; ye < xe; ye++) {
        for (var Be = ke >>> 26, Xe = ke & 67108863, et = Math.min(ye, he.length - 1), Ye = Math.max(0, ye - _e.length + 1); Ye <= et; Ye++) {
          var De = ye - Ye | 0;
          $e = _e.words[De] | 0, Te = he.words[Ye] | 0, Ie = $e * Te + Xe, Be += Ie / 67108864 | 0, Xe = Ie & 67108863;
        }
        ve.words[ye] = Xe | 0, ke = Be | 0;
      }
      return ke !== 0 ? ve.words[ye] = ke | 0 : ve.length--, ve._strip();
    }
    var Ae = function(he, ve, xe) {
      var $e = he.words, Te = ve.words, Ie = xe.words, we = 0, ke, ye, Be, Xe = $e[0] | 0, et = Xe & 8191, Ye = Xe >>> 13, De = $e[1] | 0, je = De & 8191, rt = De >>> 13, at = $e[2] | 0, qe = at & 8191, We = at >>> 13, ze = $e[3] | 0, Ge = ze & 8191, nt = ze >>> 13, ot = $e[4] | 0, lt = ot & 8191, mt = ot >>> 13, dt = $e[5] | 0, gt = dt & 8191, bt = dt >>> 13, At = $e[6] | 0, wt = At & 8191, pt = At >>> 13, ut = $e[7] | 0, ht = ut & 8191, vt = ut >>> 13, xt = $e[8] | 0, Bt = xt & 8191, Je = xt >>> 13, Me = $e[9] | 0, Le = Me & 8191, Qe = Me >>> 13, it = Te[0] | 0, st = it & 8191, ct = it >>> 13, kt = Te[1] | 0, St = kt & 8191, yt = kt >>> 13, Nt = Te[2] | 0, _t = Nt & 8191, Ct = Nt >>> 13, Ut = Te[3] | 0, Ot = Ut & 8191, $t = Ut >>> 13, zt = Te[4] | 0, Dt = zt & 8191, Et = zt >>> 13, qt = Te[5] | 0, Lt = qt & 8191, Pt = qt >>> 13, Gt = Te[6] | 0, Ft = Gt & 8191, Vt = Gt >>> 13, Wt = Te[7] | 0, Ht = Wt & 8191, It = Wt >>> 13, Kt = Te[8] | 0, jt = Kt & 8191, Tt = Kt >>> 13, Yt = Te[9] | 0, Mt = Yt & 8191, Rt = Yt >>> 13;
      xe.negative = he.negative ^ ve.negative, xe.length = 19, ke = Math.imul(et, st), ye = Math.imul(et, ct), ye = ye + Math.imul(Ye, st) | 0, Be = Math.imul(Ye, ct);
      var Jt = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (Jt >>> 26) | 0, Jt &= 67108863, ke = Math.imul(je, st), ye = Math.imul(je, ct), ye = ye + Math.imul(rt, st) | 0, Be = Math.imul(rt, ct), ke = ke + Math.imul(et, St) | 0, ye = ye + Math.imul(et, yt) | 0, ye = ye + Math.imul(Ye, St) | 0, Be = Be + Math.imul(Ye, yt) | 0;
      var Xt = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (Xt >>> 26) | 0, Xt &= 67108863, ke = Math.imul(qe, st), ye = Math.imul(qe, ct), ye = ye + Math.imul(We, st) | 0, Be = Math.imul(We, ct), ke = ke + Math.imul(je, St) | 0, ye = ye + Math.imul(je, yt) | 0, ye = ye + Math.imul(rt, St) | 0, Be = Be + Math.imul(rt, yt) | 0, ke = ke + Math.imul(et, _t) | 0, ye = ye + Math.imul(et, Ct) | 0, ye = ye + Math.imul(Ye, _t) | 0, Be = Be + Math.imul(Ye, Ct) | 0;
      var Zt = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (Zt >>> 26) | 0, Zt &= 67108863, ke = Math.imul(Ge, st), ye = Math.imul(Ge, ct), ye = ye + Math.imul(nt, st) | 0, Be = Math.imul(nt, ct), ke = ke + Math.imul(qe, St) | 0, ye = ye + Math.imul(qe, yt) | 0, ye = ye + Math.imul(We, St) | 0, Be = Be + Math.imul(We, yt) | 0, ke = ke + Math.imul(je, _t) | 0, ye = ye + Math.imul(je, Ct) | 0, ye = ye + Math.imul(rt, _t) | 0, Be = Be + Math.imul(rt, Ct) | 0, ke = ke + Math.imul(et, Ot) | 0, ye = ye + Math.imul(et, $t) | 0, ye = ye + Math.imul(Ye, Ot) | 0, Be = Be + Math.imul(Ye, $t) | 0;
      var Qt = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (Qt >>> 26) | 0, Qt &= 67108863, ke = Math.imul(lt, st), ye = Math.imul(lt, ct), ye = ye + Math.imul(mt, st) | 0, Be = Math.imul(mt, ct), ke = ke + Math.imul(Ge, St) | 0, ye = ye + Math.imul(Ge, yt) | 0, ye = ye + Math.imul(nt, St) | 0, Be = Be + Math.imul(nt, yt) | 0, ke = ke + Math.imul(qe, _t) | 0, ye = ye + Math.imul(qe, Ct) | 0, ye = ye + Math.imul(We, _t) | 0, Be = Be + Math.imul(We, Ct) | 0, ke = ke + Math.imul(je, Ot) | 0, ye = ye + Math.imul(je, $t) | 0, ye = ye + Math.imul(rt, Ot) | 0, Be = Be + Math.imul(rt, $t) | 0, ke = ke + Math.imul(et, Dt) | 0, ye = ye + Math.imul(et, Et) | 0, ye = ye + Math.imul(Ye, Dt) | 0, Be = Be + Math.imul(Ye, Et) | 0;
      var er = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (er >>> 26) | 0, er &= 67108863, ke = Math.imul(gt, st), ye = Math.imul(gt, ct), ye = ye + Math.imul(bt, st) | 0, Be = Math.imul(bt, ct), ke = ke + Math.imul(lt, St) | 0, ye = ye + Math.imul(lt, yt) | 0, ye = ye + Math.imul(mt, St) | 0, Be = Be + Math.imul(mt, yt) | 0, ke = ke + Math.imul(Ge, _t) | 0, ye = ye + Math.imul(Ge, Ct) | 0, ye = ye + Math.imul(nt, _t) | 0, Be = Be + Math.imul(nt, Ct) | 0, ke = ke + Math.imul(qe, Ot) | 0, ye = ye + Math.imul(qe, $t) | 0, ye = ye + Math.imul(We, Ot) | 0, Be = Be + Math.imul(We, $t) | 0, ke = ke + Math.imul(je, Dt) | 0, ye = ye + Math.imul(je, Et) | 0, ye = ye + Math.imul(rt, Dt) | 0, Be = Be + Math.imul(rt, Et) | 0, ke = ke + Math.imul(et, Lt) | 0, ye = ye + Math.imul(et, Pt) | 0, ye = ye + Math.imul(Ye, Lt) | 0, Be = Be + Math.imul(Ye, Pt) | 0;
      var tr = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (tr >>> 26) | 0, tr &= 67108863, ke = Math.imul(wt, st), ye = Math.imul(wt, ct), ye = ye + Math.imul(pt, st) | 0, Be = Math.imul(pt, ct), ke = ke + Math.imul(gt, St) | 0, ye = ye + Math.imul(gt, yt) | 0, ye = ye + Math.imul(bt, St) | 0, Be = Be + Math.imul(bt, yt) | 0, ke = ke + Math.imul(lt, _t) | 0, ye = ye + Math.imul(lt, Ct) | 0, ye = ye + Math.imul(mt, _t) | 0, Be = Be + Math.imul(mt, Ct) | 0, ke = ke + Math.imul(Ge, Ot) | 0, ye = ye + Math.imul(Ge, $t) | 0, ye = ye + Math.imul(nt, Ot) | 0, Be = Be + Math.imul(nt, $t) | 0, ke = ke + Math.imul(qe, Dt) | 0, ye = ye + Math.imul(qe, Et) | 0, ye = ye + Math.imul(We, Dt) | 0, Be = Be + Math.imul(We, Et) | 0, ke = ke + Math.imul(je, Lt) | 0, ye = ye + Math.imul(je, Pt) | 0, ye = ye + Math.imul(rt, Lt) | 0, Be = Be + Math.imul(rt, Pt) | 0, ke = ke + Math.imul(et, Ft) | 0, ye = ye + Math.imul(et, Vt) | 0, ye = ye + Math.imul(Ye, Ft) | 0, Be = Be + Math.imul(Ye, Vt) | 0;
      var rr = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (rr >>> 26) | 0, rr &= 67108863, ke = Math.imul(ht, st), ye = Math.imul(ht, ct), ye = ye + Math.imul(vt, st) | 0, Be = Math.imul(vt, ct), ke = ke + Math.imul(wt, St) | 0, ye = ye + Math.imul(wt, yt) | 0, ye = ye + Math.imul(pt, St) | 0, Be = Be + Math.imul(pt, yt) | 0, ke = ke + Math.imul(gt, _t) | 0, ye = ye + Math.imul(gt, Ct) | 0, ye = ye + Math.imul(bt, _t) | 0, Be = Be + Math.imul(bt, Ct) | 0, ke = ke + Math.imul(lt, Ot) | 0, ye = ye + Math.imul(lt, $t) | 0, ye = ye + Math.imul(mt, Ot) | 0, Be = Be + Math.imul(mt, $t) | 0, ke = ke + Math.imul(Ge, Dt) | 0, ye = ye + Math.imul(Ge, Et) | 0, ye = ye + Math.imul(nt, Dt) | 0, Be = Be + Math.imul(nt, Et) | 0, ke = ke + Math.imul(qe, Lt) | 0, ye = ye + Math.imul(qe, Pt) | 0, ye = ye + Math.imul(We, Lt) | 0, Be = Be + Math.imul(We, Pt) | 0, ke = ke + Math.imul(je, Ft) | 0, ye = ye + Math.imul(je, Vt) | 0, ye = ye + Math.imul(rt, Ft) | 0, Be = Be + Math.imul(rt, Vt) | 0, ke = ke + Math.imul(et, Ht) | 0, ye = ye + Math.imul(et, It) | 0, ye = ye + Math.imul(Ye, Ht) | 0, Be = Be + Math.imul(Ye, It) | 0;
      var nr = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (nr >>> 26) | 0, nr &= 67108863, ke = Math.imul(Bt, st), ye = Math.imul(Bt, ct), ye = ye + Math.imul(Je, st) | 0, Be = Math.imul(Je, ct), ke = ke + Math.imul(ht, St) | 0, ye = ye + Math.imul(ht, yt) | 0, ye = ye + Math.imul(vt, St) | 0, Be = Be + Math.imul(vt, yt) | 0, ke = ke + Math.imul(wt, _t) | 0, ye = ye + Math.imul(wt, Ct) | 0, ye = ye + Math.imul(pt, _t) | 0, Be = Be + Math.imul(pt, Ct) | 0, ke = ke + Math.imul(gt, Ot) | 0, ye = ye + Math.imul(gt, $t) | 0, ye = ye + Math.imul(bt, Ot) | 0, Be = Be + Math.imul(bt, $t) | 0, ke = ke + Math.imul(lt, Dt) | 0, ye = ye + Math.imul(lt, Et) | 0, ye = ye + Math.imul(mt, Dt) | 0, Be = Be + Math.imul(mt, Et) | 0, ke = ke + Math.imul(Ge, Lt) | 0, ye = ye + Math.imul(Ge, Pt) | 0, ye = ye + Math.imul(nt, Lt) | 0, Be = Be + Math.imul(nt, Pt) | 0, ke = ke + Math.imul(qe, Ft) | 0, ye = ye + Math.imul(qe, Vt) | 0, ye = ye + Math.imul(We, Ft) | 0, Be = Be + Math.imul(We, Vt) | 0, ke = ke + Math.imul(je, Ht) | 0, ye = ye + Math.imul(je, It) | 0, ye = ye + Math.imul(rt, Ht) | 0, Be = Be + Math.imul(rt, It) | 0, ke = ke + Math.imul(et, jt) | 0, ye = ye + Math.imul(et, Tt) | 0, ye = ye + Math.imul(Ye, jt) | 0, Be = Be + Math.imul(Ye, Tt) | 0;
      var ar = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (ar >>> 26) | 0, ar &= 67108863, ke = Math.imul(Le, st), ye = Math.imul(Le, ct), ye = ye + Math.imul(Qe, st) | 0, Be = Math.imul(Qe, ct), ke = ke + Math.imul(Bt, St) | 0, ye = ye + Math.imul(Bt, yt) | 0, ye = ye + Math.imul(Je, St) | 0, Be = Be + Math.imul(Je, yt) | 0, ke = ke + Math.imul(ht, _t) | 0, ye = ye + Math.imul(ht, Ct) | 0, ye = ye + Math.imul(vt, _t) | 0, Be = Be + Math.imul(vt, Ct) | 0, ke = ke + Math.imul(wt, Ot) | 0, ye = ye + Math.imul(wt, $t) | 0, ye = ye + Math.imul(pt, Ot) | 0, Be = Be + Math.imul(pt, $t) | 0, ke = ke + Math.imul(gt, Dt) | 0, ye = ye + Math.imul(gt, Et) | 0, ye = ye + Math.imul(bt, Dt) | 0, Be = Be + Math.imul(bt, Et) | 0, ke = ke + Math.imul(lt, Lt) | 0, ye = ye + Math.imul(lt, Pt) | 0, ye = ye + Math.imul(mt, Lt) | 0, Be = Be + Math.imul(mt, Pt) | 0, ke = ke + Math.imul(Ge, Ft) | 0, ye = ye + Math.imul(Ge, Vt) | 0, ye = ye + Math.imul(nt, Ft) | 0, Be = Be + Math.imul(nt, Vt) | 0, ke = ke + Math.imul(qe, Ht) | 0, ye = ye + Math.imul(qe, It) | 0, ye = ye + Math.imul(We, Ht) | 0, Be = Be + Math.imul(We, It) | 0, ke = ke + Math.imul(je, jt) | 0, ye = ye + Math.imul(je, Tt) | 0, ye = ye + Math.imul(rt, jt) | 0, Be = Be + Math.imul(rt, Tt) | 0, ke = ke + Math.imul(et, Mt) | 0, ye = ye + Math.imul(et, Rt) | 0, ye = ye + Math.imul(Ye, Mt) | 0, Be = Be + Math.imul(Ye, Rt) | 0;
      var ir = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (ir >>> 26) | 0, ir &= 67108863, ke = Math.imul(Le, St), ye = Math.imul(Le, yt), ye = ye + Math.imul(Qe, St) | 0, Be = Math.imul(Qe, yt), ke = ke + Math.imul(Bt, _t) | 0, ye = ye + Math.imul(Bt, Ct) | 0, ye = ye + Math.imul(Je, _t) | 0, Be = Be + Math.imul(Je, Ct) | 0, ke = ke + Math.imul(ht, Ot) | 0, ye = ye + Math.imul(ht, $t) | 0, ye = ye + Math.imul(vt, Ot) | 0, Be = Be + Math.imul(vt, $t) | 0, ke = ke + Math.imul(wt, Dt) | 0, ye = ye + Math.imul(wt, Et) | 0, ye = ye + Math.imul(pt, Dt) | 0, Be = Be + Math.imul(pt, Et) | 0, ke = ke + Math.imul(gt, Lt) | 0, ye = ye + Math.imul(gt, Pt) | 0, ye = ye + Math.imul(bt, Lt) | 0, Be = Be + Math.imul(bt, Pt) | 0, ke = ke + Math.imul(lt, Ft) | 0, ye = ye + Math.imul(lt, Vt) | 0, ye = ye + Math.imul(mt, Ft) | 0, Be = Be + Math.imul(mt, Vt) | 0, ke = ke + Math.imul(Ge, Ht) | 0, ye = ye + Math.imul(Ge, It) | 0, ye = ye + Math.imul(nt, Ht) | 0, Be = Be + Math.imul(nt, It) | 0, ke = ke + Math.imul(qe, jt) | 0, ye = ye + Math.imul(qe, Tt) | 0, ye = ye + Math.imul(We, jt) | 0, Be = Be + Math.imul(We, Tt) | 0, ke = ke + Math.imul(je, Mt) | 0, ye = ye + Math.imul(je, Rt) | 0, ye = ye + Math.imul(rt, Mt) | 0, Be = Be + Math.imul(rt, Rt) | 0;
      var or = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (or >>> 26) | 0, or &= 67108863, ke = Math.imul(Le, _t), ye = Math.imul(Le, Ct), ye = ye + Math.imul(Qe, _t) | 0, Be = Math.imul(Qe, Ct), ke = ke + Math.imul(Bt, Ot) | 0, ye = ye + Math.imul(Bt, $t) | 0, ye = ye + Math.imul(Je, Ot) | 0, Be = Be + Math.imul(Je, $t) | 0, ke = ke + Math.imul(ht, Dt) | 0, ye = ye + Math.imul(ht, Et) | 0, ye = ye + Math.imul(vt, Dt) | 0, Be = Be + Math.imul(vt, Et) | 0, ke = ke + Math.imul(wt, Lt) | 0, ye = ye + Math.imul(wt, Pt) | 0, ye = ye + Math.imul(pt, Lt) | 0, Be = Be + Math.imul(pt, Pt) | 0, ke = ke + Math.imul(gt, Ft) | 0, ye = ye + Math.imul(gt, Vt) | 0, ye = ye + Math.imul(bt, Ft) | 0, Be = Be + Math.imul(bt, Vt) | 0, ke = ke + Math.imul(lt, Ht) | 0, ye = ye + Math.imul(lt, It) | 0, ye = ye + Math.imul(mt, Ht) | 0, Be = Be + Math.imul(mt, It) | 0, ke = ke + Math.imul(Ge, jt) | 0, ye = ye + Math.imul(Ge, Tt) | 0, ye = ye + Math.imul(nt, jt) | 0, Be = Be + Math.imul(nt, Tt) | 0, ke = ke + Math.imul(qe, Mt) | 0, ye = ye + Math.imul(qe, Rt) | 0, ye = ye + Math.imul(We, Mt) | 0, Be = Be + Math.imul(We, Rt) | 0;
      var lr = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (lr >>> 26) | 0, lr &= 67108863, ke = Math.imul(Le, Ot), ye = Math.imul(Le, $t), ye = ye + Math.imul(Qe, Ot) | 0, Be = Math.imul(Qe, $t), ke = ke + Math.imul(Bt, Dt) | 0, ye = ye + Math.imul(Bt, Et) | 0, ye = ye + Math.imul(Je, Dt) | 0, Be = Be + Math.imul(Je, Et) | 0, ke = ke + Math.imul(ht, Lt) | 0, ye = ye + Math.imul(ht, Pt) | 0, ye = ye + Math.imul(vt, Lt) | 0, Be = Be + Math.imul(vt, Pt) | 0, ke = ke + Math.imul(wt, Ft) | 0, ye = ye + Math.imul(wt, Vt) | 0, ye = ye + Math.imul(pt, Ft) | 0, Be = Be + Math.imul(pt, Vt) | 0, ke = ke + Math.imul(gt, Ht) | 0, ye = ye + Math.imul(gt, It) | 0, ye = ye + Math.imul(bt, Ht) | 0, Be = Be + Math.imul(bt, It) | 0, ke = ke + Math.imul(lt, jt) | 0, ye = ye + Math.imul(lt, Tt) | 0, ye = ye + Math.imul(mt, jt) | 0, Be = Be + Math.imul(mt, Tt) | 0, ke = ke + Math.imul(Ge, Mt) | 0, ye = ye + Math.imul(Ge, Rt) | 0, ye = ye + Math.imul(nt, Mt) | 0, Be = Be + Math.imul(nt, Rt) | 0;
      var cr = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (cr >>> 26) | 0, cr &= 67108863, ke = Math.imul(Le, Dt), ye = Math.imul(Le, Et), ye = ye + Math.imul(Qe, Dt) | 0, Be = Math.imul(Qe, Et), ke = ke + Math.imul(Bt, Lt) | 0, ye = ye + Math.imul(Bt, Pt) | 0, ye = ye + Math.imul(Je, Lt) | 0, Be = Be + Math.imul(Je, Pt) | 0, ke = ke + Math.imul(ht, Ft) | 0, ye = ye + Math.imul(ht, Vt) | 0, ye = ye + Math.imul(vt, Ft) | 0, Be = Be + Math.imul(vt, Vt) | 0, ke = ke + Math.imul(wt, Ht) | 0, ye = ye + Math.imul(wt, It) | 0, ye = ye + Math.imul(pt, Ht) | 0, Be = Be + Math.imul(pt, It) | 0, ke = ke + Math.imul(gt, jt) | 0, ye = ye + Math.imul(gt, Tt) | 0, ye = ye + Math.imul(bt, jt) | 0, Be = Be + Math.imul(bt, Tt) | 0, ke = ke + Math.imul(lt, Mt) | 0, ye = ye + Math.imul(lt, Rt) | 0, ye = ye + Math.imul(mt, Mt) | 0, Be = Be + Math.imul(mt, Rt) | 0;
      var ur = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (ur >>> 26) | 0, ur &= 67108863, ke = Math.imul(Le, Lt), ye = Math.imul(Le, Pt), ye = ye + Math.imul(Qe, Lt) | 0, Be = Math.imul(Qe, Pt), ke = ke + Math.imul(Bt, Ft) | 0, ye = ye + Math.imul(Bt, Vt) | 0, ye = ye + Math.imul(Je, Ft) | 0, Be = Be + Math.imul(Je, Vt) | 0, ke = ke + Math.imul(ht, Ht) | 0, ye = ye + Math.imul(ht, It) | 0, ye = ye + Math.imul(vt, Ht) | 0, Be = Be + Math.imul(vt, It) | 0, ke = ke + Math.imul(wt, jt) | 0, ye = ye + Math.imul(wt, Tt) | 0, ye = ye + Math.imul(pt, jt) | 0, Be = Be + Math.imul(pt, Tt) | 0, ke = ke + Math.imul(gt, Mt) | 0, ye = ye + Math.imul(gt, Rt) | 0, ye = ye + Math.imul(bt, Mt) | 0, Be = Be + Math.imul(bt, Rt) | 0;
      var dr = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (dr >>> 26) | 0, dr &= 67108863, ke = Math.imul(Le, Ft), ye = Math.imul(Le, Vt), ye = ye + Math.imul(Qe, Ft) | 0, Be = Math.imul(Qe, Vt), ke = ke + Math.imul(Bt, Ht) | 0, ye = ye + Math.imul(Bt, It) | 0, ye = ye + Math.imul(Je, Ht) | 0, Be = Be + Math.imul(Je, It) | 0, ke = ke + Math.imul(ht, jt) | 0, ye = ye + Math.imul(ht, Tt) | 0, ye = ye + Math.imul(vt, jt) | 0, Be = Be + Math.imul(vt, Tt) | 0, ke = ke + Math.imul(wt, Mt) | 0, ye = ye + Math.imul(wt, Rt) | 0, ye = ye + Math.imul(pt, Mt) | 0, Be = Be + Math.imul(pt, Rt) | 0;
      var fr = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (fr >>> 26) | 0, fr &= 67108863, ke = Math.imul(Le, Ht), ye = Math.imul(Le, It), ye = ye + Math.imul(Qe, Ht) | 0, Be = Math.imul(Qe, It), ke = ke + Math.imul(Bt, jt) | 0, ye = ye + Math.imul(Bt, Tt) | 0, ye = ye + Math.imul(Je, jt) | 0, Be = Be + Math.imul(Je, Tt) | 0, ke = ke + Math.imul(ht, Mt) | 0, ye = ye + Math.imul(ht, Rt) | 0, ye = ye + Math.imul(vt, Mt) | 0, Be = Be + Math.imul(vt, Rt) | 0;
      var pr = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (pr >>> 26) | 0, pr &= 67108863, ke = Math.imul(Le, jt), ye = Math.imul(Le, Tt), ye = ye + Math.imul(Qe, jt) | 0, Be = Math.imul(Qe, Tt), ke = ke + Math.imul(Bt, Mt) | 0, ye = ye + Math.imul(Bt, Rt) | 0, ye = ye + Math.imul(Je, Mt) | 0, Be = Be + Math.imul(Je, Rt) | 0;
      var vr = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (vr >>> 26) | 0, vr &= 67108863, ke = Math.imul(Le, Mt), ye = Math.imul(Le, Rt), ye = ye + Math.imul(Qe, Mt) | 0, Be = Math.imul(Qe, Rt);
      var gr = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      return we = (Be + (ye >>> 13) | 0) + (gr >>> 26) | 0, gr &= 67108863, Ie[0] = Jt, Ie[1] = Xt, Ie[2] = Zt, Ie[3] = Qt, Ie[4] = er, Ie[5] = tr, Ie[6] = rr, Ie[7] = nr, Ie[8] = ar, Ie[9] = ir, Ie[10] = or, Ie[11] = lr, Ie[12] = cr, Ie[13] = ur, Ie[14] = dr, Ie[15] = fr, Ie[16] = pr, Ie[17] = vr, Ie[18] = gr, we !== 0 && (Ie[19] = we, xe.length++), xe;
    };
    Math.imul || (Ae = Ve);
    function Oe(_e, he, ve) {
      ve.negative = he.negative ^ _e.negative, ve.length = _e.length + he.length;
      for (var xe = 0, $e = 0, Te = 0; Te < ve.length - 1; Te++) {
        var Ie = $e;
        $e = 0;
        for (var we = xe & 67108863, ke = Math.min(Te, he.length - 1), ye = Math.max(0, Te - _e.length + 1); ye <= ke; ye++) {
          var Be = Te - ye, Xe = _e.words[Be] | 0, et = he.words[ye] | 0, Ye = Xe * et, De = Ye & 67108863;
          Ie = Ie + (Ye / 67108864 | 0) | 0, De = De + we | 0, we = De & 67108863, Ie = Ie + (De >>> 26) | 0, $e += Ie >>> 26, Ie &= 67108863;
        }
        ve.words[Te] = we, xe = Ie, Ie = $e;
      }
      return xe !== 0 ? ve.words[Te] = xe : ve.length--, ve._strip();
    }
    function Ne(_e, he, ve) {
      return Oe(_e, he, ve);
    }
    se.prototype.mulTo = function(he, ve) {
      var xe, $e = this.length + he.length;
      return this.length === 10 && he.length === 10 ? xe = Ae(this, he, ve) : $e < 63 ? xe = Ve(this, he, ve) : $e < 1024 ? xe = Oe(this, he, ve) : xe = Ne(this, he, ve), xe;
    }, se.prototype.mul = function(he) {
      var ve = new se(null);
      return ve.words = new Array(this.length + he.length), this.mulTo(he, ve);
    }, se.prototype.mulf = function(he) {
      var ve = new se(null);
      return ve.words = new Array(this.length + he.length), Ne(this, he, ve);
    }, se.prototype.imul = function(he) {
      return this.clone().mulTo(he, this);
    }, se.prototype.imuln = function(he) {
      var ve = he < 0;
      ve && (he = -he), ie(typeof he == "number"), ie(he < 67108864);
      for (var xe = 0, $e = 0; $e < this.length; $e++) {
        var Te = (this.words[$e] | 0) * he, Ie = (Te & 67108863) + (xe & 67108863);
        xe >>= 26, xe += Te / 67108864 | 0, xe += Ie >>> 26, this.words[$e] = Ie & 67108863;
      }
      return xe !== 0 && (this.words[$e] = xe, this.length++), ve ? this.ineg() : this;
    }, se.prototype.muln = function(he) {
      return this.clone().imuln(he);
    }, se.prototype.sqr = function() {
      return this.mul(this);
    }, se.prototype.isqr = function() {
      return this.imul(this.clone());
    }, se.prototype.pow = function(he) {
      var ve = Ee(he);
      if (ve.length === 0) return new se(1);
      for (var xe = this, $e = 0; $e < ve.length && ve[$e] === 0; $e++, xe = xe.sqr())
        ;
      if (++$e < ve.length)
        for (var Te = xe.sqr(); $e < ve.length; $e++, Te = Te.sqr())
          ve[$e] !== 0 && (xe = xe.mul(Te));
      return xe;
    }, se.prototype.iushln = function(he) {
      ie(typeof he == "number" && he >= 0);
      var ve = he % 26, xe = (he - ve) / 26, $e = 67108863 >>> 26 - ve << 26 - ve, Te;
      if (ve !== 0) {
        var Ie = 0;
        for (Te = 0; Te < this.length; Te++) {
          var we = this.words[Te] & $e, ke = (this.words[Te] | 0) - we << ve;
          this.words[Te] = ke | Ie, Ie = we >>> 26 - ve;
        }
        Ie && (this.words[Te] = Ie, this.length++);
      }
      if (xe !== 0) {
        for (Te = this.length - 1; Te >= 0; Te--)
          this.words[Te + xe] = this.words[Te];
        for (Te = 0; Te < xe; Te++)
          this.words[Te] = 0;
        this.length += xe;
      }
      return this._strip();
    }, se.prototype.ishln = function(he) {
      return ie(this.negative === 0), this.iushln(he);
    }, se.prototype.iushrn = function(he, ve, xe) {
      ie(typeof he == "number" && he >= 0);
      var $e;
      ve ? $e = (ve - ve % 26) / 26 : $e = 0;
      var Te = he % 26, Ie = Math.min((he - Te) / 26, this.length), we = 67108863 ^ 67108863 >>> Te << Te, ke = xe;
      if ($e -= Ie, $e = Math.max(0, $e), ke) {
        for (var ye = 0; ye < Ie; ye++)
          ke.words[ye] = this.words[ye];
        ke.length = Ie;
      }
      if (Ie !== 0) if (this.length > Ie)
        for (this.length -= Ie, ye = 0; ye < this.length; ye++)
          this.words[ye] = this.words[ye + Ie];
      else
        this.words[0] = 0, this.length = 1;
      var Be = 0;
      for (ye = this.length - 1; ye >= 0 && (Be !== 0 || ye >= $e); ye--) {
        var Xe = this.words[ye] | 0;
        this.words[ye] = Be << 26 - Te | Xe >>> Te, Be = Xe & we;
      }
      return ke && Be !== 0 && (ke.words[ke.length++] = Be), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, se.prototype.ishrn = function(he, ve, xe) {
      return ie(this.negative === 0), this.iushrn(he, ve, xe);
    }, se.prototype.shln = function(he) {
      return this.clone().ishln(he);
    }, se.prototype.ushln = function(he) {
      return this.clone().iushln(he);
    }, se.prototype.shrn = function(he) {
      return this.clone().ishrn(he);
    }, se.prototype.ushrn = function(he) {
      return this.clone().iushrn(he);
    }, se.prototype.testn = function(he) {
      ie(typeof he == "number" && he >= 0);
      var ve = he % 26, xe = (he - ve) / 26, $e = 1 << ve;
      if (this.length <= xe) return !1;
      var Te = this.words[xe];
      return !!(Te & $e);
    }, se.prototype.imaskn = function(he) {
      ie(typeof he == "number" && he >= 0);
      var ve = he % 26, xe = (he - ve) / 26;
      if (ie(this.negative === 0, "imaskn works only with positive numbers"), this.length <= xe)
        return this;
      if (ve !== 0 && xe++, this.length = Math.min(xe, this.length), ve !== 0) {
        var $e = 67108863 ^ 67108863 >>> ve << ve;
        this.words[this.length - 1] &= $e;
      }
      return this._strip();
    }, se.prototype.maskn = function(he) {
      return this.clone().imaskn(he);
    }, se.prototype.iaddn = function(he) {
      return ie(typeof he == "number"), ie(he < 67108864), he < 0 ? this.isubn(-he) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= he ? (this.words[0] = he - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(he), this.negative = 1, this) : this._iaddn(he);
    }, se.prototype._iaddn = function(he) {
      this.words[0] += he;
      for (var ve = 0; ve < this.length && this.words[ve] >= 67108864; ve++)
        this.words[ve] -= 67108864, ve === this.length - 1 ? this.words[ve + 1] = 1 : this.words[ve + 1]++;
      return this.length = Math.max(this.length, ve + 1), this;
    }, se.prototype.isubn = function(he) {
      if (ie(typeof he == "number"), ie(he < 67108864), he < 0) return this.iaddn(-he);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(he), this.negative = 1, this;
      if (this.words[0] -= he, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var ve = 0; ve < this.length && this.words[ve] < 0; ve++)
          this.words[ve] += 67108864, this.words[ve + 1] -= 1;
      return this._strip();
    }, se.prototype.addn = function(he) {
      return this.clone().iaddn(he);
    }, se.prototype.subn = function(he) {
      return this.clone().isubn(he);
    }, se.prototype.iabs = function() {
      return this.negative = 0, this;
    }, se.prototype.abs = function() {
      return this.clone().iabs();
    }, se.prototype._ishlnsubmul = function(he, ve, xe) {
      var $e = he.length + xe, Te;
      this._expand($e);
      var Ie, we = 0;
      for (Te = 0; Te < he.length; Te++) {
        Ie = (this.words[Te + xe] | 0) + we;
        var ke = (he.words[Te] | 0) * ve;
        Ie -= ke & 67108863, we = (Ie >> 26) - (ke / 67108864 | 0), this.words[Te + xe] = Ie & 67108863;
      }
      for (; Te < this.length - xe; Te++)
        Ie = (this.words[Te + xe] | 0) + we, we = Ie >> 26, this.words[Te + xe] = Ie & 67108863;
      if (we === 0) return this._strip();
      for (ie(we === -1), we = 0, Te = 0; Te < this.length; Te++)
        Ie = -(this.words[Te] | 0) + we, we = Ie >> 26, this.words[Te] = Ie & 67108863;
      return this.negative = 1, this._strip();
    }, se.prototype._wordDiv = function(he, ve) {
      var xe = this.length - he.length, $e = this.clone(), Te = he, Ie = Te.words[Te.length - 1] | 0, we = this._countBits(Ie);
      xe = 26 - we, xe !== 0 && (Te = Te.ushln(xe), $e.iushln(xe), Ie = Te.words[Te.length - 1] | 0);
      var ke = $e.length - Te.length, ye;
      if (ve !== "mod") {
        ye = new se(null), ye.length = ke + 1, ye.words = new Array(ye.length);
        for (var Be = 0; Be < ye.length; Be++)
          ye.words[Be] = 0;
      }
      var Xe = $e.clone()._ishlnsubmul(Te, 1, ke);
      Xe.negative === 0 && ($e = Xe, ye && (ye.words[ke] = 1));
      for (var et = ke - 1; et >= 0; et--) {
        var Ye = ($e.words[Te.length + et] | 0) * 67108864 + ($e.words[Te.length + et - 1] | 0);
        for (Ye = Math.min(Ye / Ie | 0, 67108863), $e._ishlnsubmul(Te, Ye, et); $e.negative !== 0; )
          Ye--, $e.negative = 0, $e._ishlnsubmul(Te, 1, et), $e.isZero() || ($e.negative ^= 1);
        ye && (ye.words[et] = Ye);
      }
      return ye && ye._strip(), $e._strip(), ve !== "div" && xe !== 0 && $e.iushrn(xe), {
        div: ye || null,
        mod: $e
      };
    }, se.prototype.divmod = function(he, ve, xe) {
      if (ie(!he.isZero()), this.isZero())
        return {
          div: new se(0),
          mod: new se(0)
        };
      var $e, Te, Ie;
      return this.negative !== 0 && he.negative === 0 ? (Ie = this.neg().divmod(he, ve), ve !== "mod" && ($e = Ie.div.neg()), ve !== "div" && (Te = Ie.mod.neg(), xe && Te.negative !== 0 && Te.iadd(he)), {
        div: $e,
        mod: Te
      }) : this.negative === 0 && he.negative !== 0 ? (Ie = this.divmod(he.neg(), ve), ve !== "mod" && ($e = Ie.div.neg()), {
        div: $e,
        mod: Ie.mod
      }) : this.negative & he.negative ? (Ie = this.neg().divmod(he.neg(), ve), ve !== "div" && (Te = Ie.mod.neg(), xe && Te.negative !== 0 && Te.isub(he)), {
        div: Ie.div,
        mod: Te
      }) : he.length > this.length || this.cmp(he) < 0 ? {
        div: new se(0),
        mod: this
      } : he.length === 1 ? ve === "div" ? {
        div: this.divn(he.words[0]),
        mod: null
      } : ve === "mod" ? {
        div: null,
        mod: new se(this.modrn(he.words[0]))
      } : {
        div: this.divn(he.words[0]),
        mod: new se(this.modrn(he.words[0]))
      } : this._wordDiv(he, ve);
    }, se.prototype.div = function(he) {
      return this.divmod(he, "div", !1).div;
    }, se.prototype.mod = function(he) {
      return this.divmod(he, "mod", !1).mod;
    }, se.prototype.umod = function(he) {
      return this.divmod(he, "mod", !0).mod;
    }, se.prototype.divRound = function(he) {
      var ve = this.divmod(he);
      if (ve.mod.isZero()) return ve.div;
      var xe = ve.div.negative !== 0 ? ve.mod.isub(he) : ve.mod, $e = he.ushrn(1), Te = he.andln(1), Ie = xe.cmp($e);
      return Ie < 0 || Te === 1 && Ie === 0 ? ve.div : ve.div.negative !== 0 ? ve.div.isubn(1) : ve.div.iaddn(1);
    }, se.prototype.modrn = function(he) {
      var ve = he < 0;
      ve && (he = -he), ie(he <= 67108863);
      for (var xe = (1 << 26) % he, $e = 0, Te = this.length - 1; Te >= 0; Te--)
        $e = (xe * $e + (this.words[Te] | 0)) % he;
      return ve ? -$e : $e;
    }, se.prototype.modn = function(he) {
      return this.modrn(he);
    }, se.prototype.idivn = function(he) {
      var ve = he < 0;
      ve && (he = -he), ie(he <= 67108863);
      for (var xe = 0, $e = this.length - 1; $e >= 0; $e--) {
        var Te = (this.words[$e] | 0) + xe * 67108864;
        this.words[$e] = Te / he | 0, xe = Te % he;
      }
      return this._strip(), ve ? this.ineg() : this;
    }, se.prototype.divn = function(he) {
      return this.clone().idivn(he);
    }, se.prototype.egcd = function(he) {
      ie(he.negative === 0), ie(!he.isZero());
      var ve = this, xe = he.clone();
      ve.negative !== 0 ? ve = ve.umod(he) : ve = ve.clone();
      for (var $e = new se(1), Te = new se(0), Ie = new se(0), we = new se(1), ke = 0; ve.isEven() && xe.isEven(); )
        ve.iushrn(1), xe.iushrn(1), ++ke;
      for (var ye = xe.clone(), Be = ve.clone(); !ve.isZero(); ) {
        for (var Xe = 0, et = 1; !(ve.words[0] & et) && Xe < 26; ++Xe, et <<= 1) ;
        if (Xe > 0)
          for (ve.iushrn(Xe); Xe-- > 0; )
            ($e.isOdd() || Te.isOdd()) && ($e.iadd(ye), Te.isub(Be)), $e.iushrn(1), Te.iushrn(1);
        for (var Ye = 0, De = 1; !(xe.words[0] & De) && Ye < 26; ++Ye, De <<= 1) ;
        if (Ye > 0)
          for (xe.iushrn(Ye); Ye-- > 0; )
            (Ie.isOdd() || we.isOdd()) && (Ie.iadd(ye), we.isub(Be)), Ie.iushrn(1), we.iushrn(1);
        ve.cmp(xe) >= 0 ? (ve.isub(xe), $e.isub(Ie), Te.isub(we)) : (xe.isub(ve), Ie.isub($e), we.isub(Te));
      }
      return {
        a: Ie,
        b: we,
        gcd: xe.iushln(ke)
      };
    }, se.prototype._invmp = function(he) {
      ie(he.negative === 0), ie(!he.isZero());
      var ve = this, xe = he.clone();
      ve.negative !== 0 ? ve = ve.umod(he) : ve = ve.clone();
      for (var $e = new se(1), Te = new se(0), Ie = xe.clone(); ve.cmpn(1) > 0 && xe.cmpn(1) > 0; ) {
        for (var we = 0, ke = 1; !(ve.words[0] & ke) && we < 26; ++we, ke <<= 1) ;
        if (we > 0)
          for (ve.iushrn(we); we-- > 0; )
            $e.isOdd() && $e.iadd(Ie), $e.iushrn(1);
        for (var ye = 0, Be = 1; !(xe.words[0] & Be) && ye < 26; ++ye, Be <<= 1) ;
        if (ye > 0)
          for (xe.iushrn(ye); ye-- > 0; )
            Te.isOdd() && Te.iadd(Ie), Te.iushrn(1);
        ve.cmp(xe) >= 0 ? (ve.isub(xe), $e.isub(Te)) : (xe.isub(ve), Te.isub($e));
      }
      var Xe;
      return ve.cmpn(1) === 0 ? Xe = $e : Xe = Te, Xe.cmpn(0) < 0 && Xe.iadd(he), Xe;
    }, se.prototype.gcd = function(he) {
      if (this.isZero()) return he.abs();
      if (he.isZero()) return this.abs();
      var ve = this.clone(), xe = he.clone();
      ve.negative = 0, xe.negative = 0;
      for (var $e = 0; ve.isEven() && xe.isEven(); $e++)
        ve.iushrn(1), xe.iushrn(1);
      do {
        for (; ve.isEven(); )
          ve.iushrn(1);
        for (; xe.isEven(); )
          xe.iushrn(1);
        var Te = ve.cmp(xe);
        if (Te < 0) {
          var Ie = ve;
          ve = xe, xe = Ie;
        } else if (Te === 0 || xe.cmpn(1) === 0)
          break;
        ve.isub(xe);
      } while (!0);
      return xe.iushln($e);
    }, se.prototype.invm = function(he) {
      return this.egcd(he).a.umod(he);
    }, se.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, se.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, se.prototype.andln = function(he) {
      return this.words[0] & he;
    }, se.prototype.bincn = function(he) {
      ie(typeof he == "number");
      var ve = he % 26, xe = (he - ve) / 26, $e = 1 << ve;
      if (this.length <= xe)
        return this._expand(xe + 1), this.words[xe] |= $e, this;
      for (var Te = $e, Ie = xe; Te !== 0 && Ie < this.length; Ie++) {
        var we = this.words[Ie] | 0;
        we += Te, Te = we >>> 26, we &= 67108863, this.words[Ie] = we;
      }
      return Te !== 0 && (this.words[Ie] = Te, this.length++), this;
    }, se.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, se.prototype.cmpn = function(he) {
      var ve = he < 0;
      if (this.negative !== 0 && !ve) return -1;
      if (this.negative === 0 && ve) return 1;
      this._strip();
      var xe;
      if (this.length > 1)
        xe = 1;
      else {
        ve && (he = -he), ie(he <= 67108863, "Number is too big");
        var $e = this.words[0] | 0;
        xe = $e === he ? 0 : $e < he ? -1 : 1;
      }
      return this.negative !== 0 ? -xe | 0 : xe;
    }, se.prototype.cmp = function(he) {
      if (this.negative !== 0 && he.negative === 0) return -1;
      if (this.negative === 0 && he.negative !== 0) return 1;
      var ve = this.ucmp(he);
      return this.negative !== 0 ? -ve | 0 : ve;
    }, se.prototype.ucmp = function(he) {
      if (this.length > he.length) return 1;
      if (this.length < he.length) return -1;
      for (var ve = 0, xe = this.length - 1; xe >= 0; xe--) {
        var $e = this.words[xe] | 0, Te = he.words[xe] | 0;
        if ($e !== Te) {
          $e < Te ? ve = -1 : $e > Te && (ve = 1);
          break;
        }
      }
      return ve;
    }, se.prototype.gtn = function(he) {
      return this.cmpn(he) === 1;
    }, se.prototype.gt = function(he) {
      return this.cmp(he) === 1;
    }, se.prototype.gten = function(he) {
      return this.cmpn(he) >= 0;
    }, se.prototype.gte = function(he) {
      return this.cmp(he) >= 0;
    }, se.prototype.ltn = function(he) {
      return this.cmpn(he) === -1;
    }, se.prototype.lt = function(he) {
      return this.cmp(he) === -1;
    }, se.prototype.lten = function(he) {
      return this.cmpn(he) <= 0;
    }, se.prototype.lte = function(he) {
      return this.cmp(he) <= 0;
    }, se.prototype.eqn = function(he) {
      return this.cmpn(he) === 0;
    }, se.prototype.eq = function(he) {
      return this.cmp(he) === 0;
    }, se.red = function(he) {
      return new Re(he);
    }, se.prototype.toRed = function(he) {
      return ie(!this.red, "Already a number in reduction context"), ie(this.negative === 0, "red works only with positives"), he.convertTo(this)._forceRed(he);
    }, se.prototype.fromRed = function() {
      return ie(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, se.prototype._forceRed = function(he) {
      return this.red = he, this;
    }, se.prototype.forceRed = function(he) {
      return ie(!this.red, "Already a number in reduction context"), this._forceRed(he);
    }, se.prototype.redAdd = function(he) {
      return ie(this.red, "redAdd works only with red numbers"), this.red.add(this, he);
    }, se.prototype.redIAdd = function(he) {
      return ie(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, he);
    }, se.prototype.redSub = function(he) {
      return ie(this.red, "redSub works only with red numbers"), this.red.sub(this, he);
    }, se.prototype.redISub = function(he) {
      return ie(this.red, "redISub works only with red numbers"), this.red.isub(this, he);
    }, se.prototype.redShl = function(he) {
      return ie(this.red, "redShl works only with red numbers"), this.red.shl(this, he);
    }, se.prototype.redMul = function(he) {
      return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, he), this.red.mul(this, he);
    }, se.prototype.redIMul = function(he) {
      return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, he), this.red.imul(this, he);
    }, se.prototype.redSqr = function() {
      return ie(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, se.prototype.redISqr = function() {
      return ie(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, se.prototype.redSqrt = function() {
      return ie(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, se.prototype.redInvm = function() {
      return ie(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, se.prototype.redNeg = function() {
      return ie(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, se.prototype.redPow = function(he) {
      return ie(this.red && !he.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, he);
    };
    var He = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function Ue(_e, he) {
      this.name = _e, this.p = new se(he, 16), this.n = this.p.bitLength(), this.k = new se(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    Ue.prototype._tmp = function() {
      var he = new se(null);
      return he.words = new Array(Math.ceil(this.n / 13)), he;
    }, Ue.prototype.ireduce = function(he) {
      var ve = he, xe;
      do
        this.split(ve, this.tmp), ve = this.imulK(ve), ve = ve.iadd(this.tmp), xe = ve.bitLength();
      while (xe > this.n);
      var $e = xe < this.n ? -1 : ve.ucmp(this.p);
      return $e === 0 ? (ve.words[0] = 0, ve.length = 1) : $e > 0 ? ve.isub(this.p) : ve.strip !== void 0 ? ve.strip() : ve._strip(), ve;
    }, Ue.prototype.split = function(he, ve) {
      he.iushrn(this.n, 0, ve);
    }, Ue.prototype.imulK = function(he) {
      return he.imul(this.k);
    };
    function Ze() {
      Ue.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    le(Ze, Ue), Ze.prototype.split = function(he, ve) {
      for (var xe = 4194303, $e = Math.min(he.length, 9), Te = 0; Te < $e; Te++)
        ve.words[Te] = he.words[Te];
      if (ve.length = $e, he.length <= 9) {
        he.words[0] = 0, he.length = 1;
        return;
      }
      var Ie = he.words[9];
      for (ve.words[ve.length++] = Ie & xe, Te = 10; Te < he.length; Te++) {
        var we = he.words[Te] | 0;
        he.words[Te - 10] = (we & xe) << 4 | Ie >>> 22, Ie = we;
      }
      Ie >>>= 22, he.words[Te - 10] = Ie, Ie === 0 && he.length > 10 ? he.length -= 10 : he.length -= 9;
    }, Ze.prototype.imulK = function(he) {
      he.words[he.length] = 0, he.words[he.length + 1] = 0, he.length += 2;
      for (var ve = 0, xe = 0; xe < he.length; xe++) {
        var $e = he.words[xe] | 0;
        ve += $e * 977, he.words[xe] = ve & 67108863, ve = $e * 64 + (ve / 67108864 | 0);
      }
      return he.words[he.length - 1] === 0 && (he.length--, he.words[he.length - 1] === 0 && he.length--), he;
    };
    function Fe() {
      Ue.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    le(Fe, Ue);
    function Ke() {
      Ue.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    le(Ke, Ue);
    function tt() {
      Ue.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    le(tt, Ue), tt.prototype.imulK = function(he) {
      for (var ve = 0, xe = 0; xe < he.length; xe++) {
        var $e = (he.words[xe] | 0) * 19 + ve, Te = $e & 67108863;
        $e >>>= 26, he.words[xe] = Te, ve = $e;
      }
      return ve !== 0 && (he.words[he.length++] = ve), he;
    }, se._prime = function(he) {
      if (He[he]) return He[he];
      var ve;
      if (he === "k256")
        ve = new Ze();
      else if (he === "p224")
        ve = new Fe();
      else if (he === "p192")
        ve = new Ke();
      else if (he === "p25519")
        ve = new tt();
      else
        throw new Error("Unknown prime " + he);
      return He[he] = ve, ve;
    };
    function Re(_e) {
      if (typeof _e == "string") {
        var he = se._prime(_e);
        this.m = he.p, this.prime = he;
      } else
        ie(_e.gtn(1), "modulus must be greater than 1"), this.m = _e, this.prime = null;
    }
    Re.prototype._verify1 = function(he) {
      ie(he.negative === 0, "red works only with positives"), ie(he.red, "red works only with red numbers");
    }, Re.prototype._verify2 = function(he, ve) {
      ie((he.negative | ve.negative) === 0, "red works only with positives"), ie(
        he.red && he.red === ve.red,
        "red works only with red numbers"
      );
    }, Re.prototype.imod = function(he) {
      return this.prime ? this.prime.ireduce(he)._forceRed(this) : (fe(he, he.umod(this.m)._forceRed(this)), he);
    }, Re.prototype.neg = function(he) {
      return he.isZero() ? he.clone() : this.m.sub(he)._forceRed(this);
    }, Re.prototype.add = function(he, ve) {
      this._verify2(he, ve);
      var xe = he.add(ve);
      return xe.cmp(this.m) >= 0 && xe.isub(this.m), xe._forceRed(this);
    }, Re.prototype.iadd = function(he, ve) {
      this._verify2(he, ve);
      var xe = he.iadd(ve);
      return xe.cmp(this.m) >= 0 && xe.isub(this.m), xe;
    }, Re.prototype.sub = function(he, ve) {
      this._verify2(he, ve);
      var xe = he.sub(ve);
      return xe.cmpn(0) < 0 && xe.iadd(this.m), xe._forceRed(this);
    }, Re.prototype.isub = function(he, ve) {
      this._verify2(he, ve);
      var xe = he.isub(ve);
      return xe.cmpn(0) < 0 && xe.iadd(this.m), xe;
    }, Re.prototype.shl = function(he, ve) {
      return this._verify1(he), this.imod(he.ushln(ve));
    }, Re.prototype.imul = function(he, ve) {
      return this._verify2(he, ve), this.imod(he.imul(ve));
    }, Re.prototype.mul = function(he, ve) {
      return this._verify2(he, ve), this.imod(he.mul(ve));
    }, Re.prototype.isqr = function(he) {
      return this.imul(he, he.clone());
    }, Re.prototype.sqr = function(he) {
      return this.mul(he, he);
    }, Re.prototype.sqrt = function(he) {
      if (he.isZero()) return he.clone();
      var ve = this.m.andln(3);
      if (ie(ve % 2 === 1), ve === 3) {
        var xe = this.m.add(new se(1)).iushrn(2);
        return this.pow(he, xe);
      }
      for (var $e = this.m.subn(1), Te = 0; !$e.isZero() && $e.andln(1) === 0; )
        Te++, $e.iushrn(1);
      ie(!$e.isZero());
      var Ie = new se(1).toRed(this), we = Ie.redNeg(), ke = this.m.subn(1).iushrn(1), ye = this.m.bitLength();
      for (ye = new se(2 * ye * ye).toRed(this); this.pow(ye, ke).cmp(we) !== 0; )
        ye.redIAdd(we);
      for (var Be = this.pow(ye, $e), Xe = this.pow(he, $e.addn(1).iushrn(1)), et = this.pow(he, $e), Ye = Te; et.cmp(Ie) !== 0; ) {
        for (var De = et, je = 0; De.cmp(Ie) !== 0; je++)
          De = De.redSqr();
        ie(je < Ye);
        var rt = this.pow(Be, new se(1).iushln(Ye - je - 1));
        Xe = Xe.redMul(rt), Be = rt.redSqr(), et = et.redMul(Be), Ye = je;
      }
      return Xe;
    }, Re.prototype.invm = function(he) {
      var ve = he._invmp(this.m);
      return ve.negative !== 0 ? (ve.negative = 0, this.imod(ve).redNeg()) : this.imod(ve);
    }, Re.prototype.pow = function(he, ve) {
      if (ve.isZero()) return new se(1).toRed(this);
      if (ve.cmpn(1) === 0) return he.clone();
      var xe = 4, $e = new Array(1 << xe);
      $e[0] = new se(1).toRed(this), $e[1] = he;
      for (var Te = 2; Te < $e.length; Te++)
        $e[Te] = this.mul($e[Te - 1], he);
      var Ie = $e[0], we = 0, ke = 0, ye = ve.bitLength() % 26;
      for (ye === 0 && (ye = 26), Te = ve.length - 1; Te >= 0; Te--) {
        for (var Be = ve.words[Te], Xe = ye - 1; Xe >= 0; Xe--) {
          var et = Be >> Xe & 1;
          if (Ie !== $e[0] && (Ie = this.sqr(Ie)), et === 0 && we === 0) {
            ke = 0;
            continue;
          }
          we <<= 1, we |= et, ke++, !(ke !== xe && (Te !== 0 || Xe !== 0)) && (Ie = this.mul(Ie, $e[we]), ke = 0, we = 0);
        }
        ye = 26;
      }
      return Ie;
    }, Re.prototype.convertTo = function(he) {
      var ve = he.umod(this.m);
      return ve === he ? ve.clone() : ve;
    }, Re.prototype.convertFrom = function(he) {
      var ve = he.clone();
      return ve.red = null, ve;
    }, se.mont = function(he) {
      return new Ce(he);
    };
    function Ce(_e) {
      Re.call(this, _e), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new se(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    le(Ce, Re), Ce.prototype.convertTo = function(he) {
      return this.imod(he.ushln(this.shift));
    }, Ce.prototype.convertFrom = function(he) {
      var ve = this.imod(he.mul(this.rinv));
      return ve.red = null, ve;
    }, Ce.prototype.imul = function(he, ve) {
      if (he.isZero() || ve.isZero())
        return he.words[0] = 0, he.length = 1, he;
      var xe = he.imul(ve), $e = xe.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Te = xe.isub($e).iushrn(this.shift), Ie = Te;
      return Te.cmp(this.m) >= 0 ? Ie = Te.isub(this.m) : Te.cmpn(0) < 0 && (Ie = Te.iadd(this.m)), Ie._forceRed(this);
    }, Ce.prototype.mul = function(he, ve) {
      if (he.isZero() || ve.isZero()) return new se(0)._forceRed(this);
      var xe = he.mul(ve), $e = xe.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Te = xe.isub($e).iushrn(this.shift), Ie = Te;
      return Te.cmp(this.m) >= 0 ? Ie = Te.isub(this.m) : Te.cmpn(0) < 0 && (Ie = Te.iadd(this.m)), Ie._forceRed(this);
    }, Ce.prototype.invm = function(he) {
      var ve = this.imod(he._invmp(this.m).mul(this.r2));
      return ve._forceRed(this);
    };
  })(re, commonjsGlobal);
})(bn$1);
var bnExports$1 = bn$1.exports, BN$a = bnExports$1, randomBytes$1 = browserExports, Buffer$7 = safeBufferExports$1.Buffer;
function getr(re) {
  var ne = re.modulus.byteLength(), ae;
  do
    ae = new BN$a(randomBytes$1(ne));
  while (ae.cmp(re.modulus) >= 0 || !ae.umod(re.prime1) || !ae.umod(re.prime2));
  return ae;
}
function blind(re) {
  var ne = getr(re), ae = ne.toRed(BN$a.mont(re.modulus)).redPow(new BN$a(re.publicExponent)).fromRed();
  return { blinder: ae, unblinder: ne.invm(re.modulus) };
}
function crt$2(re, ne) {
  var ae = blind(ne), ie = ne.modulus.byteLength(), le = new BN$a(re).mul(ae.blinder).umod(ne.modulus), se = le.toRed(BN$a.mont(ne.prime1)), ce = le.toRed(BN$a.mont(ne.prime2)), ue = ne.coefficient, de = ne.prime1, me = ne.prime2, fe = se.redPow(ne.exponent1).fromRed(), pe = ce.redPow(ne.exponent2).fromRed(), ge = fe.isub(pe).imul(ue).umod(de).imul(me);
  return pe.iadd(ge).imul(ae.unblinder).umod(ne.modulus).toArrayLike(Buffer$7, "be", ie);
}
crt$2.getr = getr;
var browserifyRsa = crt$2, elliptic = {};
const name = "elliptic", version = "6.6.0", description = "EC cryptography", main = "lib/elliptic.js", files = [
  "lib"
], scripts = {
  lint: "eslint lib test",
  "lint:fix": "npm run lint -- --fix",
  unit: "istanbul test _mocha --reporter=spec test/index.js",
  test: "npm run lint && npm run unit",
  version: "grunt dist && git add dist/"
}, repository = {
  type: "git",
  url: "git@github.com:indutny/elliptic"
}, keywords = [
  "EC",
  "Elliptic",
  "curve",
  "Cryptography"
], author = "Fedor Indutny <fedor@indutny.com>", license = "MIT", bugs = {
  url: "https://github.com/indutny/elliptic/issues"
}, homepage = "https://github.com/indutny/elliptic", devDependencies = {
  brfs: "^2.0.2",
  coveralls: "^3.1.0",
  eslint: "^7.6.0",
  grunt: "^1.2.1",
  "grunt-browserify": "^5.3.0",
  "grunt-cli": "^1.3.2",
  "grunt-contrib-connect": "^3.0.0",
  "grunt-contrib-copy": "^1.0.0",
  "grunt-contrib-uglify": "^5.0.0",
  "grunt-mocha-istanbul": "^5.0.2",
  "grunt-saucelabs": "^9.0.1",
  istanbul: "^0.4.5",
  mocha: "^8.0.1"
}, dependencies = {
  "bn.js": "^4.11.9",
  brorand: "^1.1.0",
  "hash.js": "^1.0.0",
  "hmac-drbg": "^1.0.1",
  inherits: "^2.0.4",
  "minimalistic-assert": "^1.0.1",
  "minimalistic-crypto-utils": "^1.0.1"
}, require$$0 = {
  name,
  version,
  description,
  main,
  files,
  scripts,
  repository,
  keywords,
  author,
  license,
  bugs,
  homepage,
  devDependencies,
  dependencies
};
var utils$l = {}, utils$k = {};
(function(re) {
  var ne = re;
  function ae(se, ce) {
    if (Array.isArray(se))
      return se.slice();
    if (!se)
      return [];
    var ue = [];
    if (typeof se != "string") {
      for (var de = 0; de < se.length; de++)
        ue[de] = se[de] | 0;
      return ue;
    }
    if (ce === "hex") {
      se = se.replace(/[^a-z0-9]+/ig, ""), se.length % 2 !== 0 && (se = "0" + se);
      for (var de = 0; de < se.length; de += 2)
        ue.push(parseInt(se[de] + se[de + 1], 16));
    } else
      for (var de = 0; de < se.length; de++) {
        var me = se.charCodeAt(de), fe = me >> 8, pe = me & 255;
        fe ? ue.push(fe, pe) : ue.push(pe);
      }
    return ue;
  }
  ne.toArray = ae;
  function ie(se) {
    return se.length === 1 ? "0" + se : se;
  }
  ne.zero2 = ie;
  function le(se) {
    for (var ce = "", ue = 0; ue < se.length; ue++)
      ce += ie(se[ue].toString(16));
    return ce;
  }
  ne.toHex = le, ne.encode = function(ce, ue) {
    return ue === "hex" ? le(ce) : ce;
  };
})(utils$k);
(function(re) {
  var ne = re, ae = bnExports$2, ie = minimalisticAssert, le = utils$k;
  ne.assert = ie, ne.toArray = le.toArray, ne.zero2 = le.zero2, ne.toHex = le.toHex, ne.encode = le.encode;
  function se(fe, pe, ge) {
    var be = new Array(Math.max(fe.bitLength(), ge) + 1), Se;
    for (Se = 0; Se < be.length; Se += 1)
      be[Se] = 0;
    var Pe = 1 << pe + 1, Ee = fe.clone();
    for (Se = 0; Se < be.length; Se++) {
      var Ve, Ae = Ee.andln(Pe - 1);
      Ee.isOdd() ? (Ae > (Pe >> 1) - 1 ? Ve = (Pe >> 1) - Ae : Ve = Ae, Ee.isubn(Ve)) : Ve = 0, be[Se] = Ve, Ee.iushrn(1);
    }
    return be;
  }
  ne.getNAF = se;
  function ce(fe, pe) {
    var ge = [
      [],
      []
    ];
    fe = fe.clone(), pe = pe.clone();
    for (var be = 0, Se = 0, Pe; fe.cmpn(-be) > 0 || pe.cmpn(-Se) > 0; ) {
      var Ee = fe.andln(3) + be & 3, Ve = pe.andln(3) + Se & 3;
      Ee === 3 && (Ee = -1), Ve === 3 && (Ve = -1);
      var Ae;
      Ee & 1 ? (Pe = fe.andln(7) + be & 7, (Pe === 3 || Pe === 5) && Ve === 2 ? Ae = -Ee : Ae = Ee) : Ae = 0, ge[0].push(Ae);
      var Oe;
      Ve & 1 ? (Pe = pe.andln(7) + Se & 7, (Pe === 3 || Pe === 5) && Ee === 2 ? Oe = -Ve : Oe = Ve) : Oe = 0, ge[1].push(Oe), 2 * be === Ae + 1 && (be = 1 - be), 2 * Se === Oe + 1 && (Se = 1 - Se), fe.iushrn(1), pe.iushrn(1);
    }
    return ge;
  }
  ne.getJSF = ce;
  function ue(fe, pe, ge) {
    var be = "_" + pe;
    fe.prototype[pe] = function() {
      return this[be] !== void 0 ? this[be] : this[be] = ge.call(this);
    };
  }
  ne.cachedProperty = ue;
  function de(fe) {
    return typeof fe == "string" ? ne.toArray(fe, "hex") : fe;
  }
  ne.parseBytes = de;
  function me(fe) {
    return new ae(fe, "hex", "le");
  }
  ne.intFromLE = me;
})(utils$l);
var curve = {}, BN$9 = bnExports$2, utils$j = utils$l, getNAF = utils$j.getNAF, getJSF = utils$j.getJSF, assert$d = utils$j.assert;
function BaseCurve(re, ne) {
  this.type = re, this.p = new BN$9(ne.p, 16), this.red = ne.prime ? BN$9.red(ne.prime) : BN$9.mont(this.p), this.zero = new BN$9(0).toRed(this.red), this.one = new BN$9(1).toRed(this.red), this.two = new BN$9(2).toRed(this.red), this.n = ne.n && new BN$9(ne.n, 16), this.g = ne.g && this.pointFromJSON(ne.g, ne.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
  var ae = this.n && this.p.div(this.n);
  !ae || ae.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
}
var base$1 = BaseCurve;
BaseCurve.prototype.point = function() {
  throw new Error("Not implemented");
};
BaseCurve.prototype.validate = function() {
  throw new Error("Not implemented");
};
BaseCurve.prototype._fixedNafMul = function(ne, ae) {
  assert$d(ne.precomputed);
  var ie = ne._getDoubles(), le = getNAF(ae, 1, this._bitLength), se = (1 << ie.step + 1) - (ie.step % 2 === 0 ? 2 : 1);
  se /= 3;
  var ce = [], ue, de;
  for (ue = 0; ue < le.length; ue += ie.step) {
    de = 0;
    for (var me = ue + ie.step - 1; me >= ue; me--)
      de = (de << 1) + le[me];
    ce.push(de);
  }
  for (var fe = this.jpoint(null, null, null), pe = this.jpoint(null, null, null), ge = se; ge > 0; ge--) {
    for (ue = 0; ue < ce.length; ue++)
      de = ce[ue], de === ge ? pe = pe.mixedAdd(ie.points[ue]) : de === -ge && (pe = pe.mixedAdd(ie.points[ue].neg()));
    fe = fe.add(pe);
  }
  return fe.toP();
};
BaseCurve.prototype._wnafMul = function(ne, ae) {
  var ie = 4, le = ne._getNAFPoints(ie);
  ie = le.wnd;
  for (var se = le.points, ce = getNAF(ae, ie, this._bitLength), ue = this.jpoint(null, null, null), de = ce.length - 1; de >= 0; de--) {
    for (var me = 0; de >= 0 && ce[de] === 0; de--)
      me++;
    if (de >= 0 && me++, ue = ue.dblp(me), de < 0)
      break;
    var fe = ce[de];
    assert$d(fe !== 0), ne.type === "affine" ? fe > 0 ? ue = ue.mixedAdd(se[fe - 1 >> 1]) : ue = ue.mixedAdd(se[-fe - 1 >> 1].neg()) : fe > 0 ? ue = ue.add(se[fe - 1 >> 1]) : ue = ue.add(se[-fe - 1 >> 1].neg());
  }
  return ne.type === "affine" ? ue.toP() : ue;
};
BaseCurve.prototype._wnafMulAdd = function(ne, ae, ie, le, se) {
  var ce = this._wnafT1, ue = this._wnafT2, de = this._wnafT3, me = 0, fe, pe, ge;
  for (fe = 0; fe < le; fe++) {
    ge = ae[fe];
    var be = ge._getNAFPoints(ne);
    ce[fe] = be.wnd, ue[fe] = be.points;
  }
  for (fe = le - 1; fe >= 1; fe -= 2) {
    var Se = fe - 1, Pe = fe;
    if (ce[Se] !== 1 || ce[Pe] !== 1) {
      de[Se] = getNAF(ie[Se], ce[Se], this._bitLength), de[Pe] = getNAF(ie[Pe], ce[Pe], this._bitLength), me = Math.max(de[Se].length, me), me = Math.max(de[Pe].length, me);
      continue;
    }
    var Ee = [
      ae[Se],
      /* 1 */
      null,
      /* 3 */
      null,
      /* 5 */
      ae[Pe]
      /* 7 */
    ];
    ae[Se].y.cmp(ae[Pe].y) === 0 ? (Ee[1] = ae[Se].add(ae[Pe]), Ee[2] = ae[Se].toJ().mixedAdd(ae[Pe].neg())) : ae[Se].y.cmp(ae[Pe].y.redNeg()) === 0 ? (Ee[1] = ae[Se].toJ().mixedAdd(ae[Pe]), Ee[2] = ae[Se].add(ae[Pe].neg())) : (Ee[1] = ae[Se].toJ().mixedAdd(ae[Pe]), Ee[2] = ae[Se].toJ().mixedAdd(ae[Pe].neg()));
    var Ve = [
      -3,
      /* -1 -1 */
      -1,
      /* -1 0 */
      -5,
      /* -1 1 */
      -7,
      /* 0 -1 */
      0,
      /* 0 0 */
      7,
      /* 0 1 */
      5,
      /* 1 -1 */
      1,
      /* 1 0 */
      3
      /* 1 1 */
    ], Ae = getJSF(ie[Se], ie[Pe]);
    for (me = Math.max(Ae[0].length, me), de[Se] = new Array(me), de[Pe] = new Array(me), pe = 0; pe < me; pe++) {
      var Oe = Ae[0][pe] | 0, Ne = Ae[1][pe] | 0;
      de[Se][pe] = Ve[(Oe + 1) * 3 + (Ne + 1)], de[Pe][pe] = 0, ue[Se] = Ee;
    }
  }
  var He = this.jpoint(null, null, null), Ue = this._wnafT4;
  for (fe = me; fe >= 0; fe--) {
    for (var Ze = 0; fe >= 0; ) {
      var Fe = !0;
      for (pe = 0; pe < le; pe++)
        Ue[pe] = de[pe][fe] | 0, Ue[pe] !== 0 && (Fe = !1);
      if (!Fe)
        break;
      Ze++, fe--;
    }
    if (fe >= 0 && Ze++, He = He.dblp(Ze), fe < 0)
      break;
    for (pe = 0; pe < le; pe++) {
      var Ke = Ue[pe];
      Ke !== 0 && (Ke > 0 ? ge = ue[pe][Ke - 1 >> 1] : Ke < 0 && (ge = ue[pe][-Ke - 1 >> 1].neg()), ge.type === "affine" ? He = He.mixedAdd(ge) : He = He.add(ge));
    }
  }
  for (fe = 0; fe < le; fe++)
    ue[fe] = null;
  return se ? He : He.toP();
};
function BasePoint(re, ne) {
  this.curve = re, this.type = ne, this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;
BasePoint.prototype.eq = function() {
  throw new Error("Not implemented");
};
BasePoint.prototype.validate = function() {
  return this.curve.validate(this);
};
BaseCurve.prototype.decodePoint = function(ne, ae) {
  ne = utils$j.toArray(ne, ae);
  var ie = this.p.byteLength();
  if ((ne[0] === 4 || ne[0] === 6 || ne[0] === 7) && ne.length - 1 === 2 * ie) {
    ne[0] === 6 ? assert$d(ne[ne.length - 1] % 2 === 0) : ne[0] === 7 && assert$d(ne[ne.length - 1] % 2 === 1);
    var le = this.point(
      ne.slice(1, 1 + ie),
      ne.slice(1 + ie, 1 + 2 * ie)
    );
    return le;
  } else if ((ne[0] === 2 || ne[0] === 3) && ne.length - 1 === ie)
    return this.pointFromX(ne.slice(1, 1 + ie), ne[0] === 3);
  throw new Error("Unknown point format");
};
BasePoint.prototype.encodeCompressed = function(ne) {
  return this.encode(ne, !0);
};
BasePoint.prototype._encode = function(ne) {
  var ae = this.curve.p.byteLength(), ie = this.getX().toArray("be", ae);
  return ne ? [this.getY().isEven() ? 2 : 3].concat(ie) : [4].concat(ie, this.getY().toArray("be", ae));
};
BasePoint.prototype.encode = function(ne, ae) {
  return utils$j.encode(this._encode(ae), ne);
};
BasePoint.prototype.precompute = function(ne) {
  if (this.precomputed)
    return this;
  var ae = {
    doubles: null,
    naf: null,
    beta: null
  };
  return ae.naf = this._getNAFPoints(8), ae.doubles = this._getDoubles(4, ne), ae.beta = this._getBeta(), this.precomputed = ae, this;
};
BasePoint.prototype._hasDoubles = function(ne) {
  if (!this.precomputed)
    return !1;
  var ae = this.precomputed.doubles;
  return ae ? ae.points.length >= Math.ceil((ne.bitLength() + 1) / ae.step) : !1;
};
BasePoint.prototype._getDoubles = function(ne, ae) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;
  for (var ie = [this], le = this, se = 0; se < ae; se += ne) {
    for (var ce = 0; ce < ne; ce++)
      le = le.dbl();
    ie.push(le);
  }
  return {
    step: ne,
    points: ie
  };
};
BasePoint.prototype._getNAFPoints = function(ne) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;
  for (var ae = [this], ie = (1 << ne) - 1, le = ie === 1 ? null : this.dbl(), se = 1; se < ie; se++)
    ae[se] = ae[se - 1].add(le);
  return {
    wnd: ne,
    points: ae
  };
};
BasePoint.prototype._getBeta = function() {
  return null;
};
BasePoint.prototype.dblp = function(ne) {
  for (var ae = this, ie = 0; ie < ne; ie++)
    ae = ae.dbl();
  return ae;
};
var utils$i = utils$l, BN$8 = bnExports$2, inherits$4 = inherits_browserExports, Base$2 = base$1, assert$c = utils$i.assert;
function ShortCurve(re) {
  Base$2.call(this, "short", re), this.a = new BN$8(re.a, 16).toRed(this.red), this.b = new BN$8(re.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(re), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
}
inherits$4(ShortCurve, Base$2);
var short = ShortCurve;
ShortCurve.prototype._getEndomorphism = function(ne) {
  if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
    var ae, ie;
    if (ne.beta)
      ae = new BN$8(ne.beta, 16).toRed(this.red);
    else {
      var le = this._getEndoRoots(this.p);
      ae = le[0].cmp(le[1]) < 0 ? le[0] : le[1], ae = ae.toRed(this.red);
    }
    if (ne.lambda)
      ie = new BN$8(ne.lambda, 16);
    else {
      var se = this._getEndoRoots(this.n);
      this.g.mul(se[0]).x.cmp(this.g.x.redMul(ae)) === 0 ? ie = se[0] : (ie = se[1], assert$c(this.g.mul(ie).x.cmp(this.g.x.redMul(ae)) === 0));
    }
    var ce;
    return ne.basis ? ce = ne.basis.map(function(ue) {
      return {
        a: new BN$8(ue.a, 16),
        b: new BN$8(ue.b, 16)
      };
    }) : ce = this._getEndoBasis(ie), {
      beta: ae,
      lambda: ie,
      basis: ce
    };
  }
};
ShortCurve.prototype._getEndoRoots = function(ne) {
  var ae = ne === this.p ? this.red : BN$8.mont(ne), ie = new BN$8(2).toRed(ae).redInvm(), le = ie.redNeg(), se = new BN$8(3).toRed(ae).redNeg().redSqrt().redMul(ie), ce = le.redAdd(se).fromRed(), ue = le.redSub(se).fromRed();
  return [ce, ue];
};
ShortCurve.prototype._getEndoBasis = function(ne) {
  for (var ae = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), ie = ne, le = this.n.clone(), se = new BN$8(1), ce = new BN$8(0), ue = new BN$8(0), de = new BN$8(1), me, fe, pe, ge, be, Se, Pe, Ee = 0, Ve, Ae; ie.cmpn(0) !== 0; ) {
    var Oe = le.div(ie);
    Ve = le.sub(Oe.mul(ie)), Ae = ue.sub(Oe.mul(se));
    var Ne = de.sub(Oe.mul(ce));
    if (!pe && Ve.cmp(ae) < 0)
      me = Pe.neg(), fe = se, pe = Ve.neg(), ge = Ae;
    else if (pe && ++Ee === 2)
      break;
    Pe = Ve, le = ie, ie = Ve, ue = se, se = Ae, de = ce, ce = Ne;
  }
  be = Ve.neg(), Se = Ae;
  var He = pe.sqr().add(ge.sqr()), Ue = be.sqr().add(Se.sqr());
  return Ue.cmp(He) >= 0 && (be = me, Se = fe), pe.negative && (pe = pe.neg(), ge = ge.neg()), be.negative && (be = be.neg(), Se = Se.neg()), [
    { a: pe, b: ge },
    { a: be, b: Se }
  ];
};
ShortCurve.prototype._endoSplit = function(ne) {
  var ae = this.endo.basis, ie = ae[0], le = ae[1], se = le.b.mul(ne).divRound(this.n), ce = ie.b.neg().mul(ne).divRound(this.n), ue = se.mul(ie.a), de = ce.mul(le.a), me = se.mul(ie.b), fe = ce.mul(le.b), pe = ne.sub(ue).sub(de), ge = me.add(fe).neg();
  return { k1: pe, k2: ge };
};
ShortCurve.prototype.pointFromX = function(ne, ae) {
  ne = new BN$8(ne, 16), ne.red || (ne = ne.toRed(this.red));
  var ie = ne.redSqr().redMul(ne).redIAdd(ne.redMul(this.a)).redIAdd(this.b), le = ie.redSqrt();
  if (le.redSqr().redSub(ie).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var se = le.fromRed().isOdd();
  return (ae && !se || !ae && se) && (le = le.redNeg()), this.point(ne, le);
};
ShortCurve.prototype.validate = function(ne) {
  if (ne.inf)
    return !0;
  var ae = ne.x, ie = ne.y, le = this.a.redMul(ae), se = ae.redSqr().redMul(ae).redIAdd(le).redIAdd(this.b);
  return ie.redSqr().redISub(se).cmpn(0) === 0;
};
ShortCurve.prototype._endoWnafMulAdd = function(ne, ae, ie) {
  for (var le = this._endoWnafT1, se = this._endoWnafT2, ce = 0; ce < ne.length; ce++) {
    var ue = this._endoSplit(ae[ce]), de = ne[ce], me = de._getBeta();
    ue.k1.negative && (ue.k1.ineg(), de = de.neg(!0)), ue.k2.negative && (ue.k2.ineg(), me = me.neg(!0)), le[ce * 2] = de, le[ce * 2 + 1] = me, se[ce * 2] = ue.k1, se[ce * 2 + 1] = ue.k2;
  }
  for (var fe = this._wnafMulAdd(1, le, se, ce * 2, ie), pe = 0; pe < ce * 2; pe++)
    le[pe] = null, se[pe] = null;
  return fe;
};
function Point$2(re, ne, ae, ie) {
  Base$2.BasePoint.call(this, re, "affine"), ne === null && ae === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new BN$8(ne, 16), this.y = new BN$8(ae, 16), ie && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
}
inherits$4(Point$2, Base$2.BasePoint);
ShortCurve.prototype.point = function(ne, ae, ie) {
  return new Point$2(this, ne, ae, ie);
};
ShortCurve.prototype.pointFromJSON = function(ne, ae) {
  return Point$2.fromJSON(this, ne, ae);
};
Point$2.prototype._getBeta = function() {
  if (this.curve.endo) {
    var ne = this.precomputed;
    if (ne && ne.beta)
      return ne.beta;
    var ae = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (ne) {
      var ie = this.curve, le = function(se) {
        return ie.point(se.x.redMul(ie.endo.beta), se.y);
      };
      ne.beta = ae, ae.precomputed = {
        beta: null,
        naf: ne.naf && {
          wnd: ne.naf.wnd,
          points: ne.naf.points.map(le)
        },
        doubles: ne.doubles && {
          step: ne.doubles.step,
          points: ne.doubles.points.map(le)
        }
      };
    }
    return ae;
  }
};
Point$2.prototype.toJSON = function() {
  return this.precomputed ? [this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  }] : [this.x, this.y];
};
Point$2.fromJSON = function(ne, ae, ie) {
  typeof ae == "string" && (ae = JSON.parse(ae));
  var le = ne.point(ae[0], ae[1], ie);
  if (!ae[2])
    return le;
  function se(ue) {
    return ne.point(ue[0], ue[1], ie);
  }
  var ce = ae[2];
  return le.precomputed = {
    beta: null,
    doubles: ce.doubles && {
      step: ce.doubles.step,
      points: [le].concat(ce.doubles.points.map(se))
    },
    naf: ce.naf && {
      wnd: ce.naf.wnd,
      points: [le].concat(ce.naf.points.map(se))
    }
  }, le;
};
Point$2.prototype.inspect = function() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
Point$2.prototype.isInfinity = function() {
  return this.inf;
};
Point$2.prototype.add = function(ne) {
  if (this.inf)
    return ne;
  if (ne.inf)
    return this;
  if (this.eq(ne))
    return this.dbl();
  if (this.neg().eq(ne))
    return this.curve.point(null, null);
  if (this.x.cmp(ne.x) === 0)
    return this.curve.point(null, null);
  var ae = this.y.redSub(ne.y);
  ae.cmpn(0) !== 0 && (ae = ae.redMul(this.x.redSub(ne.x).redInvm()));
  var ie = ae.redSqr().redISub(this.x).redISub(ne.x), le = ae.redMul(this.x.redSub(ie)).redISub(this.y);
  return this.curve.point(ie, le);
};
Point$2.prototype.dbl = function() {
  if (this.inf)
    return this;
  var ne = this.y.redAdd(this.y);
  if (ne.cmpn(0) === 0)
    return this.curve.point(null, null);
  var ae = this.curve.a, ie = this.x.redSqr(), le = ne.redInvm(), se = ie.redAdd(ie).redIAdd(ie).redIAdd(ae).redMul(le), ce = se.redSqr().redISub(this.x.redAdd(this.x)), ue = se.redMul(this.x.redSub(ce)).redISub(this.y);
  return this.curve.point(ce, ue);
};
Point$2.prototype.getX = function() {
  return this.x.fromRed();
};
Point$2.prototype.getY = function() {
  return this.y.fromRed();
};
Point$2.prototype.mul = function(ne) {
  return ne = new BN$8(ne, 16), this.isInfinity() ? this : this._hasDoubles(ne) ? this.curve._fixedNafMul(this, ne) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [ne]) : this.curve._wnafMul(this, ne);
};
Point$2.prototype.mulAdd = function(ne, ae, ie) {
  var le = [this, ae], se = [ne, ie];
  return this.curve.endo ? this.curve._endoWnafMulAdd(le, se) : this.curve._wnafMulAdd(1, le, se, 2);
};
Point$2.prototype.jmulAdd = function(ne, ae, ie) {
  var le = [this, ae], se = [ne, ie];
  return this.curve.endo ? this.curve._endoWnafMulAdd(le, se, !0) : this.curve._wnafMulAdd(1, le, se, 2, !0);
};
Point$2.prototype.eq = function(ne) {
  return this === ne || this.inf === ne.inf && (this.inf || this.x.cmp(ne.x) === 0 && this.y.cmp(ne.y) === 0);
};
Point$2.prototype.neg = function(ne) {
  if (this.inf)
    return this;
  var ae = this.curve.point(this.x, this.y.redNeg());
  if (ne && this.precomputed) {
    var ie = this.precomputed, le = function(se) {
      return se.neg();
    };
    ae.precomputed = {
      naf: ie.naf && {
        wnd: ie.naf.wnd,
        points: ie.naf.points.map(le)
      },
      doubles: ie.doubles && {
        step: ie.doubles.step,
        points: ie.doubles.points.map(le)
      }
    };
  }
  return ae;
};
Point$2.prototype.toJ = function() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);
  var ne = this.curve.jpoint(this.x, this.y, this.curve.one);
  return ne;
};
function JPoint(re, ne, ae, ie) {
  Base$2.BasePoint.call(this, re, "jacobian"), ne === null && ae === null && ie === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new BN$8(0)) : (this.x = new BN$8(ne, 16), this.y = new BN$8(ae, 16), this.z = new BN$8(ie, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
}
inherits$4(JPoint, Base$2.BasePoint);
ShortCurve.prototype.jpoint = function(ne, ae, ie) {
  return new JPoint(this, ne, ae, ie);
};
JPoint.prototype.toP = function() {
  if (this.isInfinity())
    return this.curve.point(null, null);
  var ne = this.z.redInvm(), ae = ne.redSqr(), ie = this.x.redMul(ae), le = this.y.redMul(ae).redMul(ne);
  return this.curve.point(ie, le);
};
JPoint.prototype.neg = function() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
JPoint.prototype.add = function(ne) {
  if (this.isInfinity())
    return ne;
  if (ne.isInfinity())
    return this;
  var ae = ne.z.redSqr(), ie = this.z.redSqr(), le = this.x.redMul(ae), se = ne.x.redMul(ie), ce = this.y.redMul(ae.redMul(ne.z)), ue = ne.y.redMul(ie.redMul(this.z)), de = le.redSub(se), me = ce.redSub(ue);
  if (de.cmpn(0) === 0)
    return me.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var fe = de.redSqr(), pe = fe.redMul(de), ge = le.redMul(fe), be = me.redSqr().redIAdd(pe).redISub(ge).redISub(ge), Se = me.redMul(ge.redISub(be)).redISub(ce.redMul(pe)), Pe = this.z.redMul(ne.z).redMul(de);
  return this.curve.jpoint(be, Se, Pe);
};
JPoint.prototype.mixedAdd = function(ne) {
  if (this.isInfinity())
    return ne.toJ();
  if (ne.isInfinity())
    return this;
  var ae = this.z.redSqr(), ie = this.x, le = ne.x.redMul(ae), se = this.y, ce = ne.y.redMul(ae).redMul(this.z), ue = ie.redSub(le), de = se.redSub(ce);
  if (ue.cmpn(0) === 0)
    return de.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var me = ue.redSqr(), fe = me.redMul(ue), pe = ie.redMul(me), ge = de.redSqr().redIAdd(fe).redISub(pe).redISub(pe), be = de.redMul(pe.redISub(ge)).redISub(se.redMul(fe)), Se = this.z.redMul(ue);
  return this.curve.jpoint(ge, be, Se);
};
JPoint.prototype.dblp = function(ne) {
  if (ne === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!ne)
    return this.dbl();
  var ae;
  if (this.curve.zeroA || this.curve.threeA) {
    var ie = this;
    for (ae = 0; ae < ne; ae++)
      ie = ie.dbl();
    return ie;
  }
  var le = this.curve.a, se = this.curve.tinv, ce = this.x, ue = this.y, de = this.z, me = de.redSqr().redSqr(), fe = ue.redAdd(ue);
  for (ae = 0; ae < ne; ae++) {
    var pe = ce.redSqr(), ge = fe.redSqr(), be = ge.redSqr(), Se = pe.redAdd(pe).redIAdd(pe).redIAdd(le.redMul(me)), Pe = ce.redMul(ge), Ee = Se.redSqr().redISub(Pe.redAdd(Pe)), Ve = Pe.redISub(Ee), Ae = Se.redMul(Ve);
    Ae = Ae.redIAdd(Ae).redISub(be);
    var Oe = fe.redMul(de);
    ae + 1 < ne && (me = me.redMul(be)), ce = Ee, de = Oe, fe = Ae;
  }
  return this.curve.jpoint(ce, fe.redMul(se), de);
};
JPoint.prototype.dbl = function() {
  return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
};
JPoint.prototype._zeroDbl = function() {
  var ne, ae, ie;
  if (this.zOne) {
    var le = this.x.redSqr(), se = this.y.redSqr(), ce = se.redSqr(), ue = this.x.redAdd(se).redSqr().redISub(le).redISub(ce);
    ue = ue.redIAdd(ue);
    var de = le.redAdd(le).redIAdd(le), me = de.redSqr().redISub(ue).redISub(ue), fe = ce.redIAdd(ce);
    fe = fe.redIAdd(fe), fe = fe.redIAdd(fe), ne = me, ae = de.redMul(ue.redISub(me)).redISub(fe), ie = this.y.redAdd(this.y);
  } else {
    var pe = this.x.redSqr(), ge = this.y.redSqr(), be = ge.redSqr(), Se = this.x.redAdd(ge).redSqr().redISub(pe).redISub(be);
    Se = Se.redIAdd(Se);
    var Pe = pe.redAdd(pe).redIAdd(pe), Ee = Pe.redSqr(), Ve = be.redIAdd(be);
    Ve = Ve.redIAdd(Ve), Ve = Ve.redIAdd(Ve), ne = Ee.redISub(Se).redISub(Se), ae = Pe.redMul(Se.redISub(ne)).redISub(Ve), ie = this.y.redMul(this.z), ie = ie.redIAdd(ie);
  }
  return this.curve.jpoint(ne, ae, ie);
};
JPoint.prototype._threeDbl = function() {
  var ne, ae, ie;
  if (this.zOne) {
    var le = this.x.redSqr(), se = this.y.redSqr(), ce = se.redSqr(), ue = this.x.redAdd(se).redSqr().redISub(le).redISub(ce);
    ue = ue.redIAdd(ue);
    var de = le.redAdd(le).redIAdd(le).redIAdd(this.curve.a), me = de.redSqr().redISub(ue).redISub(ue);
    ne = me;
    var fe = ce.redIAdd(ce);
    fe = fe.redIAdd(fe), fe = fe.redIAdd(fe), ae = de.redMul(ue.redISub(me)).redISub(fe), ie = this.y.redAdd(this.y);
  } else {
    var pe = this.z.redSqr(), ge = this.y.redSqr(), be = this.x.redMul(ge), Se = this.x.redSub(pe).redMul(this.x.redAdd(pe));
    Se = Se.redAdd(Se).redIAdd(Se);
    var Pe = be.redIAdd(be);
    Pe = Pe.redIAdd(Pe);
    var Ee = Pe.redAdd(Pe);
    ne = Se.redSqr().redISub(Ee), ie = this.y.redAdd(this.z).redSqr().redISub(ge).redISub(pe);
    var Ve = ge.redSqr();
    Ve = Ve.redIAdd(Ve), Ve = Ve.redIAdd(Ve), Ve = Ve.redIAdd(Ve), ae = Se.redMul(Pe.redISub(ne)).redISub(Ve);
  }
  return this.curve.jpoint(ne, ae, ie);
};
JPoint.prototype._dbl = function() {
  var ne = this.curve.a, ae = this.x, ie = this.y, le = this.z, se = le.redSqr().redSqr(), ce = ae.redSqr(), ue = ie.redSqr(), de = ce.redAdd(ce).redIAdd(ce).redIAdd(ne.redMul(se)), me = ae.redAdd(ae);
  me = me.redIAdd(me);
  var fe = me.redMul(ue), pe = de.redSqr().redISub(fe.redAdd(fe)), ge = fe.redISub(pe), be = ue.redSqr();
  be = be.redIAdd(be), be = be.redIAdd(be), be = be.redIAdd(be);
  var Se = de.redMul(ge).redISub(be), Pe = ie.redAdd(ie).redMul(le);
  return this.curve.jpoint(pe, Se, Pe);
};
JPoint.prototype.trpl = function() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);
  var ne = this.x.redSqr(), ae = this.y.redSqr(), ie = this.z.redSqr(), le = ae.redSqr(), se = ne.redAdd(ne).redIAdd(ne), ce = se.redSqr(), ue = this.x.redAdd(ae).redSqr().redISub(ne).redISub(le);
  ue = ue.redIAdd(ue), ue = ue.redAdd(ue).redIAdd(ue), ue = ue.redISub(ce);
  var de = ue.redSqr(), me = le.redIAdd(le);
  me = me.redIAdd(me), me = me.redIAdd(me), me = me.redIAdd(me);
  var fe = se.redIAdd(ue).redSqr().redISub(ce).redISub(de).redISub(me), pe = ae.redMul(fe);
  pe = pe.redIAdd(pe), pe = pe.redIAdd(pe);
  var ge = this.x.redMul(de).redISub(pe);
  ge = ge.redIAdd(ge), ge = ge.redIAdd(ge);
  var be = this.y.redMul(fe.redMul(me.redISub(fe)).redISub(ue.redMul(de)));
  be = be.redIAdd(be), be = be.redIAdd(be), be = be.redIAdd(be);
  var Se = this.z.redAdd(ue).redSqr().redISub(ie).redISub(de);
  return this.curve.jpoint(ge, be, Se);
};
JPoint.prototype.mul = function(ne, ae) {
  return ne = new BN$8(ne, ae), this.curve._wnafMul(this, ne);
};
JPoint.prototype.eq = function(ne) {
  if (ne.type === "affine")
    return this.eq(ne.toJ());
  if (this === ne)
    return !0;
  var ae = this.z.redSqr(), ie = ne.z.redSqr();
  if (this.x.redMul(ie).redISub(ne.x.redMul(ae)).cmpn(0) !== 0)
    return !1;
  var le = ae.redMul(this.z), se = ie.redMul(ne.z);
  return this.y.redMul(se).redISub(ne.y.redMul(le)).cmpn(0) === 0;
};
JPoint.prototype.eqXToP = function(ne) {
  var ae = this.z.redSqr(), ie = ne.toRed(this.curve.red).redMul(ae);
  if (this.x.cmp(ie) === 0)
    return !0;
  for (var le = ne.clone(), se = this.curve.redN.redMul(ae); ; ) {
    if (le.iadd(this.curve.n), le.cmp(this.curve.p) >= 0)
      return !1;
    if (ie.redIAdd(se), this.x.cmp(ie) === 0)
      return !0;
  }
};
JPoint.prototype.inspect = function() {
  return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
JPoint.prototype.isInfinity = function() {
  return this.z.cmpn(0) === 0;
};
var BN$7 = bnExports$2, inherits$3 = inherits_browserExports, Base$1 = base$1, utils$h = utils$l;
function MontCurve(re) {
  Base$1.call(this, "mont", re), this.a = new BN$7(re.a, 16).toRed(this.red), this.b = new BN$7(re.b, 16).toRed(this.red), this.i4 = new BN$7(4).toRed(this.red).redInvm(), this.two = new BN$7(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits$3(MontCurve, Base$1);
var mont = MontCurve;
MontCurve.prototype.validate = function(ne) {
  var ae = ne.normalize().x, ie = ae.redSqr(), le = ie.redMul(ae).redAdd(ie.redMul(this.a)).redAdd(ae), se = le.redSqrt();
  return se.redSqr().cmp(le) === 0;
};
function Point$1(re, ne, ae) {
  Base$1.BasePoint.call(this, re, "projective"), ne === null && ae === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new BN$7(ne, 16), this.z = new BN$7(ae, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
}
inherits$3(Point$1, Base$1.BasePoint);
MontCurve.prototype.decodePoint = function(ne, ae) {
  return this.point(utils$h.toArray(ne, ae), 1);
};
MontCurve.prototype.point = function(ne, ae) {
  return new Point$1(this, ne, ae);
};
MontCurve.prototype.pointFromJSON = function(ne) {
  return Point$1.fromJSON(this, ne);
};
Point$1.prototype.precompute = function() {
};
Point$1.prototype._encode = function() {
  return this.getX().toArray("be", this.curve.p.byteLength());
};
Point$1.fromJSON = function(ne, ae) {
  return new Point$1(ne, ae[0], ae[1] || ne.one);
};
Point$1.prototype.inspect = function() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point$1.prototype.isInfinity = function() {
  return this.z.cmpn(0) === 0;
};
Point$1.prototype.dbl = function() {
  var ne = this.x.redAdd(this.z), ae = ne.redSqr(), ie = this.x.redSub(this.z), le = ie.redSqr(), se = ae.redSub(le), ce = ae.redMul(le), ue = se.redMul(le.redAdd(this.curve.a24.redMul(se)));
  return this.curve.point(ce, ue);
};
Point$1.prototype.add = function() {
  throw new Error("Not supported on Montgomery curve");
};
Point$1.prototype.diffAdd = function(ne, ae) {
  var ie = this.x.redAdd(this.z), le = this.x.redSub(this.z), se = ne.x.redAdd(ne.z), ce = ne.x.redSub(ne.z), ue = ce.redMul(ie), de = se.redMul(le), me = ae.z.redMul(ue.redAdd(de).redSqr()), fe = ae.x.redMul(ue.redISub(de).redSqr());
  return this.curve.point(me, fe);
};
Point$1.prototype.mul = function(ne) {
  for (var ae = ne.clone(), ie = this, le = this.curve.point(null, null), se = this, ce = []; ae.cmpn(0) !== 0; ae.iushrn(1))
    ce.push(ae.andln(1));
  for (var ue = ce.length - 1; ue >= 0; ue--)
    ce[ue] === 0 ? (ie = ie.diffAdd(le, se), le = le.dbl()) : (le = ie.diffAdd(le, se), ie = ie.dbl());
  return le;
};
Point$1.prototype.mulAdd = function() {
  throw new Error("Not supported on Montgomery curve");
};
Point$1.prototype.jumlAdd = function() {
  throw new Error("Not supported on Montgomery curve");
};
Point$1.prototype.eq = function(ne) {
  return this.getX().cmp(ne.getX()) === 0;
};
Point$1.prototype.normalize = function() {
  return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
};
Point$1.prototype.getX = function() {
  return this.normalize(), this.x.fromRed();
};
var utils$g = utils$l, BN$6 = bnExports$2, inherits$2 = inherits_browserExports, Base = base$1, assert$b = utils$g.assert;
function EdwardsCurve(re) {
  this.twisted = (re.a | 0) !== 1, this.mOneA = this.twisted && (re.a | 0) === -1, this.extended = this.mOneA, Base.call(this, "edwards", re), this.a = new BN$6(re.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new BN$6(re.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new BN$6(re.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), assert$b(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (re.c | 0) === 1;
}
inherits$2(EdwardsCurve, Base);
var edwards = EdwardsCurve;
EdwardsCurve.prototype._mulA = function(ne) {
  return this.mOneA ? ne.redNeg() : this.a.redMul(ne);
};
EdwardsCurve.prototype._mulC = function(ne) {
  return this.oneC ? ne : this.c.redMul(ne);
};
EdwardsCurve.prototype.jpoint = function(ne, ae, ie, le) {
  return this.point(ne, ae, ie, le);
};
EdwardsCurve.prototype.pointFromX = function(ne, ae) {
  ne = new BN$6(ne, 16), ne.red || (ne = ne.toRed(this.red));
  var ie = ne.redSqr(), le = this.c2.redSub(this.a.redMul(ie)), se = this.one.redSub(this.c2.redMul(this.d).redMul(ie)), ce = le.redMul(se.redInvm()), ue = ce.redSqrt();
  if (ue.redSqr().redSub(ce).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var de = ue.fromRed().isOdd();
  return (ae && !de || !ae && de) && (ue = ue.redNeg()), this.point(ne, ue);
};
EdwardsCurve.prototype.pointFromY = function(ne, ae) {
  ne = new BN$6(ne, 16), ne.red || (ne = ne.toRed(this.red));
  var ie = ne.redSqr(), le = ie.redSub(this.c2), se = ie.redMul(this.d).redMul(this.c2).redSub(this.a), ce = le.redMul(se.redInvm());
  if (ce.cmp(this.zero) === 0) {
    if (ae)
      throw new Error("invalid point");
    return this.point(this.zero, ne);
  }
  var ue = ce.redSqrt();
  if (ue.redSqr().redSub(ce).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  return ue.fromRed().isOdd() !== ae && (ue = ue.redNeg()), this.point(ue, ne);
};
EdwardsCurve.prototype.validate = function(ne) {
  if (ne.isInfinity())
    return !0;
  ne.normalize();
  var ae = ne.x.redSqr(), ie = ne.y.redSqr(), le = ae.redMul(this.a).redAdd(ie), se = this.c2.redMul(this.one.redAdd(this.d.redMul(ae).redMul(ie)));
  return le.cmp(se) === 0;
};
function Point(re, ne, ae, ie, le) {
  Base.BasePoint.call(this, re, "projective"), ne === null && ae === null && ie === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new BN$6(ne, 16), this.y = new BN$6(ae, 16), this.z = ie ? new BN$6(ie, 16) : this.curve.one, this.t = le && new BN$6(le, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
}
inherits$2(Point, Base.BasePoint);
EdwardsCurve.prototype.pointFromJSON = function(ne) {
  return Point.fromJSON(this, ne);
};
EdwardsCurve.prototype.point = function(ne, ae, ie, le) {
  return new Point(this, ne, ae, ie, le);
};
Point.fromJSON = function(ne, ae) {
  return new Point(ne, ae[0], ae[1], ae[2]);
};
Point.prototype.inspect = function() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function() {
  return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
Point.prototype._extDbl = function() {
  var ne = this.x.redSqr(), ae = this.y.redSqr(), ie = this.z.redSqr();
  ie = ie.redIAdd(ie);
  var le = this.curve._mulA(ne), se = this.x.redAdd(this.y).redSqr().redISub(ne).redISub(ae), ce = le.redAdd(ae), ue = ce.redSub(ie), de = le.redSub(ae), me = se.redMul(ue), fe = ce.redMul(de), pe = se.redMul(de), ge = ue.redMul(ce);
  return this.curve.point(me, fe, ge, pe);
};
Point.prototype._projDbl = function() {
  var ne = this.x.redAdd(this.y).redSqr(), ae = this.x.redSqr(), ie = this.y.redSqr(), le, se, ce, ue, de, me;
  if (this.curve.twisted) {
    ue = this.curve._mulA(ae);
    var fe = ue.redAdd(ie);
    this.zOne ? (le = ne.redSub(ae).redSub(ie).redMul(fe.redSub(this.curve.two)), se = fe.redMul(ue.redSub(ie)), ce = fe.redSqr().redSub(fe).redSub(fe)) : (de = this.z.redSqr(), me = fe.redSub(de).redISub(de), le = ne.redSub(ae).redISub(ie).redMul(me), se = fe.redMul(ue.redSub(ie)), ce = fe.redMul(me));
  } else
    ue = ae.redAdd(ie), de = this.curve._mulC(this.z).redSqr(), me = ue.redSub(de).redSub(de), le = this.curve._mulC(ne.redISub(ue)).redMul(me), se = this.curve._mulC(ue).redMul(ae.redISub(ie)), ce = ue.redMul(me);
  return this.curve.point(le, se, ce);
};
Point.prototype.dbl = function() {
  return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
};
Point.prototype._extAdd = function(ne) {
  var ae = this.y.redSub(this.x).redMul(ne.y.redSub(ne.x)), ie = this.y.redAdd(this.x).redMul(ne.y.redAdd(ne.x)), le = this.t.redMul(this.curve.dd).redMul(ne.t), se = this.z.redMul(ne.z.redAdd(ne.z)), ce = ie.redSub(ae), ue = se.redSub(le), de = se.redAdd(le), me = ie.redAdd(ae), fe = ce.redMul(ue), pe = de.redMul(me), ge = ce.redMul(me), be = ue.redMul(de);
  return this.curve.point(fe, pe, be, ge);
};
Point.prototype._projAdd = function(ne) {
  var ae = this.z.redMul(ne.z), ie = ae.redSqr(), le = this.x.redMul(ne.x), se = this.y.redMul(ne.y), ce = this.curve.d.redMul(le).redMul(se), ue = ie.redSub(ce), de = ie.redAdd(ce), me = this.x.redAdd(this.y).redMul(ne.x.redAdd(ne.y)).redISub(le).redISub(se), fe = ae.redMul(ue).redMul(me), pe, ge;
  return this.curve.twisted ? (pe = ae.redMul(de).redMul(se.redSub(this.curve._mulA(le))), ge = ue.redMul(de)) : (pe = ae.redMul(de).redMul(se.redSub(le)), ge = this.curve._mulC(ue).redMul(de)), this.curve.point(fe, pe, ge);
};
Point.prototype.add = function(ne) {
  return this.isInfinity() ? ne : ne.isInfinity() ? this : this.curve.extended ? this._extAdd(ne) : this._projAdd(ne);
};
Point.prototype.mul = function(ne) {
  return this._hasDoubles(ne) ? this.curve._fixedNafMul(this, ne) : this.curve._wnafMul(this, ne);
};
Point.prototype.mulAdd = function(ne, ae, ie) {
  return this.curve._wnafMulAdd(1, [this, ae], [ne, ie], 2, !1);
};
Point.prototype.jmulAdd = function(ne, ae, ie) {
  return this.curve._wnafMulAdd(1, [this, ae], [ne, ie], 2, !0);
};
Point.prototype.normalize = function() {
  if (this.zOne)
    return this;
  var ne = this.z.redInvm();
  return this.x = this.x.redMul(ne), this.y = this.y.redMul(ne), this.t && (this.t = this.t.redMul(ne)), this.z = this.curve.one, this.zOne = !0, this;
};
Point.prototype.neg = function() {
  return this.curve.point(
    this.x.redNeg(),
    this.y,
    this.z,
    this.t && this.t.redNeg()
  );
};
Point.prototype.getX = function() {
  return this.normalize(), this.x.fromRed();
};
Point.prototype.getY = function() {
  return this.normalize(), this.y.fromRed();
};
Point.prototype.eq = function(ne) {
  return this === ne || this.getX().cmp(ne.getX()) === 0 && this.getY().cmp(ne.getY()) === 0;
};
Point.prototype.eqXToP = function(ne) {
  var ae = ne.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(ae) === 0)
    return !0;
  for (var ie = ne.clone(), le = this.curve.redN.redMul(this.z); ; ) {
    if (ie.iadd(this.curve.n), ie.cmp(this.curve.p) >= 0)
      return !1;
    if (ae.redIAdd(le), this.x.cmp(ae) === 0)
      return !0;
  }
};
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;
(function(re) {
  var ne = re;
  ne.base = base$1, ne.short = short, ne.mont = mont, ne.edwards = edwards;
})(curve);
var curves$1 = {}, hash$2 = {}, utils$f = {}, assert$a = minimalisticAssert, inherits$1 = inherits_browserExports;
utils$f.inherits = inherits$1;
function isSurrogatePair(re, ne) {
  return (re.charCodeAt(ne) & 64512) !== 55296 || ne < 0 || ne + 1 >= re.length ? !1 : (re.charCodeAt(ne + 1) & 64512) === 56320;
}
function toArray(re, ne) {
  if (Array.isArray(re))
    return re.slice();
  if (!re)
    return [];
  var ae = [];
  if (typeof re == "string")
    if (ne) {
      if (ne === "hex")
        for (re = re.replace(/[^a-z0-9]+/ig, ""), re.length % 2 !== 0 && (re = "0" + re), le = 0; le < re.length; le += 2)
          ae.push(parseInt(re[le] + re[le + 1], 16));
    } else for (var ie = 0, le = 0; le < re.length; le++) {
      var se = re.charCodeAt(le);
      se < 128 ? ae[ie++] = se : se < 2048 ? (ae[ie++] = se >> 6 | 192, ae[ie++] = se & 63 | 128) : isSurrogatePair(re, le) ? (se = 65536 + ((se & 1023) << 10) + (re.charCodeAt(++le) & 1023), ae[ie++] = se >> 18 | 240, ae[ie++] = se >> 12 & 63 | 128, ae[ie++] = se >> 6 & 63 | 128, ae[ie++] = se & 63 | 128) : (ae[ie++] = se >> 12 | 224, ae[ie++] = se >> 6 & 63 | 128, ae[ie++] = se & 63 | 128);
    }
  else
    for (le = 0; le < re.length; le++)
      ae[le] = re[le] | 0;
  return ae;
}
utils$f.toArray = toArray;
function toHex(re) {
  for (var ne = "", ae = 0; ae < re.length; ae++)
    ne += zero2(re[ae].toString(16));
  return ne;
}
utils$f.toHex = toHex;
function htonl(re) {
  var ne = re >>> 24 | re >>> 8 & 65280 | re << 8 & 16711680 | (re & 255) << 24;
  return ne >>> 0;
}
utils$f.htonl = htonl;
function toHex32(re, ne) {
  for (var ae = "", ie = 0; ie < re.length; ie++) {
    var le = re[ie];
    ne === "little" && (le = htonl(le)), ae += zero8(le.toString(16));
  }
  return ae;
}
utils$f.toHex32 = toHex32;
function zero2(re) {
  return re.length === 1 ? "0" + re : re;
}
utils$f.zero2 = zero2;
function zero8(re) {
  return re.length === 7 ? "0" + re : re.length === 6 ? "00" + re : re.length === 5 ? "000" + re : re.length === 4 ? "0000" + re : re.length === 3 ? "00000" + re : re.length === 2 ? "000000" + re : re.length === 1 ? "0000000" + re : re;
}
utils$f.zero8 = zero8;
function join32(re, ne, ae, ie) {
  var le = ae - ne;
  assert$a(le % 4 === 0);
  for (var se = new Array(le / 4), ce = 0, ue = ne; ce < se.length; ce++, ue += 4) {
    var de;
    ie === "big" ? de = re[ue] << 24 | re[ue + 1] << 16 | re[ue + 2] << 8 | re[ue + 3] : de = re[ue + 3] << 24 | re[ue + 2] << 16 | re[ue + 1] << 8 | re[ue], se[ce] = de >>> 0;
  }
  return se;
}
utils$f.join32 = join32;
function split32(re, ne) {
  for (var ae = new Array(re.length * 4), ie = 0, le = 0; ie < re.length; ie++, le += 4) {
    var se = re[ie];
    ne === "big" ? (ae[le] = se >>> 24, ae[le + 1] = se >>> 16 & 255, ae[le + 2] = se >>> 8 & 255, ae[le + 3] = se & 255) : (ae[le + 3] = se >>> 24, ae[le + 2] = se >>> 16 & 255, ae[le + 1] = se >>> 8 & 255, ae[le] = se & 255);
  }
  return ae;
}
utils$f.split32 = split32;
function rotr32$1(re, ne) {
  return re >>> ne | re << 32 - ne;
}
utils$f.rotr32 = rotr32$1;
function rotl32$2(re, ne) {
  return re << ne | re >>> 32 - ne;
}
utils$f.rotl32 = rotl32$2;
function sum32$3(re, ne) {
  return re + ne >>> 0;
}
utils$f.sum32 = sum32$3;
function sum32_3$1(re, ne, ae) {
  return re + ne + ae >>> 0;
}
utils$f.sum32_3 = sum32_3$1;
function sum32_4$2(re, ne, ae, ie) {
  return re + ne + ae + ie >>> 0;
}
utils$f.sum32_4 = sum32_4$2;
function sum32_5$2(re, ne, ae, ie, le) {
  return re + ne + ae + ie + le >>> 0;
}
utils$f.sum32_5 = sum32_5$2;
function sum64$1(re, ne, ae, ie) {
  var le = re[ne], se = re[ne + 1], ce = ie + se >>> 0, ue = (ce < ie ? 1 : 0) + ae + le;
  re[ne] = ue >>> 0, re[ne + 1] = ce;
}
utils$f.sum64 = sum64$1;
function sum64_hi$1(re, ne, ae, ie) {
  var le = ne + ie >>> 0, se = (le < ne ? 1 : 0) + re + ae;
  return se >>> 0;
}
utils$f.sum64_hi = sum64_hi$1;
function sum64_lo$1(re, ne, ae, ie) {
  var le = ne + ie;
  return le >>> 0;
}
utils$f.sum64_lo = sum64_lo$1;
function sum64_4_hi$1(re, ne, ae, ie, le, se, ce, ue) {
  var de = 0, me = ne;
  me = me + ie >>> 0, de += me < ne ? 1 : 0, me = me + se >>> 0, de += me < se ? 1 : 0, me = me + ue >>> 0, de += me < ue ? 1 : 0;
  var fe = re + ae + le + ce + de;
  return fe >>> 0;
}
utils$f.sum64_4_hi = sum64_4_hi$1;
function sum64_4_lo$1(re, ne, ae, ie, le, se, ce, ue) {
  var de = ne + ie + se + ue;
  return de >>> 0;
}
utils$f.sum64_4_lo = sum64_4_lo$1;
function sum64_5_hi$1(re, ne, ae, ie, le, se, ce, ue, de, me) {
  var fe = 0, pe = ne;
  pe = pe + ie >>> 0, fe += pe < ne ? 1 : 0, pe = pe + se >>> 0, fe += pe < se ? 1 : 0, pe = pe + ue >>> 0, fe += pe < ue ? 1 : 0, pe = pe + me >>> 0, fe += pe < me ? 1 : 0;
  var ge = re + ae + le + ce + de + fe;
  return ge >>> 0;
}
utils$f.sum64_5_hi = sum64_5_hi$1;
function sum64_5_lo$1(re, ne, ae, ie, le, se, ce, ue, de, me) {
  var fe = ne + ie + se + ue + me;
  return fe >>> 0;
}
utils$f.sum64_5_lo = sum64_5_lo$1;
function rotr64_hi$1(re, ne, ae) {
  var ie = ne << 32 - ae | re >>> ae;
  return ie >>> 0;
}
utils$f.rotr64_hi = rotr64_hi$1;
function rotr64_lo$1(re, ne, ae) {
  var ie = re << 32 - ae | ne >>> ae;
  return ie >>> 0;
}
utils$f.rotr64_lo = rotr64_lo$1;
function shr64_hi$1(re, ne, ae) {
  return re >>> ae;
}
utils$f.shr64_hi = shr64_hi$1;
function shr64_lo$1(re, ne, ae) {
  var ie = re << 32 - ae | ne >>> ae;
  return ie >>> 0;
}
utils$f.shr64_lo = shr64_lo$1;
var common$5 = {}, utils$e = utils$f, assert$9 = minimalisticAssert;
function BlockHash$4() {
  this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
}
common$5.BlockHash = BlockHash$4;
BlockHash$4.prototype.update = function(ne, ae) {
  if (ne = utils$e.toArray(ne, ae), this.pending ? this.pending = this.pending.concat(ne) : this.pending = ne, this.pendingTotal += ne.length, this.pending.length >= this._delta8) {
    ne = this.pending;
    var ie = ne.length % this._delta8;
    this.pending = ne.slice(ne.length - ie, ne.length), this.pending.length === 0 && (this.pending = null), ne = utils$e.join32(ne, 0, ne.length - ie, this.endian);
    for (var le = 0; le < ne.length; le += this._delta32)
      this._update(ne, le, le + this._delta32);
  }
  return this;
};
BlockHash$4.prototype.digest = function(ne) {
  return this.update(this._pad()), assert$9(this.pending === null), this._digest(ne);
};
BlockHash$4.prototype._pad = function() {
  var ne = this.pendingTotal, ae = this._delta8, ie = ae - (ne + this.padLength) % ae, le = new Array(ie + this.padLength);
  le[0] = 128;
  for (var se = 1; se < ie; se++)
    le[se] = 0;
  if (ne <<= 3, this.endian === "big") {
    for (var ce = 8; ce < this.padLength; ce++)
      le[se++] = 0;
    le[se++] = 0, le[se++] = 0, le[se++] = 0, le[se++] = 0, le[se++] = ne >>> 24 & 255, le[se++] = ne >>> 16 & 255, le[se++] = ne >>> 8 & 255, le[se++] = ne & 255;
  } else
    for (le[se++] = ne & 255, le[se++] = ne >>> 8 & 255, le[se++] = ne >>> 16 & 255, le[se++] = ne >>> 24 & 255, le[se++] = 0, le[se++] = 0, le[se++] = 0, le[se++] = 0, ce = 8; ce < this.padLength; ce++)
      le[se++] = 0;
  return le;
};
var sha = {}, common$4 = {}, utils$d = utils$f, rotr32 = utils$d.rotr32;
function ft_1$1(re, ne, ae, ie) {
  if (re === 0)
    return ch32$1(ne, ae, ie);
  if (re === 1 || re === 3)
    return p32(ne, ae, ie);
  if (re === 2)
    return maj32$1(ne, ae, ie);
}
common$4.ft_1 = ft_1$1;
function ch32$1(re, ne, ae) {
  return re & ne ^ ~re & ae;
}
common$4.ch32 = ch32$1;
function maj32$1(re, ne, ae) {
  return re & ne ^ re & ae ^ ne & ae;
}
common$4.maj32 = maj32$1;
function p32(re, ne, ae) {
  return re ^ ne ^ ae;
}
common$4.p32 = p32;
function s0_256$1(re) {
  return rotr32(re, 2) ^ rotr32(re, 13) ^ rotr32(re, 22);
}
common$4.s0_256 = s0_256$1;
function s1_256$1(re) {
  return rotr32(re, 6) ^ rotr32(re, 11) ^ rotr32(re, 25);
}
common$4.s1_256 = s1_256$1;
function g0_256$1(re) {
  return rotr32(re, 7) ^ rotr32(re, 18) ^ re >>> 3;
}
common$4.g0_256 = g0_256$1;
function g1_256$1(re) {
  return rotr32(re, 17) ^ rotr32(re, 19) ^ re >>> 10;
}
common$4.g1_256 = g1_256$1;
var utils$c = utils$f, common$3 = common$5, shaCommon$1 = common$4, rotl32$1 = utils$c.rotl32, sum32$2 = utils$c.sum32, sum32_5$1 = utils$c.sum32_5, ft_1 = shaCommon$1.ft_1, BlockHash$3 = common$3.BlockHash, sha1_K = [
  1518500249,
  1859775393,
  2400959708,
  3395469782
];
function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();
  BlockHash$3.call(this), this.h = [
    1732584193,
    4023233417,
    2562383102,
    271733878,
    3285377520
  ], this.W = new Array(80);
}
utils$c.inherits(SHA1, BlockHash$3);
var _1 = SHA1;
SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;
SHA1.prototype._update = function(ne, ae) {
  for (var ie = this.W, le = 0; le < 16; le++)
    ie[le] = ne[ae + le];
  for (; le < ie.length; le++)
    ie[le] = rotl32$1(ie[le - 3] ^ ie[le - 8] ^ ie[le - 14] ^ ie[le - 16], 1);
  var se = this.h[0], ce = this.h[1], ue = this.h[2], de = this.h[3], me = this.h[4];
  for (le = 0; le < ie.length; le++) {
    var fe = ~~(le / 20), pe = sum32_5$1(rotl32$1(se, 5), ft_1(fe, ce, ue, de), me, ie[le], sha1_K[fe]);
    me = de, de = ue, ue = rotl32$1(ce, 30), ce = se, se = pe;
  }
  this.h[0] = sum32$2(this.h[0], se), this.h[1] = sum32$2(this.h[1], ce), this.h[2] = sum32$2(this.h[2], ue), this.h[3] = sum32$2(this.h[3], de), this.h[4] = sum32$2(this.h[4], me);
};
SHA1.prototype._digest = function(ne) {
  return ne === "hex" ? utils$c.toHex32(this.h, "big") : utils$c.split32(this.h, "big");
};
var utils$b = utils$f, common$2 = common$5, shaCommon = common$4, assert$8 = minimalisticAssert, sum32$1 = utils$b.sum32, sum32_4$1 = utils$b.sum32_4, sum32_5 = utils$b.sum32_5, ch32 = shaCommon.ch32, maj32 = shaCommon.maj32, s0_256 = shaCommon.s0_256, s1_256 = shaCommon.s1_256, g0_256 = shaCommon.g0_256, g1_256 = shaCommon.g1_256, BlockHash$2 = common$2.BlockHash, sha256_K = [
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
];
function SHA256$1() {
  if (!(this instanceof SHA256$1))
    return new SHA256$1();
  BlockHash$2.call(this), this.h = [
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ], this.k = sha256_K, this.W = new Array(64);
}
utils$b.inherits(SHA256$1, BlockHash$2);
var _256 = SHA256$1;
SHA256$1.blockSize = 512;
SHA256$1.outSize = 256;
SHA256$1.hmacStrength = 192;
SHA256$1.padLength = 64;
SHA256$1.prototype._update = function(ne, ae) {
  for (var ie = this.W, le = 0; le < 16; le++)
    ie[le] = ne[ae + le];
  for (; le < ie.length; le++)
    ie[le] = sum32_4$1(g1_256(ie[le - 2]), ie[le - 7], g0_256(ie[le - 15]), ie[le - 16]);
  var se = this.h[0], ce = this.h[1], ue = this.h[2], de = this.h[3], me = this.h[4], fe = this.h[5], pe = this.h[6], ge = this.h[7];
  for (assert$8(this.k.length === ie.length), le = 0; le < ie.length; le++) {
    var be = sum32_5(ge, s1_256(me), ch32(me, fe, pe), this.k[le], ie[le]), Se = sum32$1(s0_256(se), maj32(se, ce, ue));
    ge = pe, pe = fe, fe = me, me = sum32$1(de, be), de = ue, ue = ce, ce = se, se = sum32$1(be, Se);
  }
  this.h[0] = sum32$1(this.h[0], se), this.h[1] = sum32$1(this.h[1], ce), this.h[2] = sum32$1(this.h[2], ue), this.h[3] = sum32$1(this.h[3], de), this.h[4] = sum32$1(this.h[4], me), this.h[5] = sum32$1(this.h[5], fe), this.h[6] = sum32$1(this.h[6], pe), this.h[7] = sum32$1(this.h[7], ge);
};
SHA256$1.prototype._digest = function(ne) {
  return ne === "hex" ? utils$b.toHex32(this.h, "big") : utils$b.split32(this.h, "big");
};
var utils$a = utils$f, SHA256 = _256;
function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();
  SHA256.call(this), this.h = [
    3238371032,
    914150663,
    812702999,
    4144912697,
    4290775857,
    1750603025,
    1694076839,
    3204075428
  ];
}
utils$a.inherits(SHA224, SHA256);
var _224 = SHA224;
SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;
SHA224.prototype._digest = function(ne) {
  return ne === "hex" ? utils$a.toHex32(this.h.slice(0, 7), "big") : utils$a.split32(this.h.slice(0, 7), "big");
};
var utils$9 = utils$f, common$1 = common$5, assert$7 = minimalisticAssert, rotr64_hi = utils$9.rotr64_hi, rotr64_lo = utils$9.rotr64_lo, shr64_hi = utils$9.shr64_hi, shr64_lo = utils$9.shr64_lo, sum64 = utils$9.sum64, sum64_hi = utils$9.sum64_hi, sum64_lo = utils$9.sum64_lo, sum64_4_hi = utils$9.sum64_4_hi, sum64_4_lo = utils$9.sum64_4_lo, sum64_5_hi = utils$9.sum64_5_hi, sum64_5_lo = utils$9.sum64_5_lo, BlockHash$1 = common$1.BlockHash, sha512_K = [
  1116352408,
  3609767458,
  1899447441,
  602891725,
  3049323471,
  3964484399,
  3921009573,
  2173295548,
  961987163,
  4081628472,
  1508970993,
  3053834265,
  2453635748,
  2937671579,
  2870763221,
  3664609560,
  3624381080,
  2734883394,
  310598401,
  1164996542,
  607225278,
  1323610764,
  1426881987,
  3590304994,
  1925078388,
  4068182383,
  2162078206,
  991336113,
  2614888103,
  633803317,
  3248222580,
  3479774868,
  3835390401,
  2666613458,
  4022224774,
  944711139,
  264347078,
  2341262773,
  604807628,
  2007800933,
  770255983,
  1495990901,
  1249150122,
  1856431235,
  1555081692,
  3175218132,
  1996064986,
  2198950837,
  2554220882,
  3999719339,
  2821834349,
  766784016,
  2952996808,
  2566594879,
  3210313671,
  3203337956,
  3336571891,
  1034457026,
  3584528711,
  2466948901,
  113926993,
  3758326383,
  338241895,
  168717936,
  666307205,
  1188179964,
  773529912,
  1546045734,
  1294757372,
  1522805485,
  1396182291,
  2643833823,
  1695183700,
  2343527390,
  1986661051,
  1014477480,
  2177026350,
  1206759142,
  2456956037,
  344077627,
  2730485921,
  1290863460,
  2820302411,
  3158454273,
  3259730800,
  3505952657,
  3345764771,
  106217008,
  3516065817,
  3606008344,
  3600352804,
  1432725776,
  4094571909,
  1467031594,
  275423344,
  851169720,
  430227734,
  3100823752,
  506948616,
  1363258195,
  659060556,
  3750685593,
  883997877,
  3785050280,
  958139571,
  3318307427,
  1322822218,
  3812723403,
  1537002063,
  2003034995,
  1747873779,
  3602036899,
  1955562222,
  1575990012,
  2024104815,
  1125592928,
  2227730452,
  2716904306,
  2361852424,
  442776044,
  2428436474,
  593698344,
  2756734187,
  3733110249,
  3204031479,
  2999351573,
  3329325298,
  3815920427,
  3391569614,
  3928383900,
  3515267271,
  566280711,
  3940187606,
  3454069534,
  4118630271,
  4000239992,
  116418474,
  1914138554,
  174292421,
  2731055270,
  289380356,
  3203993006,
  460393269,
  320620315,
  685471733,
  587496836,
  852142971,
  1086792851,
  1017036298,
  365543100,
  1126000580,
  2618297676,
  1288033470,
  3409855158,
  1501505948,
  4234509866,
  1607167915,
  987167468,
  1816402316,
  1246189591
];
function SHA512$1() {
  if (!(this instanceof SHA512$1))
    return new SHA512$1();
  BlockHash$1.call(this), this.h = [
    1779033703,
    4089235720,
    3144134277,
    2227873595,
    1013904242,
    4271175723,
    2773480762,
    1595750129,
    1359893119,
    2917565137,
    2600822924,
    725511199,
    528734635,
    4215389547,
    1541459225,
    327033209
  ], this.k = sha512_K, this.W = new Array(160);
}
utils$9.inherits(SHA512$1, BlockHash$1);
var _512 = SHA512$1;
SHA512$1.blockSize = 1024;
SHA512$1.outSize = 512;
SHA512$1.hmacStrength = 192;
SHA512$1.padLength = 128;
SHA512$1.prototype._prepareBlock = function(ne, ae) {
  for (var ie = this.W, le = 0; le < 32; le++)
    ie[le] = ne[ae + le];
  for (; le < ie.length; le += 2) {
    var se = g1_512_hi(ie[le - 4], ie[le - 3]), ce = g1_512_lo(ie[le - 4], ie[le - 3]), ue = ie[le - 14], de = ie[le - 13], me = g0_512_hi(ie[le - 30], ie[le - 29]), fe = g0_512_lo(ie[le - 30], ie[le - 29]), pe = ie[le - 32], ge = ie[le - 31];
    ie[le] = sum64_4_hi(
      se,
      ce,
      ue,
      de,
      me,
      fe,
      pe,
      ge
    ), ie[le + 1] = sum64_4_lo(
      se,
      ce,
      ue,
      de,
      me,
      fe,
      pe,
      ge
    );
  }
};
SHA512$1.prototype._update = function(ne, ae) {
  this._prepareBlock(ne, ae);
  var ie = this.W, le = this.h[0], se = this.h[1], ce = this.h[2], ue = this.h[3], de = this.h[4], me = this.h[5], fe = this.h[6], pe = this.h[7], ge = this.h[8], be = this.h[9], Se = this.h[10], Pe = this.h[11], Ee = this.h[12], Ve = this.h[13], Ae = this.h[14], Oe = this.h[15];
  assert$7(this.k.length === ie.length);
  for (var Ne = 0; Ne < ie.length; Ne += 2) {
    var He = Ae, Ue = Oe, Ze = s1_512_hi(ge, be), Fe = s1_512_lo(ge, be), Ke = ch64_hi(ge, be, Se, Pe, Ee), tt = ch64_lo(ge, be, Se, Pe, Ee, Ve), Re = this.k[Ne], Ce = this.k[Ne + 1], _e = ie[Ne], he = ie[Ne + 1], ve = sum64_5_hi(
      He,
      Ue,
      Ze,
      Fe,
      Ke,
      tt,
      Re,
      Ce,
      _e,
      he
    ), xe = sum64_5_lo(
      He,
      Ue,
      Ze,
      Fe,
      Ke,
      tt,
      Re,
      Ce,
      _e,
      he
    );
    He = s0_512_hi(le, se), Ue = s0_512_lo(le, se), Ze = maj64_hi(le, se, ce, ue, de), Fe = maj64_lo(le, se, ce, ue, de, me);
    var $e = sum64_hi(He, Ue, Ze, Fe), Te = sum64_lo(He, Ue, Ze, Fe);
    Ae = Ee, Oe = Ve, Ee = Se, Ve = Pe, Se = ge, Pe = be, ge = sum64_hi(fe, pe, ve, xe), be = sum64_lo(pe, pe, ve, xe), fe = de, pe = me, de = ce, me = ue, ce = le, ue = se, le = sum64_hi(ve, xe, $e, Te), se = sum64_lo(ve, xe, $e, Te);
  }
  sum64(this.h, 0, le, se), sum64(this.h, 2, ce, ue), sum64(this.h, 4, de, me), sum64(this.h, 6, fe, pe), sum64(this.h, 8, ge, be), sum64(this.h, 10, Se, Pe), sum64(this.h, 12, Ee, Ve), sum64(this.h, 14, Ae, Oe);
};
SHA512$1.prototype._digest = function(ne) {
  return ne === "hex" ? utils$9.toHex32(this.h, "big") : utils$9.split32(this.h, "big");
};
function ch64_hi(re, ne, ae, ie, le) {
  var se = re & ae ^ ~re & le;
  return se < 0 && (se += 4294967296), se;
}
function ch64_lo(re, ne, ae, ie, le, se) {
  var ce = ne & ie ^ ~ne & se;
  return ce < 0 && (ce += 4294967296), ce;
}
function maj64_hi(re, ne, ae, ie, le) {
  var se = re & ae ^ re & le ^ ae & le;
  return se < 0 && (se += 4294967296), se;
}
function maj64_lo(re, ne, ae, ie, le, se) {
  var ce = ne & ie ^ ne & se ^ ie & se;
  return ce < 0 && (ce += 4294967296), ce;
}
function s0_512_hi(re, ne) {
  var ae = rotr64_hi(re, ne, 28), ie = rotr64_hi(ne, re, 2), le = rotr64_hi(ne, re, 7), se = ae ^ ie ^ le;
  return se < 0 && (se += 4294967296), se;
}
function s0_512_lo(re, ne) {
  var ae = rotr64_lo(re, ne, 28), ie = rotr64_lo(ne, re, 2), le = rotr64_lo(ne, re, 7), se = ae ^ ie ^ le;
  return se < 0 && (se += 4294967296), se;
}
function s1_512_hi(re, ne) {
  var ae = rotr64_hi(re, ne, 14), ie = rotr64_hi(re, ne, 18), le = rotr64_hi(ne, re, 9), se = ae ^ ie ^ le;
  return se < 0 && (se += 4294967296), se;
}
function s1_512_lo(re, ne) {
  var ae = rotr64_lo(re, ne, 14), ie = rotr64_lo(re, ne, 18), le = rotr64_lo(ne, re, 9), se = ae ^ ie ^ le;
  return se < 0 && (se += 4294967296), se;
}
function g0_512_hi(re, ne) {
  var ae = rotr64_hi(re, ne, 1), ie = rotr64_hi(re, ne, 8), le = shr64_hi(re, ne, 7), se = ae ^ ie ^ le;
  return se < 0 && (se += 4294967296), se;
}
function g0_512_lo(re, ne) {
  var ae = rotr64_lo(re, ne, 1), ie = rotr64_lo(re, ne, 8), le = shr64_lo(re, ne, 7), se = ae ^ ie ^ le;
  return se < 0 && (se += 4294967296), se;
}
function g1_512_hi(re, ne) {
  var ae = rotr64_hi(re, ne, 19), ie = rotr64_hi(ne, re, 29), le = shr64_hi(re, ne, 6), se = ae ^ ie ^ le;
  return se < 0 && (se += 4294967296), se;
}
function g1_512_lo(re, ne) {
  var ae = rotr64_lo(re, ne, 19), ie = rotr64_lo(ne, re, 29), le = shr64_lo(re, ne, 6), se = ae ^ ie ^ le;
  return se < 0 && (se += 4294967296), se;
}
var utils$8 = utils$f, SHA512 = _512;
function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();
  SHA512.call(this), this.h = [
    3418070365,
    3238371032,
    1654270250,
    914150663,
    2438529370,
    812702999,
    355462360,
    4144912697,
    1731405415,
    4290775857,
    2394180231,
    1750603025,
    3675008525,
    1694076839,
    1203062813,
    3204075428
  ];
}
utils$8.inherits(SHA384, SHA512);
var _384 = SHA384;
SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;
SHA384.prototype._digest = function(ne) {
  return ne === "hex" ? utils$8.toHex32(this.h.slice(0, 12), "big") : utils$8.split32(this.h.slice(0, 12), "big");
};
sha.sha1 = _1;
sha.sha224 = _224;
sha.sha256 = _256;
sha.sha384 = _384;
sha.sha512 = _512;
var ripemd = {}, utils$7 = utils$f, common = common$5, rotl32 = utils$7.rotl32, sum32 = utils$7.sum32, sum32_3 = utils$7.sum32_3, sum32_4 = utils$7.sum32_4, BlockHash = common.BlockHash;
function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();
  BlockHash.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
}
utils$7.inherits(RIPEMD160, BlockHash);
ripemd.ripemd160 = RIPEMD160;
RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;
RIPEMD160.prototype._update = function(ne, ae) {
  for (var ie = this.h[0], le = this.h[1], se = this.h[2], ce = this.h[3], ue = this.h[4], de = ie, me = le, fe = se, pe = ce, ge = ue, be = 0; be < 80; be++) {
    var Se = sum32(
      rotl32(
        sum32_4(ie, f(be, le, se, ce), ne[r[be] + ae], K(be)),
        s[be]
      ),
      ue
    );
    ie = ue, ue = ce, ce = rotl32(se, 10), se = le, le = Se, Se = sum32(
      rotl32(
        sum32_4(de, f(79 - be, me, fe, pe), ne[rh[be] + ae], Kh(be)),
        sh[be]
      ),
      ge
    ), de = ge, ge = pe, pe = rotl32(fe, 10), fe = me, me = Se;
  }
  Se = sum32_3(this.h[1], se, pe), this.h[1] = sum32_3(this.h[2], ce, ge), this.h[2] = sum32_3(this.h[3], ue, de), this.h[3] = sum32_3(this.h[4], ie, me), this.h[4] = sum32_3(this.h[0], le, fe), this.h[0] = Se;
};
RIPEMD160.prototype._digest = function(ne) {
  return ne === "hex" ? utils$7.toHex32(this.h, "little") : utils$7.split32(this.h, "little");
};
function f(re, ne, ae, ie) {
  return re <= 15 ? ne ^ ae ^ ie : re <= 31 ? ne & ae | ~ne & ie : re <= 47 ? (ne | ~ae) ^ ie : re <= 63 ? ne & ie | ae & ~ie : ne ^ (ae | ~ie);
}
function K(re) {
  return re <= 15 ? 0 : re <= 31 ? 1518500249 : re <= 47 ? 1859775393 : re <= 63 ? 2400959708 : 2840853838;
}
function Kh(re) {
  return re <= 15 ? 1352829926 : re <= 31 ? 1548603684 : re <= 47 ? 1836072691 : re <= 63 ? 2053994217 : 0;
}
var r = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  7,
  4,
  13,
  1,
  10,
  6,
  15,
  3,
  12,
  0,
  9,
  5,
  2,
  14,
  11,
  8,
  3,
  10,
  14,
  4,
  9,
  15,
  8,
  1,
  2,
  7,
  0,
  6,
  13,
  11,
  5,
  12,
  1,
  9,
  11,
  10,
  0,
  8,
  12,
  4,
  13,
  3,
  7,
  15,
  14,
  5,
  6,
  2,
  4,
  0,
  5,
  9,
  7,
  12,
  2,
  10,
  14,
  1,
  3,
  8,
  11,
  6,
  15,
  13
], rh = [
  5,
  14,
  7,
  0,
  9,
  2,
  11,
  4,
  13,
  6,
  15,
  8,
  1,
  10,
  3,
  12,
  6,
  11,
  3,
  7,
  0,
  13,
  5,
  10,
  14,
  15,
  8,
  12,
  4,
  9,
  1,
  2,
  15,
  5,
  1,
  3,
  7,
  14,
  6,
  9,
  11,
  8,
  12,
  2,
  10,
  0,
  4,
  13,
  8,
  6,
  4,
  1,
  3,
  11,
  15,
  0,
  5,
  12,
  2,
  13,
  9,
  7,
  10,
  14,
  12,
  15,
  10,
  4,
  1,
  5,
  8,
  7,
  6,
  2,
  13,
  14,
  0,
  3,
  9,
  11
], s = [
  11,
  14,
  15,
  12,
  5,
  8,
  7,
  9,
  11,
  13,
  14,
  15,
  6,
  7,
  9,
  8,
  7,
  6,
  8,
  13,
  11,
  9,
  7,
  15,
  7,
  12,
  15,
  9,
  11,
  7,
  13,
  12,
  11,
  13,
  6,
  7,
  14,
  9,
  13,
  15,
  14,
  8,
  13,
  6,
  5,
  12,
  7,
  5,
  11,
  12,
  14,
  15,
  14,
  15,
  9,
  8,
  9,
  14,
  5,
  6,
  8,
  6,
  5,
  12,
  9,
  15,
  5,
  11,
  6,
  8,
  13,
  12,
  5,
  12,
  13,
  14,
  11,
  8,
  5,
  6
], sh = [
  8,
  9,
  9,
  11,
  13,
  15,
  15,
  5,
  7,
  7,
  8,
  11,
  14,
  14,
  12,
  6,
  9,
  13,
  15,
  7,
  12,
  8,
  9,
  11,
  7,
  7,
  12,
  7,
  6,
  15,
  13,
  11,
  9,
  7,
  15,
  11,
  8,
  6,
  6,
  14,
  12,
  13,
  5,
  14,
  13,
  13,
  7,
  5,
  15,
  5,
  8,
  11,
  14,
  14,
  6,
  14,
  6,
  9,
  12,
  9,
  12,
  5,
  15,
  8,
  8,
  5,
  12,
  9,
  12,
  5,
  14,
  6,
  8,
  13,
  6,
  5,
  15,
  13,
  11,
  11
], utils$6 = utils$f, assert$6 = minimalisticAssert;
function Hmac(re, ne, ae) {
  if (!(this instanceof Hmac))
    return new Hmac(re, ne, ae);
  this.Hash = re, this.blockSize = re.blockSize / 8, this.outSize = re.outSize / 8, this.inner = null, this.outer = null, this._init(utils$6.toArray(ne, ae));
}
var hmac = Hmac;
Hmac.prototype._init = function(ne) {
  ne.length > this.blockSize && (ne = new this.Hash().update(ne).digest()), assert$6(ne.length <= this.blockSize);
  for (var ae = ne.length; ae < this.blockSize; ae++)
    ne.push(0);
  for (ae = 0; ae < ne.length; ae++)
    ne[ae] ^= 54;
  for (this.inner = new this.Hash().update(ne), ae = 0; ae < ne.length; ae++)
    ne[ae] ^= 106;
  this.outer = new this.Hash().update(ne);
};
Hmac.prototype.update = function(ne, ae) {
  return this.inner.update(ne, ae), this;
};
Hmac.prototype.digest = function(ne) {
  return this.outer.update(this.inner.digest()), this.outer.digest(ne);
};
(function(re) {
  var ne = re;
  ne.utils = utils$f, ne.common = common$5, ne.sha = sha, ne.ripemd = ripemd, ne.hmac = hmac, ne.sha1 = ne.sha.sha1, ne.sha256 = ne.sha.sha256, ne.sha224 = ne.sha.sha224, ne.sha384 = ne.sha.sha384, ne.sha512 = ne.sha.sha512, ne.ripemd160 = ne.ripemd.ripemd160;
})(hash$2);
var secp256k1, hasRequiredSecp256k1;
function requireSecp256k1() {
  return hasRequiredSecp256k1 || (hasRequiredSecp256k1 = 1, secp256k1 = {
    doubles: {
      step: 4,
      points: [
        [
          "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
          "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
        ],
        [
          "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
          "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
        ],
        [
          "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
          "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
        ],
        [
          "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
          "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
        ],
        [
          "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
          "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
        ],
        [
          "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
          "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
        ],
        [
          "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
          "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
        ],
        [
          "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
          "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
        ],
        [
          "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
          "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
        ],
        [
          "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
          "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
        ],
        [
          "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
          "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
        ],
        [
          "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
          "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
        ],
        [
          "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
          "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
        ],
        [
          "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
          "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
        ],
        [
          "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
          "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
        ],
        [
          "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
          "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
        ],
        [
          "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
          "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
        ],
        [
          "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
          "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
        ],
        [
          "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
          "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
        ],
        [
          "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
          "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
        ],
        [
          "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
          "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
        ],
        [
          "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
          "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
        ],
        [
          "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
          "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
        ],
        [
          "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
          "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
        ],
        [
          "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
          "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
        ],
        [
          "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
          "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
        ],
        [
          "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
          "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
        ],
        [
          "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
          "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
        ],
        [
          "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
          "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
        ],
        [
          "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
          "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
        ],
        [
          "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
          "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
        ],
        [
          "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
          "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
        ],
        [
          "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
          "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
        ],
        [
          "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
          "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
        ],
        [
          "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
          "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
        ],
        [
          "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
          "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
        ],
        [
          "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
          "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
        ],
        [
          "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
          "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
        ],
        [
          "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
          "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
        ],
        [
          "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
          "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
        ],
        [
          "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
          "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
        ],
        [
          "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
          "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
        ],
        [
          "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
          "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
        ],
        [
          "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
          "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
        ],
        [
          "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
          "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
        ],
        [
          "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
          "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
        ],
        [
          "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
          "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
        ],
        [
          "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
          "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
        ],
        [
          "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
          "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
        ],
        [
          "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
          "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
        ],
        [
          "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
          "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
        ],
        [
          "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
          "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
        ],
        [
          "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
          "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
        ],
        [
          "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
          "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
        ],
        [
          "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
          "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
        ],
        [
          "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
          "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
        ],
        [
          "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
          "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
        ],
        [
          "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
          "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
        ],
        [
          "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
          "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
        ],
        [
          "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
          "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
        ],
        [
          "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
          "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
        ],
        [
          "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
          "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
        ],
        [
          "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
          "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
        ],
        [
          "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
          "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
        ],
        [
          "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
          "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
        ]
      ]
    },
    naf: {
      wnd: 7,
      points: [
        [
          "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
          "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
        ],
        [
          "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
          "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
        ],
        [
          "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
          "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
        ],
        [
          "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
          "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
        ],
        [
          "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
          "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
        ],
        [
          "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
          "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
        ],
        [
          "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
          "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
        ],
        [
          "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
          "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
        ],
        [
          "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
          "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
        ],
        [
          "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
          "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
        ],
        [
          "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
          "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
        ],
        [
          "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
          "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
        ],
        [
          "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
          "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
        ],
        [
          "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
          "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
        ],
        [
          "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
          "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
        ],
        [
          "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
          "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
        ],
        [
          "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
          "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
        ],
        [
          "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
          "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
        ],
        [
          "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
          "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
        ],
        [
          "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
          "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
        ],
        [
          "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
          "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
        ],
        [
          "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
          "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
        ],
        [
          "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
          "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
        ],
        [
          "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
          "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
        ],
        [
          "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
          "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
        ],
        [
          "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
          "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
        ],
        [
          "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
          "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
        ],
        [
          "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
          "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
        ],
        [
          "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
          "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
        ],
        [
          "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
          "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
        ],
        [
          "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
          "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
        ],
        [
          "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
          "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
        ],
        [
          "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
          "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
        ],
        [
          "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
          "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
        ],
        [
          "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
          "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
        ],
        [
          "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
          "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
        ],
        [
          "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
          "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
        ],
        [
          "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
          "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
        ],
        [
          "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
          "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
        ],
        [
          "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
          "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
        ],
        [
          "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
          "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
        ],
        [
          "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
          "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
        ],
        [
          "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
          "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
        ],
        [
          "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
          "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
        ],
        [
          "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
          "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
        ],
        [
          "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
          "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
        ],
        [
          "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
          "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
        ],
        [
          "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
          "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
        ],
        [
          "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
          "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
        ],
        [
          "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
          "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
        ],
        [
          "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
          "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
        ],
        [
          "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
          "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
        ],
        [
          "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
          "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
        ],
        [
          "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
          "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
        ],
        [
          "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
          "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
        ],
        [
          "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
          "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
        ],
        [
          "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
          "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
        ],
        [
          "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
          "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
        ],
        [
          "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
          "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
        ],
        [
          "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
          "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
        ],
        [
          "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
          "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
        ],
        [
          "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
          "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
        ],
        [
          "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
          "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
        ],
        [
          "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
          "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
        ],
        [
          "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
          "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
        ],
        [
          "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
          "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
        ],
        [
          "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
          "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
        ],
        [
          "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
          "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
        ],
        [
          "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
          "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
        ],
        [
          "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
          "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
        ],
        [
          "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
          "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
        ],
        [
          "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
          "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
        ],
        [
          "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
          "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
        ],
        [
          "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
          "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
        ],
        [
          "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
          "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
        ],
        [
          "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
          "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
        ],
        [
          "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
          "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
        ],
        [
          "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
          "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
        ],
        [
          "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
          "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
        ],
        [
          "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
          "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
        ],
        [
          "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
          "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
        ],
        [
          "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
          "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
        ],
        [
          "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
          "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
        ],
        [
          "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
          "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
        ],
        [
          "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
          "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
        ],
        [
          "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
          "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
        ],
        [
          "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
          "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
        ],
        [
          "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
          "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
        ],
        [
          "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
          "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
        ],
        [
          "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
          "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
        ],
        [
          "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
          "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
        ],
        [
          "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
          "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
        ],
        [
          "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
          "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
        ],
        [
          "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
          "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
        ],
        [
          "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
          "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
        ],
        [
          "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
          "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
        ],
        [
          "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
          "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
        ],
        [
          "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
          "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
        ],
        [
          "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
          "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
        ],
        [
          "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
          "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
        ],
        [
          "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
          "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
        ],
        [
          "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
          "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
        ],
        [
          "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
          "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
        ],
        [
          "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
          "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
        ],
        [
          "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
          "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
        ],
        [
          "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
          "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
        ],
        [
          "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
          "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
        ],
        [
          "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
          "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
        ],
        [
          "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
          "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
        ],
        [
          "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
          "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
        ],
        [
          "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
          "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
        ],
        [
          "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
          "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
        ],
        [
          "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
          "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
        ],
        [
          "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
          "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
        ],
        [
          "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
          "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
        ],
        [
          "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
          "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
        ],
        [
          "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
          "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
        ],
        [
          "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
          "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
        ],
        [
          "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
          "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
        ],
        [
          "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
          "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
        ],
        [
          "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
          "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
        ],
        [
          "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
          "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
        ],
        [
          "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
          "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
        ],
        [
          "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
          "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
        ],
        [
          "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
          "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
        ],
        [
          "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
          "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
        ],
        [
          "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
          "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
        ]
      ]
    }
  }), secp256k1;
}
(function(re) {
  var ne = re, ae = hash$2, ie = curve, le = utils$l, se = le.assert;
  function ce(me) {
    me.type === "short" ? this.curve = new ie.short(me) : me.type === "edwards" ? this.curve = new ie.edwards(me) : this.curve = new ie.mont(me), this.g = this.curve.g, this.n = this.curve.n, this.hash = me.hash, se(this.g.validate(), "Invalid curve"), se(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
  }
  ne.PresetCurve = ce;
  function ue(me, fe) {
    Object.defineProperty(ne, me, {
      configurable: !0,
      enumerable: !0,
      get: function() {
        var pe = new ce(fe);
        return Object.defineProperty(ne, me, {
          configurable: !0,
          enumerable: !0,
          value: pe
        }), pe;
      }
    });
  }
  ue("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: ae.sha256,
    gRed: !1,
    g: [
      "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
      "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
  }), ue("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: ae.sha256,
    gRed: !1,
    g: [
      "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
      "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
  }), ue("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: ae.sha256,
    gRed: !1,
    g: [
      "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
      "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
  }), ue("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: ae.sha384,
    gRed: !1,
    g: [
      "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
      "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
  }), ue("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: ae.sha512,
    gRed: !1,
    g: [
      "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
      "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
  }), ue("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: ae.sha256,
    gRed: !1,
    g: [
      "9"
    ]
  }), ue("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: ae.sha256,
    gRed: !1,
    g: [
      "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
      // 4/5
      "6666666666666666666666666666666666666666666666666666666666666658"
    ]
  });
  var de;
  try {
    de = requireSecp256k1();
  } catch {
    de = void 0;
  }
  ue("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: ae.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
      {
        a: "3086d221a7d46bcde86c90e49284eb15",
        b: "-e4437ed6010e88286f547fa90abfe4c3"
      },
      {
        a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
        b: "3086d221a7d46bcde86c90e49284eb15"
      }
    ],
    gRed: !1,
    g: [
      "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
      "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
      de
    ]
  });
})(curves$1);
var hash$1 = hash$2, utils$5 = utils$k, assert$5 = minimalisticAssert;
function HmacDRBG(re) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(re);
  this.hash = re.hash, this.predResist = !!re.predResist, this.outLen = this.hash.outSize, this.minEntropy = re.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
  var ne = utils$5.toArray(re.entropy, re.entropyEnc || "hex"), ae = utils$5.toArray(re.nonce, re.nonceEnc || "hex"), ie = utils$5.toArray(re.pers, re.persEnc || "hex");
  assert$5(
    ne.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._init(ne, ae, ie);
}
var hmacDrbg = HmacDRBG;
HmacDRBG.prototype._init = function(ne, ae, ie) {
  var le = ne.concat(ae).concat(ie);
  this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
  for (var se = 0; se < this.V.length; se++)
    this.K[se] = 0, this.V[se] = 1;
  this._update(le), this._reseed = 1, this.reseedInterval = 281474976710656;
};
HmacDRBG.prototype._hmac = function() {
  return new hash$1.hmac(this.hash, this.K);
};
HmacDRBG.prototype._update = function(ne) {
  var ae = this._hmac().update(this.V).update([0]);
  ne && (ae = ae.update(ne)), this.K = ae.digest(), this.V = this._hmac().update(this.V).digest(), ne && (this.K = this._hmac().update(this.V).update([1]).update(ne).digest(), this.V = this._hmac().update(this.V).digest());
};
HmacDRBG.prototype.reseed = function(ne, ae, ie, le) {
  typeof ae != "string" && (le = ie, ie = ae, ae = null), ne = utils$5.toArray(ne, ae), ie = utils$5.toArray(ie, le), assert$5(
    ne.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._update(ne.concat(ie || [])), this._reseed = 1;
};
HmacDRBG.prototype.generate = function(ne, ae, ie, le) {
  if (this._reseed > this.reseedInterval)
    throw new Error("Reseed is required");
  typeof ae != "string" && (le = ie, ie = ae, ae = null), ie && (ie = utils$5.toArray(ie, le || "hex"), this._update(ie));
  for (var se = []; se.length < ne; )
    this.V = this._hmac().update(this.V).digest(), se = se.concat(this.V);
  var ce = se.slice(0, ne);
  return this._update(ie), this._reseed++, utils$5.encode(ce, ae);
};
var BN$5 = bnExports$2, utils$4 = utils$l, assert$4 = utils$4.assert;
function KeyPair$2(re, ne) {
  this.ec = re, this.priv = null, this.pub = null, ne.priv && this._importPrivate(ne.priv, ne.privEnc), ne.pub && this._importPublic(ne.pub, ne.pubEnc);
}
var key$1 = KeyPair$2;
KeyPair$2.fromPublic = function(ne, ae, ie) {
  return ae instanceof KeyPair$2 ? ae : new KeyPair$2(ne, {
    pub: ae,
    pubEnc: ie
  });
};
KeyPair$2.fromPrivate = function(ne, ae, ie) {
  return ae instanceof KeyPair$2 ? ae : new KeyPair$2(ne, {
    priv: ae,
    privEnc: ie
  });
};
KeyPair$2.prototype.validate = function() {
  var ne = this.getPublic();
  return ne.isInfinity() ? { result: !1, reason: "Invalid public key" } : ne.validate() ? ne.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
};
KeyPair$2.prototype.getPublic = function(ne, ae) {
  return typeof ne == "string" && (ae = ne, ne = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), ae ? this.pub.encode(ae, ne) : this.pub;
};
KeyPair$2.prototype.getPrivate = function(ne) {
  return ne === "hex" ? this.priv.toString(16, 2) : this.priv;
};
KeyPair$2.prototype._importPrivate = function(ne, ae) {
  this.priv = new BN$5(ne, ae || 16), this.priv = this.priv.umod(this.ec.curve.n);
};
KeyPair$2.prototype._importPublic = function(ne, ae) {
  if (ne.x || ne.y) {
    this.ec.curve.type === "mont" ? assert$4(ne.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && assert$4(ne.x && ne.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(ne.x, ne.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(ne, ae);
};
KeyPair$2.prototype.derive = function(ne) {
  return ne.validate() || assert$4(ne.validate(), "public point not validated"), ne.mul(this.priv).getX();
};
KeyPair$2.prototype.sign = function(ne, ae, ie) {
  return this.ec.sign(ne, this, ae, ie);
};
KeyPair$2.prototype.verify = function(ne, ae, ie) {
  return this.ec.verify(ne, ae, this, void 0, ie);
};
KeyPair$2.prototype.inspect = function() {
  return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
var BN$4 = bnExports$2, utils$3 = utils$l, assert$3 = utils$3.assert;
function Signature$2(re, ne) {
  if (re instanceof Signature$2)
    return re;
  this._importDER(re, ne) || (assert$3(re.r && re.s, "Signature without r or s"), this.r = new BN$4(re.r, 16), this.s = new BN$4(re.s, 16), re.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = re.recoveryParam);
}
var signature$1 = Signature$2;
function Position() {
  this.place = 0;
}
function getLength(re, ne) {
  var ae = re[ne.place++];
  if (!(ae & 128))
    return ae;
  var ie = ae & 15;
  if (ie === 0 || ie > 4 || re[ne.place] === 0)
    return !1;
  for (var le = 0, se = 0, ce = ne.place; se < ie; se++, ce++)
    le <<= 8, le |= re[ce], le >>>= 0;
  return le <= 127 ? !1 : (ne.place = ce, le);
}
function rmPadding(re) {
  for (var ne = 0, ae = re.length - 1; !re[ne] && !(re[ne + 1] & 128) && ne < ae; )
    ne++;
  return ne === 0 ? re : re.slice(ne);
}
Signature$2.prototype._importDER = function(ne, ae) {
  ne = utils$3.toArray(ne, ae);
  var ie = new Position();
  if (ne[ie.place++] !== 48)
    return !1;
  var le = getLength(ne, ie);
  if (le === !1 || le + ie.place !== ne.length || ne[ie.place++] !== 2)
    return !1;
  var se = getLength(ne, ie);
  if (se === !1 || ne[ie.place] & 128)
    return !1;
  var ce = ne.slice(ie.place, se + ie.place);
  if (ie.place += se, ne[ie.place++] !== 2)
    return !1;
  var ue = getLength(ne, ie);
  if (ue === !1 || ne.length !== ue + ie.place || ne[ie.place] & 128)
    return !1;
  var de = ne.slice(ie.place, ue + ie.place);
  if (ce[0] === 0)
    if (ce[1] & 128)
      ce = ce.slice(1);
    else
      return !1;
  if (de[0] === 0)
    if (de[1] & 128)
      de = de.slice(1);
    else
      return !1;
  return this.r = new BN$4(ce), this.s = new BN$4(de), this.recoveryParam = null, !0;
};
function constructLength(re, ne) {
  if (ne < 128) {
    re.push(ne);
    return;
  }
  var ae = 1 + (Math.log(ne) / Math.LN2 >>> 3);
  for (re.push(ae | 128); --ae; )
    re.push(ne >>> (ae << 3) & 255);
  re.push(ne);
}
Signature$2.prototype.toDER = function(ne) {
  var ae = this.r.toArray(), ie = this.s.toArray();
  for (ae[0] & 128 && (ae = [0].concat(ae)), ie[0] & 128 && (ie = [0].concat(ie)), ae = rmPadding(ae), ie = rmPadding(ie); !ie[0] && !(ie[1] & 128); )
    ie = ie.slice(1);
  var le = [2];
  constructLength(le, ae.length), le = le.concat(ae), le.push(2), constructLength(le, ie.length);
  var se = le.concat(ie), ce = [48];
  return constructLength(ce, se.length), ce = ce.concat(se), utils$3.encode(ce, ne);
};
var ec, hasRequiredEc;
function requireEc() {
  if (hasRequiredEc) return ec;
  hasRequiredEc = 1;
  var re = bnExports$2, ne = hmacDrbg, ae = utils$l, ie = curves$1, le = requireBrorand(), se = ae.assert, ce = key$1, ue = signature$1;
  function de(me) {
    if (!(this instanceof de))
      return new de(me);
    typeof me == "string" && (se(
      Object.prototype.hasOwnProperty.call(ie, me),
      "Unknown curve " + me
    ), me = ie[me]), me instanceof ie.PresetCurve && (me = { curve: me }), this.curve = me.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = me.curve.g, this.g.precompute(me.curve.n.bitLength() + 1), this.hash = me.hash || me.curve.hash;
  }
  return ec = de, de.prototype.keyPair = function(fe) {
    return new ce(this, fe);
  }, de.prototype.keyFromPrivate = function(fe, pe) {
    return ce.fromPrivate(this, fe, pe);
  }, de.prototype.keyFromPublic = function(fe, pe) {
    return ce.fromPublic(this, fe, pe);
  }, de.prototype.genKeyPair = function(fe) {
    fe || (fe = {});
    for (var pe = new ne({
      hash: this.hash,
      pers: fe.pers,
      persEnc: fe.persEnc || "utf8",
      entropy: fe.entropy || le(this.hash.hmacStrength),
      entropyEnc: fe.entropy && fe.entropyEnc || "utf8",
      nonce: this.n.toArray()
    }), ge = this.n.byteLength(), be = this.n.sub(new re(2)); ; ) {
      var Se = new re(pe.generate(ge));
      if (!(Se.cmp(be) > 0))
        return Se.iaddn(1), this.keyFromPrivate(Se);
    }
  }, de.prototype._truncateToN = function(fe, pe, ge) {
    var be;
    if (re.isBN(fe) || typeof fe == "number")
      fe = new re(fe, 16), be = fe.byteLength();
    else if (typeof fe == "object")
      be = fe.length, fe = new re(fe, 16);
    else {
      var Se = fe.toString();
      be = Se.length + 1 >>> 1, fe = new re(Se, 16);
    }
    typeof ge != "number" && (ge = be * 8);
    var Pe = ge - this.n.bitLength();
    return Pe > 0 && (fe = fe.ushrn(Pe)), !pe && fe.cmp(this.n) >= 0 ? fe.sub(this.n) : fe;
  }, de.prototype.sign = function(fe, pe, ge, be) {
    typeof ge == "object" && (be = ge, ge = null), be || (be = {}), pe = this.keyFromPrivate(pe, ge), fe = this._truncateToN(fe, !1, be.msgBitLength);
    for (var Se = this.n.byteLength(), Pe = pe.getPrivate().toArray("be", Se), Ee = fe.toArray("be", Se), Ve = new ne({
      hash: this.hash,
      entropy: Pe,
      nonce: Ee,
      pers: be.pers,
      persEnc: be.persEnc || "utf8"
    }), Ae = this.n.sub(new re(1)), Oe = 0; ; Oe++) {
      var Ne = be.k ? be.k(Oe) : new re(Ve.generate(this.n.byteLength()));
      if (Ne = this._truncateToN(Ne, !0), !(Ne.cmpn(1) <= 0 || Ne.cmp(Ae) >= 0)) {
        var He = this.g.mul(Ne);
        if (!He.isInfinity()) {
          var Ue = He.getX(), Ze = Ue.umod(this.n);
          if (Ze.cmpn(0) !== 0) {
            var Fe = Ne.invm(this.n).mul(Ze.mul(pe.getPrivate()).iadd(fe));
            if (Fe = Fe.umod(this.n), Fe.cmpn(0) !== 0) {
              var Ke = (He.getY().isOdd() ? 1 : 0) | (Ue.cmp(Ze) !== 0 ? 2 : 0);
              return be.canonical && Fe.cmp(this.nh) > 0 && (Fe = this.n.sub(Fe), Ke ^= 1), new ue({ r: Ze, s: Fe, recoveryParam: Ke });
            }
          }
        }
      }
    }
  }, de.prototype.verify = function(fe, pe, ge, be, Se) {
    Se || (Se = {}), fe = this._truncateToN(fe, !1, Se.msgBitLength), ge = this.keyFromPublic(ge, be), pe = new ue(pe, "hex");
    var Pe = pe.r, Ee = pe.s;
    if (Pe.cmpn(1) < 0 || Pe.cmp(this.n) >= 0 || Ee.cmpn(1) < 0 || Ee.cmp(this.n) >= 0)
      return !1;
    var Ve = Ee.invm(this.n), Ae = Ve.mul(fe).umod(this.n), Oe = Ve.mul(Pe).umod(this.n), Ne;
    return this.curve._maxwellTrick ? (Ne = this.g.jmulAdd(Ae, ge.getPublic(), Oe), Ne.isInfinity() ? !1 : Ne.eqXToP(Pe)) : (Ne = this.g.mulAdd(Ae, ge.getPublic(), Oe), Ne.isInfinity() ? !1 : Ne.getX().umod(this.n).cmp(Pe) === 0);
  }, de.prototype.recoverPubKey = function(me, fe, pe, ge) {
    se((3 & pe) === pe, "The recovery param is more than two bits"), fe = new ue(fe, ge);
    var be = this.n, Se = new re(me), Pe = fe.r, Ee = fe.s, Ve = pe & 1, Ae = pe >> 1;
    if (Pe.cmp(this.curve.p.umod(this.curve.n)) >= 0 && Ae)
      throw new Error("Unable to find sencond key candinate");
    Ae ? Pe = this.curve.pointFromX(Pe.add(this.curve.n), Ve) : Pe = this.curve.pointFromX(Pe, Ve);
    var Oe = fe.r.invm(be), Ne = be.sub(Se).mul(Oe).umod(be), He = Ee.mul(Oe).umod(be);
    return this.g.mulAdd(Ne, Pe, He);
  }, de.prototype.getKeyRecoveryParam = function(me, fe, pe, ge) {
    if (fe = new ue(fe, ge), fe.recoveryParam !== null)
      return fe.recoveryParam;
    for (var be = 0; be < 4; be++) {
      var Se;
      try {
        Se = this.recoverPubKey(me, fe, be);
      } catch {
        continue;
      }
      if (Se.eq(pe))
        return be;
    }
    throw new Error("Unable to find valid recovery factor");
  }, ec;
}
var utils$2 = utils$l, assert$2 = utils$2.assert, parseBytes$2 = utils$2.parseBytes, cachedProperty$1 = utils$2.cachedProperty;
function KeyPair$1(re, ne) {
  this.eddsa = re, this._secret = parseBytes$2(ne.secret), re.isPoint(ne.pub) ? this._pub = ne.pub : this._pubBytes = parseBytes$2(ne.pub);
}
KeyPair$1.fromPublic = function(ne, ae) {
  return ae instanceof KeyPair$1 ? ae : new KeyPair$1(ne, { pub: ae });
};
KeyPair$1.fromSecret = function(ne, ae) {
  return ae instanceof KeyPair$1 ? ae : new KeyPair$1(ne, { secret: ae });
};
KeyPair$1.prototype.secret = function() {
  return this._secret;
};
cachedProperty$1(KeyPair$1, "pubBytes", function() {
  return this.eddsa.encodePoint(this.pub());
});
cachedProperty$1(KeyPair$1, "pub", function() {
  return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
});
cachedProperty$1(KeyPair$1, "privBytes", function() {
  var ne = this.eddsa, ae = this.hash(), ie = ne.encodingLength - 1, le = ae.slice(0, ne.encodingLength);
  return le[0] &= 248, le[ie] &= 127, le[ie] |= 64, le;
});
cachedProperty$1(KeyPair$1, "priv", function() {
  return this.eddsa.decodeInt(this.privBytes());
});
cachedProperty$1(KeyPair$1, "hash", function() {
  return this.eddsa.hash().update(this.secret()).digest();
});
cachedProperty$1(KeyPair$1, "messagePrefix", function() {
  return this.hash().slice(this.eddsa.encodingLength);
});
KeyPair$1.prototype.sign = function(ne) {
  return assert$2(this._secret, "KeyPair can only verify"), this.eddsa.sign(ne, this);
};
KeyPair$1.prototype.verify = function(ne, ae) {
  return this.eddsa.verify(ne, ae, this);
};
KeyPair$1.prototype.getSecret = function(ne) {
  return assert$2(this._secret, "KeyPair is public only"), utils$2.encode(this.secret(), ne);
};
KeyPair$1.prototype.getPublic = function(ne) {
  return utils$2.encode(this.pubBytes(), ne);
};
var key = KeyPair$1, BN$3 = bnExports$2, utils$1 = utils$l, assert$1 = utils$1.assert, cachedProperty = utils$1.cachedProperty, parseBytes$1 = utils$1.parseBytes;
function Signature$1(re, ne) {
  this.eddsa = re, typeof ne != "object" && (ne = parseBytes$1(ne)), Array.isArray(ne) && (assert$1(ne.length === re.encodingLength * 2, "Signature has invalid size"), ne = {
    R: ne.slice(0, re.encodingLength),
    S: ne.slice(re.encodingLength)
  }), assert$1(ne.R && ne.S, "Signature without R or S"), re.isPoint(ne.R) && (this._R = ne.R), ne.S instanceof BN$3 && (this._S = ne.S), this._Rencoded = Array.isArray(ne.R) ? ne.R : ne.Rencoded, this._Sencoded = Array.isArray(ne.S) ? ne.S : ne.Sencoded;
}
cachedProperty(Signature$1, "S", function() {
  return this.eddsa.decodeInt(this.Sencoded());
});
cachedProperty(Signature$1, "R", function() {
  return this.eddsa.decodePoint(this.Rencoded());
});
cachedProperty(Signature$1, "Rencoded", function() {
  return this.eddsa.encodePoint(this.R());
});
cachedProperty(Signature$1, "Sencoded", function() {
  return this.eddsa.encodeInt(this.S());
});
Signature$1.prototype.toBytes = function() {
  return this.Rencoded().concat(this.Sencoded());
};
Signature$1.prototype.toHex = function() {
  return utils$1.encode(this.toBytes(), "hex").toUpperCase();
};
var signature = Signature$1, hash = hash$2, curves = curves$1, utils = utils$l, assert = utils.assert, parseBytes = utils.parseBytes, KeyPair = key, Signature = signature;
function EDDSA(re) {
  if (assert(re === "ed25519", "only tested with ed25519 so far"), !(this instanceof EDDSA))
    return new EDDSA(re);
  re = curves[re].curve, this.curve = re, this.g = re.g, this.g.precompute(re.n.bitLength() + 1), this.pointClass = re.point().constructor, this.encodingLength = Math.ceil(re.n.bitLength() / 8), this.hash = hash.sha512;
}
var eddsa = EDDSA;
EDDSA.prototype.sign = function(ne, ae) {
  ne = parseBytes(ne);
  var ie = this.keyFromSecret(ae), le = this.hashInt(ie.messagePrefix(), ne), se = this.g.mul(le), ce = this.encodePoint(se), ue = this.hashInt(ce, ie.pubBytes(), ne).mul(ie.priv()), de = le.add(ue).umod(this.curve.n);
  return this.makeSignature({ R: se, S: de, Rencoded: ce });
};
EDDSA.prototype.verify = function(ne, ae, ie) {
  if (ne = parseBytes(ne), ae = this.makeSignature(ae), ae.S().gte(ae.eddsa.curve.n) || ae.S().isNeg())
    return !1;
  var le = this.keyFromPublic(ie), se = this.hashInt(ae.Rencoded(), le.pubBytes(), ne), ce = this.g.mul(ae.S()), ue = ae.R().add(le.pub().mul(se));
  return ue.eq(ce);
};
EDDSA.prototype.hashInt = function() {
  for (var ne = this.hash(), ae = 0; ae < arguments.length; ae++)
    ne.update(arguments[ae]);
  return utils.intFromLE(ne.digest()).umod(this.curve.n);
};
EDDSA.prototype.keyFromPublic = function(ne) {
  return KeyPair.fromPublic(this, ne);
};
EDDSA.prototype.keyFromSecret = function(ne) {
  return KeyPair.fromSecret(this, ne);
};
EDDSA.prototype.makeSignature = function(ne) {
  return ne instanceof Signature ? ne : new Signature(this, ne);
};
EDDSA.prototype.encodePoint = function(ne) {
  var ae = ne.getY().toArray("le", this.encodingLength);
  return ae[this.encodingLength - 1] |= ne.getX().isOdd() ? 128 : 0, ae;
};
EDDSA.prototype.decodePoint = function(ne) {
  ne = utils.parseBytes(ne);
  var ae = ne.length - 1, ie = ne.slice(0, ae).concat(ne[ae] & -129), le = (ne[ae] & 128) !== 0, se = utils.intFromLE(ie);
  return this.curve.pointFromY(se, le);
};
EDDSA.prototype.encodeInt = function(ne) {
  return ne.toArray("le", this.encodingLength);
};
EDDSA.prototype.decodeInt = function(ne) {
  return utils.intFromLE(ne);
};
EDDSA.prototype.isPoint = function(ne) {
  return ne instanceof this.pointClass;
};
var hasRequiredElliptic;
function requireElliptic() {
  return hasRequiredElliptic || (hasRequiredElliptic = 1, function(re) {
    var ne = re;
    ne.version = require$$0.version, ne.utils = utils$l, ne.rand = requireBrorand(), ne.curve = curve, ne.curves = curves$1, ne.ec = requireEc(), ne.eddsa = eddsa;
  }(elliptic)), elliptic;
}
var bn = { exports: {} };
bn.exports;
(function(re) {
  (function(ne, ae) {
    function ie(_e, he) {
      if (!_e) throw new Error(he || "Assertion failed");
    }
    function le(_e, he) {
      _e.super_ = he;
      var ve = function() {
      };
      ve.prototype = he.prototype, _e.prototype = new ve(), _e.prototype.constructor = _e;
    }
    function se(_e, he, ve) {
      if (se.isBN(_e))
        return _e;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, _e !== null && ((he === "le" || he === "be") && (ve = he, he = 10), this._init(_e || 0, he || 10, ve || "be"));
    }
    typeof ne == "object" ? ne.exports = se : ae.BN = se, se.BN = se, se.wordSize = 26;
    var ce;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? ce = window.Buffer : ce = require$$1$2.Buffer;
    } catch {
    }
    se.isBN = function(he) {
      return he instanceof se ? !0 : he !== null && typeof he == "object" && he.constructor.wordSize === se.wordSize && Array.isArray(he.words);
    }, se.max = function(he, ve) {
      return he.cmp(ve) > 0 ? he : ve;
    }, se.min = function(he, ve) {
      return he.cmp(ve) < 0 ? he : ve;
    }, se.prototype._init = function(he, ve, xe) {
      if (typeof he == "number")
        return this._initNumber(he, ve, xe);
      if (typeof he == "object")
        return this._initArray(he, ve, xe);
      ve === "hex" && (ve = 16), ie(ve === (ve | 0) && ve >= 2 && ve <= 36), he = he.toString().replace(/\s+/g, "");
      var $e = 0;
      he[0] === "-" && ($e++, this.negative = 1), $e < he.length && (ve === 16 ? this._parseHex(he, $e, xe) : (this._parseBase(he, ve, $e), xe === "le" && this._initArray(this.toArray(), ve, xe)));
    }, se.prototype._initNumber = function(he, ve, xe) {
      he < 0 && (this.negative = 1, he = -he), he < 67108864 ? (this.words = [he & 67108863], this.length = 1) : he < 4503599627370496 ? (this.words = [
        he & 67108863,
        he / 67108864 & 67108863
      ], this.length = 2) : (ie(he < 9007199254740992), this.words = [
        he & 67108863,
        he / 67108864 & 67108863,
        1
      ], this.length = 3), xe === "le" && this._initArray(this.toArray(), ve, xe);
    }, se.prototype._initArray = function(he, ve, xe) {
      if (ie(typeof he.length == "number"), he.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(he.length / 3), this.words = new Array(this.length);
      for (var $e = 0; $e < this.length; $e++)
        this.words[$e] = 0;
      var Te, Ie, we = 0;
      if (xe === "be")
        for ($e = he.length - 1, Te = 0; $e >= 0; $e -= 3)
          Ie = he[$e] | he[$e - 1] << 8 | he[$e - 2] << 16, this.words[Te] |= Ie << we & 67108863, this.words[Te + 1] = Ie >>> 26 - we & 67108863, we += 24, we >= 26 && (we -= 26, Te++);
      else if (xe === "le")
        for ($e = 0, Te = 0; $e < he.length; $e += 3)
          Ie = he[$e] | he[$e + 1] << 8 | he[$e + 2] << 16, this.words[Te] |= Ie << we & 67108863, this.words[Te + 1] = Ie >>> 26 - we & 67108863, we += 24, we >= 26 && (we -= 26, Te++);
      return this._strip();
    };
    function ue(_e, he) {
      var ve = _e.charCodeAt(he);
      if (ve >= 48 && ve <= 57)
        return ve - 48;
      if (ve >= 65 && ve <= 70)
        return ve - 55;
      if (ve >= 97 && ve <= 102)
        return ve - 87;
      ie(!1, "Invalid character in " + _e);
    }
    function de(_e, he, ve) {
      var xe = ue(_e, ve);
      return ve - 1 >= he && (xe |= ue(_e, ve - 1) << 4), xe;
    }
    se.prototype._parseHex = function(he, ve, xe) {
      this.length = Math.ceil((he.length - ve) / 6), this.words = new Array(this.length);
      for (var $e = 0; $e < this.length; $e++)
        this.words[$e] = 0;
      var Te = 0, Ie = 0, we;
      if (xe === "be")
        for ($e = he.length - 1; $e >= ve; $e -= 2)
          we = de(he, ve, $e) << Te, this.words[Ie] |= we & 67108863, Te >= 18 ? (Te -= 18, Ie += 1, this.words[Ie] |= we >>> 26) : Te += 8;
      else {
        var ke = he.length - ve;
        for ($e = ke % 2 === 0 ? ve + 1 : ve; $e < he.length; $e += 2)
          we = de(he, ve, $e) << Te, this.words[Ie] |= we & 67108863, Te >= 18 ? (Te -= 18, Ie += 1, this.words[Ie] |= we >>> 26) : Te += 8;
      }
      this._strip();
    };
    function me(_e, he, ve, xe) {
      for (var $e = 0, Te = 0, Ie = Math.min(_e.length, ve), we = he; we < Ie; we++) {
        var ke = _e.charCodeAt(we) - 48;
        $e *= xe, ke >= 49 ? Te = ke - 49 + 10 : ke >= 17 ? Te = ke - 17 + 10 : Te = ke, ie(ke >= 0 && Te < xe, "Invalid character"), $e += Te;
      }
      return $e;
    }
    se.prototype._parseBase = function(he, ve, xe) {
      this.words = [0], this.length = 1;
      for (var $e = 0, Te = 1; Te <= 67108863; Te *= ve)
        $e++;
      $e--, Te = Te / ve | 0;
      for (var Ie = he.length - xe, we = Ie % $e, ke = Math.min(Ie, Ie - we) + xe, ye = 0, Be = xe; Be < ke; Be += $e)
        ye = me(he, Be, Be + $e, ve), this.imuln(Te), this.words[0] + ye < 67108864 ? this.words[0] += ye : this._iaddn(ye);
      if (we !== 0) {
        var Xe = 1;
        for (ye = me(he, Be, he.length, ve), Be = 0; Be < we; Be++)
          Xe *= ve;
        this.imuln(Xe), this.words[0] + ye < 67108864 ? this.words[0] += ye : this._iaddn(ye);
      }
      this._strip();
    }, se.prototype.copy = function(he) {
      he.words = new Array(this.length);
      for (var ve = 0; ve < this.length; ve++)
        he.words[ve] = this.words[ve];
      he.length = this.length, he.negative = this.negative, he.red = this.red;
    };
    function fe(_e, he) {
      _e.words = he.words, _e.length = he.length, _e.negative = he.negative, _e.red = he.red;
    }
    if (se.prototype._move = function(he) {
      fe(he, this);
    }, se.prototype.clone = function() {
      var he = new se(null);
      return this.copy(he), he;
    }, se.prototype._expand = function(he) {
      for (; this.length < he; )
        this.words[this.length++] = 0;
      return this;
    }, se.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, se.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        se.prototype[Symbol.for("nodejs.util.inspect.custom")] = pe;
      } catch {
        se.prototype.inspect = pe;
      }
    else
      se.prototype.inspect = pe;
    function pe() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var ge = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], be = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], Se = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    se.prototype.toString = function(he, ve) {
      he = he || 10, ve = ve | 0 || 1;
      var xe;
      if (he === 16 || he === "hex") {
        xe = "";
        for (var $e = 0, Te = 0, Ie = 0; Ie < this.length; Ie++) {
          var we = this.words[Ie], ke = ((we << $e | Te) & 16777215).toString(16);
          Te = we >>> 24 - $e & 16777215, $e += 2, $e >= 26 && ($e -= 26, Ie--), Te !== 0 || Ie !== this.length - 1 ? xe = ge[6 - ke.length] + ke + xe : xe = ke + xe;
        }
        for (Te !== 0 && (xe = Te.toString(16) + xe); xe.length % ve !== 0; )
          xe = "0" + xe;
        return this.negative !== 0 && (xe = "-" + xe), xe;
      }
      if (he === (he | 0) && he >= 2 && he <= 36) {
        var ye = be[he], Be = Se[he];
        xe = "";
        var Xe = this.clone();
        for (Xe.negative = 0; !Xe.isZero(); ) {
          var et = Xe.modrn(Be).toString(he);
          Xe = Xe.idivn(Be), Xe.isZero() ? xe = et + xe : xe = ge[ye - et.length] + et + xe;
        }
        for (this.isZero() && (xe = "0" + xe); xe.length % ve !== 0; )
          xe = "0" + xe;
        return this.negative !== 0 && (xe = "-" + xe), xe;
      }
      ie(!1, "Base should be between 2 and 36");
    }, se.prototype.toNumber = function() {
      var he = this.words[0];
      return this.length === 2 ? he += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? he += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && ie(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -he : he;
    }, se.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, ce && (se.prototype.toBuffer = function(he, ve) {
      return this.toArrayLike(ce, he, ve);
    }), se.prototype.toArray = function(he, ve) {
      return this.toArrayLike(Array, he, ve);
    };
    var Pe = function(he, ve) {
      return he.allocUnsafe ? he.allocUnsafe(ve) : new he(ve);
    };
    se.prototype.toArrayLike = function(he, ve, xe) {
      this._strip();
      var $e = this.byteLength(), Te = xe || Math.max(1, $e);
      ie($e <= Te, "byte array longer than desired length"), ie(Te > 0, "Requested array length <= 0");
      var Ie = Pe(he, Te), we = ve === "le" ? "LE" : "BE";
      return this["_toArrayLike" + we](Ie, $e), Ie;
    }, se.prototype._toArrayLikeLE = function(he, ve) {
      for (var xe = 0, $e = 0, Te = 0, Ie = 0; Te < this.length; Te++) {
        var we = this.words[Te] << Ie | $e;
        he[xe++] = we & 255, xe < he.length && (he[xe++] = we >> 8 & 255), xe < he.length && (he[xe++] = we >> 16 & 255), Ie === 6 ? (xe < he.length && (he[xe++] = we >> 24 & 255), $e = 0, Ie = 0) : ($e = we >>> 24, Ie += 2);
      }
      if (xe < he.length)
        for (he[xe++] = $e; xe < he.length; )
          he[xe++] = 0;
    }, se.prototype._toArrayLikeBE = function(he, ve) {
      for (var xe = he.length - 1, $e = 0, Te = 0, Ie = 0; Te < this.length; Te++) {
        var we = this.words[Te] << Ie | $e;
        he[xe--] = we & 255, xe >= 0 && (he[xe--] = we >> 8 & 255), xe >= 0 && (he[xe--] = we >> 16 & 255), Ie === 6 ? (xe >= 0 && (he[xe--] = we >> 24 & 255), $e = 0, Ie = 0) : ($e = we >>> 24, Ie += 2);
      }
      if (xe >= 0)
        for (he[xe--] = $e; xe >= 0; )
          he[xe--] = 0;
    }, Math.clz32 ? se.prototype._countBits = function(he) {
      return 32 - Math.clz32(he);
    } : se.prototype._countBits = function(he) {
      var ve = he, xe = 0;
      return ve >= 4096 && (xe += 13, ve >>>= 13), ve >= 64 && (xe += 7, ve >>>= 7), ve >= 8 && (xe += 4, ve >>>= 4), ve >= 2 && (xe += 2, ve >>>= 2), xe + ve;
    }, se.prototype._zeroBits = function(he) {
      if (he === 0) return 26;
      var ve = he, xe = 0;
      return ve & 8191 || (xe += 13, ve >>>= 13), ve & 127 || (xe += 7, ve >>>= 7), ve & 15 || (xe += 4, ve >>>= 4), ve & 3 || (xe += 2, ve >>>= 2), ve & 1 || xe++, xe;
    }, se.prototype.bitLength = function() {
      var he = this.words[this.length - 1], ve = this._countBits(he);
      return (this.length - 1) * 26 + ve;
    };
    function Ee(_e) {
      for (var he = new Array(_e.bitLength()), ve = 0; ve < he.length; ve++) {
        var xe = ve / 26 | 0, $e = ve % 26;
        he[ve] = _e.words[xe] >>> $e & 1;
      }
      return he;
    }
    se.prototype.zeroBits = function() {
      if (this.isZero()) return 0;
      for (var he = 0, ve = 0; ve < this.length; ve++) {
        var xe = this._zeroBits(this.words[ve]);
        if (he += xe, xe !== 26) break;
      }
      return he;
    }, se.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, se.prototype.toTwos = function(he) {
      return this.negative !== 0 ? this.abs().inotn(he).iaddn(1) : this.clone();
    }, se.prototype.fromTwos = function(he) {
      return this.testn(he - 1) ? this.notn(he).iaddn(1).ineg() : this.clone();
    }, se.prototype.isNeg = function() {
      return this.negative !== 0;
    }, se.prototype.neg = function() {
      return this.clone().ineg();
    }, se.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, se.prototype.iuor = function(he) {
      for (; this.length < he.length; )
        this.words[this.length++] = 0;
      for (var ve = 0; ve < he.length; ve++)
        this.words[ve] = this.words[ve] | he.words[ve];
      return this._strip();
    }, se.prototype.ior = function(he) {
      return ie((this.negative | he.negative) === 0), this.iuor(he);
    }, se.prototype.or = function(he) {
      return this.length > he.length ? this.clone().ior(he) : he.clone().ior(this);
    }, se.prototype.uor = function(he) {
      return this.length > he.length ? this.clone().iuor(he) : he.clone().iuor(this);
    }, se.prototype.iuand = function(he) {
      var ve;
      this.length > he.length ? ve = he : ve = this;
      for (var xe = 0; xe < ve.length; xe++)
        this.words[xe] = this.words[xe] & he.words[xe];
      return this.length = ve.length, this._strip();
    }, se.prototype.iand = function(he) {
      return ie((this.negative | he.negative) === 0), this.iuand(he);
    }, se.prototype.and = function(he) {
      return this.length > he.length ? this.clone().iand(he) : he.clone().iand(this);
    }, se.prototype.uand = function(he) {
      return this.length > he.length ? this.clone().iuand(he) : he.clone().iuand(this);
    }, se.prototype.iuxor = function(he) {
      var ve, xe;
      this.length > he.length ? (ve = this, xe = he) : (ve = he, xe = this);
      for (var $e = 0; $e < xe.length; $e++)
        this.words[$e] = ve.words[$e] ^ xe.words[$e];
      if (this !== ve)
        for (; $e < ve.length; $e++)
          this.words[$e] = ve.words[$e];
      return this.length = ve.length, this._strip();
    }, se.prototype.ixor = function(he) {
      return ie((this.negative | he.negative) === 0), this.iuxor(he);
    }, se.prototype.xor = function(he) {
      return this.length > he.length ? this.clone().ixor(he) : he.clone().ixor(this);
    }, se.prototype.uxor = function(he) {
      return this.length > he.length ? this.clone().iuxor(he) : he.clone().iuxor(this);
    }, se.prototype.inotn = function(he) {
      ie(typeof he == "number" && he >= 0);
      var ve = Math.ceil(he / 26) | 0, xe = he % 26;
      this._expand(ve), xe > 0 && ve--;
      for (var $e = 0; $e < ve; $e++)
        this.words[$e] = ~this.words[$e] & 67108863;
      return xe > 0 && (this.words[$e] = ~this.words[$e] & 67108863 >> 26 - xe), this._strip();
    }, se.prototype.notn = function(he) {
      return this.clone().inotn(he);
    }, se.prototype.setn = function(he, ve) {
      ie(typeof he == "number" && he >= 0);
      var xe = he / 26 | 0, $e = he % 26;
      return this._expand(xe + 1), ve ? this.words[xe] = this.words[xe] | 1 << $e : this.words[xe] = this.words[xe] & ~(1 << $e), this._strip();
    }, se.prototype.iadd = function(he) {
      var ve;
      if (this.negative !== 0 && he.negative === 0)
        return this.negative = 0, ve = this.isub(he), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && he.negative !== 0)
        return he.negative = 0, ve = this.isub(he), he.negative = 1, ve._normSign();
      var xe, $e;
      this.length > he.length ? (xe = this, $e = he) : (xe = he, $e = this);
      for (var Te = 0, Ie = 0; Ie < $e.length; Ie++)
        ve = (xe.words[Ie] | 0) + ($e.words[Ie] | 0) + Te, this.words[Ie] = ve & 67108863, Te = ve >>> 26;
      for (; Te !== 0 && Ie < xe.length; Ie++)
        ve = (xe.words[Ie] | 0) + Te, this.words[Ie] = ve & 67108863, Te = ve >>> 26;
      if (this.length = xe.length, Te !== 0)
        this.words[this.length] = Te, this.length++;
      else if (xe !== this)
        for (; Ie < xe.length; Ie++)
          this.words[Ie] = xe.words[Ie];
      return this;
    }, se.prototype.add = function(he) {
      var ve;
      return he.negative !== 0 && this.negative === 0 ? (he.negative = 0, ve = this.sub(he), he.negative ^= 1, ve) : he.negative === 0 && this.negative !== 0 ? (this.negative = 0, ve = he.sub(this), this.negative = 1, ve) : this.length > he.length ? this.clone().iadd(he) : he.clone().iadd(this);
    }, se.prototype.isub = function(he) {
      if (he.negative !== 0) {
        he.negative = 0;
        var ve = this.iadd(he);
        return he.negative = 1, ve._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(he), this.negative = 1, this._normSign();
      var xe = this.cmp(he);
      if (xe === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var $e, Te;
      xe > 0 ? ($e = this, Te = he) : ($e = he, Te = this);
      for (var Ie = 0, we = 0; we < Te.length; we++)
        ve = ($e.words[we] | 0) - (Te.words[we] | 0) + Ie, Ie = ve >> 26, this.words[we] = ve & 67108863;
      for (; Ie !== 0 && we < $e.length; we++)
        ve = ($e.words[we] | 0) + Ie, Ie = ve >> 26, this.words[we] = ve & 67108863;
      if (Ie === 0 && we < $e.length && $e !== this)
        for (; we < $e.length; we++)
          this.words[we] = $e.words[we];
      return this.length = Math.max(this.length, we), $e !== this && (this.negative = 1), this._strip();
    }, se.prototype.sub = function(he) {
      return this.clone().isub(he);
    };
    function Ve(_e, he, ve) {
      ve.negative = he.negative ^ _e.negative;
      var xe = _e.length + he.length | 0;
      ve.length = xe, xe = xe - 1 | 0;
      var $e = _e.words[0] | 0, Te = he.words[0] | 0, Ie = $e * Te, we = Ie & 67108863, ke = Ie / 67108864 | 0;
      ve.words[0] = we;
      for (var ye = 1; ye < xe; ye++) {
        for (var Be = ke >>> 26, Xe = ke & 67108863, et = Math.min(ye, he.length - 1), Ye = Math.max(0, ye - _e.length + 1); Ye <= et; Ye++) {
          var De = ye - Ye | 0;
          $e = _e.words[De] | 0, Te = he.words[Ye] | 0, Ie = $e * Te + Xe, Be += Ie / 67108864 | 0, Xe = Ie & 67108863;
        }
        ve.words[ye] = Xe | 0, ke = Be | 0;
      }
      return ke !== 0 ? ve.words[ye] = ke | 0 : ve.length--, ve._strip();
    }
    var Ae = function(he, ve, xe) {
      var $e = he.words, Te = ve.words, Ie = xe.words, we = 0, ke, ye, Be, Xe = $e[0] | 0, et = Xe & 8191, Ye = Xe >>> 13, De = $e[1] | 0, je = De & 8191, rt = De >>> 13, at = $e[2] | 0, qe = at & 8191, We = at >>> 13, ze = $e[3] | 0, Ge = ze & 8191, nt = ze >>> 13, ot = $e[4] | 0, lt = ot & 8191, mt = ot >>> 13, dt = $e[5] | 0, gt = dt & 8191, bt = dt >>> 13, At = $e[6] | 0, wt = At & 8191, pt = At >>> 13, ut = $e[7] | 0, ht = ut & 8191, vt = ut >>> 13, xt = $e[8] | 0, Bt = xt & 8191, Je = xt >>> 13, Me = $e[9] | 0, Le = Me & 8191, Qe = Me >>> 13, it = Te[0] | 0, st = it & 8191, ct = it >>> 13, kt = Te[1] | 0, St = kt & 8191, yt = kt >>> 13, Nt = Te[2] | 0, _t = Nt & 8191, Ct = Nt >>> 13, Ut = Te[3] | 0, Ot = Ut & 8191, $t = Ut >>> 13, zt = Te[4] | 0, Dt = zt & 8191, Et = zt >>> 13, qt = Te[5] | 0, Lt = qt & 8191, Pt = qt >>> 13, Gt = Te[6] | 0, Ft = Gt & 8191, Vt = Gt >>> 13, Wt = Te[7] | 0, Ht = Wt & 8191, It = Wt >>> 13, Kt = Te[8] | 0, jt = Kt & 8191, Tt = Kt >>> 13, Yt = Te[9] | 0, Mt = Yt & 8191, Rt = Yt >>> 13;
      xe.negative = he.negative ^ ve.negative, xe.length = 19, ke = Math.imul(et, st), ye = Math.imul(et, ct), ye = ye + Math.imul(Ye, st) | 0, Be = Math.imul(Ye, ct);
      var Jt = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (Jt >>> 26) | 0, Jt &= 67108863, ke = Math.imul(je, st), ye = Math.imul(je, ct), ye = ye + Math.imul(rt, st) | 0, Be = Math.imul(rt, ct), ke = ke + Math.imul(et, St) | 0, ye = ye + Math.imul(et, yt) | 0, ye = ye + Math.imul(Ye, St) | 0, Be = Be + Math.imul(Ye, yt) | 0;
      var Xt = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (Xt >>> 26) | 0, Xt &= 67108863, ke = Math.imul(qe, st), ye = Math.imul(qe, ct), ye = ye + Math.imul(We, st) | 0, Be = Math.imul(We, ct), ke = ke + Math.imul(je, St) | 0, ye = ye + Math.imul(je, yt) | 0, ye = ye + Math.imul(rt, St) | 0, Be = Be + Math.imul(rt, yt) | 0, ke = ke + Math.imul(et, _t) | 0, ye = ye + Math.imul(et, Ct) | 0, ye = ye + Math.imul(Ye, _t) | 0, Be = Be + Math.imul(Ye, Ct) | 0;
      var Zt = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (Zt >>> 26) | 0, Zt &= 67108863, ke = Math.imul(Ge, st), ye = Math.imul(Ge, ct), ye = ye + Math.imul(nt, st) | 0, Be = Math.imul(nt, ct), ke = ke + Math.imul(qe, St) | 0, ye = ye + Math.imul(qe, yt) | 0, ye = ye + Math.imul(We, St) | 0, Be = Be + Math.imul(We, yt) | 0, ke = ke + Math.imul(je, _t) | 0, ye = ye + Math.imul(je, Ct) | 0, ye = ye + Math.imul(rt, _t) | 0, Be = Be + Math.imul(rt, Ct) | 0, ke = ke + Math.imul(et, Ot) | 0, ye = ye + Math.imul(et, $t) | 0, ye = ye + Math.imul(Ye, Ot) | 0, Be = Be + Math.imul(Ye, $t) | 0;
      var Qt = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (Qt >>> 26) | 0, Qt &= 67108863, ke = Math.imul(lt, st), ye = Math.imul(lt, ct), ye = ye + Math.imul(mt, st) | 0, Be = Math.imul(mt, ct), ke = ke + Math.imul(Ge, St) | 0, ye = ye + Math.imul(Ge, yt) | 0, ye = ye + Math.imul(nt, St) | 0, Be = Be + Math.imul(nt, yt) | 0, ke = ke + Math.imul(qe, _t) | 0, ye = ye + Math.imul(qe, Ct) | 0, ye = ye + Math.imul(We, _t) | 0, Be = Be + Math.imul(We, Ct) | 0, ke = ke + Math.imul(je, Ot) | 0, ye = ye + Math.imul(je, $t) | 0, ye = ye + Math.imul(rt, Ot) | 0, Be = Be + Math.imul(rt, $t) | 0, ke = ke + Math.imul(et, Dt) | 0, ye = ye + Math.imul(et, Et) | 0, ye = ye + Math.imul(Ye, Dt) | 0, Be = Be + Math.imul(Ye, Et) | 0;
      var er = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (er >>> 26) | 0, er &= 67108863, ke = Math.imul(gt, st), ye = Math.imul(gt, ct), ye = ye + Math.imul(bt, st) | 0, Be = Math.imul(bt, ct), ke = ke + Math.imul(lt, St) | 0, ye = ye + Math.imul(lt, yt) | 0, ye = ye + Math.imul(mt, St) | 0, Be = Be + Math.imul(mt, yt) | 0, ke = ke + Math.imul(Ge, _t) | 0, ye = ye + Math.imul(Ge, Ct) | 0, ye = ye + Math.imul(nt, _t) | 0, Be = Be + Math.imul(nt, Ct) | 0, ke = ke + Math.imul(qe, Ot) | 0, ye = ye + Math.imul(qe, $t) | 0, ye = ye + Math.imul(We, Ot) | 0, Be = Be + Math.imul(We, $t) | 0, ke = ke + Math.imul(je, Dt) | 0, ye = ye + Math.imul(je, Et) | 0, ye = ye + Math.imul(rt, Dt) | 0, Be = Be + Math.imul(rt, Et) | 0, ke = ke + Math.imul(et, Lt) | 0, ye = ye + Math.imul(et, Pt) | 0, ye = ye + Math.imul(Ye, Lt) | 0, Be = Be + Math.imul(Ye, Pt) | 0;
      var tr = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (tr >>> 26) | 0, tr &= 67108863, ke = Math.imul(wt, st), ye = Math.imul(wt, ct), ye = ye + Math.imul(pt, st) | 0, Be = Math.imul(pt, ct), ke = ke + Math.imul(gt, St) | 0, ye = ye + Math.imul(gt, yt) | 0, ye = ye + Math.imul(bt, St) | 0, Be = Be + Math.imul(bt, yt) | 0, ke = ke + Math.imul(lt, _t) | 0, ye = ye + Math.imul(lt, Ct) | 0, ye = ye + Math.imul(mt, _t) | 0, Be = Be + Math.imul(mt, Ct) | 0, ke = ke + Math.imul(Ge, Ot) | 0, ye = ye + Math.imul(Ge, $t) | 0, ye = ye + Math.imul(nt, Ot) | 0, Be = Be + Math.imul(nt, $t) | 0, ke = ke + Math.imul(qe, Dt) | 0, ye = ye + Math.imul(qe, Et) | 0, ye = ye + Math.imul(We, Dt) | 0, Be = Be + Math.imul(We, Et) | 0, ke = ke + Math.imul(je, Lt) | 0, ye = ye + Math.imul(je, Pt) | 0, ye = ye + Math.imul(rt, Lt) | 0, Be = Be + Math.imul(rt, Pt) | 0, ke = ke + Math.imul(et, Ft) | 0, ye = ye + Math.imul(et, Vt) | 0, ye = ye + Math.imul(Ye, Ft) | 0, Be = Be + Math.imul(Ye, Vt) | 0;
      var rr = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (rr >>> 26) | 0, rr &= 67108863, ke = Math.imul(ht, st), ye = Math.imul(ht, ct), ye = ye + Math.imul(vt, st) | 0, Be = Math.imul(vt, ct), ke = ke + Math.imul(wt, St) | 0, ye = ye + Math.imul(wt, yt) | 0, ye = ye + Math.imul(pt, St) | 0, Be = Be + Math.imul(pt, yt) | 0, ke = ke + Math.imul(gt, _t) | 0, ye = ye + Math.imul(gt, Ct) | 0, ye = ye + Math.imul(bt, _t) | 0, Be = Be + Math.imul(bt, Ct) | 0, ke = ke + Math.imul(lt, Ot) | 0, ye = ye + Math.imul(lt, $t) | 0, ye = ye + Math.imul(mt, Ot) | 0, Be = Be + Math.imul(mt, $t) | 0, ke = ke + Math.imul(Ge, Dt) | 0, ye = ye + Math.imul(Ge, Et) | 0, ye = ye + Math.imul(nt, Dt) | 0, Be = Be + Math.imul(nt, Et) | 0, ke = ke + Math.imul(qe, Lt) | 0, ye = ye + Math.imul(qe, Pt) | 0, ye = ye + Math.imul(We, Lt) | 0, Be = Be + Math.imul(We, Pt) | 0, ke = ke + Math.imul(je, Ft) | 0, ye = ye + Math.imul(je, Vt) | 0, ye = ye + Math.imul(rt, Ft) | 0, Be = Be + Math.imul(rt, Vt) | 0, ke = ke + Math.imul(et, Ht) | 0, ye = ye + Math.imul(et, It) | 0, ye = ye + Math.imul(Ye, Ht) | 0, Be = Be + Math.imul(Ye, It) | 0;
      var nr = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (nr >>> 26) | 0, nr &= 67108863, ke = Math.imul(Bt, st), ye = Math.imul(Bt, ct), ye = ye + Math.imul(Je, st) | 0, Be = Math.imul(Je, ct), ke = ke + Math.imul(ht, St) | 0, ye = ye + Math.imul(ht, yt) | 0, ye = ye + Math.imul(vt, St) | 0, Be = Be + Math.imul(vt, yt) | 0, ke = ke + Math.imul(wt, _t) | 0, ye = ye + Math.imul(wt, Ct) | 0, ye = ye + Math.imul(pt, _t) | 0, Be = Be + Math.imul(pt, Ct) | 0, ke = ke + Math.imul(gt, Ot) | 0, ye = ye + Math.imul(gt, $t) | 0, ye = ye + Math.imul(bt, Ot) | 0, Be = Be + Math.imul(bt, $t) | 0, ke = ke + Math.imul(lt, Dt) | 0, ye = ye + Math.imul(lt, Et) | 0, ye = ye + Math.imul(mt, Dt) | 0, Be = Be + Math.imul(mt, Et) | 0, ke = ke + Math.imul(Ge, Lt) | 0, ye = ye + Math.imul(Ge, Pt) | 0, ye = ye + Math.imul(nt, Lt) | 0, Be = Be + Math.imul(nt, Pt) | 0, ke = ke + Math.imul(qe, Ft) | 0, ye = ye + Math.imul(qe, Vt) | 0, ye = ye + Math.imul(We, Ft) | 0, Be = Be + Math.imul(We, Vt) | 0, ke = ke + Math.imul(je, Ht) | 0, ye = ye + Math.imul(je, It) | 0, ye = ye + Math.imul(rt, Ht) | 0, Be = Be + Math.imul(rt, It) | 0, ke = ke + Math.imul(et, jt) | 0, ye = ye + Math.imul(et, Tt) | 0, ye = ye + Math.imul(Ye, jt) | 0, Be = Be + Math.imul(Ye, Tt) | 0;
      var ar = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (ar >>> 26) | 0, ar &= 67108863, ke = Math.imul(Le, st), ye = Math.imul(Le, ct), ye = ye + Math.imul(Qe, st) | 0, Be = Math.imul(Qe, ct), ke = ke + Math.imul(Bt, St) | 0, ye = ye + Math.imul(Bt, yt) | 0, ye = ye + Math.imul(Je, St) | 0, Be = Be + Math.imul(Je, yt) | 0, ke = ke + Math.imul(ht, _t) | 0, ye = ye + Math.imul(ht, Ct) | 0, ye = ye + Math.imul(vt, _t) | 0, Be = Be + Math.imul(vt, Ct) | 0, ke = ke + Math.imul(wt, Ot) | 0, ye = ye + Math.imul(wt, $t) | 0, ye = ye + Math.imul(pt, Ot) | 0, Be = Be + Math.imul(pt, $t) | 0, ke = ke + Math.imul(gt, Dt) | 0, ye = ye + Math.imul(gt, Et) | 0, ye = ye + Math.imul(bt, Dt) | 0, Be = Be + Math.imul(bt, Et) | 0, ke = ke + Math.imul(lt, Lt) | 0, ye = ye + Math.imul(lt, Pt) | 0, ye = ye + Math.imul(mt, Lt) | 0, Be = Be + Math.imul(mt, Pt) | 0, ke = ke + Math.imul(Ge, Ft) | 0, ye = ye + Math.imul(Ge, Vt) | 0, ye = ye + Math.imul(nt, Ft) | 0, Be = Be + Math.imul(nt, Vt) | 0, ke = ke + Math.imul(qe, Ht) | 0, ye = ye + Math.imul(qe, It) | 0, ye = ye + Math.imul(We, Ht) | 0, Be = Be + Math.imul(We, It) | 0, ke = ke + Math.imul(je, jt) | 0, ye = ye + Math.imul(je, Tt) | 0, ye = ye + Math.imul(rt, jt) | 0, Be = Be + Math.imul(rt, Tt) | 0, ke = ke + Math.imul(et, Mt) | 0, ye = ye + Math.imul(et, Rt) | 0, ye = ye + Math.imul(Ye, Mt) | 0, Be = Be + Math.imul(Ye, Rt) | 0;
      var ir = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (ir >>> 26) | 0, ir &= 67108863, ke = Math.imul(Le, St), ye = Math.imul(Le, yt), ye = ye + Math.imul(Qe, St) | 0, Be = Math.imul(Qe, yt), ke = ke + Math.imul(Bt, _t) | 0, ye = ye + Math.imul(Bt, Ct) | 0, ye = ye + Math.imul(Je, _t) | 0, Be = Be + Math.imul(Je, Ct) | 0, ke = ke + Math.imul(ht, Ot) | 0, ye = ye + Math.imul(ht, $t) | 0, ye = ye + Math.imul(vt, Ot) | 0, Be = Be + Math.imul(vt, $t) | 0, ke = ke + Math.imul(wt, Dt) | 0, ye = ye + Math.imul(wt, Et) | 0, ye = ye + Math.imul(pt, Dt) | 0, Be = Be + Math.imul(pt, Et) | 0, ke = ke + Math.imul(gt, Lt) | 0, ye = ye + Math.imul(gt, Pt) | 0, ye = ye + Math.imul(bt, Lt) | 0, Be = Be + Math.imul(bt, Pt) | 0, ke = ke + Math.imul(lt, Ft) | 0, ye = ye + Math.imul(lt, Vt) | 0, ye = ye + Math.imul(mt, Ft) | 0, Be = Be + Math.imul(mt, Vt) | 0, ke = ke + Math.imul(Ge, Ht) | 0, ye = ye + Math.imul(Ge, It) | 0, ye = ye + Math.imul(nt, Ht) | 0, Be = Be + Math.imul(nt, It) | 0, ke = ke + Math.imul(qe, jt) | 0, ye = ye + Math.imul(qe, Tt) | 0, ye = ye + Math.imul(We, jt) | 0, Be = Be + Math.imul(We, Tt) | 0, ke = ke + Math.imul(je, Mt) | 0, ye = ye + Math.imul(je, Rt) | 0, ye = ye + Math.imul(rt, Mt) | 0, Be = Be + Math.imul(rt, Rt) | 0;
      var or = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (or >>> 26) | 0, or &= 67108863, ke = Math.imul(Le, _t), ye = Math.imul(Le, Ct), ye = ye + Math.imul(Qe, _t) | 0, Be = Math.imul(Qe, Ct), ke = ke + Math.imul(Bt, Ot) | 0, ye = ye + Math.imul(Bt, $t) | 0, ye = ye + Math.imul(Je, Ot) | 0, Be = Be + Math.imul(Je, $t) | 0, ke = ke + Math.imul(ht, Dt) | 0, ye = ye + Math.imul(ht, Et) | 0, ye = ye + Math.imul(vt, Dt) | 0, Be = Be + Math.imul(vt, Et) | 0, ke = ke + Math.imul(wt, Lt) | 0, ye = ye + Math.imul(wt, Pt) | 0, ye = ye + Math.imul(pt, Lt) | 0, Be = Be + Math.imul(pt, Pt) | 0, ke = ke + Math.imul(gt, Ft) | 0, ye = ye + Math.imul(gt, Vt) | 0, ye = ye + Math.imul(bt, Ft) | 0, Be = Be + Math.imul(bt, Vt) | 0, ke = ke + Math.imul(lt, Ht) | 0, ye = ye + Math.imul(lt, It) | 0, ye = ye + Math.imul(mt, Ht) | 0, Be = Be + Math.imul(mt, It) | 0, ke = ke + Math.imul(Ge, jt) | 0, ye = ye + Math.imul(Ge, Tt) | 0, ye = ye + Math.imul(nt, jt) | 0, Be = Be + Math.imul(nt, Tt) | 0, ke = ke + Math.imul(qe, Mt) | 0, ye = ye + Math.imul(qe, Rt) | 0, ye = ye + Math.imul(We, Mt) | 0, Be = Be + Math.imul(We, Rt) | 0;
      var lr = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (lr >>> 26) | 0, lr &= 67108863, ke = Math.imul(Le, Ot), ye = Math.imul(Le, $t), ye = ye + Math.imul(Qe, Ot) | 0, Be = Math.imul(Qe, $t), ke = ke + Math.imul(Bt, Dt) | 0, ye = ye + Math.imul(Bt, Et) | 0, ye = ye + Math.imul(Je, Dt) | 0, Be = Be + Math.imul(Je, Et) | 0, ke = ke + Math.imul(ht, Lt) | 0, ye = ye + Math.imul(ht, Pt) | 0, ye = ye + Math.imul(vt, Lt) | 0, Be = Be + Math.imul(vt, Pt) | 0, ke = ke + Math.imul(wt, Ft) | 0, ye = ye + Math.imul(wt, Vt) | 0, ye = ye + Math.imul(pt, Ft) | 0, Be = Be + Math.imul(pt, Vt) | 0, ke = ke + Math.imul(gt, Ht) | 0, ye = ye + Math.imul(gt, It) | 0, ye = ye + Math.imul(bt, Ht) | 0, Be = Be + Math.imul(bt, It) | 0, ke = ke + Math.imul(lt, jt) | 0, ye = ye + Math.imul(lt, Tt) | 0, ye = ye + Math.imul(mt, jt) | 0, Be = Be + Math.imul(mt, Tt) | 0, ke = ke + Math.imul(Ge, Mt) | 0, ye = ye + Math.imul(Ge, Rt) | 0, ye = ye + Math.imul(nt, Mt) | 0, Be = Be + Math.imul(nt, Rt) | 0;
      var cr = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (cr >>> 26) | 0, cr &= 67108863, ke = Math.imul(Le, Dt), ye = Math.imul(Le, Et), ye = ye + Math.imul(Qe, Dt) | 0, Be = Math.imul(Qe, Et), ke = ke + Math.imul(Bt, Lt) | 0, ye = ye + Math.imul(Bt, Pt) | 0, ye = ye + Math.imul(Je, Lt) | 0, Be = Be + Math.imul(Je, Pt) | 0, ke = ke + Math.imul(ht, Ft) | 0, ye = ye + Math.imul(ht, Vt) | 0, ye = ye + Math.imul(vt, Ft) | 0, Be = Be + Math.imul(vt, Vt) | 0, ke = ke + Math.imul(wt, Ht) | 0, ye = ye + Math.imul(wt, It) | 0, ye = ye + Math.imul(pt, Ht) | 0, Be = Be + Math.imul(pt, It) | 0, ke = ke + Math.imul(gt, jt) | 0, ye = ye + Math.imul(gt, Tt) | 0, ye = ye + Math.imul(bt, jt) | 0, Be = Be + Math.imul(bt, Tt) | 0, ke = ke + Math.imul(lt, Mt) | 0, ye = ye + Math.imul(lt, Rt) | 0, ye = ye + Math.imul(mt, Mt) | 0, Be = Be + Math.imul(mt, Rt) | 0;
      var ur = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (ur >>> 26) | 0, ur &= 67108863, ke = Math.imul(Le, Lt), ye = Math.imul(Le, Pt), ye = ye + Math.imul(Qe, Lt) | 0, Be = Math.imul(Qe, Pt), ke = ke + Math.imul(Bt, Ft) | 0, ye = ye + Math.imul(Bt, Vt) | 0, ye = ye + Math.imul(Je, Ft) | 0, Be = Be + Math.imul(Je, Vt) | 0, ke = ke + Math.imul(ht, Ht) | 0, ye = ye + Math.imul(ht, It) | 0, ye = ye + Math.imul(vt, Ht) | 0, Be = Be + Math.imul(vt, It) | 0, ke = ke + Math.imul(wt, jt) | 0, ye = ye + Math.imul(wt, Tt) | 0, ye = ye + Math.imul(pt, jt) | 0, Be = Be + Math.imul(pt, Tt) | 0, ke = ke + Math.imul(gt, Mt) | 0, ye = ye + Math.imul(gt, Rt) | 0, ye = ye + Math.imul(bt, Mt) | 0, Be = Be + Math.imul(bt, Rt) | 0;
      var dr = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (dr >>> 26) | 0, dr &= 67108863, ke = Math.imul(Le, Ft), ye = Math.imul(Le, Vt), ye = ye + Math.imul(Qe, Ft) | 0, Be = Math.imul(Qe, Vt), ke = ke + Math.imul(Bt, Ht) | 0, ye = ye + Math.imul(Bt, It) | 0, ye = ye + Math.imul(Je, Ht) | 0, Be = Be + Math.imul(Je, It) | 0, ke = ke + Math.imul(ht, jt) | 0, ye = ye + Math.imul(ht, Tt) | 0, ye = ye + Math.imul(vt, jt) | 0, Be = Be + Math.imul(vt, Tt) | 0, ke = ke + Math.imul(wt, Mt) | 0, ye = ye + Math.imul(wt, Rt) | 0, ye = ye + Math.imul(pt, Mt) | 0, Be = Be + Math.imul(pt, Rt) | 0;
      var fr = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (fr >>> 26) | 0, fr &= 67108863, ke = Math.imul(Le, Ht), ye = Math.imul(Le, It), ye = ye + Math.imul(Qe, Ht) | 0, Be = Math.imul(Qe, It), ke = ke + Math.imul(Bt, jt) | 0, ye = ye + Math.imul(Bt, Tt) | 0, ye = ye + Math.imul(Je, jt) | 0, Be = Be + Math.imul(Je, Tt) | 0, ke = ke + Math.imul(ht, Mt) | 0, ye = ye + Math.imul(ht, Rt) | 0, ye = ye + Math.imul(vt, Mt) | 0, Be = Be + Math.imul(vt, Rt) | 0;
      var pr = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (pr >>> 26) | 0, pr &= 67108863, ke = Math.imul(Le, jt), ye = Math.imul(Le, Tt), ye = ye + Math.imul(Qe, jt) | 0, Be = Math.imul(Qe, Tt), ke = ke + Math.imul(Bt, Mt) | 0, ye = ye + Math.imul(Bt, Rt) | 0, ye = ye + Math.imul(Je, Mt) | 0, Be = Be + Math.imul(Je, Rt) | 0;
      var vr = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      we = (Be + (ye >>> 13) | 0) + (vr >>> 26) | 0, vr &= 67108863, ke = Math.imul(Le, Mt), ye = Math.imul(Le, Rt), ye = ye + Math.imul(Qe, Mt) | 0, Be = Math.imul(Qe, Rt);
      var gr = (we + ke | 0) + ((ye & 8191) << 13) | 0;
      return we = (Be + (ye >>> 13) | 0) + (gr >>> 26) | 0, gr &= 67108863, Ie[0] = Jt, Ie[1] = Xt, Ie[2] = Zt, Ie[3] = Qt, Ie[4] = er, Ie[5] = tr, Ie[6] = rr, Ie[7] = nr, Ie[8] = ar, Ie[9] = ir, Ie[10] = or, Ie[11] = lr, Ie[12] = cr, Ie[13] = ur, Ie[14] = dr, Ie[15] = fr, Ie[16] = pr, Ie[17] = vr, Ie[18] = gr, we !== 0 && (Ie[19] = we, xe.length++), xe;
    };
    Math.imul || (Ae = Ve);
    function Oe(_e, he, ve) {
      ve.negative = he.negative ^ _e.negative, ve.length = _e.length + he.length;
      for (var xe = 0, $e = 0, Te = 0; Te < ve.length - 1; Te++) {
        var Ie = $e;
        $e = 0;
        for (var we = xe & 67108863, ke = Math.min(Te, he.length - 1), ye = Math.max(0, Te - _e.length + 1); ye <= ke; ye++) {
          var Be = Te - ye, Xe = _e.words[Be] | 0, et = he.words[ye] | 0, Ye = Xe * et, De = Ye & 67108863;
          Ie = Ie + (Ye / 67108864 | 0) | 0, De = De + we | 0, we = De & 67108863, Ie = Ie + (De >>> 26) | 0, $e += Ie >>> 26, Ie &= 67108863;
        }
        ve.words[Te] = we, xe = Ie, Ie = $e;
      }
      return xe !== 0 ? ve.words[Te] = xe : ve.length--, ve._strip();
    }
    function Ne(_e, he, ve) {
      return Oe(_e, he, ve);
    }
    se.prototype.mulTo = function(he, ve) {
      var xe, $e = this.length + he.length;
      return this.length === 10 && he.length === 10 ? xe = Ae(this, he, ve) : $e < 63 ? xe = Ve(this, he, ve) : $e < 1024 ? xe = Oe(this, he, ve) : xe = Ne(this, he, ve), xe;
    }, se.prototype.mul = function(he) {
      var ve = new se(null);
      return ve.words = new Array(this.length + he.length), this.mulTo(he, ve);
    }, se.prototype.mulf = function(he) {
      var ve = new se(null);
      return ve.words = new Array(this.length + he.length), Ne(this, he, ve);
    }, se.prototype.imul = function(he) {
      return this.clone().mulTo(he, this);
    }, se.prototype.imuln = function(he) {
      var ve = he < 0;
      ve && (he = -he), ie(typeof he == "number"), ie(he < 67108864);
      for (var xe = 0, $e = 0; $e < this.length; $e++) {
        var Te = (this.words[$e] | 0) * he, Ie = (Te & 67108863) + (xe & 67108863);
        xe >>= 26, xe += Te / 67108864 | 0, xe += Ie >>> 26, this.words[$e] = Ie & 67108863;
      }
      return xe !== 0 && (this.words[$e] = xe, this.length++), ve ? this.ineg() : this;
    }, se.prototype.muln = function(he) {
      return this.clone().imuln(he);
    }, se.prototype.sqr = function() {
      return this.mul(this);
    }, se.prototype.isqr = function() {
      return this.imul(this.clone());
    }, se.prototype.pow = function(he) {
      var ve = Ee(he);
      if (ve.length === 0) return new se(1);
      for (var xe = this, $e = 0; $e < ve.length && ve[$e] === 0; $e++, xe = xe.sqr())
        ;
      if (++$e < ve.length)
        for (var Te = xe.sqr(); $e < ve.length; $e++, Te = Te.sqr())
          ve[$e] !== 0 && (xe = xe.mul(Te));
      return xe;
    }, se.prototype.iushln = function(he) {
      ie(typeof he == "number" && he >= 0);
      var ve = he % 26, xe = (he - ve) / 26, $e = 67108863 >>> 26 - ve << 26 - ve, Te;
      if (ve !== 0) {
        var Ie = 0;
        for (Te = 0; Te < this.length; Te++) {
          var we = this.words[Te] & $e, ke = (this.words[Te] | 0) - we << ve;
          this.words[Te] = ke | Ie, Ie = we >>> 26 - ve;
        }
        Ie && (this.words[Te] = Ie, this.length++);
      }
      if (xe !== 0) {
        for (Te = this.length - 1; Te >= 0; Te--)
          this.words[Te + xe] = this.words[Te];
        for (Te = 0; Te < xe; Te++)
          this.words[Te] = 0;
        this.length += xe;
      }
      return this._strip();
    }, se.prototype.ishln = function(he) {
      return ie(this.negative === 0), this.iushln(he);
    }, se.prototype.iushrn = function(he, ve, xe) {
      ie(typeof he == "number" && he >= 0);
      var $e;
      ve ? $e = (ve - ve % 26) / 26 : $e = 0;
      var Te = he % 26, Ie = Math.min((he - Te) / 26, this.length), we = 67108863 ^ 67108863 >>> Te << Te, ke = xe;
      if ($e -= Ie, $e = Math.max(0, $e), ke) {
        for (var ye = 0; ye < Ie; ye++)
          ke.words[ye] = this.words[ye];
        ke.length = Ie;
      }
      if (Ie !== 0) if (this.length > Ie)
        for (this.length -= Ie, ye = 0; ye < this.length; ye++)
          this.words[ye] = this.words[ye + Ie];
      else
        this.words[0] = 0, this.length = 1;
      var Be = 0;
      for (ye = this.length - 1; ye >= 0 && (Be !== 0 || ye >= $e); ye--) {
        var Xe = this.words[ye] | 0;
        this.words[ye] = Be << 26 - Te | Xe >>> Te, Be = Xe & we;
      }
      return ke && Be !== 0 && (ke.words[ke.length++] = Be), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, se.prototype.ishrn = function(he, ve, xe) {
      return ie(this.negative === 0), this.iushrn(he, ve, xe);
    }, se.prototype.shln = function(he) {
      return this.clone().ishln(he);
    }, se.prototype.ushln = function(he) {
      return this.clone().iushln(he);
    }, se.prototype.shrn = function(he) {
      return this.clone().ishrn(he);
    }, se.prototype.ushrn = function(he) {
      return this.clone().iushrn(he);
    }, se.prototype.testn = function(he) {
      ie(typeof he == "number" && he >= 0);
      var ve = he % 26, xe = (he - ve) / 26, $e = 1 << ve;
      if (this.length <= xe) return !1;
      var Te = this.words[xe];
      return !!(Te & $e);
    }, se.prototype.imaskn = function(he) {
      ie(typeof he == "number" && he >= 0);
      var ve = he % 26, xe = (he - ve) / 26;
      if (ie(this.negative === 0, "imaskn works only with positive numbers"), this.length <= xe)
        return this;
      if (ve !== 0 && xe++, this.length = Math.min(xe, this.length), ve !== 0) {
        var $e = 67108863 ^ 67108863 >>> ve << ve;
        this.words[this.length - 1] &= $e;
      }
      return this._strip();
    }, se.prototype.maskn = function(he) {
      return this.clone().imaskn(he);
    }, se.prototype.iaddn = function(he) {
      return ie(typeof he == "number"), ie(he < 67108864), he < 0 ? this.isubn(-he) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= he ? (this.words[0] = he - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(he), this.negative = 1, this) : this._iaddn(he);
    }, se.prototype._iaddn = function(he) {
      this.words[0] += he;
      for (var ve = 0; ve < this.length && this.words[ve] >= 67108864; ve++)
        this.words[ve] -= 67108864, ve === this.length - 1 ? this.words[ve + 1] = 1 : this.words[ve + 1]++;
      return this.length = Math.max(this.length, ve + 1), this;
    }, se.prototype.isubn = function(he) {
      if (ie(typeof he == "number"), ie(he < 67108864), he < 0) return this.iaddn(-he);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(he), this.negative = 1, this;
      if (this.words[0] -= he, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var ve = 0; ve < this.length && this.words[ve] < 0; ve++)
          this.words[ve] += 67108864, this.words[ve + 1] -= 1;
      return this._strip();
    }, se.prototype.addn = function(he) {
      return this.clone().iaddn(he);
    }, se.prototype.subn = function(he) {
      return this.clone().isubn(he);
    }, se.prototype.iabs = function() {
      return this.negative = 0, this;
    }, se.prototype.abs = function() {
      return this.clone().iabs();
    }, se.prototype._ishlnsubmul = function(he, ve, xe) {
      var $e = he.length + xe, Te;
      this._expand($e);
      var Ie, we = 0;
      for (Te = 0; Te < he.length; Te++) {
        Ie = (this.words[Te + xe] | 0) + we;
        var ke = (he.words[Te] | 0) * ve;
        Ie -= ke & 67108863, we = (Ie >> 26) - (ke / 67108864 | 0), this.words[Te + xe] = Ie & 67108863;
      }
      for (; Te < this.length - xe; Te++)
        Ie = (this.words[Te + xe] | 0) + we, we = Ie >> 26, this.words[Te + xe] = Ie & 67108863;
      if (we === 0) return this._strip();
      for (ie(we === -1), we = 0, Te = 0; Te < this.length; Te++)
        Ie = -(this.words[Te] | 0) + we, we = Ie >> 26, this.words[Te] = Ie & 67108863;
      return this.negative = 1, this._strip();
    }, se.prototype._wordDiv = function(he, ve) {
      var xe = this.length - he.length, $e = this.clone(), Te = he, Ie = Te.words[Te.length - 1] | 0, we = this._countBits(Ie);
      xe = 26 - we, xe !== 0 && (Te = Te.ushln(xe), $e.iushln(xe), Ie = Te.words[Te.length - 1] | 0);
      var ke = $e.length - Te.length, ye;
      if (ve !== "mod") {
        ye = new se(null), ye.length = ke + 1, ye.words = new Array(ye.length);
        for (var Be = 0; Be < ye.length; Be++)
          ye.words[Be] = 0;
      }
      var Xe = $e.clone()._ishlnsubmul(Te, 1, ke);
      Xe.negative === 0 && ($e = Xe, ye && (ye.words[ke] = 1));
      for (var et = ke - 1; et >= 0; et--) {
        var Ye = ($e.words[Te.length + et] | 0) * 67108864 + ($e.words[Te.length + et - 1] | 0);
        for (Ye = Math.min(Ye / Ie | 0, 67108863), $e._ishlnsubmul(Te, Ye, et); $e.negative !== 0; )
          Ye--, $e.negative = 0, $e._ishlnsubmul(Te, 1, et), $e.isZero() || ($e.negative ^= 1);
        ye && (ye.words[et] = Ye);
      }
      return ye && ye._strip(), $e._strip(), ve !== "div" && xe !== 0 && $e.iushrn(xe), {
        div: ye || null,
        mod: $e
      };
    }, se.prototype.divmod = function(he, ve, xe) {
      if (ie(!he.isZero()), this.isZero())
        return {
          div: new se(0),
          mod: new se(0)
        };
      var $e, Te, Ie;
      return this.negative !== 0 && he.negative === 0 ? (Ie = this.neg().divmod(he, ve), ve !== "mod" && ($e = Ie.div.neg()), ve !== "div" && (Te = Ie.mod.neg(), xe && Te.negative !== 0 && Te.iadd(he)), {
        div: $e,
        mod: Te
      }) : this.negative === 0 && he.negative !== 0 ? (Ie = this.divmod(he.neg(), ve), ve !== "mod" && ($e = Ie.div.neg()), {
        div: $e,
        mod: Ie.mod
      }) : this.negative & he.negative ? (Ie = this.neg().divmod(he.neg(), ve), ve !== "div" && (Te = Ie.mod.neg(), xe && Te.negative !== 0 && Te.isub(he)), {
        div: Ie.div,
        mod: Te
      }) : he.length > this.length || this.cmp(he) < 0 ? {
        div: new se(0),
        mod: this
      } : he.length === 1 ? ve === "div" ? {
        div: this.divn(he.words[0]),
        mod: null
      } : ve === "mod" ? {
        div: null,
        mod: new se(this.modrn(he.words[0]))
      } : {
        div: this.divn(he.words[0]),
        mod: new se(this.modrn(he.words[0]))
      } : this._wordDiv(he, ve);
    }, se.prototype.div = function(he) {
      return this.divmod(he, "div", !1).div;
    }, se.prototype.mod = function(he) {
      return this.divmod(he, "mod", !1).mod;
    }, se.prototype.umod = function(he) {
      return this.divmod(he, "mod", !0).mod;
    }, se.prototype.divRound = function(he) {
      var ve = this.divmod(he);
      if (ve.mod.isZero()) return ve.div;
      var xe = ve.div.negative !== 0 ? ve.mod.isub(he) : ve.mod, $e = he.ushrn(1), Te = he.andln(1), Ie = xe.cmp($e);
      return Ie < 0 || Te === 1 && Ie === 0 ? ve.div : ve.div.negative !== 0 ? ve.div.isubn(1) : ve.div.iaddn(1);
    }, se.prototype.modrn = function(he) {
      var ve = he < 0;
      ve && (he = -he), ie(he <= 67108863);
      for (var xe = (1 << 26) % he, $e = 0, Te = this.length - 1; Te >= 0; Te--)
        $e = (xe * $e + (this.words[Te] | 0)) % he;
      return ve ? -$e : $e;
    }, se.prototype.modn = function(he) {
      return this.modrn(he);
    }, se.prototype.idivn = function(he) {
      var ve = he < 0;
      ve && (he = -he), ie(he <= 67108863);
      for (var xe = 0, $e = this.length - 1; $e >= 0; $e--) {
        var Te = (this.words[$e] | 0) + xe * 67108864;
        this.words[$e] = Te / he | 0, xe = Te % he;
      }
      return this._strip(), ve ? this.ineg() : this;
    }, se.prototype.divn = function(he) {
      return this.clone().idivn(he);
    }, se.prototype.egcd = function(he) {
      ie(he.negative === 0), ie(!he.isZero());
      var ve = this, xe = he.clone();
      ve.negative !== 0 ? ve = ve.umod(he) : ve = ve.clone();
      for (var $e = new se(1), Te = new se(0), Ie = new se(0), we = new se(1), ke = 0; ve.isEven() && xe.isEven(); )
        ve.iushrn(1), xe.iushrn(1), ++ke;
      for (var ye = xe.clone(), Be = ve.clone(); !ve.isZero(); ) {
        for (var Xe = 0, et = 1; !(ve.words[0] & et) && Xe < 26; ++Xe, et <<= 1) ;
        if (Xe > 0)
          for (ve.iushrn(Xe); Xe-- > 0; )
            ($e.isOdd() || Te.isOdd()) && ($e.iadd(ye), Te.isub(Be)), $e.iushrn(1), Te.iushrn(1);
        for (var Ye = 0, De = 1; !(xe.words[0] & De) && Ye < 26; ++Ye, De <<= 1) ;
        if (Ye > 0)
          for (xe.iushrn(Ye); Ye-- > 0; )
            (Ie.isOdd() || we.isOdd()) && (Ie.iadd(ye), we.isub(Be)), Ie.iushrn(1), we.iushrn(1);
        ve.cmp(xe) >= 0 ? (ve.isub(xe), $e.isub(Ie), Te.isub(we)) : (xe.isub(ve), Ie.isub($e), we.isub(Te));
      }
      return {
        a: Ie,
        b: we,
        gcd: xe.iushln(ke)
      };
    }, se.prototype._invmp = function(he) {
      ie(he.negative === 0), ie(!he.isZero());
      var ve = this, xe = he.clone();
      ve.negative !== 0 ? ve = ve.umod(he) : ve = ve.clone();
      for (var $e = new se(1), Te = new se(0), Ie = xe.clone(); ve.cmpn(1) > 0 && xe.cmpn(1) > 0; ) {
        for (var we = 0, ke = 1; !(ve.words[0] & ke) && we < 26; ++we, ke <<= 1) ;
        if (we > 0)
          for (ve.iushrn(we); we-- > 0; )
            $e.isOdd() && $e.iadd(Ie), $e.iushrn(1);
        for (var ye = 0, Be = 1; !(xe.words[0] & Be) && ye < 26; ++ye, Be <<= 1) ;
        if (ye > 0)
          for (xe.iushrn(ye); ye-- > 0; )
            Te.isOdd() && Te.iadd(Ie), Te.iushrn(1);
        ve.cmp(xe) >= 0 ? (ve.isub(xe), $e.isub(Te)) : (xe.isub(ve), Te.isub($e));
      }
      var Xe;
      return ve.cmpn(1) === 0 ? Xe = $e : Xe = Te, Xe.cmpn(0) < 0 && Xe.iadd(he), Xe;
    }, se.prototype.gcd = function(he) {
      if (this.isZero()) return he.abs();
      if (he.isZero()) return this.abs();
      var ve = this.clone(), xe = he.clone();
      ve.negative = 0, xe.negative = 0;
      for (var $e = 0; ve.isEven() && xe.isEven(); $e++)
        ve.iushrn(1), xe.iushrn(1);
      do {
        for (; ve.isEven(); )
          ve.iushrn(1);
        for (; xe.isEven(); )
          xe.iushrn(1);
        var Te = ve.cmp(xe);
        if (Te < 0) {
          var Ie = ve;
          ve = xe, xe = Ie;
        } else if (Te === 0 || xe.cmpn(1) === 0)
          break;
        ve.isub(xe);
      } while (!0);
      return xe.iushln($e);
    }, se.prototype.invm = function(he) {
      return this.egcd(he).a.umod(he);
    }, se.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, se.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, se.prototype.andln = function(he) {
      return this.words[0] & he;
    }, se.prototype.bincn = function(he) {
      ie(typeof he == "number");
      var ve = he % 26, xe = (he - ve) / 26, $e = 1 << ve;
      if (this.length <= xe)
        return this._expand(xe + 1), this.words[xe] |= $e, this;
      for (var Te = $e, Ie = xe; Te !== 0 && Ie < this.length; Ie++) {
        var we = this.words[Ie] | 0;
        we += Te, Te = we >>> 26, we &= 67108863, this.words[Ie] = we;
      }
      return Te !== 0 && (this.words[Ie] = Te, this.length++), this;
    }, se.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, se.prototype.cmpn = function(he) {
      var ve = he < 0;
      if (this.negative !== 0 && !ve) return -1;
      if (this.negative === 0 && ve) return 1;
      this._strip();
      var xe;
      if (this.length > 1)
        xe = 1;
      else {
        ve && (he = -he), ie(he <= 67108863, "Number is too big");
        var $e = this.words[0] | 0;
        xe = $e === he ? 0 : $e < he ? -1 : 1;
      }
      return this.negative !== 0 ? -xe | 0 : xe;
    }, se.prototype.cmp = function(he) {
      if (this.negative !== 0 && he.negative === 0) return -1;
      if (this.negative === 0 && he.negative !== 0) return 1;
      var ve = this.ucmp(he);
      return this.negative !== 0 ? -ve | 0 : ve;
    }, se.prototype.ucmp = function(he) {
      if (this.length > he.length) return 1;
      if (this.length < he.length) return -1;
      for (var ve = 0, xe = this.length - 1; xe >= 0; xe--) {
        var $e = this.words[xe] | 0, Te = he.words[xe] | 0;
        if ($e !== Te) {
          $e < Te ? ve = -1 : $e > Te && (ve = 1);
          break;
        }
      }
      return ve;
    }, se.prototype.gtn = function(he) {
      return this.cmpn(he) === 1;
    }, se.prototype.gt = function(he) {
      return this.cmp(he) === 1;
    }, se.prototype.gten = function(he) {
      return this.cmpn(he) >= 0;
    }, se.prototype.gte = function(he) {
      return this.cmp(he) >= 0;
    }, se.prototype.ltn = function(he) {
      return this.cmpn(he) === -1;
    }, se.prototype.lt = function(he) {
      return this.cmp(he) === -1;
    }, se.prototype.lten = function(he) {
      return this.cmpn(he) <= 0;
    }, se.prototype.lte = function(he) {
      return this.cmp(he) <= 0;
    }, se.prototype.eqn = function(he) {
      return this.cmpn(he) === 0;
    }, se.prototype.eq = function(he) {
      return this.cmp(he) === 0;
    }, se.red = function(he) {
      return new Re(he);
    }, se.prototype.toRed = function(he) {
      return ie(!this.red, "Already a number in reduction context"), ie(this.negative === 0, "red works only with positives"), he.convertTo(this)._forceRed(he);
    }, se.prototype.fromRed = function() {
      return ie(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, se.prototype._forceRed = function(he) {
      return this.red = he, this;
    }, se.prototype.forceRed = function(he) {
      return ie(!this.red, "Already a number in reduction context"), this._forceRed(he);
    }, se.prototype.redAdd = function(he) {
      return ie(this.red, "redAdd works only with red numbers"), this.red.add(this, he);
    }, se.prototype.redIAdd = function(he) {
      return ie(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, he);
    }, se.prototype.redSub = function(he) {
      return ie(this.red, "redSub works only with red numbers"), this.red.sub(this, he);
    }, se.prototype.redISub = function(he) {
      return ie(this.red, "redISub works only with red numbers"), this.red.isub(this, he);
    }, se.prototype.redShl = function(he) {
      return ie(this.red, "redShl works only with red numbers"), this.red.shl(this, he);
    }, se.prototype.redMul = function(he) {
      return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, he), this.red.mul(this, he);
    }, se.prototype.redIMul = function(he) {
      return ie(this.red, "redMul works only with red numbers"), this.red._verify2(this, he), this.red.imul(this, he);
    }, se.prototype.redSqr = function() {
      return ie(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, se.prototype.redISqr = function() {
      return ie(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, se.prototype.redSqrt = function() {
      return ie(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, se.prototype.redInvm = function() {
      return ie(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, se.prototype.redNeg = function() {
      return ie(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, se.prototype.redPow = function(he) {
      return ie(this.red && !he.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, he);
    };
    var He = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function Ue(_e, he) {
      this.name = _e, this.p = new se(he, 16), this.n = this.p.bitLength(), this.k = new se(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    Ue.prototype._tmp = function() {
      var he = new se(null);
      return he.words = new Array(Math.ceil(this.n / 13)), he;
    }, Ue.prototype.ireduce = function(he) {
      var ve = he, xe;
      do
        this.split(ve, this.tmp), ve = this.imulK(ve), ve = ve.iadd(this.tmp), xe = ve.bitLength();
      while (xe > this.n);
      var $e = xe < this.n ? -1 : ve.ucmp(this.p);
      return $e === 0 ? (ve.words[0] = 0, ve.length = 1) : $e > 0 ? ve.isub(this.p) : ve.strip !== void 0 ? ve.strip() : ve._strip(), ve;
    }, Ue.prototype.split = function(he, ve) {
      he.iushrn(this.n, 0, ve);
    }, Ue.prototype.imulK = function(he) {
      return he.imul(this.k);
    };
    function Ze() {
      Ue.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    le(Ze, Ue), Ze.prototype.split = function(he, ve) {
      for (var xe = 4194303, $e = Math.min(he.length, 9), Te = 0; Te < $e; Te++)
        ve.words[Te] = he.words[Te];
      if (ve.length = $e, he.length <= 9) {
        he.words[0] = 0, he.length = 1;
        return;
      }
      var Ie = he.words[9];
      for (ve.words[ve.length++] = Ie & xe, Te = 10; Te < he.length; Te++) {
        var we = he.words[Te] | 0;
        he.words[Te - 10] = (we & xe) << 4 | Ie >>> 22, Ie = we;
      }
      Ie >>>= 22, he.words[Te - 10] = Ie, Ie === 0 && he.length > 10 ? he.length -= 10 : he.length -= 9;
    }, Ze.prototype.imulK = function(he) {
      he.words[he.length] = 0, he.words[he.length + 1] = 0, he.length += 2;
      for (var ve = 0, xe = 0; xe < he.length; xe++) {
        var $e = he.words[xe] | 0;
        ve += $e * 977, he.words[xe] = ve & 67108863, ve = $e * 64 + (ve / 67108864 | 0);
      }
      return he.words[he.length - 1] === 0 && (he.length--, he.words[he.length - 1] === 0 && he.length--), he;
    };
    function Fe() {
      Ue.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    le(Fe, Ue);
    function Ke() {
      Ue.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    le(Ke, Ue);
    function tt() {
      Ue.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    le(tt, Ue), tt.prototype.imulK = function(he) {
      for (var ve = 0, xe = 0; xe < he.length; xe++) {
        var $e = (he.words[xe] | 0) * 19 + ve, Te = $e & 67108863;
        $e >>>= 26, he.words[xe] = Te, ve = $e;
      }
      return ve !== 0 && (he.words[he.length++] = ve), he;
    }, se._prime = function(he) {
      if (He[he]) return He[he];
      var ve;
      if (he === "k256")
        ve = new Ze();
      else if (he === "p224")
        ve = new Fe();
      else if (he === "p192")
        ve = new Ke();
      else if (he === "p25519")
        ve = new tt();
      else
        throw new Error("Unknown prime " + he);
      return He[he] = ve, ve;
    };
    function Re(_e) {
      if (typeof _e == "string") {
        var he = se._prime(_e);
        this.m = he.p, this.prime = he;
      } else
        ie(_e.gtn(1), "modulus must be greater than 1"), this.m = _e, this.prime = null;
    }
    Re.prototype._verify1 = function(he) {
      ie(he.negative === 0, "red works only with positives"), ie(he.red, "red works only with red numbers");
    }, Re.prototype._verify2 = function(he, ve) {
      ie((he.negative | ve.negative) === 0, "red works only with positives"), ie(
        he.red && he.red === ve.red,
        "red works only with red numbers"
      );
    }, Re.prototype.imod = function(he) {
      return this.prime ? this.prime.ireduce(he)._forceRed(this) : (fe(he, he.umod(this.m)._forceRed(this)), he);
    }, Re.prototype.neg = function(he) {
      return he.isZero() ? he.clone() : this.m.sub(he)._forceRed(this);
    }, Re.prototype.add = function(he, ve) {
      this._verify2(he, ve);
      var xe = he.add(ve);
      return xe.cmp(this.m) >= 0 && xe.isub(this.m), xe._forceRed(this);
    }, Re.prototype.iadd = function(he, ve) {
      this._verify2(he, ve);
      var xe = he.iadd(ve);
      return xe.cmp(this.m) >= 0 && xe.isub(this.m), xe;
    }, Re.prototype.sub = function(he, ve) {
      this._verify2(he, ve);
      var xe = he.sub(ve);
      return xe.cmpn(0) < 0 && xe.iadd(this.m), xe._forceRed(this);
    }, Re.prototype.isub = function(he, ve) {
      this._verify2(he, ve);
      var xe = he.isub(ve);
      return xe.cmpn(0) < 0 && xe.iadd(this.m), xe;
    }, Re.prototype.shl = function(he, ve) {
      return this._verify1(he), this.imod(he.ushln(ve));
    }, Re.prototype.imul = function(he, ve) {
      return this._verify2(he, ve), this.imod(he.imul(ve));
    }, Re.prototype.mul = function(he, ve) {
      return this._verify2(he, ve), this.imod(he.mul(ve));
    }, Re.prototype.isqr = function(he) {
      return this.imul(he, he.clone());
    }, Re.prototype.sqr = function(he) {
      return this.mul(he, he);
    }, Re.prototype.sqrt = function(he) {
      if (he.isZero()) return he.clone();
      var ve = this.m.andln(3);
      if (ie(ve % 2 === 1), ve === 3) {
        var xe = this.m.add(new se(1)).iushrn(2);
        return this.pow(he, xe);
      }
      for (var $e = this.m.subn(1), Te = 0; !$e.isZero() && $e.andln(1) === 0; )
        Te++, $e.iushrn(1);
      ie(!$e.isZero());
      var Ie = new se(1).toRed(this), we = Ie.redNeg(), ke = this.m.subn(1).iushrn(1), ye = this.m.bitLength();
      for (ye = new se(2 * ye * ye).toRed(this); this.pow(ye, ke).cmp(we) !== 0; )
        ye.redIAdd(we);
      for (var Be = this.pow(ye, $e), Xe = this.pow(he, $e.addn(1).iushrn(1)), et = this.pow(he, $e), Ye = Te; et.cmp(Ie) !== 0; ) {
        for (var De = et, je = 0; De.cmp(Ie) !== 0; je++)
          De = De.redSqr();
        ie(je < Ye);
        var rt = this.pow(Be, new se(1).iushln(Ye - je - 1));
        Xe = Xe.redMul(rt), Be = rt.redSqr(), et = et.redMul(Be), Ye = je;
      }
      return Xe;
    }, Re.prototype.invm = function(he) {
      var ve = he._invmp(this.m);
      return ve.negative !== 0 ? (ve.negative = 0, this.imod(ve).redNeg()) : this.imod(ve);
    }, Re.prototype.pow = function(he, ve) {
      if (ve.isZero()) return new se(1).toRed(this);
      if (ve.cmpn(1) === 0) return he.clone();
      var xe = 4, $e = new Array(1 << xe);
      $e[0] = new se(1).toRed(this), $e[1] = he;
      for (var Te = 2; Te < $e.length; Te++)
        $e[Te] = this.mul($e[Te - 1], he);
      var Ie = $e[0], we = 0, ke = 0, ye = ve.bitLength() % 26;
      for (ye === 0 && (ye = 26), Te = ve.length - 1; Te >= 0; Te--) {
        for (var Be = ve.words[Te], Xe = ye - 1; Xe >= 0; Xe--) {
          var et = Be >> Xe & 1;
          if (Ie !== $e[0] && (Ie = this.sqr(Ie)), et === 0 && we === 0) {
            ke = 0;
            continue;
          }
          we <<= 1, we |= et, ke++, !(ke !== xe && (Te !== 0 || Xe !== 0)) && (Ie = this.mul(Ie, $e[we]), ke = 0, we = 0);
        }
        ye = 26;
      }
      return Ie;
    }, Re.prototype.convertTo = function(he) {
      var ve = he.umod(this.m);
      return ve === he ? ve.clone() : ve;
    }, Re.prototype.convertFrom = function(he) {
      var ve = he.clone();
      return ve.red = null, ve;
    }, se.mont = function(he) {
      return new Ce(he);
    };
    function Ce(_e) {
      Re.call(this, _e), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new se(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    le(Ce, Re), Ce.prototype.convertTo = function(he) {
      return this.imod(he.ushln(this.shift));
    }, Ce.prototype.convertFrom = function(he) {
      var ve = this.imod(he.mul(this.rinv));
      return ve.red = null, ve;
    }, Ce.prototype.imul = function(he, ve) {
      if (he.isZero() || ve.isZero())
        return he.words[0] = 0, he.length = 1, he;
      var xe = he.imul(ve), $e = xe.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Te = xe.isub($e).iushrn(this.shift), Ie = Te;
      return Te.cmp(this.m) >= 0 ? Ie = Te.isub(this.m) : Te.cmpn(0) < 0 && (Ie = Te.iadd(this.m)), Ie._forceRed(this);
    }, Ce.prototype.mul = function(he, ve) {
      if (he.isZero() || ve.isZero()) return new se(0)._forceRed(this);
      var xe = he.mul(ve), $e = xe.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Te = xe.isub($e).iushrn(this.shift), Ie = Te;
      return Te.cmp(this.m) >= 0 ? Ie = Te.isub(this.m) : Te.cmpn(0) < 0 && (Ie = Te.iadd(this.m)), Ie._forceRed(this);
    }, Ce.prototype.invm = function(he) {
      var ve = this.imod(he._invmp(this.m).mul(this.r2));
      return ve._forceRed(this);
    };
  })(re, commonjsGlobal);
})(bn);
var bnExports = bn.exports, asn1$3 = {}, asn1$2 = {}, api = {}, vmBrowserify = {}, hasRequiredVmBrowserify;
function requireVmBrowserify() {
  return hasRequiredVmBrowserify || (hasRequiredVmBrowserify = 1, function(exports) {
    var indexOf = function(re, ne) {
      if (re.indexOf) return re.indexOf(ne);
      for (var ae = 0; ae < re.length; ae++)
        if (re[ae] === ne) return ae;
      return -1;
    }, Object_keys = function(re) {
      if (Object.keys) return Object.keys(re);
      var ne = [];
      for (var ae in re) ne.push(ae);
      return ne;
    }, forEach = function(re, ne) {
      if (re.forEach) return re.forEach(ne);
      for (var ae = 0; ae < re.length; ae++)
        ne(re[ae], ae, re);
    }, defineProp = function() {
      try {
        return Object.defineProperty({}, "_", {}), function(re, ne, ae) {
          Object.defineProperty(re, ne, {
            writable: !0,
            enumerable: !1,
            configurable: !0,
            value: ae
          });
        };
      } catch {
        return function(ne, ae, ie) {
          ne[ae] = ie;
        };
      }
    }(), globals = [
      "Array",
      "Boolean",
      "Date",
      "Error",
      "EvalError",
      "Function",
      "Infinity",
      "JSON",
      "Math",
      "NaN",
      "Number",
      "Object",
      "RangeError",
      "ReferenceError",
      "RegExp",
      "String",
      "SyntaxError",
      "TypeError",
      "URIError",
      "decodeURI",
      "decodeURIComponent",
      "encodeURI",
      "encodeURIComponent",
      "escape",
      "eval",
      "isFinite",
      "isNaN",
      "parseFloat",
      "parseInt",
      "undefined",
      "unescape"
    ];
    function Context() {
    }
    Context.prototype = {};
    var Script = exports.Script = function(ne) {
      if (!(this instanceof Script)) return new Script(ne);
      this.code = ne;
    };
    Script.prototype.runInContext = function(re) {
      if (!(re instanceof Context))
        throw new TypeError("needs a 'context' argument.");
      var ne = document.createElement("iframe");
      ne.style || (ne.style = {}), ne.style.display = "none", document.body.appendChild(ne);
      var ae = ne.contentWindow, ie = ae.eval, le = ae.execScript;
      !ie && le && (le.call(ae, "null"), ie = ae.eval), forEach(Object_keys(re), function(ue) {
        ae[ue] = re[ue];
      }), forEach(globals, function(ue) {
        re[ue] && (ae[ue] = re[ue]);
      });
      var se = Object_keys(ae), ce = ie.call(ae, this.code);
      return forEach(Object_keys(ae), function(ue) {
        (ue in re || indexOf(se, ue) === -1) && (re[ue] = ae[ue]);
      }), forEach(globals, function(ue) {
        ue in re || defineProp(re, ue, ae[ue]);
      }), document.body.removeChild(ne), ce;
    }, Script.prototype.runInThisContext = function() {
      return eval(this.code);
    }, Script.prototype.runInNewContext = function(re) {
      var ne = Script.createContext(re), ae = this.runInContext(ne);
      return re && forEach(Object_keys(ne), function(ie) {
        re[ie] = ne[ie];
      }), ae;
    }, forEach(Object_keys(Script.prototype), function(re) {
      exports[re] = Script[re] = function(ne) {
        var ae = Script(ne);
        return ae[re].apply(ae, [].slice.call(arguments, 1));
      };
    }), exports.isContext = function(re) {
      return re instanceof Context;
    }, exports.createScript = function(re) {
      return exports.Script(re);
    }, exports.createContext = Script.createContext = function(re) {
      var ne = new Context();
      return typeof re == "object" && forEach(Object_keys(re), function(ae) {
        ne[ae] = re[ae];
      }), ne;
    };
  }(vmBrowserify)), vmBrowserify;
}
var hasRequiredApi;
function requireApi() {
  return hasRequiredApi || (hasRequiredApi = 1, function(re) {
    var ne = requireAsn1(), ae = inherits_browserExports, ie = re;
    ie.define = function(ce, ue) {
      return new le(ce, ue);
    };
    function le(se, ce) {
      this.name = se, this.body = ce, this.decoders = {}, this.encoders = {};
    }
    le.prototype._createNamed = function(ce) {
      var ue;
      try {
        ue = requireVmBrowserify().runInThisContext(
          "(function " + this.name + `(entity) {
  this._initNamed(entity);
})`
        );
      } catch {
        ue = function(me) {
          this._initNamed(me);
        };
      }
      return ae(ue, ce), ue.prototype._initNamed = function(me) {
        ce.call(this, me);
      }, new ue(this);
    }, le.prototype._getDecoder = function(ce) {
      return ce = ce || "der", this.decoders.hasOwnProperty(ce) || (this.decoders[ce] = this._createNamed(ne.decoders[ce])), this.decoders[ce];
    }, le.prototype.decode = function(ce, ue, de) {
      return this._getDecoder(ue).decode(ce, de);
    }, le.prototype._getEncoder = function(ce) {
      return ce = ce || "der", this.encoders.hasOwnProperty(ce) || (this.encoders[ce] = this._createNamed(ne.encoders[ce])), this.encoders[ce];
    }, le.prototype.encode = function(ce, ue, de) {
      return this._getEncoder(ue).encode(ce, de);
    };
  }(api)), api;
}
var base = {}, reporter = {}, inherits = inherits_browserExports;
function Reporter(re) {
  this._reporterState = {
    obj: null,
    path: [],
    options: re || {},
    errors: []
  };
}
reporter.Reporter = Reporter;
Reporter.prototype.isError = function re(ne) {
  return ne instanceof ReporterError;
};
Reporter.prototype.save = function re() {
  var ne = this._reporterState;
  return { obj: ne.obj, pathLen: ne.path.length };
};
Reporter.prototype.restore = function re(ne) {
  var ae = this._reporterState;
  ae.obj = ne.obj, ae.path = ae.path.slice(0, ne.pathLen);
};
Reporter.prototype.enterKey = function re(ne) {
  return this._reporterState.path.push(ne);
};
Reporter.prototype.exitKey = function re(ne) {
  var ae = this._reporterState;
  ae.path = ae.path.slice(0, ne - 1);
};
Reporter.prototype.leaveKey = function re(ne, ae, ie) {
  var le = this._reporterState;
  this.exitKey(ne), le.obj !== null && (le.obj[ae] = ie);
};
Reporter.prototype.path = function re() {
  return this._reporterState.path.join("/");
};
Reporter.prototype.enterObject = function re() {
  var ne = this._reporterState, ae = ne.obj;
  return ne.obj = {}, ae;
};
Reporter.prototype.leaveObject = function re(ne) {
  var ae = this._reporterState, ie = ae.obj;
  return ae.obj = ne, ie;
};
Reporter.prototype.error = function re(ne) {
  var ae, ie = this._reporterState, le = ne instanceof ReporterError;
  if (le ? ae = ne : ae = new ReporterError(ie.path.map(function(se) {
    return "[" + JSON.stringify(se) + "]";
  }).join(""), ne.message || ne, ne.stack), !ie.options.partial)
    throw ae;
  return le || ie.errors.push(ae), ae;
};
Reporter.prototype.wrapResult = function re(ne) {
  var ae = this._reporterState;
  return ae.options.partial ? {
    result: this.isError(ne) ? null : ne,
    errors: ae.errors
  } : ne;
};
function ReporterError(re, ne) {
  this.path = re, this.rethrow(ne);
}
inherits(ReporterError, Error);
ReporterError.prototype.rethrow = function re(ne) {
  if (this.message = ne + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, ReporterError), !this.stack)
    try {
      throw new Error(this.message);
    } catch (ae) {
      this.stack = ae.stack;
    }
  return this;
};
var buffer = {}, hasRequiredBuffer;
function requireBuffer() {
  if (hasRequiredBuffer) return buffer;
  hasRequiredBuffer = 1;
  var re = inherits_browserExports, ne = requireBase().Reporter, ae = require$$1$2.Buffer;
  function ie(se, ce) {
    if (ne.call(this, ce), !ae.isBuffer(se)) {
      this.error("Input not Buffer");
      return;
    }
    this.base = se, this.offset = 0, this.length = se.length;
  }
  re(ie, ne), buffer.DecoderBuffer = ie, ie.prototype.save = function() {
    return { offset: this.offset, reporter: ne.prototype.save.call(this) };
  }, ie.prototype.restore = function(ce) {
    var ue = new ie(this.base);
    return ue.offset = ce.offset, ue.length = this.offset, this.offset = ce.offset, ne.prototype.restore.call(this, ce.reporter), ue;
  }, ie.prototype.isEmpty = function() {
    return this.offset === this.length;
  }, ie.prototype.readUInt8 = function(ce) {
    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(ce || "DecoderBuffer overrun");
  }, ie.prototype.skip = function(ce, ue) {
    if (!(this.offset + ce <= this.length))
      return this.error(ue || "DecoderBuffer overrun");
    var de = new ie(this.base);
    return de._reporterState = this._reporterState, de.offset = this.offset, de.length = this.offset + ce, this.offset += ce, de;
  }, ie.prototype.raw = function(ce) {
    return this.base.slice(ce ? ce.offset : this.offset, this.length);
  };
  function le(se, ce) {
    if (Array.isArray(se))
      this.length = 0, this.value = se.map(function(ue) {
        return ue instanceof le || (ue = new le(ue, ce)), this.length += ue.length, ue;
      }, this);
    else if (typeof se == "number") {
      if (!(0 <= se && se <= 255))
        return ce.error("non-byte EncoderBuffer value");
      this.value = se, this.length = 1;
    } else if (typeof se == "string")
      this.value = se, this.length = ae.byteLength(se);
    else if (ae.isBuffer(se))
      this.value = se, this.length = se.length;
    else
      return ce.error("Unsupported type: " + typeof se);
  }
  return buffer.EncoderBuffer = le, le.prototype.join = function(ce, ue) {
    return ce || (ce = new ae(this.length)), ue || (ue = 0), this.length === 0 || (Array.isArray(this.value) ? this.value.forEach(function(de) {
      de.join(ce, ue), ue += de.length;
    }) : (typeof this.value == "number" ? ce[ue] = this.value : typeof this.value == "string" ? ce.write(this.value, ue) : ae.isBuffer(this.value) && this.value.copy(ce, ue), ue += this.length)), ce;
  }, buffer;
}
var node, hasRequiredNode;
function requireNode() {
  if (hasRequiredNode) return node;
  hasRequiredNode = 1;
  var re = requireBase().Reporter, ne = requireBase().EncoderBuffer, ae = requireBase().DecoderBuffer, ie = minimalisticAssert, le = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
  ], se = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
  ].concat(le), ce = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
  ];
  function ue(me, fe) {
    var pe = {};
    this._baseState = pe, pe.enc = me, pe.parent = fe || null, pe.children = null, pe.tag = null, pe.args = null, pe.reverseArgs = null, pe.choice = null, pe.optional = !1, pe.any = !1, pe.obj = !1, pe.use = null, pe.useDecoder = null, pe.key = null, pe.default = null, pe.explicit = null, pe.implicit = null, pe.contains = null, pe.parent || (pe.children = [], this._wrap());
  }
  node = ue;
  var de = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
  ];
  return ue.prototype.clone = function() {
    var fe = this._baseState, pe = {};
    de.forEach(function(be) {
      pe[be] = fe[be];
    });
    var ge = new this.constructor(pe.parent);
    return ge._baseState = pe, ge;
  }, ue.prototype._wrap = function() {
    var fe = this._baseState;
    se.forEach(function(pe) {
      this[pe] = function() {
        var be = new this.constructor(this);
        return fe.children.push(be), be[pe].apply(be, arguments);
      };
    }, this);
  }, ue.prototype._init = function(fe) {
    var pe = this._baseState;
    ie(pe.parent === null), fe.call(this), pe.children = pe.children.filter(function(ge) {
      return ge._baseState.parent === this;
    }, this), ie.equal(pe.children.length, 1, "Root node can have only one child");
  }, ue.prototype._useArgs = function(fe) {
    var pe = this._baseState, ge = fe.filter(function(be) {
      return be instanceof this.constructor;
    }, this);
    fe = fe.filter(function(be) {
      return !(be instanceof this.constructor);
    }, this), ge.length !== 0 && (ie(pe.children === null), pe.children = ge, ge.forEach(function(be) {
      be._baseState.parent = this;
    }, this)), fe.length !== 0 && (ie(pe.args === null), pe.args = fe, pe.reverseArgs = fe.map(function(be) {
      if (typeof be != "object" || be.constructor !== Object)
        return be;
      var Se = {};
      return Object.keys(be).forEach(function(Pe) {
        Pe == (Pe | 0) && (Pe |= 0);
        var Ee = be[Pe];
        Se[Ee] = Pe;
      }), Se;
    }));
  }, ce.forEach(function(me) {
    ue.prototype[me] = function() {
      var pe = this._baseState;
      throw new Error(me + " not implemented for encoding: " + pe.enc);
    };
  }), le.forEach(function(me) {
    ue.prototype[me] = function() {
      var pe = this._baseState, ge = Array.prototype.slice.call(arguments);
      return ie(pe.tag === null), pe.tag = me, this._useArgs(ge), this;
    };
  }), ue.prototype.use = function(fe) {
    ie(fe);
    var pe = this._baseState;
    return ie(pe.use === null), pe.use = fe, this;
  }, ue.prototype.optional = function() {
    var fe = this._baseState;
    return fe.optional = !0, this;
  }, ue.prototype.def = function(fe) {
    var pe = this._baseState;
    return ie(pe.default === null), pe.default = fe, pe.optional = !0, this;
  }, ue.prototype.explicit = function(fe) {
    var pe = this._baseState;
    return ie(pe.explicit === null && pe.implicit === null), pe.explicit = fe, this;
  }, ue.prototype.implicit = function(fe) {
    var pe = this._baseState;
    return ie(pe.explicit === null && pe.implicit === null), pe.implicit = fe, this;
  }, ue.prototype.obj = function() {
    var fe = this._baseState, pe = Array.prototype.slice.call(arguments);
    return fe.obj = !0, pe.length !== 0 && this._useArgs(pe), this;
  }, ue.prototype.key = function(fe) {
    var pe = this._baseState;
    return ie(pe.key === null), pe.key = fe, this;
  }, ue.prototype.any = function() {
    var fe = this._baseState;
    return fe.any = !0, this;
  }, ue.prototype.choice = function(fe) {
    var pe = this._baseState;
    return ie(pe.choice === null), pe.choice = fe, this._useArgs(Object.keys(fe).map(function(ge) {
      return fe[ge];
    })), this;
  }, ue.prototype.contains = function(fe) {
    var pe = this._baseState;
    return ie(pe.use === null), pe.contains = fe, this;
  }, ue.prototype._decode = function(fe, pe) {
    var ge = this._baseState;
    if (ge.parent === null)
      return fe.wrapResult(ge.children[0]._decode(fe, pe));
    var be = ge.default, Se = !0, Pe = null;
    if (ge.key !== null && (Pe = fe.enterKey(ge.key)), ge.optional) {
      var Ee = null;
      if (ge.explicit !== null ? Ee = ge.explicit : ge.implicit !== null ? Ee = ge.implicit : ge.tag !== null && (Ee = ge.tag), Ee === null && !ge.any) {
        var Ve = fe.save();
        try {
          ge.choice === null ? this._decodeGeneric(ge.tag, fe, pe) : this._decodeChoice(fe, pe), Se = !0;
        } catch {
          Se = !1;
        }
        fe.restore(Ve);
      } else if (Se = this._peekTag(fe, Ee, ge.any), fe.isError(Se))
        return Se;
    }
    var Ae;
    if (ge.obj && Se && (Ae = fe.enterObject()), Se) {
      if (ge.explicit !== null) {
        var Oe = this._decodeTag(fe, ge.explicit);
        if (fe.isError(Oe))
          return Oe;
        fe = Oe;
      }
      var Ne = fe.offset;
      if (ge.use === null && ge.choice === null) {
        if (ge.any)
          var Ve = fe.save();
        var He = this._decodeTag(
          fe,
          ge.implicit !== null ? ge.implicit : ge.tag,
          ge.any
        );
        if (fe.isError(He))
          return He;
        ge.any ? be = fe.raw(Ve) : fe = He;
      }
      if (pe && pe.track && ge.tag !== null && pe.track(fe.path(), Ne, fe.length, "tagged"), pe && pe.track && ge.tag !== null && pe.track(fe.path(), fe.offset, fe.length, "content"), ge.any ? be = be : ge.choice === null ? be = this._decodeGeneric(ge.tag, fe, pe) : be = this._decodeChoice(fe, pe), fe.isError(be))
        return be;
      if (!ge.any && ge.choice === null && ge.children !== null && ge.children.forEach(function(Fe) {
        Fe._decode(fe, pe);
      }), ge.contains && (ge.tag === "octstr" || ge.tag === "bitstr")) {
        var Ue = new ae(be);
        be = this._getUse(ge.contains, fe._reporterState.obj)._decode(Ue, pe);
      }
    }
    return ge.obj && Se && (be = fe.leaveObject(Ae)), ge.key !== null && (be !== null || Se === !0) ? fe.leaveKey(Pe, ge.key, be) : Pe !== null && fe.exitKey(Pe), be;
  }, ue.prototype._decodeGeneric = function(fe, pe, ge) {
    var be = this._baseState;
    return fe === "seq" || fe === "set" ? null : fe === "seqof" || fe === "setof" ? this._decodeList(pe, fe, be.args[0], ge) : /str$/.test(fe) ? this._decodeStr(pe, fe, ge) : fe === "objid" && be.args ? this._decodeObjid(pe, be.args[0], be.args[1], ge) : fe === "objid" ? this._decodeObjid(pe, null, null, ge) : fe === "gentime" || fe === "utctime" ? this._decodeTime(pe, fe, ge) : fe === "null_" ? this._decodeNull(pe, ge) : fe === "bool" ? this._decodeBool(pe, ge) : fe === "objDesc" ? this._decodeStr(pe, fe, ge) : fe === "int" || fe === "enum" ? this._decodeInt(pe, be.args && be.args[0], ge) : be.use !== null ? this._getUse(be.use, pe._reporterState.obj)._decode(pe, ge) : pe.error("unknown tag: " + fe);
  }, ue.prototype._getUse = function(fe, pe) {
    var ge = this._baseState;
    return ge.useDecoder = this._use(fe, pe), ie(ge.useDecoder._baseState.parent === null), ge.useDecoder = ge.useDecoder._baseState.children[0], ge.implicit !== ge.useDecoder._baseState.implicit && (ge.useDecoder = ge.useDecoder.clone(), ge.useDecoder._baseState.implicit = ge.implicit), ge.useDecoder;
  }, ue.prototype._decodeChoice = function(fe, pe) {
    var ge = this._baseState, be = null, Se = !1;
    return Object.keys(ge.choice).some(function(Pe) {
      var Ee = fe.save(), Ve = ge.choice[Pe];
      try {
        var Ae = Ve._decode(fe, pe);
        if (fe.isError(Ae))
          return !1;
        be = { type: Pe, value: Ae }, Se = !0;
      } catch {
        return fe.restore(Ee), !1;
      }
      return !0;
    }, this), Se ? be : fe.error("Choice not matched");
  }, ue.prototype._createEncoderBuffer = function(fe) {
    return new ne(fe, this.reporter);
  }, ue.prototype._encode = function(fe, pe, ge) {
    var be = this._baseState;
    if (!(be.default !== null && be.default === fe)) {
      var Se = this._encodeValue(fe, pe, ge);
      if (Se !== void 0 && !this._skipDefault(Se, pe, ge))
        return Se;
    }
  }, ue.prototype._encodeValue = function(fe, pe, ge) {
    var be = this._baseState;
    if (be.parent === null)
      return be.children[0]._encode(fe, pe || new re());
    var Ve = null;
    if (this.reporter = pe, be.optional && fe === void 0)
      if (be.default !== null)
        fe = be.default;
      else
        return;
    var Se = null, Pe = !1;
    if (be.any)
      Ve = this._createEncoderBuffer(fe);
    else if (be.choice)
      Ve = this._encodeChoice(fe, pe);
    else if (be.contains)
      Se = this._getUse(be.contains, ge)._encode(fe, pe), Pe = !0;
    else if (be.children)
      Se = be.children.map(function(Ne) {
        if (Ne._baseState.tag === "null_")
          return Ne._encode(null, pe, fe);
        if (Ne._baseState.key === null)
          return pe.error("Child should have a key");
        var He = pe.enterKey(Ne._baseState.key);
        if (typeof fe != "object")
          return pe.error("Child expected, but input is not object");
        var Ue = Ne._encode(fe[Ne._baseState.key], pe, fe);
        return pe.leaveKey(He), Ue;
      }, this).filter(function(Ne) {
        return Ne;
      }), Se = this._createEncoderBuffer(Se);
    else if (be.tag === "seqof" || be.tag === "setof") {
      if (!(be.args && be.args.length === 1))
        return pe.error("Too many args for : " + be.tag);
      if (!Array.isArray(fe))
        return pe.error("seqof/setof, but data is not Array");
      var Ee = this.clone();
      Ee._baseState.implicit = null, Se = this._createEncoderBuffer(fe.map(function(Ne) {
        var He = this._baseState;
        return this._getUse(He.args[0], fe)._encode(Ne, pe);
      }, Ee));
    } else be.use !== null ? Ve = this._getUse(be.use, ge)._encode(fe, pe) : (Se = this._encodePrimitive(be.tag, fe), Pe = !0);
    var Ve;
    if (!be.any && be.choice === null) {
      var Ae = be.implicit !== null ? be.implicit : be.tag, Oe = be.implicit === null ? "universal" : "context";
      Ae === null ? be.use === null && pe.error("Tag could be omitted only for .use()") : be.use === null && (Ve = this._encodeComposite(Ae, Pe, Oe, Se));
    }
    return be.explicit !== null && (Ve = this._encodeComposite(be.explicit, !1, "context", Ve)), Ve;
  }, ue.prototype._encodeChoice = function(fe, pe) {
    var ge = this._baseState, be = ge.choice[fe.type];
    return be || ie(
      !1,
      fe.type + " not found in " + JSON.stringify(Object.keys(ge.choice))
    ), be._encode(fe.value, pe);
  }, ue.prototype._encodePrimitive = function(fe, pe) {
    var ge = this._baseState;
    if (/str$/.test(fe))
      return this._encodeStr(pe, fe);
    if (fe === "objid" && ge.args)
      return this._encodeObjid(pe, ge.reverseArgs[0], ge.args[1]);
    if (fe === "objid")
      return this._encodeObjid(pe, null, null);
    if (fe === "gentime" || fe === "utctime")
      return this._encodeTime(pe, fe);
    if (fe === "null_")
      return this._encodeNull();
    if (fe === "int" || fe === "enum")
      return this._encodeInt(pe, ge.args && ge.reverseArgs[0]);
    if (fe === "bool")
      return this._encodeBool(pe);
    if (fe === "objDesc")
      return this._encodeStr(pe, fe);
    throw new Error("Unsupported tag: " + fe);
  }, ue.prototype._isNumstr = function(fe) {
    return /^[0-9 ]*$/.test(fe);
  }, ue.prototype._isPrintstr = function(fe) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(fe);
  }, node;
}
var hasRequiredBase;
function requireBase() {
  return hasRequiredBase || (hasRequiredBase = 1, function(re) {
    var ne = re;
    ne.Reporter = reporter.Reporter, ne.DecoderBuffer = requireBuffer().DecoderBuffer, ne.EncoderBuffer = requireBuffer().EncoderBuffer, ne.Node = requireNode();
  }(base)), base;
}
var constants = {}, der = {}, hasRequiredDer$2;
function requireDer$2() {
  return hasRequiredDer$2 || (hasRequiredDer$2 = 1, function(re) {
    var ne = requireConstants();
    re.tagClass = {
      0: "universal",
      1: "application",
      2: "context",
      3: "private"
    }, re.tagClassByName = ne._reverse(re.tagClass), re.tag = {
      0: "end",
      1: "bool",
      2: "int",
      3: "bitstr",
      4: "octstr",
      5: "null_",
      6: "objid",
      7: "objDesc",
      8: "external",
      9: "real",
      10: "enum",
      11: "embed",
      12: "utf8str",
      13: "relativeOid",
      16: "seq",
      17: "set",
      18: "numstr",
      19: "printstr",
      20: "t61str",
      21: "videostr",
      22: "ia5str",
      23: "utctime",
      24: "gentime",
      25: "graphstr",
      26: "iso646str",
      27: "genstr",
      28: "unistr",
      29: "charstr",
      30: "bmpstr"
    }, re.tagByName = ne._reverse(re.tag);
  }(der)), der;
}
var hasRequiredConstants;
function requireConstants() {
  return hasRequiredConstants || (hasRequiredConstants = 1, function(re) {
    var ne = re;
    ne._reverse = function(ie) {
      var le = {};
      return Object.keys(ie).forEach(function(se) {
        (se | 0) == se && (se = se | 0);
        var ce = ie[se];
        le[ce] = se;
      }), le;
    }, ne.der = requireDer$2();
  }(constants)), constants;
}
var decoders = {}, der_1$1, hasRequiredDer$1;
function requireDer$1() {
  if (hasRequiredDer$1) return der_1$1;
  hasRequiredDer$1 = 1;
  var re = inherits_browserExports, ne = requireAsn1(), ae = ne.base, ie = ne.bignum, le = ne.constants.der;
  function se(me) {
    this.enc = "der", this.name = me.name, this.entity = me, this.tree = new ce(), this.tree._init(me.body);
  }
  der_1$1 = se, se.prototype.decode = function(fe, pe) {
    return fe instanceof ae.DecoderBuffer || (fe = new ae.DecoderBuffer(fe, pe)), this.tree._decode(fe, pe);
  };
  function ce(me) {
    ae.Node.call(this, "der", me);
  }
  re(ce, ae.Node), ce.prototype._peekTag = function(fe, pe, ge) {
    if (fe.isEmpty())
      return !1;
    var be = fe.save(), Se = ue(fe, 'Failed to peek tag: "' + pe + '"');
    return fe.isError(Se) ? Se : (fe.restore(be), Se.tag === pe || Se.tagStr === pe || Se.tagStr + "of" === pe || ge);
  }, ce.prototype._decodeTag = function(fe, pe, ge) {
    var be = ue(
      fe,
      'Failed to decode tag of "' + pe + '"'
    );
    if (fe.isError(be))
      return be;
    var Se = de(
      fe,
      be.primitive,
      'Failed to get length of "' + pe + '"'
    );
    if (fe.isError(Se))
      return Se;
    if (!ge && be.tag !== pe && be.tagStr !== pe && be.tagStr + "of" !== pe)
      return fe.error('Failed to match tag: "' + pe + '"');
    if (be.primitive || Se !== null)
      return fe.skip(Se, 'Failed to match body of: "' + pe + '"');
    var Pe = fe.save(), Ee = this._skipUntilEnd(
      fe,
      'Failed to skip indefinite length body: "' + this.tag + '"'
    );
    return fe.isError(Ee) ? Ee : (Se = fe.offset - Pe.offset, fe.restore(Pe), fe.skip(Se, 'Failed to match body of: "' + pe + '"'));
  }, ce.prototype._skipUntilEnd = function(fe, pe) {
    for (; ; ) {
      var ge = ue(fe, pe);
      if (fe.isError(ge))
        return ge;
      var be = de(fe, ge.primitive, pe);
      if (fe.isError(be))
        return be;
      var Se;
      if (ge.primitive || be !== null ? Se = fe.skip(be) : Se = this._skipUntilEnd(fe, pe), fe.isError(Se))
        return Se;
      if (ge.tagStr === "end")
        break;
    }
  }, ce.prototype._decodeList = function(fe, pe, ge, be) {
    for (var Se = []; !fe.isEmpty(); ) {
      var Pe = this._peekTag(fe, "end");
      if (fe.isError(Pe))
        return Pe;
      var Ee = ge.decode(fe, "der", be);
      if (fe.isError(Ee) && Pe)
        break;
      Se.push(Ee);
    }
    return Se;
  }, ce.prototype._decodeStr = function(fe, pe) {
    if (pe === "bitstr") {
      var ge = fe.readUInt8();
      return fe.isError(ge) ? ge : { unused: ge, data: fe.raw() };
    } else if (pe === "bmpstr") {
      var be = fe.raw();
      if (be.length % 2 === 1)
        return fe.error("Decoding of string type: bmpstr length mismatch");
      for (var Se = "", Pe = 0; Pe < be.length / 2; Pe++)
        Se += String.fromCharCode(be.readUInt16BE(Pe * 2));
      return Se;
    } else if (pe === "numstr") {
      var Ee = fe.raw().toString("ascii");
      return this._isNumstr(Ee) ? Ee : fe.error("Decoding of string type: numstr unsupported characters");
    } else {
      if (pe === "octstr")
        return fe.raw();
      if (pe === "objDesc")
        return fe.raw();
      if (pe === "printstr") {
        var Ve = fe.raw().toString("ascii");
        return this._isPrintstr(Ve) ? Ve : fe.error("Decoding of string type: printstr unsupported characters");
      } else return /str$/.test(pe) ? fe.raw().toString() : fe.error("Decoding of string type: " + pe + " unsupported");
    }
  }, ce.prototype._decodeObjid = function(fe, pe, ge) {
    for (var be, Se = [], Pe = 0; !fe.isEmpty(); ) {
      var Ee = fe.readUInt8();
      Pe <<= 7, Pe |= Ee & 127, Ee & 128 || (Se.push(Pe), Pe = 0);
    }
    Ee & 128 && Se.push(Pe);
    var Ve = Se[0] / 40 | 0, Ae = Se[0] % 40;
    if (ge ? be = Se : be = [Ve, Ae].concat(Se.slice(1)), pe) {
      var Oe = pe[be.join(" ")];
      Oe === void 0 && (Oe = pe[be.join(".")]), Oe !== void 0 && (be = Oe);
    }
    return be;
  }, ce.prototype._decodeTime = function(fe, pe) {
    var ge = fe.raw().toString();
    if (pe === "gentime")
      var be = ge.slice(0, 4) | 0, Se = ge.slice(4, 6) | 0, Pe = ge.slice(6, 8) | 0, Ee = ge.slice(8, 10) | 0, Ve = ge.slice(10, 12) | 0, Ae = ge.slice(12, 14) | 0;
    else if (pe === "utctime") {
      var be = ge.slice(0, 2) | 0, Se = ge.slice(2, 4) | 0, Pe = ge.slice(4, 6) | 0, Ee = ge.slice(6, 8) | 0, Ve = ge.slice(8, 10) | 0, Ae = ge.slice(10, 12) | 0;
      be < 70 ? be = 2e3 + be : be = 1900 + be;
    } else
      return fe.error("Decoding " + pe + " time is not supported yet");
    return Date.UTC(be, Se - 1, Pe, Ee, Ve, Ae, 0);
  }, ce.prototype._decodeNull = function(fe) {
    return null;
  }, ce.prototype._decodeBool = function(fe) {
    var pe = fe.readUInt8();
    return fe.isError(pe) ? pe : pe !== 0;
  }, ce.prototype._decodeInt = function(fe, pe) {
    var ge = fe.raw(), be = new ie(ge);
    return pe && (be = pe[be.toString(10)] || be), be;
  }, ce.prototype._use = function(fe, pe) {
    return typeof fe == "function" && (fe = fe(pe)), fe._getDecoder("der").tree;
  };
  function ue(me, fe) {
    var pe = me.readUInt8(fe);
    if (me.isError(pe))
      return pe;
    var ge = le.tagClass[pe >> 6], be = (pe & 32) === 0;
    if ((pe & 31) === 31) {
      var Se = pe;
      for (pe = 0; (Se & 128) === 128; ) {
        if (Se = me.readUInt8(fe), me.isError(Se))
          return Se;
        pe <<= 7, pe |= Se & 127;
      }
    } else
      pe &= 31;
    var Pe = le.tag[pe];
    return {
      cls: ge,
      primitive: be,
      tag: pe,
      tagStr: Pe
    };
  }
  function de(me, fe, pe) {
    var ge = me.readUInt8(pe);
    if (me.isError(ge))
      return ge;
    if (!fe && ge === 128)
      return null;
    if (!(ge & 128))
      return ge;
    var be = ge & 127;
    if (be > 4)
      return me.error("length octect is too long");
    ge = 0;
    for (var Se = 0; Se < be; Se++) {
      ge <<= 8;
      var Pe = me.readUInt8(pe);
      if (me.isError(Pe))
        return Pe;
      ge |= Pe;
    }
    return ge;
  }
  return der_1$1;
}
var pem$1, hasRequiredPem$1;
function requirePem$1() {
  if (hasRequiredPem$1) return pem$1;
  hasRequiredPem$1 = 1;
  var re = inherits_browserExports, ne = require$$1$2.Buffer, ae = requireDer$1();
  function ie(le) {
    ae.call(this, le), this.enc = "pem";
  }
  return re(ie, ae), pem$1 = ie, ie.prototype.decode = function(se, ce) {
    for (var ue = se.toString().split(/[\r\n]+/g), de = ce.label.toUpperCase(), me = /^-----(BEGIN|END) ([^-]+)-----$/, fe = -1, pe = -1, ge = 0; ge < ue.length; ge++) {
      var be = ue[ge].match(me);
      if (be !== null && be[2] === de)
        if (fe === -1) {
          if (be[1] !== "BEGIN")
            break;
          fe = ge;
        } else {
          if (be[1] !== "END")
            break;
          pe = ge;
          break;
        }
    }
    if (fe === -1 || pe === -1)
      throw new Error("PEM section not found for: " + de);
    var Se = ue.slice(fe + 1, pe).join("");
    Se.replace(/[^a-z0-9\+\/=]+/gi, "");
    var Pe = new ne(Se, "base64");
    return ae.prototype.decode.call(this, Pe, ce);
  }, pem$1;
}
var hasRequiredDecoders;
function requireDecoders() {
  return hasRequiredDecoders || (hasRequiredDecoders = 1, function(re) {
    var ne = re;
    ne.der = requireDer$1(), ne.pem = requirePem$1();
  }(decoders)), decoders;
}
var encoders = {}, der_1, hasRequiredDer;
function requireDer() {
  if (hasRequiredDer) return der_1;
  hasRequiredDer = 1;
  var re = inherits_browserExports, ne = require$$1$2.Buffer, ae = requireAsn1(), ie = ae.base, le = ae.constants.der;
  function se(me) {
    this.enc = "der", this.name = me.name, this.entity = me, this.tree = new ce(), this.tree._init(me.body);
  }
  der_1 = se, se.prototype.encode = function(fe, pe) {
    return this.tree._encode(fe, pe).join();
  };
  function ce(me) {
    ie.Node.call(this, "der", me);
  }
  re(ce, ie.Node), ce.prototype._encodeComposite = function(fe, pe, ge, be) {
    var Se = de(fe, pe, ge, this.reporter);
    if (be.length < 128) {
      var Ve = new ne(2);
      return Ve[0] = Se, Ve[1] = be.length, this._createEncoderBuffer([Ve, be]);
    }
    for (var Pe = 1, Ee = be.length; Ee >= 256; Ee >>= 8)
      Pe++;
    var Ve = new ne(2 + Pe);
    Ve[0] = Se, Ve[1] = 128 | Pe;
    for (var Ee = 1 + Pe, Ae = be.length; Ae > 0; Ee--, Ae >>= 8)
      Ve[Ee] = Ae & 255;
    return this._createEncoderBuffer([Ve, be]);
  }, ce.prototype._encodeStr = function(fe, pe) {
    if (pe === "bitstr")
      return this._createEncoderBuffer([fe.unused | 0, fe.data]);
    if (pe === "bmpstr") {
      for (var ge = new ne(fe.length * 2), be = 0; be < fe.length; be++)
        ge.writeUInt16BE(fe.charCodeAt(be), be * 2);
      return this._createEncoderBuffer(ge);
    } else return pe === "numstr" ? this._isNumstr(fe) ? this._createEncoderBuffer(fe) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : pe === "printstr" ? this._isPrintstr(fe) ? this._createEncoderBuffer(fe) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(pe) ? this._createEncoderBuffer(fe) : pe === "objDesc" ? this._createEncoderBuffer(fe) : this.reporter.error("Encoding of string type: " + pe + " unsupported");
  }, ce.prototype._encodeObjid = function(fe, pe, ge) {
    if (typeof fe == "string") {
      if (!pe)
        return this.reporter.error("string objid given, but no values map found");
      if (!pe.hasOwnProperty(fe))
        return this.reporter.error("objid not found in values map");
      fe = pe[fe].split(/[\s\.]+/g);
      for (var be = 0; be < fe.length; be++)
        fe[be] |= 0;
    } else if (Array.isArray(fe)) {
      fe = fe.slice();
      for (var be = 0; be < fe.length; be++)
        fe[be] |= 0;
    }
    if (!Array.isArray(fe))
      return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(fe));
    if (!ge) {
      if (fe[1] >= 40)
        return this.reporter.error("Second objid identifier OOB");
      fe.splice(0, 2, fe[0] * 40 + fe[1]);
    }
    for (var Se = 0, be = 0; be < fe.length; be++) {
      var Pe = fe[be];
      for (Se++; Pe >= 128; Pe >>= 7)
        Se++;
    }
    for (var Ee = new ne(Se), Ve = Ee.length - 1, be = fe.length - 1; be >= 0; be--) {
      var Pe = fe[be];
      for (Ee[Ve--] = Pe & 127; (Pe >>= 7) > 0; )
        Ee[Ve--] = 128 | Pe & 127;
    }
    return this._createEncoderBuffer(Ee);
  };
  function ue(me) {
    return me < 10 ? "0" + me : me;
  }
  ce.prototype._encodeTime = function(fe, pe) {
    var ge, be = new Date(fe);
    return pe === "gentime" ? ge = [
      ue(be.getFullYear()),
      ue(be.getUTCMonth() + 1),
      ue(be.getUTCDate()),
      ue(be.getUTCHours()),
      ue(be.getUTCMinutes()),
      ue(be.getUTCSeconds()),
      "Z"
    ].join("") : pe === "utctime" ? ge = [
      ue(be.getFullYear() % 100),
      ue(be.getUTCMonth() + 1),
      ue(be.getUTCDate()),
      ue(be.getUTCHours()),
      ue(be.getUTCMinutes()),
      ue(be.getUTCSeconds()),
      "Z"
    ].join("") : this.reporter.error("Encoding " + pe + " time is not supported yet"), this._encodeStr(ge, "octstr");
  }, ce.prototype._encodeNull = function() {
    return this._createEncoderBuffer("");
  }, ce.prototype._encodeInt = function(fe, pe) {
    if (typeof fe == "string") {
      if (!pe)
        return this.reporter.error("String int or enum given, but no values map");
      if (!pe.hasOwnProperty(fe))
        return this.reporter.error("Values map doesn't contain: " + JSON.stringify(fe));
      fe = pe[fe];
    }
    if (typeof fe != "number" && !ne.isBuffer(fe)) {
      var ge = fe.toArray();
      !fe.sign && ge[0] & 128 && ge.unshift(0), fe = new ne(ge);
    }
    if (ne.isBuffer(fe)) {
      var be = fe.length;
      fe.length === 0 && be++;
      var Pe = new ne(be);
      return fe.copy(Pe), fe.length === 0 && (Pe[0] = 0), this._createEncoderBuffer(Pe);
    }
    if (fe < 128)
      return this._createEncoderBuffer(fe);
    if (fe < 256)
      return this._createEncoderBuffer([0, fe]);
    for (var be = 1, Se = fe; Se >= 256; Se >>= 8)
      be++;
    for (var Pe = new Array(be), Se = Pe.length - 1; Se >= 0; Se--)
      Pe[Se] = fe & 255, fe >>= 8;
    return Pe[0] & 128 && Pe.unshift(0), this._createEncoderBuffer(new ne(Pe));
  }, ce.prototype._encodeBool = function(fe) {
    return this._createEncoderBuffer(fe ? 255 : 0);
  }, ce.prototype._use = function(fe, pe) {
    return typeof fe == "function" && (fe = fe(pe)), fe._getEncoder("der").tree;
  }, ce.prototype._skipDefault = function(fe, pe, ge) {
    var be = this._baseState, Se;
    if (be.default === null)
      return !1;
    var Pe = fe.join();
    if (be.defaultBuffer === void 0 && (be.defaultBuffer = this._encodeValue(be.default, pe, ge).join()), Pe.length !== be.defaultBuffer.length)
      return !1;
    for (Se = 0; Se < Pe.length; Se++)
      if (Pe[Se] !== be.defaultBuffer[Se])
        return !1;
    return !0;
  };
  function de(me, fe, pe, ge) {
    var be;
    if (me === "seqof" ? me = "seq" : me === "setof" && (me = "set"), le.tagByName.hasOwnProperty(me))
      be = le.tagByName[me];
    else if (typeof me == "number" && (me | 0) === me)
      be = me;
    else
      return ge.error("Unknown tag: " + me);
    return be >= 31 ? ge.error("Multi-octet tag encoding unsupported") : (fe || (be |= 32), be |= le.tagClassByName[pe || "universal"] << 6, be);
  }
  return der_1;
}
var pem, hasRequiredPem;
function requirePem() {
  if (hasRequiredPem) return pem;
  hasRequiredPem = 1;
  var re = inherits_browserExports, ne = requireDer();
  function ae(ie) {
    ne.call(this, ie), this.enc = "pem";
  }
  return re(ae, ne), pem = ae, ae.prototype.encode = function(le, se) {
    for (var ce = ne.prototype.encode.call(this, le), ue = ce.toString("base64"), de = ["-----BEGIN " + se.label + "-----"], me = 0; me < ue.length; me += 64)
      de.push(ue.slice(me, me + 64));
    return de.push("-----END " + se.label + "-----"), de.join(`
`);
  }, pem;
}
var hasRequiredEncoders;
function requireEncoders() {
  return hasRequiredEncoders || (hasRequiredEncoders = 1, function(re) {
    var ne = re;
    ne.der = requireDer(), ne.pem = requirePem();
  }(encoders)), encoders;
}
var hasRequiredAsn1;
function requireAsn1() {
  return hasRequiredAsn1 || (hasRequiredAsn1 = 1, function(re) {
    var ne = re;
    ne.bignum = bnExports$2, ne.define = requireApi().define, ne.base = requireBase(), ne.constants = requireConstants(), ne.decoders = requireDecoders(), ne.encoders = requireEncoders();
  }(asn1$2)), asn1$2;
}
var asn = requireAsn1(), Time = asn.define("Time", function() {
  this.choice({
    utcTime: this.utctime(),
    generalTime: this.gentime()
  });
}), AttributeTypeValue = asn.define("AttributeTypeValue", function() {
  this.seq().obj(
    this.key("type").objid(),
    this.key("value").any()
  );
}), AlgorithmIdentifier$1 = asn.define("AlgorithmIdentifier", function() {
  this.seq().obj(
    this.key("algorithm").objid(),
    this.key("parameters").optional(),
    this.key("curve").objid().optional()
  );
}), SubjectPublicKeyInfo = asn.define("SubjectPublicKeyInfo", function() {
  this.seq().obj(
    this.key("algorithm").use(AlgorithmIdentifier$1),
    this.key("subjectPublicKey").bitstr()
  );
}), RelativeDistinguishedName = asn.define("RelativeDistinguishedName", function() {
  this.setof(AttributeTypeValue);
}), RDNSequence = asn.define("RDNSequence", function() {
  this.seqof(RelativeDistinguishedName);
}), Name = asn.define("Name", function() {
  this.choice({
    rdnSequence: this.use(RDNSequence)
  });
}), Validity = asn.define("Validity", function() {
  this.seq().obj(
    this.key("notBefore").use(Time),
    this.key("notAfter").use(Time)
  );
}), Extension = asn.define("Extension", function() {
  this.seq().obj(
    this.key("extnID").objid(),
    this.key("critical").bool().def(!1),
    this.key("extnValue").octstr()
  );
}), TBSCertificate = asn.define("TBSCertificate", function() {
  this.seq().obj(
    this.key("version").explicit(0).int().optional(),
    this.key("serialNumber").int(),
    this.key("signature").use(AlgorithmIdentifier$1),
    this.key("issuer").use(Name),
    this.key("validity").use(Validity),
    this.key("subject").use(Name),
    this.key("subjectPublicKeyInfo").use(SubjectPublicKeyInfo),
    this.key("issuerUniqueID").implicit(1).bitstr().optional(),
    this.key("subjectUniqueID").implicit(2).bitstr().optional(),
    this.key("extensions").explicit(3).seqof(Extension).optional()
  );
}), X509Certificate = asn.define("X509Certificate", function() {
  this.seq().obj(
    this.key("tbsCertificate").use(TBSCertificate),
    this.key("signatureAlgorithm").use(AlgorithmIdentifier$1),
    this.key("signatureValue").bitstr()
  );
}), certificate = X509Certificate, asn1$1 = requireAsn1();
asn1$3.certificate = certificate;
var RSAPrivateKey = asn1$1.define("RSAPrivateKey", function() {
  this.seq().obj(
    this.key("version").int(),
    this.key("modulus").int(),
    this.key("publicExponent").int(),
    this.key("privateExponent").int(),
    this.key("prime1").int(),
    this.key("prime2").int(),
    this.key("exponent1").int(),
    this.key("exponent2").int(),
    this.key("coefficient").int()
  );
});
asn1$3.RSAPrivateKey = RSAPrivateKey;
var RSAPublicKey = asn1$1.define("RSAPublicKey", function() {
  this.seq().obj(
    this.key("modulus").int(),
    this.key("publicExponent").int()
  );
});
asn1$3.RSAPublicKey = RSAPublicKey;
var AlgorithmIdentifier = asn1$1.define("AlgorithmIdentifier", function() {
  this.seq().obj(
    this.key("algorithm").objid(),
    this.key("none").null_().optional(),
    this.key("curve").objid().optional(),
    this.key("params").seq().obj(
      this.key("p").int(),
      this.key("q").int(),
      this.key("g").int()
    ).optional()
  );
}), PublicKey = asn1$1.define("SubjectPublicKeyInfo", function() {
  this.seq().obj(
    this.key("algorithm").use(AlgorithmIdentifier),
    this.key("subjectPublicKey").bitstr()
  );
});
asn1$3.PublicKey = PublicKey;
var PrivateKeyInfo = asn1$1.define("PrivateKeyInfo", function() {
  this.seq().obj(
    this.key("version").int(),
    this.key("algorithm").use(AlgorithmIdentifier),
    this.key("subjectPrivateKey").octstr()
  );
});
asn1$3.PrivateKey = PrivateKeyInfo;
var EncryptedPrivateKeyInfo = asn1$1.define("EncryptedPrivateKeyInfo", function() {
  this.seq().obj(
    this.key("algorithm").seq().obj(
      this.key("id").objid(),
      this.key("decrypt").seq().obj(
        this.key("kde").seq().obj(
          this.key("id").objid(),
          this.key("kdeparams").seq().obj(
            this.key("salt").octstr(),
            this.key("iters").int()
          )
        ),
        this.key("cipher").seq().obj(
          this.key("algo").objid(),
          this.key("iv").octstr()
        )
      )
    ),
    this.key("subjectPrivateKey").octstr()
  );
});
asn1$3.EncryptedPrivateKey = EncryptedPrivateKeyInfo;
var DSAPrivateKey = asn1$1.define("DSAPrivateKey", function() {
  this.seq().obj(
    this.key("version").int(),
    this.key("p").int(),
    this.key("q").int(),
    this.key("g").int(),
    this.key("pub_key").int(),
    this.key("priv_key").int()
  );
});
asn1$3.DSAPrivateKey = DSAPrivateKey;
asn1$3.DSAparam = asn1$1.define("DSAparam", function() {
  this.int();
});
var ECParameters = asn1$1.define("ECParameters", function() {
  this.choice({
    namedCurve: this.objid()
  });
}), ECPrivateKey = asn1$1.define("ECPrivateKey", function() {
  this.seq().obj(
    this.key("version").int(),
    this.key("privateKey").octstr(),
    this.key("parameters").optional().explicit(0).use(ECParameters),
    this.key("publicKey").optional().explicit(1).bitstr()
  );
});
asn1$3.ECPrivateKey = ECPrivateKey;
asn1$3.signature = asn1$1.define("signature", function() {
  this.seq().obj(
    this.key("r").int(),
    this.key("s").int()
  );
});
const require$$1 = {
  "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
  "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
  "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
  "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
  "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
  "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
  "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
  "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
  "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
  "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
  "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
  "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
};
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, evp = evp_bytestokey, ciphers$1 = browser$5, Buffer$6 = safeBufferExports$1.Buffer, fixProc$1 = function(re, ne) {
  var ae = re.toString(), ie = ae.match(findProc), le;
  if (ie) {
    var ce = "aes" + ie[1], ue = Buffer$6.from(ie[2], "hex"), de = Buffer$6.from(ie[3].replace(/[\r\n]/g, ""), "base64"), me = evp(ne, ue.slice(0, 8), parseInt(ie[1], 10)).key, fe = [], pe = ciphers$1.createDecipheriv(ce, me, ue);
    fe.push(pe.update(de)), fe.push(pe.final()), le = Buffer$6.concat(fe);
  } else {
    var se = ae.match(fullRegex);
    le = Buffer$6.from(se[2].replace(/[\r\n]/g, ""), "base64");
  }
  var ge = ae.match(startRegex)[1];
  return {
    tag: ge,
    data: le
  };
}, asn1 = asn1$3, aesid = require$$1, fixProc = fixProc$1, ciphers = browser$5, compat = browser$7, Buffer$5 = safeBufferExports$1.Buffer;
function decrypt(re, ne) {
  var ae = re.algorithm.decrypt.kde.kdeparams.salt, ie = parseInt(re.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), le = aesid[re.algorithm.decrypt.cipher.algo.join(".")], se = re.algorithm.decrypt.cipher.iv, ce = re.subjectPrivateKey, ue = parseInt(le.split("-")[1], 10) / 8, de = compat.pbkdf2Sync(ne, ae, ie, ue, "sha1"), me = ciphers.createDecipheriv(le, de, se), fe = [];
  return fe.push(me.update(ce)), fe.push(me.final()), Buffer$5.concat(fe);
}
function parseKeys$2(re) {
  var ne;
  typeof re == "object" && !Buffer$5.isBuffer(re) && (ne = re.passphrase, re = re.key), typeof re == "string" && (re = Buffer$5.from(re));
  var ae = fixProc(re, ne), ie = ae.tag, le = ae.data, se, ce;
  switch (ie) {
    case "CERTIFICATE":
      ce = asn1.certificate.decode(le, "der").tbsCertificate.subjectPublicKeyInfo;
    case "PUBLIC KEY":
      switch (ce || (ce = asn1.PublicKey.decode(le, "der")), se = ce.algorithm.algorithm.join("."), se) {
        case "1.2.840.113549.1.1.1":
          return asn1.RSAPublicKey.decode(ce.subjectPublicKey.data, "der");
        case "1.2.840.10045.2.1":
          return ce.subjectPrivateKey = ce.subjectPublicKey, {
            type: "ec",
            data: ce
          };
        case "1.2.840.10040.4.1":
          return ce.algorithm.params.pub_key = asn1.DSAparam.decode(ce.subjectPublicKey.data, "der"), {
            type: "dsa",
            data: ce.algorithm.params
          };
        default:
          throw new Error("unknown key id " + se);
      }
    case "ENCRYPTED PRIVATE KEY":
      le = asn1.EncryptedPrivateKey.decode(le, "der"), le = decrypt(le, ne);
    case "PRIVATE KEY":
      switch (ce = asn1.PrivateKey.decode(le, "der"), se = ce.algorithm.algorithm.join("."), se) {
        case "1.2.840.113549.1.1.1":
          return asn1.RSAPrivateKey.decode(ce.subjectPrivateKey, "der");
        case "1.2.840.10045.2.1":
          return {
            curve: ce.algorithm.curve,
            privateKey: asn1.ECPrivateKey.decode(ce.subjectPrivateKey, "der").privateKey
          };
        case "1.2.840.10040.4.1":
          return ce.algorithm.params.priv_key = asn1.DSAparam.decode(ce.subjectPrivateKey, "der"), {
            type: "dsa",
            params: ce.algorithm.params
          };
        default:
          throw new Error("unknown key id " + se);
      }
    case "RSA PUBLIC KEY":
      return asn1.RSAPublicKey.decode(le, "der");
    case "RSA PRIVATE KEY":
      return asn1.RSAPrivateKey.decode(le, "der");
    case "DSA PRIVATE KEY":
      return {
        type: "dsa",
        params: asn1.DSAPrivateKey.decode(le, "der")
      };
    case "EC PRIVATE KEY":
      return le = asn1.ECPrivateKey.decode(le, "der"), {
        curve: le.parameters.value,
        privateKey: le.privateKey
      };
    default:
      throw new Error("unknown key type " + ie);
  }
}
parseKeys$2.signature = asn1.signature;
var parseAsn1 = parseKeys$2;
const require$$4 = {
  "1.3.132.0.10": "secp256k1",
  "1.3.132.0.33": "p224",
  "1.2.840.10045.3.1.1": "p192",
  "1.2.840.10045.3.1.7": "p256",
  "1.3.132.0.34": "p384",
  "1.3.132.0.35": "p521"
};
var hasRequiredSign;
function requireSign() {
  if (hasRequiredSign) return sign.exports;
  hasRequiredSign = 1;
  var re = safeBufferExports$1.Buffer, ne = browser$8, ae = browserifyRsa, ie = requireElliptic().ec, le = bnExports, se = parseAsn1, ce = require$$4, ue = 1;
  function de(Ve, Ae, Oe, Ne, He) {
    var Ue = se(Ae);
    if (Ue.curve) {
      if (Ne !== "ecdsa" && Ne !== "ecdsa/rsa")
        throw new Error("wrong private key type");
      return me(Ve, Ue);
    } else if (Ue.type === "dsa") {
      if (Ne !== "dsa")
        throw new Error("wrong private key type");
      return fe(Ve, Ue, Oe);
    }
    if (Ne !== "rsa" && Ne !== "ecdsa/rsa")
      throw new Error("wrong private key type");
    if (Ae.padding !== void 0 && Ae.padding !== ue)
      throw new Error("illegal or unsupported padding mode");
    Ve = re.concat([He, Ve]);
    for (var Ze = Ue.modulus.byteLength(), Fe = [0, 1]; Ve.length + Fe.length + 1 < Ze; )
      Fe.push(255);
    Fe.push(0);
    for (var Ke = -1; ++Ke < Ve.length; )
      Fe.push(Ve[Ke]);
    var tt = ae(Fe, Ue);
    return tt;
  }
  function me(Ve, Ae) {
    var Oe = ce[Ae.curve.join(".")];
    if (!Oe)
      throw new Error("unknown curve " + Ae.curve.join("."));
    var Ne = new ie(Oe), He = Ne.keyFromPrivate(Ae.privateKey), Ue = He.sign(Ve);
    return re.from(Ue.toDER());
  }
  function fe(Ve, Ae, Oe) {
    for (var Ne = Ae.params.priv_key, He = Ae.params.p, Ue = Ae.params.q, Ze = Ae.params.g, Fe = new le(0), Ke, tt = be(Ve, Ue).mod(Ue), Re = !1, Ce = ge(Ne, Ue, Ve, Oe); Re === !1; )
      Ke = Pe(Ue, Ce, Oe), Fe = Ee(Ze, Ke, He, Ue), Re = Ke.invm(Ue).imul(tt.add(Ne.mul(Fe))).mod(Ue), Re.cmpn(0) === 0 && (Re = !1, Fe = new le(0));
    return pe(Fe, Re);
  }
  function pe(Ve, Ae) {
    Ve = Ve.toArray(), Ae = Ae.toArray(), Ve[0] & 128 && (Ve = [0].concat(Ve)), Ae[0] & 128 && (Ae = [0].concat(Ae));
    var Oe = Ve.length + Ae.length + 4, Ne = [
      48,
      Oe,
      2,
      Ve.length
    ];
    return Ne = Ne.concat(Ve, [2, Ae.length], Ae), re.from(Ne);
  }
  function ge(Ve, Ae, Oe, Ne) {
    if (Ve = re.from(Ve.toArray()), Ve.length < Ae.byteLength()) {
      var He = re.alloc(Ae.byteLength() - Ve.length);
      Ve = re.concat([He, Ve]);
    }
    var Ue = Oe.length, Ze = Se(Oe, Ae), Fe = re.alloc(Ue);
    Fe.fill(1);
    var Ke = re.alloc(Ue);
    return Ke = ne(Ne, Ke).update(Fe).update(re.from([0])).update(Ve).update(Ze).digest(), Fe = ne(Ne, Ke).update(Fe).digest(), Ke = ne(Ne, Ke).update(Fe).update(re.from([1])).update(Ve).update(Ze).digest(), Fe = ne(Ne, Ke).update(Fe).digest(), { k: Ke, v: Fe };
  }
  function be(Ve, Ae) {
    var Oe = new le(Ve), Ne = (Ve.length << 3) - Ae.bitLength();
    return Ne > 0 && Oe.ishrn(Ne), Oe;
  }
  function Se(Ve, Ae) {
    Ve = be(Ve, Ae), Ve = Ve.mod(Ae);
    var Oe = re.from(Ve.toArray());
    if (Oe.length < Ae.byteLength()) {
      var Ne = re.alloc(Ae.byteLength() - Oe.length);
      Oe = re.concat([Ne, Oe]);
    }
    return Oe;
  }
  function Pe(Ve, Ae, Oe) {
    var Ne, He;
    do {
      for (Ne = re.alloc(0); Ne.length * 8 < Ve.bitLength(); )
        Ae.v = ne(Oe, Ae.k).update(Ae.v).digest(), Ne = re.concat([Ne, Ae.v]);
      He = be(Ne, Ve), Ae.k = ne(Oe, Ae.k).update(Ae.v).update(re.from([0])).digest(), Ae.v = ne(Oe, Ae.k).update(Ae.v).digest();
    } while (He.cmp(Ve) !== -1);
    return He;
  }
  function Ee(Ve, Ae, Oe, Ne) {
    return Ve.toRed(le.mont(Oe)).redPow(Ae).fromRed().mod(Ne);
  }
  return sign.exports = de, sign.exports.getKey = ge, sign.exports.makeKey = Pe, sign.exports;
}
var verify_1, hasRequiredVerify;
function requireVerify() {
  if (hasRequiredVerify) return verify_1;
  hasRequiredVerify = 1;
  var re = safeBufferExports$1.Buffer, ne = bnExports, ae = requireElliptic().ec, ie = parseAsn1, le = require$$4;
  function se(me, fe, pe, ge, be) {
    var Se = ie(pe);
    if (Se.type === "ec") {
      if (ge !== "ecdsa" && ge !== "ecdsa/rsa")
        throw new Error("wrong public key type");
      return ce(me, fe, Se);
    } else if (Se.type === "dsa") {
      if (ge !== "dsa")
        throw new Error("wrong public key type");
      return ue(me, fe, Se);
    }
    if (ge !== "rsa" && ge !== "ecdsa/rsa")
      throw new Error("wrong public key type");
    fe = re.concat([be, fe]);
    for (var Pe = Se.modulus.byteLength(), Ee = [1], Ve = 0; fe.length + Ee.length + 2 < Pe; )
      Ee.push(255), Ve += 1;
    Ee.push(0);
    for (var Ae = -1; ++Ae < fe.length; )
      Ee.push(fe[Ae]);
    Ee = re.from(Ee);
    var Oe = ne.mont(Se.modulus);
    me = new ne(me).toRed(Oe), me = me.redPow(new ne(Se.publicExponent)), me = re.from(me.fromRed().toArray());
    var Ne = Ve < 8 ? 1 : 0;
    for (Pe = Math.min(me.length, Ee.length), me.length !== Ee.length && (Ne = 1), Ae = -1; ++Ae < Pe; )
      Ne |= me[Ae] ^ Ee[Ae];
    return Ne === 0;
  }
  function ce(me, fe, pe) {
    var ge = le[pe.data.algorithm.curve.join(".")];
    if (!ge)
      throw new Error("unknown curve " + pe.data.algorithm.curve.join("."));
    var be = new ae(ge), Se = pe.data.subjectPrivateKey.data;
    return be.verify(fe, me, Se);
  }
  function ue(me, fe, pe) {
    var ge = pe.data.p, be = pe.data.q, Se = pe.data.g, Pe = pe.data.pub_key, Ee = ie.signature.decode(me, "der"), Ve = Ee.s, Ae = Ee.r;
    de(Ve, be), de(Ae, be);
    var Oe = ne.mont(ge), Ne = Ve.invm(be), He = Se.toRed(Oe).redPow(new ne(fe).mul(Ne).mod(be)).fromRed().mul(Pe.toRed(Oe).redPow(Ae.mul(Ne).mod(be)).fromRed()).mod(ge).mod(be);
    return He.cmp(Ae) === 0;
  }
  function de(me, fe) {
    if (me.cmpn(0) <= 0)
      throw new Error("invalid sig");
    if (me.cmp(fe) >= 0)
      throw new Error("invalid sig");
  }
  return verify_1 = se, verify_1;
}
var browser$3, hasRequiredBrowser$1;
function requireBrowser$1() {
  if (hasRequiredBrowser$1) return browser$3;
  hasRequiredBrowser$1 = 1;
  var re = safeBufferExports$1.Buffer, ne = browser$9, ae = readableBrowserExports, ie = inherits_browserExports, le = requireSign(), se = requireVerify(), ce = require$$6;
  Object.keys(ce).forEach(function(pe) {
    ce[pe].id = re.from(ce[pe].id, "hex"), ce[pe.toLowerCase()] = ce[pe];
  });
  function ue(pe) {
    ae.Writable.call(this);
    var ge = ce[pe];
    if (!ge)
      throw new Error("Unknown message digest");
    this._hashType = ge.hash, this._hash = ne(ge.hash), this._tag = ge.id, this._signType = ge.sign;
  }
  ie(ue, ae.Writable), ue.prototype._write = function(ge, be, Se) {
    this._hash.update(ge), Se();
  }, ue.prototype.update = function(ge, be) {
    return this._hash.update(typeof ge == "string" ? re.from(ge, be) : ge), this;
  }, ue.prototype.sign = function(ge, be) {
    this.end();
    var Se = this._hash.digest(), Pe = le(Se, ge, this._hashType, this._signType, this._tag);
    return be ? Pe.toString(be) : Pe;
  };
  function de(pe) {
    ae.Writable.call(this);
    var ge = ce[pe];
    if (!ge)
      throw new Error("Unknown message digest");
    this._hash = ne(ge.hash), this._tag = ge.id, this._signType = ge.sign;
  }
  ie(de, ae.Writable), de.prototype._write = function(ge, be, Se) {
    this._hash.update(ge), Se();
  }, de.prototype.update = function(ge, be) {
    return this._hash.update(typeof ge == "string" ? re.from(ge, be) : ge), this;
  }, de.prototype.verify = function(ge, be, Se) {
    var Pe = typeof be == "string" ? re.from(be, Se) : be;
    this.end();
    var Ee = this._hash.digest();
    return se(Pe, Ee, ge, this._signType, this._tag);
  };
  function me(pe) {
    return new ue(pe);
  }
  function fe(pe) {
    return new de(pe);
  }
  return browser$3 = {
    Sign: me,
    Verify: fe,
    createSign: me,
    createVerify: fe
  }, browser$3;
}
var browser$2, hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser) return browser$2;
  hasRequiredBrowser = 1;
  var re = requireElliptic(), ne = bnExports$2;
  browser$2 = function(ce) {
    return new ie(ce);
  };
  var ae = {
    secp256k1: {
      name: "secp256k1",
      byteLength: 32
    },
    secp224r1: {
      name: "p224",
      byteLength: 28
    },
    prime256v1: {
      name: "p256",
      byteLength: 32
    },
    prime192v1: {
      name: "p192",
      byteLength: 24
    },
    ed25519: {
      name: "ed25519",
      byteLength: 32
    },
    secp384r1: {
      name: "p384",
      byteLength: 48
    },
    secp521r1: {
      name: "p521",
      byteLength: 66
    }
  };
  ae.p224 = ae.secp224r1, ae.p256 = ae.secp256r1 = ae.prime256v1, ae.p192 = ae.secp192r1 = ae.prime192v1, ae.p384 = ae.secp384r1, ae.p521 = ae.secp521r1;
  function ie(se) {
    this.curveType = ae[se], this.curveType || (this.curveType = {
      name: se
    }), this.curve = new re.ec(this.curveType.name), this.keys = void 0;
  }
  ie.prototype.generateKeys = function(se, ce) {
    return this.keys = this.curve.genKeyPair(), this.getPublicKey(se, ce);
  }, ie.prototype.computeSecret = function(se, ce, ue) {
    ce = ce || "utf8", Buffer$D.isBuffer(se) || (se = new Buffer$D(se, ce));
    var de = this.curve.keyFromPublic(se).getPublic(), me = de.mul(this.keys.getPrivate()).getX();
    return le(me, ue, this.curveType.byteLength);
  }, ie.prototype.getPublicKey = function(se, ce) {
    var ue = this.keys.getPublic(ce === "compressed", !0);
    return ce === "hybrid" && (ue[ue.length - 1] % 2 ? ue[0] = 7 : ue[0] = 6), le(ue, se);
  }, ie.prototype.getPrivateKey = function(se) {
    return le(this.keys.getPrivate(), se);
  }, ie.prototype.setPublicKey = function(se, ce) {
    return ce = ce || "utf8", Buffer$D.isBuffer(se) || (se = new Buffer$D(se, ce)), this.keys._importPublic(se), this;
  }, ie.prototype.setPrivateKey = function(se, ce) {
    ce = ce || "utf8", Buffer$D.isBuffer(se) || (se = new Buffer$D(se, ce));
    var ue = new ne(se);
    return ue = ue.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(ue), this;
  };
  function le(se, ce, ue) {
    Array.isArray(se) || (se = se.toArray());
    var de = new Buffer$D(se);
    if (ue && de.length < ue) {
      var me = new Buffer$D(ue - de.length);
      me.fill(0), de = Buffer$D.concat([me, de]);
    }
    return ce ? de.toString(ce) : de;
  }
  return browser$2;
}
var browser$1 = {}, createHash$2 = browser$9, Buffer$4 = safeBufferExports$1.Buffer, mgf$2 = function(re, ne) {
  for (var ae = Buffer$4.alloc(0), ie = 0, le; ae.length < ne; )
    le = i2ops(ie++), ae = Buffer$4.concat([ae, createHash$2("sha1").update(re).update(le).digest()]);
  return ae.slice(0, ne);
};
function i2ops(re) {
  var ne = Buffer$4.allocUnsafe(4);
  return ne.writeUInt32BE(re, 0), ne;
}
var xor$2 = function re(ne, ae) {
  for (var ie = ne.length, le = -1; ++le < ie; )
    ne[le] ^= ae[le];
  return ne;
}, BN$2 = bnExports$2, Buffer$3 = safeBufferExports$1.Buffer;
function withPublic$2(re, ne) {
  return Buffer$3.from(re.toRed(BN$2.mont(ne.modulus)).redPow(new BN$2(ne.publicExponent)).fromRed().toArray());
}
var withPublic_1 = withPublic$2, parseKeys$1 = parseAsn1, randomBytes = browserExports, createHash$1 = browser$9, mgf$1 = mgf$2, xor$1 = xor$2, BN$1 = bnExports$2, withPublic$1 = withPublic_1, crt$1 = browserifyRsa, Buffer$2 = safeBufferExports$1.Buffer, publicEncrypt = function re(ne, ae, ie) {
  var le;
  ne.padding ? le = ne.padding : ie ? le = 1 : le = 4;
  var se = parseKeys$1(ne), ce;
  if (le === 4)
    ce = oaep$1(se, ae);
  else if (le === 1)
    ce = pkcs1$1(se, ae, ie);
  else if (le === 3) {
    if (ce = new BN$1(ae), ce.cmp(se.modulus) >= 0)
      throw new Error("data too long for modulus");
  } else
    throw new Error("unknown padding");
  return ie ? crt$1(ce, se) : withPublic$1(ce, se);
};
function oaep$1(re, ne) {
  var ae = re.modulus.byteLength(), ie = ne.length, le = createHash$1("sha1").update(Buffer$2.alloc(0)).digest(), se = le.length, ce = 2 * se;
  if (ie > ae - ce - 2)
    throw new Error("message too long");
  var ue = Buffer$2.alloc(ae - ie - ce - 2), de = ae - se - 1, me = randomBytes(se), fe = xor$1(Buffer$2.concat([le, ue, Buffer$2.alloc(1, 1), ne], de), mgf$1(me, de)), pe = xor$1(me, mgf$1(fe, se));
  return new BN$1(Buffer$2.concat([Buffer$2.alloc(1), pe, fe], ae));
}
function pkcs1$1(re, ne, ae) {
  var ie = ne.length, le = re.modulus.byteLength();
  if (ie > le - 11)
    throw new Error("message too long");
  var se;
  return ae ? se = Buffer$2.alloc(le - ie - 3, 255) : se = nonZero(le - ie - 3), new BN$1(Buffer$2.concat([Buffer$2.from([0, ae ? 1 : 2]), se, Buffer$2.alloc(1), ne], le));
}
function nonZero(re) {
  for (var ne = Buffer$2.allocUnsafe(re), ae = 0, ie = randomBytes(re * 2), le = 0, se; ae < re; )
    le === ie.length && (ie = randomBytes(re * 2), le = 0), se = ie[le++], se && (ne[ae++] = se);
  return ne;
}
var parseKeys = parseAsn1, mgf = mgf$2, xor = xor$2, BN = bnExports$2, crt = browserifyRsa, createHash = browser$9, withPublic = withPublic_1, Buffer$1 = safeBufferExports$1.Buffer, privateDecrypt = function re(ne, ae, ie) {
  var le;
  ne.padding ? le = ne.padding : ie ? le = 1 : le = 4;
  var se = parseKeys(ne), ce = se.modulus.byteLength();
  if (ae.length > ce || new BN(ae).cmp(se.modulus) >= 0)
    throw new Error("decryption error");
  var ue;
  ie ? ue = withPublic(new BN(ae), se) : ue = crt(ae, se);
  var de = Buffer$1.alloc(ce - ue.length);
  if (ue = Buffer$1.concat([de, ue], ce), le === 4)
    return oaep(se, ue);
  if (le === 1)
    return pkcs1(se, ue, ie);
  if (le === 3)
    return ue;
  throw new Error("unknown padding");
};
function oaep(re, ne) {
  var ae = re.modulus.byteLength(), ie = createHash("sha1").update(Buffer$1.alloc(0)).digest(), le = ie.length;
  if (ne[0] !== 0)
    throw new Error("decryption error");
  var se = ne.slice(1, le + 1), ce = ne.slice(le + 1), ue = xor(se, mgf(ce, le)), de = xor(ce, mgf(ue, ae - le - 1));
  if (compare(ie, de.slice(0, le)))
    throw new Error("decryption error");
  for (var me = le; de[me] === 0; )
    me++;
  if (de[me++] !== 1)
    throw new Error("decryption error");
  return de.slice(me);
}
function pkcs1(re, ne, ae) {
  for (var ie = ne.slice(0, 2), le = 2, se = 0; ne[le++] !== 0; )
    if (le >= ne.length) {
      se++;
      break;
    }
  var ce = ne.slice(2, le - 1);
  if ((ie.toString("hex") !== "0002" && !ae || ie.toString("hex") !== "0001" && ae) && se++, ce.length < 8 && se++, se)
    throw new Error("decryption error");
  return ne.slice(le);
}
function compare(re, ne) {
  re = Buffer$1.from(re), ne = Buffer$1.from(ne);
  var ae = 0, ie = re.length;
  re.length !== ne.length && (ae++, ie = Math.min(re.length, ne.length));
  for (var le = -1; ++le < ie; )
    ae += re[le] ^ ne[le];
  return ae;
}
(function(re) {
  re.publicEncrypt = publicEncrypt, re.privateDecrypt = privateDecrypt, re.privateEncrypt = function(ae, ie) {
    return re.publicEncrypt(ae, ie, !0);
  }, re.publicDecrypt = function(ae, ie) {
    return re.privateDecrypt(ae, ie, !0);
  };
})(browser$1);
var browser = {};
function oldBrowser() {
  throw new Error(`secure random number generation not supported by this browser
use chrome, FireFox or Internet Explorer 11`);
}
var safeBuffer = safeBufferExports$1, randombytes = browserExports, Buffer = safeBuffer.Buffer, kBufferMaxLength = safeBuffer.kMaxLength, crypto$1 = commonjsGlobal.crypto || commonjsGlobal.msCrypto, kMaxUint32 = Math.pow(2, 32) - 1;
function assertOffset(re, ne) {
  if (typeof re != "number" || re !== re)
    throw new TypeError("offset must be a number");
  if (re > kMaxUint32 || re < 0)
    throw new TypeError("offset must be a uint32");
  if (re > kBufferMaxLength || re > ne)
    throw new RangeError("offset out of range");
}
function assertSize(re, ne, ae) {
  if (typeof re != "number" || re !== re)
    throw new TypeError("size must be a number");
  if (re > kMaxUint32 || re < 0)
    throw new TypeError("size must be a uint32");
  if (re + ne > ae || re > kBufferMaxLength)
    throw new RangeError("buffer too small");
}
crypto$1 && crypto$1.getRandomValues || !process$1.browser ? (browser.randomFill = randomFill, browser.randomFillSync = randomFillSync) : (browser.randomFill = oldBrowser, browser.randomFillSync = oldBrowser);
function randomFill(re, ne, ae, ie) {
  if (!Buffer.isBuffer(re) && !(re instanceof commonjsGlobal.Uint8Array))
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
  if (typeof ne == "function")
    ie = ne, ne = 0, ae = re.length;
  else if (typeof ae == "function")
    ie = ae, ae = re.length - ne;
  else if (typeof ie != "function")
    throw new TypeError('"cb" argument must be a function');
  return assertOffset(ne, re.length), assertSize(ae, ne, re.length), actualFill(re, ne, ae, ie);
}
function actualFill(re, ne, ae, ie) {
  if (process$1.browser) {
    var le = re.buffer, se = new Uint8Array(le, ne, ae);
    if (crypto$1.getRandomValues(se), ie) {
      process$1.nextTick(function() {
        ie(null, re);
      });
      return;
    }
    return re;
  }
  if (ie) {
    randombytes(ae, function(ue, de) {
      if (ue)
        return ie(ue);
      de.copy(re, ne), ie(null, re);
    });
    return;
  }
  var ce = randombytes(ae);
  return ce.copy(re, ne), re;
}
function randomFillSync(re, ne, ae) {
  if (typeof ne > "u" && (ne = 0), !Buffer.isBuffer(re) && !(re instanceof commonjsGlobal.Uint8Array))
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
  return assertOffset(ne, re.length), ae === void 0 && (ae = re.length - ne), assertSize(ae, ne, re.length), actualFill(re, ne, ae);
}
var hasRequiredCryptoBrowserify;
function requireCryptoBrowserify() {
  if (hasRequiredCryptoBrowserify) return cryptoBrowserify;
  hasRequiredCryptoBrowserify = 1, cryptoBrowserify.randomBytes = cryptoBrowserify.rng = cryptoBrowserify.pseudoRandomBytes = cryptoBrowserify.prng = browserExports, cryptoBrowserify.createHash = cryptoBrowserify.Hash = browser$9, cryptoBrowserify.createHmac = cryptoBrowserify.Hmac = browser$8;
  var re = algos, ne = Object.keys(re), ae = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
  ].concat(ne);
  cryptoBrowserify.getHashes = function() {
    return ae;
  };
  var ie = browser$7;
  cryptoBrowserify.pbkdf2 = ie.pbkdf2, cryptoBrowserify.pbkdf2Sync = ie.pbkdf2Sync;
  var le = browser$6;
  cryptoBrowserify.Cipher = le.Cipher, cryptoBrowserify.createCipher = le.createCipher, cryptoBrowserify.Cipheriv = le.Cipheriv, cryptoBrowserify.createCipheriv = le.createCipheriv, cryptoBrowserify.Decipher = le.Decipher, cryptoBrowserify.createDecipher = le.createDecipher, cryptoBrowserify.Decipheriv = le.Decipheriv, cryptoBrowserify.createDecipheriv = le.createDecipheriv, cryptoBrowserify.getCiphers = le.getCiphers, cryptoBrowserify.listCiphers = le.listCiphers;
  var se = requireBrowser$2();
  cryptoBrowserify.DiffieHellmanGroup = se.DiffieHellmanGroup, cryptoBrowserify.createDiffieHellmanGroup = se.createDiffieHellmanGroup, cryptoBrowserify.getDiffieHellman = se.getDiffieHellman, cryptoBrowserify.createDiffieHellman = se.createDiffieHellman, cryptoBrowserify.DiffieHellman = se.DiffieHellman;
  var ce = requireBrowser$1();
  cryptoBrowserify.createSign = ce.createSign, cryptoBrowserify.Sign = ce.Sign, cryptoBrowserify.createVerify = ce.createVerify, cryptoBrowserify.Verify = ce.Verify, cryptoBrowserify.createECDH = requireBrowser();
  var ue = browser$1;
  cryptoBrowserify.publicEncrypt = ue.publicEncrypt, cryptoBrowserify.privateEncrypt = ue.privateEncrypt, cryptoBrowserify.publicDecrypt = ue.publicDecrypt, cryptoBrowserify.privateDecrypt = ue.privateDecrypt;
  var de = browser;
  return cryptoBrowserify.randomFill = de.randomFill, cryptoBrowserify.randomFillSync = de.randomFillSync, cryptoBrowserify.createCredentials = function() {
    throw new Error(`sorry, createCredentials is not implemented yet
we accept pull requests
https://github.com/browserify/crypto-browserify`);
  }, cryptoBrowserify.constants = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
  }, cryptoBrowserify;
}
var cryptoBrowserifyExports = requireCryptoBrowserify();
const crypto = /* @__PURE__ */ getDefaultExportFromCjs(cryptoBrowserifyExports), hashString = (re) => {
  const ne = crypto.createHash("sha256");
  return ne.update(re), ne.digest().toString("hex");
}, emailOrPublicUser = (re, ne) => re || `Public User (${ne})`, gainsightIdentity = (re, ne, ae) => {
  const ie = emailOrPublicUser(ae, ne.appName);
  return `
    aptrinsic("identify",
      {
        "id": "${hashString(ie)}",
        "email": "${ae || ""}",
        "appversion": "${re}",
        "userlicensetype": "Standard",
        "userrole": "Standard",
        "userauthmethod": "SSO"
      },
      {
        "id": "${ne.applicationId}",
        "name": "${ne.accountName}",
        "parentGroupId": "${ne.customerId}",
        "plan": "${ne.subscriptionName}",
        "IdeagenSKU": "${ne.productSku}",
        "sfdcId": "${ne.customerId}"
      }
    );`;
}, injectIdentityCodeScript = (re, ne, ae) => {
  const ie = "gainsightIdScript", le = document.createElement("script"), se = gainsightConfig(
    re.gainsightApplicationId,
    re.gainsightClientName,
    re.gainsightProductTag,
    re.gainsightAppName
  ), ce = gainsightIdentity(ne, se, ae);
  le.id = ie, le.text = ce;
  const ue = document.getElementById(ie);
  ue ? ue.parentNode.replaceChild(le, ue) : document.head.appendChild(le);
}, setupGainsight = async (re, ne, ae) => {
  injectTrackingCodeScript(re), await injectIdentityCodeScript(re, ne, ae);
}, gainsightService = {
  getSiteInfo: async (re, ne) => getSiteInfo(re, ne),
  setupGainsight: async (re, ne, ae) => setupGainsight(re, ne, ae)
}, makeVAppProps = propsFactory({
  ...makeComponentProps(),
  ...makeLayoutProps({
    fullHeight: !0
  }),
  ...makeThemeProps()
}, "VApp"), VApp = genericComponent()({
  name: "VApp",
  props: makeVAppProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = provideTheme(re), {
      layoutClasses: le,
      getLayoutItem: se,
      items: ce,
      layoutRef: ue
    } = createLayout(re), {
      rtlClasses: de
    } = useRtl();
    return useRender(() => {
      var me;
      return createVNode("div", {
        ref: ue,
        class: ["v-application", ie.themeClasses.value, le.value, de.value, re.class],
        style: [re.style]
      }, [createVNode("div", {
        class: "v-application__wrap"
      }, [(me = ae.default) == null ? void 0 : me.call(ae)])]);
    }), {
      getLayoutItem: se,
      items: ce,
      theme: ie
    };
  }
}), makeVFooterProps = propsFactory({
  app: Boolean,
  color: String,
  height: {
    type: [Number, String],
    default: "auto"
  },
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeElevationProps(),
  ...makeLayoutItemProps(),
  ...makeRoundedProps(),
  ...makeTagProps({
    tag: "footer"
  }),
  ...makeThemeProps()
}, "VFooter"), VFooter = genericComponent()({
  name: "VFooter",
  props: makeVFooterProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = ref$1(), {
      themeClasses: le
    } = provideTheme(re), {
      backgroundColorClasses: se,
      backgroundColorStyles: ce
    } = useBackgroundColor(toRef(re, "color")), {
      borderClasses: ue
    } = useBorder(re), {
      elevationClasses: de
    } = useElevation(re), {
      roundedClasses: me
    } = useRounded(re), fe = shallowRef(32), {
      resizeRef: pe
    } = useResizeObserver((be) => {
      be.length && (fe.value = be[0].target.clientHeight);
    }), ge = computed(() => re.height === "auto" ? fe.value : parseInt(re.height, 10));
    return useToggleScope(() => re.app, () => {
      const be = useLayoutItem({
        id: re.name,
        order: computed(() => parseInt(re.order, 10)),
        position: computed(() => "bottom"),
        layoutSize: ge,
        elementSize: computed(() => re.height === "auto" ? void 0 : ge.value),
        active: computed(() => re.app),
        absolute: toRef(re, "absolute")
      });
      watchEffect(() => {
        ie.value = be.layoutItemStyles.value;
      });
    }), useRender(() => createVNode(re.tag, {
      ref: pe,
      class: ["v-footer", le.value, se.value, ue.value, de.value, me.value, re.class],
      style: [ce.value, re.app ? ie.value : {
        height: convertToUnit(re.height)
      }, re.style]
    }, ae)), {};
  }
}), makeVMainProps = propsFactory({
  scrollable: Boolean,
  ...makeComponentProps(),
  ...makeDimensionProps(),
  ...makeTagProps({
    tag: "main"
  })
}, "VMain"), VMain = genericComponent()({
  name: "VMain",
  props: makeVMainProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      dimensionStyles: ie
    } = useDimension(re), {
      mainStyles: le
    } = useLayout(), {
      ssrBootStyles: se
    } = useSsrBoot();
    return useRender(() => createVNode(re.tag, {
      class: ["v-main", {
        "v-main--scrollable": re.scrollable
      }, re.class],
      style: [le.value, se.value, ie.value, re.style]
    }, {
      default: () => {
        var ce, ue;
        return [re.scrollable ? createVNode("div", {
          class: "v-main__scroller"
        }, [(ce = ae.default) == null ? void 0 : ce.call(ae)]) : (ue = ae.default) == null ? void 0 : ue.call(ae)];
      }
    })), {};
  }
}), _sfc_main$T = {
  name: "CSApp",
  extends: CSBase,
  props: {
    id: { type: String, required: !1, default: "" },
    sideNavWidth: { type: Number, required: !1, default: 0 },
    appLogoUri: { type: String, required: !1, default: "" },
    customerLogoUri: { type: String, required: !1, default: "" },
    customerLogoWidth: { type: Number, required: !1, default: 125 },
    customerName: { type: String, required: !1, default: "" },
    showHeader: { type: Boolean, required: !1, default: !1 },
    homeRoute: { type: String, required: !1, default: "" },
    publicView: { type: Boolean, required: !1, default: !1 },
    headerProfile: {
      type: CSHeaderProfileProps,
      required: !1,
      default: void 0
    },
    feedbackBtn: {
      type: CSHeaderButtonProps,
      required: !1,
      default: void 0
    },
    helpBtn: {
      type: CSHeaderButtonProps,
      required: !1,
      default: void 0
    },
    searchBtn: {
      type: CSHeaderActiveButtonProps,
      required: !1,
      default: void 0
    },
    updateBtn: {
      type: CSHeaderButtonProps,
      required: !1,
      default: void 0
    },
    viewBtn: {
      type: CSHeaderActiveButtonProps,
      required: !1,
      default: void 0
    },
    settingsBtn: {
      type: CSHeaderButtonProps,
      required: !1,
      default: void 0
    },
    version: { type: String, required: !1, default: "" },
    versionInUserProfile: {
      type: String,
      required: !1,
      default: void 0
    }
  },
  emits: [
    "feedback-btn-click",
    "search-btn-click",
    "help-btn-click",
    "update-btn-click",
    "view-btn-click",
    "settings-btn-click"
  ],
  data() {
    return {
      showLoadingDialog: !1,
      tokenValidated: !1,
      shouldUpdateGainsight: !1,
      isRouteNameReady: !1
    };
  },
  computed: {
    ...mapState({
      cursor: (re) => re["cs-appearance"].cursor,
      showSideNav: (re) => re["cs-appearance"].showSideNav
    }),
    ...mapGetters({
      user: "cs-session/user"
    }),
    cssShowSideNav() {
      return {
        marginLeft: `${this.showSideNav ? this.sideNavWidth - 20 : 0}px`
      };
    },
    cssAlert() {
      return this.sideNavWidth ? "pl-3" : "";
    },
    isOnLogInPage() {
      return this.$route.name === "login";
    },
    isReadyToSetupGainsight() {
      return this.shouldUpdateGainsight && this.isRouteNameReady;
    }
  },
  watch: {
    cursor(re) {
      switch (re) {
        case "progress":
          document.body.classList.add("busy-cursor"), this.showLoadingDialog = !0;
          break;
        default:
          document.body.classList.remove("busy-cursor"), this.showLoadingDialog = !1;
          break;
      }
    },
    headerProfile: {
      handler(re) {
        re && (this.shouldUpdateGainsight = !0);
      },
      deep: !0,
      immediate: !0
    },
    "$route.name": {
      handler(re) {
        re && (this.isRouteNameReady = !0);
      },
      immediate: !0
    },
    isReadyToSetupGainsight: {
      async handler(re) {
        re && await this.setupGainsight();
      },
      immediate: !0
    }
  },
  async created() {
    this.$store._actions["auth0/getRemoteClientAppConfig"] && await this.$store.dispatch("auth0/getRemoteClientAppConfig"), window.addEventListener("resize", this.resizeHandler), this.$store.getters["cs-session/isLoggedIn"] && Auth0State.loading && watch(
      () => Auth0State.loading,
      () => {
        !Auth0State.loading && !this.tokenValidated && this.getToken();
      }
    );
  },
  async mounted() {
    this.$store.getters["cs-session/isLoggedIn"] && !Auth0State.loading && await this.getToken();
  },
  methods: {
    async getToken() {
      this.tokenValidated = !0, await this.$store.dispatch("cs-session/getToken");
    },
    resizeHandler() {
      this.setShowSideNav(this.showSideNav);
    },
    onClickSideBarArrowBtn() {
      this.setShowSideNav(!this.showSideNav);
    },
    onFeedbackBtn() {
      this.$emit("feedback-btn-click");
    },
    async onHelpBtn() {
      this.$emit("help-btn-click");
    },
    async onSearchBtn() {
      this.$emit("search-btn-click");
    },
    async onUpdateBtn() {
      this.$emit("update-btn-click");
    },
    async onViewBtn() {
      this.$emit("view-btn-click");
    },
    async onSettingsBtn() {
      this.$emit("settings-btn-click");
    },
    async setupGainsight() {
      var re, ne, ae;
      try {
        if (this.$store.getters["gainsight/isEnabled"] && (this.isOnLogInPage && this.$store.dispatch("gainsight/resetGainsight"), await this.$store.dispatch("gainsight/initGainsight")), this.$store.getters["gainsight/isAvailable"]) {
          const ie = ((ne = (re = this.headerProfile) == null ? void 0 : re.user) == null ? void 0 : ne.email) || ((ae = this.user) == null ? void 0 : ae.email) || void 0;
          await gainsightService.setupGainsight(
            this.$store.state.gainsight.gainsightModel,
            this.version,
            ie
          );
        }
        this.shouldUpdateGainsight = !1;
      } catch (ie) {
        console.error("Failed to setup gainsight:", ie.message);
      }
    }
  }
};
function _sfc_render$T(re, ne, ae, ie, le, se) {
  const ce = resolveComponent("cs-header"), ue = resolveComponent("cs-side-nav"), de = resolveComponent("cs-alert");
  return openBlock(), createBlock(VApp, {
    id: ae.id,
    class: "cs-app"
  }, {
    default: withCtx(() => [
      ae.showHeader && !se.isOnLogInPage ? (openBlock(), createBlock(ce, {
        key: 0,
        class: "cs-header",
        "app-logo-uri": ae.appLogoUri,
        "header-profile": ae.headerProfile,
        "home-route": ae.homeRoute,
        "feedback-btn": ae.feedbackBtn,
        "help-btn": ae.helpBtn,
        "search-btn": ae.searchBtn,
        "update-btn": ae.updateBtn,
        "view-btn": ae.viewBtn,
        "settings-btn": ae.settingsBtn,
        "public-view": ae.publicView,
        "version-in-user-profile": ae.versionInUserProfile,
        onFeedbackBtnClick: se.onFeedbackBtn,
        onHelpBtnClick: se.onHelpBtn,
        onSearchBtnClick: se.onSearchBtn,
        onUpdateBtnClick: se.onUpdateBtn,
        onViewBtnClick: se.onViewBtn,
        onSettingsBtnClick: se.onSettingsBtn
      }, createSlots({
        "header-menu": withCtx(() => [
          renderSlot(re.$slots, "header-menu", {}, void 0, !0)
        ]),
        "header-left": withCtx(() => [
          renderSlot(re.$slots, "header-left", {}, void 0, !0)
        ]),
        "header-right-2": withCtx(() => [
          renderSlot(re.$slots, "header-right-2", {}, void 0, !0)
        ]),
        "header-right": withCtx(() => [
          renderSlot(re.$slots, "header-right", {}, void 0, !0)
        ]),
        _: 2
      }, [
        re.$slots["header-help-menu"] ? {
          name: "header-help-menu",
          fn: withCtx(() => [
            renderSlot(re.$slots, "header-help-menu", {}, void 0, !0)
          ]),
          key: "0"
        } : void 0,
        re.$slots["header-searcy-menu"] ? {
          name: "header-search-menu",
          fn: withCtx(() => [
            renderSlot(re.$slots, "header-search-menu", {}, void 0, !0)
          ]),
          key: "1"
        } : void 0,
        re.$slots["header-update-menu"] ? {
          name: "header-update-menu",
          fn: withCtx(() => [
            renderSlot(re.$slots, "header-update-menu", {}, void 0, !0)
          ]),
          key: "2"
        } : void 0,
        re.$slots["header-view-menu"] ? {
          name: "header-view-menu",
          fn: withCtx(() => [
            renderSlot(re.$slots, "header-view-menu", {}, void 0, !0)
          ]),
          key: "3"
        } : void 0,
        re.$slots["header-settings-menu"] ? {
          name: "header-settings-menu",
          fn: withCtx(() => [
            renderSlot(re.$slots, "header-settings-menu", {}, void 0, !0)
          ]),
          key: "4"
        } : void 0
      ]), 1032, ["app-logo-uri", "header-profile", "home-route", "feedback-btn", "help-btn", "search-btn", "update-btn", "view-btn", "settings-btn", "public-view", "version-in-user-profile", "onFeedbackBtnClick", "onHelpBtnClick", "onSearchBtnClick", "onUpdateBtnClick", "onViewBtnClick", "onSettingsBtnClick"])) : createCommentVNode("", !0),
      ae.sideNavWidth && !se.isOnLogInPage ? (openBlock(), createElementBlock("div", {
        key: 1,
        id: "cs-app--side-bar-arrow-btn",
        class: "cs-app-split-bar-arrow",
        style: normalizeStyle(se.cssShowSideNav),
        onClick: ne[0] || (ne[0] = (...me) => se.onClickSideBarArrowBtn && se.onClickSideBarArrowBtn(...me))
      }, [
        createVNode(VBtn, {
          size: "x-small",
          ripple: !1,
          color: "primary",
          icon: re.showSideNav ? "mdi-menu-left" : "mdi-menu-right"
        }, null, 8, ["icon"])
      ], 4)) : createCommentVNode("", !0),
      ae.sideNavWidth && !se.isOnLogInPage ? (openBlock(), createBlock(ue, {
        key: 2,
        modelValue: re.showSideNav,
        "onUpdate:modelValue": ne[1] || (ne[1] = (me) => re.showSideNav = me),
        version: ae.version,
        width: ae.sideNavWidth,
        "customer-logo-uri": ae.customerLogoUri,
        "customer-logo-width": ae.customerLogoWidth,
        "customer-name": ae.customerName
      }, {
        "side-nav": withCtx(() => [
          renderSlot(re.$slots, "side-nav", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["modelValue", "version", "width", "customer-logo-uri", "customer-logo-width", "customer-name"])) : createCommentVNode("", !0),
      renderSlot(re.$slots, "right-side-nav", {}, void 0, !0),
      createVNode(VMain, { class: "main" }, {
        default: withCtx(() => [
          createElementVNode("div", {
            class: normalizeClass(ae.showHeader ? "cs-app-header-alert" : "cs-app-alert")
          }, [
            createVNode(de, {
              id: "cs-alert",
              class: normalizeClass(se.cssAlert)
            }, null, 8, ["class"])
          ], 2),
          renderSlot(re.$slots, "router-view", {}, void 0, !0)
        ]),
        _: 3
      }),
      ae.sideNavWidth ? createCommentVNode("", !0) : (openBlock(), createBlock(VFooter, {
        key: 3,
        class: "cs-footer"
      }, {
        default: withCtx(() => [
          renderSlot(re.$slots, "footer", {}, void 0, !0)
        ]),
        _: 3
      }))
    ]),
    _: 3
  }, 8, ["id"]);
}
const CSApp = /* @__PURE__ */ _export_sfc(_sfc_main$T, [["render", _sfc_render$T], ["__scopeId", "data-v-60938a2c"]]), AxiosPlugin = {
  install(re, { axios: ne, store: ae }) {
    ne.interceptors.request.use((ie) => ie.headers.Authorization ? ie : ae.dispatch("cs-session/getToken").then((le) => (le && (ie.headers.Authorization = `Bearer ${le}`), ie)));
  }
};
new TextEncoder();
const decoder = new TextDecoder(), decodeBase64 = (re) => {
  const ne = atob(re), ae = new Uint8Array(ne.length);
  for (let ie = 0; ie < ne.length; ie++)
    ae[ie] = ne.charCodeAt(ie);
  return ae;
}, decode$1 = (re) => {
  let ne = re;
  ne instanceof Uint8Array && (ne = decoder.decode(ne)), ne = ne.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
  try {
    return decodeBase64(ne);
  } catch {
    throw new TypeError("The input to be decoded is not correctly encoded.");
  }
};
class JOSEError extends Error {
  constructor(ne, ae) {
    var ie;
    super(ne, ae), this.code = "ERR_JOSE_GENERIC", this.name = this.constructor.name, (ie = Error.captureStackTrace) == null || ie.call(Error, this, this.constructor);
  }
}
JOSEError.code = "ERR_JOSE_GENERIC";
class JWTClaimValidationFailed extends JOSEError {
  constructor(ne, ae, ie = "unspecified", le = "unspecified") {
    super(ne, { cause: { claim: ie, reason: le, payload: ae } }), this.code = "ERR_JWT_CLAIM_VALIDATION_FAILED", this.claim = ie, this.reason = le, this.payload = ae;
  }
}
JWTClaimValidationFailed.code = "ERR_JWT_CLAIM_VALIDATION_FAILED";
class JWTExpired extends JOSEError {
  constructor(ne, ae, ie = "unspecified", le = "unspecified") {
    super(ne, { cause: { claim: ie, reason: le, payload: ae } }), this.code = "ERR_JWT_EXPIRED", this.claim = ie, this.reason = le, this.payload = ae;
  }
}
JWTExpired.code = "ERR_JWT_EXPIRED";
class JOSEAlgNotAllowed extends JOSEError {
  constructor() {
    super(...arguments), this.code = "ERR_JOSE_ALG_NOT_ALLOWED";
  }
}
JOSEAlgNotAllowed.code = "ERR_JOSE_ALG_NOT_ALLOWED";
class JOSENotSupported extends JOSEError {
  constructor() {
    super(...arguments), this.code = "ERR_JOSE_NOT_SUPPORTED";
  }
}
JOSENotSupported.code = "ERR_JOSE_NOT_SUPPORTED";
class JWEDecryptionFailed extends JOSEError {
  constructor(ne = "decryption operation failed", ae) {
    super(ne, ae), this.code = "ERR_JWE_DECRYPTION_FAILED";
  }
}
JWEDecryptionFailed.code = "ERR_JWE_DECRYPTION_FAILED";
class JWEInvalid extends JOSEError {
  constructor() {
    super(...arguments), this.code = "ERR_JWE_INVALID";
  }
}
JWEInvalid.code = "ERR_JWE_INVALID";
class JWSInvalid extends JOSEError {
  constructor() {
    super(...arguments), this.code = "ERR_JWS_INVALID";
  }
}
JWSInvalid.code = "ERR_JWS_INVALID";
class JWTInvalid extends JOSEError {
  constructor() {
    super(...arguments), this.code = "ERR_JWT_INVALID";
  }
}
JWTInvalid.code = "ERR_JWT_INVALID";
class JWKInvalid extends JOSEError {
  constructor() {
    super(...arguments), this.code = "ERR_JWK_INVALID";
  }
}
JWKInvalid.code = "ERR_JWK_INVALID";
class JWKSInvalid extends JOSEError {
  constructor() {
    super(...arguments), this.code = "ERR_JWKS_INVALID";
  }
}
JWKSInvalid.code = "ERR_JWKS_INVALID";
class JWKSNoMatchingKey extends JOSEError {
  constructor(ne = "no applicable key found in the JSON Web Key Set", ae) {
    super(ne, ae), this.code = "ERR_JWKS_NO_MATCHING_KEY";
  }
}
JWKSNoMatchingKey.code = "ERR_JWKS_NO_MATCHING_KEY";
class JWKSMultipleMatchingKeys extends JOSEError {
  constructor(ne = "multiple matching keys found in the JSON Web Key Set", ae) {
    super(ne, ae), this.code = "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
  }
}
JWKSMultipleMatchingKeys.code = "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
class JWKSTimeout extends JOSEError {
  constructor(ne = "request timed out", ae) {
    super(ne, ae), this.code = "ERR_JWKS_TIMEOUT";
  }
}
JWKSTimeout.code = "ERR_JWKS_TIMEOUT";
class JWSSignatureVerificationFailed extends JOSEError {
  constructor(ne = "signature verification failed", ae) {
    super(ne, ae), this.code = "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
  }
}
JWSSignatureVerificationFailed.code = "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
function isObjectLike$7(re) {
  return typeof re == "object" && re !== null;
}
function isObject$6(re) {
  if (!isObjectLike$7(re) || Object.prototype.toString.call(re) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(re) === null)
    return !0;
  let ne = re;
  for (; Object.getPrototypeOf(ne) !== null; )
    ne = Object.getPrototypeOf(ne);
  return Object.getPrototypeOf(re) === ne;
}
const decode = decode$1;
function decodeJwt(re) {
  if (typeof re != "string")
    throw new JWTInvalid("JWTs must use Compact JWS serialization, JWT must be a string");
  const { 1: ne, length: ae } = re.split(".");
  if (ae === 5)
    throw new JWTInvalid("Only JWTs using Compact JWS serialization can be decoded");
  if (ae !== 3)
    throw new JWTInvalid("Invalid JWT");
  if (!ne)
    throw new JWTInvalid("JWTs must contain a payload");
  let ie;
  try {
    ie = decode(ne);
  } catch {
    throw new JWTInvalid("Failed to base64url decode the payload");
  }
  let le;
  try {
    le = JSON.parse(decoder.decode(ie));
  } catch {
    throw new JWTInvalid("Failed to parse the decoded payload as JSON");
  }
  if (!isObject$6(le))
    throw new JWTInvalid("Invalid JWT Claims Set");
  return le;
}
const mutations$3 = {
  /* eslint-disable no-param-reassign, no-unused-vars */
  [RESET_SESSION](re) {
    re.user = null, re.token = null, re.decoded = null;
  },
  [SET_USER](re, ne) {
    re.user = ne;
  },
  [SET_TOKEN](re, ne) {
    re.token = ne, re.decoded = decodeJwt(re.token);
  },
  [SET_USER_GROUP_ALLOW_LIST](re, ne) {
    re.userGroupAllowList = ne;
  }
  /* eslint-enable no-param-reassign, no-unused-vars */
}, state$3 = {
  user: null,
  token: null,
  decoded: null,
  userGroupAllowList: []
}, getUser = (re) => {
  if (re)
    return re;
  const ne = localStorage.getItem(USER);
  if (!ne)
    return null;
  try {
    return User$1.unserialise(ne);
  } catch (ae) {
    return console.warn(`warning: failed to unserialise saved user dut to error ${ae.message}`), null;
  }
}, getters$3 = {
  isLoggedIn: (re) => !!getUser(re.user),
  user: (re) => getUser(re.user),
  token: (re) => re.token,
  isTokenExpiredByDate: (re) => (ne) => {
    if (!re.token || !re.decoded)
      return !0;
    const { exp: ae } = re.decoded;
    return ne.getTime() >= ae * 1e3;
  }
}, csSessionStore = {
  namespaced: !0,
  state: state$3,
  getters: getters$3,
  mutations: mutations$3,
  actions: actions$1
}, defaultState = {
  viewTitle: "",
  showSideNav: !0,
  alert: {
    type: null,
    message: null,
    onDialogOnly: !1,
    href: null,
    func: null
  },
  isLoading: !1,
  cursor: "default",
  dialogIsShown: !1,
  loginResetBtnTimeout: 5
};
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, _freeGlobal = freeGlobal$1, freeGlobal = _freeGlobal, freeSelf = typeof self == "object" && self && self.Object === Object && self, root$8 = freeGlobal || freeSelf || Function("return this")(), _root = root$8, root$7 = _root, Symbol$5 = root$7.Symbol, _Symbol = Symbol$5, Symbol$4 = _Symbol, objectProto$b = Object.prototype, hasOwnProperty$9 = objectProto$b.hasOwnProperty, nativeObjectToString$1 = objectProto$b.toString, symToStringTag$1 = Symbol$4 ? Symbol$4.toStringTag : void 0;
function getRawTag$1(re) {
  var ne = hasOwnProperty$9.call(re, symToStringTag$1), ae = re[symToStringTag$1];
  try {
    re[symToStringTag$1] = void 0;
    var ie = !0;
  } catch {
  }
  var le = nativeObjectToString$1.call(re);
  return ie && (ne ? re[symToStringTag$1] = ae : delete re[symToStringTag$1]), le;
}
var _getRawTag = getRawTag$1, objectProto$a = Object.prototype, nativeObjectToString = objectProto$a.toString;
function objectToString$2(re) {
  return nativeObjectToString.call(re);
}
var _objectToString = objectToString$2, Symbol$3 = _Symbol, getRawTag = _getRawTag, objectToString$1 = _objectToString, nullTag = "[object Null]", undefinedTag = "[object Undefined]", symToStringTag = Symbol$3 ? Symbol$3.toStringTag : void 0;
function baseGetTag$6(re) {
  return re == null ? re === void 0 ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(re) ? getRawTag(re) : objectToString$1(re);
}
var _baseGetTag = baseGetTag$6;
function isObjectLike$6(re) {
  return re != null && typeof re == "object";
}
var isObjectLike_1 = isObjectLike$6, baseGetTag$5 = _baseGetTag, isObjectLike$5 = isObjectLike_1, numberTag$2 = "[object Number]";
function isNumber$2(re) {
  return typeof re == "number" || isObjectLike$5(re) && baseGetTag$5(re) == numberTag$2;
}
var isNumber_1 = isNumber$2, isNumber$1 = isNumber_1;
function isNaN$1(re) {
  return isNumber$1(re) && re != +re;
}
var _isNaN = isNaN$1;
const isNaN$2 = /* @__PURE__ */ getDefaultExportFromCjs(_isNaN), mutations$2 = {
  /* eslint-disable no-param-reassign, no-unused-vars */
  [RESET_CS_APPEARANCE](re) {
    JSON.parse(JSON.stringify(defaultState));
  },
  [SET_SIDE_NAV](re, ne) {
    re.showSideNav = ne;
  },
  [TOGGLE_SIDE_NAV](re) {
    re.showSideNav = !re.showSideNav;
  },
  [SET_ALERT](re, ne) {
    re.alert = ne;
  },
  [RESET_ALERT](re) {
    re.alert = {
      type: null,
      message: null
    };
  },
  [SET_DEFAULT_CURSOR](re) {
    re.cursor = "default";
  },
  [SET_PROGRESS_CURSOR](re) {
    re.cursor = "progress";
  },
  [SET_VIEW_TITLE](re, ne) {
    re.viewTitle = ne;
  },
  [SET_DIALOG_IS_SHOWN](re, ne) {
    re.dialogIsShown = ne;
  },
  [SET_LOGIN_RESET_BTN_TIMEOUT](re, ne) {
    if (ne && !isNaN$2(ne)) {
      const ae = parseInt(ne, 10);
      ae > 0 && (re.loginResetBtnTimeout = ae);
    }
  }
  /* eslint-enable no-param-reassign, no-unused-vars */
}, state$2 = JSON.parse(JSON.stringify(defaultState)), getters$2 = {
  dialogIsShown: (re) => !!re.dialog,
  viewTitle: (re) => re.viewTitle,
  isAlertClickable: (re) => {
    var ne, ae;
    return !!((ne = re.alert) != null && ne.href) || !!((ae = re.alert) != null && ae.func);
  }
}, csAppearanceStore = {
  namespaced: !0,
  state: state$2,
  mutations: mutations$2,
  getters: getters$2
}, mutations$1 = {
  /* eslint-disable no-param-reassign */
  [SET_AUTH0_CONFIG](re, { appEnv: ne, appHost: ae, appUrl: ie, domain: le, clientId: se, audience: ce }) {
    re.config = {
      appEnv: Assert.isPresent(ne, "appEnv"),
      appHost: Assert.isPresent(ae, "appHost"),
      appUrl: Assert.isPresent(ie, "appUrl"),
      domain: Assert.isPresent(le, "domain"),
      clientId: Assert.isPresent(se, "clientId"),
      audience: Assert.isPresent(ce, "audience")
    };
  },
  [SET_CLIENT_APP_CONFIG](re, ne) {
    re.clientAppConfig = Assert.isPresent(ne, "clientAppConfig");
  }
  /* eslint-enable no-param-reassign */
}, state$1 = {
  config: null,
  clientAppConfig: null
}, getClientConfig = (re) => {
  if (re.clientAppConfig)
    return re.clientAppConfig;
  const ne = localStorage.getItem(CLIENT_APP_CONFIG);
  return ne ? JSON.parse(ne) : null;
}, getters$1 = {
  config: (re) => re.config,
  clientAppConfig: (re) => getClientConfig(re),
  enabled: (re) => {
    const ne = getClientConfig(re);
    return ne && !!ne.organization;
  }
}, auth0Store = {
  namespaced: !0,
  state: state$1,
  getters: getters$1,
  mutations: mutations$1,
  actions: actions$2
}, iplLogo = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20id='H_full_colour'%20data-name='H%20full%20colour'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20368.51939%2080'%3e%3cdefs%3e%3cstyle%3e%20.cls-1%20{%20fill:%20%23e2408e;%20}%20.cls-2%20{%20fill:%20%23304050;%20}%20.cls-3%20{%20fill:%20%23039db6;%20}%20.cls-4%20{%20fill:%20%2345bbce;%20}%20%3c/style%3e%3c/defs%3e%3cpolygon%20class='cls-4'%20points='165.29%2030.675%20165.29%2035.725%20165.68%2035.725%20165.68%2030.905%20173.79999%2035.745%20182.21%2030.675%20173.79999%2025.615%20165.29%2030.675'/%3e%3cpolygon%20class='cls-3'%20points='173.79999%2035.745%20173.79999%2045.875%20182.21%2040.805%20182.21%2030.675%20173.79999%2035.745'/%3e%3cpolygon%20class='cls-1'%20points='173.7%2015.485%20173.7%2020.495%20174.09%2020.495%20174.09%2015.715%20182.21%2020.545%20190.62%2015.485%20182.21%2010.415%20173.7%2015.485'/%3e%3cpolygon%20class='cls-2'%20points='182.21%2020.545%20182.21%2030.675%20190.62%2025.615%20190.62%2015.485%20182.21%2020.545'/%3e%3cpath%20class='cls-2'%20d='M14.22,28.185v31.74h-4.22v-31.74h4.22Z'/%3e%3cpath%20class='cls-2'%20d='M41.06,28.185v31.74h-3.94v-3.9c-1.81,2.77-4.72,4.49-8.57,4.49-6.3,0-11.47-5.21-11.47-11.92s5.17-11.93,11.47-11.93c3.85,0,6.76,1.72,8.57,4.49v-12.97h3.94ZM37.12,48.585c0-4.62-3.49-8.12-8.07-8.12s-8.03,3.49-8.03,8.12,3.49,8.12,8.03,8.12,8.07-3.49,8.07-8.12Z'/%3e%3cpath%20class='cls-2'%20d='M55.75,56.795c3.13,0,5.4-1.45,6.53-3.31l3.36,1.9c-2,3.08-5.44,5.12-9.98,5.12-7.3,0-12.15-5.12-12.15-11.92s4.81-11.93,11.88-11.93,11.29,5.62,11.29,11.97c0,.59-.05,1.18-.14,1.77h-19c.77,4.08,3.99,6.39,8.21,6.39v.01ZM47.54,46.955h15.14c-.68-4.49-3.9-6.57-7.3-6.57-4.26,0-7.21,2.63-7.84,6.57Z'/%3e%3cpath%20class='cls-2'%20d='M91.62,37.255v22.67h-3.94v-3.9c-1.81,2.77-4.72,4.49-8.57,4.49-6.3,0-11.47-5.21-11.47-11.92s5.17-11.93,11.47-11.93c3.85,0,6.76,1.72,8.57,4.49v-3.9h3.94ZM87.68,48.595c0-4.62-3.49-8.12-8.07-8.12s-8.03,3.49-8.03,8.12,3.49,8.12,8.03,8.12,8.07-3.49,8.07-8.12Z'/%3e%3cpath%20class='cls-2'%20d='M118.05,37.255v21.72c0,7.07-5.67,10.61-11.56,10.61-5.08,0-8.89-1.95-10.75-5.53l3.45-1.95c1.04,2.13,2.95,3.81,7.39,3.81,4.72,0,7.57-2.67,7.57-6.94v-3.22c-1.81,2.77-4.72,4.53-8.52,4.53-6.44,0-11.56-5.21-11.56-11.83s5.12-11.79,11.56-11.79c3.81,0,6.71,1.72,8.52,4.49v-3.9h3.9ZM114.15,48.455c0-4.53-3.49-8.03-8.07-8.03s-8.07,3.49-8.07,8.03,3.49,8.07,8.07,8.07,8.07-3.49,8.07-8.07Z'/%3e%3cpath%20class='cls-2'%20d='M132.75001,56.795c3.13,0,5.39999-1.45,6.53-3.31l3.36,1.9c-2,3.08-5.44,5.12-9.98,5.12-7.3,0-12.15-5.12-12.15-11.92s4.81-11.93,11.88-11.93,11.28999,5.62,11.28999,11.97c0,.59-.05,1.18-.14,1.77h-19c.77,4.08,3.99001,6.39,8.21001,6.39v.01ZM124.54001,46.955h15.14001c-.67999-4.49-3.89999-6.57-7.3-6.57-4.25999,0-7.21,2.63-7.84,6.57Z'/%3e%3cpath%20class='cls-2'%20d='M166.03,46.005v13.92h-3.95v-13.69c0-3.72-2.13-5.8-5.62-5.8s-6.57001,2.13-6.57001,7.48v12.02h-3.94v-22.67h3.94v3.26c1.67999-2.68,4.17-3.85,7.35001-3.85,5.31,0,8.8,3.54,8.8,9.34l-.01001-.01001Z'/%3e%3cg%3e%3cpath%20class='cls-1'%20d='M214.14844,44.94531c0,3.99902-3.05664,7.08594-7.11914,7.08594h-5.07031v7.87305h-2.92773v-22.0459h7.99805c4.0625,0,7.11914,3.05566,7.11914,7.08691ZM211.25,44.94531c0-2.51953-1.79492-4.34668-4.2207-4.34668h-5.07031v8.69238h5.07031c2.42578,0,4.2207-1.8584,4.2207-4.3457Z'/%3e%3cpath%20class='cls-1'%20d='M214.62305,52.03125c0-4.66113,3.68555-8.2832,8.2832-8.2832s8.31445,3.62207,8.31445,8.2832-3.7168,8.2832-8.31445,8.2832-8.2832-3.62207-8.2832-8.2832ZM228.48047,52.03125c0-3.18066-2.42578-5.60645-5.57422-5.60645-3.11914,0-5.54297,2.42578-5.54297,5.60645s2.42383,5.60547,5.54297,5.60547c3.14844,0,5.57422-2.4248,5.57422-5.60547Z'/%3e%3cpath%20class='cls-1'%20d='M233.83789,36.91406h2.74023v22.99023h-2.74023v-22.99023Z'/%3e%3cpath%20class='cls-1'%20d='M239.66602,39.46484c0-1.00781.81836-1.8584,1.85742-1.8584,1.00781,0,1.82617.85059,1.82617,1.8584s-.81836,1.82715-1.82617,1.82715c-1.03906,0-1.85742-.81934-1.85742-1.82715ZM240.13672,44.15723h2.74023v15.74707h-2.74023v-15.74707Z'/%3e%3cpath%20class='cls-1'%20d='M245.55469,52.03125c0-4.66113,3.52734-8.2832,8.2832-8.2832,3.11719,0,5.76367,1.6377,6.95898,4.12598l-2.29883,1.32227c-.78711-1.66895-2.55078-2.77148-4.66016-2.77148-3.15039,0-5.54297,2.42578-5.54297,5.60645,0,3.14941,2.39258,5.57422,5.54297,5.57422,2.14062,0,3.87305-1.10254,4.75586-2.74023l2.33008,1.35449c-1.32227,2.45703-4,4.09473-7.08594,4.09473-4.75586,0-8.2832-3.62207-8.2832-8.2832Z'/%3e%3cpath%20class='cls-1'%20d='M276.95703,44.15723l-6.42383,16.72363c-1.32422,3.52734-3.7793,5.54297-6.99219,5.32227v-2.55078c2.10938.15723,3.43359-1.13379,4.25195-3.21191l.2832-.59863-6.86523-15.68457h2.92773l5.35547,12.3457,4.53516-12.3457h2.92773Z'/%3e%3cpath%20class='cls-1'%20d='M298.59766,57.13281v2.77148h-12.43945v-22.0459h2.92969v19.27441h9.50977Z'/%3e%3cpath%20class='cls-1'%20d='M299.10547,52.03125c0-4.66113,3.68555-8.2832,8.2832-8.2832s8.31445,3.62207,8.31445,8.2832-3.7168,8.2832-8.31445,8.2832-8.2832-3.62207-8.2832-8.2832ZM312.96289,52.03125c0-3.18066-2.42578-5.60645-5.57422-5.60645-3.11914,0-5.54297,2.42578-5.54297,5.60645s2.42383,5.60547,5.54297,5.60547c3.14844,0,5.57422-2.4248,5.57422-5.60547Z'/%3e%3cpath%20class='cls-1'%20d='M334.09766,44.15723v15.08594c0,4.91309-3.9375,7.37012-8.03125,7.37012-3.52734,0-6.17188-1.35449-7.46289-3.84277l2.39258-1.35449c.72461,1.48047,2.04688,2.64551,5.13281,2.64551,3.27539,0,5.25977-1.85742,5.25977-4.81836v-2.23633c-1.25977,1.92188-3.27539,3.14941-5.91992,3.14941-4.47266,0-8.03125-3.62109-8.03125-8.21973,0-4.56641,3.55859-8.18848,8.03125-8.18848,2.64453,0,4.66016,1.19727,5.91992,3.11816v-2.70898h2.70898ZM331.38867,51.93652c0-3.14941-2.42383-5.57422-5.60547-5.57422s-5.60547,2.4248-5.60547,5.57422c0,3.18066,2.42383,5.60645,5.60547,5.60645s5.60547-2.42578,5.60547-5.60645Z'/%3e%3cpath%20class='cls-1'%20d='M337.15625,39.46484c0-1.00781.81836-1.8584,1.85742-1.8584,1.00781,0,1.82812.85059,1.82812,1.8584s-.82031,1.82715-1.82812,1.82715c-1.03906,0-1.85742-.81934-1.85742-1.82715ZM337.62891,44.15723h2.74023v15.74707h-2.74023v-15.74707Z'/%3e%3cpath%20class='cls-1'%20d='M343.04688,52.03125c0-4.66113,3.52734-8.2832,8.2832-8.2832,3.11719,0,5.76367,1.6377,6.95898,4.12598l-2.29883,1.32227c-.78711-1.66895-2.55078-2.77148-4.66016-2.77148-3.15039,0-5.54297,2.42578-5.54297,5.60645,0,3.14941,2.39258,5.57422,5.54297,5.57422,2.14062,0,3.87305-1.10254,4.75586-2.74023l2.33008,1.35449c-1.32227,2.45703-4,4.09473-7.08594,4.09473-4.75586,0-8.2832-3.62207-8.2832-8.2832Z'/%3e%3c/g%3e%3c/svg%3e", makeVLabelProps = propsFactory({
  text: String,
  onClick: EventProp(),
  ...makeComponentProps(),
  ...makeThemeProps()
}, "VLabel"), VLabel = genericComponent()({
  name: "VLabel",
  props: makeVLabelProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    return useRender(() => {
      var ie;
      return createVNode("label", {
        class: ["v-label", {
          "v-label--clickable": !!re.onClick
        }, re.class],
        style: re.style,
        onClick: re.onClick
      }, [re.text, (ie = ae.default) == null ? void 0 : ie.call(ae)]);
    }), {};
  }
}), VSelectionControlGroupSymbol = Symbol.for("vuetify:selection-control-group"), makeSelectionControlGroupProps = propsFactory({
  color: String,
  disabled: {
    type: Boolean,
    default: null
  },
  defaultsTarget: String,
  error: Boolean,
  id: String,
  inline: Boolean,
  falseIcon: IconValue,
  trueIcon: IconValue,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  multiple: {
    type: Boolean,
    default: null
  },
  name: String,
  readonly: {
    type: Boolean,
    default: null
  },
  modelValue: null,
  type: String,
  valueComparator: {
    type: Function,
    default: deepEqual
  },
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeThemeProps()
}, "SelectionControlGroup"), makeVSelectionControlGroupProps = propsFactory({
  ...makeSelectionControlGroupProps({
    defaultsTarget: "VSelectionControl"
  })
}, "VSelectionControlGroup"), VSelectionControlGroup = genericComponent()({
  name: "VSelectionControlGroup",
  props: makeVSelectionControlGroupProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = useProxiedModel(re, "modelValue"), le = getUid(), se = computed(() => re.id || `v-selection-control-group-${le}`), ce = computed(() => re.name || se.value), ue = /* @__PURE__ */ new Set();
    return provide(VSelectionControlGroupSymbol, {
      modelValue: ie,
      forceUpdate: () => {
        ue.forEach((de) => de());
      },
      onForceUpdate: (de) => {
        ue.add(de), onScopeDispose(() => {
          ue.delete(de);
        });
      }
    }), provideDefaults({
      [re.defaultsTarget]: {
        color: toRef(re, "color"),
        disabled: toRef(re, "disabled"),
        density: toRef(re, "density"),
        error: toRef(re, "error"),
        inline: toRef(re, "inline"),
        modelValue: ie,
        multiple: computed(() => !!re.multiple || re.multiple == null && Array.isArray(ie.value)),
        name: ce,
        falseIcon: toRef(re, "falseIcon"),
        trueIcon: toRef(re, "trueIcon"),
        readonly: toRef(re, "readonly"),
        ripple: toRef(re, "ripple"),
        type: toRef(re, "type"),
        valueComparator: toRef(re, "valueComparator")
      }
    }), useRender(() => {
      var de;
      return createVNode("div", {
        class: ["v-selection-control-group", {
          "v-selection-control-group--inline": re.inline
        }, re.class],
        style: re.style,
        role: re.type === "radio" ? "radiogroup" : void 0
      }, [(de = ae.default) == null ? void 0 : de.call(ae)]);
    }), {};
  }
}), makeVSelectionControlProps = propsFactory({
  label: String,
  baseColor: String,
  trueValue: null,
  falseValue: null,
  value: null,
  ...makeComponentProps(),
  ...makeSelectionControlGroupProps()
}, "VSelectionControl");
function useSelectionControl(re) {
  const ne = inject(VSelectionControlGroupSymbol, void 0), {
    densityClasses: ae
  } = useDensity(re), ie = useProxiedModel(re, "modelValue"), le = computed(() => re.trueValue !== void 0 ? re.trueValue : re.value !== void 0 ? re.value : !0), se = computed(() => re.falseValue !== void 0 ? re.falseValue : !1), ce = computed(() => !!re.multiple || re.multiple == null && Array.isArray(ie.value)), ue = computed({
    get() {
      const be = ne ? ne.modelValue.value : ie.value;
      return ce.value ? wrapInArray(be).some((Se) => re.valueComparator(Se, le.value)) : re.valueComparator(be, le.value);
    },
    set(be) {
      if (re.readonly) return;
      const Se = be ? le.value : se.value;
      let Pe = Se;
      ce.value && (Pe = be ? [...wrapInArray(ie.value), Se] : wrapInArray(ie.value).filter((Ee) => !re.valueComparator(Ee, le.value))), ne ? ne.modelValue.value = Pe : ie.value = Pe;
    }
  }), {
    textColorClasses: de,
    textColorStyles: me
  } = useTextColor(computed(() => {
    if (!(re.error || re.disabled))
      return ue.value ? re.color : re.baseColor;
  })), {
    backgroundColorClasses: fe,
    backgroundColorStyles: pe
  } = useBackgroundColor(computed(() => ue.value && !re.error && !re.disabled ? re.color : re.baseColor)), ge = computed(() => ue.value ? re.trueIcon : re.falseIcon);
  return {
    group: ne,
    densityClasses: ae,
    trueValue: le,
    falseValue: se,
    model: ue,
    textColorClasses: de,
    textColorStyles: me,
    backgroundColorClasses: fe,
    backgroundColorStyles: pe,
    icon: ge
  };
}
const VSelectionControl = genericComponent()({
  name: "VSelectionControl",
  directives: {
    Ripple
  },
  inheritAttrs: !1,
  props: makeVSelectionControlProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      attrs: ae,
      slots: ie
    } = ne;
    const {
      group: le,
      densityClasses: se,
      icon: ce,
      model: ue,
      textColorClasses: de,
      textColorStyles: me,
      backgroundColorClasses: fe,
      backgroundColorStyles: pe,
      trueValue: ge
    } = useSelectionControl(re), be = getUid(), Se = shallowRef(!1), Pe = shallowRef(!1), Ee = ref$1(), Ve = computed(() => re.id || `input-${be}`), Ae = computed(() => !re.disabled && !re.readonly);
    le == null || le.onForceUpdate(() => {
      Ee.value && (Ee.value.checked = ue.value);
    });
    function Oe(Ze) {
      Ae.value && (Se.value = !0, matchesSelector(Ze.target, ":focus-visible") !== !1 && (Pe.value = !0));
    }
    function Ne() {
      Se.value = !1, Pe.value = !1;
    }
    function He(Ze) {
      Ze.stopPropagation();
    }
    function Ue(Ze) {
      if (!Ae.value) {
        Ee.value && (Ee.value.checked = ue.value);
        return;
      }
      re.readonly && le && nextTick$2(() => le.forceUpdate()), ue.value = Ze.target.checked;
    }
    return useRender(() => {
      var Re, Ce;
      const Ze = ie.label ? ie.label({
        label: re.label,
        props: {
          for: Ve.value
        }
      }) : re.label, [Fe, Ke] = filterInputAttrs(ae), tt = createVNode("input", mergeProps({
        ref: Ee,
        checked: ue.value,
        disabled: !!re.disabled,
        id: Ve.value,
        onBlur: Ne,
        onFocus: Oe,
        onInput: Ue,
        "aria-disabled": !!re.disabled,
        "aria-label": re.label,
        type: re.type,
        value: ge.value,
        name: re.name,
        "aria-checked": re.type === "checkbox" ? ue.value : void 0
      }, Ke), null);
      return createVNode("div", mergeProps({
        class: ["v-selection-control", {
          "v-selection-control--dirty": ue.value,
          "v-selection-control--disabled": re.disabled,
          "v-selection-control--error": re.error,
          "v-selection-control--focused": Se.value,
          "v-selection-control--focus-visible": Pe.value,
          "v-selection-control--inline": re.inline
        }, se.value, re.class]
      }, Fe, {
        style: re.style
      }), [createVNode("div", {
        class: ["v-selection-control__wrapper", de.value],
        style: me.value
      }, [(Re = ie.default) == null ? void 0 : Re.call(ie, {
        backgroundColorClasses: fe,
        backgroundColorStyles: pe
      }), withDirectives(createVNode("div", {
        class: ["v-selection-control__input"]
      }, [((Ce = ie.input) == null ? void 0 : Ce.call(ie, {
        model: ue,
        textColorClasses: de,
        textColorStyles: me,
        backgroundColorClasses: fe,
        backgroundColorStyles: pe,
        inputNode: tt,
        icon: ce.value,
        props: {
          onFocus: Oe,
          onBlur: Ne,
          id: Ve.value
        }
      })) ?? createVNode(Fragment, null, [ce.value && createVNode(VIcon, {
        key: "icon",
        icon: ce.value
      }, null), tt])]), [[resolveDirective("ripple"), re.ripple && [!re.disabled && !re.readonly, null, ["center", "circle"]]]])]), Ze && createVNode(VLabel, {
        for: Ve.value,
        onClick: He
      }, {
        default: () => [Ze]
      })]);
    }), {
      isFocused: Se,
      input: Ee
    };
  }
}), makeVRadioProps = propsFactory({
  ...makeVSelectionControlProps({
    falseIcon: "$radioOff",
    trueIcon: "$radioOn"
  })
}, "VRadio"), VRadio = genericComponent()({
  name: "VRadio",
  props: makeVRadioProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    return useRender(() => {
      const ie = VSelectionControl.filterProps(re);
      return createVNode(VSelectionControl, mergeProps(ie, {
        class: ["v-radio", re.class],
        style: re.style,
        type: "radio"
      }), ae);
    }), {};
  }
});
function useInputIcon(re) {
  const {
    t: ne
  } = useLocale();
  function ae(ie) {
    let {
      name: le
    } = ie;
    const se = {
      prepend: "prependAction",
      prependInner: "prependAction",
      append: "appendAction",
      appendInner: "appendAction",
      clear: "clear"
    }[le], ce = re[`onClick:${le}`];
    function ue(me) {
      me.key !== "Enter" && me.key !== " " || (me.preventDefault(), me.stopPropagation(), callEvent(ce, new PointerEvent("click", me)));
    }
    const de = ce && se ? ne(`$vuetify.input.${se}`, re.label ?? "") : void 0;
    return createVNode(VIcon, {
      icon: re[`${le}Icon`],
      "aria-label": de,
      onClick: ce,
      onKeydown: ue
    }, null);
  }
  return {
    InputIcon: ae
  };
}
const makeVMessagesProps = propsFactory({
  active: Boolean,
  color: String,
  messages: {
    type: [Array, String],
    default: () => []
  },
  ...makeComponentProps(),
  ...makeTransitionProps({
    transition: {
      component: VSlideYTransition,
      leaveAbsolute: !0,
      group: !0
    }
  })
}, "VMessages"), VMessages = genericComponent()({
  name: "VMessages",
  props: makeVMessagesProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = computed(() => wrapInArray(re.messages)), {
      textColorClasses: le,
      textColorStyles: se
    } = useTextColor(computed(() => re.color));
    return useRender(() => createVNode(MaybeTransition, {
      transition: re.transition,
      tag: "div",
      class: ["v-messages", le.value, re.class],
      style: [se.value, re.style]
    }, {
      default: () => [re.active && ie.value.map((ce, ue) => createVNode("div", {
        class: "v-messages__message",
        key: `${ue}-${ie.value}`
      }, [ae.message ? ae.message({
        message: ce
      }) : ce]))]
    })), {};
  }
}), makeFocusProps = propsFactory({
  focused: Boolean,
  "onUpdate:focused": EventProp()
}, "focus");
function useFocus(re) {
  let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getCurrentInstanceName();
  const ae = useProxiedModel(re, "focused"), ie = computed(() => ({
    [`${ne}--focused`]: ae.value
  }));
  function le() {
    ae.value = !0;
  }
  function se() {
    ae.value = !1;
  }
  return {
    focusClasses: ie,
    isFocused: ae,
    focus: le,
    blur: se
  };
}
const FormKey = Symbol.for("vuetify:form"), makeFormProps = propsFactory({
  disabled: Boolean,
  fastFail: Boolean,
  readonly: Boolean,
  modelValue: {
    type: Boolean,
    default: null
  },
  validateOn: {
    type: String,
    default: "input"
  }
}, "form");
function createForm(re) {
  const ne = useProxiedModel(re, "modelValue"), ae = computed(() => re.disabled), ie = computed(() => re.readonly), le = shallowRef(!1), se = ref$1([]), ce = ref$1([]);
  async function ue() {
    const fe = [];
    let pe = !0;
    ce.value = [], le.value = !0;
    for (const ge of se.value) {
      const be = await ge.validate();
      if (be.length > 0 && (pe = !1, fe.push({
        id: ge.id,
        errorMessages: be
      })), !pe && re.fastFail) break;
    }
    return ce.value = fe, le.value = !1, {
      valid: pe,
      errors: ce.value
    };
  }
  function de() {
    se.value.forEach((fe) => fe.reset());
  }
  function me() {
    se.value.forEach((fe) => fe.resetValidation());
  }
  return watch(se, () => {
    let fe = 0, pe = 0;
    const ge = [];
    for (const be of se.value)
      be.isValid === !1 ? (pe++, ge.push({
        id: be.id,
        errorMessages: be.errorMessages
      })) : be.isValid === !0 && fe++;
    ce.value = ge, ne.value = pe > 0 ? !1 : fe === se.value.length ? !0 : null;
  }, {
    deep: !0,
    flush: "post"
  }), provide(FormKey, {
    register: (fe) => {
      let {
        id: pe,
        vm: ge,
        validate: be,
        reset: Se,
        resetValidation: Pe
      } = fe;
      se.value.some((Ee) => Ee.id === pe) && consoleWarn(`Duplicate input name "${pe}"`), se.value.push({
        id: pe,
        validate: be,
        reset: Se,
        resetValidation: Pe,
        vm: markRaw(ge),
        isValid: null,
        errorMessages: []
      });
    },
    unregister: (fe) => {
      se.value = se.value.filter((pe) => pe.id !== fe);
    },
    update: (fe, pe, ge) => {
      const be = se.value.find((Se) => Se.id === fe);
      be && (be.isValid = pe, be.errorMessages = ge);
    },
    isDisabled: ae,
    isReadonly: ie,
    isValidating: le,
    isValid: ne,
    items: se,
    validateOn: toRef(re, "validateOn")
  }), {
    errors: ce,
    isDisabled: ae,
    isReadonly: ie,
    isValidating: le,
    isValid: ne,
    items: se,
    validate: ue,
    reset: de,
    resetValidation: me
  };
}
function useForm(re) {
  const ne = inject(FormKey, null);
  return {
    ...ne,
    isReadonly: computed(() => !!((re == null ? void 0 : re.readonly) ?? (ne == null ? void 0 : ne.isReadonly.value))),
    isDisabled: computed(() => !!((re == null ? void 0 : re.disabled) ?? (ne == null ? void 0 : ne.isDisabled.value)))
  };
}
const makeValidationProps = propsFactory({
  disabled: {
    type: Boolean,
    default: null
  },
  error: Boolean,
  errorMessages: {
    type: [Array, String],
    default: () => []
  },
  maxErrors: {
    type: [Number, String],
    default: 1
  },
  name: String,
  label: String,
  readonly: {
    type: Boolean,
    default: null
  },
  rules: {
    type: Array,
    default: () => []
  },
  modelValue: null,
  validateOn: String,
  validationValue: null,
  ...makeFocusProps()
}, "validation");
function useValidation(re) {
  let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getCurrentInstanceName(), ae = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : getUid();
  const ie = useProxiedModel(re, "modelValue"), le = computed(() => re.validationValue === void 0 ? ie.value : re.validationValue), se = useForm(re), ce = ref$1([]), ue = shallowRef(!0), de = computed(() => !!(wrapInArray(ie.value === "" ? null : ie.value).length || wrapInArray(le.value === "" ? null : le.value).length)), me = computed(() => {
    var Oe;
    return (Oe = re.errorMessages) != null && Oe.length ? wrapInArray(re.errorMessages).concat(ce.value).slice(0, Math.max(0, Number(re.maxErrors))) : ce.value;
  }), fe = computed(() => {
    var He;
    let Oe = (re.validateOn ?? ((He = se.validateOn) == null ? void 0 : He.value)) || "input";
    Oe === "lazy" && (Oe = "input lazy"), Oe === "eager" && (Oe = "input eager");
    const Ne = new Set((Oe == null ? void 0 : Oe.split(" ")) ?? []);
    return {
      input: Ne.has("input"),
      blur: Ne.has("blur") || Ne.has("input") || Ne.has("invalid-input"),
      invalidInput: Ne.has("invalid-input"),
      lazy: Ne.has("lazy"),
      eager: Ne.has("eager")
    };
  }), pe = computed(() => {
    var Oe;
    return re.error || (Oe = re.errorMessages) != null && Oe.length ? !1 : re.rules.length ? ue.value ? ce.value.length || fe.value.lazy ? null : !0 : !ce.value.length : !0;
  }), ge = shallowRef(!1), be = computed(() => ({
    [`${ne}--error`]: pe.value === !1,
    [`${ne}--dirty`]: de.value,
    [`${ne}--disabled`]: se.isDisabled.value,
    [`${ne}--readonly`]: se.isReadonly.value
  })), Se = getCurrentInstance("validation"), Pe = computed(() => re.name ?? unref(ae));
  onBeforeMount(() => {
    var Oe;
    (Oe = se.register) == null || Oe.call(se, {
      id: Pe.value,
      vm: Se,
      validate: Ae,
      reset: Ee,
      resetValidation: Ve
    });
  }), onBeforeUnmount(() => {
    var Oe;
    (Oe = se.unregister) == null || Oe.call(se, Pe.value);
  }), onMounted(async () => {
    var Oe;
    fe.value.lazy || await Ae(!fe.value.eager), (Oe = se.update) == null || Oe.call(se, Pe.value, pe.value, me.value);
  }), useToggleScope(() => fe.value.input || fe.value.invalidInput && pe.value === !1, () => {
    watch(le, () => {
      if (le.value != null)
        Ae();
      else if (re.focused) {
        const Oe = watch(() => re.focused, (Ne) => {
          Ne || Ae(), Oe();
        });
      }
    });
  }), useToggleScope(() => fe.value.blur, () => {
    watch(() => re.focused, (Oe) => {
      Oe || Ae();
    });
  }), watch([pe, me], () => {
    var Oe;
    (Oe = se.update) == null || Oe.call(se, Pe.value, pe.value, me.value);
  });
  async function Ee() {
    ie.value = null, await nextTick$2(), await Ve();
  }
  async function Ve() {
    ue.value = !0, fe.value.lazy ? ce.value = [] : await Ae(!fe.value.eager);
  }
  async function Ae() {
    let Oe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    const Ne = [];
    ge.value = !0;
    for (const He of re.rules) {
      if (Ne.length >= Number(re.maxErrors ?? 1))
        break;
      const Ze = await (typeof He == "function" ? He : () => He)(le.value);
      if (Ze !== !0) {
        if (Ze !== !1 && typeof Ze != "string") {
          console.warn(`${Ze} is not a valid value. Rule functions must return boolean true or a string.`);
          continue;
        }
        Ne.push(Ze || "");
      }
    }
    return ce.value = Ne, ge.value = !1, ue.value = Oe, ce.value;
  }
  return {
    errorMessages: me,
    isDirty: de,
    isDisabled: se.isDisabled,
    isReadonly: se.isReadonly,
    isPristine: ue,
    isValid: pe,
    isValidating: ge,
    reset: Ee,
    resetValidation: Ve,
    validate: Ae,
    validationClasses: be
  };
}
const makeVInputProps = propsFactory({
  id: String,
  appendIcon: IconValue,
  centerAffix: {
    type: Boolean,
    default: !0
  },
  prependIcon: IconValue,
  hideDetails: [Boolean, String],
  hideSpinButtons: Boolean,
  hint: String,
  persistentHint: Boolean,
  messages: {
    type: [Array, String],
    default: () => []
  },
  direction: {
    type: String,
    default: "horizontal",
    validator: (re) => ["horizontal", "vertical"].includes(re)
  },
  "onClick:prepend": EventProp(),
  "onClick:append": EventProp(),
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...pick(makeDimensionProps(), ["maxWidth", "minWidth", "width"]),
  ...makeThemeProps(),
  ...makeValidationProps()
}, "VInput"), VInput = genericComponent()({
  name: "VInput",
  props: {
    ...makeVInputProps()
  },
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      attrs: ae,
      slots: ie,
      emit: le
    } = ne;
    const {
      densityClasses: se
    } = useDensity(re), {
      dimensionStyles: ce
    } = useDimension(re), {
      themeClasses: ue
    } = provideTheme(re), {
      rtlClasses: de
    } = useRtl(), {
      InputIcon: me
    } = useInputIcon(re), fe = getUid(), pe = computed(() => re.id || `input-${fe}`), ge = computed(() => `${pe.value}-messages`), {
      errorMessages: be,
      isDirty: Se,
      isDisabled: Pe,
      isReadonly: Ee,
      isPristine: Ve,
      isValid: Ae,
      isValidating: Oe,
      reset: Ne,
      resetValidation: He,
      validate: Ue,
      validationClasses: Ze
    } = useValidation(re, "v-input", pe), Fe = computed(() => ({
      id: pe,
      messagesId: ge,
      isDirty: Se,
      isDisabled: Pe,
      isReadonly: Ee,
      isPristine: Ve,
      isValid: Ae,
      isValidating: Oe,
      reset: Ne,
      resetValidation: He,
      validate: Ue
    })), Ke = computed(() => {
      var tt;
      return (tt = re.errorMessages) != null && tt.length || !Ve.value && be.value.length ? be.value : re.hint && (re.persistentHint || re.focused) ? re.hint : re.messages;
    });
    return useRender(() => {
      var he, ve, xe, $e;
      const tt = !!(ie.prepend || re.prependIcon), Re = !!(ie.append || re.appendIcon), Ce = Ke.value.length > 0, _e = !re.hideDetails || re.hideDetails === "auto" && (Ce || !!ie.details);
      return createVNode("div", {
        class: ["v-input", `v-input--${re.direction}`, {
          "v-input--center-affix": re.centerAffix,
          "v-input--hide-spin-buttons": re.hideSpinButtons
        }, se.value, ue.value, de.value, Ze.value, re.class],
        style: [ce.value, re.style]
      }, [tt && createVNode("div", {
        key: "prepend",
        class: "v-input__prepend"
      }, [(he = ie.prepend) == null ? void 0 : he.call(ie, Fe.value), re.prependIcon && createVNode(me, {
        key: "prepend-icon",
        name: "prepend"
      }, null)]), ie.default && createVNode("div", {
        class: "v-input__control"
      }, [(ve = ie.default) == null ? void 0 : ve.call(ie, Fe.value)]), Re && createVNode("div", {
        key: "append",
        class: "v-input__append"
      }, [re.appendIcon && createVNode(me, {
        key: "append-icon",
        name: "append"
      }, null), (xe = ie.append) == null ? void 0 : xe.call(ie, Fe.value)]), _e && createVNode("div", {
        id: ge.value,
        class: "v-input__details",
        role: "alert",
        "aria-live": "polite"
      }, [createVNode(VMessages, {
        active: Ce,
        messages: Ke.value
      }, {
        message: ie.message
      }), ($e = ie.details) == null ? void 0 : $e.call(ie, Fe.value)])]);
    }), {
      reset: Ne,
      resetValidation: He,
      validate: Ue,
      isValid: Ae,
      errorMessages: be
    };
  }
}), makeVRadioGroupProps = propsFactory({
  height: {
    type: [Number, String],
    default: "auto"
  },
  ...makeVInputProps(),
  ...omit(makeSelectionControlGroupProps(), ["multiple"]),
  trueIcon: {
    type: IconValue,
    default: "$radioOn"
  },
  falseIcon: {
    type: IconValue,
    default: "$radioOff"
  },
  type: {
    type: String,
    default: "radio"
  }
}, "VRadioGroup"), VRadioGroup = genericComponent()({
  name: "VRadioGroup",
  inheritAttrs: !1,
  props: makeVRadioGroupProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      attrs: ae,
      slots: ie
    } = ne;
    const le = getUid(), se = computed(() => re.id || `radio-group-${le}`), ce = useProxiedModel(re, "modelValue");
    return useRender(() => {
      const [ue, de] = filterInputAttrs(ae), me = VInput.filterProps(re), fe = VSelectionControl.filterProps(re), pe = ie.label ? ie.label({
        label: re.label,
        props: {
          for: se.value
        }
      }) : re.label;
      return createVNode(VInput, mergeProps({
        class: ["v-radio-group", re.class],
        style: re.style
      }, ue, me, {
        modelValue: ce.value,
        "onUpdate:modelValue": (ge) => ce.value = ge,
        id: se.value
      }), {
        ...ie,
        default: (ge) => {
          let {
            id: be,
            messagesId: Se,
            isDisabled: Pe,
            isReadonly: Ee
          } = ge;
          return createVNode(Fragment, null, [pe && createVNode(VLabel, {
            id: be.value
          }, {
            default: () => [pe]
          }), createVNode(VSelectionControlGroup, mergeProps(fe, {
            id: be.value,
            "aria-describedby": Se.value,
            defaultsTarget: "VRadio",
            trueIcon: re.trueIcon,
            falseIcon: re.falseIcon,
            type: re.type,
            disabled: Pe.value,
            readonly: Ee.value,
            "aria-labelledby": pe ? be.value : void 0,
            multiple: !1
          }, de, {
            modelValue: ce.value,
            "onUpdate:modelValue": (Ve) => ce.value = Ve
          }), ie)]);
        }
      });
    }), {};
  }
}), makeVAvatarProps = propsFactory({
  start: Boolean,
  end: Boolean,
  icon: IconValue,
  image: String,
  text: String,
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeRoundedProps(),
  ...makeSizeProps(),
  ...makeTagProps(),
  ...makeThemeProps(),
  ...makeVariantProps({
    variant: "flat"
  })
}, "VAvatar"), VAvatar = genericComponent()({
  name: "VAvatar",
  props: makeVAvatarProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      themeClasses: ie
    } = provideTheme(re), {
      borderClasses: le
    } = useBorder(re), {
      colorClasses: se,
      colorStyles: ce,
      variantClasses: ue
    } = useVariant(re), {
      densityClasses: de
    } = useDensity(re), {
      roundedClasses: me
    } = useRounded(re), {
      sizeClasses: fe,
      sizeStyles: pe
    } = useSize(re);
    return useRender(() => createVNode(re.tag, {
      class: ["v-avatar", {
        "v-avatar--start": re.start,
        "v-avatar--end": re.end
      }, ie.value, le.value, se.value, de.value, me.value, fe.value, ue.value, re.class],
      style: [ce.value, pe.value, re.style]
    }, {
      default: () => [ae.default ? createVNode(VDefaultsProvider, {
        key: "content-defaults",
        defaults: {
          VImg: {
            cover: !0,
            src: re.image
          },
          VIcon: {
            icon: re.icon
          }
        }
      }, {
        default: () => [ae.default()]
      }) : re.image ? createVNode(VImg, {
        key: "image",
        src: re.image,
        alt: "",
        cover: !0
      }, null) : re.icon ? createVNode(VIcon, {
        key: "icon",
        icon: re.icon
      }, null) : re.text, genOverlays(!1, "v-avatar")]
    })), {};
  }
}), makeVCheckboxBtnProps = propsFactory({
  indeterminate: Boolean,
  indeterminateIcon: {
    type: IconValue,
    default: "$checkboxIndeterminate"
  },
  ...makeVSelectionControlProps({
    falseIcon: "$checkboxOff",
    trueIcon: "$checkboxOn"
  })
}, "VCheckboxBtn"), VCheckboxBtn = genericComponent()({
  name: "VCheckboxBtn",
  props: makeVCheckboxBtnProps(),
  emits: {
    "update:modelValue": (re) => !0,
    "update:indeterminate": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = useProxiedModel(re, "indeterminate"), le = useProxiedModel(re, "modelValue");
    function se(de) {
      ie.value && (ie.value = !1);
    }
    const ce = computed(() => ie.value ? re.indeterminateIcon : re.falseIcon), ue = computed(() => ie.value ? re.indeterminateIcon : re.trueIcon);
    return useRender(() => {
      const de = omit(VSelectionControl.filterProps(re), ["modelValue"]);
      return createVNode(VSelectionControl, mergeProps(de, {
        modelValue: le.value,
        "onUpdate:modelValue": [(me) => le.value = me, se],
        class: ["v-checkbox-btn", re.class],
        style: re.style,
        type: "checkbox",
        falseIcon: ce.value,
        trueIcon: ue.value,
        "aria-checked": ie.value ? "mixed" : void 0
      }), ae);
    }), {};
  }
}), makeVCheckboxProps = propsFactory({
  ...makeVInputProps(),
  ...omit(makeVCheckboxBtnProps(), ["inline"])
}, "VCheckbox"), VCheckbox = genericComponent()({
  name: "VCheckbox",
  inheritAttrs: !1,
  props: makeVCheckboxProps(),
  emits: {
    "update:modelValue": (re) => !0,
    "update:focused": (re) => !0
  },
  setup(re, ne) {
    let {
      attrs: ae,
      slots: ie
    } = ne;
    const le = useProxiedModel(re, "modelValue"), {
      isFocused: se,
      focus: ce,
      blur: ue
    } = useFocus(re), de = getUid(), me = computed(() => re.id || `checkbox-${de}`);
    return useRender(() => {
      const [fe, pe] = filterInputAttrs(ae), ge = VInput.filterProps(re), be = VCheckboxBtn.filterProps(re);
      return createVNode(VInput, mergeProps({
        class: ["v-checkbox", re.class]
      }, fe, ge, {
        modelValue: le.value,
        "onUpdate:modelValue": (Se) => le.value = Se,
        id: me.value,
        focused: se.value,
        style: re.style
      }), {
        ...ie,
        default: (Se) => {
          let {
            id: Pe,
            messagesId: Ee,
            isDisabled: Ve,
            isReadonly: Ae,
            isValid: Oe
          } = Se;
          return createVNode(VCheckboxBtn, mergeProps(be, {
            id: Pe.value,
            "aria-describedby": Ee.value,
            disabled: Ve.value,
            readonly: Ae.value
          }, pe, {
            error: Oe.value === !1,
            modelValue: le.value,
            "onUpdate:modelValue": (Ne) => le.value = Ne,
            onFocus: ce,
            onBlur: ue
          }), ie);
        }
      });
    }), {};
  }
});
function calculateUpdatedTarget(re) {
  let {
    selectedElement: ne,
    containerElement: ae,
    isRtl: ie,
    isHorizontal: le
  } = re;
  const se = getOffsetSize(le, ae), ce = getScrollPosition(le, ie, ae), ue = getOffsetSize(le, ne), de = getOffsetPosition(le, ne), me = ue * 0.4;
  return ce > de ? de - me : ce + se < de + ue ? de - se + ue + me : ce;
}
function calculateCenteredTarget(re) {
  let {
    selectedElement: ne,
    containerElement: ae,
    isHorizontal: ie
  } = re;
  const le = getOffsetSize(ie, ae), se = getOffsetPosition(ie, ne), ce = getOffsetSize(ie, ne);
  return se - le / 2 + ce / 2;
}
function getScrollSize(re, ne) {
  const ae = re ? "scrollWidth" : "scrollHeight";
  return (ne == null ? void 0 : ne[ae]) || 0;
}
function getClientSize(re, ne) {
  const ae = re ? "clientWidth" : "clientHeight";
  return (ne == null ? void 0 : ne[ae]) || 0;
}
function getScrollPosition(re, ne, ae) {
  if (!ae)
    return 0;
  const {
    scrollLeft: ie,
    offsetWidth: le,
    scrollWidth: se
  } = ae;
  return re ? ne ? se - le + ie : ie : ae.scrollTop;
}
function getOffsetSize(re, ne) {
  const ae = re ? "offsetWidth" : "offsetHeight";
  return (ne == null ? void 0 : ne[ae]) || 0;
}
function getOffsetPosition(re, ne) {
  const ae = re ? "offsetLeft" : "offsetTop";
  return (ne == null ? void 0 : ne[ae]) || 0;
}
const VSlideGroupSymbol = Symbol.for("vuetify:v-slide-group"), makeVSlideGroupProps = propsFactory({
  centerActive: Boolean,
  direction: {
    type: String,
    default: "horizontal"
  },
  symbol: {
    type: null,
    default: VSlideGroupSymbol
  },
  nextIcon: {
    type: IconValue,
    default: "$next"
  },
  prevIcon: {
    type: IconValue,
    default: "$prev"
  },
  showArrows: {
    type: [Boolean, String],
    validator: (re) => typeof re == "boolean" || ["always", "desktop", "mobile"].includes(re)
  },
  ...makeComponentProps(),
  ...makeDisplayProps({
    mobile: null
  }),
  ...makeTagProps(),
  ...makeGroupProps({
    selectedClass: "v-slide-group-item--active"
  })
}, "VSlideGroup"), VSlideGroup = genericComponent()({
  name: "VSlideGroup",
  props: makeVSlideGroupProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      isRtl: ie
    } = useRtl(), {
      displayClasses: le,
      mobile: se
    } = useDisplay(re), ce = useGroup(re, re.symbol), ue = shallowRef(!1), de = shallowRef(0), me = shallowRef(0), fe = shallowRef(0), pe = computed(() => re.direction === "horizontal"), {
      resizeRef: ge,
      contentRect: be
    } = useResizeObserver(), {
      resizeRef: Se,
      contentRect: Pe
    } = useResizeObserver(), Ee = useGoTo(), Ve = computed(() => ({
      container: ge.el,
      duration: 200,
      easing: "easeOutQuart"
    })), Ae = computed(() => ce.selected.value.length ? ce.items.value.findIndex((ke) => ke.id === ce.selected.value[0]) : -1), Oe = computed(() => ce.selected.value.length ? ce.items.value.findIndex((ke) => ke.id === ce.selected.value[ce.selected.value.length - 1]) : -1);
    if (IN_BROWSER) {
      let ke = -1;
      watch(() => [ce.selected.value, be.value, Pe.value, pe.value], () => {
        cancelAnimationFrame(ke), ke = requestAnimationFrame(() => {
          if (be.value && Pe.value) {
            const ye = pe.value ? "width" : "height";
            me.value = be.value[ye], fe.value = Pe.value[ye], ue.value = me.value + 1 < fe.value;
          }
          if (Ae.value >= 0 && Se.el) {
            const ye = Se.el.children[Oe.value];
            He(ye, re.centerActive);
          }
        });
      });
    }
    const Ne = shallowRef(!1);
    function He(ke, ye) {
      let Be = 0;
      ye ? Be = calculateCenteredTarget({
        containerElement: ge.el,
        isHorizontal: pe.value,
        selectedElement: ke
      }) : Be = calculateUpdatedTarget({
        containerElement: ge.el,
        isHorizontal: pe.value,
        isRtl: ie.value,
        selectedElement: ke
      }), Ue(Be);
    }
    function Ue(ke) {
      if (!IN_BROWSER || !ge.el) return;
      const ye = getOffsetSize(pe.value, ge.el), Be = getScrollPosition(pe.value, ie.value, ge.el);
      if (!(getScrollSize(pe.value, ge.el) <= ye || // Prevent scrolling by only a couple of pixels, which doesn't look smooth
      Math.abs(ke - Be) < 16)) {
        if (pe.value && ie.value && ge.el) {
          const {
            scrollWidth: et,
            offsetWidth: Ye
          } = ge.el;
          ke = et - Ye - ke;
        }
        pe.value ? Ee.horizontal(ke, Ve.value) : Ee(ke, Ve.value);
      }
    }
    function Ze(ke) {
      const {
        scrollTop: ye,
        scrollLeft: Be
      } = ke.target;
      de.value = pe.value ? Be : ye;
    }
    function Fe(ke) {
      if (Ne.value = !0, !(!ue.value || !Se.el)) {
        for (const ye of ke.composedPath())
          for (const Be of Se.el.children)
            if (Be === ye) {
              He(Be);
              return;
            }
      }
    }
    function Ke(ke) {
      Ne.value = !1;
    }
    let tt = !1;
    function Re(ke) {
      var ye;
      !tt && !Ne.value && !(ke.relatedTarget && ((ye = Se.el) != null && ye.contains(ke.relatedTarget))) && ve(), tt = !1;
    }
    function Ce() {
      tt = !0;
    }
    function _e(ke) {
      if (!Se.el) return;
      function ye(Be) {
        ke.preventDefault(), ve(Be);
      }
      pe.value ? ke.key === "ArrowRight" ? ye(ie.value ? "prev" : "next") : ke.key === "ArrowLeft" && ye(ie.value ? "next" : "prev") : ke.key === "ArrowDown" ? ye("next") : ke.key === "ArrowUp" && ye("prev"), ke.key === "Home" ? ye("first") : ke.key === "End" && ye("last");
    }
    function he(ke, ye) {
      if (!ke) return;
      let Be = ke;
      do
        Be = Be == null ? void 0 : Be[ye === "next" ? "nextElementSibling" : "previousElementSibling"];
      while (Be != null && Be.hasAttribute("disabled"));
      return Be;
    }
    function ve(ke) {
      if (!Se.el) return;
      let ye;
      if (!ke)
        ye = focusableChildren(Se.el)[0];
      else if (ke === "next") {
        if (ye = he(Se.el.querySelector(":focus"), ke), !ye) return ve("first");
      } else if (ke === "prev") {
        if (ye = he(Se.el.querySelector(":focus"), ke), !ye) return ve("last");
      } else ke === "first" ? (ye = Se.el.firstElementChild, ye != null && ye.hasAttribute("disabled") && (ye = he(ye, "next"))) : ke === "last" && (ye = Se.el.lastElementChild, ye != null && ye.hasAttribute("disabled") && (ye = he(ye, "prev")));
      ye && ye.focus({
        preventScroll: !0
      });
    }
    function xe(ke) {
      const ye = pe.value && ie.value ? -1 : 1, Be = (ke === "prev" ? -ye : ye) * me.value;
      let Xe = de.value + Be;
      if (pe.value && ie.value && ge.el) {
        const {
          scrollWidth: et,
          offsetWidth: Ye
        } = ge.el;
        Xe += et - Ye;
      }
      Ue(Xe);
    }
    const $e = computed(() => ({
      next: ce.next,
      prev: ce.prev,
      select: ce.select,
      isSelected: ce.isSelected
    })), Te = computed(() => {
      switch (re.showArrows) {
        case "always":
          return !0;
        case "desktop":
          return !se.value;
        case !0:
          return ue.value || Math.abs(de.value) > 0;
        case "mobile":
          return se.value || ue.value || Math.abs(de.value) > 0;
        default:
          return !se.value && (ue.value || Math.abs(de.value) > 0);
      }
    }), Ie = computed(() => Math.abs(de.value) > 1), we = computed(() => {
      if (!ge.value) return !1;
      const ke = getScrollSize(pe.value, ge.el), ye = getClientSize(pe.value, ge.el);
      return ke - ye - Math.abs(de.value) > 1;
    });
    return useRender(() => createVNode(re.tag, {
      class: ["v-slide-group", {
        "v-slide-group--vertical": !pe.value,
        "v-slide-group--has-affixes": Te.value,
        "v-slide-group--is-overflowing": ue.value
      }, le.value, re.class],
      style: re.style,
      tabindex: Ne.value || ce.selected.value.length ? -1 : 0,
      onFocus: Re
    }, {
      default: () => {
        var ke, ye, Be;
        return [Te.value && createVNode("div", {
          key: "prev",
          class: ["v-slide-group__prev", {
            "v-slide-group__prev--disabled": !Ie.value
          }],
          onMousedown: Ce,
          onClick: () => Ie.value && xe("prev")
        }, [((ke = ae.prev) == null ? void 0 : ke.call(ae, $e.value)) ?? createVNode(VFadeTransition, null, {
          default: () => [createVNode(VIcon, {
            icon: ie.value ? re.nextIcon : re.prevIcon
          }, null)]
        })]), createVNode("div", {
          key: "container",
          ref: ge,
          class: "v-slide-group__container",
          onScroll: Ze
        }, [createVNode("div", {
          ref: Se,
          class: "v-slide-group__content",
          onFocusin: Fe,
          onFocusout: Ke,
          onKeydown: _e
        }, [(ye = ae.default) == null ? void 0 : ye.call(ae, $e.value)])]), Te.value && createVNode("div", {
          key: "next",
          class: ["v-slide-group__next", {
            "v-slide-group__next--disabled": !we.value
          }],
          onMousedown: Ce,
          onClick: () => we.value && xe("next")
        }, [((Be = ae.next) == null ? void 0 : Be.call(ae, $e.value)) ?? createVNode(VFadeTransition, null, {
          default: () => [createVNode(VIcon, {
            icon: ie.value ? re.prevIcon : re.nextIcon
          }, null)]
        })])];
      }
    })), {
      selected: ce.selected,
      scrollTo: xe,
      scrollOffset: de,
      focus: ve,
      hasPrev: Ie,
      hasNext: we
    };
  }
}), VChipGroupSymbol = Symbol.for("vuetify:v-chip-group"), makeVChipGroupProps = propsFactory({
  column: Boolean,
  filter: Boolean,
  valueComparator: {
    type: Function,
    default: deepEqual
  },
  ...makeVSlideGroupProps(),
  ...makeComponentProps(),
  ...makeGroupProps({
    selectedClass: "v-chip--selected"
  }),
  ...makeTagProps(),
  ...makeThemeProps(),
  ...makeVariantProps({
    variant: "tonal"
  })
}, "VChipGroup"), VChipGroup = genericComponent()({
  name: "VChipGroup",
  props: makeVChipGroupProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      themeClasses: ie
    } = provideTheme(re), {
      isSelected: le,
      select: se,
      next: ce,
      prev: ue,
      selected: de
    } = useGroup(re, VChipGroupSymbol);
    return provideDefaults({
      VChip: {
        color: toRef(re, "color"),
        disabled: toRef(re, "disabled"),
        filter: toRef(re, "filter"),
        variant: toRef(re, "variant")
      }
    }), useRender(() => {
      const me = VSlideGroup.filterProps(re);
      return createVNode(VSlideGroup, mergeProps(me, {
        class: ["v-chip-group", {
          "v-chip-group--column": re.column
        }, ie.value, re.class],
        style: re.style
      }), {
        default: () => {
          var fe;
          return [(fe = ae.default) == null ? void 0 : fe.call(ae, {
            isSelected: le,
            select: se,
            next: ce,
            prev: ue,
            selected: de.value
          })];
        }
      });
    }), {};
  }
}), makeVChipProps = propsFactory({
  activeClass: String,
  appendAvatar: String,
  appendIcon: IconValue,
  closable: Boolean,
  closeIcon: {
    type: IconValue,
    default: "$delete"
  },
  closeLabel: {
    type: String,
    default: "$vuetify.close"
  },
  draggable: Boolean,
  filter: Boolean,
  filterIcon: {
    type: IconValue,
    default: "$complete"
  },
  label: Boolean,
  link: {
    type: Boolean,
    default: void 0
  },
  pill: Boolean,
  prependAvatar: String,
  prependIcon: IconValue,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  text: {
    type: [String, Number, Boolean],
    default: void 0
  },
  modelValue: {
    type: Boolean,
    default: !0
  },
  onClick: EventProp(),
  onClickOnce: EventProp(),
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeElevationProps(),
  ...makeGroupItemProps(),
  ...makeRoundedProps(),
  ...makeRouterProps(),
  ...makeSizeProps(),
  ...makeTagProps({
    tag: "span"
  }),
  ...makeThemeProps(),
  ...makeVariantProps({
    variant: "tonal"
  })
}, "VChip"), VChip = genericComponent()({
  name: "VChip",
  directives: {
    Ripple
  },
  props: makeVChipProps(),
  emits: {
    "click:close": (re) => !0,
    "update:modelValue": (re) => !0,
    "group:selected": (re) => !0,
    click: (re) => !0
  },
  setup(re, ne) {
    let {
      attrs: ae,
      emit: ie,
      slots: le
    } = ne;
    const {
      t: se
    } = useLocale(), {
      borderClasses: ce
    } = useBorder(re), {
      colorClasses: ue,
      colorStyles: de,
      variantClasses: me
    } = useVariant(re), {
      densityClasses: fe
    } = useDensity(re), {
      elevationClasses: pe
    } = useElevation(re), {
      roundedClasses: ge
    } = useRounded(re), {
      sizeClasses: be
    } = useSize(re), {
      themeClasses: Se
    } = provideTheme(re), Pe = useProxiedModel(re, "modelValue"), Ee = useGroupItem(re, VChipGroupSymbol, !1), Ve = useLink(re, ae), Ae = computed(() => re.link !== !1 && Ve.isLink.value), Oe = computed(() => !re.disabled && re.link !== !1 && (!!Ee || re.link || Ve.isClickable.value)), Ne = computed(() => ({
      "aria-label": se(re.closeLabel),
      onClick(Ze) {
        Ze.preventDefault(), Ze.stopPropagation(), Pe.value = !1, ie("click:close", Ze);
      }
    }));
    function He(Ze) {
      var Fe;
      ie("click", Ze), Oe.value && ((Fe = Ve.navigate) == null || Fe.call(Ve, Ze), Ee == null || Ee.toggle());
    }
    function Ue(Ze) {
      (Ze.key === "Enter" || Ze.key === " ") && (Ze.preventDefault(), He(Ze));
    }
    return () => {
      var ve;
      const Ze = Ve.isLink.value ? "a" : re.tag, Fe = !!(re.appendIcon || re.appendAvatar), Ke = !!(Fe || le.append), tt = !!(le.close || re.closable), Re = !!(le.filter || re.filter) && Ee, Ce = !!(re.prependIcon || re.prependAvatar), _e = !!(Ce || le.prepend), he = !Ee || Ee.isSelected.value;
      return Pe.value && withDirectives(createVNode(Ze, mergeProps({
        class: ["v-chip", {
          "v-chip--disabled": re.disabled,
          "v-chip--label": re.label,
          "v-chip--link": Oe.value,
          "v-chip--filter": Re,
          "v-chip--pill": re.pill,
          [`${re.activeClass}`]: re.activeClass && ((ve = Ve.isActive) == null ? void 0 : ve.value)
        }, Se.value, ce.value, he ? ue.value : void 0, fe.value, pe.value, ge.value, be.value, me.value, Ee == null ? void 0 : Ee.selectedClass.value, re.class],
        style: [he ? de.value : void 0, re.style],
        disabled: re.disabled || void 0,
        draggable: re.draggable,
        tabindex: Oe.value ? 0 : void 0,
        onClick: He,
        onKeydown: Oe.value && !Ae.value && Ue
      }, Ve.linkProps), {
        default: () => {
          var xe;
          return [genOverlays(Oe.value, "v-chip"), Re && createVNode(VExpandXTransition, {
            key: "filter"
          }, {
            default: () => [withDirectives(createVNode("div", {
              class: "v-chip__filter"
            }, [le.filter ? createVNode(VDefaultsProvider, {
              key: "filter-defaults",
              disabled: !re.filterIcon,
              defaults: {
                VIcon: {
                  icon: re.filterIcon
                }
              }
            }, le.filter) : createVNode(VIcon, {
              key: "filter-icon",
              icon: re.filterIcon
            }, null)]), [[vShow, Ee.isSelected.value]])]
          }), _e && createVNode("div", {
            key: "prepend",
            class: "v-chip__prepend"
          }, [le.prepend ? createVNode(VDefaultsProvider, {
            key: "prepend-defaults",
            disabled: !Ce,
            defaults: {
              VAvatar: {
                image: re.prependAvatar,
                start: !0
              },
              VIcon: {
                icon: re.prependIcon,
                start: !0
              }
            }
          }, le.prepend) : createVNode(Fragment, null, [re.prependIcon && createVNode(VIcon, {
            key: "prepend-icon",
            icon: re.prependIcon,
            start: !0
          }, null), re.prependAvatar && createVNode(VAvatar, {
            key: "prepend-avatar",
            image: re.prependAvatar,
            start: !0
          }, null)])]), createVNode("div", {
            class: "v-chip__content",
            "data-no-activator": ""
          }, [((xe = le.default) == null ? void 0 : xe.call(le, {
            isSelected: Ee == null ? void 0 : Ee.isSelected.value,
            selectedClass: Ee == null ? void 0 : Ee.selectedClass.value,
            select: Ee == null ? void 0 : Ee.select,
            toggle: Ee == null ? void 0 : Ee.toggle,
            value: Ee == null ? void 0 : Ee.value.value,
            disabled: re.disabled
          })) ?? toDisplayString$1(re.text)]), Ke && createVNode("div", {
            key: "append",
            class: "v-chip__append"
          }, [le.append ? createVNode(VDefaultsProvider, {
            key: "append-defaults",
            disabled: !Fe,
            defaults: {
              VAvatar: {
                end: !0,
                image: re.appendAvatar
              },
              VIcon: {
                end: !0,
                icon: re.appendIcon
              }
            }
          }, le.append) : createVNode(Fragment, null, [re.appendIcon && createVNode(VIcon, {
            key: "append-icon",
            end: !0,
            icon: re.appendIcon
          }, null), re.appendAvatar && createVNode(VAvatar, {
            key: "append-avatar",
            end: !0,
            image: re.appendAvatar
          }, null)])]), tt && createVNode("button", mergeProps({
            key: "close",
            class: "v-chip__close",
            type: "button",
            "data-testid": "close-chip"
          }, Ne.value), [le.close ? createVNode(VDefaultsProvider, {
            key: "close-defaults",
            defaults: {
              VIcon: {
                icon: re.closeIcon,
                size: "x-small"
              }
            }
          }, le.close) : createVNode(VIcon, {
            key: "close-icon",
            icon: re.closeIcon,
            size: "x-small"
          }, null)])];
        }
      }), [[resolveDirective("ripple"), Oe.value && re.ripple, null]]);
    };
  }
}), ListKey = Symbol.for("vuetify:list");
function createList() {
  const re = inject(ListKey, {
    hasPrepend: shallowRef(!1),
    updateHasPrepend: () => null
  }), ne = {
    hasPrepend: shallowRef(!1),
    updateHasPrepend: (ae) => {
      ae && (ne.hasPrepend.value = ae);
    }
  };
  return provide(ListKey, ne), re;
}
function useList() {
  return inject(ListKey, null);
}
const independentActiveStrategy = (re) => {
  const ne = {
    activate: (ae) => {
      let {
        id: ie,
        value: le,
        activated: se
      } = ae;
      return ie = toRaw(ie), re && !le && se.size === 1 && se.has(ie) || (le ? se.add(ie) : se.delete(ie)), se;
    },
    in: (ae, ie, le) => {
      let se = /* @__PURE__ */ new Set();
      if (ae != null)
        for (const ce of wrapInArray(ae))
          se = ne.activate({
            id: ce,
            value: !0,
            activated: new Set(se),
            children: ie,
            parents: le
          });
      return se;
    },
    out: (ae) => Array.from(ae)
  };
  return ne;
}, independentSingleActiveStrategy = (re) => {
  const ne = independentActiveStrategy(re);
  return {
    activate: (ie) => {
      let {
        activated: le,
        id: se,
        ...ce
      } = ie;
      se = toRaw(se);
      const ue = le.has(se) ? /* @__PURE__ */ new Set([se]) : /* @__PURE__ */ new Set();
      return ne.activate({
        ...ce,
        id: se,
        activated: ue
      });
    },
    in: (ie, le, se) => {
      let ce = /* @__PURE__ */ new Set();
      if (ie != null) {
        const ue = wrapInArray(ie);
        ue.length && (ce = ne.in(ue.slice(0, 1), le, se));
      }
      return ce;
    },
    out: (ie, le, se) => ne.out(ie, le, se)
  };
}, leafActiveStrategy = (re) => {
  const ne = independentActiveStrategy(re);
  return {
    activate: (ie) => {
      let {
        id: le,
        activated: se,
        children: ce,
        ...ue
      } = ie;
      return le = toRaw(le), ce.has(le) ? se : ne.activate({
        id: le,
        activated: se,
        children: ce,
        ...ue
      });
    },
    in: ne.in,
    out: ne.out
  };
}, leafSingleActiveStrategy = (re) => {
  const ne = independentSingleActiveStrategy(re);
  return {
    activate: (ie) => {
      let {
        id: le,
        activated: se,
        children: ce,
        ...ue
      } = ie;
      return le = toRaw(le), ce.has(le) ? se : ne.activate({
        id: le,
        activated: se,
        children: ce,
        ...ue
      });
    },
    in: ne.in,
    out: ne.out
  };
}, singleOpenStrategy = {
  open: (re) => {
    let {
      id: ne,
      value: ae,
      opened: ie,
      parents: le
    } = re;
    if (ae) {
      const se = /* @__PURE__ */ new Set();
      se.add(ne);
      let ce = le.get(ne);
      for (; ce != null; )
        se.add(ce), ce = le.get(ce);
      return se;
    } else
      return ie.delete(ne), ie;
  },
  select: () => null
}, multipleOpenStrategy = {
  open: (re) => {
    let {
      id: ne,
      value: ae,
      opened: ie,
      parents: le
    } = re;
    if (ae) {
      let se = le.get(ne);
      for (ie.add(ne); se != null && se !== ne; )
        ie.add(se), se = le.get(se);
      return ie;
    } else
      ie.delete(ne);
    return ie;
  },
  select: () => null
}, listOpenStrategy = {
  open: multipleOpenStrategy.open,
  select: (re) => {
    let {
      id: ne,
      value: ae,
      opened: ie,
      parents: le
    } = re;
    if (!ae) return ie;
    const se = [];
    let ce = le.get(ne);
    for (; ce != null; )
      se.push(ce), ce = le.get(ce);
    return new Set(se);
  }
}, independentSelectStrategy = (re) => {
  const ne = {
    select: (ae) => {
      let {
        id: ie,
        value: le,
        selected: se
      } = ae;
      if (ie = toRaw(ie), re && !le) {
        const ce = Array.from(se.entries()).reduce((ue, de) => {
          let [me, fe] = de;
          return fe === "on" && ue.push(me), ue;
        }, []);
        if (ce.length === 1 && ce[0] === ie) return se;
      }
      return se.set(ie, le ? "on" : "off"), se;
    },
    in: (ae, ie, le) => {
      const se = /* @__PURE__ */ new Map();
      for (const ce of ae || [])
        ne.select({
          id: ce,
          value: !0,
          selected: se,
          children: ie,
          parents: le
        });
      return se;
    },
    out: (ae) => {
      const ie = [];
      for (const [le, se] of ae.entries())
        se === "on" && ie.push(le);
      return ie;
    }
  };
  return ne;
}, independentSingleSelectStrategy = (re) => {
  const ne = independentSelectStrategy(re);
  return {
    select: (ie) => {
      let {
        selected: le,
        id: se,
        ...ce
      } = ie;
      se = toRaw(se);
      const ue = le.has(se) ? /* @__PURE__ */ new Map([[se, le.get(se)]]) : /* @__PURE__ */ new Map();
      return ne.select({
        ...ce,
        id: se,
        selected: ue
      });
    },
    in: (ie, le, se) => ie != null && ie.length ? ne.in(ie.slice(0, 1), le, se) : /* @__PURE__ */ new Map(),
    out: (ie, le, se) => ne.out(ie, le, se)
  };
}, leafSelectStrategy = (re) => {
  const ne = independentSelectStrategy(re);
  return {
    select: (ie) => {
      let {
        id: le,
        selected: se,
        children: ce,
        ...ue
      } = ie;
      return le = toRaw(le), ce.has(le) ? se : ne.select({
        id: le,
        selected: se,
        children: ce,
        ...ue
      });
    },
    in: ne.in,
    out: ne.out
  };
}, leafSingleSelectStrategy = (re) => {
  const ne = independentSingleSelectStrategy(re);
  return {
    select: (ie) => {
      let {
        id: le,
        selected: se,
        children: ce,
        ...ue
      } = ie;
      return le = toRaw(le), ce.has(le) ? se : ne.select({
        id: le,
        selected: se,
        children: ce,
        ...ue
      });
    },
    in: ne.in,
    out: ne.out
  };
}, classicSelectStrategy = (re) => {
  const ne = {
    select: (ae) => {
      let {
        id: ie,
        value: le,
        selected: se,
        children: ce,
        parents: ue
      } = ae;
      ie = toRaw(ie);
      const de = new Map(se), me = [ie];
      for (; me.length; ) {
        const pe = me.shift();
        se.set(toRaw(pe), le ? "on" : "off"), ce.has(pe) && me.push(...ce.get(pe));
      }
      let fe = toRaw(ue.get(ie));
      for (; fe; ) {
        const pe = ce.get(fe), ge = pe.every((Se) => se.get(toRaw(Se)) === "on"), be = pe.every((Se) => !se.has(toRaw(Se)) || se.get(toRaw(Se)) === "off");
        se.set(fe, ge ? "on" : be ? "off" : "indeterminate"), fe = toRaw(ue.get(fe));
      }
      return re && !le && Array.from(se.entries()).reduce((ge, be) => {
        let [Se, Pe] = be;
        return Pe === "on" && ge.push(Se), ge;
      }, []).length === 0 ? de : se;
    },
    in: (ae, ie, le) => {
      let se = /* @__PURE__ */ new Map();
      for (const ce of ae || [])
        se = ne.select({
          id: ce,
          value: !0,
          selected: se,
          children: ie,
          parents: le
        });
      return se;
    },
    out: (ae, ie) => {
      const le = [];
      for (const [se, ce] of ae.entries())
        ce === "on" && !ie.has(se) && le.push(se);
      return le;
    }
  };
  return ne;
}, VNestedSymbol = Symbol.for("vuetify:nested"), emptyNested = {
  id: shallowRef(),
  root: {
    register: () => null,
    unregister: () => null,
    parents: ref$1(/* @__PURE__ */ new Map()),
    children: ref$1(/* @__PURE__ */ new Map()),
    open: () => null,
    openOnSelect: () => null,
    activate: () => null,
    select: () => null,
    activatable: ref$1(!1),
    selectable: ref$1(!1),
    opened: ref$1(/* @__PURE__ */ new Set()),
    activated: ref$1(/* @__PURE__ */ new Set()),
    selected: ref$1(/* @__PURE__ */ new Map()),
    selectedValues: ref$1([]),
    getPath: () => []
  }
}, makeNestedProps = propsFactory({
  activatable: Boolean,
  selectable: Boolean,
  activeStrategy: [String, Function, Object],
  selectStrategy: [String, Function, Object],
  openStrategy: [String, Object],
  opened: null,
  activated: null,
  selected: null,
  mandatory: Boolean
}, "nested"), useNested = (re) => {
  let ne = !1;
  const ae = ref$1(/* @__PURE__ */ new Map()), ie = ref$1(/* @__PURE__ */ new Map()), le = useProxiedModel(re, "opened", re.opened, (Se) => new Set(Se), (Se) => [...Se.values()]), se = computed(() => {
    if (typeof re.activeStrategy == "object") return re.activeStrategy;
    if (typeof re.activeStrategy == "function") return re.activeStrategy(re.mandatory);
    switch (re.activeStrategy) {
      case "leaf":
        return leafActiveStrategy(re.mandatory);
      case "single-leaf":
        return leafSingleActiveStrategy(re.mandatory);
      case "independent":
        return independentActiveStrategy(re.mandatory);
      case "single-independent":
      default:
        return independentSingleActiveStrategy(re.mandatory);
    }
  }), ce = computed(() => {
    if (typeof re.selectStrategy == "object") return re.selectStrategy;
    if (typeof re.selectStrategy == "function") return re.selectStrategy(re.mandatory);
    switch (re.selectStrategy) {
      case "single-leaf":
        return leafSingleSelectStrategy(re.mandatory);
      case "leaf":
        return leafSelectStrategy(re.mandatory);
      case "independent":
        return independentSelectStrategy(re.mandatory);
      case "single-independent":
        return independentSingleSelectStrategy(re.mandatory);
      case "classic":
      default:
        return classicSelectStrategy(re.mandatory);
    }
  }), ue = computed(() => {
    if (typeof re.openStrategy == "object") return re.openStrategy;
    switch (re.openStrategy) {
      case "list":
        return listOpenStrategy;
      case "single":
        return singleOpenStrategy;
      case "multiple":
      default:
        return multipleOpenStrategy;
    }
  }), de = useProxiedModel(re, "activated", re.activated, (Se) => se.value.in(Se, ae.value, ie.value), (Se) => se.value.out(Se, ae.value, ie.value)), me = useProxiedModel(re, "selected", re.selected, (Se) => ce.value.in(Se, ae.value, ie.value), (Se) => ce.value.out(Se, ae.value, ie.value));
  onBeforeUnmount(() => {
    ne = !0;
  });
  function fe(Se) {
    const Pe = [];
    let Ee = Se;
    for (; Ee != null; )
      Pe.unshift(Ee), Ee = ie.value.get(Ee);
    return Pe;
  }
  const pe = getCurrentInstance("nested"), ge = /* @__PURE__ */ new Set(), be = {
    id: shallowRef(),
    root: {
      opened: le,
      activatable: toRef(re, "activatable"),
      selectable: toRef(re, "selectable"),
      activated: de,
      selected: me,
      selectedValues: computed(() => {
        const Se = [];
        for (const [Pe, Ee] of me.value.entries())
          Ee === "on" && Se.push(Pe);
        return Se;
      }),
      register: (Se, Pe, Ee) => {
        if (ge.has(Se)) {
          const Ve = fe(Se).map(String).join(" -> "), Ae = fe(Pe).concat(Se).map(String).join(" -> ");
          consoleError(`Multiple nodes with the same ID
	${Ve}
	${Ae}`);
          return;
        } else
          ge.add(Se);
        Pe && Se !== Pe && ie.value.set(Se, Pe), Ee && ae.value.set(Se, []), Pe != null && ae.value.set(Pe, [...ae.value.get(Pe) || [], Se]);
      },
      unregister: (Se) => {
        if (ne) return;
        ge.delete(Se), ae.value.delete(Se);
        const Pe = ie.value.get(Se);
        if (Pe) {
          const Ee = ae.value.get(Pe) ?? [];
          ae.value.set(Pe, Ee.filter((Ve) => Ve !== Se));
        }
        ie.value.delete(Se);
      },
      open: (Se, Pe, Ee) => {
        pe.emit("click:open", {
          id: Se,
          value: Pe,
          path: fe(Se),
          event: Ee
        });
        const Ve = ue.value.open({
          id: Se,
          value: Pe,
          opened: new Set(le.value),
          children: ae.value,
          parents: ie.value,
          event: Ee
        });
        Ve && (le.value = Ve);
      },
      openOnSelect: (Se, Pe, Ee) => {
        const Ve = ue.value.select({
          id: Se,
          value: Pe,
          selected: new Map(me.value),
          opened: new Set(le.value),
          children: ae.value,
          parents: ie.value,
          event: Ee
        });
        Ve && (le.value = Ve);
      },
      select: (Se, Pe, Ee) => {
        pe.emit("click:select", {
          id: Se,
          value: Pe,
          path: fe(Se),
          event: Ee
        });
        const Ve = ce.value.select({
          id: Se,
          value: Pe,
          selected: new Map(me.value),
          children: ae.value,
          parents: ie.value,
          event: Ee
        });
        Ve && (me.value = Ve), be.root.openOnSelect(Se, Pe, Ee);
      },
      activate: (Se, Pe, Ee) => {
        if (!re.activatable)
          return be.root.select(Se, !0, Ee);
        pe.emit("click:activate", {
          id: Se,
          value: Pe,
          path: fe(Se),
          event: Ee
        });
        const Ve = se.value.activate({
          id: Se,
          value: Pe,
          activated: new Set(de.value),
          children: ae.value,
          parents: ie.value,
          event: Ee
        });
        if (Ve.size !== de.value.size)
          de.value = Ve;
        else {
          for (const Ae of Ve)
            if (!de.value.has(Ae)) {
              de.value = Ve;
              return;
            }
          for (const Ae of de.value)
            if (!Ve.has(Ae)) {
              de.value = Ve;
              return;
            }
        }
      },
      children: ae,
      parents: ie,
      getPath: fe
    }
  };
  return provide(VNestedSymbol, be), be.root;
}, useNestedItem = (re, ne) => {
  const ae = inject(VNestedSymbol, emptyNested), ie = Symbol(getUid()), le = computed(() => re.value !== void 0 ? re.value : ie), se = {
    ...ae,
    id: le,
    open: (ce, ue) => ae.root.open(le.value, ce, ue),
    openOnSelect: (ce, ue) => ae.root.openOnSelect(le.value, ce, ue),
    isOpen: computed(() => ae.root.opened.value.has(le.value)),
    parent: computed(() => ae.root.parents.value.get(le.value)),
    activate: (ce, ue) => ae.root.activate(le.value, ce, ue),
    isActivated: computed(() => ae.root.activated.value.has(toRaw(le.value))),
    select: (ce, ue) => ae.root.select(le.value, ce, ue),
    isSelected: computed(() => ae.root.selected.value.get(toRaw(le.value)) === "on"),
    isIndeterminate: computed(() => ae.root.selected.value.get(toRaw(le.value)) === "indeterminate"),
    isLeaf: computed(() => !ae.root.children.value.get(le.value)),
    isGroupActivator: ae.isGroupActivator
  };
  return onBeforeMount(() => {
    !ae.isGroupActivator && ae.root.register(le.value, ae.id.value, ne);
  }), onBeforeUnmount(() => {
    !ae.isGroupActivator && ae.root.unregister(le.value);
  }), ne && provide(VNestedSymbol, se), se;
}, useNestedGroupActivator = () => {
  const re = inject(VNestedSymbol, emptyNested);
  provide(VNestedSymbol, {
    ...re,
    isGroupActivator: !0
  });
}, VListGroupActivator = defineComponent({
  name: "VListGroupActivator",
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    return useNestedGroupActivator(), () => {
      var ie;
      return (ie = ae.default) == null ? void 0 : ie.call(ae);
    };
  }
}), makeVListGroupProps = propsFactory({
  /* @deprecated */
  activeColor: String,
  baseColor: String,
  color: String,
  collapseIcon: {
    type: IconValue,
    default: "$collapse"
  },
  expandIcon: {
    type: IconValue,
    default: "$expand"
  },
  prependIcon: IconValue,
  appendIcon: IconValue,
  fluid: Boolean,
  subgroup: Boolean,
  title: String,
  value: null,
  ...makeComponentProps(),
  ...makeTagProps()
}, "VListGroup"), VListGroup = genericComponent()({
  name: "VListGroup",
  props: makeVListGroupProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      isOpen: ie,
      open: le,
      id: se
    } = useNestedItem(toRef(re, "value"), !0), ce = computed(() => `v-list-group--id-${String(se.value)}`), ue = useList(), {
      isBooted: de
    } = useSsrBoot();
    function me(be) {
      be.stopPropagation(), le(!ie.value, be);
    }
    const fe = computed(() => ({
      onClick: me,
      class: "v-list-group__header",
      id: ce.value
    })), pe = computed(() => ie.value ? re.collapseIcon : re.expandIcon), ge = computed(() => ({
      VListItem: {
        active: ie.value,
        activeColor: re.activeColor,
        baseColor: re.baseColor,
        color: re.color,
        prependIcon: re.prependIcon || re.subgroup && pe.value,
        appendIcon: re.appendIcon || !re.subgroup && pe.value,
        title: re.title,
        value: re.value
      }
    }));
    return useRender(() => createVNode(re.tag, {
      class: ["v-list-group", {
        "v-list-group--prepend": ue == null ? void 0 : ue.hasPrepend.value,
        "v-list-group--fluid": re.fluid,
        "v-list-group--subgroup": re.subgroup,
        "v-list-group--open": ie.value
      }, re.class],
      style: re.style
    }, {
      default: () => [ae.activator && createVNode(VDefaultsProvider, {
        defaults: ge.value
      }, {
        default: () => [createVNode(VListGroupActivator, null, {
          default: () => [ae.activator({
            props: fe.value,
            isOpen: ie.value
          })]
        })]
      }), createVNode(MaybeTransition, {
        transition: {
          component: VExpandTransition
        },
        disabled: !de.value
      }, {
        default: () => {
          var be;
          return [withDirectives(createVNode("div", {
            class: "v-list-group__items",
            role: "group",
            "aria-labelledby": ce.value
          }, [(be = ae.default) == null ? void 0 : be.call(ae)]), [[vShow, ie.value]])];
        }
      })]
    })), {
      isOpen: ie
    };
  }
}), makeVListItemSubtitleProps = propsFactory({
  opacity: [Number, String],
  ...makeComponentProps(),
  ...makeTagProps()
}, "VListItemSubtitle"), VListItemSubtitle = genericComponent()({
  name: "VListItemSubtitle",
  props: makeVListItemSubtitleProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    return useRender(() => createVNode(re.tag, {
      class: ["v-list-item-subtitle", re.class],
      style: [{
        "--v-list-item-subtitle-opacity": re.opacity
      }, re.style]
    }, ae)), {};
  }
}), VListItemTitle = createSimpleFunctional("v-list-item-title"), makeVListItemProps = propsFactory({
  active: {
    type: Boolean,
    default: void 0
  },
  activeClass: String,
  /* @deprecated */
  activeColor: String,
  appendAvatar: String,
  appendIcon: IconValue,
  baseColor: String,
  disabled: Boolean,
  lines: [Boolean, String],
  link: {
    type: Boolean,
    default: void 0
  },
  nav: Boolean,
  prependAvatar: String,
  prependIcon: IconValue,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  slim: Boolean,
  subtitle: {
    type: [String, Number, Boolean],
    default: void 0
  },
  title: {
    type: [String, Number, Boolean],
    default: void 0
  },
  value: null,
  onClick: EventProp(),
  onClickOnce: EventProp(),
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeDimensionProps(),
  ...makeElevationProps(),
  ...makeRoundedProps(),
  ...makeRouterProps(),
  ...makeTagProps(),
  ...makeThemeProps(),
  ...makeVariantProps({
    variant: "text"
  })
}, "VListItem"), VListItem = genericComponent()({
  name: "VListItem",
  directives: {
    Ripple
  },
  props: makeVListItemProps(),
  emits: {
    click: (re) => !0
  },
  setup(re, ne) {
    let {
      attrs: ae,
      slots: ie,
      emit: le
    } = ne;
    const se = useLink(re, ae), ce = computed(() => re.value === void 0 ? se.href.value : re.value), {
      activate: ue,
      isActivated: de,
      select: me,
      isOpen: fe,
      isSelected: pe,
      isIndeterminate: ge,
      isGroupActivator: be,
      root: Se,
      parent: Pe,
      openOnSelect: Ee,
      id: Ve
    } = useNestedItem(ce, !1), Ae = useList(), Oe = computed(() => {
      var Xe;
      return re.active !== !1 && (re.active || ((Xe = se.isActive) == null ? void 0 : Xe.value) || (Se.activatable.value ? de.value : pe.value));
    }), Ne = computed(() => re.link !== !1 && se.isLink.value), He = computed(() => !!Ae && (Se.selectable.value || Se.activatable.value || re.value != null)), Ue = computed(() => !re.disabled && re.link !== !1 && (re.link || se.isClickable.value || He.value)), Ze = computed(() => re.rounded || re.nav), Fe = computed(() => re.color ?? re.activeColor), Ke = computed(() => ({
      color: Oe.value ? Fe.value ?? re.baseColor : re.baseColor,
      variant: re.variant
    }));
    watch(() => {
      var Xe;
      return (Xe = se.isActive) == null ? void 0 : Xe.value;
    }, (Xe) => {
      Xe && tt();
    }), onBeforeMount(() => {
      var Xe;
      (Xe = se.isActive) != null && Xe.value && tt();
    });
    function tt() {
      Pe.value != null && Se.open(Pe.value, !0), Ee(!0);
    }
    const {
      themeClasses: Re
    } = provideTheme(re), {
      borderClasses: Ce
    } = useBorder(re), {
      colorClasses: _e,
      colorStyles: he,
      variantClasses: ve
    } = useVariant(Ke), {
      densityClasses: xe
    } = useDensity(re), {
      dimensionStyles: $e
    } = useDimension(re), {
      elevationClasses: Te
    } = useElevation(re), {
      roundedClasses: Ie
    } = useRounded(Ze), we = computed(() => re.lines ? `v-list-item--${re.lines}-line` : void 0), ke = computed(() => ({
      isActive: Oe.value,
      select: me,
      isOpen: fe.value,
      isSelected: pe.value,
      isIndeterminate: ge.value
    }));
    function ye(Xe) {
      var et;
      le("click", Xe), Ue.value && ((et = se.navigate) == null || et.call(se, Xe), !be && (Se.activatable.value ? ue(!de.value, Xe) : (Se.selectable.value || re.value != null) && me(!pe.value, Xe)));
    }
    function Be(Xe) {
      const et = Xe.target;
      ["INPUT", "TEXTAREA"].includes(et.tagName) || (Xe.key === "Enter" || Xe.key === " ") && (Xe.preventDefault(), Xe.target.dispatchEvent(new MouseEvent("click", Xe)));
    }
    return useRender(() => {
      const Xe = Ne.value ? "a" : re.tag, et = ie.title || re.title != null, Ye = ie.subtitle || re.subtitle != null, De = !!(re.appendAvatar || re.appendIcon), je = !!(De || ie.append), rt = !!(re.prependAvatar || re.prependIcon), at = !!(rt || ie.prepend);
      return Ae == null || Ae.updateHasPrepend(at), re.activeColor && deprecate$1("active-color", ["color", "base-color"]), withDirectives(createVNode(Xe, mergeProps({
        class: ["v-list-item", {
          "v-list-item--active": Oe.value,
          "v-list-item--disabled": re.disabled,
          "v-list-item--link": Ue.value,
          "v-list-item--nav": re.nav,
          "v-list-item--prepend": !at && (Ae == null ? void 0 : Ae.hasPrepend.value),
          "v-list-item--slim": re.slim,
          [`${re.activeClass}`]: re.activeClass && Oe.value
        }, Re.value, Ce.value, _e.value, xe.value, Te.value, we.value, Ie.value, ve.value, re.class],
        style: [he.value, $e.value, re.style],
        tabindex: Ue.value ? Ae ? -2 : 0 : void 0,
        "aria-selected": He.value ? Se.activatable.value ? de.value : Se.selectable.value ? pe.value : Oe.value : void 0,
        onClick: ye,
        onKeydown: Ue.value && !Ne.value && Be
      }, se.linkProps), {
        default: () => {
          var qe;
          return [genOverlays(Ue.value || Oe.value, "v-list-item"), at && createVNode("div", {
            key: "prepend",
            class: "v-list-item__prepend"
          }, [ie.prepend ? createVNode(VDefaultsProvider, {
            key: "prepend-defaults",
            disabled: !rt,
            defaults: {
              VAvatar: {
                density: re.density,
                image: re.prependAvatar
              },
              VIcon: {
                density: re.density,
                icon: re.prependIcon
              },
              VListItemAction: {
                start: !0
              }
            }
          }, {
            default: () => {
              var We;
              return [(We = ie.prepend) == null ? void 0 : We.call(ie, ke.value)];
            }
          }) : createVNode(Fragment, null, [re.prependAvatar && createVNode(VAvatar, {
            key: "prepend-avatar",
            density: re.density,
            image: re.prependAvatar
          }, null), re.prependIcon && createVNode(VIcon, {
            key: "prepend-icon",
            density: re.density,
            icon: re.prependIcon
          }, null)]), createVNode("div", {
            class: "v-list-item__spacer"
          }, null)]), createVNode("div", {
            class: "v-list-item__content",
            "data-no-activator": ""
          }, [et && createVNode(VListItemTitle, {
            key: "title"
          }, {
            default: () => {
              var We;
              return [((We = ie.title) == null ? void 0 : We.call(ie, {
                title: re.title
              })) ?? toDisplayString$1(re.title)];
            }
          }), Ye && createVNode(VListItemSubtitle, {
            key: "subtitle"
          }, {
            default: () => {
              var We;
              return [((We = ie.subtitle) == null ? void 0 : We.call(ie, {
                subtitle: re.subtitle
              })) ?? toDisplayString$1(re.subtitle)];
            }
          }), (qe = ie.default) == null ? void 0 : qe.call(ie, ke.value)]), je && createVNode("div", {
            key: "append",
            class: "v-list-item__append"
          }, [ie.append ? createVNode(VDefaultsProvider, {
            key: "append-defaults",
            disabled: !De,
            defaults: {
              VAvatar: {
                density: re.density,
                image: re.appendAvatar
              },
              VIcon: {
                density: re.density,
                icon: re.appendIcon
              },
              VListItemAction: {
                end: !0
              }
            }
          }, {
            default: () => {
              var We;
              return [(We = ie.append) == null ? void 0 : We.call(ie, ke.value)];
            }
          }) : createVNode(Fragment, null, [re.appendIcon && createVNode(VIcon, {
            key: "append-icon",
            density: re.density,
            icon: re.appendIcon
          }, null), re.appendAvatar && createVNode(VAvatar, {
            key: "append-avatar",
            density: re.density,
            image: re.appendAvatar
          }, null)]), createVNode("div", {
            class: "v-list-item__spacer"
          }, null)])];
        }
      }), [[resolveDirective("ripple"), Ue.value && re.ripple]]);
    }), {
      activate: ue,
      isActivated: de,
      isGroupActivator: be,
      isSelected: pe,
      list: Ae,
      select: me,
      root: Se,
      id: Ve,
      link: se
    };
  }
}), makeVListSubheaderProps = propsFactory({
  color: String,
  inset: Boolean,
  sticky: Boolean,
  title: String,
  ...makeComponentProps(),
  ...makeTagProps()
}, "VListSubheader"), VListSubheader = genericComponent()({
  name: "VListSubheader",
  props: makeVListSubheaderProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      textColorClasses: ie,
      textColorStyles: le
    } = useTextColor(toRef(re, "color"));
    return useRender(() => {
      const se = !!(ae.default || re.title);
      return createVNode(re.tag, {
        class: ["v-list-subheader", {
          "v-list-subheader--inset": re.inset,
          "v-list-subheader--sticky": re.sticky
        }, ie.value, re.class],
        style: [{
          textColorStyles: le
        }, re.style]
      }, {
        default: () => {
          var ce;
          return [se && createVNode("div", {
            class: "v-list-subheader__text"
          }, [((ce = ae.default) == null ? void 0 : ce.call(ae)) ?? re.title])];
        }
      });
    }), {};
  }
}), makeVDividerProps = propsFactory({
  color: String,
  inset: Boolean,
  length: [Number, String],
  opacity: [Number, String],
  thickness: [Number, String],
  vertical: Boolean,
  ...makeComponentProps(),
  ...makeThemeProps()
}, "VDivider"), VDivider = genericComponent()({
  name: "VDivider",
  props: makeVDividerProps(),
  setup(re, ne) {
    let {
      attrs: ae,
      slots: ie
    } = ne;
    const {
      themeClasses: le
    } = provideTheme(re), {
      textColorClasses: se,
      textColorStyles: ce
    } = useTextColor(toRef(re, "color")), ue = computed(() => {
      const de = {};
      return re.length && (de[re.vertical ? "height" : "width"] = convertToUnit(re.length)), re.thickness && (de[re.vertical ? "borderRightWidth" : "borderTopWidth"] = convertToUnit(re.thickness)), de;
    });
    return useRender(() => {
      const de = createVNode("hr", {
        class: [{
          "v-divider": !0,
          "v-divider--inset": re.inset,
          "v-divider--vertical": re.vertical
        }, le.value, se.value, re.class],
        style: [ue.value, ce.value, {
          "--v-border-opacity": re.opacity
        }, re.style],
        "aria-orientation": !ae.role || ae.role === "separator" ? re.vertical ? "vertical" : "horizontal" : void 0,
        role: `${ae.role || "separator"}`
      }, null);
      return ie.default ? createVNode("div", {
        class: ["v-divider__wrapper", {
          "v-divider__wrapper--vertical": re.vertical,
          "v-divider__wrapper--inset": re.inset
        }]
      }, [de, createVNode("div", {
        class: "v-divider__content"
      }, [ie.default()]), de]) : de;
    }), {};
  }
}), makeVListChildrenProps = propsFactory({
  items: Array,
  returnObject: Boolean
}, "VListChildren"), VListChildren = genericComponent()({
  name: "VListChildren",
  props: makeVListChildrenProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    return createList(), () => {
      var ie, le;
      return ((ie = ae.default) == null ? void 0 : ie.call(ae)) ?? ((le = re.items) == null ? void 0 : le.map((se) => {
        var ge, be;
        let {
          children: ce,
          props: ue,
          type: de,
          raw: me
        } = se;
        if (de === "divider")
          return ((ge = ae.divider) == null ? void 0 : ge.call(ae, {
            props: ue
          })) ?? createVNode(VDivider, ue, null);
        if (de === "subheader")
          return ((be = ae.subheader) == null ? void 0 : be.call(ae, {
            props: ue
          })) ?? createVNode(VListSubheader, ue, null);
        const fe = {
          subtitle: ae.subtitle ? (Se) => {
            var Pe;
            return (Pe = ae.subtitle) == null ? void 0 : Pe.call(ae, {
              ...Se,
              item: me
            });
          } : void 0,
          prepend: ae.prepend ? (Se) => {
            var Pe;
            return (Pe = ae.prepend) == null ? void 0 : Pe.call(ae, {
              ...Se,
              item: me
            });
          } : void 0,
          append: ae.append ? (Se) => {
            var Pe;
            return (Pe = ae.append) == null ? void 0 : Pe.call(ae, {
              ...Se,
              item: me
            });
          } : void 0,
          title: ae.title ? (Se) => {
            var Pe;
            return (Pe = ae.title) == null ? void 0 : Pe.call(ae, {
              ...Se,
              item: me
            });
          } : void 0
        }, pe = VListGroup.filterProps(ue);
        return ce ? createVNode(VListGroup, mergeProps({
          value: ue == null ? void 0 : ue.value
        }, pe), {
          activator: (Se) => {
            let {
              props: Pe
            } = Se;
            const Ee = {
              ...ue,
              ...Pe,
              value: re.returnObject ? me : ue.value
            };
            return ae.header ? ae.header({
              props: Ee
            }) : createVNode(VListItem, Ee, fe);
          },
          default: () => createVNode(VListChildren, {
            items: ce,
            returnObject: re.returnObject
          }, ae)
        }) : ae.item ? ae.item({
          props: ue
        }) : createVNode(VListItem, mergeProps(ue, {
          value: re.returnObject ? me : ue.value
        }), fe);
      }));
    };
  }
}), makeItemsProps = propsFactory({
  items: {
    type: Array,
    default: () => []
  },
  itemTitle: {
    type: [String, Array, Function],
    default: "title"
  },
  itemValue: {
    type: [String, Array, Function],
    default: "value"
  },
  itemChildren: {
    type: [Boolean, String, Array, Function],
    default: "children"
  },
  itemProps: {
    type: [Boolean, String, Array, Function],
    default: "props"
  },
  returnObject: Boolean,
  valueComparator: Function
}, "list-items");
function transformItem$3(re, ne) {
  const ae = getPropertyFromItem(ne, re.itemTitle, ne), ie = getPropertyFromItem(ne, re.itemValue, ae), le = getPropertyFromItem(ne, re.itemChildren), se = re.itemProps === !0 ? typeof ne == "object" && ne != null && !Array.isArray(ne) ? "children" in ne ? omit(ne, ["children"]) : ne : void 0 : getPropertyFromItem(ne, re.itemProps), ce = {
    title: ae,
    value: ie,
    ...se
  };
  return {
    title: String(ce.title ?? ""),
    value: ce.value,
    props: ce,
    children: Array.isArray(le) ? transformItems$3(re, le) : void 0,
    raw: ne
  };
}
function transformItems$3(re, ne) {
  const ae = pick(re, ["itemTitle", "itemValue", "itemChildren", "itemProps", "returnObject", "valueComparator"]), ie = [];
  for (const le of ne)
    ie.push(transformItem$3(ae, le));
  return ie;
}
function useItems(re) {
  const ne = computed(() => transformItems$3(re, re.items)), ae = computed(() => ne.value.some((ue) => ue.value === null)), ie = shallowRef(/* @__PURE__ */ new Map()), le = shallowRef([]);
  watchEffect(() => {
    const ue = ne.value, de = /* @__PURE__ */ new Map(), me = [];
    for (let fe = 0; fe < ue.length; fe++) {
      const pe = ue[fe];
      if (isPrimitive$1(pe.value) || pe.value === null) {
        let ge = de.get(pe.value);
        ge || (ge = [], de.set(pe.value, ge)), ge.push(pe);
      } else
        me.push(pe);
    }
    ie.value = de, le.value = me;
  });
  function se(ue) {
    const de = ie.value, me = ne.value, fe = le.value, pe = ae.value, ge = re.returnObject, be = !!re.valueComparator, Se = re.valueComparator || deepEqual, Pe = pick(re, ["itemTitle", "itemValue", "itemChildren", "itemProps", "returnObject", "valueComparator"]), Ee = [];
    e: for (const Ve of ue) {
      if (!pe && Ve === null) continue;
      if (ge && typeof Ve == "string") {
        Ee.push(transformItem$3(Pe, Ve));
        continue;
      }
      const Ae = de.get(Ve);
      if (be || !Ae) {
        for (const Oe of be ? me : fe)
          if (Se(Ve, Oe.value)) {
            Ee.push(Oe);
            continue e;
          }
        Ee.push(transformItem$3(Pe, Ve));
        continue;
      }
      Ee.push(...Ae);
    }
    return Ee;
  }
  function ce(ue) {
    return re.returnObject ? ue.map((de) => {
      let {
        raw: me
      } = de;
      return me;
    }) : ue.map((de) => {
      let {
        value: me
      } = de;
      return me;
    });
  }
  return {
    items: ne,
    transformIn: se,
    transformOut: ce
  };
}
function transformItem$2(re, ne) {
  const ae = getPropertyFromItem(ne, re.itemType, "item"), ie = isPrimitive$1(ne) ? ne : getPropertyFromItem(ne, re.itemTitle), le = getPropertyFromItem(ne, re.itemValue, void 0), se = getPropertyFromItem(ne, re.itemChildren), ce = re.itemProps === !0 ? omit(ne, ["children"]) : getPropertyFromItem(ne, re.itemProps), ue = {
    title: ie,
    value: le,
    ...ce
  };
  return {
    type: ae,
    title: ue.title,
    value: ue.value,
    props: ue,
    children: ae === "item" && se ? transformItems$2(re, se) : void 0,
    raw: ne
  };
}
function transformItems$2(re, ne) {
  const ae = [];
  for (const ie of ne)
    ae.push(transformItem$2(re, ie));
  return ae;
}
function useListItems(re) {
  return {
    items: computed(() => transformItems$2(re, re.items))
  };
}
const makeVListProps = propsFactory({
  baseColor: String,
  /* @deprecated */
  activeColor: String,
  activeClass: String,
  bgColor: String,
  disabled: Boolean,
  expandIcon: IconValue,
  collapseIcon: IconValue,
  lines: {
    type: [Boolean, String],
    default: "one"
  },
  slim: Boolean,
  nav: Boolean,
  "onClick:open": EventProp(),
  "onClick:select": EventProp(),
  "onUpdate:opened": EventProp(),
  ...makeNestedProps({
    selectStrategy: "single-leaf",
    openStrategy: "list"
  }),
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeDimensionProps(),
  ...makeElevationProps(),
  itemType: {
    type: String,
    default: "type"
  },
  ...makeItemsProps(),
  ...makeRoundedProps(),
  ...makeTagProps(),
  ...makeThemeProps(),
  ...makeVariantProps({
    variant: "text"
  })
}, "VList"), VList = genericComponent()({
  name: "VList",
  props: makeVListProps(),
  emits: {
    "update:selected": (re) => !0,
    "update:activated": (re) => !0,
    "update:opened": (re) => !0,
    "click:open": (re) => !0,
    "click:activate": (re) => !0,
    "click:select": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      items: ie
    } = useListItems(re), {
      themeClasses: le
    } = provideTheme(re), {
      backgroundColorClasses: se,
      backgroundColorStyles: ce
    } = useBackgroundColor(toRef(re, "bgColor")), {
      borderClasses: ue
    } = useBorder(re), {
      densityClasses: de
    } = useDensity(re), {
      dimensionStyles: me
    } = useDimension(re), {
      elevationClasses: fe
    } = useElevation(re), {
      roundedClasses: pe
    } = useRounded(re), {
      children: ge,
      open: be,
      parents: Se,
      select: Pe,
      getPath: Ee
    } = useNested(re), Ve = computed(() => re.lines ? `v-list--${re.lines}-line` : void 0), Ae = toRef(re, "activeColor"), Oe = toRef(re, "baseColor"), Ne = toRef(re, "color");
    createList(), provideDefaults({
      VListGroup: {
        activeColor: Ae,
        baseColor: Oe,
        color: Ne,
        expandIcon: toRef(re, "expandIcon"),
        collapseIcon: toRef(re, "collapseIcon")
      },
      VListItem: {
        activeClass: toRef(re, "activeClass"),
        activeColor: Ae,
        baseColor: Oe,
        color: Ne,
        density: toRef(re, "density"),
        disabled: toRef(re, "disabled"),
        lines: toRef(re, "lines"),
        nav: toRef(re, "nav"),
        slim: toRef(re, "slim"),
        variant: toRef(re, "variant")
      }
    });
    const He = shallowRef(!1), Ue = ref$1();
    function Ze(_e) {
      He.value = !0;
    }
    function Fe(_e) {
      He.value = !1;
    }
    function Ke(_e) {
      var he;
      !He.value && !(_e.relatedTarget && ((he = Ue.value) != null && he.contains(_e.relatedTarget))) && Ce();
    }
    function tt(_e) {
      const he = _e.target;
      if (!(!Ue.value || ["INPUT", "TEXTAREA"].includes(he.tagName))) {
        if (_e.key === "ArrowDown")
          Ce("next");
        else if (_e.key === "ArrowUp")
          Ce("prev");
        else if (_e.key === "Home")
          Ce("first");
        else if (_e.key === "End")
          Ce("last");
        else
          return;
        _e.preventDefault();
      }
    }
    function Re(_e) {
      He.value = !0;
    }
    function Ce(_e) {
      if (Ue.value)
        return focusChild(Ue.value, _e);
    }
    return useRender(() => createVNode(re.tag, {
      ref: Ue,
      class: ["v-list", {
        "v-list--disabled": re.disabled,
        "v-list--nav": re.nav,
        "v-list--slim": re.slim
      }, le.value, se.value, ue.value, de.value, fe.value, Ve.value, pe.value, re.class],
      style: [ce.value, me.value, re.style],
      tabindex: re.disabled ? -1 : 0,
      role: "listbox",
      "aria-activedescendant": void 0,
      onFocusin: Ze,
      onFocusout: Fe,
      onFocus: Ke,
      onKeydown: tt,
      onMousedown: Re
    }, {
      default: () => [createVNode(VListChildren, {
        items: ie.value,
        returnObject: re.returnObject
      }, ae)]
    })), {
      open: be,
      select: Pe,
      focus: Ce,
      children: ge,
      parents: Se,
      getPath: Ee
    };
  }
}), VListImg = createSimpleFunctional("v-list-img"), makeVListItemActionProps = propsFactory({
  start: Boolean,
  end: Boolean,
  ...makeComponentProps(),
  ...makeTagProps()
}, "VListItemAction"), VListItemAction = genericComponent()({
  name: "VListItemAction",
  props: makeVListItemActionProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    return useRender(() => createVNode(re.tag, {
      class: ["v-list-item-action", {
        "v-list-item-action--start": re.start,
        "v-list-item-action--end": re.end
      }, re.class],
      style: re.style
    }, ae)), {};
  }
}), makeVListItemMediaProps = propsFactory({
  start: Boolean,
  end: Boolean,
  ...makeComponentProps(),
  ...makeTagProps()
}, "VListItemMedia"), VListItemMedia = genericComponent()({
  name: "VListItemMedia",
  props: makeVListItemMediaProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    return useRender(() => createVNode(re.tag, {
      class: ["v-list-item-media", {
        "v-list-item-media--start": re.start,
        "v-list-item-media--end": re.end
      }, re.class],
      style: re.style
    }, ae)), {};
  }
}), makeVCounterProps = propsFactory({
  active: Boolean,
  disabled: Boolean,
  max: [Number, String],
  value: {
    type: [Number, String],
    default: 0
  },
  ...makeComponentProps(),
  ...makeTransitionProps({
    transition: {
      component: VSlideYTransition
    }
  })
}, "VCounter"), VCounter = genericComponent()({
  name: "VCounter",
  functional: !0,
  props: makeVCounterProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = computed(() => re.max ? `${re.value} / ${re.max}` : String(re.value));
    return useRender(() => createVNode(MaybeTransition, {
      transition: re.transition
    }, {
      default: () => [withDirectives(createVNode("div", {
        class: ["v-counter", {
          "text-error": re.max && !re.disabled && parseFloat(re.value) > parseFloat(re.max)
        }, re.class],
        style: re.style
      }, [ae.default ? ae.default({
        counter: ie.value,
        max: re.max,
        value: re.value
      }) : ie.value]), [[vShow, re.active]])]
    })), {};
  }
}), makeVFieldLabelProps = propsFactory({
  floating: Boolean,
  ...makeComponentProps()
}, "VFieldLabel"), VFieldLabel = genericComponent()({
  name: "VFieldLabel",
  props: makeVFieldLabelProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    return useRender(() => createVNode(VLabel, {
      class: ["v-field-label", {
        "v-field-label--floating": re.floating
      }, re.class],
      style: re.style,
      "aria-hidden": re.floating || void 0
    }, ae)), {};
  }
}), allowedVariants$1 = ["underlined", "outlined", "filled", "solo", "solo-inverted", "solo-filled", "plain"], makeVFieldProps = propsFactory({
  appendInnerIcon: IconValue,
  bgColor: String,
  clearable: Boolean,
  clearIcon: {
    type: IconValue,
    default: "$clear"
  },
  active: Boolean,
  centerAffix: {
    type: Boolean,
    default: void 0
  },
  color: String,
  baseColor: String,
  dirty: Boolean,
  disabled: {
    type: Boolean,
    default: null
  },
  error: Boolean,
  flat: Boolean,
  label: String,
  persistentClear: Boolean,
  prependInnerIcon: IconValue,
  reverse: Boolean,
  singleLine: Boolean,
  variant: {
    type: String,
    default: "filled",
    validator: (re) => allowedVariants$1.includes(re)
  },
  "onClick:clear": EventProp(),
  "onClick:appendInner": EventProp(),
  "onClick:prependInner": EventProp(),
  ...makeComponentProps(),
  ...makeLoaderProps(),
  ...makeRoundedProps(),
  ...makeThemeProps()
}, "VField"), VField = genericComponent()({
  name: "VField",
  inheritAttrs: !1,
  props: {
    id: String,
    ...makeFocusProps(),
    ...makeVFieldProps()
  },
  emits: {
    "update:focused": (re) => !0,
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      attrs: ae,
      emit: ie,
      slots: le
    } = ne;
    const {
      themeClasses: se
    } = provideTheme(re), {
      loaderClasses: ce
    } = useLoader(re), {
      focusClasses: ue,
      isFocused: de,
      focus: me,
      blur: fe
    } = useFocus(re), {
      InputIcon: pe
    } = useInputIcon(re), {
      roundedClasses: ge
    } = useRounded(re), {
      rtlClasses: be
    } = useRtl(), Se = computed(() => re.dirty || re.active), Pe = computed(() => !!(re.label || le.label)), Ee = computed(() => !re.singleLine && Pe.value), Ve = getUid(), Ae = computed(() => re.id || `input-${Ve}`), Oe = computed(() => `${Ae.value}-messages`), Ne = ref$1(), He = ref$1(), Ue = ref$1(), Ze = computed(() => ["plain", "underlined"].includes(re.variant)), {
      backgroundColorClasses: Fe,
      backgroundColorStyles: Ke
    } = useBackgroundColor(toRef(re, "bgColor")), {
      textColorClasses: tt,
      textColorStyles: Re
    } = useTextColor(computed(() => re.error || re.disabled ? void 0 : Se.value && de.value ? re.color : re.baseColor));
    watch(Se, (he) => {
      if (Ee.value) {
        const ve = Ne.value.$el, xe = He.value.$el;
        requestAnimationFrame(() => {
          const $e = nullifyTransforms(ve), Te = xe.getBoundingClientRect(), Ie = Te.x - $e.x, we = Te.y - $e.y - ($e.height / 2 - Te.height / 2), ke = Te.width / 0.75, ye = Math.abs(ke - $e.width) > 1 ? {
            maxWidth: convertToUnit(ke)
          } : void 0, Be = getComputedStyle(ve), Xe = getComputedStyle(xe), et = parseFloat(Be.transitionDuration) * 1e3 || 150, Ye = parseFloat(Xe.getPropertyValue("--v-field-label-scale")), De = Xe.getPropertyValue("color");
          ve.style.visibility = "visible", xe.style.visibility = "hidden", animate(ve, {
            transform: `translate(${Ie}px, ${we}px) scale(${Ye})`,
            color: De,
            ...ye
          }, {
            duration: et,
            easing: standardEasing,
            direction: he ? "normal" : "reverse"
          }).finished.then(() => {
            ve.style.removeProperty("visibility"), xe.style.removeProperty("visibility");
          });
        });
      }
    }, {
      flush: "post"
    });
    const Ce = computed(() => ({
      isActive: Se,
      isFocused: de,
      controlRef: Ue,
      blur: fe,
      focus: me
    }));
    function _e(he) {
      he.target !== document.activeElement && he.preventDefault();
    }
    return useRender(() => {
      var Ie, we, ke;
      const he = re.variant === "outlined", ve = !!(le["prepend-inner"] || re.prependInnerIcon), xe = !!(re.clearable || le.clear) && !re.disabled, $e = !!(le["append-inner"] || re.appendInnerIcon || xe), Te = () => le.label ? le.label({
        ...Ce.value,
        label: re.label,
        props: {
          for: Ae.value
        }
      }) : re.label;
      return createVNode("div", mergeProps({
        class: ["v-field", {
          "v-field--active": Se.value,
          "v-field--appended": $e,
          "v-field--center-affix": re.centerAffix ?? !Ze.value,
          "v-field--disabled": re.disabled,
          "v-field--dirty": re.dirty,
          "v-field--error": re.error,
          "v-field--flat": re.flat,
          "v-field--has-background": !!re.bgColor,
          "v-field--persistent-clear": re.persistentClear,
          "v-field--prepended": ve,
          "v-field--reverse": re.reverse,
          "v-field--single-line": re.singleLine,
          "v-field--no-label": !Te(),
          [`v-field--variant-${re.variant}`]: !0
        }, se.value, Fe.value, ue.value, ce.value, ge.value, be.value, re.class],
        style: [Ke.value, re.style],
        onClick: _e
      }, ae), [createVNode("div", {
        class: "v-field__overlay"
      }, null), createVNode(LoaderSlot, {
        name: "v-field",
        active: !!re.loading,
        color: re.error ? "error" : typeof re.loading == "string" ? re.loading : re.color
      }, {
        default: le.loader
      }), ve && createVNode("div", {
        key: "prepend",
        class: "v-field__prepend-inner"
      }, [re.prependInnerIcon && createVNode(pe, {
        key: "prepend-icon",
        name: "prependInner"
      }, null), (Ie = le["prepend-inner"]) == null ? void 0 : Ie.call(le, Ce.value)]), createVNode("div", {
        class: "v-field__field",
        "data-no-activator": ""
      }, [["filled", "solo", "solo-inverted", "solo-filled"].includes(re.variant) && Ee.value && createVNode(VFieldLabel, {
        key: "floating-label",
        ref: He,
        class: [tt.value],
        floating: !0,
        for: Ae.value,
        style: Re.value
      }, {
        default: () => [Te()]
      }), Pe.value && createVNode(VFieldLabel, {
        key: "label",
        ref: Ne,
        for: Ae.value
      }, {
        default: () => [Te()]
      }), (we = le.default) == null ? void 0 : we.call(le, {
        ...Ce.value,
        props: {
          id: Ae.value,
          class: "v-field__input",
          "aria-describedby": Oe.value
        },
        focus: me,
        blur: fe
      })]), xe && createVNode(VExpandXTransition, {
        key: "clear"
      }, {
        default: () => [withDirectives(createVNode("div", {
          class: "v-field__clearable",
          onMousedown: (ye) => {
            ye.preventDefault(), ye.stopPropagation();
          }
        }, [createVNode(VDefaultsProvider, {
          defaults: {
            VIcon: {
              icon: re.clearIcon
            }
          }
        }, {
          default: () => [le.clear ? le.clear({
            ...Ce.value,
            props: {
              onFocus: me,
              onBlur: fe,
              onClick: re["onClick:clear"]
            }
          }) : createVNode(pe, {
            name: "clear",
            onFocus: me,
            onBlur: fe
          }, null)]
        })]), [[vShow, re.dirty]])]
      }), $e && createVNode("div", {
        key: "append",
        class: "v-field__append-inner"
      }, [(ke = le["append-inner"]) == null ? void 0 : ke.call(le, Ce.value), re.appendInnerIcon && createVNode(pe, {
        key: "append-icon",
        name: "appendInner"
      }, null)]), createVNode("div", {
        class: ["v-field__outline", tt.value],
        style: Re.value
      }, [he && createVNode(Fragment, null, [createVNode("div", {
        class: "v-field__outline__start"
      }, null), Ee.value && createVNode("div", {
        class: "v-field__outline__notch"
      }, [createVNode(VFieldLabel, {
        ref: He,
        floating: !0,
        for: Ae.value
      }, {
        default: () => [Te()]
      })]), createVNode("div", {
        class: "v-field__outline__end"
      }, null)]), Ze.value && Ee.value && createVNode(VFieldLabel, {
        ref: He,
        floating: !0,
        for: Ae.value
      }, {
        default: () => [Te()]
      })])]);
    }), {
      controlRef: Ue
    };
  }
}), activeTypes = ["color", "file", "time", "date", "datetime-local", "week", "month"], makeVTextFieldProps = propsFactory({
  autofocus: Boolean,
  counter: [Boolean, Number, String],
  counterValue: [Number, Function],
  prefix: String,
  placeholder: String,
  persistentPlaceholder: Boolean,
  persistentCounter: Boolean,
  suffix: String,
  role: String,
  type: {
    type: String,
    default: "text"
  },
  modelModifiers: Object,
  ...makeVInputProps(),
  ...makeVFieldProps()
}, "VTextField"), VTextField = genericComponent()({
  name: "VTextField",
  directives: {
    Intersect
  },
  inheritAttrs: !1,
  props: makeVTextFieldProps(),
  emits: {
    "click:control": (re) => !0,
    "mousedown:control": (re) => !0,
    "update:focused": (re) => !0,
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      attrs: ae,
      emit: ie,
      slots: le
    } = ne;
    const se = useProxiedModel(re, "modelValue"), {
      isFocused: ce,
      focus: ue,
      blur: de
    } = useFocus(re), me = computed(() => typeof re.counterValue == "function" ? re.counterValue(se.value) : typeof re.counterValue == "number" ? re.counterValue : (se.value ?? "").toString().length), fe = computed(() => {
      if (ae.maxlength) return ae.maxlength;
      if (!(!re.counter || typeof re.counter != "number" && typeof re.counter != "string"))
        return re.counter;
    }), pe = computed(() => ["plain", "underlined"].includes(re.variant));
    function ge(Ue, Ze) {
      var Fe, Ke;
      !re.autofocus || !Ue || (Ke = (Fe = Ze[0].target) == null ? void 0 : Fe.focus) == null || Ke.call(Fe);
    }
    const be = ref$1(), Se = ref$1(), Pe = ref$1(), Ee = computed(() => activeTypes.includes(re.type) || re.persistentPlaceholder || ce.value || re.active);
    function Ve() {
      var Ue;
      Pe.value !== document.activeElement && ((Ue = Pe.value) == null || Ue.focus()), ce.value || ue();
    }
    function Ae(Ue) {
      ie("mousedown:control", Ue), Ue.target !== Pe.value && (Ve(), Ue.preventDefault());
    }
    function Oe(Ue) {
      Ve(), ie("click:control", Ue);
    }
    function Ne(Ue) {
      Ue.stopPropagation(), Ve(), nextTick$2(() => {
        se.value = null, callEvent(re["onClick:clear"], Ue);
      });
    }
    function He(Ue) {
      var Fe;
      const Ze = Ue.target;
      if (se.value = Ze.value, (Fe = re.modelModifiers) != null && Fe.trim && ["text", "search", "password", "tel", "url"].includes(re.type)) {
        const Ke = [Ze.selectionStart, Ze.selectionEnd];
        nextTick$2(() => {
          Ze.selectionStart = Ke[0], Ze.selectionEnd = Ke[1];
        });
      }
    }
    return useRender(() => {
      const Ue = !!(le.counter || re.counter !== !1 && re.counter != null), Ze = !!(Ue || le.details), [Fe, Ke] = filterInputAttrs(ae), {
        modelValue: tt,
        ...Re
      } = VInput.filterProps(re), Ce = VField.filterProps(re);
      return createVNode(VInput, mergeProps({
        ref: be,
        modelValue: se.value,
        "onUpdate:modelValue": (_e) => se.value = _e,
        class: ["v-text-field", {
          "v-text-field--prefixed": re.prefix,
          "v-text-field--suffixed": re.suffix,
          "v-input--plain-underlined": pe.value
        }, re.class],
        style: re.style
      }, Fe, Re, {
        centerAffix: !pe.value,
        focused: ce.value
      }), {
        ...le,
        default: (_e) => {
          let {
            id: he,
            isDisabled: ve,
            isDirty: xe,
            isReadonly: $e,
            isValid: Te
          } = _e;
          return createVNode(VField, mergeProps({
            ref: Se,
            onMousedown: Ae,
            onClick: Oe,
            "onClick:clear": Ne,
            "onClick:prependInner": re["onClick:prependInner"],
            "onClick:appendInner": re["onClick:appendInner"],
            role: re.role
          }, Ce, {
            id: he.value,
            active: Ee.value || xe.value,
            dirty: xe.value || re.dirty,
            disabled: ve.value,
            focused: ce.value,
            error: Te.value === !1
          }), {
            ...le,
            default: (Ie) => {
              let {
                props: {
                  class: we,
                  ...ke
                }
              } = Ie;
              const ye = withDirectives(createVNode("input", mergeProps({
                ref: Pe,
                value: se.value,
                onInput: He,
                autofocus: re.autofocus,
                readonly: $e.value,
                disabled: ve.value,
                name: re.name,
                placeholder: re.placeholder,
                size: 1,
                type: re.type,
                onFocus: Ve,
                onBlur: de
              }, ke, Ke), null), [[resolveDirective("intersect"), {
                handler: ge
              }, null, {
                once: !0
              }]]);
              return createVNode(Fragment, null, [re.prefix && createVNode("span", {
                class: "v-text-field__prefix"
              }, [createVNode("span", {
                class: "v-text-field__prefix__text"
              }, [re.prefix])]), le.default ? createVNode("div", {
                class: we,
                "data-no-activator": ""
              }, [le.default(), ye]) : cloneVNode(ye, {
                class: we
              }), re.suffix && createVNode("span", {
                class: "v-text-field__suffix"
              }, [createVNode("span", {
                class: "v-text-field__suffix__text"
              }, [re.suffix])])]);
            }
          });
        },
        details: Ze ? (_e) => {
          var he;
          return createVNode(Fragment, null, [(he = le.details) == null ? void 0 : he.call(le, _e), Ue && createVNode(Fragment, null, [createVNode("span", null, null), createVNode(VCounter, {
            active: re.persistentCounter || ce.value,
            value: me.value,
            max: fe.value,
            disabled: re.disabled
          }, le.counter)])]);
        } : void 0
      });
    }), forwardRefs({}, be, Se, Pe);
  }
}), makeVVirtualScrollItemProps = propsFactory({
  renderless: Boolean,
  ...makeComponentProps()
}, "VVirtualScrollItem"), VVirtualScrollItem = genericComponent()({
  name: "VVirtualScrollItem",
  inheritAttrs: !1,
  props: makeVVirtualScrollItemProps(),
  emits: {
    "update:height": (re) => !0
  },
  setup(re, ne) {
    let {
      attrs: ae,
      emit: ie,
      slots: le
    } = ne;
    const {
      resizeRef: se,
      contentRect: ce
    } = useResizeObserver(void 0, "border");
    watch(() => {
      var ue;
      return (ue = ce.value) == null ? void 0 : ue.height;
    }, (ue) => {
      ue != null && ie("update:height", ue);
    }), useRender(() => {
      var ue, de;
      return re.renderless ? createVNode(Fragment, null, [(ue = le.default) == null ? void 0 : ue.call(le, {
        itemRef: se
      })]) : createVNode("div", mergeProps({
        ref: se,
        class: ["v-virtual-scroll__item", re.class],
        style: re.style
      }, ae), [(de = le.default) == null ? void 0 : de.call(le)]);
    });
  }
}), UP = -1, DOWN = 1, BUFFER_PX = 100, makeVirtualProps = propsFactory({
  itemHeight: {
    type: [Number, String],
    default: null
  },
  height: [Number, String]
}, "virtual");
function useVirtual(re, ne) {
  const ae = useDisplay(), ie = shallowRef(0);
  watchEffect(() => {
    ie.value = parseFloat(re.itemHeight || 0);
  });
  const le = shallowRef(0), se = shallowRef(Math.ceil(
    // Assume 16px items filling the entire screen height if
    // not provided. This is probably incorrect but it minimises
    // the chance of ending up with empty space at the bottom.
    // The default value is set here to avoid poisoning getSize()
    (parseInt(re.height) || ae.height.value) / (ie.value || 16)
  ) || 1), ce = shallowRef(0), ue = shallowRef(0), de = ref$1(), me = ref$1();
  let fe = 0;
  const {
    resizeRef: pe,
    contentRect: ge
  } = useResizeObserver();
  watchEffect(() => {
    pe.value = de.value;
  });
  const be = computed(() => {
    var we;
    return de.value === document.documentElement ? ae.height.value : ((we = ge.value) == null ? void 0 : we.height) || parseInt(re.height) || 0;
  }), Se = computed(() => !!(de.value && me.value && be.value && ie.value));
  let Pe = Array.from({
    length: ne.value.length
  }), Ee = Array.from({
    length: ne.value.length
  });
  const Ve = shallowRef(0);
  let Ae = -1;
  function Oe(we) {
    return Pe[we] || ie.value;
  }
  const Ne = debounce(() => {
    const we = performance.now();
    Ee[0] = 0;
    const ke = ne.value.length;
    for (let ye = 1; ye <= ke - 1; ye++)
      Ee[ye] = (Ee[ye - 1] || 0) + Oe(ye - 1);
    Ve.value = Math.max(Ve.value, performance.now() - we);
  }, Ve), He = watch(Se, (we) => {
    we && (He(), fe = me.value.offsetTop, Ne.immediate(), xe(), ~Ae && nextTick$2(() => {
      IN_BROWSER && window.requestAnimationFrame(() => {
        Te(Ae), Ae = -1;
      });
    }));
  });
  onScopeDispose(() => {
    Ne.clear();
  });
  function Ue(we, ke) {
    const ye = Pe[we], Be = ie.value;
    ie.value = Be ? Math.min(ie.value, ke) : ke, (ye !== ke || Be !== ie.value) && (Pe[we] = ke, Ne());
  }
  function Ze(we) {
    return we = clamp(we, 0, ne.value.length - 1), Ee[we] || 0;
  }
  function Fe(we) {
    return binaryClosest(Ee, we);
  }
  let Ke = 0, tt = 0, Re = 0;
  watch(be, (we, ke) => {
    ke && (xe(), we < ke && requestAnimationFrame(() => {
      tt = 0, xe();
    }));
  });
  let Ce = -1;
  function _e() {
    if (!de.value || !me.value) return;
    const we = de.value.scrollTop, ke = performance.now();
    ke - Re > 500 ? (tt = Math.sign(we - Ke), fe = me.value.offsetTop) : tt = we - Ke, Ke = we, Re = ke, window.clearTimeout(Ce), Ce = window.setTimeout(he, 500), xe();
  }
  function he() {
    !de.value || !me.value || (tt = 0, Re = 0, window.clearTimeout(Ce), xe());
  }
  let ve = -1;
  function xe() {
    cancelAnimationFrame(ve), ve = requestAnimationFrame($e);
  }
  function $e() {
    if (!de.value || !be.value) return;
    const we = Ke - fe, ke = Math.sign(tt), ye = Math.max(0, we - BUFFER_PX), Be = clamp(Fe(ye), 0, ne.value.length), Xe = we + be.value + BUFFER_PX, et = clamp(Fe(Xe) + 1, Be + 1, ne.value.length);
    if (
      // Only update the side we're scrolling towards,
      // the other side will be updated incidentally
      (ke !== UP || Be < le.value) && (ke !== DOWN || et > se.value)
    ) {
      const Ye = Ze(le.value) - Ze(Be), De = Ze(et) - Ze(se.value);
      Math.max(Ye, De) > BUFFER_PX ? (le.value = Be, se.value = et) : (Be <= 0 && (le.value = Be), et >= ne.value.length && (se.value = et));
    }
    ce.value = Ze(le.value), ue.value = Ze(ne.value.length) - Ze(se.value);
  }
  function Te(we) {
    const ke = Ze(we);
    !de.value || we && !ke ? Ae = we : de.value.scrollTop = ke;
  }
  const Ie = computed(() => ne.value.slice(le.value, se.value).map((we, ke) => ({
    raw: we,
    index: ke + le.value,
    key: isObject$8(we) && "value" in we ? we.value : ke + le.value
  })));
  return watch(ne, () => {
    Pe = Array.from({
      length: ne.value.length
    }), Ee = Array.from({
      length: ne.value.length
    }), Ne.immediate(), xe();
  }, {
    deep: !0
  }), {
    calculateVisibleItems: xe,
    containerRef: de,
    markerRef: me,
    computedItems: Ie,
    paddingTop: ce,
    paddingBottom: ue,
    scrollToIndex: Te,
    handleScroll: _e,
    handleScrollend: he,
    handleItemResize: Ue
  };
}
function binaryClosest(re, ne) {
  let ae = re.length - 1, ie = 0, le = 0, se = null, ce = -1;
  if (re[ae] < ne)
    return ae;
  for (; ie <= ae; )
    if (le = ie + ae >> 1, se = re[le], se > ne)
      ae = le - 1;
    else if (se < ne)
      ce = le, ie = le + 1;
    else return se === ne ? le : ie;
  return ce;
}
const makeVVirtualScrollProps = propsFactory({
  items: {
    type: Array,
    default: () => []
  },
  renderless: Boolean,
  ...makeVirtualProps(),
  ...makeComponentProps(),
  ...makeDimensionProps()
}, "VVirtualScroll"), VVirtualScroll = genericComponent()({
  name: "VVirtualScroll",
  props: makeVVirtualScrollProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = getCurrentInstance("VVirtualScroll"), {
      dimensionStyles: le
    } = useDimension(re), {
      calculateVisibleItems: se,
      containerRef: ce,
      markerRef: ue,
      handleScroll: de,
      handleScrollend: me,
      handleItemResize: fe,
      scrollToIndex: pe,
      paddingTop: ge,
      paddingBottom: be,
      computedItems: Se
    } = useVirtual(re, toRef(re, "items"));
    return useToggleScope(() => re.renderless, () => {
      function Pe() {
        var Ae, Oe;
        const Ve = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1) ? "addEventListener" : "removeEventListener";
        ce.value === document.documentElement ? (document[Ve]("scroll", de, {
          passive: !0
        }), document[Ve]("scrollend", me)) : ((Ae = ce.value) == null || Ae[Ve]("scroll", de, {
          passive: !0
        }), (Oe = ce.value) == null || Oe[Ve]("scrollend", me));
      }
      onMounted(() => {
        ce.value = getScrollParent(ie.vnode.el, !0), Pe(!0);
      }), onScopeDispose(Pe);
    }), useRender(() => {
      const Pe = Se.value.map((Ee) => createVNode(VVirtualScrollItem, {
        key: Ee.key,
        renderless: re.renderless,
        "onUpdate:height": (Ve) => fe(Ee.index, Ve)
      }, {
        default: (Ve) => {
          var Ae;
          return (Ae = ae.default) == null ? void 0 : Ae.call(ae, {
            item: Ee.raw,
            index: Ee.index,
            ...Ve
          });
        }
      }));
      return re.renderless ? createVNode(Fragment, null, [createVNode("div", {
        ref: ue,
        class: "v-virtual-scroll__spacer",
        style: {
          paddingTop: convertToUnit(ge.value)
        }
      }, null), Pe, createVNode("div", {
        class: "v-virtual-scroll__spacer",
        style: {
          paddingBottom: convertToUnit(be.value)
        }
      }, null)]) : createVNode("div", {
        ref: ce,
        class: ["v-virtual-scroll", re.class],
        onScrollPassive: de,
        onScrollend: me,
        style: [le.value, re.style]
      }, [createVNode("div", {
        ref: ue,
        class: "v-virtual-scroll__container",
        style: {
          paddingTop: convertToUnit(ge.value),
          paddingBottom: convertToUnit(be.value)
        }
      }, [Pe])]);
    }), {
      calculateVisibleItems: se,
      scrollToIndex: pe
    };
  }
});
function useScrolling(re, ne) {
  const ae = shallowRef(!1);
  let ie;
  function le(ue) {
    cancelAnimationFrame(ie), ae.value = !0, ie = requestAnimationFrame(() => {
      ie = requestAnimationFrame(() => {
        ae.value = !1;
      });
    });
  }
  async function se() {
    await new Promise((ue) => requestAnimationFrame(ue)), await new Promise((ue) => requestAnimationFrame(ue)), await new Promise((ue) => requestAnimationFrame(ue)), await new Promise((ue) => {
      if (ae.value) {
        const de = watch(ae, () => {
          de(), ue();
        });
      } else ue();
    });
  }
  async function ce(ue) {
    var fe, pe;
    if (ue.key === "Tab" && ((fe = ne.value) == null || fe.focus()), !["PageDown", "PageUp", "Home", "End"].includes(ue.key)) return;
    const de = (pe = re.value) == null ? void 0 : pe.$el;
    if (!de) return;
    (ue.key === "Home" || ue.key === "End") && de.scrollTo({
      top: ue.key === "Home" ? 0 : de.scrollHeight,
      behavior: "smooth"
    }), await se();
    const me = de.querySelectorAll(":scope > :not(.v-virtual-scroll__spacer)");
    if (ue.key === "PageDown" || ue.key === "Home") {
      const ge = de.getBoundingClientRect().top;
      for (const be of me)
        if (be.getBoundingClientRect().top >= ge) {
          be.focus();
          break;
        }
    } else {
      const ge = de.getBoundingClientRect().bottom;
      for (const be of [...me].reverse())
        if (be.getBoundingClientRect().bottom <= ge) {
          be.focus();
          break;
        }
    }
  }
  return {
    onScrollPassive: le,
    onKeydown: ce
  };
}
const makeSelectProps = propsFactory({
  chips: Boolean,
  closableChips: Boolean,
  closeText: {
    type: String,
    default: "$vuetify.close"
  },
  openText: {
    type: String,
    default: "$vuetify.open"
  },
  eager: Boolean,
  hideNoData: Boolean,
  hideSelected: Boolean,
  listProps: {
    type: Object
  },
  menu: Boolean,
  menuIcon: {
    type: IconValue,
    default: "$dropdown"
  },
  menuProps: {
    type: Object
  },
  multiple: Boolean,
  noDataText: {
    type: String,
    default: "$vuetify.noDataText"
  },
  openOnClear: Boolean,
  itemColor: String,
  ...makeItemsProps({
    itemChildren: !1
  })
}, "Select"), makeVSelectProps = propsFactory({
  ...makeSelectProps(),
  ...omit(makeVTextFieldProps({
    modelValue: null,
    role: "combobox"
  }), ["validationValue", "dirty", "appendInnerIcon"]),
  ...makeTransitionProps({
    transition: {
      component: VDialogTransition
    }
  })
}, "VSelect"), VSelect = genericComponent()({
  name: "VSelect",
  props: makeVSelectProps(),
  emits: {
    "update:focused": (re) => !0,
    "update:modelValue": (re) => !0,
    "update:menu": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      t: ie
    } = useLocale(), le = ref$1(), se = ref$1(), ce = ref$1(), ue = useProxiedModel(re, "menu"), de = computed({
      get: () => ue.value,
      set: (Ie) => {
        var we;
        ue.value && !Ie && ((we = se.value) != null && we.ΨopenChildren.size) || (ue.value = Ie);
      }
    }), {
      items: me,
      transformIn: fe,
      transformOut: pe
    } = useItems(re), ge = useProxiedModel(re, "modelValue", [], (Ie) => fe(Ie === null ? [null] : wrapInArray(Ie)), (Ie) => {
      const we = pe(Ie);
      return re.multiple ? we : we[0] ?? null;
    }), be = computed(() => typeof re.counterValue == "function" ? re.counterValue(ge.value) : typeof re.counterValue == "number" ? re.counterValue : ge.value.length), Se = useForm(re), Pe = computed(() => ge.value.map((Ie) => Ie.value)), Ee = shallowRef(!1), Ve = computed(() => de.value ? re.closeText : re.openText);
    let Ae = "", Oe;
    const Ne = computed(() => re.hideSelected ? me.value.filter((Ie) => !ge.value.some((we) => (re.valueComparator || deepEqual)(we, Ie))) : me.value), He = computed(() => re.hideNoData && !Ne.value.length || Se.isReadonly.value || Se.isDisabled.value), Ue = computed(() => {
      var Ie;
      return {
        ...re.menuProps,
        activatorProps: {
          ...((Ie = re.menuProps) == null ? void 0 : Ie.activatorProps) || {},
          "aria-haspopup": "listbox"
          // Set aria-haspopup to 'listbox'
        }
      };
    }), Ze = ref$1(), Fe = useScrolling(Ze, le);
    function Ke(Ie) {
      re.openOnClear && (de.value = !0);
    }
    function tt() {
      He.value || (de.value = !de.value);
    }
    function Re(Ie) {
      checkPrintable(Ie) && Ce(Ie);
    }
    function Ce(Ie) {
      var Be, Xe;
      if (!Ie.key || Se.isReadonly.value) return;
      ["Enter", " ", "ArrowDown", "ArrowUp", "Home", "End"].includes(Ie.key) && Ie.preventDefault(), ["Enter", "ArrowDown", " "].includes(Ie.key) && (de.value = !0), ["Escape", "Tab"].includes(Ie.key) && (de.value = !1), Ie.key === "Home" ? (Be = Ze.value) == null || Be.focus("first") : Ie.key === "End" && ((Xe = Ze.value) == null || Xe.focus("last"));
      const we = 1e3;
      if (!checkPrintable(Ie)) return;
      const ke = performance.now();
      ke - Oe > we && (Ae = ""), Ae += Ie.key.toLowerCase(), Oe = ke;
      const ye = me.value.find((et) => et.title.toLowerCase().startsWith(Ae));
      if (ye !== void 0) {
        ge.value = [ye];
        const et = Ne.value.indexOf(ye);
        IN_BROWSER && window.requestAnimationFrame(() => {
          var Ye;
          et >= 0 && ((Ye = ce.value) == null || Ye.scrollToIndex(et));
        });
      }
    }
    function _e(Ie) {
      let we = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      if (!Ie.props.disabled)
        if (re.multiple) {
          const ke = ge.value.findIndex((Be) => (re.valueComparator || deepEqual)(Be.value, Ie.value)), ye = we ?? !~ke;
          if (~ke) {
            const Be = ye ? [...ge.value, Ie] : [...ge.value];
            Be.splice(ke, 1), ge.value = Be;
          } else ye && (ge.value = [...ge.value, Ie]);
        } else {
          const ke = we !== !1;
          ge.value = ke ? [Ie] : [], nextTick$2(() => {
            de.value = !1;
          });
        }
    }
    function he(Ie) {
      var we;
      (we = Ze.value) != null && we.$el.contains(Ie.relatedTarget) || (de.value = !1);
    }
    function ve() {
      var Ie;
      re.eager && ((Ie = ce.value) == null || Ie.calculateVisibleItems());
    }
    function xe() {
      var Ie;
      Ee.value && ((Ie = le.value) == null || Ie.focus());
    }
    function $e(Ie) {
      Ee.value = !0;
    }
    function Te(Ie) {
      if (Ie == null) ge.value = [];
      else if (matchesSelector(le.value, ":autofill") || matchesSelector(le.value, ":-webkit-autofill")) {
        const we = me.value.find((ke) => ke.title === Ie);
        we && _e(we);
      } else le.value && (le.value.value = "");
    }
    return watch(de, () => {
      if (!re.hideSelected && de.value && ge.value.length) {
        const Ie = Ne.value.findIndex((we) => ge.value.some((ke) => (re.valueComparator || deepEqual)(ke.value, we.value)));
        IN_BROWSER && window.requestAnimationFrame(() => {
          var we;
          Ie >= 0 && ((we = ce.value) == null || we.scrollToIndex(Ie));
        });
      }
    }), watch(() => re.items, (Ie, we) => {
      de.value || Ee.value && !we.length && Ie.length && (de.value = !0);
    }), useRender(() => {
      const Ie = !!(re.chips || ae.chip), we = !!(!re.hideNoData || Ne.value.length || ae["prepend-item"] || ae["append-item"] || ae["no-data"]), ke = ge.value.length > 0, ye = VTextField.filterProps(re), Be = ke || !Ee.value && re.label && !re.persistentPlaceholder ? void 0 : re.placeholder;
      return createVNode(VTextField, mergeProps({
        ref: le
      }, ye, {
        modelValue: ge.value.map((Xe) => Xe.props.value).join(", "),
        "onUpdate:modelValue": Te,
        focused: Ee.value,
        "onUpdate:focused": (Xe) => Ee.value = Xe,
        validationValue: ge.externalValue,
        counterValue: be.value,
        dirty: ke,
        class: ["v-select", {
          "v-select--active-menu": de.value,
          "v-select--chips": !!re.chips,
          [`v-select--${re.multiple ? "multiple" : "single"}`]: !0,
          "v-select--selected": ge.value.length,
          "v-select--selection-slot": !!ae.selection
        }, re.class],
        style: re.style,
        inputmode: "none",
        placeholder: Be,
        "onClick:clear": Ke,
        "onMousedown:control": tt,
        onBlur: he,
        onKeydown: Ce,
        "aria-label": ie(Ve.value),
        title: ie(Ve.value)
      }), {
        ...ae,
        default: () => createVNode(Fragment, null, [createVNode(VMenu, mergeProps({
          ref: se,
          modelValue: de.value,
          "onUpdate:modelValue": (Xe) => de.value = Xe,
          activator: "parent",
          contentClass: "v-select__content",
          disabled: He.value,
          eager: re.eager,
          maxHeight: 310,
          openOnClick: !1,
          closeOnContentClick: !1,
          transition: re.transition,
          onAfterEnter: ve,
          onAfterLeave: xe
        }, Ue.value), {
          default: () => [we && createVNode(VList, mergeProps({
            ref: Ze,
            selected: Pe.value,
            selectStrategy: re.multiple ? "independent" : "single-independent",
            onMousedown: (Xe) => Xe.preventDefault(),
            onKeydown: Re,
            onFocusin: $e,
            tabindex: "-1",
            "aria-live": "polite",
            color: re.itemColor ?? re.color
          }, Fe, re.listProps), {
            default: () => {
              var Xe, et, Ye;
              return [(Xe = ae["prepend-item"]) == null ? void 0 : Xe.call(ae), !Ne.value.length && !re.hideNoData && (((et = ae["no-data"]) == null ? void 0 : et.call(ae)) ?? createVNode(VListItem, {
                key: "no-data",
                title: ie(re.noDataText)
              }, null)), createVNode(VVirtualScroll, {
                ref: ce,
                renderless: !0,
                items: Ne.value
              }, {
                default: (De) => {
                  var We;
                  let {
                    item: je,
                    index: rt,
                    itemRef: at
                  } = De;
                  const qe = mergeProps(je.props, {
                    ref: at,
                    key: je.value,
                    onClick: () => _e(je, null)
                  });
                  return ((We = ae.item) == null ? void 0 : We.call(ae, {
                    item: je,
                    index: rt,
                    props: qe
                  })) ?? createVNode(VListItem, mergeProps(qe, {
                    role: "option"
                  }), {
                    prepend: (ze) => {
                      let {
                        isSelected: Ge
                      } = ze;
                      return createVNode(Fragment, null, [re.multiple && !re.hideSelected ? createVNode(VCheckboxBtn, {
                        key: je.value,
                        modelValue: Ge,
                        ripple: !1,
                        tabindex: "-1"
                      }, null) : void 0, je.props.prependAvatar && createVNode(VAvatar, {
                        image: je.props.prependAvatar
                      }, null), je.props.prependIcon && createVNode(VIcon, {
                        icon: je.props.prependIcon
                      }, null)]);
                    }
                  });
                }
              }), (Ye = ae["append-item"]) == null ? void 0 : Ye.call(ae)];
            }
          })]
        }), ge.value.map((Xe, et) => {
          function Ye(at) {
            at.stopPropagation(), at.preventDefault(), _e(Xe, !1);
          }
          const De = {
            "onClick:close": Ye,
            onKeydown(at) {
              at.key !== "Enter" && at.key !== " " || (at.preventDefault(), at.stopPropagation(), Ye(at));
            },
            onMousedown(at) {
              at.preventDefault(), at.stopPropagation();
            },
            modelValue: !0,
            "onUpdate:modelValue": void 0
          }, je = Ie ? !!ae.chip : !!ae.selection, rt = je ? ensureValidVNode(Ie ? ae.chip({
            item: Xe,
            index: et,
            props: De
          }) : ae.selection({
            item: Xe,
            index: et
          })) : void 0;
          if (!(je && !rt))
            return createVNode("div", {
              key: Xe.value,
              class: "v-select__selection"
            }, [Ie ? ae.chip ? createVNode(VDefaultsProvider, {
              key: "chip-defaults",
              defaults: {
                VChip: {
                  closable: re.closableChips,
                  size: "small",
                  text: Xe.title
                }
              }
            }, {
              default: () => [rt]
            }) : createVNode(VChip, mergeProps({
              key: "chip",
              closable: re.closableChips,
              size: "small",
              text: Xe.title,
              disabled: Xe.props.disabled
            }, De), null) : rt ?? createVNode("span", {
              class: "v-select__selection-text"
            }, [Xe.title, re.multiple && et < ge.value.length - 1 && createVNode("span", {
              class: "v-select__selection-comma"
            }, [createTextVNode(",")])])]);
        })]),
        "append-inner": function() {
          var De;
          for (var Xe = arguments.length, et = new Array(Xe), Ye = 0; Ye < Xe; Ye++)
            et[Ye] = arguments[Ye];
          return createVNode(Fragment, null, [(De = ae["append-inner"]) == null ? void 0 : De.call(ae, ...et), re.menuIcon ? createVNode(VIcon, {
            class: "v-select__menu-icon",
            icon: re.menuIcon
          }, null) : void 0]);
        }
      });
    }), forwardRefs({
      isFocused: Ee,
      menu: de,
      select: _e
    }, le);
  }
}), _sfc_main$S = {
  name: "CSLogin",
  extends: CSBase,
  data() {
    return {
      iplLogo,
      isLoggedIn: !1,
      auth0User: null,
      deviceOptions: "shared-device",
      containWelcomeMessageSubText: !!this.$t("cs.login.welcomeMessageSubText"),
      selectedConnection: "",
      getRemoteClientAppConfigResolved: !1
    };
  },
  computed: {
    ...mapState({
      resetBtnTimeout: (re) => re["cs-appearance"].loginResetBtnTimeout
    }),
    ...mapGetters({
      auth0Enabled: "auth0/enabled",
      clientAppConfig: "auth0/clientAppConfig",
      authorizationUri: "session/authorizationUri",
      authorizationUriComplispaceStaff: "session/authorizationUriComplispaceStaff",
      appName: "app/name"
    }),
    promptOnLoginEnabled() {
      return this.clientAppConfig && this.clientAppConfig.promptOnLoginEnabled;
    },
    sharedDeviceEnabled() {
      return this.clientAppConfig && this.clientAppConfig.sharedDeviceEnabled;
    },
    connectionButtonsEnabled() {
      return this.clientAppConfig && this.clientAppConfig.connectionButtonsEnabled;
    },
    connectionNames() {
      return this.clientAppConfig && this.clientAppConfig.connectionNames || [];
    },
    connectionDisplayItems() {
      return this.connectionNames.map((re) => ({
        title: re === "complispace-staff" ? "policy-logic-staff" : re,
        value: re
      }));
    },
    showConnectionSelector() {
      return !this.isLoggedIn && this.connectionButtonsEnabled;
    },
    showDeviceOptions() {
      return this.connectionButtonsEnabled ? !this.isLoggedIn && this.promptOnLoginEnabled && !!this.selectedConnection : !this.isLoggedIn && this.promptOnLoginEnabled;
    },
    loginBtnEnabled() {
      return this.loading ? !1 : this.connectionButtonsEnabled ? !!this.selectedConnection : !0;
    },
    showReLoginBtns() {
      return this.isLoggedIn && !!this.auth0User;
    },
    showAuth0LoginBtn() {
      return this.auth0Enabled && this.getRemoteClientAppConfigResolved;
    },
    showLegacyLoginBtn() {
      return !this.auth0Enabled && !!this.authorizationUri && this.getRemoteClientAppConfigResolved;
    },
    showLegacyStaffLoginBtn() {
      return !this.auth0Enabled && !!this.authorizationUriComplispaceStaff && this.getRemoteClientAppConfigResolved;
    }
  },
  async mounted() {
    const re = localStorage.getItem(ERROR_ALERT_MESSAGE);
    re && this.showErrorAlert(re), await this.$store.dispatch("auth0/getRemoteClientAppConfig", {
      refresh: !0
    }), this.auth0Enabled && (this.isLoggedIn = await this.$store.dispatch("cs-session/isLoggedIn", {
      auth0Only: !0
    }), this.isLoggedIn ? this.auth0User = await this.$store.dispatch("cs-session/getUser") : this.$store.dispatch("cs-session/resetSession"), this.deviceOptions = this.sharedDeviceEnabled ? "shared-device" : "personal-device"), this.getRemoteClientAppConfigResolved = !0, this.showResetSessionAlert();
  },
  methods: {
    navigateToIdpLogin() {
      this.setLoading(!0), window.location.href = this.authorizationUri;
    },
    async onLoginBtn() {
      this.setLoading(!0);
      try {
        localStorage.setItem(DEVICE_OPTIONS, this.deviceOptions), this.selectedConnection ? await this.$store.dispatch("cs-session/login", {
          connection: this.selectedConnection
        }) : await this.$store.dispatch("cs-session/login");
      } catch (re) {
        errorHandler(this, re);
      }
    },
    async logout() {
      try {
        this.setLoading(!0), await this.$store.dispatch("cs-session/logout", { federated: !0 }), this.clearLoading();
      } catch (re) {
        this.clearLoading(), errorHandler(this, re);
      }
    },
    showResetSessionAlert() {
      const re = "If you are unable to view the Login button you will need to reload your browser. <func>Click here to reload.</func> If issues persist please contact <href>Service Desk.</href>";
      setTimeout(() => {
        this.showWarningAlert(re, !1, {
          href: "https://complispace.help.ideagen.com/hc/en-gb",
          func: this.onReset
        });
      }, this.resetBtnTimeout * 1e3);
    },
    onReset() {
      this.$store.dispatch("cs-session/resetSession"), localStorage.clear(), sessionStorage.clear(), this.clearCookies(), window.location.reload();
    },
    clearCookies() {
      document.cookie.split(";").forEach((ne) => {
        document.cookie = `${ne}=;expires=${(/* @__PURE__ */ new Date(0)).toUTCString()}; path=/`;
      });
    }
  }
}, _hoisted_1$G = ["src"], _hoisted_2$l = {
  key: 0,
  class: "cs-welcome-message-app-name ma-0 pt-13"
}, _hoisted_3$c = {
  key: 1,
  class: "cs-welcome-message-app-name ma-0 pt-13"
}, _hoisted_4$7 = {
  key: 2,
  class: "cs-welcome-message-sub-text ma-0 pt-1"
}, _hoisted_5$3 = {
  key: 3,
  class: "cs-welcome-message-sub-text ma-0 pt-1"
}, _hoisted_6$2 = ["href"];
function _sfc_render$S(re, ne, ae, ie, le, se) {
  const ce = resolveComponent("cs-button"), ue = resolveComponent("cs-view");
  return openBlock(), createBlock(ue, {
    "single-view": "",
    center: "",
    class: "cs-login"
  }, {
    content: withCtx(() => [
      createVNode(VContainer, { class: "cs-login-container" }, {
        default: withCtx(() => [
          createVNode(VRow, {
            justify: "space-around",
            class: "ma-0 pt-5 pb-6"
          }, {
            default: withCtx(() => [
              createVNode(VCol, { class: "pa-0 ma-0" }, {
                default: withCtx(() => [
                  createElementVNode("img", {
                    class: "ma-0 pt-5",
                    src: le.iplLogo,
                    alt: ""
                  }, null, 8, _hoisted_1$G),
                  re.$te("custom.login.welcomeMessage") ? (openBlock(), createElementBlock("h3", _hoisted_2$l, toDisplayString$1(re.$t("custom.login.welcomeMessage", { appName: re.appName })), 1)) : (openBlock(), createElementBlock("h3", _hoisted_3$c, toDisplayString$1(re.$t("cs.login.welcomeMessage", { appName: re.appName })), 1)),
                  re.$te("custom.login.welcomeMessageSubText") ? (openBlock(), createElementBlock("span", _hoisted_4$7, toDisplayString$1(re.$t("custom.login.welcomeMessageSubText", { appName: re.appName })), 1)) : re.$te("cs.login.welcomeMessageSubText") ? (openBlock(), createElementBlock("span", _hoisted_5$3, toDisplayString$1(re.$t("cs.login.welcomeMessageSubText", { appName: re.appName })), 1)) : createCommentVNode("", !0)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          se.showAuth0LoginBtn && se.showReLoginBtns ? (openBlock(), createBlock(VRow, {
            key: 0,
            justify: "space-around",
            class: "ma-0 pb-6"
          }, {
            default: withCtx(() => [
              createVNode(VCol, {
                justify: "space-around",
                class: "pa-0 ma-0"
              }, {
                default: withCtx(() => [
                  createVNode(VRow, {
                    justify: "space-around",
                    class: "pb-6"
                  }, {
                    default: withCtx(() => [
                      createTextVNode(" Are you " + toDisplayString$1(le.auth0User.given_name) + " " + toDisplayString$1(le.auth0User.family_name) + "? ", 1)
                    ]),
                    _: 1
                  }),
                  createVNode(VRow, { justify: "center" }, {
                    default: withCtx(() => [
                      createVNode(ce, {
                        id: "cs-auth0-yes-btn",
                        label: "Yes",
                        primary: "",
                        loading: re.loading,
                        disabled: re.loading,
                        class: "mr-2",
                        onClick: se.onLoginBtn
                      }, null, 8, ["loading", "disabled", "onClick"]),
                      createVNode(ce, {
                        id: "cs-auth0-logout-btn",
                        label: "No",
                        color: "secondary",
                        onClick: se.logout
                      }, null, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })) : createCommentVNode("", !0),
          re.auth0Enabled && se.showConnectionSelector ? (openBlock(), createBlock(VRow, {
            key: 1,
            justify: "space-around",
            class: "ma-0 pa-0"
          }, {
            default: withCtx(() => [
              se.connectionButtonsEnabled ? (openBlock(), createBlock(VSelect, {
                key: 0,
                modelValue: le.selectedConnection,
                "onUpdate:modelValue": ne[0] || (ne[0] = (de) => le.selectedConnection = de),
                class: "cs-login-connection-name-select pa-0 ma-0",
                items: se.connectionDisplayItems,
                label: "Select Organization",
                variant: "solo"
              }, null, 8, ["modelValue", "items"])) : createCommentVNode("", !0)
            ]),
            _: 1
          })) : createCommentVNode("", !0),
          createVNode(VRow, {
            justify: "space-around",
            class: "ma-0 pa-0 cs-device-options"
          }, {
            default: withCtx(() => [
              se.showDeviceOptions ? (openBlock(), createBlock(VRadioGroup, {
                key: 0,
                modelValue: le.deviceOptions,
                "onUpdate:modelValue": ne[1] || (ne[1] = (de) => le.deviceOptions = de),
                class: "ma-0 pa-0 cs-device-options-radio-group",
                mandatory: ""
              }, {
                default: withCtx(() => [
                  createVNode(VRadio, {
                    id: "cs-device-options-personal-device",
                    label: "You are the only person using this device.",
                    class: "ma-0 pt-0 style-7 cs-device-options-personal-device",
                    color: "primary",
                    value: "personal-device"
                  }),
                  createVNode(VRadio, {
                    id: "cs-device-options-shared-device",
                    label: "This is a shared device.",
                    class: "ma-0 style-7 cs-device-options-shared-device",
                    color: "primary",
                    value: "shared-device"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])) : createCommentVNode("", !0)
            ]),
            _: 1
          }),
          se.showAuth0LoginBtn && !se.showReLoginBtns ? (openBlock(), createBlock(VRow, {
            key: 2,
            justify: "space-around",
            class: "ma-0 pa-0 cs-login-btn"
          }, {
            default: withCtx(() => [
              createVNode(VCol, { class: "pa-0 ma-0" }, {
                default: withCtx(() => [
                  createVNode(ce, {
                    id: "cs-auth0-login-btn",
                    label: re.$t("cs.login.loginButtonText"),
                    primary: "",
                    loading: re.loading,
                    disabled: !se.loginBtnEnabled,
                    onClick: se.onLoginBtn
                  }, null, 8, ["label", "loading", "disabled", "onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })) : createCommentVNode("", !0),
          se.showLegacyLoginBtn ? (openBlock(), createBlock(VRow, {
            key: 3,
            justify: "space-around",
            class: "ma-0 pa-0 cs-login-btn"
          }, {
            default: withCtx(() => [
              createVNode(ce, {
                id: "cs-idp-login-btn",
                label: re.$t("cs.login.loginButtonText"),
                primary: "",
                loading: re.loading,
                disabled: !se.loginBtnEnabled,
                onClick: se.navigateToIdpLogin
              }, null, 8, ["label", "loading", "disabled", "onClick"])
            ]),
            _: 1
          })) : createCommentVNode("", !0),
          se.showLegacyStaffLoginBtn ? (openBlock(), createBlock(VFooter, {
            key: 4,
            app: "",
            padless: "",
            class: "cs-login-footer"
          }, {
            default: withCtx(() => [
              createVNode(VCol, { class: "cs-text-center" }, {
                default: withCtx(() => [
                  createElementVNode("a", { href: re.authorizationUriComplispaceStaff }, "CompliSpace Staff Login", 8, _hoisted_6$2)
                ]),
                _: 1
              })
            ]),
            _: 1
          })) : createCommentVNode("", !0)
        ]),
        _: 1
      })
    ]),
    _: 1
  });
}
const CSLogin = /* @__PURE__ */ _export_sfc(_sfc_main$S, [["render", _sfc_render$S], ["__scopeId", "data-v-9622983e"]]), _sfc_main$R = {
  name: "CSLoginCallback",
  data() {
    return {
      authReady: !1
    };
  },
  watch: {
    authReady(re) {
      re && this.handleRedirect();
    }
  },
  created() {
    this.authReady = !Auth0State.loading, Auth0State.loading && watch(
      () => Auth0State.loading,
      (re) => {
        re || (this.authReady = !0);
      }
    );
  },
  methods: {
    async handleRedirect() {
      await this.$store.dispatch("cs-session/handleRedirectCallback");
      const re = localStorage.getItem("redirect");
      localStorage.removeItem("redirect"), !re || re === "/login" ? await this.$router.push({ path: "/" }) : await this.$router.push({ path: re });
    }
  }
};
function _sfc_render$R(re, ne, ae, ie, le, se) {
  return openBlock(), createElementBlock("div");
}
const CSLoginCallback = /* @__PURE__ */ _export_sfc(_sfc_main$R, [["render", _sfc_render$R]]), routes = [
  {
    name: "login",
    path: "/login",
    component: CSLogin,
    beforeEnter: (re, ne, ae) => {
      window.location.pathname !== "/login" && window.location.pathname !== "/login/callback" && localStorage.setItem("redirect", window.location.pathname), ae();
    }
  },
  {
    name: "login/callback",
    path: "/login/callback",
    component: CSLoginCallback
  }
], VAlertTitle = createSimpleFunctional("v-alert-title"), allowedTypes = ["success", "info", "warning", "error"], makeVAlertProps = propsFactory({
  border: {
    type: [Boolean, String],
    validator: (re) => typeof re == "boolean" || ["top", "end", "bottom", "start"].includes(re)
  },
  borderColor: String,
  closable: Boolean,
  closeIcon: {
    type: IconValue,
    default: "$close"
  },
  closeLabel: {
    type: String,
    default: "$vuetify.close"
  },
  icon: {
    type: [Boolean, String, Function, Object],
    default: null
  },
  modelValue: {
    type: Boolean,
    default: !0
  },
  prominent: Boolean,
  title: String,
  text: String,
  type: {
    type: String,
    validator: (re) => allowedTypes.includes(re)
  },
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeDimensionProps(),
  ...makeElevationProps(),
  ...makeLocationProps(),
  ...makePositionProps(),
  ...makeRoundedProps(),
  ...makeTagProps(),
  ...makeThemeProps(),
  ...makeVariantProps({
    variant: "flat"
  })
}, "VAlert"), VAlert = genericComponent()({
  name: "VAlert",
  props: makeVAlertProps(),
  emits: {
    "click:close": (re) => !0,
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      emit: ae,
      slots: ie
    } = ne;
    const le = useProxiedModel(re, "modelValue"), se = computed(() => {
      if (re.icon !== !1)
        return re.type ? re.icon ?? `$${re.type}` : re.icon;
    }), ce = computed(() => ({
      color: re.color ?? re.type,
      variant: re.variant
    })), {
      themeClasses: ue
    } = provideTheme(re), {
      colorClasses: de,
      colorStyles: me,
      variantClasses: fe
    } = useVariant(ce), {
      densityClasses: pe
    } = useDensity(re), {
      dimensionStyles: ge
    } = useDimension(re), {
      elevationClasses: be
    } = useElevation(re), {
      locationStyles: Se
    } = useLocation(re), {
      positionClasses: Pe
    } = usePosition(re), {
      roundedClasses: Ee
    } = useRounded(re), {
      textColorClasses: Ve,
      textColorStyles: Ae
    } = useTextColor(toRef(re, "borderColor")), {
      t: Oe
    } = useLocale(), Ne = computed(() => ({
      "aria-label": Oe(re.closeLabel),
      onClick(He) {
        le.value = !1, ae("click:close", He);
      }
    }));
    return () => {
      const He = !!(ie.prepend || se.value), Ue = !!(ie.title || re.title), Ze = !!(ie.close || re.closable);
      return le.value && createVNode(re.tag, {
        class: ["v-alert", re.border && {
          "v-alert--border": !!re.border,
          [`v-alert--border-${re.border === !0 ? "start" : re.border}`]: !0
        }, {
          "v-alert--prominent": re.prominent
        }, ue.value, de.value, pe.value, be.value, Pe.value, Ee.value, fe.value, re.class],
        style: [me.value, ge.value, Se.value, re.style],
        role: "alert"
      }, {
        default: () => {
          var Fe, Ke;
          return [genOverlays(!1, "v-alert"), re.border && createVNode("div", {
            key: "border",
            class: ["v-alert__border", Ve.value],
            style: Ae.value
          }, null), He && createVNode("div", {
            key: "prepend",
            class: "v-alert__prepend"
          }, [ie.prepend ? createVNode(VDefaultsProvider, {
            key: "prepend-defaults",
            disabled: !se.value,
            defaults: {
              VIcon: {
                density: re.density,
                icon: se.value,
                size: re.prominent ? 44 : 28
              }
            }
          }, ie.prepend) : createVNode(VIcon, {
            key: "prepend-icon",
            density: re.density,
            icon: se.value,
            size: re.prominent ? 44 : 28
          }, null)]), createVNode("div", {
            class: "v-alert__content"
          }, [Ue && createVNode(VAlertTitle, {
            key: "title"
          }, {
            default: () => {
              var tt;
              return [((tt = ie.title) == null ? void 0 : tt.call(ie)) ?? re.title];
            }
          }), ((Fe = ie.text) == null ? void 0 : Fe.call(ie)) ?? re.text, (Ke = ie.default) == null ? void 0 : Ke.call(ie)]), ie.append && createVNode("div", {
            key: "append",
            class: "v-alert__append"
          }, [ie.append()]), Ze && createVNode("div", {
            key: "close",
            class: "v-alert__close"
          }, [ie.close ? createVNode(VDefaultsProvider, {
            key: "close-defaults",
            defaults: {
              VBtn: {
                icon: re.closeIcon,
                size: "x-small",
                variant: "text"
              }
            }
          }, {
            default: () => {
              var tt;
              return [(tt = ie.close) == null ? void 0 : tt.call(ie, {
                props: Ne.value
              })];
            }
          }) : createVNode(VBtn, mergeProps({
            key: "close-btn",
            icon: re.closeIcon,
            size: "x-small",
            variant: "text"
          }, Ne.value), null)])];
        }
      });
    };
  }
}), defaultFilter = (re, ne, ae) => re == null || ne == null ? -1 : re.toString().toLocaleLowerCase().indexOf(ne.toString().toLocaleLowerCase()), makeFilterProps = propsFactory({
  customFilter: Function,
  customKeyFilter: Object,
  filterKeys: [Array, String],
  filterMode: {
    type: String,
    default: "intersection"
  },
  noFilter: Boolean
}, "filter");
function filterItems(re, ne, ae) {
  var ue;
  const ie = [], le = (ae == null ? void 0 : ae.default) ?? defaultFilter, se = ae != null && ae.filterKeys ? wrapInArray(ae.filterKeys) : !1, ce = Object.keys((ae == null ? void 0 : ae.customKeyFilter) ?? {}).length;
  if (!(re != null && re.length)) return ie;
  e: for (let de = 0; de < re.length; de++) {
    const [me, fe = me] = wrapInArray(re[de]), pe = {}, ge = {};
    let be = -1;
    if ((ne || ce > 0) && !(ae != null && ae.noFilter)) {
      if (typeof me == "object") {
        const Ee = se || Object.keys(fe);
        for (const Ve of Ee) {
          const Ae = getPropertyFromItem(fe, Ve), Oe = (ue = ae == null ? void 0 : ae.customKeyFilter) == null ? void 0 : ue[Ve];
          if (be = Oe ? Oe(Ae, ne, me) : le(Ae, ne, me), be !== -1 && be !== !1)
            Oe ? pe[Ve] = be : ge[Ve] = be;
          else if ((ae == null ? void 0 : ae.filterMode) === "every")
            continue e;
        }
      } else
        be = le(me, ne, me), be !== -1 && be !== !1 && (ge.title = be);
      const Se = Object.keys(ge).length, Pe = Object.keys(pe).length;
      if (!Se && !Pe || (ae == null ? void 0 : ae.filterMode) === "union" && Pe !== ce && !Se || (ae == null ? void 0 : ae.filterMode) === "intersection" && (Pe !== ce || !Se)) continue;
    }
    ie.push({
      index: de,
      matches: {
        ...ge,
        ...pe
      }
    });
  }
  return ie;
}
function useFilter(re, ne, ae, ie) {
  const le = shallowRef([]), se = shallowRef(/* @__PURE__ */ new Map()), ce = computed(() => ie != null && ie.transform ? unref(ne).map((de) => [de, ie.transform(de)]) : unref(ne));
  watchEffect(() => {
    const de = typeof ae == "function" ? ae() : unref(ae), me = typeof de != "string" && typeof de != "number" ? "" : String(de), fe = filterItems(ce.value, me, {
      customKeyFilter: {
        ...re.customKeyFilter,
        ...unref(ie == null ? void 0 : ie.customKeyFilter)
      },
      default: re.customFilter,
      filterKeys: re.filterKeys,
      filterMode: re.filterMode,
      noFilter: re.noFilter
    }), pe = unref(ne), ge = [], be = /* @__PURE__ */ new Map();
    fe.forEach((Se) => {
      let {
        index: Pe,
        matches: Ee
      } = Se;
      const Ve = pe[Pe];
      ge.push(Ve), be.set(Ve.value, Ee);
    }), le.value = ge, se.value = be;
  });
  function ue(de) {
    return se.value.get(de.value);
  }
  return {
    filteredItems: le,
    filteredMatches: se,
    getMatches: ue
  };
}
function highlightResult$1(re, ne, ae) {
  if (ne == null) return re;
  if (Array.isArray(ne)) throw new Error("Multiple matches is not implemented");
  return typeof ne == "number" && ~ne ? createVNode(Fragment, null, [createVNode("span", {
    class: "v-autocomplete__unmask"
  }, [re.substr(0, ne)]), createVNode("span", {
    class: "v-autocomplete__mask"
  }, [re.substr(ne, ae)]), createVNode("span", {
    class: "v-autocomplete__unmask"
  }, [re.substr(ne + ae)])]) : re;
}
const makeVAutocompleteProps = propsFactory({
  autoSelectFirst: {
    type: [Boolean, String]
  },
  clearOnSelect: Boolean,
  search: String,
  ...makeFilterProps({
    filterKeys: ["title"]
  }),
  ...makeSelectProps(),
  ...omit(makeVTextFieldProps({
    modelValue: null,
    role: "combobox"
  }), ["validationValue", "dirty", "appendInnerIcon"]),
  ...makeTransitionProps({
    transition: !1
  })
}, "VAutocomplete"), VAutocomplete = genericComponent()({
  name: "VAutocomplete",
  props: makeVAutocompleteProps(),
  emits: {
    "update:focused": (re) => !0,
    "update:search": (re) => !0,
    "update:modelValue": (re) => !0,
    "update:menu": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      t: ie
    } = useLocale(), le = ref$1(), se = shallowRef(!1), ce = shallowRef(!0), ue = shallowRef(!1), de = ref$1(), me = ref$1(), fe = useProxiedModel(re, "menu"), pe = computed({
      get: () => fe.value,
      set: (qe) => {
        var We;
        fe.value && !qe && ((We = de.value) != null && We.ΨopenChildren.size) || (fe.value = qe);
      }
    }), ge = shallowRef(-1), be = computed(() => {
      var qe;
      return (qe = le.value) == null ? void 0 : qe.color;
    }), Se = computed(() => pe.value ? re.closeText : re.openText), {
      items: Pe,
      transformIn: Ee,
      transformOut: Ve
    } = useItems(re), {
      textColorClasses: Ae,
      textColorStyles: Oe
    } = useTextColor(be), Ne = useProxiedModel(re, "search", ""), He = useProxiedModel(re, "modelValue", [], (qe) => Ee(qe === null ? [null] : wrapInArray(qe)), (qe) => {
      const We = Ve(qe);
      return re.multiple ? We : We[0] ?? null;
    }), Ue = computed(() => typeof re.counterValue == "function" ? re.counterValue(He.value) : typeof re.counterValue == "number" ? re.counterValue : He.value.length), Ze = useForm(re), {
      filteredItems: Fe,
      getMatches: Ke
    } = useFilter(re, Pe, () => ce.value ? "" : Ne.value), tt = computed(() => re.hideSelected ? Fe.value.filter((qe) => !He.value.some((We) => We.value === qe.value)) : Fe.value), Re = computed(() => !!(re.chips || ae.chip)), Ce = computed(() => Re.value || !!ae.selection), _e = computed(() => He.value.map((qe) => qe.props.value)), he = computed(() => {
      var We;
      return (re.autoSelectFirst === !0 || re.autoSelectFirst === "exact" && Ne.value === ((We = tt.value[0]) == null ? void 0 : We.title)) && tt.value.length > 0 && !ce.value && !ue.value;
    }), ve = computed(() => re.hideNoData && !tt.value.length || Ze.isReadonly.value || Ze.isDisabled.value), xe = ref$1(), $e = useScrolling(xe, le);
    function Te(qe) {
      re.openOnClear && (pe.value = !0), Ne.value = "";
    }
    function Ie() {
      ve.value || (pe.value = !0);
    }
    function we(qe) {
      ve.value || (se.value && (qe.preventDefault(), qe.stopPropagation()), pe.value = !pe.value);
    }
    function ke(qe) {
      var We;
      qe.key !== " " && checkPrintable(qe) && ((We = le.value) == null || We.focus());
    }
    function ye(qe) {
      var Ge, nt, ot;
      if (Ze.isReadonly.value) return;
      const We = le.value.selectionStart, ze = He.value.length;
      if (["Enter", "ArrowDown", "ArrowUp"].includes(qe.key) && qe.preventDefault(), ["Enter", "ArrowDown"].includes(qe.key) && (pe.value = !0), ["Escape"].includes(qe.key) && (pe.value = !1), he.value && ["Enter", "Tab"].includes(qe.key) && !He.value.some((lt) => {
        let {
          value: mt
        } = lt;
        return mt === tt.value[0].value;
      }) && at(tt.value[0]), qe.key === "ArrowDown" && he.value && ((Ge = xe.value) == null || Ge.focus("next")), ["Backspace", "Delete"].includes(qe.key)) {
        if (!re.multiple && Ce.value && He.value.length > 0 && !Ne.value) return at(He.value[0], !1);
        if (~ge.value) {
          qe.preventDefault();
          const lt = ge.value;
          at(He.value[ge.value], !1), ge.value = lt >= ze - 1 ? ze - 2 : lt;
        } else qe.key === "Backspace" && !Ne.value && (ge.value = ze - 1);
        return;
      }
      if (re.multiple)
        if (qe.key === "ArrowLeft") {
          if (ge.value < 0 && We > 0) return;
          const lt = ge.value > -1 ? ge.value - 1 : ze - 1;
          He.value[lt] ? ge.value = lt : (ge.value = -1, le.value.setSelectionRange((nt = Ne.value) == null ? void 0 : nt.length, (ot = Ne.value) == null ? void 0 : ot.length));
        } else if (qe.key === "ArrowRight") {
          if (ge.value < 0) return;
          const lt = ge.value + 1;
          He.value[lt] ? ge.value = lt : (ge.value = -1, le.value.setSelectionRange(0, 0));
        } else ~ge.value && checkPrintable(qe) && (ge.value = -1);
    }
    function Be(qe) {
      if (matchesSelector(le.value, ":autofill") || matchesSelector(le.value, ":-webkit-autofill")) {
        const We = Pe.value.find((ze) => ze.title === qe.target.value);
        We && at(We);
      }
    }
    function Xe() {
      var qe;
      re.eager && ((qe = me.value) == null || qe.calculateVisibleItems());
    }
    function et() {
      var qe;
      se.value && (ce.value = !0, (qe = le.value) == null || qe.focus());
    }
    function Ye(qe) {
      se.value = !0, setTimeout(() => {
        ue.value = !0;
      });
    }
    function De(qe) {
      ue.value = !1;
    }
    function je(qe) {
      (qe == null || qe === "" && !re.multiple && !Ce.value) && (He.value = []);
    }
    const rt = shallowRef(!1);
    function at(qe) {
      let We = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      if (!(!qe || qe.props.disabled))
        if (re.multiple) {
          const ze = He.value.findIndex((nt) => (re.valueComparator || deepEqual)(nt.value, qe.value)), Ge = We ?? !~ze;
          if (~ze) {
            const nt = Ge ? [...He.value, qe] : [...He.value];
            nt.splice(ze, 1), He.value = nt;
          } else Ge && (He.value = [...He.value, qe]);
          re.clearOnSelect && (Ne.value = "");
        } else {
          const ze = We !== !1;
          He.value = ze ? [qe] : [], Ne.value = ze && !Ce.value ? qe.title : "", nextTick$2(() => {
            pe.value = !1, ce.value = !0;
          });
        }
    }
    return watch(se, (qe, We) => {
      var ze;
      qe !== We && (qe ? (rt.value = !0, Ne.value = re.multiple || Ce.value ? "" : String(((ze = He.value.at(-1)) == null ? void 0 : ze.props.title) ?? ""), ce.value = !0, nextTick$2(() => rt.value = !1)) : (!re.multiple && Ne.value == null && (He.value = []), pe.value = !1, He.value.some((Ge) => {
        let {
          title: nt
        } = Ge;
        return nt === Ne.value;
      }) || (Ne.value = ""), ge.value = -1));
    }), watch(Ne, (qe) => {
      !se.value || rt.value || (qe && (pe.value = !0), ce.value = !qe);
    }), watch(pe, () => {
      if (!re.hideSelected && pe.value && He.value.length) {
        const qe = tt.value.findIndex((We) => He.value.some((ze) => We.value === ze.value));
        IN_BROWSER && window.requestAnimationFrame(() => {
          var We;
          qe >= 0 && ((We = me.value) == null || We.scrollToIndex(qe));
        });
      }
    }), watch(() => re.items, (qe, We) => {
      pe.value || se.value && !We.length && qe.length && (pe.value = !0);
    }), useRender(() => {
      const qe = !!(!re.hideNoData || tt.value.length || ae["prepend-item"] || ae["append-item"] || ae["no-data"]), We = He.value.length > 0, ze = VTextField.filterProps(re);
      return createVNode(VTextField, mergeProps({
        ref: le
      }, ze, {
        modelValue: Ne.value,
        "onUpdate:modelValue": [(Ge) => Ne.value = Ge, je],
        focused: se.value,
        "onUpdate:focused": (Ge) => se.value = Ge,
        validationValue: He.externalValue,
        counterValue: Ue.value,
        dirty: We,
        onChange: Be,
        class: ["v-autocomplete", `v-autocomplete--${re.multiple ? "multiple" : "single"}`, {
          "v-autocomplete--active-menu": pe.value,
          "v-autocomplete--chips": !!re.chips,
          "v-autocomplete--selection-slot": !!Ce.value,
          "v-autocomplete--selecting-index": ge.value > -1
        }, re.class],
        style: re.style,
        readonly: Ze.isReadonly.value,
        placeholder: We ? void 0 : re.placeholder,
        "onClick:clear": Te,
        "onMousedown:control": Ie,
        onKeydown: ye
      }), {
        ...ae,
        default: () => createVNode(Fragment, null, [createVNode(VMenu, mergeProps({
          ref: de,
          modelValue: pe.value,
          "onUpdate:modelValue": (Ge) => pe.value = Ge,
          activator: "parent",
          contentClass: "v-autocomplete__content",
          disabled: ve.value,
          eager: re.eager,
          maxHeight: 310,
          openOnClick: !1,
          closeOnContentClick: !1,
          transition: re.transition,
          onAfterEnter: Xe,
          onAfterLeave: et
        }, re.menuProps), {
          default: () => [qe && createVNode(VList, mergeProps({
            ref: xe,
            selected: _e.value,
            selectStrategy: re.multiple ? "independent" : "single-independent",
            onMousedown: (Ge) => Ge.preventDefault(),
            onKeydown: ke,
            onFocusin: Ye,
            onFocusout: De,
            tabindex: "-1",
            "aria-live": "polite",
            color: re.itemColor ?? re.color
          }, $e, re.listProps), {
            default: () => {
              var Ge, nt, ot;
              return [(Ge = ae["prepend-item"]) == null ? void 0 : Ge.call(ae), !tt.value.length && !re.hideNoData && (((nt = ae["no-data"]) == null ? void 0 : nt.call(ae)) ?? createVNode(VListItem, {
                key: "no-data",
                title: ie(re.noDataText)
              }, null)), createVNode(VVirtualScroll, {
                ref: me,
                renderless: !0,
                items: tt.value
              }, {
                default: (lt) => {
                  var At;
                  let {
                    item: mt,
                    index: dt,
                    itemRef: gt
                  } = lt;
                  const bt = mergeProps(mt.props, {
                    ref: gt,
                    key: mt.value,
                    active: he.value && dt === 0 ? !0 : void 0,
                    onClick: () => at(mt, null)
                  });
                  return ((At = ae.item) == null ? void 0 : At.call(ae, {
                    item: mt,
                    index: dt,
                    props: bt
                  })) ?? createVNode(VListItem, mergeProps(bt, {
                    role: "option"
                  }), {
                    prepend: (wt) => {
                      let {
                        isSelected: pt
                      } = wt;
                      return createVNode(Fragment, null, [re.multiple && !re.hideSelected ? createVNode(VCheckboxBtn, {
                        key: mt.value,
                        modelValue: pt,
                        ripple: !1,
                        tabindex: "-1"
                      }, null) : void 0, mt.props.prependAvatar && createVNode(VAvatar, {
                        image: mt.props.prependAvatar
                      }, null), mt.props.prependIcon && createVNode(VIcon, {
                        icon: mt.props.prependIcon
                      }, null)]);
                    },
                    title: () => {
                      var wt, pt;
                      return ce.value ? mt.title : highlightResult$1(mt.title, (wt = Ke(mt)) == null ? void 0 : wt.title, ((pt = Ne.value) == null ? void 0 : pt.length) ?? 0);
                    }
                  });
                }
              }), (ot = ae["append-item"]) == null ? void 0 : ot.call(ae)];
            }
          })]
        }), He.value.map((Ge, nt) => {
          function ot(gt) {
            gt.stopPropagation(), gt.preventDefault(), at(Ge, !1);
          }
          const lt = {
            "onClick:close": ot,
            onKeydown(gt) {
              gt.key !== "Enter" && gt.key !== " " || (gt.preventDefault(), gt.stopPropagation(), ot(gt));
            },
            onMousedown(gt) {
              gt.preventDefault(), gt.stopPropagation();
            },
            modelValue: !0,
            "onUpdate:modelValue": void 0
          }, mt = Re.value ? !!ae.chip : !!ae.selection, dt = mt ? ensureValidVNode(Re.value ? ae.chip({
            item: Ge,
            index: nt,
            props: lt
          }) : ae.selection({
            item: Ge,
            index: nt
          })) : void 0;
          if (!(mt && !dt))
            return createVNode("div", {
              key: Ge.value,
              class: ["v-autocomplete__selection", nt === ge.value && ["v-autocomplete__selection--selected", Ae.value]],
              style: nt === ge.value ? Oe.value : {}
            }, [Re.value ? ae.chip ? createVNode(VDefaultsProvider, {
              key: "chip-defaults",
              defaults: {
                VChip: {
                  closable: re.closableChips,
                  size: "small",
                  text: Ge.title
                }
              }
            }, {
              default: () => [dt]
            }) : createVNode(VChip, mergeProps({
              key: "chip",
              closable: re.closableChips,
              size: "small",
              text: Ge.title,
              disabled: Ge.props.disabled
            }, lt), null) : dt ?? createVNode("span", {
              class: "v-autocomplete__selection-text"
            }, [Ge.title, re.multiple && nt < He.value.length - 1 && createVNode("span", {
              class: "v-autocomplete__selection-comma"
            }, [createTextVNode(",")])])]);
        })]),
        "append-inner": function() {
          var lt;
          for (var Ge = arguments.length, nt = new Array(Ge), ot = 0; ot < Ge; ot++)
            nt[ot] = arguments[ot];
          return createVNode(Fragment, null, [(lt = ae["append-inner"]) == null ? void 0 : lt.call(ae, ...nt), re.menuIcon ? createVNode(VIcon, {
            class: "v-autocomplete__menu-icon",
            icon: re.menuIcon,
            onMousedown: we,
            onClick: noop$2,
            "aria-label": ie(Se.value),
            title: ie(Se.value),
            tabindex: "-1"
          }, null) : void 0]);
        }
      });
    }), forwardRefs({
      isFocused: se,
      isPristine: ce,
      menu: pe,
      search: Ne,
      filteredItems: Fe,
      select: at
    }, le);
  }
}), makeVBadgeProps = propsFactory({
  bordered: Boolean,
  color: String,
  content: [Number, String],
  dot: Boolean,
  floating: Boolean,
  icon: IconValue,
  inline: Boolean,
  label: {
    type: String,
    default: "$vuetify.badge"
  },
  max: [Number, String],
  modelValue: {
    type: Boolean,
    default: !0
  },
  offsetX: [Number, String],
  offsetY: [Number, String],
  textColor: String,
  ...makeComponentProps(),
  ...makeLocationProps({
    location: "top end"
  }),
  ...makeRoundedProps(),
  ...makeTagProps(),
  ...makeThemeProps(),
  ...makeTransitionProps({
    transition: "scale-rotate-transition"
  })
}, "VBadge"), VBadge = genericComponent()({
  name: "VBadge",
  inheritAttrs: !1,
  props: makeVBadgeProps(),
  setup(re, ne) {
    const {
      backgroundColorClasses: ae,
      backgroundColorStyles: ie
    } = useBackgroundColor(toRef(re, "color")), {
      roundedClasses: le
    } = useRounded(re), {
      t: se
    } = useLocale(), {
      textColorClasses: ce,
      textColorStyles: ue
    } = useTextColor(toRef(re, "textColor")), {
      themeClasses: de
    } = useTheme(), {
      locationStyles: me
    } = useLocation(re, !0, (fe) => (re.floating ? re.dot ? 2 : 4 : re.dot ? 8 : 12) + (["top", "bottom"].includes(fe) ? Number(re.offsetY ?? 0) : ["left", "right"].includes(fe) ? Number(re.offsetX ?? 0) : 0));
    return useRender(() => {
      const fe = Number(re.content), pe = !re.max || isNaN(fe) ? re.content : fe <= Number(re.max) ? fe : `${re.max}+`, [ge, be] = pickWithRest(ne.attrs, ["aria-atomic", "aria-label", "aria-live", "role", "title"]);
      return createVNode(re.tag, mergeProps({
        class: ["v-badge", {
          "v-badge--bordered": re.bordered,
          "v-badge--dot": re.dot,
          "v-badge--floating": re.floating,
          "v-badge--inline": re.inline
        }, re.class]
      }, be, {
        style: re.style
      }), {
        default: () => {
          var Se, Pe;
          return [createVNode("div", {
            class: "v-badge__wrapper"
          }, [(Pe = (Se = ne.slots).default) == null ? void 0 : Pe.call(Se), createVNode(MaybeTransition, {
            transition: re.transition
          }, {
            default: () => {
              var Ee, Ve;
              return [withDirectives(createVNode("span", mergeProps({
                class: ["v-badge__badge", de.value, ae.value, le.value, ce.value],
                style: [ie.value, ue.value, re.inline ? {} : me.value],
                "aria-atomic": "true",
                "aria-label": se(re.label, fe),
                "aria-live": "polite",
                role: "status"
              }, ge), [re.dot ? void 0 : ne.slots.badge ? (Ve = (Ee = ne.slots).badge) == null ? void 0 : Ve.call(Ee) : re.icon ? createVNode(VIcon, {
                icon: re.icon
              }, null) : pe]), [[vShow, re.modelValue]])];
            }
          })])];
        }
      });
    }), {};
  }
}), makeVBannerActionsProps = propsFactory({
  color: String,
  density: String,
  ...makeComponentProps()
}, "VBannerActions"), VBannerActions = genericComponent()({
  name: "VBannerActions",
  props: makeVBannerActionsProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    return provideDefaults({
      VBtn: {
        color: re.color,
        density: re.density,
        slim: !0,
        variant: "text"
      }
    }), useRender(() => {
      var ie;
      return createVNode("div", {
        class: ["v-banner-actions", re.class],
        style: re.style
      }, [(ie = ae.default) == null ? void 0 : ie.call(ae)]);
    }), {};
  }
}), VBannerText = createSimpleFunctional("v-banner-text"), makeVBannerProps = propsFactory({
  avatar: String,
  bgColor: String,
  color: String,
  icon: IconValue,
  lines: String,
  stacked: Boolean,
  sticky: Boolean,
  text: String,
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeDimensionProps(),
  ...makeDisplayProps({
    mobile: null
  }),
  ...makeElevationProps(),
  ...makeLocationProps(),
  ...makePositionProps(),
  ...makeRoundedProps(),
  ...makeTagProps(),
  ...makeThemeProps()
}, "VBanner"), VBanner = genericComponent()({
  name: "VBanner",
  props: makeVBannerProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      backgroundColorClasses: ie,
      backgroundColorStyles: le
    } = useBackgroundColor(re, "bgColor"), {
      borderClasses: se
    } = useBorder(re), {
      densityClasses: ce
    } = useDensity(re), {
      displayClasses: ue,
      mobile: de
    } = useDisplay(re), {
      dimensionStyles: me
    } = useDimension(re), {
      elevationClasses: fe
    } = useElevation(re), {
      locationStyles: pe
    } = useLocation(re), {
      positionClasses: ge
    } = usePosition(re), {
      roundedClasses: be
    } = useRounded(re), {
      themeClasses: Se
    } = provideTheme(re), Pe = toRef(re, "color"), Ee = toRef(re, "density");
    provideDefaults({
      VBannerActions: {
        color: Pe,
        density: Ee
      }
    }), useRender(() => {
      const Ve = !!(re.text || ae.text), Ae = !!(re.avatar || re.icon), Oe = !!(Ae || ae.prepend);
      return createVNode(re.tag, {
        class: ["v-banner", {
          "v-banner--stacked": re.stacked || de.value,
          "v-banner--sticky": re.sticky,
          [`v-banner--${re.lines}-line`]: !!re.lines
        }, Se.value, ie.value, se.value, ce.value, ue.value, fe.value, ge.value, be.value, re.class],
        style: [le.value, me.value, pe.value, re.style],
        role: "banner"
      }, {
        default: () => {
          var Ne;
          return [Oe && createVNode("div", {
            key: "prepend",
            class: "v-banner__prepend"
          }, [ae.prepend ? createVNode(VDefaultsProvider, {
            key: "prepend-defaults",
            disabled: !Ae,
            defaults: {
              VAvatar: {
                color: Pe.value,
                density: Ee.value,
                icon: re.icon,
                image: re.avatar
              }
            }
          }, ae.prepend) : createVNode(VAvatar, {
            key: "prepend-avatar",
            color: Pe.value,
            density: Ee.value,
            icon: re.icon,
            image: re.avatar
          }, null)]), createVNode("div", {
            class: "v-banner__content"
          }, [Ve && createVNode(VBannerText, {
            key: "text"
          }, {
            default: () => {
              var He;
              return [((He = ae.text) == null ? void 0 : He.call(ae)) ?? re.text];
            }
          }), (Ne = ae.default) == null ? void 0 : Ne.call(ae)]), ae.actions && createVNode(VBannerActions, {
            key: "actions"
          }, ae.actions)];
        }
      });
    });
  }
}), makeVBottomNavigationProps = propsFactory({
  baseColor: String,
  bgColor: String,
  color: String,
  grow: Boolean,
  mode: {
    type: String,
    validator: (re) => !re || ["horizontal", "shift"].includes(re)
  },
  height: {
    type: [Number, String],
    default: 56
  },
  active: {
    type: Boolean,
    default: !0
  },
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeElevationProps(),
  ...makeRoundedProps(),
  ...makeLayoutItemProps({
    name: "bottom-navigation"
  }),
  ...makeTagProps({
    tag: "header"
  }),
  ...makeGroupProps({
    selectedClass: "v-btn--selected"
  }),
  ...makeThemeProps()
}, "VBottomNavigation"), VBottomNavigation = genericComponent()({
  name: "VBottomNavigation",
  props: makeVBottomNavigationProps(),
  emits: {
    "update:active": (re) => !0,
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      themeClasses: ie
    } = useTheme(), {
      borderClasses: le
    } = useBorder(re), {
      backgroundColorClasses: se,
      backgroundColorStyles: ce
    } = useBackgroundColor(toRef(re, "bgColor")), {
      densityClasses: ue
    } = useDensity(re), {
      elevationClasses: de
    } = useElevation(re), {
      roundedClasses: me
    } = useRounded(re), {
      ssrBootStyles: fe
    } = useSsrBoot(), pe = computed(() => Number(re.height) - (re.density === "comfortable" ? 8 : 0) - (re.density === "compact" ? 16 : 0)), ge = useProxiedModel(re, "active", re.active), {
      layoutItemStyles: be
    } = useLayoutItem({
      id: re.name,
      order: computed(() => parseInt(re.order, 10)),
      position: computed(() => "bottom"),
      layoutSize: computed(() => ge.value ? pe.value : 0),
      elementSize: pe,
      active: ge,
      absolute: toRef(re, "absolute")
    });
    return useGroup(re, VBtnToggleSymbol), provideDefaults({
      VBtn: {
        baseColor: toRef(re, "baseColor"),
        color: toRef(re, "color"),
        density: toRef(re, "density"),
        stacked: computed(() => re.mode !== "horizontal"),
        variant: "text"
      }
    }, {
      scoped: !0
    }), useRender(() => createVNode(re.tag, {
      class: ["v-bottom-navigation", {
        "v-bottom-navigation--active": ge.value,
        "v-bottom-navigation--grow": re.grow,
        "v-bottom-navigation--shift": re.mode === "shift"
      }, ie.value, se.value, le.value, ue.value, de.value, me.value, re.class],
      style: [ce.value, be.value, {
        height: convertToUnit(pe.value)
      }, fe.value, re.style]
    }, {
      default: () => [ae.default && createVNode("div", {
        class: "v-bottom-navigation__content"
      }, [ae.default()])]
    })), {};
  }
}), makeVDialogProps = propsFactory({
  fullscreen: Boolean,
  retainFocus: {
    type: Boolean,
    default: !0
  },
  scrollable: Boolean,
  ...makeVOverlayProps({
    origin: "center center",
    scrollStrategy: "block",
    transition: {
      component: VDialogTransition
    },
    zIndex: 2400
  })
}, "VDialog"), VDialog = genericComponent()({
  name: "VDialog",
  props: makeVDialogProps(),
  emits: {
    "update:modelValue": (re) => !0,
    afterEnter: () => !0,
    afterLeave: () => !0
  },
  setup(re, ne) {
    let {
      emit: ae,
      slots: ie
    } = ne;
    const le = useProxiedModel(re, "modelValue"), {
      scopeId: se
    } = useScopeId(), ce = ref$1();
    function ue(fe) {
      var be, Se;
      const pe = fe.relatedTarget, ge = fe.target;
      if (pe !== ge && ((be = ce.value) != null && be.contentEl) && // We're the topmost dialog
      ((Se = ce.value) != null && Se.globalTop) && // It isn't the document or the dialog body
      ![document, ce.value.contentEl].includes(ge) && // It isn't inside the dialog body
      !ce.value.contentEl.contains(ge)) {
        const Pe = focusableChildren(ce.value.contentEl);
        if (!Pe.length) return;
        const Ee = Pe[0], Ve = Pe[Pe.length - 1];
        pe === Ee ? Ve.focus() : Ee.focus();
      }
    }
    onBeforeUnmount(() => {
      document.removeEventListener("focusin", ue);
    }), IN_BROWSER && watch(() => le.value && re.retainFocus, (fe) => {
      fe ? document.addEventListener("focusin", ue) : document.removeEventListener("focusin", ue);
    }, {
      immediate: !0
    });
    function de() {
      var fe;
      ae("afterEnter"), (fe = ce.value) != null && fe.contentEl && !ce.value.contentEl.contains(document.activeElement) && ce.value.contentEl.focus({
        preventScroll: !0
      });
    }
    function me() {
      ae("afterLeave");
    }
    return watch(le, async (fe) => {
      var pe;
      fe || (await nextTick$2(), (pe = ce.value.activatorEl) == null || pe.focus({
        preventScroll: !0
      }));
    }), useRender(() => {
      const fe = VOverlay.filterProps(re), pe = mergeProps({
        "aria-haspopup": "dialog"
      }, re.activatorProps), ge = mergeProps({
        tabindex: -1
      }, re.contentProps);
      return createVNode(VOverlay, mergeProps({
        ref: ce,
        class: ["v-dialog", {
          "v-dialog--fullscreen": re.fullscreen,
          "v-dialog--scrollable": re.scrollable
        }, re.class],
        style: re.style
      }, fe, {
        modelValue: le.value,
        "onUpdate:modelValue": (be) => le.value = be,
        "aria-modal": "true",
        activatorProps: pe,
        contentProps: ge,
        height: re.fullscreen ? void 0 : re.height,
        width: re.fullscreen ? void 0 : re.width,
        maxHeight: re.fullscreen ? void 0 : re.maxHeight,
        maxWidth: re.fullscreen ? void 0 : re.maxWidth,
        role: "dialog",
        onAfterEnter: de,
        onAfterLeave: me
      }, se), {
        activator: ie.activator,
        default: function() {
          for (var be = arguments.length, Se = new Array(be), Pe = 0; Pe < be; Pe++)
            Se[Pe] = arguments[Pe];
          return createVNode(VDefaultsProvider, {
            root: "VDialog"
          }, {
            default: () => {
              var Ee;
              return [(Ee = ie.default) == null ? void 0 : Ee.call(ie, ...Se)];
            }
          });
        }
      });
    }), forwardRefs({}, ce);
  }
}), makeVBottomSheetProps = propsFactory({
  inset: Boolean,
  ...makeVDialogProps({
    transition: "bottom-sheet-transition"
  })
}, "VBottomSheet"), VBottomSheet = genericComponent()({
  name: "VBottomSheet",
  props: makeVBottomSheetProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = useProxiedModel(re, "modelValue");
    return useRender(() => {
      const le = VDialog.filterProps(re);
      return createVNode(VDialog, mergeProps(le, {
        contentClass: ["v-bottom-sheet__content", re.contentClass],
        modelValue: ie.value,
        "onUpdate:modelValue": (se) => ie.value = se,
        class: ["v-bottom-sheet", {
          "v-bottom-sheet--inset": re.inset
        }, re.class],
        style: re.style
      }), ae);
    }), {};
  }
}), makeVBreadcrumbsDividerProps = propsFactory({
  divider: [Number, String],
  ...makeComponentProps()
}, "VBreadcrumbsDivider"), VBreadcrumbsDivider = genericComponent()({
  name: "VBreadcrumbsDivider",
  props: makeVBreadcrumbsDividerProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    return useRender(() => {
      var ie;
      return createVNode("li", {
        "aria-hidden": "true",
        class: ["v-breadcrumbs-divider", re.class],
        style: re.style
      }, [((ie = ae == null ? void 0 : ae.default) == null ? void 0 : ie.call(ae)) ?? re.divider]);
    }), {};
  }
}), makeVBreadcrumbsItemProps = propsFactory({
  active: Boolean,
  activeClass: String,
  activeColor: String,
  color: String,
  disabled: Boolean,
  title: String,
  ...makeComponentProps(),
  ...makeRouterProps(),
  ...makeTagProps({
    tag: "li"
  })
}, "VBreadcrumbsItem"), VBreadcrumbsItem = genericComponent()({
  name: "VBreadcrumbsItem",
  props: makeVBreadcrumbsItemProps(),
  setup(re, ne) {
    let {
      slots: ae,
      attrs: ie
    } = ne;
    const le = useLink(re, ie), se = computed(() => {
      var me;
      return re.active || ((me = le.isActive) == null ? void 0 : me.value);
    }), ce = computed(() => se.value ? re.activeColor : re.color), {
      textColorClasses: ue,
      textColorStyles: de
    } = useTextColor(ce);
    return useRender(() => createVNode(re.tag, {
      class: ["v-breadcrumbs-item", {
        "v-breadcrumbs-item--active": se.value,
        "v-breadcrumbs-item--disabled": re.disabled,
        [`${re.activeClass}`]: se.value && re.activeClass
      }, ue.value, re.class],
      style: [de.value, re.style],
      "aria-current": se.value ? "page" : void 0
    }, {
      default: () => {
        var me, fe;
        return [le.isLink.value ? createVNode("a", mergeProps({
          class: "v-breadcrumbs-item--link",
          onClick: le.navigate
        }, le.linkProps), [((fe = ae.default) == null ? void 0 : fe.call(ae)) ?? re.title]) : ((me = ae.default) == null ? void 0 : me.call(ae)) ?? re.title];
      }
    })), {};
  }
}), makeVBreadcrumbsProps = propsFactory({
  activeClass: String,
  activeColor: String,
  bgColor: String,
  color: String,
  disabled: Boolean,
  divider: {
    type: String,
    default: "/"
  },
  icon: IconValue,
  items: {
    type: Array,
    default: () => []
  },
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeRoundedProps(),
  ...makeTagProps({
    tag: "ul"
  })
}, "VBreadcrumbs"), VBreadcrumbs = genericComponent()({
  name: "VBreadcrumbs",
  props: makeVBreadcrumbsProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      backgroundColorClasses: ie,
      backgroundColorStyles: le
    } = useBackgroundColor(toRef(re, "bgColor")), {
      densityClasses: se
    } = useDensity(re), {
      roundedClasses: ce
    } = useRounded(re);
    provideDefaults({
      VBreadcrumbsDivider: {
        divider: toRef(re, "divider")
      },
      VBreadcrumbsItem: {
        activeClass: toRef(re, "activeClass"),
        activeColor: toRef(re, "activeColor"),
        color: toRef(re, "color"),
        disabled: toRef(re, "disabled")
      }
    });
    const ue = computed(() => re.items.map((de) => typeof de == "string" ? {
      item: {
        title: de
      },
      raw: de
    } : {
      item: de,
      raw: de
    }));
    return useRender(() => {
      const de = !!(ae.prepend || re.icon);
      return createVNode(re.tag, {
        class: ["v-breadcrumbs", ie.value, se.value, ce.value, re.class],
        style: [le.value, re.style]
      }, {
        default: () => {
          var me;
          return [de && createVNode("li", {
            key: "prepend",
            class: "v-breadcrumbs__prepend"
          }, [ae.prepend ? createVNode(VDefaultsProvider, {
            key: "prepend-defaults",
            disabled: !re.icon,
            defaults: {
              VIcon: {
                icon: re.icon,
                start: !0
              }
            }
          }, ae.prepend) : createVNode(VIcon, {
            key: "prepend-icon",
            start: !0,
            icon: re.icon
          }, null)]), ue.value.map((fe, pe, ge) => {
            var Pe;
            let {
              item: be,
              raw: Se
            } = fe;
            return createVNode(Fragment, null, [((Pe = ae.item) == null ? void 0 : Pe.call(ae, {
              item: be,
              index: pe
            })) ?? createVNode(VBreadcrumbsItem, mergeProps({
              key: pe,
              disabled: pe >= ge.length - 1
            }, typeof be == "string" ? {
              title: be
            } : be), {
              default: ae.title ? () => {
                var Ee;
                return (Ee = ae.title) == null ? void 0 : Ee.call(ae, {
                  item: be,
                  index: pe
                });
              } : void 0
            }), pe < ge.length - 1 && createVNode(VBreadcrumbsDivider, null, {
              default: ae.divider ? () => {
                var Ee;
                return (Ee = ae.divider) == null ? void 0 : Ee.call(ae, {
                  item: Se,
                  index: pe
                });
              } : void 0
            })]);
          }), (me = ae.default) == null ? void 0 : me.call(ae)];
        }
      });
    }), {};
  }
}), VCardActions = genericComponent()({
  name: "VCardActions",
  props: makeComponentProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    return provideDefaults({
      VBtn: {
        slim: !0,
        variant: "text"
      }
    }), useRender(() => {
      var ie;
      return createVNode("div", {
        class: ["v-card-actions", re.class],
        style: re.style
      }, [(ie = ae.default) == null ? void 0 : ie.call(ae)]);
    }), {};
  }
}), makeVCardSubtitleProps = propsFactory({
  opacity: [Number, String],
  ...makeComponentProps(),
  ...makeTagProps()
}, "VCardSubtitle"), VCardSubtitle = genericComponent()({
  name: "VCardSubtitle",
  props: makeVCardSubtitleProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    return useRender(() => createVNode(re.tag, {
      class: ["v-card-subtitle", re.class],
      style: [{
        "--v-card-subtitle-opacity": re.opacity
      }, re.style]
    }, ae)), {};
  }
}), VCardTitle = createSimpleFunctional("v-card-title"), makeCardItemProps = propsFactory({
  appendAvatar: String,
  appendIcon: IconValue,
  prependAvatar: String,
  prependIcon: IconValue,
  subtitle: {
    type: [String, Number, Boolean],
    default: void 0
  },
  title: {
    type: [String, Number, Boolean],
    default: void 0
  },
  ...makeComponentProps(),
  ...makeDensityProps()
}, "VCardItem"), VCardItem = genericComponent()({
  name: "VCardItem",
  props: makeCardItemProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    return useRender(() => {
      var me;
      const ie = !!(re.prependAvatar || re.prependIcon), le = !!(ie || ae.prepend), se = !!(re.appendAvatar || re.appendIcon), ce = !!(se || ae.append), ue = !!(re.title != null || ae.title), de = !!(re.subtitle != null || ae.subtitle);
      return createVNode("div", {
        class: ["v-card-item", re.class],
        style: re.style
      }, [le && createVNode("div", {
        key: "prepend",
        class: "v-card-item__prepend"
      }, [ae.prepend ? createVNode(VDefaultsProvider, {
        key: "prepend-defaults",
        disabled: !ie,
        defaults: {
          VAvatar: {
            density: re.density,
            image: re.prependAvatar
          },
          VIcon: {
            density: re.density,
            icon: re.prependIcon
          }
        }
      }, ae.prepend) : createVNode(Fragment, null, [re.prependAvatar && createVNode(VAvatar, {
        key: "prepend-avatar",
        density: re.density,
        image: re.prependAvatar
      }, null), re.prependIcon && createVNode(VIcon, {
        key: "prepend-icon",
        density: re.density,
        icon: re.prependIcon
      }, null)])]), createVNode("div", {
        class: "v-card-item__content"
      }, [ue && createVNode(VCardTitle, {
        key: "title"
      }, {
        default: () => {
          var fe;
          return [((fe = ae.title) == null ? void 0 : fe.call(ae)) ?? toDisplayString$1(re.title)];
        }
      }), de && createVNode(VCardSubtitle, {
        key: "subtitle"
      }, {
        default: () => {
          var fe;
          return [((fe = ae.subtitle) == null ? void 0 : fe.call(ae)) ?? toDisplayString$1(re.subtitle)];
        }
      }), (me = ae.default) == null ? void 0 : me.call(ae)]), ce && createVNode("div", {
        key: "append",
        class: "v-card-item__append"
      }, [ae.append ? createVNode(VDefaultsProvider, {
        key: "append-defaults",
        disabled: !se,
        defaults: {
          VAvatar: {
            density: re.density,
            image: re.appendAvatar
          },
          VIcon: {
            density: re.density,
            icon: re.appendIcon
          }
        }
      }, ae.append) : createVNode(Fragment, null, [re.appendIcon && createVNode(VIcon, {
        key: "append-icon",
        density: re.density,
        icon: re.appendIcon
      }, null), re.appendAvatar && createVNode(VAvatar, {
        key: "append-avatar",
        density: re.density,
        image: re.appendAvatar
      }, null)])])]);
    }), {};
  }
}), makeVCardTextProps = propsFactory({
  opacity: [Number, String],
  ...makeComponentProps(),
  ...makeTagProps()
}, "VCardText"), VCardText = genericComponent()({
  name: "VCardText",
  props: makeVCardTextProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    return useRender(() => createVNode(re.tag, {
      class: ["v-card-text", re.class],
      style: [{
        "--v-card-text-opacity": re.opacity
      }, re.style]
    }, ae)), {};
  }
}), makeVCardProps = propsFactory({
  appendAvatar: String,
  appendIcon: IconValue,
  disabled: Boolean,
  flat: Boolean,
  hover: Boolean,
  image: String,
  link: {
    type: Boolean,
    default: void 0
  },
  prependAvatar: String,
  prependIcon: IconValue,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  subtitle: {
    type: [String, Number, Boolean],
    default: void 0
  },
  text: {
    type: [String, Number, Boolean],
    default: void 0
  },
  title: {
    type: [String, Number, Boolean],
    default: void 0
  },
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeDimensionProps(),
  ...makeElevationProps(),
  ...makeLoaderProps(),
  ...makeLocationProps(),
  ...makePositionProps(),
  ...makeRoundedProps(),
  ...makeRouterProps(),
  ...makeTagProps(),
  ...makeThemeProps(),
  ...makeVariantProps({
    variant: "elevated"
  })
}, "VCard"), VCard = genericComponent()({
  name: "VCard",
  directives: {
    Ripple
  },
  props: makeVCardProps(),
  setup(re, ne) {
    let {
      attrs: ae,
      slots: ie
    } = ne;
    const {
      themeClasses: le
    } = provideTheme(re), {
      borderClasses: se
    } = useBorder(re), {
      colorClasses: ce,
      colorStyles: ue,
      variantClasses: de
    } = useVariant(re), {
      densityClasses: me
    } = useDensity(re), {
      dimensionStyles: fe
    } = useDimension(re), {
      elevationClasses: pe
    } = useElevation(re), {
      loaderClasses: ge
    } = useLoader(re), {
      locationStyles: be
    } = useLocation(re), {
      positionClasses: Se
    } = usePosition(re), {
      roundedClasses: Pe
    } = useRounded(re), Ee = useLink(re, ae), Ve = computed(() => re.link !== !1 && Ee.isLink.value), Ae = computed(() => !re.disabled && re.link !== !1 && (re.link || Ee.isClickable.value));
    return useRender(() => {
      const Oe = Ve.value ? "a" : re.tag, Ne = !!(ie.title || re.title != null), He = !!(ie.subtitle || re.subtitle != null), Ue = Ne || He, Ze = !!(ie.append || re.appendAvatar || re.appendIcon), Fe = !!(ie.prepend || re.prependAvatar || re.prependIcon), Ke = !!(ie.image || re.image), tt = Ue || Fe || Ze, Re = !!(ie.text || re.text != null);
      return withDirectives(createVNode(Oe, mergeProps({
        class: ["v-card", {
          "v-card--disabled": re.disabled,
          "v-card--flat": re.flat,
          "v-card--hover": re.hover && !(re.disabled || re.flat),
          "v-card--link": Ae.value
        }, le.value, se.value, ce.value, me.value, pe.value, ge.value, Se.value, Pe.value, de.value, re.class],
        style: [ue.value, fe.value, be.value, re.style],
        onClick: Ae.value && Ee.navigate,
        tabindex: re.disabled ? -1 : void 0
      }, Ee.linkProps), {
        default: () => {
          var Ce;
          return [Ke && createVNode("div", {
            key: "image",
            class: "v-card__image"
          }, [ie.image ? createVNode(VDefaultsProvider, {
            key: "image-defaults",
            disabled: !re.image,
            defaults: {
              VImg: {
                cover: !0,
                src: re.image
              }
            }
          }, ie.image) : createVNode(VImg, {
            key: "image-img",
            cover: !0,
            src: re.image
          }, null)]), createVNode(LoaderSlot, {
            name: "v-card",
            active: !!re.loading,
            color: typeof re.loading == "boolean" ? void 0 : re.loading
          }, {
            default: ie.loader
          }), tt && createVNode(VCardItem, {
            key: "item",
            prependAvatar: re.prependAvatar,
            prependIcon: re.prependIcon,
            title: re.title,
            subtitle: re.subtitle,
            appendAvatar: re.appendAvatar,
            appendIcon: re.appendIcon
          }, {
            default: ie.item,
            prepend: ie.prepend,
            title: ie.title,
            subtitle: ie.subtitle,
            append: ie.append
          }), Re && createVNode(VCardText, {
            key: "text"
          }, {
            default: () => {
              var _e;
              return [((_e = ie.text) == null ? void 0 : _e.call(ie)) ?? re.text];
            }
          }), (Ce = ie.default) == null ? void 0 : Ce.call(ie), ie.actions && createVNode(VCardActions, null, {
            default: ie.actions
          }), genOverlays(Ae.value, "v-card")];
        }
      }), [[resolveDirective("ripple"), Ae.value && re.ripple]]);
    }), {};
  }
}), handleGesture = (re) => {
  const {
    touchstartX: ne,
    touchendX: ae,
    touchstartY: ie,
    touchendY: le
  } = re, se = 0.5, ce = 16;
  re.offsetX = ae - ne, re.offsetY = le - ie, Math.abs(re.offsetY) < se * Math.abs(re.offsetX) && (re.left && ae < ne - ce && re.left(re), re.right && ae > ne + ce && re.right(re)), Math.abs(re.offsetX) < se * Math.abs(re.offsetY) && (re.up && le < ie - ce && re.up(re), re.down && le > ie + ce && re.down(re));
};
function touchstart(re, ne) {
  var ie;
  const ae = re.changedTouches[0];
  ne.touchstartX = ae.clientX, ne.touchstartY = ae.clientY, (ie = ne.start) == null || ie.call(ne, {
    originalEvent: re,
    ...ne
  });
}
function touchend(re, ne) {
  var ie;
  const ae = re.changedTouches[0];
  ne.touchendX = ae.clientX, ne.touchendY = ae.clientY, (ie = ne.end) == null || ie.call(ne, {
    originalEvent: re,
    ...ne
  }), handleGesture(ne);
}
function touchmove(re, ne) {
  var ie;
  const ae = re.changedTouches[0];
  ne.touchmoveX = ae.clientX, ne.touchmoveY = ae.clientY, (ie = ne.move) == null || ie.call(ne, {
    originalEvent: re,
    ...ne
  });
}
function createHandlers() {
  let re = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const ne = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: re.left,
    right: re.right,
    up: re.up,
    down: re.down,
    start: re.start,
    move: re.move,
    end: re.end
  };
  return {
    touchstart: (ae) => touchstart(ae, ne),
    touchend: (ae) => touchend(ae, ne),
    touchmove: (ae) => touchmove(ae, ne)
  };
}
function mounted$3(re, ne) {
  var ue;
  const ae = ne.value, ie = ae != null && ae.parent ? re.parentElement : re, le = (ae == null ? void 0 : ae.options) ?? {
    passive: !0
  }, se = (ue = ne.instance) == null ? void 0 : ue.$.uid;
  if (!ie || !se) return;
  const ce = createHandlers(ne.value);
  ie._touchHandlers = ie._touchHandlers ?? /* @__PURE__ */ Object.create(null), ie._touchHandlers[se] = ce, keys$4(ce).forEach((de) => {
    ie.addEventListener(de, ce[de], le);
  });
}
function unmounted$3(re, ne) {
  var se, ce;
  const ae = (se = ne.value) != null && se.parent ? re.parentElement : re, ie = (ce = ne.instance) == null ? void 0 : ce.$.uid;
  if (!(ae != null && ae._touchHandlers) || !ie) return;
  const le = ae._touchHandlers[ie];
  keys$4(le).forEach((ue) => {
    ae.removeEventListener(ue, le[ue]);
  }), delete ae._touchHandlers[ie];
}
const Touch = {
  mounted: mounted$3,
  unmounted: unmounted$3
}, VWindowSymbol = Symbol.for("vuetify:v-window"), VWindowGroupSymbol = Symbol.for("vuetify:v-window-group"), makeVWindowProps = propsFactory({
  continuous: Boolean,
  nextIcon: {
    type: [Boolean, String, Function, Object],
    default: "$next"
  },
  prevIcon: {
    type: [Boolean, String, Function, Object],
    default: "$prev"
  },
  reverse: Boolean,
  showArrows: {
    type: [Boolean, String],
    validator: (re) => typeof re == "boolean" || re === "hover"
  },
  touch: {
    type: [Object, Boolean],
    default: void 0
  },
  direction: {
    type: String,
    default: "horizontal"
  },
  modelValue: null,
  disabled: Boolean,
  selectedClass: {
    type: String,
    default: "v-window-item--active"
  },
  // TODO: mandatory should probably not be exposed but do this for now
  mandatory: {
    type: [Boolean, String],
    default: "force"
  },
  ...makeComponentProps(),
  ...makeTagProps(),
  ...makeThemeProps()
}, "VWindow"), VWindow = genericComponent()({
  name: "VWindow",
  directives: {
    Touch
  },
  props: makeVWindowProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      themeClasses: ie
    } = provideTheme(re), {
      isRtl: le
    } = useRtl(), {
      t: se
    } = useLocale(), ce = useGroup(re, VWindowGroupSymbol), ue = ref$1(), de = computed(() => le.value ? !re.reverse : re.reverse), me = shallowRef(!1), fe = computed(() => {
      const Ne = re.direction === "vertical" ? "y" : "x", Ue = (de.value ? !me.value : me.value) ? "-reverse" : "";
      return `v-window-${Ne}${Ue}-transition`;
    }), pe = shallowRef(0), ge = ref$1(void 0), be = computed(() => ce.items.value.findIndex((Ne) => ce.selected.value.includes(Ne.id)));
    watch(be, (Ne, He) => {
      const Ue = ce.items.value.length, Ze = Ue - 1;
      Ue <= 2 ? me.value = Ne < He : Ne === Ze && He === 0 ? me.value = !0 : Ne === 0 && He === Ze ? me.value = !1 : me.value = Ne < He;
    }), provide(VWindowSymbol, {
      transition: fe,
      isReversed: me,
      transitionCount: pe,
      transitionHeight: ge,
      rootRef: ue
    });
    const Se = computed(() => re.continuous || be.value !== 0), Pe = computed(() => re.continuous || be.value !== ce.items.value.length - 1);
    function Ee() {
      Se.value && ce.prev();
    }
    function Ve() {
      Pe.value && ce.next();
    }
    const Ae = computed(() => {
      const Ne = [], He = {
        icon: le.value ? re.nextIcon : re.prevIcon,
        class: `v-window__${de.value ? "right" : "left"}`,
        onClick: ce.prev,
        "aria-label": se("$vuetify.carousel.prev")
      };
      Ne.push(Se.value ? ae.prev ? ae.prev({
        props: He
      }) : createVNode(VBtn, He, null) : createVNode("div", null, null));
      const Ue = {
        icon: le.value ? re.prevIcon : re.nextIcon,
        class: `v-window__${de.value ? "left" : "right"}`,
        onClick: ce.next,
        "aria-label": se("$vuetify.carousel.next")
      };
      return Ne.push(Pe.value ? ae.next ? ae.next({
        props: Ue
      }) : createVNode(VBtn, Ue, null) : createVNode("div", null, null)), Ne;
    }), Oe = computed(() => re.touch === !1 ? re.touch : {
      ...{
        left: () => {
          de.value ? Ee() : Ve();
        },
        right: () => {
          de.value ? Ve() : Ee();
        },
        start: (He) => {
          let {
            originalEvent: Ue
          } = He;
          Ue.stopPropagation();
        }
      },
      ...re.touch === !0 ? {} : re.touch
    });
    return useRender(() => withDirectives(createVNode(re.tag, {
      ref: ue,
      class: ["v-window", {
        "v-window--show-arrows-on-hover": re.showArrows === "hover"
      }, ie.value, re.class],
      style: re.style
    }, {
      default: () => {
        var Ne, He;
        return [createVNode("div", {
          class: "v-window__container",
          style: {
            height: ge.value
          }
        }, [(Ne = ae.default) == null ? void 0 : Ne.call(ae, {
          group: ce
        }), re.showArrows !== !1 && createVNode("div", {
          class: "v-window__controls"
        }, [Ae.value])]), (He = ae.additional) == null ? void 0 : He.call(ae, {
          group: ce
        })];
      }
    }), [[resolveDirective("touch"), Oe.value]])), {
      group: ce
    };
  }
}), makeVCarouselProps = propsFactory({
  color: String,
  cycle: Boolean,
  delimiterIcon: {
    type: IconValue,
    default: "$delimiter"
  },
  height: {
    type: [Number, String],
    default: 500
  },
  hideDelimiters: Boolean,
  hideDelimiterBackground: Boolean,
  interval: {
    type: [Number, String],
    default: 6e3,
    validator: (re) => Number(re) > 0
  },
  progress: [Boolean, String],
  verticalDelimiters: [Boolean, String],
  ...makeVWindowProps({
    continuous: !0,
    mandatory: "force",
    showArrows: !0
  })
}, "VCarousel"), VCarousel = genericComponent()({
  name: "VCarousel",
  props: makeVCarouselProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = useProxiedModel(re, "modelValue"), {
      t: le
    } = useLocale(), se = ref$1();
    let ce = -1;
    watch(ie, de), watch(() => re.interval, de), watch(() => re.cycle, (me) => {
      me ? de() : window.clearTimeout(ce);
    }), onMounted(ue);
    function ue() {
      !re.cycle || !se.value || (ce = window.setTimeout(se.value.group.next, Number(re.interval) > 0 ? Number(re.interval) : 6e3));
    }
    function de() {
      window.clearTimeout(ce), window.requestAnimationFrame(ue);
    }
    return useRender(() => {
      const me = VWindow.filterProps(re);
      return createVNode(VWindow, mergeProps({
        ref: se
      }, me, {
        modelValue: ie.value,
        "onUpdate:modelValue": (fe) => ie.value = fe,
        class: ["v-carousel", {
          "v-carousel--hide-delimiter-background": re.hideDelimiterBackground,
          "v-carousel--vertical-delimiters": re.verticalDelimiters
        }, re.class],
        style: [{
          height: convertToUnit(re.height)
        }, re.style]
      }), {
        default: ae.default,
        additional: (fe) => {
          let {
            group: pe
          } = fe;
          return createVNode(Fragment, null, [!re.hideDelimiters && createVNode("div", {
            class: "v-carousel__controls",
            style: {
              left: re.verticalDelimiters === "left" && re.verticalDelimiters ? 0 : "auto",
              right: re.verticalDelimiters === "right" ? 0 : "auto"
            }
          }, [pe.items.value.length > 0 && createVNode(VDefaultsProvider, {
            defaults: {
              VBtn: {
                color: re.color,
                icon: re.delimiterIcon,
                size: "x-small",
                variant: "text"
              }
            },
            scoped: !0
          }, {
            default: () => [pe.items.value.map((ge, be) => {
              const Se = {
                id: `carousel-item-${ge.id}`,
                "aria-label": le("$vuetify.carousel.ariaLabel.delimiter", be + 1, pe.items.value.length),
                class: ["v-carousel__controls__item", pe.isSelected(ge.id) && "v-btn--active"],
                onClick: () => pe.select(ge.id, !0)
              };
              return ae.item ? ae.item({
                props: Se,
                item: ge
              }) : createVNode(VBtn, mergeProps(ge, Se), null);
            })]
          })]), re.progress && createVNode(VProgressLinear, {
            class: "v-carousel__progress",
            color: typeof re.progress == "string" ? re.progress : void 0,
            modelValue: (pe.getItemIndex(ie.value) + 1) / pe.items.value.length * 100
          }, null)]);
        },
        prev: ae.prev,
        next: ae.next
      });
    }), {};
  }
}), makeVWindowItemProps = propsFactory({
  reverseTransition: {
    type: [Boolean, String],
    default: void 0
  },
  transition: {
    type: [Boolean, String],
    default: void 0
  },
  ...makeComponentProps(),
  ...makeGroupItemProps(),
  ...makeLazyProps()
}, "VWindowItem"), VWindowItem = genericComponent()({
  name: "VWindowItem",
  directives: {
    Touch
  },
  props: makeVWindowItemProps(),
  emits: {
    "group:selected": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = inject(VWindowSymbol), le = useGroupItem(re, VWindowGroupSymbol), {
      isBooted: se
    } = useSsrBoot();
    if (!ie || !le) throw new Error("[Vuetify] VWindowItem must be used inside VWindow");
    const ce = shallowRef(!1), ue = computed(() => se.value && (ie.isReversed.value ? re.reverseTransition !== !1 : re.transition !== !1));
    function de() {
      !ce.value || !ie || (ce.value = !1, ie.transitionCount.value > 0 && (ie.transitionCount.value -= 1, ie.transitionCount.value === 0 && (ie.transitionHeight.value = void 0)));
    }
    function me() {
      var Se;
      ce.value || !ie || (ce.value = !0, ie.transitionCount.value === 0 && (ie.transitionHeight.value = convertToUnit((Se = ie.rootRef.value) == null ? void 0 : Se.clientHeight)), ie.transitionCount.value += 1);
    }
    function fe() {
      de();
    }
    function pe(Se) {
      ce.value && nextTick$2(() => {
        !ue.value || !ce.value || !ie || (ie.transitionHeight.value = convertToUnit(Se.clientHeight));
      });
    }
    const ge = computed(() => {
      const Se = ie.isReversed.value ? re.reverseTransition : re.transition;
      return ue.value ? {
        name: typeof Se != "string" ? ie.transition.value : Se,
        onBeforeEnter: me,
        onAfterEnter: de,
        onEnterCancelled: fe,
        onBeforeLeave: me,
        onAfterLeave: de,
        onLeaveCancelled: fe,
        onEnter: pe
      } : !1;
    }), {
      hasContent: be
    } = useLazy(re, le.isSelected);
    return useRender(() => createVNode(MaybeTransition, {
      transition: ge.value,
      disabled: !se.value
    }, {
      default: () => {
        var Se;
        return [withDirectives(createVNode("div", {
          class: ["v-window-item", le.selectedClass.value, re.class],
          style: re.style
        }, [be.value && ((Se = ae.default) == null ? void 0 : Se.call(ae))]), [[vShow, le.isSelected.value]])];
      }
    })), {
      groupItem: le
    };
  }
}), makeVCarouselItemProps = propsFactory({
  ...makeVImgProps(),
  ...makeVWindowItemProps()
}, "VCarouselItem"), VCarouselItem = genericComponent()({
  name: "VCarouselItem",
  inheritAttrs: !1,
  props: makeVCarouselItemProps(),
  setup(re, ne) {
    let {
      slots: ae,
      attrs: ie
    } = ne;
    useRender(() => {
      const le = VImg.filterProps(re), se = VWindowItem.filterProps(re);
      return createVNode(VWindowItem, mergeProps({
        class: ["v-carousel-item", re.class]
      }, se), {
        default: () => [createVNode(VImg, mergeProps(ie, le), ae)]
      });
    });
  }
}), VCode = createSimpleFunctional("v-code", "code"), makeVColorPickerCanvasProps = propsFactory({
  color: {
    type: Object
  },
  disabled: Boolean,
  dotSize: {
    type: [Number, String],
    default: 10
  },
  height: {
    type: [Number, String],
    default: 150
  },
  width: {
    type: [Number, String],
    default: 300
  },
  ...makeComponentProps()
}, "VColorPickerCanvas"), VColorPickerCanvas = defineComponent({
  name: "VColorPickerCanvas",
  props: makeVColorPickerCanvasProps(),
  emits: {
    "update:color": (re) => !0,
    "update:position": (re) => !0
  },
  setup(re, ne) {
    let {
      emit: ae
    } = ne;
    const ie = shallowRef(!1), le = ref$1(), se = shallowRef(parseFloat(re.width)), ce = shallowRef(parseFloat(re.height)), ue = ref$1({
      x: 0,
      y: 0
    }), de = computed({
      get: () => ue.value,
      set(Ee) {
        var Oe, Ne;
        if (!le.value) return;
        const {
          x: Ve,
          y: Ae
        } = Ee;
        ue.value = Ee, ae("update:color", {
          h: ((Oe = re.color) == null ? void 0 : Oe.h) ?? 0,
          s: clamp(Ve, 0, se.value) / se.value,
          v: 1 - clamp(Ae, 0, ce.value) / ce.value,
          a: ((Ne = re.color) == null ? void 0 : Ne.a) ?? 1
        });
      }
    }), me = computed(() => {
      const {
        x: Ee,
        y: Ve
      } = de.value, Ae = parseInt(re.dotSize, 10) / 2;
      return {
        width: convertToUnit(re.dotSize),
        height: convertToUnit(re.dotSize),
        transform: `translate(${convertToUnit(Ee - Ae)}, ${convertToUnit(Ve - Ae)})`
      };
    }), {
      resizeRef: fe
    } = useResizeObserver((Ee) => {
      var Oe;
      if (!((Oe = fe.el) != null && Oe.offsetParent)) return;
      const {
        width: Ve,
        height: Ae
      } = Ee[0].contentRect;
      se.value = Ve, ce.value = Ae;
    });
    function pe(Ee, Ve, Ae) {
      const {
        left: Oe,
        top: Ne,
        width: He,
        height: Ue
      } = Ae;
      de.value = {
        x: clamp(Ee - Oe, 0, He),
        y: clamp(Ve - Ne, 0, Ue)
      };
    }
    function ge(Ee) {
      Ee.type === "mousedown" && Ee.preventDefault(), !re.disabled && (be(Ee), window.addEventListener("mousemove", be), window.addEventListener("mouseup", Se), window.addEventListener("touchmove", be), window.addEventListener("touchend", Se));
    }
    function be(Ee) {
      if (re.disabled || !le.value) return;
      ie.value = !0;
      const Ve = getEventCoordinates(Ee);
      pe(Ve.clientX, Ve.clientY, le.value.getBoundingClientRect());
    }
    function Se() {
      window.removeEventListener("mousemove", be), window.removeEventListener("mouseup", Se), window.removeEventListener("touchmove", be), window.removeEventListener("touchend", Se);
    }
    function Pe() {
      var Ne;
      if (!le.value) return;
      const Ee = le.value, Ve = Ee.getContext("2d");
      if (!Ve) return;
      const Ae = Ve.createLinearGradient(0, 0, Ee.width, 0);
      Ae.addColorStop(0, "hsla(0, 0%, 100%, 1)"), Ae.addColorStop(1, `hsla(${((Ne = re.color) == null ? void 0 : Ne.h) ?? 0}, 100%, 50%, 1)`), Ve.fillStyle = Ae, Ve.fillRect(0, 0, Ee.width, Ee.height);
      const Oe = Ve.createLinearGradient(0, 0, 0, Ee.height);
      Oe.addColorStop(0, "hsla(0, 0%, 0%, 0)"), Oe.addColorStop(1, "hsla(0, 0%, 0%, 1)"), Ve.fillStyle = Oe, Ve.fillRect(0, 0, Ee.width, Ee.height);
    }
    return watch(() => {
      var Ee;
      return (Ee = re.color) == null ? void 0 : Ee.h;
    }, Pe, {
      immediate: !0
    }), watch(() => [se.value, ce.value], (Ee, Ve) => {
      Pe(), ue.value = {
        x: de.value.x * Ee[0] / Ve[0],
        y: de.value.y * Ee[1] / Ve[1]
      };
    }, {
      flush: "post"
    }), watch(() => re.color, () => {
      if (ie.value) {
        ie.value = !1;
        return;
      }
      ue.value = re.color ? {
        x: re.color.s * se.value,
        y: (1 - re.color.v) * ce.value
      } : {
        x: 0,
        y: 0
      };
    }, {
      deep: !0,
      immediate: !0
    }), onMounted(() => Pe()), useRender(() => createVNode("div", {
      ref: fe,
      class: ["v-color-picker-canvas", re.class],
      style: re.style,
      onMousedown: ge,
      onTouchstartPassive: ge
    }, [createVNode("canvas", {
      ref: le,
      width: se.value,
      height: ce.value
    }, null), re.color && createVNode("div", {
      class: ["v-color-picker-canvas__dot", {
        "v-color-picker-canvas__dot--disabled": re.disabled
      }],
      style: me.value
    }, null)])), {};
  }
});
function stripAlpha(re, ne) {
  if (ne) {
    const {
      a: ae,
      ...ie
    } = re;
    return ie;
  }
  return re;
}
function extractColor(re, ne) {
  if (ne == null || typeof ne == "string") {
    const ae = HSVtoHex(re);
    return re.a === 1 ? ae.slice(0, 7) : ae;
  }
  if (typeof ne == "object") {
    let ae;
    return has(ne, ["r", "g", "b"]) ? ae = HSVtoRGB(re) : has(ne, ["h", "s", "l"]) ? ae = HSVtoHSL(re) : has(ne, ["h", "s", "v"]) && (ae = re), stripAlpha(ae, !has(ne, ["a"]) && re.a === 1);
  }
  return re;
}
const nullColor = {
  h: 0,
  s: 0,
  v: 0,
  a: 1
}, rgba = {
  inputProps: {
    type: "number",
    min: 0
  },
  inputs: [{
    label: "R",
    max: 255,
    step: 1,
    getValue: (re) => Math.round(re.r),
    getColor: (re, ne) => ({
      ...re,
      r: Number(ne)
    })
  }, {
    label: "G",
    max: 255,
    step: 1,
    getValue: (re) => Math.round(re.g),
    getColor: (re, ne) => ({
      ...re,
      g: Number(ne)
    })
  }, {
    label: "B",
    max: 255,
    step: 1,
    getValue: (re) => Math.round(re.b),
    getColor: (re, ne) => ({
      ...re,
      b: Number(ne)
    })
  }, {
    label: "A",
    max: 1,
    step: 0.01,
    getValue: (re) => {
      let {
        a: ne
      } = re;
      return ne != null ? Math.round(ne * 100) / 100 : 1;
    },
    getColor: (re, ne) => ({
      ...re,
      a: Number(ne)
    })
  }],
  to: HSVtoRGB,
  from: RGBtoHSV
};
var yr;
const rgb = {
  ...rgba,
  inputs: (yr = rgba.inputs) == null ? void 0 : yr.slice(0, 3)
}, hsla = {
  inputProps: {
    type: "number",
    min: 0
  },
  inputs: [{
    label: "H",
    max: 360,
    step: 1,
    getValue: (re) => Math.round(re.h),
    getColor: (re, ne) => ({
      ...re,
      h: Number(ne)
    })
  }, {
    label: "S",
    max: 1,
    step: 0.01,
    getValue: (re) => Math.round(re.s * 100) / 100,
    getColor: (re, ne) => ({
      ...re,
      s: Number(ne)
    })
  }, {
    label: "L",
    max: 1,
    step: 0.01,
    getValue: (re) => Math.round(re.l * 100) / 100,
    getColor: (re, ne) => ({
      ...re,
      l: Number(ne)
    })
  }, {
    label: "A",
    max: 1,
    step: 0.01,
    getValue: (re) => {
      let {
        a: ne
      } = re;
      return ne != null ? Math.round(ne * 100) / 100 : 1;
    },
    getColor: (re, ne) => ({
      ...re,
      a: Number(ne)
    })
  }],
  to: HSVtoHSL,
  from: HSLtoHSV
}, hsl = {
  ...hsla,
  inputs: hsla.inputs.slice(0, 3)
}, hexa = {
  inputProps: {
    type: "text"
  },
  inputs: [{
    label: "HEXA",
    getValue: (re) => re,
    getColor: (re, ne) => ne
  }],
  to: HSVtoHex,
  from: HexToHSV
}, hex = {
  ...hexa,
  inputs: [{
    label: "HEX",
    getValue: (re) => re.slice(0, 7),
    getColor: (re, ne) => ne
  }]
}, modes = {
  rgb,
  rgba,
  hsl,
  hsla,
  hex,
  hexa
}, VColorPickerInput = (re) => {
  let {
    label: ne,
    ...ae
  } = re;
  return createVNode("div", {
    class: "v-color-picker-edit__input"
  }, [createVNode("input", ae, null), createVNode("span", null, [ne])]);
}, makeVColorPickerEditProps = propsFactory({
  color: Object,
  disabled: Boolean,
  mode: {
    type: String,
    default: "rgba",
    validator: (re) => Object.keys(modes).includes(re)
  },
  modes: {
    type: Array,
    default: () => Object.keys(modes),
    validator: (re) => Array.isArray(re) && re.every((ne) => Object.keys(modes).includes(ne))
  },
  ...makeComponentProps()
}, "VColorPickerEdit"), VColorPickerEdit = defineComponent({
  name: "VColorPickerEdit",
  props: makeVColorPickerEditProps(),
  emits: {
    "update:color": (re) => !0,
    "update:mode": (re) => !0
  },
  setup(re, ne) {
    let {
      emit: ae
    } = ne;
    const ie = computed(() => re.modes.map((se) => ({
      ...modes[se],
      name: se
    }))), le = computed(() => {
      var ue;
      const se = ie.value.find((de) => de.name === re.mode);
      if (!se) return [];
      const ce = re.color ? se.to(re.color) : null;
      return (ue = se.inputs) == null ? void 0 : ue.map((de) => {
        let {
          getValue: me,
          getColor: fe,
          ...pe
        } = de;
        return {
          ...se.inputProps,
          ...pe,
          disabled: re.disabled,
          value: ce && me(ce),
          onChange: (ge) => {
            const be = ge.target;
            be && ae("update:color", se.from(fe(ce ?? se.to(nullColor), be.value)));
          }
        };
      });
    });
    return useRender(() => {
      var se;
      return createVNode("div", {
        class: ["v-color-picker-edit", re.class],
        style: re.style
      }, [(se = le.value) == null ? void 0 : se.map((ce) => createVNode(VColorPickerInput, ce, null)), ie.value.length > 1 && createVNode(VBtn, {
        icon: "$unfold",
        size: "x-small",
        variant: "plain",
        onClick: () => {
          const ce = ie.value.findIndex((ue) => ue.name === re.mode);
          ae("update:mode", ie.value[(ce + 1) % ie.value.length].name);
        }
      }, null)]);
    }), {};
  }
}), VSliderSymbol = Symbol.for("vuetify:v-slider");
function getOffset(re, ne, ae) {
  const ie = ae === "vertical", le = ne.getBoundingClientRect(), se = "touches" in re ? re.touches[0] : re;
  return ie ? se.clientY - (le.top + le.height / 2) : se.clientX - (le.left + le.width / 2);
}
function getPosition(re, ne) {
  return "touches" in re && re.touches.length ? re.touches[0][ne] : "changedTouches" in re && re.changedTouches.length ? re.changedTouches[0][ne] : re[ne];
}
const makeSliderProps = propsFactory({
  disabled: {
    type: Boolean,
    default: null
  },
  error: Boolean,
  readonly: {
    type: Boolean,
    default: null
  },
  max: {
    type: [Number, String],
    default: 100
  },
  min: {
    type: [Number, String],
    default: 0
  },
  step: {
    type: [Number, String],
    default: 0
  },
  thumbColor: String,
  thumbLabel: {
    type: [Boolean, String],
    default: void 0,
    validator: (re) => typeof re == "boolean" || re === "always"
  },
  thumbSize: {
    type: [Number, String],
    default: 20
  },
  showTicks: {
    type: [Boolean, String],
    default: !1,
    validator: (re) => typeof re == "boolean" || re === "always"
  },
  ticks: {
    type: [Array, Object]
  },
  tickSize: {
    type: [Number, String],
    default: 2
  },
  color: String,
  trackColor: String,
  trackFillColor: String,
  trackSize: {
    type: [Number, String],
    default: 4
  },
  direction: {
    type: String,
    default: "horizontal",
    validator: (re) => ["vertical", "horizontal"].includes(re)
  },
  reverse: Boolean,
  ...makeRoundedProps(),
  ...makeElevationProps({
    elevation: 2
  }),
  ripple: {
    type: Boolean,
    default: !0
  }
}, "Slider"), useSteps = (re) => {
  const ne = computed(() => parseFloat(re.min)), ae = computed(() => parseFloat(re.max)), ie = computed(() => Number(re.step) > 0 ? parseFloat(re.step) : 0), le = computed(() => Math.max(getDecimals(ie.value), getDecimals(ne.value)));
  function se(ce) {
    if (ce = parseFloat(ce), ie.value <= 0) return ce;
    const ue = clamp(ce, ne.value, ae.value), de = ne.value % ie.value, me = Math.round((ue - de) / ie.value) * ie.value + de;
    return parseFloat(Math.min(me, ae.value).toFixed(le.value));
  }
  return {
    min: ne,
    max: ae,
    step: ie,
    decimals: le,
    roundValue: se
  };
}, useSlider = (re) => {
  let {
    props: ne,
    steps: ae,
    onSliderStart: ie,
    onSliderMove: le,
    onSliderEnd: se,
    getActiveThumb: ce
  } = re;
  const {
    isRtl: ue
  } = useRtl(), de = toRef(ne, "reverse"), me = computed(() => ne.direction === "vertical"), fe = computed(() => me.value !== de.value), {
    min: pe,
    max: ge,
    step: be,
    decimals: Se,
    roundValue: Pe
  } = ae, Ee = computed(() => parseInt(ne.thumbSize, 10)), Ve = computed(() => parseInt(ne.tickSize, 10)), Ae = computed(() => parseInt(ne.trackSize, 10)), Oe = computed(() => (ge.value - pe.value) / be.value), Ne = toRef(ne, "disabled"), He = computed(() => ne.error || ne.disabled ? void 0 : ne.thumbColor ?? ne.color), Ue = computed(() => ne.error || ne.disabled ? void 0 : ne.trackColor ?? ne.color), Ze = computed(() => ne.error || ne.disabled ? void 0 : ne.trackFillColor ?? ne.color), Fe = shallowRef(!1), Ke = shallowRef(0), tt = ref$1(), Re = ref$1();
  function Ce(Ye) {
    var ot;
    const De = (ot = tt.value) == null ? void 0 : ot.$el;
    if (!De) return;
    const je = ne.direction === "vertical", rt = je ? "top" : "left", at = je ? "height" : "width", qe = je ? "clientY" : "clientX", {
      [rt]: We,
      [at]: ze
    } = De.getBoundingClientRect(), Ge = getPosition(Ye, qe);
    let nt = Math.min(Math.max((Ge - We - Ke.value) / ze, 0), 1) || 0;
    return (je ? fe.value : fe.value !== ue.value) && (nt = 1 - nt), Pe(pe.value + nt * (ge.value - pe.value));
  }
  const _e = (Ye) => {
    const De = Ce(Ye);
    De != null && se({
      value: De
    }), Fe.value = !1, Ke.value = 0;
  }, he = (Ye) => {
    const De = Ce(Ye);
    Re.value = ce(Ye), Re.value && (Fe.value = !0, Re.value.contains(Ye.target) ? Ke.value = getOffset(Ye, Re.value, ne.direction) : (Ke.value = 0, De != null && le({
      value: De
    })), De != null && ie({
      value: De
    }), nextTick$2(() => {
      var je;
      return (je = Re.value) == null ? void 0 : je.focus();
    }));
  }, ve = {
    passive: !0,
    capture: !0
  };
  function xe(Ye) {
    const De = Ce(Ye);
    De != null && le({
      value: De
    });
  }
  function $e(Ye) {
    Ye.stopPropagation(), Ye.preventDefault(), _e(Ye), window.removeEventListener("mousemove", xe, ve), window.removeEventListener("mouseup", $e);
  }
  function Te(Ye) {
    var De;
    _e(Ye), window.removeEventListener("touchmove", xe, ve), (De = Ye.target) == null || De.removeEventListener("touchend", Te);
  }
  function Ie(Ye) {
    var De;
    he(Ye), window.addEventListener("touchmove", xe, ve), (De = Ye.target) == null || De.addEventListener("touchend", Te, {
      passive: !1
    });
  }
  function we(Ye) {
    Ye.button === 0 && (Ye.preventDefault(), he(Ye), window.addEventListener("mousemove", xe, ve), window.addEventListener("mouseup", $e, {
      passive: !1
    }));
  }
  const ke = (Ye) => {
    const De = (Ye - pe.value) / (ge.value - pe.value) * 100;
    return clamp(isNaN(De) ? 0 : De, 0, 100);
  }, ye = toRef(ne, "showTicks"), Be = computed(() => ye.value ? ne.ticks ? Array.isArray(ne.ticks) ? ne.ticks.map((Ye) => ({
    value: Ye,
    position: ke(Ye),
    label: Ye.toString()
  })) : Object.keys(ne.ticks).map((Ye) => ({
    value: parseFloat(Ye),
    position: ke(parseFloat(Ye)),
    label: ne.ticks[Ye]
  })) : Oe.value !== 1 / 0 ? createRange(Oe.value + 1).map((Ye) => {
    const De = pe.value + Ye * be.value;
    return {
      value: De,
      position: ke(De)
    };
  }) : [] : []), Xe = computed(() => Be.value.some((Ye) => {
    let {
      label: De
    } = Ye;
    return !!De;
  })), et = {
    activeThumbRef: Re,
    color: toRef(ne, "color"),
    decimals: Se,
    disabled: Ne,
    direction: toRef(ne, "direction"),
    elevation: toRef(ne, "elevation"),
    hasLabels: Xe,
    isReversed: de,
    indexFromEnd: fe,
    min: pe,
    max: ge,
    mousePressed: Fe,
    numTicks: Oe,
    onSliderMousedown: we,
    onSliderTouchstart: Ie,
    parsedTicks: Be,
    parseMouseMove: Ce,
    position: ke,
    readonly: toRef(ne, "readonly"),
    rounded: toRef(ne, "rounded"),
    roundValue: Pe,
    showTicks: ye,
    startOffset: Ke,
    step: be,
    thumbSize: Ee,
    thumbColor: He,
    thumbLabel: toRef(ne, "thumbLabel"),
    ticks: toRef(ne, "ticks"),
    tickSize: Ve,
    trackColor: Ue,
    trackContainerRef: tt,
    trackFillColor: Ze,
    trackSize: Ae,
    vertical: me
  };
  return provide(VSliderSymbol, et), et;
}, makeVSliderThumbProps = propsFactory({
  focused: Boolean,
  max: {
    type: Number,
    required: !0
  },
  min: {
    type: Number,
    required: !0
  },
  modelValue: {
    type: Number,
    required: !0
  },
  position: {
    type: Number,
    required: !0
  },
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  name: String,
  ...makeComponentProps()
}, "VSliderThumb"), VSliderThumb = genericComponent()({
  name: "VSliderThumb",
  directives: {
    Ripple
  },
  props: makeVSliderThumbProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae,
      emit: ie
    } = ne;
    const le = inject(VSliderSymbol), {
      isRtl: se,
      rtlClasses: ce
    } = useRtl();
    if (!le) throw new Error("[Vuetify] v-slider-thumb must be used inside v-slider or v-range-slider");
    const {
      thumbColor: ue,
      step: de,
      disabled: me,
      thumbSize: fe,
      thumbLabel: pe,
      direction: ge,
      isReversed: be,
      vertical: Se,
      readonly: Pe,
      elevation: Ee,
      mousePressed: Ve,
      decimals: Ae,
      indexFromEnd: Oe
    } = le, Ne = computed(() => me.value ? void 0 : Ee.value), {
      elevationClasses: He
    } = useElevation(Ne), {
      textColorClasses: Ue,
      textColorStyles: Ze
    } = useTextColor(ue), {
      pageup: Fe,
      pagedown: Ke,
      end: tt,
      home: Re,
      left: Ce,
      right: _e,
      down: he,
      up: ve
    } = keyValues, xe = [Fe, Ke, tt, Re, Ce, _e, he, ve], $e = computed(() => de.value ? [1, 2, 3] : [1, 5, 10]);
    function Te(we, ke) {
      if (!xe.includes(we.key)) return;
      we.preventDefault();
      const ye = de.value || 0.1, Be = (re.max - re.min) / ye;
      if ([Ce, _e, he, ve].includes(we.key)) {
        const et = (Se.value ? [se.value ? Ce : _e, be.value ? he : ve] : Oe.value !== se.value ? [Ce, ve] : [_e, ve]).includes(we.key) ? 1 : -1, Ye = we.shiftKey ? 2 : we.ctrlKey ? 1 : 0;
        ke = ke + et * ye * $e.value[Ye];
      } else if (we.key === Re)
        ke = re.min;
      else if (we.key === tt)
        ke = re.max;
      else {
        const Xe = we.key === Ke ? 1 : -1;
        ke = ke - Xe * ye * (Be > 100 ? Be / 10 : 10);
      }
      return Math.max(re.min, Math.min(re.max, ke));
    }
    function Ie(we) {
      const ke = Te(we, re.modelValue);
      ke != null && ie("update:modelValue", ke);
    }
    return useRender(() => {
      const we = convertToUnit(Oe.value ? 100 - re.position : re.position, "%");
      return createVNode("div", {
        class: ["v-slider-thumb", {
          "v-slider-thumb--focused": re.focused,
          "v-slider-thumb--pressed": re.focused && Ve.value
        }, re.class, ce.value],
        style: [{
          "--v-slider-thumb-position": we,
          "--v-slider-thumb-size": convertToUnit(fe.value)
        }, re.style],
        role: "slider",
        tabindex: me.value ? -1 : 0,
        "aria-label": re.name,
        "aria-valuemin": re.min,
        "aria-valuemax": re.max,
        "aria-valuenow": re.modelValue,
        "aria-readonly": !!Pe.value,
        "aria-orientation": ge.value,
        onKeydown: Pe.value ? void 0 : Ie
      }, [createVNode("div", {
        class: ["v-slider-thumb__surface", Ue.value, He.value],
        style: {
          ...Ze.value
        }
      }, null), withDirectives(createVNode("div", {
        class: ["v-slider-thumb__ripple", Ue.value],
        style: Ze.value
      }, null), [[resolveDirective("ripple"), re.ripple, null, {
        circle: !0,
        center: !0
      }]]), createVNode(VScaleTransition, {
        origin: "bottom center"
      }, {
        default: () => {
          var ke;
          return [withDirectives(createVNode("div", {
            class: "v-slider-thumb__label-container"
          }, [createVNode("div", {
            class: ["v-slider-thumb__label"]
          }, [createVNode("div", null, [((ke = ae["thumb-label"]) == null ? void 0 : ke.call(ae, {
            modelValue: re.modelValue
          })) ?? re.modelValue.toFixed(de.value ? Ae.value : 1)])])]), [[vShow, pe.value && re.focused || pe.value === "always"]])];
        }
      })]);
    }), {};
  }
}), makeVSliderTrackProps = propsFactory({
  start: {
    type: Number,
    required: !0
  },
  stop: {
    type: Number,
    required: !0
  },
  ...makeComponentProps()
}, "VSliderTrack"), VSliderTrack = genericComponent()({
  name: "VSliderTrack",
  props: makeVSliderTrackProps(),
  emits: {},
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = inject(VSliderSymbol);
    if (!ie) throw new Error("[Vuetify] v-slider-track must be inside v-slider or v-range-slider");
    const {
      color: le,
      parsedTicks: se,
      rounded: ce,
      showTicks: ue,
      tickSize: de,
      trackColor: me,
      trackFillColor: fe,
      trackSize: pe,
      vertical: ge,
      min: be,
      max: Se,
      indexFromEnd: Pe
    } = ie, {
      roundedClasses: Ee
    } = useRounded(ce), {
      backgroundColorClasses: Ve,
      backgroundColorStyles: Ae
    } = useBackgroundColor(fe), {
      backgroundColorClasses: Oe,
      backgroundColorStyles: Ne
    } = useBackgroundColor(me), He = computed(() => `inset-${ge.value ? "block" : "inline"}-${Pe.value ? "end" : "start"}`), Ue = computed(() => ge.value ? "height" : "width"), Ze = computed(() => ({
      [He.value]: "0%",
      [Ue.value]: "100%"
    })), Fe = computed(() => re.stop - re.start), Ke = computed(() => ({
      [He.value]: convertToUnit(re.start, "%"),
      [Ue.value]: convertToUnit(Fe.value, "%")
    })), tt = computed(() => ue.value ? (ge.value ? se.value.slice().reverse() : se.value).map((Ce, _e) => {
      var ve;
      const he = Ce.value !== be.value && Ce.value !== Se.value ? convertToUnit(Ce.position, "%") : void 0;
      return createVNode("div", {
        key: Ce.value,
        class: ["v-slider-track__tick", {
          "v-slider-track__tick--filled": Ce.position >= re.start && Ce.position <= re.stop,
          "v-slider-track__tick--first": Ce.value === be.value,
          "v-slider-track__tick--last": Ce.value === Se.value
        }],
        style: {
          [He.value]: he
        }
      }, [(Ce.label || ae["tick-label"]) && createVNode("div", {
        class: "v-slider-track__tick-label"
      }, [((ve = ae["tick-label"]) == null ? void 0 : ve.call(ae, {
        tick: Ce,
        index: _e
      })) ?? Ce.label])]);
    }) : []);
    return useRender(() => createVNode("div", {
      class: ["v-slider-track", Ee.value, re.class],
      style: [{
        "--v-slider-track-size": convertToUnit(pe.value),
        "--v-slider-tick-size": convertToUnit(de.value)
      }, re.style]
    }, [createVNode("div", {
      class: ["v-slider-track__background", Oe.value, {
        "v-slider-track__background--opacity": !!le.value || !fe.value
      }],
      style: {
        ...Ze.value,
        ...Ne.value
      }
    }, null), createVNode("div", {
      class: ["v-slider-track__fill", Ve.value],
      style: {
        ...Ke.value,
        ...Ae.value
      }
    }, null), ue.value && createVNode("div", {
      class: ["v-slider-track__ticks", {
        "v-slider-track__ticks--always-show": ue.value === "always"
      }]
    }, [tt.value])])), {};
  }
}), makeVSliderProps = propsFactory({
  ...makeFocusProps(),
  ...makeSliderProps(),
  ...makeVInputProps(),
  modelValue: {
    type: [Number, String],
    default: 0
  }
}, "VSlider"), VSlider = genericComponent()({
  name: "VSlider",
  props: makeVSliderProps(),
  emits: {
    "update:focused": (re) => !0,
    "update:modelValue": (re) => !0,
    start: (re) => !0,
    end: (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae,
      emit: ie
    } = ne;
    const le = ref$1(), {
      rtlClasses: se
    } = useRtl(), ce = useSteps(re), ue = useProxiedModel(re, "modelValue", void 0, (Ue) => ce.roundValue(Ue ?? ce.min.value)), {
      min: de,
      max: me,
      mousePressed: fe,
      roundValue: pe,
      onSliderMousedown: ge,
      onSliderTouchstart: be,
      trackContainerRef: Se,
      position: Pe,
      hasLabels: Ee,
      readonly: Ve
    } = useSlider({
      props: re,
      steps: ce,
      onSliderStart: () => {
        ie("start", ue.value);
      },
      onSliderEnd: (Ue) => {
        let {
          value: Ze
        } = Ue;
        const Fe = pe(Ze);
        ue.value = Fe, ie("end", Fe);
      },
      onSliderMove: (Ue) => {
        let {
          value: Ze
        } = Ue;
        return ue.value = pe(Ze);
      },
      getActiveThumb: () => {
        var Ue;
        return (Ue = le.value) == null ? void 0 : Ue.$el;
      }
    }), {
      isFocused: Ae,
      focus: Oe,
      blur: Ne
    } = useFocus(re), He = computed(() => Pe(ue.value));
    return useRender(() => {
      const Ue = VInput.filterProps(re), Ze = !!(re.label || ae.label || ae.prepend);
      return createVNode(VInput, mergeProps({
        class: ["v-slider", {
          "v-slider--has-labels": !!ae["tick-label"] || Ee.value,
          "v-slider--focused": Ae.value,
          "v-slider--pressed": fe.value,
          "v-slider--disabled": re.disabled
        }, se.value, re.class],
        style: re.style
      }, Ue, {
        focused: Ae.value
      }), {
        ...ae,
        prepend: Ze ? (Fe) => {
          var Ke, tt;
          return createVNode(Fragment, null, [((Ke = ae.label) == null ? void 0 : Ke.call(ae, Fe)) ?? (re.label ? createVNode(VLabel, {
            id: Fe.id.value,
            class: "v-slider__label",
            text: re.label
          }, null) : void 0), (tt = ae.prepend) == null ? void 0 : tt.call(ae, Fe)]);
        } : void 0,
        default: (Fe) => {
          let {
            id: Ke,
            messagesId: tt
          } = Fe;
          return createVNode("div", {
            class: "v-slider__container",
            onMousedown: Ve.value ? void 0 : ge,
            onTouchstartPassive: Ve.value ? void 0 : be
          }, [createVNode("input", {
            id: Ke.value,
            name: re.name || Ke.value,
            disabled: !!re.disabled,
            readonly: !!re.readonly,
            tabindex: "-1",
            value: ue.value
          }, null), createVNode(VSliderTrack, {
            ref: Se,
            start: 0,
            stop: He.value
          }, {
            "tick-label": ae["tick-label"]
          }), createVNode(VSliderThumb, {
            ref: le,
            "aria-describedby": tt.value,
            focused: Ae.value,
            min: de.value,
            max: me.value,
            modelValue: ue.value,
            "onUpdate:modelValue": (Re) => ue.value = Re,
            position: He.value,
            elevation: re.elevation,
            onFocus: Oe,
            onBlur: Ne,
            ripple: re.ripple,
            name: re.name
          }, {
            "thumb-label": ae["thumb-label"]
          })]);
        }
      });
    }), {};
  }
}), makeVColorPickerPreviewProps = propsFactory({
  color: {
    type: Object
  },
  disabled: Boolean,
  hideAlpha: Boolean,
  ...makeComponentProps()
}, "VColorPickerPreview"), VColorPickerPreview = defineComponent({
  name: "VColorPickerPreview",
  props: makeVColorPickerPreviewProps(),
  emits: {
    "update:color": (re) => !0
  },
  setup(re, ne) {
    let {
      emit: ae
    } = ne;
    const ie = new AbortController();
    onUnmounted(() => ie.abort());
    async function le() {
      if (!SUPPORTS_EYE_DROPPER) return;
      const se = new window.EyeDropper();
      try {
        const ce = await se.open({
          signal: ie.signal
        }), ue = RGBtoHSV(parseColor(ce.sRGBHex));
        ae("update:color", {
          ...re.color ?? nullColor,
          ...ue
        });
      } catch {
      }
    }
    return useRender(() => {
      var se, ce;
      return createVNode("div", {
        class: ["v-color-picker-preview", {
          "v-color-picker-preview--hide-alpha": re.hideAlpha
        }, re.class],
        style: re.style
      }, [SUPPORTS_EYE_DROPPER && createVNode("div", {
        class: "v-color-picker-preview__eye-dropper",
        key: "eyeDropper"
      }, [createVNode(VBtn, {
        onClick: le,
        icon: "$eyeDropper",
        variant: "plain",
        density: "comfortable"
      }, null)]), createVNode("div", {
        class: "v-color-picker-preview__dot"
      }, [createVNode("div", {
        style: {
          background: HSVtoCSS(re.color ?? nullColor)
        }
      }, null)]), createVNode("div", {
        class: "v-color-picker-preview__sliders"
      }, [createVNode(VSlider, {
        class: "v-color-picker-preview__track v-color-picker-preview__hue",
        modelValue: (se = re.color) == null ? void 0 : se.h,
        "onUpdate:modelValue": (ue) => ae("update:color", {
          ...re.color ?? nullColor,
          h: ue
        }),
        step: 0,
        min: 0,
        max: 360,
        disabled: re.disabled,
        thumbSize: 14,
        trackSize: 8,
        trackFillColor: "white",
        hideDetails: !0
      }, null), !re.hideAlpha && createVNode(VSlider, {
        class: "v-color-picker-preview__track v-color-picker-preview__alpha",
        modelValue: ((ce = re.color) == null ? void 0 : ce.a) ?? 1,
        "onUpdate:modelValue": (ue) => ae("update:color", {
          ...re.color ?? nullColor,
          a: ue
        }),
        step: 1 / 256,
        min: 0,
        max: 1,
        disabled: re.disabled,
        thumbSize: 14,
        trackSize: 8,
        trackFillColor: "white",
        hideDetails: !0
      }, null)])]);
    }), {};
  }
}), red = {
  base: "#f44336",
  lighten5: "#ffebee",
  lighten4: "#ffcdd2",
  lighten3: "#ef9a9a",
  lighten2: "#e57373",
  lighten1: "#ef5350",
  darken1: "#e53935",
  darken2: "#d32f2f",
  darken3: "#c62828",
  darken4: "#b71c1c",
  accent1: "#ff8a80",
  accent2: "#ff5252",
  accent3: "#ff1744",
  accent4: "#d50000"
}, pink = {
  base: "#e91e63",
  lighten5: "#fce4ec",
  lighten4: "#f8bbd0",
  lighten3: "#f48fb1",
  lighten2: "#f06292",
  lighten1: "#ec407a",
  darken1: "#d81b60",
  darken2: "#c2185b",
  darken3: "#ad1457",
  darken4: "#880e4f",
  accent1: "#ff80ab",
  accent2: "#ff4081",
  accent3: "#f50057",
  accent4: "#c51162"
}, purple = {
  base: "#9c27b0",
  lighten5: "#f3e5f5",
  lighten4: "#e1bee7",
  lighten3: "#ce93d8",
  lighten2: "#ba68c8",
  lighten1: "#ab47bc",
  darken1: "#8e24aa",
  darken2: "#7b1fa2",
  darken3: "#6a1b9a",
  darken4: "#4a148c",
  accent1: "#ea80fc",
  accent2: "#e040fb",
  accent3: "#d500f9",
  accent4: "#aa00ff"
}, deepPurple = {
  base: "#673ab7",
  lighten5: "#ede7f6",
  lighten4: "#d1c4e9",
  lighten3: "#b39ddb",
  lighten2: "#9575cd",
  lighten1: "#7e57c2",
  darken1: "#5e35b1",
  darken2: "#512da8",
  darken3: "#4527a0",
  darken4: "#311b92",
  accent1: "#b388ff",
  accent2: "#7c4dff",
  accent3: "#651fff",
  accent4: "#6200ea"
}, indigo = {
  base: "#3f51b5",
  lighten5: "#e8eaf6",
  lighten4: "#c5cae9",
  lighten3: "#9fa8da",
  lighten2: "#7986cb",
  lighten1: "#5c6bc0",
  darken1: "#3949ab",
  darken2: "#303f9f",
  darken3: "#283593",
  darken4: "#1a237e",
  accent1: "#8c9eff",
  accent2: "#536dfe",
  accent3: "#3d5afe",
  accent4: "#304ffe"
}, blue = {
  base: "#2196f3",
  lighten5: "#e3f2fd",
  lighten4: "#bbdefb",
  lighten3: "#90caf9",
  lighten2: "#64b5f6",
  lighten1: "#42a5f5",
  darken1: "#1e88e5",
  darken2: "#1976d2",
  darken3: "#1565c0",
  darken4: "#0d47a1",
  accent1: "#82b1ff",
  accent2: "#448aff",
  accent3: "#2979ff",
  accent4: "#2962ff"
}, lightBlue = {
  base: "#03a9f4",
  lighten5: "#e1f5fe",
  lighten4: "#b3e5fc",
  lighten3: "#81d4fa",
  lighten2: "#4fc3f7",
  lighten1: "#29b6f6",
  darken1: "#039be5",
  darken2: "#0288d1",
  darken3: "#0277bd",
  darken4: "#01579b",
  accent1: "#80d8ff",
  accent2: "#40c4ff",
  accent3: "#00b0ff",
  accent4: "#0091ea"
}, cyan = {
  base: "#00bcd4",
  lighten5: "#e0f7fa",
  lighten4: "#b2ebf2",
  lighten3: "#80deea",
  lighten2: "#4dd0e1",
  lighten1: "#26c6da",
  darken1: "#00acc1",
  darken2: "#0097a7",
  darken3: "#00838f",
  darken4: "#006064",
  accent1: "#84ffff",
  accent2: "#18ffff",
  accent3: "#00e5ff",
  accent4: "#00b8d4"
}, teal = {
  base: "#009688",
  lighten5: "#e0f2f1",
  lighten4: "#b2dfdb",
  lighten3: "#80cbc4",
  lighten2: "#4db6ac",
  lighten1: "#26a69a",
  darken1: "#00897b",
  darken2: "#00796b",
  darken3: "#00695c",
  darken4: "#004d40",
  accent1: "#a7ffeb",
  accent2: "#64ffda",
  accent3: "#1de9b6",
  accent4: "#00bfa5"
}, green = {
  base: "#4caf50",
  lighten5: "#e8f5e9",
  lighten4: "#c8e6c9",
  lighten3: "#a5d6a7",
  lighten2: "#81c784",
  lighten1: "#66bb6a",
  darken1: "#43a047",
  darken2: "#388e3c",
  darken3: "#2e7d32",
  darken4: "#1b5e20",
  accent1: "#b9f6ca",
  accent2: "#69f0ae",
  accent3: "#00e676",
  accent4: "#00c853"
}, lightGreen = {
  base: "#8bc34a",
  lighten5: "#f1f8e9",
  lighten4: "#dcedc8",
  lighten3: "#c5e1a5",
  lighten2: "#aed581",
  lighten1: "#9ccc65",
  darken1: "#7cb342",
  darken2: "#689f38",
  darken3: "#558b2f",
  darken4: "#33691e",
  accent1: "#ccff90",
  accent2: "#b2ff59",
  accent3: "#76ff03",
  accent4: "#64dd17"
}, lime = {
  base: "#cddc39",
  lighten5: "#f9fbe7",
  lighten4: "#f0f4c3",
  lighten3: "#e6ee9c",
  lighten2: "#dce775",
  lighten1: "#d4e157",
  darken1: "#c0ca33",
  darken2: "#afb42b",
  darken3: "#9e9d24",
  darken4: "#827717",
  accent1: "#f4ff81",
  accent2: "#eeff41",
  accent3: "#c6ff00",
  accent4: "#aeea00"
}, yellow = {
  base: "#ffeb3b",
  lighten5: "#fffde7",
  lighten4: "#fff9c4",
  lighten3: "#fff59d",
  lighten2: "#fff176",
  lighten1: "#ffee58",
  darken1: "#fdd835",
  darken2: "#fbc02d",
  darken3: "#f9a825",
  darken4: "#f57f17",
  accent1: "#ffff8d",
  accent2: "#ffff00",
  accent3: "#ffea00",
  accent4: "#ffd600"
}, amber = {
  base: "#ffc107",
  lighten5: "#fff8e1",
  lighten4: "#ffecb3",
  lighten3: "#ffe082",
  lighten2: "#ffd54f",
  lighten1: "#ffca28",
  darken1: "#ffb300",
  darken2: "#ffa000",
  darken3: "#ff8f00",
  darken4: "#ff6f00",
  accent1: "#ffe57f",
  accent2: "#ffd740",
  accent3: "#ffc400",
  accent4: "#ffab00"
}, orange = {
  base: "#ff9800",
  lighten5: "#fff3e0",
  lighten4: "#ffe0b2",
  lighten3: "#ffcc80",
  lighten2: "#ffb74d",
  lighten1: "#ffa726",
  darken1: "#fb8c00",
  darken2: "#f57c00",
  darken3: "#ef6c00",
  darken4: "#e65100",
  accent1: "#ffd180",
  accent2: "#ffab40",
  accent3: "#ff9100",
  accent4: "#ff6d00"
}, deepOrange = {
  base: "#ff5722",
  lighten5: "#fbe9e7",
  lighten4: "#ffccbc",
  lighten3: "#ffab91",
  lighten2: "#ff8a65",
  lighten1: "#ff7043",
  darken1: "#f4511e",
  darken2: "#e64a19",
  darken3: "#d84315",
  darken4: "#bf360c",
  accent1: "#ff9e80",
  accent2: "#ff6e40",
  accent3: "#ff3d00",
  accent4: "#dd2c00"
}, brown = {
  base: "#795548",
  lighten5: "#efebe9",
  lighten4: "#d7ccc8",
  lighten3: "#bcaaa4",
  lighten2: "#a1887f",
  lighten1: "#8d6e63",
  darken1: "#6d4c41",
  darken2: "#5d4037",
  darken3: "#4e342e",
  darken4: "#3e2723"
}, blueGrey = {
  base: "#607d8b",
  lighten5: "#eceff1",
  lighten4: "#cfd8dc",
  lighten3: "#b0bec5",
  lighten2: "#90a4ae",
  lighten1: "#78909c",
  darken1: "#546e7a",
  darken2: "#455a64",
  darken3: "#37474f",
  darken4: "#263238"
}, grey = {
  base: "#9e9e9e",
  lighten5: "#fafafa",
  lighten4: "#f5f5f5",
  lighten3: "#eeeeee",
  lighten2: "#e0e0e0",
  lighten1: "#bdbdbd",
  darken1: "#757575",
  darken2: "#616161",
  darken3: "#424242",
  darken4: "#212121"
}, shades = {
  black: "#000000",
  white: "#ffffff",
  transparent: "#ffffff00"
}, colors = {
  red,
  pink,
  purple,
  deepPurple,
  indigo,
  blue,
  lightBlue,
  cyan,
  teal,
  green,
  lightGreen,
  lime,
  yellow,
  amber,
  orange,
  deepOrange,
  brown,
  blueGrey,
  grey,
  shades
}, makeVColorPickerSwatchesProps = propsFactory({
  swatches: {
    type: Array,
    default: () => parseDefaultColors(colors)
  },
  disabled: Boolean,
  color: Object,
  maxHeight: [Number, String],
  ...makeComponentProps()
}, "VColorPickerSwatches");
function parseDefaultColors(re) {
  return Object.keys(re).map((ne) => {
    const ae = re[ne];
    return ae.base ? [ae.base, ae.darken4, ae.darken3, ae.darken2, ae.darken1, ae.lighten1, ae.lighten2, ae.lighten3, ae.lighten4, ae.lighten5] : [ae.black, ae.white, ae.transparent];
  });
}
const VColorPickerSwatches = defineComponent({
  name: "VColorPickerSwatches",
  props: makeVColorPickerSwatchesProps(),
  emits: {
    "update:color": (re) => !0
  },
  setup(re, ne) {
    let {
      emit: ae
    } = ne;
    return useRender(() => createVNode("div", {
      class: ["v-color-picker-swatches", re.class],
      style: [{
        maxHeight: convertToUnit(re.maxHeight)
      }, re.style]
    }, [createVNode("div", null, [re.swatches.map((ie) => createVNode("div", {
      class: "v-color-picker-swatches__swatch"
    }, [ie.map((le) => {
      const se = parseColor(le), ce = RGBtoHSV(se), ue = RGBtoCSS(se);
      return createVNode("div", {
        class: "v-color-picker-swatches__color",
        onClick: () => ce && ae("update:color", ce)
      }, [createVNode("div", {
        style: {
          background: ue
        }
      }, [re.color && deepEqual(re.color, ce) ? createVNode(VIcon, {
        size: "x-small",
        icon: "$success",
        color: getContrast(le, "#FFFFFF") > 2 ? "white" : "black"
      }, null) : void 0])]);
    })]))])])), {};
  }
}), makeVColorPickerProps = propsFactory({
  canvasHeight: {
    type: [String, Number],
    default: 150
  },
  disabled: Boolean,
  dotSize: {
    type: [Number, String],
    default: 10
  },
  hideCanvas: Boolean,
  hideSliders: Boolean,
  hideInputs: Boolean,
  mode: {
    type: String,
    default: "rgba",
    validator: (re) => Object.keys(modes).includes(re)
  },
  modes: {
    type: Array,
    default: () => Object.keys(modes),
    validator: (re) => Array.isArray(re) && re.every((ne) => Object.keys(modes).includes(ne))
  },
  showSwatches: Boolean,
  swatches: Array,
  swatchesMaxHeight: {
    type: [Number, String],
    default: 150
  },
  modelValue: {
    type: [Object, String]
  },
  ...omit(makeVSheetProps({
    width: 300
  }), ["height", "location", "minHeight", "maxHeight", "minWidth", "maxWidth"])
}, "VColorPicker"), VColorPicker = defineComponent({
  name: "VColorPicker",
  props: makeVColorPickerProps(),
  emits: {
    "update:modelValue": (re) => !0,
    "update:mode": (re) => !0
  },
  setup(re) {
    const ne = useProxiedModel(re, "mode"), ae = ref$1(null), ie = useProxiedModel(re, "modelValue", void 0, (de) => {
      if (de == null || de === "") return null;
      let me;
      try {
        me = RGBtoHSV(parseColor(de));
      } catch (fe) {
        return consoleWarn(fe), null;
      }
      return me;
    }, (de) => de ? extractColor(de, re.modelValue) : null), le = computed(() => ie.value ? {
      ...ie.value,
      h: ae.value ?? ie.value.h
    } : null), {
      rtlClasses: se
    } = useRtl();
    let ce = !0;
    watch(ie, (de) => {
      if (!ce) {
        ce = !0;
        return;
      }
      de && (ae.value = de.h);
    }, {
      immediate: !0
    });
    const ue = (de) => {
      ce = !1, ae.value = de.h, ie.value = de;
    };
    return onBeforeMount(() => {
      re.modes.includes(ne.value) || (ne.value = re.modes[0]);
    }), provideDefaults({
      VSlider: {
        color: void 0,
        trackColor: void 0,
        trackFillColor: void 0
      }
    }), useRender(() => {
      const de = VSheet.filterProps(re);
      return createVNode(VSheet, mergeProps({
        rounded: re.rounded,
        elevation: re.elevation,
        theme: re.theme,
        class: ["v-color-picker", se.value, re.class],
        style: [{
          "--v-color-picker-color-hsv": HSVtoCSS({
            ...le.value ?? nullColor,
            a: 1
          })
        }, re.style]
      }, de, {
        maxWidth: re.width
      }), {
        default: () => [!re.hideCanvas && createVNode(VColorPickerCanvas, {
          key: "canvas",
          color: le.value,
          "onUpdate:color": ue,
          disabled: re.disabled,
          dotSize: re.dotSize,
          width: re.width,
          height: re.canvasHeight
        }, null), (!re.hideSliders || !re.hideInputs) && createVNode("div", {
          key: "controls",
          class: "v-color-picker__controls"
        }, [!re.hideSliders && createVNode(VColorPickerPreview, {
          key: "preview",
          color: le.value,
          "onUpdate:color": ue,
          hideAlpha: !ne.value.endsWith("a"),
          disabled: re.disabled
        }, null), !re.hideInputs && createVNode(VColorPickerEdit, {
          key: "edit",
          modes: re.modes,
          mode: ne.value,
          "onUpdate:mode": (me) => ne.value = me,
          color: le.value,
          "onUpdate:color": ue,
          disabled: re.disabled
        }, null)]), re.showSwatches && createVNode(VColorPickerSwatches, {
          key: "swatches",
          color: le.value,
          "onUpdate:color": ue,
          maxHeight: re.swatchesMaxHeight,
          swatches: re.swatches,
          disabled: re.disabled
        }, null)]
      });
    }), {};
  }
});
function highlightResult(re, ne, ae) {
  if (ne == null) return re;
  if (Array.isArray(ne)) throw new Error("Multiple matches is not implemented");
  return typeof ne == "number" && ~ne ? createVNode(Fragment, null, [createVNode("span", {
    class: "v-combobox__unmask"
  }, [re.substr(0, ne)]), createVNode("span", {
    class: "v-combobox__mask"
  }, [re.substr(ne, ae)]), createVNode("span", {
    class: "v-combobox__unmask"
  }, [re.substr(ne + ae)])]) : re;
}
const makeVComboboxProps = propsFactory({
  autoSelectFirst: {
    type: [Boolean, String]
  },
  clearOnSelect: {
    type: Boolean,
    default: !0
  },
  delimiters: Array,
  ...makeFilterProps({
    filterKeys: ["title"]
  }),
  ...makeSelectProps({
    hideNoData: !0,
    returnObject: !0
  }),
  ...omit(makeVTextFieldProps({
    modelValue: null,
    role: "combobox"
  }), ["validationValue", "dirty", "appendInnerIcon"]),
  ...makeTransitionProps({
    transition: !1
  })
}, "VCombobox"), VCombobox = genericComponent()({
  name: "VCombobox",
  props: makeVComboboxProps(),
  emits: {
    "update:focused": (re) => !0,
    "update:modelValue": (re) => !0,
    "update:search": (re) => !0,
    "update:menu": (re) => !0
  },
  setup(re, ne) {
    var We;
    let {
      emit: ae,
      slots: ie
    } = ne;
    const {
      t: le
    } = useLocale(), se = ref$1(), ce = shallowRef(!1), ue = shallowRef(!0), de = shallowRef(!1), me = ref$1(), fe = ref$1(), pe = useProxiedModel(re, "menu"), ge = computed({
      get: () => pe.value,
      set: (ze) => {
        var Ge;
        pe.value && !ze && ((Ge = me.value) != null && Ge.ΨopenChildren.size) || (pe.value = ze);
      }
    }), be = shallowRef(-1);
    let Se = !1;
    const Pe = computed(() => {
      var ze;
      return (ze = se.value) == null ? void 0 : ze.color;
    }), Ee = computed(() => ge.value ? re.closeText : re.openText), {
      items: Ve,
      transformIn: Ae,
      transformOut: Oe
    } = useItems(re), {
      textColorClasses: Ne,
      textColorStyles: He
    } = useTextColor(Pe), Ue = useProxiedModel(re, "modelValue", [], (ze) => Ae(wrapInArray(ze)), (ze) => {
      const Ge = Oe(ze);
      return re.multiple ? Ge : Ge[0] ?? null;
    }), Ze = useForm(re), Fe = computed(() => !!(re.chips || ie.chip)), Ke = computed(() => Fe.value || !!ie.selection), tt = shallowRef(!re.multiple && !Ke.value ? ((We = Ue.value[0]) == null ? void 0 : We.title) ?? "" : ""), Re = computed({
      get: () => tt.value,
      set: (ze) => {
        var Ge;
        if (tt.value = ze ?? "", !re.multiple && !Ke.value && (Ue.value = [transformItem$3(re, ze)]), ze && re.multiple && ((Ge = re.delimiters) != null && Ge.length)) {
          const nt = ze.split(new RegExp(`(?:${re.delimiters.join("|")})+`));
          nt.length > 1 && (nt.forEach((ot) => {
            ot = ot.trim(), ot && je(transformItem$3(re, ot));
          }), tt.value = "");
        }
        ze || (be.value = -1), ue.value = !ze;
      }
    }), Ce = computed(() => typeof re.counterValue == "function" ? re.counterValue(Ue.value) : typeof re.counterValue == "number" ? re.counterValue : re.multiple ? Ue.value.length : Re.value.length);
    watch(tt, (ze) => {
      Se ? nextTick$2(() => Se = !1) : ce.value && !ge.value && (ge.value = !0), ae("update:search", ze);
    }), watch(Ue, (ze) => {
      var Ge;
      !re.multiple && !Ke.value && (tt.value = ((Ge = ze[0]) == null ? void 0 : Ge.title) ?? "");
    });
    const {
      filteredItems: _e,
      getMatches: he
    } = useFilter(re, Ve, () => ue.value ? "" : Re.value), ve = computed(() => re.hideSelected ? _e.value.filter((ze) => !Ue.value.some((Ge) => Ge.value === ze.value)) : _e.value), xe = computed(() => Ue.value.map((ze) => ze.value)), $e = computed(() => {
      var Ge;
      return (re.autoSelectFirst === !0 || re.autoSelectFirst === "exact" && Re.value === ((Ge = ve.value[0]) == null ? void 0 : Ge.title)) && ve.value.length > 0 && !ue.value && !de.value;
    }), Te = computed(() => re.hideNoData && !ve.value.length || Ze.isReadonly.value || Ze.isDisabled.value), Ie = ref$1(), we = useScrolling(Ie, se);
    function ke(ze) {
      Se = !0, re.openOnClear && (ge.value = !0);
    }
    function ye() {
      Te.value || (ge.value = !0);
    }
    function Be(ze) {
      Te.value || (ce.value && (ze.preventDefault(), ze.stopPropagation()), ge.value = !ge.value);
    }
    function Xe(ze) {
      var Ge;
      ze.key !== " " && checkPrintable(ze) && ((Ge = se.value) == null || Ge.focus());
    }
    function et(ze) {
      var ot;
      if (isComposingIgnoreKey(ze) || Ze.isReadonly.value) return;
      const Ge = se.value.selectionStart, nt = Ue.value.length;
      if (["Enter", "ArrowDown", "ArrowUp"].includes(ze.key) && ze.preventDefault(), ["Enter", "ArrowDown"].includes(ze.key) && (ge.value = !0), ["Escape"].includes(ze.key) && (ge.value = !1), ["Enter", "Escape", "Tab"].includes(ze.key) && ($e.value && ["Enter", "Tab"].includes(ze.key) && !Ue.value.some((lt) => {
        let {
          value: mt
        } = lt;
        return mt === ve.value[0].value;
      }) && je(_e.value[0]), ue.value = !0), ze.key === "ArrowDown" && $e.value && ((ot = Ie.value) == null || ot.focus("next")), ze.key === "Enter" && Re.value && (je(transformItem$3(re, Re.value)), Ke.value && (tt.value = "")), ["Backspace", "Delete"].includes(ze.key)) {
        if (!re.multiple && Ke.value && Ue.value.length > 0 && !Re.value) return je(Ue.value[0], !1);
        if (~be.value) {
          ze.preventDefault();
          const lt = be.value;
          je(Ue.value[be.value], !1), be.value = lt >= nt - 1 ? nt - 2 : lt;
        } else ze.key === "Backspace" && !Re.value && (be.value = nt - 1);
        return;
      }
      if (re.multiple)
        if (ze.key === "ArrowLeft") {
          if (be.value < 0 && Ge > 0) return;
          const lt = be.value > -1 ? be.value - 1 : nt - 1;
          Ue.value[lt] ? be.value = lt : (be.value = -1, se.value.setSelectionRange(Re.value.length, Re.value.length));
        } else if (ze.key === "ArrowRight") {
          if (be.value < 0) return;
          const lt = be.value + 1;
          Ue.value[lt] ? be.value = lt : (be.value = -1, se.value.setSelectionRange(0, 0));
        } else ~be.value && checkPrintable(ze) && (be.value = -1);
    }
    function Ye() {
      var ze;
      re.eager && ((ze = fe.value) == null || ze.calculateVisibleItems());
    }
    function De() {
      var ze;
      ce.value && (ue.value = !0, (ze = se.value) == null || ze.focus());
    }
    function je(ze) {
      let Ge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      if (!(!ze || ze.props.disabled))
        if (re.multiple) {
          const nt = Ue.value.findIndex((lt) => (re.valueComparator || deepEqual)(lt.value, ze.value)), ot = Ge ?? !~nt;
          if (~nt) {
            const lt = ot ? [...Ue.value, ze] : [...Ue.value];
            lt.splice(nt, 1), Ue.value = lt;
          } else ot && (Ue.value = [...Ue.value, ze]);
          re.clearOnSelect && (Re.value = "");
        } else {
          const nt = Ge !== !1;
          Ue.value = nt ? [ze] : [], tt.value = nt && !Ke.value ? ze.title : "", nextTick$2(() => {
            ge.value = !1, ue.value = !0;
          });
        }
    }
    function rt(ze) {
      ce.value = !0, setTimeout(() => {
        de.value = !0;
      });
    }
    function at(ze) {
      de.value = !1;
    }
    function qe(ze) {
      (ze == null || ze === "" && !re.multiple && !Ke.value) && (Ue.value = []);
    }
    return watch(ce, (ze, Ge) => {
      if (!(ze || ze === Ge) && (be.value = -1, ge.value = !1, Re.value)) {
        if (re.multiple) {
          je(transformItem$3(re, Re.value));
          return;
        }
        if (!Ke.value) return;
        Ue.value.some((nt) => {
          let {
            title: ot
          } = nt;
          return ot === Re.value;
        }) ? tt.value = "" : je(transformItem$3(re, Re.value));
      }
    }), watch(ge, () => {
      if (!re.hideSelected && ge.value && Ue.value.length) {
        const ze = ve.value.findIndex((Ge) => Ue.value.some((nt) => (re.valueComparator || deepEqual)(nt.value, Ge.value)));
        IN_BROWSER && window.requestAnimationFrame(() => {
          var Ge;
          ze >= 0 && ((Ge = fe.value) == null || Ge.scrollToIndex(ze));
        });
      }
    }), watch(() => re.items, (ze, Ge) => {
      ge.value || ce.value && !Ge.length && ze.length && (ge.value = !0);
    }), useRender(() => {
      const ze = !!(!re.hideNoData || ve.value.length || ie["prepend-item"] || ie["append-item"] || ie["no-data"]), Ge = Ue.value.length > 0, nt = VTextField.filterProps(re);
      return createVNode(VTextField, mergeProps({
        ref: se
      }, nt, {
        modelValue: Re.value,
        "onUpdate:modelValue": [(ot) => Re.value = ot, qe],
        focused: ce.value,
        "onUpdate:focused": (ot) => ce.value = ot,
        validationValue: Ue.externalValue,
        counterValue: Ce.value,
        dirty: Ge,
        class: ["v-combobox", {
          "v-combobox--active-menu": ge.value,
          "v-combobox--chips": !!re.chips,
          "v-combobox--selection-slot": !!Ke.value,
          "v-combobox--selecting-index": be.value > -1,
          [`v-combobox--${re.multiple ? "multiple" : "single"}`]: !0
        }, re.class],
        style: re.style,
        readonly: Ze.isReadonly.value,
        placeholder: Ge ? void 0 : re.placeholder,
        "onClick:clear": ke,
        "onMousedown:control": ye,
        onKeydown: et
      }), {
        ...ie,
        default: () => createVNode(Fragment, null, [createVNode(VMenu, mergeProps({
          ref: me,
          modelValue: ge.value,
          "onUpdate:modelValue": (ot) => ge.value = ot,
          activator: "parent",
          contentClass: "v-combobox__content",
          disabled: Te.value,
          eager: re.eager,
          maxHeight: 310,
          openOnClick: !1,
          closeOnContentClick: !1,
          transition: re.transition,
          onAfterEnter: Ye,
          onAfterLeave: De
        }, re.menuProps), {
          default: () => [ze && createVNode(VList, mergeProps({
            ref: Ie,
            selected: xe.value,
            selectStrategy: re.multiple ? "independent" : "single-independent",
            onMousedown: (ot) => ot.preventDefault(),
            onKeydown: Xe,
            onFocusin: rt,
            onFocusout: at,
            tabindex: "-1",
            "aria-live": "polite",
            color: re.itemColor ?? re.color
          }, we, re.listProps), {
            default: () => {
              var ot, lt, mt;
              return [(ot = ie["prepend-item"]) == null ? void 0 : ot.call(ie), !ve.value.length && !re.hideNoData && (((lt = ie["no-data"]) == null ? void 0 : lt.call(ie)) ?? createVNode(VListItem, {
                key: "no-data",
                title: le(re.noDataText)
              }, null)), createVNode(VVirtualScroll, {
                ref: fe,
                renderless: !0,
                items: ve.value
              }, {
                default: (dt) => {
                  var pt;
                  let {
                    item: gt,
                    index: bt,
                    itemRef: At
                  } = dt;
                  const wt = mergeProps(gt.props, {
                    ref: At,
                    key: gt.value,
                    active: $e.value && bt === 0 ? !0 : void 0,
                    onClick: () => je(gt, null)
                  });
                  return ((pt = ie.item) == null ? void 0 : pt.call(ie, {
                    item: gt,
                    index: bt,
                    props: wt
                  })) ?? createVNode(VListItem, mergeProps(wt, {
                    role: "option"
                  }), {
                    prepend: (ut) => {
                      let {
                        isSelected: ht
                      } = ut;
                      return createVNode(Fragment, null, [re.multiple && !re.hideSelected ? createVNode(VCheckboxBtn, {
                        key: gt.value,
                        modelValue: ht,
                        ripple: !1,
                        tabindex: "-1"
                      }, null) : void 0, gt.props.prependAvatar && createVNode(VAvatar, {
                        image: gt.props.prependAvatar
                      }, null), gt.props.prependIcon && createVNode(VIcon, {
                        icon: gt.props.prependIcon
                      }, null)]);
                    },
                    title: () => {
                      var ut, ht;
                      return ue.value ? gt.title : highlightResult(gt.title, (ut = he(gt)) == null ? void 0 : ut.title, ((ht = Re.value) == null ? void 0 : ht.length) ?? 0);
                    }
                  });
                }
              }), (mt = ie["append-item"]) == null ? void 0 : mt.call(ie)];
            }
          })]
        }), Ue.value.map((ot, lt) => {
          function mt(At) {
            At.stopPropagation(), At.preventDefault(), je(ot, !1);
          }
          const dt = {
            "onClick:close": mt,
            onKeydown(At) {
              At.key !== "Enter" && At.key !== " " || (At.preventDefault(), At.stopPropagation(), mt(At));
            },
            onMousedown(At) {
              At.preventDefault(), At.stopPropagation();
            },
            modelValue: !0,
            "onUpdate:modelValue": void 0
          }, gt = Fe.value ? !!ie.chip : !!ie.selection, bt = gt ? ensureValidVNode(Fe.value ? ie.chip({
            item: ot,
            index: lt,
            props: dt
          }) : ie.selection({
            item: ot,
            index: lt
          })) : void 0;
          if (!(gt && !bt))
            return createVNode("div", {
              key: ot.value,
              class: ["v-combobox__selection", lt === be.value && ["v-combobox__selection--selected", Ne.value]],
              style: lt === be.value ? He.value : {}
            }, [Fe.value ? ie.chip ? createVNode(VDefaultsProvider, {
              key: "chip-defaults",
              defaults: {
                VChip: {
                  closable: re.closableChips,
                  size: "small",
                  text: ot.title
                }
              }
            }, {
              default: () => [bt]
            }) : createVNode(VChip, mergeProps({
              key: "chip",
              closable: re.closableChips,
              size: "small",
              text: ot.title,
              disabled: ot.props.disabled
            }, dt), null) : bt ?? createVNode("span", {
              class: "v-combobox__selection-text"
            }, [ot.title, re.multiple && lt < Ue.value.length - 1 && createVNode("span", {
              class: "v-combobox__selection-comma"
            }, [createTextVNode(",")])])]);
        })]),
        "append-inner": function() {
          var dt;
          for (var ot = arguments.length, lt = new Array(ot), mt = 0; mt < ot; mt++)
            lt[mt] = arguments[mt];
          return createVNode(Fragment, null, [(dt = ie["append-inner"]) == null ? void 0 : dt.call(ie, ...lt), (!re.hideNoData || re.items.length) && re.menuIcon ? createVNode(VIcon, {
            class: "v-combobox__menu-icon",
            icon: re.menuIcon,
            onMousedown: Be,
            onClick: noop$2,
            "aria-label": le(Ee.value),
            title: le(Ee.value),
            tabindex: "-1"
          }, null) : void 0]);
        }
      });
    }), forwardRefs({
      isFocused: ce,
      isPristine: ue,
      menu: ge,
      search: Re,
      selectionIndex: be,
      filteredItems: _e,
      select: je
    }, se);
  }
}), makeVConfirmEditProps = propsFactory({
  modelValue: null,
  color: String,
  cancelText: {
    type: String,
    default: "$vuetify.confirmEdit.cancel"
  },
  okText: {
    type: String,
    default: "$vuetify.confirmEdit.ok"
  }
}, "VConfirmEdit"), VConfirmEdit = genericComponent()({
  name: "VConfirmEdit",
  props: makeVConfirmEditProps(),
  emits: {
    cancel: () => !0,
    save: (re) => !0,
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      emit: ae,
      slots: ie
    } = ne;
    const le = useProxiedModel(re, "modelValue"), se = ref$1();
    watchEffect(() => {
      se.value = structuredClone(toRaw(le.value));
    });
    const {
      t: ce
    } = useLocale(), ue = computed(() => deepEqual(le.value, se.value));
    function de() {
      le.value = se.value, ae("save", se.value);
    }
    function me() {
      se.value = structuredClone(toRaw(le.value)), ae("cancel");
    }
    function fe(ge) {
      return createVNode(Fragment, null, [createVNode(VBtn, mergeProps({
        disabled: ue.value,
        variant: "text",
        color: re.color,
        onClick: me,
        text: ce(re.cancelText)
      }, ge), null), createVNode(VBtn, mergeProps({
        disabled: ue.value,
        variant: "text",
        color: re.color,
        onClick: de,
        text: ce(re.okText)
      }, ge), null)]);
    }
    let pe = !1;
    return useRender(() => {
      var ge;
      return createVNode(Fragment, null, [(ge = ie.default) == null ? void 0 : ge.call(ie, {
        model: se,
        save: de,
        cancel: me,
        isPristine: ue.value,
        get actions() {
          return pe = !0, fe;
        }
      }), !pe && fe()]);
    }), {
      save: de,
      cancel: me,
      isPristine: ue
    };
  }
}), makeDataTableExpandProps = propsFactory({
  expandOnClick: Boolean,
  showExpand: Boolean,
  expanded: {
    type: Array,
    default: () => []
  }
}, "DataTable-expand"), VDataTableExpandedKey = Symbol.for("vuetify:datatable:expanded");
function provideExpanded(re) {
  const ne = toRef(re, "expandOnClick"), ae = useProxiedModel(re, "expanded", re.expanded, (ue) => new Set(ue), (ue) => [...ue.values()]);
  function ie(ue, de) {
    const me = new Set(ae.value);
    de ? me.add(ue.value) : me.delete(ue.value), ae.value = me;
  }
  function le(ue) {
    return ae.value.has(ue.value);
  }
  function se(ue) {
    ie(ue, !le(ue));
  }
  const ce = {
    expand: ie,
    expanded: ae,
    expandOnClick: ne,
    isExpanded: le,
    toggleExpand: se
  };
  return provide(VDataTableExpandedKey, ce), ce;
}
function useExpanded() {
  const re = inject(VDataTableExpandedKey);
  if (!re) throw new Error("foo");
  return re;
}
const makeDataTableGroupProps = propsFactory({
  groupBy: {
    type: Array,
    default: () => []
  }
}, "DataTable-group"), VDataTableGroupSymbol = Symbol.for("vuetify:data-table-group");
function createGroupBy(re) {
  return {
    groupBy: useProxiedModel(re, "groupBy")
  };
}
function provideGroupBy(re) {
  const {
    disableSort: ne,
    groupBy: ae,
    sortBy: ie
  } = re, le = ref$1(/* @__PURE__ */ new Set()), se = computed(() => ae.value.map((fe) => ({
    ...fe,
    order: fe.order ?? !1
  })).concat(ne != null && ne.value ? [] : ie.value));
  function ce(fe) {
    return le.value.has(fe.id);
  }
  function ue(fe) {
    const pe = new Set(le.value);
    ce(fe) ? pe.delete(fe.id) : pe.add(fe.id), le.value = pe;
  }
  function de(fe) {
    function pe(ge) {
      const be = [];
      for (const Se of ge.items)
        "type" in Se && Se.type === "group" ? be.push(...pe(Se)) : be.push(Se);
      return [...new Set(be)];
    }
    return pe({
      type: "group",
      items: fe,
      id: "dummy",
      key: "dummy",
      value: "dummy",
      depth: 0
    });
  }
  const me = {
    sortByWithGroups: se,
    toggleGroup: ue,
    opened: le,
    groupBy: ae,
    extractRows: de,
    isGroupOpen: ce
  };
  return provide(VDataTableGroupSymbol, me), me;
}
function useGroupBy() {
  const re = inject(VDataTableGroupSymbol);
  if (!re) throw new Error("Missing group!");
  return re;
}
function groupItemsByProperty(re, ne) {
  if (!re.length) return [];
  const ae = /* @__PURE__ */ new Map();
  for (const ie of re) {
    const le = getObjectValueByPath(ie.raw, ne);
    ae.has(le) || ae.set(le, []), ae.get(le).push(ie);
  }
  return ae;
}
function groupItems(re, ne) {
  let ae = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, ie = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "root";
  if (!ne.length) return [];
  const le = groupItemsByProperty(re, ne[0]), se = [], ce = ne.slice(1);
  return le.forEach((ue, de) => {
    const me = ne[0], fe = `${ie}_${me}_${de}`;
    se.push({
      depth: ae,
      id: fe,
      key: me,
      value: de,
      items: ce.length ? groupItems(ue, ce, ae + 1, fe) : ue,
      type: "group"
    });
  }), se;
}
function flattenItems(re, ne) {
  const ae = [];
  for (const ie of re)
    "type" in ie && ie.type === "group" ? (ie.value != null && ae.push(ie), (ne.has(ie.id) || ie.value == null) && ae.push(...flattenItems(ie.items, ne))) : ae.push(ie);
  return ae;
}
function useGroupedItems(re, ne, ae) {
  return {
    flatItems: computed(() => {
      if (!ne.value.length) return re.value;
      const le = groupItems(re.value, ne.value.map((se) => se.key));
      return flattenItems(le, ae.value);
    })
  };
}
function useOptions(re) {
  let {
    page: ne,
    itemsPerPage: ae,
    sortBy: ie,
    groupBy: le,
    search: se
  } = re;
  const ce = getCurrentInstance("VDataTable"), ue = computed(() => ({
    page: ne.value,
    itemsPerPage: ae.value,
    sortBy: ie.value,
    groupBy: le.value,
    search: se.value
  }));
  let de = null;
  watch(ue, () => {
    deepEqual(de, ue.value) || (de && de.search !== ue.value.search && (ne.value = 1), ce.emit("update:options", ue.value), de = ue.value);
  }, {
    deep: !0,
    immediate: !0
  });
}
const makeDataTablePaginateProps = propsFactory({
  page: {
    type: [Number, String],
    default: 1
  },
  itemsPerPage: {
    type: [Number, String],
    default: 10
  }
}, "DataTable-paginate"), VDataTablePaginationSymbol = Symbol.for("vuetify:data-table-pagination");
function createPagination(re) {
  const ne = useProxiedModel(re, "page", void 0, (ie) => Number(ie ?? 1)), ae = useProxiedModel(re, "itemsPerPage", void 0, (ie) => Number(ie ?? 10));
  return {
    page: ne,
    itemsPerPage: ae
  };
}
function providePagination(re) {
  const {
    page: ne,
    itemsPerPage: ae,
    itemsLength: ie
  } = re, le = computed(() => ae.value === -1 ? 0 : ae.value * (ne.value - 1)), se = computed(() => ae.value === -1 ? ie.value : Math.min(ie.value, le.value + ae.value)), ce = computed(() => ae.value === -1 || ie.value === 0 ? 1 : Math.ceil(ie.value / ae.value));
  watch([ne, ce], () => {
    ne.value > ce.value && (ne.value = ce.value);
  });
  function ue(ge) {
    ae.value = ge, ne.value = 1;
  }
  function de() {
    ne.value = clamp(ne.value + 1, 1, ce.value);
  }
  function me() {
    ne.value = clamp(ne.value - 1, 1, ce.value);
  }
  function fe(ge) {
    ne.value = clamp(ge, 1, ce.value);
  }
  const pe = {
    page: ne,
    itemsPerPage: ae,
    startIndex: le,
    stopIndex: se,
    pageCount: ce,
    itemsLength: ie,
    nextPage: de,
    prevPage: me,
    setPage: fe,
    setItemsPerPage: ue
  };
  return provide(VDataTablePaginationSymbol, pe), pe;
}
function usePagination() {
  const re = inject(VDataTablePaginationSymbol);
  if (!re) throw new Error("Missing pagination!");
  return re;
}
function usePaginatedItems(re) {
  const ne = getCurrentInstance("usePaginatedItems"), {
    items: ae,
    startIndex: ie,
    stopIndex: le,
    itemsPerPage: se
  } = re, ce = computed(() => se.value <= 0 ? ae.value : ae.value.slice(ie.value, le.value));
  return watch(ce, (ue) => {
    ne.emit("update:currentItems", ue);
  }, {
    immediate: !0
  }), {
    paginatedItems: ce
  };
}
const singleSelectStrategy = {
  showSelectAll: !1,
  allSelected: () => [],
  select: (re) => {
    var ie;
    let {
      items: ne,
      value: ae
    } = re;
    return new Set(ae ? [(ie = ne[0]) == null ? void 0 : ie.value] : []);
  },
  selectAll: (re) => {
    let {
      selected: ne
    } = re;
    return ne;
  }
}, pageSelectStrategy = {
  showSelectAll: !0,
  allSelected: (re) => {
    let {
      currentPage: ne
    } = re;
    return ne;
  },
  select: (re) => {
    let {
      items: ne,
      value: ae,
      selected: ie
    } = re;
    for (const le of ne)
      ae ? ie.add(le.value) : ie.delete(le.value);
    return ie;
  },
  selectAll: (re) => {
    let {
      value: ne,
      currentPage: ae,
      selected: ie
    } = re;
    return pageSelectStrategy.select({
      items: ae,
      value: ne,
      selected: ie
    });
  }
}, allSelectStrategy = {
  showSelectAll: !0,
  allSelected: (re) => {
    let {
      allItems: ne
    } = re;
    return ne;
  },
  select: (re) => {
    let {
      items: ne,
      value: ae,
      selected: ie
    } = re;
    for (const le of ne)
      ae ? ie.add(le.value) : ie.delete(le.value);
    return ie;
  },
  selectAll: (re) => {
    let {
      value: ne,
      allItems: ae,
      selected: ie
    } = re;
    return allSelectStrategy.select({
      items: ae,
      value: ne,
      selected: ie
    });
  }
}, makeDataTableSelectProps = propsFactory({
  showSelect: Boolean,
  selectStrategy: {
    type: [String, Object],
    default: "page"
  },
  modelValue: {
    type: Array,
    default: () => []
  },
  valueComparator: {
    type: Function,
    default: deepEqual
  }
}, "DataTable-select"), VDataTableSelectionSymbol = Symbol.for("vuetify:data-table-selection");
function provideSelection(re, ne) {
  let {
    allItems: ae,
    currentPage: ie
  } = ne;
  const le = useProxiedModel(re, "modelValue", re.modelValue, (Ve) => new Set(wrapInArray(Ve).map((Ae) => {
    var Oe;
    return ((Oe = ae.value.find((Ne) => re.valueComparator(Ae, Ne.value))) == null ? void 0 : Oe.value) ?? Ae;
  })), (Ve) => [...Ve.values()]), se = computed(() => ae.value.filter((Ve) => Ve.selectable)), ce = computed(() => ie.value.filter((Ve) => Ve.selectable)), ue = computed(() => {
    if (typeof re.selectStrategy == "object") return re.selectStrategy;
    switch (re.selectStrategy) {
      case "single":
        return singleSelectStrategy;
      case "all":
        return allSelectStrategy;
      case "page":
      default:
        return pageSelectStrategy;
    }
  });
  function de(Ve) {
    return wrapInArray(Ve).every((Ae) => le.value.has(Ae.value));
  }
  function me(Ve) {
    return wrapInArray(Ve).some((Ae) => le.value.has(Ae.value));
  }
  function fe(Ve, Ae) {
    const Oe = ue.value.select({
      items: Ve,
      value: Ae,
      selected: new Set(le.value)
    });
    le.value = Oe;
  }
  function pe(Ve) {
    fe([Ve], !de([Ve]));
  }
  function ge(Ve) {
    const Ae = ue.value.selectAll({
      value: Ve,
      allItems: se.value,
      currentPage: ce.value,
      selected: new Set(le.value)
    });
    le.value = Ae;
  }
  const be = computed(() => le.value.size > 0), Se = computed(() => {
    const Ve = ue.value.allSelected({
      allItems: se.value,
      currentPage: ce.value
    });
    return !!Ve.length && de(Ve);
  }), Pe = computed(() => ue.value.showSelectAll), Ee = {
    toggleSelect: pe,
    select: fe,
    selectAll: ge,
    isSelected: de,
    isSomeSelected: me,
    someSelected: be,
    allSelected: Se,
    showSelectAll: Pe
  };
  return provide(VDataTableSelectionSymbol, Ee), Ee;
}
function useSelection() {
  const re = inject(VDataTableSelectionSymbol);
  if (!re) throw new Error("Missing selection!");
  return re;
}
const makeDataTableSortProps = propsFactory({
  sortBy: {
    type: Array,
    default: () => []
  },
  customKeySort: Object,
  multiSort: Boolean,
  mustSort: Boolean
}, "DataTable-sort"), VDataTableSortSymbol = Symbol.for("vuetify:data-table-sort");
function createSort(re) {
  const ne = useProxiedModel(re, "sortBy"), ae = toRef(re, "mustSort"), ie = toRef(re, "multiSort");
  return {
    sortBy: ne,
    mustSort: ae,
    multiSort: ie
  };
}
function provideSort(re) {
  const {
    sortBy: ne,
    mustSort: ae,
    multiSort: ie,
    page: le
  } = re, se = (de) => {
    if (de.key == null) return;
    let me = ne.value.map((pe) => ({
      ...pe
    })) ?? [];
    const fe = me.find((pe) => pe.key === de.key);
    fe ? fe.order === "desc" ? ae.value && me.length === 1 ? fe.order = "asc" : me = me.filter((pe) => pe.key !== de.key) : fe.order = "desc" : ie.value ? me.push({
      key: de.key,
      order: "asc"
    }) : me = [{
      key: de.key,
      order: "asc"
    }], ne.value = me, le && (le.value = 1);
  };
  function ce(de) {
    return !!ne.value.find((me) => me.key === de.key);
  }
  const ue = {
    sortBy: ne,
    toggleSort: se,
    isSorted: ce
  };
  return provide(VDataTableSortSymbol, ue), ue;
}
function useSort() {
  const re = inject(VDataTableSortSymbol);
  if (!re) throw new Error("Missing sort!");
  return re;
}
function useSortedItems(re, ne, ae, ie) {
  const le = useLocale();
  return {
    sortedItems: computed(() => {
      var ce, ue;
      return ae.value.length ? sortItems(ne.value, ae.value, le.current.value, {
        transform: ie == null ? void 0 : ie.transform,
        sortFunctions: {
          ...re.customKeySort,
          ...(ce = ie == null ? void 0 : ie.sortFunctions) == null ? void 0 : ce.value
        },
        sortRawFunctions: (ue = ie == null ? void 0 : ie.sortRawFunctions) == null ? void 0 : ue.value
      }) : ne.value;
    })
  };
}
function sortItems(re, ne, ae, ie) {
  const le = new Intl.Collator(ae, {
    sensitivity: "accent",
    usage: "sort"
  });
  return re.map((ce) => [ce, ie != null && ie.transform ? ie.transform(ce) : ce]).sort((ce, ue) => {
    var de, me;
    for (let fe = 0; fe < ne.length; fe++) {
      let pe = !1;
      const ge = ne[fe].key, be = ne[fe].order ?? "asc";
      if (be === !1) continue;
      let Se = getObjectValueByPath(ce[1], ge), Pe = getObjectValueByPath(ue[1], ge), Ee = ce[0].raw, Ve = ue[0].raw;
      if (be === "desc" && ([Se, Pe] = [Pe, Se], [Ee, Ve] = [Ve, Ee]), (de = ie == null ? void 0 : ie.sortRawFunctions) != null && de[ge]) {
        const Ae = ie.sortRawFunctions[ge](Ee, Ve);
        if (Ae == null) continue;
        if (pe = !0, Ae) return Ae;
      }
      if ((me = ie == null ? void 0 : ie.sortFunctions) != null && me[ge]) {
        const Ae = ie.sortFunctions[ge](Se, Pe);
        if (Ae == null) continue;
        if (pe = !0, Ae) return Ae;
      }
      if (!pe) {
        if (Se instanceof Date && Pe instanceof Date)
          return Se.getTime() - Pe.getTime();
        if ([Se, Pe] = [Se, Pe].map((Ae) => Ae != null ? Ae.toString().toLocaleLowerCase() : Ae), Se !== Pe)
          return isEmpty(Se) && isEmpty(Pe) ? 0 : isEmpty(Se) ? -1 : isEmpty(Pe) ? 1 : !isNaN(Se) && !isNaN(Pe) ? Number(Se) - Number(Pe) : le.compare(Se, Pe);
      }
    }
    return 0;
  }).map((ce) => {
    let [ue] = ce;
    return ue;
  });
}
const makeDataIteratorItemsProps = propsFactory({
  items: {
    type: Array,
    default: () => []
  },
  itemValue: {
    type: [String, Array, Function],
    default: "id"
  },
  itemSelectable: {
    type: [String, Array, Function],
    default: null
  },
  returnObject: Boolean
}, "DataIterator-items");
function transformItem$1(re, ne) {
  const ae = re.returnObject ? ne : getPropertyFromItem(ne, re.itemValue), ie = getPropertyFromItem(ne, re.itemSelectable, !0);
  return {
    type: "item",
    value: ae,
    selectable: ie,
    raw: ne
  };
}
function transformItems$1(re, ne) {
  const ae = [];
  for (const ie of ne)
    ae.push(transformItem$1(re, ie));
  return ae;
}
function useDataIteratorItems(re) {
  return {
    items: computed(() => transformItems$1(re, re.items))
  };
}
const makeVDataIteratorProps = propsFactory({
  search: String,
  loading: Boolean,
  ...makeComponentProps(),
  ...makeDataIteratorItemsProps(),
  ...makeDataTableSelectProps(),
  ...makeDataTableSortProps(),
  ...makeDataTablePaginateProps({
    itemsPerPage: 5
  }),
  ...makeDataTableExpandProps(),
  ...makeDataTableGroupProps(),
  ...makeFilterProps(),
  ...makeTagProps(),
  ...makeTransitionProps({
    transition: {
      component: VFadeTransition,
      hideOnLeave: !0
    }
  })
}, "VDataIterator"), VDataIterator = genericComponent()({
  name: "VDataIterator",
  props: makeVDataIteratorProps(),
  emits: {
    "update:modelValue": (re) => !0,
    "update:groupBy": (re) => !0,
    "update:page": (re) => !0,
    "update:itemsPerPage": (re) => !0,
    "update:sortBy": (re) => !0,
    "update:options": (re) => !0,
    "update:expanded": (re) => !0,
    "update:currentItems": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = useProxiedModel(re, "groupBy"), le = toRef(re, "search"), {
      items: se
    } = useDataIteratorItems(re), {
      filteredItems: ce
    } = useFilter(re, se, le, {
      transform: (ke) => ke.raw
    }), {
      sortBy: ue,
      multiSort: de,
      mustSort: me
    } = createSort(re), {
      page: fe,
      itemsPerPage: pe
    } = createPagination(re), {
      toggleSort: ge
    } = provideSort({
      sortBy: ue,
      multiSort: de,
      mustSort: me,
      page: fe
    }), {
      sortByWithGroups: be,
      opened: Se,
      extractRows: Pe,
      isGroupOpen: Ee,
      toggleGroup: Ve
    } = provideGroupBy({
      groupBy: ie,
      sortBy: ue
    }), {
      sortedItems: Ae
    } = useSortedItems(re, ce, be, {
      transform: (ke) => ke.raw
    }), {
      flatItems: Oe
    } = useGroupedItems(Ae, ie, Se), Ne = computed(() => Oe.value.length), {
      startIndex: He,
      stopIndex: Ue,
      pageCount: Ze,
      prevPage: Fe,
      nextPage: Ke,
      setItemsPerPage: tt,
      setPage: Re
    } = providePagination({
      page: fe,
      itemsPerPage: pe,
      itemsLength: Ne
    }), {
      paginatedItems: Ce
    } = usePaginatedItems({
      items: Oe,
      startIndex: He,
      stopIndex: Ue,
      itemsPerPage: pe
    }), _e = computed(() => Pe(Ce.value)), {
      isSelected: he,
      select: ve,
      selectAll: xe,
      toggleSelect: $e
    } = provideSelection(re, {
      allItems: se,
      currentPage: _e
    }), {
      isExpanded: Te,
      toggleExpand: Ie
    } = provideExpanded(re);
    useOptions({
      page: fe,
      itemsPerPage: pe,
      sortBy: ue,
      groupBy: ie,
      search: le
    });
    const we = computed(() => ({
      page: fe.value,
      itemsPerPage: pe.value,
      sortBy: ue.value,
      pageCount: Ze.value,
      toggleSort: ge,
      prevPage: Fe,
      nextPage: Ke,
      setPage: Re,
      setItemsPerPage: tt,
      isSelected: he,
      select: ve,
      selectAll: xe,
      toggleSelect: $e,
      isExpanded: Te,
      toggleExpand: Ie,
      isGroupOpen: Ee,
      toggleGroup: Ve,
      items: _e.value,
      groupedItems: Ce.value
    }));
    return useRender(() => createVNode(re.tag, {
      class: ["v-data-iterator", {
        "v-data-iterator--loading": re.loading
      }, re.class],
      style: re.style
    }, {
      default: () => {
        var ke, ye;
        return [(ke = ae.header) == null ? void 0 : ke.call(ae, we.value), createVNode(MaybeTransition, {
          transition: re.transition
        }, {
          default: () => {
            var Be, Xe;
            return [re.loading ? createVNode(LoaderSlot, {
              key: "loader",
              name: "v-data-iterator",
              active: !0
            }, {
              default: (et) => {
                var Ye;
                return (Ye = ae.loader) == null ? void 0 : Ye.call(ae, et);
              }
            }) : createVNode("div", {
              key: "items"
            }, [Ce.value.length ? (Xe = ae.default) == null ? void 0 : Xe.call(ae, we.value) : (Be = ae["no-data"]) == null ? void 0 : Be.call(ae)])];
          }
        }), (ye = ae.footer) == null ? void 0 : ye.call(ae, we.value)];
      }
    })), {};
  }
});
function useRefs() {
  const re = ref$1([]);
  onBeforeUpdate(() => re.value = []);
  function ne(ae, ie) {
    re.value[ie] = ae;
  }
  return {
    refs: re,
    updateRef: ne
  };
}
const makeVPaginationProps = propsFactory({
  activeColor: String,
  start: {
    type: [Number, String],
    default: 1
  },
  modelValue: {
    type: Number,
    default: (re) => re.start
  },
  disabled: Boolean,
  length: {
    type: [Number, String],
    default: 1,
    validator: (re) => re % 1 === 0
  },
  totalVisible: [Number, String],
  firstIcon: {
    type: IconValue,
    default: "$first"
  },
  prevIcon: {
    type: IconValue,
    default: "$prev"
  },
  nextIcon: {
    type: IconValue,
    default: "$next"
  },
  lastIcon: {
    type: IconValue,
    default: "$last"
  },
  ariaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.root"
  },
  pageAriaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.page"
  },
  currentPageAriaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.currentPage"
  },
  firstAriaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.first"
  },
  previousAriaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.previous"
  },
  nextAriaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.next"
  },
  lastAriaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.last"
  },
  ellipsis: {
    type: String,
    default: "..."
  },
  showFirstLastPage: Boolean,
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeElevationProps(),
  ...makeRoundedProps(),
  ...makeSizeProps(),
  ...makeTagProps({
    tag: "nav"
  }),
  ...makeThemeProps(),
  ...makeVariantProps({
    variant: "text"
  })
}, "VPagination"), VPagination = genericComponent()({
  name: "VPagination",
  props: makeVPaginationProps(),
  emits: {
    "update:modelValue": (re) => !0,
    first: (re) => !0,
    prev: (re) => !0,
    next: (re) => !0,
    last: (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae,
      emit: ie
    } = ne;
    const le = useProxiedModel(re, "modelValue"), {
      t: se,
      n: ce
    } = useLocale(), {
      isRtl: ue
    } = useRtl(), {
      themeClasses: de
    } = provideTheme(re), {
      width: me
    } = useDisplay(), fe = shallowRef(-1);
    provideDefaults(void 0, {
      scoped: !0
    });
    const {
      resizeRef: pe
    } = useResizeObserver((Fe) => {
      if (!Fe.length) return;
      const {
        target: Ke,
        contentRect: tt
      } = Fe[0], Re = Ke.querySelector(".v-pagination__list > *");
      if (!Re) return;
      const Ce = tt.width, _e = Re.offsetWidth + parseFloat(getComputedStyle(Re).marginRight) * 2;
      fe.value = Pe(Ce, _e);
    }), ge = computed(() => parseInt(re.length, 10)), be = computed(() => parseInt(re.start, 10)), Se = computed(() => re.totalVisible != null ? parseInt(re.totalVisible, 10) : fe.value >= 0 ? fe.value : Pe(me.value, 58));
    function Pe(Fe, Ke) {
      const tt = re.showFirstLastPage ? 5 : 3;
      return Math.max(0, Math.floor(
        // Round to two decimal places to avoid floating point errors
        Number(((Fe - Ke * tt) / Ke).toFixed(2))
      ));
    }
    const Ee = computed(() => {
      if (ge.value <= 0 || isNaN(ge.value) || ge.value > Number.MAX_SAFE_INTEGER) return [];
      if (Se.value <= 0) return [];
      if (Se.value === 1) return [le.value];
      if (ge.value <= Se.value)
        return createRange(ge.value, be.value);
      const Fe = Se.value % 2 === 0, Ke = Fe ? Se.value / 2 : Math.floor(Se.value / 2), tt = Fe ? Ke : Ke + 1, Re = ge.value - Ke;
      if (tt - le.value >= 0)
        return [...createRange(Math.max(1, Se.value - 1), be.value), re.ellipsis, ge.value];
      if (le.value - Re >= (Fe ? 1 : 0)) {
        const Ce = Se.value - 1, _e = ge.value - Ce + be.value;
        return [be.value, re.ellipsis, ...createRange(Ce, _e)];
      } else {
        const Ce = Math.max(1, Se.value - 2), _e = Ce === 1 ? le.value : le.value - Math.ceil(Ce / 2) + be.value;
        return [be.value, re.ellipsis, ...createRange(Ce, _e), re.ellipsis, ge.value];
      }
    });
    function Ve(Fe, Ke, tt) {
      Fe.preventDefault(), le.value = Ke, tt && ie(tt, Ke);
    }
    const {
      refs: Ae,
      updateRef: Oe
    } = useRefs();
    provideDefaults({
      VPaginationBtn: {
        color: toRef(re, "color"),
        border: toRef(re, "border"),
        density: toRef(re, "density"),
        size: toRef(re, "size"),
        variant: toRef(re, "variant"),
        rounded: toRef(re, "rounded"),
        elevation: toRef(re, "elevation")
      }
    });
    const Ne = computed(() => Ee.value.map((Fe, Ke) => {
      const tt = (Re) => Oe(Re, Ke);
      if (typeof Fe == "string")
        return {
          isActive: !1,
          key: `ellipsis-${Ke}`,
          page: Fe,
          props: {
            ref: tt,
            ellipsis: !0,
            icon: !0,
            disabled: !0
          }
        };
      {
        const Re = Fe === le.value;
        return {
          isActive: Re,
          key: Fe,
          page: ce(Fe),
          props: {
            ref: tt,
            ellipsis: !1,
            icon: !0,
            disabled: !!re.disabled || Number(re.length) < 2,
            color: Re ? re.activeColor : re.color,
            "aria-current": Re,
            "aria-label": se(Re ? re.currentPageAriaLabel : re.pageAriaLabel, Fe),
            onClick: (Ce) => Ve(Ce, Fe)
          }
        };
      }
    })), He = computed(() => {
      const Fe = !!re.disabled || le.value <= be.value, Ke = !!re.disabled || le.value >= be.value + ge.value - 1;
      return {
        first: re.showFirstLastPage ? {
          icon: ue.value ? re.lastIcon : re.firstIcon,
          onClick: (tt) => Ve(tt, be.value, "first"),
          disabled: Fe,
          "aria-label": se(re.firstAriaLabel),
          "aria-disabled": Fe
        } : void 0,
        prev: {
          icon: ue.value ? re.nextIcon : re.prevIcon,
          onClick: (tt) => Ve(tt, le.value - 1, "prev"),
          disabled: Fe,
          "aria-label": se(re.previousAriaLabel),
          "aria-disabled": Fe
        },
        next: {
          icon: ue.value ? re.prevIcon : re.nextIcon,
          onClick: (tt) => Ve(tt, le.value + 1, "next"),
          disabled: Ke,
          "aria-label": se(re.nextAriaLabel),
          "aria-disabled": Ke
        },
        last: re.showFirstLastPage ? {
          icon: ue.value ? re.firstIcon : re.lastIcon,
          onClick: (tt) => Ve(tt, be.value + ge.value - 1, "last"),
          disabled: Ke,
          "aria-label": se(re.lastAriaLabel),
          "aria-disabled": Ke
        } : void 0
      };
    });
    function Ue() {
      var Ke;
      const Fe = le.value - be.value;
      (Ke = Ae.value[Fe]) == null || Ke.$el.focus();
    }
    function Ze(Fe) {
      Fe.key === keyValues.left && !re.disabled && le.value > Number(re.start) ? (le.value = le.value - 1, nextTick$2(Ue)) : Fe.key === keyValues.right && !re.disabled && le.value < be.value + ge.value - 1 && (le.value = le.value + 1, nextTick$2(Ue));
    }
    return useRender(() => createVNode(re.tag, {
      ref: pe,
      class: ["v-pagination", de.value, re.class],
      style: re.style,
      role: "navigation",
      "aria-label": se(re.ariaLabel),
      onKeydown: Ze,
      "data-test": "v-pagination-root"
    }, {
      default: () => [createVNode("ul", {
        class: "v-pagination__list"
      }, [re.showFirstLastPage && createVNode("li", {
        key: "first",
        class: "v-pagination__first",
        "data-test": "v-pagination-first"
      }, [ae.first ? ae.first(He.value.first) : createVNode(VBtn, mergeProps({
        _as: "VPaginationBtn"
      }, He.value.first), null)]), createVNode("li", {
        key: "prev",
        class: "v-pagination__prev",
        "data-test": "v-pagination-prev"
      }, [ae.prev ? ae.prev(He.value.prev) : createVNode(VBtn, mergeProps({
        _as: "VPaginationBtn"
      }, He.value.prev), null)]), Ne.value.map((Fe, Ke) => createVNode("li", {
        key: Fe.key,
        class: ["v-pagination__item", {
          "v-pagination__item--is-active": Fe.isActive
        }],
        "data-test": "v-pagination-item"
      }, [ae.item ? ae.item(Fe) : createVNode(VBtn, mergeProps({
        _as: "VPaginationBtn"
      }, Fe.props), {
        default: () => [Fe.page]
      })])), createVNode("li", {
        key: "next",
        class: "v-pagination__next",
        "data-test": "v-pagination-next"
      }, [ae.next ? ae.next(He.value.next) : createVNode(VBtn, mergeProps({
        _as: "VPaginationBtn"
      }, He.value.next), null)]), re.showFirstLastPage && createVNode("li", {
        key: "last",
        class: "v-pagination__last",
        "data-test": "v-pagination-last"
      }, [ae.last ? ae.last(He.value.last) : createVNode(VBtn, mergeProps({
        _as: "VPaginationBtn"
      }, He.value.last), null)])])]
    })), {};
  }
}), makeVDataTableFooterProps = propsFactory({
  prevIcon: {
    type: IconValue,
    default: "$prev"
  },
  nextIcon: {
    type: IconValue,
    default: "$next"
  },
  firstIcon: {
    type: IconValue,
    default: "$first"
  },
  lastIcon: {
    type: IconValue,
    default: "$last"
  },
  itemsPerPageText: {
    type: String,
    default: "$vuetify.dataFooter.itemsPerPageText"
  },
  pageText: {
    type: String,
    default: "$vuetify.dataFooter.pageText"
  },
  firstPageLabel: {
    type: String,
    default: "$vuetify.dataFooter.firstPage"
  },
  prevPageLabel: {
    type: String,
    default: "$vuetify.dataFooter.prevPage"
  },
  nextPageLabel: {
    type: String,
    default: "$vuetify.dataFooter.nextPage"
  },
  lastPageLabel: {
    type: String,
    default: "$vuetify.dataFooter.lastPage"
  },
  itemsPerPageOptions: {
    type: Array,
    default: () => [{
      value: 10,
      title: "10"
    }, {
      value: 25,
      title: "25"
    }, {
      value: 50,
      title: "50"
    }, {
      value: 100,
      title: "100"
    }, {
      value: -1,
      title: "$vuetify.dataFooter.itemsPerPageAll"
    }]
  },
  showCurrentPage: Boolean
}, "VDataTableFooter"), VDataTableFooter = genericComponent()({
  name: "VDataTableFooter",
  props: makeVDataTableFooterProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      t: ie
    } = useLocale(), {
      page: le,
      pageCount: se,
      startIndex: ce,
      stopIndex: ue,
      itemsLength: de,
      itemsPerPage: me,
      setItemsPerPage: fe
    } = usePagination(), pe = computed(() => re.itemsPerPageOptions.map((ge) => typeof ge == "number" ? {
      value: ge,
      title: ge === -1 ? ie("$vuetify.dataFooter.itemsPerPageAll") : String(ge)
    } : {
      ...ge,
      title: isNaN(Number(ge.title)) ? ie(ge.title) : ge.title
    }));
    return useRender(() => {
      var be;
      const ge = VPagination.filterProps(re);
      return createVNode("div", {
        class: "v-data-table-footer"
      }, [(be = ae.prepend) == null ? void 0 : be.call(ae), createVNode("div", {
        class: "v-data-table-footer__items-per-page"
      }, [createVNode("span", null, [ie(re.itemsPerPageText)]), createVNode(VSelect, {
        items: pe.value,
        modelValue: me.value,
        "onUpdate:modelValue": (Se) => fe(Number(Se)),
        density: "compact",
        variant: "outlined",
        "hide-details": !0
      }, null)]), createVNode("div", {
        class: "v-data-table-footer__info"
      }, [createVNode("div", null, [ie(re.pageText, de.value ? ce.value + 1 : 0, ue.value, de.value)])]), createVNode("div", {
        class: "v-data-table-footer__pagination"
      }, [createVNode(VPagination, mergeProps({
        modelValue: le.value,
        "onUpdate:modelValue": (Se) => le.value = Se,
        density: "comfortable",
        "first-aria-label": re.firstPageLabel,
        "last-aria-label": re.lastPageLabel,
        length: se.value,
        "next-aria-label": re.nextPageLabel,
        "previous-aria-label": re.prevPageLabel,
        rounded: !0,
        "show-first-last-page": !0,
        "total-visible": re.showCurrentPage ? 1 : 0,
        variant: "plain"
      }, ge), null)])]);
    }), {};
  }
}), VDataTableColumn = defineFunctionalComponent({
  align: {
    type: String,
    default: "start"
  },
  fixed: Boolean,
  fixedOffset: [Number, String],
  height: [Number, String],
  lastFixed: Boolean,
  noPadding: Boolean,
  tag: String,
  width: [Number, String],
  maxWidth: [Number, String],
  nowrap: Boolean
}, (re, ne) => {
  let {
    slots: ae
  } = ne;
  const ie = re.tag ?? "td";
  return createVNode(ie, {
    class: ["v-data-table__td", {
      "v-data-table-column--fixed": re.fixed,
      "v-data-table-column--last-fixed": re.lastFixed,
      "v-data-table-column--no-padding": re.noPadding,
      "v-data-table-column--nowrap": re.nowrap
    }, `v-data-table-column--align-${re.align}`],
    style: {
      height: convertToUnit(re.height),
      width: convertToUnit(re.width),
      maxWidth: convertToUnit(re.maxWidth),
      left: convertToUnit(re.fixedOffset || null)
    }
  }, {
    default: () => {
      var le;
      return [(le = ae.default) == null ? void 0 : le.call(ae)];
    }
  });
}), makeDataTableHeaderProps = propsFactory({
  headers: Array
}, "DataTable-header"), VDataTableHeadersSymbol = Symbol.for("vuetify:data-table-headers"), defaultHeader = {
  title: "",
  sortable: !1
}, defaultActionHeader = {
  ...defaultHeader,
  width: 48
};
function priorityQueue() {
  const ne = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : []).map((ae) => ({
    element: ae,
    priority: 0
  }));
  return {
    enqueue: (ae, ie) => {
      let le = !1;
      for (let se = 0; se < ne.length; se++)
        if (ne[se].priority > ie) {
          ne.splice(se, 0, {
            element: ae,
            priority: ie
          }), le = !0;
          break;
        }
      le || ne.push({
        element: ae,
        priority: ie
      });
    },
    size: () => ne.length,
    count: () => {
      let ae = 0;
      if (!ne.length) return 0;
      const ie = Math.floor(ne[0].priority);
      for (let le = 0; le < ne.length; le++)
        Math.floor(ne[le].priority) === ie && (ae += 1);
      return ae;
    },
    dequeue: () => ne.shift()
  };
}
function extractLeaves(re) {
  let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  if (!re.children)
    ne.push(re);
  else
    for (const ae of re.children)
      extractLeaves(ae, ne);
  return ne;
}
function extractKeys(re) {
  let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : /* @__PURE__ */ new Set();
  for (const ae of re)
    ae.key && ne.add(ae.key), ae.children && extractKeys(ae.children, ne);
  return ne;
}
function getDefaultItem(re) {
  if (re.key) {
    if (re.key === "data-table-group") return defaultHeader;
    if (["data-table-expand", "data-table-select"].includes(re.key)) return defaultActionHeader;
  }
}
function getDepth(re) {
  let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return re.children ? Math.max(ne, ...re.children.map((ae) => getDepth(ae, ne + 1))) : ne;
}
function parseFixedColumns(re) {
  let ne = !1;
  function ae(se) {
    let ce = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (se)
      if (ce && (se.fixed = !0), se.fixed)
        if (se.children)
          for (let ue = se.children.length - 1; ue >= 0; ue--)
            ae(se.children[ue], !0);
        else
          ne ? isNaN(Number(se.width)) ? consoleError(`Multiple fixed columns should have a static width (key: ${se.key})`) : se.minWidth = Math.max(Number(se.width) || 0, Number(se.minWidth) || 0) : se.lastFixed = !0, ne = !0;
      else if (se.children)
        for (let ue = se.children.length - 1; ue >= 0; ue--)
          ae(se.children[ue]);
      else
        ne = !1;
  }
  for (let se = re.length - 1; se >= 0; se--)
    ae(re[se]);
  function ie(se) {
    let ce = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (!se) return ce;
    if (se.children) {
      se.fixedOffset = ce;
      for (const ue of se.children)
        ce = ie(ue, ce);
    } else se.fixed && (se.fixedOffset = ce, ce += parseFloat(se.width || "0") || 0);
    return ce;
  }
  let le = 0;
  for (const se of re)
    le = ie(se, le);
}
function parse$1(re, ne) {
  const ae = [];
  let ie = 0;
  const le = priorityQueue(re);
  for (; le.size() > 0; ) {
    let ce = le.count();
    const ue = [];
    let de = 1;
    for (; ce > 0; ) {
      const {
        element: me,
        priority: fe
      } = le.dequeue(), pe = ne - ie - getDepth(me);
      if (ue.push({
        ...me,
        rowspan: pe ?? 1,
        colspan: me.children ? extractLeaves(me).length : 1
      }), me.children)
        for (const ge of me.children) {
          const be = fe % 1 + de / Math.pow(10, ie + 2);
          le.enqueue(ge, ie + pe + be);
        }
      de += 1, ce -= 1;
    }
    ie += 1, ae.push(ue);
  }
  return {
    columns: re.map((ce) => extractLeaves(ce)).flat(),
    headers: ae
  };
}
function convertToInternalHeaders(re) {
  const ne = [];
  for (const ae of re) {
    const ie = {
      ...getDefaultItem(ae),
      ...ae
    }, le = ie.key ?? (typeof ie.value == "string" ? ie.value : null), se = ie.value ?? le ?? null, ce = {
      ...ie,
      key: le,
      value: se,
      sortable: ie.sortable ?? (ie.key != null || !!ie.sort),
      children: ie.children ? convertToInternalHeaders(ie.children) : void 0
    };
    ne.push(ce);
  }
  return ne;
}
function createHeaders(re, ne) {
  const ae = ref$1([]), ie = ref$1([]), le = ref$1({}), se = ref$1({}), ce = ref$1({});
  watchEffect(() => {
    var Pe, Ee, Ve;
    const me = (re.headers || Object.keys(re.items[0] ?? {}).map((Ae) => ({
      key: Ae,
      title: capitalize$1(Ae)
    }))).slice(), fe = extractKeys(me);
    (Pe = ne == null ? void 0 : ne.groupBy) != null && Pe.value.length && !fe.has("data-table-group") && me.unshift({
      key: "data-table-group",
      title: "Group"
    }), (Ee = ne == null ? void 0 : ne.showSelect) != null && Ee.value && !fe.has("data-table-select") && me.unshift({
      key: "data-table-select"
    }), (Ve = ne == null ? void 0 : ne.showExpand) != null && Ve.value && !fe.has("data-table-expand") && me.push({
      key: "data-table-expand"
    });
    const pe = convertToInternalHeaders(me);
    parseFixedColumns(pe);
    const ge = Math.max(...pe.map((Ae) => getDepth(Ae))) + 1, be = parse$1(pe, ge);
    ae.value = be.headers, ie.value = be.columns;
    const Se = be.headers.flat(1);
    for (const Ae of Se)
      Ae.key && (Ae.sortable && (Ae.sort && (le.value[Ae.key] = Ae.sort), Ae.sortRaw && (se.value[Ae.key] = Ae.sortRaw)), Ae.filter && (ce.value[Ae.key] = Ae.filter));
  });
  const ue = {
    headers: ae,
    columns: ie,
    sortFunctions: le,
    sortRawFunctions: se,
    filterFunctions: ce
  };
  return provide(VDataTableHeadersSymbol, ue), ue;
}
function useHeaders() {
  const re = inject(VDataTableHeadersSymbol);
  if (!re) throw new Error("Missing headers!");
  return re;
}
const makeVDataTableHeadersProps = propsFactory({
  color: String,
  disableSort: Boolean,
  fixedHeader: Boolean,
  multiSort: Boolean,
  sortAscIcon: {
    type: IconValue,
    default: "$sortAsc"
  },
  sortDescIcon: {
    type: IconValue,
    default: "$sortDesc"
  },
  headerProps: {
    type: Object
  },
  /** @deprecated */
  sticky: Boolean,
  ...makeDisplayProps(),
  ...makeLoaderProps()
}, "VDataTableHeaders"), VDataTableHeaders = genericComponent()({
  name: "VDataTableHeaders",
  props: makeVDataTableHeadersProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      t: ie
    } = useLocale(), {
      toggleSort: le,
      sortBy: se,
      isSorted: ce
    } = useSort(), {
      someSelected: ue,
      allSelected: de,
      selectAll: me,
      showSelectAll: fe
    } = useSelection(), {
      columns: pe,
      headers: ge
    } = useHeaders(), {
      loaderClasses: be
    } = useLoader(re);
    function Se(Fe, Ke) {
      if (!(!(re.sticky || re.fixedHeader) && !Fe.fixed))
        return {
          position: "sticky",
          left: Fe.fixed ? convertToUnit(Fe.fixedOffset) : void 0,
          top: re.sticky || re.fixedHeader ? `calc(var(--v-table-header-height) * ${Ke})` : void 0
        };
    }
    function Pe(Fe) {
      const Ke = se.value.find((tt) => tt.key === Fe.key);
      return Ke ? Ke.order === "asc" ? re.sortAscIcon : re.sortDescIcon : re.sortAscIcon;
    }
    const {
      backgroundColorClasses: Ee,
      backgroundColorStyles: Ve
    } = useBackgroundColor(re, "color"), {
      displayClasses: Ae,
      mobile: Oe
    } = useDisplay(re), Ne = computed(() => ({
      headers: ge.value,
      columns: pe.value,
      toggleSort: le,
      isSorted: ce,
      sortBy: se.value,
      someSelected: ue.value,
      allSelected: de.value,
      selectAll: me,
      getSortIcon: Pe
    })), He = computed(() => ["v-data-table__th", {
      "v-data-table__th--sticky": re.sticky || re.fixedHeader
    }, Ae.value, be.value]), Ue = (Fe) => {
      let {
        column: Ke,
        x: tt,
        y: Re
      } = Fe;
      const Ce = Ke.key === "data-table-select" || Ke.key === "data-table-expand", _e = mergeProps(re.headerProps ?? {}, Ke.headerProps ?? {});
      return createVNode(VDataTableColumn, mergeProps({
        tag: "th",
        align: Ke.align,
        class: [{
          "v-data-table__th--sortable": Ke.sortable && !re.disableSort,
          "v-data-table__th--sorted": ce(Ke),
          "v-data-table__th--fixed": Ke.fixed
        }, ...He.value],
        style: {
          width: convertToUnit(Ke.width),
          minWidth: convertToUnit(Ke.minWidth),
          maxWidth: convertToUnit(Ke.maxWidth),
          ...Se(Ke, Re)
        },
        colspan: Ke.colspan,
        rowspan: Ke.rowspan,
        onClick: Ke.sortable ? () => le(Ke) : void 0,
        fixed: Ke.fixed,
        nowrap: Ke.nowrap,
        lastFixed: Ke.lastFixed,
        noPadding: Ce
      }, _e), {
        default: () => {
          var xe;
          const he = `header.${Ke.key}`, ve = {
            column: Ke,
            selectAll: me,
            isSorted: ce,
            toggleSort: le,
            sortBy: se.value,
            someSelected: ue.value,
            allSelected: de.value,
            getSortIcon: Pe
          };
          return ae[he] ? ae[he](ve) : Ke.key === "data-table-select" ? ((xe = ae["header.data-table-select"]) == null ? void 0 : xe.call(ae, ve)) ?? (fe.value && createVNode(VCheckboxBtn, {
            modelValue: de.value,
            indeterminate: ue.value && !de.value,
            "onUpdate:modelValue": me
          }, null)) : createVNode("div", {
            class: "v-data-table-header__content"
          }, [createVNode("span", null, [Ke.title]), Ke.sortable && !re.disableSort && createVNode(VIcon, {
            key: "icon",
            class: "v-data-table-header__sort-icon",
            icon: Pe(Ke)
          }, null), re.multiSort && ce(Ke) && createVNode("div", {
            key: "badge",
            class: ["v-data-table-header__sort-badge", ...Ee.value],
            style: Ve.value
          }, [se.value.findIndex(($e) => $e.key === Ke.key) + 1])]);
        }
      });
    }, Ze = () => {
      const Fe = mergeProps(re.headerProps ?? {} ?? {}), Ke = computed(() => pe.value.filter((Re) => (Re == null ? void 0 : Re.sortable) && !re.disableSort)), tt = computed(() => {
        if (pe.value.find((Ce) => Ce.key === "data-table-select") != null)
          return de.value ? "$checkboxOn" : ue.value ? "$checkboxIndeterminate" : "$checkboxOff";
      });
      return createVNode(VDataTableColumn, mergeProps({
        tag: "th",
        class: [...He.value],
        colspan: ge.value.length + 1
      }, Fe), {
        default: () => [createVNode("div", {
          class: "v-data-table-header__content"
        }, [createVNode(VSelect, {
          chips: !0,
          class: "v-data-table__td-sort-select",
          clearable: !0,
          density: "default",
          items: Ke.value,
          label: ie("$vuetify.dataTable.sortBy"),
          multiple: re.multiSort,
          variant: "underlined",
          "onClick:clear": () => se.value = [],
          appendIcon: tt.value,
          "onClick:append": () => me(!de.value)
        }, {
          ...ae,
          chip: (Re) => {
            var Ce;
            return createVNode(VChip, {
              onClick: (Ce = Re.item.raw) != null && Ce.sortable ? () => le(Re.item.raw) : void 0,
              onMousedown: (_e) => {
                _e.preventDefault(), _e.stopPropagation();
              }
            }, {
              default: () => [Re.item.title, createVNode(VIcon, {
                class: ["v-data-table__td-sort-icon", ce(Re.item.raw) && "v-data-table__td-sort-icon-active"],
                icon: Pe(Re.item.raw),
                size: "small"
              }, null)]
            });
          }
        })])]
      });
    };
    useRender(() => Oe.value ? createVNode("tr", null, [createVNode(Ze, null, null)]) : createVNode(Fragment, null, [ae.headers ? ae.headers(Ne.value) : ge.value.map((Fe, Ke) => createVNode("tr", null, [Fe.map((tt, Re) => createVNode(Ue, {
      column: tt,
      x: Re,
      y: Ke
    }, null))])), re.loading && createVNode("tr", {
      class: "v-data-table-progress"
    }, [createVNode("th", {
      colspan: pe.value.length
    }, [createVNode(LoaderSlot, {
      name: "v-data-table-progress",
      absolute: !0,
      active: !0,
      color: typeof re.loading == "boolean" ? void 0 : re.loading,
      indeterminate: !0
    }, {
      default: ae.loader
    })])])]));
  }
}), makeVDataTableGroupHeaderRowProps = propsFactory({
  item: {
    type: Object,
    required: !0
  }
}, "VDataTableGroupHeaderRow"), VDataTableGroupHeaderRow = genericComponent()({
  name: "VDataTableGroupHeaderRow",
  props: makeVDataTableGroupHeaderRowProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      isGroupOpen: ie,
      toggleGroup: le,
      extractRows: se
    } = useGroupBy(), {
      isSelected: ce,
      isSomeSelected: ue,
      select: de
    } = useSelection(), {
      columns: me
    } = useHeaders(), fe = computed(() => se([re.item]));
    return () => createVNode("tr", {
      class: "v-data-table-group-header-row",
      style: {
        "--v-data-table-group-header-row-depth": re.item.depth
      }
    }, [me.value.map((pe) => {
      var ge, be;
      if (pe.key === "data-table-group") {
        const Se = ie(re.item) ? "$expand" : "$next", Pe = () => le(re.item);
        return ((ge = ae["data-table-group"]) == null ? void 0 : ge.call(ae, {
          item: re.item,
          count: fe.value.length,
          props: {
            icon: Se,
            onClick: Pe
          }
        })) ?? createVNode(VDataTableColumn, {
          class: "v-data-table-group-header-row__column"
        }, {
          default: () => [createVNode(VBtn, {
            size: "small",
            variant: "text",
            icon: Se,
            onClick: Pe
          }, null), createVNode("span", null, [re.item.value]), createVNode("span", null, [createTextVNode("("), fe.value.length, createTextVNode(")")])]
        });
      }
      if (pe.key === "data-table-select") {
        const Se = ce(fe.value), Pe = ue(fe.value) && !Se, Ee = (Ve) => de(fe.value, Ve);
        return ((be = ae["data-table-select"]) == null ? void 0 : be.call(ae, {
          props: {
            modelValue: Se,
            indeterminate: Pe,
            "onUpdate:modelValue": Ee
          }
        })) ?? createVNode("td", null, [createVNode(VCheckboxBtn, {
          modelValue: Se,
          indeterminate: Pe,
          "onUpdate:modelValue": Ee
        }, null)]);
      }
      return createVNode("td", null, null);
    })]);
  }
}), makeVDataTableRowProps = propsFactory({
  index: Number,
  item: Object,
  cellProps: [Object, Function],
  onClick: EventProp(),
  onContextmenu: EventProp(),
  onDblclick: EventProp(),
  ...makeDisplayProps()
}, "VDataTableRow"), VDataTableRow = genericComponent()({
  name: "VDataTableRow",
  props: makeVDataTableRowProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      displayClasses: ie,
      mobile: le
    } = useDisplay(re, "v-data-table__tr"), {
      isSelected: se,
      toggleSelect: ce,
      someSelected: ue,
      allSelected: de,
      selectAll: me
    } = useSelection(), {
      isExpanded: fe,
      toggleExpand: pe
    } = useExpanded(), {
      toggleSort: ge,
      sortBy: be,
      isSorted: Se
    } = useSort(), {
      columns: Pe
    } = useHeaders();
    useRender(() => createVNode("tr", {
      class: ["v-data-table__tr", {
        "v-data-table__tr--clickable": !!(re.onClick || re.onContextmenu || re.onDblclick)
      }, ie.value],
      onClick: re.onClick,
      onContextmenu: re.onContextmenu,
      onDblclick: re.onDblclick
    }, [re.item && Pe.value.map((Ee, Ve) => {
      const Ae = re.item, Oe = `item.${Ee.key}`, Ne = `header.${Ee.key}`, He = {
        index: re.index,
        item: Ae.raw,
        internalItem: Ae,
        value: getObjectValueByPath(Ae.columns, Ee.key),
        column: Ee,
        isSelected: se,
        toggleSelect: ce,
        isExpanded: fe,
        toggleExpand: pe
      }, Ue = {
        column: Ee,
        selectAll: me,
        isSorted: Se,
        toggleSort: ge,
        sortBy: be.value,
        someSelected: ue.value,
        allSelected: de.value,
        getSortIcon: () => ""
      }, Ze = typeof re.cellProps == "function" ? re.cellProps({
        index: He.index,
        item: He.item,
        internalItem: He.internalItem,
        value: He.value,
        column: Ee
      }) : re.cellProps, Fe = typeof Ee.cellProps == "function" ? Ee.cellProps({
        index: He.index,
        item: He.item,
        internalItem: He.internalItem,
        value: He.value
      }) : Ee.cellProps;
      return createVNode(VDataTableColumn, mergeProps({
        align: Ee.align,
        class: {
          "v-data-table__td--expanded-row": Ee.key === "data-table-expand",
          "v-data-table__td--select-row": Ee.key === "data-table-select"
        },
        fixed: Ee.fixed,
        fixedOffset: Ee.fixedOffset,
        lastFixed: Ee.lastFixed,
        maxWidth: le.value ? void 0 : Ee.maxWidth,
        noPadding: Ee.key === "data-table-select" || Ee.key === "data-table-expand",
        nowrap: Ee.nowrap,
        width: le.value ? void 0 : Ee.width
      }, Ze, Fe), {
        default: () => {
          var tt, Re, Ce, _e;
          if (Ee.key === "data-table-select")
            return ((tt = ae["item.data-table-select"]) == null ? void 0 : tt.call(ae, {
              ...He,
              props: {
                disabled: !Ae.selectable,
                modelValue: se([Ae]),
                onClick: withModifiers(() => ce(Ae), ["stop"])
              }
            })) ?? createVNode(VCheckboxBtn, {
              disabled: !Ae.selectable,
              modelValue: se([Ae]),
              onClick: withModifiers(() => ce(Ae), ["stop"])
            }, null);
          if (Ee.key === "data-table-expand")
            return ((Re = ae["item.data-table-expand"]) == null ? void 0 : Re.call(ae, {
              ...He,
              props: {
                icon: fe(Ae) ? "$collapse" : "$expand",
                size: "small",
                variant: "text",
                onClick: withModifiers(() => pe(Ae), ["stop"])
              }
            })) ?? createVNode(VBtn, {
              icon: fe(Ae) ? "$collapse" : "$expand",
              size: "small",
              variant: "text",
              onClick: withModifiers(() => pe(Ae), ["stop"])
            }, null);
          if (ae[Oe] && !le.value) return ae[Oe](He);
          const Ke = toDisplayString$1(He.value);
          return le.value ? createVNode(Fragment, null, [createVNode("div", {
            class: "v-data-table__td-title"
          }, [((Ce = ae[Ne]) == null ? void 0 : Ce.call(ae, Ue)) ?? Ee.title]), createVNode("div", {
            class: "v-data-table__td-value"
          }, [((_e = ae[Oe]) == null ? void 0 : _e.call(ae, He)) ?? Ke])]) : Ke;
        }
      });
    })]));
  }
}), makeVDataTableRowsProps = propsFactory({
  loading: [Boolean, String],
  loadingText: {
    type: String,
    default: "$vuetify.dataIterator.loadingText"
  },
  hideNoData: Boolean,
  items: {
    type: Array,
    default: () => []
  },
  noDataText: {
    type: String,
    default: "$vuetify.noDataText"
  },
  rowProps: [Object, Function],
  cellProps: [Object, Function],
  ...makeDisplayProps()
}, "VDataTableRows"), VDataTableRows = genericComponent()({
  name: "VDataTableRows",
  inheritAttrs: !1,
  props: makeVDataTableRowsProps(),
  setup(re, ne) {
    let {
      attrs: ae,
      slots: ie
    } = ne;
    const {
      columns: le
    } = useHeaders(), {
      expandOnClick: se,
      toggleExpand: ce,
      isExpanded: ue
    } = useExpanded(), {
      isSelected: de,
      toggleSelect: me
    } = useSelection(), {
      toggleGroup: fe,
      isGroupOpen: pe
    } = useGroupBy(), {
      t: ge
    } = useLocale(), {
      mobile: be
    } = useDisplay(re);
    return useRender(() => {
      var Se, Pe;
      return re.loading && (!re.items.length || ie.loading) ? createVNode("tr", {
        class: "v-data-table-rows-loading",
        key: "loading"
      }, [createVNode("td", {
        colspan: le.value.length
      }, [((Se = ie.loading) == null ? void 0 : Se.call(ie)) ?? ge(re.loadingText)])]) : !re.loading && !re.items.length && !re.hideNoData ? createVNode("tr", {
        class: "v-data-table-rows-no-data",
        key: "no-data"
      }, [createVNode("td", {
        colspan: le.value.length
      }, [((Pe = ie["no-data"]) == null ? void 0 : Pe.call(ie)) ?? ge(re.noDataText)])]) : createVNode(Fragment, null, [re.items.map((Ee, Ve) => {
        var Ne;
        if (Ee.type === "group") {
          const He = {
            index: Ve,
            item: Ee,
            columns: le.value,
            isExpanded: ue,
            toggleExpand: ce,
            isSelected: de,
            toggleSelect: me,
            toggleGroup: fe,
            isGroupOpen: pe
          };
          return ie["group-header"] ? ie["group-header"](He) : createVNode(VDataTableGroupHeaderRow, mergeProps({
            key: `group-header_${Ee.id}`,
            item: Ee
          }, getPrefixedEventHandlers(ae, ":group-header", () => He)), ie);
        }
        const Ae = {
          index: Ve,
          item: Ee.raw,
          internalItem: Ee,
          columns: le.value,
          isExpanded: ue,
          toggleExpand: ce,
          isSelected: de,
          toggleSelect: me
        }, Oe = {
          ...Ae,
          props: mergeProps({
            key: `item_${Ee.key ?? Ee.index}`,
            onClick: se.value ? () => {
              ce(Ee);
            } : void 0,
            index: Ve,
            item: Ee,
            cellProps: re.cellProps,
            mobile: be.value
          }, getPrefixedEventHandlers(ae, ":row", () => Ae), typeof re.rowProps == "function" ? re.rowProps({
            item: Ae.item,
            index: Ae.index,
            internalItem: Ae.internalItem
          }) : re.rowProps)
        };
        return createVNode(Fragment, {
          key: Oe.props.key
        }, [ie.item ? ie.item(Oe) : createVNode(VDataTableRow, Oe.props, ie), ue(Ee) && ((Ne = ie["expanded-row"]) == null ? void 0 : Ne.call(ie, Ae))]);
      })]);
    }), {};
  }
}), makeVTableProps = propsFactory({
  fixedHeader: Boolean,
  fixedFooter: Boolean,
  height: [Number, String],
  hover: Boolean,
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeTagProps(),
  ...makeThemeProps()
}, "VTable"), VTable = genericComponent()({
  name: "VTable",
  props: makeVTableProps(),
  setup(re, ne) {
    let {
      slots: ae,
      emit: ie
    } = ne;
    const {
      themeClasses: le
    } = provideTheme(re), {
      densityClasses: se
    } = useDensity(re);
    return useRender(() => createVNode(re.tag, {
      class: ["v-table", {
        "v-table--fixed-height": !!re.height,
        "v-table--fixed-header": re.fixedHeader,
        "v-table--fixed-footer": re.fixedFooter,
        "v-table--has-top": !!ae.top,
        "v-table--has-bottom": !!ae.bottom,
        "v-table--hover": re.hover
      }, le.value, se.value, re.class],
      style: re.style
    }, {
      default: () => {
        var ce, ue, de;
        return [(ce = ae.top) == null ? void 0 : ce.call(ae), ae.default ? createVNode("div", {
          class: "v-table__wrapper",
          style: {
            height: convertToUnit(re.height)
          }
        }, [createVNode("table", null, [ae.default()])]) : (ue = ae.wrapper) == null ? void 0 : ue.call(ae), (de = ae.bottom) == null ? void 0 : de.call(ae)];
      }
    })), {};
  }
}), makeDataTableItemsProps = propsFactory({
  items: {
    type: Array,
    default: () => []
  },
  itemValue: {
    type: [String, Array, Function],
    default: "id"
  },
  itemSelectable: {
    type: [String, Array, Function],
    default: null
  },
  rowProps: [Object, Function],
  cellProps: [Object, Function],
  returnObject: Boolean
}, "DataTable-items");
function transformItem(re, ne, ae, ie) {
  const le = re.returnObject ? ne : getPropertyFromItem(ne, re.itemValue), se = getPropertyFromItem(ne, re.itemSelectable, !0), ce = ie.reduce((ue, de) => (de.key != null && (ue[de.key] = getPropertyFromItem(ne, de.value)), ue), {});
  return {
    type: "item",
    key: re.returnObject ? getPropertyFromItem(ne, re.itemValue) : le,
    index: ae,
    value: le,
    selectable: se,
    columns: ce,
    raw: ne
  };
}
function transformItems(re, ne, ae) {
  return ne.map((ie, le) => transformItem(re, ie, le, ae));
}
function useDataTableItems(re, ne) {
  return {
    items: computed(() => transformItems(re, re.items, ne.value))
  };
}
const makeDataTableProps = propsFactory({
  ...makeVDataTableRowsProps(),
  hideDefaultBody: Boolean,
  hideDefaultFooter: Boolean,
  hideDefaultHeader: Boolean,
  width: [String, Number],
  search: String,
  ...makeDataTableExpandProps(),
  ...makeDataTableGroupProps(),
  ...makeDataTableHeaderProps(),
  ...makeDataTableItemsProps(),
  ...makeDataTableSelectProps(),
  ...makeDataTableSortProps(),
  ...makeVDataTableHeadersProps(),
  ...makeVTableProps()
}, "DataTable"), makeVDataTableProps = propsFactory({
  ...makeDataTablePaginateProps(),
  ...makeDataTableProps(),
  ...makeFilterProps(),
  ...makeVDataTableFooterProps()
}, "VDataTable"), VDataTable = genericComponent()({
  name: "VDataTable",
  props: makeVDataTableProps(),
  emits: {
    "update:modelValue": (re) => !0,
    "update:page": (re) => !0,
    "update:itemsPerPage": (re) => !0,
    "update:sortBy": (re) => !0,
    "update:options": (re) => !0,
    "update:groupBy": (re) => !0,
    "update:expanded": (re) => !0,
    "update:currentItems": (re) => !0
  },
  setup(re, ne) {
    let {
      attrs: ae,
      slots: ie
    } = ne;
    const {
      groupBy: le
    } = createGroupBy(re), {
      sortBy: se,
      multiSort: ce,
      mustSort: ue
    } = createSort(re), {
      page: de,
      itemsPerPage: me
    } = createPagination(re), {
      disableSort: fe
    } = toRefs(re), {
      columns: pe,
      headers: ge,
      sortFunctions: be,
      sortRawFunctions: Se,
      filterFunctions: Pe
    } = createHeaders(re, {
      groupBy: le,
      showSelect: toRef(re, "showSelect"),
      showExpand: toRef(re, "showExpand")
    }), {
      items: Ee
    } = useDataTableItems(re, pe), Ve = toRef(re, "search"), {
      filteredItems: Ae
    } = useFilter(re, Ee, Ve, {
      transform: (De) => De.columns,
      customKeyFilter: Pe
    }), {
      toggleSort: Oe
    } = provideSort({
      sortBy: se,
      multiSort: ce,
      mustSort: ue,
      page: de
    }), {
      sortByWithGroups: Ne,
      opened: He,
      extractRows: Ue,
      isGroupOpen: Ze,
      toggleGroup: Fe
    } = provideGroupBy({
      groupBy: le,
      sortBy: se,
      disableSort: fe
    }), {
      sortedItems: Ke
    } = useSortedItems(re, Ae, Ne, {
      transform: (De) => ({
        ...De.raw,
        ...De.columns
      }),
      sortFunctions: be,
      sortRawFunctions: Se
    }), {
      flatItems: tt
    } = useGroupedItems(Ke, le, He), Re = computed(() => tt.value.length), {
      startIndex: Ce,
      stopIndex: _e,
      pageCount: he,
      setItemsPerPage: ve
    } = providePagination({
      page: de,
      itemsPerPage: me,
      itemsLength: Re
    }), {
      paginatedItems: xe
    } = usePaginatedItems({
      items: tt,
      startIndex: Ce,
      stopIndex: _e,
      itemsPerPage: me
    }), $e = computed(() => Ue(xe.value)), {
      isSelected: Te,
      select: Ie,
      selectAll: we,
      toggleSelect: ke,
      someSelected: ye,
      allSelected: Be
    } = provideSelection(re, {
      allItems: Ee,
      currentPage: $e
    }), {
      isExpanded: Xe,
      toggleExpand: et
    } = provideExpanded(re);
    useOptions({
      page: de,
      itemsPerPage: me,
      sortBy: se,
      groupBy: le,
      search: Ve
    }), provideDefaults({
      VDataTableRows: {
        hideNoData: toRef(re, "hideNoData"),
        noDataText: toRef(re, "noDataText"),
        loading: toRef(re, "loading"),
        loadingText: toRef(re, "loadingText")
      }
    });
    const Ye = computed(() => ({
      page: de.value,
      itemsPerPage: me.value,
      sortBy: se.value,
      pageCount: he.value,
      toggleSort: Oe,
      setItemsPerPage: ve,
      someSelected: ye.value,
      allSelected: Be.value,
      isSelected: Te,
      select: Ie,
      selectAll: we,
      toggleSelect: ke,
      isExpanded: Xe,
      toggleExpand: et,
      isGroupOpen: Ze,
      toggleGroup: Fe,
      items: $e.value.map((De) => De.raw),
      internalItems: $e.value,
      groupedItems: xe.value,
      columns: pe.value,
      headers: ge.value
    }));
    return useRender(() => {
      const De = VDataTableFooter.filterProps(re), je = VDataTableHeaders.filterProps(re), rt = VDataTableRows.filterProps(re), at = VTable.filterProps(re);
      return createVNode(VTable, mergeProps({
        class: ["v-data-table", {
          "v-data-table--show-select": re.showSelect,
          "v-data-table--loading": re.loading
        }, re.class],
        style: re.style
      }, at, {
        fixedHeader: re.fixedHeader || re.sticky
      }), {
        top: () => {
          var qe;
          return (qe = ie.top) == null ? void 0 : qe.call(ie, Ye.value);
        },
        default: () => {
          var qe, We, ze, Ge, nt, ot;
          return ie.default ? ie.default(Ye.value) : createVNode(Fragment, null, [(qe = ie.colgroup) == null ? void 0 : qe.call(ie, Ye.value), !re.hideDefaultHeader && createVNode("thead", {
            key: "thead"
          }, [createVNode(VDataTableHeaders, je, ie)]), (We = ie.thead) == null ? void 0 : We.call(ie, Ye.value), !re.hideDefaultBody && createVNode("tbody", null, [(ze = ie["body.prepend"]) == null ? void 0 : ze.call(ie, Ye.value), ie.body ? ie.body(Ye.value) : createVNode(VDataTableRows, mergeProps(ae, rt, {
            items: xe.value
          }), ie), (Ge = ie["body.append"]) == null ? void 0 : Ge.call(ie, Ye.value)]), (nt = ie.tbody) == null ? void 0 : nt.call(ie, Ye.value), (ot = ie.tfoot) == null ? void 0 : ot.call(ie, Ye.value)]);
        },
        bottom: () => ie.bottom ? ie.bottom(Ye.value) : !re.hideDefaultFooter && createVNode(Fragment, null, [createVNode(VDivider, null, null), createVNode(VDataTableFooter, De, {
          prepend: ie["footer.prepend"]
        })])
      });
    }), {};
  }
}), makeVDataTableVirtualProps = propsFactory({
  ...makeDataTableProps(),
  ...makeDataTableGroupProps(),
  ...makeVirtualProps(),
  ...makeFilterProps()
}, "VDataTableVirtual"), VDataTableVirtual = genericComponent()({
  name: "VDataTableVirtual",
  props: makeVDataTableVirtualProps(),
  emits: {
    "update:modelValue": (re) => !0,
    "update:sortBy": (re) => !0,
    "update:options": (re) => !0,
    "update:groupBy": (re) => !0,
    "update:expanded": (re) => !0
  },
  setup(re, ne) {
    let {
      attrs: ae,
      slots: ie
    } = ne;
    const {
      groupBy: le
    } = createGroupBy(re), {
      sortBy: se,
      multiSort: ce,
      mustSort: ue
    } = createSort(re), {
      disableSort: de
    } = toRefs(re), {
      columns: me,
      headers: fe,
      filterFunctions: pe,
      sortFunctions: ge,
      sortRawFunctions: be
    } = createHeaders(re, {
      groupBy: le,
      showSelect: toRef(re, "showSelect"),
      showExpand: toRef(re, "showExpand")
    }), {
      items: Se
    } = useDataTableItems(re, me), Pe = toRef(re, "search"), {
      filteredItems: Ee
    } = useFilter(re, Se, Pe, {
      transform: (je) => je.columns,
      customKeyFilter: pe
    }), {
      toggleSort: Ve
    } = provideSort({
      sortBy: se,
      multiSort: ce,
      mustSort: ue
    }), {
      sortByWithGroups: Ae,
      opened: Oe,
      extractRows: Ne,
      isGroupOpen: He,
      toggleGroup: Ue
    } = provideGroupBy({
      groupBy: le,
      sortBy: se,
      disableSort: de
    }), {
      sortedItems: Ze
    } = useSortedItems(re, Ee, Ae, {
      transform: (je) => ({
        ...je.raw,
        ...je.columns
      }),
      sortFunctions: ge,
      sortRawFunctions: be
    }), {
      flatItems: Fe
    } = useGroupedItems(Ze, le, Oe), Ke = computed(() => Ne(Fe.value)), {
      isSelected: tt,
      select: Re,
      selectAll: Ce,
      toggleSelect: _e,
      someSelected: he,
      allSelected: ve
    } = provideSelection(re, {
      allItems: Ke,
      currentPage: Ke
    }), {
      isExpanded: xe,
      toggleExpand: $e
    } = provideExpanded(re), {
      containerRef: Te,
      markerRef: Ie,
      paddingTop: we,
      paddingBottom: ke,
      computedItems: ye,
      handleItemResize: Be,
      handleScroll: Xe,
      handleScrollend: et
    } = useVirtual(re, Fe), Ye = computed(() => ye.value.map((je) => je.raw));
    useOptions({
      sortBy: se,
      page: shallowRef(1),
      itemsPerPage: shallowRef(-1),
      groupBy: le,
      search: Pe
    }), provideDefaults({
      VDataTableRows: {
        hideNoData: toRef(re, "hideNoData"),
        noDataText: toRef(re, "noDataText"),
        loading: toRef(re, "loading"),
        loadingText: toRef(re, "loadingText")
      }
    });
    const De = computed(() => ({
      sortBy: se.value,
      toggleSort: Ve,
      someSelected: he.value,
      allSelected: ve.value,
      isSelected: tt,
      select: Re,
      selectAll: Ce,
      toggleSelect: _e,
      isExpanded: xe,
      toggleExpand: $e,
      isGroupOpen: He,
      toggleGroup: Ue,
      items: Ke.value.map((je) => je.raw),
      internalItems: Ke.value,
      groupedItems: Fe.value,
      columns: me.value,
      headers: fe.value
    }));
    useRender(() => {
      const je = VDataTableHeaders.filterProps(re), rt = VDataTableRows.filterProps(re), at = VTable.filterProps(re);
      return createVNode(VTable, mergeProps({
        class: ["v-data-table", {
          "v-data-table--loading": re.loading
        }, re.class],
        style: re.style
      }, at, {
        fixedHeader: re.fixedHeader || re.sticky
      }), {
        top: () => {
          var qe;
          return (qe = ie.top) == null ? void 0 : qe.call(ie, De.value);
        },
        wrapper: () => {
          var qe, We, ze;
          return createVNode("div", {
            ref: Te,
            onScrollPassive: Xe,
            onScrollend: et,
            class: "v-table__wrapper",
            style: {
              height: convertToUnit(re.height)
            }
          }, [createVNode("table", null, [(qe = ie.colgroup) == null ? void 0 : qe.call(ie, De.value), !re.hideDefaultHeader && createVNode("thead", {
            key: "thead"
          }, [createVNode(VDataTableHeaders, je, ie)]), !re.hideDefaultBody && createVNode("tbody", null, [createVNode("tr", {
            ref: Ie,
            style: {
              height: convertToUnit(we.value),
              border: 0
            }
          }, [createVNode("td", {
            colspan: me.value.length,
            style: {
              height: 0,
              border: 0
            }
          }, null)]), (We = ie["body.prepend"]) == null ? void 0 : We.call(ie, De.value), createVNode(VDataTableRows, mergeProps(ae, rt, {
            items: Ye.value
          }), {
            ...ie,
            item: (Ge) => createVNode(VVirtualScrollItem, {
              key: Ge.internalItem.index,
              renderless: !0,
              "onUpdate:height": (nt) => Be(Ge.internalItem.index, nt)
            }, {
              default: (nt) => {
                var lt;
                let {
                  itemRef: ot
                } = nt;
                return ((lt = ie.item) == null ? void 0 : lt.call(ie, {
                  ...Ge,
                  itemRef: ot
                })) ?? createVNode(VDataTableRow, mergeProps(Ge.props, {
                  ref: ot,
                  key: Ge.internalItem.index,
                  index: Ge.internalItem.index
                }), ie);
              }
            })
          }), (ze = ie["body.append"]) == null ? void 0 : ze.call(ie, De.value), createVNode("tr", {
            style: {
              height: convertToUnit(ke.value),
              border: 0
            }
          }, [createVNode("td", {
            colspan: me.value.length,
            style: {
              height: 0,
              border: 0
            }
          }, null)])])])]);
        },
        bottom: () => {
          var qe;
          return (qe = ie.bottom) == null ? void 0 : qe.call(ie, De.value);
        }
      });
    });
  }
}), makeVDataTableServerProps = propsFactory({
  itemsLength: {
    type: [Number, String],
    required: !0
  },
  ...makeDataTablePaginateProps(),
  ...makeDataTableProps(),
  ...makeVDataTableFooterProps()
}, "VDataTableServer"), VDataTableServer = genericComponent()({
  name: "VDataTableServer",
  props: makeVDataTableServerProps(),
  emits: {
    "update:modelValue": (re) => !0,
    "update:page": (re) => !0,
    "update:itemsPerPage": (re) => !0,
    "update:sortBy": (re) => !0,
    "update:options": (re) => !0,
    "update:expanded": (re) => !0,
    "update:groupBy": (re) => !0
  },
  setup(re, ne) {
    let {
      attrs: ae,
      slots: ie
    } = ne;
    const {
      groupBy: le
    } = createGroupBy(re), {
      sortBy: se,
      multiSort: ce,
      mustSort: ue
    } = createSort(re), {
      page: de,
      itemsPerPage: me
    } = createPagination(re), {
      disableSort: fe
    } = toRefs(re), pe = computed(() => parseInt(re.itemsLength, 10)), {
      columns: ge,
      headers: be
    } = createHeaders(re, {
      groupBy: le,
      showSelect: toRef(re, "showSelect"),
      showExpand: toRef(re, "showExpand")
    }), {
      items: Se
    } = useDataTableItems(re, ge), {
      toggleSort: Pe
    } = provideSort({
      sortBy: se,
      multiSort: ce,
      mustSort: ue,
      page: de
    }), {
      opened: Ee,
      isGroupOpen: Ve,
      toggleGroup: Ae,
      extractRows: Oe
    } = provideGroupBy({
      groupBy: le,
      sortBy: se,
      disableSort: fe
    }), {
      pageCount: Ne,
      setItemsPerPage: He
    } = providePagination({
      page: de,
      itemsPerPage: me,
      itemsLength: pe
    }), {
      flatItems: Ue
    } = useGroupedItems(Se, le, Ee), {
      isSelected: Ze,
      select: Fe,
      selectAll: Ke,
      toggleSelect: tt,
      someSelected: Re,
      allSelected: Ce
    } = provideSelection(re, {
      allItems: Se,
      currentPage: Se
    }), {
      isExpanded: _e,
      toggleExpand: he
    } = provideExpanded(re), ve = computed(() => Oe(Se.value));
    useOptions({
      page: de,
      itemsPerPage: me,
      sortBy: se,
      groupBy: le,
      search: toRef(re, "search")
    }), provide("v-data-table", {
      toggleSort: Pe,
      sortBy: se
    }), provideDefaults({
      VDataTableRows: {
        hideNoData: toRef(re, "hideNoData"),
        noDataText: toRef(re, "noDataText"),
        loading: toRef(re, "loading"),
        loadingText: toRef(re, "loadingText")
      }
    });
    const xe = computed(() => ({
      page: de.value,
      itemsPerPage: me.value,
      sortBy: se.value,
      pageCount: Ne.value,
      toggleSort: Pe,
      setItemsPerPage: He,
      someSelected: Re.value,
      allSelected: Ce.value,
      isSelected: Ze,
      select: Fe,
      selectAll: Ke,
      toggleSelect: tt,
      isExpanded: _e,
      toggleExpand: he,
      isGroupOpen: Ve,
      toggleGroup: Ae,
      items: ve.value.map(($e) => $e.raw),
      internalItems: ve.value,
      groupedItems: Ue.value,
      columns: ge.value,
      headers: be.value
    }));
    useRender(() => {
      const $e = VDataTableFooter.filterProps(re), Te = VDataTableHeaders.filterProps(re), Ie = VDataTableRows.filterProps(re), we = VTable.filterProps(re);
      return createVNode(VTable, mergeProps({
        class: ["v-data-table", {
          "v-data-table--loading": re.loading
        }, re.class],
        style: re.style
      }, we, {
        fixedHeader: re.fixedHeader || re.sticky
      }), {
        top: () => {
          var ke;
          return (ke = ie.top) == null ? void 0 : ke.call(ie, xe.value);
        },
        default: () => {
          var ke, ye, Be, Xe, et, Ye;
          return ie.default ? ie.default(xe.value) : createVNode(Fragment, null, [(ke = ie.colgroup) == null ? void 0 : ke.call(ie, xe.value), !re.hideDefaultHeader && createVNode("thead", {
            key: "thead",
            class: "v-data-table__thead",
            role: "rowgroup"
          }, [createVNode(VDataTableHeaders, Te, ie)]), (ye = ie.thead) == null ? void 0 : ye.call(ie, xe.value), !re.hideDefaultBody && createVNode("tbody", {
            class: "v-data-table__tbody",
            role: "rowgroup"
          }, [(Be = ie["body.prepend"]) == null ? void 0 : Be.call(ie, xe.value), ie.body ? ie.body(xe.value) : createVNode(VDataTableRows, mergeProps(ae, Ie, {
            items: Ue.value
          }), ie), (Xe = ie["body.append"]) == null ? void 0 : Xe.call(ie, xe.value)]), (et = ie.tbody) == null ? void 0 : et.call(ie, xe.value), (Ye = ie.tfoot) == null ? void 0 : Ye.call(ie, xe.value)]);
        },
        bottom: () => ie.bottom ? ie.bottom(xe.value) : !re.hideDefaultFooter && createVNode(Fragment, null, [createVNode(VDivider, null, null), createVNode(VDataTableFooter, $e, {
          prepend: ie["footer.prepend"]
        })])
      });
    });
  }
}), makeVDatePickerControlsProps = propsFactory({
  active: {
    type: [String, Array],
    default: void 0
  },
  disabled: {
    type: [Boolean, String, Array],
    default: null
  },
  nextIcon: {
    type: IconValue,
    default: "$next"
  },
  prevIcon: {
    type: IconValue,
    default: "$prev"
  },
  modeIcon: {
    type: IconValue,
    default: "$subgroup"
  },
  text: String,
  viewMode: {
    type: String,
    default: "month"
  }
}, "VDatePickerControls"), VDatePickerControls = genericComponent()({
  name: "VDatePickerControls",
  props: makeVDatePickerControlsProps(),
  emits: {
    "click:year": () => !0,
    "click:month": () => !0,
    "click:prev": () => !0,
    "click:next": () => !0,
    "click:text": () => !0
  },
  setup(re, ne) {
    let {
      emit: ae
    } = ne;
    const ie = computed(() => Array.isArray(re.disabled) ? re.disabled.includes("text") : !!re.disabled), le = computed(() => Array.isArray(re.disabled) ? re.disabled.includes("mode") : !!re.disabled), se = computed(() => Array.isArray(re.disabled) ? re.disabled.includes("prev") : !!re.disabled), ce = computed(() => Array.isArray(re.disabled) ? re.disabled.includes("next") : !!re.disabled);
    function ue() {
      ae("click:prev");
    }
    function de() {
      ae("click:next");
    }
    function me() {
      ae("click:year");
    }
    function fe() {
      ae("click:month");
    }
    return useRender(() => createVNode("div", {
      class: ["v-date-picker-controls"]
    }, [createVNode(VBtn, {
      class: "v-date-picker-controls__month-btn",
      "data-testid": "month-btn",
      disabled: ie.value,
      text: re.text,
      variant: "text",
      rounded: !0,
      onClick: fe
    }, null), createVNode(VBtn, {
      class: "v-date-picker-controls__mode-btn",
      "data-testid": "year-btn",
      disabled: le.value,
      density: "comfortable",
      icon: re.modeIcon,
      variant: "text",
      onClick: me
    }, null), createVNode(VSpacer, null, null), createVNode("div", {
      class: "v-date-picker-controls__month"
    }, [createVNode(VBtn, {
      "data-testid": "prev-month",
      disabled: se.value,
      icon: re.prevIcon,
      variant: "text",
      onClick: ue
    }, null), createVNode(VBtn, {
      "data-testid": "next-month",
      disabled: ce.value,
      icon: re.nextIcon,
      variant: "text",
      onClick: de
    }, null)])])), {};
  }
}), makeVDatePickerHeaderProps = propsFactory({
  appendIcon: IconValue,
  color: String,
  header: String,
  transition: String,
  onClick: EventProp()
}, "VDatePickerHeader"), VDatePickerHeader = genericComponent()({
  name: "VDatePickerHeader",
  props: makeVDatePickerHeaderProps(),
  emits: {
    click: () => !0,
    "click:append": () => !0
  },
  setup(re, ne) {
    let {
      emit: ae,
      slots: ie
    } = ne;
    const {
      backgroundColorClasses: le,
      backgroundColorStyles: se
    } = useBackgroundColor(re, "color");
    function ce() {
      ae("click");
    }
    function ue() {
      ae("click:append");
    }
    return useRender(() => {
      const de = !!(ie.default || re.header), me = !!(ie.append || re.appendIcon);
      return createVNode("div", {
        class: ["v-date-picker-header", {
          "v-date-picker-header--clickable": !!re.onClick
        }, le.value],
        style: se.value,
        onClick: ce
      }, [ie.prepend && createVNode("div", {
        key: "prepend",
        class: "v-date-picker-header__prepend"
      }, [ie.prepend()]), de && createVNode(MaybeTransition, {
        key: "content",
        name: re.transition
      }, {
        default: () => {
          var fe;
          return [createVNode("div", {
            key: re.header,
            class: "v-date-picker-header__content"
          }, [((fe = ie.default) == null ? void 0 : fe.call(ie)) ?? re.header])];
        }
      }), me && createVNode("div", {
        class: "v-date-picker-header__append"
      }, [ie.append ? createVNode(VDefaultsProvider, {
        key: "append-defaults",
        disabled: !re.appendIcon,
        defaults: {
          VBtn: {
            icon: re.appendIcon,
            variant: "text"
          }
        }
      }, {
        default: () => {
          var fe;
          return [(fe = ie.append) == null ? void 0 : fe.call(ie)];
        }
      }) : createVNode(VBtn, {
        key: "append-btn",
        icon: re.appendIcon,
        variant: "text",
        onClick: ue
      }, null)])]);
    }), {};
  }
}), makeCalendarProps = propsFactory({
  allowedDates: [Array, Function],
  disabled: {
    type: Boolean,
    default: null
  },
  displayValue: null,
  modelValue: Array,
  month: [Number, String],
  max: null,
  min: null,
  showAdjacentMonths: Boolean,
  year: [Number, String],
  weekdays: {
    type: Array,
    default: () => [0, 1, 2, 3, 4, 5, 6]
  },
  weeksInMonth: {
    type: String,
    default: "dynamic"
  },
  firstDayOfWeek: [Number, String]
}, "calendar");
function useCalendar(re) {
  const ne = useDate(), ae = useProxiedModel(re, "modelValue", [], (Se) => wrapInArray(Se).map((Pe) => ne.date(Pe))), ie = computed(() => re.displayValue ? ne.date(re.displayValue) : ae.value.length > 0 ? ne.date(ae.value[0]) : re.min ? ne.date(re.min) : Array.isArray(re.allowedDates) ? ne.date(re.allowedDates[0]) : ne.date()), le = useProxiedModel(re, "year", void 0, (Se) => {
    const Pe = Se != null ? Number(Se) : ne.getYear(ie.value);
    return ne.startOfYear(ne.setYear(ne.date(), Pe));
  }, (Se) => ne.getYear(Se)), se = useProxiedModel(re, "month", void 0, (Se) => {
    const Pe = Se != null ? Number(Se) : ne.getMonth(ie.value), Ee = ne.setYear(ne.startOfMonth(ne.date()), ne.getYear(le.value));
    return ne.setMonth(Ee, Pe);
  }, (Se) => ne.getMonth(Se)), ce = computed(() => re.firstDayOfWeek ?? re.weekdays[0]), ue = computed(() => {
    const Se = Number(re.firstDayOfWeek ?? 0);
    return re.weekdays.map((Pe) => (Pe + Se) % 7);
  }), de = computed(() => {
    const Se = ne.getWeekArray(se.value, ce.value), Pe = Se.flat(), Ee = 6 * 7;
    if (re.weeksInMonth === "static" && Pe.length < Ee) {
      const Ve = Pe[Pe.length - 1];
      let Ae = [];
      for (let Oe = 1; Oe <= Ee - Pe.length; Oe++)
        Ae.push(ne.addDays(Ve, Oe)), Oe % 7 === 0 && (Se.push(Ae), Ae = []);
    }
    return Se;
  });
  function me(Se, Pe) {
    return Se.filter((Ee) => ue.value.includes(ne.toJsDate(Ee).getDay())).map((Ee, Ve) => {
      const Ae = ne.toISO(Ee), Oe = !ne.isSameMonth(Ee, se.value), Ne = ne.isSameDay(Ee, ne.startOfMonth(se.value)), He = ne.isSameDay(Ee, ne.endOfMonth(se.value)), Ue = ne.isSameDay(Ee, se.value);
      return {
        date: Ee,
        isoDate: Ae,
        formatted: ne.format(Ee, "keyboardDate"),
        year: ne.getYear(Ee),
        month: ne.getMonth(Ee),
        isDisabled: be(Ee),
        isWeekStart: Ve % 7 === 0,
        isWeekEnd: Ve % 7 === 6,
        isToday: ne.isSameDay(Ee, Pe),
        isAdjacent: Oe,
        isHidden: Oe && !re.showAdjacentMonths,
        isStart: Ne,
        isSelected: ae.value.some((Ze) => ne.isSameDay(Ee, Ze)),
        isEnd: He,
        isSame: Ue,
        localized: ne.format(Ee, "dayOfMonth")
      };
    });
  }
  const fe = computed(() => {
    const Se = ne.startOfWeek(ie.value, re.firstDayOfWeek), Pe = [];
    for (let Ve = 0; Ve <= 6; Ve++)
      Pe.push(ne.addDays(Se, Ve));
    const Ee = ne.date();
    return me(Pe, Ee);
  }), pe = computed(() => {
    const Se = de.value.flat(), Pe = ne.date();
    return me(Se, Pe);
  }), ge = computed(() => de.value.map((Se) => Se.length ? getWeek(ne, Se[0]) : null));
  function be(Se) {
    if (re.disabled) return !0;
    const Pe = ne.date(Se);
    return re.min && ne.isAfter(ne.date(re.min), Pe) || re.max && ne.isAfter(Pe, ne.date(re.max)) ? !0 : Array.isArray(re.allowedDates) && re.allowedDates.length > 0 ? !re.allowedDates.some((Ee) => ne.isSameDay(ne.date(Ee), Pe)) : typeof re.allowedDates == "function" ? !re.allowedDates(Pe) : !1;
  }
  return {
    displayValue: ie,
    daysInMonth: pe,
    daysInWeek: fe,
    genDays: me,
    model: ae,
    weeksInMonth: de,
    weekDays: ue,
    weekNumbers: ge
  };
}
const makeVDatePickerMonthProps = propsFactory({
  color: String,
  hideWeekdays: Boolean,
  multiple: [Boolean, Number, String],
  showWeek: Boolean,
  transition: {
    type: String,
    default: "picker-transition"
  },
  reverseTransition: {
    type: String,
    default: "picker-reverse-transition"
  },
  ...omit(makeCalendarProps(), ["displayValue"])
}, "VDatePickerMonth"), VDatePickerMonth = genericComponent()({
  name: "VDatePickerMonth",
  props: makeVDatePickerMonthProps(),
  emits: {
    "update:modelValue": (re) => !0,
    "update:month": (re) => !0,
    "update:year": (re) => !0
  },
  setup(re, ne) {
    let {
      emit: ae,
      slots: ie
    } = ne;
    const le = ref$1(), {
      daysInMonth: se,
      model: ce,
      weekNumbers: ue
    } = useCalendar(re), de = useDate(), me = shallowRef(), fe = shallowRef(), pe = shallowRef(!1), ge = computed(() => pe.value ? re.reverseTransition : re.transition);
    re.multiple === "range" && ce.value.length > 0 && (me.value = ce.value[0], ce.value.length > 1 && (fe.value = ce.value[ce.value.length - 1]));
    const be = computed(() => {
      const Ve = ["number", "string"].includes(typeof re.multiple) ? Number(re.multiple) : 1 / 0;
      return ce.value.length >= Ve;
    });
    watch(se, (Ve, Ae) => {
      Ae && (pe.value = de.isBefore(Ve[0].date, Ae[0].date));
    });
    function Se(Ve) {
      const Ae = de.startOfDay(Ve);
      if (ce.value.length === 0 ? me.value = void 0 : ce.value.length === 1 && (me.value = ce.value[0], fe.value = void 0), !me.value)
        me.value = Ae, ce.value = [me.value];
      else if (fe.value)
        me.value = Ve, fe.value = void 0, ce.value = [me.value];
      else {
        if (de.isSameDay(Ae, me.value)) {
          me.value = void 0, ce.value = [];
          return;
        } else de.isBefore(Ae, me.value) ? (fe.value = de.endOfDay(me.value), me.value = Ae) : fe.value = de.endOfDay(Ae);
        const Oe = de.getDiff(fe.value, me.value, "days"), Ne = [me.value];
        for (let He = 1; He < Oe; He++) {
          const Ue = de.addDays(me.value, He);
          Ne.push(Ue);
        }
        Ne.push(fe.value), ce.value = Ne;
      }
    }
    function Pe(Ve) {
      const Ae = ce.value.findIndex((Oe) => de.isSameDay(Oe, Ve));
      if (Ae === -1)
        ce.value = [...ce.value, Ve];
      else {
        const Oe = [...ce.value];
        Oe.splice(Ae, 1), ce.value = Oe;
      }
    }
    function Ee(Ve) {
      re.multiple === "range" ? Se(Ve) : re.multiple ? Pe(Ve) : ce.value = [Ve];
    }
    return () => createVNode("div", {
      class: "v-date-picker-month"
    }, [re.showWeek && createVNode("div", {
      key: "weeks",
      class: "v-date-picker-month__weeks"
    }, [!re.hideWeekdays && createVNode("div", {
      key: "hide-week-days",
      class: "v-date-picker-month__day"
    }, [createTextVNode(" ")]), ue.value.map((Ve) => createVNode("div", {
      class: ["v-date-picker-month__day", "v-date-picker-month__day--adjacent"]
    }, [Ve]))]), createVNode(MaybeTransition, {
      name: ge.value
    }, {
      default: () => {
        var Ve;
        return [createVNode("div", {
          ref: le,
          key: (Ve = se.value[0].date) == null ? void 0 : Ve.toString(),
          class: "v-date-picker-month__days"
        }, [!re.hideWeekdays && de.getWeekdays(re.firstDayOfWeek).map((Ae) => createVNode("div", {
          class: ["v-date-picker-month__day", "v-date-picker-month__weekday"]
        }, [Ae])), se.value.map((Ae, Oe) => {
          const Ne = {
            props: {
              onClick: () => Ee(Ae.date)
            },
            item: Ae,
            i: Oe
          };
          return be.value && !Ae.isSelected && (Ae.isDisabled = !0), createVNode("div", {
            class: ["v-date-picker-month__day", {
              "v-date-picker-month__day--adjacent": Ae.isAdjacent,
              "v-date-picker-month__day--hide-adjacent": Ae.isHidden,
              "v-date-picker-month__day--selected": Ae.isSelected,
              "v-date-picker-month__day--week-end": Ae.isWeekEnd,
              "v-date-picker-month__day--week-start": Ae.isWeekStart
            }],
            "data-v-date": Ae.isDisabled ? void 0 : Ae.isoDate
          }, [(re.showAdjacentMonths || !Ae.isAdjacent) && createVNode(VDefaultsProvider, {
            defaults: {
              VBtn: {
                class: "v-date-picker-month__day-btn",
                color: (Ae.isSelected || Ae.isToday) && !Ae.isDisabled ? re.color : void 0,
                disabled: Ae.isDisabled,
                icon: !0,
                ripple: !1,
                text: Ae.localized,
                variant: Ae.isDisabled ? Ae.isToday ? "outlined" : "text" : Ae.isToday && !Ae.isSelected ? "outlined" : "flat",
                onClick: () => Ee(Ae.date)
              }
            }
          }, {
            default: () => {
              var He;
              return [((He = ie.day) == null ? void 0 : He.call(ie, Ne)) ?? createVNode(VBtn, Ne.props, null)];
            }
          })]);
        })])];
      }
    })]);
  }
}), makeVDatePickerMonthsProps = propsFactory({
  color: String,
  height: [String, Number],
  min: null,
  max: null,
  modelValue: Number,
  year: Number
}, "VDatePickerMonths"), VDatePickerMonths = genericComponent()({
  name: "VDatePickerMonths",
  props: makeVDatePickerMonthsProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      emit: ae,
      slots: ie
    } = ne;
    const le = useDate(), se = useProxiedModel(re, "modelValue"), ce = computed(() => {
      let ue = le.startOfYear(le.date());
      return re.year && (ue = le.setYear(ue, re.year)), createRange(12).map((de) => {
        const me = le.format(ue, "monthShort"), fe = !!(re.min && le.isAfter(le.startOfMonth(le.date(re.min)), ue) || re.max && le.isAfter(ue, le.startOfMonth(le.date(re.max))));
        return ue = le.getNextMonth(ue), {
          isDisabled: fe,
          text: me,
          value: de
        };
      });
    });
    return watchEffect(() => {
      se.value = se.value ?? le.getMonth(le.date());
    }), useRender(() => createVNode("div", {
      class: "v-date-picker-months",
      style: {
        height: convertToUnit(re.height)
      }
    }, [createVNode("div", {
      class: "v-date-picker-months__content"
    }, [ce.value.map((ue, de) => {
      var pe;
      const me = {
        active: se.value === de,
        color: se.value === de ? re.color : void 0,
        disabled: ue.isDisabled,
        rounded: !0,
        text: ue.text,
        variant: se.value === ue.value ? "flat" : "text",
        onClick: () => fe(de)
      };
      function fe(ge) {
        if (se.value === ge) {
          ae("update:modelValue", se.value);
          return;
        }
        se.value = ge;
      }
      return ((pe = ie.month) == null ? void 0 : pe.call(ie, {
        month: ue,
        i: de,
        props: me
      })) ?? createVNode(VBtn, mergeProps({
        key: "month"
      }, me), null);
    })])])), {};
  }
}), makeVDatePickerYearsProps = propsFactory({
  color: String,
  height: [String, Number],
  min: null,
  max: null,
  modelValue: Number
}, "VDatePickerYears"), VDatePickerYears = genericComponent()({
  name: "VDatePickerYears",
  props: makeVDatePickerYearsProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      emit: ae,
      slots: ie
    } = ne;
    const le = useDate(), se = useProxiedModel(re, "modelValue"), ce = computed(() => {
      const de = le.getYear(le.date());
      let me = de - 100, fe = de + 52;
      re.min && (me = le.getYear(le.date(re.min))), re.max && (fe = le.getYear(le.date(re.max)));
      let pe = le.startOfYear(le.date());
      return pe = le.setYear(pe, me), createRange(fe - me + 1, me).map((ge) => {
        const be = le.format(pe, "year");
        return pe = le.setYear(pe, le.getYear(pe) + 1), {
          text: be,
          value: ge
        };
      });
    });
    watchEffect(() => {
      se.value = se.value ?? le.getYear(le.date());
    });
    const ue = templateRef();
    return onMounted(async () => {
      var de;
      await nextTick$2(), (de = ue.el) == null || de.scrollIntoView({
        block: "center"
      });
    }), useRender(() => createVNode("div", {
      class: "v-date-picker-years",
      style: {
        height: convertToUnit(re.height)
      }
    }, [createVNode("div", {
      class: "v-date-picker-years__content"
    }, [ce.value.map((de, me) => {
      var pe;
      const fe = {
        ref: se.value === de.value ? ue : void 0,
        active: se.value === de.value,
        color: se.value === de.value ? re.color : void 0,
        rounded: !0,
        text: de.text,
        variant: se.value === de.value ? "flat" : "text",
        onClick: () => {
          if (se.value === de.value) {
            ae("update:modelValue", se.value);
            return;
          }
          se.value = de.value;
        }
      };
      return ((pe = ie.year) == null ? void 0 : pe.call(ie, {
        year: de,
        i: me,
        props: fe
      })) ?? createVNode(VBtn, mergeProps({
        key: "month"
      }, fe), null);
    })])])), {};
  }
}), VPickerTitle = createSimpleFunctional("v-picker-title"), makeVPickerProps = propsFactory({
  bgColor: String,
  landscape: Boolean,
  title: String,
  hideHeader: Boolean,
  ...makeVSheetProps()
}, "VPicker"), VPicker = genericComponent()({
  name: "VPicker",
  props: makeVPickerProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      backgroundColorClasses: ie,
      backgroundColorStyles: le
    } = useBackgroundColor(toRef(re, "color"));
    return useRender(() => {
      const se = VSheet.filterProps(re), ce = !!(re.title || ae.title);
      return createVNode(VSheet, mergeProps(se, {
        color: re.bgColor,
        class: ["v-picker", {
          "v-picker--landscape": re.landscape,
          "v-picker--with-actions": !!ae.actions
        }, re.class],
        style: re.style
      }), {
        default: () => {
          var ue;
          return [!re.hideHeader && createVNode("div", {
            key: "header",
            class: [ie.value],
            style: [le.value]
          }, [ce && createVNode(VPickerTitle, {
            key: "picker-title"
          }, {
            default: () => {
              var de;
              return [((de = ae.title) == null ? void 0 : de.call(ae)) ?? re.title];
            }
          }), ae.header && createVNode("div", {
            class: "v-picker__header"
          }, [ae.header()])]), createVNode("div", {
            class: "v-picker__body"
          }, [(ue = ae.default) == null ? void 0 : ue.call(ae)]), ae.actions && createVNode(VDefaultsProvider, {
            defaults: {
              VBtn: {
                slim: !0,
                variant: "text"
              }
            }
          }, {
            default: () => [createVNode("div", {
              class: "v-picker__actions"
            }, [ae.actions()])]
          })];
        }
      });
    }), {};
  }
}), makeVDatePickerProps = propsFactory({
  // TODO: implement in v3.5
  // calendarIcon: {
  //   type: String,
  //   default: '$calendar',
  // },
  // keyboardIcon: {
  //   type: String,
  //   default: '$edit',
  // },
  // inputMode: {
  //   type: String as PropType<'calendar' | 'keyboard'>,
  //   default: 'calendar',
  // },
  // inputText: {
  //   type: String,
  //   default: '$vuetify.datePicker.input.placeholder',
  // },
  // inputPlaceholder: {
  //   type: String,
  //   default: 'dd/mm/yyyy',
  // },
  header: {
    type: String,
    default: "$vuetify.datePicker.header"
  },
  ...makeVDatePickerControlsProps(),
  ...makeVDatePickerMonthProps({
    weeksInMonth: "static"
  }),
  ...omit(makeVDatePickerMonthsProps(), ["modelValue"]),
  ...omit(makeVDatePickerYearsProps(), ["modelValue"]),
  ...makeVPickerProps({
    title: "$vuetify.datePicker.title"
  }),
  modelValue: null
}, "VDatePicker"), VDatePicker = genericComponent()({
  name: "VDatePicker",
  props: makeVDatePickerProps(),
  emits: {
    "update:modelValue": (re) => !0,
    "update:month": (re) => !0,
    "update:year": (re) => !0,
    // 'update:inputMode': (date: any) => true,
    "update:viewMode": (re) => !0
  },
  setup(re, ne) {
    let {
      emit: ae,
      slots: ie
    } = ne;
    const le = useDate(), {
      t: se
    } = useLocale(), ce = useProxiedModel(re, "modelValue", void 0, (Ke) => wrapInArray(Ke).map((tt) => le.date(tt)), (Ke) => re.multiple ? Ke : Ke[0]), ue = useProxiedModel(re, "viewMode"), de = computed(() => {
      const Ke = le.date(re.min);
      return re.min && le.isValid(Ke) ? Ke : null;
    }), me = computed(() => {
      const Ke = le.date(re.max);
      return re.max && le.isValid(Ke) ? Ke : null;
    }), fe = computed(() => {
      var Re;
      const Ke = le.date();
      let tt = Ke;
      return (Re = ce.value) != null && Re[0] ? tt = le.date(ce.value[0]) : de.value && le.isBefore(Ke, de.value) ? tt = de.value : me.value && le.isAfter(Ke, me.value) && (tt = me.value), tt && le.isValid(tt) ? tt : Ke;
    }), pe = ref$1(Number(re.month ?? le.getMonth(le.startOfMonth(fe.value)))), ge = ref$1(Number(re.year ?? le.getYear(le.startOfYear(le.setMonth(fe.value, pe.value))))), be = shallowRef(!1), Se = computed(() => re.multiple && ce.value.length > 1 ? se("$vuetify.datePicker.itemsSelected", ce.value.length) : ce.value[0] && le.isValid(ce.value[0]) ? le.format(le.date(ce.value[0]), "normalDateWithWeekday") : se(re.header)), Pe = computed(() => {
      let Ke = le.date();
      return Ke = le.setDate(Ke, 1), Ke = le.setMonth(Ke, pe.value), Ke = le.setYear(Ke, ge.value), le.format(Ke, "monthAndYear");
    }), Ee = computed(() => `date-picker-header${be.value ? "-reverse" : ""}-transition`), Ve = computed(() => {
      if (re.disabled) return !0;
      const Ke = [];
      if (ue.value !== "month")
        Ke.push("prev", "next");
      else {
        let tt = le.date();
        if (tt = le.startOfMonth(tt), tt = le.setMonth(tt, pe.value), tt = le.setYear(tt, ge.value), de.value) {
          const Re = le.addDays(le.startOfMonth(tt), -1);
          le.isAfter(de.value, Re) && Ke.push("prev");
        }
        if (me.value) {
          const Re = le.addDays(le.endOfMonth(tt), 1);
          le.isAfter(Re, me.value) && Ke.push("next");
        }
      }
      return Ke;
    });
    function Ae() {
      pe.value < 11 ? pe.value++ : (ge.value++, pe.value = 0, Fe(ge.value)), Ze(pe.value);
    }
    function Oe() {
      pe.value > 0 ? pe.value-- : (ge.value--, pe.value = 11, Fe(ge.value)), Ze(pe.value);
    }
    function Ne() {
      ue.value = "month";
    }
    function He() {
      ue.value = ue.value === "months" ? "month" : "months";
    }
    function Ue() {
      ue.value = ue.value === "year" ? "month" : "year";
    }
    function Ze(Ke) {
      ue.value === "months" && He(), ae("update:month", Ke);
    }
    function Fe(Ke) {
      ue.value === "year" && Ue(), ae("update:year", Ke);
    }
    return watch(ce, (Ke, tt) => {
      const Re = wrapInArray(tt), Ce = wrapInArray(Ke);
      if (!Ce.length) return;
      const _e = le.date(Re[Re.length - 1]), he = le.date(Ce[Ce.length - 1]), ve = le.getMonth(he), xe = le.getYear(he);
      ve !== pe.value && (pe.value = ve, Ze(pe.value)), xe !== ge.value && (ge.value = xe, Fe(ge.value)), be.value = le.isBefore(_e, he);
    }), useRender(() => {
      const Ke = VPicker.filterProps(re), tt = VDatePickerControls.filterProps(re), Re = VDatePickerHeader.filterProps(re), Ce = VDatePickerMonth.filterProps(re), _e = omit(VDatePickerMonths.filterProps(re), ["modelValue"]), he = omit(VDatePickerYears.filterProps(re), ["modelValue"]), ve = {
        header: Se.value,
        transition: Ee.value
      };
      return createVNode(VPicker, mergeProps(Ke, {
        class: ["v-date-picker", `v-date-picker--${ue.value}`, {
          "v-date-picker--show-week": re.showWeek
        }, re.class],
        style: re.style
      }), {
        title: () => {
          var xe;
          return ((xe = ie.title) == null ? void 0 : xe.call(ie)) ?? createVNode("div", {
            class: "v-date-picker__title"
          }, [se(re.title)]);
        },
        header: () => ie.header ? createVNode(VDefaultsProvider, {
          defaults: {
            VDatePickerHeader: {
              ...ve
            }
          }
        }, {
          default: () => {
            var xe;
            return [(xe = ie.header) == null ? void 0 : xe.call(ie, ve)];
          }
        }) : createVNode(VDatePickerHeader, mergeProps({
          key: "header"
        }, Re, ve, {
          onClick: ue.value !== "month" ? Ne : void 0
        }), {
          ...ie,
          default: void 0
        }),
        default: () => createVNode(Fragment, null, [createVNode(VDatePickerControls, mergeProps(tt, {
          disabled: Ve.value,
          text: Pe.value,
          "onClick:next": Ae,
          "onClick:prev": Oe,
          "onClick:month": He,
          "onClick:year": Ue
        }), null), createVNode(VFadeTransition, {
          hideOnLeave: !0
        }, {
          default: () => [ue.value === "months" ? createVNode(VDatePickerMonths, mergeProps({
            key: "date-picker-months"
          }, _e, {
            modelValue: pe.value,
            "onUpdate:modelValue": [(xe) => pe.value = xe, Ze],
            min: de.value,
            max: me.value,
            year: ge.value
          }), null) : ue.value === "year" ? createVNode(VDatePickerYears, mergeProps({
            key: "date-picker-years"
          }, he, {
            modelValue: ge.value,
            "onUpdate:modelValue": [(xe) => ge.value = xe, Fe],
            min: de.value,
            max: me.value
          }), null) : createVNode(VDatePickerMonth, mergeProps({
            key: "date-picker-month"
          }, Ce, {
            modelValue: ce.value,
            "onUpdate:modelValue": (xe) => ce.value = xe,
            month: pe.value,
            "onUpdate:month": [(xe) => pe.value = xe, Ze],
            year: ge.value,
            "onUpdate:year": [(xe) => ge.value = xe, Fe],
            min: de.value,
            max: me.value
          }), null)]
        })]),
        actions: ie.actions
      });
    }), {};
  }
}), makeVEmptyStateProps = propsFactory({
  actionText: String,
  bgColor: String,
  color: String,
  icon: IconValue,
  image: String,
  justify: {
    type: String,
    default: "center"
  },
  headline: String,
  title: String,
  text: String,
  textWidth: {
    type: [Number, String],
    default: 500
  },
  href: String,
  to: String,
  ...makeComponentProps(),
  ...makeDimensionProps(),
  ...makeSizeProps({
    size: void 0
  }),
  ...makeThemeProps()
}, "VEmptyState"), VEmptyState = genericComponent()({
  name: "VEmptyState",
  props: makeVEmptyStateProps(),
  emits: {
    "click:action": (re) => !0
  },
  setup(re, ne) {
    let {
      emit: ae,
      slots: ie
    } = ne;
    const {
      themeClasses: le
    } = provideTheme(re), {
      backgroundColorClasses: se,
      backgroundColorStyles: ce
    } = useBackgroundColor(toRef(re, "bgColor")), {
      dimensionStyles: ue
    } = useDimension(re), {
      displayClasses: de
    } = useDisplay();
    function me(fe) {
      ae("click:action", fe);
    }
    return useRender(() => {
      var Ee, Ve, Ae;
      const fe = !!(ie.actions || re.actionText), pe = !!(ie.headline || re.headline), ge = !!(ie.title || re.title), be = !!(ie.text || re.text), Se = !!(ie.media || re.image || re.icon), Pe = re.size || (re.image ? 200 : 96);
      return createVNode("div", {
        class: ["v-empty-state", {
          [`v-empty-state--${re.justify}`]: !0
        }, le.value, se.value, de.value, re.class],
        style: [ce.value, ue.value, re.style]
      }, [Se && createVNode("div", {
        key: "media",
        class: "v-empty-state__media"
      }, [ie.media ? createVNode(VDefaultsProvider, {
        key: "media-defaults",
        defaults: {
          VImg: {
            src: re.image,
            height: Pe
          },
          VIcon: {
            size: Pe,
            icon: re.icon
          }
        }
      }, {
        default: () => [ie.media()]
      }) : createVNode(Fragment, null, [re.image ? createVNode(VImg, {
        key: "image",
        src: re.image,
        height: Pe
      }, null) : re.icon ? createVNode(VIcon, {
        key: "icon",
        color: re.color,
        size: Pe,
        icon: re.icon
      }, null) : void 0])]), pe && createVNode("div", {
        key: "headline",
        class: "v-empty-state__headline"
      }, [((Ee = ie.headline) == null ? void 0 : Ee.call(ie)) ?? re.headline]), ge && createVNode("div", {
        key: "title",
        class: "v-empty-state__title"
      }, [((Ve = ie.title) == null ? void 0 : Ve.call(ie)) ?? re.title]), be && createVNode("div", {
        key: "text",
        class: "v-empty-state__text",
        style: {
          maxWidth: convertToUnit(re.textWidth)
        }
      }, [((Ae = ie.text) == null ? void 0 : Ae.call(ie)) ?? re.text]), ie.default && createVNode("div", {
        key: "content",
        class: "v-empty-state__content"
      }, [ie.default()]), fe && createVNode("div", {
        key: "actions",
        class: "v-empty-state__actions"
      }, [createVNode(VDefaultsProvider, {
        defaults: {
          VBtn: {
            class: "v-empty-state__action-btn",
            color: re.color ?? "surface-variant",
            text: re.actionText
          }
        }
      }, {
        default: () => {
          var Oe;
          return [((Oe = ie.actions) == null ? void 0 : Oe.call(ie, {
            props: {
              onClick: me
            }
          })) ?? createVNode(VBtn, {
            onClick: me
          }, null)];
        }
      })])]);
    }), {};
  }
}), VExpansionPanelSymbol = Symbol.for("vuetify:v-expansion-panel"), makeVExpansionPanelTextProps = propsFactory({
  ...makeComponentProps(),
  ...makeLazyProps()
}, "VExpansionPanelText"), VExpansionPanelText = genericComponent()({
  name: "VExpansionPanelText",
  props: makeVExpansionPanelTextProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = inject(VExpansionPanelSymbol);
    if (!ie) throw new Error("[Vuetify] v-expansion-panel-text needs to be placed inside v-expansion-panel");
    const {
      hasContent: le,
      onAfterLeave: se
    } = useLazy(re, ie.isSelected);
    return useRender(() => createVNode(VExpandTransition, {
      onAfterLeave: se
    }, {
      default: () => {
        var ce;
        return [withDirectives(createVNode("div", {
          class: ["v-expansion-panel-text", re.class],
          style: re.style
        }, [ae.default && le.value && createVNode("div", {
          class: "v-expansion-panel-text__wrapper"
        }, [(ce = ae.default) == null ? void 0 : ce.call(ae)])]), [[vShow, ie.isSelected.value]])];
      }
    })), {};
  }
}), makeVExpansionPanelTitleProps = propsFactory({
  color: String,
  expandIcon: {
    type: IconValue,
    default: "$expand"
  },
  collapseIcon: {
    type: IconValue,
    default: "$collapse"
  },
  hideActions: Boolean,
  focusable: Boolean,
  static: Boolean,
  ripple: {
    type: [Boolean, Object],
    default: !1
  },
  readonly: Boolean,
  ...makeComponentProps(),
  ...makeDimensionProps()
}, "VExpansionPanelTitle"), VExpansionPanelTitle = genericComponent()({
  name: "VExpansionPanelTitle",
  directives: {
    Ripple
  },
  props: makeVExpansionPanelTitleProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = inject(VExpansionPanelSymbol);
    if (!ie) throw new Error("[Vuetify] v-expansion-panel-title needs to be placed inside v-expansion-panel");
    const {
      backgroundColorClasses: le,
      backgroundColorStyles: se
    } = useBackgroundColor(re, "color"), {
      dimensionStyles: ce
    } = useDimension(re), ue = computed(() => ({
      collapseIcon: re.collapseIcon,
      disabled: ie.disabled.value,
      expanded: ie.isSelected.value,
      expandIcon: re.expandIcon,
      readonly: re.readonly
    })), de = computed(() => ie.isSelected.value ? re.collapseIcon : re.expandIcon);
    return useRender(() => {
      var me;
      return withDirectives(createVNode("button", {
        class: ["v-expansion-panel-title", {
          "v-expansion-panel-title--active": ie.isSelected.value,
          "v-expansion-panel-title--focusable": re.focusable,
          "v-expansion-panel-title--static": re.static
        }, le.value, re.class],
        style: [se.value, ce.value, re.style],
        type: "button",
        tabindex: ie.disabled.value ? -1 : void 0,
        disabled: ie.disabled.value,
        "aria-expanded": ie.isSelected.value,
        onClick: re.readonly ? void 0 : ie.toggle
      }, [createVNode("span", {
        class: "v-expansion-panel-title__overlay"
      }, null), (me = ae.default) == null ? void 0 : me.call(ae, ue.value), !re.hideActions && createVNode(VDefaultsProvider, {
        defaults: {
          VIcon: {
            icon: de.value
          }
        }
      }, {
        default: () => {
          var fe;
          return [createVNode("span", {
            class: "v-expansion-panel-title__icon"
          }, [((fe = ae.actions) == null ? void 0 : fe.call(ae, ue.value)) ?? createVNode(VIcon, null, null)])];
        }
      })]), [[resolveDirective("ripple"), re.ripple]]);
    }), {};
  }
}), makeVExpansionPanelProps = propsFactory({
  title: String,
  text: String,
  bgColor: String,
  ...makeElevationProps(),
  ...makeGroupItemProps(),
  ...makeRoundedProps(),
  ...makeTagProps(),
  ...makeVExpansionPanelTitleProps(),
  ...makeVExpansionPanelTextProps()
}, "VExpansionPanel"), VExpansionPanel = genericComponent()({
  name: "VExpansionPanel",
  props: makeVExpansionPanelProps(),
  emits: {
    "group:selected": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = useGroupItem(re, VExpansionPanelSymbol), {
      backgroundColorClasses: le,
      backgroundColorStyles: se
    } = useBackgroundColor(re, "bgColor"), {
      elevationClasses: ce
    } = useElevation(re), {
      roundedClasses: ue
    } = useRounded(re), de = computed(() => (ie == null ? void 0 : ie.disabled.value) || re.disabled), me = computed(() => ie.group.items.value.reduce((ge, be, Se) => (ie.group.selected.value.includes(be.id) && ge.push(Se), ge), [])), fe = computed(() => {
      const ge = ie.group.items.value.findIndex((be) => be.id === ie.id);
      return !ie.isSelected.value && me.value.some((be) => be - ge === 1);
    }), pe = computed(() => {
      const ge = ie.group.items.value.findIndex((be) => be.id === ie.id);
      return !ie.isSelected.value && me.value.some((be) => be - ge === -1);
    });
    return provide(VExpansionPanelSymbol, ie), useRender(() => {
      const ge = !!(ae.text || re.text), be = !!(ae.title || re.title), Se = VExpansionPanelTitle.filterProps(re), Pe = VExpansionPanelText.filterProps(re);
      return createVNode(re.tag, {
        class: ["v-expansion-panel", {
          "v-expansion-panel--active": ie.isSelected.value,
          "v-expansion-panel--before-active": fe.value,
          "v-expansion-panel--after-active": pe.value,
          "v-expansion-panel--disabled": de.value
        }, ue.value, le.value, re.class],
        style: [se.value, re.style]
      }, {
        default: () => [createVNode("div", {
          class: ["v-expansion-panel__shadow", ...ce.value]
        }, null), createVNode(VDefaultsProvider, {
          defaults: {
            VExpansionPanelTitle: {
              ...Se
            },
            VExpansionPanelText: {
              ...Pe
            }
          }
        }, {
          default: () => {
            var Ee;
            return [be && createVNode(VExpansionPanelTitle, {
              key: "title"
            }, {
              default: () => [ae.title ? ae.title() : re.title]
            }), ge && createVNode(VExpansionPanelText, {
              key: "text"
            }, {
              default: () => [ae.text ? ae.text() : re.text]
            }), (Ee = ae.default) == null ? void 0 : Ee.call(ae)];
          }
        })]
      });
    }), {
      groupItem: ie
    };
  }
}), allowedVariants = ["default", "accordion", "inset", "popout"], makeVExpansionPanelsProps = propsFactory({
  flat: Boolean,
  ...makeGroupProps(),
  ...pick(makeVExpansionPanelProps(), ["bgColor", "collapseIcon", "color", "eager", "elevation", "expandIcon", "focusable", "hideActions", "readonly", "ripple", "rounded", "tile", "static"]),
  ...makeThemeProps(),
  ...makeComponentProps(),
  ...makeTagProps(),
  variant: {
    type: String,
    default: "default",
    validator: (re) => allowedVariants.includes(re)
  }
}, "VExpansionPanels"), VExpansionPanels = genericComponent()({
  name: "VExpansionPanels",
  props: makeVExpansionPanelsProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      next: ie,
      prev: le
    } = useGroup(re, VExpansionPanelSymbol), {
      themeClasses: se
    } = provideTheme(re), ce = computed(() => re.variant && `v-expansion-panels--variant-${re.variant}`);
    return provideDefaults({
      VExpansionPanel: {
        bgColor: toRef(re, "bgColor"),
        collapseIcon: toRef(re, "collapseIcon"),
        color: toRef(re, "color"),
        eager: toRef(re, "eager"),
        elevation: toRef(re, "elevation"),
        expandIcon: toRef(re, "expandIcon"),
        focusable: toRef(re, "focusable"),
        hideActions: toRef(re, "hideActions"),
        readonly: toRef(re, "readonly"),
        ripple: toRef(re, "ripple"),
        rounded: toRef(re, "rounded"),
        static: toRef(re, "static")
      }
    }), useRender(() => createVNode(re.tag, {
      class: ["v-expansion-panels", {
        "v-expansion-panels--flat": re.flat,
        "v-expansion-panels--tile": re.tile
      }, se.value, ce.value, re.class],
      style: re.style
    }, {
      default: () => {
        var ue;
        return [(ue = ae.default) == null ? void 0 : ue.call(ae, {
          prev: le,
          next: ie
        })];
      }
    })), {
      next: ie,
      prev: le
    };
  }
}), makeVFabProps = propsFactory({
  app: Boolean,
  appear: Boolean,
  extended: Boolean,
  layout: Boolean,
  offset: Boolean,
  modelValue: {
    type: Boolean,
    default: !0
  },
  ...omit(makeVBtnProps({
    active: !0
  }), ["location"]),
  ...makeLayoutItemProps(),
  ...makeLocationProps(),
  ...makeTransitionProps({
    transition: "fab-transition"
  })
}, "VFab"), VFab = genericComponent()({
  name: "VFab",
  props: makeVFabProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = useProxiedModel(re, "modelValue"), le = shallowRef(56), se = ref$1(), {
      resizeRef: ce
    } = useResizeObserver((pe) => {
      pe.length && (le.value = pe[0].target.clientHeight);
    }), ue = computed(() => re.app || re.absolute), de = computed(() => {
      var pe;
      return ue.value ? ((pe = re.location) == null ? void 0 : pe.split(" ").shift()) ?? "bottom" : !1;
    }), me = computed(() => {
      var pe;
      return ue.value ? ((pe = re.location) == null ? void 0 : pe.split(" ")[1]) ?? "end" : !1;
    });
    useToggleScope(() => re.app, () => {
      const pe = useLayoutItem({
        id: re.name,
        order: computed(() => parseInt(re.order, 10)),
        position: de,
        layoutSize: computed(() => re.layout ? le.value + 24 : 0),
        elementSize: computed(() => le.value + 24),
        active: computed(() => re.app && ie.value),
        absolute: toRef(re, "absolute")
      });
      watchEffect(() => {
        se.value = pe.layoutItemStyles.value;
      });
    });
    const fe = ref$1();
    return useRender(() => {
      const pe = VBtn.filterProps(re);
      return createVNode("div", {
        ref: fe,
        class: ["v-fab", {
          "v-fab--absolute": re.absolute,
          "v-fab--app": !!re.app,
          "v-fab--extended": re.extended,
          "v-fab--offset": re.offset,
          [`v-fab--${de.value}`]: ue.value,
          [`v-fab--${me.value}`]: ue.value
        }, re.class],
        style: [re.app ? {
          ...se.value
        } : {
          height: re.absolute ? "100%" : "inherit"
        }, re.style]
      }, [createVNode("div", {
        class: "v-fab__container"
      }, [createVNode(MaybeTransition, {
        appear: re.appear,
        transition: re.transition
      }, {
        default: () => [withDirectives(createVNode(VBtn, mergeProps({
          ref: ce
        }, pe, {
          active: void 0,
          location: void 0
        }), ae), [[vShow, re.active]])]
      })])]);
    }), {};
  }
}), makeVFileInputProps = propsFactory({
  chips: Boolean,
  counter: Boolean,
  counterSizeString: {
    type: String,
    default: "$vuetify.fileInput.counterSize"
  },
  counterString: {
    type: String,
    default: "$vuetify.fileInput.counter"
  },
  hideInput: Boolean,
  multiple: Boolean,
  showSize: {
    type: [Boolean, Number, String],
    default: !1,
    validator: (re) => typeof re == "boolean" || [1e3, 1024].includes(Number(re))
  },
  ...makeVInputProps({
    prependIcon: "$file"
  }),
  modelValue: {
    type: [Array, Object],
    default: (re) => re.multiple ? [] : null,
    validator: (re) => wrapInArray(re).every((ne) => ne != null && typeof ne == "object")
  },
  ...makeVFieldProps({
    clearable: !0
  })
}, "VFileInput"), VFileInput = genericComponent()({
  name: "VFileInput",
  inheritAttrs: !1,
  props: makeVFileInputProps(),
  emits: {
    "click:control": (re) => !0,
    "mousedown:control": (re) => !0,
    "update:focused": (re) => !0,
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      attrs: ae,
      emit: ie,
      slots: le
    } = ne;
    const {
      t: se
    } = useLocale(), ce = useProxiedModel(re, "modelValue", re.modelValue, (Re) => wrapInArray(Re), (Re) => !re.multiple && Array.isArray(Re) ? Re[0] : Re), {
      isFocused: ue,
      focus: de,
      blur: me
    } = useFocus(re), fe = computed(() => typeof re.showSize != "boolean" ? re.showSize : void 0), pe = computed(() => (ce.value ?? []).reduce((Re, Ce) => {
      let {
        size: _e = 0
      } = Ce;
      return Re + _e;
    }, 0)), ge = computed(() => humanReadableFileSize(pe.value, fe.value)), be = computed(() => (ce.value ?? []).map((Re) => {
      const {
        name: Ce = "",
        size: _e = 0
      } = Re;
      return re.showSize ? `${Ce} (${humanReadableFileSize(_e, fe.value)})` : Ce;
    })), Se = computed(() => {
      var Ce;
      const Re = ((Ce = ce.value) == null ? void 0 : Ce.length) ?? 0;
      return re.showSize ? se(re.counterSizeString, Re, ge.value) : se(re.counterString, Re);
    }), Pe = ref$1(), Ee = ref$1(), Ve = ref$1(), Ae = computed(() => ue.value || re.active), Oe = computed(() => ["plain", "underlined"].includes(re.variant));
    function Ne() {
      var Re;
      Ve.value !== document.activeElement && ((Re = Ve.value) == null || Re.focus()), ue.value || de();
    }
    function He(Re) {
      var Ce;
      (Ce = Ve.value) == null || Ce.click();
    }
    function Ue(Re) {
      ie("mousedown:control", Re);
    }
    function Ze(Re) {
      var Ce;
      (Ce = Ve.value) == null || Ce.click(), ie("click:control", Re);
    }
    function Fe(Re) {
      Re.stopPropagation(), Ne(), nextTick$2(() => {
        ce.value = [], callEvent(re["onClick:clear"], Re);
      });
    }
    function Ke(Re) {
      Re.preventDefault();
    }
    function tt(Re) {
      Re.preventDefault(), Re.dataTransfer && (ce.value = [...Re.dataTransfer.files ?? []]);
    }
    return watch(ce, (Re) => {
      (!Array.isArray(Re) || !Re.length) && Ve.value && (Ve.value.value = "");
    }), useRender(() => {
      const Re = !!(le.counter || re.counter), Ce = !!(Re || le.details), [_e, he] = filterInputAttrs(ae), {
        modelValue: ve,
        ...xe
      } = VInput.filterProps(re), $e = VField.filterProps(re);
      return createVNode(VInput, mergeProps({
        ref: Pe,
        modelValue: re.multiple ? ce.value : ce.value[0],
        class: ["v-file-input", {
          "v-file-input--chips": !!re.chips,
          "v-file-input--hide": re.hideInput,
          "v-input--plain-underlined": Oe.value
        }, re.class],
        style: re.style,
        "onClick:prepend": He
      }, _e, xe, {
        centerAffix: !Oe.value,
        focused: ue.value
      }), {
        ...le,
        default: (Te) => {
          let {
            id: Ie,
            isDisabled: we,
            isDirty: ke,
            isReadonly: ye,
            isValid: Be
          } = Te;
          return createVNode(VField, mergeProps({
            ref: Ee,
            "prepend-icon": re.prependIcon,
            onMousedown: Ue,
            onClick: Ze,
            "onClick:clear": Fe,
            "onClick:prependInner": re["onClick:prependInner"],
            "onClick:appendInner": re["onClick:appendInner"]
          }, $e, {
            id: Ie.value,
            active: Ae.value || ke.value,
            dirty: ke.value || re.dirty,
            disabled: we.value,
            focused: ue.value,
            error: Be.value === !1,
            onDragover: Ke,
            onDrop: tt
          }), {
            ...le,
            default: (Xe) => {
              var De;
              let {
                props: {
                  class: et,
                  ...Ye
                }
              } = Xe;
              return createVNode(Fragment, null, [createVNode("input", mergeProps({
                ref: Ve,
                type: "file",
                readonly: ye.value,
                disabled: we.value,
                multiple: re.multiple,
                name: re.name,
                onClick: (je) => {
                  je.stopPropagation(), ye.value && je.preventDefault(), Ne();
                },
                onChange: (je) => {
                  if (!je.target) return;
                  const rt = je.target;
                  ce.value = [...rt.files ?? []];
                },
                onFocus: Ne,
                onBlur: me
              }, Ye, he), null), createVNode("div", {
                class: et
              }, [!!((De = ce.value) != null && De.length) && !re.hideInput && (le.selection ? le.selection({
                fileNames: be.value,
                totalBytes: pe.value,
                totalBytesReadable: ge.value
              }) : re.chips ? be.value.map((je) => createVNode(VChip, {
                key: je,
                size: "small",
                text: je
              }, null)) : be.value.join(", "))])]);
            }
          });
        },
        details: Ce ? (Te) => {
          var Ie, we;
          return createVNode(Fragment, null, [(Ie = le.details) == null ? void 0 : Ie.call(le, Te), Re && createVNode(Fragment, null, [createVNode("span", null, null), createVNode(VCounter, {
            active: !!((we = ce.value) != null && we.length),
            value: Se.value,
            disabled: re.disabled
          }, le.counter)])]);
        } : void 0
      });
    }), forwardRefs({}, Pe, Ee, Ve);
  }
}), makeVFormProps = propsFactory({
  ...makeComponentProps(),
  ...makeFormProps()
}, "VForm"), VForm = genericComponent()({
  name: "VForm",
  props: makeVFormProps(),
  emits: {
    "update:modelValue": (re) => !0,
    submit: (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae,
      emit: ie
    } = ne;
    const le = createForm(re), se = ref$1();
    function ce(de) {
      de.preventDefault(), le.reset();
    }
    function ue(de) {
      const me = de, fe = le.validate();
      me.then = fe.then.bind(fe), me.catch = fe.catch.bind(fe), me.finally = fe.finally.bind(fe), ie("submit", me), me.defaultPrevented || fe.then((pe) => {
        var be;
        let {
          valid: ge
        } = pe;
        ge && ((be = se.value) == null || be.submit());
      }), me.preventDefault();
    }
    return useRender(() => {
      var de;
      return createVNode("form", {
        ref: se,
        class: ["v-form", re.class],
        style: re.style,
        novalidate: !0,
        onReset: ce,
        onSubmit: ue
      }, [(de = ae.default) == null ? void 0 : de.call(ae, le)]);
    }), forwardRefs(le, se);
  }
}), makeVHoverProps = propsFactory({
  disabled: Boolean,
  modelValue: {
    type: Boolean,
    default: null
  },
  ...makeDelayProps()
}, "VHover"), VHover = genericComponent()({
  name: "VHover",
  props: makeVHoverProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = useProxiedModel(re, "modelValue"), {
      runOpenDelay: le,
      runCloseDelay: se
    } = useDelay(re, (ce) => !re.disabled && (ie.value = ce));
    return () => {
      var ce;
      return (ce = ae.default) == null ? void 0 : ce.call(ae, {
        isHovering: ie.value,
        props: {
          onMouseenter: le,
          onMouseleave: se
        }
      });
    };
  }
}), makeVInfiniteScrollProps = propsFactory({
  color: String,
  direction: {
    type: String,
    default: "vertical",
    validator: (re) => ["vertical", "horizontal"].includes(re)
  },
  side: {
    type: String,
    default: "end",
    validator: (re) => ["start", "end", "both"].includes(re)
  },
  mode: {
    type: String,
    default: "intersect",
    validator: (re) => ["intersect", "manual"].includes(re)
  },
  margin: [Number, String],
  loadMoreText: {
    type: String,
    default: "$vuetify.infiniteScroll.loadMore"
  },
  emptyText: {
    type: String,
    default: "$vuetify.infiniteScroll.empty"
  },
  ...makeDimensionProps(),
  ...makeTagProps()
}, "VInfiniteScroll"), VInfiniteScrollIntersect = defineComponent({
  name: "VInfiniteScrollIntersect",
  props: {
    side: {
      type: String,
      required: !0
    },
    rootMargin: String
  },
  emits: {
    intersect: (re, ne) => !0
  },
  setup(re, ne) {
    let {
      emit: ae
    } = ne;
    const {
      intersectionRef: ie,
      isIntersecting: le
    } = useIntersectionObserver();
    return watch(le, async (se) => {
      ae("intersect", re.side, se);
    }), useRender(() => createVNode("div", {
      class: "v-infinite-scroll-intersect",
      style: {
        "--v-infinite-margin-size": re.rootMargin
      },
      ref: ie
    }, [createTextVNode(" ")])), {};
  }
}), VInfiniteScroll = genericComponent()({
  name: "VInfiniteScroll",
  props: makeVInfiniteScrollProps(),
  emits: {
    load: (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae,
      emit: ie
    } = ne;
    const le = ref$1(), se = shallowRef("ok"), ce = shallowRef("ok"), ue = computed(() => convertToUnit(re.margin)), de = shallowRef(!1);
    function me(He) {
      if (!le.value) return;
      const Ue = re.direction === "vertical" ? "scrollTop" : "scrollLeft";
      le.value[Ue] = He;
    }
    function fe() {
      if (!le.value) return 0;
      const He = re.direction === "vertical" ? "scrollTop" : "scrollLeft";
      return le.value[He];
    }
    function pe() {
      if (!le.value) return 0;
      const He = re.direction === "vertical" ? "scrollHeight" : "scrollWidth";
      return le.value[He];
    }
    function ge() {
      if (!le.value) return 0;
      const He = re.direction === "vertical" ? "clientHeight" : "clientWidth";
      return le.value[He];
    }
    onMounted(() => {
      le.value && (re.side === "start" ? me(pe()) : re.side === "both" && me(pe() / 2 - ge() / 2));
    });
    function be(He, Ue) {
      He === "start" ? se.value = Ue : He === "end" && (ce.value = Ue);
    }
    function Se(He) {
      return He === "start" ? se.value : ce.value;
    }
    let Pe = 0;
    function Ee(He, Ue) {
      de.value = Ue, de.value && Ve(He);
    }
    function Ve(He) {
      if (re.mode !== "manual" && !de.value) return;
      const Ue = Se(He);
      if (!le.value || ["empty", "loading"].includes(Ue)) return;
      Pe = pe(), be(He, "loading");
      function Ze(Fe) {
        be(He, Fe), nextTick$2(() => {
          Fe === "empty" || Fe === "error" || (Fe === "ok" && He === "start" && me(pe() - Pe + fe()), re.mode !== "manual" && nextTick$2(() => {
            window.requestAnimationFrame(() => {
              window.requestAnimationFrame(() => {
                window.requestAnimationFrame(() => {
                  Ve(He);
                });
              });
            });
          }));
        });
      }
      ie("load", {
        side: He,
        done: Ze
      });
    }
    const {
      t: Ae
    } = useLocale();
    function Oe(He, Ue) {
      var Ke, tt, Re, Ce, _e;
      if (re.side !== He && re.side !== "both") return;
      const Ze = () => Ve(He), Fe = {
        side: He,
        props: {
          onClick: Ze,
          color: re.color
        }
      };
      return Ue === "error" ? (Ke = ae.error) == null ? void 0 : Ke.call(ae, Fe) : Ue === "empty" ? ((tt = ae.empty) == null ? void 0 : tt.call(ae, Fe)) ?? createVNode("div", null, [Ae(re.emptyText)]) : re.mode === "manual" ? Ue === "loading" ? ((Re = ae.loading) == null ? void 0 : Re.call(ae, Fe)) ?? createVNode(VProgressCircular, {
        indeterminate: !0,
        color: re.color
      }, null) : ((Ce = ae["load-more"]) == null ? void 0 : Ce.call(ae, Fe)) ?? createVNode(VBtn, {
        variant: "outlined",
        color: re.color,
        onClick: Ze
      }, {
        default: () => [Ae(re.loadMoreText)]
      }) : ((_e = ae.loading) == null ? void 0 : _e.call(ae, Fe)) ?? createVNode(VProgressCircular, {
        indeterminate: !0,
        color: re.color
      }, null);
    }
    const {
      dimensionStyles: Ne
    } = useDimension(re);
    useRender(() => {
      const He = re.tag, Ue = re.side === "start" || re.side === "both", Ze = re.side === "end" || re.side === "both", Fe = re.mode === "intersect";
      return createVNode(He, {
        ref: le,
        class: ["v-infinite-scroll", `v-infinite-scroll--${re.direction}`, {
          "v-infinite-scroll--start": Ue,
          "v-infinite-scroll--end": Ze
        }],
        style: Ne.value
      }, {
        default: () => {
          var Ke;
          return [createVNode("div", {
            class: "v-infinite-scroll__side"
          }, [Oe("start", se.value)]), Ue && Fe && createVNode(VInfiniteScrollIntersect, {
            key: "start",
            side: "start",
            onIntersect: Ee,
            rootMargin: ue.value
          }, null), (Ke = ae.default) == null ? void 0 : Ke.call(ae), Ze && Fe && createVNode(VInfiniteScrollIntersect, {
            key: "end",
            side: "end",
            onIntersect: Ee,
            rootMargin: ue.value
          }, null), createVNode("div", {
            class: "v-infinite-scroll__side"
          }, [Oe("end", ce.value)])];
        }
      });
    });
  }
}), VItemGroupSymbol = Symbol.for("vuetify:v-item-group"), makeVItemGroupProps = propsFactory({
  ...makeComponentProps(),
  ...makeGroupProps({
    selectedClass: "v-item--selected"
  }),
  ...makeTagProps(),
  ...makeThemeProps()
}, "VItemGroup"), VItemGroup = genericComponent()({
  name: "VItemGroup",
  props: makeVItemGroupProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      themeClasses: ie
    } = provideTheme(re), {
      isSelected: le,
      select: se,
      next: ce,
      prev: ue,
      selected: de
    } = useGroup(re, VItemGroupSymbol);
    return () => createVNode(re.tag, {
      class: ["v-item-group", ie.value, re.class],
      style: re.style
    }, {
      default: () => {
        var me;
        return [(me = ae.default) == null ? void 0 : me.call(ae, {
          isSelected: le,
          select: se,
          next: ce,
          prev: ue,
          selected: de.value
        })];
      }
    });
  }
}), VItem = genericComponent()({
  name: "VItem",
  props: makeGroupItemProps(),
  emits: {
    "group:selected": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      isSelected: ie,
      select: le,
      toggle: se,
      selectedClass: ce,
      value: ue,
      disabled: de
    } = useGroupItem(re, VItemGroupSymbol);
    return () => {
      var me;
      return (me = ae.default) == null ? void 0 : me.call(ae, {
        isSelected: ie.value,
        selectedClass: ce.value,
        select: le,
        toggle: se,
        value: ue.value,
        disabled: de.value
      });
    };
  }
}), VKbd = createSimpleFunctional("v-kbd", "kbd"), makeVLayoutProps = propsFactory({
  ...makeComponentProps(),
  ...makeDimensionProps(),
  ...makeLayoutProps()
}, "VLayout"), VLayout = genericComponent()({
  name: "VLayout",
  props: makeVLayoutProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      layoutClasses: ie,
      layoutStyles: le,
      getLayoutItem: se,
      items: ce,
      layoutRef: ue
    } = createLayout(re), {
      dimensionStyles: de
    } = useDimension(re);
    return useRender(() => {
      var me;
      return createVNode("div", {
        ref: ue,
        class: [ie.value, re.class],
        style: [de.value, le.value, re.style]
      }, [(me = ae.default) == null ? void 0 : me.call(ae)]);
    }), {
      getLayoutItem: se,
      items: ce
    };
  }
}), makeVLayoutItemProps = propsFactory({
  position: {
    type: String,
    required: !0
  },
  size: {
    type: [Number, String],
    default: 300
  },
  modelValue: Boolean,
  ...makeComponentProps(),
  ...makeLayoutItemProps()
}, "VLayoutItem"), VLayoutItem = genericComponent()({
  name: "VLayoutItem",
  props: makeVLayoutItemProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      layoutItemStyles: ie
    } = useLayoutItem({
      id: re.name,
      order: computed(() => parseInt(re.order, 10)),
      position: toRef(re, "position"),
      elementSize: toRef(re, "size"),
      layoutSize: toRef(re, "size"),
      active: toRef(re, "modelValue"),
      absolute: toRef(re, "absolute")
    });
    return () => {
      var le;
      return createVNode("div", {
        class: ["v-layout-item", re.class],
        style: [ie.value, re.style]
      }, [(le = ae.default) == null ? void 0 : le.call(ae)]);
    };
  }
}), makeVLazyProps = propsFactory({
  modelValue: Boolean,
  options: {
    type: Object,
    // For more information on types, navigate to:
    // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
    default: () => ({
      root: void 0,
      rootMargin: void 0,
      threshold: void 0
    })
  },
  ...makeComponentProps(),
  ...makeDimensionProps(),
  ...makeTagProps(),
  ...makeTransitionProps({
    transition: "fade-transition"
  })
}, "VLazy"), VLazy = genericComponent()({
  name: "VLazy",
  directives: {
    intersect: Intersect
  },
  props: makeVLazyProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      dimensionStyles: ie
    } = useDimension(re), le = useProxiedModel(re, "modelValue");
    function se(ce) {
      le.value || (le.value = ce);
    }
    return useRender(() => withDirectives(createVNode(re.tag, {
      class: ["v-lazy", re.class],
      style: [ie.value, re.style]
    }, {
      default: () => [le.value && createVNode(MaybeTransition, {
        transition: re.transition,
        appear: !0
      }, {
        default: () => {
          var ce;
          return [(ce = ae.default) == null ? void 0 : ce.call(ae)];
        }
      })]
    }), [[resolveDirective("intersect"), {
      handler: se,
      options: re.options
    }, null]])), {};
  }
}), makeVLocaleProviderProps = propsFactory({
  locale: String,
  fallbackLocale: String,
  messages: Object,
  rtl: {
    type: Boolean,
    default: void 0
  },
  ...makeComponentProps()
}, "VLocaleProvider"), VLocaleProvider = genericComponent()({
  name: "VLocaleProvider",
  props: makeVLocaleProviderProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      rtlClasses: ie
    } = provideLocale(re);
    return useRender(() => {
      var le;
      return createVNode("div", {
        class: ["v-locale-provider", ie.value, re.class],
        style: re.style
      }, [(le = ae.default) == null ? void 0 : le.call(ae)]);
    }), {};
  }
}), VNoSsr = defineComponent({
  name: "VNoSsr",
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = useHydration();
    return () => {
      var le;
      return ie.value && ((le = ae.default) == null ? void 0 : le.call(ae));
    };
  }
}), makeVOtpInputProps = propsFactory({
  autofocus: Boolean,
  divider: String,
  focusAll: Boolean,
  label: {
    type: String,
    default: "$vuetify.input.otp"
  },
  length: {
    type: [Number, String],
    default: 6
  },
  modelValue: {
    type: [Number, String],
    default: void 0
  },
  placeholder: String,
  type: {
    type: String,
    default: "number"
  },
  ...makeDimensionProps(),
  ...makeFocusProps(),
  ...pick(makeVFieldProps({
    variant: "outlined"
  }), ["baseColor", "bgColor", "class", "color", "disabled", "error", "loading", "rounded", "style", "theme", "variant"])
}, "VOtpInput"), VOtpInput = genericComponent()({
  name: "VOtpInput",
  props: makeVOtpInputProps(),
  emits: {
    finish: (re) => !0,
    "update:focused": (re) => !0,
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      attrs: ae,
      emit: ie,
      slots: le
    } = ne;
    const {
      dimensionStyles: se
    } = useDimension(re), {
      isFocused: ce,
      focus: ue,
      blur: de
    } = useFocus(re), me = useProxiedModel(re, "modelValue", "", (Fe) => Fe == null ? [] : String(Fe).split(""), (Fe) => Fe.join("")), {
      t: fe
    } = useLocale(), pe = computed(() => Number(re.length)), ge = computed(() => Array(pe.value).fill(0)), be = ref$1(-1), Se = ref$1(), Pe = ref$1([]), Ee = computed(() => Pe.value[be.value]);
    function Ve() {
      if (Ze(Ee.value.value)) {
        Ee.value.value = "";
        return;
      }
      const Fe = me.value.slice(), Ke = Ee.value.value;
      Fe[be.value] = Ke;
      let tt = null;
      be.value > me.value.length ? tt = me.value.length + 1 : be.value + 1 !== pe.value && (tt = "next"), me.value = Fe, tt && focusChild(Se.value, tt);
    }
    function Ae(Fe) {
      const Ke = me.value.slice(), tt = be.value;
      let Re = null;
      ["ArrowLeft", "ArrowRight", "Backspace", "Delete"].includes(Fe.key) && (Fe.preventDefault(), Fe.key === "ArrowLeft" ? Re = "prev" : Fe.key === "ArrowRight" ? Re = "next" : ["Backspace", "Delete"].includes(Fe.key) && (Ke[be.value] = "", me.value = Ke, be.value > 0 && Fe.key === "Backspace" ? Re = "prev" : requestAnimationFrame(() => {
        var Ce;
        (Ce = Pe.value[tt]) == null || Ce.select();
      })), requestAnimationFrame(() => {
        Re != null && focusChild(Se.value, Re);
      }));
    }
    function Oe(Fe, Ke) {
      var Re, Ce;
      Ke.preventDefault(), Ke.stopPropagation();
      const tt = ((Re = Ke == null ? void 0 : Ke.clipboardData) == null ? void 0 : Re.getData("Text").slice(0, pe.value)) ?? "";
      Ze(tt) || (me.value = tt.split(""), (Ce = Pe.value) == null || Ce[Fe].blur());
    }
    function Ne() {
      me.value = [];
    }
    function He(Fe, Ke) {
      ue(), be.value = Ke;
    }
    function Ue() {
      de(), be.value = -1;
    }
    function Ze(Fe) {
      return re.type === "number" && /[^0-9]/g.test(Fe);
    }
    return provideDefaults({
      VField: {
        color: computed(() => re.color),
        bgColor: computed(() => re.color),
        baseColor: computed(() => re.baseColor),
        disabled: computed(() => re.disabled),
        error: computed(() => re.error),
        variant: computed(() => re.variant)
      }
    }, {
      scoped: !0
    }), watch(me, (Fe) => {
      Fe.length === pe.value && ie("finish", Fe.join(""));
    }, {
      deep: !0
    }), watch(be, (Fe) => {
      Fe < 0 || nextTick$2(() => {
        var Ke;
        (Ke = Pe.value[Fe]) == null || Ke.select();
      });
    }), useRender(() => {
      var tt;
      const [Fe, Ke] = filterInputAttrs(ae);
      return createVNode("div", mergeProps({
        class: ["v-otp-input", {
          "v-otp-input--divided": !!re.divider
        }, re.class],
        style: [re.style]
      }, Fe), [createVNode("div", {
        ref: Se,
        class: "v-otp-input__content",
        style: [se.value]
      }, [ge.value.map((Re, Ce) => createVNode(Fragment, null, [re.divider && Ce !== 0 && createVNode("span", {
        class: "v-otp-input__divider"
      }, [re.divider]), createVNode(VField, {
        focused: ce.value && re.focusAll || be.value === Ce,
        key: Ce
      }, {
        ...le,
        loader: void 0,
        default: () => createVNode("input", {
          ref: (_e) => Pe.value[Ce] = _e,
          "aria-label": fe(re.label, Ce + 1),
          autofocus: Ce === 0 && re.autofocus,
          autocomplete: "one-time-code",
          class: ["v-otp-input__field"],
          disabled: re.disabled,
          inputmode: re.type === "number" ? "numeric" : "text",
          min: re.type === "number" ? 0 : void 0,
          maxlength: Ce === 0 ? pe.value : "1",
          placeholder: re.placeholder,
          type: re.type === "number" ? "text" : re.type,
          value: me.value[Ce],
          onInput: Ve,
          onFocus: (_e) => He(_e, Ce),
          onBlur: Ue,
          onKeydown: Ae,
          onPaste: (_e) => Oe(Ce, _e)
        }, null)
      })])), createVNode("input", mergeProps({
        class: "v-otp-input-input",
        type: "hidden"
      }, Ke, {
        value: me.value.join("")
      }), null), createVNode(VOverlay, {
        contained: !0,
        "content-class": "v-otp-input__loader",
        "model-value": !!re.loading,
        persistent: !0
      }, {
        default: () => {
          var Re;
          return [((Re = le.loader) == null ? void 0 : Re.call(le)) ?? createVNode(VProgressCircular, {
            color: typeof re.loading == "boolean" ? void 0 : re.loading,
            indeterminate: !0,
            size: "24",
            width: "2"
          }, null)];
        }
      }), (tt = le.default) == null ? void 0 : tt.call(le)])]);
    }), {
      blur: () => {
        var Fe;
        (Fe = Pe.value) == null || Fe.some((Ke) => Ke.blur());
      },
      focus: () => {
        var Fe;
        (Fe = Pe.value) == null || Fe[0].focus();
      },
      reset: Ne,
      isFocused: ce
    };
  }
});
function floor(re) {
  return Math.floor(Math.abs(re)) * Math.sign(re);
}
const makeVParallaxProps = propsFactory({
  scale: {
    type: [Number, String],
    default: 0.5
  },
  ...makeComponentProps()
}, "VParallax"), VParallax = genericComponent()({
  name: "VParallax",
  props: makeVParallaxProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      intersectionRef: ie,
      isIntersecting: le
    } = useIntersectionObserver(), {
      resizeRef: se,
      contentRect: ce
    } = useResizeObserver(), {
      height: ue
    } = useDisplay(), de = ref$1();
    watchEffect(() => {
      var be;
      ie.value = se.value = (be = de.value) == null ? void 0 : be.$el;
    });
    let me;
    watch(le, (be) => {
      be ? (me = getScrollParent(ie.value), me = me === document.scrollingElement ? document : me, me.addEventListener("scroll", ge, {
        passive: !0
      }), ge()) : me.removeEventListener("scroll", ge);
    }), onBeforeUnmount(() => {
      me == null || me.removeEventListener("scroll", ge);
    }), watch(ue, ge), watch(() => {
      var be;
      return (be = ce.value) == null ? void 0 : be.height;
    }, ge);
    const fe = computed(() => 1 - clamp(Number(re.scale)));
    let pe = -1;
    function ge() {
      le.value && (cancelAnimationFrame(pe), pe = requestAnimationFrame(() => {
        var He;
        const be = ((He = de.value) == null ? void 0 : He.$el).querySelector(".v-img__img");
        if (!be) return;
        const Se = me instanceof Document ? document.documentElement.clientHeight : me.clientHeight, Pe = me instanceof Document ? window.scrollY : me.scrollTop, Ee = ie.value.getBoundingClientRect().top + Pe, Ve = ce.value.height, Ae = Ee + (Ve - Se) / 2, Oe = floor((Pe - Ae) * fe.value), Ne = Math.max(1, (fe.value * (Se - Ve) + Ve) / Ve);
        be.style.setProperty("transform", `translateY(${Oe}px) scale(${Ne})`);
      }));
    }
    return useRender(() => createVNode(VImg, {
      class: ["v-parallax", {
        "v-parallax--active": le.value
      }, re.class],
      style: re.style,
      ref: de,
      cover: !0,
      onLoadstart: ge,
      onLoad: ge
    }, ae)), {};
  }
}), makeVRangeSliderProps = propsFactory({
  ...makeFocusProps(),
  ...makeVInputProps(),
  ...makeSliderProps(),
  strict: Boolean,
  modelValue: {
    type: Array,
    default: () => [0, 0]
  }
}, "VRangeSlider"), VRangeSlider = genericComponent()({
  name: "VRangeSlider",
  props: makeVRangeSliderProps(),
  emits: {
    "update:focused": (re) => !0,
    "update:modelValue": (re) => !0,
    end: (re) => !0,
    start: (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae,
      emit: ie
    } = ne;
    const le = ref$1(), se = ref$1(), ce = ref$1(), {
      rtlClasses: ue
    } = useRtl();
    function de(tt) {
      if (!le.value || !se.value) return;
      const Re = getOffset(tt, le.value.$el, re.direction), Ce = getOffset(tt, se.value.$el, re.direction), _e = Math.abs(Re), he = Math.abs(Ce);
      return _e < he || _e === he && Re < 0 ? le.value.$el : se.value.$el;
    }
    const me = useSteps(re), fe = useProxiedModel(re, "modelValue", void 0, (tt) => tt != null && tt.length ? tt.map((Re) => me.roundValue(Re)) : [0, 0]), {
      activeThumbRef: pe,
      hasLabels: ge,
      max: be,
      min: Se,
      mousePressed: Pe,
      onSliderMousedown: Ee,
      onSliderTouchstart: Ve,
      position: Ae,
      trackContainerRef: Oe,
      readonly: Ne
    } = useSlider({
      props: re,
      steps: me,
      onSliderStart: () => {
        ie("start", fe.value);
      },
      onSliderEnd: (tt) => {
        var _e;
        let {
          value: Re
        } = tt;
        const Ce = pe.value === ((_e = le.value) == null ? void 0 : _e.$el) ? [Re, fe.value[1]] : [fe.value[0], Re];
        !re.strict && Ce[0] < Ce[1] && (fe.value = Ce), ie("end", fe.value);
      },
      onSliderMove: (tt) => {
        var he, ve, xe, $e;
        let {
          value: Re
        } = tt;
        const [Ce, _e] = fe.value;
        !re.strict && Ce === _e && Ce !== Se.value && (pe.value = Re > Ce ? (he = se.value) == null ? void 0 : he.$el : (ve = le.value) == null ? void 0 : ve.$el, (xe = pe.value) == null || xe.focus()), pe.value === (($e = le.value) == null ? void 0 : $e.$el) ? fe.value = [Math.min(Re, _e), _e] : fe.value = [Ce, Math.max(Ce, Re)];
      },
      getActiveThumb: de
    }), {
      isFocused: He,
      focus: Ue,
      blur: Ze
    } = useFocus(re), Fe = computed(() => Ae(fe.value[0])), Ke = computed(() => Ae(fe.value[1]));
    return useRender(() => {
      const tt = VInput.filterProps(re), Re = !!(re.label || ae.label || ae.prepend);
      return createVNode(VInput, mergeProps({
        class: ["v-slider", "v-range-slider", {
          "v-slider--has-labels": !!ae["tick-label"] || ge.value,
          "v-slider--focused": He.value,
          "v-slider--pressed": Pe.value,
          "v-slider--disabled": re.disabled
        }, ue.value, re.class],
        style: re.style,
        ref: ce
      }, tt, {
        focused: He.value
      }), {
        ...ae,
        prepend: Re ? (Ce) => {
          var _e, he;
          return createVNode(Fragment, null, [((_e = ae.label) == null ? void 0 : _e.call(ae, Ce)) ?? (re.label ? createVNode(VLabel, {
            class: "v-slider__label",
            text: re.label
          }, null) : void 0), (he = ae.prepend) == null ? void 0 : he.call(ae, Ce)]);
        } : void 0,
        default: (Ce) => {
          var ve, xe;
          let {
            id: _e,
            messagesId: he
          } = Ce;
          return createVNode("div", {
            class: "v-slider__container",
            onMousedown: Ne.value ? void 0 : Ee,
            onTouchstartPassive: Ne.value ? void 0 : Ve
          }, [createVNode("input", {
            id: `${_e.value}_start`,
            name: re.name || _e.value,
            disabled: !!re.disabled,
            readonly: !!re.readonly,
            tabindex: "-1",
            value: fe.value[0]
          }, null), createVNode("input", {
            id: `${_e.value}_stop`,
            name: re.name || _e.value,
            disabled: !!re.disabled,
            readonly: !!re.readonly,
            tabindex: "-1",
            value: fe.value[1]
          }, null), createVNode(VSliderTrack, {
            ref: Oe,
            start: Fe.value,
            stop: Ke.value
          }, {
            "tick-label": ae["tick-label"]
          }), createVNode(VSliderThumb, {
            ref: le,
            "aria-describedby": he.value,
            focused: He && pe.value === ((ve = le.value) == null ? void 0 : ve.$el),
            modelValue: fe.value[0],
            "onUpdate:modelValue": ($e) => fe.value = [$e, fe.value[1]],
            onFocus: ($e) => {
              var Te, Ie, we, ke;
              Ue(), pe.value = (Te = le.value) == null ? void 0 : Te.$el, be.value !== Se.value && fe.value[0] === fe.value[1] && fe.value[1] === Se.value && $e.relatedTarget !== ((Ie = se.value) == null ? void 0 : Ie.$el) && ((we = le.value) == null || we.$el.blur(), (ke = se.value) == null || ke.$el.focus());
            },
            onBlur: () => {
              Ze(), pe.value = void 0;
            },
            min: Se.value,
            max: fe.value[1],
            position: Fe.value,
            ripple: re.ripple
          }, {
            "thumb-label": ae["thumb-label"]
          }), createVNode(VSliderThumb, {
            ref: se,
            "aria-describedby": he.value,
            focused: He && pe.value === ((xe = se.value) == null ? void 0 : xe.$el),
            modelValue: fe.value[1],
            "onUpdate:modelValue": ($e) => fe.value = [fe.value[0], $e],
            onFocus: ($e) => {
              var Te, Ie, we, ke;
              Ue(), pe.value = (Te = se.value) == null ? void 0 : Te.$el, be.value !== Se.value && fe.value[0] === fe.value[1] && fe.value[0] === be.value && $e.relatedTarget !== ((Ie = le.value) == null ? void 0 : Ie.$el) && ((we = se.value) == null || we.$el.blur(), (ke = le.value) == null || ke.$el.focus());
            },
            onBlur: () => {
              Ze(), pe.value = void 0;
            },
            min: fe.value[0],
            max: be.value,
            position: Ke.value,
            ripple: re.ripple
          }, {
            "thumb-label": ae["thumb-label"]
          })]);
        }
      });
    }), {};
  }
}), makeVRatingProps = propsFactory({
  name: String,
  itemAriaLabel: {
    type: String,
    default: "$vuetify.rating.ariaLabel.item"
  },
  activeColor: String,
  color: String,
  clearable: Boolean,
  disabled: Boolean,
  emptyIcon: {
    type: IconValue,
    default: "$ratingEmpty"
  },
  fullIcon: {
    type: IconValue,
    default: "$ratingFull"
  },
  halfIncrements: Boolean,
  hover: Boolean,
  length: {
    type: [Number, String],
    default: 5
  },
  readonly: Boolean,
  modelValue: {
    type: [Number, String],
    default: 0
  },
  itemLabels: Array,
  itemLabelPosition: {
    type: String,
    default: "top",
    validator: (re) => ["top", "bottom"].includes(re)
  },
  ripple: Boolean,
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeSizeProps(),
  ...makeTagProps(),
  ...makeThemeProps()
}, "VRating"), VRating = genericComponent()({
  name: "VRating",
  props: makeVRatingProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      t: ie
    } = useLocale(), {
      themeClasses: le
    } = provideTheme(re), se = useProxiedModel(re, "modelValue"), ce = computed(() => clamp(parseFloat(se.value), 0, Number(re.length))), ue = computed(() => createRange(Number(re.length), 1)), de = computed(() => ue.value.flatMap((Pe) => re.halfIncrements ? [Pe - 0.5, Pe] : [Pe])), me = shallowRef(-1), fe = computed(() => de.value.map((Pe) => {
      const Ee = re.hover && me.value > -1, Ve = ce.value >= Pe, Ae = me.value >= Pe, Ne = (Ee ? Ae : Ve) ? re.fullIcon : re.emptyIcon, He = re.activeColor ?? re.color, Ue = Ve || Ae ? He : re.color;
      return {
        isFilled: Ve,
        isHovered: Ae,
        icon: Ne,
        color: Ue
      };
    })), pe = computed(() => [0, ...de.value].map((Pe) => {
      function Ee() {
        me.value = Pe;
      }
      function Ve() {
        me.value = -1;
      }
      function Ae() {
        re.disabled || re.readonly || (se.value = ce.value === Pe && re.clearable ? 0 : Pe);
      }
      return {
        onMouseenter: re.hover ? Ee : void 0,
        onMouseleave: re.hover ? Ve : void 0,
        onClick: Ae
      };
    })), ge = computed(() => re.name ?? `v-rating-${getUid()}`);
    function be(Pe) {
      var Fe, Ke;
      let {
        value: Ee,
        index: Ve,
        showStar: Ae = !0
      } = Pe;
      const {
        onMouseenter: Oe,
        onMouseleave: Ne,
        onClick: He
      } = pe.value[Ve + 1], Ue = `${ge.value}-${String(Ee).replace(".", "-")}`, Ze = {
        color: (Fe = fe.value[Ve]) == null ? void 0 : Fe.color,
        density: re.density,
        disabled: re.disabled,
        icon: (Ke = fe.value[Ve]) == null ? void 0 : Ke.icon,
        ripple: re.ripple,
        size: re.size,
        variant: "plain"
      };
      return createVNode(Fragment, null, [createVNode("label", {
        for: Ue,
        class: {
          "v-rating__item--half": re.halfIncrements && Ee % 1 > 0,
          "v-rating__item--full": re.halfIncrements && Ee % 1 === 0
        },
        onMouseenter: Oe,
        onMouseleave: Ne,
        onClick: He
      }, [createVNode("span", {
        class: "v-rating__hidden"
      }, [ie(re.itemAriaLabel, Ee, re.length)]), Ae ? ae.item ? ae.item({
        ...fe.value[Ve],
        props: Ze,
        value: Ee,
        index: Ve,
        rating: ce.value
      }) : createVNode(VBtn, mergeProps({
        "aria-label": ie(re.itemAriaLabel, Ee, re.length)
      }, Ze), null) : void 0]), createVNode("input", {
        class: "v-rating__hidden",
        name: ge.value,
        id: Ue,
        type: "radio",
        value: Ee,
        checked: ce.value === Ee,
        tabindex: -1,
        readonly: re.readonly,
        disabled: re.disabled
      }, null)]);
    }
    function Se(Pe) {
      return ae["item-label"] ? ae["item-label"](Pe) : Pe.label ? createVNode("span", null, [Pe.label]) : createVNode("span", null, [createTextVNode(" ")]);
    }
    return useRender(() => {
      var Ee;
      const Pe = !!((Ee = re.itemLabels) != null && Ee.length) || ae["item-label"];
      return createVNode(re.tag, {
        class: ["v-rating", {
          "v-rating--hover": re.hover,
          "v-rating--readonly": re.readonly
        }, le.value, re.class],
        style: re.style
      }, {
        default: () => [createVNode(be, {
          value: 0,
          index: -1,
          showStar: !1
        }, null), ue.value.map((Ve, Ae) => {
          var Oe, Ne;
          return createVNode("div", {
            class: "v-rating__wrapper"
          }, [Pe && re.itemLabelPosition === "top" ? Se({
            value: Ve,
            index: Ae,
            label: (Oe = re.itemLabels) == null ? void 0 : Oe[Ae]
          }) : void 0, createVNode("div", {
            class: "v-rating__item"
          }, [re.halfIncrements ? createVNode(Fragment, null, [createVNode(be, {
            value: Ve - 0.5,
            index: Ae * 2
          }, null), createVNode(be, {
            value: Ve,
            index: Ae * 2 + 1
          }, null)]) : createVNode(be, {
            value: Ve,
            index: Ae
          }, null)]), Pe && re.itemLabelPosition === "bottom" ? Se({
            value: Ve,
            index: Ae,
            label: (Ne = re.itemLabels) == null ? void 0 : Ne[Ae]
          }) : void 0]);
        })]
      });
    }), {};
  }
}), rootTypes = {
  actions: "button@2",
  article: "heading, paragraph",
  avatar: "avatar",
  button: "button",
  card: "image, heading",
  "card-avatar": "image, list-item-avatar",
  chip: "chip",
  "date-picker": "list-item, heading, divider, date-picker-options, date-picker-days, actions",
  "date-picker-options": "text, avatar@2",
  "date-picker-days": "avatar@28",
  divider: "divider",
  heading: "heading",
  image: "image",
  "list-item": "text",
  "list-item-avatar": "avatar, text",
  "list-item-two-line": "sentences",
  "list-item-avatar-two-line": "avatar, sentences",
  "list-item-three-line": "paragraph",
  "list-item-avatar-three-line": "avatar, paragraph",
  ossein: "ossein",
  paragraph: "text@3",
  sentences: "text@2",
  subtitle: "text",
  table: "table-heading, table-thead, table-tbody, table-tfoot",
  "table-heading": "chip, text",
  "table-thead": "heading@6",
  "table-tbody": "table-row-divider@6",
  "table-row-divider": "table-row, divider",
  "table-row": "text@6",
  "table-tfoot": "text@2, avatar@2",
  text: "text"
};
function genBone(re) {
  let ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return createVNode("div", {
    class: ["v-skeleton-loader__bone", `v-skeleton-loader__${re}`]
  }, [ne]);
}
function genBones(re) {
  const [ne, ae] = re.split("@");
  return Array.from({
    length: ae
  }).map(() => genStructure(ne));
}
function genStructure(re) {
  let ne = [];
  if (!re) return ne;
  const ae = rootTypes[re];
  if (re !== ae) {
    if (re.includes(",")) return mapBones(re);
    if (re.includes("@")) return genBones(re);
    ae.includes(",") ? ne = mapBones(ae) : ae.includes("@") ? ne = genBones(ae) : ae && ne.push(genStructure(ae));
  }
  return [genBone(re, ne)];
}
function mapBones(re) {
  return re.replace(/\s/g, "").split(",").map(genStructure);
}
const makeVSkeletonLoaderProps = propsFactory({
  boilerplate: Boolean,
  color: String,
  loading: Boolean,
  loadingText: {
    type: String,
    default: "$vuetify.loading"
  },
  type: {
    type: [String, Array],
    default: "ossein"
  },
  ...makeDimensionProps(),
  ...makeElevationProps(),
  ...makeThemeProps()
}, "VSkeletonLoader"), VSkeletonLoader = genericComponent()({
  name: "VSkeletonLoader",
  props: makeVSkeletonLoaderProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      backgroundColorClasses: ie,
      backgroundColorStyles: le
    } = useBackgroundColor(toRef(re, "color")), {
      dimensionStyles: se
    } = useDimension(re), {
      elevationClasses: ce
    } = useElevation(re), {
      themeClasses: ue
    } = provideTheme(re), {
      t: de
    } = useLocale(), me = computed(() => genStructure(wrapInArray(re.type).join(",")));
    return useRender(() => {
      var ge;
      const fe = !ae.default || re.loading, pe = re.boilerplate || !fe ? {} : {
        ariaLive: "polite",
        ariaLabel: de(re.loadingText),
        role: "alert"
      };
      return createVNode("div", mergeProps({
        class: ["v-skeleton-loader", {
          "v-skeleton-loader--boilerplate": re.boilerplate
        }, ue.value, ie.value, ce.value],
        style: [le.value, fe ? se.value : {}]
      }, pe), [fe ? me.value : (ge = ae.default) == null ? void 0 : ge.call(ae)]);
    }), {};
  }
}), VSlideGroupItem = genericComponent()({
  name: "VSlideGroupItem",
  props: makeGroupItemProps(),
  emits: {
    "group:selected": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = useGroupItem(re, VSlideGroupSymbol);
    return () => {
      var le;
      return (le = ae.default) == null ? void 0 : le.call(ae, {
        isSelected: ie.isSelected.value,
        select: ie.select,
        toggle: ie.toggle,
        selectedClass: ie.selectedClass.value
      });
    };
  }
});
function useCountdown(re) {
  const ne = shallowRef(re());
  let ae = -1;
  function ie() {
    clearInterval(ae);
  }
  function le() {
    ie(), nextTick$2(() => ne.value = re());
  }
  function se(ce) {
    const ue = ce ? getComputedStyle(ce) : {
      transitionDuration: 0.2
    }, de = parseFloat(ue.transitionDuration) * 1e3 || 200;
    if (ie(), ne.value <= 0) return;
    const me = performance.now();
    ae = window.setInterval(() => {
      const fe = performance.now() - me + de;
      ne.value = Math.max(re() - fe, 0), ne.value <= 0 && ie();
    }, de);
  }
  return onScopeDispose(ie), {
    clear: ie,
    time: ne,
    start: se,
    reset: le
  };
}
const makeVSnackbarProps = propsFactory({
  multiLine: Boolean,
  text: String,
  timer: [Boolean, String],
  timeout: {
    type: [Number, String],
    default: 5e3
  },
  vertical: Boolean,
  ...makeLocationProps({
    location: "bottom"
  }),
  ...makePositionProps(),
  ...makeRoundedProps(),
  ...makeVariantProps(),
  ...makeThemeProps(),
  ...omit(makeVOverlayProps({
    transition: "v-snackbar-transition"
  }), ["persistent", "noClickAnimation", "scrim", "scrollStrategy"])
}, "VSnackbar"), VSnackbar = genericComponent()({
  name: "VSnackbar",
  props: makeVSnackbarProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = useProxiedModel(re, "modelValue"), {
      positionClasses: le
    } = usePosition(re), {
      scopeId: se
    } = useScopeId(), {
      themeClasses: ce
    } = provideTheme(re), {
      colorClasses: ue,
      colorStyles: de,
      variantClasses: me
    } = useVariant(re), {
      roundedClasses: fe
    } = useRounded(re), pe = useCountdown(() => Number(re.timeout)), ge = ref$1(), be = ref$1(), Se = shallowRef(!1), Pe = shallowRef(0), Ee = ref$1(), Ve = inject(VuetifyLayoutKey, void 0);
    useToggleScope(() => !!Ve, () => {
      const Re = useLayout();
      watchEffect(() => {
        Ee.value = Re.mainStyles.value;
      });
    }), watch(ie, Oe), watch(() => re.timeout, Oe), onMounted(() => {
      ie.value && Oe();
    });
    let Ae = -1;
    function Oe() {
      pe.reset(), window.clearTimeout(Ae);
      const Re = Number(re.timeout);
      if (!ie.value || Re === -1) return;
      const Ce = refElement(be.value);
      pe.start(Ce), Ae = window.setTimeout(() => {
        ie.value = !1;
      }, Re);
    }
    function Ne() {
      pe.reset(), window.clearTimeout(Ae);
    }
    function He() {
      Se.value = !0, Ne();
    }
    function Ue() {
      Se.value = !1, Oe();
    }
    function Ze(Re) {
      Pe.value = Re.touches[0].clientY;
    }
    function Fe(Re) {
      Math.abs(Pe.value - Re.changedTouches[0].clientY) > 50 && (ie.value = !1);
    }
    function Ke() {
      Se.value && Ue();
    }
    const tt = computed(() => re.location.split(" ").reduce((Re, Ce) => (Re[`v-snackbar--${Ce}`] = !0, Re), {}));
    return useRender(() => {
      const Re = VOverlay.filterProps(re), Ce = !!(ae.default || ae.text || re.text);
      return createVNode(VOverlay, mergeProps({
        ref: ge,
        class: ["v-snackbar", {
          "v-snackbar--active": ie.value,
          "v-snackbar--multi-line": re.multiLine && !re.vertical,
          "v-snackbar--timer": !!re.timer,
          "v-snackbar--vertical": re.vertical
        }, tt.value, le.value, re.class],
        style: [Ee.value, re.style]
      }, Re, {
        modelValue: ie.value,
        "onUpdate:modelValue": (_e) => ie.value = _e,
        contentProps: mergeProps({
          class: ["v-snackbar__wrapper", ce.value, ue.value, fe.value, me.value],
          style: [de.value],
          onPointerenter: He,
          onPointerleave: Ue
        }, Re.contentProps),
        persistent: !0,
        noClickAnimation: !0,
        scrim: !1,
        scrollStrategy: "none",
        _disableGlobalStack: !0,
        onTouchstartPassive: Ze,
        onTouchend: Fe,
        onAfterLeave: Ke
      }, se), {
        default: () => {
          var _e, he;
          return [genOverlays(!1, "v-snackbar"), re.timer && !Se.value && createVNode("div", {
            key: "timer",
            class: "v-snackbar__timer"
          }, [createVNode(VProgressLinear, {
            ref: be,
            color: typeof re.timer == "string" ? re.timer : "info",
            max: re.timeout,
            "model-value": pe.time.value
          }, null)]), Ce && createVNode("div", {
            key: "content",
            class: "v-snackbar__content",
            role: "status",
            "aria-live": "polite"
          }, [((_e = ae.text) == null ? void 0 : _e.call(ae)) ?? re.text, (he = ae.default) == null ? void 0 : he.call(ae)]), ae.actions && createVNode(VDefaultsProvider, {
            defaults: {
              VBtn: {
                variant: "text",
                ripple: !1,
                slim: !0
              }
            }
          }, {
            default: () => [createVNode("div", {
              class: "v-snackbar__actions"
            }, [ae.actions({
              isActive: ie
            })])]
          })];
        },
        activator: ae.activator
      });
    }), forwardRefs({}, ge);
  }
}), makeLineProps = propsFactory({
  autoDraw: Boolean,
  autoDrawDuration: [Number, String],
  autoDrawEasing: {
    type: String,
    default: "ease"
  },
  color: String,
  gradient: {
    type: Array,
    default: () => []
  },
  gradientDirection: {
    type: String,
    validator: (re) => ["top", "bottom", "left", "right"].includes(re),
    default: "top"
  },
  height: {
    type: [String, Number],
    default: 75
  },
  labels: {
    type: Array,
    default: () => []
  },
  labelSize: {
    type: [Number, String],
    default: 7
  },
  lineWidth: {
    type: [String, Number],
    default: 4
  },
  id: String,
  itemValue: {
    type: String,
    default: "value"
  },
  modelValue: {
    type: Array,
    default: () => []
  },
  min: [String, Number],
  max: [String, Number],
  padding: {
    type: [String, Number],
    default: 8
  },
  showLabels: Boolean,
  smooth: [Boolean, String, Number],
  width: {
    type: [Number, String],
    default: 300
  }
}, "Line"), makeVBarlineProps = propsFactory({
  autoLineWidth: Boolean,
  ...makeLineProps()
}, "VBarline"), VBarline = genericComponent()({
  name: "VBarline",
  props: makeVBarlineProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = getUid(), le = computed(() => re.id || `barline-${ie}`), se = computed(() => Number(re.autoDrawDuration) || 500), ce = computed(() => !!(re.showLabels || re.labels.length > 0 || ae != null && ae.label)), ue = computed(() => parseFloat(re.lineWidth) || 4), de = computed(() => Math.max(re.modelValue.length * ue.value, Number(re.width))), me = computed(() => ({
      minX: 0,
      maxX: de.value,
      minY: 0,
      maxY: parseInt(re.height, 10)
    })), fe = computed(() => re.modelValue.map((Ee) => getPropertyFromItem(Ee, re.itemValue, Ee)));
    function pe(Ee, Ve) {
      const {
        minX: Ae,
        maxX: Oe,
        minY: Ne,
        maxY: He
      } = Ve, Ue = Ee.length;
      let Ze = re.max != null ? Number(re.max) : Math.max(...Ee), Fe = re.min != null ? Number(re.min) : Math.min(...Ee);
      Fe > 0 && re.min == null && (Fe = 0), Ze < 0 && re.max == null && (Ze = 0);
      const Ke = Oe / Ue, tt = (He - Ne) / (Ze - Fe || 1), Re = He - Math.abs(Fe * tt);
      return Ee.map((Ce, _e) => {
        const he = Math.abs(tt * Ce);
        return {
          x: Ae + _e * Ke,
          y: Re - he + +(Ce < 0) * he,
          height: he,
          value: Ce
        };
      });
    }
    const ge = computed(() => {
      const Ee = [], Ve = pe(fe.value, me.value), Ae = Ve.length;
      for (let Oe = 0; Ee.length < Ae; Oe++) {
        const Ne = Ve[Oe];
        let He = re.labels[Oe];
        He || (He = typeof Ne == "object" ? Ne.value : Ne), Ee.push({
          x: Ne.x,
          value: String(He)
        });
      }
      return Ee;
    }), be = computed(() => pe(fe.value, me.value)), Se = computed(() => (Math.abs(be.value[0].x - be.value[1].x) - ue.value) / 2), Pe = computed(() => typeof re.smooth == "boolean" ? re.smooth ? 2 : 0 : Number(re.smooth));
    useRender(() => {
      const Ee = re.gradient.slice().length ? re.gradient.slice().reverse() : [""];
      return createVNode("svg", {
        display: "block"
      }, [createVNode("defs", null, [createVNode("linearGradient", {
        id: le.value,
        gradientUnits: "userSpaceOnUse",
        x1: re.gradientDirection === "left" ? "100%" : "0",
        y1: re.gradientDirection === "top" ? "100%" : "0",
        x2: re.gradientDirection === "right" ? "100%" : "0",
        y2: re.gradientDirection === "bottom" ? "100%" : "0"
      }, [Ee.map((Ve, Ae) => createVNode("stop", {
        offset: Ae / Math.max(Ee.length - 1, 1),
        "stop-color": Ve || "currentColor"
      }, null))])]), createVNode("clipPath", {
        id: `${le.value}-clip`
      }, [be.value.map((Ve) => createVNode("rect", {
        x: Ve.x + Se.value,
        y: Ve.y,
        width: ue.value,
        height: Ve.height,
        rx: Pe.value,
        ry: Pe.value
      }, [re.autoDraw && createVNode(Fragment, null, [createVNode("animate", {
        attributeName: "y",
        from: Ve.y + Ve.height,
        to: Ve.y,
        dur: `${se.value}ms`,
        fill: "freeze"
      }, null), createVNode("animate", {
        attributeName: "height",
        from: "0",
        to: Ve.height,
        dur: `${se.value}ms`,
        fill: "freeze"
      }, null)])]))]), ce.value && createVNode("g", {
        key: "labels",
        style: {
          textAnchor: "middle",
          dominantBaseline: "mathematical",
          fill: "currentColor"
        }
      }, [ge.value.map((Ve, Ae) => {
        var Oe;
        return createVNode("text", {
          x: Ve.x + Se.value + ue.value / 2,
          y: parseInt(re.height, 10) - 2 + (parseInt(re.labelSize, 10) || 7 * 0.75),
          "font-size": Number(re.labelSize) || 7
        }, [((Oe = ae.label) == null ? void 0 : Oe.call(ae, {
          index: Ae,
          value: Ve.value
        })) ?? Ve.value]);
      })]), createVNode("g", {
        "clip-path": `url(#${le.value}-clip)`,
        fill: `url(#${le.value})`
      }, [createVNode("rect", {
        x: 0,
        y: 0,
        width: Math.max(re.modelValue.length * ue.value, Number(re.width)),
        height: re.height
      }, null)])]);
    });
  }
});
function genPath(re, ne) {
  let ae = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, ie = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 75;
  if (re.length === 0) return "";
  const le = re.shift(), se = re[re.length - 1];
  return (ae ? `M${le.x} ${ie - le.x + 2} L${le.x} ${le.y}` : `M${le.x} ${le.y}`) + re.map((ce, ue) => {
    const de = re[ue + 1], me = re[ue - 1] || le, fe = de && checkCollinear(de, ce, me);
    if (!de || fe)
      return `L${ce.x} ${ce.y}`;
    const pe = Math.min(getDistance(me, ce), getDistance(de, ce)), be = pe / 2 < ne ? pe / 2 : ne, Se = moveTo(me, ce, be), Pe = moveTo(de, ce, be);
    return `L${Se.x} ${Se.y}S${ce.x} ${ce.y} ${Pe.x} ${Pe.y}`;
  }).join("") + (ae ? `L${se.x} ${ie - le.x + 2} Z` : "");
}
function int(re) {
  return parseInt(re, 10);
}
function checkCollinear(re, ne, ae) {
  return int(re.x + ae.x) === int(2 * ne.x) && int(re.y + ae.y) === int(2 * ne.y);
}
function getDistance(re, ne) {
  return Math.sqrt(Math.pow(ne.x - re.x, 2) + Math.pow(ne.y - re.y, 2));
}
function moveTo(re, ne, ae) {
  const ie = {
    x: re.x - ne.x,
    y: re.y - ne.y
  }, le = Math.sqrt(ie.x * ie.x + ie.y * ie.y), se = {
    x: ie.x / le,
    y: ie.y / le
  };
  return {
    x: ne.x + se.x * ae,
    y: ne.y + se.y * ae
  };
}
const makeVTrendlineProps = propsFactory({
  fill: Boolean,
  ...makeLineProps()
}, "VTrendline"), VTrendline = genericComponent()({
  name: "VTrendline",
  props: makeVTrendlineProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = getUid(), le = computed(() => re.id || `trendline-${ie}`), se = computed(() => Number(re.autoDrawDuration) || (re.fill ? 500 : 2e3)), ce = ref$1(0), ue = ref$1(null);
    function de(Ee, Ve) {
      const {
        minX: Ae,
        maxX: Oe,
        minY: Ne,
        maxY: He
      } = Ve, Ue = Ee.length, Ze = re.max != null ? Number(re.max) : Math.max(...Ee), Fe = re.min != null ? Number(re.min) : Math.min(...Ee), Ke = (Oe - Ae) / (Ue - 1), tt = (He - Ne) / (Ze - Fe || 1);
      return Ee.map((Re, Ce) => ({
        x: Ae + Ce * Ke,
        y: He - (Re - Fe) * tt,
        value: Re
      }));
    }
    const me = computed(() => !!(re.showLabels || re.labels.length > 0 || ae != null && ae.label)), fe = computed(() => parseFloat(re.lineWidth) || 4), pe = computed(() => Number(re.width)), ge = computed(() => {
      const Ee = Number(re.padding);
      return {
        minX: Ee,
        maxX: pe.value - Ee,
        minY: Ee,
        maxY: parseInt(re.height, 10) - Ee
      };
    }), be = computed(() => re.modelValue.map((Ee) => getPropertyFromItem(Ee, re.itemValue, Ee))), Se = computed(() => {
      const Ee = [], Ve = de(be.value, ge.value), Ae = Ve.length;
      for (let Oe = 0; Ee.length < Ae; Oe++) {
        const Ne = Ve[Oe];
        let He = re.labels[Oe];
        He || (He = typeof Ne == "object" ? Ne.value : Ne), Ee.push({
          x: Ne.x,
          value: String(He)
        });
      }
      return Ee;
    });
    watch(() => re.modelValue, async () => {
      if (await nextTick$2(), !re.autoDraw || !ue.value) return;
      const Ee = ue.value, Ve = Ee.getTotalLength();
      re.fill ? (Ee.style.transformOrigin = "bottom center", Ee.style.transition = "none", Ee.style.transform = "scaleY(0)", Ee.getBoundingClientRect(), Ee.style.transition = `transform ${se.value}ms ${re.autoDrawEasing}`, Ee.style.transform = "scaleY(1)") : (Ee.style.strokeDasharray = `${Ve}`, Ee.style.strokeDashoffset = `${Ve}`, Ee.getBoundingClientRect(), Ee.style.transition = `stroke-dashoffset ${se.value}ms ${re.autoDrawEasing}`, Ee.style.strokeDashoffset = "0"), ce.value = Ve;
    }, {
      immediate: !0
    });
    function Pe(Ee) {
      const Ve = typeof re.smooth == "boolean" ? re.smooth ? 8 : 0 : Number(re.smooth);
      return genPath(de(be.value, ge.value), Ve, Ee, parseInt(re.height, 10));
    }
    useRender(() => {
      var Ve;
      const Ee = re.gradient.slice().length ? re.gradient.slice().reverse() : [""];
      return createVNode("svg", {
        display: "block",
        "stroke-width": parseFloat(re.lineWidth) ?? 4
      }, [createVNode("defs", null, [createVNode("linearGradient", {
        id: le.value,
        gradientUnits: "userSpaceOnUse",
        x1: re.gradientDirection === "left" ? "100%" : "0",
        y1: re.gradientDirection === "top" ? "100%" : "0",
        x2: re.gradientDirection === "right" ? "100%" : "0",
        y2: re.gradientDirection === "bottom" ? "100%" : "0"
      }, [Ee.map((Ae, Oe) => createVNode("stop", {
        offset: Oe / Math.max(Ee.length - 1, 1),
        "stop-color": Ae || "currentColor"
      }, null))])]), me.value && createVNode("g", {
        key: "labels",
        style: {
          textAnchor: "middle",
          dominantBaseline: "mathematical",
          fill: "currentColor"
        }
      }, [Se.value.map((Ae, Oe) => {
        var Ne;
        return createVNode("text", {
          x: Ae.x + fe.value / 2 + fe.value / 2,
          y: parseInt(re.height, 10) - 4 + (parseInt(re.labelSize, 10) || 7 * 0.75),
          "font-size": Number(re.labelSize) || 7
        }, [((Ne = ae.label) == null ? void 0 : Ne.call(ae, {
          index: Oe,
          value: Ae.value
        })) ?? Ae.value]);
      })]), createVNode("path", {
        ref: ue,
        d: Pe(re.fill),
        fill: re.fill ? `url(#${le.value})` : "none",
        stroke: re.fill ? "none" : `url(#${le.value})`
      }, null), re.fill && createVNode("path", {
        d: Pe(!1),
        fill: "none",
        stroke: re.color ?? ((Ve = re.gradient) == null ? void 0 : Ve[0])
      }, null)]);
    });
  }
}), makeVSparklineProps = propsFactory({
  type: {
    type: String,
    default: "trend"
  },
  ...makeVBarlineProps(),
  ...makeVTrendlineProps()
}, "VSparkline"), VSparkline = genericComponent()({
  name: "VSparkline",
  props: makeVSparklineProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      textColorClasses: ie,
      textColorStyles: le
    } = useTextColor(toRef(re, "color")), se = computed(() => !!(re.showLabels || re.labels.length > 0 || ae != null && ae.label)), ce = computed(() => {
      let ue = parseInt(re.height, 10);
      return se.value && (ue += parseInt(re.labelSize, 10) * 1.5), ue;
    });
    useRender(() => {
      const ue = re.type === "trend" ? VTrendline : VBarline, de = re.type === "trend" ? VTrendline.filterProps(re) : VBarline.filterProps(re);
      return createVNode(ue, mergeProps({
        key: re.type,
        class: ie.value,
        style: le.value,
        viewBox: `0 0 ${re.width} ${parseInt(ce.value, 10)}`
      }, de), ae);
    });
  }
}), makeVSpeedDialProps = propsFactory({
  ...makeComponentProps(),
  ...makeVMenuProps({
    offset: 8,
    minWidth: 0,
    openDelay: 0,
    closeDelay: 100,
    location: "top center",
    transition: "scale-transition"
  })
}, "VSpeedDial"), VSpeedDial = genericComponent()({
  name: "VSpeedDial",
  props: makeVSpeedDialProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = useProxiedModel(re, "modelValue"), le = ref$1(), se = computed(() => {
      var me;
      const [ue, de = "center"] = ((me = re.location) == null ? void 0 : me.split(" ")) ?? [];
      return `${ue} ${de}`;
    }), ce = computed(() => ({
      [`v-speed-dial__content--${se.value.replace(" ", "-")}`]: !0
    }));
    return useRender(() => {
      const ue = VMenu.filterProps(re);
      return createVNode(VMenu, mergeProps(ue, {
        modelValue: ie.value,
        "onUpdate:modelValue": (de) => ie.value = de,
        class: re.class,
        style: re.style,
        contentClass: ["v-speed-dial__content", ce.value, re.contentClass],
        location: se.value,
        ref: le,
        transition: "fade-transition"
      }), {
        ...ae,
        default: (de) => createVNode(VDefaultsProvider, {
          defaults: {
            VBtn: {
              size: "small"
            }
          }
        }, {
          default: () => [createVNode(MaybeTransition, {
            appear: !0,
            group: !0,
            transition: re.transition
          }, {
            default: () => {
              var me;
              return [(me = ae.default) == null ? void 0 : me.call(ae, de)];
            }
          })]
        })
      });
    }), {};
  }
}), VStepperSymbol = Symbol.for("vuetify:v-stepper"), makeVStepperActionsProps = propsFactory({
  color: String,
  disabled: {
    type: [Boolean, String],
    default: !1
  },
  prevText: {
    type: String,
    default: "$vuetify.stepper.prev"
  },
  nextText: {
    type: String,
    default: "$vuetify.stepper.next"
  }
}, "VStepperActions"), VStepperActions = genericComponent()({
  name: "VStepperActions",
  props: makeVStepperActionsProps(),
  emits: {
    "click:prev": () => !0,
    "click:next": () => !0
  },
  setup(re, ne) {
    let {
      emit: ae,
      slots: ie
    } = ne;
    const {
      t: le
    } = useLocale();
    function se() {
      ae("click:prev");
    }
    function ce() {
      ae("click:next");
    }
    return useRender(() => {
      const ue = {
        onClick: se
      }, de = {
        onClick: ce
      };
      return createVNode("div", {
        class: "v-stepper-actions"
      }, [createVNode(VDefaultsProvider, {
        defaults: {
          VBtn: {
            disabled: ["prev", !0].includes(re.disabled),
            text: le(re.prevText),
            variant: "text"
          }
        }
      }, {
        default: () => {
          var me;
          return [((me = ie.prev) == null ? void 0 : me.call(ie, {
            props: ue
          })) ?? createVNode(VBtn, ue, null)];
        }
      }), createVNode(VDefaultsProvider, {
        defaults: {
          VBtn: {
            color: re.color,
            disabled: ["next", !0].includes(re.disabled),
            text: le(re.nextText),
            variant: "tonal"
          }
        }
      }, {
        default: () => {
          var me;
          return [((me = ie.next) == null ? void 0 : me.call(ie, {
            props: de
          })) ?? createVNode(VBtn, de, null)];
        }
      })]);
    }), {};
  }
}), VStepperHeader = createSimpleFunctional("v-stepper-header"), makeStepperItemProps = propsFactory({
  color: String,
  title: String,
  subtitle: String,
  complete: Boolean,
  completeIcon: {
    type: IconValue,
    default: "$complete"
  },
  editable: Boolean,
  editIcon: {
    type: IconValue,
    default: "$edit"
  },
  error: Boolean,
  errorIcon: {
    type: IconValue,
    default: "$error"
  },
  icon: IconValue,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  rules: {
    type: Array,
    default: () => []
  }
}, "StepperItem"), makeVStepperItemProps = propsFactory({
  ...makeStepperItemProps(),
  ...makeGroupItemProps()
}, "VStepperItem"), VStepperItem = genericComponent()({
  name: "VStepperItem",
  directives: {
    Ripple
  },
  props: makeVStepperItemProps(),
  emits: {
    "group:selected": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = useGroupItem(re, VStepperSymbol, !0), le = computed(() => (ie == null ? void 0 : ie.value.value) ?? re.value), se = computed(() => re.rules.every((ge) => ge() === !0)), ce = computed(() => !re.disabled && re.editable), ue = computed(() => !re.disabled && re.editable), de = computed(() => re.error || !se.value), me = computed(() => re.complete || re.rules.length > 0 && se.value), fe = computed(() => de.value ? re.errorIcon : me.value ? re.completeIcon : ie.isSelected.value && re.editable ? re.editIcon : re.icon), pe = computed(() => ({
      canEdit: ue.value,
      hasError: de.value,
      hasCompleted: me.value,
      title: re.title,
      subtitle: re.subtitle,
      step: le.value,
      value: re.value
    }));
    return useRender(() => {
      var Ee, Ve, Ae;
      const ge = (!ie || ie.isSelected.value || me.value || ue.value) && !de.value && !re.disabled, be = !!(re.title != null || ae.title), Se = !!(re.subtitle != null || ae.subtitle);
      function Pe() {
        ie == null || ie.toggle();
      }
      return withDirectives(createVNode("button", {
        class: ["v-stepper-item", {
          "v-stepper-item--complete": me.value,
          "v-stepper-item--disabled": re.disabled,
          "v-stepper-item--error": de.value
        }, ie == null ? void 0 : ie.selectedClass.value],
        disabled: !re.editable,
        type: "button",
        onClick: Pe
      }, [ce.value && genOverlays(!0, "v-stepper-item"), createVNode(VAvatar, {
        key: "stepper-avatar",
        class: "v-stepper-item__avatar",
        color: ge ? re.color : void 0,
        size: 24
      }, {
        default: () => {
          var Oe;
          return [((Oe = ae.icon) == null ? void 0 : Oe.call(ae, pe.value)) ?? (fe.value ? createVNode(VIcon, {
            icon: fe.value
          }, null) : le.value)];
        }
      }), createVNode("div", {
        class: "v-stepper-item__content"
      }, [be && createVNode("div", {
        key: "title",
        class: "v-stepper-item__title"
      }, [((Ee = ae.title) == null ? void 0 : Ee.call(ae, pe.value)) ?? re.title]), Se && createVNode("div", {
        key: "subtitle",
        class: "v-stepper-item__subtitle"
      }, [((Ve = ae.subtitle) == null ? void 0 : Ve.call(ae, pe.value)) ?? re.subtitle]), (Ae = ae.default) == null ? void 0 : Ae.call(ae, pe.value)])]), [[resolveDirective("ripple"), re.ripple && re.editable, null]]);
    }), {};
  }
}), makeVStepperWindowProps = propsFactory({
  ...omit(makeVWindowProps(), ["continuous", "nextIcon", "prevIcon", "showArrows", "touch", "mandatory"])
}, "VStepperWindow"), VStepperWindow = genericComponent()({
  name: "VStepperWindow",
  props: makeVStepperWindowProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = inject(VStepperSymbol, null), le = useProxiedModel(re, "modelValue"), se = computed({
      get() {
        var ce;
        return le.value != null || !ie ? le.value : (ce = ie.items.value.find((ue) => ie.selected.value.includes(ue.id))) == null ? void 0 : ce.value;
      },
      set(ce) {
        le.value = ce;
      }
    });
    return useRender(() => {
      const ce = VWindow.filterProps(re);
      return createVNode(VWindow, mergeProps({
        _as: "VStepperWindow"
      }, ce, {
        modelValue: se.value,
        "onUpdate:modelValue": (ue) => se.value = ue,
        class: ["v-stepper-window", re.class],
        style: re.style,
        mandatory: !1,
        touch: !1
      }), ae);
    }), {};
  }
}), makeVStepperWindowItemProps = propsFactory({
  ...makeVWindowItemProps()
}, "VStepperWindowItem"), VStepperWindowItem = genericComponent()({
  name: "VStepperWindowItem",
  props: makeVStepperWindowItemProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    return useRender(() => {
      const ie = VWindowItem.filterProps(re);
      return createVNode(VWindowItem, mergeProps({
        _as: "VStepperWindowItem"
      }, ie, {
        class: ["v-stepper-window-item", re.class],
        style: re.style
      }), ae);
    }), {};
  }
}), makeStepperProps = propsFactory({
  altLabels: Boolean,
  bgColor: String,
  completeIcon: IconValue,
  editIcon: IconValue,
  editable: Boolean,
  errorIcon: IconValue,
  hideActions: Boolean,
  items: {
    type: Array,
    default: () => []
  },
  itemTitle: {
    type: String,
    default: "title"
  },
  itemValue: {
    type: String,
    default: "value"
  },
  nonLinear: Boolean,
  flat: Boolean,
  ...makeDisplayProps()
}, "Stepper"), makeVStepperProps = propsFactory({
  ...makeStepperProps(),
  ...makeGroupProps({
    mandatory: "force",
    selectedClass: "v-stepper-item--selected"
  }),
  ...makeVSheetProps(),
  ...pick(makeVStepperActionsProps(), ["prevText", "nextText"])
}, "VStepper"), VStepper = genericComponent()({
  name: "VStepper",
  props: makeVStepperProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      items: ie,
      next: le,
      prev: se,
      selected: ce
    } = useGroup(re, VStepperSymbol), {
      displayClasses: ue,
      mobile: de
    } = useDisplay(re), {
      completeIcon: me,
      editIcon: fe,
      errorIcon: pe,
      color: ge,
      editable: be,
      prevText: Se,
      nextText: Pe
    } = toRefs(re), Ee = computed(() => re.items.map((Oe, Ne) => {
      const He = getPropertyFromItem(Oe, re.itemTitle, Oe), Ue = getPropertyFromItem(Oe, re.itemValue, Ne + 1);
      return {
        title: He,
        value: Ue,
        raw: Oe
      };
    })), Ve = computed(() => ie.value.findIndex((Oe) => ce.value.includes(Oe.id))), Ae = computed(() => re.disabled ? re.disabled : Ve.value === 0 ? "prev" : Ve.value === ie.value.length - 1 ? "next" : !1);
    return provideDefaults({
      VStepperItem: {
        editable: be,
        errorIcon: pe,
        completeIcon: me,
        editIcon: fe,
        prevText: Se,
        nextText: Pe
      },
      VStepperActions: {
        color: ge,
        disabled: Ae,
        prevText: Se,
        nextText: Pe
      }
    }), useRender(() => {
      const Oe = VSheet.filterProps(re), Ne = !!(ae.header || re.items.length), He = re.items.length > 0, Ue = !re.hideActions && !!(He || ae.actions);
      return createVNode(VSheet, mergeProps(Oe, {
        color: re.bgColor,
        class: ["v-stepper", {
          "v-stepper--alt-labels": re.altLabels,
          "v-stepper--flat": re.flat,
          "v-stepper--non-linear": re.nonLinear,
          "v-stepper--mobile": de.value
        }, ue.value, re.class],
        style: re.style
      }), {
        default: () => {
          var Ze, Fe;
          return [Ne && createVNode(VStepperHeader, {
            key: "stepper-header"
          }, {
            default: () => [Ee.value.map((Ke, tt) => {
              let {
                raw: Re,
                ...Ce
              } = Ke;
              return createVNode(Fragment, null, [!!tt && createVNode(VDivider, null, null), createVNode(VStepperItem, Ce, {
                default: ae[`header-item.${Ce.value}`] ?? ae.header,
                icon: ae.icon,
                title: ae.title,
                subtitle: ae.subtitle
              })]);
            })]
          }), He && createVNode(VStepperWindow, {
            key: "stepper-window"
          }, {
            default: () => [Ee.value.map((Ke) => createVNode(VStepperWindowItem, {
              value: Ke.value
            }, {
              default: () => {
                var tt, Re;
                return ((tt = ae[`item.${Ke.value}`]) == null ? void 0 : tt.call(ae, Ke)) ?? ((Re = ae.item) == null ? void 0 : Re.call(ae, Ke));
              }
            }))]
          }), (Ze = ae.default) == null ? void 0 : Ze.call(ae, {
            prev: se,
            next: le
          }), Ue && (((Fe = ae.actions) == null ? void 0 : Fe.call(ae, {
            next: le,
            prev: se
          })) ?? createVNode(VStepperActions, {
            key: "stepper-actions",
            "onClick:prev": se,
            "onClick:next": le
          }, ae))];
        }
      });
    }), {
      prev: se,
      next: le
    };
  }
}), makeVSwitchProps = propsFactory({
  indeterminate: Boolean,
  inset: Boolean,
  flat: Boolean,
  loading: {
    type: [Boolean, String],
    default: !1
  },
  ...makeVInputProps(),
  ...makeVSelectionControlProps()
}, "VSwitch"), VSwitch = genericComponent()({
  name: "VSwitch",
  inheritAttrs: !1,
  props: makeVSwitchProps(),
  emits: {
    "update:focused": (re) => !0,
    "update:modelValue": (re) => !0,
    "update:indeterminate": (re) => !0
  },
  setup(re, ne) {
    let {
      attrs: ae,
      slots: ie
    } = ne;
    const le = useProxiedModel(re, "indeterminate"), se = useProxiedModel(re, "modelValue"), {
      loaderClasses: ce
    } = useLoader(re), {
      isFocused: ue,
      focus: de,
      blur: me
    } = useFocus(re), fe = ref$1(), pe = IN_BROWSER && window.matchMedia("(forced-colors: active)").matches, ge = computed(() => typeof re.loading == "string" && re.loading !== "" ? re.loading : re.color), be = getUid(), Se = computed(() => re.id || `switch-${be}`);
    function Pe() {
      le.value && (le.value = !1);
    }
    function Ee(Ve) {
      var Ae, Oe;
      Ve.stopPropagation(), Ve.preventDefault(), (Oe = (Ae = fe.value) == null ? void 0 : Ae.input) == null || Oe.click();
    }
    return useRender(() => {
      const [Ve, Ae] = filterInputAttrs(ae), Oe = VInput.filterProps(re), Ne = VSelectionControl.filterProps(re);
      return createVNode(VInput, mergeProps({
        class: ["v-switch", {
          "v-switch--flat": re.flat
        }, {
          "v-switch--inset": re.inset
        }, {
          "v-switch--indeterminate": le.value
        }, ce.value, re.class]
      }, Ve, Oe, {
        modelValue: se.value,
        "onUpdate:modelValue": (He) => se.value = He,
        id: Se.value,
        focused: ue.value,
        style: re.style
      }), {
        ...ie,
        default: (He) => {
          let {
            id: Ue,
            messagesId: Ze,
            isDisabled: Fe,
            isReadonly: Ke,
            isValid: tt
          } = He;
          const Re = {
            model: se,
            isValid: tt
          };
          return createVNode(VSelectionControl, mergeProps({
            ref: fe
          }, Ne, {
            modelValue: se.value,
            "onUpdate:modelValue": [(Ce) => se.value = Ce, Pe],
            id: Ue.value,
            "aria-describedby": Ze.value,
            type: "checkbox",
            "aria-checked": le.value ? "mixed" : void 0,
            disabled: Fe.value,
            readonly: Ke.value,
            onFocus: de,
            onBlur: me
          }, Ae), {
            ...ie,
            default: (Ce) => {
              let {
                backgroundColorClasses: _e,
                backgroundColorStyles: he
              } = Ce;
              return createVNode("div", {
                class: ["v-switch__track", pe ? void 0 : _e.value],
                style: he.value,
                onClick: Ee
              }, [ie["track-true"] && createVNode("div", {
                key: "prepend",
                class: "v-switch__track-true"
              }, [ie["track-true"](Re)]), ie["track-false"] && createVNode("div", {
                key: "append",
                class: "v-switch__track-false"
              }, [ie["track-false"](Re)])]);
            },
            input: (Ce) => {
              let {
                inputNode: _e,
                icon: he,
                backgroundColorClasses: ve,
                backgroundColorStyles: xe
              } = Ce;
              return createVNode(Fragment, null, [_e, createVNode("div", {
                class: ["v-switch__thumb", {
                  "v-switch__thumb--filled": he || re.loading
                }, re.inset || pe ? void 0 : ve.value],
                style: re.inset ? void 0 : xe.value
              }, [ie.thumb ? createVNode(VDefaultsProvider, {
                defaults: {
                  VIcon: {
                    icon: he,
                    size: "x-small"
                  }
                }
              }, {
                default: () => [ie.thumb({
                  ...Re,
                  icon: he
                })]
              }) : createVNode(VScaleTransition, null, {
                default: () => [re.loading ? createVNode(LoaderSlot, {
                  name: "v-switch",
                  active: !0,
                  color: tt.value === !1 ? void 0 : ge.value
                }, {
                  default: ($e) => ie.loader ? ie.loader($e) : createVNode(VProgressCircular, {
                    active: $e.isActive,
                    color: $e.color,
                    indeterminate: !0,
                    size: "16",
                    width: "2"
                  }, null)
                }) : he && createVNode(VIcon, {
                  key: String(he),
                  icon: he,
                  size: "x-small"
                }, null)]
              })])]);
            }
          });
        }
      });
    }), {};
  }
}), makeVSystemBarProps = propsFactory({
  color: String,
  height: [Number, String],
  window: Boolean,
  ...makeComponentProps(),
  ...makeElevationProps(),
  ...makeLayoutItemProps(),
  ...makeRoundedProps(),
  ...makeTagProps(),
  ...makeThemeProps()
}, "VSystemBar"), VSystemBar = genericComponent()({
  name: "VSystemBar",
  props: makeVSystemBarProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      themeClasses: ie
    } = provideTheme(re), {
      backgroundColorClasses: le,
      backgroundColorStyles: se
    } = useBackgroundColor(toRef(re, "color")), {
      elevationClasses: ce
    } = useElevation(re), {
      roundedClasses: ue
    } = useRounded(re), {
      ssrBootStyles: de
    } = useSsrBoot(), me = computed(() => re.height ?? (re.window ? 32 : 24)), {
      layoutItemStyles: fe
    } = useLayoutItem({
      id: re.name,
      order: computed(() => parseInt(re.order, 10)),
      position: shallowRef("top"),
      layoutSize: me,
      elementSize: me,
      active: computed(() => !0),
      absolute: toRef(re, "absolute")
    });
    return useRender(() => createVNode(re.tag, {
      class: ["v-system-bar", {
        "v-system-bar--window": re.window
      }, ie.value, le.value, ce.value, ue.value, re.class],
      style: [se.value, fe.value, de.value, re.style]
    }, ae)), {};
  }
}), VTabsSymbol = Symbol.for("vuetify:v-tabs"), makeVTabProps = propsFactory({
  fixed: Boolean,
  sliderColor: String,
  hideSlider: Boolean,
  direction: {
    type: String,
    default: "horizontal"
  },
  ...omit(makeVBtnProps({
    selectedClass: "v-tab--selected",
    variant: "text"
  }), ["active", "block", "flat", "location", "position", "symbol"])
}, "VTab"), VTab = genericComponent()({
  name: "VTab",
  props: makeVTabProps(),
  setup(re, ne) {
    let {
      slots: ae,
      attrs: ie
    } = ne;
    const {
      textColorClasses: le,
      textColorStyles: se
    } = useTextColor(re, "sliderColor"), ce = ref$1(), ue = ref$1(), de = computed(() => re.direction === "horizontal"), me = computed(() => {
      var pe, ge;
      return ((ge = (pe = ce.value) == null ? void 0 : pe.group) == null ? void 0 : ge.isSelected.value) ?? !1;
    });
    function fe(pe) {
      var be, Se;
      let {
        value: ge
      } = pe;
      if (ge) {
        const Pe = (Se = (be = ce.value) == null ? void 0 : be.$el.parentElement) == null ? void 0 : Se.querySelector(".v-tab--selected .v-tab__slider"), Ee = ue.value;
        if (!Pe || !Ee) return;
        const Ve = getComputedStyle(Pe).color, Ae = Pe.getBoundingClientRect(), Oe = Ee.getBoundingClientRect(), Ne = de.value ? "x" : "y", He = de.value ? "X" : "Y", Ue = de.value ? "right" : "bottom", Ze = de.value ? "width" : "height", Fe = Ae[Ne], Ke = Oe[Ne], tt = Fe > Ke ? Ae[Ue] - Oe[Ue] : Ae[Ne] - Oe[Ne], Re = Math.sign(tt) > 0 ? de.value ? "right" : "bottom" : Math.sign(tt) < 0 ? de.value ? "left" : "top" : "center", _e = (Math.abs(tt) + (Math.sign(tt) < 0 ? Ae[Ze] : Oe[Ze])) / Math.max(Ae[Ze], Oe[Ze]) || 0, he = Ae[Ze] / Oe[Ze] || 0, ve = 1.5;
        animate(Ee, {
          backgroundColor: [Ve, "currentcolor"],
          transform: [`translate${He}(${tt}px) scale${He}(${he})`, `translate${He}(${tt / ve}px) scale${He}(${(_e - 1) / ve + 1})`, "none"],
          transformOrigin: Array(3).fill(Re)
        }, {
          duration: 225,
          easing: standardEasing
        });
      }
    }
    return useRender(() => {
      const pe = VBtn.filterProps(re);
      return createVNode(VBtn, mergeProps({
        symbol: VTabsSymbol,
        ref: ce,
        class: ["v-tab", re.class],
        style: re.style,
        tabindex: me.value ? 0 : -1,
        role: "tab",
        "aria-selected": String(me.value),
        active: !1
      }, pe, ie, {
        block: re.fixed,
        maxWidth: re.fixed ? 300 : void 0,
        "onGroup:selected": fe
      }), {
        ...ae,
        default: () => {
          var ge;
          return createVNode(Fragment, null, [((ge = ae.default) == null ? void 0 : ge.call(ae)) ?? re.text, !re.hideSlider && createVNode("div", {
            ref: ue,
            class: ["v-tab__slider", le.value],
            style: se.value
          }, null)]);
        }
      });
    }), forwardRefs({}, ce);
  }
}), makeVTabsWindowProps = propsFactory({
  ...omit(makeVWindowProps(), ["continuous", "nextIcon", "prevIcon", "showArrows", "touch", "mandatory"])
}, "VTabsWindow"), VTabsWindow = genericComponent()({
  name: "VTabsWindow",
  props: makeVTabsWindowProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = inject(VTabsSymbol, null), le = useProxiedModel(re, "modelValue"), se = computed({
      get() {
        var ce;
        return le.value != null || !ie ? le.value : (ce = ie.items.value.find((ue) => ie.selected.value.includes(ue.id))) == null ? void 0 : ce.value;
      },
      set(ce) {
        le.value = ce;
      }
    });
    return useRender(() => {
      const ce = VWindow.filterProps(re);
      return createVNode(VWindow, mergeProps({
        _as: "VTabsWindow"
      }, ce, {
        modelValue: se.value,
        "onUpdate:modelValue": (ue) => se.value = ue,
        class: ["v-tabs-window", re.class],
        style: re.style,
        mandatory: !1,
        touch: !1
      }), ae);
    }), {};
  }
}), makeVTabsWindowItemProps = propsFactory({
  ...makeVWindowItemProps()
}, "VTabsWindowItem"), VTabsWindowItem = genericComponent()({
  name: "VTabsWindowItem",
  props: makeVTabsWindowItemProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    return useRender(() => {
      const ie = VWindowItem.filterProps(re);
      return createVNode(VWindowItem, mergeProps({
        _as: "VTabsWindowItem"
      }, ie, {
        class: ["v-tabs-window-item", re.class],
        style: re.style
      }), ae);
    }), {};
  }
});
function parseItems(re) {
  return re ? re.map((ne) => isObject$8(ne) ? ne : {
    text: ne,
    value: ne
  }) : [];
}
const makeVTabsProps = propsFactory({
  alignTabs: {
    type: String,
    default: "start"
  },
  color: String,
  fixedTabs: Boolean,
  items: {
    type: Array,
    default: () => []
  },
  stacked: Boolean,
  bgColor: String,
  grow: Boolean,
  height: {
    type: [Number, String],
    default: void 0
  },
  hideSlider: Boolean,
  sliderColor: String,
  ...makeVSlideGroupProps({
    mandatory: "force",
    selectedClass: "v-tab-item--selected"
  }),
  ...makeDensityProps(),
  ...makeTagProps()
}, "VTabs"), VTabs = genericComponent()({
  name: "VTabs",
  props: makeVTabsProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      attrs: ae,
      slots: ie
    } = ne;
    const le = useProxiedModel(re, "modelValue"), se = computed(() => parseItems(re.items)), {
      densityClasses: ce
    } = useDensity(re), {
      backgroundColorClasses: ue,
      backgroundColorStyles: de
    } = useBackgroundColor(toRef(re, "bgColor")), {
      scopeId: me
    } = useScopeId();
    return provideDefaults({
      VTab: {
        color: toRef(re, "color"),
        direction: toRef(re, "direction"),
        stacked: toRef(re, "stacked"),
        fixed: toRef(re, "fixedTabs"),
        sliderColor: toRef(re, "sliderColor"),
        hideSlider: toRef(re, "hideSlider")
      }
    }), useRender(() => {
      const fe = VSlideGroup.filterProps(re), pe = !!(ie.window || re.items.length > 0);
      return createVNode(Fragment, null, [createVNode(VSlideGroup, mergeProps(fe, {
        modelValue: le.value,
        "onUpdate:modelValue": (ge) => le.value = ge,
        class: ["v-tabs", `v-tabs--${re.direction}`, `v-tabs--align-tabs-${re.alignTabs}`, {
          "v-tabs--fixed-tabs": re.fixedTabs,
          "v-tabs--grow": re.grow,
          "v-tabs--stacked": re.stacked
        }, ce.value, ue.value, re.class],
        style: [{
          "--v-tabs-height": convertToUnit(re.height)
        }, de.value, re.style],
        role: "tablist",
        symbol: VTabsSymbol
      }, me, ae), {
        default: () => {
          var ge;
          return [((ge = ie.default) == null ? void 0 : ge.call(ie)) ?? se.value.map((be) => {
            var Se;
            return ((Se = ie.tab) == null ? void 0 : Se.call(ie, {
              item: be
            })) ?? createVNode(VTab, mergeProps(be, {
              key: be.text,
              value: be.value
            }), {
              default: ie[`tab.${be.value}`] ? () => {
                var Pe;
                return (Pe = ie[`tab.${be.value}`]) == null ? void 0 : Pe.call(ie, {
                  item: be
                });
              } : void 0
            });
          })];
        }
      }), pe && createVNode(VTabsWindow, mergeProps({
        modelValue: le.value,
        "onUpdate:modelValue": (ge) => le.value = ge,
        key: "tabs-window"
      }, me), {
        default: () => {
          var ge;
          return [se.value.map((be) => {
            var Se;
            return ((Se = ie.item) == null ? void 0 : Se.call(ie, {
              item: be
            })) ?? createVNode(VTabsWindowItem, {
              value: be.value
            }, {
              default: () => {
                var Pe;
                return (Pe = ie[`item.${be.value}`]) == null ? void 0 : Pe.call(ie, {
                  item: be
                });
              }
            });
          }), (ge = ie.window) == null ? void 0 : ge.call(ie)];
        }
      })]);
    }), {};
  }
}), makeVTextareaProps = propsFactory({
  autoGrow: Boolean,
  autofocus: Boolean,
  counter: [Boolean, Number, String],
  counterValue: Function,
  prefix: String,
  placeholder: String,
  persistentPlaceholder: Boolean,
  persistentCounter: Boolean,
  noResize: Boolean,
  rows: {
    type: [Number, String],
    default: 5,
    validator: (re) => !isNaN(parseFloat(re))
  },
  maxRows: {
    type: [Number, String],
    validator: (re) => !isNaN(parseFloat(re))
  },
  suffix: String,
  modelModifiers: Object,
  ...makeVInputProps(),
  ...makeVFieldProps()
}, "VTextarea"), VTextarea = genericComponent()({
  name: "VTextarea",
  directives: {
    Intersect
  },
  inheritAttrs: !1,
  props: makeVTextareaProps(),
  emits: {
    "click:control": (re) => !0,
    "mousedown:control": (re) => !0,
    "update:focused": (re) => !0,
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      attrs: ae,
      emit: ie,
      slots: le
    } = ne;
    const se = useProxiedModel(re, "modelValue"), {
      isFocused: ce,
      focus: ue,
      blur: de
    } = useFocus(re), me = computed(() => typeof re.counterValue == "function" ? re.counterValue(se.value) : (se.value || "").toString().length), fe = computed(() => {
      if (ae.maxlength) return ae.maxlength;
      if (!(!re.counter || typeof re.counter != "number" && typeof re.counter != "string"))
        return re.counter;
    });
    function pe(Re, Ce) {
      var _e, he;
      !re.autofocus || !Re || (he = (_e = Ce[0].target) == null ? void 0 : _e.focus) == null || he.call(_e);
    }
    const ge = ref$1(), be = ref$1(), Se = shallowRef(""), Pe = ref$1(), Ee = computed(() => re.persistentPlaceholder || ce.value || re.active);
    function Ve() {
      var Re;
      Pe.value !== document.activeElement && ((Re = Pe.value) == null || Re.focus()), ce.value || ue();
    }
    function Ae(Re) {
      Ve(), ie("click:control", Re);
    }
    function Oe(Re) {
      ie("mousedown:control", Re);
    }
    function Ne(Re) {
      Re.stopPropagation(), Ve(), nextTick$2(() => {
        se.value = "", callEvent(re["onClick:clear"], Re);
      });
    }
    function He(Re) {
      var _e;
      const Ce = Re.target;
      if (se.value = Ce.value, (_e = re.modelModifiers) != null && _e.trim) {
        const he = [Ce.selectionStart, Ce.selectionEnd];
        nextTick$2(() => {
          Ce.selectionStart = he[0], Ce.selectionEnd = he[1];
        });
      }
    }
    const Ue = ref$1(), Ze = ref$1(Number(re.rows)), Fe = computed(() => ["plain", "underlined"].includes(re.variant));
    watchEffect(() => {
      re.autoGrow || (Ze.value = Number(re.rows));
    });
    function Ke() {
      re.autoGrow && nextTick$2(() => {
        if (!Ue.value || !be.value) return;
        const Re = getComputedStyle(Ue.value), Ce = getComputedStyle(be.value.$el), _e = parseFloat(Re.getPropertyValue("--v-field-padding-top")) + parseFloat(Re.getPropertyValue("--v-input-padding-top")) + parseFloat(Re.getPropertyValue("--v-field-padding-bottom")), he = Ue.value.scrollHeight, ve = parseFloat(Re.lineHeight), xe = Math.max(parseFloat(re.rows) * ve + _e, parseFloat(Ce.getPropertyValue("--v-input-control-height"))), $e = parseFloat(re.maxRows) * ve + _e || 1 / 0, Te = clamp(he ?? 0, xe, $e);
        Ze.value = Math.floor((Te - _e) / ve), Se.value = convertToUnit(Te);
      });
    }
    onMounted(Ke), watch(se, Ke), watch(() => re.rows, Ke), watch(() => re.maxRows, Ke), watch(() => re.density, Ke);
    let tt;
    return watch(Ue, (Re) => {
      Re ? (tt = new ResizeObserver(Ke), tt.observe(Ue.value)) : tt == null || tt.disconnect();
    }), onBeforeUnmount(() => {
      tt == null || tt.disconnect();
    }), useRender(() => {
      const Re = !!(le.counter || re.counter || re.counterValue), Ce = !!(Re || le.details), [_e, he] = filterInputAttrs(ae), {
        modelValue: ve,
        ...xe
      } = VInput.filterProps(re), $e = VField.filterProps(re);
      return createVNode(VInput, mergeProps({
        ref: ge,
        modelValue: se.value,
        "onUpdate:modelValue": (Te) => se.value = Te,
        class: ["v-textarea v-text-field", {
          "v-textarea--prefixed": re.prefix,
          "v-textarea--suffixed": re.suffix,
          "v-text-field--prefixed": re.prefix,
          "v-text-field--suffixed": re.suffix,
          "v-textarea--auto-grow": re.autoGrow,
          "v-textarea--no-resize": re.noResize || re.autoGrow,
          "v-input--plain-underlined": Fe.value
        }, re.class],
        style: re.style
      }, _e, xe, {
        centerAffix: Ze.value === 1 && !Fe.value,
        focused: ce.value
      }), {
        ...le,
        default: (Te) => {
          let {
            id: Ie,
            isDisabled: we,
            isDirty: ke,
            isReadonly: ye,
            isValid: Be
          } = Te;
          return createVNode(VField, mergeProps({
            ref: be,
            style: {
              "--v-textarea-control-height": Se.value
            },
            onClick: Ae,
            onMousedown: Oe,
            "onClick:clear": Ne,
            "onClick:prependInner": re["onClick:prependInner"],
            "onClick:appendInner": re["onClick:appendInner"]
          }, $e, {
            id: Ie.value,
            active: Ee.value || ke.value,
            centerAffix: Ze.value === 1 && !Fe.value,
            dirty: ke.value || re.dirty,
            disabled: we.value,
            focused: ce.value,
            error: Be.value === !1
          }), {
            ...le,
            default: (Xe) => {
              let {
                props: {
                  class: et,
                  ...Ye
                }
              } = Xe;
              return createVNode(Fragment, null, [re.prefix && createVNode("span", {
                class: "v-text-field__prefix"
              }, [re.prefix]), withDirectives(createVNode("textarea", mergeProps({
                ref: Pe,
                class: et,
                value: se.value,
                onInput: He,
                autofocus: re.autofocus,
                readonly: ye.value,
                disabled: we.value,
                placeholder: re.placeholder,
                rows: re.rows,
                name: re.name,
                onFocus: Ve,
                onBlur: de
              }, Ye, he), null), [[resolveDirective("intersect"), {
                handler: pe
              }, null, {
                once: !0
              }]]), re.autoGrow && withDirectives(createVNode("textarea", {
                class: [et, "v-textarea__sizer"],
                id: `${Ye.id}-sizer`,
                "onUpdate:modelValue": (De) => se.value = De,
                ref: Ue,
                readonly: !0,
                "aria-hidden": "true"
              }, null), [[vModelText, se.value]]), re.suffix && createVNode("span", {
                class: "v-text-field__suffix"
              }, [re.suffix])]);
            }
          });
        },
        details: Ce ? (Te) => {
          var Ie;
          return createVNode(Fragment, null, [(Ie = le.details) == null ? void 0 : Ie.call(le, Te), Re && createVNode(Fragment, null, [createVNode("span", null, null), createVNode(VCounter, {
            active: re.persistentCounter || ce.value,
            value: me.value,
            max: fe.value,
            disabled: re.disabled
          }, le.counter)])]);
        } : void 0
      });
    }), forwardRefs({}, ge, be, Pe);
  }
}), makeVThemeProviderProps = propsFactory({
  withBackground: Boolean,
  ...makeComponentProps(),
  ...makeThemeProps(),
  ...makeTagProps()
}, "VThemeProvider"), VThemeProvider = genericComponent()({
  name: "VThemeProvider",
  props: makeVThemeProviderProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      themeClasses: ie
    } = provideTheme(re);
    return () => {
      var le;
      return re.withBackground ? createVNode(re.tag, {
        class: ["v-theme-provider", ie.value, re.class],
        style: re.style
      }, {
        default: () => {
          var se;
          return [(se = ae.default) == null ? void 0 : se.call(ae)];
        }
      }) : (le = ae.default) == null ? void 0 : le.call(ae);
    };
  }
}), makeVTimelineDividerProps = propsFactory({
  dotColor: String,
  fillDot: Boolean,
  hideDot: Boolean,
  icon: IconValue,
  iconColor: String,
  lineColor: String,
  ...makeComponentProps(),
  ...makeRoundedProps(),
  ...makeSizeProps(),
  ...makeElevationProps()
}, "VTimelineDivider"), VTimelineDivider = genericComponent()({
  name: "VTimelineDivider",
  props: makeVTimelineDividerProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      sizeClasses: ie,
      sizeStyles: le
    } = useSize(re, "v-timeline-divider__dot"), {
      backgroundColorStyles: se,
      backgroundColorClasses: ce
    } = useBackgroundColor(toRef(re, "dotColor")), {
      roundedClasses: ue
    } = useRounded(re, "v-timeline-divider__dot"), {
      elevationClasses: de
    } = useElevation(re), {
      backgroundColorClasses: me,
      backgroundColorStyles: fe
    } = useBackgroundColor(toRef(re, "lineColor"));
    return useRender(() => createVNode("div", {
      class: ["v-timeline-divider", {
        "v-timeline-divider--fill-dot": re.fillDot
      }, re.class],
      style: re.style
    }, [createVNode("div", {
      class: ["v-timeline-divider__before", me.value],
      style: fe.value
    }, null), !re.hideDot && createVNode("div", {
      key: "dot",
      class: ["v-timeline-divider__dot", de.value, ue.value, ie.value],
      style: le.value
    }, [createVNode("div", {
      class: ["v-timeline-divider__inner-dot", ce.value, ue.value],
      style: se.value
    }, [ae.default ? createVNode(VDefaultsProvider, {
      key: "icon-defaults",
      disabled: !re.icon,
      defaults: {
        VIcon: {
          color: re.iconColor,
          icon: re.icon,
          size: re.size
        }
      }
    }, ae.default) : createVNode(VIcon, {
      key: "icon",
      color: re.iconColor,
      icon: re.icon,
      size: re.size
    }, null)])]), createVNode("div", {
      class: ["v-timeline-divider__after", me.value],
      style: fe.value
    }, null)])), {};
  }
}), makeVTimelineItemProps = propsFactory({
  density: String,
  dotColor: String,
  fillDot: Boolean,
  hideDot: Boolean,
  hideOpposite: {
    type: Boolean,
    default: void 0
  },
  icon: IconValue,
  iconColor: String,
  lineInset: [Number, String],
  ...makeComponentProps(),
  ...makeDimensionProps(),
  ...makeElevationProps(),
  ...makeRoundedProps(),
  ...makeSizeProps(),
  ...makeTagProps()
}, "VTimelineItem"), VTimelineItem = genericComponent()({
  name: "VTimelineItem",
  props: makeVTimelineItemProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      dimensionStyles: ie
    } = useDimension(re), le = shallowRef(0), se = ref$1();
    return watch(se, (ce) => {
      var ue;
      ce && (le.value = ((ue = ce.$el.querySelector(".v-timeline-divider__dot")) == null ? void 0 : ue.getBoundingClientRect().width) ?? 0);
    }, {
      flush: "post"
    }), useRender(() => {
      var ce, ue;
      return createVNode("div", {
        class: ["v-timeline-item", {
          "v-timeline-item--fill-dot": re.fillDot
        }, re.class],
        style: [{
          "--v-timeline-dot-size": convertToUnit(le.value),
          "--v-timeline-line-inset": re.lineInset ? `calc(var(--v-timeline-dot-size) / 2 + ${convertToUnit(re.lineInset)})` : convertToUnit(0)
        }, re.style]
      }, [createVNode("div", {
        class: "v-timeline-item__body",
        style: ie.value
      }, [(ce = ae.default) == null ? void 0 : ce.call(ae)]), createVNode(VTimelineDivider, {
        ref: se,
        hideDot: re.hideDot,
        icon: re.icon,
        iconColor: re.iconColor,
        size: re.size,
        elevation: re.elevation,
        dotColor: re.dotColor,
        fillDot: re.fillDot,
        rounded: re.rounded
      }, {
        default: ae.icon
      }), re.density !== "compact" && createVNode("div", {
        class: "v-timeline-item__opposite"
      }, [!re.hideOpposite && ((ue = ae.opposite) == null ? void 0 : ue.call(ae))])]);
    }), {};
  }
}), makeVTimelineProps = propsFactory({
  align: {
    type: String,
    default: "center",
    validator: (re) => ["center", "start"].includes(re)
  },
  direction: {
    type: String,
    default: "vertical",
    validator: (re) => ["vertical", "horizontal"].includes(re)
  },
  justify: {
    type: String,
    default: "auto",
    validator: (re) => ["auto", "center"].includes(re)
  },
  side: {
    type: String,
    validator: (re) => re == null || ["start", "end"].includes(re)
  },
  lineThickness: {
    type: [String, Number],
    default: 2
  },
  lineColor: String,
  truncateLine: {
    type: String,
    validator: (re) => ["start", "end", "both"].includes(re)
  },
  ...pick(makeVTimelineItemProps({
    lineInset: 0
  }), ["dotColor", "fillDot", "hideOpposite", "iconColor", "lineInset", "size"]),
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeTagProps(),
  ...makeThemeProps()
}, "VTimeline"), VTimeline = genericComponent()({
  name: "VTimeline",
  props: makeVTimelineProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const {
      themeClasses: ie
    } = provideTheme(re), {
      densityClasses: le
    } = useDensity(re), {
      rtlClasses: se
    } = useRtl();
    provideDefaults({
      VTimelineDivider: {
        lineColor: toRef(re, "lineColor")
      },
      VTimelineItem: {
        density: toRef(re, "density"),
        dotColor: toRef(re, "dotColor"),
        fillDot: toRef(re, "fillDot"),
        hideOpposite: toRef(re, "hideOpposite"),
        iconColor: toRef(re, "iconColor"),
        lineColor: toRef(re, "lineColor"),
        lineInset: toRef(re, "lineInset"),
        size: toRef(re, "size")
      }
    });
    const ce = computed(() => {
      const de = re.side ? re.side : re.density !== "default" ? "end" : null;
      return de && `v-timeline--side-${de}`;
    }), ue = computed(() => {
      const de = ["v-timeline--truncate-line-start", "v-timeline--truncate-line-end"];
      switch (re.truncateLine) {
        case "both":
          return de;
        case "start":
          return de[0];
        case "end":
          return de[1];
        default:
          return null;
      }
    });
    return useRender(() => createVNode(re.tag, {
      class: ["v-timeline", `v-timeline--${re.direction}`, `v-timeline--align-${re.align}`, `v-timeline--justify-${re.justify}`, ue.value, {
        "v-timeline--inset-line": !!re.lineInset
      }, ie.value, le.value, ce.value, se.value, re.class],
      style: [{
        "--v-timeline-line-thickness": convertToUnit(re.lineThickness)
      }, re.style]
    }, ae)), {};
  }
}), makeVToolbarItemsProps = propsFactory({
  ...makeComponentProps(),
  ...makeVariantProps({
    variant: "text"
  })
}, "VToolbarItems"), VToolbarItems = genericComponent()({
  name: "VToolbarItems",
  props: makeVToolbarItemsProps(),
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    return provideDefaults({
      VBtn: {
        color: toRef(re, "color"),
        height: "inherit",
        variant: toRef(re, "variant")
      }
    }), useRender(() => {
      var ie;
      return createVNode("div", {
        class: ["v-toolbar-items", re.class],
        style: re.style
      }, [(ie = ae.default) == null ? void 0 : ie.call(ae)]);
    }), {};
  }
}), makeVTooltipProps = propsFactory({
  id: String,
  text: String,
  ...omit(makeVOverlayProps({
    closeOnBack: !1,
    location: "end",
    locationStrategy: "connected",
    eager: !0,
    minWidth: 0,
    offset: 10,
    openOnClick: !1,
    openOnHover: !0,
    origin: "auto",
    scrim: !1,
    scrollStrategy: "reposition",
    transition: !1
  }), ["absolute", "persistent"])
}, "VTooltip"), VTooltip = genericComponent()({
  name: "VTooltip",
  props: makeVTooltipProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = useProxiedModel(re, "modelValue"), {
      scopeId: le
    } = useScopeId(), se = getUid(), ce = computed(() => re.id || `v-tooltip-${se}`), ue = ref$1(), de = computed(() => re.location.split(" ").length > 1 ? re.location : re.location + " center"), me = computed(() => re.origin === "auto" || re.origin === "overlap" || re.origin.split(" ").length > 1 || re.location.split(" ").length > 1 ? re.origin : re.origin + " center"), fe = computed(() => re.transition ? re.transition : ie.value ? "scale-transition" : "fade-transition"), pe = computed(() => mergeProps({
      "aria-describedby": ce.value
    }, re.activatorProps));
    return useRender(() => {
      const ge = VOverlay.filterProps(re);
      return createVNode(VOverlay, mergeProps({
        ref: ue,
        class: ["v-tooltip", re.class],
        style: re.style,
        id: ce.value
      }, ge, {
        modelValue: ie.value,
        "onUpdate:modelValue": (be) => ie.value = be,
        transition: fe.value,
        absolute: !0,
        location: de.value,
        origin: me.value,
        persistent: !0,
        role: "tooltip",
        activatorProps: pe.value,
        _disableGlobalStack: !0
      }, le), {
        activator: ae.activator,
        default: function() {
          var Ee;
          for (var be = arguments.length, Se = new Array(be), Pe = 0; Pe < be; Pe++)
            Se[Pe] = arguments[Pe];
          return ((Ee = ae.default) == null ? void 0 : Ee.call(ae, ...Se)) ?? re.text;
        }
      });
    }), forwardRefs({}, ue);
  }
}), VValidation = genericComponent()({
  name: "VValidation",
  props: makeValidationProps(),
  emits: {
    "update:modelValue": (re) => !0
  },
  setup(re, ne) {
    let {
      slots: ae
    } = ne;
    const ie = useValidation(re, "validation");
    return () => {
      var le;
      return (le = ae.default) == null ? void 0 : le.call(ae, ie);
    };
  }
}), components = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  VAlert,
  VAlertTitle,
  VApp,
  VAppBar,
  VAppBarNavIcon,
  VAppBarTitle,
  VAutocomplete,
  VAvatar,
  VBadge,
  VBanner,
  VBannerActions,
  VBannerText,
  VBottomNavigation,
  VBottomSheet,
  VBreadcrumbs,
  VBreadcrumbsDivider,
  VBreadcrumbsItem,
  VBtn,
  VBtnGroup,
  VBtnToggle,
  VCard,
  VCardActions,
  VCardItem,
  VCardSubtitle,
  VCardText,
  VCardTitle,
  VCarousel,
  VCarouselItem,
  VCheckbox,
  VCheckboxBtn,
  VChip,
  VChipGroup,
  VClassIcon,
  VCode,
  VCol,
  VColorPicker,
  VCombobox,
  VComponentIcon,
  VConfirmEdit,
  VContainer,
  VCounter,
  VDataIterator,
  VDataTable,
  VDataTableFooter,
  VDataTableHeaders,
  VDataTableRow,
  VDataTableRows,
  VDataTableServer,
  VDataTableVirtual,
  VDatePicker,
  VDatePickerControls,
  VDatePickerHeader,
  VDatePickerMonth,
  VDatePickerMonths,
  VDatePickerYears,
  VDefaultsProvider,
  VDialog,
  VDialogBottomTransition,
  VDialogTopTransition,
  VDialogTransition,
  VDivider,
  VEmptyState,
  VExpandTransition,
  VExpandXTransition,
  VExpansionPanel,
  VExpansionPanelText,
  VExpansionPanelTitle,
  VExpansionPanels,
  VFab,
  VFabTransition,
  VFadeTransition,
  VField,
  VFieldLabel,
  VFileInput,
  VFooter,
  VForm,
  VHover,
  VIcon,
  VImg,
  VInfiniteScroll,
  VInput,
  VItem,
  VItemGroup,
  VKbd,
  VLabel,
  VLayout,
  VLayoutItem,
  VLazy,
  VLigatureIcon,
  VList,
  VListGroup,
  VListImg,
  VListItem,
  VListItemAction,
  VListItemMedia,
  VListItemSubtitle,
  VListItemTitle,
  VListSubheader,
  VLocaleProvider,
  VMain,
  VMenu,
  VMessages,
  VNavigationDrawer,
  VNoSsr,
  VOtpInput,
  VOverlay,
  VPagination,
  VParallax,
  VProgressCircular,
  VProgressLinear,
  VRadio,
  VRadioGroup,
  VRangeSlider,
  VRating,
  VResponsive,
  VRow,
  VScaleTransition,
  VScrollXReverseTransition,
  VScrollXTransition,
  VScrollYReverseTransition,
  VScrollYTransition,
  VSelect,
  VSelectionControl,
  VSelectionControlGroup,
  VSheet,
  VSkeletonLoader,
  VSlideGroup,
  VSlideGroupItem,
  VSlideXReverseTransition,
  VSlideXTransition,
  VSlideYReverseTransition,
  VSlideYTransition,
  VSlider,
  VSnackbar,
  VSpacer,
  VSparkline,
  VSpeedDial,
  VStepper,
  VStepperActions,
  VStepperHeader,
  VStepperItem,
  VStepperWindow,
  VStepperWindowItem,
  VSvgIcon,
  VSwitch,
  VSystemBar,
  VTab,
  VTable,
  VTabs,
  VTabsWindow,
  VTabsWindowItem,
  VTextField,
  VTextarea,
  VThemeProvider,
  VTimeline,
  VTimelineItem,
  VToolbar,
  VToolbarItems,
  VToolbarTitle,
  VTooltip,
  VValidation,
  VVirtualScroll,
  VWindow,
  VWindowItem
}, Symbol.toStringTag, { value: "Module" }));
function mounted$2(re, ne) {
  const ae = ne.modifiers || {}, ie = ne.value, {
    once: le,
    immediate: se,
    ...ce
  } = ae, ue = !Object.keys(ce).length, {
    handler: de,
    options: me
  } = typeof ie == "object" ? ie : {
    handler: ie,
    options: {
      attributes: (ce == null ? void 0 : ce.attr) ?? ue,
      characterData: (ce == null ? void 0 : ce.char) ?? ue,
      childList: (ce == null ? void 0 : ce.child) ?? ue,
      subtree: (ce == null ? void 0 : ce.sub) ?? ue
    }
  }, fe = new MutationObserver(function() {
    let pe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], ge = arguments.length > 1 ? arguments[1] : void 0;
    de == null || de(pe, ge), le && unmounted$2(re, ne);
  });
  se && (de == null || de([], fe)), re._mutate = Object(re._mutate), re._mutate[ne.instance.$.uid] = {
    observer: fe
  }, fe.observe(re, me);
}
function unmounted$2(re, ne) {
  var ae;
  (ae = re._mutate) != null && ae[ne.instance.$.uid] && (re._mutate[ne.instance.$.uid].observer.disconnect(), delete re._mutate[ne.instance.$.uid]);
}
const Mutate = {
  mounted: mounted$2,
  unmounted: unmounted$2
};
function mounted$1(re, ne) {
  var le, se;
  const ae = ne.value, ie = {
    passive: !((le = ne.modifiers) != null && le.active)
  };
  window.addEventListener("resize", ae, ie), re._onResize = Object(re._onResize), re._onResize[ne.instance.$.uid] = {
    handler: ae,
    options: ie
  }, (se = ne.modifiers) != null && se.quiet || ae();
}
function unmounted$1(re, ne) {
  var le;
  if (!((le = re._onResize) != null && le[ne.instance.$.uid])) return;
  const {
    handler: ae,
    options: ie
  } = re._onResize[ne.instance.$.uid];
  window.removeEventListener("resize", ae, ie), delete re._onResize[ne.instance.$.uid];
}
const Resize = {
  mounted: mounted$1,
  unmounted: unmounted$1
};
function mounted(re, ne) {
  const {
    self: ae = !1
  } = ne.modifiers ?? {}, ie = ne.value, le = typeof ie == "object" && ie.options || {
    passive: !0
  }, se = typeof ie == "function" || "handleEvent" in ie ? ie : ie.handler, ce = ae ? re : ne.arg ? document.querySelector(ne.arg) : window;
  ce && (ce.addEventListener("scroll", se, le), re._onScroll = Object(re._onScroll), re._onScroll[ne.instance.$.uid] = {
    handler: se,
    options: le,
    // Don't reference self
    target: ae ? void 0 : ce
  });
}
function unmounted(re, ne) {
  var se;
  if (!((se = re._onScroll) != null && se[ne.instance.$.uid])) return;
  const {
    handler: ae,
    options: ie,
    target: le = re
  } = re._onScroll[ne.instance.$.uid];
  le.removeEventListener("scroll", ae, ie), delete re._onScroll[ne.instance.$.uid];
}
function updated(re, ne) {
  ne.value !== ne.oldValue && (unmounted(re, ne), mounted(re, ne));
}
const Scroll = {
  mounted,
  unmounted,
  updated
};
function useDirectiveComponent(re, ne) {
  const ae = typeof re == "string" ? resolveComponent(re) : re, ie = mountComponent(ae, ne);
  return {
    mounted: ie,
    updated: ie,
    unmounted(le) {
      render(null, le);
    }
  };
}
function mountComponent(re, ne) {
  return function(ae, ie, le) {
    var pe, ge, be;
    const se = typeof ne == "function" ? ne(ie) : ne, ce = ((pe = ie.value) == null ? void 0 : pe.text) ?? ie.value ?? (se == null ? void 0 : se.text), ue = isObject$8(ie.value) ? ie.value : {}, de = () => ce ?? ae.textContent, me = (le.ctx === ie.instance.$ ? (ge = findComponentParent(le, ie.instance.$)) == null ? void 0 : ge.provides : (be = le.ctx) == null ? void 0 : be.provides) ?? ie.instance.$.provides, fe = h$1(re, mergeProps(se, ue), de);
    fe.appContext = Object.assign(/* @__PURE__ */ Object.create(null), ie.instance.$.appContext, {
      provides: me
    }), render(fe, ae);
  };
}
function findComponentParent(re, ne) {
  const ae = /* @__PURE__ */ new Set(), ie = (se) => {
    var ce, ue;
    for (const de of se) {
      if (!de) continue;
      if (de === re || de.el && re.el && de.el === re.el)
        return !0;
      ae.add(de);
      let me;
      if (de.suspense ? me = ie([de.ssContent]) : Array.isArray(de.children) ? me = ie(de.children) : (ce = de.component) != null && ce.vnode && (me = ie([(ue = de.component) == null ? void 0 : ue.subTree])), me)
        return me;
      ae.delete(de);
    }
    return !1;
  };
  if (!ie([ne.subTree]))
    return consoleError("Could not find original vnode, component will not inherit provides"), ne;
  const le = Array.from(ae).reverse();
  for (const se of le)
    if (se.component)
      return se.component;
  return ne;
}
const Tooltip = useDirectiveComponent(VTooltip, (re) => {
  var ne;
  return {
    activator: "parent",
    location: (ne = re.arg) == null ? void 0 : ne.replace("-", " "),
    text: typeof re.value == "boolean" ? void 0 : re.value
  };
}), directives = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ClickOutside,
  Intersect,
  Mutate,
  Resize,
  Ripple,
  Scroll,
  Tooltip,
  Touch
}, Symbol.toStringTag, { value: "Module" })), black = Object.freeze({ base: "#000000" }), teal05 = Object.freeze({ base: "#E4FCFF" }), teal10 = Object.freeze({ base: "#D2F6FA" }), teal20 = Object.freeze({ base: "#C1F0F5" }), teal30 = Object.freeze({ base: "#98E5EC" }), teal40 = Object.freeze({ base: "#76D7E0" }), teal50 = Object.freeze({ base: "#5CC7D0" }), teal60 = Object.freeze({ base: "#3BB7C2" }), teal70 = Object.freeze({ base: "#22A3AF" }), teal80 = Object.freeze({ base: "#1B838B" }), teal90 = Object.freeze({ base: "#056D78" }), teal100 = Object.freeze({ base: "#004F58" }), mg05 = Object.freeze({ base: "#F4F5F6" }), mg10 = Object.freeze({ base: "#DDE0E3" }), mg20 = Object.freeze({ base: "#C8CCD1" }), mg30 = Object.freeze({ base: "#B6BBC1" }), mg40 = Object.freeze({ base: "#9EA6AD" }), mg50 = Object.freeze({ base: "#8B939A" }), mg90 = Object.freeze({ base: "#2F4051" }), mg100 = Object.freeze({ base: "#212D38" }), mg110 = Object.freeze({ base: "#121E29" }), mg120 = Object.freeze({ base: "#0C161F" }), neutral05 = Object.freeze({ base: "#F4F5F6" }), neutral10 = Object.freeze({ base: "#DDE0E3" }), neutral20 = Object.freeze({ base: "#C8CCD1" }), neutral30 = Object.freeze({ base: "#B6BBC1" }), neutral40 = Object.freeze({ base: "#9EA6AD" }), neutral50 = Object.freeze({ base: "#8B939A" }), neutral60 = Object.freeze({ base: "#6E7881" }), neutral70 = Object.freeze({ base: "#5D6977" }), neutral80 = Object.freeze({ base: "#465564" }), neutral90 = Object.freeze({ base: "#2F4051" }), neutral100 = Object.freeze({ base: "#212D38" }), neutral110 = Object.freeze({ base: "#121E29" }), neutral120 = Object.freeze({ base: "#0C161F" }), red05 = Object.freeze({ base: "#FFE4E6" }), red10 = Object.freeze({ base: "#FEC9CC" }), red20 = Object.freeze({ base: "#FCAEB3" }), red30 = Object.freeze({ base: "#F77B83" }), red40 = Object.freeze({ base: "#FA5B62" }), red50 = Object.freeze({ base: "#E22D38" }), red60 = Object.freeze({ base: "#D11723" }), red70 = Object.freeze({ base: "#BA0914" }), red80 = Object.freeze({ base: "#9D010B" }), red90 = Object.freeze({ base: "#7C0008" }), red100 = Object.freeze({ base: "#590006" }), pink05 = Object.freeze({ base: "#FFE4F1" }), pink10 = Object.freeze({ base: "#FFC7E3" }), pink20 = Object.freeze({ base: "#FFAAD5" }), pink30 = Object.freeze({ base: "#FF73B8" }), pink40 = Object.freeze({ base: "#FC4CA8" }), pink50 = Object.freeze({ base: "#E11687" }), pink60 = Object.freeze({ base: "#E30072" }), pink70 = Object.freeze({ base: "#C80063" }), pink80 = Object.freeze({ base: "#A60052" }), pink90 = Object.freeze({ base: "#81003F" }), pink100 = Object.freeze({ base: "#59002B" }), green05 = Object.freeze({ base: "#E4FFF4" }), green10 = Object.freeze({ base: "#C5FDE7" }), green20 = Object.freeze({ base: "#A7FBD9" }), green30 = Object.freeze({ base: "#71F5C0" }), green40 = Object.freeze({ base: "#42ECA8" }), green50 = Object.freeze({ base: "#1EDF92" }), green60 = Object.freeze({ base: "#04CE7D" }), green70 = Object.freeze({ base: "#00B86E" }), green80 = Object.freeze({ base: "#08A768" }), green90 = Object.freeze({ base: "#007B4A" }), green100 = Object.freeze({ base: "#005936" }), blue05 = Object.freeze({ base: "#E4EAFF" }), blue10 = Object.freeze({ base: "#CFD8FF" }), blue20 = Object.freeze({ base: "#B9C7FF" }), blue30 = Object.freeze({ base: "#8AA0FE" }), blue40 = Object.freeze({ base: "#708BF8" }), blue50 = Object.freeze({ base: "#4261EE" }), blue60 = Object.freeze({ base: "#2647DA" }), blue70 = Object.freeze({ base: "#1233C1" }), blue80 = Object.freeze({ base: "#0624A2" }), blue90 = Object.freeze({ base: "#011A7E" }), blue100 = Object.freeze({ base: "#001259" }), yellow05 = Object.freeze({ base: "#FFFAE4" }), yellow10 = Object.freeze({ base: "#FFF4C3" }), yellow20 = Object.freeze({ base: "#FFEFA1" }), yellow30 = Object.freeze({ base: "#FFE066" }), yellow40 = Object.freeze({ base: "#F5CA3F" }), yellow50 = Object.freeze({ base: "#E7AF22" }), yellow60 = Object.freeze({ base: "#D5920F" }), yellow70 = Object.freeze({ base: "#CB820B" }), yellow80 = Object.freeze({ base: "#9F5C00" }), yellow90 = Object.freeze({ base: "#7D4600" }), yellow100 = Object.freeze({ base: "#593100" }), white = Object.freeze({ base: "#FFFFFF" }), helixifyColors$1 = Object.freeze({
  black,
  teal05,
  teal10,
  teal20,
  teal30,
  teal40,
  teal50,
  teal60,
  teal70,
  teal80,
  teal90,
  teal100,
  mg05,
  mg10,
  mg20,
  mg30,
  mg40,
  mg50,
  mg90,
  mg100,
  mg110,
  mg120,
  neutral05,
  neutral10,
  neutral20,
  neutral30,
  neutral40,
  neutral50,
  neutral60,
  neutral70,
  neutral80,
  neutral90,
  neutral100,
  neutral110,
  neutral120,
  red05,
  red10,
  red20,
  red30,
  red40,
  red50,
  red60,
  red70,
  red80,
  red90,
  red100,
  pink05,
  pink10,
  pink20,
  pink30,
  pink40,
  pink50,
  pink60,
  pink70,
  pink80,
  pink90,
  pink100,
  green05,
  green10,
  green20,
  green30,
  green40,
  green50,
  green60,
  green70,
  green80,
  green90,
  green100,
  blue05,
  blue10,
  blue20,
  blue30,
  blue40,
  blue50,
  blue60,
  blue70,
  blue80,
  blue90,
  blue100,
  yellow05,
  yellow10,
  yellow20,
  yellow30,
  yellow40,
  yellow50,
  yellow60,
  yellow70,
  yellow80,
  yellow90,
  yellow100,
  white
}), helixifyLightTheme = Object.freeze({
  primary: {
    lighten1: helixifyColors$1.pink70.base,
    base: helixifyColors$1.pink80.base,
    darken1: helixifyColors$1.pink90.base
  },
  secondary: {
    lighten2: helixifyColors$1.white.base,
    lighten1: helixifyColors$1.white.base,
    base: helixifyColors$1.neutral05.base,
    darken1: helixifyColors$1.neutral10.base,
    darken2: helixifyColors$1.neutral20.base,
    darken3: helixifyColors$1.neutral30.base
  },
  accent: helixifyColors$1.pink70,
  error: helixifyColors$1.red50,
  info: helixifyColors$1.teal80,
  success: helixifyColors$1.green50,
  warning: helixifyColors$1.yellow30,
  ongoing: helixifyColors$1.blue60,
  black: {
    base: helixifyColors$1.neutral120.base,
    lighten1: helixifyColors$1.neutral110.base,
    lighten2: helixifyColors$1.neutral100.base,
    lighten3: helixifyColors$1.neutral90.base,
    lighten4: helixifyColors$1.neutral80.base,
    lighten5: helixifyColors$1.neutral70.base
  },
  white: helixifyColors$1.white,
  btnFocusBorder: helixifyColors$1.blue70,
  errorAlertBorder: helixifyColors$1.red50,
  warningAlertBorder: helixifyColors$1.yellow60,
  infoAlertBorder: helixifyColors$1.teal80,
  successAlertBorder: helixifyColors$1.green80,
  errorAlertBackground: helixifyColors$1.red05,
  warningAlertBackground: helixifyColors$1.yellow05,
  infoAlertBackground: helixifyColors$1.teal05,
  successAlertBackground: helixifyColors$1.green05,
  alertText: helixifyColors$1.neutral90,
  dialogHeader: helixifyColors$1.neutral05,
  dialogTitle: helixifyColors$1.neutral100,
  dialogSubTitle: helixifyColors$1.black,
  activeHeaderIcon: helixifyColors$1.pink70,
  btnDelete: helixifyColors$1.red50.base,
  btnDeleteHover: helixifyColors$1.red40.base,
  btnDeletePress: helixifyColors$1.red90.base
}), helixifyCeLightTheme = Object.freeze({
  primary: {
    lighten1: helixifyColors$1.teal70.base,
    base: helixifyColors$1.teal80.base,
    darken1: helixifyColors$1.teal90.base
  },
  secondary: {
    lighten2: helixifyColors$1.white.base,
    lighten1: helixifyColors$1.white.base,
    base: helixifyColors$1.neutral05.base,
    darken1: helixifyColors$1.neutral10.base,
    darken2: helixifyColors$1.neutral20.base,
    darken3: helixifyColors$1.neutral30.base
  },
  accent: helixifyColors$1.teal70,
  error: helixifyColors$1.red50,
  info: helixifyColors$1.teal80,
  success: helixifyColors$1.green50,
  warning: helixifyColors$1.yellow30,
  ongoing: helixifyColors$1.blue60,
  black: {
    base: helixifyColors$1.neutral120.base,
    lighten1: helixifyColors$1.neutral110.base,
    lighten2: helixifyColors$1.neutral100.base,
    lighten3: helixifyColors$1.neutral90.base,
    lighten4: helixifyColors$1.neutral80.base,
    lighten5: helixifyColors$1.neutral70.base
  },
  white: helixifyColors$1.white,
  btnFocusBorder: helixifyColors$1.blue70,
  errorAlertBorder: helixifyColors$1.red50,
  warningAlertBorder: helixifyColors$1.yellow60,
  infoAlertBorder: helixifyColors$1.teal80,
  successAlertBorder: helixifyColors$1.green80,
  errorAlertBackground: helixifyColors$1.red05,
  warningAlertBackground: helixifyColors$1.yellow05,
  infoAlertBackground: helixifyColors$1.teal05,
  successAlertBackground: helixifyColors$1.green05,
  alertText: helixifyColors$1.neutral90,
  dialogHeader: helixifyColors$1.neutral05,
  dialogTitle: helixifyColors$1.neutral100,
  dialogSubTitle: helixifyColors$1.black,
  activeHeaderIcon: helixifyColors$1.teal40,
  btnDelete: helixifyColors$1.red50.base,
  btnDeleteHover: helixifyColors$1.red40.base,
  btnDeletePress: helixifyColors$1.red90.base
}), helixifyVuetifyDefinitions$1 = Object.freeze({
  theme: {
    themes: {
      light: helixifyLightTheme
    },
    options: {
      customProperties: !0
    }
  },
  options: {
    customProperties: !0
  },
  icons: {
    iconfont: "md"
  }
}), helixifyVuetifyCeDefinitions = Object.freeze({
  theme: {
    themes: {
      light: helixifyCeLightTheme
    },
    options: {
      customProperties: !0
    }
  },
  options: {
    customProperties: !0
  },
  icons: {
    iconfont: "md"
  }
}), helixifyIllustrations = {
  prefix: "/svg/illustrations"
}, definitions$1 = Object.freeze({
  helixifyColors: helixifyColors$1,
  helixifyVuetifyDefinitions: helixifyVuetifyDefinitions$1,
  helixifyVuetifyCeDefinitions,
  helixifyIllustrations
}), fa = {
  component: VClassIcon
}, helixifyCeLightThemeV3 = Object.freeze({
  dark: !1,
  colors: {
    primary: helixifyColors$1.teal80.base,
    "primary-lighten-1": helixifyColors$1.teal70.base,
    "primary-darken-1": helixifyColors$1.teal90.base,
    "primary-darken-2": helixifyColors$1.teal50.base,
    "primary-darken-3": helixifyColors$1.teal40.base,
    secondary: helixifyColors$1.neutral05.base,
    "secondary-lighten-1": helixifyColors$1.white.base,
    "secondary-lighten-2": helixifyColors$1.white.base,
    "secondary-darken-1": helixifyColors$1.neutral10.base,
    "secondary-darken-2": helixifyColors$1.neutral20.base,
    "secondary-darken-3": helixifyColors$1.neutral30.base,
    "secondary-darken-4": helixifyColors$1.neutral50.base,
    accent: helixifyColors$1.teal70.base,
    error: helixifyColors$1.red50.base,
    info: helixifyColors$1.teal80.base,
    success: helixifyColors$1.green50.base,
    warning: helixifyColors$1.yellow30.base,
    ongoing: helixifyColors$1.blue60.base,
    black: helixifyColors$1.neutral120.base,
    "black-lighten-1": helixifyColors$1.neutral110.base,
    "black-lighten-2": helixifyColors$1.neutral100.base,
    "black-lighten-3": helixifyColors$1.neutral90.base,
    "black-lighten-4": helixifyColors$1.neutral80.base,
    "black-lighten-5": helixifyColors$1.neutral70.base,
    white: helixifyColors$1.white.base,
    btnFocusBorder: helixifyColors$1.blue70.base,
    errorAlertBorder: helixifyColors$1.red50.base,
    warningAlertBorder: helixifyColors$1.yellow60.base,
    infoAlertBorder: helixifyColors$1.teal80.base,
    successAlertBorder: helixifyColors$1.green80.base,
    errorAlertBackground: helixifyColors$1.red05.base,
    warningAlertBackground: helixifyColors$1.yellow05.base,
    infoAlertBackground: helixifyColors$1.teal05.base,
    successAlertBackground: helixifyColors$1.green05.base,
    alertText: helixifyColors$1.neutral90.base,
    dialogHeader: helixifyColors$1.neutral05.base,
    dialogTitle: helixifyColors$1.neutral100.base,
    dialogSubTitle: helixifyColors$1.black.base,
    activeHeaderIcon: helixifyColors$1.teal40.base,
    btnDelete: helixifyColors$1.red50.base,
    btnDeleteHover: helixifyColors$1.red40.base,
    btnDeletePress: helixifyColors$1.red90.base
  }
}), helixifyLightThemeV3 = Object.freeze({
  dark: !1,
  colors: {
    primary: helixifyColors$1.pink80.base,
    "primary-lighten-1": helixifyColors$1.pink70.base,
    "primary-darken-1": helixifyColors$1.pink90.base,
    secondary: helixifyColors$1.neutral05.base,
    "secondary-lighten-1": helixifyColors$1.white.base,
    "secondary-lighten-2": helixifyColors$1.white.base,
    "secondary-darken-1": helixifyColors$1.neutral10.base,
    "secondary-darken-2": helixifyColors$1.neutral20.base,
    "secondary-darken-3": helixifyColors$1.neutral30.base,
    accent: helixifyColors$1.pink70.base,
    error: helixifyColors$1.red50.base,
    info: helixifyColors$1.teal80.base,
    success: helixifyColors$1.green50.base,
    warning: helixifyColors$1.yellow30.base,
    ongoing: helixifyColors$1.blue60.base,
    black: helixifyColors$1.neutral120.base,
    "black-lighten-1": helixifyColors$1.neutral110.base,
    "black-lighten-2": helixifyColors$1.neutral100.base,
    "black-lighten-3": helixifyColors$1.neutral90.base,
    "black-lighten-4": helixifyColors$1.neutral80.base,
    "black-lighten-5": helixifyColors$1.neutral70.base,
    white: helixifyColors$1.white.base,
    btnFocusBorder: helixifyColors$1.blue70.base,
    errorAlertBorder: helixifyColors$1.red50.base,
    warningAlertBorder: helixifyColors$1.yellow60.base,
    infoAlertBorder: helixifyColors$1.teal80.base,
    successAlertBorder: helixifyColors$1.green80.base,
    errorAlertBackground: helixifyColors$1.red05.base,
    warningAlertBackground: helixifyColors$1.yellow05.base,
    infoAlertBackground: helixifyColors$1.teal05.base,
    successAlertBackground: helixifyColors$1.green05.base,
    alertText: helixifyColors$1.neutral90.base,
    dialogHeader: helixifyColors$1.neutral05.base,
    dialogTitle: helixifyColors$1.neutral100.base,
    dialogSubTitle: helixifyColors$1.black.base,
    activeHeaderIcon: helixifyColors$1.pink70.base,
    btnDelete: helixifyColors$1.red50.base,
    btnDeleteHover: helixifyColors$1.red40.base,
    btnDeletePress: helixifyColors$1.red90.base
  }
}), helixifyVuetifyDefinitions = {
  components,
  directives,
  theme: {
    themes: {
      light: helixifyLightThemeV3,
      ce: helixifyCeLightThemeV3
    }
  },
  options: {
    customProperties: !0
  },
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
      fa
    }
  }
}, helixifyVuetifyDefinitionsV3 = Object.freeze(helixifyVuetifyDefinitions), definitions = {
  helixifyColors: definitions$1.helixifyColors,
  helixifyVuetifyDefinitionsV3,
  helixifyVuetifyDefinitions: definitions$1.helixifyVuetifyDefinitions,
  helixifyVuetifyCeDefinitions: definitions$1.helixifyVuetifyCeDefinitions,
  helixifyIllustrations: definitions$1.helixifyIllustrations
}, _sfc_main$Q = {
  name: "HxIconCollapse"
}, _hoisted_1$F = {
  id: "hx-icon-collapse",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
function _sfc_render$Q(re, ne, ae, ie, le, se) {
  return openBlock(), createElementBlock("svg", _hoisted_1$F, ne[0] || (ne[0] = [
    createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19 18C19.5523 18 20 17.5523 20 17L20 7C20 6.44772 19.5523 6 19 6C18.4477 6 18 6.44772 18 7L18 17C18 17.5523 18.4477 18 19 18ZM10.6269 16.7903C10.9711 17.0699 11.4561 17.0699 11.8003 16.7903L11.8905 16.7071L15.7196 12.7071L15.7993 12.6129C16.0669 12.2533 16.0669 11.7467 15.7993 11.3871L15.7196 11.2929L11.8905 7.29289L11.8003 7.2097C11.4248 6.90468 10.8818 6.93241 10.5367 7.29289C10.1916 7.65338 10.1651 8.22061 10.4571 8.6129L10.5367 8.70711L12.7319 11.001L4.95728 11L4.84564 11.0067C4.36955 11.0645 4 11.4872 4 12C4 12.5523 4.42859 13 4.95728 13L12.7299 13.001L10.5367 15.2929L10.4571 15.3871C10.1894 15.7467 10.1894 16.2533 10.4571 16.6129L10.5367 16.7071L10.6269 16.7903Z"
    }, null, -1)
  ]));
}
const HxIconCollapse = /* @__PURE__ */ _export_sfc(_sfc_main$Q, [["render", _sfc_render$Q]]), _sfc_main$P = {
  name: "HxIconExpand"
}, _hoisted_1$E = {
  id: "hx-icon-expand",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
function _sfc_render$P(re, ne, ae, ie, le, se) {
  return openBlock(), createElementBlock("svg", _hoisted_1$E, ne[0] || (ne[0] = [
    createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19 18C19.5523 18 20 17.5523 20 17L20 7C20 6.44772 19.5523 6 19 6C18.4477 6 18 6.44772 18 7L18 17C18 17.5523 18.4477 18 19 18ZM9.37311 7.2097C9.02887 6.9301 8.54391 6.9301 8.19968 7.2097L8.10949 7.29289L4.28038 11.2929L4.20075 11.3871C3.93308 11.7467 3.93308 12.2533 4.20075 12.6129L4.28038 12.7071L8.10949 16.7071L8.19968 16.7903C8.57521 17.0953 9.1182 17.0676 9.46329 16.7071C9.80837 16.3466 9.83492 15.7794 9.54292 15.3871L9.46329 15.2929L7.26815 12.999L15.0427 13L15.1544 12.9933C15.6305 12.9355 16 12.5128 16 12C16 11.4477 15.5714 11 15.0427 11L7.27006 10.999L9.46329 8.70711L9.54292 8.6129C9.81058 8.2533 9.81058 7.7467 9.54292 7.3871L9.46329 7.29289L9.37311 7.2097Z"
    }, null, -1)
  ]));
}
const HxIconExpand = /* @__PURE__ */ _export_sfc(_sfc_main$P, [["render", _sfc_render$P]]), _sfc_main$O = {
  name: "HxIconSystemSettings"
}, _hoisted_1$D = {
  id: "hx-icon-system-settings",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
function _sfc_render$O(re, ne, ae, ie, le, se) {
  return openBlock(), createElementBlock("svg", _hoisted_1$D, ne[0] || (ne[0] = [
    createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15 3C13.1362 3 11.5701 4.27477 11.126 6L3 6C2.44772 6 2 6.44771 2 7C2 7.55228 2.44772 8 3 8L11.126 8C11.5701 9.72523 13.1362 11 15 11C16.8638 11 18.4299 9.72523 18.874 8L21 8C21.5523 8 22 7.55228 22 7C22 6.44772 21.5523 6 21 6L18.874 6C18.4299 4.27477 16.8638 3 15 3ZM15 5C13.8954 5 13 5.89543 13 7C13 8.10457 13.8954 9 15 9C16.1046 9 17 8.10457 17 7C17 5.89543 16.1046 5 15 5ZM9 21C10.8639 21 12.43 19.7252 12.874 18H21C21.5523 18 22 17.5523 22 17C22 16.4477 21.5523 16 21 16H12.874C12.43 14.2748 10.8639 13 9 13C7.13609 13 5.57004 14.2748 5.12601 16H3C2.44772 16 2 16.4477 2 17C2 17.5523 2.44772 18 3 18H5.12601C5.57004 19.7252 7.13609 21 9 21ZM9 19C10.1045 19 11 18.1046 11 17C11 15.8954 10.1045 15 9 15C7.89551 15 7 15.8954 7 17C7 18.1046 7.89551 19 9 19Z"
    }, null, -1)
  ]));
}
const HxIconSystemSettings = /* @__PURE__ */ _export_sfc(_sfc_main$O, [["render", _sfc_render$O]]), _sfc_main$N = {
  name: "HxRocket"
}, _hoisted_1$C = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function _sfc_render$N(re, ne, ae, ie, le, se) {
  return openBlock(), createElementBlock("svg", _hoisted_1$C, ne[0] || (ne[0] = [
    createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.7684 2.00383C18.7944 2.02645 19.749 2.14537 20.3475 2.23634C21.132 2.35556 21.7379 2.97915 21.8365 3.7708C21.9037 4.31064 21.9859 5.13372 21.9984 6.01383C22.0106 6.87998 21.9569 7.8676 21.7193 8.70706C21.3952 9.85222 20.6491 11.0026 19.9432 11.919C19.2237 12.8531 18.4798 13.6277 18.0788 14.027C18.0711 14.0346 18.0666 14.0421 18.0643 14.0475C18.0621 14.0527 18.0622 14.0552 18.0622 14.0553V17.5921C18.0622 18.2299 17.7352 18.8228 17.1969 19.161L13.1313 21.7154C11.9044 22.4863 10.3124 21.6003 10.3124 20.1466V18.1125C9.59228 18.8271 8.4317 18.8242 7.7151 18.1038L6.80181 17.1857C6.08306 16.4631 6.08306 15.2922 6.80181 14.5696L6.88068 14.4903L3.58307 14.0168C2.29584 13.8319 1.59933 12.4017 2.24411 11.2673L4.26088 7.71929C4.58877 7.14244 5.19928 6.7864 5.86053 6.7864H9.29293C9.29321 6.7864 9.30705 6.78593 9.32282 6.76622C9.71234 6.27941 10.4584 5.39329 11.3774 4.53325C12.2786 3.68991 13.4284 2.79243 14.6287 2.38164C15.5991 2.04956 16.7601 1.9816 17.7684 2.00383ZM17.728 3.85387C16.7913 3.83322 15.8868 3.90603 15.2228 4.13327C14.399 4.41518 13.481 5.09367 12.633 5.88725C11.8028 6.66412 11.1184 7.47587 10.7586 7.92554C10.4089 8.36256 9.87597 8.63688 9.29293 8.63688L5.86053 8.63688L3.84376 12.1849L7.41278 12.6975C7.77811 12.7499 8.11663 12.9201 8.37749 13.1823C9.04271 13.851 9.04271 14.9348 8.37749 15.6035L8.10482 15.8776L9.01812 16.7958L9.32116 16.4911C9.96933 15.8395 11.0207 15.8395 11.6689 16.4911C11.9798 16.8037 12.1545 17.2276 12.1545 17.6695L12.1545 20.1466L16.2201 17.5921V14.0553C16.2201 13.5386 16.4337 13.0595 16.7822 12.7126C17.152 12.3444 17.8345 11.6328 18.4863 10.7866C19.1517 9.92279 19.7216 8.99899 19.9475 8.20095C20.1122 7.61912 20.1678 6.84274 20.1565 6.04012C20.1458 5.28089 20.0765 4.55706 20.0157 4.05754C19.4596 3.97468 18.6167 3.87346 17.728 3.85387Z",
      fill: "#1B838B"
    }, null, -1),
    createElementVNode("path", {
      d: "M18.316 7.08886C18.316 7.85535 17.6974 8.47672 16.9344 8.47672C16.1714 8.47672 15.5529 7.85535 15.5529 7.08886C15.5529 6.32236 16.1714 5.70099 16.9344 5.70099C17.6974 5.70099 18.316 6.32236 18.316 7.08886Z",
      fill: "#1B838B"
    }, null, -1)
  ]));
}
const IconRocket = /* @__PURE__ */ _export_sfc(_sfc_main$N, [["render", _sfc_render$N]]), _sfc_main$M = {
  name: "HxIconReport"
}, _hoisted_1$B = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function _sfc_render$M(re, ne, ae, ie, le, se) {
  return openBlock(), createElementBlock("svg", _hoisted_1$B, ne[0] || (ne[0] = [
    createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.00025 7.94141L8.43377 6.93758C10.1364 6.23523 11.7339 5.30106 13.1809 4.16154L14.3813 3.21623C15.0373 2.69966 16 3.16692 16 4.00186V17.8812C16 18.7161 15.0373 19.1834 14.3813 18.6668L13.1809 17.7215C11.7339 16.582 10.1364 15.6478 8.43377 14.9454L6.58643 14.1834L8.52274 19.6051C8.75532 20.2563 8.27253 20.9414 7.581 20.9414H7.20472C6.78211 20.9414 6.40512 20.6757 6.26298 20.2777L4 13.9414H3C2.44772 13.9414 2 13.4937 2 12.9414V8.94141C2 8.38912 2.44772 7.94141 3 7.94141H6.00025ZM8 9.27484V12.6082L8.50804 12.8022C10.162 13.434 11.7248 14.2825 13.1554 15.3257L14 15.9415V5.94151L13.1554 6.55737C11.7248 7.60051 10.162 8.44907 8.50804 9.0808L8 9.27484ZM6 9.94141H4V11.9414H6V9.94141ZM18.1344 7.46493C17.8583 6.99505 18.0187 6.39618 18.4928 6.1273L19.3741 5.62741C19.8482 5.35853 20.4563 5.52147 20.7325 5.99134C21.0086 6.46121 20.8482 7.06009 20.3741 7.32897L19.4928 7.82885C19.0187 8.09773 18.4105 7.9348 18.1344 7.46493ZM18.1344 14.8329C17.8583 15.3028 18.0187 15.9017 18.4928 16.1706L19.3741 16.6704C19.8482 16.9393 20.4563 16.7764 20.7325 16.3065C21.0086 15.8366 20.8482 15.2378 20.3741 14.9689L19.4928 14.469C19.0187 14.2001 18.4105 14.3631 18.1344 14.8329ZM19.6168 12.0173C19.0742 12.0173 18.6344 11.5775 18.6344 11.0349C18.6344 10.4924 19.0742 10.0525 19.6168 10.0525H20.652C21.1946 10.0525 21.6344 10.4924 21.6344 11.0349C21.6344 11.5775 21.1946 12.0173 20.652 12.0173H19.6168Z",
      fill: "#465564"
    }, null, -1)
  ]));
}
const IconReport = /* @__PURE__ */ _export_sfc(_sfc_main$M, [["render", _sfc_render$M]]), _sfc_main$L = {
  name: "HxIconIdeagenColor"
}, _hoisted_1$A = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function _sfc_render$L(re, ne, ae, ie, le, se) {
  return openBlock(), createElementBlock("svg", _hoisted_1$A, ne[0] || (ne[0] = [
    createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.3335 4.33333V7.63129L9.5795 7.63072L9.58114 4.48739L14.6668 7.66667L20.0002 4.33333L14.6668 1L9.3335 4.33333Z",
      fill: "#E30072"
    }, null, -1),
    createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M14.667 7.66683V13.6668L20.0003 10.3335V4.3335L14.667 7.66683Z",
      fill: "#2F4051"
    }, null, -1),
    createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4 13.6668V16.9648L4.246 16.9642L4.24764 13.8209L9.33333 17.0002L14.6667 13.6668L9.33333 10.3335L4 13.6668Z",
      fill: "#15CAD2"
    }, null, -1),
    createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.3335 17.0001V23.0001L14.6668 19.6667V13.6667L9.3335 17.0001Z",
      fill: "#02838F"
    }, null, -1)
  ]));
}
const IconIdeagenColor = /* @__PURE__ */ _export_sfc(_sfc_main$L, [["render", _sfc_render$L]]), _sfc_main$K = {
  name: "HxIconTextSelect"
}, _hoisted_1$z = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function _sfc_render$K(re, ne, ae, ie, le, se) {
  return openBlock(), createElementBlock("svg", _hoisted_1$z, ne[0] || (ne[0] = [
    createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.22876 18H5.22876V6H9.22876V18ZM15.2287 7.00031L16.2287 6.00031H19.2297V8.00031H16.2287V16.0003H19.2297V18.0003H16.2287L15.2287 17.0003L14.2287 18.0003H11.2297V16.0003H14.2287V8.00031H11.2297V6.00031H14.2287L15.2287 7.00031Z",
      fill: "#465564"
    }, null, -1)
  ]));
}
const IconTextSelect = /* @__PURE__ */ _export_sfc(_sfc_main$K, [["render", _sfc_render$K]]), _sfc_main$J = {
  name: "HxIconView"
}, _hoisted_1$y = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function _sfc_render$J(re, ne, ae, ie, le, se) {
  return openBlock(), createElementBlock("svg", _hoisted_1$y, ne[0] || (ne[0] = [
    createElementVNode("path", {
      d: "M20.5274 5L21.6745 6.6383L4.47235 18.6834L3.3252 17.0451L20.5274 5Z",
      fill: "#2F4051"
    }, null, -1),
    createElementVNode("path", {
      d: "M20.1281 9.55597C20.7983 10.2394 21.4248 11.0048 22.0002 11.8418C19.4572 15.5408 15.9182 17.8418 12.0002 17.8418C10.8675 17.8418 9.76639 17.6495 8.71191 17.2866L10.8868 15.7635C11.2552 15.8155 11.6267 15.8418 12.0002 15.8418C14.7342 15.8418 17.3582 14.4328 19.4992 11.8418C19.1646 11.4371 18.8183 11.0612 18.4615 10.7149L20.1281 9.55597Z",
      fill: "#2F4051"
    }, null, -1),
    createElementVNode("path", {
      d: "M15.7369 6.56259C14.5474 6.09286 13.2944 5.84171 12 5.84171C8.082 5.84171 4.543 8.14271 2 11.8417C2.67674 12.8261 3.42402 13.7115 4.2302 14.4808L5.92307 13.3271C5.42976 12.8865 4.95457 12.3906 4.501 11.8417C6.642 9.25171 9.265 7.84171 12 7.84171C12.559 7.84171 13.1134 7.90065 13.66 8.01657L15.7369 6.56259Z",
      fill: "#2F4051"
    }, null, -1)
  ]));
}
const IconView = /* @__PURE__ */ _export_sfc(_sfc_main$J, [["render", _sfc_render$J]]), _sfc_main$I = {
  name: "HxIconHistory"
}, _hoisted_1$x = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function _sfc_render$I(re, ne, ae, ie, le, se) {
  return openBlock(), createElementBlock("svg", _hoisted_1$x, ne[0] || (ne[0] = [
    createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19.2998 4.92893C15.3946 1.02369 9.06293 1.02369 5.15769 4.92893C5.11691 4.96971 5.07656 5.01076 5.03663 5.05206L5.03663 3.48197L5.03678 3.46462C5.03678 2.91234 4.58906 2.46463 4.03678 2.46463C3.48449 2.46463 3.03663 2.91234 3.03663 3.46464L3.03663 7.33435C3.03663 7.95859 3.54268 8.46464 4.16692 8.46464L8.02609 8.46453L8.03689 8.46458C8.58918 8.46458 9.03689 8.01687 9.03689 7.46458C9.03689 6.9123 8.58906 6.46453 8.03678 6.46453L6.45294 6.46453C6.49207 6.42373 6.53172 6.38325 6.57188 6.34309C9.69607 3.21889 14.7614 3.21889 17.8856 6.34309C21.0098 9.46728 21.0098 14.5326 17.8856 17.6568C14.7614 20.781 9.69607 20.781 6.57188 17.6568C4.93923 16.0242 4.15978 13.8614 4.23351 11.7226C4.23845 11.6778 4.24037 11.6328 4.23929 11.5879L4.23892 11.5758C4.23008 11.3321 4.13267 11.0911 3.94669 10.9051C3.55616 10.5146 2.923 10.5146 2.53247 10.9051C2.34649 11.0911 2.24908 11.3321 2.24024 11.5758L2.23771 11.5758C2.12382 14.2745 3.09715 17.0105 5.15769 19.0711C9.06294 22.9763 15.3946 22.9763 19.2998 19.0711C23.2051 15.1658 23.2051 8.83417 19.2998 4.92893ZM15.0106 8.89319L15.0122 8.89475C15.3163 8.59064 15.8079 8.59064 16.112 8.89475C16.4161 9.19886 16.4161 9.69042 16.112 9.99453C16.1109 9.99561 16.1095 9.99636 16.108 9.99716C16.1062 9.99809 16.1043 9.99908 16.1026 10.0007L13.9482 12.1552C13.9824 12.2835 14.0065 12.4165 14.0065 12.5557C14.0065 13.4152 13.3104 14.1113 12.451 14.1113C11.877 14.1113 11.3808 13.7971 11.1109 13.3335H8.56209C8.13276 13.3335 7.78432 12.9851 7.78432 12.5557C7.78432 12.1264 8.13276 11.778 8.56209 11.778H11.1109C11.3808 11.3152 11.877 11.0002 12.451 11.0002C12.5886 11.0002 12.7193 11.0235 12.8461 11.057L15.0106 8.89319Z",
      fill: "#465564"
    }, null, -1)
  ]));
}
const IconHistory = /* @__PURE__ */ _export_sfc(_sfc_main$I, [["render", _sfc_render$I]]), _sfc_main$H = {
  name: "HxIconTrash"
}, _hoisted_1$w = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "hx-icon-trash"
};
function _sfc_render$H(re, ne, ae, ie, le, se) {
  return openBlock(), createElementBlock("svg", _hoisted_1$w, ne[0] || (ne[0] = [
    createElementVNode("path", { d: "M17 2.99994H14.625C14.625 2.44768 14.1773 2 13.625 2H10.375C9.82274 2 9.37503 2.44768 9.375 2.99994H7C5.89543 2.99994 5 3.89537 5 4.99994H19C19 3.89537 18.1046 2.99994 17 2.99994Z" }, null, -1),
    createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5 20C5 21.104 5.896 22 7 22H17C18.104 22 19 21.104 19 20V7H5V20ZM15 20H17V9H15V20ZM11 20H13V9H11V20ZM7 20H9V9H7V20Z"
    }, null, -1)
  ]));
}
const IconTrash = /* @__PURE__ */ _export_sfc(_sfc_main$H, [["render", _sfc_render$H], ["__scopeId", "data-v-ed87277e"]]), vuetifyBuilder = (re) => {
  let ne = "light";
  re && (ne = re.themeName || "light");
  const ae = definitions.helixifyVuetifyDefinitionsV3, ie = {
    components,
    directives,
    theme: { defaultTheme: ne, themes: ae.theme.themes },
    options: ae.options,
    icons: {
      ...ae.icons,
      aliases: {
        "i-action-left-expand": HxIconCollapse,
        "i-action-left-collapse": HxIconExpand,
        "i-action-right-collapse": HxIconCollapse,
        "i-action-right-expand": HxIconExpand,
        "i-system-settings": HxIconSystemSettings,
        "i-rocket": IconRocket,
        "i-report": IconReport,
        "i-ideagen-color": IconIdeagenColor,
        "i-text-select": IconTextSelect,
        "i-view": IconView,
        "i-history": IconHistory,
        "i-trash": IconTrash
      }
    }
  };
  return {
    build: () => createVuetify(ie),
    getHelixifyVuetifyDefinitions: () => ae
  };
}, vuetify = vuetifyBuilder().build(), auth0Config = (re, ne, ae, ie, le, se) => ({
  appEnv: se || "production",
  appHost: Assert.isPresent(re, "appHost"),
  appUrl: Assert.isPresent(ne, "appUrl"),
  domain: Assert.isPresent(ae, "domain"),
  clientId: Assert.isPresent(ie, "clientId"),
  audience: Assert.isPresent(le, "audience")
}), overrideLoginTranslations = (re, ne) => {
  const ae = { ...re };
  return ae.cs.login = {
    welcomeMessage: ne && ne.loginViewTitle || re.cs.login.welcomeMessage,
    welcomeMessageSubText: ne && ne.loginViewSubTitle || void 0,
    loginButtonText: ne && ne.loginViewButtonText || re.cs.login.loginButtonText
  }, ae;
}, _sfc_main$G = {
  name: "CSAvatar",
  props: {
    on: { type: Object, required: !1, default: () => ({}) },
    initials: { type: String, required: !1, default: "" },
    picture: { type: String, required: !1, default: "" }
  }
}, _hoisted_1$v = { class: "text-black" }, _hoisted_2$k = ["src"];
function _sfc_render$G(re, ne, ae, ie, le, se) {
  return ae.initials ? (openBlock(), createBlock(VAvatar, mergeProps({
    key: 0,
    class: "cs-avatar initials-avatar",
    size: "40"
  }, toHandlers(ae.on)), {
    default: withCtx(() => [
      createElementVNode("span", _hoisted_1$v, toDisplayString$1(ae.initials), 1)
    ]),
    _: 1
  }, 16)) : ae.picture ? (openBlock(), createBlock(VAvatar, mergeProps({
    key: 1,
    class: "picture-avatar",
    size: "40"
  }, toHandlers(ae.on)), {
    default: withCtx(() => [
      createElementVNode("img", {
        src: ae.picture,
        alt: ""
      }, null, 8, _hoisted_2$k)
    ]),
    _: 1
  }, 16)) : (openBlock(), createBlock(VAvatar, mergeProps({
    key: 2,
    class: "cs-avatar",
    size: "40"
  }, toHandlers(ae.on)), {
    default: withCtx(() => ne[0] || (ne[0] = [
      createElementVNode("span", { class: "text-black" }, " CS ", -1)
    ])),
    _: 1
  }, 16));
}
const CSAvatar = /* @__PURE__ */ _export_sfc(_sfc_main$G, [["render", _sfc_render$G], ["__scopeId", "data-v-b5b97e9f"]]), _sfc_main$F = {
  name: "CSUserProfile",
  props: {
    user: {
      type: User,
      required: !0
    },
    versionInUserProfile: {
      type: String,
      required: !1,
      default: void 0
    }
  },
  data() {
    return {
      itemClass: "text-center ma-3"
    };
  }
}, _hoisted_1$u = {
  key: 0,
  class: "text-left ml-2 mt-2"
}, _hoisted_2$j = { class: "text-sm-caption text-center mb-2" };
function _sfc_render$F(re, ne, ae, ie, le, se) {
  return openBlock(), createBlock(VSheet, {
    class: "cs-user-profile",
    color: "secondary"
  }, {
    default: withCtx(() => [
      createElementVNode("div", {
        class: normalizeClass(le.itemClass)
      }, [
        renderSlot(re.$slots, "avatar")
      ], 2),
      createElementVNode("div", {
        id: "full-name",
        class: normalizeClass(le.itemClass)
      }, toDisplayString$1(ae.user.fullName), 3),
      createElementVNode("div", {
        id: "email",
        class: normalizeClass(le.itemClass)
      }, toDisplayString$1(ae.user.email), 3),
      createElementVNode("div", {
        class: normalizeClass(le.itemClass)
      }, [
        renderSlot(re.$slots, "action")
      ], 2),
      ae.versionInUserProfile ? (openBlock(), createElementBlock("div", _hoisted_1$u, [
        createElementVNode("p", _hoisted_2$j, " ©" + toDisplayString$1(re.$te("custom.copyRightText") ? re.$t("custom.copyRightText") : re.$t("cs.copyRightText")) + " (" + toDisplayString$1(ae.versionInUserProfile) + ") ", 1)
      ])) : createCommentVNode("", !0)
    ]),
    _: 3
  });
}
const CSUserProfile = /* @__PURE__ */ _export_sfc(_sfc_main$F, [["render", _sfc_render$F]]), _sfc_main$E = {
  name: "CSFormDialog",
  extends: CSBase,
  props: {
    id: { type: String, required: !1, default: "" },
    bodyId: { type: String, required: !1, default: "" },
    modelValue: { type: Boolean, required: !0 },
    heading: { type: String, required: !0 },
    subheading: { type: String, required: !1, default: "" },
    primaryAction: { type: Object, required: !1, default: void 0 },
    secondaryAction1: { type: Object, required: !1, default: void 0 },
    secondaryAction2: { type: Object, required: !1, default: void 0 },
    deleteAction: { type: Object, required: !1, default: void 0 }
  },
  emits: [
    "update:modelValue",
    "primary-click",
    "secondary1-click",
    "secondary2-click",
    "delete-click"
  ],
  data() {
    return {
      dialog: this.modelValue,
      btnWidthFull: !1,
      btnHeight: 0
    };
  },
  computed: {
    buttonClass() {
      return this.btnWidthFull ? "cs-form-dialog-btn-full" : "";
    },
    showButton() {
      const re = this.primaryAction && this.primaryAction.label || !1, ne = this.deleteAction && this.deleteAction.label || !1;
      return (re || ne) && this.getButtonCount() <= 3;
    }
  },
  watch: {
    modelValue(re) {
      this.setDialogIsShown(re), (re || !this.dialog) && this.clearAlert(), this.validProps() && (this.dialog = re);
    }
  },
  mounted() {
    this.validProps();
  },
  methods: {
    onClose() {
      this.dialog = !1, this.$emit("update:modelValue", this.dialog);
    },
    onPrimaryClick() {
      this.$emit("primary-click");
    },
    onSecondary1Click() {
      this.$emit("secondary1-click");
    },
    onSecondary2Click() {
      this.$emit("secondary2-click");
    },
    onDeleteClick() {
      this.$emit("delete-click");
    },
    async onResize() {
      this.btnWidthFull = !1, await this.$nextTick(), this.resetBtnWidth();
    },
    getButtonHeight() {
      const re = document.querySelector(".cs-form-dialog-button");
      let ne = 0;
      if (re) {
        const ae = window.getComputedStyle(re, null), ie = parseInt(ae.getPropertyValue("margin-top"), 10) + parseInt(ae.getPropertyValue("margin-bottom"), 10);
        ne = re.offsetHeight + ie;
      }
      return ne;
    },
    resetBtnWidth() {
      if (this.btnHeight || (this.btnHeight = this.getButtonHeight()), !this.btnHeight)
        return;
      const ne = document.querySelector(".cs-form-dialog-actions");
      ne && ne.offsetHeight > this.btnHeight * 2 ? this.btnWidthFull = !0 : this.btnWidthFull = !1;
    },
    getButtonCount() {
      let re = 0;
      return this.primaryAction && (re += 1), this.deleteAction && (re += 1), this.secondaryAction1 && (re += 1), this.secondaryAction2 && (re += 1), re;
    },
    validProps() {
      return this.heading ? this.getButtonCount() > 3 ? (this.onClose(), console.error("Dialog must not have more than 3 buttons!"), !1) : !0 : (this.onClose(), console.error("Dialog heading must be provided!"), !1);
    }
  }
}, _hoisted_1$t = { class: "cs-form-dialog-alert" }, _hoisted_2$i = { class: "cs-form-dialog-content style-06" }, _hoisted_3$b = {
  key: 2,
  class: "cs-form-dialog-bottom-space"
};
function _sfc_render$E(re, ne, ae, ie, le, se) {
  const ce = resolveComponent("cs-alert"), ue = resolveComponent("cs-button");
  return openBlock(), createBlock(VDialog, {
    id: ae.id,
    modelValue: le.dialog,
    "onUpdate:modelValue": ne[4] || (ne[4] = (de) => le.dialog = de),
    class: "cs-form-dialog",
    transition: "dialog-bottom-transition",
    scrollable: "",
    persistent: "",
    "max-width": "800px"
  }, {
    default: withCtx(() => [
      createVNode(VCard, {
        id: ae.bodyId,
        class: "cs-form-dialog-card"
      }, {
        default: withCtx(() => [
          createVNode(VCardTitle, {
            class: normalizeClass(["cs-form-dialog-title", { "cs-form-dialog-title-nobottom": !!ae.subheading }])
          }, {
            default: withCtx(() => [
              createElementVNode("h1", null, toDisplayString$1(ae.heading), 1),
              createVNode(VBtn, {
                icon: "",
                variant: "plain",
                size: "24px",
                onClick: se.onClose
              }, {
                default: withCtx(() => [
                  createVNode(VIcon, {
                    size: "24px",
                    color: "alertText",
                    icon: "mdi-close"
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["class"]),
          ae.subheading ? (openBlock(), createBlock(VCardSubtitle, {
            key: 0,
            class: "cs-form-dialog-subTitle"
          }, {
            default: withCtx(() => [
              createElementVNode("h3", null, toDisplayString$1(ae.subheading), 1)
            ]),
            _: 1
          })) : createCommentVNode("", !0),
          createElementVNode("div", _hoisted_1$t, [
            createVNode(ce, { dialog: "" })
          ]),
          createElementVNode("div", _hoisted_2$i, [
            renderSlot(re.$slots, "cs-form-dialog-content", {}, void 0, !0)
          ]),
          se.showButton ? withDirectives((openBlock(), createBlock(VCardActions, {
            key: 1,
            class: "cs-form-dialog-actions"
          }, {
            default: withCtx(() => [
              ae.secondaryAction2 && ae.secondaryAction2.label ? (openBlock(), createBlock(ue, {
                key: 0,
                class: normalizeClass(["cs-form-dialog-button", se.buttonClass]),
                secondary: "",
                disabled: !!ae.secondaryAction2.disabled || !!ae.secondaryAction2.loading,
                label: ae.secondaryAction2.label,
                loading: !!ae.secondaryAction2.loading,
                "left-icon": ae.secondaryAction2.leftIcon,
                "right-icon": ae.secondaryAction2.rightIcon,
                onClick: ne[0] || (ne[0] = (de) => se.onSecondary2Click())
              }, null, 8, ["class", "disabled", "label", "loading", "left-icon", "right-icon"])) : createCommentVNode("", !0),
              ae.secondaryAction1 && ae.secondaryAction1.label ? (openBlock(), createBlock(ue, {
                key: 1,
                class: normalizeClass(["cs-form-dialog-button", se.buttonClass]),
                secondary: "",
                disabled: !!ae.secondaryAction1.disabled || !!ae.secondaryAction1.loading,
                label: ae.secondaryAction1.label,
                loading: !!ae.secondaryAction1.loading,
                "left-icon": ae.secondaryAction1.leftIcon,
                "right-icon": ae.secondaryAction1.rightIcon,
                onClick: ne[1] || (ne[1] = (de) => se.onSecondary1Click())
              }, null, 8, ["class", "disabled", "label", "loading", "left-icon", "right-icon"])) : createCommentVNode("", !0),
              ae.deleteAction && ae.deleteAction.label ? (openBlock(), createBlock(ue, {
                key: 2,
                class: normalizeClass(["cs-form-dialog-button", se.buttonClass]),
                delete: "",
                disabled: !!ae.deleteAction.disabled || !!ae.deleteAction.loading,
                label: ae.deleteAction.label,
                loading: !!ae.deleteAction.loading,
                "left-icon": ae.deleteAction.leftIcon,
                "right-icon": ae.deleteAction.rightIcon,
                onClick: ne[2] || (ne[2] = (de) => se.onDeleteClick())
              }, null, 8, ["class", "disabled", "label", "loading", "left-icon", "right-icon"])) : createCommentVNode("", !0),
              ae.primaryAction && ae.primaryAction.label ? (openBlock(), createBlock(ue, {
                key: 3,
                class: normalizeClass(["cs-form-dialog-button", se.buttonClass]),
                primary: "",
                disabled: !!ae.primaryAction.disabled || !!ae.primaryAction.loading,
                label: ae.primaryAction.label,
                loading: !!ae.primaryAction.loading,
                "left-icon": ae.primaryAction.leftIcon,
                "right-icon": ae.primaryAction.rightIcon,
                onClick: ne[3] || (ne[3] = (de) => se.onPrimaryClick())
              }, null, 8, ["class", "disabled", "label", "loading", "left-icon", "right-icon"])) : createCommentVNode("", !0)
            ]),
            _: 1
          })), [
            [Resize, se.onResize]
          ]) : (openBlock(), createElementBlock("div", _hoisted_3$b))
        ]),
        _: 3
      }, 8, ["id"])
    ]),
    _: 3
  }, 8, ["id", "modelValue"]);
}
const CSFormDialog = /* @__PURE__ */ _export_sfc(_sfc_main$E, [["render", _sfc_render$E], ["__scopeId", "data-v-4ff52ee8"]]), cs$1 = {
  login: {
    welcomeMessage: "Welcome",
    welcomeMessageSubText: "Log in to {appName} CS Design System Documentation Site below",
    loginButtonText: "Login"
  },
  copyRightText: "2019 CompliSpace",
  header: {
    homeMenuText: "Home",
    loginButtonText: "Login",
    logoutButtonText: "Logout"
  }
}, en = {
  cs: cs$1
}, __vite_glob_0_0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cs: cs$1,
  default: en
}, Symbol.toStringTag, { value: "Module" })), cs = {
  login: {
    welcomeMessage: "Welcome",
    welcomeMessageSubText: "Log in to {appName} CS Design System Documentation Site below",
    loginButtonText: "Login"
  },
  copyRightText: "2019 CompliSpace",
  header: {
    homeMenuText: "Home",
    loginButtonText: "Login",
    logoutButtonText: "Logout"
  }
}, zh = {
  cs
}, __vite_glob_0_1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cs,
  default: zh
}, Symbol.toStringTag, { value: "Module" }));
/*!
  * shared v9.9.0
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const inBrowser = typeof window < "u", makeSymbol = (re, ne = !1) => ne ? Symbol.for(re) : Symbol(re), generateFormatCacheKey = (re, ne, ae) => friendlyJSONstringify({ l: re, k: ne, s: ae }), friendlyJSONstringify = (re) => JSON.stringify(re).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), isNumber = (re) => typeof re == "number" && isFinite(re), isDate = (re) => toTypeString(re) === "[object Date]", isRegExp = (re) => toTypeString(re) === "[object RegExp]", isEmptyObject = (re) => isPlainObject(re) && Object.keys(re).length === 0, assign$1 = Object.assign;
let _globalThis;
const getGlobalThis = () => _globalThis || (_globalThis = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global$1 < "u" ? global$1 : {});
function escapeHtml(re) {
  return re.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const hasOwnProperty$8 = Object.prototype.hasOwnProperty;
function hasOwn(re, ne) {
  return hasOwnProperty$8.call(re, ne);
}
const isArray$b = Array.isArray, isFunction$3 = (re) => typeof re == "function", isString$1 = (re) => typeof re == "string", isBoolean = (re) => typeof re == "boolean", isObject$5 = (re) => re !== null && typeof re == "object", isPromise = (re) => isObject$5(re) && isFunction$3(re.then) && isFunction$3(re.catch), objectToString = Object.prototype.toString, toTypeString = (re) => objectToString.call(re), isPlainObject = (re) => {
  if (!isObject$5(re))
    return !1;
  const ne = Object.getPrototypeOf(re);
  return ne === null || ne.constructor === Object;
}, toDisplayString = (re) => re == null ? "" : isArray$b(re) || isPlainObject(re) && re.toString === objectToString ? JSON.stringify(re, null, 2) : String(re);
function join$1(re, ne = "") {
  return re.reduce((ae, ie, le) => le === 0 ? ae + ie : ae + ne + ie, "");
}
function incrementer(re) {
  let ne = re;
  return () => ++ne;
}
function warn(re, ne) {
  typeof console < "u" && (console.warn("[intlify] " + re), ne && console.warn(ne.stack));
}
const isNotObjectOrIsArray = (re) => !isObject$5(re) || isArray$b(re);
function deepCopy(re, ne) {
  if (isNotObjectOrIsArray(re) || isNotObjectOrIsArray(ne))
    throw new Error("Invalid value");
  const ae = [{ src: re, des: ne }];
  for (; ae.length; ) {
    const { src: ie, des: le } = ae.pop();
    Object.keys(ie).forEach((se) => {
      isNotObjectOrIsArray(ie[se]) || isNotObjectOrIsArray(le[se]) ? le[se] = ie[se] : ae.push({ src: ie[se], des: le[se] });
    });
  }
}
/*!
  * message-compiler v9.9.0
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function createPosition(re, ne, ae) {
  return { line: re, column: ne, offset: ae };
}
function createLocation(re, ne, ae) {
  return { start: re, end: ne };
}
const RE_ARGS = /\{([0-9a-zA-Z]+)\}/g;
function format$1(re, ...ne) {
  return ne.length === 1 && isObject$4(ne[0]) && (ne = ne[0]), (!ne || !ne.hasOwnProperty) && (ne = {}), re.replace(RE_ARGS, (ae, ie) => ne.hasOwnProperty(ie) ? ne[ie] : "");
}
const assign = Object.assign, isString = (re) => typeof re == "string", isObject$4 = (re) => re !== null && typeof re == "object";
function join(re, ne = "") {
  return re.reduce((ae, ie, le) => le === 0 ? ae + ie : ae + ne + ie, "");
}
const CompileErrorCodes = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16,
  // Special value for higher-order compilers to pick up the last code
  // to avoid collision of error codes. This should always be kept as the last
  // item.
  __EXTEND_POINT__: 17
}, errorMessages = {
  // tokenizer error messages
  [CompileErrorCodes.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [CompileErrorCodes.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [CompileErrorCodes.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [CompileErrorCodes.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [CompileErrorCodes.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [CompileErrorCodes.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [CompileErrorCodes.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [CompileErrorCodes.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [CompileErrorCodes.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [CompileErrorCodes.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [CompileErrorCodes.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [CompileErrorCodes.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [CompileErrorCodes.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function createCompileError(re, ne, ae = {}) {
  const { domain: ie, messages: le, args: se } = ae, ce = format$1((le || errorMessages)[re] || "", ...se || []), ue = new SyntaxError(String(ce));
  return ue.code = re, ne && (ue.location = ne), ue.domain = ie, ue;
}
function defaultOnError(re) {
  throw re;
}
const CHAR_SP = " ", CHAR_CR = "\r", CHAR_LF = `
`, CHAR_LS = "\u2028", CHAR_PS = "\u2029";
function createScanner(re) {
  const ne = re;
  let ae = 0, ie = 1, le = 1, se = 0;
  const ce = (Ze) => ne[Ze] === CHAR_CR && ne[Ze + 1] === CHAR_LF, ue = (Ze) => ne[Ze] === CHAR_LF, de = (Ze) => ne[Ze] === CHAR_PS, me = (Ze) => ne[Ze] === CHAR_LS, fe = (Ze) => ce(Ze) || ue(Ze) || de(Ze) || me(Ze), pe = () => ae, ge = () => ie, be = () => le, Se = () => se, Pe = (Ze) => ce(Ze) || de(Ze) || me(Ze) ? CHAR_LF : ne[Ze], Ee = () => Pe(ae), Ve = () => Pe(ae + se);
  function Ae() {
    return se = 0, fe(ae) && (ie++, le = 0), ce(ae) && ae++, ae++, le++, ne[ae];
  }
  function Oe() {
    return ce(ae + se) && se++, se++, ne[ae + se];
  }
  function Ne() {
    ae = 0, ie = 1, le = 1, se = 0;
  }
  function He(Ze = 0) {
    se = Ze;
  }
  function Ue() {
    const Ze = ae + se;
    for (; Ze !== ae; )
      Ae();
    se = 0;
  }
  return {
    index: pe,
    line: ge,
    column: be,
    peekOffset: Se,
    charAt: Pe,
    currentChar: Ee,
    currentPeek: Ve,
    next: Ae,
    peek: Oe,
    reset: Ne,
    resetPeek: He,
    skipToPeek: Ue
  };
}
const EOF = void 0, DOT = ".", LITERAL_DELIMITER = "'", ERROR_DOMAIN$3 = "tokenizer";
function createTokenizer(re, ne = {}) {
  const ae = ne.location !== !1, ie = createScanner(re), le = () => ie.index(), se = () => createPosition(ie.line(), ie.column(), ie.index()), ce = se(), ue = le(), de = {
    currentType: 14,
    offset: ue,
    startLoc: ce,
    endLoc: ce,
    lastType: 14,
    lastOffset: ue,
    lastStartLoc: ce,
    lastEndLoc: ce,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, me = () => de, { onError: fe } = ne;
  function pe(ze, Ge, nt, ...ot) {
    const lt = me();
    if (Ge.column += nt, Ge.offset += nt, fe) {
      const mt = ae ? createLocation(lt.startLoc, Ge) : null, dt = createCompileError(ze, mt, {
        domain: ERROR_DOMAIN$3,
        args: ot
      });
      fe(dt);
    }
  }
  function ge(ze, Ge, nt) {
    ze.endLoc = se(), ze.currentType = Ge;
    const ot = { type: Ge };
    return ae && (ot.loc = createLocation(ze.startLoc, ze.endLoc)), nt != null && (ot.value = nt), ot;
  }
  const be = (ze) => ge(
    ze,
    14
    /* TokenTypes.EOF */
  );
  function Se(ze, Ge) {
    return ze.currentChar() === Ge ? (ze.next(), Ge) : (pe(CompileErrorCodes.EXPECTED_TOKEN, se(), 0, Ge), "");
  }
  function Pe(ze) {
    let Ge = "";
    for (; ze.currentPeek() === CHAR_SP || ze.currentPeek() === CHAR_LF; )
      Ge += ze.currentPeek(), ze.peek();
    return Ge;
  }
  function Ee(ze) {
    const Ge = Pe(ze);
    return ze.skipToPeek(), Ge;
  }
  function Ve(ze) {
    if (ze === EOF)
      return !1;
    const Ge = ze.charCodeAt(0);
    return Ge >= 97 && Ge <= 122 || // a-z
    Ge >= 65 && Ge <= 90 || // A-Z
    Ge === 95;
  }
  function Ae(ze) {
    if (ze === EOF)
      return !1;
    const Ge = ze.charCodeAt(0);
    return Ge >= 48 && Ge <= 57;
  }
  function Oe(ze, Ge) {
    const { currentType: nt } = Ge;
    if (nt !== 2)
      return !1;
    Pe(ze);
    const ot = Ve(ze.currentPeek());
    return ze.resetPeek(), ot;
  }
  function Ne(ze, Ge) {
    const { currentType: nt } = Ge;
    if (nt !== 2)
      return !1;
    Pe(ze);
    const ot = ze.currentPeek() === "-" ? ze.peek() : ze.currentPeek(), lt = Ae(ot);
    return ze.resetPeek(), lt;
  }
  function He(ze, Ge) {
    const { currentType: nt } = Ge;
    if (nt !== 2)
      return !1;
    Pe(ze);
    const ot = ze.currentPeek() === LITERAL_DELIMITER;
    return ze.resetPeek(), ot;
  }
  function Ue(ze, Ge) {
    const { currentType: nt } = Ge;
    if (nt !== 8)
      return !1;
    Pe(ze);
    const ot = ze.currentPeek() === ".";
    return ze.resetPeek(), ot;
  }
  function Ze(ze, Ge) {
    const { currentType: nt } = Ge;
    if (nt !== 9)
      return !1;
    Pe(ze);
    const ot = Ve(ze.currentPeek());
    return ze.resetPeek(), ot;
  }
  function Fe(ze, Ge) {
    const { currentType: nt } = Ge;
    if (!(nt === 8 || nt === 12))
      return !1;
    Pe(ze);
    const ot = ze.currentPeek() === ":";
    return ze.resetPeek(), ot;
  }
  function Ke(ze, Ge) {
    const { currentType: nt } = Ge;
    if (nt !== 10)
      return !1;
    const ot = () => {
      const mt = ze.currentPeek();
      return mt === "{" ? Ve(ze.peek()) : mt === "@" || mt === "%" || mt === "|" || mt === ":" || mt === "." || mt === CHAR_SP || !mt ? !1 : mt === CHAR_LF ? (ze.peek(), ot()) : Ve(mt);
    }, lt = ot();
    return ze.resetPeek(), lt;
  }
  function tt(ze) {
    Pe(ze);
    const Ge = ze.currentPeek() === "|";
    return ze.resetPeek(), Ge;
  }
  function Re(ze) {
    const Ge = Pe(ze), nt = ze.currentPeek() === "%" && ze.peek() === "{";
    return ze.resetPeek(), {
      isModulo: nt,
      hasSpace: Ge.length > 0
    };
  }
  function Ce(ze, Ge = !0) {
    const nt = (lt = !1, mt = "", dt = !1) => {
      const gt = ze.currentPeek();
      return gt === "{" ? mt === "%" ? !1 : lt : gt === "@" || !gt ? mt === "%" ? !0 : lt : gt === "%" ? (ze.peek(), nt(lt, "%", !0)) : gt === "|" ? mt === "%" || dt ? !0 : !(mt === CHAR_SP || mt === CHAR_LF) : gt === CHAR_SP ? (ze.peek(), nt(!0, CHAR_SP, dt)) : gt === CHAR_LF ? (ze.peek(), nt(!0, CHAR_LF, dt)) : !0;
    }, ot = nt();
    return Ge && ze.resetPeek(), ot;
  }
  function _e(ze, Ge) {
    const nt = ze.currentChar();
    return nt === EOF ? EOF : Ge(nt) ? (ze.next(), nt) : null;
  }
  function he(ze) {
    return _e(ze, (nt) => {
      const ot = nt.charCodeAt(0);
      return ot >= 97 && ot <= 122 || // a-z
      ot >= 65 && ot <= 90 || // A-Z
      ot >= 48 && ot <= 57 || // 0-9
      ot === 95 || // _
      ot === 36;
    });
  }
  function ve(ze) {
    return _e(ze, (nt) => {
      const ot = nt.charCodeAt(0);
      return ot >= 48 && ot <= 57;
    });
  }
  function xe(ze) {
    return _e(ze, (nt) => {
      const ot = nt.charCodeAt(0);
      return ot >= 48 && ot <= 57 || // 0-9
      ot >= 65 && ot <= 70 || // A-F
      ot >= 97 && ot <= 102;
    });
  }
  function $e(ze) {
    let Ge = "", nt = "";
    for (; Ge = ve(ze); )
      nt += Ge;
    return nt;
  }
  function Te(ze) {
    Ee(ze);
    const Ge = ze.currentChar();
    return Ge !== "%" && pe(CompileErrorCodes.EXPECTED_TOKEN, se(), 0, Ge), ze.next(), "%";
  }
  function Ie(ze) {
    let Ge = "";
    for (; ; ) {
      const nt = ze.currentChar();
      if (nt === "{" || nt === "}" || nt === "@" || nt === "|" || !nt)
        break;
      if (nt === "%")
        if (Ce(ze))
          Ge += nt, ze.next();
        else
          break;
      else if (nt === CHAR_SP || nt === CHAR_LF)
        if (Ce(ze))
          Ge += nt, ze.next();
        else {
          if (tt(ze))
            break;
          Ge += nt, ze.next();
        }
      else
        Ge += nt, ze.next();
    }
    return Ge;
  }
  function we(ze) {
    Ee(ze);
    let Ge = "", nt = "";
    for (; Ge = he(ze); )
      nt += Ge;
    return ze.currentChar() === EOF && pe(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, se(), 0), nt;
  }
  function ke(ze) {
    Ee(ze);
    let Ge = "";
    return ze.currentChar() === "-" ? (ze.next(), Ge += `-${$e(ze)}`) : Ge += $e(ze), ze.currentChar() === EOF && pe(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, se(), 0), Ge;
  }
  function ye(ze) {
    Ee(ze), Se(ze, "'");
    let Ge = "", nt = "";
    const ot = (mt) => mt !== LITERAL_DELIMITER && mt !== CHAR_LF;
    for (; Ge = _e(ze, ot); )
      Ge === "\\" ? nt += Be(ze) : nt += Ge;
    const lt = ze.currentChar();
    return lt === CHAR_LF || lt === EOF ? (pe(CompileErrorCodes.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, se(), 0), lt === CHAR_LF && (ze.next(), Se(ze, "'")), nt) : (Se(ze, "'"), nt);
  }
  function Be(ze) {
    const Ge = ze.currentChar();
    switch (Ge) {
      case "\\":
      case "'":
        return ze.next(), `\\${Ge}`;
      case "u":
        return Xe(ze, Ge, 4);
      case "U":
        return Xe(ze, Ge, 6);
      default:
        return pe(CompileErrorCodes.UNKNOWN_ESCAPE_SEQUENCE, se(), 0, Ge), "";
    }
  }
  function Xe(ze, Ge, nt) {
    Se(ze, Ge);
    let ot = "";
    for (let lt = 0; lt < nt; lt++) {
      const mt = xe(ze);
      if (!mt) {
        pe(CompileErrorCodes.INVALID_UNICODE_ESCAPE_SEQUENCE, se(), 0, `\\${Ge}${ot}${ze.currentChar()}`);
        break;
      }
      ot += mt;
    }
    return `\\${Ge}${ot}`;
  }
  function et(ze) {
    Ee(ze);
    let Ge = "", nt = "";
    const ot = (lt) => lt !== "{" && lt !== "}" && lt !== CHAR_SP && lt !== CHAR_LF;
    for (; Ge = _e(ze, ot); )
      nt += Ge;
    return nt;
  }
  function Ye(ze) {
    let Ge = "", nt = "";
    for (; Ge = he(ze); )
      nt += Ge;
    return nt;
  }
  function De(ze) {
    const Ge = (nt = !1, ot) => {
      const lt = ze.currentChar();
      return lt === "{" || lt === "%" || lt === "@" || lt === "|" || lt === "(" || lt === ")" || !lt || lt === CHAR_SP ? ot : lt === CHAR_LF || lt === DOT ? (ot += lt, ze.next(), Ge(nt, ot)) : (ot += lt, ze.next(), Ge(!0, ot));
    };
    return Ge(!1, "");
  }
  function je(ze) {
    Ee(ze);
    const Ge = Se(
      ze,
      "|"
      /* TokenChars.Pipe */
    );
    return Ee(ze), Ge;
  }
  function rt(ze, Ge) {
    let nt = null;
    switch (ze.currentChar()) {
      case "{":
        return Ge.braceNest >= 1 && pe(CompileErrorCodes.NOT_ALLOW_NEST_PLACEHOLDER, se(), 0), ze.next(), nt = ge(
          Ge,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), Ee(ze), Ge.braceNest++, nt;
      case "}":
        return Ge.braceNest > 0 && Ge.currentType === 2 && pe(CompileErrorCodes.EMPTY_PLACEHOLDER, se(), 0), ze.next(), nt = ge(
          Ge,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), Ge.braceNest--, Ge.braceNest > 0 && Ee(ze), Ge.inLinked && Ge.braceNest === 0 && (Ge.inLinked = !1), nt;
      case "@":
        return Ge.braceNest > 0 && pe(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, se(), 0), nt = at(ze, Ge) || be(Ge), Ge.braceNest = 0, nt;
      default:
        let lt = !0, mt = !0, dt = !0;
        if (tt(ze))
          return Ge.braceNest > 0 && pe(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, se(), 0), nt = ge(Ge, 1, je(ze)), Ge.braceNest = 0, Ge.inLinked = !1, nt;
        if (Ge.braceNest > 0 && (Ge.currentType === 5 || Ge.currentType === 6 || Ge.currentType === 7))
          return pe(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, se(), 0), Ge.braceNest = 0, qe(ze, Ge);
        if (lt = Oe(ze, Ge))
          return nt = ge(Ge, 5, we(ze)), Ee(ze), nt;
        if (mt = Ne(ze, Ge))
          return nt = ge(Ge, 6, ke(ze)), Ee(ze), nt;
        if (dt = He(ze, Ge))
          return nt = ge(Ge, 7, ye(ze)), Ee(ze), nt;
        if (!lt && !mt && !dt)
          return nt = ge(Ge, 13, et(ze)), pe(CompileErrorCodes.INVALID_TOKEN_IN_PLACEHOLDER, se(), 0, nt.value), Ee(ze), nt;
        break;
    }
    return nt;
  }
  function at(ze, Ge) {
    const { currentType: nt } = Ge;
    let ot = null;
    const lt = ze.currentChar();
    switch ((nt === 8 || nt === 9 || nt === 12 || nt === 10) && (lt === CHAR_LF || lt === CHAR_SP) && pe(CompileErrorCodes.INVALID_LINKED_FORMAT, se(), 0), lt) {
      case "@":
        return ze.next(), ot = ge(
          Ge,
          8,
          "@"
          /* TokenChars.LinkedAlias */
        ), Ge.inLinked = !0, ot;
      case ".":
        return Ee(ze), ze.next(), ge(
          Ge,
          9,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return Ee(ze), ze.next(), ge(
          Ge,
          10,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return tt(ze) ? (ot = ge(Ge, 1, je(ze)), Ge.braceNest = 0, Ge.inLinked = !1, ot) : Ue(ze, Ge) || Fe(ze, Ge) ? (Ee(ze), at(ze, Ge)) : Ze(ze, Ge) ? (Ee(ze), ge(Ge, 12, Ye(ze))) : Ke(ze, Ge) ? (Ee(ze), lt === "{" ? rt(ze, Ge) || ot : ge(Ge, 11, De(ze))) : (nt === 8 && pe(CompileErrorCodes.INVALID_LINKED_FORMAT, se(), 0), Ge.braceNest = 0, Ge.inLinked = !1, qe(ze, Ge));
    }
  }
  function qe(ze, Ge) {
    let nt = {
      type: 14
      /* TokenTypes.EOF */
    };
    if (Ge.braceNest > 0)
      return rt(ze, Ge) || be(Ge);
    if (Ge.inLinked)
      return at(ze, Ge) || be(Ge);
    switch (ze.currentChar()) {
      case "{":
        return rt(ze, Ge) || be(Ge);
      case "}":
        return pe(CompileErrorCodes.UNBALANCED_CLOSING_BRACE, se(), 0), ze.next(), ge(
          Ge,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return at(ze, Ge) || be(Ge);
      default:
        if (tt(ze))
          return nt = ge(Ge, 1, je(ze)), Ge.braceNest = 0, Ge.inLinked = !1, nt;
        const { isModulo: lt, hasSpace: mt } = Re(ze);
        if (lt)
          return mt ? ge(Ge, 0, Ie(ze)) : ge(Ge, 4, Te(ze));
        if (Ce(ze))
          return ge(Ge, 0, Ie(ze));
        break;
    }
    return nt;
  }
  function We() {
    const { currentType: ze, offset: Ge, startLoc: nt, endLoc: ot } = de;
    return de.lastType = ze, de.lastOffset = Ge, de.lastStartLoc = nt, de.lastEndLoc = ot, de.offset = le(), de.startLoc = se(), ie.currentChar() === EOF ? ge(
      de,
      14
      /* TokenTypes.EOF */
    ) : qe(ie, de);
  }
  return {
    nextToken: We,
    currentOffset: le,
    currentPosition: se,
    context: me
  };
}
const ERROR_DOMAIN$2 = "parser", KNOWN_ESCAPES = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function fromEscapeSequence(re, ne, ae) {
  switch (re) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const ie = parseInt(ne || ae, 16);
      return ie <= 55295 || ie >= 57344 ? String.fromCodePoint(ie) : "�";
    }
  }
}
function createParser(re = {}) {
  const ne = re.location !== !1, { onError: ae } = re;
  function ie(Ve, Ae, Oe, Ne, ...He) {
    const Ue = Ve.currentPosition();
    if (Ue.offset += Ne, Ue.column += Ne, ae) {
      const Ze = ne ? createLocation(Oe, Ue) : null, Fe = createCompileError(Ae, Ze, {
        domain: ERROR_DOMAIN$2,
        args: He
      });
      ae(Fe);
    }
  }
  function le(Ve, Ae, Oe) {
    const Ne = { type: Ve };
    return ne && (Ne.start = Ae, Ne.end = Ae, Ne.loc = { start: Oe, end: Oe }), Ne;
  }
  function se(Ve, Ae, Oe, Ne) {
    ne && (Ve.end = Ae, Ve.loc && (Ve.loc.end = Oe));
  }
  function ce(Ve, Ae) {
    const Oe = Ve.context(), Ne = le(3, Oe.offset, Oe.startLoc);
    return Ne.value = Ae, se(Ne, Ve.currentOffset(), Ve.currentPosition()), Ne;
  }
  function ue(Ve, Ae) {
    const Oe = Ve.context(), { lastOffset: Ne, lastStartLoc: He } = Oe, Ue = le(5, Ne, He);
    return Ue.index = parseInt(Ae, 10), Ve.nextToken(), se(Ue, Ve.currentOffset(), Ve.currentPosition()), Ue;
  }
  function de(Ve, Ae) {
    const Oe = Ve.context(), { lastOffset: Ne, lastStartLoc: He } = Oe, Ue = le(4, Ne, He);
    return Ue.key = Ae, Ve.nextToken(), se(Ue, Ve.currentOffset(), Ve.currentPosition()), Ue;
  }
  function me(Ve, Ae) {
    const Oe = Ve.context(), { lastOffset: Ne, lastStartLoc: He } = Oe, Ue = le(9, Ne, He);
    return Ue.value = Ae.replace(KNOWN_ESCAPES, fromEscapeSequence), Ve.nextToken(), se(Ue, Ve.currentOffset(), Ve.currentPosition()), Ue;
  }
  function fe(Ve) {
    const Ae = Ve.nextToken(), Oe = Ve.context(), { lastOffset: Ne, lastStartLoc: He } = Oe, Ue = le(8, Ne, He);
    return Ae.type !== 12 ? (ie(Ve, CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_MODIFIER, Oe.lastStartLoc, 0), Ue.value = "", se(Ue, Ne, He), {
      nextConsumeToken: Ae,
      node: Ue
    }) : (Ae.value == null && ie(Ve, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, Oe.lastStartLoc, 0, getTokenCaption(Ae)), Ue.value = Ae.value || "", se(Ue, Ve.currentOffset(), Ve.currentPosition()), {
      node: Ue
    });
  }
  function pe(Ve, Ae) {
    const Oe = Ve.context(), Ne = le(7, Oe.offset, Oe.startLoc);
    return Ne.value = Ae, se(Ne, Ve.currentOffset(), Ve.currentPosition()), Ne;
  }
  function ge(Ve) {
    const Ae = Ve.context(), Oe = le(6, Ae.offset, Ae.startLoc);
    let Ne = Ve.nextToken();
    if (Ne.type === 9) {
      const He = fe(Ve);
      Oe.modifier = He.node, Ne = He.nextConsumeToken || Ve.nextToken();
    }
    switch (Ne.type !== 10 && ie(Ve, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, Ae.lastStartLoc, 0, getTokenCaption(Ne)), Ne = Ve.nextToken(), Ne.type === 2 && (Ne = Ve.nextToken()), Ne.type) {
      case 11:
        Ne.value == null && ie(Ve, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, Ae.lastStartLoc, 0, getTokenCaption(Ne)), Oe.key = pe(Ve, Ne.value || "");
        break;
      case 5:
        Ne.value == null && ie(Ve, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, Ae.lastStartLoc, 0, getTokenCaption(Ne)), Oe.key = de(Ve, Ne.value || "");
        break;
      case 6:
        Ne.value == null && ie(Ve, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, Ae.lastStartLoc, 0, getTokenCaption(Ne)), Oe.key = ue(Ve, Ne.value || "");
        break;
      case 7:
        Ne.value == null && ie(Ve, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, Ae.lastStartLoc, 0, getTokenCaption(Ne)), Oe.key = me(Ve, Ne.value || "");
        break;
      default:
        ie(Ve, CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_KEY, Ae.lastStartLoc, 0);
        const He = Ve.context(), Ue = le(7, He.offset, He.startLoc);
        return Ue.value = "", se(Ue, He.offset, He.startLoc), Oe.key = Ue, se(Oe, He.offset, He.startLoc), {
          nextConsumeToken: Ne,
          node: Oe
        };
    }
    return se(Oe, Ve.currentOffset(), Ve.currentPosition()), {
      node: Oe
    };
  }
  function be(Ve) {
    const Ae = Ve.context(), Oe = Ae.currentType === 1 ? Ve.currentOffset() : Ae.offset, Ne = Ae.currentType === 1 ? Ae.endLoc : Ae.startLoc, He = le(2, Oe, Ne);
    He.items = [];
    let Ue = null;
    do {
      const Ke = Ue || Ve.nextToken();
      switch (Ue = null, Ke.type) {
        case 0:
          Ke.value == null && ie(Ve, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, Ae.lastStartLoc, 0, getTokenCaption(Ke)), He.items.push(ce(Ve, Ke.value || ""));
          break;
        case 6:
          Ke.value == null && ie(Ve, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, Ae.lastStartLoc, 0, getTokenCaption(Ke)), He.items.push(ue(Ve, Ke.value || ""));
          break;
        case 5:
          Ke.value == null && ie(Ve, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, Ae.lastStartLoc, 0, getTokenCaption(Ke)), He.items.push(de(Ve, Ke.value || ""));
          break;
        case 7:
          Ke.value == null && ie(Ve, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, Ae.lastStartLoc, 0, getTokenCaption(Ke)), He.items.push(me(Ve, Ke.value || ""));
          break;
        case 8:
          const tt = ge(Ve);
          He.items.push(tt.node), Ue = tt.nextConsumeToken || null;
          break;
      }
    } while (Ae.currentType !== 14 && Ae.currentType !== 1);
    const Ze = Ae.currentType === 1 ? Ae.lastOffset : Ve.currentOffset(), Fe = Ae.currentType === 1 ? Ae.lastEndLoc : Ve.currentPosition();
    return se(He, Ze, Fe), He;
  }
  function Se(Ve, Ae, Oe, Ne) {
    const He = Ve.context();
    let Ue = Ne.items.length === 0;
    const Ze = le(1, Ae, Oe);
    Ze.cases = [], Ze.cases.push(Ne);
    do {
      const Fe = be(Ve);
      Ue || (Ue = Fe.items.length === 0), Ze.cases.push(Fe);
    } while (He.currentType !== 14);
    return Ue && ie(Ve, CompileErrorCodes.MUST_HAVE_MESSAGES_IN_PLURAL, Oe, 0), se(Ze, Ve.currentOffset(), Ve.currentPosition()), Ze;
  }
  function Pe(Ve) {
    const Ae = Ve.context(), { offset: Oe, startLoc: Ne } = Ae, He = be(Ve);
    return Ae.currentType === 14 ? He : Se(Ve, Oe, Ne, He);
  }
  function Ee(Ve) {
    const Ae = createTokenizer(Ve, assign({}, re)), Oe = Ae.context(), Ne = le(0, Oe.offset, Oe.startLoc);
    return ne && Ne.loc && (Ne.loc.source = Ve), Ne.body = Pe(Ae), re.onCacheKey && (Ne.cacheKey = re.onCacheKey(Ve)), Oe.currentType !== 14 && ie(Ae, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, Oe.lastStartLoc, 0, Ve[Oe.offset] || ""), se(Ne, Ae.currentOffset(), Ae.currentPosition()), Ne;
  }
  return { parse: Ee };
}
function getTokenCaption(re) {
  if (re.type === 14)
    return "EOF";
  const ne = (re.value || "").replace(/\r?\n/gu, "\\n");
  return ne.length > 10 ? ne.slice(0, 9) + "…" : ne;
}
function createTransformer(re, ne = {}) {
  const ae = {
    ast: re,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => ae, helper: (se) => (ae.helpers.add(se), se) };
}
function traverseNodes(re, ne) {
  for (let ae = 0; ae < re.length; ae++)
    traverseNode(re[ae], ne);
}
function traverseNode(re, ne) {
  switch (re.type) {
    case 1:
      traverseNodes(re.cases, ne), ne.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      traverseNodes(re.items, ne);
      break;
    case 6:
      traverseNode(re.key, ne), ne.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), ne.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    case 5:
      ne.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), ne.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      ne.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), ne.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function transform(re, ne = {}) {
  const ae = createTransformer(re);
  ae.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), re.body && traverseNode(re.body, ae);
  const ie = ae.context();
  re.helpers = Array.from(ie.helpers);
}
function optimize(re) {
  const ne = re.body;
  return ne.type === 2 ? optimizeMessageNode(ne) : ne.cases.forEach((ae) => optimizeMessageNode(ae)), re;
}
function optimizeMessageNode(re) {
  if (re.items.length === 1) {
    const ne = re.items[0];
    (ne.type === 3 || ne.type === 9) && (re.static = ne.value, delete ne.value);
  } else {
    const ne = [];
    for (let ae = 0; ae < re.items.length; ae++) {
      const ie = re.items[ae];
      if (!(ie.type === 3 || ie.type === 9) || ie.value == null)
        break;
      ne.push(ie.value);
    }
    if (ne.length === re.items.length) {
      re.static = join(ne);
      for (let ae = 0; ae < re.items.length; ae++) {
        const ie = re.items[ae];
        (ie.type === 3 || ie.type === 9) && delete ie.value;
      }
    }
  }
}
const ERROR_DOMAIN$1 = "minifier";
function minify(re) {
  switch (re.t = re.type, re.type) {
    case 0:
      const ne = re;
      minify(ne.body), ne.b = ne.body, delete ne.body;
      break;
    case 1:
      const ae = re, ie = ae.cases;
      for (let fe = 0; fe < ie.length; fe++)
        minify(ie[fe]);
      ae.c = ie, delete ae.cases;
      break;
    case 2:
      const le = re, se = le.items;
      for (let fe = 0; fe < se.length; fe++)
        minify(se[fe]);
      le.i = se, delete le.items, le.static && (le.s = le.static, delete le.static);
      break;
    case 3:
    case 9:
    case 8:
    case 7:
      const ce = re;
      ce.value && (ce.v = ce.value, delete ce.value);
      break;
    case 6:
      const ue = re;
      minify(ue.key), ue.k = ue.key, delete ue.key, ue.modifier && (minify(ue.modifier), ue.m = ue.modifier, delete ue.modifier);
      break;
    case 5:
      const de = re;
      de.i = de.index, delete de.index;
      break;
    case 4:
      const me = re;
      me.k = me.key, delete me.key;
      break;
    default:
      throw createCompileError(CompileErrorCodes.UNHANDLED_MINIFIER_NODE_TYPE, null, {
        domain: ERROR_DOMAIN$1,
        args: [re.type]
      });
  }
  delete re.type;
}
const ERROR_DOMAIN = "parser";
function createCodeGenerator(re, ne) {
  const { sourceMap: ae, filename: ie, breakLineCode: le, needIndent: se } = ne, ce = ne.location !== !1, ue = {
    filename: ie,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: le,
    needIndent: se,
    indentLevel: 0
  };
  ce && re.loc && (ue.source = re.loc.source);
  const de = () => ue;
  function me(Ee, Ve) {
    ue.code += Ee;
  }
  function fe(Ee, Ve = !0) {
    const Ae = Ve ? le : "";
    me(se ? Ae + "  ".repeat(Ee) : Ae);
  }
  function pe(Ee = !0) {
    const Ve = ++ue.indentLevel;
    Ee && fe(Ve);
  }
  function ge(Ee = !0) {
    const Ve = --ue.indentLevel;
    Ee && fe(Ve);
  }
  function be() {
    fe(ue.indentLevel);
  }
  return {
    context: de,
    push: me,
    indent: pe,
    deindent: ge,
    newline: be,
    helper: (Ee) => `_${Ee}`,
    needIndent: () => ue.needIndent
  };
}
function generateLinkedNode(re, ne) {
  const { helper: ae } = re;
  re.push(`${ae(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), generateNode(re, ne.key), ne.modifier ? (re.push(", "), generateNode(re, ne.modifier), re.push(", _type")) : re.push(", undefined, _type"), re.push(")");
}
function generateMessageNode(re, ne) {
  const { helper: ae, needIndent: ie } = re;
  re.push(`${ae(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), re.indent(ie());
  const le = ne.items.length;
  for (let se = 0; se < le && (generateNode(re, ne.items[se]), se !== le - 1); se++)
    re.push(", ");
  re.deindent(ie()), re.push("])");
}
function generatePluralNode(re, ne) {
  const { helper: ae, needIndent: ie } = re;
  if (ne.cases.length > 1) {
    re.push(`${ae(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), re.indent(ie());
    const le = ne.cases.length;
    for (let se = 0; se < le && (generateNode(re, ne.cases[se]), se !== le - 1); se++)
      re.push(", ");
    re.deindent(ie()), re.push("])");
  }
}
function generateResource(re, ne) {
  ne.body ? generateNode(re, ne.body) : re.push("null");
}
function generateNode(re, ne) {
  const { helper: ae } = re;
  switch (ne.type) {
    case 0:
      generateResource(re, ne);
      break;
    case 1:
      generatePluralNode(re, ne);
      break;
    case 2:
      generateMessageNode(re, ne);
      break;
    case 6:
      generateLinkedNode(re, ne);
      break;
    case 8:
      re.push(JSON.stringify(ne.value), ne);
      break;
    case 7:
      re.push(JSON.stringify(ne.value), ne);
      break;
    case 5:
      re.push(`${ae(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${ae(
        "list"
        /* HelperNameMap.LIST */
      )}(${ne.index}))`, ne);
      break;
    case 4:
      re.push(`${ae(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${ae(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(ne.key)}))`, ne);
      break;
    case 9:
      re.push(JSON.stringify(ne.value), ne);
      break;
    case 3:
      re.push(JSON.stringify(ne.value), ne);
      break;
    default:
      throw createCompileError(CompileErrorCodes.UNHANDLED_CODEGEN_NODE_TYPE, null, {
        domain: ERROR_DOMAIN,
        args: [ne.type]
      });
  }
}
const generate = (re, ne = {}) => {
  const ae = isString(ne.mode) ? ne.mode : "normal", ie = isString(ne.filename) ? ne.filename : "message.intl", le = !!ne.sourceMap, se = ne.breakLineCode != null ? ne.breakLineCode : ae === "arrow" ? ";" : `
`, ce = ne.needIndent ? ne.needIndent : ae !== "arrow", ue = re.helpers || [], de = createCodeGenerator(re, {
    mode: ae,
    filename: ie,
    sourceMap: le,
    breakLineCode: se,
    needIndent: ce
  });
  de.push(ae === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), de.indent(ce), ue.length > 0 && (de.push(`const { ${join(ue.map((pe) => `${pe}: _${pe}`), ", ")} } = ctx`), de.newline()), de.push("return "), generateNode(de, re), de.deindent(ce), de.push("}"), delete re.helpers;
  const { code: me, map: fe } = de.context();
  return {
    ast: re,
    code: me,
    map: fe ? fe.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function baseCompile$1(re, ne = {}) {
  const ae = assign({}, ne), ie = !!ae.jit, le = !!ae.minify, se = ae.optimize == null ? !0 : ae.optimize, ue = createParser(ae).parse(re);
  return ie ? (se && optimize(ue), le && minify(ue), { ast: ue, code: "" }) : (transform(ue, ae), generate(ue, ae));
}
var define_process_env_default$1 = { npm_package_exports___require: "./dist/cs-design-system.umd.js", npm_package_devDependencies_vitest: "~2.1.4", npm_package_devDependencies_eslint_import_resolver_alias: "~1.1.2", npm_config_version_commit_hooks: "true", npm_config_user_agent: "yarn/1.22.19 npm/? node/v18.16.0 linux x64", NODE_VERSION: "18.16.0", npm_package_dependencies_vue: "~3.5.13", npm_config_bin_links: "true", npm_config_wrap_output: "", HOSTNAME: "14649218c17b", YARN_VERSION: "1.22.19", npm_node_execpath: "/usr/local/bin/node", npm_package_devDependencies_vite: "~5.4.9", npm_config_init_version: "1.0.0", npm_package_packageManager: "yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e", npm_package_files_0: "dist", HOME: "/root", npm_package_devDependencies_sass: "1.77.6", npm_package_dependencies_vuex: "4.1.0", npm_package_engines_node: ">=18.16.0", npm_config_init_license: "MIT", YARN_WRAP_OUTPUT: "false", npm_package_peerDependencies_vue: "~3.5.13", npm_package_dependencies__complispace_gainsight_px: "~2.1.0", npm_package_scripts_rebuild: "rm -rf dist && rm -rf node_modules && yarn install && yarn lint-staged && yarn build && yarn test:unit", npm_config_version_tag_prefix: "v", npm_config__complispace_registry: "https://registry.npmjs.org/", npm_package_keywords_0: "auth0", npm_package_devDependencies_husky: "~9.1.7", npm_package_keywords_1: "vue", npm_package_peerDependencies_vuex: "~4.1.0", npm_package_description: "Complispace SPA web application skeleton, including auth0 login process and UI components", npm_package_readmeFilename: "README.md", npm_package_lint_staged___vue_0: "eslint --fix", npm_package_keywords_2: "vuetify", npm_package_devDependencies_prettier: "~3.2.4", npm_package_devDependencies_mockdate: "~3.0.5", npm_package_lint_staged___js_0: "eslint --fix", npm_package_scripts_watch_rebuild: "rm -rf dist && rm -rf node_modules && yarn install && yarn lint-staged && yarn watch-build", npm_package_type: "module", npm_package_devDependencies_vite_plugin_node_polyfills: "~0.22.0", npm_package_module: "./dist/cs-design-system.es.js", npm_package_devDependencies__vitest_coverage_v8: "~2.1.4", npm_package_scripts_prepare: "husky", npm_package_scripts_lint: "eslint --ext .js,.vue src/", npm_config_registry: "https://registry.yarnpkg.com", npm_config_scope: "complispace", npm_package_devDependencies_happy_dom: "~15.11.2", npm_package_dependencies_vuetify: "~3.7.19", npm_package_devDependencies__vitejs_plugin_vue: "~5.1.4", npm_package_exports___import: "./dist/cs-design-system.es.js", npm_config_ignore_scripts: "", npm_config_version: "1.22.19", npm_package_dependencies_axios: "~1.7.7", PATH: "/tmp/yarn--1756864169391-0.6098667048828752:/var/lib/app/node_modules/.bin:/usr/local/share/.config/yarn/link/node_modules/.bin:/usr/local/libexec/lib/node_modules/npm/bin/node-gyp-bin:/usr/local/lib/node_modules/npm/bin/node-gyp-bin:/usr/local/bin/node_modules/npm/bin/node-gyp-bin:/tmp/yarn--1756864165216-0.09775249259687246:/var/lib/app/node_modules/.bin:/usr/local/share/.config/yarn/link/node_modules/.bin:/usr/local/libexec/lib/node_modules/npm/bin/node-gyp-bin:/usr/local/lib/node_modules/npm/bin/node-gyp-bin:/usr/local/bin/node_modules/npm/bin/node-gyp-bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin", NODE: "/usr/local/bin/node", npm_package_devDependencies__babel_eslint_parser: "~7.25.9", npm_package_dependencies_cross_env: "~7.0.3", npm_package_name: "@complispace/cs-design-system", npm_package_dependencies_jose: "~5.9.6", npm_package_devDependencies__vitest_ui: "~2.1.4", npm_package_scripts_build_scss_theme: "node --es-module-specifier-resolution=node ./src/theme/buildScss.mjs", npm_package_scripts_test_unit: "vitest run --dir src/tests/unit", npm_package_peerDependencies_vuetify: "~3.7.19", npm_package_devDependencies_eslint: "~8.57.1", npm_package_devDependencies__vue_test_utils: "~2.4.6", npm_lifecycle_script: "vite build", npm_package_browserslist_0: "> 1%", npm_package_exports___style_css: "./dist/style.css", npm_package_main: "./dist/cs-design-system.umd.js", npm_package_browserslist_1: "last 2 versions", npm_package_devDependencies__vue_eslint_config_prettier: "~9.0.0", npm_config_version_git_message: "v%s", npm_lifecycle_event: "build", npm_package_browserslist_2: "not dead", npm_package_version: "1.4.0", npm_config_argv: '{"remain":[],"cooked":["run","rebuild"],"original":["rebuild"]}', npm_package_engines_yarn: ">= 1.22.5", npm_package_devDependencies_lint_staged: "~15.2.0", npm_package_dependencies_vue_i18n: "9.9.0", npm_package_dependencies_buffer: "~6.0.3", npm_package_scripts_build: "vite build", npm_package_dependencies_lodash: "~4.17.21", npm_package_devDependencies_vite_plugin_vuetify: "~2.0.4", npm_package_devDependencies_sass_loader: "~10.2.0", npm_package_dependencies_vue_router: "4.2.5", npm_config_version_git_tag: "true", npm_config_version_git_sign: "", npm_package_license: "UNLICENSED", npm_config_strict_ssl: "true", npm_package_peerDependencies_vitest: "~2.1.4", npm_package_devDependencies_eslint_plugin_prettier: "~5.2.1", npm_config_complispace_registry: "https://registry.npmjs.org/", PWD: "/var/lib/app", npm_execpath: "/opt/yarn-v1.22.19/bin/yarn.js", npm_package_devDependencies_vue_eslint_parser: "~9.4.3", npm_package_peerDependencies_vue_i18n: "~9.9.0", npm_package_scripts_watch_build: "vite build --watch", npm_package_devDependencies_eslint_plugin_vue: "~9.31.0", npm_package_devDependencies__vue_eslint_config_standard: "~8.0.1", npm_package_dependencies__auth0_auth0_spa_js: "~2.1.3", npm_config_save_prefix: "^", npm_config_ignore_optional: "", npm_package_peerDependencies_vue_router: "~4.2.5", INIT_CWD: "/var/lib/app", npm_package_devDependencies_unplugin_vue_components: "~0.27.4", NODE_ENV: "production" };
function initFeatureFlags$1() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (getGlobalThis().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (getGlobalThis().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (getGlobalThis().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
const pathStateMachine = [];
pathStateMachine[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
pathStateMachine[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
pathStateMachine[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
pathStateMachine[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
pathStateMachine[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
pathStateMachine[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
pathStateMachine[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function isLiteral(re) {
  return literalValueRE.test(re);
}
function stripQuotes(re) {
  const ne = re.charCodeAt(0), ae = re.charCodeAt(re.length - 1);
  return ne === ae && (ne === 34 || ne === 39) ? re.slice(1, -1) : re;
}
function getPathCharType(re) {
  if (re == null)
    return "o";
  switch (re.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return re;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function formatSubPath(re) {
  const ne = re.trim();
  return re.charAt(0) === "0" && isNaN(parseInt(re)) ? !1 : isLiteral(ne) ? stripQuotes(ne) : "*" + ne;
}
function parse(re) {
  const ne = [];
  let ae = -1, ie = 0, le = 0, se, ce, ue, de, me, fe, pe;
  const ge = [];
  ge[
    0
    /* Actions.APPEND */
  ] = () => {
    ce === void 0 ? ce = ue : ce += ue;
  }, ge[
    1
    /* Actions.PUSH */
  ] = () => {
    ce !== void 0 && (ne.push(ce), ce = void 0);
  }, ge[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    ge[
      0
      /* Actions.APPEND */
    ](), le++;
  }, ge[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (le > 0)
      le--, ie = 4, ge[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (le = 0, ce === void 0 || (ce = formatSubPath(ce), ce === !1))
        return !1;
      ge[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function be() {
    const Se = re[ae + 1];
    if (ie === 5 && Se === "'" || ie === 6 && Se === '"')
      return ae++, ue = "\\" + Se, ge[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; ie !== null; )
    if (ae++, se = re[ae], !(se === "\\" && be())) {
      if (de = getPathCharType(se), pe = pathStateMachine[ie], me = pe[de] || pe.l || 8, me === 8 || (ie = me[0], me[1] !== void 0 && (fe = ge[me[1]], fe && (ue = se, fe() === !1))))
        return;
      if (ie === 7)
        return ne;
    }
}
const cache = /* @__PURE__ */ new Map();
function resolveWithKeyValue(re, ne) {
  return isObject$5(re) ? re[ne] : null;
}
function resolveValue(re, ne) {
  if (!isObject$5(re))
    return null;
  let ae = cache.get(ne);
  if (ae || (ae = parse(ne), ae && cache.set(ne, ae)), !ae)
    return null;
  const ie = ae.length;
  let le = re, se = 0;
  for (; se < ie; ) {
    const ce = le[ae[se]];
    if (ce === void 0 || isFunction$3(le))
      return null;
    le = ce, se++;
  }
  return le;
}
const DEFAULT_MODIFIER = (re) => re, DEFAULT_MESSAGE = (re) => "", DEFAULT_MESSAGE_DATA_TYPE = "text", DEFAULT_NORMALIZE = (re) => re.length === 0 ? "" : join$1(re), DEFAULT_INTERPOLATE = toDisplayString;
function pluralDefault(re, ne) {
  return re = Math.abs(re), ne === 2 ? re ? re > 1 ? 1 : 0 : 1 : re ? Math.min(re, 2) : 0;
}
function getPluralIndex(re) {
  const ne = isNumber(re.pluralIndex) ? re.pluralIndex : -1;
  return re.named && (isNumber(re.named.count) || isNumber(re.named.n)) ? isNumber(re.named.count) ? re.named.count : isNumber(re.named.n) ? re.named.n : ne : ne;
}
function normalizeNamed(re, ne) {
  ne.count || (ne.count = re), ne.n || (ne.n = re);
}
function createMessageContext(re = {}) {
  const ne = re.locale, ae = getPluralIndex(re), ie = isObject$5(re.pluralRules) && isString$1(ne) && isFunction$3(re.pluralRules[ne]) ? re.pluralRules[ne] : pluralDefault, le = isObject$5(re.pluralRules) && isString$1(ne) && isFunction$3(re.pluralRules[ne]) ? pluralDefault : void 0, se = (Ve) => Ve[ie(ae, Ve.length, le)], ce = re.list || [], ue = (Ve) => ce[Ve], de = re.named || {};
  isNumber(re.pluralIndex) && normalizeNamed(ae, de);
  const me = (Ve) => de[Ve];
  function fe(Ve) {
    const Ae = isFunction$3(re.messages) ? re.messages(Ve) : isObject$5(re.messages) ? re.messages[Ve] : !1;
    return Ae || (re.parent ? re.parent.message(Ve) : DEFAULT_MESSAGE);
  }
  const pe = (Ve) => re.modifiers ? re.modifiers[Ve] : DEFAULT_MODIFIER, ge = isPlainObject(re.processor) && isFunction$3(re.processor.normalize) ? re.processor.normalize : DEFAULT_NORMALIZE, be = isPlainObject(re.processor) && isFunction$3(re.processor.interpolate) ? re.processor.interpolate : DEFAULT_INTERPOLATE, Se = isPlainObject(re.processor) && isString$1(re.processor.type) ? re.processor.type : DEFAULT_MESSAGE_DATA_TYPE, Ee = {
    list: ue,
    named: me,
    plural: se,
    linked: (Ve, ...Ae) => {
      const [Oe, Ne] = Ae;
      let He = "text", Ue = "";
      Ae.length === 1 ? isObject$5(Oe) ? (Ue = Oe.modifier || Ue, He = Oe.type || He) : isString$1(Oe) && (Ue = Oe || Ue) : Ae.length === 2 && (isString$1(Oe) && (Ue = Oe || Ue), isString$1(Ne) && (He = Ne || He));
      const Ze = fe(Ve)(Ee), Fe = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        He === "vnode" && isArray$b(Ze) && Ue ? Ze[0] : Ze
      );
      return Ue ? pe(Ue)(Fe, He) : Fe;
    },
    message: fe,
    type: Se,
    interpolate: be,
    normalize: ge,
    values: assign$1({}, ce, de)
  };
  return Ee;
}
let devtools = null;
function setDevToolsHook(re) {
  devtools = re;
}
function initI18nDevTools(re, ne, ae) {
  devtools && devtools.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: re,
    version: ne,
    meta: ae
  });
}
const translateDevTools = /* @__PURE__ */ createDevToolsHook(
  "function:translate"
  /* IntlifyDevToolsHooks.FunctionTranslate */
);
function createDevToolsHook(re) {
  return (ne) => devtools && devtools.emit(re, ne);
}
const CoreWarnCodes = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7,
  __EXTEND_POINT__: 8
}, code$2 = CompileErrorCodes.__EXTEND_POINT__, inc$2 = incrementer(code$2), CoreErrorCodes = {
  INVALID_ARGUMENT: code$2,
  INVALID_DATE_ARGUMENT: inc$2(),
  INVALID_ISO_DATE_ARGUMENT: inc$2(),
  NOT_SUPPORT_NON_STRING_MESSAGE: inc$2(),
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: inc$2(),
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: inc$2(),
  NOT_SUPPORT_LOCALE_TYPE: inc$2(),
  __EXTEND_POINT__: inc$2()
  // 25
};
function createCoreError(re) {
  return createCompileError(re, null, void 0);
}
function getLocale(re, ne) {
  return ne.locale != null ? resolveLocale(ne.locale) : resolveLocale(re.locale);
}
let _resolveLocale;
function resolveLocale(re) {
  if (isString$1(re))
    return re;
  if (isFunction$3(re)) {
    if (re.resolvedOnce && _resolveLocale != null)
      return _resolveLocale;
    if (re.constructor.name === "Function") {
      const ne = re();
      if (isPromise(ne))
        throw createCoreError(CoreErrorCodes.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return _resolveLocale = ne;
    } else
      throw createCoreError(CoreErrorCodes.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw createCoreError(CoreErrorCodes.NOT_SUPPORT_LOCALE_TYPE);
}
function fallbackWithSimple(re, ne, ae) {
  return [.../* @__PURE__ */ new Set([
    ae,
    ...isArray$b(ne) ? ne : isObject$5(ne) ? Object.keys(ne) : isString$1(ne) ? [ne] : [ae]
  ])];
}
function fallbackWithLocaleChain(re, ne, ae) {
  const ie = isString$1(ae) ? ae : DEFAULT_LOCALE, le = re;
  le.__localeChainCache || (le.__localeChainCache = /* @__PURE__ */ new Map());
  let se = le.__localeChainCache.get(ie);
  if (!se) {
    se = [];
    let ce = [ae];
    for (; isArray$b(ce); )
      ce = appendBlockToChain(se, ce, ne);
    const ue = isArray$b(ne) || !isPlainObject(ne) ? ne : ne.default ? ne.default : null;
    ce = isString$1(ue) ? [ue] : ue, isArray$b(ce) && appendBlockToChain(se, ce, !1), le.__localeChainCache.set(ie, se);
  }
  return se;
}
function appendBlockToChain(re, ne, ae) {
  let ie = !0;
  for (let le = 0; le < ne.length && isBoolean(ie); le++) {
    const se = ne[le];
    isString$1(se) && (ie = appendLocaleToChain(re, ne[le], ae));
  }
  return ie;
}
function appendLocaleToChain(re, ne, ae) {
  let ie;
  const le = ne.split("-");
  do {
    const se = le.join("-");
    ie = appendItemToChain(re, se, ae), le.splice(-1, 1);
  } while (le.length && ie === !0);
  return ie;
}
function appendItemToChain(re, ne, ae) {
  let ie = !1;
  if (!re.includes(ne) && (ie = !0, ne)) {
    ie = ne[ne.length - 1] !== "!";
    const le = ne.replace(/!/g, "");
    re.push(le), (isArray$b(ae) || isPlainObject(ae)) && ae[le] && (ie = ae[le]);
  }
  return ie;
}
const VERSION$1 = "9.9.0", NOT_REOSLVED = -1, DEFAULT_LOCALE = "en-US", MISSING_RESOLVE_VALUE = "", capitalize = (re) => `${re.charAt(0).toLocaleUpperCase()}${re.substr(1)}`;
function getDefaultLinkedModifiers() {
  return {
    upper: (re, ne) => ne === "text" && isString$1(re) ? re.toUpperCase() : ne === "vnode" && isObject$5(re) && "__v_isVNode" in re ? re.children.toUpperCase() : re,
    lower: (re, ne) => ne === "text" && isString$1(re) ? re.toLowerCase() : ne === "vnode" && isObject$5(re) && "__v_isVNode" in re ? re.children.toLowerCase() : re,
    capitalize: (re, ne) => ne === "text" && isString$1(re) ? capitalize(re) : ne === "vnode" && isObject$5(re) && "__v_isVNode" in re ? capitalize(re.children) : re
  };
}
let _compiler;
function registerMessageCompiler(re) {
  _compiler = re;
}
let _resolver;
function registerMessageResolver(re) {
  _resolver = re;
}
let _fallbacker;
function registerLocaleFallbacker(re) {
  _fallbacker = re;
}
let _additionalMeta = null;
const setAdditionalMeta = /* @__NO_SIDE_EFFECTS__ */ (re) => {
  _additionalMeta = re;
}, getAdditionalMeta = /* @__NO_SIDE_EFFECTS__ */ () => _additionalMeta;
let _fallbackContext = null;
const setFallbackContext = (re) => {
  _fallbackContext = re;
}, getFallbackContext = () => _fallbackContext;
let _cid = 0;
function createCoreContext(re = {}) {
  const ne = isFunction$3(re.onWarn) ? re.onWarn : warn, ae = isString$1(re.version) ? re.version : VERSION$1, ie = isString$1(re.locale) || isFunction$3(re.locale) ? re.locale : DEFAULT_LOCALE, le = isFunction$3(ie) ? DEFAULT_LOCALE : ie, se = isArray$b(re.fallbackLocale) || isPlainObject(re.fallbackLocale) || isString$1(re.fallbackLocale) || re.fallbackLocale === !1 ? re.fallbackLocale : le, ce = isPlainObject(re.messages) ? re.messages : { [le]: {} }, ue = isPlainObject(re.datetimeFormats) ? re.datetimeFormats : { [le]: {} }, de = isPlainObject(re.numberFormats) ? re.numberFormats : { [le]: {} }, me = assign$1({}, re.modifiers || {}, getDefaultLinkedModifiers()), fe = re.pluralRules || {}, pe = isFunction$3(re.missing) ? re.missing : null, ge = isBoolean(re.missingWarn) || isRegExp(re.missingWarn) ? re.missingWarn : !0, be = isBoolean(re.fallbackWarn) || isRegExp(re.fallbackWarn) ? re.fallbackWarn : !0, Se = !!re.fallbackFormat, Pe = !!re.unresolving, Ee = isFunction$3(re.postTranslation) ? re.postTranslation : null, Ve = isPlainObject(re.processor) ? re.processor : null, Ae = isBoolean(re.warnHtmlMessage) ? re.warnHtmlMessage : !0, Oe = !!re.escapeParameter, Ne = isFunction$3(re.messageCompiler) ? re.messageCompiler : _compiler, He = isFunction$3(re.messageResolver) ? re.messageResolver : _resolver || resolveWithKeyValue, Ue = isFunction$3(re.localeFallbacker) ? re.localeFallbacker : _fallbacker || fallbackWithSimple, Ze = isObject$5(re.fallbackContext) ? re.fallbackContext : void 0, Fe = re, Ke = isObject$5(Fe.__datetimeFormatters) ? Fe.__datetimeFormatters : /* @__PURE__ */ new Map(), tt = isObject$5(Fe.__numberFormatters) ? Fe.__numberFormatters : /* @__PURE__ */ new Map(), Re = isObject$5(Fe.__meta) ? Fe.__meta : {};
  _cid++;
  const Ce = {
    version: ae,
    cid: _cid,
    locale: ie,
    fallbackLocale: se,
    messages: ce,
    modifiers: me,
    pluralRules: fe,
    missing: pe,
    missingWarn: ge,
    fallbackWarn: be,
    fallbackFormat: Se,
    unresolving: Pe,
    postTranslation: Ee,
    processor: Ve,
    warnHtmlMessage: Ae,
    escapeParameter: Oe,
    messageCompiler: Ne,
    messageResolver: He,
    localeFallbacker: Ue,
    fallbackContext: Ze,
    onWarn: ne,
    __meta: Re
  };
  return Ce.datetimeFormats = ue, Ce.numberFormats = de, Ce.__datetimeFormatters = Ke, Ce.__numberFormatters = tt, __INTLIFY_PROD_DEVTOOLS__ && initI18nDevTools(Ce, ae, Re), Ce;
}
function handleMissing(re, ne, ae, ie, le) {
  const { missing: se, onWarn: ce } = re;
  if (se !== null) {
    const ue = se(re, ae, ne, le);
    return isString$1(ue) ? ue : ne;
  } else
    return ne;
}
function updateFallbackLocale(re, ne, ae) {
  const ie = re;
  ie.__localeChainCache = /* @__PURE__ */ new Map(), re.localeFallbacker(re, ae, ne);
}
function format(re) {
  return (ae) => formatParts(ae, re);
}
function formatParts(re, ne) {
  const ae = ne.b || ne.body;
  if ((ae.t || ae.type) === 1) {
    const ie = ae, le = ie.c || ie.cases;
    return re.plural(le.reduce((se, ce) => [
      ...se,
      formatMessageParts(re, ce)
    ], []));
  } else
    return formatMessageParts(re, ae);
}
function formatMessageParts(re, ne) {
  const ae = ne.s || ne.static;
  if (ae)
    return re.type === "text" ? ae : re.normalize([ae]);
  {
    const ie = (ne.i || ne.items).reduce((le, se) => [...le, formatMessagePart(re, se)], []);
    return re.normalize(ie);
  }
}
function formatMessagePart(re, ne) {
  const ae = ne.t || ne.type;
  switch (ae) {
    case 3:
      const ie = ne;
      return ie.v || ie.value;
    case 9:
      const le = ne;
      return le.v || le.value;
    case 4:
      const se = ne;
      return re.interpolate(re.named(se.k || se.key));
    case 5:
      const ce = ne;
      return re.interpolate(re.list(ce.i != null ? ce.i : ce.index));
    case 6:
      const ue = ne, de = ue.m || ue.modifier;
      return re.linked(formatMessagePart(re, ue.k || ue.key), de ? formatMessagePart(re, de) : void 0, re.type);
    case 7:
      const me = ne;
      return me.v || me.value;
    case 8:
      const fe = ne;
      return fe.v || fe.value;
    default:
      throw new Error(`unhandled node type on format message part: ${ae}`);
  }
}
const defaultOnCacheKey = (re) => re;
let compileCache = /* @__PURE__ */ Object.create(null);
const isMessageAST = (re) => isObject$5(re) && (re.t === 0 || re.type === 0) && ("b" in re || "body" in re);
function baseCompile(re, ne = {}) {
  let ae = !1;
  const ie = ne.onError || defaultOnError;
  return ne.onError = (le) => {
    ae = !0, ie(le);
  }, { ...baseCompile$1(re, ne), detectError: ae };
}
const compileToFunction = /* @__NO_SIDE_EFFECTS__ */ (re, ne) => {
  if (!isString$1(re))
    throw createCoreError(CoreErrorCodes.NOT_SUPPORT_NON_STRING_MESSAGE);
  {
    isBoolean(ne.warnHtmlMessage) && ne.warnHtmlMessage;
    const ie = (ne.onCacheKey || defaultOnCacheKey)(re), le = compileCache[ie];
    if (le)
      return le;
    const { code: se, detectError: ce } = baseCompile(re, ne), ue = new Function(`return ${se}`)();
    return ce ? ue : compileCache[ie] = ue;
  }
};
function compile(re, ne) {
  if (__INTLIFY_JIT_COMPILATION__ && !__INTLIFY_DROP_MESSAGE_COMPILER__ && isString$1(re)) {
    isBoolean(ne.warnHtmlMessage) && ne.warnHtmlMessage;
    const ie = (ne.onCacheKey || defaultOnCacheKey)(re), le = compileCache[ie];
    if (le)
      return le;
    const { ast: se, detectError: ce } = baseCompile(re, {
      ...ne,
      location: define_process_env_default$1.NODE_ENV !== "production",
      jit: !0
    }), ue = format(se);
    return ce ? ue : compileCache[ie] = ue;
  } else {
    const ae = re.cacheKey;
    if (ae) {
      const ie = compileCache[ae];
      return ie || (compileCache[ae] = format(re));
    } else
      return format(re);
  }
}
const NOOP_MESSAGE_FUNCTION = () => "", isMessageFunction = (re) => isFunction$3(re);
function translate(re, ...ne) {
  const { fallbackFormat: ae, postTranslation: ie, unresolving: le, messageCompiler: se, fallbackLocale: ce, messages: ue } = re, [de, me] = parseTranslateArgs(...ne), fe = isBoolean(me.missingWarn) ? me.missingWarn : re.missingWarn, pe = isBoolean(me.fallbackWarn) ? me.fallbackWarn : re.fallbackWarn, ge = isBoolean(me.escapeParameter) ? me.escapeParameter : re.escapeParameter, be = !!me.resolvedMessage, Se = isString$1(me.default) || isBoolean(me.default) ? isBoolean(me.default) ? se ? de : () => de : me.default : ae ? se ? de : () => de : "", Pe = ae || Se !== "", Ee = getLocale(re, me);
  ge && escapeParams(me);
  let [Ve, Ae, Oe] = be ? [
    de,
    Ee,
    ue[Ee] || {}
  ] : resolveMessageFormat(re, de, Ee, ce, pe, fe), Ne = Ve, He = de;
  if (!be && !(isString$1(Ne) || isMessageAST(Ne) || isMessageFunction(Ne)) && Pe && (Ne = Se, He = Ne), !be && (!(isString$1(Ne) || isMessageAST(Ne) || isMessageFunction(Ne)) || !isString$1(Ae)))
    return le ? NOT_REOSLVED : de;
  let Ue = !1;
  const Ze = () => {
    Ue = !0;
  }, Fe = isMessageFunction(Ne) ? Ne : compileMessageFormat(re, de, Ae, Ne, He, Ze);
  if (Ue)
    return Ne;
  const Ke = getMessageContextOptions(re, Ae, Oe, me), tt = createMessageContext(Ke), Re = evaluateMessage(re, Fe, tt), Ce = ie ? ie(Re, de) : Re;
  if (__INTLIFY_PROD_DEVTOOLS__) {
    const _e = {
      timestamp: Date.now(),
      key: isString$1(de) ? de : isMessageFunction(Ne) ? Ne.key : "",
      locale: Ae || (isMessageFunction(Ne) ? Ne.locale : ""),
      format: isString$1(Ne) ? Ne : isMessageFunction(Ne) ? Ne.source : "",
      message: Ce
    };
    _e.meta = assign$1({}, re.__meta, /* @__PURE__ */ getAdditionalMeta() || {}), translateDevTools(_e);
  }
  return Ce;
}
function escapeParams(re) {
  isArray$b(re.list) ? re.list = re.list.map((ne) => isString$1(ne) ? escapeHtml(ne) : ne) : isObject$5(re.named) && Object.keys(re.named).forEach((ne) => {
    isString$1(re.named[ne]) && (re.named[ne] = escapeHtml(re.named[ne]));
  });
}
function resolveMessageFormat(re, ne, ae, ie, le, se) {
  const { messages: ce, onWarn: ue, messageResolver: de, localeFallbacker: me } = re, fe = me(re, ie, ae);
  let pe = {}, ge, be = null;
  const Se = "translate";
  for (let Pe = 0; Pe < fe.length && (ge = fe[Pe], pe = ce[ge] || {}, (be = de(pe, ne)) === null && (be = pe[ne]), !(isString$1(be) || isMessageAST(be) || isMessageFunction(be))); Pe++) {
    const Ee = handleMissing(
      re,
      // eslint-disable-line @typescript-eslint/no-explicit-any
      ne,
      ge,
      se,
      Se
    );
    Ee !== ne && (be = Ee);
  }
  return [be, ge, pe];
}
function compileMessageFormat(re, ne, ae, ie, le, se) {
  const { messageCompiler: ce, warnHtmlMessage: ue } = re;
  if (isMessageFunction(ie)) {
    const me = ie;
    return me.locale = me.locale || ae, me.key = me.key || ne, me;
  }
  if (ce == null) {
    const me = () => ie;
    return me.locale = ae, me.key = ne, me;
  }
  const de = ce(ie, getCompileContext(re, ae, le, ie, ue, se));
  return de.locale = ae, de.key = ne, de.source = ie, de;
}
function evaluateMessage(re, ne, ae) {
  return ne(ae);
}
function parseTranslateArgs(...re) {
  const [ne, ae, ie] = re, le = {};
  if (!isString$1(ne) && !isNumber(ne) && !isMessageFunction(ne) && !isMessageAST(ne))
    throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);
  const se = isNumber(ne) ? String(ne) : (isMessageFunction(ne), ne);
  return isNumber(ae) ? le.plural = ae : isString$1(ae) ? le.default = ae : isPlainObject(ae) && !isEmptyObject(ae) ? le.named = ae : isArray$b(ae) && (le.list = ae), isNumber(ie) ? le.plural = ie : isString$1(ie) ? le.default = ie : isPlainObject(ie) && assign$1(le, ie), [se, le];
}
function getCompileContext(re, ne, ae, ie, le, se) {
  return {
    locale: ne,
    key: ae,
    warnHtmlMessage: le,
    onError: (ce) => {
      throw se && se(ce), ce;
    },
    onCacheKey: (ce) => generateFormatCacheKey(ne, ae, ce)
  };
}
function getMessageContextOptions(re, ne, ae, ie) {
  const { modifiers: le, pluralRules: se, messageResolver: ce, fallbackLocale: ue, fallbackWarn: de, missingWarn: me, fallbackContext: fe } = re, ge = {
    locale: ne,
    modifiers: le,
    pluralRules: se,
    messages: (be) => {
      let Se = ce(ae, be);
      if (Se == null && fe) {
        const [, , Pe] = resolveMessageFormat(fe, be, ne, ue, de, me);
        Se = ce(Pe, be);
      }
      if (isString$1(Se) || isMessageAST(Se)) {
        let Pe = !1;
        const Ve = compileMessageFormat(re, be, ne, Se, be, () => {
          Pe = !0;
        });
        return Pe ? NOOP_MESSAGE_FUNCTION : Ve;
      } else return isMessageFunction(Se) ? Se : NOOP_MESSAGE_FUNCTION;
    }
  };
  return re.processor && (ge.processor = re.processor), ie.list && (ge.list = ie.list), ie.named && (ge.named = ie.named), isNumber(ie.plural) && (ge.pluralIndex = ie.plural), ge;
}
function datetime(re, ...ne) {
  const { datetimeFormats: ae, unresolving: ie, fallbackLocale: le, onWarn: se, localeFallbacker: ce } = re, { __datetimeFormatters: ue } = re, [de, me, fe, pe] = parseDateTimeArgs(...ne), ge = isBoolean(fe.missingWarn) ? fe.missingWarn : re.missingWarn;
  isBoolean(fe.fallbackWarn) ? fe.fallbackWarn : re.fallbackWarn;
  const be = !!fe.part, Se = getLocale(re, fe), Pe = ce(
    re,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    le,
    Se
  );
  if (!isString$1(de) || de === "")
    return new Intl.DateTimeFormat(Se, pe).format(me);
  let Ee = {}, Ve, Ae = null;
  const Oe = "datetime format";
  for (let Ue = 0; Ue < Pe.length && (Ve = Pe[Ue], Ee = ae[Ve] || {}, Ae = Ee[de], !isPlainObject(Ae)); Ue++)
    handleMissing(re, de, Ve, ge, Oe);
  if (!isPlainObject(Ae) || !isString$1(Ve))
    return ie ? NOT_REOSLVED : de;
  let Ne = `${Ve}__${de}`;
  isEmptyObject(pe) || (Ne = `${Ne}__${JSON.stringify(pe)}`);
  let He = ue.get(Ne);
  return He || (He = new Intl.DateTimeFormat(Ve, assign$1({}, Ae, pe)), ue.set(Ne, He)), be ? He.formatToParts(me) : He.format(me);
}
const DATETIME_FORMAT_OPTIONS_KEYS = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function parseDateTimeArgs(...re) {
  const [ne, ae, ie, le] = re, se = {};
  let ce = {}, ue;
  if (isString$1(ne)) {
    const de = ne.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!de)
      throw createCoreError(CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT);
    const me = de[3] ? de[3].trim().startsWith("T") ? `${de[1].trim()}${de[3].trim()}` : `${de[1].trim()}T${de[3].trim()}` : de[1].trim();
    ue = new Date(me);
    try {
      ue.toISOString();
    } catch {
      throw createCoreError(CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (isDate(ne)) {
    if (isNaN(ne.getTime()))
      throw createCoreError(CoreErrorCodes.INVALID_DATE_ARGUMENT);
    ue = ne;
  } else if (isNumber(ne))
    ue = ne;
  else
    throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);
  return isString$1(ae) ? se.key = ae : isPlainObject(ae) && Object.keys(ae).forEach((de) => {
    DATETIME_FORMAT_OPTIONS_KEYS.includes(de) ? ce[de] = ae[de] : se[de] = ae[de];
  }), isString$1(ie) ? se.locale = ie : isPlainObject(ie) && (ce = ie), isPlainObject(le) && (ce = le), [se.key || "", ue, se, ce];
}
function clearDateTimeFormat(re, ne, ae) {
  const ie = re;
  for (const le in ae) {
    const se = `${ne}__${le}`;
    ie.__datetimeFormatters.has(se) && ie.__datetimeFormatters.delete(se);
  }
}
function number(re, ...ne) {
  const { numberFormats: ae, unresolving: ie, fallbackLocale: le, onWarn: se, localeFallbacker: ce } = re, { __numberFormatters: ue } = re, [de, me, fe, pe] = parseNumberArgs(...ne), ge = isBoolean(fe.missingWarn) ? fe.missingWarn : re.missingWarn;
  isBoolean(fe.fallbackWarn) ? fe.fallbackWarn : re.fallbackWarn;
  const be = !!fe.part, Se = getLocale(re, fe), Pe = ce(
    re,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    le,
    Se
  );
  if (!isString$1(de) || de === "")
    return new Intl.NumberFormat(Se, pe).format(me);
  let Ee = {}, Ve, Ae = null;
  const Oe = "number format";
  for (let Ue = 0; Ue < Pe.length && (Ve = Pe[Ue], Ee = ae[Ve] || {}, Ae = Ee[de], !isPlainObject(Ae)); Ue++)
    handleMissing(re, de, Ve, ge, Oe);
  if (!isPlainObject(Ae) || !isString$1(Ve))
    return ie ? NOT_REOSLVED : de;
  let Ne = `${Ve}__${de}`;
  isEmptyObject(pe) || (Ne = `${Ne}__${JSON.stringify(pe)}`);
  let He = ue.get(Ne);
  return He || (He = new Intl.NumberFormat(Ve, assign$1({}, Ae, pe)), ue.set(Ne, He)), be ? He.formatToParts(me) : He.format(me);
}
const NUMBER_FORMAT_OPTIONS_KEYS = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function parseNumberArgs(...re) {
  const [ne, ae, ie, le] = re, se = {};
  let ce = {};
  if (!isNumber(ne))
    throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);
  const ue = ne;
  return isString$1(ae) ? se.key = ae : isPlainObject(ae) && Object.keys(ae).forEach((de) => {
    NUMBER_FORMAT_OPTIONS_KEYS.includes(de) ? ce[de] = ae[de] : se[de] = ae[de];
  }), isString$1(ie) ? se.locale = ie : isPlainObject(ie) && (ce = ie), isPlainObject(le) && (ce = le), [se.key || "", ue, se, ce];
}
function clearNumberFormat(re, ne, ae) {
  const ie = re;
  for (const le in ae) {
    const se = `${ne}__${le}`;
    ie.__numberFormatters.has(se) && ie.__numberFormatters.delete(se);
  }
}
initFeatureFlags$1();
var define_process_env_default = { npm_package_exports___require: "./dist/cs-design-system.umd.js", npm_package_devDependencies_vitest: "~2.1.4", npm_package_devDependencies_eslint_import_resolver_alias: "~1.1.2", npm_config_version_commit_hooks: "true", npm_config_user_agent: "yarn/1.22.19 npm/? node/v18.16.0 linux x64", NODE_VERSION: "18.16.0", npm_package_dependencies_vue: "~3.5.13", npm_config_bin_links: "true", npm_config_wrap_output: "", HOSTNAME: "14649218c17b", YARN_VERSION: "1.22.19", npm_node_execpath: "/usr/local/bin/node", npm_package_devDependencies_vite: "~5.4.9", npm_config_init_version: "1.0.0", npm_package_packageManager: "yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e", npm_package_files_0: "dist", HOME: "/root", npm_package_devDependencies_sass: "1.77.6", npm_package_dependencies_vuex: "4.1.0", npm_package_engines_node: ">=18.16.0", npm_config_init_license: "MIT", YARN_WRAP_OUTPUT: "false", npm_package_peerDependencies_vue: "~3.5.13", npm_package_dependencies__complispace_gainsight_px: "~2.1.0", npm_package_scripts_rebuild: "rm -rf dist && rm -rf node_modules && yarn install && yarn lint-staged && yarn build && yarn test:unit", npm_config_version_tag_prefix: "v", npm_config__complispace_registry: "https://registry.npmjs.org/", npm_package_keywords_0: "auth0", npm_package_devDependencies_husky: "~9.1.7", npm_package_keywords_1: "vue", npm_package_peerDependencies_vuex: "~4.1.0", npm_package_description: "Complispace SPA web application skeleton, including auth0 login process and UI components", npm_package_readmeFilename: "README.md", npm_package_lint_staged___vue_0: "eslint --fix", npm_package_keywords_2: "vuetify", npm_package_devDependencies_prettier: "~3.2.4", npm_package_devDependencies_mockdate: "~3.0.5", npm_package_lint_staged___js_0: "eslint --fix", npm_package_scripts_watch_rebuild: "rm -rf dist && rm -rf node_modules && yarn install && yarn lint-staged && yarn watch-build", npm_package_type: "module", npm_package_devDependencies_vite_plugin_node_polyfills: "~0.22.0", npm_package_module: "./dist/cs-design-system.es.js", npm_package_devDependencies__vitest_coverage_v8: "~2.1.4", npm_package_scripts_prepare: "husky", npm_package_scripts_lint: "eslint --ext .js,.vue src/", npm_config_registry: "https://registry.yarnpkg.com", npm_config_scope: "complispace", npm_package_devDependencies_happy_dom: "~15.11.2", npm_package_dependencies_vuetify: "~3.7.19", npm_package_devDependencies__vitejs_plugin_vue: "~5.1.4", npm_package_exports___import: "./dist/cs-design-system.es.js", npm_config_ignore_scripts: "", npm_config_version: "1.22.19", npm_package_dependencies_axios: "~1.7.7", PATH: "/tmp/yarn--1756864169391-0.6098667048828752:/var/lib/app/node_modules/.bin:/usr/local/share/.config/yarn/link/node_modules/.bin:/usr/local/libexec/lib/node_modules/npm/bin/node-gyp-bin:/usr/local/lib/node_modules/npm/bin/node-gyp-bin:/usr/local/bin/node_modules/npm/bin/node-gyp-bin:/tmp/yarn--1756864165216-0.09775249259687246:/var/lib/app/node_modules/.bin:/usr/local/share/.config/yarn/link/node_modules/.bin:/usr/local/libexec/lib/node_modules/npm/bin/node-gyp-bin:/usr/local/lib/node_modules/npm/bin/node-gyp-bin:/usr/local/bin/node_modules/npm/bin/node-gyp-bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin", NODE: "/usr/local/bin/node", npm_package_devDependencies__babel_eslint_parser: "~7.25.9", npm_package_dependencies_cross_env: "~7.0.3", npm_package_name: "@complispace/cs-design-system", npm_package_dependencies_jose: "~5.9.6", npm_package_devDependencies__vitest_ui: "~2.1.4", npm_package_scripts_build_scss_theme: "node --es-module-specifier-resolution=node ./src/theme/buildScss.mjs", npm_package_scripts_test_unit: "vitest run --dir src/tests/unit", npm_package_peerDependencies_vuetify: "~3.7.19", npm_package_devDependencies_eslint: "~8.57.1", npm_package_devDependencies__vue_test_utils: "~2.4.6", npm_lifecycle_script: "vite build", npm_package_browserslist_0: "> 1%", npm_package_exports___style_css: "./dist/style.css", npm_package_main: "./dist/cs-design-system.umd.js", npm_package_browserslist_1: "last 2 versions", npm_package_devDependencies__vue_eslint_config_prettier: "~9.0.0", npm_config_version_git_message: "v%s", npm_lifecycle_event: "build", npm_package_browserslist_2: "not dead", npm_package_version: "1.4.0", npm_config_argv: '{"remain":[],"cooked":["run","rebuild"],"original":["rebuild"]}', npm_package_engines_yarn: ">= 1.22.5", npm_package_devDependencies_lint_staged: "~15.2.0", npm_package_dependencies_vue_i18n: "9.9.0", npm_package_dependencies_buffer: "~6.0.3", npm_package_scripts_build: "vite build", npm_package_dependencies_lodash: "~4.17.21", npm_package_devDependencies_vite_plugin_vuetify: "~2.0.4", npm_package_devDependencies_sass_loader: "~10.2.0", npm_package_dependencies_vue_router: "4.2.5", npm_config_version_git_tag: "true", npm_config_version_git_sign: "", npm_package_license: "UNLICENSED", npm_config_strict_ssl: "true", npm_package_peerDependencies_vitest: "~2.1.4", npm_package_devDependencies_eslint_plugin_prettier: "~5.2.1", npm_config_complispace_registry: "https://registry.npmjs.org/", PWD: "/var/lib/app", npm_execpath: "/opt/yarn-v1.22.19/bin/yarn.js", npm_package_devDependencies_vue_eslint_parser: "~9.4.3", npm_package_peerDependencies_vue_i18n: "~9.9.0", npm_package_scripts_watch_build: "vite build --watch", npm_package_devDependencies_eslint_plugin_vue: "~9.31.0", npm_package_devDependencies__vue_eslint_config_standard: "~8.0.1", npm_package_dependencies__auth0_auth0_spa_js: "~2.1.3", npm_config_save_prefix: "^", npm_config_ignore_optional: "", npm_package_peerDependencies_vue_router: "~4.2.5", INIT_CWD: "/var/lib/app", npm_package_devDependencies_unplugin_vue_components: "~0.27.4", NODE_ENV: "production" };
const VERSION = "9.9.0";
function initFeatureFlags() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (getGlobalThis().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (getGlobalThis().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (getGlobalThis().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (getGlobalThis().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (getGlobalThis().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const code$1 = CoreWarnCodes.__EXTEND_POINT__, inc$1 = incrementer(code$1);
inc$1(), inc$1(), inc$1(), inc$1(), inc$1(), inc$1(), inc$1(), inc$1();
const code = CoreErrorCodes.__EXTEND_POINT__, inc = incrementer(code), I18nErrorCodes = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: code,
  // legacy module errors
  INVALID_ARGUMENT: inc(),
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: inc(),
  NOT_INSTALLED: inc(),
  NOT_AVAILABLE_IN_LEGACY_MODE: inc(),
  // directive module errors
  REQUIRED_VALUE: inc(),
  INVALID_VALUE: inc(),
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: inc(),
  NOT_INSTALLED_WITH_PROVIDE: inc(),
  // unexpected error
  UNEXPECTED_ERROR: inc(),
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: inc(),
  // bridge support vue 2.x only
  BRIDGE_SUPPORT_VUE_2_ONLY: inc(),
  // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
  MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: inc(),
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: inc(),
  // for enhancement
  __EXTEND_POINT__: inc()
  // 40
};
function createI18nError(re, ...ne) {
  return createCompileError(re, null, void 0);
}
const TranslateVNodeSymbol = /* @__PURE__ */ makeSymbol("__translateVNode"), DatetimePartsSymbol = /* @__PURE__ */ makeSymbol("__datetimeParts"), NumberPartsSymbol = /* @__PURE__ */ makeSymbol("__numberParts"), SetPluralRulesSymbol = makeSymbol("__setPluralRules"), InejctWithOptionSymbol = /* @__PURE__ */ makeSymbol("__injectWithOption"), DisposeSymbol = /* @__PURE__ */ makeSymbol("__dispose");
function handleFlatJson(re) {
  if (!isObject$5(re))
    return re;
  for (const ne in re)
    if (hasOwn(re, ne))
      if (!ne.includes("."))
        isObject$5(re[ne]) && handleFlatJson(re[ne]);
      else {
        const ae = ne.split("."), ie = ae.length - 1;
        let le = re, se = !1;
        for (let ce = 0; ce < ie; ce++) {
          if (ae[ce] in le || (le[ae[ce]] = {}), !isObject$5(le[ae[ce]])) {
            se = !0;
            break;
          }
          le = le[ae[ce]];
        }
        se || (le[ae[ie]] = re[ne], delete re[ne]), isObject$5(le[ae[ie]]) && handleFlatJson(le[ae[ie]]);
      }
  return re;
}
function getLocaleMessages(re, ne) {
  const { messages: ae, __i18n: ie, messageResolver: le, flatJson: se } = ne, ce = isPlainObject(ae) ? ae : isArray$b(ie) ? {} : { [re]: {} };
  if (isArray$b(ie) && ie.forEach((ue) => {
    if ("locale" in ue && "resource" in ue) {
      const { locale: de, resource: me } = ue;
      de ? (ce[de] = ce[de] || {}, deepCopy(me, ce[de])) : deepCopy(me, ce);
    } else
      isString$1(ue) && deepCopy(JSON.parse(ue), ce);
  }), le == null && se)
    for (const ue in ce)
      hasOwn(ce, ue) && handleFlatJson(ce[ue]);
  return ce;
}
function getComponentOptions(re) {
  return re.type;
}
function adjustI18nResources(re, ne, ae) {
  let ie = isObject$5(ne.messages) ? ne.messages : {};
  "__i18nGlobal" in ae && (ie = getLocaleMessages(re.locale.value, {
    messages: ie,
    __i18n: ae.__i18nGlobal
  }));
  const le = Object.keys(ie);
  le.length && le.forEach((se) => {
    re.mergeLocaleMessage(se, ie[se]);
  });
  {
    if (isObject$5(ne.datetimeFormats)) {
      const se = Object.keys(ne.datetimeFormats);
      se.length && se.forEach((ce) => {
        re.mergeDateTimeFormat(ce, ne.datetimeFormats[ce]);
      });
    }
    if (isObject$5(ne.numberFormats)) {
      const se = Object.keys(ne.numberFormats);
      se.length && se.forEach((ce) => {
        re.mergeNumberFormat(ce, ne.numberFormats[ce]);
      });
    }
  }
}
function createTextNode(re) {
  return createVNode(Text, null, re, 0);
}
const DEVTOOLS_META = "__INTLIFY_META__", NOOP_RETURN_ARRAY = () => [], NOOP_RETURN_FALSE = () => !1;
let composerID = 0;
function defineCoreMissingHandler(re) {
  return (ne, ae, ie, le) => re(ae, ie, getCurrentInstance$1() || void 0, le);
}
const getMetaInfo = /* @__NO_SIDE_EFFECTS__ */ () => {
  const re = getCurrentInstance$1();
  let ne = null;
  return re && (ne = getComponentOptions(re)[DEVTOOLS_META]) ? { [DEVTOOLS_META]: ne } : null;
};
function createComposer(re = {}, ne) {
  const { __root: ae, __injectWithOption: ie } = re, le = ae === void 0, se = re.flatJson, ce = inBrowser ? ref$1 : shallowRef;
  let ue = isBoolean(re.inheritLocale) ? re.inheritLocale : !0;
  const de = ce(
    // prettier-ignore
    ae && ue ? ae.locale.value : isString$1(re.locale) ? re.locale : DEFAULT_LOCALE
  ), me = ce(
    // prettier-ignore
    ae && ue ? ae.fallbackLocale.value : isString$1(re.fallbackLocale) || isArray$b(re.fallbackLocale) || isPlainObject(re.fallbackLocale) || re.fallbackLocale === !1 ? re.fallbackLocale : de.value
  ), fe = ce(getLocaleMessages(de.value, re)), pe = ce(isPlainObject(re.datetimeFormats) ? re.datetimeFormats : { [de.value]: {} }), ge = ce(isPlainObject(re.numberFormats) ? re.numberFormats : { [de.value]: {} });
  let be = ae ? ae.missingWarn : isBoolean(re.missingWarn) || isRegExp(re.missingWarn) ? re.missingWarn : !0, Se = ae ? ae.fallbackWarn : isBoolean(re.fallbackWarn) || isRegExp(re.fallbackWarn) ? re.fallbackWarn : !0, Pe = ae ? ae.fallbackRoot : isBoolean(re.fallbackRoot) ? re.fallbackRoot : !0, Ee = !!re.fallbackFormat, Ve = isFunction$3(re.missing) ? re.missing : null, Ae = isFunction$3(re.missing) ? defineCoreMissingHandler(re.missing) : null, Oe = isFunction$3(re.postTranslation) ? re.postTranslation : null, Ne = ae ? ae.warnHtmlMessage : isBoolean(re.warnHtmlMessage) ? re.warnHtmlMessage : !0, He = !!re.escapeParameter;
  const Ue = ae ? ae.modifiers : isPlainObject(re.modifiers) ? re.modifiers : {};
  let Ze = re.pluralRules || ae && ae.pluralRules, Fe;
  Fe = (() => {
    le && setFallbackContext(null);
    const ut = {
      version: VERSION,
      locale: de.value,
      fallbackLocale: me.value,
      messages: fe.value,
      modifiers: Ue,
      pluralRules: Ze,
      missing: Ae === null ? void 0 : Ae,
      missingWarn: be,
      fallbackWarn: Se,
      fallbackFormat: Ee,
      unresolving: !0,
      postTranslation: Oe === null ? void 0 : Oe,
      warnHtmlMessage: Ne,
      escapeParameter: He,
      messageResolver: re.messageResolver,
      messageCompiler: re.messageCompiler,
      __meta: { framework: "vue" }
    };
    ut.datetimeFormats = pe.value, ut.numberFormats = ge.value, ut.__datetimeFormatters = isPlainObject(Fe) ? Fe.__datetimeFormatters : void 0, ut.__numberFormatters = isPlainObject(Fe) ? Fe.__numberFormatters : void 0;
    const ht = createCoreContext(ut);
    return le && setFallbackContext(ht), ht;
  })(), updateFallbackLocale(Fe, de.value, me.value);
  function tt() {
    return [
      de.value,
      me.value,
      fe.value,
      pe.value,
      ge.value
    ];
  }
  const Re = computed({
    get: () => de.value,
    set: (ut) => {
      de.value = ut, Fe.locale = de.value;
    }
  }), Ce = computed({
    get: () => me.value,
    set: (ut) => {
      me.value = ut, Fe.fallbackLocale = me.value, updateFallbackLocale(Fe, de.value, ut);
    }
  }), _e = computed(() => fe.value), he = /* @__PURE__ */ computed(() => pe.value), ve = /* @__PURE__ */ computed(() => ge.value);
  function xe() {
    return isFunction$3(Oe) ? Oe : null;
  }
  function $e(ut) {
    Oe = ut, Fe.postTranslation = ut;
  }
  function Te() {
    return Ve;
  }
  function Ie(ut) {
    ut !== null && (Ae = defineCoreMissingHandler(ut)), Ve = ut, Fe.missing = Ae;
  }
  const we = (ut, ht, vt, xt, Bt, Je) => {
    tt();
    let Me;
    try {
      define_process_env_default.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, le || (Fe.fallbackContext = ae ? getFallbackContext() : void 0), Me = ut(Fe);
    } finally {
      __INTLIFY_PROD_DEVTOOLS__, le || (Fe.fallbackContext = void 0);
    }
    if (vt !== "translate exists" && // for not `te` (e.g `t`)
    isNumber(Me) && Me === NOT_REOSLVED || vt === "translate exists" && !Me) {
      const [Le, Qe] = ht();
      return ae && Pe ? xt(ae) : Bt(Le);
    } else {
      if (Je(Me))
        return Me;
      throw createI18nError(I18nErrorCodes.UNEXPECTED_RETURN_TYPE);
    }
  };
  function ke(...ut) {
    return we((ht) => Reflect.apply(translate, null, [ht, ...ut]), () => parseTranslateArgs(...ut), "translate", (ht) => Reflect.apply(ht.t, ht, [...ut]), (ht) => ht, (ht) => isString$1(ht));
  }
  function ye(...ut) {
    const [ht, vt, xt] = ut;
    if (xt && !isObject$5(xt))
      throw createI18nError(I18nErrorCodes.INVALID_ARGUMENT);
    return ke(ht, vt, assign$1({ resolvedMessage: !0 }, xt || {}));
  }
  function Be(...ut) {
    return we((ht) => Reflect.apply(datetime, null, [ht, ...ut]), () => parseDateTimeArgs(...ut), "datetime format", (ht) => Reflect.apply(ht.d, ht, [...ut]), () => MISSING_RESOLVE_VALUE, (ht) => isString$1(ht));
  }
  function Xe(...ut) {
    return we((ht) => Reflect.apply(number, null, [ht, ...ut]), () => parseNumberArgs(...ut), "number format", (ht) => Reflect.apply(ht.n, ht, [...ut]), () => MISSING_RESOLVE_VALUE, (ht) => isString$1(ht));
  }
  function et(ut) {
    return ut.map((ht) => isString$1(ht) || isNumber(ht) || isBoolean(ht) ? createTextNode(String(ht)) : ht);
  }
  const De = {
    normalize: et,
    interpolate: (ut) => ut,
    type: "vnode"
  };
  function je(...ut) {
    return we(
      (ht) => {
        let vt;
        const xt = ht;
        try {
          xt.processor = De, vt = Reflect.apply(translate, null, [xt, ...ut]);
        } finally {
          xt.processor = null;
        }
        return vt;
      },
      () => parseTranslateArgs(...ut),
      "translate",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (ht) => ht[TranslateVNodeSymbol](...ut),
      (ht) => [createTextNode(ht)],
      (ht) => isArray$b(ht)
    );
  }
  function rt(...ut) {
    return we(
      (ht) => Reflect.apply(number, null, [ht, ...ut]),
      () => parseNumberArgs(...ut),
      "number format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (ht) => ht[NumberPartsSymbol](...ut),
      NOOP_RETURN_ARRAY,
      (ht) => isString$1(ht) || isArray$b(ht)
    );
  }
  function at(...ut) {
    return we(
      (ht) => Reflect.apply(datetime, null, [ht, ...ut]),
      () => parseDateTimeArgs(...ut),
      "datetime format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (ht) => ht[DatetimePartsSymbol](...ut),
      NOOP_RETURN_ARRAY,
      (ht) => isString$1(ht) || isArray$b(ht)
    );
  }
  function qe(ut) {
    Ze = ut, Fe.pluralRules = Ze;
  }
  function We(ut, ht) {
    return we(() => {
      if (!ut)
        return !1;
      const vt = isString$1(ht) ? ht : de.value, xt = nt(vt), Bt = Fe.messageResolver(xt, ut);
      return isMessageAST(Bt) || isMessageFunction(Bt) || isString$1(Bt);
    }, () => [ut], "translate exists", (vt) => Reflect.apply(vt.te, vt, [ut, ht]), NOOP_RETURN_FALSE, (vt) => isBoolean(vt));
  }
  function ze(ut) {
    let ht = null;
    const vt = fallbackWithLocaleChain(Fe, me.value, de.value);
    for (let xt = 0; xt < vt.length; xt++) {
      const Bt = fe.value[vt[xt]] || {}, Je = Fe.messageResolver(Bt, ut);
      if (Je != null) {
        ht = Je;
        break;
      }
    }
    return ht;
  }
  function Ge(ut) {
    const ht = ze(ut);
    return ht ?? (ae ? ae.tm(ut) || {} : {});
  }
  function nt(ut) {
    return fe.value[ut] || {};
  }
  function ot(ut, ht) {
    if (se) {
      const vt = { [ut]: ht };
      for (const xt in vt)
        hasOwn(vt, xt) && handleFlatJson(vt[xt]);
      ht = vt[ut];
    }
    fe.value[ut] = ht, Fe.messages = fe.value;
  }
  function lt(ut, ht) {
    fe.value[ut] = fe.value[ut] || {};
    const vt = { [ut]: ht };
    for (const xt in vt)
      hasOwn(vt, xt) && handleFlatJson(vt[xt]);
    ht = vt[ut], deepCopy(ht, fe.value[ut]), Fe.messages = fe.value;
  }
  function mt(ut) {
    return pe.value[ut] || {};
  }
  function dt(ut, ht) {
    pe.value[ut] = ht, Fe.datetimeFormats = pe.value, clearDateTimeFormat(Fe, ut, ht);
  }
  function gt(ut, ht) {
    pe.value[ut] = assign$1(pe.value[ut] || {}, ht), Fe.datetimeFormats = pe.value, clearDateTimeFormat(Fe, ut, ht);
  }
  function bt(ut) {
    return ge.value[ut] || {};
  }
  function At(ut, ht) {
    ge.value[ut] = ht, Fe.numberFormats = ge.value, clearNumberFormat(Fe, ut, ht);
  }
  function wt(ut, ht) {
    ge.value[ut] = assign$1(ge.value[ut] || {}, ht), Fe.numberFormats = ge.value, clearNumberFormat(Fe, ut, ht);
  }
  composerID++, ae && inBrowser && (watch(ae.locale, (ut) => {
    ue && (de.value = ut, Fe.locale = ut, updateFallbackLocale(Fe, de.value, me.value));
  }), watch(ae.fallbackLocale, (ut) => {
    ue && (me.value = ut, Fe.fallbackLocale = ut, updateFallbackLocale(Fe, de.value, me.value));
  }));
  const pt = {
    id: composerID,
    locale: Re,
    fallbackLocale: Ce,
    get inheritLocale() {
      return ue;
    },
    set inheritLocale(ut) {
      ue = ut, ut && ae && (de.value = ae.locale.value, me.value = ae.fallbackLocale.value, updateFallbackLocale(Fe, de.value, me.value));
    },
    get availableLocales() {
      return Object.keys(fe.value).sort();
    },
    messages: _e,
    get modifiers() {
      return Ue;
    },
    get pluralRules() {
      return Ze || {};
    },
    get isGlobal() {
      return le;
    },
    get missingWarn() {
      return be;
    },
    set missingWarn(ut) {
      be = ut, Fe.missingWarn = be;
    },
    get fallbackWarn() {
      return Se;
    },
    set fallbackWarn(ut) {
      Se = ut, Fe.fallbackWarn = Se;
    },
    get fallbackRoot() {
      return Pe;
    },
    set fallbackRoot(ut) {
      Pe = ut;
    },
    get fallbackFormat() {
      return Ee;
    },
    set fallbackFormat(ut) {
      Ee = ut, Fe.fallbackFormat = Ee;
    },
    get warnHtmlMessage() {
      return Ne;
    },
    set warnHtmlMessage(ut) {
      Ne = ut, Fe.warnHtmlMessage = ut;
    },
    get escapeParameter() {
      return He;
    },
    set escapeParameter(ut) {
      He = ut, Fe.escapeParameter = ut;
    },
    t: ke,
    getLocaleMessage: nt,
    setLocaleMessage: ot,
    mergeLocaleMessage: lt,
    getPostTranslationHandler: xe,
    setPostTranslationHandler: $e,
    getMissingHandler: Te,
    setMissingHandler: Ie,
    [SetPluralRulesSymbol]: qe
  };
  return pt.datetimeFormats = he, pt.numberFormats = ve, pt.rt = ye, pt.te = We, pt.tm = Ge, pt.d = Be, pt.n = Xe, pt.getDateTimeFormat = mt, pt.setDateTimeFormat = dt, pt.mergeDateTimeFormat = gt, pt.getNumberFormat = bt, pt.setNumberFormat = At, pt.mergeNumberFormat = wt, pt[InejctWithOptionSymbol] = ie, pt[TranslateVNodeSymbol] = je, pt[DatetimePartsSymbol] = at, pt[NumberPartsSymbol] = rt, pt;
}
function convertComposerOptions(re) {
  const ne = isString$1(re.locale) ? re.locale : DEFAULT_LOCALE, ae = isString$1(re.fallbackLocale) || isArray$b(re.fallbackLocale) || isPlainObject(re.fallbackLocale) || re.fallbackLocale === !1 ? re.fallbackLocale : ne, ie = isFunction$3(re.missing) ? re.missing : void 0, le = isBoolean(re.silentTranslationWarn) || isRegExp(re.silentTranslationWarn) ? !re.silentTranslationWarn : !0, se = isBoolean(re.silentFallbackWarn) || isRegExp(re.silentFallbackWarn) ? !re.silentFallbackWarn : !0, ce = isBoolean(re.fallbackRoot) ? re.fallbackRoot : !0, ue = !!re.formatFallbackMessages, de = isPlainObject(re.modifiers) ? re.modifiers : {}, me = re.pluralizationRules, fe = isFunction$3(re.postTranslation) ? re.postTranslation : void 0, pe = isString$1(re.warnHtmlInMessage) ? re.warnHtmlInMessage !== "off" : !0, ge = !!re.escapeParameterHtml, be = isBoolean(re.sync) ? re.sync : !0;
  let Se = re.messages;
  if (isPlainObject(re.sharedMessages)) {
    const He = re.sharedMessages;
    Se = Object.keys(He).reduce((Ze, Fe) => {
      const Ke = Ze[Fe] || (Ze[Fe] = {});
      return assign$1(Ke, He[Fe]), Ze;
    }, Se || {});
  }
  const { __i18n: Pe, __root: Ee, __injectWithOption: Ve } = re, Ae = re.datetimeFormats, Oe = re.numberFormats, Ne = re.flatJson;
  return {
    locale: ne,
    fallbackLocale: ae,
    messages: Se,
    flatJson: Ne,
    datetimeFormats: Ae,
    numberFormats: Oe,
    missing: ie,
    missingWarn: le,
    fallbackWarn: se,
    fallbackRoot: ce,
    fallbackFormat: ue,
    modifiers: de,
    pluralRules: me,
    postTranslation: fe,
    warnHtmlMessage: pe,
    escapeParameter: ge,
    messageResolver: re.messageResolver,
    inheritLocale: be,
    __i18n: Pe,
    __root: Ee,
    __injectWithOption: Ve
  };
}
function createVueI18n(re = {}, ne) {
  {
    const ae = createComposer(convertComposerOptions(re)), { __extender: ie } = re, le = {
      // id
      id: ae.id,
      // locale
      get locale() {
        return ae.locale.value;
      },
      set locale(se) {
        ae.locale.value = se;
      },
      // fallbackLocale
      get fallbackLocale() {
        return ae.fallbackLocale.value;
      },
      set fallbackLocale(se) {
        ae.fallbackLocale.value = se;
      },
      // messages
      get messages() {
        return ae.messages.value;
      },
      // datetimeFormats
      get datetimeFormats() {
        return ae.datetimeFormats.value;
      },
      // numberFormats
      get numberFormats() {
        return ae.numberFormats.value;
      },
      // availableLocales
      get availableLocales() {
        return ae.availableLocales;
      },
      // formatter
      get formatter() {
        return {
          interpolate() {
            return [];
          }
        };
      },
      set formatter(se) {
      },
      // missing
      get missing() {
        return ae.getMissingHandler();
      },
      set missing(se) {
        ae.setMissingHandler(se);
      },
      // silentTranslationWarn
      get silentTranslationWarn() {
        return isBoolean(ae.missingWarn) ? !ae.missingWarn : ae.missingWarn;
      },
      set silentTranslationWarn(se) {
        ae.missingWarn = isBoolean(se) ? !se : se;
      },
      // silentFallbackWarn
      get silentFallbackWarn() {
        return isBoolean(ae.fallbackWarn) ? !ae.fallbackWarn : ae.fallbackWarn;
      },
      set silentFallbackWarn(se) {
        ae.fallbackWarn = isBoolean(se) ? !se : se;
      },
      // modifiers
      get modifiers() {
        return ae.modifiers;
      },
      // formatFallbackMessages
      get formatFallbackMessages() {
        return ae.fallbackFormat;
      },
      set formatFallbackMessages(se) {
        ae.fallbackFormat = se;
      },
      // postTranslation
      get postTranslation() {
        return ae.getPostTranslationHandler();
      },
      set postTranslation(se) {
        ae.setPostTranslationHandler(se);
      },
      // sync
      get sync() {
        return ae.inheritLocale;
      },
      set sync(se) {
        ae.inheritLocale = se;
      },
      // warnInHtmlMessage
      get warnHtmlInMessage() {
        return ae.warnHtmlMessage ? "warn" : "off";
      },
      set warnHtmlInMessage(se) {
        ae.warnHtmlMessage = se !== "off";
      },
      // escapeParameterHtml
      get escapeParameterHtml() {
        return ae.escapeParameter;
      },
      set escapeParameterHtml(se) {
        ae.escapeParameter = se;
      },
      // preserveDirectiveContent
      get preserveDirectiveContent() {
        return !0;
      },
      set preserveDirectiveContent(se) {
      },
      // pluralizationRules
      get pluralizationRules() {
        return ae.pluralRules || {};
      },
      // for internal
      __composer: ae,
      // t
      t(...se) {
        const [ce, ue, de] = se, me = {};
        let fe = null, pe = null;
        if (!isString$1(ce))
          throw createI18nError(I18nErrorCodes.INVALID_ARGUMENT);
        const ge = ce;
        return isString$1(ue) ? me.locale = ue : isArray$b(ue) ? fe = ue : isPlainObject(ue) && (pe = ue), isArray$b(de) ? fe = de : isPlainObject(de) && (pe = de), Reflect.apply(ae.t, ae, [
          ge,
          fe || pe || {},
          me
        ]);
      },
      rt(...se) {
        return Reflect.apply(ae.rt, ae, [...se]);
      },
      // tc
      tc(...se) {
        const [ce, ue, de] = se, me = { plural: 1 };
        let fe = null, pe = null;
        if (!isString$1(ce))
          throw createI18nError(I18nErrorCodes.INVALID_ARGUMENT);
        const ge = ce;
        return isString$1(ue) ? me.locale = ue : isNumber(ue) ? me.plural = ue : isArray$b(ue) ? fe = ue : isPlainObject(ue) && (pe = ue), isString$1(de) ? me.locale = de : isArray$b(de) ? fe = de : isPlainObject(de) && (pe = de), Reflect.apply(ae.t, ae, [
          ge,
          fe || pe || {},
          me
        ]);
      },
      // te
      te(se, ce) {
        return ae.te(se, ce);
      },
      // tm
      tm(se) {
        return ae.tm(se);
      },
      // getLocaleMessage
      getLocaleMessage(se) {
        return ae.getLocaleMessage(se);
      },
      // setLocaleMessage
      setLocaleMessage(se, ce) {
        ae.setLocaleMessage(se, ce);
      },
      // mergeLocaleMessage
      mergeLocaleMessage(se, ce) {
        ae.mergeLocaleMessage(se, ce);
      },
      // d
      d(...se) {
        return Reflect.apply(ae.d, ae, [...se]);
      },
      // getDateTimeFormat
      getDateTimeFormat(se) {
        return ae.getDateTimeFormat(se);
      },
      // setDateTimeFormat
      setDateTimeFormat(se, ce) {
        ae.setDateTimeFormat(se, ce);
      },
      // mergeDateTimeFormat
      mergeDateTimeFormat(se, ce) {
        ae.mergeDateTimeFormat(se, ce);
      },
      // n
      n(...se) {
        return Reflect.apply(ae.n, ae, [...se]);
      },
      // getNumberFormat
      getNumberFormat(se) {
        return ae.getNumberFormat(se);
      },
      // setNumberFormat
      setNumberFormat(se, ce) {
        ae.setNumberFormat(se, ce);
      },
      // mergeNumberFormat
      mergeNumberFormat(se, ce) {
        ae.mergeNumberFormat(se, ce);
      },
      // getChoiceIndex
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      getChoiceIndex(se, ce) {
        return -1;
      }
    };
    return le.__extender = ie, le;
  }
}
const baseFormatProps = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (re) => re === "parent" || re === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function getInterpolateArg({ slots: re }, ne) {
  return ne.length === 1 && ne[0] === "default" ? (re.default ? re.default() : []).reduce((ie, le) => [
    ...ie,
    // prettier-ignore
    ...le.type === Fragment ? le.children : [le]
  ], []) : ne.reduce((ae, ie) => {
    const le = re[ie];
    return le && (ae[ie] = le()), ae;
  }, {});
}
function getFragmentableTag(re) {
  return Fragment;
}
const TranslationImpl = /* @__PURE__ */ defineComponent$1({
  /* eslint-disable */
  name: "i18n-t",
  props: assign$1({
    keypath: {
      type: String,
      required: !0
    },
    plural: {
      type: [Number, String],
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      validator: (re) => isNumber(re) || !isNaN(re)
    }
  }, baseFormatProps),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(re, ne) {
    const { slots: ae, attrs: ie } = ne, le = re.i18n || useI18n({
      useScope: re.scope,
      __useComponent: !0
    });
    return () => {
      const se = Object.keys(ae).filter((pe) => pe !== "_"), ce = {};
      re.locale && (ce.locale = re.locale), re.plural !== void 0 && (ce.plural = isString$1(re.plural) ? +re.plural : re.plural);
      const ue = getInterpolateArg(ne, se), de = le[TranslateVNodeSymbol](re.keypath, ue, ce), me = assign$1({}, ie), fe = isString$1(re.tag) || isObject$5(re.tag) ? re.tag : getFragmentableTag();
      return h$1(fe, me, de);
    };
  }
}), Translation = TranslationImpl;
function isVNode(re) {
  return isArray$b(re) && !isString$1(re[0]);
}
function renderFormatter(re, ne, ae, ie) {
  const { slots: le, attrs: se } = ne;
  return () => {
    const ce = { part: !0 };
    let ue = {};
    re.locale && (ce.locale = re.locale), isString$1(re.format) ? ce.key = re.format : isObject$5(re.format) && (isString$1(re.format.key) && (ce.key = re.format.key), ue = Object.keys(re.format).reduce((ge, be) => ae.includes(be) ? assign$1({}, ge, { [be]: re.format[be] }) : ge, {}));
    const de = ie(re.value, ce, ue);
    let me = [ce.key];
    isArray$b(de) ? me = de.map((ge, be) => {
      const Se = le[ge.type], Pe = Se ? Se({ [ge.type]: ge.value, index: be, parts: de }) : [ge.value];
      return isVNode(Pe) && (Pe[0].key = `${ge.type}-${be}`), Pe;
    }) : isString$1(de) && (me = [de]);
    const fe = assign$1({}, se), pe = isString$1(re.tag) || isObject$5(re.tag) ? re.tag : getFragmentableTag();
    return h$1(pe, fe, me);
  };
}
const NumberFormatImpl = /* @__PURE__ */ defineComponent$1({
  /* eslint-disable */
  name: "i18n-n",
  props: assign$1({
    value: {
      type: Number,
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, baseFormatProps),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(re, ne) {
    const ae = re.i18n || useI18n({
      useScope: "parent",
      __useComponent: !0
    });
    return renderFormatter(re, ne, NUMBER_FORMAT_OPTIONS_KEYS, (...ie) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ae[NumberPartsSymbol](...ie)
    ));
  }
}), NumberFormat = NumberFormatImpl, DatetimeFormatImpl = /* @__PURE__ */ defineComponent$1({
  /* eslint-disable */
  name: "i18n-d",
  props: assign$1({
    value: {
      type: [Number, Date],
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, baseFormatProps),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(re, ne) {
    const ae = re.i18n || useI18n({
      useScope: "parent",
      __useComponent: !0
    });
    return renderFormatter(re, ne, DATETIME_FORMAT_OPTIONS_KEYS, (...ie) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ae[DatetimePartsSymbol](...ie)
    ));
  }
}), DatetimeFormat = DatetimeFormatImpl;
function getComposer$2(re, ne) {
  const ae = re;
  if (re.mode === "composition")
    return ae.__getInstance(ne) || re.global;
  {
    const ie = ae.__getInstance(ne);
    return ie != null ? ie.__composer : re.global.__composer;
  }
}
function vTDirective(re) {
  const ne = (ce) => {
    const { instance: ue, modifiers: de, value: me } = ce;
    if (!ue || !ue.$)
      throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
    const fe = getComposer$2(re, ue.$), pe = parseValue(me);
    return [
      Reflect.apply(fe.t, fe, [...makeParams(pe)]),
      fe
    ];
  };
  return {
    created: (ce, ue) => {
      const [de, me] = ne(ue);
      inBrowser && re.global === me && (ce.__i18nWatcher = watch(me.locale, () => {
        ue.instance && ue.instance.$forceUpdate();
      })), ce.__composer = me, ce.textContent = de;
    },
    unmounted: (ce) => {
      inBrowser && ce.__i18nWatcher && (ce.__i18nWatcher(), ce.__i18nWatcher = void 0, delete ce.__i18nWatcher), ce.__composer && (ce.__composer = void 0, delete ce.__composer);
    },
    beforeUpdate: (ce, { value: ue }) => {
      if (ce.__composer) {
        const de = ce.__composer, me = parseValue(ue);
        ce.textContent = Reflect.apply(de.t, de, [
          ...makeParams(me)
        ]);
      }
    },
    getSSRProps: (ce) => {
      const [ue] = ne(ce);
      return { textContent: ue };
    }
  };
}
function parseValue(re) {
  if (isString$1(re))
    return { path: re };
  if (isPlainObject(re)) {
    if (!("path" in re))
      throw createI18nError(I18nErrorCodes.REQUIRED_VALUE, "path");
    return re;
  } else
    throw createI18nError(I18nErrorCodes.INVALID_VALUE);
}
function makeParams(re) {
  const { path: ne, locale: ae, args: ie, choice: le, plural: se } = re, ce = {}, ue = ie || {};
  return isString$1(ae) && (ce.locale = ae), isNumber(le) && (ce.plural = le), isNumber(se) && (ce.plural = se), [ne, ue, ce];
}
function apply(re, ne, ...ae) {
  const ie = isPlainObject(ae[0]) ? ae[0] : {}, le = !!ie.useI18nComponentName;
  (isBoolean(ie.globalInstall) ? ie.globalInstall : !0) && ([le ? "i18n" : Translation.name, "I18nT"].forEach((ce) => re.component(ce, Translation)), [NumberFormat.name, "I18nN"].forEach((ce) => re.component(ce, NumberFormat)), [DatetimeFormat.name, "I18nD"].forEach((ce) => re.component(ce, DatetimeFormat))), re.directive("t", vTDirective(ne));
}
function defineMixin(re, ne, ae) {
  return {
    beforeCreate() {
      const ie = getCurrentInstance$1();
      if (!ie)
        throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
      const le = this.$options;
      if (le.i18n) {
        const se = le.i18n;
        if (le.__i18n && (se.__i18n = le.__i18n), se.__root = ne, this === this.$root)
          this.$i18n = mergeToGlobal(re, se);
        else {
          se.__injectWithOption = !0, se.__extender = ae.__vueI18nExtend, this.$i18n = createVueI18n(se);
          const ce = this.$i18n;
          ce.__extender && (ce.__disposer = ce.__extender(this.$i18n));
        }
      } else if (le.__i18n)
        if (this === this.$root)
          this.$i18n = mergeToGlobal(re, le);
        else {
          this.$i18n = createVueI18n({
            __i18n: le.__i18n,
            __injectWithOption: !0,
            __extender: ae.__vueI18nExtend,
            __root: ne
          });
          const se = this.$i18n;
          se.__extender && (se.__disposer = se.__extender(this.$i18n));
        }
      else
        this.$i18n = re;
      le.__i18nGlobal && adjustI18nResources(ne, le, le), this.$t = (...se) => this.$i18n.t(...se), this.$rt = (...se) => this.$i18n.rt(...se), this.$tc = (...se) => this.$i18n.tc(...se), this.$te = (se, ce) => this.$i18n.te(se, ce), this.$d = (...se) => this.$i18n.d(...se), this.$n = (...se) => this.$i18n.n(...se), this.$tm = (se) => this.$i18n.tm(se), ae.__setInstance(ie, this.$i18n);
    },
    mounted() {
    },
    unmounted() {
      const ie = getCurrentInstance$1();
      if (!ie)
        throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
      const le = this.$i18n;
      delete this.$t, delete this.$rt, delete this.$tc, delete this.$te, delete this.$d, delete this.$n, delete this.$tm, le.__disposer && (le.__disposer(), delete le.__disposer, delete le.__extender), ae.__deleteInstance(ie), delete this.$i18n;
    }
  };
}
function mergeToGlobal(re, ne) {
  re.locale = ne.locale || re.locale, re.fallbackLocale = ne.fallbackLocale || re.fallbackLocale, re.missing = ne.missing || re.missing, re.silentTranslationWarn = ne.silentTranslationWarn || re.silentFallbackWarn, re.silentFallbackWarn = ne.silentFallbackWarn || re.silentFallbackWarn, re.formatFallbackMessages = ne.formatFallbackMessages || re.formatFallbackMessages, re.postTranslation = ne.postTranslation || re.postTranslation, re.warnHtmlInMessage = ne.warnHtmlInMessage || re.warnHtmlInMessage, re.escapeParameterHtml = ne.escapeParameterHtml || re.escapeParameterHtml, re.sync = ne.sync || re.sync, re.__composer[SetPluralRulesSymbol](ne.pluralizationRules || re.pluralizationRules);
  const ae = getLocaleMessages(re.locale, {
    messages: ne.messages,
    __i18n: ne.__i18n
  });
  return Object.keys(ae).forEach((ie) => re.mergeLocaleMessage(ie, ae[ie])), ne.datetimeFormats && Object.keys(ne.datetimeFormats).forEach((ie) => re.mergeDateTimeFormat(ie, ne.datetimeFormats[ie])), ne.numberFormats && Object.keys(ne.numberFormats).forEach((ie) => re.mergeNumberFormat(ie, ne.numberFormats[ie])), re;
}
const I18nInjectionKey = /* @__PURE__ */ makeSymbol("global-vue-i18n");
function createI18n(re = {}, ne) {
  const ae = __VUE_I18N_LEGACY_API__ && isBoolean(re.legacy) ? re.legacy : __VUE_I18N_LEGACY_API__, ie = isBoolean(re.globalInjection) ? re.globalInjection : !0, le = __VUE_I18N_LEGACY_API__ && ae ? !!re.allowComposition : !0, se = /* @__PURE__ */ new Map(), [ce, ue] = createGlobal(re, ae), de = /* @__PURE__ */ makeSymbol("");
  function me(ge) {
    return se.get(ge) || null;
  }
  function fe(ge, be) {
    se.set(ge, be);
  }
  function pe(ge) {
    se.delete(ge);
  }
  {
    const ge = {
      // mode
      get mode() {
        return __VUE_I18N_LEGACY_API__ && ae ? "legacy" : "composition";
      },
      // allowComposition
      get allowComposition() {
        return le;
      },
      // install plugin
      async install(be, ...Se) {
        if (be.__VUE_I18N_SYMBOL__ = de, be.provide(be.__VUE_I18N_SYMBOL__, ge), isPlainObject(Se[0])) {
          const Ve = Se[0];
          ge.__composerExtend = Ve.__composerExtend, ge.__vueI18nExtend = Ve.__vueI18nExtend;
        }
        let Pe = null;
        !ae && ie && (Pe = injectGlobalFields(be, ge.global)), __VUE_I18N_FULL_INSTALL__ && apply(be, ge, ...Se), __VUE_I18N_LEGACY_API__ && ae && be.mixin(defineMixin(ue, ue.__composer, ge));
        const Ee = be.unmount;
        be.unmount = () => {
          Pe && Pe(), ge.dispose(), Ee();
        };
      },
      // global accessor
      get global() {
        return ue;
      },
      dispose() {
        ce.stop();
      },
      // @internal
      __instances: se,
      // @internal
      __getInstance: me,
      // @internal
      __setInstance: fe,
      // @internal
      __deleteInstance: pe
    };
    return ge;
  }
}
function useI18n(re = {}) {
  const ne = getCurrentInstance$1();
  if (ne == null)
    throw createI18nError(I18nErrorCodes.MUST_BE_CALL_SETUP_TOP);
  if (!ne.isCE && ne.appContext.app != null && !ne.appContext.app.__VUE_I18N_SYMBOL__)
    throw createI18nError(I18nErrorCodes.NOT_INSTALLED);
  const ae = getI18nInstance(ne), ie = getGlobalComposer(ae), le = getComponentOptions(ne), se = getScope(re, le);
  if (__VUE_I18N_LEGACY_API__ && ae.mode === "legacy" && !re.__useComponent) {
    if (!ae.allowComposition)
      throw createI18nError(I18nErrorCodes.NOT_AVAILABLE_IN_LEGACY_MODE);
    return useI18nForLegacy(ne, se, ie, re);
  }
  if (se === "global")
    return adjustI18nResources(ie, re, le), ie;
  if (se === "parent") {
    let de = getComposer(ae, ne, re.__useComponent);
    return de == null && (de = ie), de;
  }
  const ce = ae;
  let ue = ce.__getInstance(ne);
  if (ue == null) {
    const de = assign$1({}, re);
    "__i18n" in le && (de.__i18n = le.__i18n), ie && (de.__root = ie), ue = createComposer(de), ce.__composerExtend && (ue[DisposeSymbol] = ce.__composerExtend(ue)), setupLifeCycle(ce, ne, ue), ce.__setInstance(ne, ue);
  }
  return ue;
}
function createGlobal(re, ne, ae) {
  const ie = effectScope();
  {
    const le = __VUE_I18N_LEGACY_API__ && ne ? ie.run(() => createVueI18n(re)) : ie.run(() => createComposer(re));
    if (le == null)
      throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
    return [ie, le];
  }
}
function getI18nInstance(re) {
  {
    const ne = inject(re.isCE ? I18nInjectionKey : re.appContext.app.__VUE_I18N_SYMBOL__);
    if (!ne)
      throw createI18nError(re.isCE ? I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE : I18nErrorCodes.UNEXPECTED_ERROR);
    return ne;
  }
}
function getScope(re, ne) {
  return isEmptyObject(re) ? "__i18n" in ne ? "local" : "global" : re.useScope ? re.useScope : "local";
}
function getGlobalComposer(re) {
  return re.mode === "composition" ? re.global : re.global.__composer;
}
function getComposer(re, ne, ae = !1) {
  let ie = null;
  const le = ne.root;
  let se = getParentComponentInstance(ne, ae);
  for (; se != null; ) {
    const ce = re;
    if (re.mode === "composition")
      ie = ce.__getInstance(se);
    else if (__VUE_I18N_LEGACY_API__) {
      const ue = ce.__getInstance(se);
      ue != null && (ie = ue.__composer, ae && ie && !ie[InejctWithOptionSymbol] && (ie = null));
    }
    if (ie != null || le === se)
      break;
    se = se.parent;
  }
  return ie;
}
function getParentComponentInstance(re, ne = !1) {
  return re == null ? null : ne && re.vnode.ctx || re.parent;
}
function setupLifeCycle(re, ne, ae) {
  onMounted(() => {
  }, ne), onUnmounted(() => {
    const ie = ae;
    re.__deleteInstance(ne);
    const le = ie[DisposeSymbol];
    le && (le(), delete ie[DisposeSymbol]);
  }, ne);
}
function useI18nForLegacy(re, ne, ae, ie = {}) {
  const le = ne === "local", se = shallowRef(null);
  if (le && re.proxy && !(re.proxy.$options.i18n || re.proxy.$options.__i18n))
    throw createI18nError(I18nErrorCodes.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);
  const ce = isBoolean(ie.inheritLocale) ? ie.inheritLocale : !isString$1(ie.locale), ue = ref$1(
    // prettier-ignore
    !le || ce ? ae.locale.value : isString$1(ie.locale) ? ie.locale : DEFAULT_LOCALE
  ), de = ref$1(
    // prettier-ignore
    !le || ce ? ae.fallbackLocale.value : isString$1(ie.fallbackLocale) || isArray$b(ie.fallbackLocale) || isPlainObject(ie.fallbackLocale) || ie.fallbackLocale === !1 ? ie.fallbackLocale : ue.value
  ), me = ref$1(getLocaleMessages(ue.value, ie)), fe = ref$1(isPlainObject(ie.datetimeFormats) ? ie.datetimeFormats : { [ue.value]: {} }), pe = ref$1(isPlainObject(ie.numberFormats) ? ie.numberFormats : { [ue.value]: {} }), ge = le ? ae.missingWarn : isBoolean(ie.missingWarn) || isRegExp(ie.missingWarn) ? ie.missingWarn : !0, be = le ? ae.fallbackWarn : isBoolean(ie.fallbackWarn) || isRegExp(ie.fallbackWarn) ? ie.fallbackWarn : !0, Se = le ? ae.fallbackRoot : isBoolean(ie.fallbackRoot) ? ie.fallbackRoot : !0, Pe = !!ie.fallbackFormat, Ee = isFunction$3(ie.missing) ? ie.missing : null, Ve = isFunction$3(ie.postTranslation) ? ie.postTranslation : null, Ae = le ? ae.warnHtmlMessage : isBoolean(ie.warnHtmlMessage) ? ie.warnHtmlMessage : !0, Oe = !!ie.escapeParameter, Ne = le ? ae.modifiers : isPlainObject(ie.modifiers) ? ie.modifiers : {}, He = ie.pluralRules || le && ae.pluralRules;
  function Ue() {
    return [
      ue.value,
      de.value,
      me.value,
      fe.value,
      pe.value
    ];
  }
  const Ze = computed({
    get: () => se.value ? se.value.locale.value : ue.value,
    set: (Ge) => {
      se.value && (se.value.locale.value = Ge), ue.value = Ge;
    }
  }), Fe = computed({
    get: () => se.value ? se.value.fallbackLocale.value : de.value,
    set: (Ge) => {
      se.value && (se.value.fallbackLocale.value = Ge), de.value = Ge;
    }
  }), Ke = computed(() => se.value ? se.value.messages.value : me.value), tt = computed(() => fe.value), Re = computed(() => pe.value);
  function Ce() {
    return se.value ? se.value.getPostTranslationHandler() : Ve;
  }
  function _e(Ge) {
    se.value && se.value.setPostTranslationHandler(Ge);
  }
  function he() {
    return se.value ? se.value.getMissingHandler() : Ee;
  }
  function ve(Ge) {
    se.value && se.value.setMissingHandler(Ge);
  }
  function xe(Ge) {
    return Ue(), Ge();
  }
  function $e(...Ge) {
    return se.value ? xe(() => Reflect.apply(se.value.t, null, [...Ge])) : xe(() => "");
  }
  function Te(...Ge) {
    return se.value ? Reflect.apply(se.value.rt, null, [...Ge]) : "";
  }
  function Ie(...Ge) {
    return se.value ? xe(() => Reflect.apply(se.value.d, null, [...Ge])) : xe(() => "");
  }
  function we(...Ge) {
    return se.value ? xe(() => Reflect.apply(se.value.n, null, [...Ge])) : xe(() => "");
  }
  function ke(Ge) {
    return se.value ? se.value.tm(Ge) : {};
  }
  function ye(Ge, nt) {
    return se.value ? se.value.te(Ge, nt) : !1;
  }
  function Be(Ge) {
    return se.value ? se.value.getLocaleMessage(Ge) : {};
  }
  function Xe(Ge, nt) {
    se.value && (se.value.setLocaleMessage(Ge, nt), me.value[Ge] = nt);
  }
  function et(Ge, nt) {
    se.value && se.value.mergeLocaleMessage(Ge, nt);
  }
  function Ye(Ge) {
    return se.value ? se.value.getDateTimeFormat(Ge) : {};
  }
  function De(Ge, nt) {
    se.value && (se.value.setDateTimeFormat(Ge, nt), fe.value[Ge] = nt);
  }
  function je(Ge, nt) {
    se.value && se.value.mergeDateTimeFormat(Ge, nt);
  }
  function rt(Ge) {
    return se.value ? se.value.getNumberFormat(Ge) : {};
  }
  function at(Ge, nt) {
    se.value && (se.value.setNumberFormat(Ge, nt), pe.value[Ge] = nt);
  }
  function qe(Ge, nt) {
    se.value && se.value.mergeNumberFormat(Ge, nt);
  }
  const We = {
    get id() {
      return se.value ? se.value.id : -1;
    },
    locale: Ze,
    fallbackLocale: Fe,
    messages: Ke,
    datetimeFormats: tt,
    numberFormats: Re,
    get inheritLocale() {
      return se.value ? se.value.inheritLocale : ce;
    },
    set inheritLocale(Ge) {
      se.value && (se.value.inheritLocale = Ge);
    },
    get availableLocales() {
      return se.value ? se.value.availableLocales : Object.keys(me.value);
    },
    get modifiers() {
      return se.value ? se.value.modifiers : Ne;
    },
    get pluralRules() {
      return se.value ? se.value.pluralRules : He;
    },
    get isGlobal() {
      return se.value ? se.value.isGlobal : !1;
    },
    get missingWarn() {
      return se.value ? se.value.missingWarn : ge;
    },
    set missingWarn(Ge) {
      se.value && (se.value.missingWarn = Ge);
    },
    get fallbackWarn() {
      return se.value ? se.value.fallbackWarn : be;
    },
    set fallbackWarn(Ge) {
      se.value && (se.value.missingWarn = Ge);
    },
    get fallbackRoot() {
      return se.value ? se.value.fallbackRoot : Se;
    },
    set fallbackRoot(Ge) {
      se.value && (se.value.fallbackRoot = Ge);
    },
    get fallbackFormat() {
      return se.value ? se.value.fallbackFormat : Pe;
    },
    set fallbackFormat(Ge) {
      se.value && (se.value.fallbackFormat = Ge);
    },
    get warnHtmlMessage() {
      return se.value ? se.value.warnHtmlMessage : Ae;
    },
    set warnHtmlMessage(Ge) {
      se.value && (se.value.warnHtmlMessage = Ge);
    },
    get escapeParameter() {
      return se.value ? se.value.escapeParameter : Oe;
    },
    set escapeParameter(Ge) {
      se.value && (se.value.escapeParameter = Ge);
    },
    t: $e,
    getPostTranslationHandler: Ce,
    setPostTranslationHandler: _e,
    getMissingHandler: he,
    setMissingHandler: ve,
    rt: Te,
    d: Ie,
    n: we,
    tm: ke,
    te: ye,
    getLocaleMessage: Be,
    setLocaleMessage: Xe,
    mergeLocaleMessage: et,
    getDateTimeFormat: Ye,
    setDateTimeFormat: De,
    mergeDateTimeFormat: je,
    getNumberFormat: rt,
    setNumberFormat: at,
    mergeNumberFormat: qe
  };
  function ze(Ge) {
    Ge.locale.value = ue.value, Ge.fallbackLocale.value = de.value, Object.keys(me.value).forEach((nt) => {
      Ge.mergeLocaleMessage(nt, me.value[nt]);
    }), Object.keys(fe.value).forEach((nt) => {
      Ge.mergeDateTimeFormat(nt, fe.value[nt]);
    }), Object.keys(pe.value).forEach((nt) => {
      Ge.mergeNumberFormat(nt, pe.value[nt]);
    }), Ge.escapeParameter = Oe, Ge.fallbackFormat = Pe, Ge.fallbackRoot = Se, Ge.fallbackWarn = be, Ge.missingWarn = ge, Ge.warnHtmlMessage = Ae;
  }
  return onBeforeMount(() => {
    if (re.proxy == null || re.proxy.$i18n == null)
      throw createI18nError(I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
    const Ge = se.value = re.proxy.$i18n.__composer;
    ne === "global" ? (ue.value = Ge.locale.value, de.value = Ge.fallbackLocale.value, me.value = Ge.messages.value, fe.value = Ge.datetimeFormats.value, pe.value = Ge.numberFormats.value) : le && ze(Ge);
  }), We;
}
const globalExportProps = [
  "locale",
  "fallbackLocale",
  "availableLocales"
], globalExportMethods = ["t", "rt", "d", "n", "tm", "te"];
function injectGlobalFields(re, ne) {
  const ae = /* @__PURE__ */ Object.create(null);
  return globalExportProps.forEach((le) => {
    const se = Object.getOwnPropertyDescriptor(ne, le);
    if (!se)
      throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
    const ce = isRef(se.value) ? {
      get() {
        return se.value.value;
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      set(ue) {
        se.value.value = ue;
      }
    } : {
      get() {
        return se.get && se.get();
      }
    };
    Object.defineProperty(ae, le, ce);
  }), re.config.globalProperties.$i18n = ae, globalExportMethods.forEach((le) => {
    const se = Object.getOwnPropertyDescriptor(ne, le);
    if (!se || !se.value)
      throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
    Object.defineProperty(re.config.globalProperties, `$${le}`, se);
  }), () => {
    delete re.config.globalProperties.$i18n, globalExportMethods.forEach((le) => {
      delete re.config.globalProperties[`$${le}`];
    });
  };
}
initFeatureFlags();
__INTLIFY_JIT_COMPILATION__ ? registerMessageCompiler(compile) : registerMessageCompiler(compileToFunction);
registerMessageResolver(resolveValue);
registerLocaleFallbacker(fallbackWithLocaleChain);
if (__INTLIFY_PROD_DEVTOOLS__) {
  const re = getGlobalThis();
  re.__INTLIFY__ = !0, setDevToolsHook(re.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
function loadLocaleMessages() {
  const re = /* @__PURE__ */ Object.assign({ "./locales/en.json": __vite_glob_0_0, "./locales/zh.json": __vite_glob_0_1 }), ne = {};
  return Object.keys(re).forEach((ae) => {
    const ie = ae.match(/([A-Za-z0-9-_]+)\./i);
    if (ie && ie.length > 1) {
      const le = ie[1];
      ne[le] = re[ae];
    }
  }), ne;
}
const i18n$1 = createI18n({
  globalInjection: !0,
  locale: "en",
  fallbackLocale: "en",
  messages: loadLocaleMessages()
}), translator = {
  i18n: i18n$1,
  getLocale: () => i18n$1.global.locale,
  setLocale: (re) => {
    i18n$1.global.locale = re;
  },
  applyAppI18n: (re) => (i18n$1.global.availableLocales.forEach((ae) => {
    const ie = Object.keys(re).filter((ce) => ce.includes(ae)), le = re[ie], se = i18n$1.global.messages[ae];
    i18n$1.global.setLocaleMessage(ae, Object.assign({ ...se }, le));
  }), i18n$1.global.messages)
}, _sfc_main$D = {
  name: "CSHeaderIconBtn",
  props: {
    id: { type: String, required: !0 },
    toolTip: { type: String, required: !0 },
    action: { type: Function, required: !1, default: void 0 },
    href: { type: String, required: !1, default: "" },
    active: { type: Boolean, required: !1, default: !1 }
  },
  emits: ["click"],
  computed: {
    menuId() {
      return `cs-header--${this.id}-menu`;
    },
    bthId() {
      return `cs-header--${this.id}-btn`;
    },
    headerBtnMenu() {
      return !!this.$slots["header-btn-menu"];
    }
  },
  methods: {
    mergeProps,
    async onBtnAction() {
      this.action && await this.action(), this.$emit("click");
    }
  }
}, _hoisted_1$s = { class: "cs-header-icon-btn" }, _hoisted_2$h = { class: "cs-header-icon-btn-tooltip" }, _hoisted_3$a = { class: "cs-header-icon-btn-tooltip" };
function _sfc_render$D(re, ne, ae, ie, le, se) {
  return openBlock(), createElementBlock("div", _hoisted_1$s, [
    se.headerBtnMenu ? (openBlock(), createBlock(VMenu, {
      key: 0,
      id: se.menuId,
      eager: "",
      location: "bottom",
      transition: "slide-y-reverse-transition",
      "close-on-content-click": !1
    }, {
      activator: withCtx(({ props: ce }) => [
        createVNode(VTooltip, {
          location: "bottom",
          attach: "body",
          "z-index": "1200",
          offset: "20"
        }, {
          activator: withCtx(({ props: ue }) => [
            createVNode(VBtn, mergeProps(se.mergeProps(ce, ue), {
              icon: "",
              class: ae.active ? "cs-header-icon-btn-active" : "cs-header-icon-btn-default",
              onClick: se.onBtnAction
            }), {
              default: withCtx(() => [
                renderSlot(re.$slots, "header-btn-icon", {}, void 0, !0)
              ]),
              _: 2
            }, 1040, ["class", "onClick"])
          ]),
          default: withCtx(() => [
            createElementVNode("span", _hoisted_2$h, toDisplayString$1(ae.toolTip), 1)
          ]),
          _: 2
        }, 1024)
      ]),
      default: withCtx(() => [
        createVNode(VSheet, null, {
          default: withCtx(() => [
            renderSlot(re.$slots, "header-btn-menu", {}, void 0, !0)
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["id"])) : (openBlock(), createBlock(VTooltip, {
      key: 1,
      location: "bottom",
      attach: "body",
      "z-index": "1200",
      offset: "20"
    }, {
      activator: withCtx(({ props: ce }) => [
        ae.href ? (openBlock(), createBlock(VBtn, mergeProps({ key: 0 }, ce, {
          id: se.bthId,
          icon: "",
          href: ae.href,
          target: "_blank",
          rel: "noopener noreferrer",
          class: ["ma-0", ae.active ? "cs-header-icon-btn-active" : "cs-header-icon-btn-default"]
        }), {
          default: withCtx(() => [
            renderSlot(re.$slots, "header-btn-icon", {}, void 0, !0)
          ]),
          _: 2
        }, 1040, ["id", "href", "class"])) : (openBlock(), createBlock(VBtn, mergeProps({ key: 1 }, ce, {
          id: se.bthId,
          icon: "",
          class: ["ma-0", ae.active ? "cs-header-icon-btn-active" : "cs-header-icon-btn-default"],
          onClick: se.onBtnAction
        }), {
          default: withCtx(() => [
            renderSlot(re.$slots, "header-btn-icon", {}, void 0, !0)
          ]),
          _: 2
        }, 1040, ["id", "class", "onClick"]))
      ]),
      default: withCtx(() => [
        createElementVNode("span", _hoisted_3$a, toDisplayString$1(ae.toolTip), 1)
      ]),
      _: 3
    }))
  ]);
}
const CSHeaderIconBtn = /* @__PURE__ */ _export_sfc(_sfc_main$D, [["render", _sfc_render$D], ["__scopeId", "data-v-063cc3ef"]]), _sfc_main$C = {
  name: "HxButton",
  props: {
    id: { type: String, default: "" },
    label: {
      type: String,
      default: ""
    },
    variant: {
      type: String,
      default: "secondary",
      validator: (re, ne) => ne.ghost && re === "white" || ["primary", "secondary", "danger"].includes(re) ? !0 : (console.error("Invalid variant for a Helix Button"), !1)
    },
    size: {
      type: String,
      default: "medium",
      validator: (re) => ["small", "medium", "large"].includes(re) ? !0 : (console.error("Invalid size for a Helix Button"), !1)
    },
    ghost: { type: Boolean },
    type: {
      type: String,
      default: "button",
      validator: (re) => ["button", "submit", "reset"].includes(re) ? !0 : (console.error("Invalid type for a Helix Button"), !1)
    },
    loading: {
      type: Boolean
    },
    disabled: { type: Boolean },
    leftIcon: { type: String, default: "" },
    rightIcon: { type: String, default: "" }
  },
  emits: ["click"],
  computed: {
    classes() {
      let re = ["hx-button"];
      return this.variant && (re = re.concat(this.variant)), this.size === "medium" ? re = re.concat("button-md") : this.size === "large" ? re = re.concat("button-lg") : re = re.concat("button-sm"), this.ghost === !0 ? re = re.concat("ghost") : re = re.concat("contained"), re;
    },
    btnClass() {
      return this.classes.join(" ");
    },
    btnColor() {
      return this.variant === "primary" ? "primary" : this.variant === "danger" ? "error" : "secondary";
    },
    btnSize() {
      return this.size === "medium" ? "default" : this.size === "small" ? "small" : "large";
    },
    btnVariant() {
      return this.ghost ? "plain" : "elevated";
    }
  },
  methods: {
    onClick(re) {
      this.$emit("click", re);
    }
  }
}, _hoisted_1$r = { key: 1 };
function _sfc_render$C(re, ne, ae, ie, le, se) {
  return openBlock(), createBlock(VBtn, {
    id: ae.id,
    elevation: "0",
    ripple: !1,
    class: normalizeClass(se.btnClass),
    variant: se.btnVariant,
    disabled: ae.disabled,
    loading: ae.loading,
    type: ae.type,
    onClick: se.onClick
  }, {
    default: withCtx(() => [
      ae.leftIcon ? (openBlock(), createBlock(VIcon, {
        key: 0,
        class: "hx-button-icon-left"
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString$1(ae.leftIcon), 1)
        ]),
        _: 1
      })) : createCommentVNode("", !0),
      ae.label ? (openBlock(), createElementBlock("span", _hoisted_1$r, toDisplayString$1(ae.label), 1)) : createCommentVNode("", !0),
      ae.rightIcon ? (openBlock(), createBlock(VIcon, {
        key: 2,
        class: "hx-button-icon-right"
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString$1(ae.rightIcon), 1)
        ]),
        _: 1
      })) : createCommentVNode("", !0)
    ]),
    _: 1
  }, 8, ["id", "class", "variant", "disabled", "loading", "type", "onClick"]);
}
const HxButton = /* @__PURE__ */ _export_sfc(_sfc_main$C, [["render", _sfc_render$C], ["__scopeId", "data-v-3e50df62"]]), _sfc_main$B = {
  name: "HxSearch",
  props: {
    search: {
      type: String,
      required: !0
    },
    placeholder: {
      type: String,
      default: "Search"
    }
  },
  emits: ["update:search"],
  computed: {
    searchValue: {
      get() {
        return this.search;
      },
      set(re) {
        this.$emit("update:search", re);
      }
    }
  },
  methods: {
    clearSearch() {
      this.searchValue = "";
    }
  }
};
function _sfc_render$B(re, ne, ae, ie, le, se) {
  const ce = HxButton;
  return openBlock(), createBlock(VTextField, {
    modelValue: se.searchValue,
    "onUpdate:modelValue": ne[0] || (ne[0] = (ue) => se.searchValue = ue),
    density: "compact",
    placeholder: ae.placeholder,
    variant: "outlined",
    clearable: "",
    "max-width": "316",
    class: "hx-search",
    "hide-details": ""
  }, {
    clear: withCtx(() => [
      createVNode(ce, {
        variant: "secondary",
        ghost: "",
        size: "large",
        "left-icon": "mdi-close-circle-outline",
        onClick: se.clearSearch
      }, null, 8, ["onClick"])
    ]),
    "append-inner": withCtx(() => [
      createVNode(ce, {
        variant: "secondary",
        ghost: "",
        size: "large",
        "left-icon": "mdi-magnify"
      })
    ]),
    _: 1
  }, 8, ["modelValue", "placeholder"]);
}
const HxSearch = /* @__PURE__ */ _export_sfc(_sfc_main$B, [["render", _sfc_render$B], ["__scopeId", "data-v-f0309075"]]), _sfc_main$A = {
  name: "HxTable",
  props: {
    id: { type: String, required: !1, default: "" },
    items: { type: Array, required: !0 },
    headers: { type: Array, required: !0 },
    title: { type: String, default: void 0, required: !1 },
    showToolbar: { type: Boolean, default: !1, required: !1 },
    loading: { type: Boolean, default: !1, required: !1 },
    showSelect: { type: Boolean, default: !1, required: !1 },
    itemsPerPage: { type: Number, default: 10, required: !1 },
    itemsPerPageOptions: { type: Array, default: () => [5, 10, 15], required: !1 }
  },
  data() {
    return {
      selected: [],
      search: "",
      buttonId: "button-id",
      label: "Filter"
    };
  },
  mounted() {
    const re = document.querySelector(
      ".v-data-table-footer__items-per-page .v-input.v-select--selected .v-input__control .v-field.v-field--active .v-field__append-inner .v-select__menu-icon"
    );
    re && (re.classList.remove("mdi-menu-down"), re.classList.add("mdi-chevron-down"));
  }
}, _hoisted_1$q = { class: "hx-table-border overflow-hidden" }, _hoisted_2$g = {
  key: 0,
  class: "table-title style-03"
}, _hoisted_3$9 = { class: "px-4 py-2" }, _hoisted_4$6 = {
  key: 1,
  class: "d-flex border-t border-b pa-2 hx-table-toolbar"
};
function _sfc_render$A(re, ne, ae, ie, le, se) {
  const ce = HxSearch, ue = HxButton;
  return openBlock(), createBlock(VContainer, { id: ae.id }, {
    default: withCtx(() => [
      createElementVNode("div", _hoisted_1$q, [
        ae.title ? (openBlock(), createElementBlock("div", _hoisted_2$g, [
          createElementVNode("div", _hoisted_3$9, toDisplayString$1(ae.title), 1)
        ])) : createCommentVNode("", !0),
        ae.showToolbar ? (openBlock(), createElementBlock("div", _hoisted_4$6, [
          createVNode(ce, {
            search: le.search,
            "onUpdate:search": ne[0] || (ne[0] = (de) => le.search = de),
            placeholder: "Search"
          }, null, 8, ["search"]),
          createVNode(VSpacer),
          createVNode(ue, {
            id: le.buttonId,
            size: "large",
            label: le.label,
            "right-icon": "mdi-filter-outline"
          }, null, 8, ["id", "label"])
        ])) : createCommentVNode("", !0),
        createVNode(VDataTable, {
          modelValue: le.selected,
          "onUpdate:modelValue": ne[1] || (ne[1] = (de) => le.selected = de),
          items: ae.items,
          headers: ae.headers,
          "items-per-page-text": "Rows per page",
          "items-per-page": ae.itemsPerPage,
          "items-per-page-options": ae.itemsPerPageOptions,
          density: "comfortable",
          loading: ae.loading ? "rgb(var(--v-theme-primary))" : !1,
          "show-select": ae.showSelect,
          search: le.search,
          class: normalizeClass(`hx-table ${ae.items.length < ae.itemsPerPage ? "no-items-per-page" : ""}`)
        }, null, 8, ["modelValue", "items", "headers", "items-per-page", "items-per-page-options", "loading", "show-select", "search", "class"])
      ])
    ]),
    _: 1
  }, 8, ["id"]);
}
const HxTable = /* @__PURE__ */ _export_sfc(_sfc_main$A, [["render", _sfc_render$A], ["__scopeId", "data-v-d8f74b2f"]]), _sfc_main$z = {
  name: "HxToggleSwitch",
  props: {
    titleText: {
      type: String,
      default: void 0,
      required: !1
    },
    id: { type: String, default: "" },
    modelValue: {
      type: Boolean,
      default: !1,
      required: !1
    },
    rightLabel: {
      type: String,
      default: void 0,
      required: !1
    },
    leftLabel: {
      type: String,
      default: void 0,
      required: !1
    },
    disabled: { type: Boolean, required: !1 },
    tabindex: {
      type: Number,
      default: void 0
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      switchValue: this.modelValue
    };
  },
  computed: {
    classes() {
      let re = ["hx-toggle-switch"];
      return this.switchValue ? re = re.concat("active") : re = re.concat("inactive"), re;
    },
    toggleSwitchClass() {
      return this.classes.join(" ");
    }
  },
  watch: {
    modelValue(re) {
      this.switchValue = re;
    }
  },
  methods: {
    updateModel() {
      this.$emit("update:modelValue", this.switchValue);
    }
  }
}, _hoisted_1$p = {
  key: 0,
  class: "title-text"
};
function _sfc_render$z(re, ne, ae, ie, le, se) {
  return openBlock(), createElementBlock("div", null, [
    ae.titleText ? (openBlock(), createElementBlock("span", _hoisted_1$p, toDisplayString$1(ae.titleText), 1)) : createCommentVNode("", !0),
    createVNode(VSwitch, {
      modelValue: le.switchValue,
      "onUpdate:modelValue": ne[0] || (ne[0] = (ce) => le.switchValue = ce),
      label: ae.rightLabel,
      "hide-details": "",
      inset: "",
      tabindex: ae.tabindex,
      class: normalizeClass(se.toggleSwitchClass),
      disabled: ae.disabled,
      onChange: se.updateModel
    }, createSlots({ _: 2 }, [
      ae.leftLabel ? {
        name: "prepend",
        fn: withCtx(() => [
          createTextVNode(toDisplayString$1(ae.leftLabel), 1)
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["modelValue", "label", "tabindex", "class", "disabled", "onChange"])
  ]);
}
const HxToggleSwitch = /* @__PURE__ */ _export_sfc(_sfc_main$z, [["render", _sfc_render$z], ["__scopeId", "data-v-641dd376"]]), _sfc_main$y = {
  name: "HxContentCard",
  props: {
    id: { type: String, default: "", required: !1 },
    height: { type: String, default: void 0, required: !1 },
    minHeight: { type: String, default: void 0, required: !1 },
    maxHeight: { type: String, default: void 0, required: !1 },
    width: { type: String, default: void 0, required: !1 },
    minWidth: { type: String, default: void 0, required: !1 },
    maxWidth: { type: String, default: void 0, required: !1 },
    color: {
      type: String,
      default: "white",
      required: !1,
      validator: (re) => ["white", "grey"].includes(re) ? !0 : (console.error("Invalid color for a Helix Card"), !1)
    },
    elevation: {
      type: String,
      default: "flat",
      required: !1,
      validator: (re) => ["flat", "xl", "md"].includes(re) ? !0 : (console.error("Invalid elevation for a Helix Card"), !1)
    }
  },
  computed: {
    classes() {
      let re = ["hx-content-card"];
      return this.elevation === "xl" ? re = re.concat("elevation-xl") : this.elevation === "md" ? re = re.concat("elevation-md") : re = re.concat("flat"), this.color === "grey" ? re = re.concat("color-grey") : re = re.concat("color-white"), re;
    },
    cardClass() {
      return this.classes.join(" ");
    }
  }
};
function _sfc_render$y(re, ne, ae, ie, le, se) {
  return openBlock(), createBlock(VCard, {
    id: ae.id,
    height: ae.height,
    "min-height": ae.minHeight,
    "max-height": ae.maxHeight,
    width: ae.width,
    "min-width": ae.minWidth,
    "max-width": ae.maxWidth,
    variant: "flat",
    class: normalizeClass(se.cardClass)
  }, {
    default: withCtx(() => [
      re.$slots.header ? (openBlock(), createBlock(VCardItem, {
        key: 0,
        class: "content-card-header-container"
      }, {
        default: withCtx(() => [
          createVNode(VCardTitle, { class: "content-card-header" }, {
            default: withCtx(() => [
              renderSlot(re.$slots, "header", {}, void 0, !0)
            ]),
            _: 3
          })
        ]),
        _: 3
      })) : createCommentVNode("", !0),
      re.$slots.default ? (openBlock(), createBlock(VCardText, {
        key: 1,
        class: "content-card-body"
      }, {
        default: withCtx(() => [
          renderSlot(re.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      })) : createCommentVNode("", !0),
      re.$slots.footer ? (openBlock(), createBlock(VCardActions, {
        key: 2,
        class: "content-card-footer"
      }, {
        default: withCtx(() => [
          renderSlot(re.$slots, "footer", {}, void 0, !0)
        ]),
        _: 3
      })) : createCommentVNode("", !0)
    ]),
    _: 3
  }, 8, ["id", "height", "min-height", "max-height", "width", "min-width", "max-width", "class"]);
}
const HxContentCard = /* @__PURE__ */ _export_sfc(_sfc_main$y, [["render", _sfc_render$y], ["__scopeId", "data-v-3a872f74"]]), _sfc_main$x = {
  name: "HxCheckbox",
  props: {
    id: { type: String, default: "" },
    modelValue: { type: Boolean, default: !1 },
    indeterminate: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    label: { type: String, default: "" }
  },
  emits: ["update:modelValue", "update:indeterminate"],
  data() {
    return {
      isSelected: this.modelValue,
      isIndeterminate: this.indeterminate
    };
  },
  computed: {
    checkboxClass() {
      let re = ["hx-checkbox"];
      return this.disabled && (re = re.concat("disabled")), re.join(" ");
    },
    iconClass() {
      let re = ["container"];
      return this.disabled && (re = re.concat("disabled")), this.isIndeterminate ? re = re.concat("indeterminate") : this.isSelected ? re = re.concat("checked") : re = re.concat("unchecked"), re.join(" ");
    }
  },
  watch: {
    modelValue(re) {
      this.isSelected = re;
    },
    indeterminate(re) {
      this.isIndeterminate = re;
    }
  },
  methods: {
    handleChange(re) {
      this.disabled || (this.isIndeterminate ? (this.isIndeterminate = !1, this.isSelected = !0, this.indeterminate === !0 && this.$emit("update:indeterminate", !1), this.modelValue === !1 && this.$emit("update:modelValue", !0)) : (this.isSelected = re, this.$emit("update:modelValue", re)));
    }
  }
};
function _sfc_render$x(re, ne, ae, ie, le, se) {
  return openBlock(), createBlock(VCheckbox, {
    id: ae.id,
    class: normalizeClass(se.checkboxClass),
    disabled: ae.disabled,
    ripple: !1,
    "hide-details": !0,
    density: "compact",
    indeterminate: le.isIndeterminate,
    "model-value": le.isIndeterminate ? void 0 : le.isSelected,
    label: ae.label,
    "onUpdate:modelValue": se.handleChange
  }, createSlots({
    input: withCtx(({ inputNode: ce }) => [
      createElementVNode("div", {
        class: normalizeClass(se.iconClass)
      }, [
        createVNode(VIcon, { size: "16" }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString$1(le.isIndeterminate ? "mdi-minus" : le.isSelected ? "mdi-check" : ""), 1)
          ]),
          _: 1
        })
      ], 2),
      (openBlock(), createBlock(resolveDynamicComponent(ce)))
    ]),
    _: 2
  }, [
    re.$slots.label ? {
      name: "label",
      fn: withCtx(() => [
        renderSlot(re.$slots, "label", {}, void 0, !0)
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["id", "class", "disabled", "indeterminate", "model-value", "label", "onUpdate:modelValue"]);
}
const HxCheckbox = /* @__PURE__ */ _export_sfc(_sfc_main$x, [["render", _sfc_render$x], ["__scopeId", "data-v-3f76e356"]]), _sfc_main$w = {
  name: "HxRadioButton",
  props: {
    id: { type: String, default: "" },
    label: {
      type: String,
      default: "",
      validator: (re) => re ? !0 : (console.error("Require label for a Helix Radio Button"), !1)
    },
    value: {
      type: String,
      default: ""
    },
    disabled: { type: Boolean, default: !1, required: !1 }
  }
};
function _sfc_render$w(re, ne, ae, ie, le, se) {
  return openBlock(), createBlock(VRadio, {
    label: ae.label,
    value: ae.value,
    ripple: !1,
    class: "hx-radio-button",
    disabled: ae.disabled
  }, null, 8, ["label", "value", "disabled"]);
}
const HxRadioButton = /* @__PURE__ */ _export_sfc(_sfc_main$w, [["render", _sfc_render$w], ["__scopeId", "data-v-4930dfb7"]]), _sfc_main$v = {
  name: "HxChip",
  props: {
    id: { type: String, default: "" },
    type: {
      type: String,
      default: "static",
      validator: (re) => !!["static", "action", "input"].includes(re)
    },
    color: {
      type: String,
      default: "grey",
      validator: (re, ne) => ne.type === "input" ? !!["grey", "teal"].includes(re) : !!["blue", "green", "grey", "pink", "red", "yellow", "teal"].includes(re)
    },
    active: {
      type: Boolean,
      default: !1
    },
    disabled: { type: Boolean, default: !1 },
    label: { type: String, default: "" },
    leftIcon: { type: String, default: "mdi-check" },
    rightIcon: { type: String, default: "mdi-close" },
    showLeftIcon: { type: Boolean, default: !1 },
    showRightIcon: { type: Boolean, default: !1 }
  },
  emits: ["update:active", "click", "dismiss"],
  computed: {
    chipClass() {
      let re = ["hx-chip"];
      return this.disabled && (re = re.concat("disabled")), this.color && (re = re.concat(this.color)), this.type && (re = re.concat(`${this.type}-type`)), this.active && (re = re.concat("active")), re.join(" ");
    },
    clickFn() {
      return this.type === "action" ? this.onClick : void 0;
    },
    dismissFn() {
      return this.type === "input" ? this.onDismiss : void 0;
    },
    dismissButtonVariant() {
      if (this.active)
        return "white";
      if (this.color === "teal")
        return "primary";
      if (this.color === "grey")
        return "secondary";
    }
  },
  methods: {
    onClick() {
      this.disabled || (this.$emit("update:active", !this.active), this.$emit("click"));
    },
    onDismiss() {
      this.disabled || this.$emit("dismiss");
    }
  }
}, _hoisted_1$o = {
  key: 1,
  class: "label"
};
function _sfc_render$v(re, ne, ae, ie, le, se) {
  const ce = HxButton;
  return openBlock(), createBlock(VChip, {
    id: ae.id,
    class: normalizeClass(se.chipClass),
    density: "compact",
    disabled: ae.disabled,
    ripple: !1,
    variant: "flat",
    onClick: se.clickFn
  }, {
    default: withCtx(() => [
      ae.showLeftIcon ? (openBlock(), createBlock(VIcon, {
        key: 0,
        size: "16"
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString$1(ae.leftIcon), 1)
        ]),
        _: 1
      })) : createCommentVNode("", !0),
      ae.label ? (openBlock(), createElementBlock("div", _hoisted_1$o, toDisplayString$1(ae.label), 1)) : createCommentVNode("", !0),
      ae.type === "input" && ae.showRightIcon ? (openBlock(), createBlock(ce, {
        key: 2,
        ghost: "",
        "left-icon": ae.rightIcon,
        variant: se.dismissButtonVariant,
        size: "small",
        disabled: ae.disabled,
        onClick: se.dismissFn
      }, null, 8, ["left-icon", "variant", "disabled", "onClick"])) : ae.showRightIcon ? (openBlock(), createBlock(VIcon, {
        key: 3,
        size: "16"
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString$1(ae.rightIcon), 1)
        ]),
        _: 1
      })) : createCommentVNode("", !0)
    ]),
    _: 1
  }, 8, ["id", "class", "disabled", "onClick"]);
}
const HxChip = /* @__PURE__ */ _export_sfc(_sfc_main$v, [["render", _sfc_render$v], ["__scopeId", "data-v-04a5c8b5"]]), _sfc_main$u = {
  name: "HxTooltip",
  props: {
    id: { type: String, default: "" },
    text: {
      type: String,
      default: "",
      validator: (re) => re ? !0 : (console.error("Require text for a Helix Tooltip"), !1)
    },
    location: {
      type: String,
      default: "left",
      validator: (re) => {
        switch (re) {
          case "left":
          case "right":
          case "top":
          case "bottom":
            return !0;
          default:
            return console.error("Invalid location for a Helix Tooltip"), !1;
        }
      }
    }
  },
  data() {
    return {
      timer: null
    };
  },
  computed: {
    tooltipClass() {
      let re = ["hx-tooltip"];
      switch (this.location) {
        case "right":
          re = re.concat("pinch-left");
          break;
        case "top":
          re = re.concat("pinch-bottom");
          break;
        case "bottom":
          re = re.concat("pinch-top");
          break;
        default:
          re = re.concat("pinch-right");
      }
      return re.join(" ");
    }
  },
  methods: {
    handleOnHover(re, ne) {
      this.timer = setTimeout(() => {
        ne(re);
      }, 500);
    },
    handleOnBlur() {
      this.timer && (clearTimeout(this.timer), this.timer = null);
    }
  }
};
function _sfc_render$u(re, ne, ae, ie, le, se) {
  return openBlock(), createBlock(VTooltip, {
    id: ae.id,
    text: ae.text,
    location: ae.location,
    class: normalizeClass(se.tooltipClass),
    "content-class": "hx-tooltip-content",
    "open-delay": "0",
    "close-delay": "200",
    "max-width": "274",
    offset: "11"
  }, {
    activator: withCtx(({ props: { onFocus: ce, onMouseenter: ue, ...de } }) => [
      renderSlot(re.$slots, "default", mergeProps(de, {
        onFocus: ce,
        onBlur: ne[0] || (ne[0] = (...me) => se.handleOnBlur && se.handleOnBlur(...me)),
        onMouseleave: ne[1] || (ne[1] = (...me) => se.handleOnBlur && se.handleOnBlur(...me)),
        onMouseenter: (me) => se.handleOnHover(me, ue)
      }), void 0, !0)
    ]),
    _: 3
  }, 8, ["id", "text", "location", "class"]);
}
const HxTooltip = /* @__PURE__ */ _export_sfc(_sfc_main$u, [["render", _sfc_render$u], ["__scopeId", "data-v-92d30392"]]), _sfc_main$t = {
  name: "HxModal",
  props: {
    id: {
      type: String,
      default: ""
    },
    maxWidth: {
      type: String,
      default: "766px"
    },
    title: {
      type: String,
      default: void 0
    },
    subtitle: {
      type: String,
      default: void 0
    },
    modelValue: {
      type: Boolean,
      required: !0
    },
    height: {
      type: String,
      default: "625px"
    },
    width: {
      type: String,
      default: "640px"
    },
    primaryAction: { type: Object, default: void 0 },
    secondaryAction1: { type: Object, default: void 0 },
    secondaryAction2: { type: Object, default: void 0 }
  },
  emits: ["update:modelValue", "primary-click", "secondary1-click", "secondary2-click"],
  data() {
    return {
      dialog: this.modelValue
    };
  },
  computed: {
    classes() {
      return ["hx-modal"];
    },
    modalClass() {
      return this.classes.join(" ");
    }
  },
  watch: {
    modelValue(re) {
      this.dialog = re;
    },
    $props: {
      immediate: !0,
      handler() {
        this.validateProps();
      }
    }
  },
  methods: {
    onClose() {
      this.dialog = !1, this.$emit("update:modelValue", this.dialog);
    },
    onPrimaryClick() {
      this.$emit("primary-click");
    },
    onSecondary1Click() {
      this.$emit("secondary1-click");
    },
    onSecondary2Click() {
      this.$emit("secondary2-click");
    },
    validateProps() {
      this.title || console.error("Please include a title"), !this.primaryAction && !this.secondaryAction1 && !this.secondaryAction2 && console.error("Please include a button"), this.$slots.content || console.error("Please include a content slot");
    }
  }
}, _hoisted_1$n = { class: "d-flex justify-space-between header-container" }, _hoisted_2$f = { class: "align-self-center close-button" };
function _sfc_render$t(re, ne, ae, ie, le, se) {
  const ce = HxButton;
  return openBlock(), createBlock(VDialog, {
    modelValue: le.dialog,
    "onUpdate:modelValue": ne[3] || (ne[3] = (ue) => le.dialog = ue),
    persistent: "",
    height: ae.height,
    width: ae.width,
    "max-width": ae.maxWidth,
    class: normalizeClass(se.modalClass),
    scrollable: "",
    onKeydown: withKeys(se.onClose, ["esc"])
  }, {
    default: withCtx(() => [
      createVNode(VCard, null, {
        default: withCtx(() => [
          createElementVNode("div", _hoisted_1$n, [
            createElementVNode("div", null, [
              ae.title ? (openBlock(), createBlock(VCardTitle, { key: 0 }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString$1(ae.title), 1)
                ]),
                _: 1
              })) : createCommentVNode("", !0),
              ae.subtitle ? (openBlock(), createBlock(VCardSubtitle, { key: 1 }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString$1(ae.subtitle), 1)
                ]),
                _: 1
              })) : createCommentVNode("", !0)
            ]),
            createElementVNode("div", _hoisted_2$f, [
              createVNode(VBtn, {
                icon: "",
                variant: "plain",
                size: "24px",
                onClick: se.onClose
              }, {
                default: withCtx(() => [
                  createVNode(VIcon, {
                    size: "14px",
                    icon: "mdi-close"
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          createVNode(VCardText, null, {
            default: withCtx(() => [
              renderSlot(re.$slots, "content", {}, void 0, !0)
            ]),
            _: 3
          }),
          ae.primaryAction || ae.secondaryAction1 || ae.secondaryAction2 ? (openBlock(), createBlock(VCardActions, { key: 0 }, {
            default: withCtx(() => [
              createVNode(VSpacer),
              ae.secondaryAction2 && ae.secondaryAction2.label ? (openBlock(), createBlock(ce, {
                key: 0,
                id: ae.secondaryAction2.id,
                variant: ae.secondaryAction2.variant,
                label: ae.secondaryAction2.label,
                "left-icon": ae.secondaryAction2.leftIcon,
                "right-icon": ae.secondaryAction2.rightIcon,
                class: "mx-1",
                onClick: ne[0] || (ne[0] = (ue) => se.onSecondary2Click())
              }, null, 8, ["id", "variant", "label", "left-icon", "right-icon"])) : createCommentVNode("", !0),
              ae.secondaryAction1 && ae.secondaryAction1.label ? (openBlock(), createBlock(ce, {
                key: 1,
                id: ae.secondaryAction1.id,
                variant: ae.secondaryAction1.variant,
                label: ae.secondaryAction1.label,
                "left-icon": ae.secondaryAction1.leftIcon,
                "right-icon": ae.secondaryAction1.rightIcon,
                class: "mx-1",
                onClick: ne[1] || (ne[1] = (ue) => se.onSecondary1Click())
              }, null, 8, ["id", "variant", "label", "left-icon", "right-icon"])) : createCommentVNode("", !0),
              ae.primaryAction && ae.primaryAction.label ? (openBlock(), createBlock(ce, {
                key: 2,
                id: ae.primaryAction.id,
                variant: ae.primaryAction.variant,
                label: ae.primaryAction.label,
                "left-icon": ae.primaryAction.leftIcon,
                "right-icon": ae.primaryAction.rightIcon,
                class: "mx-1",
                onClick: ne[2] || (ne[2] = (ue) => se.onPrimaryClick())
              }, null, 8, ["id", "variant", "label", "left-icon", "right-icon"])) : createCommentVNode("", !0)
            ]),
            _: 1
          })) : createCommentVNode("", !0)
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["modelValue", "height", "width", "max-width", "class", "onKeydown"]);
}
const HxModal = /* @__PURE__ */ _export_sfc(_sfc_main$t, [["render", _sfc_render$t], ["__scopeId", "data-v-9c76405a"]]), _sfc_main$s = {
  name: "HxOption",
  props: {
    id: { type: String, default: "" },
    label: { type: String, default: "" },
    caption: { type: String, default: "" },
    size: {
      type: String,
      default: "compact",
      validator: (re) => ["regular", "compact"].includes(re)
    },
    disabled: { type: Boolean, default: !1 },
    multiple: { type: Boolean, default: !1 },
    isSelected: { type: Boolean, default: !1 },
    isExpanded: { type: Boolean, default: !1 },
    leftIcon: { type: String, default: "" },
    activeIcon: { type: String, default: "mdi-check-circle-outline" },
    showActiveIcon: { type: Boolean, default: !1 },
    showChevron: { type: Boolean, default: !1 },
    showChip: { type: Boolean, default: !1 },
    primary: { type: Boolean, default: !1 },
    chipProps: {
      type: Object,
      default: () => ({
        type: "static",
        color: "teal",
        active: !1,
        disabled: !1,
        label: "Active"
      })
    }
  },
  emits: ["update:isSelected", "update:isExpanded"],
  computed: {
    optionClass() {
      let re = ["hx-option"];
      return this.disabled && (re = re.concat("disabled")), this.size && (re = re.concat(this.size)), this.multiple && (re = re.concat("multiple")), this.primary && !this.disabled && (re = re.concat("primary")), re.join(" ");
    }
  },
  methods: {
    onSelect() {
      this.disabled || this.$emit("update:isSelected", !this.isSelected);
    },
    onExpand() {
      this.disabled || this.$emit("update:isExpanded", !this.isExpanded);
    }
  }
}, _hoisted_1$m = ["id", "tabindex"], _hoisted_2$e = {
  key: 2,
  class: "content"
}, _hoisted_3$8 = {
  key: 0,
  class: "label"
}, _hoisted_4$5 = {
  key: 1,
  class: "caption"
}, _hoisted_5$2 = { key: 5 };
function _sfc_render$s(re, ne, ae, ie, le, se) {
  const ce = HxCheckbox, ue = HxChip, de = HxButton;
  return openBlock(), createElementBlock("div", {
    id: ae.id,
    class: normalizeClass(se.optionClass),
    tabindex: ae.disabled ? void 0 : "0",
    onClick: ne[5] || (ne[5] = (me) => se.onSelect()),
    onKeydown: [
      ne[6] || (ne[6] = withKeys(withModifiers((me) => se.onSelect(), ["prevent", "self"]), ["space"])),
      ne[7] || (ne[7] = withKeys(withModifiers((me) => se.onSelect(), ["prevent", "self"]), ["enter"]))
    ]
  }, [
    ae.multiple ? (openBlock(), createBlock(ce, {
      key: 0,
      tabindex: "-1",
      "model-value": ae.isSelected,
      disabled: ae.disabled,
      "onUpdate:modelValue": ne[0] || (ne[0] = (me) => re.$emit("update:isSelected", me)),
      onClick: ne[1] || (ne[1] = withModifiers(() => {
      }, ["prevent"]))
    }, null, 8, ["model-value", "disabled"])) : createCommentVNode("", !0),
    ae.leftIcon ? (openBlock(), createBlock(VIcon, {
      key: 1,
      class: "left-icon",
      size: "24"
    }, {
      default: withCtx(() => [
        createTextVNode(toDisplayString$1(ae.leftIcon), 1)
      ]),
      _: 1
    })) : createCommentVNode("", !0),
    ae.label || ae.caption ? (openBlock(), createElementBlock("div", _hoisted_2$e, [
      ae.label ? (openBlock(), createElementBlock("span", _hoisted_3$8, toDisplayString$1(ae.label), 1)) : createCommentVNode("", !0),
      ae.caption ? (openBlock(), createElementBlock("span", _hoisted_4$5, toDisplayString$1(ae.caption), 1)) : createCommentVNode("", !0)
    ])) : createCommentVNode("", !0),
    ae.showChip ? (openBlock(), createBlock(ue, mergeProps({ key: 3 }, ae.chipProps, { disabled: ae.disabled }), null, 16, ["disabled"])) : createCommentVNode("", !0),
    ae.isSelected && !ae.multiple ? (openBlock(), createBlock(VIcon, {
      key: 4,
      class: "active-icon",
      size: "24"
    }, {
      default: withCtx(() => [
        createTextVNode(toDisplayString$1(ae.activeIcon), 1)
      ]),
      _: 1
    })) : createCommentVNode("", !0),
    ae.showChevron ? (openBlock(), createElementBlock("div", _hoisted_5$2, [
      createVNode(de, {
        ghost: "",
        "left-icon": ae.isExpanded ? "mdi-chevron-up" : "mdi-chevron-down",
        variant: ae.primary ? "primary" : "secondary",
        size: "large",
        disabled: ae.disabled,
        onClick: ne[2] || (ne[2] = withModifiers((me) => se.onExpand(), ["stop"])),
        onKeydown: [
          ne[3] || (ne[3] = withKeys(withModifiers((me) => se.onExpand(), ["prevent"]), ["space"])),
          ne[4] || (ne[4] = withKeys(withModifiers((me) => se.onExpand(), ["prevent"]), ["enter"]))
        ]
      }, null, 8, ["left-icon", "variant", "disabled"])
    ])) : createCommentVNode("", !0)
  ], 42, _hoisted_1$m);
}
const HxOption = /* @__PURE__ */ _export_sfc(_sfc_main$s, [["render", _sfc_render$s], ["__scopeId", "data-v-6dd958c1"]]), menuProps = {
  compact: { type: Boolean, default: !1 },
  regular: { type: Boolean, default: !0 },
  maxCharacters: {
    type: Number,
    default: 49
  },
  tooltipDirection: {
    type: String,
    default: "right",
    validator: (re) => {
      switch (re) {
        case "left":
        case "right":
        case "top":
        case "bottom":
          return !0;
        default:
          return console.error("Invalid location for a Helix Tooltip in Helix Menu"), !1;
      }
    }
  }
}, _sfc_main$r = {
  name: "MenuItem",
  props: {
    ...menuProps,
    item: {
      type: Object,
      required: !0
    },
    index: {
      type: Number,
      required: !0
    },
    isToggled: {
      type: Boolean
    }
  },
  emits: ["click", "update:isToggled"],
  computed: {
    classes() {
      const re = ["v-list-item"];
      re.push(this.compact ? "height-compact" : "height-regular");
      const ne = this.$slots.default || this.item.icon;
      return re.push(ne ? "has-prepend" : "no-prepend"), this.item.color && re.push(this.item.color), re;
    },
    itemClass() {
      return this.classes.join(" ");
    },
    isEnabled: {
      get() {
        return this.isToggled;
      },
      set(re) {
        this.$emit("update:isToggled", re);
      }
    }
  },
  methods: {
    onClick() {
      this.$emit("click", this.item, this.index);
    },
    isLongTitle(re) {
      return re.length > this.maxCharacters;
    },
    truncateIntoElipsis(re) {
      return this.isLongTitle(re) ? `${re.slice(0, this.maxCharacters)}...` : re;
    },
    handleToggle() {
      this.isEnabled = !this.isEnabled;
    },
    focusNextTabindex() {
      const re = this.$refs.listRef.$el.nextElementSibling;
      re && re.nextElementSibling && re.focus();
    },
    focusPrevTabindex() {
      const re = this.$refs.listRef.$el.nextElementSibling;
      re && re.previousElementSibling && re.previousElementSibling.focus();
    }
  }
};
function _sfc_render$r(re, ne, ae, ie, le, se) {
  const ce = HxToggleSwitch, ue = HxTooltip;
  return openBlock(), createElementBlock(Fragment, null, [
    createVNode(VListItem, {
      ref: "listRef",
      lines: "false",
      rounded: "lg",
      class: normalizeClass(se.itemClass),
      onClick: se.onClick
    }, createSlots({
      append: withCtx(() => [
        ae.item.showToggleSwitch ? (openBlock(), createBlock(ce, {
          key: 0,
          modelValue: se.isEnabled,
          "onUpdate:modelValue": ne[0] || (ne[0] = (de) => se.isEnabled = de),
          tabindex: -2,
          onClick: withModifiers(se.handleToggle, ["stop"]),
          onKeydown: [
            withKeys(se.focusNextTabindex, ["down"]),
            withKeys(se.focusPrevTabindex, ["up"])
          ]
        }, null, 8, ["modelValue", "onClick", "onKeydown"])) : createCommentVNode("", !0)
      ]),
      default: withCtx(() => [
        re.$slots.default ? renderSlot(re.$slots, "default", { key: 0 }, void 0, !0) : createCommentVNode("", !0),
        se.isLongTitle(ae.item.title) ? (openBlock(), createBlock(ue, {
          key: 1,
          id: "tooltip-direction",
          text: ae.item.title,
          location: re.tooltipDirection
        }, {
          default: withCtx((de) => [
            createVNode(VListItemTitle, normalizeProps(guardReactiveProps(de)), {
              default: withCtx(() => [
                createTextVNode(toDisplayString$1(se.truncateIntoElipsis(ae.item.title)), 1)
              ]),
              _: 2
            }, 1040)
          ]),
          _: 1
        }, 8, ["text", "location"])) : (openBlock(), createBlock(VListItemTitle, { key: 2 }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString$1(ae.item.title), 1)
          ]),
          _: 1
        }))
      ]),
      _: 2
    }, [
      ae.item.icon ? {
        name: "prepend",
        fn: withCtx(() => [
          createVNode(VIcon, {
            size: "24",
            icon: ae.item.icon,
            class: "hx-menu-item-icon"
          }, null, 8, ["icon"])
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["class", "onClick"]),
    ae.item.hasDivider ? (openBlock(), createBlock(VDivider, {
      key: 0,
      class: "hx-menu-divider"
    })) : createCommentVNode("", !0)
  ], 64);
}
const __unplugin_components_0$3 = /* @__PURE__ */ _export_sfc(_sfc_main$r, [["render", _sfc_render$r], ["__scopeId", "data-v-3b0b642d"]]), _sfc_main$q = {
  name: "HxMenu",
  components: {
    MenuItem: __unplugin_components_0$3
  },
  props: {
    ...menuProps,
    items: {
      type: Array,
      default: () => []
    },
    isToggled: {
      type: Boolean
    }
  },
  emits: ["click", "update:isToggled"],
  computed: {
    listClasses() {
      return {
        scrollable: this.items.length > 10,
        "scrollable-regular": this.items.length > 10 && this.regular,
        "scrollable-compact": this.items.length > 10 && this.compact
      };
    },
    menuLocation() {
      return this.items.length > 10 ? "start" : "bottom";
    },
    isEnabled: {
      get() {
        return this.isToggled;
      },
      set(re) {
        this.$emit("update:isToggled", re);
      }
    }
  },
  watch: {
    $props: {
      immediate: !0,
      handler() {
        this.validateProps();
      }
    }
  },
  methods: {
    onClick(re, ne) {
      this.$emit("click", re, ne);
    },
    validateProps() {
      this.compact && this.regular && console.error("Please use either compact or regular only");
    }
  }
};
function _sfc_render$q(re, ne, ae, ie, le, se) {
  const ce = __unplugin_components_0$3;
  return openBlock(), createBlock(VMenu, {
    class: "hx-menu",
    location: se.menuLocation
  }, createSlots({
    default: withCtx(() => [
      createVNode(VList, {
        class: normalizeClass(se.listClasses)
      }, {
        default: withCtx(() => [
          (openBlock(!0), createElementBlock(Fragment, null, renderList(ae.items, (ue, de) => (openBlock(), createBlock(ce, {
            key: de,
            "is-toggled": se.isEnabled,
            "onUpdate:isToggled": ne[0] || (ne[0] = (me) => se.isEnabled = me),
            item: ue,
            index: de,
            compact: re.compact,
            regular: re.regular,
            "max-characters": re.maxCharacters,
            "tooltip-direction": re.tooltipDirection,
            onClick: se.onClick
          }, {
            default: withCtx(() => [
              renderSlot(re.$slots, `item-${de}`, {
                item: ue,
                index: de
              }, void 0, !0)
            ]),
            _: 2
          }, 1032, ["is-toggled", "item", "index", "compact", "regular", "max-characters", "tooltip-direction", "onClick"]))), 128))
        ]),
        _: 3
      }, 8, ["class"])
    ]),
    _: 2
  }, [
    re.$slots.default ? {
      name: "activator",
      fn: withCtx(({ props: ue }) => [
        renderSlot(re.$slots, "default", normalizeProps(guardReactiveProps(ue)), void 0, !0)
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["location"]);
}
const HxMenu = /* @__PURE__ */ _export_sfc(_sfc_main$q, [["render", _sfc_render$q], ["__scopeId", "data-v-534f7b08"]]), _sfc_main$p = {
  name: "HxLinearProgress",
  props: {
    value: {
      type: Number,
      default: 0,
      required: !0,
      validator: (re) => re < 0 ? (console.error("Value cannot be a negative integer for Helix Linear Progress"), !1) : !0
    },
    total: {
      type: Number,
      default: null,
      required: !0,
      validator: (re) => re <= 0 ? (console.error("Invalid total for Helix Linear Progress"), !1) : !0
    },
    unit: {
      type: String,
      default: "Tasks",
      required: !0
    },
    state: {
      type: String,
      default: "ok",
      required: !0,
      validator: (re) => ["ok", "warning", "error"].includes(re) ? !0 : (console.error("Invalid state for Helix Linear Progress"), !1)
    }
  },
  computed: {
    percentage() {
      return this.value > this.total ? (console.warn("Value exceeds total, capping at 100% for Helix Linear Progress"), 100) : Math.round(this.value / this.total * 100);
    },
    progressClass() {
      const re = ["hx-linear-progress"];
      return this.state === "warning" ? re.concat("warning").join(" ") : this.state === "error" ? re.concat("error").join(" ") : this.percentage > 0 && this.percentage < 100 ? re.concat("ongoing").join(" ") : this.percentage === 100 ? re.concat("complete").join(" ") : re.join(" ");
    },
    helperText() {
      const re = this.unit.charAt(0).toUpperCase() + this.unit.slice(1);
      return `${this.value}/${this.total} ${re} complete`;
    }
  }
}, _hoisted_1$l = { class: "hx-linear-progress-text" };
function _sfc_render$p(re, ne, ae, ie, le, se) {
  return openBlock(), createElementBlock(Fragment, null, [
    createVNode(VProgressLinear, {
      class: normalizeClass(se.progressClass),
      "model-value": se.percentage,
      rounded: "",
      "rounded-bar": "",
      height: "8"
    }, null, 8, ["class", "model-value"]),
    createElementVNode("div", _hoisted_1$l, toDisplayString$1(se.helperText), 1)
  ], 64);
}
const HxLinearProgress = /* @__PURE__ */ _export_sfc(_sfc_main$p, [["render", _sfc_render$p], ["__scopeId", "data-v-34031830"]]), _sfc_main$o = {
  name: "BreadcrumbsRegular",
  props: {
    id: { type: String, default: "" },
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isCollapse: !1,
      breadcrumbsOriginalWidth: 0,
      resizeObserver: null
    };
  },
  computed: {
    computedItems() {
      return this.isCollapse && this.items.length > 2 ? [this.items[0], this.items[this.items.length - 1]] : this.items;
    },
    menuItems() {
      return this.items.slice(1, -1).map((re) => ({ title: re.text, to: re.to, text: re.text }));
    }
  },
  watch: {
    items: {
      handler() {
        this.isCollapse = !1;
        const re = this.$refs.breadcrumbsRef.$el;
        this.$nextTick(() => {
          this.breadcrumbsOriginalWidth = re.clientWidth, this.checkOverflow();
        });
      }
    }
  },
  mounted() {
    const re = this.$refs.breadcrumbsRef.$el;
    this.$nextTick(() => {
      this.breadcrumbsOriginalWidth = re.clientWidth, this.checkOverflow();
    }), this.resizeObserver = new ResizeObserver(this.checkOverflow), this.resizeObserver.observe(this.$refs.containerRef);
  },
  beforeUnmount() {
    this.resizeObserver && (this.resizeObserver.unobserve(this.$refs.containerRef), this.resizeObserver.disconnect());
  },
  methods: {
    checkOverflow() {
      this.$refs.containerRef.clientWidth < this.breadcrumbsOriginalWidth ? this.isCollapse = !0 : this.isCollapse = !1;
    },
    onClick(re) {
      const ne = re.to || re.path;
      ne && this.$router.push(ne);
    }
  }
}, _hoisted_1$k = {
  ref: "containerRef",
  class: "hx-breadcrumbs-container"
}, _hoisted_2$d = {
  key: 0,
  class: "collapsed-items"
}, _hoisted_3$7 = ["href", "onClick"];
function _sfc_render$o(re, ne, ae, ie, le, se) {
  const ce = HxMenu;
  return openBlock(), createElementBlock("div", _hoisted_1$k, [
    createVNode(VBreadcrumbs, {
      id: ae.id,
      ref: "breadcrumbsRef",
      items: se.computedItems,
      class: "hx-breadcrumbs"
    }, {
      divider: withCtx(() => [
        le.isCollapse && ae.items.length > 2 ? (openBlock(), createElementBlock("div", _hoisted_2$d, [
          createVNode(VIcon, {
            icon: "mdi-chevron-right",
            class: "hx-breadcrumbs-divider"
          }),
          createVNode(ce, {
            items: se.menuItems,
            regular: "",
            "open-on-hover": "",
            location: "bottom",
            onClick: se.onClick
          }, {
            default: withCtx((ue) => [
              createElementVNode("span", mergeProps(ue, {
                tabindex: "0",
                class: "hx-breadcrumbs-item"
              }), "...", 16)
            ]),
            _: 1
          }, 8, ["items", "onClick"]),
          createVNode(VIcon, {
            icon: "mdi-chevron-right",
            class: "hx-breadcrumbs-divider"
          })
        ])) : (openBlock(), createBlock(VIcon, {
          key: 1,
          icon: "mdi-chevron-right",
          class: "hx-breadcrumbs-divider"
        }))
      ]),
      item: withCtx(({ item: ue }) => [
        createVNode(VBreadcrumbsItem, {
          class: "hx-breadcrumbs-item",
          disabled: ue.disabled
        }, {
          default: withCtx(() => [
            createElementVNode("a", {
              href: ue.to,
              class: "hx-breadcrumbs-item--link",
              onClick: withModifiers(() => se.onClick(ue), ["prevent"])
            }, toDisplayString$1(ue.text), 9, _hoisted_3$7)
          ]),
          _: 2
        }, 1032, ["disabled"])
      ]),
      default: withCtx(() => [
        createVNode(VIcon, {
          icon: "mdi-chevron-right",
          class: "hx-breadcrumbs-divider last"
        })
      ]),
      _: 1
    }, 8, ["id", "items"])
  ], 512);
}
const __unplugin_components_1 = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["render", _sfc_render$o], ["__scopeId", "data-v-96a87c1a"]]), _sfc_main$n = {
  name: "BreadcrumbsCompact",
  props: {
    id: { type: String, default: "" },
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    showHierarchy() {
      if (this.items.length > 1)
        return this.items.slice(-1);
    },
    menuItems() {
      return this.items.length === 1 ? this.items.map((re) => ({ title: re.text, to: re.to, text: re.text })) : this.items.slice(0, -1).map((re) => ({ title: re.text, to: re.to, text: re.text }));
    },
    showLastDivider() {
      return !!this.showHierarchy;
    }
  },
  methods: {
    onClick(re) {
      const ne = re.to || re.path;
      ne && this.$router.push(ne);
    }
  }
}, _hoisted_1$j = { class: "hx-breadcrumbs-prepend mr-1" }, _hoisted_2$c = ["href", "onClick"];
function _sfc_render$n(re, ne, ae, ie, le, se) {
  const ce = HxMenu;
  return openBlock(), createBlock(VBreadcrumbs, {
    id: ae.id,
    class: "breadcrumbs-compact",
    items: se.showHierarchy
  }, {
    prepend: withCtx(() => [
      createElementVNode("div", _hoisted_1$j, [
        createVNode(ce, {
          items: se.menuItems,
          compact: "",
          onClick: se.onClick
        }, {
          default: withCtx((ue) => [
            createVNode(VIcon, mergeProps(ue, {
              icon: "mdi-menu",
              class: "hx-menu-icon mr-1",
              tabindex: "-1"
            }), null, 16)
          ]),
          _: 1
        }, 8, ["items", "onClick"]),
        createVNode(VIcon, {
          icon: "mdi-chevron-right",
          class: "hx-breadcrumbs-divider"
        })
      ])
    ]),
    item: withCtx(({ item: ue }) => [
      createVNode(VBreadcrumbsItem, { class: "hx-breadcrumbs-item" }, {
        default: withCtx(() => [
          createElementVNode("a", {
            href: ue.to,
            class: "hx-breadcrumbs-item--link",
            onClick: withModifiers(() => se.onClick(ue), ["prevent"])
          }, toDisplayString$1(ue.text), 9, _hoisted_2$c)
        ]),
        _: 2
      }, 1024)
    ]),
    default: withCtx(() => [
      se.showLastDivider ? (openBlock(), createBlock(VIcon, {
        key: 0,
        icon: "mdi-chevron-right",
        class: "hx-breadcrumbs-divider ml-1"
      })) : createCommentVNode("", !0)
    ]),
    _: 1
  }, 8, ["id", "items"]);
}
const __unplugin_components_0$2 = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["render", _sfc_render$n], ["__scopeId", "data-v-5cec7c14"]]), _sfc_main$m = {
  name: "HxBreadcrumbs",
  components: {
    BreadcrumbsCompact: __unplugin_components_0$2,
    BreadcrumbsRegular: __unplugin_components_1
  },
  props: {
    id: { type: String, default: "" },
    items: {
      type: Array,
      default: () => [],
      validator(re) {
        return re.length > 0 && re.every(
          (ne) => typeof ne == "object" && "text" in ne && typeof ne.text == "string" && "key" in ne && typeof ne.key == "string" && "to" in ne && typeof ne.to == "string"
        ) ? !0 : (console.error(
          "Please include an array of objects with text, key, and to properties in the items prop for HxBreadcrumbs"
        ), !1);
      }
    },
    regular: {
      type: Boolean,
      default: !1
    },
    compact: {
      type: Boolean,
      default: !1
    }
  },
  watch: {
    $props: {
      immediate: !0,
      handler() {
        this.validateProps();
      }
    }
  },
  methods: {
    validateProps() {
      (this.regular && this.compact || !this.regular && !this.compact) && console.error("Please include either regular or compact prop");
    }
  }
};
function _sfc_render$m(re, ne, ae, ie, le, se) {
  const ce = __unplugin_components_0$2, ue = __unplugin_components_1;
  return ae.compact ? (openBlock(), createBlock(ce, {
    key: 0,
    id: ae.id,
    items: ae.items
  }, null, 8, ["id", "items"])) : (openBlock(), createBlock(ue, {
    key: 1,
    id: ae.id,
    items: ae.items
  }, null, 8, ["id", "items"]));
}
const HxBreadcrumbs = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["render", _sfc_render$m]]), _sfc_main$l = {
  name: "HxHeader",
  props: {
    breadcrumbItems: {
      type: Array,
      default: () => []
    },
    headerText: {
      type: String,
      default: ""
    },
    chips: {
      type: Array,
      default: () => []
    },
    tooltipLocation: {
      type: String,
      default: "top"
    }
  },
  data() {
    return {
      isTruncated: !1,
      useH2Style: !1
    };
  },
  computed: {
    headerTextClasses() {
      const re = [];
      return this.useH2Style ? re.push("h2") : re.push("h1"), this.isTruncated && re.push("text-truncate"), re;
    }
  },
  watch: {
    headerText() {
      this.useH2Style = !1, this.isTruncated = !1, this.$nextTick(() => {
        this.checkTextOverflow();
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.checkTextOverflow();
    }), window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.$nextTick(() => {
        this.checkTextOverflow();
      });
    },
    checkTextOverflow() {
      const re = this.$refs.headerTextRef;
      re && (this.useH2Style = !1, this.isTruncated = !1, this.$nextTick(() => {
        re.scrollWidth > re.clientWidth && (this.useH2Style = !0, this.$nextTick(() => {
          re.scrollWidth > re.clientWidth && (this.isTruncated = !0);
        }));
      }));
    }
  }
}, _hoisted_1$i = { class: "hx-header" }, _hoisted_2$b = {
  key: 0,
  class: "breadcrumbs-container"
}, _hoisted_3$6 = { class: "d-flex flex-wrap align-center" }, _hoisted_4$4 = { key: 2 };
function _sfc_render$l(re, ne, ae, ie, le, se) {
  const ce = HxBreadcrumbs, ue = HxTooltip, de = HxChip;
  return openBlock(), createElementBlock("div", _hoisted_1$i, [
    createElementVNode("div", null, [
      ae.breadcrumbItems && ae.breadcrumbItems.length ? (openBlock(), createElementBlock("div", _hoisted_2$b, [
        createVNode(ce, {
          regular: "",
          items: ae.breadcrumbItems
        }, null, 8, ["items"])
      ])) : createCommentVNode("", !0),
      createElementVNode("div", _hoisted_3$6, [
        ae.headerText && le.isTruncated ? (openBlock(), createBlock(ue, {
          key: 0,
          id: "header-tooltip",
          text: ae.headerText,
          location: ae.tooltipLocation
        }, {
          default: withCtx((me) => [
            createElementVNode("div", mergeProps(me, {
              ref: "headerTextRef",
              class: [se.headerTextClasses, "header-text"]
            }), toDisplayString$1(ae.headerText), 17)
          ]),
          _: 1
        }, 8, ["text", "location"])) : ae.headerText ? (openBlock(), createElementBlock("div", {
          key: 1,
          ref: "headerTextRef",
          class: normalizeClass([se.headerTextClasses, "header-text"])
        }, toDisplayString$1(ae.headerText), 3)) : createCommentVNode("", !0),
        ae.chips && ae.chips.length ? (openBlock(), createElementBlock("div", _hoisted_4$4, [
          (openBlock(!0), createElementBlock(Fragment, null, renderList(ae.chips, (me, fe) => (openBlock(), createBlock(de, mergeProps({
            key: fe,
            "show-left-icon": !!me.leftIcon,
            ref_for: !0
          }, me, { class: "mr-2" }), null, 16, ["show-left-icon"]))), 128))
        ])) : createCommentVNode("", !0)
      ])
    ]),
    createVNode(VDivider)
  ]);
}
const HxHeader = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["render", _sfc_render$l], ["__scopeId", "data-v-7d462c91"]]), _sfc_main$k = {
  name: "HxTabs",
  provide() {
    return {
      selectedTab: computed(() => this.internalTab)
    };
  },
  props: {
    id: { type: String, default: "" },
    modelValue: {
      type: [String, Number],
      default: null
    },
    height: {
      type: [String, Number],
      default: 42
    },
    alignTabs: {
      type: String,
      default: "start",
      validator: (re) => ["start", "center", "end"].includes(re)
    },
    /**
     * Whether tabs should grow to fill available space
     */
    grow: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether to show the content panel below the tabs
     */
    showContent: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      internalTab: this.modelValue
    };
  },
  watch: {
    modelValue(re) {
      re !== null && re !== this.internalTab && (this.internalTab = re);
    },
    internalTab(re) {
      this.$emit("update:modelValue", re);
    }
  }
}, _hoisted_1$h = ["id"];
function _sfc_render$k(re, ne, ae, ie, le, se) {
  return openBlock(), createElementBlock("div", {
    id: ae.id,
    class: "hx-tabs"
  }, [
    createVNode(VTabs, {
      modelValue: le.internalTab,
      "onUpdate:modelValue": ne[0] || (ne[0] = (ce) => le.internalTab = ce),
      "align-tabs": ae.alignTabs,
      grow: ae.grow,
      "show-arrows": "",
      height: ae.height,
      class: "hx-tabs-header"
    }, {
      default: withCtx(() => [
        renderSlot(re.$slots, "default")
      ]),
      _: 3
    }, 8, ["modelValue", "align-tabs", "grow", "height"]),
    ae.showContent ? (openBlock(), createBlock(VTabsWindow, {
      key: 0,
      modelValue: le.internalTab,
      "onUpdate:modelValue": ne[1] || (ne[1] = (ce) => le.internalTab = ce),
      class: "hx-tabs-content"
    }, {
      default: withCtx(() => [
        renderSlot(re.$slots, "content")
      ]),
      _: 3
    }, 8, ["modelValue"])) : createCommentVNode("", !0)
  ], 8, _hoisted_1$h);
}
const HxTabs = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["render", _sfc_render$k]]), _sfc_main$j = {
  name: "HxTab",
  inject: ["selectedTab"],
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    title: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    badge: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  computed: {
    classes() {
      const re = ["hx-tab"];
      return this.isSelected && re.push("selected"), this.disabled && re.push("disabled"), this.badge && re.push("has-badge"), re;
    },
    tabClass() {
      return this.classes.join(" ");
    },
    isSelected() {
      return this.selectedTab === this.value;
    }
  }
}, _hoisted_1$g = { class: "tab-text" };
function _sfc_render$j(re, ne, ae, ie, le, se) {
  return openBlock(), createBlock(VTab, {
    value: ae.value,
    disabled: ae.disabled,
    class: normalizeClass(se.tabClass),
    ripple: !1,
    variant: "plain",
    onClick: ne[0] || (ne[0] = (ce) => re.$emit("click", ae.value))
  }, {
    default: withCtx(() => [
      ae.icon ? (openBlock(), createBlock(VIcon, {
        key: 0,
        icon: ae.icon,
        size: "24",
        class: "tab-icon"
      }, null, 8, ["icon"])) : createCommentVNode("", !0),
      createElementVNode("span", _hoisted_1$g, [
        renderSlot(re.$slots, "default", {}, () => [
          createTextVNode(toDisplayString$1(ae.title), 1)
        ], !0)
      ]),
      ae.badge ? (openBlock(), createBlock(VIcon, {
        key: 1,
        icon: "mdi-circle",
        size: "6",
        class: "tab-badge"
      })) : createCommentVNode("", !0),
      ne[1] || (ne[1] = createElementVNode("div", { class: "custom-slider" }, null, -1))
    ]),
    _: 3
  }, 8, ["value", "disabled", "class"]);
}
const HxTab = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["render", _sfc_render$j], ["__scopeId", "data-v-5fc7050f"]]), _sfc_main$i = {
  name: "HxTabContent",
  props: {
    /**
     * The value of the tab content, must match the corresponding tab value
     */
    value: {
      type: [String, Number],
      required: !0
    }
  }
};
function _sfc_render$i(re, ne, ae, ie, le, se) {
  return openBlock(), createBlock(VTabsWindowItem, {
    value: ae.value,
    class: "hx-tab-content"
  }, {
    default: withCtx(() => [
      renderSlot(re.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  }, 8, ["value"]);
}
const HxTabContent = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["render", _sfc_render$i], ["__scopeId", "data-v-e5357bff"]]), avatarProps = {
  id: { type: String, default: "" },
  size: {
    type: String,
    default: "medium",
    validator: (re) => ["small", "medium", "large", "extra-large"].includes(re) ? !0 : (console.error("Invalid size for a Helix Avatar"), !1)
  },
  type: {
    type: String,
    default: "initial",
    validator: (re) => ["initial", "image"].includes(re) ? !0 : (console.error("Invalid type for a Helix Avatar"), !1)
  },
  name: { type: String, default: "", required: !0 },
  initials: { type: String, default: "" },
  image: { type: String, default: "" },
  alt: { type: String, default: "" },
  generateColor: { type: Boolean, default: !0 },
  tooltipText: {
    type: String,
    default: ""
  }
}, _sfc_main$h = {
  name: "HxAvatarBase",
  props: {
    ...avatarProps
  },
  computed: {
    classes() {
      let re = ["hx-avatar-base"];
      return this.size && (re = re.concat(`size-${this.size}`)), this.type && (re = re.concat(`type-${this.type}`)), this.generateColor ? re = re.concat("color-generated") : re = re.concat("color-default"), re;
    },
    avatarClass() {
      return this.classes.join(" ");
    },
    avatarSize() {
      return this.size === "small" ? "24" : this.size === "large" ? "56" : this.size === "extra-large" ? "80" : "40";
    },
    computedInitials() {
      if (this.initials)
        return this.initials.substring(0, 3);
      if (this.name) {
        const ne = this.name.split(/[^a-zA-Z]+/).map((ae) => ae.charAt(0)).join("");
        return ne.length > 3 ? `${ne.charAt(0)}${ne.slice(-2)}` : ne;
      }
      return "";
    },
    initialsClass() {
      return this.type === "initial" ? this.computedInitials.length >= 3 ? "three-initials" : "two-initials" : "";
    },
    avatarStyle() {
      return this.type === "initial" && this.generateColor ? {
        backgroundColor: this.stringToHslColor(this.name)
      } : {};
    }
  },
  methods: {
    stringToHslColor(re) {
      if (!re || re.length === 0) return "hsl(184 67.5% 32.5%)";
      let ne = 0;
      return [...re].forEach((ie, le) => {
        ne = re.charCodeAt(le) + ((ne << 5) - ne);
      }), `hsl(${Math.abs(ne) % 360}, 30%, 50%)`;
    }
  }
};
function _sfc_render$h(re, ne, ae, ie, le, se) {
  const ce = HxTooltip;
  return re.name ? (openBlock(), createBlock(ce, {
    key: 0,
    text: re.tooltipText || re.name,
    location: "bottom"
  }, {
    default: withCtx((ue) => [
      createVNode(VAvatar, mergeProps({
        id: re.id,
        tabindex: "0",
        class: se.avatarClass,
        size: se.avatarSize,
        style: se.avatarStyle
      }, ue, toHandlers(re.$attrs)), {
        default: withCtx(() => [
          re.type === "image" && re.image ? (openBlock(), createBlock(VImg, {
            key: 0,
            src: re.image,
            alt: re.alt || "User avatar",
            cover: ""
          }, null, 8, ["src", "alt"])) : (openBlock(), createElementBlock("span", {
            key: 1,
            class: normalizeClass(se.initialsClass)
          }, toDisplayString$1(se.computedInitials), 3))
        ]),
        _: 2
      }, 1040, ["id", "class", "size", "style"])
    ]),
    _: 1
  }, 8, ["text"])) : createCommentVNode("", !0);
}
const __unplugin_components_0$1 = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["render", _sfc_render$h], ["__scopeId", "data-v-c11a0849"]]), _sfc_main$g = {
  name: "HxAvatar",
  components: {
    HxAvatarBase: __unplugin_components_0$1
  },
  props: {
    ...avatarProps,
    // Additional details props
    showDetails: { type: Boolean, default: !1 },
    chipProps: {
      type: Object,
      default: () => ({})
    },
    label: { type: String, default: "" },
    nameText: { type: String, default: "" },
    subtitleText: { type: String, default: "" },
    emailText: { type: String, default: "" }
  }
}, _hoisted_1$f = ["id"], _hoisted_2$a = {
  key: 0,
  class: "field-label"
}, _hoisted_3$5 = { class: "avatar-content" }, _hoisted_4$3 = {
  key: 0,
  class: "avatar-text"
}, _hoisted_5$1 = { class: "avatar-name-container" }, _hoisted_6$1 = { class: "avatar-name" }, _hoisted_7$1 = {
  key: 0,
  class: "avatar-subtitle"
}, _hoisted_8 = ["href"];
function _sfc_render$g(re, ne, ae, ie, le, se) {
  const ce = __unplugin_components_0$1, ue = HxChip;
  return openBlock(), createElementBlock("div", {
    id: re.id,
    class: "hx-avatar"
  }, [
    ae.showDetails && ae.label ? (openBlock(), createElementBlock("div", _hoisted_2$a, toDisplayString$1(ae.label), 1)) : createCommentVNode("", !0),
    createElementVNode("div", _hoisted_3$5, [
      createVNode(ce, {
        size: re.size,
        type: re.type,
        initials: re.initials,
        image: re.image,
        alt: re.alt,
        "generate-color": re.generateColor,
        name: re.name,
        "tooltip-text": re.tooltipText
      }, null, 8, ["size", "type", "initials", "image", "alt", "generate-color", "name", "tooltip-text"]),
      ae.showDetails ? (openBlock(), createElementBlock("div", _hoisted_4$3, [
        createElementVNode("div", _hoisted_5$1, [
          createElementVNode("div", _hoisted_6$1, toDisplayString$1(ae.nameText || re.name), 1),
          ae.chipProps.label ? (openBlock(), createBlock(ue, mergeProps({
            key: 0,
            type: "static",
            color: "teal"
          }, ae.chipProps), null, 16)) : createCommentVNode("", !0)
        ]),
        ae.subtitleText ? (openBlock(), createElementBlock("div", _hoisted_7$1, toDisplayString$1(ae.subtitleText), 1)) : createCommentVNode("", !0),
        ae.emailText ? (openBlock(), createElementBlock("a", {
          key: 1,
          href: `mailto:${ae.emailText}`,
          class: "avatar-email"
        }, toDisplayString$1(ae.emailText), 9, _hoisted_8)) : createCommentVNode("", !0)
      ])) : createCommentVNode("", !0)
    ])
  ], 8, _hoisted_1$f);
}
const HxAvatar = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["render", _sfc_render$g], ["__scopeId", "data-v-78a69e2f"]]), ideagenLogo = "data:image/png;base64,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", productLogo = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20id='Layer_1'%20data-name='Layer%201'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20300%20300'%3e%3cdefs%3e%3cstyle%3e%20.cls-1%20{%20fill:%20%23e2408e;%20}%20.cls-2%20{%20fill:%20%23f4f4f4;%20}%20%3c/style%3e%3c/defs%3e%3cpolygon%20class='cls-2'%20points='279.84808%2074.97003%20149.99994%200%2020.10004%2075%2020.10004%20225%20149.99994%20300%20279.89996%20225%20279.89996%20224.94%20279.89996%2075%20279.89996%2074.94%20279.84808%2074.97003'/%3e%3cpath%20class='cls-1'%20d='M105.75,105.75c0-8.13555,6.61445-14.75,14.75-14.75h34.45508c3.91797,0,7.67461,1.54414,10.44023,4.30976l24.54492,24.56797c2.76562,2.76562,4.30977,6.52227,4.30977,10.44024v63.93203c0,8.13554-6.61446,14.75-14.75,14.75h-59c-8.13555,0-14.75-6.61446-14.75-14.75v-88.5ZM153.6875,104.48242v21.54883c0,3.06524,2.46602,5.53125,5.53125,5.53125h21.54883l-27.08008-27.08008ZM169.45156,158.45821c1.61328-2.58125.82969-5.99219-1.75156-7.62852-2.58125-1.63633-5.99219-.82969-7.62851,1.75156l-14.15079,22.65508-6.22266-8.29688c-1.84375-2.44297-5.30078-2.95-7.74375-1.10625-2.44297,1.84375-2.95,5.30078-1.10625,7.74374l11.0625,14.75c1.08321,1.45196,2.83477,2.28165,4.65547,2.2125,1.8207-.06914,3.48008-1.03711,4.44804-2.60429l18.4375-29.5v.02305Z'/%3e%3c/svg%3e", _sfc_main$f = {
  name: "HxHomebarHorizontal",
  props: {
    avatarType: {
      type: String,
      default: "initial",
      validator: (re) => ["initial", "image"].includes(re) ? !0 : (console.error("Invalid type for a Helix Avatar in Helix Homebar Horizontal"), !1)
    },
    name: {
      type: String,
      required: !0
    },
    avatarImage: {
      type: String,
      default: ""
    },
    email: {
      type: String,
      required: !0
    },
    showSiteSettings: {
      type: Boolean,
      default: !0
    },
    showBetaTester: {
      type: Boolean,
      default: !0
    }
  },
  emits: [
    "product-logo-click",
    "help-click",
    "profile-header-click",
    "site-settings-click",
    "beta-tester-click",
    "feedback-click",
    "about-click",
    "sign-out-click"
  ],
  data() {
    return {
      ideagenLogo,
      productLogo
    };
  },
  computed: {
    showLongProfileText() {
      return this.name.length > 27 || this.email.length > 27;
    },
    truncatedName() {
      return this.name.length > 27 ? `${this.name.slice(0, 27)}...` : this.name;
    },
    truncatedEmail() {
      return this.email.length > 27 ? `${this.email.slice(0, 27)}...` : this.email;
    },
    profileTooltipText() {
      return [this.name, this.email].join(`
`);
    },
    manageProfileItems() {
      const re = [
        {
          title: "",
          action: "profile-header",
          hasDivider: !0
        }
      ];
      return this.showSiteSettings && re.push({
        title: "Site Settings",
        action: "site-settings",
        icon: "mdi-cog",
        hasDivider: !0
      }), this.showBetaTester && re.push({
        title: "Become a BETA tester",
        action: "beta-tester",
        icon: "$i-rocket",
        hasDivider: !1
      }), re.push(
        {
          title: "Give Feedback",
          action: "feedback",
          icon: "$i-report"
        },
        {
          title: "About Ideagen",
          action: "about",
          icon: "$i-ideagen-color",
          hasDivider: !0
        },
        {
          title: "Sign Out",
          action: "sign-out",
          icon: "mdi-logout",
          color: "red"
        }
      ), re;
    }
  },
  methods: {
    onProductClick() {
      this.$emit("product-logo-click");
    },
    onHelpClick() {
      this.$emit("help-click");
    },
    manageProfileClick(re, ne) {
      const ae = this.manageProfileItems[ne];
      this.$emit(`${ae.action}-click`);
    }
  }
}, _hoisted_1$e = { class: "hx-homebar-horizontal__product-logo-label" }, _hoisted_2$9 = ["src"], _hoisted_3$4 = { class: "hx-homebar-horizontal__container" }, _hoisted_4$2 = ["src"];
function _sfc_render$f(re, ne, ae, ie, le, se) {
  const ce = resolveComponent("RouterLink"), ue = HxButton, de = HxAvatar, me = HxTooltip, fe = HxMenu;
  return openBlock(), createBlock(VAppBar, {
    color: "primary",
    class: "hx-homebar-horizontal"
  }, {
    prepend: withCtx(() => [
      createVNode(ce, {
        to: "/",
        class: "hx-homebar-horizontal__product-logo",
        onClick: se.onProductClick
      }, {
        default: withCtx(() => [
          createElementVNode("div", _hoisted_1$e, [
            createElementVNode("img", {
              src: le.productLogo,
              alt: "Product Logo",
              "max-width": "220px",
              height: "40px"
            }, null, 8, _hoisted_2$9),
            ne[1] || (ne[1] = createElementVNode("h3", null, "Ideagen Policy Logic", -1))
          ])
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    append: withCtx(() => [
      createElementVNode("div", _hoisted_3$4, [
        createElementVNode("a", {
          href: "https://complispace.help.ideagen.com/hc/en-gb",
          target: "_blank",
          rel: "noopener noreferrer",
          "aria-label": "Help",
          onClick: ne[0] || (ne[0] = (...pe) => se.onHelpClick && se.onHelpClick(...pe))
        }, [
          createVNode(ue, {
            size: "large",
            variant: "white",
            ghost: "",
            "left-icon": "mdi-help-circle-outline"
          })
        ]),
        createVNode(fe, {
          items: se.manageProfileItems,
          class: "hx-homebar-horizontal__menu",
          onClick: se.manageProfileClick
        }, {
          default: withCtx((pe) => [
            createVNode(de, mergeProps({ id: "homebar-avatar" }, pe, {
              type: ae.avatarType,
              image: ae.avatarType === "image" ? ae.avatarImage : void 0,
              alt: "Homebar Avatar",
              name: ae.name
            }), null, 16, ["type", "image", "name"])
          ]),
          "item-0": withCtx(() => [
            se.showLongProfileText ? (openBlock(), createBlock(me, {
              key: 0,
              id: "avatar-header-tooltip",
              text: se.profileTooltipText,
              location: "left"
            }, {
              default: withCtx((pe) => [
                createVNode(de, mergeProps({ id: "avatar-header" }, pe, {
                  "show-details": !0,
                  name: se.truncatedName,
                  "email-text": se.truncatedEmail,
                  type: ae.avatarType,
                  image: ae.avatarType === "image" ? ae.avatarImage : void 0
                }), null, 16, ["name", "email-text", "type", "image"])
              ]),
              _: 1
            }, 8, ["text"])) : (openBlock(), createBlock(de, {
              key: 1,
              "show-details": !0,
              name: se.truncatedName,
              "email-text": se.truncatedEmail,
              type: ae.avatarType,
              image: ae.avatarType === "image" ? ae.avatarImage : void 0
            }, null, 8, ["name", "email-text", "type", "image"]))
          ]),
          _: 1
        }, 8, ["items", "onClick"]),
        createElementVNode("img", {
          src: le.ideagenLogo,
          alt: "Ideagen Logo",
          width: "120px",
          height: "40px"
        }, null, 8, _hoisted_4$2)
      ])
    ]),
    _: 1
  });
}
const HxHomebarHorizontal = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["render", _sfc_render$f], ["__scopeId", "data-v-6d861833"]]), _sfc_main$e = {
  name: "HxToolbar",
  props: {
    id: { type: String, default: "" },
    headerIcon: { type: String, default: "mdi-plus-circle-outline" },
    headerTitle: { type: String, default: "Title" },
    width: {
      type: Number,
      default: 292,
      validator: (re) => re < 292 ? (console.error("Require width for a Helix toolbar to be at least 292px"), !1) : !0
    },
    collapsed: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["update:collapsed"],
  data() {
    return {
      drawer: !0,
      isTruncated: !1
    };
  },
  computed: {
    rail: {
      get() {
        return this.collapsed;
      },
      set(re) {
        this.$emit("update:collapsed", re);
      }
    },
    toolbarClasses() {
      let re = ["hx-toolbar"];
      return this.rail ? re = re.concat("collapsed") : re = re.concat("expanded"), re.join(" ");
    }
  },
  watch: {
    headerTitle() {
      this.checkIsTitleOverflow();
    }
  },
  methods: {
    checkIsTitleOverflow() {
      this.$nextTick(() => {
        const re = this.$refs.headerTitleRef.$el;
        this.isTruncated = re.scrollWidth > re.clientWidth;
      });
    }
  }
}, _hoisted_1$d = { class: "hx-toolbar__header" }, _hoisted_2$8 = { class: "hx-toolbar__body" }, _hoisted_3$3 = { class: "hx-toolbar__footer" };
function _sfc_render$e(re, ne, ae, ie, le, se) {
  const ce = HxTooltip, ue = HxButton;
  return openBlock(), createBlock(VNavigationDrawer, {
    modelValue: le.drawer,
    "onUpdate:modelValue": ne[1] || (ne[1] = (de) => le.drawer = de),
    class: normalizeClass(se.toolbarClasses),
    location: "right",
    rail: se.rail,
    "header-icon": ae.headerIcon,
    "header-title": ae.headerTitle,
    width: ae.width,
    "rail-width": "80",
    permanent: "",
    onTransitionend: se.checkIsTitleOverflow,
    onClick: ne[2] || (ne[2] = (de) => se.rail = !1)
  }, {
    default: withCtx(() => [
      createElementVNode("div", _hoisted_1$d, [
        createVNode(VListItem, { "min-height": "24" }, {
          prepend: withCtx(() => [
            renderSlot(re.$slots, "header-prepend", {}, () => [
              createElementVNode("div", null, [
                se.rail ? (openBlock(), createBlock(ce, {
                  key: 0,
                  id: "header-icon-tooltip",
                  text: ae.headerTitle,
                  location: "left"
                }, {
                  default: withCtx((de) => [
                    createVNode(VIcon, mergeProps(de, { class: "hx-toolbar__header-icon" }), {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(ae.headerIcon), 1)
                      ]),
                      _: 2
                    }, 1040)
                  ]),
                  _: 1
                }, 8, ["text"])) : (openBlock(), createBlock(VIcon, {
                  key: 1,
                  class: "hx-toolbar__header-icon"
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString$1(ae.headerIcon), 1)
                  ]),
                  _: 1
                }))
              ])
            ], !0)
          ]),
          default: withCtx(() => [
            le.isTruncated ? (openBlock(), createBlock(ce, {
              key: 0,
              id: "header-title-tooltip",
              text: ae.headerTitle,
              location: "bottom"
            }, {
              default: withCtx((de) => [
                createVNode(VListItemTitle, mergeProps(de, {
                  ref: "headerTitleRef",
                  class: "hx-toolbar__header-title"
                }), {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString$1(ae.headerTitle), 1)
                  ]),
                  _: 2
                }, 1040)
              ]),
              _: 1
            }, 8, ["text"])) : (openBlock(), createBlock(VListItemTitle, {
              key: 1,
              ref: "headerTitleRef",
              class: "hx-toolbar__header-title"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString$1(ae.headerTitle), 1)
              ]),
              _: 1
            }, 512))
          ]),
          _: 3
        })
      ]),
      createElementVNode("div", _hoisted_2$8, [
        se.rail ? createCommentVNode("", !0) : renderSlot(re.$slots, "default", { key: 0 }, void 0, !0)
      ]),
      createElementVNode("div", _hoisted_3$3, [
        createVNode(VListItem, null, {
          prepend: withCtx(() => [
            createVNode(ue, {
              class: "hx-toolbar__footer-action-button",
              size: "large",
              ghost: !0,
              "left-icon": se.rail ? "$i-action-right-expand" : "$i-action-right-collapse",
              onClick: ne[0] || (ne[0] = withModifiers((de) => se.rail = !se.rail, ["stop"]))
            }, null, 8, ["left-icon"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 3
  }, 8, ["modelValue", "class", "rail", "header-icon", "header-title", "width", "onTransitionend"]);
}
const HxToolbar = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["render", _sfc_render$e], ["__scopeId", "data-v-59b34d35"]]), _sfc_main$d = {
  name: "HxToolbarBodySection"
}, _hoisted_1$c = { class: "hx-toolbar__body-section" };
function _sfc_render$d(re, ne, ae, ie, le, se) {
  return openBlock(), createBlock(VListItem, { density: "comfortable" }, {
    default: withCtx(() => [
      createElementVNode("div", _hoisted_1$c, [
        renderSlot(re.$slots, "default", {}, void 0, !0)
      ])
    ]),
    _: 3
  });
}
const HxToolbarBodySection = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["render", _sfc_render$d], ["__scopeId", "data-v-675d0169"]]), _sfc_main$c = {
  name: "HxToolbarBodySectionContentBlock"
}, _hoisted_1$b = { class: "hx-toolbar__body-section-content-block" };
function _sfc_render$c(re, ne, ae, ie, le, se) {
  return openBlock(), createElementBlock("div", _hoisted_1$b, [
    renderSlot(re.$slots, "default", {}, void 0, !0)
  ]);
}
const HxToolbarBodySectionContentBlock = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["render", _sfc_render$c], ["__scopeId", "data-v-4ebe2ff8"]]), _sfc_main$b = {
  name: "HxTrackers",
  props: {
    id: { type: String, default: "" },
    modelValue: {
      type: Number,
      default: 1
    },
    items: {
      type: Array,
      default: () => [],
      validator: (re) => re.every((ne) => Object.prototype.hasOwnProperty.call(ne, "title") ? !0 : (console.error("Please include title in Helix Trackers"), !1))
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      currentStep: this.modelValue
    };
  },
  watch: {
    currentStep(re) {
      this.$emit("update:modelValue", re);
    },
    modelValue(re) {
      this.currentStep = re;
    }
  },
  methods: {
    getStepValue(re) {
      return re + 1;
    },
    stepperItemColorClass(re) {
      return {
        complete: "stepper-item-color-complete",
        error: "stepper-item-color-error",
        skip: "stepper-item-color-skip",
        current: "stepper-item-color-current",
        past: "stepper-item-color-past"
      }[re.state] || "";
    },
    dividerColorClass(re, ne, ae) {
      const ie = {
        complete: "complete",
        error: "error",
        skip: "skip",
        current: "current",
        past: "past",
        default: "default"
      };
      return this.getStepValue(ae) === ne ? "in-progress" : ie[re.state] || "default";
    },
    getIcon(re, ne) {
      return this.getStepValue(ne) === this.currentStep ? "mdi-dots-horizontal" : {
        complete: "mdi-check",
        error: "mdi-close",
        skip: "mdi-redo"
      }[re.state] || "";
    }
  }
}, _hoisted_1$a = {
  key: 2,
  class: "icon-number-default"
};
function _sfc_render$b(re, ne, ae, ie, le, se) {
  return openBlock(), createBlock(VStepper, {
    id: ae.id,
    modelValue: le.currentStep,
    "onUpdate:modelValue": ne[0] || (ne[0] = (ce) => le.currentStep = ce),
    "alt-labels": "",
    class: "hx-trackers"
  }, {
    default: withCtx(() => [
      createVNode(VStepperHeader, null, {
        default: withCtx(() => [
          (openBlock(!0), createElementBlock(Fragment, null, renderList(ae.items, (ce, ue) => (openBlock(), createElementBlock(Fragment, { key: ue }, [
            createVNode(VStepperItem, {
              value: se.getStepValue(ue),
              editable: "",
              title: ce.title,
              subtitle: ce.subtitle,
              class: normalizeClass(se.stepperItemColorClass(ce))
            }, {
              icon: withCtx(() => [
                (re.icon = se.getIcon(ce, ue)) ? (openBlock(), createBlock(VIcon, {
                  key: 0,
                  icon: re.icon
                }, null, 8, ["icon"])) : ["current", "past"].includes(ce == null ? void 0 : ce.state) ? (openBlock(), createBlock(VIcon, {
                  key: 1,
                  icon: ""
                })) : (openBlock(), createElementBlock("span", _hoisted_1$a, toDisplayString$1(se.getStepValue(ue)), 1))
              ]),
              _: 2
            }, 1032, ["value", "title", "subtitle", "class"]),
            createVNode(VDivider, {
              class: normalizeClass(se.dividerColorClass(ce, le.currentStep, ue))
            }, null, 8, ["class"])
          ], 64))), 128))
        ]),
        _: 1
      }),
      createVNode(VStepperWindow, null, {
        default: withCtx(() => [
          (openBlock(!0), createElementBlock(Fragment, null, renderList(ae.items, (ce, ue) => (openBlock(), createBlock(VStepperWindowItem, {
            key: ue,
            value: se.getStepValue(ue)
          }, {
            default: withCtx(() => [
              renderSlot(re.$slots, `item.${ue + 1}`, {}, void 0, !0)
            ]),
            _: 2
          }, 1032, ["value"]))), 128))
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "modelValue"]);
}
const HxTrackers = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["render", _sfc_render$b], ["__scopeId", "data-v-48a7eef1"]]), _sfc_main$a = {
  name: "HxAccordion",
  props: {
    expanded: {
      type: Number,
      default: void 0
    },
    elevated: {
      type: Boolean,
      default: !1
    },
    border: {
      type: Boolean,
      default: !1
    },
    titleText: {
      type: String,
      default: ""
    },
    leftButton: {
      type: String,
      default: ""
    },
    userIcon: {
      type: String,
      default: ""
    },
    rightButton: {
      type: String,
      default: ""
    },
    titleIcon: {
      type: String,
      default: ""
    },
    helperText: {
      type: String,
      default: ""
    },
    showCheckbox: {
      type: Boolean,
      default: !1
    },
    showToggleSwitch: {
      type: Boolean,
      default: !1
    },
    chipLabel: {
      type: String,
      default: ""
    },
    chipColor: {
      type: String,
      default: ""
    },
    chipIcon: {
      type: String,
      default: ""
    },
    isSelected: { type: Boolean, default: !1 },
    isToggled: {
      type: Boolean,
      default: !0
    }
  },
  emits: [
    "update:expanded",
    "update:isToggled",
    "update:isSelected",
    "left-button-click",
    "right-button-click"
  ],
  data() {
    return {
      expandedAccordion: this.expanded,
      isEnabled: this.isToggled
    };
  },
  computed: {
    classes() {
      let re = ["hx-accordion"];
      return this.elevated ? re = re.concat("elevated") : re = re.concat("border"), re;
    },
    accordionClass() {
      return this.classes.join(" ");
    }
  },
  watch: {
    expandedAccordion(re) {
      this.$emit("update:expanded", re);
    },
    expanded(re) {
      this.expandedAccordion = re;
    },
    isEnabled(re) {
      this.$emit("update:isToggled", re);
    },
    isToggled(re) {
      this.isEnabled = re;
    }
  },
  methods: {
    emitSelectedPanel() {
      this.$emit("update:isSelected", this.isSelected);
    },
    leftButtonClick() {
      this.$emit("left-button-click");
    },
    rightButtonClick() {
      this.$emit("right-button-click");
    },
    showLongTitle(re) {
      return re.length > 14 ? re : "";
    },
    truncateIntoElipsis(re) {
      return re.length > 14 ? `${re.slice(0, 14)}...` : re;
    }
  }
}, _hoisted_1$9 = {
  key: 4,
  class: "hx-accordion-title-text mr-2"
}, _hoisted_2$7 = {
  key: 1,
  class: "hx-accordion-helper-text mr-2"
};
function _sfc_render$a(re, ne, ae, ie, le, se) {
  const ce = HxCheckbox, ue = HxButton, de = HxTooltip, me = HxChip, fe = HxToggleSwitch;
  return openBlock(), createBlock(VExpansionPanels, {
    modelValue: le.expandedAccordion,
    "onUpdate:modelValue": ne[8] || (ne[8] = (pe) => le.expandedAccordion = pe),
    class: normalizeClass(se.accordionClass)
  }, {
    default: withCtx(() => [
      createVNode(VExpansionPanel, null, {
        default: withCtx(() => [
          createVNode(VExpansionPanelTitle, null, {
            actions: withCtx(({ expanded: pe }) => [
              pe ? (openBlock(), createBlock(ue, {
                key: 0,
                ghost: "",
                size: "large",
                "left-icon": "mdi-chevron-up"
              })) : (openBlock(), createBlock(ue, {
                key: 1,
                ghost: "",
                size: "large",
                "left-icon": "mdi-chevron-down"
              }))
            ]),
            default: withCtx(() => [
              createVNode(VCol, { class: "justify-start d-flex align-center pa-0" }, {
                default: withCtx(() => [
                  ae.showCheckbox ? (openBlock(), createBlock(ce, {
                    key: 0,
                    tabindex: "-1",
                    "model-value": ae.isSelected,
                    class: "mr-2",
                    onClick: ne[0] || (ne[0] = withModifiers(() => {
                    }, ["stop"])),
                    "onUpdate:modelValue": ne[1] || (ne[1] = (pe) => re.$emit("update:isSelected", pe))
                  }, null, 8, ["model-value"])) : createCommentVNode("", !0),
                  ae.leftButton ? (openBlock(), createBlock(ue, {
                    key: 1,
                    ghost: "",
                    size: "large",
                    "left-icon": ae.leftButton,
                    class: "hx-accordion-left-button mr-2",
                    onClick: [
                      ne[2] || (ne[2] = (pe) => se.leftButtonClick()),
                      ne[3] || (ne[3] = withModifiers(() => {
                      }, ["stop"]))
                    ]
                  }, null, 8, ["left-icon"])) : createCommentVNode("", !0),
                  ae.titleIcon ? (openBlock(), createBlock(VIcon, {
                    key: 2,
                    icon: ae.titleIcon,
                    class: "hx-accordion-title-icon mr-2"
                  }, null, 8, ["icon"])) : createCommentVNode("", !0),
                  se.showLongTitle(ae.titleText) ? (openBlock(), createBlock(de, {
                    key: 3,
                    id: "tooltip-bottom",
                    text: se.showLongTitle(ae.titleText),
                    location: "bottom"
                  }, {
                    default: withCtx((pe) => [
                      createElementVNode("div", mergeProps({ class: "hx-accordion-title-text mr-2" }, pe), toDisplayString$1(se.truncateIntoElipsis(ae.titleText)), 17)
                    ]),
                    _: 1
                  }, 8, ["text"])) : (openBlock(), createElementBlock("div", _hoisted_1$9, toDisplayString$1(ae.titleText), 1)),
                  ae.chipLabel && ae.chipColor ? (openBlock(), createBlock(me, {
                    key: 5,
                    label: ae.chipLabel,
                    color: ae.chipColor,
                    "left-icon": ae.chipIcon,
                    "show-left-icon": !!ae.chipIcon,
                    class: "mr-1"
                  }, null, 8, ["label", "color", "left-icon", "show-left-icon"])) : createCommentVNode("", !0)
                ]),
                _: 1
              }),
              createVNode(VCol, { class: "justify-end d-flex align-center pa-0" }, {
                default: withCtx(() => [
                  ae.userIcon ? (openBlock(), createBlock(VIcon, {
                    key: 0,
                    icon: ae.userIcon,
                    class: "hx-accordion-user-icon mr-1"
                  }, null, 8, ["icon"])) : createCommentVNode("", !0),
                  ae.helperText ? (openBlock(), createElementBlock("div", _hoisted_2$7, toDisplayString$1(ae.helperText), 1)) : createCommentVNode("", !0),
                  ae.rightButton ? (openBlock(), createBlock(ue, {
                    key: 2,
                    ghost: "",
                    size: "large",
                    "left-icon": ae.rightButton,
                    class: "hx-accordion-right-button mr-2",
                    onClick: [
                      ne[4] || (ne[4] = (pe) => se.rightButtonClick()),
                      ne[5] || (ne[5] = withModifiers(() => {
                      }, ["stop"]))
                    ]
                  }, null, 8, ["left-icon"])) : createCommentVNode("", !0),
                  ae.showToggleSwitch ? (openBlock(), createBlock(fe, {
                    key: 3,
                    modelValue: le.isEnabled,
                    "onUpdate:modelValue": ne[6] || (ne[6] = (pe) => le.isEnabled = pe),
                    tabindex: "-1",
                    "right-label": "On",
                    class: "mr-2",
                    onClick: ne[7] || (ne[7] = withModifiers(() => {
                    }, ["stop"]))
                  }, null, 8, ["modelValue"])) : createCommentVNode("", !0)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          createVNode(VDivider),
          createVNode(VExpansionPanelText, null, {
            default: withCtx(() => [
              renderSlot(re.$slots, "content", { enabled: le.isEnabled }, void 0, !0)
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["modelValue", "class"]);
}
const HxAccordion = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["render", _sfc_render$a], ["__scopeId", "data-v-c60baccc"]]), _sfc_main$9 = {
  name: "NavbarV2Header",
  props: {
    breadcrumbsItems: {
      type: Array,
      default: () => []
    },
    breadcrumbsId: {
      type: String,
      default: ""
    },
    headerTitle: {
      type: String,
      default: ""
    }
  },
  emits: ["navitem-title-click"],
  data() {
    return {
      isTruncated: !1
    };
  },
  watch: {
    headerTitle() {
      this.checkIsTitleOverflow();
    }
  },
  mounted() {
    this.checkIsTitleOverflow(), window.addEventListener("resize", this.checkIsTitleOverflow);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkIsTitleOverflow);
  },
  methods: {
    navitemTitleClick() {
      this.$emit("navitem-title-click");
    },
    checkIsTitleOverflow() {
      this.$nextTick(() => {
        const re = this.$refs.textRef;
        re && (this.isTruncated = re.scrollWidth > re.clientWidth);
      });
    }
  }
}, _hoisted_1$8 = {
  key: 0,
  class: "hx-navbar-v2-breadcrumbs"
}, _hoisted_2$6 = {
  key: 1,
  class: "hx-navbar-v2-breadcrumbs-header"
};
function _sfc_render$9(re, ne, ae, ie, le, se) {
  const ce = HxBreadcrumbs, ue = HxButton, de = HxTooltip;
  return openBlock(), createElementBlock(Fragment, null, [
    ae.breadcrumbsItems.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_1$8, [
      createVNode(ce, {
        id: ae.breadcrumbsId,
        compact: "",
        items: ae.breadcrumbsItems
      }, null, 8, ["id", "items"])
    ])) : createCommentVNode("", !0),
    ae.headerTitle ? (openBlock(), createElementBlock("div", _hoisted_2$6, [
      createVNode(ue, {
        variant: "secondary",
        ghost: "",
        size: "large",
        "left-icon": "mdi-chevron-left",
        onClick: se.navitemTitleClick
      }, null, 8, ["onClick"]),
      le.isTruncated ? (openBlock(), createBlock(de, {
        key: 0,
        id: "tooltip-bottom",
        text: ae.headerTitle,
        location: "bottom"
      }, {
        default: withCtx((me) => [
          createElementVNode("div", mergeProps(me, {
            ref: "textRef",
            class: "hx-navbar-v2-breadcrumbs-header-title"
          }), toDisplayString$1(ae.headerTitle), 17)
        ]),
        _: 1
      }, 8, ["text"])) : (openBlock(), createElementBlock("div", {
        key: 1,
        ref: "textRef",
        class: "hx-navbar-v2-breadcrumbs-header-title"
      }, toDisplayString$1(ae.headerTitle), 513))
    ])) : createCommentVNode("", !0)
  ], 64);
}
const __unplugin_components_3 = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["render", _sfc_render$9], ["__scopeId", "data-v-caecc35b"]]), _sfc_main$8 = {
  name: "NavbarV2ItemTitle",
  props: {
    textTitle: {
      type: String,
      default: ""
    },
    href: {
      type: String,
      default: ""
    },
    target: {
      type: String,
      default: "_blank"
    }
  },
  data() {
    return {
      isTruncated: !1
    };
  },
  watch: {
    textTitle() {
      this.checkIsTitleOverflow();
    }
  },
  mounted() {
    this.checkIsTitleOverflow(), window.addEventListener("resize", this.checkIsTitleOverflow);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkIsTitleOverflow);
  },
  methods: {
    checkIsTitleOverflow() {
      this.$nextTick(() => {
        const re = this.$refs.titleRef;
        re && (this.isTruncated = re.scrollWidth > re.clientWidth);
      });
    }
  }
}, _hoisted_1$7 = {
  key: 0,
  ref: "titleRef",
  class: "hx-navbar-v2-item-title"
}, _hoisted_2$5 = ["href", "target"], _hoisted_3$2 = ["href", "target"], _hoisted_4$1 = { key: 1 };
function _sfc_render$8(re, ne, ae, ie, le, se) {
  const ce = HxTooltip;
  return ae.textTitle ? (openBlock(), createElementBlock("div", _hoisted_1$7, [
    le.isTruncated ? (openBlock(), createBlock(ce, {
      key: 0,
      id: "tooltip-bottom",
      text: ae.textTitle,
      location: "bottom"
    }, {
      default: withCtx((ue) => [
        ae.href ? (openBlock(), createElementBlock("a", mergeProps({ key: 0 }, ue, {
          href: ae.href,
          target: ae.target,
          class: "hx-navbar-v2-item-title-link",
          onClick: ne[0] || (ne[0] = withModifiers(() => {
          }, ["stop"]))
        }), toDisplayString$1(ae.textTitle), 17, _hoisted_2$5)) : (openBlock(), createElementBlock("span", normalizeProps(mergeProps({ key: 1 }, ue)), toDisplayString$1(ae.textTitle), 17))
      ]),
      _: 1
    }, 8, ["text"])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
      ae.href ? (openBlock(), createElementBlock("a", {
        key: 0,
        href: ae.href,
        target: ae.target,
        class: "hx-navbar-v2-item-title-link",
        onClick: ne[1] || (ne[1] = withModifiers(() => {
        }, ["stop"]))
      }, toDisplayString$1(ae.textTitle), 9, _hoisted_3$2)) : (openBlock(), createElementBlock("span", _hoisted_4$1, toDisplayString$1(ae.textTitle), 1))
    ], 64))
  ], 512)) : createCommentVNode("", !0);
}
const __unplugin_components_0 = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["render", _sfc_render$8], ["__scopeId", "data-v-25db9a86"]]), _sfc_main$7 = {
  name: "NavbarV2Item",
  components: {
    NavbarV2ItemTitle: __unplugin_components_0
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    order: {
      type: String,
      default: "asc"
    }
  },
  emits: ["left-icon-click", "right-icon-click"],
  computed: {
    showNavbarItem() {
      return this.items && this.items.length > 0 && this.items.some((re) => re.text || re.leftIcon || re.rightIcon);
    },
    sortedItems() {
      if (!this.items || this.items.length === 0) return [];
      const re = [...this.items];
      return this.order === "asc" ? re.sort((ne, ae) => ne.text.localeCompare(ae.text)) : re.sort((ne, ae) => ae.text.localeCompare(ne.text));
    }
  },
  methods: {
    onLeftIconClick(re) {
      this.$emit("left-icon-click", re);
    },
    onRightIconClick(re) {
      this.$emit("right-icon-click", re);
    }
  }
};
function _sfc_render$7(re, ne, ae, ie, le, se) {
  const ce = __unplugin_components_0;
  return se.showNavbarItem ? (openBlock(), createBlock(VList, {
    key: 0,
    class: "hx-navbar-v2-item"
  }, {
    default: withCtx(() => [
      (openBlock(!0), createElementBlock(Fragment, null, renderList(se.sortedItems, (ue, de) => (openBlock(), createBlock(VListItem, {
        key: de,
        value: ue
      }, {
        prepend: withCtx(() => [
          ue.leftIcon ? (openBlock(), createBlock(VIcon, {
            key: 0,
            icon: ue.leftIcon,
            onClick: withModifiers((me) => se.onLeftIconClick(de), ["stop"])
          }, null, 8, ["icon", "onClick"])) : createCommentVNode("", !0),
          renderSlot(re.$slots, "leftIcon", { index: de }, void 0, !0)
        ]),
        append: withCtx(() => [
          renderSlot(re.$slots, "rightIcon", { index: de }, void 0, !0),
          ue.rightIcon ? (openBlock(), createBlock(VIcon, {
            key: 0,
            icon: ue.rightIcon,
            onClick: withModifiers((me) => se.onRightIconClick(de), ["stop"])
          }, null, 8, ["icon", "onClick"])) : createCommentVNode("", !0)
        ]),
        default: withCtx(() => [
          createVNode(ce, {
            "text-title": ue.text,
            href: ue.href,
            target: ue.target
          }, null, 8, ["text-title", "href", "target"])
        ]),
        _: 2
      }, 1032, ["value"]))), 128))
    ]),
    _: 3
  })) : createCommentVNode("", !0);
}
const NavbarItem = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$7], ["__scopeId", "data-v-c3e36a44"]]), _sfc_main$6 = {
  name: "HxNavbarV2",
  components: {
    NavbarV2Header: __unplugin_components_3,
    NavbarItem
  },
  props: {
    breadcrumbsItems: {
      type: Array,
      default: () => []
    },
    breadcrumbsId: {
      type: String,
      default: ""
    },
    searchText: {
      type: String,
      default: ""
    },
    header: {
      type: String,
      default: ""
    },
    isToggled: {
      type: Boolean,
      default: !0
    },
    enableDraftMode: {
      type: String,
      default: "Enable Draft Mode"
    },
    title: {
      type: String,
      default: "Menu"
    },
    width: {
      type: Number,
      default: 292,
      validator: (re) => re < 292 ? (console.error("Require width for a Helix toolbar to be at least 292px"), !1) : !0
    },
    navbarItems: {
      type: Array,
      default: () => []
    },
    order: {
      type: String,
      default: "asc",
      validator(re) {
        return ["asc", "desc"].includes(re) || console.error('Invalid order prop: use "asc" or "desc" only');
      }
    }
  },
  emits: [
    "update:isToggled",
    "update:searchText",
    "title-click",
    "breadcrumb-back-btn-click",
    "navbar-item-left-icon-click",
    "navbar-item-right-icon-click"
  ],
  data() {
    return {
      isEnabled: this.isToggled,
      drawer: !0,
      isFolded: !0,
      focusField: !1
    };
  },
  computed: {
    getContainerClass() {
      return (re) => this.isFolded ? `d-flex justify-center ${re}` : re;
    },
    search: {
      get() {
        return this.searchText;
      },
      set(re) {
        this.$emit("update:searchText", re);
      }
    }
  },
  watch: {
    isEnabled(re) {
      this.$emit("update:isToggled", re);
    },
    isToggled(re) {
      this.isEnabled = !!re;
    }
  },
  methods: {
    toggleFold() {
      this.isFolded = !this.isFolded;
    },
    focusSearchField() {
      this.$nextTick(() => {
        var ne;
        const re = (ne = this.$refs.searchField) == null ? void 0 : ne.$el.querySelector("input");
        re && re.focus();
      });
    },
    openDrawerAndFocus() {
      this.focusField = !0, this.toggleFold(), this.focusSearchField(), this.focusField = !1;
    },
    titleClick() {
      this.$emit("title-click");
    },
    breadcrumbBackBtnClick() {
      this.$emit("breadcrumb-back-btn-click");
    },
    handleLeftIconClick(re) {
      this.$emit("navbar-item-left-icon-click", re);
    },
    handleRightIconClick(re) {
      this.$emit("navbar-item-right-icon-click", re);
    }
  }
}, _hoisted_1$6 = {
  key: 0,
  class: "hx-navbar-v2-draft-text"
};
function _sfc_render$6(re, ne, ae, ie, le, se) {
  const ce = HxButton, ue = HxSearch, de = HxToggleSwitch, me = __unplugin_components_3, fe = resolveComponent("NavbarItem");
  return openBlock(), createBlock(VNavigationDrawer, {
    modelValue: le.drawer,
    "onUpdate:modelValue": ne[3] || (ne[3] = (pe) => le.drawer = pe),
    class: "hx-navbar-v2",
    width: ae.width,
    "rail-width": "72",
    rail: le.isFolded,
    permanent: ""
  }, {
    default: withCtx(() => [
      createElementVNode("div", {
        class: normalizeClass(se.getContainerClass("hx-navbar-v2-title-container"))
      }, [
        createVNode(ce, {
          variant: "secondary",
          ghost: "",
          size: "large",
          "left-icon": "mdi-menu",
          label: le.isFolded ? "" : ae.title,
          onClick: se.titleClick
        }, null, 8, ["label", "onClick"])
      ], 2),
      createElementVNode("div", {
        class: normalizeClass(se.getContainerClass("hx-navbar-v2-search-container"))
      }, [
        le.isFolded ? (openBlock(), createBlock(ce, {
          key: 1,
          variant: "secondary",
          ghost: "",
          size: "large",
          "left-icon": "mdi-magnify",
          onClick: se.openDrawerAndFocus
        }, null, 8, ["onClick"])) : (openBlock(), createBlock(ue, {
          key: 0,
          ref: "searchField",
          search: se.search,
          "onUpdate:search": ne[0] || (ne[0] = (pe) => se.search = pe),
          autofocus: le.focusField
        }, null, 8, ["search", "autofocus"]))
      ], 2),
      createElementVNode("div", {
        class: normalizeClass(se.getContainerClass("hx-navbar-v2-draft-container"))
      }, [
        le.isFolded ? createCommentVNode("", !0) : (openBlock(), createElementBlock("div", _hoisted_1$6, toDisplayString$1(ae.enableDraftMode), 1)),
        createVNode(de, {
          modelValue: le.isEnabled,
          "onUpdate:modelValue": ne[1] || (ne[1] = (pe) => le.isEnabled = pe),
          onClick: ne[2] || (ne[2] = withModifiers(() => {
          }, ["stop"]))
        }, null, 8, ["modelValue"])
      ], 2),
      !le.isFolded && ae.breadcrumbsItems.length > 0 ? (openBlock(), createBlock(me, {
        key: 0,
        "breadcrumbs-id": ae.breadcrumbsId,
        "breadcrumbs-items": ae.breadcrumbsItems,
        "header-title": ae.header,
        onNavitemTitleClick: se.breadcrumbBackBtnClick
      }, null, 8, ["breadcrumbs-id", "breadcrumbs-items", "header-title", "onNavitemTitleClick"])) : createCommentVNode("", !0),
      createElementVNode("div", {
        class: normalizeClass([
          "hx-navbar-v2-navitem-container",
          { "hx-navbar-v2-navitem-container-slot": !le.isFolded }
        ])
      }, [
        le.isFolded ? createCommentVNode("", !0) : (openBlock(), createBlock(fe, {
          key: 0,
          items: ae.navbarItems,
          order: ae.order,
          onLeftIconClick: se.handleLeftIconClick,
          onRightIconClick: se.handleRightIconClick
        }, createSlots({ _: 2 }, [
          renderList(re.$slots, (pe, ge, be) => ({
            name: ge,
            fn: withCtx((Se) => [
              renderSlot(re.$slots, ge, mergeProps({ index: be }, Se), void 0, !0)
            ])
          }))
        ]), 1032, ["items", "order", "onLeftIconClick", "onRightIconClick"]))
      ], 2),
      createElementVNode("div", {
        class: normalizeClass(se.getContainerClass("hx-navbar-v2-collapse"))
      }, [
        createVNode(ce, {
          size: "large",
          ghost: !0,
          "left-icon": le.isFolded ? "$i-action-left-expand" : "$i-action-left-collapse",
          onClick: withModifiers(se.toggleFold, ["stop"])
        }, null, 8, ["left-icon", "onClick"])
      ], 2)
    ]),
    _: 3
  }, 8, ["modelValue", "width", "rail"]);
}
const HxNavbarV2 = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$6], ["__scopeId", "data-v-a021e087"]]);
let idCounter = 0;
const _sfc_main$5 = {
  name: "CSOptionSelectItem",
  props: {
    item: {
      type: Object,
      required: !0
    },
    isNested: {
      type: Boolean,
      default: !1
    },
    level: {
      type: Number,
      default: 1
    },
    tooltipDirection: {
      type: String,
      default: "right",
      validator: (re) => {
        switch (re) {
          case "left":
          case "right":
          case "top":
          case "bottom":
            return !0;
          default:
            return console.error("Invalid location for a Helix Tooltip in CS Option Select Item"), !1;
        }
      }
    }
  },
  emits: ["select"],
  data() {
    return {
      isTitleOverflowing: !1,
      resizeObserver: null
    };
  },
  computed: {
    titleElementId() {
      return `option-select-item-title-${++idCounter}`;
    }
  },
  mounted() {
    this.setupOverflowDetection();
  },
  beforeUnmount() {
    this.resizeObserver && this.resizeObserver.disconnect();
  },
  methods: {
    setupOverflowDetection() {
      this.$nextTick(() => {
        var ne;
        const re = ((ne = this.$refs.titleElement) == null ? void 0 : ne.$el) || this.$refs.titleElement;
        re && (this.checkTitleOverflow(), this.resizeObserver = new ResizeObserver(() => {
          this.checkTitleOverflow();
        }), this.resizeObserver.observe(re));
      });
    },
    checkTitleOverflow() {
      var ne;
      const re = ((ne = this.$refs.titleElement) == null ? void 0 : ne.$el) || this.$refs.titleElement;
      re && re.offsetWidth > 0 && (this.isTitleOverflowing = re.scrollWidth > re.clientWidth);
    }
  }
}, _hoisted_1$5 = {
  key: 0,
  class: "cs-dropdown-item__prepend"
}, _hoisted_2$4 = {
  key: 0,
  class: "cs-dropdown-item__prepend"
};
function _sfc_render$5(re, ne, ae, ie, le, se) {
  const ce = HxTooltip, ue = resolveComponent("CSOptionSelectItem", !0);
  return !ae.item.children || !ae.isNested ? (openBlock(), createBlock(VListItem, {
    key: 0,
    class: normalizeClass(["cs-dropdown-item", `level-${ae.level}`]),
    onClick: ne[0] || (ne[0] = () => re.$emit("select", ae.item.title))
  }, {
    prepend: withCtx(() => [
      ae.level > 1 ? (openBlock(), createElementBlock("div", _hoisted_1$5, [
        createVNode(VDivider, {
          vertical: "",
          class: "cs-dropdown-item__divider"
        })
      ])) : createCommentVNode("", !0)
    ]),
    default: withCtx(() => [
      le.isTitleOverflowing ? (openBlock(), createBlock(ce, {
        key: 0,
        text: ae.item.title,
        location: ae.tooltipDirection
      }, {
        default: withCtx((de) => [
          createVNode(VListItemTitle, mergeProps({ id: se.titleElementId }, de, {
            ref: "titleElement",
            class: "cs-dropdown-item__title"
          }), {
            default: withCtx(() => [
              createTextVNode(toDisplayString$1(ae.item.title), 1)
            ]),
            _: 2
          }, 1040, ["id"])
        ]),
        _: 1
      }, 8, ["text", "location"])) : (openBlock(), createBlock(VListItemTitle, {
        key: 1,
        id: se.titleElementId,
        ref: "titleElement",
        class: "cs-dropdown-item__title"
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString$1(ae.item.title), 1)
        ]),
        _: 1
      }, 8, ["id"]))
    ]),
    _: 1
  }, 8, ["class"])) : (openBlock(), createBlock(VListGroup, {
    key: 1,
    value: ae.item.title,
    class: "cs-dropdown-item__group"
  }, {
    activator: withCtx(({ props: de }) => [
      createVNode(VListItem, mergeProps(de, {
        class: ["cs-dropdown-item", `level-${ae.level}`],
        "append-icon": null,
        tabindex: "0",
        onClick: ne[1] || (ne[1] = () => re.$emit("select", ae.item.title))
      }), {
        prepend: withCtx(() => [
          ae.level > 1 ? (openBlock(), createElementBlock("div", _hoisted_2$4, [
            createVNode(VDivider, {
              vertical: "",
              class: "cs-dropdown-item__divider"
            })
          ])) : createCommentVNode("", !0)
        ]),
        default: withCtx(() => [
          le.isTitleOverflowing ? (openBlock(), createBlock(ce, {
            key: 0,
            text: ae.item.title,
            location: ae.tooltipDirection
          }, {
            default: withCtx((me) => [
              createVNode(VListItemTitle, mergeProps({ id: se.titleElementId }, me, {
                ref: "titleElement",
                class: "cs-dropdown-item__title"
              }), {
                default: withCtx(() => [
                  createTextVNode(toDisplayString$1(ae.item.title), 1)
                ]),
                _: 2
              }, 1040, ["id"])
            ]),
            _: 1
          }, 8, ["text", "location"])) : (openBlock(), createBlock(VListItemTitle, {
            key: 1,
            id: se.titleElementId,
            ref: "titleElement",
            class: "cs-dropdown-item__title"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString$1(ae.item.title), 1)
            ]),
            _: 1
          }, 8, ["id"]))
        ]),
        _: 2
      }, 1040, ["class"])
    ]),
    default: withCtx(() => [
      (openBlock(!0), createElementBlock(Fragment, null, renderList(ae.item.children, (de, me) => (openBlock(), createBlock(ue, {
        key: `${de.title + me}`,
        item: de,
        "is-nested": ae.isNested,
        level: ae.level + 1,
        "tooltip-direction": ae.tooltipDirection,
        onSelect: ne[2] || (ne[2] = (fe) => re.$emit("select", fe))
      }, null, 8, ["item", "is-nested", "level", "tooltip-direction"]))), 128))
    ]),
    _: 1
  }, 8, ["value"]));
}
const CSOptionSelectItem = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$5], ["__scopeId", "data-v-da05ee27"]]), _sfc_main$4 = {
  name: "CSOptionSelect",
  components: {
    "cs-option-select-item": CSOptionSelectItem
  },
  props: {
    items: {
      type: Array,
      default: () => [],
      required: !0
    },
    showChip: {
      type: Boolean,
      required: !0
    },
    showSearchbar: {
      type: Boolean,
      required: !0
    },
    isPrimary: {
      type: Boolean,
      required: !0
    },
    isNested: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      default: "",
      required: !0
    },
    chipProps: {
      type: Object,
      default: () => ({})
    },
    tooltipDirection: {
      type: String,
      default: "right",
      validator: (re) => {
        switch (re) {
          case "left":
          case "right":
          case "top":
          case "bottom":
            return !0;
          default:
            return console.error("Invalid location for a Helix Tooltip in CS Option Select"), !1;
        }
      }
    }
  },
  emits: ["update:optionSelectValue"],
  data() {
    return {
      searchValue: "",
      isOpen: !1,
      optionSelectValue: ""
    };
  },
  computed: {
    filteredItems() {
      if (!this.showSearchbar || !this.searchValue)
        return this.items;
      const re = this.searchValue.toLowerCase(), ne = (ae) => ae.map((ie) => {
        const le = ie.title.toLowerCase().includes(re);
        let se = [], ce = !1;
        return ie.children && (se = ne(ie.children), ce = se.length > 0), le || ce ? {
          ...ie,
          children: ce ? se : ie.children
        } : null;
      }).filter(Boolean);
      return ne(this.items);
    },
    open() {
      if (this.isNested) {
        const re = (ne) => {
          let ae = [];
          return ne.forEach((ie) => {
            ie.children && ie.children.length > 0 && (ae.push(ie.title), ae = ae.concat(re(ie.children)));
          }), ae;
        };
        return re(this.filteredItems);
      }
      return [];
    }
  },
  methods: {
    selectItem(re) {
      this.optionSelectValue = re, this.isOpen = !1, this.$emit("update:optionSelectValue", re);
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    }
  }
}, _hoisted_1$4 = { class: "cs-option-select" };
function _sfc_render$4(re, ne, ae, ie, le, se) {
  const ce = HxOption, ue = HxSearch, de = resolveComponent("cs-option-select-item");
  return openBlock(), createElementBlock("div", _hoisted_1$4, [
    createVNode(ce, {
      label: ae.label,
      "show-chevron": "",
      "show-chip": ae.showChip,
      primary: ae.isPrimary,
      "chip-props": ae.chipProps,
      size: "compact",
      "is-expanded": le.isOpen,
      "selected-value": le.optionSelectValue,
      "onUpdate:isSelected": se.toggleDropdown,
      "onUpdate:isExpanded": se.toggleDropdown
    }, null, 8, ["label", "show-chip", "primary", "chip-props", "is-expanded", "selected-value", "onUpdate:isSelected", "onUpdate:isExpanded"]),
    withDirectives(createVNode(VList, {
      opened: se.open,
      "onUpdate:opened": ne[2] || (ne[2] = (me) => se.open = me),
      class: normalizeClass([
        "cs-option-select__dropdown",
        { "cs-option-select__dropdown--with-search": ae.showSearchbar }
      ]),
      density: "compact"
    }, {
      default: withCtx(() => [
        ae.showSearchbar ? (openBlock(), createBlock(VListItem, {
          key: 0,
          class: "cs-option-select__dropdown-search"
        }, {
          default: withCtx(() => [
            createVNode(ue, {
              search: le.searchValue,
              "onUpdate:search": ne[0] || (ne[0] = (me) => le.searchValue = me),
              placeholder: "Search",
              onClick: ne[1] || (ne[1] = withModifiers(() => {
              }, ["stop"]))
            }, null, 8, ["search"])
          ]),
          _: 1
        })) : createCommentVNode("", !0),
        se.filteredItems.length > 0 ? (openBlock(!0), createElementBlock(Fragment, { key: 1 }, renderList(se.filteredItems, (me, fe) => (openBlock(), createBlock(de, {
          key: fe,
          item: me,
          "is-nested": ae.isNested,
          level: 1,
          "tooltip-direction": ae.tooltipDirection,
          onSelect: se.selectItem
        }, null, 8, ["item", "is-nested", "tooltip-direction", "onSelect"]))), 128)) : ae.showSearchbar && le.searchValue && se.filteredItems.length === 0 ? (openBlock(), createBlock(VListItem, {
          key: 2,
          class: "cs-option-select__no-results"
        }, {
          default: withCtx(() => [
            createVNode(VListItemTitle, null, {
              default: withCtx(() => ne[3] || (ne[3] = [
                createTextVNode("No results found")
              ])),
              _: 1
            })
          ]),
          _: 1
        })) : createCommentVNode("", !0)
      ]),
      _: 1
    }, 8, ["opened", "class"]), [
      [vShow, le.isOpen]
    ])
  ]);
}
const CSOptionSelect = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$4], ["__scopeId", "data-v-cca79600"]]), _sfc_main$3 = {
  name: "HxSelect",
  props: {
    label: {
      type: String,
      default: ""
    },
    optionalText: {
      type: String,
      default: ""
    },
    mandatory: {
      type: Boolean,
      default: !1
    },
    items: {
      type: Array,
      default: () => [],
      validator: (re) => re.every(
        (ne) => typeof ne == "object" && "title" in ne && "value" in ne
      )
    },
    modelValue: {
      type: Array,
      default: () => [],
      validator: (re) => re.every(
        (ne) => typeof ne == "object" && "title" in ne && "value" in ne
      )
    },
    placeholder: {
      type: String,
      default: "Select an option"
    },
    helperMessage: {
      type: [Boolean, String],
      default: void 0
    },
    errorMessages: {
      type: [Boolean, String],
      default: void 0
    },
    width: {
      type: [Number, String],
      default: "100%"
    },
    disabled: {
      type: Boolean,
      default: null
    },
    applyButtonText: {
      type: String,
      default: "Apply Module Filter"
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      selectedItems: this.modelValue || [],
      search: "",
      isMenuOpen: !1
    };
  },
  computed: {
    selectItems() {
      return this.items.filter(
        (re) => !this.selectedItems.some((ne) => ne.value === re.value)
      );
    },
    filteredSelectItems() {
      if (!this.search) return this.selectItems;
      const re = this.search.toLowerCase();
      return this.selectItems.filter((ne) => ne.title.toLowerCase().includes(re));
    },
    showSearch() {
      return this.items.length >= 20;
    }
  },
  watch: {
    modelValue: {
      handler(re) {
        this.selectedItems = re || [];
      },
      immediate: !0
    },
    selectedItems: {
      handler(re) {
        this.$emit("update:modelValue", re);
      }
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    toggleItem(re) {
      const { title: ne, value: ae } = re, ie = this.selectedItems.findIndex((se) => se.value === ae), le = [...this.selectedItems];
      ie > -1 ? le.splice(ie, 1) : le.push({
        title: ne,
        value: ae
      }), this.selectedItems = le;
    },
    clearAll() {
      this.selectedItems = [];
    },
    selectAll() {
      this.selectedItems = [...this.items];
    },
    closeMenu() {
      this.isMenuOpen = !1;
    },
    handleClickOutside(re) {
      var ae, ie;
      const ne = (ae = this.$refs.searchInput) == null ? void 0 : ae.$el;
      ne && !ne.contains(re.target) && ((ie = ne.querySelector("input")) == null || ie.blur());
    }
  }
}, _hoisted_1$3 = { class: "d-flex flex-column hx-select-container" }, _hoisted_2$3 = {
  key: 0,
  class: "hx-select-label"
}, _hoisted_3$1 = {
  key: 0,
  class: "hx-select-label-optional"
}, _hoisted_4 = {
  key: 1,
  class: "hx-select-label-mandatory"
}, _hoisted_5 = { class: "d-flex justify-space-between hx-select-selected-title" }, _hoisted_6 = { class: "d-flex justify-space-between hx-select-select-title" }, _hoisted_7 = { class: "d-flex justify-center" };
function _sfc_render$3(re, ne, ae, ie, le, se) {
  const ce = HxChip, ue = HxSearch, de = HxButton, me = HxOption;
  return openBlock(), createElementBlock("div", _hoisted_1$3, [
    ae.label ? (openBlock(), createElementBlock("div", _hoisted_2$3, [
      createElementVNode("span", null, toDisplayString$1(ae.label), 1),
      ae.optionalText ? (openBlock(), createElementBlock("span", _hoisted_3$1, toDisplayString$1(ae.optionalText), 1)) : createCommentVNode("", !0),
      ae.mandatory ? (openBlock(), createElementBlock("span", _hoisted_4, "*")) : createCommentVNode("", !0)
    ])) : createCommentVNode("", !0),
    createVNode(VSelect, {
      modelValue: le.selectedItems,
      "onUpdate:modelValue": ne[4] || (ne[4] = (fe) => le.selectedItems = fe),
      menu: le.isMenuOpen,
      "onUpdate:menu": ne[5] || (ne[5] = (fe) => le.isMenuOpen = fe),
      variant: "outlined",
      density: "compact",
      items: se.filteredSelectItems,
      "menu-icon": "mdi-chevron-down",
      "item-title": "title",
      "item-value": "value",
      "return-object": "",
      class: "hx-select",
      "menu-props": {
        contentClass: "hx-select__content",
        offset: "8px"
      },
      multiple: "",
      placeholder: ae.placeholder,
      messages: ae.helperMessage,
      "error-messages": ae.errorMessages,
      width: ae.width,
      disabled: ae.disabled
    }, createSlots({
      selection: withCtx(({ item: fe }) => [
        fe ? (openBlock(), createBlock(ce, {
          key: 0,
          label: fe.title
        }, null, 8, ["label"])) : createCommentVNode("", !0)
      ]),
      "prepend-item": withCtx(() => [
        se.showSearch ? (openBlock(), createBlock(ue, {
          key: 0,
          ref: "searchInput",
          search: le.search,
          "onUpdate:search": ne[0] || (ne[0] = (fe) => le.search = fe),
          class: "mb-2",
          onKeydown: [
            ne[1] || (ne[1] = withKeys(withModifiers(() => {
            }, ["stop"]), ["space"])),
            ne[2] || (ne[2] = withModifiers(() => {
            }, ["stop"]))
          ],
          onBlur: ne[3] || (ne[3] = (fe) => le.search = "")
        }, null, 8, ["search"])) : createCommentVNode("", !0),
        createElementVNode("div", _hoisted_5, [
          ne[6] || (ne[6] = createElementVNode("span", { class: "hx-select-selected-title-text" }, "Selected", -1)),
          createVNode(de, {
            id: "clear-all-button",
            variant: "primary",
            ghost: "",
            size: "large",
            label: "Clear All",
            onClick: se.clearAll
          }, null, 8, ["onClick"])
        ]),
        (openBlock(!0), createElementBlock(Fragment, null, renderList(le.selectedItems, (fe, pe) => (openBlock(), createBlock(me, {
          key: pe,
          class: "hx-selected-item",
          "is-selected": !0,
          label: fe.title,
          size: "compact",
          multiple: "",
          onKeydown: [
            withKeys((ge) => se.toggleItem(fe), ["space"]),
            withKeys((ge) => se.toggleItem(fe), ["enter"])
          ],
          onClick: (ge) => se.toggleItem(fe)
        }, null, 8, ["label", "onKeydown", "onClick"]))), 128)),
        createElementVNode("div", _hoisted_6, [
          ne[7] || (ne[7] = createElementVNode("span", { class: "hx-select-select-title-text" }, "Select", -1)),
          createVNode(de, {
            id: "select-all-button",
            variant: "primary",
            ghost: "",
            size: "large",
            label: "Select All",
            onClick: se.selectAll
          }, null, 8, ["onClick"])
        ]),
        (openBlock(!0), createElementBlock(Fragment, null, renderList(se.filteredSelectItems, (fe, pe) => (openBlock(), createBlock(me, {
          key: pe,
          class: "hx-select-item",
          "is-selected": !1,
          label: fe.title,
          size: "compact",
          multiple: "",
          onKeydown: [
            withKeys((ge) => se.toggleItem(fe), ["space"]),
            withKeys((ge) => se.toggleItem(fe), ["enter"])
          ],
          onClick: (ge) => se.toggleItem(fe)
        }, null, 8, ["label", "onKeydown", "onClick"]))), 128))
      ]),
      item: withCtx(() => []),
      "append-item": withCtx(() => [
        createElementVNode("div", _hoisted_7, [
          createVNode(de, {
            id: "apply-filter-button",
            variant: "primary",
            contained: "",
            size: "large",
            label: ae.applyButtonText,
            class: "w-100",
            onClick: se.closeMenu
          }, null, 8, ["label", "onClick"])
        ])
      ]),
      "no-data": withCtx(() => [
        ne[8] || (ne[8] = createElementVNode("span", null, "No results found", -1))
      ]),
      _: 2
    }, [
      ae.errorMessages ? {
        name: "append-inner",
        fn: withCtx(() => [
          createVNode(VIcon, { icon: "mdi-alert-circle-outline" })
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["modelValue", "menu", "items", "placeholder", "messages", "error-messages", "width", "disabled"])
  ]);
}
const HxSelect = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3], ["__scopeId", "data-v-f010a138"]]), beforeEachRouteBuilder = {
  build: (re, ne) => async (ae, ie, le) => {
    if (ne)
      await ne(ae, ie, le);
    else {
      const se = await re.dispatch("cs-session/isLoggedIn");
      se && (ae.name === "login" || ae.name === "login/callback") ? le({ path: "/" }) : se ? le() : (await re.dispatch("cs-session/resetSession"), ae.path === "/" ? le({ name: "login" }) : ae.name === "login" ? le() : ae.name !== "login" && ae.name !== "login/callback" ? (localStorage.setItem("redirect", window.location.pathname), le({ name: "login" })) : le());
    }
  }
};
function arrayMap$2(re, ne) {
  for (var ae = -1, ie = re == null ? 0 : re.length, le = Array(ie); ++ae < ie; )
    le[ae] = ne(re[ae], ae, re);
  return le;
}
var _arrayMap = arrayMap$2, isArray$a = Array.isArray, isArray_1 = isArray$a, baseGetTag$4 = _baseGetTag, isObjectLike$4 = isObjectLike_1, symbolTag$1 = "[object Symbol]";
function isSymbol$4(re) {
  return typeof re == "symbol" || isObjectLike$4(re) && baseGetTag$4(re) == symbolTag$1;
}
var isSymbol_1 = isSymbol$4, isArray$9 = isArray_1, isSymbol$3 = isSymbol_1, reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey$3(re, ne) {
  if (isArray$9(re))
    return !1;
  var ae = typeof re;
  return ae == "number" || ae == "symbol" || ae == "boolean" || re == null || isSymbol$3(re) ? !0 : reIsPlainProp.test(re) || !reIsDeepProp.test(re) || ne != null && re in Object(ne);
}
var _isKey = isKey$3;
function isObject$3(re) {
  var ne = typeof re;
  return re != null && (ne == "object" || ne == "function");
}
var isObject_1 = isObject$3, baseGetTag$3 = _baseGetTag, isObject$2 = isObject_1, asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$2(re) {
  if (!isObject$2(re))
    return !1;
  var ne = baseGetTag$3(re);
  return ne == funcTag$1 || ne == genTag || ne == asyncTag || ne == proxyTag;
}
var isFunction_1 = isFunction$2, root$6 = _root, coreJsData$1 = root$6["__core-js_shared__"], _coreJsData = coreJsData$1, coreJsData = _coreJsData, maskSrcKey = function() {
  var re = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return re ? "Symbol(src)_1." + re : "";
}();
function isMasked$1(re) {
  return !!maskSrcKey && maskSrcKey in re;
}
var _isMasked = isMasked$1, funcProto$1 = Function.prototype, funcToString$1 = funcProto$1.toString;
function toSource$2(re) {
  if (re != null) {
    try {
      return funcToString$1.call(re);
    } catch {
    }
    try {
      return re + "";
    } catch {
    }
  }
  return "";
}
var _toSource = toSource$2, isFunction$1 = isFunction_1, isMasked = _isMasked, isObject$1 = isObject_1, toSource$1 = _toSource, reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reIsHostCtor = /^\[object .+?Constructor\]$/, funcProto = Function.prototype, objectProto$9 = Object.prototype, funcToString = funcProto.toString, hasOwnProperty$7 = objectProto$9.hasOwnProperty, reIsNative = RegExp(
  "^" + funcToString.call(hasOwnProperty$7).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$1(re) {
  if (!isObject$1(re) || isMasked(re))
    return !1;
  var ne = isFunction$1(re) ? reIsNative : reIsHostCtor;
  return ne.test(toSource$1(re));
}
var _baseIsNative = baseIsNative$1;
function getValue$1(re, ne) {
  return re == null ? void 0 : re[ne];
}
var _getValue = getValue$1, baseIsNative = _baseIsNative, getValue = _getValue;
function getNative$6(re, ne) {
  var ae = getValue(re, ne);
  return baseIsNative(ae) ? ae : void 0;
}
var _getNative = getNative$6, getNative$5 = _getNative, nativeCreate$4 = getNative$5(Object, "create"), _nativeCreate = nativeCreate$4, nativeCreate$3 = _nativeCreate;
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {}, this.size = 0;
}
var _hashClear = hashClear$1;
function hashDelete$1(re) {
  var ne = this.has(re) && delete this.__data__[re];
  return this.size -= ne ? 1 : 0, ne;
}
var _hashDelete = hashDelete$1, nativeCreate$2 = _nativeCreate, HASH_UNDEFINED$2 = "__lodash_hash_undefined__", objectProto$8 = Object.prototype, hasOwnProperty$6 = objectProto$8.hasOwnProperty;
function hashGet$1(re) {
  var ne = this.__data__;
  if (nativeCreate$2) {
    var ae = ne[re];
    return ae === HASH_UNDEFINED$2 ? void 0 : ae;
  }
  return hasOwnProperty$6.call(ne, re) ? ne[re] : void 0;
}
var _hashGet = hashGet$1, nativeCreate$1 = _nativeCreate, objectProto$7 = Object.prototype, hasOwnProperty$5 = objectProto$7.hasOwnProperty;
function hashHas$1(re) {
  var ne = this.__data__;
  return nativeCreate$1 ? ne[re] !== void 0 : hasOwnProperty$5.call(ne, re);
}
var _hashHas = hashHas$1, nativeCreate = _nativeCreate, HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet$1(re, ne) {
  var ae = this.__data__;
  return this.size += this.has(re) ? 0 : 1, ae[re] = nativeCreate && ne === void 0 ? HASH_UNDEFINED$1 : ne, this;
}
var _hashSet = hashSet$1, hashClear = _hashClear, hashDelete = _hashDelete, hashGet = _hashGet, hashHas = _hashHas, hashSet = _hashSet;
function Hash$1(re) {
  var ne = -1, ae = re == null ? 0 : re.length;
  for (this.clear(); ++ne < ae; ) {
    var ie = re[ne];
    this.set(ie[0], ie[1]);
  }
}
Hash$1.prototype.clear = hashClear;
Hash$1.prototype.delete = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;
function listCacheClear$1() {
  this.__data__ = [], this.size = 0;
}
var _listCacheClear = listCacheClear$1;
function eq$2(re, ne) {
  return re === ne || re !== re && ne !== ne;
}
var eq_1 = eq$2, eq$1 = eq_1;
function assocIndexOf$4(re, ne) {
  for (var ae = re.length; ae--; )
    if (eq$1(re[ae][0], ne))
      return ae;
  return -1;
}
var _assocIndexOf = assocIndexOf$4, assocIndexOf$3 = _assocIndexOf, arrayProto = Array.prototype, splice = arrayProto.splice;
function listCacheDelete$1(re) {
  var ne = this.__data__, ae = assocIndexOf$3(ne, re);
  if (ae < 0)
    return !1;
  var ie = ne.length - 1;
  return ae == ie ? ne.pop() : splice.call(ne, ae, 1), --this.size, !0;
}
var _listCacheDelete = listCacheDelete$1, assocIndexOf$2 = _assocIndexOf;
function listCacheGet$1(re) {
  var ne = this.__data__, ae = assocIndexOf$2(ne, re);
  return ae < 0 ? void 0 : ne[ae][1];
}
var _listCacheGet = listCacheGet$1, assocIndexOf$1 = _assocIndexOf;
function listCacheHas$1(re) {
  return assocIndexOf$1(this.__data__, re) > -1;
}
var _listCacheHas = listCacheHas$1, assocIndexOf = _assocIndexOf;
function listCacheSet$1(re, ne) {
  var ae = this.__data__, ie = assocIndexOf(ae, re);
  return ie < 0 ? (++this.size, ae.push([re, ne])) : ae[ie][1] = ne, this;
}
var _listCacheSet = listCacheSet$1, listCacheClear = _listCacheClear, listCacheDelete = _listCacheDelete, listCacheGet = _listCacheGet, listCacheHas = _listCacheHas, listCacheSet = _listCacheSet;
function ListCache$4(re) {
  var ne = -1, ae = re == null ? 0 : re.length;
  for (this.clear(); ++ne < ae; ) {
    var ie = re[ne];
    this.set(ie[0], ie[1]);
  }
}
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype.delete = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4, getNative$4 = _getNative, root$5 = _root, Map$4 = getNative$4(root$5, "Map"), _Map = Map$4, Hash = _Hash, ListCache$3 = _ListCache, Map$3 = _Map;
function mapCacheClear$1() {
  this.size = 0, this.__data__ = {
    hash: new Hash(),
    map: new (Map$3 || ListCache$3)(),
    string: new Hash()
  };
}
var _mapCacheClear = mapCacheClear$1;
function isKeyable$1(re) {
  var ne = typeof re;
  return ne == "string" || ne == "number" || ne == "symbol" || ne == "boolean" ? re !== "__proto__" : re === null;
}
var _isKeyable = isKeyable$1, isKeyable = _isKeyable;
function getMapData$4(re, ne) {
  var ae = re.__data__;
  return isKeyable(ne) ? ae[typeof ne == "string" ? "string" : "hash"] : ae.map;
}
var _getMapData = getMapData$4, getMapData$3 = _getMapData;
function mapCacheDelete$1(re) {
  var ne = getMapData$3(this, re).delete(re);
  return this.size -= ne ? 1 : 0, ne;
}
var _mapCacheDelete = mapCacheDelete$1, getMapData$2 = _getMapData;
function mapCacheGet$1(re) {
  return getMapData$2(this, re).get(re);
}
var _mapCacheGet = mapCacheGet$1, getMapData$1 = _getMapData;
function mapCacheHas$1(re) {
  return getMapData$1(this, re).has(re);
}
var _mapCacheHas = mapCacheHas$1, getMapData = _getMapData;
function mapCacheSet$1(re, ne) {
  var ae = getMapData(this, re), ie = ae.size;
  return ae.set(re, ne), this.size += ae.size == ie ? 0 : 1, this;
}
var _mapCacheSet = mapCacheSet$1, mapCacheClear = _mapCacheClear, mapCacheDelete = _mapCacheDelete, mapCacheGet = _mapCacheGet, mapCacheHas = _mapCacheHas, mapCacheSet = _mapCacheSet;
function MapCache$3(re) {
  var ne = -1, ae = re == null ? 0 : re.length;
  for (this.clear(); ++ne < ae; ) {
    var ie = re[ne];
    this.set(ie[0], ie[1]);
  }
}
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype.delete = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;
var _MapCache = MapCache$3, MapCache$2 = _MapCache, FUNC_ERROR_TEXT = "Expected a function";
function memoize$1(re, ne) {
  if (typeof re != "function" || ne != null && typeof ne != "function")
    throw new TypeError(FUNC_ERROR_TEXT);
  var ae = function() {
    var ie = arguments, le = ne ? ne.apply(this, ie) : ie[0], se = ae.cache;
    if (se.has(le))
      return se.get(le);
    var ce = re.apply(this, ie);
    return ae.cache = se.set(le, ce) || se, ce;
  };
  return ae.cache = new (memoize$1.Cache || MapCache$2)(), ae;
}
memoize$1.Cache = MapCache$2;
var memoize_1 = memoize$1, memoize = memoize_1, MAX_MEMOIZE_SIZE = 500;
function memoizeCapped$1(re) {
  var ne = memoize(re, function(ie) {
    return ae.size === MAX_MEMOIZE_SIZE && ae.clear(), ie;
  }), ae = ne.cache;
  return ne;
}
var _memoizeCapped = memoizeCapped$1, memoizeCapped = _memoizeCapped, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, reEscapeChar = /\\(\\)?/g, stringToPath$1 = memoizeCapped(function(re) {
  var ne = [];
  return re.charCodeAt(0) === 46 && ne.push(""), re.replace(rePropName, function(ae, ie, le, se) {
    ne.push(le ? se.replace(reEscapeChar, "$1") : ie || ae);
  }), ne;
}), _stringToPath = stringToPath$1, Symbol$2 = _Symbol, arrayMap$1 = _arrayMap, isArray$8 = isArray_1, isSymbol$2 = isSymbol_1, INFINITY$1 = 1 / 0, symbolProto$1 = Symbol$2 ? Symbol$2.prototype : void 0, symbolToString = symbolProto$1 ? symbolProto$1.toString : void 0;
function baseToString$1(re) {
  if (typeof re == "string")
    return re;
  if (isArray$8(re))
    return arrayMap$1(re, baseToString$1) + "";
  if (isSymbol$2(re))
    return symbolToString ? symbolToString.call(re) : "";
  var ne = re + "";
  return ne == "0" && 1 / re == -INFINITY$1 ? "-0" : ne;
}
var _baseToString = baseToString$1, baseToString = _baseToString;
function toString$1(re) {
  return re == null ? "" : baseToString(re);
}
var toString_1 = toString$1, isArray$7 = isArray_1, isKey$2 = _isKey, stringToPath = _stringToPath, toString = toString_1;
function castPath$2(re, ne) {
  return isArray$7(re) ? re : isKey$2(re, ne) ? [re] : stringToPath(toString(re));
}
var _castPath = castPath$2, isSymbol$1 = isSymbol_1, INFINITY = 1 / 0;
function toKey$4(re) {
  if (typeof re == "string" || isSymbol$1(re))
    return re;
  var ne = re + "";
  return ne == "0" && 1 / re == -INFINITY ? "-0" : ne;
}
var _toKey = toKey$4, castPath$1 = _castPath, toKey$3 = _toKey;
function baseGet$3(re, ne) {
  ne = castPath$1(ne, re);
  for (var ae = 0, ie = ne.length; re != null && ae < ie; )
    re = re[toKey$3(ne[ae++])];
  return ae && ae == ie ? re : void 0;
}
var _baseGet = baseGet$3, ListCache$2 = _ListCache;
function stackClear$1() {
  this.__data__ = new ListCache$2(), this.size = 0;
}
var _stackClear = stackClear$1;
function stackDelete$1(re) {
  var ne = this.__data__, ae = ne.delete(re);
  return this.size = ne.size, ae;
}
var _stackDelete = stackDelete$1;
function stackGet$1(re) {
  return this.__data__.get(re);
}
var _stackGet = stackGet$1;
function stackHas$1(re) {
  return this.__data__.has(re);
}
var _stackHas = stackHas$1, ListCache$1 = _ListCache, Map$2 = _Map, MapCache$1 = _MapCache, LARGE_ARRAY_SIZE = 200;
function stackSet$1(re, ne) {
  var ae = this.__data__;
  if (ae instanceof ListCache$1) {
    var ie = ae.__data__;
    if (!Map$2 || ie.length < LARGE_ARRAY_SIZE - 1)
      return ie.push([re, ne]), this.size = ++ae.size, this;
    ae = this.__data__ = new MapCache$1(ie);
  }
  return ae.set(re, ne), this.size = ae.size, this;
}
var _stackSet = stackSet$1, ListCache = _ListCache, stackClear = _stackClear, stackDelete = _stackDelete, stackGet = _stackGet, stackHas = _stackHas, stackSet = _stackSet;
function Stack$2(re) {
  var ne = this.__data__ = new ListCache(re);
  this.size = ne.size;
}
Stack$2.prototype.clear = stackClear;
Stack$2.prototype.delete = stackDelete;
Stack$2.prototype.get = stackGet;
Stack$2.prototype.has = stackHas;
Stack$2.prototype.set = stackSet;
var _Stack = Stack$2, HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd$1(re) {
  return this.__data__.set(re, HASH_UNDEFINED), this;
}
var _setCacheAdd = setCacheAdd$1;
function setCacheHas$1(re) {
  return this.__data__.has(re);
}
var _setCacheHas = setCacheHas$1, MapCache = _MapCache, setCacheAdd = _setCacheAdd, setCacheHas = _setCacheHas;
function SetCache$1(re) {
  var ne = -1, ae = re == null ? 0 : re.length;
  for (this.__data__ = new MapCache(); ++ne < ae; )
    this.add(re[ne]);
}
SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;
var _SetCache = SetCache$1;
function arraySome$1(re, ne) {
  for (var ae = -1, ie = re == null ? 0 : re.length; ++ae < ie; )
    if (ne(re[ae], ae, re))
      return !0;
  return !1;
}
var _arraySome = arraySome$1;
function cacheHas$1(re, ne) {
  return re.has(ne);
}
var _cacheHas = cacheHas$1, SetCache = _SetCache, arraySome = _arraySome, cacheHas = _cacheHas, COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays$2(re, ne, ae, ie, le, se) {
  var ce = ae & COMPARE_PARTIAL_FLAG$5, ue = re.length, de = ne.length;
  if (ue != de && !(ce && de > ue))
    return !1;
  var me = se.get(re), fe = se.get(ne);
  if (me && fe)
    return me == ne && fe == re;
  var pe = -1, ge = !0, be = ae & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  for (se.set(re, ne), se.set(ne, re); ++pe < ue; ) {
    var Se = re[pe], Pe = ne[pe];
    if (ie)
      var Ee = ce ? ie(Pe, Se, pe, ne, re, se) : ie(Se, Pe, pe, re, ne, se);
    if (Ee !== void 0) {
      if (Ee)
        continue;
      ge = !1;
      break;
    }
    if (be) {
      if (!arraySome(ne, function(Ve, Ae) {
        if (!cacheHas(be, Ae) && (Se === Ve || le(Se, Ve, ae, ie, se)))
          return be.push(Ae);
      })) {
        ge = !1;
        break;
      }
    } else if (!(Se === Pe || le(Se, Pe, ae, ie, se))) {
      ge = !1;
      break;
    }
  }
  return se.delete(re), se.delete(ne), ge;
}
var _equalArrays = equalArrays$2, root$4 = _root, Uint8Array$2 = root$4.Uint8Array, _Uint8Array = Uint8Array$2;
function mapToArray$1(re) {
  var ne = -1, ae = Array(re.size);
  return re.forEach(function(ie, le) {
    ae[++ne] = [le, ie];
  }), ae;
}
var _mapToArray = mapToArray$1;
function setToArray$1(re) {
  var ne = -1, ae = Array(re.size);
  return re.forEach(function(ie) {
    ae[++ne] = ie;
  }), ae;
}
var _setToArray = setToArray$1, Symbol$1 = _Symbol, Uint8Array$1 = _Uint8Array, eq = eq_1, equalArrays$1 = _equalArrays, mapToArray = _mapToArray, setToArray = _setToArray, COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2, boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", symbolTag = "[object Symbol]", arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag$1(re, ne, ae, ie, le, se, ce) {
  switch (ae) {
    case dataViewTag$2:
      if (re.byteLength != ne.byteLength || re.byteOffset != ne.byteOffset)
        return !1;
      re = re.buffer, ne = ne.buffer;
    case arrayBufferTag$1:
      return !(re.byteLength != ne.byteLength || !se(new Uint8Array$1(re), new Uint8Array$1(ne)));
    case boolTag$1:
    case dateTag$1:
    case numberTag$1:
      return eq(+re, +ne);
    case errorTag$1:
      return re.name == ne.name && re.message == ne.message;
    case regexpTag$1:
    case stringTag$1:
      return re == ne + "";
    case mapTag$2:
      var ue = mapToArray;
    case setTag$2:
      var de = ie & COMPARE_PARTIAL_FLAG$4;
      if (ue || (ue = setToArray), re.size != ne.size && !de)
        return !1;
      var me = ce.get(re);
      if (me)
        return me == ne;
      ie |= COMPARE_UNORDERED_FLAG$2, ce.set(re, ne);
      var fe = equalArrays$1(ue(re), ue(ne), ie, le, se, ce);
      return ce.delete(re), fe;
    case symbolTag:
      if (symbolValueOf)
        return symbolValueOf.call(re) == symbolValueOf.call(ne);
  }
  return !1;
}
var _equalByTag = equalByTag$1;
function arrayPush$1(re, ne) {
  for (var ae = -1, ie = ne.length, le = re.length; ++ae < ie; )
    re[le + ae] = ne[ae];
  return re;
}
var _arrayPush = arrayPush$1, arrayPush = _arrayPush, isArray$6 = isArray_1;
function baseGetAllKeys$1(re, ne, ae) {
  var ie = ne(re);
  return isArray$6(re) ? ie : arrayPush(ie, ae(re));
}
var _baseGetAllKeys = baseGetAllKeys$1;
function arrayFilter$1(re, ne) {
  for (var ae = -1, ie = re == null ? 0 : re.length, le = 0, se = []; ++ae < ie; ) {
    var ce = re[ae];
    ne(ce, ae, re) && (se[le++] = ce);
  }
  return se;
}
var _arrayFilter = arrayFilter$1;
function stubArray$1() {
  return [];
}
var stubArray_1 = stubArray$1, arrayFilter = _arrayFilter, stubArray = stubArray_1, objectProto$6 = Object.prototype, propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable, nativeGetSymbols = Object.getOwnPropertySymbols, getSymbols$1 = nativeGetSymbols ? function(re) {
  return re == null ? [] : (re = Object(re), arrayFilter(nativeGetSymbols(re), function(ne) {
    return propertyIsEnumerable$1.call(re, ne);
  }));
} : stubArray, _getSymbols = getSymbols$1;
function baseTimes$1(re, ne) {
  for (var ae = -1, ie = Array(re); ++ae < re; )
    ie[ae] = ne(ae);
  return ie;
}
var _baseTimes = baseTimes$1, baseGetTag$2 = _baseGetTag, isObjectLike$3 = isObjectLike_1, argsTag$2 = "[object Arguments]";
function baseIsArguments$1(re) {
  return isObjectLike$3(re) && baseGetTag$2(re) == argsTag$2;
}
var _baseIsArguments = baseIsArguments$1, baseIsArguments = _baseIsArguments, isObjectLike$2 = isObjectLike_1, objectProto$5 = Object.prototype, hasOwnProperty$4 = objectProto$5.hasOwnProperty, propertyIsEnumerable = objectProto$5.propertyIsEnumerable, isArguments$2 = baseIsArguments(/* @__PURE__ */ function() {
  return arguments;
}()) ? baseIsArguments : function(re) {
  return isObjectLike$2(re) && hasOwnProperty$4.call(re, "callee") && !propertyIsEnumerable.call(re, "callee");
}, isArguments_1 = isArguments$2, isBuffer$2 = { exports: {} };
function stubFalse() {
  return !1;
}
var stubFalse_1 = stubFalse;
isBuffer$2.exports;
(function(re, ne) {
  var ae = _root, ie = stubFalse_1, le = ne && !ne.nodeType && ne, se = le && !0 && re && !re.nodeType && re, ce = se && se.exports === le, ue = ce ? ae.Buffer : void 0, de = ue ? ue.isBuffer : void 0, me = de || ie;
  re.exports = me;
})(isBuffer$2, isBuffer$2.exports);
var isBufferExports = isBuffer$2.exports, MAX_SAFE_INTEGER$1 = 9007199254740991, reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex$2(re, ne) {
  var ae = typeof re;
  return ne = ne ?? MAX_SAFE_INTEGER$1, !!ne && (ae == "number" || ae != "symbol" && reIsUint.test(re)) && re > -1 && re % 1 == 0 && re < ne;
}
var _isIndex = isIndex$2, MAX_SAFE_INTEGER = 9007199254740991;
function isLength$3(re) {
  return typeof re == "number" && re > -1 && re % 1 == 0 && re <= MAX_SAFE_INTEGER;
}
var isLength_1 = isLength$3, baseGetTag$1 = _baseGetTag, isLength$2 = isLength_1, isObjectLike$1 = isObjectLike_1, argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag$1 = "[object Map]", numberTag = "[object Number]", objectTag$2 = "[object Object]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", weakMapTag$1 = "[object WeakMap]", arrayBufferTag = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]", typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = !0;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag] = typedArrayTags[setTag$1] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag$1] = !1;
function baseIsTypedArray$1(re) {
  return isObjectLike$1(re) && isLength$2(re.length) && !!typedArrayTags[baseGetTag$1(re)];
}
var _baseIsTypedArray = baseIsTypedArray$1;
function baseUnary$2(re) {
  return function(ne) {
    return re(ne);
  };
}
var _baseUnary = baseUnary$2, _nodeUtil = { exports: {} };
_nodeUtil.exports;
(function(re, ne) {
  var ae = _freeGlobal, ie = ne && !ne.nodeType && ne, le = ie && !0 && re && !re.nodeType && re, se = le && le.exports === ie, ce = se && ae.process, ue = function() {
    try {
      var de = le && le.require && le.require("util").types;
      return de || ce && ce.binding && ce.binding("util");
    } catch {
    }
  }();
  re.exports = ue;
})(_nodeUtil, _nodeUtil.exports);
var _nodeUtilExports = _nodeUtil.exports, baseIsTypedArray = _baseIsTypedArray, baseUnary$1 = _baseUnary, nodeUtil = _nodeUtilExports, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray, isTypedArray$2 = nodeIsTypedArray ? baseUnary$1(nodeIsTypedArray) : baseIsTypedArray, isTypedArray_1 = isTypedArray$2, baseTimes = _baseTimes, isArguments$1 = isArguments_1, isArray$5 = isArray_1, isBuffer$1 = isBufferExports, isIndex$1 = _isIndex, isTypedArray$1 = isTypedArray_1, objectProto$4 = Object.prototype, hasOwnProperty$3 = objectProto$4.hasOwnProperty;
function arrayLikeKeys$1(re, ne) {
  var ae = isArray$5(re), ie = !ae && isArguments$1(re), le = !ae && !ie && isBuffer$1(re), se = !ae && !ie && !le && isTypedArray$1(re), ce = ae || ie || le || se, ue = ce ? baseTimes(re.length, String) : [], de = ue.length;
  for (var me in re)
    (ne || hasOwnProperty$3.call(re, me)) && !(ce && // Safari 9 has enumerable `arguments.length` in strict mode.
    (me == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    le && (me == "offset" || me == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    se && (me == "buffer" || me == "byteLength" || me == "byteOffset") || // Skip index properties.
    isIndex$1(me, de))) && ue.push(me);
  return ue;
}
var _arrayLikeKeys = arrayLikeKeys$1, objectProto$3 = Object.prototype;
function isPrototype$1(re) {
  var ne = re && re.constructor, ae = typeof ne == "function" && ne.prototype || objectProto$3;
  return re === ae;
}
var _isPrototype = isPrototype$1;
function overArg$1(re, ne) {
  return function(ae) {
    return re(ne(ae));
  };
}
var _overArg = overArg$1, overArg = _overArg, nativeKeys$1 = overArg(Object.keys, Object), _nativeKeys = nativeKeys$1, isPrototype = _isPrototype, nativeKeys = _nativeKeys, objectProto$2 = Object.prototype, hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function baseKeys$1(re) {
  if (!isPrototype(re))
    return nativeKeys(re);
  var ne = [];
  for (var ae in Object(re))
    hasOwnProperty$2.call(re, ae) && ae != "constructor" && ne.push(ae);
  return ne;
}
var _baseKeys = baseKeys$1, isFunction = isFunction_1, isLength$1 = isLength_1;
function isArrayLike$3(re) {
  return re != null && isLength$1(re.length) && !isFunction(re);
}
var isArrayLike_1 = isArrayLike$3, arrayLikeKeys = _arrayLikeKeys, baseKeys = _baseKeys, isArrayLike$2 = isArrayLike_1;
function keys$3(re) {
  return isArrayLike$2(re) ? arrayLikeKeys(re) : baseKeys(re);
}
var keys_1 = keys$3, baseGetAllKeys = _baseGetAllKeys, getSymbols = _getSymbols, keys$2 = keys_1;
function getAllKeys$1(re) {
  return baseGetAllKeys(re, keys$2, getSymbols);
}
var _getAllKeys = getAllKeys$1, getAllKeys = _getAllKeys, COMPARE_PARTIAL_FLAG$3 = 1, objectProto$1 = Object.prototype, hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function equalObjects$1(re, ne, ae, ie, le, se) {
  var ce = ae & COMPARE_PARTIAL_FLAG$3, ue = getAllKeys(re), de = ue.length, me = getAllKeys(ne), fe = me.length;
  if (de != fe && !ce)
    return !1;
  for (var pe = de; pe--; ) {
    var ge = ue[pe];
    if (!(ce ? ge in ne : hasOwnProperty$1.call(ne, ge)))
      return !1;
  }
  var be = se.get(re), Se = se.get(ne);
  if (be && Se)
    return be == ne && Se == re;
  var Pe = !0;
  se.set(re, ne), se.set(ne, re);
  for (var Ee = ce; ++pe < de; ) {
    ge = ue[pe];
    var Ve = re[ge], Ae = ne[ge];
    if (ie)
      var Oe = ce ? ie(Ae, Ve, ge, ne, re, se) : ie(Ve, Ae, ge, re, ne, se);
    if (!(Oe === void 0 ? Ve === Ae || le(Ve, Ae, ae, ie, se) : Oe)) {
      Pe = !1;
      break;
    }
    Ee || (Ee = ge == "constructor");
  }
  if (Pe && !Ee) {
    var Ne = re.constructor, He = ne.constructor;
    Ne != He && "constructor" in re && "constructor" in ne && !(typeof Ne == "function" && Ne instanceof Ne && typeof He == "function" && He instanceof He) && (Pe = !1);
  }
  return se.delete(re), se.delete(ne), Pe;
}
var _equalObjects = equalObjects$1, getNative$3 = _getNative, root$3 = _root, DataView$2 = getNative$3(root$3, "DataView"), _DataView = DataView$2, getNative$2 = _getNative, root$2 = _root, Promise$2 = getNative$2(root$2, "Promise"), _Promise = Promise$2, getNative$1 = _getNative, root$1 = _root, Set$2 = getNative$1(root$1, "Set"), _Set = Set$2, getNative = _getNative, root = _root, WeakMap$2 = getNative(root, "WeakMap"), _WeakMap = WeakMap$2, DataView$1 = _DataView, Map$1 = _Map, Promise$1 = _Promise, Set$1 = _Set, WeakMap$1 = _WeakMap, baseGetTag = _baseGetTag, toSource = _toSource, mapTag = "[object Map]", objectTag$1 = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]", dataViewTag = "[object DataView]", dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap$1), getTag$1 = baseGetTag;
(DataView$1 && getTag$1(new DataView$1(new ArrayBuffer(1))) != dataViewTag || Map$1 && getTag$1(new Map$1()) != mapTag || Promise$1 && getTag$1(Promise$1.resolve()) != promiseTag || Set$1 && getTag$1(new Set$1()) != setTag || WeakMap$1 && getTag$1(new WeakMap$1()) != weakMapTag) && (getTag$1 = function(re) {
  var ne = baseGetTag(re), ae = ne == objectTag$1 ? re.constructor : void 0, ie = ae ? toSource(ae) : "";
  if (ie)
    switch (ie) {
      case dataViewCtorString:
        return dataViewTag;
      case mapCtorString:
        return mapTag;
      case promiseCtorString:
        return promiseTag;
      case setCtorString:
        return setTag;
      case weakMapCtorString:
        return weakMapTag;
    }
  return ne;
});
var _getTag = getTag$1, Stack$1 = _Stack, equalArrays = _equalArrays, equalByTag = _equalByTag, equalObjects = _equalObjects, getTag = _getTag, isArray$4 = isArray_1, isBuffer = isBufferExports, isTypedArray = isTypedArray_1, COMPARE_PARTIAL_FLAG$2 = 1, argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]", objectProto = Object.prototype, hasOwnProperty = objectProto.hasOwnProperty;
function baseIsEqualDeep$1(re, ne, ae, ie, le, se) {
  var ce = isArray$4(re), ue = isArray$4(ne), de = ce ? arrayTag : getTag(re), me = ue ? arrayTag : getTag(ne);
  de = de == argsTag ? objectTag : de, me = me == argsTag ? objectTag : me;
  var fe = de == objectTag, pe = me == objectTag, ge = de == me;
  if (ge && isBuffer(re)) {
    if (!isBuffer(ne))
      return !1;
    ce = !0, fe = !1;
  }
  if (ge && !fe)
    return se || (se = new Stack$1()), ce || isTypedArray(re) ? equalArrays(re, ne, ae, ie, le, se) : equalByTag(re, ne, de, ae, ie, le, se);
  if (!(ae & COMPARE_PARTIAL_FLAG$2)) {
    var be = fe && hasOwnProperty.call(re, "__wrapped__"), Se = pe && hasOwnProperty.call(ne, "__wrapped__");
    if (be || Se) {
      var Pe = be ? re.value() : re, Ee = Se ? ne.value() : ne;
      return se || (se = new Stack$1()), le(Pe, Ee, ae, ie, se);
    }
  }
  return ge ? (se || (se = new Stack$1()), equalObjects(re, ne, ae, ie, le, se)) : !1;
}
var _baseIsEqualDeep = baseIsEqualDeep$1, baseIsEqualDeep = _baseIsEqualDeep, isObjectLike = isObjectLike_1;
function baseIsEqual$2(re, ne, ae, ie, le) {
  return re === ne ? !0 : re == null || ne == null || !isObjectLike(re) && !isObjectLike(ne) ? re !== re && ne !== ne : baseIsEqualDeep(re, ne, ae, ie, baseIsEqual$2, le);
}
var _baseIsEqual = baseIsEqual$2, Stack = _Stack, baseIsEqual$1 = _baseIsEqual, COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch$1(re, ne, ae, ie) {
  var le = ae.length, se = le, ce = !ie;
  if (re == null)
    return !se;
  for (re = Object(re); le--; ) {
    var ue = ae[le];
    if (ce && ue[2] ? ue[1] !== re[ue[0]] : !(ue[0] in re))
      return !1;
  }
  for (; ++le < se; ) {
    ue = ae[le];
    var de = ue[0], me = re[de], fe = ue[1];
    if (ce && ue[2]) {
      if (me === void 0 && !(de in re))
        return !1;
    } else {
      var pe = new Stack();
      if (ie)
        var ge = ie(me, fe, de, re, ne, pe);
      if (!(ge === void 0 ? baseIsEqual$1(fe, me, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, ie, pe) : ge))
        return !1;
    }
  }
  return !0;
}
var _baseIsMatch = baseIsMatch$1, isObject = isObject_1;
function isStrictComparable$2(re) {
  return re === re && !isObject(re);
}
var _isStrictComparable = isStrictComparable$2, isStrictComparable$1 = _isStrictComparable, keys$1 = keys_1;
function getMatchData$1(re) {
  for (var ne = keys$1(re), ae = ne.length; ae--; ) {
    var ie = ne[ae], le = re[ie];
    ne[ae] = [ie, le, isStrictComparable$1(le)];
  }
  return ne;
}
var _getMatchData = getMatchData$1;
function matchesStrictComparable$2(re, ne) {
  return function(ae) {
    return ae == null ? !1 : ae[re] === ne && (ne !== void 0 || re in Object(ae));
  };
}
var _matchesStrictComparable = matchesStrictComparable$2, baseIsMatch = _baseIsMatch, getMatchData = _getMatchData, matchesStrictComparable$1 = _matchesStrictComparable;
function baseMatches$1(re) {
  var ne = getMatchData(re);
  return ne.length == 1 && ne[0][2] ? matchesStrictComparable$1(ne[0][0], ne[0][1]) : function(ae) {
    return ae === re || baseIsMatch(ae, re, ne);
  };
}
var _baseMatches = baseMatches$1, baseGet$2 = _baseGet;
function get$1(re, ne, ae) {
  var ie = re == null ? void 0 : baseGet$2(re, ne);
  return ie === void 0 ? ae : ie;
}
var get_1 = get$1;
function baseHasIn$1(re, ne) {
  return re != null && ne in Object(re);
}
var _baseHasIn = baseHasIn$1, castPath = _castPath, isArguments = isArguments_1, isArray$3 = isArray_1, isIndex = _isIndex, isLength = isLength_1, toKey$2 = _toKey;
function hasPath$1(re, ne, ae) {
  ne = castPath(ne, re);
  for (var ie = -1, le = ne.length, se = !1; ++ie < le; ) {
    var ce = toKey$2(ne[ie]);
    if (!(se = re != null && ae(re, ce)))
      break;
    re = re[ce];
  }
  return se || ++ie != le ? se : (le = re == null ? 0 : re.length, !!le && isLength(le) && isIndex(ce, le) && (isArray$3(re) || isArguments(re)));
}
var _hasPath = hasPath$1, baseHasIn = _baseHasIn, hasPath = _hasPath;
function hasIn$1(re, ne) {
  return re != null && hasPath(re, ne, baseHasIn);
}
var hasIn_1 = hasIn$1, baseIsEqual = _baseIsEqual, get = get_1, hasIn = hasIn_1, isKey$1 = _isKey, isStrictComparable = _isStrictComparable, matchesStrictComparable = _matchesStrictComparable, toKey$1 = _toKey, COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty$1(re, ne) {
  return isKey$1(re) && isStrictComparable(ne) ? matchesStrictComparable(toKey$1(re), ne) : function(ae) {
    var ie = get(ae, re);
    return ie === void 0 && ie === ne ? hasIn(ae, re) : baseIsEqual(ne, ie, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
var _baseMatchesProperty = baseMatchesProperty$1;
function identity$2(re) {
  return re;
}
var identity_1 = identity$2;
function baseProperty$1(re) {
  return function(ne) {
    return ne == null ? void 0 : ne[re];
  };
}
var _baseProperty = baseProperty$1, baseGet$1 = _baseGet;
function basePropertyDeep$1(re) {
  return function(ne) {
    return baseGet$1(ne, re);
  };
}
var _basePropertyDeep = basePropertyDeep$1, baseProperty = _baseProperty, basePropertyDeep = _basePropertyDeep, isKey = _isKey, toKey = _toKey;
function property$1(re) {
  return isKey(re) ? baseProperty(toKey(re)) : basePropertyDeep(re);
}
var property_1 = property$1, baseMatches = _baseMatches, baseMatchesProperty = _baseMatchesProperty, identity$1 = identity_1, isArray$2 = isArray_1, property = property_1;
function baseIteratee$1(re) {
  return typeof re == "function" ? re : re == null ? identity$1 : typeof re == "object" ? isArray$2(re) ? baseMatchesProperty(re[0], re[1]) : baseMatches(re) : property(re);
}
var _baseIteratee = baseIteratee$1;
function createBaseFor$1(re) {
  return function(ne, ae, ie) {
    for (var le = -1, se = Object(ne), ce = ie(ne), ue = ce.length; ue--; ) {
      var de = ce[re ? ue : ++le];
      if (ae(se[de], de, se) === !1)
        break;
    }
    return ne;
  };
}
var _createBaseFor = createBaseFor$1, createBaseFor = _createBaseFor, baseFor$1 = createBaseFor(), _baseFor = baseFor$1, baseFor = _baseFor, keys = keys_1;
function baseForOwn$1(re, ne) {
  return re && baseFor(re, ne, keys);
}
var _baseForOwn = baseForOwn$1, isArrayLike$1 = isArrayLike_1;
function createBaseEach$1(re, ne) {
  return function(ae, ie) {
    if (ae == null)
      return ae;
    if (!isArrayLike$1(ae))
      return re(ae, ie);
    for (var le = ae.length, se = ne ? le : -1, ce = Object(ae); (ne ? se-- : ++se < le) && ie(ce[se], se, ce) !== !1; )
      ;
    return ae;
  };
}
var _createBaseEach = createBaseEach$1, baseForOwn = _baseForOwn, createBaseEach = _createBaseEach, baseEach$1 = createBaseEach(baseForOwn), _baseEach = baseEach$1, baseEach = _baseEach, isArrayLike = isArrayLike_1;
function baseMap$1(re, ne) {
  var ae = -1, ie = isArrayLike(re) ? Array(re.length) : [];
  return baseEach(re, function(le, se, ce) {
    ie[++ae] = ne(le, se, ce);
  }), ie;
}
var _baseMap = baseMap$1;
function baseSortBy$1(re, ne) {
  var ae = re.length;
  for (re.sort(ne); ae--; )
    re[ae] = re[ae].value;
  return re;
}
var _baseSortBy = baseSortBy$1, isSymbol = isSymbol_1;
function compareAscending$1(re, ne) {
  if (re !== ne) {
    var ae = re !== void 0, ie = re === null, le = re === re, se = isSymbol(re), ce = ne !== void 0, ue = ne === null, de = ne === ne, me = isSymbol(ne);
    if (!ue && !me && !se && re > ne || se && ce && de && !ue && !me || ie && ce && de || !ae && de || !le)
      return 1;
    if (!ie && !se && !me && re < ne || me && ae && le && !ie && !se || ue && ae && le || !ce && le || !de)
      return -1;
  }
  return 0;
}
var _compareAscending = compareAscending$1, compareAscending = _compareAscending;
function compareMultiple$1(re, ne, ae) {
  for (var ie = -1, le = re.criteria, se = ne.criteria, ce = le.length, ue = ae.length; ++ie < ce; ) {
    var de = compareAscending(le[ie], se[ie]);
    if (de) {
      if (ie >= ue)
        return de;
      var me = ae[ie];
      return de * (me == "desc" ? -1 : 1);
    }
  }
  return re.index - ne.index;
}
var _compareMultiple = compareMultiple$1, arrayMap = _arrayMap, baseGet = _baseGet, baseIteratee = _baseIteratee, baseMap = _baseMap, baseSortBy = _baseSortBy, baseUnary = _baseUnary, compareMultiple = _compareMultiple, identity = identity_1, isArray$1 = isArray_1;
function baseOrderBy$1(re, ne, ae) {
  ne.length ? ne = arrayMap(ne, function(se) {
    return isArray$1(se) ? function(ce) {
      return baseGet(ce, se.length === 1 ? se[0] : se);
    } : se;
  }) : ne = [identity];
  var ie = -1;
  ne = arrayMap(ne, baseUnary(baseIteratee));
  var le = baseMap(re, function(se, ce, ue) {
    var de = arrayMap(ne, function(me) {
      return me(se);
    });
    return { criteria: de, index: ++ie, value: se };
  });
  return baseSortBy(le, function(se, ce) {
    return compareMultiple(se, ce, ae);
  });
}
var _baseOrderBy = baseOrderBy$1, baseOrderBy = _baseOrderBy, isArray = isArray_1;
function orderBy(re, ne, ae, ie) {
  return re == null ? [] : (isArray(ne) || (ne = ne == null ? [] : [ne]), ae = ie ? void 0 : ae, isArray(ae) || (ae = ae == null ? [] : [ae]), baseOrderBy(re, ne, ae));
}
var orderBy_1 = orderBy;
const orderBy$1 = /* @__PURE__ */ getDefaultExportFromCjs(orderBy_1), _sfc_main$2 = {
  name: "CSIllustrationSelectorPanel",
  props: {
    id: { type: String, required: !1, default: "" },
    modelValue: { type: String, required: !1, default: void 0 },
    search: { type: String, required: !1, default: "" },
    path: { type: String, required: !0 },
    show: { type: Boolean, required: !1, default: !0 }
  },
  emits: ["update:modelValue", "change", "hasSelected", "isEmpty"],
  data() {
    return {
      items: [],
      selected: void 0,
      selectedOrigin: void 0,
      isUserClick: !1
    };
  },
  computed: {
    filteredItems() {
      if (this.search && this.items) {
        const re = this.search.toLowerCase();
        return this.items.filter((ne) => ne.name.toLowerCase().includes(re));
      }
      return this.items || [];
    }
  },
  watch: {
    modelValue() {
      this.resetSelection(this.filteredItems);
    },
    filteredItems(re) {
      re.length > 0 ? (this.selectByUrl(re, this.modelValue), this.$emit("isEmpty", !1)) : this.$emit("isEmpty", !0);
    }
  },
  async mounted() {
    await this.getSelectorItems(), this.resetSelection(this.items);
  },
  methods: {
    onItemClicks() {
      this.isUserClick = !0;
    },
    async getSelectorItems() {
      const re = this.path || "", ne = await illustration.getListBy(re), ae = illustration.getDirPathBy(re), ie = [];
      ne.forEach((le) => {
        le && ie.push({
          name: le.substring(0, le.lastIndexOf(".")),
          url: `${ae}${le}`
        });
      }), this.items = orderBy$1(ie, [(le) => le.name.toLowerCase()], ["asc"]);
    },
    onSelectChange(re) {
      re && re.url ? (this.$emit("update:modelValue", re.url), this.$emit("change", re)) : this.isUserClick && !re && (this.$emit("update:modelValue", ""), this.$emit("change", "")), this.isUserClick = !1;
    },
    selectByUrl(re, ne) {
      if (ne) {
        const ae = re.find((ie) => ie.url === ne);
        ae ? this.selected = ae : this.selected = void 0;
      } else
        this.selected = void 0;
    },
    resetSelection(re) {
      this.selectByUrl(re, this.modelValue), this.$emit("hasSelected", !!this.selected);
    }
  }
}, _hoisted_1$2 = { class: "cs-illustration-selector-panel-btn-div" }, _hoisted_2$2 = ["src"], _hoisted_3 = { class: "mb-0 style-12-wide cs-illustration-selector-panel-btn-name" };
function _sfc_render$2(re, ne, ae, ie, le, se) {
  return ae.show ? (openBlock(), createBlock(VItemGroup, {
    key: 0,
    modelValue: le.selected,
    "onUpdate:modelValue": [
      ne[0] || (ne[0] = (ce) => le.selected = ce),
      se.onSelectChange
    ],
    class: "cs-illustration-selector-panel",
    "show-arrows": "",
    "selected-class": "cs-illustration-selector-panel-active-item"
  }, {
    default: withCtx(() => [
      (openBlock(!0), createElementBlock(Fragment, null, renderList(se.filteredItems, (ce, ue) => (openBlock(), createElementBlock("div", {
        key: ue,
        cols: "1"
      }, [
        createVNode(VItem, { value: ce }, {
          default: withCtx(({ isSelected: de, toggle: me }) => [
            createVNode(VTooltip, { location: "bottom" }, {
              activator: withCtx(({ props: fe }) => [
                createVNode(VBtn, mergeProps({ ref_for: !0 }, fe, {
                  class: "cs-illustration-selector-panel-btn",
                  active: de,
                  "selected-class": "cs-illustration-selector-panel-active-item",
                  variant: "flat",
                  ripple: !1,
                  height: "100px",
                  width: "100px",
                  onClick: (pe) => {
                    se.onItemClicks(), me(pe);
                  }
                }), {
                  default: withCtx(() => [
                    createElementVNode("div", _hoisted_1$2, [
                      createElementVNode("img", {
                        class: "cs-illustration-selector-panel-btn-img",
                        src: encodeURI(ce.url),
                        alt: ""
                      }, null, 8, _hoisted_2$2),
                      createElementVNode("div", _hoisted_3, toDisplayString$1(ce.name), 1)
                    ])
                  ]),
                  _: 2
                }, 1040, ["active", "onClick"])
              ]),
              default: withCtx(() => [
                createElementVNode("span", null, toDisplayString$1(ce.name), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["value"])
      ]))), 128))
    ]),
    _: 1
  }, 8, ["modelValue", "onUpdate:modelValue"])) : createCommentVNode("", !0);
}
const CSIllustrationSelectorPanel = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2], ["__scopeId", "data-v-44088b71"]]), _sfc_main$1 = {
  name: "CSIllustrationSelector",
  components: { "cs-illustration-selector-panel": CSIllustrationSelectorPanel },
  props: {
    id: { type: String, required: !1, default: "" },
    modelValue: { type: String, required: !1, default: void 0 },
    path: { type: String, required: !0 }
  },
  emits: ["update:modelValue", "change"],
  data() {
    return {
      tabItems: [],
      search: "",
      tab: 0,
      selectedUrl: "",
      expand: !1
    };
  },
  computed: {
    hasTab() {
      return !!(this.tabItems && this.tabItems.length > 0);
    }
  },
  watch: {
    modelValue(re) {
      this.selectByUrl(re);
    }
  },
  async mounted() {
    await this.getTabItems(), this.selectByUrl(this.modelValue);
  },
  methods: {
    async getTabItems() {
      const re = this.path || "", ne = await illustration.getDirListBy(re), ae = illustration.getDirPathBy(re), ie = [];
      ne.forEach((le) => {
        le && ie.push({
          name: le,
          url: `${ae}${le}`,
          path: `${re}/${le}`,
          isEmpty: !1,
          hasSelected: !1
        });
      }), this.tabItems = orderBy$1(ie, [(le) => le.name.toLowerCase()], ["asc"]);
    },
    onSelectChange(re) {
      re && re.url ? (this.$emit("update:modelValue", re.url), this.$emit("change", re.url)) : re || (this.$emit("update:modelValue", ""), this.$emit("change", ""));
    },
    selectByUrl(re) {
      this.selectedUrl = re;
    },
    onPanelIsEmpty(re, ne) {
      this.tabItems[re].isEmpty = ne, this.tabItems[this.tab] && this.tabItems[this.tab].isEmpty && this.resetSelectedTab();
    },
    onPanelHasSelected(re, ne) {
      this.tabItems[re].hasSelected = ne, this.tabItems[this.tab] && !this.tabItems[this.tab].hasSelected && this.resetSelectedTab();
    },
    resetSelectedTab() {
      let re = -1, ne = -1;
      this.tabItems.every((ae, ie) => !ae.isEmpty && (re < 0 && (re = ie), ae.hasSelected) ? (ne = ie, !1) : !0), ne > -1 ? this.tab = ne : re > -1 && (this.tab = re);
    },
    onExpand() {
      this.expand = !0, this.search = "";
    }
  }
}, _hoisted_1$1 = { class: "cs-illustration-selector" }, _hoisted_2$1 = { class: "grid-content" };
function _sfc_render$1(re, ne, ae, ie, le, se) {
  const ce = resolveComponent("cs-illustration-selector-panel");
  return openBlock(), createElementBlock("div", _hoisted_1$1, [
    ne[5] || (ne[5] = createElementVNode("div", { class: "style-07 cs-illustration-selector-label" }, "Choose Icon", -1)),
    le.expand ? (openBlock(), createBlock(VSheet, {
      key: 1,
      id: ae.id,
      fluid: "",
      class: "pa-0 mx-auto cs-illustration-selector-sheet",
      width: "100%",
      style: { "justify-content": "center" },
      elevation: "2"
    }, {
      default: withCtx(() => [
        createVNode(VTextField, {
          id: "cs-illustration-selector-search",
          modelValue: le.search,
          "onUpdate:modelValue": ne[0] || (ne[0] = (ue) => le.search = ue),
          density: "compact",
          variant: "outlined",
          "hide-details": "auto",
          class: "ma-0 cs-illustration-selector-search",
          "prepend-inner-icon": "mdi-magnify",
          "append-inner-icon": "mdi-chevron-up",
          placeholder: "Search",
          color: "secondary-darken-3",
          "onClick:appendInner": ne[1] || (ne[1] = (ue) => le.expand = !1)
        }, null, 8, ["modelValue"]),
        se.hasTab ? createCommentVNode("", !0) : (openBlock(), createBlock(ce, {
          key: 0,
          modelValue: le.selectedUrl,
          "onUpdate:modelValue": ne[2] || (ne[2] = (ue) => le.selectedUrl = ue),
          show: !se.hasTab,
          path: ae.path,
          search: le.search,
          class: "mb-0",
          onChange: se.onSelectChange
        }, null, 8, ["modelValue", "show", "path", "search", "onChange"])),
        se.hasTab ? (openBlock(), createBlock(VTabs, {
          key: 1,
          modelValue: le.tab,
          "onUpdate:modelValue": ne[3] || (ne[3] = (ue) => le.tab = ue),
          "show-arrows": "",
          class: "cs-illustration-selector-tabs",
          height: "42px"
        }, {
          default: withCtx(() => [
            (openBlock(!0), createElementBlock(Fragment, null, renderList(le.tabItems, (ue) => (openBlock(), createBlock(VTab, {
              key: ue.name,
              class: "cs-illustration-selector-tab",
              disabled: ue.isEmpty,
              ripple: !1
            }, {
              default: withCtx(() => [
                createElementVNode("span", _hoisted_2$1, toDisplayString$1(ue.name), 1)
              ]),
              _: 2
            }, 1032, ["disabled"]))), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])) : createCommentVNode("", !0),
        createVNode(VDivider, { class: "cs-illustration-selector-tabs-divider" }),
        se.hasTab ? (openBlock(!0), createElementBlock(Fragment, { key: 2 }, renderList(le.tabItems, (ue, de) => (openBlock(), createBlock(ce, {
          key: ue.name,
          modelValue: le.selectedUrl,
          "onUpdate:modelValue": ne[4] || (ne[4] = (me) => le.selectedUrl = me),
          show: le.tab === de,
          path: ue.path,
          search: le.search,
          class: "mb-0",
          onChange: se.onSelectChange,
          onIsEmpty: (me) => {
            se.onPanelIsEmpty(de, me);
          },
          onHasSelected: (me) => {
            se.onPanelHasSelected(de, me);
          }
        }, null, 8, ["modelValue", "show", "path", "search", "onChange", "onIsEmpty", "onHasSelected"]))), 128)) : createCommentVNode("", !0)
      ]),
      _: 1
    }, 8, ["id"])) : (openBlock(), createBlock(VTextField, {
      key: 0,
      id: "cs-illustration-selector-select",
      readonly: "",
      density: "compact",
      variant: "outlined",
      "append-inner-icon": "mdi-chevron-down",
      "hide-details": "auto",
      class: "ma-0 cs-illustration-selector-select style-07",
      placeholder: "Select",
      "model-value": le.selectedUrl,
      onClick: se.onExpand,
      "onClick:appendInner": se.onExpand
    }, null, 8, ["model-value", "onClick", "onClick:appendInner"]))
  ]);
}
const CSIllustrationSelector = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1], ["__scopeId", "data-v-2677d740"]]), _sfc_main = {
  name: "CSButton",
  props: {
    id: { type: String, required: !1, default: "" },
    label: { type: String, required: !1, default: "" },
    primary: { type: Boolean, required: !1 },
    disabled: { type: Boolean, required: !1 },
    large: { type: Boolean, required: !1 },
    small: { type: Boolean, required: !1 },
    leftIcon: { type: String, required: !1, default: "" },
    rightIcon: { type: String, required: !1, default: "" },
    information: { type: Boolean, required: !1 },
    title: { type: String, required: !1, default: "" },
    description: { type: String, required: !1, default: "" },
    loading: { type: Boolean, required: !1 },
    href: { type: String, required: !1, default: "" },
    delete: { type: Boolean, required: !1 }
  },
  emits: ["click"],
  computed: {
    classes() {
      let re = ["cs-button"];
      return this.information ? re.concat("button-info") : (this.primary ? re = re.concat("primary") : this.delete ? re = re.concat("delete") : re = re.concat("secondary"), this.large ? re = re.concat("button-lg") : this.small ? re = re.concat("button-sm") : re = re.concat("button-md"), re);
    },
    btnClass() {
      return this.classes.join(" ");
    },
    btnSize() {
      return this.information ? "default" : this.large ? "large" : this.small ? "small" : "default";
    }
  },
  created() {
    this.information ? this.title || console.error("Require title for a information button") : this.label || console.error("Require label for a CS Button");
  },
  methods: {
    onClick(re) {
      this.$emit("click", re);
    }
  }
}, _hoisted_1 = {
  key: 1,
  class: "information"
}, _hoisted_2 = { class: "title-1" };
function _sfc_render(re, ne, ae, ie, le, se) {
  return openBlock(), createBlock(VBtn, {
    id: ae.id,
    elevation: "0",
    class: normalizeClass(se.btnClass),
    color: ae.primary && !ae.disabled ? "primary" : "secondary",
    size: se.btnSize,
    variant: ae.information ? "outlined" : "elevated",
    disabled: ae.disabled,
    ripple: !1,
    loading: ae.loading,
    href: ae.href,
    onClick: se.onClick
  }, {
    default: withCtx(() => [
      ae.leftIcon ? (openBlock(), createBlock(VIcon, {
        key: 0,
        class: "cs-button-icon-left"
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString$1(ae.leftIcon), 1)
        ]),
        _: 1
      })) : createCommentVNode("", !0),
      ae.information ? (openBlock(), createElementBlock("div", _hoisted_1, [
        createElementVNode("div", _hoisted_2, toDisplayString$1(ae.title), 1),
        ae.description ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(["info-desc card-button", { "no-icon": !ae.leftIcon }])
        }, toDisplayString$1(ae.description), 3)) : createCommentVNode("", !0)
      ])) : (openBlock(), createElementBlock(Fragment, { key: 2 }, [
        createTextVNode(toDisplayString$1(ae.label), 1)
      ], 64)),
      ae.rightIcon && !ae.information ? (openBlock(), createBlock(VIcon, {
        key: 3,
        class: "cs-button-icon-right"
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString$1(ae.rightIcon), 1)
        ]),
        _: 1
      })) : createCommentVNode("", !0)
    ]),
    _: 1
  }, 8, ["id", "class", "color", "size", "variant", "disabled", "loading", "href", "onClick"]);
}
const CSButton = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-4b038f27"]]), GainsightConfig = (re, ne, ae, ie) => (Assert.isPresent(re, "gainsightSiteInfoApiHost"), Assert.isPresent(ae, "gainsightProductTag"), Assert.isPresent(ie, "gainsightAppName"), {
  gainsightSiteInfoApiHost: re,
  gainsightUrl: ne || "https://web-sdk-eu.aptrinsic.com/api/aptrinsic.js",
  gainsightProductTag: ae,
  gainsightAppName: ie
}), getters = {
  isEnabled: (re) => !!re.gainsightConfig,
  isAvailable: (re) => !!re.gainsightModel
}, Gainsight = (re, ne, ae, ie, le, se, ce) => (Assert.isPresent(re, "gainsightUrl"), Assert.isPresent(ne, "gainsightProductTag"), Assert.isPresent(ae, "gainsightClientName"), Assert.isPresent(ie, "gainsightProductId"), Assert.isPresent(le, "gainsightSafeId"), Assert.isPresent(se, "gainsightSubscriptionId"), Assert.isPresent(ce, "gainsightAppName"), {
  gainsightUrl: re,
  gainsightProductTag: ne,
  gainsightClientName: ae,
  gainsightProductId: ie,
  gainsightSafeId: le,
  gainsightSubscriptionId: se,
  gainsightApplicationId: `${le}|${se}|${ie}`,
  gainsightAppName: ce,
  serialize() {
    return JSON.stringify({
      gainsightUrl: re,
      gainsightProductTag: ne,
      gainsightClientName: ae,
      gainsightProductId: ie,
      gainsightSafeId: le,
      gainsightSubscriptionId: se,
      gainsightAppName: ce
    });
  }
});
Gainsight.deserialize = (re) => {
  if (!re || Array.isArray(re))
    throw new DeserializeGainsightFailed(`invalid input ${re}`);
  try {
    const ne = JSON.parse(re);
    return Gainsight(
      ne.gainsightUrl,
      ne.gainsightProductTag,
      ne.gainsightClientName,
      ne.gainsightProductId,
      ne.gainsightSafeId,
      ne.gainsightSubscriptionId,
      ne.gainsightAppName
    );
  } catch (ne) {
    throw new DeserializeGainsightFailed(
      `invalid input ${re} with ${ne.message}`
    );
  }
};
function gainsightBuilder(re, ne) {
  return {
    async build() {
      const { gainsightSiteInfoApiHost: ae, gainsightUrl: ie, gainsightProductTag: le, gainsightAppName: se } = ne;
      let ce, ue, de;
      try {
        const pe = await re.getSiteInfo(
          axios.create(),
          ae
        );
        ce = pe.safeId, ue = pe.subscriptionId, de = pe.clientName;
      } catch {
        return console.info("Gainsight info not found"), null;
      }
      const me = Gainsight(
        ie,
        le,
        de,
        "SKU-00000074",
        ce,
        ue,
        se
      );
      localStorage.setItem("GAINSIGHT", me.serialize());
      const fe = (/* @__PURE__ */ new Date()).getTime() + 1e3 * 60 * 60 * 24;
      return localStorage.setItem("GAINSIGHT_EXPIRATION", fe), me;
    }
  };
}
const actions = {
  async initGainsight({ state: re, commit: ne, dispatch: ae }) {
    let ie = null;
    try {
      const le = localStorage.getItem("GAINSIGHT_EXPIRATION");
      ie = le && (/* @__PURE__ */ new Date()).getTime() < le ? Gainsight.deserialize(localStorage.getItem("GAINSIGHT")) : null;
    } catch (le) {
      console.info("Failed to deserialize gainsight object: ", le.message), ae("resetGainsight");
    }
    if (ie || (ie = await gainsightBuilder(gainsightService, re.gainsightConfig).build()), !ie) {
      console.info("Failed to initialize gainsight object");
      return;
    }
    ne(INIT_GAINSIGHT, ie);
  },
  resetGainsight({ commit: re }) {
    localStorage.removeItem("GAINSIGHT"), localStorage.removeItem("GAINSIGHT_EXPIRATION"), re(RESET_GAINSIGHT);
  }
}, mutations = {
  /* eslint-disable no-param-reassign, no-unused-vars */
  [SET_GAINSIGHT_CONFIG](re, ne) {
    re.gainsightConfig = ne;
  },
  [INIT_GAINSIGHT](re, ne) {
    re.gainsightModel = ne, re.siteInfo.productTag = ne.gainsightProductTag, re.siteInfo.ApplicationId = ne.gainsightApplicationId, re.siteInfo.ClientName = ne.gainsightClientName;
  },
  [RESET_GAINSIGHT](re) {
    re.gainsightModel = null, re.siteInfo.productTag = "", re.siteInfo.ApplicationId = "", re.siteInfo.ClientName = "";
  }
  /* eslint-enable no-param-reassign, no-unused-vars */
}, state = {
  gainsightConfig: null,
  gainsightModel: null,
  siteInfo: {
    productTag: "",
    ApplicationId: "",
    ClientName: ""
  }
}, gainsightStore = {
  namespaced: !0,
  state,
  getters,
  mutations,
  actions
};
function install(re, { store: ne, router: ae, auth0: ie, beforeEachRoute: le, userGroupAllowList: se, login: ce, gainsight: ue }) {
  if (ue)
    try {
      const { gainsightSiteInfoApiHost: de, gainsightUrl: me, gainsightProductTag: fe, gainsightAppName: pe } = ue, ge = GainsightConfig(
        de,
        me,
        fe,
        pe
      );
      ne.registerModule("gainsight", gainsightStore), ne.commit(GAINSIGHT_SET_GAINSIGHT_CONFIG, ge);
    } catch (de) {
      console.info("Failed to initialize gainsight config: ", de.message);
    }
  if (re.use(translator.i18n), ie) {
    const { appEnv: de, appHost: me, appUrl: fe, auth0Domain: pe, auth0ClientId: ge, auth0Audience: be } = ie, Se = auth0Config(me, fe, pe, ge, be, de);
    ne.registerModule("cs-session", csSessionStore), ne.registerModule("auth0", auth0Store), ne.dispatch("auth0/init", Se), ne.commit(SET_CS_SESSION_USER_GROUP_ALLOW_LIST, se), re.use(AxiosPlugin, { axios, store: ne }), routes.forEach((Ee) => {
      ae.addRoute(Ee);
    });
    const Pe = beforeEachRouteBuilder.build(ne, le);
    ae.beforeEach(async (Ee, Ve, Ae) => {
      await Pe(Ee, Ve, Ae);
    });
  }
  ne.registerModule("cs-appearance", csAppearanceStore), ce && ce.resetBtnTimeout && ne.commit(CS_APPEARANCE_SET_LOGIN_RESET_BTN_TIMEOUT, ce.resetBtnTimeout), re.component("CsAlert", CSAlert), re.component("CsLoader", CSLoader), re.component("CsHeader", CSHeader), re.component("CsHeaderIconBtn", CSHeaderIconBtn), re.component("CsHeaderProfile", CSHeaderProfile), re.component("CsUserProfile", CSUserProfile), re.component("CsAvatar", CSAvatar), re.component("CsView", CSView), re.component("CsSideNav", CSSideNav), re.component("CsBase", CSBase), re.component("CsFormDialog", CSFormDialog), re.component("HxTable", HxTable), re.component("HxToggleSwitch", HxToggleSwitch), re.component("HxButton", HxButton), re.component("HxSearch", HxSearch), re.component("HxContentCard", HxContentCard), re.component("HxCheckbox", HxCheckbox), re.component("HxRadioButton", HxRadioButton), re.component("HxChip", HxChip), re.component("HxTooltip", HxTooltip), re.component("HxModal", HxModal), re.component("HxOption", HxOption), re.component("HxMenu", HxMenu), re.component("HxLinearProgress", HxLinearProgress), re.component("HxBreadcrumbs", HxBreadcrumbs), re.component("HxHeader", HxHeader), re.component("HxTabs", HxTabs), re.component("HxTab", HxTab), re.component("HxTabContent", HxTabContent), re.component("HxHomebarHorizontal", HxHomebarHorizontal), re.component("HxToolbar", HxToolbar), re.component("HxToolbarBodySection", HxToolbarBodySection), re.component("HxToolbarBodySectionContentBlock", HxToolbarBodySectionContentBlock), re.component("HxAvatar", HxAvatar), re.component("HxTrackers", HxTrackers), re.component("HxAccordion", HxAccordion), re.component("HxNavbarV2", HxNavbarV2), re.component("CsOptionSelect", CSOptionSelect), re.component("HxSelect", HxSelect), re.component("CsApp", CSApp), re.component("CsButton", CSButton), re.component("CsIllustrationSvgSelector", CSIllustrationSelector);
}
const { i18n } = translator, { helixifyColors } = definitions;
export {
  CSAlert,
  CSApp,
  CSBase,
  CSButton,
  CSFormDialog,
  CSHeader,
  CSHeaderActiveButtonProps,
  CSHeaderButtonProps,
  CSHeaderIconBtn,
  CSHeaderProfileProps,
  CSIllustrationSelector,
  CSOptionSelect,
  CSSideNav,
  CSView,
  HxAccordion,
  HxAvatar,
  HxBreadcrumbs,
  HxButton,
  HxCheckbox,
  HxChip,
  HxContentCard,
  HxHeader,
  HxHomebarHorizontal,
  HxLinearProgress,
  HxMenu,
  HxModal,
  HxNavbarV2,
  HxOption,
  HxRadioButton,
  HxSearch,
  HxSelect,
  HxTab,
  HxTabContent,
  HxTable,
  HxTabs,
  HxToggleSwitch,
  HxToolbar,
  HxToolbarBodySection,
  HxToolbarBodySectionContentBlock,
  HxTooltip,
  HxTrackers,
  axios,
  helixifyColors,
  i18n,
  install,
  overrideLoginTranslations,
  translator,
  vuetify,
  vuetifyBuilder
};
//# sourceMappingURL=cs-design-system.es.js.map
